// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23a0aec0%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 16 16%27%3E%3Ccircle cx=%278%27 cy=%278%27 r=%273%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

html{
  line-height:1.15;
  -webkit-text-size-adjust:100%
}

body{
  margin:0
}

main{
  display:block
}

h1{
  font-size:2em;
  margin:.67em 0
}

hr{
  box-sizing:initial;
  height:0;
  overflow:visible
}

pre{
  font-family:monospace,monospace;
  font-size:1em
}

a{
  background-color:initial
}

abbr[title]{
  border-bottom:none;
  text-decoration:underline;
  text-decoration:underline dotted
}

b,strong{
  font-weight:bolder
}

code,kbd,samp{
  font-family:monospace,monospace;
  font-size:1em
}

small{
  font-size:80%
}

sub,sup{
  font-size:75%;
  line-height:0;
  position:relative;
  vertical-align:initial
}

sub{
  bottom:-.25em
}

sup{
  top:-.5em
}

img{
  border-style:none
}

button,input,optgroup,select,textarea{
  font-family:inherit;
  font-size:100%;
  line-height:1.15;
  margin:0
}

button,input{
  overflow:visible
}

button,select{
  text-transform:none
}

[type=button],[type=reset],[type=submit],button{
  -webkit-appearance:button
}

[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{
  border-style:none;
  padding:0
}

[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{
  outline:1px dotted ButtonText
}

fieldset{
  padding:.35em .75em .625em
}

legend{
  box-sizing:border-box;
  color:inherit;
  display:table;
  max-width:100%;
  padding:0;
  white-space:normal
}

progress{
  vertical-align:initial
}

textarea{
  overflow:auto
}

[type=checkbox],[type=radio]{
  box-sizing:border-box;
  padding:0
}

[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{
  height:auto
}

[type=search]{
  -webkit-appearance:textfield;
  outline-offset:-2px
}

[type=search]::-webkit-search-decoration{
  -webkit-appearance:none
}

::-webkit-file-upload-button{
  -webkit-appearance:button;
  font:inherit
}

details{
  display:block
}

summary{
  display:list-item
}

[hidden],template{
  display:none
}

blockquote,dd,dl,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{
  margin:0
}

button{
  background-color:initial;
  background-image:none;
  padding:0
}

button:focus{
  outline:1px dotted;
  outline:5px auto -webkit-focus-ring-color
}

fieldset,ol,ul{
  margin:0;
  padding:0
}

ol,ul{
  list-style:none
}

html{
  font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
  line-height:1.5
}

*,:after,:before{
  border:0 solid #d5d6d7;
  box-sizing:border-box
}

hr{
  border-top-width:1px
}

img{
  border-style:solid
}

textarea{
  resize:vertical
}

input::placeholder,textarea::placeholder{
  color:#a0aec0
}

[role=button],button{
  cursor:pointer
}

table{
  border-collapse:collapse
}

h1,h2,h3,h4,h5,h6{
  font-size:inherit;
  font-weight:inherit
}

a{
  color:inherit;
  text-decoration:inherit
}

button,input,optgroup,select,textarea{
  color:inherit;
  line-height:inherit;
  padding:0
}

code,kbd,pre,samp{
  font-family:Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace
}

audio,canvas,embed,iframe,img,object,svg,video{
  display:block;
  vertical-align:middle
}

img,video{
  height:auto;
  max-width:100%
}

.container{
  width:100%
}

@media (min-width:640px){
  .container{
    max-width:640px
  }
}

@media (min-width:768px){
  .container{
    max-width:768px
  }
}

@media (min-width:1024px){
  .container{
    max-width:1024px
  }
}

@media (min-width:1280px){
  .container{
    max-width:1280px
  }
}

.form-input{
  appearance:none;
  background-color:#fff;
  border-color:#e2e8f0;
  border-radius:.25rem;
  border-width:1px;
  font-size:1rem;
  line-height:1.5;
  padding:.5rem .75rem
}

.form-input::placeholder{
  color:#9e9e9e;
  opacity:1
}

.form-input:focus{
  border-color:#63b3ed;
  box-shadow:0 0 0 3px #4299e180;
  outline:none
}

.form-textarea{
  appearance:none;
  background-color:#fff;
  border-color:#e2e8f0;
  border-radius:.25rem;
  border-width:1px;
  font-size:1rem;
  line-height:1.5;
  padding:.5rem .75rem
}

.form-textarea::placeholder{
  color:#9e9e9e;
  opacity:1
}

.form-textarea:focus{
  border-color:#63b3ed;
  box-shadow:0 0 0 3px #4299e180;
  outline:none
}

.form-multiselect{
  appearance:none;
  background-color:#fff;
  border-color:#e2e8f0;
  border-radius:.25rem;
  border-width:1px;
  font-size:1rem;
  line-height:1.5;
  padding:.5rem .75rem
}

.form-multiselect:focus{
  border-color:#63b3ed;
  box-shadow:0 0 0 3px #4299e180;
  outline:none
}

.form-select{
  appearance:none;
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  print-color-adjust:exact;
  background-color:#fff;
  background-position:right .5rem center;
  background-repeat:no-repeat;
  background-size:1.5em 1.5em;
  border-color:#e2e8f0;
  border-radius:.25rem;
  border-width:1px;
  font-size:1rem;
  line-height:1.5;
  padding:.5rem 2.5rem .5rem .75rem
}

.form-select::-ms-expand{
  border:none;
  color:#a0aec0
}

@media not print{
  .form-select::-ms-expand{
    display:none
  }
}

@media print and (-ms-high-contrast:active),print and (-ms-high-contrast:none){
  .form-select{
    padding-right:.75rem
  }
}

.form-select:focus{
  border-color:#63b3ed;
  box-shadow:0 0 0 3px #4299e180;
  outline:none
}

.form-checkbox{
  appearance:none;
  print-color-adjust:exact;
  background-color:#fff;
  background-origin:border-box;
  border-color:#e2e8f0;
  border-radius:.25rem;
  border-width:1px;
  color:#4299e1;
  display:inline-block;
  flex-shrink:0;
  height:1em;
  -webkit-user-select:none;
  user-select:none;
  vertical-align:middle;
  width:1em
}

.form-checkbox:checked{
  background-color:currentColor;
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position:50%;
  background-repeat:no-repeat;
  background-size:100% 100%;
  border-color:#0000
}

@media not print{
  .form-checkbox::-ms-check{
    background:inherit;
    border-color:inherit;
    border-radius:inherit;
    border-width:1px;
    color:#0000
  }
}

.form-checkbox:focus{
  border-color:#63b3ed;
  box-shadow:0 0 0 3px #4299e180;
  outline:none
}

.form-radio{
  appearance:none;
  print-color-adjust:exact;
  background-color:#fff;
  background-origin:border-box;
  border-color:#e2e8f0;
  border-radius:100%;
  border-width:1px;
  color:#4299e1;
  display:inline-block;
  flex-shrink:0;
  height:1em;
  -webkit-user-select:none;
  user-select:none;
  vertical-align:middle;
  width:1em
}

.form-radio:checked{
  background-color:currentColor;
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position:50%;
  background-repeat:no-repeat;
  background-size:100% 100%;
  border-color:#0000
}

@media not print{
  .form-radio::-ms-check{
    background:inherit;
    border-color:inherit;
    border-radius:inherit;
    border-width:1px;
    color:#0000
  }
}

.form-radio:focus{
  border-color:#63b3ed;
  box-shadow:0 0 0 3px #4299e180;
  outline:none
}

.space-y-0>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(0px*var(--space-y-reverse));
  margin-top:calc(0px*(1 - var(--space-y-reverse)))
}

.space-x-0>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(0px*(1 - var(--space-x-reverse)));
  margin-right:calc(0px*var(--space-x-reverse))
}

.space-y-1>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(.25rem*var(--space-y-reverse));
  margin-top:calc(.25rem*(1 - var(--space-y-reverse)))
}

.space-x-1>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(.25rem*(1 - var(--space-x-reverse)));
  margin-right:calc(.25rem*var(--space-x-reverse))
}

.space-y-2>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(.5rem*var(--space-y-reverse));
  margin-top:calc(.5rem*(1 - var(--space-y-reverse)))
}

.space-x-2>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(.5rem*(1 - var(--space-x-reverse)));
  margin-right:calc(.5rem*var(--space-x-reverse))
}

.space-y-3>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(.75rem*var(--space-y-reverse));
  margin-top:calc(.75rem*(1 - var(--space-y-reverse)))
}

.space-x-3>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(.75rem*(1 - var(--space-x-reverse)));
  margin-right:calc(.75rem*var(--space-x-reverse))
}

.space-y-4>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(1rem*var(--space-y-reverse));
  margin-top:calc(1rem*(1 - var(--space-y-reverse)))
}

.space-x-4>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(1rem*(1 - var(--space-x-reverse)));
  margin-right:calc(1rem*var(--space-x-reverse))
}

.space-y-5>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(1.25rem*var(--space-y-reverse));
  margin-top:calc(1.25rem*(1 - var(--space-y-reverse)))
}

.space-x-5>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(1.25rem*(1 - var(--space-x-reverse)));
  margin-right:calc(1.25rem*var(--space-x-reverse))
}

.space-y-6>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(1.5rem*var(--space-y-reverse));
  margin-top:calc(1.5rem*(1 - var(--space-y-reverse)))
}

.space-x-6>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(1.5rem*(1 - var(--space-x-reverse)));
  margin-right:calc(1.5rem*var(--space-x-reverse))
}

.space-y-8>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(2rem*var(--space-y-reverse));
  margin-top:calc(2rem*(1 - var(--space-y-reverse)))
}

.space-x-8>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(2rem*(1 - var(--space-x-reverse)));
  margin-right:calc(2rem*var(--space-x-reverse))
}

.space-y-10>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(2.5rem*var(--space-y-reverse));
  margin-top:calc(2.5rem*(1 - var(--space-y-reverse)))
}

.space-x-10>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(2.5rem*(1 - var(--space-x-reverse)));
  margin-right:calc(2.5rem*var(--space-x-reverse))
}

.space-y-12>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(3rem*var(--space-y-reverse));
  margin-top:calc(3rem*(1 - var(--space-y-reverse)))
}

.space-x-12>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(3rem*(1 - var(--space-x-reverse)));
  margin-right:calc(3rem*var(--space-x-reverse))
}

.space-y-16>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(4rem*var(--space-y-reverse));
  margin-top:calc(4rem*(1 - var(--space-y-reverse)))
}

.space-x-16>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(4rem*(1 - var(--space-x-reverse)));
  margin-right:calc(4rem*var(--space-x-reverse))
}

.space-y-20>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(5rem*var(--space-y-reverse));
  margin-top:calc(5rem*(1 - var(--space-y-reverse)))
}

.space-x-20>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(5rem*(1 - var(--space-x-reverse)));
  margin-right:calc(5rem*var(--space-x-reverse))
}

.space-y-24>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(6rem*var(--space-y-reverse));
  margin-top:calc(6rem*(1 - var(--space-y-reverse)))
}

.space-x-24>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(6rem*(1 - var(--space-x-reverse)));
  margin-right:calc(6rem*var(--space-x-reverse))
}

.space-y-32>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(8rem*var(--space-y-reverse));
  margin-top:calc(8rem*(1 - var(--space-y-reverse)))
}

.space-x-32>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(8rem*(1 - var(--space-x-reverse)));
  margin-right:calc(8rem*var(--space-x-reverse))
}

.space-y-40>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(10rem*var(--space-y-reverse));
  margin-top:calc(10rem*(1 - var(--space-y-reverse)))
}

.space-x-40>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(10rem*(1 - var(--space-x-reverse)));
  margin-right:calc(10rem*var(--space-x-reverse))
}

.space-y-48>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(12rem*var(--space-y-reverse));
  margin-top:calc(12rem*(1 - var(--space-y-reverse)))
}

.space-x-48>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(12rem*(1 - var(--space-x-reverse)));
  margin-right:calc(12rem*var(--space-x-reverse))
}

.space-y-56>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(14rem*var(--space-y-reverse));
  margin-top:calc(14rem*(1 - var(--space-y-reverse)))
}

.space-x-56>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(14rem*(1 - var(--space-x-reverse)));
  margin-right:calc(14rem*var(--space-x-reverse))
}

.space-y-64>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(16rem*var(--space-y-reverse));
  margin-top:calc(16rem*(1 - var(--space-y-reverse)))
}

.space-x-64>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(16rem*(1 - var(--space-x-reverse)));
  margin-right:calc(16rem*var(--space-x-reverse))
}

.space-y-px>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(1px*var(--space-y-reverse));
  margin-top:calc(1px*(1 - var(--space-y-reverse)))
}

.space-x-px>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(1px*(1 - var(--space-x-reverse)));
  margin-right:calc(1px*var(--space-x-reverse))
}

.-space-y-1>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-.25rem*var(--space-y-reverse));
  margin-top:calc(-.25rem*(1 - var(--space-y-reverse)))
}

.-space-x-1>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-.25rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-.25rem*var(--space-x-reverse))
}

.-space-y-2>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-.5rem*var(--space-y-reverse));
  margin-top:calc(-.5rem*(1 - var(--space-y-reverse)))
}

.-space-x-2>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-.5rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-.5rem*var(--space-x-reverse))
}

.-space-y-3>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-.75rem*var(--space-y-reverse));
  margin-top:calc(-.75rem*(1 - var(--space-y-reverse)))
}

.-space-x-3>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-.75rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-.75rem*var(--space-x-reverse))
}

.-space-y-4>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-1rem*var(--space-y-reverse));
  margin-top:calc(-1rem*(1 - var(--space-y-reverse)))
}

.-space-x-4>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-1rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-1rem*var(--space-x-reverse))
}

.-space-y-5>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-1.25rem*var(--space-y-reverse));
  margin-top:calc(-1.25rem*(1 - var(--space-y-reverse)))
}

.-space-x-5>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-1.25rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-1.25rem*var(--space-x-reverse))
}

.-space-y-6>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-1.5rem*var(--space-y-reverse));
  margin-top:calc(-1.5rem*(1 - var(--space-y-reverse)))
}

.-space-x-6>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-1.5rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-1.5rem*var(--space-x-reverse))
}

.-space-y-8>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-2rem*var(--space-y-reverse));
  margin-top:calc(-2rem*(1 - var(--space-y-reverse)))
}

.-space-x-8>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-2rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-2rem*var(--space-x-reverse))
}

.-space-y-10>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-2.5rem*var(--space-y-reverse));
  margin-top:calc(-2.5rem*(1 - var(--space-y-reverse)))
}

.-space-x-10>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-2.5rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-2.5rem*var(--space-x-reverse))
}

.-space-y-12>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-3rem*var(--space-y-reverse));
  margin-top:calc(-3rem*(1 - var(--space-y-reverse)))
}

.-space-x-12>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-3rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-3rem*var(--space-x-reverse))
}

.-space-y-16>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-4rem*var(--space-y-reverse));
  margin-top:calc(-4rem*(1 - var(--space-y-reverse)))
}

.-space-x-16>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-4rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-4rem*var(--space-x-reverse))
}

.-space-y-20>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-5rem*var(--space-y-reverse));
  margin-top:calc(-5rem*(1 - var(--space-y-reverse)))
}

.-space-x-20>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-5rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-5rem*var(--space-x-reverse))
}

.-space-y-24>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-6rem*var(--space-y-reverse));
  margin-top:calc(-6rem*(1 - var(--space-y-reverse)))
}

.-space-x-24>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-6rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-6rem*var(--space-x-reverse))
}

.-space-y-32>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-8rem*var(--space-y-reverse));
  margin-top:calc(-8rem*(1 - var(--space-y-reverse)))
}

.-space-x-32>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-8rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-8rem*var(--space-x-reverse))
}

.-space-y-40>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-10rem*var(--space-y-reverse));
  margin-top:calc(-10rem*(1 - var(--space-y-reverse)))
}

.-space-x-40>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-10rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-10rem*var(--space-x-reverse))
}

.-space-y-48>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-12rem*var(--space-y-reverse));
  margin-top:calc(-12rem*(1 - var(--space-y-reverse)))
}

.-space-x-48>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-12rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-12rem*var(--space-x-reverse))
}

.-space-y-56>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-14rem*var(--space-y-reverse));
  margin-top:calc(-14rem*(1 - var(--space-y-reverse)))
}

.-space-x-56>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-14rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-14rem*var(--space-x-reverse))
}

.-space-y-64>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-16rem*var(--space-y-reverse));
  margin-top:calc(-16rem*(1 - var(--space-y-reverse)))
}

.-space-x-64>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-16rem*(1 - var(--space-x-reverse)));
  margin-right:calc(-16rem*var(--space-x-reverse))
}

.-space-y-px>:not(template)~:not(template){
  --space-y-reverse:0;
  margin-bottom:calc(-1px*var(--space-y-reverse));
  margin-top:calc(-1px*(1 - var(--space-y-reverse)))
}

.-space-x-px>:not(template)~:not(template){
  --space-x-reverse:0;
  margin-left:calc(-1px*(1 - var(--space-x-reverse)));
  margin-right:calc(-1px*var(--space-x-reverse))
}

.space-y-reverse>:not(template)~:not(template){
  --space-y-reverse:1
}

.space-x-reverse>:not(template)~:not(template){
  --space-x-reverse:1
}

.divide-y-0>:not(template)~:not(template){
  --divide-y-reverse:0;
  border-bottom-width:calc(0px*var(--divide-y-reverse));
  border-top-width:calc(0px*(1 - var(--divide-y-reverse)))
}

.divide-x-0>:not(template)~:not(template){
  --divide-x-reverse:0;
  border-left-width:calc(0px*(1 - var(--divide-x-reverse)));
  border-right-width:calc(0px*var(--divide-x-reverse))
}

.divide-y-2>:not(template)~:not(template){
  --divide-y-reverse:0;
  border-bottom-width:calc(2px*var(--divide-y-reverse));
  border-top-width:calc(2px*(1 - var(--divide-y-reverse)))
}

.divide-x-2>:not(template)~:not(template){
  --divide-x-reverse:0;
  border-left-width:calc(2px*(1 - var(--divide-x-reverse)));
  border-right-width:calc(2px*var(--divide-x-reverse))
}

.divide-y-4>:not(template)~:not(template){
  --divide-y-reverse:0;
  border-bottom-width:calc(4px*var(--divide-y-reverse));
  border-top-width:calc(4px*(1 - var(--divide-y-reverse)))
}

.divide-x-4>:not(template)~:not(template){
  --divide-x-reverse:0;
  border-left-width:calc(4px*(1 - var(--divide-x-reverse)));
  border-right-width:calc(4px*var(--divide-x-reverse))
}

.divide-y-8>:not(template)~:not(template){
  --divide-y-reverse:0;
  border-bottom-width:calc(8px*var(--divide-y-reverse));
  border-top-width:calc(8px*(1 - var(--divide-y-reverse)))
}

.divide-x-8>:not(template)~:not(template){
  --divide-x-reverse:0;
  border-left-width:calc(8px*(1 - var(--divide-x-reverse)));
  border-right-width:calc(8px*var(--divide-x-reverse))
}

.divide-y>:not(template)~:not(template){
  --divide-y-reverse:0;
  border-bottom-width:calc(1px*var(--divide-y-reverse));
  border-top-width:calc(1px*(1 - var(--divide-y-reverse)))
}

.divide-x>:not(template)~:not(template){
  --divide-x-reverse:0;
  border-left-width:calc(1px*(1 - var(--divide-x-reverse)));
  border-right-width:calc(1px*var(--divide-x-reverse))
}

.divide-y-reverse>:not(template)~:not(template){
  --divide-y-reverse:1
}

.divide-x-reverse>:not(template)~:not(template){
  --divide-x-reverse:1
}

.divide-transparent>:not(template)~:not(template){
  border-color:#0000
}

.divide-white>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fff;
  border-color:rgba(255,255,255,var(--divide-opacity))
}

.divide-black>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#000;
  border-color:rgba(0,0,0,var(--divide-opacity))
}

.divide-gray-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f9fafb;
  border-color:rgba(249,250,251,var(--divide-opacity))
}

.divide-gray-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f4f5f7;
  border-color:rgba(244,245,247,var(--divide-opacity))
}

.divide-gray-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#e5e7eb;
  border-color:rgba(229,231,235,var(--divide-opacity))
}

.divide-gray-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#d5d6d7;
  border-color:rgba(213,214,215,var(--divide-opacity))
}

.divide-gray-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#9e9e9e;
  border-color:rgba(158,158,158,var(--divide-opacity))
}

.divide-gray-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#707275;
  border-color:rgba(112,114,117,var(--divide-opacity))
}

.divide-gray-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#4c4f52;
  border-color:rgba(76,79,82,var(--divide-opacity))
}

.divide-gray-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#24262d;
  border-color:rgba(36,38,45,var(--divide-opacity))
}

.divide-gray-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#1a1c23;
  border-color:rgba(26,28,35,var(--divide-opacity))
}

.divide-gray-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#121317;
  border-color:rgba(18,19,23,var(--divide-opacity))
}

.divide-cool-gray-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fbfdfe;
  border-color:rgba(251,253,254,var(--divide-opacity))
}

.divide-cool-gray-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f1f5f9;
  border-color:rgba(241,245,249,var(--divide-opacity))
}

.divide-cool-gray-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#e2e8f0;
  border-color:rgba(226,232,240,var(--divide-opacity))
}

.divide-cool-gray-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#cfd8e3;
  border-color:rgba(207,216,227,var(--divide-opacity))
}

.divide-cool-gray-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#97a6ba;
  border-color:rgba(151,166,186,var(--divide-opacity))
}

.divide-cool-gray-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#64748b;
  border-color:rgba(100,116,139,var(--divide-opacity))
}

.divide-cool-gray-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#475569;
  border-color:rgba(71,85,105,var(--divide-opacity))
}

.divide-cool-gray-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#364152;
  border-color:rgba(54,65,82,var(--divide-opacity))
}

.divide-cool-gray-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#27303f;
  border-color:rgba(39,48,63,var(--divide-opacity))
}

.divide-cool-gray-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#1a202e;
  border-color:rgba(26,32,46,var(--divide-opacity))
}

.divide-red-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fdf2f2;
  border-color:rgba(253,242,242,var(--divide-opacity))
}

.divide-red-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fde8e8;
  border-color:rgba(253,232,232,var(--divide-opacity))
}

.divide-red-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fbd5d5;
  border-color:rgba(251,213,213,var(--divide-opacity))
}

.divide-red-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f8b4b4;
  border-color:rgba(248,180,180,var(--divide-opacity))
}

.divide-red-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f98080;
  border-color:rgba(249,128,128,var(--divide-opacity))
}

.divide-red-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f05252;
  border-color:rgba(240,82,82,var(--divide-opacity))
}

.divide-red-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#e02424;
  border-color:rgba(224,36,36,var(--divide-opacity))
}

.divide-red-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#c81e1e;
  border-color:rgba(200,30,30,var(--divide-opacity))
}

.divide-red-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#9b1c1c;
  border-color:rgba(155,28,28,var(--divide-opacity))
}

.divide-red-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--divide-opacity))
}

.divide-orange-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fff8f1;
  border-color:rgba(255,248,241,var(--divide-opacity))
}

.divide-orange-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#feecdc;
  border-color:rgba(254,236,220,var(--divide-opacity))
}

.divide-orange-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fcd9bd;
  border-color:rgba(252,217,189,var(--divide-opacity))
}

.divide-orange-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fdba8c;
  border-color:rgba(253,186,140,var(--divide-opacity))
}

.divide-orange-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#ff8a4c;
  border-color:rgba(255,138,76,var(--divide-opacity))
}

.divide-orange-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#ff5a1f;
  border-color:rgba(255,90,31,var(--divide-opacity))
}

.divide-orange-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#d03801;
  border-color:rgba(208,56,1,var(--divide-opacity))
}

.divide-orange-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#b43403;
  border-color:rgba(180,52,3,var(--divide-opacity))
}

.divide-orange-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#8a2c0d;
  border-color:rgba(138,44,13,var(--divide-opacity))
}

.divide-orange-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--divide-opacity))
}

.divide-yellow-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fdfdea;
  border-color:rgba(253,253,234,var(--divide-opacity))
}

.divide-yellow-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fdf6b2;
  border-color:rgba(253,246,178,var(--divide-opacity))
}

.divide-yellow-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fce96a;
  border-color:rgba(252,233,106,var(--divide-opacity))
}

.divide-yellow-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#faca15;
  border-color:rgba(250,202,21,var(--divide-opacity))
}

.divide-yellow-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#e3a008;
  border-color:rgba(227,160,8,var(--divide-opacity))
}

.divide-yellow-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#c27803;
  border-color:rgba(194,120,3,var(--divide-opacity))
}

.divide-yellow-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#9f580a;
  border-color:rgba(159,88,10,var(--divide-opacity))
}

.divide-yellow-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#8e4b10;
  border-color:rgba(142,75,16,var(--divide-opacity))
}

.divide-yellow-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#723b13;
  border-color:rgba(114,59,19,var(--divide-opacity))
}

.divide-yellow-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#633112;
  border-color:rgba(99,49,18,var(--divide-opacity))
}

.divide-green-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f3faf7;
  border-color:rgba(243,250,247,var(--divide-opacity))
}

.divide-green-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#def7ec;
  border-color:rgba(222,247,236,var(--divide-opacity))
}

.divide-green-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#bcf0da;
  border-color:rgba(188,240,218,var(--divide-opacity))
}

.divide-green-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#84e1bc;
  border-color:rgba(132,225,188,var(--divide-opacity))
}

.divide-green-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#31c48d;
  border-color:rgba(49,196,141,var(--divide-opacity))
}

.divide-green-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#0e9f6e;
  border-color:rgba(14,159,110,var(--divide-opacity))
}

.divide-green-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#057a55;
  border-color:rgba(5,122,85,var(--divide-opacity))
}

.divide-green-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#046c4e;
  border-color:rgba(4,108,78,var(--divide-opacity))
}

.divide-green-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#03543f;
  border-color:rgba(3,84,63,var(--divide-opacity))
}

.divide-green-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#014737;
  border-color:rgba(1,71,55,var(--divide-opacity))
}

.divide-teal-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#edfafa;
  border-color:rgba(237,250,250,var(--divide-opacity))
}

.divide-teal-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#d5f5f6;
  border-color:rgba(213,245,246,var(--divide-opacity))
}

.divide-teal-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#afecef;
  border-color:rgba(175,236,239,var(--divide-opacity))
}

.divide-teal-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#7edce2;
  border-color:rgba(126,220,226,var(--divide-opacity))
}

.divide-teal-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#16bdca;
  border-color:rgba(22,189,202,var(--divide-opacity))
}

.divide-teal-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#0694a2;
  border-color:rgba(6,148,162,var(--divide-opacity))
}

.divide-teal-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#047481;
  border-color:rgba(4,116,129,var(--divide-opacity))
}

.divide-teal-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#036672;
  border-color:rgba(3,102,114,var(--divide-opacity))
}

.divide-teal-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#05505c;
  border-color:rgba(5,80,92,var(--divide-opacity))
}

.divide-teal-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#014451;
  border-color:rgba(1,68,81,var(--divide-opacity))
}

.divide-blue-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#ebf5ff;
  border-color:rgba(235,245,255,var(--divide-opacity))
}

.divide-blue-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#e1effe;
  border-color:rgba(225,239,254,var(--divide-opacity))
}

.divide-blue-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#c3ddfd;
  border-color:rgba(195,221,253,var(--divide-opacity))
}

.divide-blue-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#a4cafe;
  border-color:rgba(164,202,254,var(--divide-opacity))
}

.divide-blue-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#76a9fa;
  border-color:rgba(118,169,250,var(--divide-opacity))
}

.divide-blue-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#3f83f8;
  border-color:rgba(63,131,248,var(--divide-opacity))
}

.divide-blue-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#1c64f2;
  border-color:rgba(28,100,242,var(--divide-opacity))
}

.divide-blue-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#1a56db;
  border-color:rgba(26,86,219,var(--divide-opacity))
}

.divide-blue-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#1e429f;
  border-color:rgba(30,66,159,var(--divide-opacity))
}

.divide-blue-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#233876;
  border-color:rgba(35,56,118,var(--divide-opacity))
}

.divide-indigo-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f0f5ff;
  border-color:rgba(240,245,255,var(--divide-opacity))
}

.divide-indigo-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#e5edff;
  border-color:rgba(229,237,255,var(--divide-opacity))
}

.divide-indigo-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#cddbfe;
  border-color:rgba(205,219,254,var(--divide-opacity))
}

.divide-indigo-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#b4c6fc;
  border-color:rgba(180,198,252,var(--divide-opacity))
}

.divide-indigo-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#8da2fb;
  border-color:rgba(141,162,251,var(--divide-opacity))
}

.divide-indigo-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#6875f5;
  border-color:rgba(104,117,245,var(--divide-opacity))
}

.divide-indigo-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#5850ec;
  border-color:rgba(88,80,236,var(--divide-opacity))
}

.divide-indigo-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#5145cd;
  border-color:rgba(81,69,205,var(--divide-opacity))
}

.divide-indigo-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#42389d;
  border-color:rgba(66,56,157,var(--divide-opacity))
}

.divide-indigo-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#362f78;
  border-color:rgba(54,47,120,var(--divide-opacity))
}

.divide-indigo-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f6f5ff;
  border-color:rgba(246,245,255,var(--divide-opacity))
}

.divide-indigo-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#edebfe;
  border-color:rgba(237,235,254,var(--divide-opacity))
}

.divide-indigo-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#dcd7fe;
  border-color:rgba(220,215,254,var(--divide-opacity))
}

.divide-indigo-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#cabffd;
  border-color:rgba(202,191,253,var(--divide-opacity))
}

.divide-indigo-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#ac94fa;
  border-color:rgba(172,148,250,var(--divide-opacity))
}

.divide-indigo-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#9061f9;
  border-color:rgba(144,97,249,var(--divide-opacity))
}

.divide-indigo-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#7e3af2;
  border-color:rgba(126,58,242,var(--divide-opacity))
}

.divide-indigo-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#6c2bd9;
  border-color:rgba(108,43,217,var(--divide-opacity))
}

.divide-indigo-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#5521b5;
  border-color:rgba(85,33,181,var(--divide-opacity))
}

.divide-indigo-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#4a1d96;
  border-color:rgba(74,29,150,var(--divide-opacity))
}

.divide-pink-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fdf2f8;
  border-color:rgba(253,242,248,var(--divide-opacity))
}

.divide-pink-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fce8f3;
  border-color:rgba(252,232,243,var(--divide-opacity))
}

.divide-pink-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fad1e8;
  border-color:rgba(250,209,232,var(--divide-opacity))
}

.divide-pink-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f8b4d9;
  border-color:rgba(248,180,217,var(--divide-opacity))
}

.divide-pink-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f17eb8;
  border-color:rgba(241,126,184,var(--divide-opacity))
}

.divide-pink-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#e74694;
  border-color:rgba(231,70,148,var(--divide-opacity))
}

.divide-pink-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#d61f69;
  border-color:rgba(214,31,105,var(--divide-opacity))
}

.divide-pink-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#bf125d;
  border-color:rgba(191,18,93,var(--divide-opacity))
}

.divide-pink-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#99154b;
  border-color:rgba(153,21,75,var(--divide-opacity))
}

.divide-pink-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#751a3d;
  border-color:rgba(117,26,61,var(--divide-opacity))
}

.theme-dark .dark\\:divide-transparent>:not(template)~:not(template){
  border-color:#0000
}

.theme-dark .dark\\:divide-white>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fff;
  border-color:rgba(255,255,255,var(--divide-opacity))
}

.theme-dark .dark\\:divide-black>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#000;
  border-color:rgba(0,0,0,var(--divide-opacity))
}

.theme-dark .dark\\:divide-gray-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f9fafb;
  border-color:rgba(249,250,251,var(--divide-opacity))
}

.theme-dark .dark\\:divide-gray-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f4f5f7;
  border-color:rgba(244,245,247,var(--divide-opacity))
}

.theme-dark .dark\\:divide-gray-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#e5e7eb;
  border-color:rgba(229,231,235,var(--divide-opacity))
}

.theme-dark .dark\\:divide-gray-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#d5d6d7;
  border-color:rgba(213,214,215,var(--divide-opacity))
}

.theme-dark .dark\\:divide-gray-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#9e9e9e;
  border-color:rgba(158,158,158,var(--divide-opacity))
}

.theme-dark .dark\\:divide-gray-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#707275;
  border-color:rgba(112,114,117,var(--divide-opacity))
}

.theme-dark .dark\\:divide-gray-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#4c4f52;
  border-color:rgba(76,79,82,var(--divide-opacity))
}

.theme-dark .dark\\:divide-gray-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#24262d;
  border-color:rgba(36,38,45,var(--divide-opacity))
}

.theme-dark .dark\\:divide-gray-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#1a1c23;
  border-color:rgba(26,28,35,var(--divide-opacity))
}

.theme-dark .dark\\:divide-gray-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#121317;
  border-color:rgba(18,19,23,var(--divide-opacity))
}

.theme-dark .dark\\:divide-cool-gray-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fbfdfe;
  border-color:rgba(251,253,254,var(--divide-opacity))
}

.theme-dark .dark\\:divide-cool-gray-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f1f5f9;
  border-color:rgba(241,245,249,var(--divide-opacity))
}

.theme-dark .dark\\:divide-cool-gray-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#e2e8f0;
  border-color:rgba(226,232,240,var(--divide-opacity))
}

.theme-dark .dark\\:divide-cool-gray-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#cfd8e3;
  border-color:rgba(207,216,227,var(--divide-opacity))
}

.theme-dark .dark\\:divide-cool-gray-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#97a6ba;
  border-color:rgba(151,166,186,var(--divide-opacity))
}

.theme-dark .dark\\:divide-cool-gray-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#64748b;
  border-color:rgba(100,116,139,var(--divide-opacity))
}

.theme-dark .dark\\:divide-cool-gray-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#475569;
  border-color:rgba(71,85,105,var(--divide-opacity))
}

.theme-dark .dark\\:divide-cool-gray-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#364152;
  border-color:rgba(54,65,82,var(--divide-opacity))
}

.theme-dark .dark\\:divide-cool-gray-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#27303f;
  border-color:rgba(39,48,63,var(--divide-opacity))
}

.theme-dark .dark\\:divide-cool-gray-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#1a202e;
  border-color:rgba(26,32,46,var(--divide-opacity))
}

.theme-dark .dark\\:divide-red-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fdf2f2;
  border-color:rgba(253,242,242,var(--divide-opacity))
}

.theme-dark .dark\\:divide-red-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fde8e8;
  border-color:rgba(253,232,232,var(--divide-opacity))
}

.theme-dark .dark\\:divide-red-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fbd5d5;
  border-color:rgba(251,213,213,var(--divide-opacity))
}

.theme-dark .dark\\:divide-red-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f8b4b4;
  border-color:rgba(248,180,180,var(--divide-opacity))
}

.theme-dark .dark\\:divide-red-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f98080;
  border-color:rgba(249,128,128,var(--divide-opacity))
}

.theme-dark .dark\\:divide-red-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f05252;
  border-color:rgba(240,82,82,var(--divide-opacity))
}

.theme-dark .dark\\:divide-red-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#e02424;
  border-color:rgba(224,36,36,var(--divide-opacity))
}

.theme-dark .dark\\:divide-red-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#c81e1e;
  border-color:rgba(200,30,30,var(--divide-opacity))
}

.theme-dark .dark\\:divide-red-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#9b1c1c;
  border-color:rgba(155,28,28,var(--divide-opacity))
}

.theme-dark .dark\\:divide-red-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--divide-opacity))
}

.theme-dark .dark\\:divide-orange-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fff8f1;
  border-color:rgba(255,248,241,var(--divide-opacity))
}

.theme-dark .dark\\:divide-orange-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#feecdc;
  border-color:rgba(254,236,220,var(--divide-opacity))
}

.theme-dark .dark\\:divide-orange-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fcd9bd;
  border-color:rgba(252,217,189,var(--divide-opacity))
}

.theme-dark .dark\\:divide-orange-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fdba8c;
  border-color:rgba(253,186,140,var(--divide-opacity))
}

.theme-dark .dark\\:divide-orange-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#ff8a4c;
  border-color:rgba(255,138,76,var(--divide-opacity))
}

.theme-dark .dark\\:divide-orange-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#ff5a1f;
  border-color:rgba(255,90,31,var(--divide-opacity))
}

.theme-dark .dark\\:divide-orange-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#d03801;
  border-color:rgba(208,56,1,var(--divide-opacity))
}

.theme-dark .dark\\:divide-orange-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#b43403;
  border-color:rgba(180,52,3,var(--divide-opacity))
}

.theme-dark .dark\\:divide-orange-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#8a2c0d;
  border-color:rgba(138,44,13,var(--divide-opacity))
}

.theme-dark .dark\\:divide-orange-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--divide-opacity))
}

.theme-dark .dark\\:divide-yellow-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fdfdea;
  border-color:rgba(253,253,234,var(--divide-opacity))
}

.theme-dark .dark\\:divide-yellow-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fdf6b2;
  border-color:rgba(253,246,178,var(--divide-opacity))
}

.theme-dark .dark\\:divide-yellow-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fce96a;
  border-color:rgba(252,233,106,var(--divide-opacity))
}

.theme-dark .dark\\:divide-yellow-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#faca15;
  border-color:rgba(250,202,21,var(--divide-opacity))
}

.theme-dark .dark\\:divide-yellow-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#e3a008;
  border-color:rgba(227,160,8,var(--divide-opacity))
}

.theme-dark .dark\\:divide-yellow-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#c27803;
  border-color:rgba(194,120,3,var(--divide-opacity))
}

.theme-dark .dark\\:divide-yellow-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#9f580a;
  border-color:rgba(159,88,10,var(--divide-opacity))
}

.theme-dark .dark\\:divide-yellow-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#8e4b10;
  border-color:rgba(142,75,16,var(--divide-opacity))
}

.theme-dark .dark\\:divide-yellow-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#723b13;
  border-color:rgba(114,59,19,var(--divide-opacity))
}

.theme-dark .dark\\:divide-yellow-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#633112;
  border-color:rgba(99,49,18,var(--divide-opacity))
}

.theme-dark .dark\\:divide-green-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f3faf7;
  border-color:rgba(243,250,247,var(--divide-opacity))
}

.theme-dark .dark\\:divide-green-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#def7ec;
  border-color:rgba(222,247,236,var(--divide-opacity))
}

.theme-dark .dark\\:divide-green-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#bcf0da;
  border-color:rgba(188,240,218,var(--divide-opacity))
}

.theme-dark .dark\\:divide-green-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#84e1bc;
  border-color:rgba(132,225,188,var(--divide-opacity))
}

.theme-dark .dark\\:divide-green-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#31c48d;
  border-color:rgba(49,196,141,var(--divide-opacity))
}

.theme-dark .dark\\:divide-green-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#0e9f6e;
  border-color:rgba(14,159,110,var(--divide-opacity))
}

.theme-dark .dark\\:divide-green-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#057a55;
  border-color:rgba(5,122,85,var(--divide-opacity))
}

.theme-dark .dark\\:divide-green-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#046c4e;
  border-color:rgba(4,108,78,var(--divide-opacity))
}

.theme-dark .dark\\:divide-green-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#03543f;
  border-color:rgba(3,84,63,var(--divide-opacity))
}

.theme-dark .dark\\:divide-green-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#014737;
  border-color:rgba(1,71,55,var(--divide-opacity))
}

.theme-dark .dark\\:divide-teal-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#edfafa;
  border-color:rgba(237,250,250,var(--divide-opacity))
}

.theme-dark .dark\\:divide-teal-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#d5f5f6;
  border-color:rgba(213,245,246,var(--divide-opacity))
}

.theme-dark .dark\\:divide-teal-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#afecef;
  border-color:rgba(175,236,239,var(--divide-opacity))
}

.theme-dark .dark\\:divide-teal-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#7edce2;
  border-color:rgba(126,220,226,var(--divide-opacity))
}

.theme-dark .dark\\:divide-teal-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#16bdca;
  border-color:rgba(22,189,202,var(--divide-opacity))
}

.theme-dark .dark\\:divide-teal-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#0694a2;
  border-color:rgba(6,148,162,var(--divide-opacity))
}

.theme-dark .dark\\:divide-teal-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#047481;
  border-color:rgba(4,116,129,var(--divide-opacity))
}

.theme-dark .dark\\:divide-teal-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#036672;
  border-color:rgba(3,102,114,var(--divide-opacity))
}

.theme-dark .dark\\:divide-teal-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#05505c;
  border-color:rgba(5,80,92,var(--divide-opacity))
}

.theme-dark .dark\\:divide-teal-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#014451;
  border-color:rgba(1,68,81,var(--divide-opacity))
}

.theme-dark .dark\\:divide-blue-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#ebf5ff;
  border-color:rgba(235,245,255,var(--divide-opacity))
}

.theme-dark .dark\\:divide-blue-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#e1effe;
  border-color:rgba(225,239,254,var(--divide-opacity))
}

.theme-dark .dark\\:divide-blue-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#c3ddfd;
  border-color:rgba(195,221,253,var(--divide-opacity))
}

.theme-dark .dark\\:divide-blue-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#a4cafe;
  border-color:rgba(164,202,254,var(--divide-opacity))
}

.theme-dark .dark\\:divide-blue-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#76a9fa;
  border-color:rgba(118,169,250,var(--divide-opacity))
}

.theme-dark .dark\\:divide-blue-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#3f83f8;
  border-color:rgba(63,131,248,var(--divide-opacity))
}

.theme-dark .dark\\:divide-blue-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#1c64f2;
  border-color:rgba(28,100,242,var(--divide-opacity))
}

.theme-dark .dark\\:divide-blue-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#1a56db;
  border-color:rgba(26,86,219,var(--divide-opacity))
}

.theme-dark .dark\\:divide-blue-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#1e429f;
  border-color:rgba(30,66,159,var(--divide-opacity))
}

.theme-dark .dark\\:divide-blue-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#233876;
  border-color:rgba(35,56,118,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f0f5ff;
  border-color:rgba(240,245,255,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#e5edff;
  border-color:rgba(229,237,255,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#cddbfe;
  border-color:rgba(205,219,254,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#b4c6fc;
  border-color:rgba(180,198,252,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#8da2fb;
  border-color:rgba(141,162,251,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#6875f5;
  border-color:rgba(104,117,245,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#5850ec;
  border-color:rgba(88,80,236,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#5145cd;
  border-color:rgba(81,69,205,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#42389d;
  border-color:rgba(66,56,157,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#362f78;
  border-color:rgba(54,47,120,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f6f5ff;
  border-color:rgba(246,245,255,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#edebfe;
  border-color:rgba(237,235,254,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#dcd7fe;
  border-color:rgba(220,215,254,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#cabffd;
  border-color:rgba(202,191,253,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#ac94fa;
  border-color:rgba(172,148,250,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#9061f9;
  border-color:rgba(144,97,249,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#7e3af2;
  border-color:rgba(126,58,242,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#6c2bd9;
  border-color:rgba(108,43,217,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#5521b5;
  border-color:rgba(85,33,181,var(--divide-opacity))
}

.theme-dark .dark\\:divide-indigo-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#4a1d96;
  border-color:rgba(74,29,150,var(--divide-opacity))
}

.theme-dark .dark\\:divide-pink-50>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fdf2f8;
  border-color:rgba(253,242,248,var(--divide-opacity))
}

.theme-dark .dark\\:divide-pink-100>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fce8f3;
  border-color:rgba(252,232,243,var(--divide-opacity))
}

.theme-dark .dark\\:divide-pink-200>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#fad1e8;
  border-color:rgba(250,209,232,var(--divide-opacity))
}

.theme-dark .dark\\:divide-pink-300>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f8b4d9;
  border-color:rgba(248,180,217,var(--divide-opacity))
}

.theme-dark .dark\\:divide-pink-400>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#f17eb8;
  border-color:rgba(241,126,184,var(--divide-opacity))
}

.theme-dark .dark\\:divide-pink-500>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#e74694;
  border-color:rgba(231,70,148,var(--divide-opacity))
}

.theme-dark .dark\\:divide-pink-600>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#d61f69;
  border-color:rgba(214,31,105,var(--divide-opacity))
}

.theme-dark .dark\\:divide-pink-700>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#bf125d;
  border-color:rgba(191,18,93,var(--divide-opacity))
}

.theme-dark .dark\\:divide-pink-800>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#99154b;
  border-color:rgba(153,21,75,var(--divide-opacity))
}

.theme-dark .dark\\:divide-pink-900>:not(template)~:not(template){
  --divide-opacity:1;
  border-color:#751a3d;
  border-color:rgba(117,26,61,var(--divide-opacity))
}

.divide-opacity-0>:not(template)~:not(template){
  --divide-opacity:0
}

.divide-opacity-25>:not(template)~:not(template){
  --divide-opacity:0.25
}

.divide-opacity-50>:not(template)~:not(template){
  --divide-opacity:0.5
}

.divide-opacity-75>:not(template)~:not(template){
  --divide-opacity:0.75
}

.divide-opacity-100>:not(template)~:not(template){
  --divide-opacity:1
}

.sr-only{
  height:1px;
  margin:-1px;
  overflow:hidden;
  padding:0;
  position:absolute;
  width:1px;
  clip:rect(0,0,0,0);
  border-width:0;
  white-space:nowrap
}

.not-sr-only{
  height:auto;
  margin:0;
  overflow:visible;
  padding:0;
  position:static;
  width:auto;
  clip:auto;
  white-space:normal
}

.focus\\:sr-only:focus{
  height:1px;
  margin:-1px;
  overflow:hidden;
  padding:0;
  position:absolute;
  width:1px;
  clip:rect(0,0,0,0);
  border-width:0;
  white-space:nowrap
}

.focus\\:not-sr-only:focus{
  height:auto;
  margin:0;
  overflow:visible;
  padding:0;
  position:static;
  width:auto;
  clip:auto;
  white-space:normal
}

.appearance-none{
  appearance:none
}

.bg-fixed{
  background-attachment:fixed
}

.bg-local{
  background-attachment:local
}

.bg-scroll{
  background-attachment:scroll
}

.bg-transparent{
  background-color:initial
}

.bg-white{
  --bg-opacity:1;
  background-color:#fff;
  background-color:rgba(255,255,255,var(--bg-opacity))
}

.bg-black{
  --bg-opacity:1;
  background-color:#000;
  background-color:rgba(0,0,0,var(--bg-opacity))
}

.bg-gray-50{
  --bg-opacity:1;
  background-color:#f9fafb;
  background-color:rgba(249,250,251,var(--bg-opacity))
}

.bg-gray-100{
  --bg-opacity:1;
  background-color:#f4f5f7;
  background-color:rgba(244,245,247,var(--bg-opacity))
}

.bg-gray-200{
  --bg-opacity:1;
  background-color:#e5e7eb;
  background-color:rgba(229,231,235,var(--bg-opacity))
}

.bg-gray-300{
  --bg-opacity:1;
  background-color:#d5d6d7;
  background-color:rgba(213,214,215,var(--bg-opacity))
}

.bg-gray-400{
  --bg-opacity:1;
  background-color:#9e9e9e;
  background-color:rgba(158,158,158,var(--bg-opacity))
}

.bg-gray-500{
  --bg-opacity:1;
  background-color:#707275;
  background-color:rgba(112,114,117,var(--bg-opacity))
}

.bg-gray-600{
  --bg-opacity:1;
  background-color:#4c4f52;
  background-color:rgba(76,79,82,var(--bg-opacity))
}

.bg-gray-700{
  --bg-opacity:1;
  background-color:#24262d;
  background-color:rgba(36,38,45,var(--bg-opacity))
}

.bg-gray-800{
  --bg-opacity:1;
  background-color:#1a1c23;
  background-color:rgba(26,28,35,var(--bg-opacity))
}

.bg-gray-900{
  --bg-opacity:1;
  background-color:#121317;
  background-color:rgba(18,19,23,var(--bg-opacity))
}

.bg-cool-gray-50{
  --bg-opacity:1;
  background-color:#fbfdfe;
  background-color:rgba(251,253,254,var(--bg-opacity))
}

.bg-cool-gray-100{
  --bg-opacity:1;
  background-color:#f1f5f9;
  background-color:rgba(241,245,249,var(--bg-opacity))
}

.bg-cool-gray-200{
  --bg-opacity:1;
  background-color:#e2e8f0;
  background-color:rgba(226,232,240,var(--bg-opacity))
}

.bg-cool-gray-300{
  --bg-opacity:1;
  background-color:#cfd8e3;
  background-color:rgba(207,216,227,var(--bg-opacity))
}

.bg-cool-gray-400{
  --bg-opacity:1;
  background-color:#97a6ba;
  background-color:rgba(151,166,186,var(--bg-opacity))
}

.bg-cool-gray-500{
  --bg-opacity:1;
  background-color:#64748b;
  background-color:rgba(100,116,139,var(--bg-opacity))
}

.bg-cool-gray-600{
  --bg-opacity:1;
  background-color:#475569;
  background-color:rgba(71,85,105,var(--bg-opacity))
}

.bg-cool-gray-700{
  --bg-opacity:1;
  background-color:#364152;
  background-color:rgba(54,65,82,var(--bg-opacity))
}

.bg-cool-gray-800{
  --bg-opacity:1;
  background-color:#27303f;
  background-color:rgba(39,48,63,var(--bg-opacity))
}

.bg-cool-gray-900{
  --bg-opacity:1;
  background-color:#1a202e;
  background-color:rgba(26,32,46,var(--bg-opacity))
}

.bg-red-50{
  --bg-opacity:1;
  background-color:#fdf2f2;
  background-color:rgba(253,242,242,var(--bg-opacity))
}

.bg-red-100{
  --bg-opacity:1;
  background-color:#fde8e8;
  background-color:rgba(253,232,232,var(--bg-opacity))
}

.bg-red-200{
  --bg-opacity:1;
  background-color:#fbd5d5;
  background-color:rgba(251,213,213,var(--bg-opacity))
}

.bg-red-300{
  --bg-opacity:1;
  background-color:#f8b4b4;
  background-color:rgba(248,180,180,var(--bg-opacity))
}

.bg-red-400{
  --bg-opacity:1;
  background-color:#f98080;
  background-color:rgba(249,128,128,var(--bg-opacity))
}

.bg-red-500{
  --bg-opacity:1;
  background-color:#f05252;
  background-color:rgba(240,82,82,var(--bg-opacity))
}

.bg-red-600{
  --bg-opacity:1;
  background-color:#e02424;
  background-color:rgba(224,36,36,var(--bg-opacity))
}

.bg-red-700{
  --bg-opacity:1;
  background-color:#c81e1e;
  background-color:rgba(200,30,30,var(--bg-opacity))
}

.bg-red-800{
  --bg-opacity:1;
  background-color:#9b1c1c;
  background-color:rgba(155,28,28,var(--bg-opacity))
}

.bg-red-900{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.bg-orange-50{
  --bg-opacity:1;
  background-color:#fff8f1;
  background-color:rgba(255,248,241,var(--bg-opacity))
}

.bg-orange-100{
  --bg-opacity:1;
  background-color:#feecdc;
  background-color:rgba(254,236,220,var(--bg-opacity))
}

.bg-orange-200{
  --bg-opacity:1;
  background-color:#fcd9bd;
  background-color:rgba(252,217,189,var(--bg-opacity))
}

.bg-orange-300{
  --bg-opacity:1;
  background-color:#fdba8c;
  background-color:rgba(253,186,140,var(--bg-opacity))
}

.bg-orange-400{
  --bg-opacity:1;
  background-color:#ff8a4c;
  background-color:rgba(255,138,76,var(--bg-opacity))
}

.bg-orange-500{
  --bg-opacity:1;
  background-color:#ff5a1f;
  background-color:rgba(255,90,31,var(--bg-opacity))
}

.bg-orange-600{
  --bg-opacity:1;
  background-color:#d03801;
  background-color:rgba(208,56,1,var(--bg-opacity))
}

.bg-orange-700{
  --bg-opacity:1;
  background-color:#b43403;
  background-color:rgba(180,52,3,var(--bg-opacity))
}

.bg-orange-800{
  --bg-opacity:1;
  background-color:#8a2c0d;
  background-color:rgba(138,44,13,var(--bg-opacity))
}

.bg-orange-900{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.bg-yellow-50{
  --bg-opacity:1;
  background-color:#fdfdea;
  background-color:rgba(253,253,234,var(--bg-opacity))
}

.bg-yellow-100{
  --bg-opacity:1;
  background-color:#fdf6b2;
  background-color:rgba(253,246,178,var(--bg-opacity))
}

.bg-yellow-200{
  --bg-opacity:1;
  background-color:#fce96a;
  background-color:rgba(252,233,106,var(--bg-opacity))
}

.bg-yellow-300{
  --bg-opacity:1;
  background-color:#faca15;
  background-color:rgba(250,202,21,var(--bg-opacity))
}

.bg-yellow-400{
  --bg-opacity:1;
  background-color:#e3a008;
  background-color:rgba(227,160,8,var(--bg-opacity))
}

.bg-yellow-500{
  --bg-opacity:1;
  background-color:#c27803;
  background-color:rgba(194,120,3,var(--bg-opacity))
}

.bg-yellow-600{
  --bg-opacity:1;
  background-color:#9f580a;
  background-color:rgba(159,88,10,var(--bg-opacity))
}

.bg-yellow-700{
  --bg-opacity:1;
  background-color:#8e4b10;
  background-color:rgba(142,75,16,var(--bg-opacity))
}

.bg-yellow-800{
  --bg-opacity:1;
  background-color:#723b13;
  background-color:rgba(114,59,19,var(--bg-opacity))
}

.bg-yellow-900{
  --bg-opacity:1;
  background-color:#633112;
  background-color:rgba(99,49,18,var(--bg-opacity))
}

.bg-green-50{
  --bg-opacity:1;
  background-color:#f3faf7;
  background-color:rgba(243,250,247,var(--bg-opacity))
}

.bg-green-100{
  --bg-opacity:1;
  background-color:#def7ec;
  background-color:rgba(222,247,236,var(--bg-opacity))
}

.bg-green-200{
  --bg-opacity:1;
  background-color:#bcf0da;
  background-color:rgba(188,240,218,var(--bg-opacity))
}

.bg-green-300{
  --bg-opacity:1;
  background-color:#84e1bc;
  background-color:rgba(132,225,188,var(--bg-opacity))
}

.bg-green-400{
  --bg-opacity:1;
  background-color:#31c48d;
  background-color:rgba(49,196,141,var(--bg-opacity))
}

.bg-green-500{
  --bg-opacity:1;
  background-color:#0e9f6e;
  background-color:rgba(14,159,110,var(--bg-opacity))
}

.bg-green-600{
  --bg-opacity:1;
  background-color:#057a55;
  background-color:rgba(5,122,85,var(--bg-opacity))
}

.bg-green-700{
  --bg-opacity:1;
  background-color:#046c4e;
  background-color:rgba(4,108,78,var(--bg-opacity))
}

.bg-green-800{
  --bg-opacity:1;
  background-color:#03543f;
  background-color:rgba(3,84,63,var(--bg-opacity))
}

.bg-green-900{
  --bg-opacity:1;
  background-color:#014737;
  background-color:rgba(1,71,55,var(--bg-opacity))
}

.bg-teal-50{
  --bg-opacity:1;
  background-color:#edfafa;
  background-color:rgba(237,250,250,var(--bg-opacity))
}

.bg-teal-100{
  --bg-opacity:1;
  background-color:#d5f5f6;
  background-color:rgba(213,245,246,var(--bg-opacity))
}

.bg-teal-200{
  --bg-opacity:1;
  background-color:#afecef;
  background-color:rgba(175,236,239,var(--bg-opacity))
}

.bg-teal-300{
  --bg-opacity:1;
  background-color:#7edce2;
  background-color:rgba(126,220,226,var(--bg-opacity))
}

.bg-teal-400{
  --bg-opacity:1;
  background-color:#16bdca;
  background-color:rgba(22,189,202,var(--bg-opacity))
}

.bg-teal-500{
  --bg-opacity:1;
  background-color:#0694a2;
  background-color:rgba(6,148,162,var(--bg-opacity))
}

.bg-teal-600{
  --bg-opacity:1;
  background-color:#047481;
  background-color:rgba(4,116,129,var(--bg-opacity))
}

.bg-teal-700{
  --bg-opacity:1;
  background-color:#036672;
  background-color:rgba(3,102,114,var(--bg-opacity))
}

.bg-teal-800{
  --bg-opacity:1;
  background-color:#05505c;
  background-color:rgba(5,80,92,var(--bg-opacity))
}

.bg-teal-900{
  --bg-opacity:1;
  background-color:#014451;
  background-color:rgba(1,68,81,var(--bg-opacity))
}

.bg-blue-50{
  --bg-opacity:1;
  background-color:#ebf5ff;
  background-color:rgba(235,245,255,var(--bg-opacity))
}

.bg-blue-100{
  --bg-opacity:1;
  background-color:#e1effe;
  background-color:rgba(225,239,254,var(--bg-opacity))
}

.bg-blue-200{
  --bg-opacity:1;
  background-color:#c3ddfd;
  background-color:rgba(195,221,253,var(--bg-opacity))
}

.bg-blue-300{
  --bg-opacity:1;
  background-color:#a4cafe;
  background-color:rgba(164,202,254,var(--bg-opacity))
}

.bg-blue-400{
  --bg-opacity:1;
  background-color:#76a9fa;
  background-color:rgba(118,169,250,var(--bg-opacity))
}

.bg-blue-500{
  --bg-opacity:1;
  background-color:#3f83f8;
  background-color:rgba(63,131,248,var(--bg-opacity))
}

.bg-blue-600{
  --bg-opacity:1;
  background-color:#1c64f2;
  background-color:rgba(28,100,242,var(--bg-opacity))
}

.bg-blue-700{
  --bg-opacity:1;
  background-color:#1a56db;
  background-color:rgba(26,86,219,var(--bg-opacity))
}

.bg-blue-800{
  --bg-opacity:1;
  background-color:#1e429f;
  background-color:rgba(30,66,159,var(--bg-opacity))
}

.bg-blue-900{
  --bg-opacity:1;
  background-color:#233876;
  background-color:rgba(35,56,118,var(--bg-opacity))
}

.bg-indigo-50{
  --bg-opacity:1;
  background-color:#f0f5ff;
  background-color:rgba(240,245,255,var(--bg-opacity))
}

.bg-indigo-100{
  --bg-opacity:1;
  background-color:#e5edff;
  background-color:rgba(229,237,255,var(--bg-opacity))
}

.bg-indigo-200{
  --bg-opacity:1;
  background-color:#cddbfe;
  background-color:rgba(205,219,254,var(--bg-opacity))
}

.bg-indigo-300{
  --bg-opacity:1;
  background-color:#b4c6fc;
  background-color:rgba(180,198,252,var(--bg-opacity))
}

.bg-indigo-400{
  --bg-opacity:1;
  background-color:#8da2fb;
  background-color:rgba(141,162,251,var(--bg-opacity))
}

.bg-indigo-500{
  --bg-opacity:1;
  background-color:#6875f5;
  background-color:rgba(104,117,245,var(--bg-opacity))
}

.bg-indigo-600{
  --bg-opacity:1;
  background-color:#5850ec;
  background-color:rgba(88,80,236,var(--bg-opacity))
}

.bg-indigo-700{
  --bg-opacity:1;
  background-color:#5145cd;
  background-color:rgba(81,69,205,var(--bg-opacity))
}

.bg-indigo-800{
  --bg-opacity:1;
  background-color:#42389d;
  background-color:rgba(66,56,157,var(--bg-opacity))
}

.bg-indigo-900{
  --bg-opacity:1;
  background-color:#362f78;
  background-color:rgba(54,47,120,var(--bg-opacity))
}

.bg-indigo-50{
  --bg-opacity:1;
  background-color:#f6f5ff;
  background-color:rgba(246,245,255,var(--bg-opacity))
}

.bg-indigo-100{
  --bg-opacity:1;
  background-color:#edebfe;
  background-color:rgba(237,235,254,var(--bg-opacity))
}

.bg-indigo-200{
  --bg-opacity:1;
  background-color:#dcd7fe;
  background-color:rgba(220,215,254,var(--bg-opacity))
}

.bg-indigo-300{
  --bg-opacity:1;
  background-color:#cabffd;
  background-color:rgba(202,191,253,var(--bg-opacity))
}

.bg-indigo-400{
  --bg-opacity:1;
  background-color:#ac94fa;
  background-color:rgba(172,148,250,var(--bg-opacity))
}

.bg-indigo-500{
  --bg-opacity:1;
  background-color:#9061f9;
  background-color:rgba(144,97,249,var(--bg-opacity))
}

.bg-indigo-600{
  --bg-opacity:1;
  background-color:#7e3af2;
  background-color:rgba(126,58,242,var(--bg-opacity))
}

.bg-indigo-700{
  --bg-opacity:1;
  background-color:#6c2bd9;
  background-color:rgba(108,43,217,var(--bg-opacity))
}

.bg-indigo-800{
  --bg-opacity:1;
  background-color:#5521b5;
  background-color:rgba(85,33,181,var(--bg-opacity))
}

.bg-indigo-900{
  --bg-opacity:1;
  background-color:#4a1d96;
  background-color:rgba(74,29,150,var(--bg-opacity))
}

.bg-pink-50{
  --bg-opacity:1;
  background-color:#fdf2f8;
  background-color:rgba(253,242,248,var(--bg-opacity))
}

.bg-pink-100{
  --bg-opacity:1;
  background-color:#fce8f3;
  background-color:rgba(252,232,243,var(--bg-opacity))
}

.bg-pink-200{
  --bg-opacity:1;
  background-color:#fad1e8;
  background-color:rgba(250,209,232,var(--bg-opacity))
}

.bg-pink-300{
  --bg-opacity:1;
  background-color:#f8b4d9;
  background-color:rgba(248,180,217,var(--bg-opacity))
}

.bg-pink-400{
  --bg-opacity:1;
  background-color:#f17eb8;
  background-color:rgba(241,126,184,var(--bg-opacity))
}

.bg-pink-500{
  --bg-opacity:1;
  background-color:#e74694;
  background-color:rgba(231,70,148,var(--bg-opacity))
}

.bg-pink-600{
  --bg-opacity:1;
  background-color:#d61f69;
  background-color:rgba(214,31,105,var(--bg-opacity))
}

.bg-pink-700{
  --bg-opacity:1;
  background-color:#bf125d;
  background-color:rgba(191,18,93,var(--bg-opacity))
}

.bg-pink-800{
  --bg-opacity:1;
  background-color:#99154b;
  background-color:rgba(153,21,75,var(--bg-opacity))
}

.bg-pink-900{
  --bg-opacity:1;
  background-color:#751a3d;
  background-color:rgba(117,26,61,var(--bg-opacity))
}

.hover\\:bg-transparent:hover{
  background-color:initial
}

.hover\\:bg-white:hover{
  --bg-opacity:1;
  background-color:#fff;
  background-color:rgba(255,255,255,var(--bg-opacity))
}

.hover\\:bg-black:hover{
  --bg-opacity:1;
  background-color:#000;
  background-color:rgba(0,0,0,var(--bg-opacity))
}

.hover\\:bg-gray-50:hover{
  --bg-opacity:1;
  background-color:#f9fafb;
  background-color:rgba(249,250,251,var(--bg-opacity))
}

.hover\\:bg-gray-100:hover{
  --bg-opacity:1;
  background-color:#f4f5f7;
  background-color:rgba(244,245,247,var(--bg-opacity))
}

.hover\\:bg-gray-200:hover{
  --bg-opacity:1;
  background-color:#e5e7eb;
  background-color:rgba(229,231,235,var(--bg-opacity))
}

.hover\\:bg-gray-300:hover{
  --bg-opacity:1;
  background-color:#d5d6d7;
  background-color:rgba(213,214,215,var(--bg-opacity))
}

.hover\\:bg-gray-400:hover{
  --bg-opacity:1;
  background-color:#9e9e9e;
  background-color:rgba(158,158,158,var(--bg-opacity))
}

.hover\\:bg-gray-500:hover{
  --bg-opacity:1;
  background-color:#707275;
  background-color:rgba(112,114,117,var(--bg-opacity))
}

.hover\\:bg-gray-600:hover{
  --bg-opacity:1;
  background-color:#4c4f52;
  background-color:rgba(76,79,82,var(--bg-opacity))
}

.hover\\:bg-gray-700:hover{
  --bg-opacity:1;
  background-color:#24262d;
  background-color:rgba(36,38,45,var(--bg-opacity))
}

.hover\\:bg-gray-800:hover{
  --bg-opacity:1;
  background-color:#1a1c23;
  background-color:rgba(26,28,35,var(--bg-opacity))
}

.hover\\:bg-gray-900:hover{
  --bg-opacity:1;
  background-color:#121317;
  background-color:rgba(18,19,23,var(--bg-opacity))
}

.hover\\:bg-cool-gray-50:hover{
  --bg-opacity:1;
  background-color:#fbfdfe;
  background-color:rgba(251,253,254,var(--bg-opacity))
}

.hover\\:bg-cool-gray-100:hover{
  --bg-opacity:1;
  background-color:#f1f5f9;
  background-color:rgba(241,245,249,var(--bg-opacity))
}

.hover\\:bg-cool-gray-200:hover{
  --bg-opacity:1;
  background-color:#e2e8f0;
  background-color:rgba(226,232,240,var(--bg-opacity))
}

.hover\\:bg-cool-gray-300:hover{
  --bg-opacity:1;
  background-color:#cfd8e3;
  background-color:rgba(207,216,227,var(--bg-opacity))
}

.hover\\:bg-cool-gray-400:hover{
  --bg-opacity:1;
  background-color:#97a6ba;
  background-color:rgba(151,166,186,var(--bg-opacity))
}

.hover\\:bg-cool-gray-500:hover{
  --bg-opacity:1;
  background-color:#64748b;
  background-color:rgba(100,116,139,var(--bg-opacity))
}

.hover\\:bg-cool-gray-600:hover{
  --bg-opacity:1;
  background-color:#475569;
  background-color:rgba(71,85,105,var(--bg-opacity))
}

.hover\\:bg-cool-gray-700:hover{
  --bg-opacity:1;
  background-color:#364152;
  background-color:rgba(54,65,82,var(--bg-opacity))
}

.hover\\:bg-cool-gray-800:hover{
  --bg-opacity:1;
  background-color:#27303f;
  background-color:rgba(39,48,63,var(--bg-opacity))
}

.hover\\:bg-cool-gray-900:hover{
  --bg-opacity:1;
  background-color:#1a202e;
  background-color:rgba(26,32,46,var(--bg-opacity))
}

.hover\\:bg-red-50:hover{
  --bg-opacity:1;
  background-color:#fdf2f2;
  background-color:rgba(253,242,242,var(--bg-opacity))
}

.hover\\:bg-red-100:hover{
  --bg-opacity:1;
  background-color:#fde8e8;
  background-color:rgba(253,232,232,var(--bg-opacity))
}

.hover\\:bg-red-200:hover{
  --bg-opacity:1;
  background-color:#fbd5d5;
  background-color:rgba(251,213,213,var(--bg-opacity))
}

.hover\\:bg-red-300:hover{
  --bg-opacity:1;
  background-color:#f8b4b4;
  background-color:rgba(248,180,180,var(--bg-opacity))
}

.hover\\:bg-red-400:hover{
  --bg-opacity:1;
  background-color:#f98080;
  background-color:rgba(249,128,128,var(--bg-opacity))
}

.hover\\:bg-red-500:hover{
  --bg-opacity:1;
  background-color:#f05252;
  background-color:rgba(240,82,82,var(--bg-opacity))
}

.hover\\:bg-red-600:hover{
  --bg-opacity:1;
  background-color:#e02424;
  background-color:rgba(224,36,36,var(--bg-opacity))
}

.hover\\:bg-red-700:hover{
  --bg-opacity:1;
  background-color:#c81e1e;
  background-color:rgba(200,30,30,var(--bg-opacity))
}

.hover\\:bg-red-800:hover{
  --bg-opacity:1;
  background-color:#9b1c1c;
  background-color:rgba(155,28,28,var(--bg-opacity))
}

.hover\\:bg-red-900:hover{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.hover\\:bg-orange-50:hover{
  --bg-opacity:1;
  background-color:#fff8f1;
  background-color:rgba(255,248,241,var(--bg-opacity))
}

.hover\\:bg-orange-100:hover{
  --bg-opacity:1;
  background-color:#feecdc;
  background-color:rgba(254,236,220,var(--bg-opacity))
}

.hover\\:bg-orange-200:hover{
  --bg-opacity:1;
  background-color:#fcd9bd;
  background-color:rgba(252,217,189,var(--bg-opacity))
}

.hover\\:bg-orange-300:hover{
  --bg-opacity:1;
  background-color:#fdba8c;
  background-color:rgba(253,186,140,var(--bg-opacity))
}

.hover\\:bg-orange-400:hover{
  --bg-opacity:1;
  background-color:#ff8a4c;
  background-color:rgba(255,138,76,var(--bg-opacity))
}

.hover\\:bg-orange-500:hover{
  --bg-opacity:1;
  background-color:#ff5a1f;
  background-color:rgba(255,90,31,var(--bg-opacity))
}

.hover\\:bg-orange-600:hover{
  --bg-opacity:1;
  background-color:#d03801;
  background-color:rgba(208,56,1,var(--bg-opacity))
}

.hover\\:bg-orange-700:hover{
  --bg-opacity:1;
  background-color:#b43403;
  background-color:rgba(180,52,3,var(--bg-opacity))
}

.hover\\:bg-orange-800:hover{
  --bg-opacity:1;
  background-color:#8a2c0d;
  background-color:rgba(138,44,13,var(--bg-opacity))
}

.hover\\:bg-orange-900:hover{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.hover\\:bg-yellow-50:hover{
  --bg-opacity:1;
  background-color:#fdfdea;
  background-color:rgba(253,253,234,var(--bg-opacity))
}

.hover\\:bg-yellow-100:hover{
  --bg-opacity:1;
  background-color:#fdf6b2;
  background-color:rgba(253,246,178,var(--bg-opacity))
}

.hover\\:bg-yellow-200:hover{
  --bg-opacity:1;
  background-color:#fce96a;
  background-color:rgba(252,233,106,var(--bg-opacity))
}

.hover\\:bg-yellow-300:hover{
  --bg-opacity:1;
  background-color:#faca15;
  background-color:rgba(250,202,21,var(--bg-opacity))
}

.hover\\:bg-yellow-400:hover{
  --bg-opacity:1;
  background-color:#e3a008;
  background-color:rgba(227,160,8,var(--bg-opacity))
}

.hover\\:bg-yellow-500:hover{
  --bg-opacity:1;
  background-color:#c27803;
  background-color:rgba(194,120,3,var(--bg-opacity))
}

.hover\\:bg-yellow-600:hover{
  --bg-opacity:1;
  background-color:#9f580a;
  background-color:rgba(159,88,10,var(--bg-opacity))
}

.hover\\:bg-yellow-700:hover{
  --bg-opacity:1;
  background-color:#8e4b10;
  background-color:rgba(142,75,16,var(--bg-opacity))
}

.hover\\:bg-yellow-800:hover{
  --bg-opacity:1;
  background-color:#723b13;
  background-color:rgba(114,59,19,var(--bg-opacity))
}

.hover\\:bg-yellow-900:hover{
  --bg-opacity:1;
  background-color:#633112;
  background-color:rgba(99,49,18,var(--bg-opacity))
}

.hover\\:bg-green-50:hover{
  --bg-opacity:1;
  background-color:#f3faf7;
  background-color:rgba(243,250,247,var(--bg-opacity))
}

.hover\\:bg-green-100:hover{
  --bg-opacity:1;
  background-color:#def7ec;
  background-color:rgba(222,247,236,var(--bg-opacity))
}

.hover\\:bg-green-200:hover{
  --bg-opacity:1;
  background-color:#bcf0da;
  background-color:rgba(188,240,218,var(--bg-opacity))
}

.hover\\:bg-green-300:hover{
  --bg-opacity:1;
  background-color:#84e1bc;
  background-color:rgba(132,225,188,var(--bg-opacity))
}

.hover\\:bg-green-400:hover{
  --bg-opacity:1;
  background-color:#31c48d;
  background-color:rgba(49,196,141,var(--bg-opacity))
}

.hover\\:bg-green-500:hover{
  --bg-opacity:1;
  background-color:#0e9f6e;
  background-color:rgba(14,159,110,var(--bg-opacity))
}

.hover\\:bg-green-600:hover{
  --bg-opacity:1;
  background-color:#057a55;
  background-color:rgba(5,122,85,var(--bg-opacity))
}

.hover\\:bg-green-700:hover{
  --bg-opacity:1;
  background-color:#046c4e;
  background-color:rgba(4,108,78,var(--bg-opacity))
}

.hover\\:bg-green-800:hover{
  --bg-opacity:1;
  background-color:#03543f;
  background-color:rgba(3,84,63,var(--bg-opacity))
}

.hover\\:bg-green-900:hover{
  --bg-opacity:1;
  background-color:#014737;
  background-color:rgba(1,71,55,var(--bg-opacity))
}

.hover\\:bg-teal-50:hover{
  --bg-opacity:1;
  background-color:#edfafa;
  background-color:rgba(237,250,250,var(--bg-opacity))
}

.hover\\:bg-teal-100:hover{
  --bg-opacity:1;
  background-color:#d5f5f6;
  background-color:rgba(213,245,246,var(--bg-opacity))
}

.hover\\:bg-teal-200:hover{
  --bg-opacity:1;
  background-color:#afecef;
  background-color:rgba(175,236,239,var(--bg-opacity))
}

.hover\\:bg-teal-300:hover{
  --bg-opacity:1;
  background-color:#7edce2;
  background-color:rgba(126,220,226,var(--bg-opacity))
}

.hover\\:bg-teal-400:hover{
  --bg-opacity:1;
  background-color:#16bdca;
  background-color:rgba(22,189,202,var(--bg-opacity))
}

.hover\\:bg-teal-500:hover{
  --bg-opacity:1;
  background-color:#0694a2;
  background-color:rgba(6,148,162,var(--bg-opacity))
}

.hover\\:bg-teal-600:hover{
  --bg-opacity:1;
  background-color:#047481;
  background-color:rgba(4,116,129,var(--bg-opacity))
}

.hover\\:bg-teal-700:hover{
  --bg-opacity:1;
  background-color:#036672;
  background-color:rgba(3,102,114,var(--bg-opacity))
}

.hover\\:bg-teal-800:hover{
  --bg-opacity:1;
  background-color:#05505c;
  background-color:rgba(5,80,92,var(--bg-opacity))
}

.hover\\:bg-teal-900:hover{
  --bg-opacity:1;
  background-color:#014451;
  background-color:rgba(1,68,81,var(--bg-opacity))
}

.hover\\:bg-blue-50:hover{
  --bg-opacity:1;
  background-color:#ebf5ff;
  background-color:rgba(235,245,255,var(--bg-opacity))
}

.hover\\:bg-blue-100:hover{
  --bg-opacity:1;
  background-color:#e1effe;
  background-color:rgba(225,239,254,var(--bg-opacity))
}

.hover\\:bg-blue-200:hover{
  --bg-opacity:1;
  background-color:#c3ddfd;
  background-color:rgba(195,221,253,var(--bg-opacity))
}

.hover\\:bg-blue-300:hover{
  --bg-opacity:1;
  background-color:#a4cafe;
  background-color:rgba(164,202,254,var(--bg-opacity))
}

.hover\\:bg-blue-400:hover{
  --bg-opacity:1;
  background-color:#76a9fa;
  background-color:rgba(118,169,250,var(--bg-opacity))
}

.hover\\:bg-blue-500:hover{
  --bg-opacity:1;
  background-color:#3f83f8;
  background-color:rgba(63,131,248,var(--bg-opacity))
}

.hover\\:bg-blue-600:hover{
  --bg-opacity:1;
  background-color:#1c64f2;
  background-color:rgba(28,100,242,var(--bg-opacity))
}

.hover\\:bg-blue-700:hover{
  --bg-opacity:1;
  background-color:#1a56db;
  background-color:rgba(26,86,219,var(--bg-opacity))
}

.hover\\:bg-blue-800:hover{
  --bg-opacity:1;
  background-color:#1e429f;
  background-color:rgba(30,66,159,var(--bg-opacity))
}

.hover\\:bg-blue-900:hover{
  --bg-opacity:1;
  background-color:#233876;
  background-color:rgba(35,56,118,var(--bg-opacity))
}

.hover\\:bg-indigo-50:hover{
  --bg-opacity:1;
  background-color:#f0f5ff;
  background-color:rgba(240,245,255,var(--bg-opacity))
}

.hover\\:bg-indigo-100:hover{
  --bg-opacity:1;
  background-color:#e5edff;
  background-color:rgba(229,237,255,var(--bg-opacity))
}

.hover\\:bg-indigo-200:hover{
  --bg-opacity:1;
  background-color:#cddbfe;
  background-color:rgba(205,219,254,var(--bg-opacity))
}

.hover\\:bg-indigo-300:hover{
  --bg-opacity:1;
  background-color:#b4c6fc;
  background-color:rgba(180,198,252,var(--bg-opacity))
}

.hover\\:bg-indigo-400:hover{
  --bg-opacity:1;
  background-color:#8da2fb;
  background-color:rgba(141,162,251,var(--bg-opacity))
}

.hover\\:bg-indigo-500:hover{
  --bg-opacity:1;
  background-color:#6875f5;
  background-color:rgba(104,117,245,var(--bg-opacity))
}

.hover\\:bg-indigo-600:hover{
  --bg-opacity:1;
  background-color:#5850ec;
  background-color:rgba(88,80,236,var(--bg-opacity))
}

.hover\\:bg-indigo-700:hover{
  --bg-opacity:1;
  background-color:#5145cd;
  background-color:rgba(81,69,205,var(--bg-opacity))
}

.hover\\:bg-indigo-800:hover{
  --bg-opacity:1;
  background-color:#42389d;
  background-color:rgba(66,56,157,var(--bg-opacity))
}

.hover\\:bg-indigo-900:hover{
  --bg-opacity:1;
  background-color:#362f78;
  background-color:rgba(54,47,120,var(--bg-opacity))
}

.hover\\:bg-indigo-50:hover{
  --bg-opacity:1;
  background-color:#f6f5ff;
  background-color:rgba(246,245,255,var(--bg-opacity))
}

.hover\\:bg-indigo-100:hover{
  --bg-opacity:1;
  background-color:#edebfe;
  background-color:rgba(237,235,254,var(--bg-opacity))
}

.hover\\:bg-indigo-200:hover{
  --bg-opacity:1;
  background-color:#dcd7fe;
  background-color:rgba(220,215,254,var(--bg-opacity))
}

.hover\\:bg-indigo-300:hover{
  --bg-opacity:1;
  background-color:#cabffd;
  background-color:rgba(202,191,253,var(--bg-opacity))
}

.hover\\:bg-indigo-400:hover{
  --bg-opacity:1;
  background-color:#ac94fa;
  background-color:rgba(172,148,250,var(--bg-opacity))
}

.hover\\:bg-indigo-500:hover{
  --bg-opacity:1;
  background-color:#9061f9;
  background-color:rgba(144,97,249,var(--bg-opacity))
}

.hover\\:bg-indigo-600:hover{
  --bg-opacity:1;
  background-color:#7e3af2;
  background-color:rgba(126,58,242,var(--bg-opacity))
}

.hover\\:bg-indigo-700:hover{
  --bg-opacity:1;
  background-color:#6c2bd9;
  background-color:rgba(108,43,217,var(--bg-opacity))
}

.hover\\:bg-indigo-800:hover{
  --bg-opacity:1;
  background-color:#5521b5;
  background-color:rgba(85,33,181,var(--bg-opacity))
}

.hover\\:bg-indigo-900:hover{
  --bg-opacity:1;
  background-color:#4a1d96;
  background-color:rgba(74,29,150,var(--bg-opacity))
}

.hover\\:bg-pink-50:hover{
  --bg-opacity:1;
  background-color:#fdf2f8;
  background-color:rgba(253,242,248,var(--bg-opacity))
}

.hover\\:bg-pink-100:hover{
  --bg-opacity:1;
  background-color:#fce8f3;
  background-color:rgba(252,232,243,var(--bg-opacity))
}

.hover\\:bg-pink-200:hover{
  --bg-opacity:1;
  background-color:#fad1e8;
  background-color:rgba(250,209,232,var(--bg-opacity))
}

.hover\\:bg-pink-300:hover{
  --bg-opacity:1;
  background-color:#f8b4d9;
  background-color:rgba(248,180,217,var(--bg-opacity))
}

.hover\\:bg-pink-400:hover{
  --bg-opacity:1;
  background-color:#f17eb8;
  background-color:rgba(241,126,184,var(--bg-opacity))
}

.hover\\:bg-pink-500:hover{
  --bg-opacity:1;
  background-color:#e74694;
  background-color:rgba(231,70,148,var(--bg-opacity))
}

.hover\\:bg-pink-600:hover{
  --bg-opacity:1;
  background-color:#d61f69;
  background-color:rgba(214,31,105,var(--bg-opacity))
}

.hover\\:bg-pink-700:hover{
  --bg-opacity:1;
  background-color:#bf125d;
  background-color:rgba(191,18,93,var(--bg-opacity))
}

.hover\\:bg-pink-800:hover{
  --bg-opacity:1;
  background-color:#99154b;
  background-color:rgba(153,21,75,var(--bg-opacity))
}

.hover\\:bg-pink-900:hover{
  --bg-opacity:1;
  background-color:#751a3d;
  background-color:rgba(117,26,61,var(--bg-opacity))
}

.focus\\:bg-transparent:focus{
  background-color:initial
}

.focus\\:bg-white:focus{
  --bg-opacity:1;
  background-color:#fff;
  background-color:rgba(255,255,255,var(--bg-opacity))
}

.focus\\:bg-black:focus{
  --bg-opacity:1;
  background-color:#000;
  background-color:rgba(0,0,0,var(--bg-opacity))
}

.focus\\:bg-gray-50:focus{
  --bg-opacity:1;
  background-color:#f9fafb;
  background-color:rgba(249,250,251,var(--bg-opacity))
}

.focus\\:bg-gray-100:focus{
  --bg-opacity:1;
  background-color:#f4f5f7;
  background-color:rgba(244,245,247,var(--bg-opacity))
}

.focus\\:bg-gray-200:focus{
  --bg-opacity:1;
  background-color:#e5e7eb;
  background-color:rgba(229,231,235,var(--bg-opacity))
}

.focus\\:bg-gray-300:focus{
  --bg-opacity:1;
  background-color:#d5d6d7;
  background-color:rgba(213,214,215,var(--bg-opacity))
}

.focus\\:bg-gray-400:focus{
  --bg-opacity:1;
  background-color:#9e9e9e;
  background-color:rgba(158,158,158,var(--bg-opacity))
}

.focus\\:bg-gray-500:focus{
  --bg-opacity:1;
  background-color:#707275;
  background-color:rgba(112,114,117,var(--bg-opacity))
}

.focus\\:bg-gray-600:focus{
  --bg-opacity:1;
  background-color:#4c4f52;
  background-color:rgba(76,79,82,var(--bg-opacity))
}

.focus\\:bg-gray-700:focus{
  --bg-opacity:1;
  background-color:#24262d;
  background-color:rgba(36,38,45,var(--bg-opacity))
}

.focus\\:bg-gray-800:focus{
  --bg-opacity:1;
  background-color:#1a1c23;
  background-color:rgba(26,28,35,var(--bg-opacity))
}

.focus\\:bg-gray-900:focus{
  --bg-opacity:1;
  background-color:#121317;
  background-color:rgba(18,19,23,var(--bg-opacity))
}

.focus\\:bg-cool-gray-50:focus{
  --bg-opacity:1;
  background-color:#fbfdfe;
  background-color:rgba(251,253,254,var(--bg-opacity))
}

.focus\\:bg-cool-gray-100:focus{
  --bg-opacity:1;
  background-color:#f1f5f9;
  background-color:rgba(241,245,249,var(--bg-opacity))
}

.focus\\:bg-cool-gray-200:focus{
  --bg-opacity:1;
  background-color:#e2e8f0;
  background-color:rgba(226,232,240,var(--bg-opacity))
}

.focus\\:bg-cool-gray-300:focus{
  --bg-opacity:1;
  background-color:#cfd8e3;
  background-color:rgba(207,216,227,var(--bg-opacity))
}

.focus\\:bg-cool-gray-400:focus{
  --bg-opacity:1;
  background-color:#97a6ba;
  background-color:rgba(151,166,186,var(--bg-opacity))
}

.focus\\:bg-cool-gray-500:focus{
  --bg-opacity:1;
  background-color:#64748b;
  background-color:rgba(100,116,139,var(--bg-opacity))
}

.focus\\:bg-cool-gray-600:focus{
  --bg-opacity:1;
  background-color:#475569;
  background-color:rgba(71,85,105,var(--bg-opacity))
}

.focus\\:bg-cool-gray-700:focus{
  --bg-opacity:1;
  background-color:#364152;
  background-color:rgba(54,65,82,var(--bg-opacity))
}

.focus\\:bg-cool-gray-800:focus{
  --bg-opacity:1;
  background-color:#27303f;
  background-color:rgba(39,48,63,var(--bg-opacity))
}

.focus\\:bg-cool-gray-900:focus{
  --bg-opacity:1;
  background-color:#1a202e;
  background-color:rgba(26,32,46,var(--bg-opacity))
}

.focus\\:bg-red-50:focus{
  --bg-opacity:1;
  background-color:#fdf2f2;
  background-color:rgba(253,242,242,var(--bg-opacity))
}

.focus\\:bg-red-100:focus{
  --bg-opacity:1;
  background-color:#fde8e8;
  background-color:rgba(253,232,232,var(--bg-opacity))
}

.focus\\:bg-red-200:focus{
  --bg-opacity:1;
  background-color:#fbd5d5;
  background-color:rgba(251,213,213,var(--bg-opacity))
}

.focus\\:bg-red-300:focus{
  --bg-opacity:1;
  background-color:#f8b4b4;
  background-color:rgba(248,180,180,var(--bg-opacity))
}

.focus\\:bg-red-400:focus{
  --bg-opacity:1;
  background-color:#f98080;
  background-color:rgba(249,128,128,var(--bg-opacity))
}

.focus\\:bg-red-500:focus{
  --bg-opacity:1;
  background-color:#f05252;
  background-color:rgba(240,82,82,var(--bg-opacity))
}

.focus\\:bg-red-600:focus{
  --bg-opacity:1;
  background-color:#e02424;
  background-color:rgba(224,36,36,var(--bg-opacity))
}

.focus\\:bg-red-700:focus{
  --bg-opacity:1;
  background-color:#c81e1e;
  background-color:rgba(200,30,30,var(--bg-opacity))
}

.focus\\:bg-red-800:focus{
  --bg-opacity:1;
  background-color:#9b1c1c;
  background-color:rgba(155,28,28,var(--bg-opacity))
}

.focus\\:bg-red-900:focus{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.focus\\:bg-orange-50:focus{
  --bg-opacity:1;
  background-color:#fff8f1;
  background-color:rgba(255,248,241,var(--bg-opacity))
}

.focus\\:bg-orange-100:focus{
  --bg-opacity:1;
  background-color:#feecdc;
  background-color:rgba(254,236,220,var(--bg-opacity))
}

.focus\\:bg-orange-200:focus{
  --bg-opacity:1;
  background-color:#fcd9bd;
  background-color:rgba(252,217,189,var(--bg-opacity))
}

.focus\\:bg-orange-300:focus{
  --bg-opacity:1;
  background-color:#fdba8c;
  background-color:rgba(253,186,140,var(--bg-opacity))
}

.focus\\:bg-orange-400:focus{
  --bg-opacity:1;
  background-color:#ff8a4c;
  background-color:rgba(255,138,76,var(--bg-opacity))
}

.focus\\:bg-orange-500:focus{
  --bg-opacity:1;
  background-color:#ff5a1f;
  background-color:rgba(255,90,31,var(--bg-opacity))
}

.focus\\:bg-orange-600:focus{
  --bg-opacity:1;
  background-color:#d03801;
  background-color:rgba(208,56,1,var(--bg-opacity))
}

.focus\\:bg-orange-700:focus{
  --bg-opacity:1;
  background-color:#b43403;
  background-color:rgba(180,52,3,var(--bg-opacity))
}

.focus\\:bg-orange-800:focus{
  --bg-opacity:1;
  background-color:#8a2c0d;
  background-color:rgba(138,44,13,var(--bg-opacity))
}

.focus\\:bg-orange-900:focus{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.focus\\:bg-yellow-50:focus{
  --bg-opacity:1;
  background-color:#fdfdea;
  background-color:rgba(253,253,234,var(--bg-opacity))
}

.focus\\:bg-yellow-100:focus{
  --bg-opacity:1;
  background-color:#fdf6b2;
  background-color:rgba(253,246,178,var(--bg-opacity))
}

.focus\\:bg-yellow-200:focus{
  --bg-opacity:1;
  background-color:#fce96a;
  background-color:rgba(252,233,106,var(--bg-opacity))
}

.focus\\:bg-yellow-300:focus{
  --bg-opacity:1;
  background-color:#faca15;
  background-color:rgba(250,202,21,var(--bg-opacity))
}

.focus\\:bg-yellow-400:focus{
  --bg-opacity:1;
  background-color:#e3a008;
  background-color:rgba(227,160,8,var(--bg-opacity))
}

.focus\\:bg-yellow-500:focus{
  --bg-opacity:1;
  background-color:#c27803;
  background-color:rgba(194,120,3,var(--bg-opacity))
}

.focus\\:bg-yellow-600:focus{
  --bg-opacity:1;
  background-color:#9f580a;
  background-color:rgba(159,88,10,var(--bg-opacity))
}

.focus\\:bg-yellow-700:focus{
  --bg-opacity:1;
  background-color:#8e4b10;
  background-color:rgba(142,75,16,var(--bg-opacity))
}

.focus\\:bg-yellow-800:focus{
  --bg-opacity:1;
  background-color:#723b13;
  background-color:rgba(114,59,19,var(--bg-opacity))
}

.focus\\:bg-yellow-900:focus{
  --bg-opacity:1;
  background-color:#633112;
  background-color:rgba(99,49,18,var(--bg-opacity))
}

.focus\\:bg-green-50:focus{
  --bg-opacity:1;
  background-color:#f3faf7;
  background-color:rgba(243,250,247,var(--bg-opacity))
}

.focus\\:bg-green-100:focus{
  --bg-opacity:1;
  background-color:#def7ec;
  background-color:rgba(222,247,236,var(--bg-opacity))
}

.focus\\:bg-green-200:focus{
  --bg-opacity:1;
  background-color:#bcf0da;
  background-color:rgba(188,240,218,var(--bg-opacity))
}

.focus\\:bg-green-300:focus{
  --bg-opacity:1;
  background-color:#84e1bc;
  background-color:rgba(132,225,188,var(--bg-opacity))
}

.focus\\:bg-green-400:focus{
  --bg-opacity:1;
  background-color:#31c48d;
  background-color:rgba(49,196,141,var(--bg-opacity))
}

.focus\\:bg-green-500:focus{
  --bg-opacity:1;
  background-color:#0e9f6e;
  background-color:rgba(14,159,110,var(--bg-opacity))
}

.focus\\:bg-green-600:focus{
  --bg-opacity:1;
  background-color:#057a55;
  background-color:rgba(5,122,85,var(--bg-opacity))
}

.focus\\:bg-green-700:focus{
  --bg-opacity:1;
  background-color:#046c4e;
  background-color:rgba(4,108,78,var(--bg-opacity))
}

.focus\\:bg-green-800:focus{
  --bg-opacity:1;
  background-color:#03543f;
  background-color:rgba(3,84,63,var(--bg-opacity))
}

.focus\\:bg-green-900:focus{
  --bg-opacity:1;
  background-color:#014737;
  background-color:rgba(1,71,55,var(--bg-opacity))
}

.focus\\:bg-teal-50:focus{
  --bg-opacity:1;
  background-color:#edfafa;
  background-color:rgba(237,250,250,var(--bg-opacity))
}

.focus\\:bg-teal-100:focus{
  --bg-opacity:1;
  background-color:#d5f5f6;
  background-color:rgba(213,245,246,var(--bg-opacity))
}

.focus\\:bg-teal-200:focus{
  --bg-opacity:1;
  background-color:#afecef;
  background-color:rgba(175,236,239,var(--bg-opacity))
}

.focus\\:bg-teal-300:focus{
  --bg-opacity:1;
  background-color:#7edce2;
  background-color:rgba(126,220,226,var(--bg-opacity))
}

.focus\\:bg-teal-400:focus{
  --bg-opacity:1;
  background-color:#16bdca;
  background-color:rgba(22,189,202,var(--bg-opacity))
}

.focus\\:bg-teal-500:focus{
  --bg-opacity:1;
  background-color:#0694a2;
  background-color:rgba(6,148,162,var(--bg-opacity))
}

.focus\\:bg-teal-600:focus{
  --bg-opacity:1;
  background-color:#047481;
  background-color:rgba(4,116,129,var(--bg-opacity))
}

.focus\\:bg-teal-700:focus{
  --bg-opacity:1;
  background-color:#036672;
  background-color:rgba(3,102,114,var(--bg-opacity))
}

.focus\\:bg-teal-800:focus{
  --bg-opacity:1;
  background-color:#05505c;
  background-color:rgba(5,80,92,var(--bg-opacity))
}

.focus\\:bg-teal-900:focus{
  --bg-opacity:1;
  background-color:#014451;
  background-color:rgba(1,68,81,var(--bg-opacity))
}

.focus\\:bg-blue-50:focus{
  --bg-opacity:1;
  background-color:#ebf5ff;
  background-color:rgba(235,245,255,var(--bg-opacity))
}

.focus\\:bg-blue-100:focus{
  --bg-opacity:1;
  background-color:#e1effe;
  background-color:rgba(225,239,254,var(--bg-opacity))
}

.focus\\:bg-blue-200:focus{
  --bg-opacity:1;
  background-color:#c3ddfd;
  background-color:rgba(195,221,253,var(--bg-opacity))
}

.focus\\:bg-blue-300:focus{
  --bg-opacity:1;
  background-color:#a4cafe;
  background-color:rgba(164,202,254,var(--bg-opacity))
}

.focus\\:bg-blue-400:focus{
  --bg-opacity:1;
  background-color:#76a9fa;
  background-color:rgba(118,169,250,var(--bg-opacity))
}

.focus\\:bg-blue-500:focus{
  --bg-opacity:1;
  background-color:#3f83f8;
  background-color:rgba(63,131,248,var(--bg-opacity))
}

.focus\\:bg-blue-600:focus{
  --bg-opacity:1;
  background-color:#1c64f2;
  background-color:rgba(28,100,242,var(--bg-opacity))
}

.focus\\:bg-blue-700:focus{
  --bg-opacity:1;
  background-color:#1a56db;
  background-color:rgba(26,86,219,var(--bg-opacity))
}

.focus\\:bg-blue-800:focus{
  --bg-opacity:1;
  background-color:#1e429f;
  background-color:rgba(30,66,159,var(--bg-opacity))
}

.focus\\:bg-blue-900:focus{
  --bg-opacity:1;
  background-color:#233876;
  background-color:rgba(35,56,118,var(--bg-opacity))
}

.focus\\:bg-indigo-50:focus{
  --bg-opacity:1;
  background-color:#f0f5ff;
  background-color:rgba(240,245,255,var(--bg-opacity))
}

.focus\\:bg-indigo-100:focus{
  --bg-opacity:1;
  background-color:#e5edff;
  background-color:rgba(229,237,255,var(--bg-opacity))
}

.focus\\:bg-indigo-200:focus{
  --bg-opacity:1;
  background-color:#cddbfe;
  background-color:rgba(205,219,254,var(--bg-opacity))
}

.focus\\:bg-indigo-300:focus{
  --bg-opacity:1;
  background-color:#b4c6fc;
  background-color:rgba(180,198,252,var(--bg-opacity))
}

.focus\\:bg-indigo-400:focus{
  --bg-opacity:1;
  background-color:#8da2fb;
  background-color:rgba(141,162,251,var(--bg-opacity))
}

.focus\\:bg-indigo-500:focus{
  --bg-opacity:1;
  background-color:#6875f5;
  background-color:rgba(104,117,245,var(--bg-opacity))
}

.focus\\:bg-indigo-600:focus{
  --bg-opacity:1;
  background-color:#5850ec;
  background-color:rgba(88,80,236,var(--bg-opacity))
}

.focus\\:bg-indigo-700:focus{
  --bg-opacity:1;
  background-color:#5145cd;
  background-color:rgba(81,69,205,var(--bg-opacity))
}

.focus\\:bg-indigo-800:focus{
  --bg-opacity:1;
  background-color:#42389d;
  background-color:rgba(66,56,157,var(--bg-opacity))
}

.focus\\:bg-indigo-900:focus{
  --bg-opacity:1;
  background-color:#362f78;
  background-color:rgba(54,47,120,var(--bg-opacity))
}

.focus\\:bg-indigo-50:focus{
  --bg-opacity:1;
  background-color:#f6f5ff;
  background-color:rgba(246,245,255,var(--bg-opacity))
}

.focus\\:bg-indigo-100:focus{
  --bg-opacity:1;
  background-color:#edebfe;
  background-color:rgba(237,235,254,var(--bg-opacity))
}

.focus\\:bg-indigo-200:focus{
  --bg-opacity:1;
  background-color:#dcd7fe;
  background-color:rgba(220,215,254,var(--bg-opacity))
}

.focus\\:bg-indigo-300:focus{
  --bg-opacity:1;
  background-color:#cabffd;
  background-color:rgba(202,191,253,var(--bg-opacity))
}

.focus\\:bg-indigo-400:focus{
  --bg-opacity:1;
  background-color:#ac94fa;
  background-color:rgba(172,148,250,var(--bg-opacity))
}

.focus\\:bg-indigo-500:focus{
  --bg-opacity:1;
  background-color:#9061f9;
  background-color:rgba(144,97,249,var(--bg-opacity))
}

.focus\\:bg-indigo-600:focus{
  --bg-opacity:1;
  background-color:#7e3af2;
  background-color:rgba(126,58,242,var(--bg-opacity))
}

.focus\\:bg-indigo-700:focus{
  --bg-opacity:1;
  background-color:#6c2bd9;
  background-color:rgba(108,43,217,var(--bg-opacity))
}

.focus\\:bg-indigo-800:focus{
  --bg-opacity:1;
  background-color:#5521b5;
  background-color:rgba(85,33,181,var(--bg-opacity))
}

.focus\\:bg-indigo-900:focus{
  --bg-opacity:1;
  background-color:#4a1d96;
  background-color:rgba(74,29,150,var(--bg-opacity))
}

.focus\\:bg-pink-50:focus{
  --bg-opacity:1;
  background-color:#fdf2f8;
  background-color:rgba(253,242,248,var(--bg-opacity))
}

.focus\\:bg-pink-100:focus{
  --bg-opacity:1;
  background-color:#fce8f3;
  background-color:rgba(252,232,243,var(--bg-opacity))
}

.focus\\:bg-pink-200:focus{
  --bg-opacity:1;
  background-color:#fad1e8;
  background-color:rgba(250,209,232,var(--bg-opacity))
}

.focus\\:bg-pink-300:focus{
  --bg-opacity:1;
  background-color:#f8b4d9;
  background-color:rgba(248,180,217,var(--bg-opacity))
}

.focus\\:bg-pink-400:focus{
  --bg-opacity:1;
  background-color:#f17eb8;
  background-color:rgba(241,126,184,var(--bg-opacity))
}

.focus\\:bg-pink-500:focus{
  --bg-opacity:1;
  background-color:#e74694;
  background-color:rgba(231,70,148,var(--bg-opacity))
}

.focus\\:bg-pink-600:focus{
  --bg-opacity:1;
  background-color:#d61f69;
  background-color:rgba(214,31,105,var(--bg-opacity))
}

.focus\\:bg-pink-700:focus{
  --bg-opacity:1;
  background-color:#bf125d;
  background-color:rgba(191,18,93,var(--bg-opacity))
}

.focus\\:bg-pink-800:focus{
  --bg-opacity:1;
  background-color:#99154b;
  background-color:rgba(153,21,75,var(--bg-opacity))
}

.focus\\:bg-pink-900:focus{
  --bg-opacity:1;
  background-color:#751a3d;
  background-color:rgba(117,26,61,var(--bg-opacity))
}

.active\\:bg-transparent:active{
  background-color:initial
}

.active\\:bg-white:active{
  --bg-opacity:1;
  background-color:#fff;
  background-color:rgba(255,255,255,var(--bg-opacity))
}

.active\\:bg-black:active{
  --bg-opacity:1;
  background-color:#000;
  background-color:rgba(0,0,0,var(--bg-opacity))
}

.active\\:bg-gray-50:active{
  --bg-opacity:1;
  background-color:#f9fafb;
  background-color:rgba(249,250,251,var(--bg-opacity))
}

.active\\:bg-gray-100:active{
  --bg-opacity:1;
  background-color:#f4f5f7;
  background-color:rgba(244,245,247,var(--bg-opacity))
}

.active\\:bg-gray-200:active{
  --bg-opacity:1;
  background-color:#e5e7eb;
  background-color:rgba(229,231,235,var(--bg-opacity))
}

.active\\:bg-gray-300:active{
  --bg-opacity:1;
  background-color:#d5d6d7;
  background-color:rgba(213,214,215,var(--bg-opacity))
}

.active\\:bg-gray-400:active{
  --bg-opacity:1;
  background-color:#9e9e9e;
  background-color:rgba(158,158,158,var(--bg-opacity))
}

.active\\:bg-gray-500:active{
  --bg-opacity:1;
  background-color:#707275;
  background-color:rgba(112,114,117,var(--bg-opacity))
}

.active\\:bg-gray-600:active{
  --bg-opacity:1;
  background-color:#4c4f52;
  background-color:rgba(76,79,82,var(--bg-opacity))
}

.active\\:bg-gray-700:active{
  --bg-opacity:1;
  background-color:#24262d;
  background-color:rgba(36,38,45,var(--bg-opacity))
}

.active\\:bg-gray-800:active{
  --bg-opacity:1;
  background-color:#1a1c23;
  background-color:rgba(26,28,35,var(--bg-opacity))
}

.active\\:bg-gray-900:active{
  --bg-opacity:1;
  background-color:#121317;
  background-color:rgba(18,19,23,var(--bg-opacity))
}

.active\\:bg-cool-gray-50:active{
  --bg-opacity:1;
  background-color:#fbfdfe;
  background-color:rgba(251,253,254,var(--bg-opacity))
}

.active\\:bg-cool-gray-100:active{
  --bg-opacity:1;
  background-color:#f1f5f9;
  background-color:rgba(241,245,249,var(--bg-opacity))
}

.active\\:bg-cool-gray-200:active{
  --bg-opacity:1;
  background-color:#e2e8f0;
  background-color:rgba(226,232,240,var(--bg-opacity))
}

.active\\:bg-cool-gray-300:active{
  --bg-opacity:1;
  background-color:#cfd8e3;
  background-color:rgba(207,216,227,var(--bg-opacity))
}

.active\\:bg-cool-gray-400:active{
  --bg-opacity:1;
  background-color:#97a6ba;
  background-color:rgba(151,166,186,var(--bg-opacity))
}

.active\\:bg-cool-gray-500:active{
  --bg-opacity:1;
  background-color:#64748b;
  background-color:rgba(100,116,139,var(--bg-opacity))
}

.active\\:bg-cool-gray-600:active{
  --bg-opacity:1;
  background-color:#475569;
  background-color:rgba(71,85,105,var(--bg-opacity))
}

.active\\:bg-cool-gray-700:active{
  --bg-opacity:1;
  background-color:#364152;
  background-color:rgba(54,65,82,var(--bg-opacity))
}

.active\\:bg-cool-gray-800:active{
  --bg-opacity:1;
  background-color:#27303f;
  background-color:rgba(39,48,63,var(--bg-opacity))
}

.active\\:bg-cool-gray-900:active{
  --bg-opacity:1;
  background-color:#1a202e;
  background-color:rgba(26,32,46,var(--bg-opacity))
}

.active\\:bg-red-50:active{
  --bg-opacity:1;
  background-color:#fdf2f2;
  background-color:rgba(253,242,242,var(--bg-opacity))
}

.active\\:bg-red-100:active{
  --bg-opacity:1;
  background-color:#fde8e8;
  background-color:rgba(253,232,232,var(--bg-opacity))
}

.active\\:bg-red-200:active{
  --bg-opacity:1;
  background-color:#fbd5d5;
  background-color:rgba(251,213,213,var(--bg-opacity))
}

.active\\:bg-red-300:active{
  --bg-opacity:1;
  background-color:#f8b4b4;
  background-color:rgba(248,180,180,var(--bg-opacity))
}

.active\\:bg-red-400:active{
  --bg-opacity:1;
  background-color:#f98080;
  background-color:rgba(249,128,128,var(--bg-opacity))
}

.active\\:bg-red-500:active{
  --bg-opacity:1;
  background-color:#f05252;
  background-color:rgba(240,82,82,var(--bg-opacity))
}

.active\\:bg-red-600:active{
  --bg-opacity:1;
  background-color:#e02424;
  background-color:rgba(224,36,36,var(--bg-opacity))
}

.active\\:bg-red-700:active{
  --bg-opacity:1;
  background-color:#c81e1e;
  background-color:rgba(200,30,30,var(--bg-opacity))
}

.active\\:bg-red-800:active{
  --bg-opacity:1;
  background-color:#9b1c1c;
  background-color:rgba(155,28,28,var(--bg-opacity))
}

.active\\:bg-red-900:active{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.active\\:bg-orange-50:active{
  --bg-opacity:1;
  background-color:#fff8f1;
  background-color:rgba(255,248,241,var(--bg-opacity))
}

.active\\:bg-orange-100:active{
  --bg-opacity:1;
  background-color:#feecdc;
  background-color:rgba(254,236,220,var(--bg-opacity))
}

.active\\:bg-orange-200:active{
  --bg-opacity:1;
  background-color:#fcd9bd;
  background-color:rgba(252,217,189,var(--bg-opacity))
}

.active\\:bg-orange-300:active{
  --bg-opacity:1;
  background-color:#fdba8c;
  background-color:rgba(253,186,140,var(--bg-opacity))
}

.active\\:bg-orange-400:active{
  --bg-opacity:1;
  background-color:#ff8a4c;
  background-color:rgba(255,138,76,var(--bg-opacity))
}

.active\\:bg-orange-500:active{
  --bg-opacity:1;
  background-color:#ff5a1f;
  background-color:rgba(255,90,31,var(--bg-opacity))
}

.active\\:bg-orange-600:active{
  --bg-opacity:1;
  background-color:#d03801;
  background-color:rgba(208,56,1,var(--bg-opacity))
}

.active\\:bg-orange-700:active{
  --bg-opacity:1;
  background-color:#b43403;
  background-color:rgba(180,52,3,var(--bg-opacity))
}

.active\\:bg-orange-800:active{
  --bg-opacity:1;
  background-color:#8a2c0d;
  background-color:rgba(138,44,13,var(--bg-opacity))
}

.active\\:bg-orange-900:active{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.active\\:bg-yellow-50:active{
  --bg-opacity:1;
  background-color:#fdfdea;
  background-color:rgba(253,253,234,var(--bg-opacity))
}

.active\\:bg-yellow-100:active{
  --bg-opacity:1;
  background-color:#fdf6b2;
  background-color:rgba(253,246,178,var(--bg-opacity))
}

.active\\:bg-yellow-200:active{
  --bg-opacity:1;
  background-color:#fce96a;
  background-color:rgba(252,233,106,var(--bg-opacity))
}

.active\\:bg-yellow-300:active{
  --bg-opacity:1;
  background-color:#faca15;
  background-color:rgba(250,202,21,var(--bg-opacity))
}

.active\\:bg-yellow-400:active{
  --bg-opacity:1;
  background-color:#e3a008;
  background-color:rgba(227,160,8,var(--bg-opacity))
}

.active\\:bg-yellow-500:active{
  --bg-opacity:1;
  background-color:#c27803;
  background-color:rgba(194,120,3,var(--bg-opacity))
}

.active\\:bg-yellow-600:active{
  --bg-opacity:1;
  background-color:#9f580a;
  background-color:rgba(159,88,10,var(--bg-opacity))
}

.active\\:bg-yellow-700:active{
  --bg-opacity:1;
  background-color:#8e4b10;
  background-color:rgba(142,75,16,var(--bg-opacity))
}

.active\\:bg-yellow-800:active{
  --bg-opacity:1;
  background-color:#723b13;
  background-color:rgba(114,59,19,var(--bg-opacity))
}

.active\\:bg-yellow-900:active{
  --bg-opacity:1;
  background-color:#633112;
  background-color:rgba(99,49,18,var(--bg-opacity))
}

.active\\:bg-green-50:active{
  --bg-opacity:1;
  background-color:#f3faf7;
  background-color:rgba(243,250,247,var(--bg-opacity))
}

.active\\:bg-green-100:active{
  --bg-opacity:1;
  background-color:#def7ec;
  background-color:rgba(222,247,236,var(--bg-opacity))
}

.active\\:bg-green-200:active{
  --bg-opacity:1;
  background-color:#bcf0da;
  background-color:rgba(188,240,218,var(--bg-opacity))
}

.active\\:bg-green-300:active{
  --bg-opacity:1;
  background-color:#84e1bc;
  background-color:rgba(132,225,188,var(--bg-opacity))
}

.active\\:bg-green-400:active{
  --bg-opacity:1;
  background-color:#31c48d;
  background-color:rgba(49,196,141,var(--bg-opacity))
}

.active\\:bg-green-500:active{
  --bg-opacity:1;
  background-color:#0e9f6e;
  background-color:rgba(14,159,110,var(--bg-opacity))
}

.active\\:bg-green-600:active{
  --bg-opacity:1;
  background-color:#057a55;
  background-color:rgba(5,122,85,var(--bg-opacity))
}

.active\\:bg-green-700:active{
  --bg-opacity:1;
  background-color:#046c4e;
  background-color:rgba(4,108,78,var(--bg-opacity))
}

.active\\:bg-green-800:active{
  --bg-opacity:1;
  background-color:#03543f;
  background-color:rgba(3,84,63,var(--bg-opacity))
}

.active\\:bg-green-900:active{
  --bg-opacity:1;
  background-color:#014737;
  background-color:rgba(1,71,55,var(--bg-opacity))
}

.active\\:bg-teal-50:active{
  --bg-opacity:1;
  background-color:#edfafa;
  background-color:rgba(237,250,250,var(--bg-opacity))
}

.active\\:bg-teal-100:active{
  --bg-opacity:1;
  background-color:#d5f5f6;
  background-color:rgba(213,245,246,var(--bg-opacity))
}

.active\\:bg-teal-200:active{
  --bg-opacity:1;
  background-color:#afecef;
  background-color:rgba(175,236,239,var(--bg-opacity))
}

.active\\:bg-teal-300:active{
  --bg-opacity:1;
  background-color:#7edce2;
  background-color:rgba(126,220,226,var(--bg-opacity))
}

.active\\:bg-teal-400:active{
  --bg-opacity:1;
  background-color:#16bdca;
  background-color:rgba(22,189,202,var(--bg-opacity))
}

.active\\:bg-teal-500:active{
  --bg-opacity:1;
  background-color:#0694a2;
  background-color:rgba(6,148,162,var(--bg-opacity))
}

.active\\:bg-teal-600:active{
  --bg-opacity:1;
  background-color:#047481;
  background-color:rgba(4,116,129,var(--bg-opacity))
}

.active\\:bg-teal-700:active{
  --bg-opacity:1;
  background-color:#036672;
  background-color:rgba(3,102,114,var(--bg-opacity))
}

.active\\:bg-teal-800:active{
  --bg-opacity:1;
  background-color:#05505c;
  background-color:rgba(5,80,92,var(--bg-opacity))
}

.active\\:bg-teal-900:active{
  --bg-opacity:1;
  background-color:#014451;
  background-color:rgba(1,68,81,var(--bg-opacity))
}

.active\\:bg-blue-50:active{
  --bg-opacity:1;
  background-color:#ebf5ff;
  background-color:rgba(235,245,255,var(--bg-opacity))
}

.active\\:bg-blue-100:active{
  --bg-opacity:1;
  background-color:#e1effe;
  background-color:rgba(225,239,254,var(--bg-opacity))
}

.active\\:bg-blue-200:active{
  --bg-opacity:1;
  background-color:#c3ddfd;
  background-color:rgba(195,221,253,var(--bg-opacity))
}

.active\\:bg-blue-300:active{
  --bg-opacity:1;
  background-color:#a4cafe;
  background-color:rgba(164,202,254,var(--bg-opacity))
}

.active\\:bg-blue-400:active{
  --bg-opacity:1;
  background-color:#76a9fa;
  background-color:rgba(118,169,250,var(--bg-opacity))
}

.active\\:bg-blue-500:active{
  --bg-opacity:1;
  background-color:#3f83f8;
  background-color:rgba(63,131,248,var(--bg-opacity))
}

.active\\:bg-blue-600:active{
  --bg-opacity:1;
  background-color:#1c64f2;
  background-color:rgba(28,100,242,var(--bg-opacity))
}

.active\\:bg-blue-700:active{
  --bg-opacity:1;
  background-color:#1a56db;
  background-color:rgba(26,86,219,var(--bg-opacity))
}

.active\\:bg-blue-800:active{
  --bg-opacity:1;
  background-color:#1e429f;
  background-color:rgba(30,66,159,var(--bg-opacity))
}

.active\\:bg-blue-900:active{
  --bg-opacity:1;
  background-color:#233876;
  background-color:rgba(35,56,118,var(--bg-opacity))
}

.active\\:bg-indigo-50:active{
  --bg-opacity:1;
  background-color:#f0f5ff;
  background-color:rgba(240,245,255,var(--bg-opacity))
}

.active\\:bg-indigo-100:active{
  --bg-opacity:1;
  background-color:#e5edff;
  background-color:rgba(229,237,255,var(--bg-opacity))
}

.active\\:bg-indigo-200:active{
  --bg-opacity:1;
  background-color:#cddbfe;
  background-color:rgba(205,219,254,var(--bg-opacity))
}

.active\\:bg-indigo-300:active{
  --bg-opacity:1;
  background-color:#b4c6fc;
  background-color:rgba(180,198,252,var(--bg-opacity))
}

.active\\:bg-indigo-400:active{
  --bg-opacity:1;
  background-color:#8da2fb;
  background-color:rgba(141,162,251,var(--bg-opacity))
}

.active\\:bg-indigo-500:active{
  --bg-opacity:1;
  background-color:#6875f5;
  background-color:rgba(104,117,245,var(--bg-opacity))
}

.active\\:bg-indigo-600:active{
  --bg-opacity:1;
  background-color:#5850ec;
  background-color:rgba(88,80,236,var(--bg-opacity))
}

.active\\:bg-indigo-700:active{
  --bg-opacity:1;
  background-color:#5145cd;
  background-color:rgba(81,69,205,var(--bg-opacity))
}

.active\\:bg-indigo-800:active{
  --bg-opacity:1;
  background-color:#42389d;
  background-color:rgba(66,56,157,var(--bg-opacity))
}

.active\\:bg-indigo-900:active{
  --bg-opacity:1;
  background-color:#362f78;
  background-color:rgba(54,47,120,var(--bg-opacity))
}

.active\\:bg-indigo-50:active{
  --bg-opacity:1;
  background-color:#f6f5ff;
  background-color:rgba(246,245,255,var(--bg-opacity))
}

.active\\:bg-indigo-100:active{
  --bg-opacity:1;
  background-color:#edebfe;
  background-color:rgba(237,235,254,var(--bg-opacity))
}

.active\\:bg-indigo-200:active{
  --bg-opacity:1;
  background-color:#dcd7fe;
  background-color:rgba(220,215,254,var(--bg-opacity))
}

.active\\:bg-indigo-300:active{
  --bg-opacity:1;
  background-color:#cabffd;
  background-color:rgba(202,191,253,var(--bg-opacity))
}

.active\\:bg-indigo-400:active{
  --bg-opacity:1;
  background-color:#ac94fa;
  background-color:rgba(172,148,250,var(--bg-opacity))
}

.active\\:bg-indigo-500:active{
  --bg-opacity:1;
  background-color:#9061f9;
  background-color:rgba(144,97,249,var(--bg-opacity))
}

.active\\:bg-indigo-600:active{
  --bg-opacity:1;
  background-color:#7e3af2;
  background-color:rgba(126,58,242,var(--bg-opacity))
}

.active\\:bg-indigo-700:active{
  --bg-opacity:1;
  background-color:#6c2bd9;
  background-color:rgba(108,43,217,var(--bg-opacity))
}

.active\\:bg-indigo-800:active{
  --bg-opacity:1;
  background-color:#5521b5;
  background-color:rgba(85,33,181,var(--bg-opacity))
}

.active\\:bg-indigo-900:active{
  --bg-opacity:1;
  background-color:#4a1d96;
  background-color:rgba(74,29,150,var(--bg-opacity))
}

.active\\:bg-pink-50:active{
  --bg-opacity:1;
  background-color:#fdf2f8;
  background-color:rgba(253,242,248,var(--bg-opacity))
}

.active\\:bg-pink-100:active{
  --bg-opacity:1;
  background-color:#fce8f3;
  background-color:rgba(252,232,243,var(--bg-opacity))
}

.active\\:bg-pink-200:active{
  --bg-opacity:1;
  background-color:#fad1e8;
  background-color:rgba(250,209,232,var(--bg-opacity))
}

.active\\:bg-pink-300:active{
  --bg-opacity:1;
  background-color:#f8b4d9;
  background-color:rgba(248,180,217,var(--bg-opacity))
}

.active\\:bg-pink-400:active{
  --bg-opacity:1;
  background-color:#f17eb8;
  background-color:rgba(241,126,184,var(--bg-opacity))
}

.active\\:bg-pink-500:active{
  --bg-opacity:1;
  background-color:#e74694;
  background-color:rgba(231,70,148,var(--bg-opacity))
}

.active\\:bg-pink-600:active{
  --bg-opacity:1;
  background-color:#d61f69;
  background-color:rgba(214,31,105,var(--bg-opacity))
}

.active\\:bg-pink-700:active{
  --bg-opacity:1;
  background-color:#bf125d;
  background-color:rgba(191,18,93,var(--bg-opacity))
}

.active\\:bg-pink-800:active{
  --bg-opacity:1;
  background-color:#99154b;
  background-color:rgba(153,21,75,var(--bg-opacity))
}

.active\\:bg-pink-900:active{
  --bg-opacity:1;
  background-color:#751a3d;
  background-color:rgba(117,26,61,var(--bg-opacity))
}

.odd\\:bg-transparent:nth-child(odd){
  background-color:initial
}

.odd\\:bg-white:nth-child(odd){
  --bg-opacity:1;
  background-color:#fff;
  background-color:rgba(255,255,255,var(--bg-opacity))
}

.odd\\:bg-black:nth-child(odd){
  --bg-opacity:1;
  background-color:#000;
  background-color:rgba(0,0,0,var(--bg-opacity))
}

.odd\\:bg-gray-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#f9fafb;
  background-color:rgba(249,250,251,var(--bg-opacity))
}

.odd\\:bg-gray-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#f4f5f7;
  background-color:rgba(244,245,247,var(--bg-opacity))
}

.odd\\:bg-gray-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#e5e7eb;
  background-color:rgba(229,231,235,var(--bg-opacity))
}

.odd\\:bg-gray-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#d5d6d7;
  background-color:rgba(213,214,215,var(--bg-opacity))
}

.odd\\:bg-gray-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#9e9e9e;
  background-color:rgba(158,158,158,var(--bg-opacity))
}

.odd\\:bg-gray-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#707275;
  background-color:rgba(112,114,117,var(--bg-opacity))
}

.odd\\:bg-gray-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#4c4f52;
  background-color:rgba(76,79,82,var(--bg-opacity))
}

.odd\\:bg-gray-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#24262d;
  background-color:rgba(36,38,45,var(--bg-opacity))
}

.odd\\:bg-gray-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#1a1c23;
  background-color:rgba(26,28,35,var(--bg-opacity))
}

.odd\\:bg-gray-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#121317;
  background-color:rgba(18,19,23,var(--bg-opacity))
}

.odd\\:bg-cool-gray-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#fbfdfe;
  background-color:rgba(251,253,254,var(--bg-opacity))
}

.odd\\:bg-cool-gray-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#f1f5f9;
  background-color:rgba(241,245,249,var(--bg-opacity))
}

.odd\\:bg-cool-gray-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#e2e8f0;
  background-color:rgba(226,232,240,var(--bg-opacity))
}

.odd\\:bg-cool-gray-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#cfd8e3;
  background-color:rgba(207,216,227,var(--bg-opacity))
}

.odd\\:bg-cool-gray-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#97a6ba;
  background-color:rgba(151,166,186,var(--bg-opacity))
}

.odd\\:bg-cool-gray-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#64748b;
  background-color:rgba(100,116,139,var(--bg-opacity))
}

.odd\\:bg-cool-gray-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#475569;
  background-color:rgba(71,85,105,var(--bg-opacity))
}

.odd\\:bg-cool-gray-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#364152;
  background-color:rgba(54,65,82,var(--bg-opacity))
}

.odd\\:bg-cool-gray-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#27303f;
  background-color:rgba(39,48,63,var(--bg-opacity))
}

.odd\\:bg-cool-gray-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#1a202e;
  background-color:rgba(26,32,46,var(--bg-opacity))
}

.odd\\:bg-red-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#fdf2f2;
  background-color:rgba(253,242,242,var(--bg-opacity))
}

.odd\\:bg-red-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#fde8e8;
  background-color:rgba(253,232,232,var(--bg-opacity))
}

.odd\\:bg-red-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#fbd5d5;
  background-color:rgba(251,213,213,var(--bg-opacity))
}

.odd\\:bg-red-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#f8b4b4;
  background-color:rgba(248,180,180,var(--bg-opacity))
}

.odd\\:bg-red-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#f98080;
  background-color:rgba(249,128,128,var(--bg-opacity))
}

.odd\\:bg-red-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#f05252;
  background-color:rgba(240,82,82,var(--bg-opacity))
}

.odd\\:bg-red-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#e02424;
  background-color:rgba(224,36,36,var(--bg-opacity))
}

.odd\\:bg-red-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#c81e1e;
  background-color:rgba(200,30,30,var(--bg-opacity))
}

.odd\\:bg-red-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#9b1c1c;
  background-color:rgba(155,28,28,var(--bg-opacity))
}

.odd\\:bg-red-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.odd\\:bg-orange-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#fff8f1;
  background-color:rgba(255,248,241,var(--bg-opacity))
}

.odd\\:bg-orange-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#feecdc;
  background-color:rgba(254,236,220,var(--bg-opacity))
}

.odd\\:bg-orange-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#fcd9bd;
  background-color:rgba(252,217,189,var(--bg-opacity))
}

.odd\\:bg-orange-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#fdba8c;
  background-color:rgba(253,186,140,var(--bg-opacity))
}

.odd\\:bg-orange-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#ff8a4c;
  background-color:rgba(255,138,76,var(--bg-opacity))
}

.odd\\:bg-orange-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#ff5a1f;
  background-color:rgba(255,90,31,var(--bg-opacity))
}

.odd\\:bg-orange-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#d03801;
  background-color:rgba(208,56,1,var(--bg-opacity))
}

.odd\\:bg-orange-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#b43403;
  background-color:rgba(180,52,3,var(--bg-opacity))
}

.odd\\:bg-orange-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#8a2c0d;
  background-color:rgba(138,44,13,var(--bg-opacity))
}

.odd\\:bg-orange-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.odd\\:bg-yellow-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#fdfdea;
  background-color:rgba(253,253,234,var(--bg-opacity))
}

.odd\\:bg-yellow-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#fdf6b2;
  background-color:rgba(253,246,178,var(--bg-opacity))
}

.odd\\:bg-yellow-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#fce96a;
  background-color:rgba(252,233,106,var(--bg-opacity))
}

.odd\\:bg-yellow-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#faca15;
  background-color:rgba(250,202,21,var(--bg-opacity))
}

.odd\\:bg-yellow-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#e3a008;
  background-color:rgba(227,160,8,var(--bg-opacity))
}

.odd\\:bg-yellow-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#c27803;
  background-color:rgba(194,120,3,var(--bg-opacity))
}

.odd\\:bg-yellow-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#9f580a;
  background-color:rgba(159,88,10,var(--bg-opacity))
}

.odd\\:bg-yellow-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#8e4b10;
  background-color:rgba(142,75,16,var(--bg-opacity))
}

.odd\\:bg-yellow-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#723b13;
  background-color:rgba(114,59,19,var(--bg-opacity))
}

.odd\\:bg-yellow-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#633112;
  background-color:rgba(99,49,18,var(--bg-opacity))
}

.odd\\:bg-green-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#f3faf7;
  background-color:rgba(243,250,247,var(--bg-opacity))
}

.odd\\:bg-green-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#def7ec;
  background-color:rgba(222,247,236,var(--bg-opacity))
}

.odd\\:bg-green-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#bcf0da;
  background-color:rgba(188,240,218,var(--bg-opacity))
}

.odd\\:bg-green-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#84e1bc;
  background-color:rgba(132,225,188,var(--bg-opacity))
}

.odd\\:bg-green-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#31c48d;
  background-color:rgba(49,196,141,var(--bg-opacity))
}

.odd\\:bg-green-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#0e9f6e;
  background-color:rgba(14,159,110,var(--bg-opacity))
}

.odd\\:bg-green-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#057a55;
  background-color:rgba(5,122,85,var(--bg-opacity))
}

.odd\\:bg-green-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#046c4e;
  background-color:rgba(4,108,78,var(--bg-opacity))
}

.odd\\:bg-green-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#03543f;
  background-color:rgba(3,84,63,var(--bg-opacity))
}

.odd\\:bg-green-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#014737;
  background-color:rgba(1,71,55,var(--bg-opacity))
}

.odd\\:bg-teal-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#edfafa;
  background-color:rgba(237,250,250,var(--bg-opacity))
}

.odd\\:bg-teal-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#d5f5f6;
  background-color:rgba(213,245,246,var(--bg-opacity))
}

.odd\\:bg-teal-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#afecef;
  background-color:rgba(175,236,239,var(--bg-opacity))
}

.odd\\:bg-teal-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#7edce2;
  background-color:rgba(126,220,226,var(--bg-opacity))
}

.odd\\:bg-teal-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#16bdca;
  background-color:rgba(22,189,202,var(--bg-opacity))
}

.odd\\:bg-teal-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#0694a2;
  background-color:rgba(6,148,162,var(--bg-opacity))
}

.odd\\:bg-teal-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#047481;
  background-color:rgba(4,116,129,var(--bg-opacity))
}

.odd\\:bg-teal-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#036672;
  background-color:rgba(3,102,114,var(--bg-opacity))
}

.odd\\:bg-teal-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#05505c;
  background-color:rgba(5,80,92,var(--bg-opacity))
}

.odd\\:bg-teal-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#014451;
  background-color:rgba(1,68,81,var(--bg-opacity))
}

.odd\\:bg-blue-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#ebf5ff;
  background-color:rgba(235,245,255,var(--bg-opacity))
}

.odd\\:bg-blue-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#e1effe;
  background-color:rgba(225,239,254,var(--bg-opacity))
}

.odd\\:bg-blue-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#c3ddfd;
  background-color:rgba(195,221,253,var(--bg-opacity))
}

.odd\\:bg-blue-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#a4cafe;
  background-color:rgba(164,202,254,var(--bg-opacity))
}

.odd\\:bg-blue-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#76a9fa;
  background-color:rgba(118,169,250,var(--bg-opacity))
}

.odd\\:bg-blue-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#3f83f8;
  background-color:rgba(63,131,248,var(--bg-opacity))
}

.odd\\:bg-blue-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#1c64f2;
  background-color:rgba(28,100,242,var(--bg-opacity))
}

.odd\\:bg-blue-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#1a56db;
  background-color:rgba(26,86,219,var(--bg-opacity))
}

.odd\\:bg-blue-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#1e429f;
  background-color:rgba(30,66,159,var(--bg-opacity))
}

.odd\\:bg-blue-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#233876;
  background-color:rgba(35,56,118,var(--bg-opacity))
}

.odd\\:bg-indigo-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#f0f5ff;
  background-color:rgba(240,245,255,var(--bg-opacity))
}

.odd\\:bg-indigo-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#e5edff;
  background-color:rgba(229,237,255,var(--bg-opacity))
}

.odd\\:bg-indigo-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#cddbfe;
  background-color:rgba(205,219,254,var(--bg-opacity))
}

.odd\\:bg-indigo-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#b4c6fc;
  background-color:rgba(180,198,252,var(--bg-opacity))
}

.odd\\:bg-indigo-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#8da2fb;
  background-color:rgba(141,162,251,var(--bg-opacity))
}

.odd\\:bg-indigo-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#6875f5;
  background-color:rgba(104,117,245,var(--bg-opacity))
}

.odd\\:bg-indigo-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#5850ec;
  background-color:rgba(88,80,236,var(--bg-opacity))
}

.odd\\:bg-indigo-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#5145cd;
  background-color:rgba(81,69,205,var(--bg-opacity))
}

.odd\\:bg-indigo-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#42389d;
  background-color:rgba(66,56,157,var(--bg-opacity))
}

.odd\\:bg-indigo-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#362f78;
  background-color:rgba(54,47,120,var(--bg-opacity))
}

.odd\\:bg-indigo-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#f6f5ff;
  background-color:rgba(246,245,255,var(--bg-opacity))
}

.odd\\:bg-indigo-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#edebfe;
  background-color:rgba(237,235,254,var(--bg-opacity))
}

.odd\\:bg-indigo-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#dcd7fe;
  background-color:rgba(220,215,254,var(--bg-opacity))
}

.odd\\:bg-indigo-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#cabffd;
  background-color:rgba(202,191,253,var(--bg-opacity))
}

.odd\\:bg-indigo-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#ac94fa;
  background-color:rgba(172,148,250,var(--bg-opacity))
}

.odd\\:bg-indigo-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#9061f9;
  background-color:rgba(144,97,249,var(--bg-opacity))
}

.odd\\:bg-indigo-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#7e3af2;
  background-color:rgba(126,58,242,var(--bg-opacity))
}

.odd\\:bg-indigo-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#6c2bd9;
  background-color:rgba(108,43,217,var(--bg-opacity))
}

.odd\\:bg-indigo-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#5521b5;
  background-color:rgba(85,33,181,var(--bg-opacity))
}

.odd\\:bg-indigo-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#4a1d96;
  background-color:rgba(74,29,150,var(--bg-opacity))
}

.odd\\:bg-pink-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#fdf2f8;
  background-color:rgba(253,242,248,var(--bg-opacity))
}

.odd\\:bg-pink-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#fce8f3;
  background-color:rgba(252,232,243,var(--bg-opacity))
}

.odd\\:bg-pink-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#fad1e8;
  background-color:rgba(250,209,232,var(--bg-opacity))
}

.odd\\:bg-pink-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#f8b4d9;
  background-color:rgba(248,180,217,var(--bg-opacity))
}

.odd\\:bg-pink-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#f17eb8;
  background-color:rgba(241,126,184,var(--bg-opacity))
}

.odd\\:bg-pink-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#e74694;
  background-color:rgba(231,70,148,var(--bg-opacity))
}

.odd\\:bg-pink-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#d61f69;
  background-color:rgba(214,31,105,var(--bg-opacity))
}

.odd\\:bg-pink-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#bf125d;
  background-color:rgba(191,18,93,var(--bg-opacity))
}

.odd\\:bg-pink-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#99154b;
  background-color:rgba(153,21,75,var(--bg-opacity))
}

.odd\\:bg-pink-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#751a3d;
  background-color:rgba(117,26,61,var(--bg-opacity))
}

.theme-dark .dark\\:bg-transparent{
  background-color:initial
}

.theme-dark .dark\\:bg-white{
  --bg-opacity:1;
  background-color:#fff;
  background-color:rgba(255,255,255,var(--bg-opacity))
}

.theme-dark .dark\\:bg-black{
  --bg-opacity:1;
  background-color:#000;
  background-color:rgba(0,0,0,var(--bg-opacity))
}

.theme-dark .dark\\:bg-gray-50{
  --bg-opacity:1;
  background-color:#f9fafb;
  background-color:rgba(249,250,251,var(--bg-opacity))
}

.theme-dark .dark\\:bg-gray-100{
  --bg-opacity:1;
  background-color:#f4f5f7;
  background-color:rgba(244,245,247,var(--bg-opacity))
}

.theme-dark .dark\\:bg-gray-200{
  --bg-opacity:1;
  background-color:#e5e7eb;
  background-color:rgba(229,231,235,var(--bg-opacity))
}

.theme-dark .dark\\:bg-gray-300{
  --bg-opacity:1;
  background-color:#d5d6d7;
  background-color:rgba(213,214,215,var(--bg-opacity))
}

.theme-dark .dark\\:bg-gray-400{
  --bg-opacity:1;
  background-color:#9e9e9e;
  background-color:rgba(158,158,158,var(--bg-opacity))
}

.theme-dark .dark\\:bg-gray-500{
  --bg-opacity:1;
  background-color:#707275;
  background-color:rgba(112,114,117,var(--bg-opacity))
}

.theme-dark .dark\\:bg-gray-600{
  --bg-opacity:1;
  background-color:#4c4f52;
  background-color:rgba(76,79,82,var(--bg-opacity))
}

.theme-dark .dark\\:bg-gray-700{
  --bg-opacity:1;
  background-color:#24262d;
  background-color:rgba(36,38,45,var(--bg-opacity))
}

.theme-dark .dark\\:bg-gray-800{
  --bg-opacity:1;
  background-color:#1a1c23;
  background-color:rgba(26,28,35,var(--bg-opacity))
}

.theme-dark .dark\\:bg-gray-900{
  --bg-opacity:1;
  background-color:#121317;
  background-color:rgba(18,19,23,var(--bg-opacity))
}

.theme-dark .dark\\:bg-cool-gray-50{
  --bg-opacity:1;
  background-color:#fbfdfe;
  background-color:rgba(251,253,254,var(--bg-opacity))
}

.theme-dark .dark\\:bg-cool-gray-100{
  --bg-opacity:1;
  background-color:#f1f5f9;
  background-color:rgba(241,245,249,var(--bg-opacity))
}

.theme-dark .dark\\:bg-cool-gray-200{
  --bg-opacity:1;
  background-color:#e2e8f0;
  background-color:rgba(226,232,240,var(--bg-opacity))
}

.theme-dark .dark\\:bg-cool-gray-300{
  --bg-opacity:1;
  background-color:#cfd8e3;
  background-color:rgba(207,216,227,var(--bg-opacity))
}

.theme-dark .dark\\:bg-cool-gray-400{
  --bg-opacity:1;
  background-color:#97a6ba;
  background-color:rgba(151,166,186,var(--bg-opacity))
}

.theme-dark .dark\\:bg-cool-gray-500{
  --bg-opacity:1;
  background-color:#64748b;
  background-color:rgba(100,116,139,var(--bg-opacity))
}

.theme-dark .dark\\:bg-cool-gray-600{
  --bg-opacity:1;
  background-color:#475569;
  background-color:rgba(71,85,105,var(--bg-opacity))
}

.theme-dark .dark\\:bg-cool-gray-700{
  --bg-opacity:1;
  background-color:#364152;
  background-color:rgba(54,65,82,var(--bg-opacity))
}

.theme-dark .dark\\:bg-cool-gray-800{
  --bg-opacity:1;
  background-color:#27303f;
  background-color:rgba(39,48,63,var(--bg-opacity))
}

.theme-dark .dark\\:bg-cool-gray-900{
  --bg-opacity:1;
  background-color:#1a202e;
  background-color:rgba(26,32,46,var(--bg-opacity))
}

.theme-dark .dark\\:bg-red-50{
  --bg-opacity:1;
  background-color:#fdf2f2;
  background-color:rgba(253,242,242,var(--bg-opacity))
}

.theme-dark .dark\\:bg-red-100{
  --bg-opacity:1;
  background-color:#fde8e8;
  background-color:rgba(253,232,232,var(--bg-opacity))
}

.theme-dark .dark\\:bg-red-200{
  --bg-opacity:1;
  background-color:#fbd5d5;
  background-color:rgba(251,213,213,var(--bg-opacity))
}

.theme-dark .dark\\:bg-red-300{
  --bg-opacity:1;
  background-color:#f8b4b4;
  background-color:rgba(248,180,180,var(--bg-opacity))
}

.theme-dark .dark\\:bg-red-400{
  --bg-opacity:1;
  background-color:#f98080;
  background-color:rgba(249,128,128,var(--bg-opacity))
}

.theme-dark .dark\\:bg-red-500{
  --bg-opacity:1;
  background-color:#f05252;
  background-color:rgba(240,82,82,var(--bg-opacity))
}

.theme-dark .dark\\:bg-red-600{
  --bg-opacity:1;
  background-color:#e02424;
  background-color:rgba(224,36,36,var(--bg-opacity))
}

.theme-dark .dark\\:bg-red-700{
  --bg-opacity:1;
  background-color:#c81e1e;
  background-color:rgba(200,30,30,var(--bg-opacity))
}

.theme-dark .dark\\:bg-red-800{
  --bg-opacity:1;
  background-color:#9b1c1c;
  background-color:rgba(155,28,28,var(--bg-opacity))
}

.theme-dark .dark\\:bg-red-900{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.theme-dark .dark\\:bg-orange-50{
  --bg-opacity:1;
  background-color:#fff8f1;
  background-color:rgba(255,248,241,var(--bg-opacity))
}

.theme-dark .dark\\:bg-orange-100{
  --bg-opacity:1;
  background-color:#feecdc;
  background-color:rgba(254,236,220,var(--bg-opacity))
}

.theme-dark .dark\\:bg-orange-200{
  --bg-opacity:1;
  background-color:#fcd9bd;
  background-color:rgba(252,217,189,var(--bg-opacity))
}

.theme-dark .dark\\:bg-orange-300{
  --bg-opacity:1;
  background-color:#fdba8c;
  background-color:rgba(253,186,140,var(--bg-opacity))
}

.theme-dark .dark\\:bg-orange-400{
  --bg-opacity:1;
  background-color:#ff8a4c;
  background-color:rgba(255,138,76,var(--bg-opacity))
}

.theme-dark .dark\\:bg-orange-500{
  --bg-opacity:1;
  background-color:#ff5a1f;
  background-color:rgba(255,90,31,var(--bg-opacity))
}

.theme-dark .dark\\:bg-orange-600{
  --bg-opacity:1;
  background-color:#d03801;
  background-color:rgba(208,56,1,var(--bg-opacity))
}

.theme-dark .dark\\:bg-orange-700{
  --bg-opacity:1;
  background-color:#b43403;
  background-color:rgba(180,52,3,var(--bg-opacity))
}

.theme-dark .dark\\:bg-orange-800{
  --bg-opacity:1;
  background-color:#8a2c0d;
  background-color:rgba(138,44,13,var(--bg-opacity))
}

.theme-dark .dark\\:bg-orange-900{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.theme-dark .dark\\:bg-yellow-50{
  --bg-opacity:1;
  background-color:#fdfdea;
  background-color:rgba(253,253,234,var(--bg-opacity))
}

.theme-dark .dark\\:bg-yellow-100{
  --bg-opacity:1;
  background-color:#fdf6b2;
  background-color:rgba(253,246,178,var(--bg-opacity))
}

.theme-dark .dark\\:bg-yellow-200{
  --bg-opacity:1;
  background-color:#fce96a;
  background-color:rgba(252,233,106,var(--bg-opacity))
}

.theme-dark .dark\\:bg-yellow-300{
  --bg-opacity:1;
  background-color:#faca15;
  background-color:rgba(250,202,21,var(--bg-opacity))
}

.theme-dark .dark\\:bg-yellow-400{
  --bg-opacity:1;
  background-color:#e3a008;
  background-color:rgba(227,160,8,var(--bg-opacity))
}

.theme-dark .dark\\:bg-yellow-500{
  --bg-opacity:1;
  background-color:#c27803;
  background-color:rgba(194,120,3,var(--bg-opacity))
}

.theme-dark .dark\\:bg-yellow-600{
  --bg-opacity:1;
  background-color:#9f580a;
  background-color:rgba(159,88,10,var(--bg-opacity))
}

.theme-dark .dark\\:bg-yellow-700{
  --bg-opacity:1;
  background-color:#8e4b10;
  background-color:rgba(142,75,16,var(--bg-opacity))
}

.theme-dark .dark\\:bg-yellow-800{
  --bg-opacity:1;
  background-color:#723b13;
  background-color:rgba(114,59,19,var(--bg-opacity))
}

.theme-dark .dark\\:bg-yellow-900{
  --bg-opacity:1;
  background-color:#633112;
  background-color:rgba(99,49,18,var(--bg-opacity))
}

.theme-dark .dark\\:bg-green-50{
  --bg-opacity:1;
  background-color:#f3faf7;
  background-color:rgba(243,250,247,var(--bg-opacity))
}

.theme-dark .dark\\:bg-green-100{
  --bg-opacity:1;
  background-color:#def7ec;
  background-color:rgba(222,247,236,var(--bg-opacity))
}

.theme-dark .dark\\:bg-green-200{
  --bg-opacity:1;
  background-color:#bcf0da;
  background-color:rgba(188,240,218,var(--bg-opacity))
}

.theme-dark .dark\\:bg-green-300{
  --bg-opacity:1;
  background-color:#84e1bc;
  background-color:rgba(132,225,188,var(--bg-opacity))
}

.theme-dark .dark\\:bg-green-400{
  --bg-opacity:1;
  background-color:#31c48d;
  background-color:rgba(49,196,141,var(--bg-opacity))
}

.theme-dark .dark\\:bg-green-500{
  --bg-opacity:1;
  background-color:#0e9f6e;
  background-color:rgba(14,159,110,var(--bg-opacity))
}

.theme-dark .dark\\:bg-green-600{
  --bg-opacity:1;
  background-color:#057a55;
  background-color:rgba(5,122,85,var(--bg-opacity))
}

.theme-dark .dark\\:bg-green-700{
  --bg-opacity:1;
  background-color:#046c4e;
  background-color:rgba(4,108,78,var(--bg-opacity))
}

.theme-dark .dark\\:bg-green-800{
  --bg-opacity:1;
  background-color:#03543f;
  background-color:rgba(3,84,63,var(--bg-opacity))
}

.theme-dark .dark\\:bg-green-900{
  --bg-opacity:1;
  background-color:#014737;
  background-color:rgba(1,71,55,var(--bg-opacity))
}

.theme-dark .dark\\:bg-teal-50{
  --bg-opacity:1;
  background-color:#edfafa;
  background-color:rgba(237,250,250,var(--bg-opacity))
}

.theme-dark .dark\\:bg-teal-100{
  --bg-opacity:1;
  background-color:#d5f5f6;
  background-color:rgba(213,245,246,var(--bg-opacity))
}

.theme-dark .dark\\:bg-teal-200{
  --bg-opacity:1;
  background-color:#afecef;
  background-color:rgba(175,236,239,var(--bg-opacity))
}

.theme-dark .dark\\:bg-teal-300{
  --bg-opacity:1;
  background-color:#7edce2;
  background-color:rgba(126,220,226,var(--bg-opacity))
}

.theme-dark .dark\\:bg-teal-400{
  --bg-opacity:1;
  background-color:#16bdca;
  background-color:rgba(22,189,202,var(--bg-opacity))
}

.theme-dark .dark\\:bg-teal-500{
  --bg-opacity:1;
  background-color:#0694a2;
  background-color:rgba(6,148,162,var(--bg-opacity))
}

.theme-dark .dark\\:bg-teal-600{
  --bg-opacity:1;
  background-color:#047481;
  background-color:rgba(4,116,129,var(--bg-opacity))
}

.theme-dark .dark\\:bg-teal-700{
  --bg-opacity:1;
  background-color:#036672;
  background-color:rgba(3,102,114,var(--bg-opacity))
}

.theme-dark .dark\\:bg-teal-800{
  --bg-opacity:1;
  background-color:#05505c;
  background-color:rgba(5,80,92,var(--bg-opacity))
}

.theme-dark .dark\\:bg-teal-900{
  --bg-opacity:1;
  background-color:#014451;
  background-color:rgba(1,68,81,var(--bg-opacity))
}

.theme-dark .dark\\:bg-blue-50{
  --bg-opacity:1;
  background-color:#ebf5ff;
  background-color:rgba(235,245,255,var(--bg-opacity))
}

.theme-dark .dark\\:bg-blue-100{
  --bg-opacity:1;
  background-color:#e1effe;
  background-color:rgba(225,239,254,var(--bg-opacity))
}

.theme-dark .dark\\:bg-blue-200{
  --bg-opacity:1;
  background-color:#c3ddfd;
  background-color:rgba(195,221,253,var(--bg-opacity))
}

.theme-dark .dark\\:bg-blue-300{
  --bg-opacity:1;
  background-color:#a4cafe;
  background-color:rgba(164,202,254,var(--bg-opacity))
}

.theme-dark .dark\\:bg-blue-400{
  --bg-opacity:1;
  background-color:#76a9fa;
  background-color:rgba(118,169,250,var(--bg-opacity))
}

.theme-dark .dark\\:bg-blue-500{
  --bg-opacity:1;
  background-color:#3f83f8;
  background-color:rgba(63,131,248,var(--bg-opacity))
}

.theme-dark .dark\\:bg-blue-600{
  --bg-opacity:1;
  background-color:#1c64f2;
  background-color:rgba(28,100,242,var(--bg-opacity))
}

.theme-dark .dark\\:bg-blue-700{
  --bg-opacity:1;
  background-color:#1a56db;
  background-color:rgba(26,86,219,var(--bg-opacity))
}

.theme-dark .dark\\:bg-blue-800{
  --bg-opacity:1;
  background-color:#1e429f;
  background-color:rgba(30,66,159,var(--bg-opacity))
}

.theme-dark .dark\\:bg-blue-900{
  --bg-opacity:1;
  background-color:#233876;
  background-color:rgba(35,56,118,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-50{
  --bg-opacity:1;
  background-color:#f0f5ff;
  background-color:rgba(240,245,255,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-100{
  --bg-opacity:1;
  background-color:#e5edff;
  background-color:rgba(229,237,255,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-200{
  --bg-opacity:1;
  background-color:#cddbfe;
  background-color:rgba(205,219,254,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-300{
  --bg-opacity:1;
  background-color:#b4c6fc;
  background-color:rgba(180,198,252,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-400{
  --bg-opacity:1;
  background-color:#8da2fb;
  background-color:rgba(141,162,251,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-500{
  --bg-opacity:1;
  background-color:#6875f5;
  background-color:rgba(104,117,245,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-600{
  --bg-opacity:1;
  background-color:#5850ec;
  background-color:rgba(88,80,236,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-700{
  --bg-opacity:1;
  background-color:#5145cd;
  background-color:rgba(81,69,205,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-800{
  --bg-opacity:1;
  background-color:#42389d;
  background-color:rgba(66,56,157,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-900{
  --bg-opacity:1;
  background-color:#362f78;
  background-color:rgba(54,47,120,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-50{
  --bg-opacity:1;
  background-color:#f6f5ff;
  background-color:rgba(246,245,255,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-100{
  --bg-opacity:1;
  background-color:#edebfe;
  background-color:rgba(237,235,254,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-200{
  --bg-opacity:1;
  background-color:#dcd7fe;
  background-color:rgba(220,215,254,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-300{
  --bg-opacity:1;
  background-color:#cabffd;
  background-color:rgba(202,191,253,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-400{
  --bg-opacity:1;
  background-color:#ac94fa;
  background-color:rgba(172,148,250,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-500{
  --bg-opacity:1;
  background-color:#9061f9;
  background-color:rgba(144,97,249,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-600{
  --bg-opacity:1;
  background-color:#7e3af2;
  background-color:rgba(126,58,242,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-700{
  --bg-opacity:1;
  background-color:#6c2bd9;
  background-color:rgba(108,43,217,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-800{
  --bg-opacity:1;
  background-color:#5521b5;
  background-color:rgba(85,33,181,var(--bg-opacity))
}

.theme-dark .dark\\:bg-indigo-900{
  --bg-opacity:1;
  background-color:#4a1d96;
  background-color:rgba(74,29,150,var(--bg-opacity))
}

.theme-dark .dark\\:bg-pink-50{
  --bg-opacity:1;
  background-color:#fdf2f8;
  background-color:rgba(253,242,248,var(--bg-opacity))
}

.theme-dark .dark\\:bg-pink-100{
  --bg-opacity:1;
  background-color:#fce8f3;
  background-color:rgba(252,232,243,var(--bg-opacity))
}

.theme-dark .dark\\:bg-pink-200{
  --bg-opacity:1;
  background-color:#fad1e8;
  background-color:rgba(250,209,232,var(--bg-opacity))
}

.theme-dark .dark\\:bg-pink-300{
  --bg-opacity:1;
  background-color:#f8b4d9;
  background-color:rgba(248,180,217,var(--bg-opacity))
}

.theme-dark .dark\\:bg-pink-400{
  --bg-opacity:1;
  background-color:#f17eb8;
  background-color:rgba(241,126,184,var(--bg-opacity))
}

.theme-dark .dark\\:bg-pink-500{
  --bg-opacity:1;
  background-color:#e74694;
  background-color:rgba(231,70,148,var(--bg-opacity))
}

.theme-dark .dark\\:bg-pink-600{
  --bg-opacity:1;
  background-color:#d61f69;
  background-color:rgba(214,31,105,var(--bg-opacity))
}

.theme-dark .dark\\:bg-pink-700{
  --bg-opacity:1;
  background-color:#bf125d;
  background-color:rgba(191,18,93,var(--bg-opacity))
}

.theme-dark .dark\\:bg-pink-800{
  --bg-opacity:1;
  background-color:#99154b;
  background-color:rgba(153,21,75,var(--bg-opacity))
}

.theme-dark .dark\\:bg-pink-900{
  --bg-opacity:1;
  background-color:#751a3d;
  background-color:rgba(117,26,61,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-transparent:hover{
  background-color:initial
}

.theme-dark .dark\\:hover\\:bg-white:hover{
  --bg-opacity:1;
  background-color:#fff;
  background-color:rgba(255,255,255,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-black:hover{
  --bg-opacity:1;
  background-color:#000;
  background-color:rgba(0,0,0,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-gray-50:hover{
  --bg-opacity:1;
  background-color:#f9fafb;
  background-color:rgba(249,250,251,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-gray-100:hover{
  --bg-opacity:1;
  background-color:#f4f5f7;
  background-color:rgba(244,245,247,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-gray-200:hover{
  --bg-opacity:1;
  background-color:#e5e7eb;
  background-color:rgba(229,231,235,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-gray-300:hover{
  --bg-opacity:1;
  background-color:#d5d6d7;
  background-color:rgba(213,214,215,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-gray-400:hover{
  --bg-opacity:1;
  background-color:#9e9e9e;
  background-color:rgba(158,158,158,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-gray-500:hover{
  --bg-opacity:1;
  background-color:#707275;
  background-color:rgba(112,114,117,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-gray-600:hover{
  --bg-opacity:1;
  background-color:#4c4f52;
  background-color:rgba(76,79,82,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-gray-700:hover{
  --bg-opacity:1;
  background-color:#24262d;
  background-color:rgba(36,38,45,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-gray-800:hover{
  --bg-opacity:1;
  background-color:#1a1c23;
  background-color:rgba(26,28,35,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-gray-900:hover{
  --bg-opacity:1;
  background-color:#121317;
  background-color:rgba(18,19,23,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-cool-gray-50:hover{
  --bg-opacity:1;
  background-color:#fbfdfe;
  background-color:rgba(251,253,254,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-cool-gray-100:hover{
  --bg-opacity:1;
  background-color:#f1f5f9;
  background-color:rgba(241,245,249,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-cool-gray-200:hover{
  --bg-opacity:1;
  background-color:#e2e8f0;
  background-color:rgba(226,232,240,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-cool-gray-300:hover{
  --bg-opacity:1;
  background-color:#cfd8e3;
  background-color:rgba(207,216,227,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-cool-gray-400:hover{
  --bg-opacity:1;
  background-color:#97a6ba;
  background-color:rgba(151,166,186,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-cool-gray-500:hover{
  --bg-opacity:1;
  background-color:#64748b;
  background-color:rgba(100,116,139,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-cool-gray-600:hover{
  --bg-opacity:1;
  background-color:#475569;
  background-color:rgba(71,85,105,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-cool-gray-700:hover{
  --bg-opacity:1;
  background-color:#364152;
  background-color:rgba(54,65,82,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-cool-gray-800:hover{
  --bg-opacity:1;
  background-color:#27303f;
  background-color:rgba(39,48,63,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-cool-gray-900:hover{
  --bg-opacity:1;
  background-color:#1a202e;
  background-color:rgba(26,32,46,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-red-50:hover{
  --bg-opacity:1;
  background-color:#fdf2f2;
  background-color:rgba(253,242,242,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-red-100:hover{
  --bg-opacity:1;
  background-color:#fde8e8;
  background-color:rgba(253,232,232,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-red-200:hover{
  --bg-opacity:1;
  background-color:#fbd5d5;
  background-color:rgba(251,213,213,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-red-300:hover{
  --bg-opacity:1;
  background-color:#f8b4b4;
  background-color:rgba(248,180,180,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-red-400:hover{
  --bg-opacity:1;
  background-color:#f98080;
  background-color:rgba(249,128,128,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-red-500:hover{
  --bg-opacity:1;
  background-color:#f05252;
  background-color:rgba(240,82,82,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-red-600:hover{
  --bg-opacity:1;
  background-color:#e02424;
  background-color:rgba(224,36,36,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-red-700:hover{
  --bg-opacity:1;
  background-color:#c81e1e;
  background-color:rgba(200,30,30,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-red-800:hover{
  --bg-opacity:1;
  background-color:#9b1c1c;
  background-color:rgba(155,28,28,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-red-900:hover{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-orange-50:hover{
  --bg-opacity:1;
  background-color:#fff8f1;
  background-color:rgba(255,248,241,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-orange-100:hover{
  --bg-opacity:1;
  background-color:#feecdc;
  background-color:rgba(254,236,220,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-orange-200:hover{
  --bg-opacity:1;
  background-color:#fcd9bd;
  background-color:rgba(252,217,189,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-orange-300:hover{
  --bg-opacity:1;
  background-color:#fdba8c;
  background-color:rgba(253,186,140,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-orange-400:hover{
  --bg-opacity:1;
  background-color:#ff8a4c;
  background-color:rgba(255,138,76,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-orange-500:hover{
  --bg-opacity:1;
  background-color:#ff5a1f;
  background-color:rgba(255,90,31,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-orange-600:hover{
  --bg-opacity:1;
  background-color:#d03801;
  background-color:rgba(208,56,1,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-orange-700:hover{
  --bg-opacity:1;
  background-color:#b43403;
  background-color:rgba(180,52,3,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-orange-800:hover{
  --bg-opacity:1;
  background-color:#8a2c0d;
  background-color:rgba(138,44,13,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-orange-900:hover{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-yellow-50:hover{
  --bg-opacity:1;
  background-color:#fdfdea;
  background-color:rgba(253,253,234,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-yellow-100:hover{
  --bg-opacity:1;
  background-color:#fdf6b2;
  background-color:rgba(253,246,178,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-yellow-200:hover{
  --bg-opacity:1;
  background-color:#fce96a;
  background-color:rgba(252,233,106,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-yellow-300:hover{
  --bg-opacity:1;
  background-color:#faca15;
  background-color:rgba(250,202,21,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-yellow-400:hover{
  --bg-opacity:1;
  background-color:#e3a008;
  background-color:rgba(227,160,8,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-yellow-500:hover{
  --bg-opacity:1;
  background-color:#c27803;
  background-color:rgba(194,120,3,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-yellow-600:hover{
  --bg-opacity:1;
  background-color:#9f580a;
  background-color:rgba(159,88,10,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-yellow-700:hover{
  --bg-opacity:1;
  background-color:#8e4b10;
  background-color:rgba(142,75,16,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-yellow-800:hover{
  --bg-opacity:1;
  background-color:#723b13;
  background-color:rgba(114,59,19,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-yellow-900:hover{
  --bg-opacity:1;
  background-color:#633112;
  background-color:rgba(99,49,18,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-green-50:hover{
  --bg-opacity:1;
  background-color:#f3faf7;
  background-color:rgba(243,250,247,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-green-100:hover{
  --bg-opacity:1;
  background-color:#def7ec;
  background-color:rgba(222,247,236,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-green-200:hover{
  --bg-opacity:1;
  background-color:#bcf0da;
  background-color:rgba(188,240,218,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-green-300:hover{
  --bg-opacity:1;
  background-color:#84e1bc;
  background-color:rgba(132,225,188,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-green-400:hover{
  --bg-opacity:1;
  background-color:#31c48d;
  background-color:rgba(49,196,141,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-green-500:hover{
  --bg-opacity:1;
  background-color:#0e9f6e;
  background-color:rgba(14,159,110,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-green-600:hover{
  --bg-opacity:1;
  background-color:#057a55;
  background-color:rgba(5,122,85,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-green-700:hover{
  --bg-opacity:1;
  background-color:#046c4e;
  background-color:rgba(4,108,78,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-green-800:hover{
  --bg-opacity:1;
  background-color:#03543f;
  background-color:rgba(3,84,63,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-green-900:hover{
  --bg-opacity:1;
  background-color:#014737;
  background-color:rgba(1,71,55,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-teal-50:hover{
  --bg-opacity:1;
  background-color:#edfafa;
  background-color:rgba(237,250,250,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-teal-100:hover{
  --bg-opacity:1;
  background-color:#d5f5f6;
  background-color:rgba(213,245,246,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-teal-200:hover{
  --bg-opacity:1;
  background-color:#afecef;
  background-color:rgba(175,236,239,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-teal-300:hover{
  --bg-opacity:1;
  background-color:#7edce2;
  background-color:rgba(126,220,226,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-teal-400:hover{
  --bg-opacity:1;
  background-color:#16bdca;
  background-color:rgba(22,189,202,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-teal-500:hover{
  --bg-opacity:1;
  background-color:#0694a2;
  background-color:rgba(6,148,162,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-teal-600:hover{
  --bg-opacity:1;
  background-color:#047481;
  background-color:rgba(4,116,129,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-teal-700:hover{
  --bg-opacity:1;
  background-color:#036672;
  background-color:rgba(3,102,114,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-teal-800:hover{
  --bg-opacity:1;
  background-color:#05505c;
  background-color:rgba(5,80,92,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-teal-900:hover{
  --bg-opacity:1;
  background-color:#014451;
  background-color:rgba(1,68,81,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-blue-50:hover{
  --bg-opacity:1;
  background-color:#ebf5ff;
  background-color:rgba(235,245,255,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-blue-100:hover{
  --bg-opacity:1;
  background-color:#e1effe;
  background-color:rgba(225,239,254,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-blue-200:hover{
  --bg-opacity:1;
  background-color:#c3ddfd;
  background-color:rgba(195,221,253,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-blue-300:hover{
  --bg-opacity:1;
  background-color:#a4cafe;
  background-color:rgba(164,202,254,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-blue-400:hover{
  --bg-opacity:1;
  background-color:#76a9fa;
  background-color:rgba(118,169,250,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-blue-500:hover{
  --bg-opacity:1;
  background-color:#3f83f8;
  background-color:rgba(63,131,248,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-blue-600:hover{
  --bg-opacity:1;
  background-color:#1c64f2;
  background-color:rgba(28,100,242,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-blue-700:hover{
  --bg-opacity:1;
  background-color:#1a56db;
  background-color:rgba(26,86,219,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-blue-800:hover{
  --bg-opacity:1;
  background-color:#1e429f;
  background-color:rgba(30,66,159,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-blue-900:hover{
  --bg-opacity:1;
  background-color:#233876;
  background-color:rgba(35,56,118,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-50:hover{
  --bg-opacity:1;
  background-color:#f0f5ff;
  background-color:rgba(240,245,255,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-100:hover{
  --bg-opacity:1;
  background-color:#e5edff;
  background-color:rgba(229,237,255,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-200:hover{
  --bg-opacity:1;
  background-color:#cddbfe;
  background-color:rgba(205,219,254,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-300:hover{
  --bg-opacity:1;
  background-color:#b4c6fc;
  background-color:rgba(180,198,252,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-400:hover{
  --bg-opacity:1;
  background-color:#8da2fb;
  background-color:rgba(141,162,251,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-500:hover{
  --bg-opacity:1;
  background-color:#6875f5;
  background-color:rgba(104,117,245,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-600:hover{
  --bg-opacity:1;
  background-color:#5850ec;
  background-color:rgba(88,80,236,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-700:hover{
  --bg-opacity:1;
  background-color:#5145cd;
  background-color:rgba(81,69,205,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-800:hover{
  --bg-opacity:1;
  background-color:#42389d;
  background-color:rgba(66,56,157,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-900:hover{
  --bg-opacity:1;
  background-color:#362f78;
  background-color:rgba(54,47,120,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-50:hover{
  --bg-opacity:1;
  background-color:#f6f5ff;
  background-color:rgba(246,245,255,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-100:hover{
  --bg-opacity:1;
  background-color:#edebfe;
  background-color:rgba(237,235,254,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-200:hover{
  --bg-opacity:1;
  background-color:#dcd7fe;
  background-color:rgba(220,215,254,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-300:hover{
  --bg-opacity:1;
  background-color:#cabffd;
  background-color:rgba(202,191,253,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-400:hover{
  --bg-opacity:1;
  background-color:#ac94fa;
  background-color:rgba(172,148,250,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-500:hover{
  --bg-opacity:1;
  background-color:#9061f9;
  background-color:rgba(144,97,249,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-600:hover{
  --bg-opacity:1;
  background-color:#7e3af2;
  background-color:rgba(126,58,242,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-700:hover{
  --bg-opacity:1;
  background-color:#6c2bd9;
  background-color:rgba(108,43,217,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-800:hover{
  --bg-opacity:1;
  background-color:#5521b5;
  background-color:rgba(85,33,181,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-indigo-900:hover{
  --bg-opacity:1;
  background-color:#4a1d96;
  background-color:rgba(74,29,150,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-pink-50:hover{
  --bg-opacity:1;
  background-color:#fdf2f8;
  background-color:rgba(253,242,248,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-pink-100:hover{
  --bg-opacity:1;
  background-color:#fce8f3;
  background-color:rgba(252,232,243,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-pink-200:hover{
  --bg-opacity:1;
  background-color:#fad1e8;
  background-color:rgba(250,209,232,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-pink-300:hover{
  --bg-opacity:1;
  background-color:#f8b4d9;
  background-color:rgba(248,180,217,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-pink-400:hover{
  --bg-opacity:1;
  background-color:#f17eb8;
  background-color:rgba(241,126,184,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-pink-500:hover{
  --bg-opacity:1;
  background-color:#e74694;
  background-color:rgba(231,70,148,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-pink-600:hover{
  --bg-opacity:1;
  background-color:#d61f69;
  background-color:rgba(214,31,105,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-pink-700:hover{
  --bg-opacity:1;
  background-color:#bf125d;
  background-color:rgba(191,18,93,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-pink-800:hover{
  --bg-opacity:1;
  background-color:#99154b;
  background-color:rgba(153,21,75,var(--bg-opacity))
}

.theme-dark .dark\\:hover\\:bg-pink-900:hover{
  --bg-opacity:1;
  background-color:#751a3d;
  background-color:rgba(117,26,61,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-transparent:focus{
  background-color:initial
}

.theme-dark .dark\\:focus\\:bg-white:focus{
  --bg-opacity:1;
  background-color:#fff;
  background-color:rgba(255,255,255,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-black:focus{
  --bg-opacity:1;
  background-color:#000;
  background-color:rgba(0,0,0,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-gray-50:focus{
  --bg-opacity:1;
  background-color:#f9fafb;
  background-color:rgba(249,250,251,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-gray-100:focus{
  --bg-opacity:1;
  background-color:#f4f5f7;
  background-color:rgba(244,245,247,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-gray-200:focus{
  --bg-opacity:1;
  background-color:#e5e7eb;
  background-color:rgba(229,231,235,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-gray-300:focus{
  --bg-opacity:1;
  background-color:#d5d6d7;
  background-color:rgba(213,214,215,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-gray-400:focus{
  --bg-opacity:1;
  background-color:#9e9e9e;
  background-color:rgba(158,158,158,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-gray-500:focus{
  --bg-opacity:1;
  background-color:#707275;
  background-color:rgba(112,114,117,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-gray-600:focus{
  --bg-opacity:1;
  background-color:#4c4f52;
  background-color:rgba(76,79,82,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-gray-700:focus{
  --bg-opacity:1;
  background-color:#24262d;
  background-color:rgba(36,38,45,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-gray-800:focus{
  --bg-opacity:1;
  background-color:#1a1c23;
  background-color:rgba(26,28,35,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-gray-900:focus{
  --bg-opacity:1;
  background-color:#121317;
  background-color:rgba(18,19,23,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-cool-gray-50:focus{
  --bg-opacity:1;
  background-color:#fbfdfe;
  background-color:rgba(251,253,254,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-cool-gray-100:focus{
  --bg-opacity:1;
  background-color:#f1f5f9;
  background-color:rgba(241,245,249,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-cool-gray-200:focus{
  --bg-opacity:1;
  background-color:#e2e8f0;
  background-color:rgba(226,232,240,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-cool-gray-300:focus{
  --bg-opacity:1;
  background-color:#cfd8e3;
  background-color:rgba(207,216,227,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-cool-gray-400:focus{
  --bg-opacity:1;
  background-color:#97a6ba;
  background-color:rgba(151,166,186,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-cool-gray-500:focus{
  --bg-opacity:1;
  background-color:#64748b;
  background-color:rgba(100,116,139,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-cool-gray-600:focus{
  --bg-opacity:1;
  background-color:#475569;
  background-color:rgba(71,85,105,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-cool-gray-700:focus{
  --bg-opacity:1;
  background-color:#364152;
  background-color:rgba(54,65,82,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-cool-gray-800:focus{
  --bg-opacity:1;
  background-color:#27303f;
  background-color:rgba(39,48,63,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-cool-gray-900:focus{
  --bg-opacity:1;
  background-color:#1a202e;
  background-color:rgba(26,32,46,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-red-50:focus{
  --bg-opacity:1;
  background-color:#fdf2f2;
  background-color:rgba(253,242,242,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-red-100:focus{
  --bg-opacity:1;
  background-color:#fde8e8;
  background-color:rgba(253,232,232,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-red-200:focus{
  --bg-opacity:1;
  background-color:#fbd5d5;
  background-color:rgba(251,213,213,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-red-300:focus{
  --bg-opacity:1;
  background-color:#f8b4b4;
  background-color:rgba(248,180,180,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-red-400:focus{
  --bg-opacity:1;
  background-color:#f98080;
  background-color:rgba(249,128,128,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-red-500:focus{
  --bg-opacity:1;
  background-color:#f05252;
  background-color:rgba(240,82,82,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-red-600:focus{
  --bg-opacity:1;
  background-color:#e02424;
  background-color:rgba(224,36,36,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-red-700:focus{
  --bg-opacity:1;
  background-color:#c81e1e;
  background-color:rgba(200,30,30,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-red-800:focus{
  --bg-opacity:1;
  background-color:#9b1c1c;
  background-color:rgba(155,28,28,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-red-900:focus{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-orange-50:focus{
  --bg-opacity:1;
  background-color:#fff8f1;
  background-color:rgba(255,248,241,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-orange-100:focus{
  --bg-opacity:1;
  background-color:#feecdc;
  background-color:rgba(254,236,220,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-orange-200:focus{
  --bg-opacity:1;
  background-color:#fcd9bd;
  background-color:rgba(252,217,189,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-orange-300:focus{
  --bg-opacity:1;
  background-color:#fdba8c;
  background-color:rgba(253,186,140,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-orange-400:focus{
  --bg-opacity:1;
  background-color:#ff8a4c;
  background-color:rgba(255,138,76,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-orange-500:focus{
  --bg-opacity:1;
  background-color:#ff5a1f;
  background-color:rgba(255,90,31,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-orange-600:focus{
  --bg-opacity:1;
  background-color:#d03801;
  background-color:rgba(208,56,1,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-orange-700:focus{
  --bg-opacity:1;
  background-color:#b43403;
  background-color:rgba(180,52,3,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-orange-800:focus{
  --bg-opacity:1;
  background-color:#8a2c0d;
  background-color:rgba(138,44,13,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-orange-900:focus{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-yellow-50:focus{
  --bg-opacity:1;
  background-color:#fdfdea;
  background-color:rgba(253,253,234,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-yellow-100:focus{
  --bg-opacity:1;
  background-color:#fdf6b2;
  background-color:rgba(253,246,178,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-yellow-200:focus{
  --bg-opacity:1;
  background-color:#fce96a;
  background-color:rgba(252,233,106,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-yellow-300:focus{
  --bg-opacity:1;
  background-color:#faca15;
  background-color:rgba(250,202,21,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-yellow-400:focus{
  --bg-opacity:1;
  background-color:#e3a008;
  background-color:rgba(227,160,8,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-yellow-500:focus{
  --bg-opacity:1;
  background-color:#c27803;
  background-color:rgba(194,120,3,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-yellow-600:focus{
  --bg-opacity:1;
  background-color:#9f580a;
  background-color:rgba(159,88,10,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-yellow-700:focus{
  --bg-opacity:1;
  background-color:#8e4b10;
  background-color:rgba(142,75,16,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-yellow-800:focus{
  --bg-opacity:1;
  background-color:#723b13;
  background-color:rgba(114,59,19,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-yellow-900:focus{
  --bg-opacity:1;
  background-color:#633112;
  background-color:rgba(99,49,18,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-green-50:focus{
  --bg-opacity:1;
  background-color:#f3faf7;
  background-color:rgba(243,250,247,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-green-100:focus{
  --bg-opacity:1;
  background-color:#def7ec;
  background-color:rgba(222,247,236,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-green-200:focus{
  --bg-opacity:1;
  background-color:#bcf0da;
  background-color:rgba(188,240,218,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-green-300:focus{
  --bg-opacity:1;
  background-color:#84e1bc;
  background-color:rgba(132,225,188,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-green-400:focus{
  --bg-opacity:1;
  background-color:#31c48d;
  background-color:rgba(49,196,141,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-green-500:focus{
  --bg-opacity:1;
  background-color:#0e9f6e;
  background-color:rgba(14,159,110,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-green-600:focus{
  --bg-opacity:1;
  background-color:#057a55;
  background-color:rgba(5,122,85,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-green-700:focus{
  --bg-opacity:1;
  background-color:#046c4e;
  background-color:rgba(4,108,78,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-green-800:focus{
  --bg-opacity:1;
  background-color:#03543f;
  background-color:rgba(3,84,63,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-green-900:focus{
  --bg-opacity:1;
  background-color:#014737;
  background-color:rgba(1,71,55,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-teal-50:focus{
  --bg-opacity:1;
  background-color:#edfafa;
  background-color:rgba(237,250,250,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-teal-100:focus{
  --bg-opacity:1;
  background-color:#d5f5f6;
  background-color:rgba(213,245,246,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-teal-200:focus{
  --bg-opacity:1;
  background-color:#afecef;
  background-color:rgba(175,236,239,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-teal-300:focus{
  --bg-opacity:1;
  background-color:#7edce2;
  background-color:rgba(126,220,226,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-teal-400:focus{
  --bg-opacity:1;
  background-color:#16bdca;
  background-color:rgba(22,189,202,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-teal-500:focus{
  --bg-opacity:1;
  background-color:#0694a2;
  background-color:rgba(6,148,162,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-teal-600:focus{
  --bg-opacity:1;
  background-color:#047481;
  background-color:rgba(4,116,129,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-teal-700:focus{
  --bg-opacity:1;
  background-color:#036672;
  background-color:rgba(3,102,114,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-teal-800:focus{
  --bg-opacity:1;
  background-color:#05505c;
  background-color:rgba(5,80,92,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-teal-900:focus{
  --bg-opacity:1;
  background-color:#014451;
  background-color:rgba(1,68,81,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-blue-50:focus{
  --bg-opacity:1;
  background-color:#ebf5ff;
  background-color:rgba(235,245,255,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-blue-100:focus{
  --bg-opacity:1;
  background-color:#e1effe;
  background-color:rgba(225,239,254,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-blue-200:focus{
  --bg-opacity:1;
  background-color:#c3ddfd;
  background-color:rgba(195,221,253,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-blue-300:focus{
  --bg-opacity:1;
  background-color:#a4cafe;
  background-color:rgba(164,202,254,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-blue-400:focus{
  --bg-opacity:1;
  background-color:#76a9fa;
  background-color:rgba(118,169,250,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-blue-500:focus{
  --bg-opacity:1;
  background-color:#3f83f8;
  background-color:rgba(63,131,248,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-blue-600:focus{
  --bg-opacity:1;
  background-color:#1c64f2;
  background-color:rgba(28,100,242,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-blue-700:focus{
  --bg-opacity:1;
  background-color:#1a56db;
  background-color:rgba(26,86,219,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-blue-800:focus{
  --bg-opacity:1;
  background-color:#1e429f;
  background-color:rgba(30,66,159,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-blue-900:focus{
  --bg-opacity:1;
  background-color:#233876;
  background-color:rgba(35,56,118,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-50:focus{
  --bg-opacity:1;
  background-color:#f0f5ff;
  background-color:rgba(240,245,255,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-100:focus{
  --bg-opacity:1;
  background-color:#e5edff;
  background-color:rgba(229,237,255,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-200:focus{
  --bg-opacity:1;
  background-color:#cddbfe;
  background-color:rgba(205,219,254,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-300:focus{
  --bg-opacity:1;
  background-color:#b4c6fc;
  background-color:rgba(180,198,252,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-400:focus{
  --bg-opacity:1;
  background-color:#8da2fb;
  background-color:rgba(141,162,251,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-500:focus{
  --bg-opacity:1;
  background-color:#6875f5;
  background-color:rgba(104,117,245,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-600:focus{
  --bg-opacity:1;
  background-color:#5850ec;
  background-color:rgba(88,80,236,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-700:focus{
  --bg-opacity:1;
  background-color:#5145cd;
  background-color:rgba(81,69,205,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-800:focus{
  --bg-opacity:1;
  background-color:#42389d;
  background-color:rgba(66,56,157,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-900:focus{
  --bg-opacity:1;
  background-color:#362f78;
  background-color:rgba(54,47,120,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-50:focus{
  --bg-opacity:1;
  background-color:#f6f5ff;
  background-color:rgba(246,245,255,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-100:focus{
  --bg-opacity:1;
  background-color:#edebfe;
  background-color:rgba(237,235,254,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-200:focus{
  --bg-opacity:1;
  background-color:#dcd7fe;
  background-color:rgba(220,215,254,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-300:focus{
  --bg-opacity:1;
  background-color:#cabffd;
  background-color:rgba(202,191,253,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-400:focus{
  --bg-opacity:1;
  background-color:#ac94fa;
  background-color:rgba(172,148,250,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-500:focus{
  --bg-opacity:1;
  background-color:#9061f9;
  background-color:rgba(144,97,249,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-600:focus{
  --bg-opacity:1;
  background-color:#7e3af2;
  background-color:rgba(126,58,242,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-700:focus{
  --bg-opacity:1;
  background-color:#6c2bd9;
  background-color:rgba(108,43,217,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-800:focus{
  --bg-opacity:1;
  background-color:#5521b5;
  background-color:rgba(85,33,181,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-indigo-900:focus{
  --bg-opacity:1;
  background-color:#4a1d96;
  background-color:rgba(74,29,150,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-pink-50:focus{
  --bg-opacity:1;
  background-color:#fdf2f8;
  background-color:rgba(253,242,248,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-pink-100:focus{
  --bg-opacity:1;
  background-color:#fce8f3;
  background-color:rgba(252,232,243,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-pink-200:focus{
  --bg-opacity:1;
  background-color:#fad1e8;
  background-color:rgba(250,209,232,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-pink-300:focus{
  --bg-opacity:1;
  background-color:#f8b4d9;
  background-color:rgba(248,180,217,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-pink-400:focus{
  --bg-opacity:1;
  background-color:#f17eb8;
  background-color:rgba(241,126,184,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-pink-500:focus{
  --bg-opacity:1;
  background-color:#e74694;
  background-color:rgba(231,70,148,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-pink-600:focus{
  --bg-opacity:1;
  background-color:#d61f69;
  background-color:rgba(214,31,105,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-pink-700:focus{
  --bg-opacity:1;
  background-color:#bf125d;
  background-color:rgba(191,18,93,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-pink-800:focus{
  --bg-opacity:1;
  background-color:#99154b;
  background-color:rgba(153,21,75,var(--bg-opacity))
}

.theme-dark .dark\\:focus\\:bg-pink-900:focus{
  --bg-opacity:1;
  background-color:#751a3d;
  background-color:rgba(117,26,61,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-transparent:active{
  background-color:initial
}

.theme-dark .dark\\:active\\:bg-white:active{
  --bg-opacity:1;
  background-color:#fff;
  background-color:rgba(255,255,255,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-black:active{
  --bg-opacity:1;
  background-color:#000;
  background-color:rgba(0,0,0,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-gray-50:active{
  --bg-opacity:1;
  background-color:#f9fafb;
  background-color:rgba(249,250,251,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-gray-100:active{
  --bg-opacity:1;
  background-color:#f4f5f7;
  background-color:rgba(244,245,247,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-gray-200:active{
  --bg-opacity:1;
  background-color:#e5e7eb;
  background-color:rgba(229,231,235,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-gray-300:active{
  --bg-opacity:1;
  background-color:#d5d6d7;
  background-color:rgba(213,214,215,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-gray-400:active{
  --bg-opacity:1;
  background-color:#9e9e9e;
  background-color:rgba(158,158,158,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-gray-500:active{
  --bg-opacity:1;
  background-color:#707275;
  background-color:rgba(112,114,117,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-gray-600:active{
  --bg-opacity:1;
  background-color:#4c4f52;
  background-color:rgba(76,79,82,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-gray-700:active{
  --bg-opacity:1;
  background-color:#24262d;
  background-color:rgba(36,38,45,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-gray-800:active{
  --bg-opacity:1;
  background-color:#1a1c23;
  background-color:rgba(26,28,35,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-gray-900:active{
  --bg-opacity:1;
  background-color:#121317;
  background-color:rgba(18,19,23,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-cool-gray-50:active{
  --bg-opacity:1;
  background-color:#fbfdfe;
  background-color:rgba(251,253,254,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-cool-gray-100:active{
  --bg-opacity:1;
  background-color:#f1f5f9;
  background-color:rgba(241,245,249,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-cool-gray-200:active{
  --bg-opacity:1;
  background-color:#e2e8f0;
  background-color:rgba(226,232,240,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-cool-gray-300:active{
  --bg-opacity:1;
  background-color:#cfd8e3;
  background-color:rgba(207,216,227,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-cool-gray-400:active{
  --bg-opacity:1;
  background-color:#97a6ba;
  background-color:rgba(151,166,186,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-cool-gray-500:active{
  --bg-opacity:1;
  background-color:#64748b;
  background-color:rgba(100,116,139,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-cool-gray-600:active{
  --bg-opacity:1;
  background-color:#475569;
  background-color:rgba(71,85,105,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-cool-gray-700:active{
  --bg-opacity:1;
  background-color:#364152;
  background-color:rgba(54,65,82,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-cool-gray-800:active{
  --bg-opacity:1;
  background-color:#27303f;
  background-color:rgba(39,48,63,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-cool-gray-900:active{
  --bg-opacity:1;
  background-color:#1a202e;
  background-color:rgba(26,32,46,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-red-50:active{
  --bg-opacity:1;
  background-color:#fdf2f2;
  background-color:rgba(253,242,242,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-red-100:active{
  --bg-opacity:1;
  background-color:#fde8e8;
  background-color:rgba(253,232,232,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-red-200:active{
  --bg-opacity:1;
  background-color:#fbd5d5;
  background-color:rgba(251,213,213,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-red-300:active{
  --bg-opacity:1;
  background-color:#f8b4b4;
  background-color:rgba(248,180,180,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-red-400:active{
  --bg-opacity:1;
  background-color:#f98080;
  background-color:rgba(249,128,128,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-red-500:active{
  --bg-opacity:1;
  background-color:#f05252;
  background-color:rgba(240,82,82,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-red-600:active{
  --bg-opacity:1;
  background-color:#e02424;
  background-color:rgba(224,36,36,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-red-700:active{
  --bg-opacity:1;
  background-color:#c81e1e;
  background-color:rgba(200,30,30,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-red-800:active{
  --bg-opacity:1;
  background-color:#9b1c1c;
  background-color:rgba(155,28,28,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-red-900:active{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-orange-50:active{
  --bg-opacity:1;
  background-color:#fff8f1;
  background-color:rgba(255,248,241,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-orange-100:active{
  --bg-opacity:1;
  background-color:#feecdc;
  background-color:rgba(254,236,220,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-orange-200:active{
  --bg-opacity:1;
  background-color:#fcd9bd;
  background-color:rgba(252,217,189,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-orange-300:active{
  --bg-opacity:1;
  background-color:#fdba8c;
  background-color:rgba(253,186,140,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-orange-400:active{
  --bg-opacity:1;
  background-color:#ff8a4c;
  background-color:rgba(255,138,76,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-orange-500:active{
  --bg-opacity:1;
  background-color:#ff5a1f;
  background-color:rgba(255,90,31,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-orange-600:active{
  --bg-opacity:1;
  background-color:#d03801;
  background-color:rgba(208,56,1,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-orange-700:active{
  --bg-opacity:1;
  background-color:#b43403;
  background-color:rgba(180,52,3,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-orange-800:active{
  --bg-opacity:1;
  background-color:#8a2c0d;
  background-color:rgba(138,44,13,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-orange-900:active{
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-yellow-50:active{
  --bg-opacity:1;
  background-color:#fdfdea;
  background-color:rgba(253,253,234,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-yellow-100:active{
  --bg-opacity:1;
  background-color:#fdf6b2;
  background-color:rgba(253,246,178,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-yellow-200:active{
  --bg-opacity:1;
  background-color:#fce96a;
  background-color:rgba(252,233,106,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-yellow-300:active{
  --bg-opacity:1;
  background-color:#faca15;
  background-color:rgba(250,202,21,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-yellow-400:active{
  --bg-opacity:1;
  background-color:#e3a008;
  background-color:rgba(227,160,8,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-yellow-500:active{
  --bg-opacity:1;
  background-color:#c27803;
  background-color:rgba(194,120,3,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-yellow-600:active{
  --bg-opacity:1;
  background-color:#9f580a;
  background-color:rgba(159,88,10,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-yellow-700:active{
  --bg-opacity:1;
  background-color:#8e4b10;
  background-color:rgba(142,75,16,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-yellow-800:active{
  --bg-opacity:1;
  background-color:#723b13;
  background-color:rgba(114,59,19,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-yellow-900:active{
  --bg-opacity:1;
  background-color:#633112;
  background-color:rgba(99,49,18,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-green-50:active{
  --bg-opacity:1;
  background-color:#f3faf7;
  background-color:rgba(243,250,247,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-green-100:active{
  --bg-opacity:1;
  background-color:#def7ec;
  background-color:rgba(222,247,236,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-green-200:active{
  --bg-opacity:1;
  background-color:#bcf0da;
  background-color:rgba(188,240,218,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-green-300:active{
  --bg-opacity:1;
  background-color:#84e1bc;
  background-color:rgba(132,225,188,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-green-400:active{
  --bg-opacity:1;
  background-color:#31c48d;
  background-color:rgba(49,196,141,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-green-500:active{
  --bg-opacity:1;
  background-color:#0e9f6e;
  background-color:rgba(14,159,110,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-green-600:active{
  --bg-opacity:1;
  background-color:#057a55;
  background-color:rgba(5,122,85,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-green-700:active{
  --bg-opacity:1;
  background-color:#046c4e;
  background-color:rgba(4,108,78,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-green-800:active{
  --bg-opacity:1;
  background-color:#03543f;
  background-color:rgba(3,84,63,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-green-900:active{
  --bg-opacity:1;
  background-color:#014737;
  background-color:rgba(1,71,55,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-teal-50:active{
  --bg-opacity:1;
  background-color:#edfafa;
  background-color:rgba(237,250,250,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-teal-100:active{
  --bg-opacity:1;
  background-color:#d5f5f6;
  background-color:rgba(213,245,246,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-teal-200:active{
  --bg-opacity:1;
  background-color:#afecef;
  background-color:rgba(175,236,239,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-teal-300:active{
  --bg-opacity:1;
  background-color:#7edce2;
  background-color:rgba(126,220,226,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-teal-400:active{
  --bg-opacity:1;
  background-color:#16bdca;
  background-color:rgba(22,189,202,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-teal-500:active{
  --bg-opacity:1;
  background-color:#0694a2;
  background-color:rgba(6,148,162,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-teal-600:active{
  --bg-opacity:1;
  background-color:#047481;
  background-color:rgba(4,116,129,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-teal-700:active{
  --bg-opacity:1;
  background-color:#036672;
  background-color:rgba(3,102,114,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-teal-800:active{
  --bg-opacity:1;
  background-color:#05505c;
  background-color:rgba(5,80,92,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-teal-900:active{
  --bg-opacity:1;
  background-color:#014451;
  background-color:rgba(1,68,81,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-blue-50:active{
  --bg-opacity:1;
  background-color:#ebf5ff;
  background-color:rgba(235,245,255,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-blue-100:active{
  --bg-opacity:1;
  background-color:#e1effe;
  background-color:rgba(225,239,254,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-blue-200:active{
  --bg-opacity:1;
  background-color:#c3ddfd;
  background-color:rgba(195,221,253,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-blue-300:active{
  --bg-opacity:1;
  background-color:#a4cafe;
  background-color:rgba(164,202,254,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-blue-400:active{
  --bg-opacity:1;
  background-color:#76a9fa;
  background-color:rgba(118,169,250,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-blue-500:active{
  --bg-opacity:1;
  background-color:#3f83f8;
  background-color:rgba(63,131,248,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-blue-600:active{
  --bg-opacity:1;
  background-color:#1c64f2;
  background-color:rgba(28,100,242,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-blue-700:active{
  --bg-opacity:1;
  background-color:#1a56db;
  background-color:rgba(26,86,219,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-blue-800:active{
  --bg-opacity:1;
  background-color:#1e429f;
  background-color:rgba(30,66,159,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-blue-900:active{
  --bg-opacity:1;
  background-color:#233876;
  background-color:rgba(35,56,118,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-50:active{
  --bg-opacity:1;
  background-color:#f0f5ff;
  background-color:rgba(240,245,255,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-100:active{
  --bg-opacity:1;
  background-color:#e5edff;
  background-color:rgba(229,237,255,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-200:active{
  --bg-opacity:1;
  background-color:#cddbfe;
  background-color:rgba(205,219,254,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-300:active{
  --bg-opacity:1;
  background-color:#b4c6fc;
  background-color:rgba(180,198,252,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-400:active{
  --bg-opacity:1;
  background-color:#8da2fb;
  background-color:rgba(141,162,251,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-500:active{
  --bg-opacity:1;
  background-color:#6875f5;
  background-color:rgba(104,117,245,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-600:active{
  --bg-opacity:1;
  background-color:#5850ec;
  background-color:rgba(88,80,236,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-700:active{
  --bg-opacity:1;
  background-color:#5145cd;
  background-color:rgba(81,69,205,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-800:active{
  --bg-opacity:1;
  background-color:#42389d;
  background-color:rgba(66,56,157,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-900:active{
  --bg-opacity:1;
  background-color:#362f78;
  background-color:rgba(54,47,120,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-50:active{
  --bg-opacity:1;
  background-color:#f6f5ff;
  background-color:rgba(246,245,255,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-100:active{
  --bg-opacity:1;
  background-color:#edebfe;
  background-color:rgba(237,235,254,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-200:active{
  --bg-opacity:1;
  background-color:#dcd7fe;
  background-color:rgba(220,215,254,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-300:active{
  --bg-opacity:1;
  background-color:#cabffd;
  background-color:rgba(202,191,253,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-400:active{
  --bg-opacity:1;
  background-color:#ac94fa;
  background-color:rgba(172,148,250,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-500:active{
  --bg-opacity:1;
  background-color:#9061f9;
  background-color:rgba(144,97,249,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-600:active{
  --bg-opacity:1;
  background-color:#7e3af2;
  background-color:rgba(126,58,242,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-700:active{
  --bg-opacity:1;
  background-color:#6c2bd9;
  background-color:rgba(108,43,217,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-800:active{
  --bg-opacity:1;
  background-color:#5521b5;
  background-color:rgba(85,33,181,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-indigo-900:active{
  --bg-opacity:1;
  background-color:#4a1d96;
  background-color:rgba(74,29,150,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-pink-50:active{
  --bg-opacity:1;
  background-color:#fdf2f8;
  background-color:rgba(253,242,248,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-pink-100:active{
  --bg-opacity:1;
  background-color:#fce8f3;
  background-color:rgba(252,232,243,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-pink-200:active{
  --bg-opacity:1;
  background-color:#fad1e8;
  background-color:rgba(250,209,232,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-pink-300:active{
  --bg-opacity:1;
  background-color:#f8b4d9;
  background-color:rgba(248,180,217,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-pink-400:active{
  --bg-opacity:1;
  background-color:#f17eb8;
  background-color:rgba(241,126,184,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-pink-500:active{
  --bg-opacity:1;
  background-color:#e74694;
  background-color:rgba(231,70,148,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-pink-600:active{
  --bg-opacity:1;
  background-color:#d61f69;
  background-color:rgba(214,31,105,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-pink-700:active{
  --bg-opacity:1;
  background-color:#bf125d;
  background-color:rgba(191,18,93,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-pink-800:active{
  --bg-opacity:1;
  background-color:#99154b;
  background-color:rgba(153,21,75,var(--bg-opacity))
}

.theme-dark .dark\\:active\\:bg-pink-900:active{
  --bg-opacity:1;
  background-color:#751a3d;
  background-color:rgba(117,26,61,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-transparent:nth-child(odd){
  background-color:initial
}

.theme-dark .dark\\:odd\\:bg-white:nth-child(odd){
  --bg-opacity:1;
  background-color:#fff;
  background-color:rgba(255,255,255,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-black:nth-child(odd){
  --bg-opacity:1;
  background-color:#000;
  background-color:rgba(0,0,0,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-gray-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#f9fafb;
  background-color:rgba(249,250,251,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-gray-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#f4f5f7;
  background-color:rgba(244,245,247,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-gray-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#e5e7eb;
  background-color:rgba(229,231,235,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-gray-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#d5d6d7;
  background-color:rgba(213,214,215,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-gray-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#9e9e9e;
  background-color:rgba(158,158,158,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-gray-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#707275;
  background-color:rgba(112,114,117,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-gray-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#4c4f52;
  background-color:rgba(76,79,82,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-gray-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#24262d;
  background-color:rgba(36,38,45,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-gray-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#1a1c23;
  background-color:rgba(26,28,35,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-gray-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#121317;
  background-color:rgba(18,19,23,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-cool-gray-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#fbfdfe;
  background-color:rgba(251,253,254,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-cool-gray-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#f1f5f9;
  background-color:rgba(241,245,249,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-cool-gray-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#e2e8f0;
  background-color:rgba(226,232,240,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-cool-gray-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#cfd8e3;
  background-color:rgba(207,216,227,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-cool-gray-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#97a6ba;
  background-color:rgba(151,166,186,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-cool-gray-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#64748b;
  background-color:rgba(100,116,139,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-cool-gray-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#475569;
  background-color:rgba(71,85,105,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-cool-gray-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#364152;
  background-color:rgba(54,65,82,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-cool-gray-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#27303f;
  background-color:rgba(39,48,63,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-cool-gray-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#1a202e;
  background-color:rgba(26,32,46,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-red-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#fdf2f2;
  background-color:rgba(253,242,242,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-red-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#fde8e8;
  background-color:rgba(253,232,232,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-red-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#fbd5d5;
  background-color:rgba(251,213,213,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-red-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#f8b4b4;
  background-color:rgba(248,180,180,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-red-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#f98080;
  background-color:rgba(249,128,128,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-red-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#f05252;
  background-color:rgba(240,82,82,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-red-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#e02424;
  background-color:rgba(224,36,36,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-red-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#c81e1e;
  background-color:rgba(200,30,30,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-red-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#9b1c1c;
  background-color:rgba(155,28,28,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-red-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-orange-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#fff8f1;
  background-color:rgba(255,248,241,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-orange-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#feecdc;
  background-color:rgba(254,236,220,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-orange-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#fcd9bd;
  background-color:rgba(252,217,189,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-orange-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#fdba8c;
  background-color:rgba(253,186,140,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-orange-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#ff8a4c;
  background-color:rgba(255,138,76,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-orange-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#ff5a1f;
  background-color:rgba(255,90,31,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-orange-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#d03801;
  background-color:rgba(208,56,1,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-orange-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#b43403;
  background-color:rgba(180,52,3,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-orange-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#8a2c0d;
  background-color:rgba(138,44,13,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-orange-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#771d1d;
  background-color:rgba(119,29,29,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-yellow-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#fdfdea;
  background-color:rgba(253,253,234,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-yellow-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#fdf6b2;
  background-color:rgba(253,246,178,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-yellow-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#fce96a;
  background-color:rgba(252,233,106,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-yellow-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#faca15;
  background-color:rgba(250,202,21,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-yellow-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#e3a008;
  background-color:rgba(227,160,8,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-yellow-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#c27803;
  background-color:rgba(194,120,3,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-yellow-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#9f580a;
  background-color:rgba(159,88,10,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-yellow-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#8e4b10;
  background-color:rgba(142,75,16,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-yellow-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#723b13;
  background-color:rgba(114,59,19,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-yellow-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#633112;
  background-color:rgba(99,49,18,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-green-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#f3faf7;
  background-color:rgba(243,250,247,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-green-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#def7ec;
  background-color:rgba(222,247,236,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-green-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#bcf0da;
  background-color:rgba(188,240,218,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-green-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#84e1bc;
  background-color:rgba(132,225,188,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-green-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#31c48d;
  background-color:rgba(49,196,141,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-green-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#0e9f6e;
  background-color:rgba(14,159,110,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-green-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#057a55;
  background-color:rgba(5,122,85,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-green-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#046c4e;
  background-color:rgba(4,108,78,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-green-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#03543f;
  background-color:rgba(3,84,63,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-green-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#014737;
  background-color:rgba(1,71,55,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-teal-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#edfafa;
  background-color:rgba(237,250,250,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-teal-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#d5f5f6;
  background-color:rgba(213,245,246,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-teal-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#afecef;
  background-color:rgba(175,236,239,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-teal-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#7edce2;
  background-color:rgba(126,220,226,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-teal-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#16bdca;
  background-color:rgba(22,189,202,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-teal-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#0694a2;
  background-color:rgba(6,148,162,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-teal-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#047481;
  background-color:rgba(4,116,129,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-teal-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#036672;
  background-color:rgba(3,102,114,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-teal-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#05505c;
  background-color:rgba(5,80,92,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-teal-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#014451;
  background-color:rgba(1,68,81,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-blue-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#ebf5ff;
  background-color:rgba(235,245,255,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-blue-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#e1effe;
  background-color:rgba(225,239,254,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-blue-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#c3ddfd;
  background-color:rgba(195,221,253,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-blue-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#a4cafe;
  background-color:rgba(164,202,254,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-blue-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#76a9fa;
  background-color:rgba(118,169,250,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-blue-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#3f83f8;
  background-color:rgba(63,131,248,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-blue-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#1c64f2;
  background-color:rgba(28,100,242,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-blue-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#1a56db;
  background-color:rgba(26,86,219,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-blue-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#1e429f;
  background-color:rgba(30,66,159,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-blue-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#233876;
  background-color:rgba(35,56,118,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#f0f5ff;
  background-color:rgba(240,245,255,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#e5edff;
  background-color:rgba(229,237,255,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#cddbfe;
  background-color:rgba(205,219,254,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#b4c6fc;
  background-color:rgba(180,198,252,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#8da2fb;
  background-color:rgba(141,162,251,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#6875f5;
  background-color:rgba(104,117,245,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#5850ec;
  background-color:rgba(88,80,236,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#5145cd;
  background-color:rgba(81,69,205,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#42389d;
  background-color:rgba(66,56,157,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#362f78;
  background-color:rgba(54,47,120,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#f6f5ff;
  background-color:rgba(246,245,255,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#edebfe;
  background-color:rgba(237,235,254,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#dcd7fe;
  background-color:rgba(220,215,254,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#cabffd;
  background-color:rgba(202,191,253,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#ac94fa;
  background-color:rgba(172,148,250,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#9061f9;
  background-color:rgba(144,97,249,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#7e3af2;
  background-color:rgba(126,58,242,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#6c2bd9;
  background-color:rgba(108,43,217,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#5521b5;
  background-color:rgba(85,33,181,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-indigo-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#4a1d96;
  background-color:rgba(74,29,150,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-pink-50:nth-child(odd){
  --bg-opacity:1;
  background-color:#fdf2f8;
  background-color:rgba(253,242,248,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-pink-100:nth-child(odd){
  --bg-opacity:1;
  background-color:#fce8f3;
  background-color:rgba(252,232,243,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-pink-200:nth-child(odd){
  --bg-opacity:1;
  background-color:#fad1e8;
  background-color:rgba(250,209,232,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-pink-300:nth-child(odd){
  --bg-opacity:1;
  background-color:#f8b4d9;
  background-color:rgba(248,180,217,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-pink-400:nth-child(odd){
  --bg-opacity:1;
  background-color:#f17eb8;
  background-color:rgba(241,126,184,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-pink-500:nth-child(odd){
  --bg-opacity:1;
  background-color:#e74694;
  background-color:rgba(231,70,148,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-pink-600:nth-child(odd){
  --bg-opacity:1;
  background-color:#d61f69;
  background-color:rgba(214,31,105,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-pink-700:nth-child(odd){
  --bg-opacity:1;
  background-color:#bf125d;
  background-color:rgba(191,18,93,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-pink-800:nth-child(odd){
  --bg-opacity:1;
  background-color:#99154b;
  background-color:rgba(153,21,75,var(--bg-opacity))
}

.theme-dark .dark\\:odd\\:bg-pink-900:nth-child(odd){
  --bg-opacity:1;
  background-color:#751a3d;
  background-color:rgba(117,26,61,var(--bg-opacity))
}

.bg-opacity-0{
  --bg-opacity:0
}

.bg-opacity-10{
  --bg-opacity:0.1
}

.bg-opacity-25{
  --bg-opacity:0.25
}

.bg-opacity-50{
  --bg-opacity:0.5
}

.bg-opacity-75{
  --bg-opacity:0.75
}

.bg-opacity-100{
  --bg-opacity:1
}

.hover\\:bg-opacity-0:hover{
  --bg-opacity:0
}

.hover\\:bg-opacity-10:hover{
  --bg-opacity:0.1
}

.hover\\:bg-opacity-25:hover{
  --bg-opacity:0.25
}

.hover\\:bg-opacity-50:hover{
  --bg-opacity:0.5
}

.hover\\:bg-opacity-75:hover{
  --bg-opacity:0.75
}

.hover\\:bg-opacity-100:hover{
  --bg-opacity:1
}

.focus\\:bg-opacity-0:focus{
  --bg-opacity:0
}

.focus\\:bg-opacity-10:focus{
  --bg-opacity:0.1
}

.focus\\:bg-opacity-25:focus{
  --bg-opacity:0.25
}

.focus\\:bg-opacity-50:focus{
  --bg-opacity:0.5
}

.focus\\:bg-opacity-75:focus{
  --bg-opacity:0.75
}

.focus\\:bg-opacity-100:focus{
  --bg-opacity:1
}

.theme-dark .dark\\:hover\\:bg-opacity-0:hover{
  --bg-opacity:0
}

.theme-dark .dark\\:hover\\:bg-opacity-10:hover{
  --bg-opacity:0.1
}

.theme-dark .dark\\:hover\\:bg-opacity-25:hover{
  --bg-opacity:0.25
}

.theme-dark .dark\\:hover\\:bg-opacity-50:hover{
  --bg-opacity:0.5
}

.theme-dark .dark\\:hover\\:bg-opacity-75:hover{
  --bg-opacity:0.75
}

.theme-dark .dark\\:hover\\:bg-opacity-100:hover{
  --bg-opacity:1
}

.bg-bottom{
  background-position:bottom
}

.bg-center{
  background-position:50%
}

.bg-left{
  background-position:0
}

.bg-left-bottom{
  background-position:0 100%
}

.bg-left-top{
  background-position:0 0
}

.bg-right{
  background-position:100%
}

.bg-right-bottom{
  background-position:100% 100%
}

.bg-right-top{
  background-position:100% 0
}

.bg-top{
  background-position:top
}

.bg-repeat{
  background-repeat:repeat
}

.bg-no-repeat{
  background-repeat:no-repeat
}

.bg-repeat-x{
  background-repeat:repeat-x
}

.bg-repeat-y{
  background-repeat:repeat-y
}

.bg-repeat-round{
  background-repeat:round
}

.bg-repeat-space{
  background-repeat:space
}

.bg-auto{
  background-size:auto
}

.bg-cover{
  background-size:cover
}

.bg-contain{
  background-size:contain
}

.border-collapse{
  border-collapse:collapse
}

.border-separate{
  border-collapse:initial
}

.border-transparent{
  border-color:#0000
}

.border-white{
  --border-opacity:1;
  border-color:#fff;
  border-color:rgba(255,255,255,var(--border-opacity))
}

.border-black{
  --border-opacity:1;
  border-color:#000;
  border-color:rgba(0,0,0,var(--border-opacity))
}

.border-gray-50{
  --border-opacity:1;
  border-color:#f9fafb;
  border-color:rgba(249,250,251,var(--border-opacity))
}

.border-gray-100{
  --border-opacity:1;
  border-color:#f4f5f7;
  border-color:rgba(244,245,247,var(--border-opacity))
}

.border-gray-200{
  --border-opacity:1;
  border-color:#e5e7eb;
  border-color:rgba(229,231,235,var(--border-opacity))
}

.border-gray-300{
  --border-opacity:1;
  border-color:#d5d6d7;
  border-color:rgba(213,214,215,var(--border-opacity))
}

.border-gray-400{
  --border-opacity:1;
  border-color:#9e9e9e;
  border-color:rgba(158,158,158,var(--border-opacity))
}

.border-gray-500{
  --border-opacity:1;
  border-color:#707275;
  border-color:rgba(112,114,117,var(--border-opacity))
}

.border-gray-600{
  --border-opacity:1;
  border-color:#4c4f52;
  border-color:rgba(76,79,82,var(--border-opacity))
}

.border-gray-700{
  --border-opacity:1;
  border-color:#24262d;
  border-color:rgba(36,38,45,var(--border-opacity))
}

.border-gray-800{
  --border-opacity:1;
  border-color:#1a1c23;
  border-color:rgba(26,28,35,var(--border-opacity))
}

.border-gray-900{
  --border-opacity:1;
  border-color:#121317;
  border-color:rgba(18,19,23,var(--border-opacity))
}

.border-cool-gray-50{
  --border-opacity:1;
  border-color:#fbfdfe;
  border-color:rgba(251,253,254,var(--border-opacity))
}

.border-cool-gray-100{
  --border-opacity:1;
  border-color:#f1f5f9;
  border-color:rgba(241,245,249,var(--border-opacity))
}

.border-cool-gray-200{
  --border-opacity:1;
  border-color:#e2e8f0;
  border-color:rgba(226,232,240,var(--border-opacity))
}

.border-cool-gray-300{
  --border-opacity:1;
  border-color:#cfd8e3;
  border-color:rgba(207,216,227,var(--border-opacity))
}

.border-cool-gray-400{
  --border-opacity:1;
  border-color:#97a6ba;
  border-color:rgba(151,166,186,var(--border-opacity))
}

.border-cool-gray-500{
  --border-opacity:1;
  border-color:#64748b;
  border-color:rgba(100,116,139,var(--border-opacity))
}

.border-cool-gray-600{
  --border-opacity:1;
  border-color:#475569;
  border-color:rgba(71,85,105,var(--border-opacity))
}

.border-cool-gray-700{
  --border-opacity:1;
  border-color:#364152;
  border-color:rgba(54,65,82,var(--border-opacity))
}

.border-cool-gray-800{
  --border-opacity:1;
  border-color:#27303f;
  border-color:rgba(39,48,63,var(--border-opacity))
}

.border-cool-gray-900{
  --border-opacity:1;
  border-color:#1a202e;
  border-color:rgba(26,32,46,var(--border-opacity))
}

.border-red-50{
  --border-opacity:1;
  border-color:#fdf2f2;
  border-color:rgba(253,242,242,var(--border-opacity))
}

.border-red-100{
  --border-opacity:1;
  border-color:#fde8e8;
  border-color:rgba(253,232,232,var(--border-opacity))
}

.border-red-200{
  --border-opacity:1;
  border-color:#fbd5d5;
  border-color:rgba(251,213,213,var(--border-opacity))
}

.border-red-300{
  --border-opacity:1;
  border-color:#f8b4b4;
  border-color:rgba(248,180,180,var(--border-opacity))
}

.border-red-400{
  --border-opacity:1;
  border-color:#f98080;
  border-color:rgba(249,128,128,var(--border-opacity))
}

.border-red-500{
  --border-opacity:1;
  border-color:#f05252;
  border-color:rgba(240,82,82,var(--border-opacity))
}

.border-red-600{
  --border-opacity:1;
  border-color:#e02424;
  border-color:rgba(224,36,36,var(--border-opacity))
}

.border-red-700{
  --border-opacity:1;
  border-color:#c81e1e;
  border-color:rgba(200,30,30,var(--border-opacity))
}

.border-red-800{
  --border-opacity:1;
  border-color:#9b1c1c;
  border-color:rgba(155,28,28,var(--border-opacity))
}

.border-red-900{
  --border-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--border-opacity))
}

.border-orange-50{
  --border-opacity:1;
  border-color:#fff8f1;
  border-color:rgba(255,248,241,var(--border-opacity))
}

.border-orange-100{
  --border-opacity:1;
  border-color:#feecdc;
  border-color:rgba(254,236,220,var(--border-opacity))
}

.border-orange-200{
  --border-opacity:1;
  border-color:#fcd9bd;
  border-color:rgba(252,217,189,var(--border-opacity))
}

.border-orange-300{
  --border-opacity:1;
  border-color:#fdba8c;
  border-color:rgba(253,186,140,var(--border-opacity))
}

.border-orange-400{
  --border-opacity:1;
  border-color:#ff8a4c;
  border-color:rgba(255,138,76,var(--border-opacity))
}

.border-orange-500{
  --border-opacity:1;
  border-color:#ff5a1f;
  border-color:rgba(255,90,31,var(--border-opacity))
}

.border-orange-600{
  --border-opacity:1;
  border-color:#d03801;
  border-color:rgba(208,56,1,var(--border-opacity))
}

.border-orange-700{
  --border-opacity:1;
  border-color:#b43403;
  border-color:rgba(180,52,3,var(--border-opacity))
}

.border-orange-800{
  --border-opacity:1;
  border-color:#8a2c0d;
  border-color:rgba(138,44,13,var(--border-opacity))
}

.border-orange-900{
  --border-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--border-opacity))
}

.border-yellow-50{
  --border-opacity:1;
  border-color:#fdfdea;
  border-color:rgba(253,253,234,var(--border-opacity))
}

.border-yellow-100{
  --border-opacity:1;
  border-color:#fdf6b2;
  border-color:rgba(253,246,178,var(--border-opacity))
}

.border-yellow-200{
  --border-opacity:1;
  border-color:#fce96a;
  border-color:rgba(252,233,106,var(--border-opacity))
}

.border-yellow-300{
  --border-opacity:1;
  border-color:#faca15;
  border-color:rgba(250,202,21,var(--border-opacity))
}

.border-yellow-400{
  --border-opacity:1;
  border-color:#e3a008;
  border-color:rgba(227,160,8,var(--border-opacity))
}

.border-yellow-500{
  --border-opacity:1;
  border-color:#c27803;
  border-color:rgba(194,120,3,var(--border-opacity))
}

.border-yellow-600{
  --border-opacity:1;
  border-color:#9f580a;
  border-color:rgba(159,88,10,var(--border-opacity))
}

.border-yellow-700{
  --border-opacity:1;
  border-color:#8e4b10;
  border-color:rgba(142,75,16,var(--border-opacity))
}

.border-yellow-800{
  --border-opacity:1;
  border-color:#723b13;
  border-color:rgba(114,59,19,var(--border-opacity))
}

.border-yellow-900{
  --border-opacity:1;
  border-color:#633112;
  border-color:rgba(99,49,18,var(--border-opacity))
}

.border-green-50{
  --border-opacity:1;
  border-color:#f3faf7;
  border-color:rgba(243,250,247,var(--border-opacity))
}

.border-green-100{
  --border-opacity:1;
  border-color:#def7ec;
  border-color:rgba(222,247,236,var(--border-opacity))
}

.border-green-200{
  --border-opacity:1;
  border-color:#bcf0da;
  border-color:rgba(188,240,218,var(--border-opacity))
}

.border-green-300{
  --border-opacity:1;
  border-color:#84e1bc;
  border-color:rgba(132,225,188,var(--border-opacity))
}

.border-green-400{
  --border-opacity:1;
  border-color:#31c48d;
  border-color:rgba(49,196,141,var(--border-opacity))
}

.border-green-500{
  --border-opacity:1;
  border-color:#0e9f6e;
  border-color:rgba(14,159,110,var(--border-opacity))
}

.border-green-600{
  --border-opacity:1;
  border-color:#057a55;
  border-color:rgba(5,122,85,var(--border-opacity))
}

.border-green-700{
  --border-opacity:1;
  border-color:#046c4e;
  border-color:rgba(4,108,78,var(--border-opacity))
}

.border-green-800{
  --border-opacity:1;
  border-color:#03543f;
  border-color:rgba(3,84,63,var(--border-opacity))
}

.border-green-900{
  --border-opacity:1;
  border-color:#014737;
  border-color:rgba(1,71,55,var(--border-opacity))
}

.border-teal-50{
  --border-opacity:1;
  border-color:#edfafa;
  border-color:rgba(237,250,250,var(--border-opacity))
}

.border-teal-100{
  --border-opacity:1;
  border-color:#d5f5f6;
  border-color:rgba(213,245,246,var(--border-opacity))
}

.border-teal-200{
  --border-opacity:1;
  border-color:#afecef;
  border-color:rgba(175,236,239,var(--border-opacity))
}

.border-teal-300{
  --border-opacity:1;
  border-color:#7edce2;
  border-color:rgba(126,220,226,var(--border-opacity))
}

.border-teal-400{
  --border-opacity:1;
  border-color:#16bdca;
  border-color:rgba(22,189,202,var(--border-opacity))
}

.border-teal-500{
  --border-opacity:1;
  border-color:#0694a2;
  border-color:rgba(6,148,162,var(--border-opacity))
}

.border-teal-600{
  --border-opacity:1;
  border-color:#047481;
  border-color:rgba(4,116,129,var(--border-opacity))
}

.border-teal-700{
  --border-opacity:1;
  border-color:#036672;
  border-color:rgba(3,102,114,var(--border-opacity))
}

.border-teal-800{
  --border-opacity:1;
  border-color:#05505c;
  border-color:rgba(5,80,92,var(--border-opacity))
}

.border-teal-900{
  --border-opacity:1;
  border-color:#014451;
  border-color:rgba(1,68,81,var(--border-opacity))
}

.border-blue-50{
  --border-opacity:1;
  border-color:#ebf5ff;
  border-color:rgba(235,245,255,var(--border-opacity))
}

.border-blue-100{
  --border-opacity:1;
  border-color:#e1effe;
  border-color:rgba(225,239,254,var(--border-opacity))
}

.border-blue-200{
  --border-opacity:1;
  border-color:#c3ddfd;
  border-color:rgba(195,221,253,var(--border-opacity))
}

.border-blue-300{
  --border-opacity:1;
  border-color:#a4cafe;
  border-color:rgba(164,202,254,var(--border-opacity))
}

.border-blue-400{
  --border-opacity:1;
  border-color:#76a9fa;
  border-color:rgba(118,169,250,var(--border-opacity))
}

.border-blue-500{
  --border-opacity:1;
  border-color:#3f83f8;
  border-color:rgba(63,131,248,var(--border-opacity))
}

.border-blue-600{
  --border-opacity:1;
  border-color:#1c64f2;
  border-color:rgba(28,100,242,var(--border-opacity))
}

.border-blue-700{
  --border-opacity:1;
  border-color:#1a56db;
  border-color:rgba(26,86,219,var(--border-opacity))
}

.border-blue-800{
  --border-opacity:1;
  border-color:#1e429f;
  border-color:rgba(30,66,159,var(--border-opacity))
}

.border-blue-900{
  --border-opacity:1;
  border-color:#233876;
  border-color:rgba(35,56,118,var(--border-opacity))
}

.border-indigo-50{
  --border-opacity:1;
  border-color:#f0f5ff;
  border-color:rgba(240,245,255,var(--border-opacity))
}

.border-indigo-100{
  --border-opacity:1;
  border-color:#e5edff;
  border-color:rgba(229,237,255,var(--border-opacity))
}

.border-indigo-200{
  --border-opacity:1;
  border-color:#cddbfe;
  border-color:rgba(205,219,254,var(--border-opacity))
}

.border-indigo-300{
  --border-opacity:1;
  border-color:#b4c6fc;
  border-color:rgba(180,198,252,var(--border-opacity))
}

.border-indigo-400{
  --border-opacity:1;
  border-color:#8da2fb;
  border-color:rgba(141,162,251,var(--border-opacity))
}

.border-indigo-500{
  --border-opacity:1;
  border-color:#6875f5;
  border-color:rgba(104,117,245,var(--border-opacity))
}

.border-indigo-600{
  --border-opacity:1;
  border-color:#5850ec;
  border-color:rgba(88,80,236,var(--border-opacity))
}

.border-indigo-700{
  --border-opacity:1;
  border-color:#5145cd;
  border-color:rgba(81,69,205,var(--border-opacity))
}

.border-indigo-800{
  --border-opacity:1;
  border-color:#42389d;
  border-color:rgba(66,56,157,var(--border-opacity))
}

.border-indigo-900{
  --border-opacity:1;
  border-color:#362f78;
  border-color:rgba(54,47,120,var(--border-opacity))
}

.border-indigo-50{
  --border-opacity:1;
  border-color:#f6f5ff;
  border-color:rgba(246,245,255,var(--border-opacity))
}

.border-indigo-100{
  --border-opacity:1;
  border-color:#edebfe;
  border-color:rgba(237,235,254,var(--border-opacity))
}

.border-indigo-200{
  --border-opacity:1;
  border-color:#dcd7fe;
  border-color:rgba(220,215,254,var(--border-opacity))
}

.border-indigo-300{
  --border-opacity:1;
  border-color:#cabffd;
  border-color:rgba(202,191,253,var(--border-opacity))
}

.border-indigo-400{
  --border-opacity:1;
  border-color:#ac94fa;
  border-color:rgba(172,148,250,var(--border-opacity))
}

.border-indigo-500{
  --border-opacity:1;
  border-color:#9061f9;
  border-color:rgba(144,97,249,var(--border-opacity))
}

.border-indigo-600{
  --border-opacity:1;
  border-color:#7e3af2;
  border-color:rgba(126,58,242,var(--border-opacity))
}

.border-indigo-700{
  --border-opacity:1;
  border-color:#6c2bd9;
  border-color:rgba(108,43,217,var(--border-opacity))
}

.border-indigo-800{
  --border-opacity:1;
  border-color:#5521b5;
  border-color:rgba(85,33,181,var(--border-opacity))
}

.border-indigo-900{
  --border-opacity:1;
  border-color:#4a1d96;
  border-color:rgba(74,29,150,var(--border-opacity))
}

.border-pink-50{
  --border-opacity:1;
  border-color:#fdf2f8;
  border-color:rgba(253,242,248,var(--border-opacity))
}

.border-pink-100{
  --border-opacity:1;
  border-color:#fce8f3;
  border-color:rgba(252,232,243,var(--border-opacity))
}

.border-pink-200{
  --border-opacity:1;
  border-color:#fad1e8;
  border-color:rgba(250,209,232,var(--border-opacity))
}

.border-pink-300{
  --border-opacity:1;
  border-color:#f8b4d9;
  border-color:rgba(248,180,217,var(--border-opacity))
}

.border-pink-400{
  --border-opacity:1;
  border-color:#f17eb8;
  border-color:rgba(241,126,184,var(--border-opacity))
}

.border-pink-500{
  --border-opacity:1;
  border-color:#e74694;
  border-color:rgba(231,70,148,var(--border-opacity))
}

.border-pink-600{
  --border-opacity:1;
  border-color:#d61f69;
  border-color:rgba(214,31,105,var(--border-opacity))
}

.border-pink-700{
  --border-opacity:1;
  border-color:#bf125d;
  border-color:rgba(191,18,93,var(--border-opacity))
}

.border-pink-800{
  --border-opacity:1;
  border-color:#99154b;
  border-color:rgba(153,21,75,var(--border-opacity))
}

.border-pink-900{
  --border-opacity:1;
  border-color:#751a3d;
  border-color:rgba(117,26,61,var(--border-opacity))
}

.hover\\:border-transparent:hover{
  border-color:#0000
}

.hover\\:border-white:hover{
  --border-opacity:1;
  border-color:#fff;
  border-color:rgba(255,255,255,var(--border-opacity))
}

.hover\\:border-black:hover{
  --border-opacity:1;
  border-color:#000;
  border-color:rgba(0,0,0,var(--border-opacity))
}

.hover\\:border-gray-50:hover{
  --border-opacity:1;
  border-color:#f9fafb;
  border-color:rgba(249,250,251,var(--border-opacity))
}

.hover\\:border-gray-100:hover{
  --border-opacity:1;
  border-color:#f4f5f7;
  border-color:rgba(244,245,247,var(--border-opacity))
}

.hover\\:border-gray-200:hover{
  --border-opacity:1;
  border-color:#e5e7eb;
  border-color:rgba(229,231,235,var(--border-opacity))
}

.hover\\:border-gray-300:hover{
  --border-opacity:1;
  border-color:#d5d6d7;
  border-color:rgba(213,214,215,var(--border-opacity))
}

.hover\\:border-gray-400:hover{
  --border-opacity:1;
  border-color:#9e9e9e;
  border-color:rgba(158,158,158,var(--border-opacity))
}

.hover\\:border-gray-500:hover{
  --border-opacity:1;
  border-color:#707275;
  border-color:rgba(112,114,117,var(--border-opacity))
}

.hover\\:border-gray-600:hover{
  --border-opacity:1;
  border-color:#4c4f52;
  border-color:rgba(76,79,82,var(--border-opacity))
}

.hover\\:border-gray-700:hover{
  --border-opacity:1;
  border-color:#24262d;
  border-color:rgba(36,38,45,var(--border-opacity))
}

.hover\\:border-gray-800:hover{
  --border-opacity:1;
  border-color:#1a1c23;
  border-color:rgba(26,28,35,var(--border-opacity))
}

.hover\\:border-gray-900:hover{
  --border-opacity:1;
  border-color:#121317;
  border-color:rgba(18,19,23,var(--border-opacity))
}

.hover\\:border-cool-gray-50:hover{
  --border-opacity:1;
  border-color:#fbfdfe;
  border-color:rgba(251,253,254,var(--border-opacity))
}

.hover\\:border-cool-gray-100:hover{
  --border-opacity:1;
  border-color:#f1f5f9;
  border-color:rgba(241,245,249,var(--border-opacity))
}

.hover\\:border-cool-gray-200:hover{
  --border-opacity:1;
  border-color:#e2e8f0;
  border-color:rgba(226,232,240,var(--border-opacity))
}

.hover\\:border-cool-gray-300:hover{
  --border-opacity:1;
  border-color:#cfd8e3;
  border-color:rgba(207,216,227,var(--border-opacity))
}

.hover\\:border-cool-gray-400:hover{
  --border-opacity:1;
  border-color:#97a6ba;
  border-color:rgba(151,166,186,var(--border-opacity))
}

.hover\\:border-cool-gray-500:hover{
  --border-opacity:1;
  border-color:#64748b;
  border-color:rgba(100,116,139,var(--border-opacity))
}

.hover\\:border-cool-gray-600:hover{
  --border-opacity:1;
  border-color:#475569;
  border-color:rgba(71,85,105,var(--border-opacity))
}

.hover\\:border-cool-gray-700:hover{
  --border-opacity:1;
  border-color:#364152;
  border-color:rgba(54,65,82,var(--border-opacity))
}

.hover\\:border-cool-gray-800:hover{
  --border-opacity:1;
  border-color:#27303f;
  border-color:rgba(39,48,63,var(--border-opacity))
}

.hover\\:border-cool-gray-900:hover{
  --border-opacity:1;
  border-color:#1a202e;
  border-color:rgba(26,32,46,var(--border-opacity))
}

.hover\\:border-red-50:hover{
  --border-opacity:1;
  border-color:#fdf2f2;
  border-color:rgba(253,242,242,var(--border-opacity))
}

.hover\\:border-red-100:hover{
  --border-opacity:1;
  border-color:#fde8e8;
  border-color:rgba(253,232,232,var(--border-opacity))
}

.hover\\:border-red-200:hover{
  --border-opacity:1;
  border-color:#fbd5d5;
  border-color:rgba(251,213,213,var(--border-opacity))
}

.hover\\:border-red-300:hover{
  --border-opacity:1;
  border-color:#f8b4b4;
  border-color:rgba(248,180,180,var(--border-opacity))
}

.hover\\:border-red-400:hover{
  --border-opacity:1;
  border-color:#f98080;
  border-color:rgba(249,128,128,var(--border-opacity))
}

.hover\\:border-red-500:hover{
  --border-opacity:1;
  border-color:#f05252;
  border-color:rgba(240,82,82,var(--border-opacity))
}

.hover\\:border-red-600:hover{
  --border-opacity:1;
  border-color:#e02424;
  border-color:rgba(224,36,36,var(--border-opacity))
}

.hover\\:border-red-700:hover{
  --border-opacity:1;
  border-color:#c81e1e;
  border-color:rgba(200,30,30,var(--border-opacity))
}

.hover\\:border-red-800:hover{
  --border-opacity:1;
  border-color:#9b1c1c;
  border-color:rgba(155,28,28,var(--border-opacity))
}

.hover\\:border-red-900:hover{
  --border-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--border-opacity))
}

.hover\\:border-orange-50:hover{
  --border-opacity:1;
  border-color:#fff8f1;
  border-color:rgba(255,248,241,var(--border-opacity))
}

.hover\\:border-orange-100:hover{
  --border-opacity:1;
  border-color:#feecdc;
  border-color:rgba(254,236,220,var(--border-opacity))
}

.hover\\:border-orange-200:hover{
  --border-opacity:1;
  border-color:#fcd9bd;
  border-color:rgba(252,217,189,var(--border-opacity))
}

.hover\\:border-orange-300:hover{
  --border-opacity:1;
  border-color:#fdba8c;
  border-color:rgba(253,186,140,var(--border-opacity))
}

.hover\\:border-orange-400:hover{
  --border-opacity:1;
  border-color:#ff8a4c;
  border-color:rgba(255,138,76,var(--border-opacity))
}

.hover\\:border-orange-500:hover{
  --border-opacity:1;
  border-color:#ff5a1f;
  border-color:rgba(255,90,31,var(--border-opacity))
}

.hover\\:border-orange-600:hover{
  --border-opacity:1;
  border-color:#d03801;
  border-color:rgba(208,56,1,var(--border-opacity))
}

.hover\\:border-orange-700:hover{
  --border-opacity:1;
  border-color:#b43403;
  border-color:rgba(180,52,3,var(--border-opacity))
}

.hover\\:border-orange-800:hover{
  --border-opacity:1;
  border-color:#8a2c0d;
  border-color:rgba(138,44,13,var(--border-opacity))
}

.hover\\:border-orange-900:hover{
  --border-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--border-opacity))
}

.hover\\:border-yellow-50:hover{
  --border-opacity:1;
  border-color:#fdfdea;
  border-color:rgba(253,253,234,var(--border-opacity))
}

.hover\\:border-yellow-100:hover{
  --border-opacity:1;
  border-color:#fdf6b2;
  border-color:rgba(253,246,178,var(--border-opacity))
}

.hover\\:border-yellow-200:hover{
  --border-opacity:1;
  border-color:#fce96a;
  border-color:rgba(252,233,106,var(--border-opacity))
}

.hover\\:border-yellow-300:hover{
  --border-opacity:1;
  border-color:#faca15;
  border-color:rgba(250,202,21,var(--border-opacity))
}

.hover\\:border-yellow-400:hover{
  --border-opacity:1;
  border-color:#e3a008;
  border-color:rgba(227,160,8,var(--border-opacity))
}

.hover\\:border-yellow-500:hover{
  --border-opacity:1;
  border-color:#c27803;
  border-color:rgba(194,120,3,var(--border-opacity))
}

.hover\\:border-yellow-600:hover{
  --border-opacity:1;
  border-color:#9f580a;
  border-color:rgba(159,88,10,var(--border-opacity))
}

.hover\\:border-yellow-700:hover{
  --border-opacity:1;
  border-color:#8e4b10;
  border-color:rgba(142,75,16,var(--border-opacity))
}

.hover\\:border-yellow-800:hover{
  --border-opacity:1;
  border-color:#723b13;
  border-color:rgba(114,59,19,var(--border-opacity))
}

.hover\\:border-yellow-900:hover{
  --border-opacity:1;
  border-color:#633112;
  border-color:rgba(99,49,18,var(--border-opacity))
}

.hover\\:border-green-50:hover{
  --border-opacity:1;
  border-color:#f3faf7;
  border-color:rgba(243,250,247,var(--border-opacity))
}

.hover\\:border-green-100:hover{
  --border-opacity:1;
  border-color:#def7ec;
  border-color:rgba(222,247,236,var(--border-opacity))
}

.hover\\:border-green-200:hover{
  --border-opacity:1;
  border-color:#bcf0da;
  border-color:rgba(188,240,218,var(--border-opacity))
}

.hover\\:border-green-300:hover{
  --border-opacity:1;
  border-color:#84e1bc;
  border-color:rgba(132,225,188,var(--border-opacity))
}

.hover\\:border-green-400:hover{
  --border-opacity:1;
  border-color:#31c48d;
  border-color:rgba(49,196,141,var(--border-opacity))
}

.hover\\:border-green-500:hover{
  --border-opacity:1;
  border-color:#0e9f6e;
  border-color:rgba(14,159,110,var(--border-opacity))
}

.hover\\:border-green-600:hover{
  --border-opacity:1;
  border-color:#057a55;
  border-color:rgba(5,122,85,var(--border-opacity))
}

.hover\\:border-green-700:hover{
  --border-opacity:1;
  border-color:#046c4e;
  border-color:rgba(4,108,78,var(--border-opacity))
}

.hover\\:border-green-800:hover{
  --border-opacity:1;
  border-color:#03543f;
  border-color:rgba(3,84,63,var(--border-opacity))
}

.hover\\:border-green-900:hover{
  --border-opacity:1;
  border-color:#014737;
  border-color:rgba(1,71,55,var(--border-opacity))
}

.hover\\:border-teal-50:hover{
  --border-opacity:1;
  border-color:#edfafa;
  border-color:rgba(237,250,250,var(--border-opacity))
}

.hover\\:border-teal-100:hover{
  --border-opacity:1;
  border-color:#d5f5f6;
  border-color:rgba(213,245,246,var(--border-opacity))
}

.hover\\:border-teal-200:hover{
  --border-opacity:1;
  border-color:#afecef;
  border-color:rgba(175,236,239,var(--border-opacity))
}

.hover\\:border-teal-300:hover{
  --border-opacity:1;
  border-color:#7edce2;
  border-color:rgba(126,220,226,var(--border-opacity))
}

.hover\\:border-teal-400:hover{
  --border-opacity:1;
  border-color:#16bdca;
  border-color:rgba(22,189,202,var(--border-opacity))
}

.hover\\:border-teal-500:hover{
  --border-opacity:1;
  border-color:#0694a2;
  border-color:rgba(6,148,162,var(--border-opacity))
}

.hover\\:border-teal-600:hover{
  --border-opacity:1;
  border-color:#047481;
  border-color:rgba(4,116,129,var(--border-opacity))
}

.hover\\:border-teal-700:hover{
  --border-opacity:1;
  border-color:#036672;
  border-color:rgba(3,102,114,var(--border-opacity))
}

.hover\\:border-teal-800:hover{
  --border-opacity:1;
  border-color:#05505c;
  border-color:rgba(5,80,92,var(--border-opacity))
}

.hover\\:border-teal-900:hover{
  --border-opacity:1;
  border-color:#014451;
  border-color:rgba(1,68,81,var(--border-opacity))
}

.hover\\:border-blue-50:hover{
  --border-opacity:1;
  border-color:#ebf5ff;
  border-color:rgba(235,245,255,var(--border-opacity))
}

.hover\\:border-blue-100:hover{
  --border-opacity:1;
  border-color:#e1effe;
  border-color:rgba(225,239,254,var(--border-opacity))
}

.hover\\:border-blue-200:hover{
  --border-opacity:1;
  border-color:#c3ddfd;
  border-color:rgba(195,221,253,var(--border-opacity))
}

.hover\\:border-blue-300:hover{
  --border-opacity:1;
  border-color:#a4cafe;
  border-color:rgba(164,202,254,var(--border-opacity))
}

.hover\\:border-blue-400:hover{
  --border-opacity:1;
  border-color:#76a9fa;
  border-color:rgba(118,169,250,var(--border-opacity))
}

.hover\\:border-blue-500:hover{
  --border-opacity:1;
  border-color:#3f83f8;
  border-color:rgba(63,131,248,var(--border-opacity))
}

.hover\\:border-blue-600:hover{
  --border-opacity:1;
  border-color:#1c64f2;
  border-color:rgba(28,100,242,var(--border-opacity))
}

.hover\\:border-blue-700:hover{
  --border-opacity:1;
  border-color:#1a56db;
  border-color:rgba(26,86,219,var(--border-opacity))
}

.hover\\:border-blue-800:hover{
  --border-opacity:1;
  border-color:#1e429f;
  border-color:rgba(30,66,159,var(--border-opacity))
}

.hover\\:border-blue-900:hover{
  --border-opacity:1;
  border-color:#233876;
  border-color:rgba(35,56,118,var(--border-opacity))
}

.hover\\:border-indigo-50:hover{
  --border-opacity:1;
  border-color:#f0f5ff;
  border-color:rgba(240,245,255,var(--border-opacity))
}

.hover\\:border-indigo-100:hover{
  --border-opacity:1;
  border-color:#e5edff;
  border-color:rgba(229,237,255,var(--border-opacity))
}

.hover\\:border-indigo-200:hover{
  --border-opacity:1;
  border-color:#cddbfe;
  border-color:rgba(205,219,254,var(--border-opacity))
}

.hover\\:border-indigo-300:hover{
  --border-opacity:1;
  border-color:#b4c6fc;
  border-color:rgba(180,198,252,var(--border-opacity))
}

.hover\\:border-indigo-400:hover{
  --border-opacity:1;
  border-color:#8da2fb;
  border-color:rgba(141,162,251,var(--border-opacity))
}

.hover\\:border-indigo-500:hover{
  --border-opacity:1;
  border-color:#6875f5;
  border-color:rgba(104,117,245,var(--border-opacity))
}

.hover\\:border-indigo-600:hover{
  --border-opacity:1;
  border-color:#5850ec;
  border-color:rgba(88,80,236,var(--border-opacity))
}

.hover\\:border-indigo-700:hover{
  --border-opacity:1;
  border-color:#5145cd;
  border-color:rgba(81,69,205,var(--border-opacity))
}

.hover\\:border-indigo-800:hover{
  --border-opacity:1;
  border-color:#42389d;
  border-color:rgba(66,56,157,var(--border-opacity))
}

.hover\\:border-indigo-900:hover{
  --border-opacity:1;
  border-color:#362f78;
  border-color:rgba(54,47,120,var(--border-opacity))
}

.hover\\:border-indigo-50:hover{
  --border-opacity:1;
  border-color:#f6f5ff;
  border-color:rgba(246,245,255,var(--border-opacity))
}

.hover\\:border-indigo-100:hover{
  --border-opacity:1;
  border-color:#edebfe;
  border-color:rgba(237,235,254,var(--border-opacity))
}

.hover\\:border-indigo-200:hover{
  --border-opacity:1;
  border-color:#dcd7fe;
  border-color:rgba(220,215,254,var(--border-opacity))
}

.hover\\:border-indigo-300:hover{
  --border-opacity:1;
  border-color:#cabffd;
  border-color:rgba(202,191,253,var(--border-opacity))
}

.hover\\:border-indigo-400:hover{
  --border-opacity:1;
  border-color:#ac94fa;
  border-color:rgba(172,148,250,var(--border-opacity))
}

.hover\\:border-indigo-500:hover{
  --border-opacity:1;
  border-color:#9061f9;
  border-color:rgba(144,97,249,var(--border-opacity))
}

.hover\\:border-indigo-600:hover{
  --border-opacity:1;
  border-color:#7e3af2;
  border-color:rgba(126,58,242,var(--border-opacity))
}

.hover\\:border-indigo-700:hover{
  --border-opacity:1;
  border-color:#6c2bd9;
  border-color:rgba(108,43,217,var(--border-opacity))
}

.hover\\:border-indigo-800:hover{
  --border-opacity:1;
  border-color:#5521b5;
  border-color:rgba(85,33,181,var(--border-opacity))
}

.hover\\:border-indigo-900:hover{
  --border-opacity:1;
  border-color:#4a1d96;
  border-color:rgba(74,29,150,var(--border-opacity))
}

.hover\\:border-pink-50:hover{
  --border-opacity:1;
  border-color:#fdf2f8;
  border-color:rgba(253,242,248,var(--border-opacity))
}

.hover\\:border-pink-100:hover{
  --border-opacity:1;
  border-color:#fce8f3;
  border-color:rgba(252,232,243,var(--border-opacity))
}

.hover\\:border-pink-200:hover{
  --border-opacity:1;
  border-color:#fad1e8;
  border-color:rgba(250,209,232,var(--border-opacity))
}

.hover\\:border-pink-300:hover{
  --border-opacity:1;
  border-color:#f8b4d9;
  border-color:rgba(248,180,217,var(--border-opacity))
}

.hover\\:border-pink-400:hover{
  --border-opacity:1;
  border-color:#f17eb8;
  border-color:rgba(241,126,184,var(--border-opacity))
}

.hover\\:border-pink-500:hover{
  --border-opacity:1;
  border-color:#e74694;
  border-color:rgba(231,70,148,var(--border-opacity))
}

.hover\\:border-pink-600:hover{
  --border-opacity:1;
  border-color:#d61f69;
  border-color:rgba(214,31,105,var(--border-opacity))
}

.hover\\:border-pink-700:hover{
  --border-opacity:1;
  border-color:#bf125d;
  border-color:rgba(191,18,93,var(--border-opacity))
}

.hover\\:border-pink-800:hover{
  --border-opacity:1;
  border-color:#99154b;
  border-color:rgba(153,21,75,var(--border-opacity))
}

.hover\\:border-pink-900:hover{
  --border-opacity:1;
  border-color:#751a3d;
  border-color:rgba(117,26,61,var(--border-opacity))
}

.focus\\:border-transparent:focus{
  border-color:#0000
}

.focus\\:border-white:focus{
  --border-opacity:1;
  border-color:#fff;
  border-color:rgba(255,255,255,var(--border-opacity))
}

.focus\\:border-black:focus{
  --border-opacity:1;
  border-color:#000;
  border-color:rgba(0,0,0,var(--border-opacity))
}

.focus\\:border-gray-50:focus{
  --border-opacity:1;
  border-color:#f9fafb;
  border-color:rgba(249,250,251,var(--border-opacity))
}

.focus\\:border-gray-100:focus{
  --border-opacity:1;
  border-color:#f4f5f7;
  border-color:rgba(244,245,247,var(--border-opacity))
}

.focus\\:border-gray-200:focus{
  --border-opacity:1;
  border-color:#e5e7eb;
  border-color:rgba(229,231,235,var(--border-opacity))
}

.focus\\:border-gray-300:focus{
  --border-opacity:1;
  border-color:#d5d6d7;
  border-color:rgba(213,214,215,var(--border-opacity))
}

.focus\\:border-gray-400:focus{
  --border-opacity:1;
  border-color:#9e9e9e;
  border-color:rgba(158,158,158,var(--border-opacity))
}

.focus\\:border-gray-500:focus{
  --border-opacity:1;
  border-color:#707275;
  border-color:rgba(112,114,117,var(--border-opacity))
}

.focus\\:border-gray-600:focus{
  --border-opacity:1;
  border-color:#4c4f52;
  border-color:rgba(76,79,82,var(--border-opacity))
}

.focus\\:border-gray-700:focus{
  --border-opacity:1;
  border-color:#24262d;
  border-color:rgba(36,38,45,var(--border-opacity))
}

.focus\\:border-gray-800:focus{
  --border-opacity:1;
  border-color:#1a1c23;
  border-color:rgba(26,28,35,var(--border-opacity))
}

.focus\\:border-gray-900:focus{
  --border-opacity:1;
  border-color:#121317;
  border-color:rgba(18,19,23,var(--border-opacity))
}

.focus\\:border-cool-gray-50:focus{
  --border-opacity:1;
  border-color:#fbfdfe;
  border-color:rgba(251,253,254,var(--border-opacity))
}

.focus\\:border-cool-gray-100:focus{
  --border-opacity:1;
  border-color:#f1f5f9;
  border-color:rgba(241,245,249,var(--border-opacity))
}

.focus\\:border-cool-gray-200:focus{
  --border-opacity:1;
  border-color:#e2e8f0;
  border-color:rgba(226,232,240,var(--border-opacity))
}

.focus\\:border-cool-gray-300:focus{
  --border-opacity:1;
  border-color:#cfd8e3;
  border-color:rgba(207,216,227,var(--border-opacity))
}

.focus\\:border-cool-gray-400:focus{
  --border-opacity:1;
  border-color:#97a6ba;
  border-color:rgba(151,166,186,var(--border-opacity))
}

.focus\\:border-cool-gray-500:focus{
  --border-opacity:1;
  border-color:#64748b;
  border-color:rgba(100,116,139,var(--border-opacity))
}

.focus\\:border-cool-gray-600:focus{
  --border-opacity:1;
  border-color:#475569;
  border-color:rgba(71,85,105,var(--border-opacity))
}

.focus\\:border-cool-gray-700:focus{
  --border-opacity:1;
  border-color:#364152;
  border-color:rgba(54,65,82,var(--border-opacity))
}

.focus\\:border-cool-gray-800:focus{
  --border-opacity:1;
  border-color:#27303f;
  border-color:rgba(39,48,63,var(--border-opacity))
}

.focus\\:border-cool-gray-900:focus{
  --border-opacity:1;
  border-color:#1a202e;
  border-color:rgba(26,32,46,var(--border-opacity))
}

.focus\\:border-red-50:focus{
  --border-opacity:1;
  border-color:#fdf2f2;
  border-color:rgba(253,242,242,var(--border-opacity))
}

.focus\\:border-red-100:focus{
  --border-opacity:1;
  border-color:#fde8e8;
  border-color:rgba(253,232,232,var(--border-opacity))
}

.focus\\:border-red-200:focus{
  --border-opacity:1;
  border-color:#fbd5d5;
  border-color:rgba(251,213,213,var(--border-opacity))
}

.focus\\:border-red-300:focus{
  --border-opacity:1;
  border-color:#f8b4b4;
  border-color:rgba(248,180,180,var(--border-opacity))
}

.focus\\:border-red-400:focus{
  --border-opacity:1;
  border-color:#f98080;
  border-color:rgba(249,128,128,var(--border-opacity))
}

.focus\\:border-red-500:focus{
  --border-opacity:1;
  border-color:#f05252;
  border-color:rgba(240,82,82,var(--border-opacity))
}

.focus\\:border-red-600:focus{
  --border-opacity:1;
  border-color:#e02424;
  border-color:rgba(224,36,36,var(--border-opacity))
}

.focus\\:border-red-700:focus{
  --border-opacity:1;
  border-color:#c81e1e;
  border-color:rgba(200,30,30,var(--border-opacity))
}

.focus\\:border-red-800:focus{
  --border-opacity:1;
  border-color:#9b1c1c;
  border-color:rgba(155,28,28,var(--border-opacity))
}

.focus\\:border-red-900:focus{
  --border-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--border-opacity))
}

.focus\\:border-orange-50:focus{
  --border-opacity:1;
  border-color:#fff8f1;
  border-color:rgba(255,248,241,var(--border-opacity))
}

.focus\\:border-orange-100:focus{
  --border-opacity:1;
  border-color:#feecdc;
  border-color:rgba(254,236,220,var(--border-opacity))
}

.focus\\:border-orange-200:focus{
  --border-opacity:1;
  border-color:#fcd9bd;
  border-color:rgba(252,217,189,var(--border-opacity))
}

.focus\\:border-orange-300:focus{
  --border-opacity:1;
  border-color:#fdba8c;
  border-color:rgba(253,186,140,var(--border-opacity))
}

.focus\\:border-orange-400:focus{
  --border-opacity:1;
  border-color:#ff8a4c;
  border-color:rgba(255,138,76,var(--border-opacity))
}

.focus\\:border-orange-500:focus{
  --border-opacity:1;
  border-color:#ff5a1f;
  border-color:rgba(255,90,31,var(--border-opacity))
}

.focus\\:border-orange-600:focus{
  --border-opacity:1;
  border-color:#d03801;
  border-color:rgba(208,56,1,var(--border-opacity))
}

.focus\\:border-orange-700:focus{
  --border-opacity:1;
  border-color:#b43403;
  border-color:rgba(180,52,3,var(--border-opacity))
}

.focus\\:border-orange-800:focus{
  --border-opacity:1;
  border-color:#8a2c0d;
  border-color:rgba(138,44,13,var(--border-opacity))
}

.focus\\:border-orange-900:focus{
  --border-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--border-opacity))
}

.focus\\:border-yellow-50:focus{
  --border-opacity:1;
  border-color:#fdfdea;
  border-color:rgba(253,253,234,var(--border-opacity))
}

.focus\\:border-yellow-100:focus{
  --border-opacity:1;
  border-color:#fdf6b2;
  border-color:rgba(253,246,178,var(--border-opacity))
}

.focus\\:border-yellow-200:focus{
  --border-opacity:1;
  border-color:#fce96a;
  border-color:rgba(252,233,106,var(--border-opacity))
}

.focus\\:border-yellow-300:focus{
  --border-opacity:1;
  border-color:#faca15;
  border-color:rgba(250,202,21,var(--border-opacity))
}

.focus\\:border-yellow-400:focus{
  --border-opacity:1;
  border-color:#e3a008;
  border-color:rgba(227,160,8,var(--border-opacity))
}

.focus\\:border-yellow-500:focus{
  --border-opacity:1;
  border-color:#c27803;
  border-color:rgba(194,120,3,var(--border-opacity))
}

.focus\\:border-yellow-600:focus{
  --border-opacity:1;
  border-color:#9f580a;
  border-color:rgba(159,88,10,var(--border-opacity))
}

.focus\\:border-yellow-700:focus{
  --border-opacity:1;
  border-color:#8e4b10;
  border-color:rgba(142,75,16,var(--border-opacity))
}

.focus\\:border-yellow-800:focus{
  --border-opacity:1;
  border-color:#723b13;
  border-color:rgba(114,59,19,var(--border-opacity))
}

.focus\\:border-yellow-900:focus{
  --border-opacity:1;
  border-color:#633112;
  border-color:rgba(99,49,18,var(--border-opacity))
}

.focus\\:border-green-50:focus{
  --border-opacity:1;
  border-color:#f3faf7;
  border-color:rgba(243,250,247,var(--border-opacity))
}

.focus\\:border-green-100:focus{
  --border-opacity:1;
  border-color:#def7ec;
  border-color:rgba(222,247,236,var(--border-opacity))
}

.focus\\:border-green-200:focus{
  --border-opacity:1;
  border-color:#bcf0da;
  border-color:rgba(188,240,218,var(--border-opacity))
}

.focus\\:border-green-300:focus{
  --border-opacity:1;
  border-color:#84e1bc;
  border-color:rgba(132,225,188,var(--border-opacity))
}

.focus\\:border-green-400:focus{
  --border-opacity:1;
  border-color:#31c48d;
  border-color:rgba(49,196,141,var(--border-opacity))
}

.focus\\:border-green-500:focus{
  --border-opacity:1;
  border-color:#0e9f6e;
  border-color:rgba(14,159,110,var(--border-opacity))
}

.focus\\:border-green-600:focus{
  --border-opacity:1;
  border-color:#057a55;
  border-color:rgba(5,122,85,var(--border-opacity))
}

.focus\\:border-green-700:focus{
  --border-opacity:1;
  border-color:#046c4e;
  border-color:rgba(4,108,78,var(--border-opacity))
}

.focus\\:border-green-800:focus{
  --border-opacity:1;
  border-color:#03543f;
  border-color:rgba(3,84,63,var(--border-opacity))
}

.focus\\:border-green-900:focus{
  --border-opacity:1;
  border-color:#014737;
  border-color:rgba(1,71,55,var(--border-opacity))
}

.focus\\:border-teal-50:focus{
  --border-opacity:1;
  border-color:#edfafa;
  border-color:rgba(237,250,250,var(--border-opacity))
}

.focus\\:border-teal-100:focus{
  --border-opacity:1;
  border-color:#d5f5f6;
  border-color:rgba(213,245,246,var(--border-opacity))
}

.focus\\:border-teal-200:focus{
  --border-opacity:1;
  border-color:#afecef;
  border-color:rgba(175,236,239,var(--border-opacity))
}

.focus\\:border-teal-300:focus{
  --border-opacity:1;
  border-color:#7edce2;
  border-color:rgba(126,220,226,var(--border-opacity))
}

.focus\\:border-teal-400:focus{
  --border-opacity:1;
  border-color:#16bdca;
  border-color:rgba(22,189,202,var(--border-opacity))
}

.focus\\:border-teal-500:focus{
  --border-opacity:1;
  border-color:#0694a2;
  border-color:rgba(6,148,162,var(--border-opacity))
}

.focus\\:border-teal-600:focus{
  --border-opacity:1;
  border-color:#047481;
  border-color:rgba(4,116,129,var(--border-opacity))
}

.focus\\:border-teal-700:focus{
  --border-opacity:1;
  border-color:#036672;
  border-color:rgba(3,102,114,var(--border-opacity))
}

.focus\\:border-teal-800:focus{
  --border-opacity:1;
  border-color:#05505c;
  border-color:rgba(5,80,92,var(--border-opacity))
}

.focus\\:border-teal-900:focus{
  --border-opacity:1;
  border-color:#014451;
  border-color:rgba(1,68,81,var(--border-opacity))
}

.focus\\:border-blue-50:focus{
  --border-opacity:1;
  border-color:#ebf5ff;
  border-color:rgba(235,245,255,var(--border-opacity))
}

.focus\\:border-blue-100:focus{
  --border-opacity:1;
  border-color:#e1effe;
  border-color:rgba(225,239,254,var(--border-opacity))
}

.focus\\:border-blue-200:focus{
  --border-opacity:1;
  border-color:#c3ddfd;
  border-color:rgba(195,221,253,var(--border-opacity))
}

.focus\\:border-blue-300:focus{
  --border-opacity:1;
  border-color:#a4cafe;
  border-color:rgba(164,202,254,var(--border-opacity))
}

.focus\\:border-blue-400:focus{
  --border-opacity:1;
  border-color:#76a9fa;
  border-color:rgba(118,169,250,var(--border-opacity))
}

.focus\\:border-blue-500:focus{
  --border-opacity:1;
  border-color:#3f83f8;
  border-color:rgba(63,131,248,var(--border-opacity))
}

.focus\\:border-blue-600:focus{
  --border-opacity:1;
  border-color:#1c64f2;
  border-color:rgba(28,100,242,var(--border-opacity))
}

.focus\\:border-blue-700:focus{
  --border-opacity:1;
  border-color:#1a56db;
  border-color:rgba(26,86,219,var(--border-opacity))
}

.focus\\:border-blue-800:focus{
  --border-opacity:1;
  border-color:#1e429f;
  border-color:rgba(30,66,159,var(--border-opacity))
}

.focus\\:border-blue-900:focus{
  --border-opacity:1;
  border-color:#233876;
  border-color:rgba(35,56,118,var(--border-opacity))
}

.focus\\:border-indigo-50:focus{
  --border-opacity:1;
  border-color:#f0f5ff;
  border-color:rgba(240,245,255,var(--border-opacity))
}

.focus\\:border-indigo-100:focus{
  --border-opacity:1;
  border-color:#e5edff;
  border-color:rgba(229,237,255,var(--border-opacity))
}

.focus\\:border-indigo-200:focus{
  --border-opacity:1;
  border-color:#cddbfe;
  border-color:rgba(205,219,254,var(--border-opacity))
}

.focus\\:border-indigo-300:focus{
  --border-opacity:1;
  border-color:#b4c6fc;
  border-color:rgba(180,198,252,var(--border-opacity))
}

.focus\\:border-indigo-400:focus{
  --border-opacity:1;
  border-color:#8da2fb;
  border-color:rgba(141,162,251,var(--border-opacity))
}

.focus\\:border-indigo-500:focus{
  --border-opacity:1;
  border-color:#6875f5;
  border-color:rgba(104,117,245,var(--border-opacity))
}

.focus\\:border-indigo-600:focus{
  --border-opacity:1;
  border-color:#5850ec;
  border-color:rgba(88,80,236,var(--border-opacity))
}

.focus\\:border-indigo-700:focus{
  --border-opacity:1;
  border-color:#5145cd;
  border-color:rgba(81,69,205,var(--border-opacity))
}

.focus\\:border-indigo-800:focus{
  --border-opacity:1;
  border-color:#42389d;
  border-color:rgba(66,56,157,var(--border-opacity))
}

.focus\\:border-indigo-900:focus{
  --border-opacity:1;
  border-color:#362f78;
  border-color:rgba(54,47,120,var(--border-opacity))
}

.focus\\:border-indigo-50:focus{
  --border-opacity:1;
  border-color:#f6f5ff;
  border-color:rgba(246,245,255,var(--border-opacity))
}

.focus\\:border-indigo-100:focus{
  --border-opacity:1;
  border-color:#edebfe;
  border-color:rgba(237,235,254,var(--border-opacity))
}

.focus\\:border-indigo-200:focus{
  --border-opacity:1;
  border-color:#dcd7fe;
  border-color:rgba(220,215,254,var(--border-opacity))
}

.focus\\:border-indigo-300:focus{
  --border-opacity:1;
  border-color:#cabffd;
  border-color:rgba(202,191,253,var(--border-opacity))
}

.focus\\:border-indigo-400:focus{
  --border-opacity:1;
  border-color:#ac94fa;
  border-color:rgba(172,148,250,var(--border-opacity))
}

.focus\\:border-indigo-500:focus{
  --border-opacity:1;
  border-color:#9061f9;
  border-color:rgba(144,97,249,var(--border-opacity))
}

.focus\\:border-indigo-600:focus{
  --border-opacity:1;
  border-color:#7e3af2;
  border-color:rgba(126,58,242,var(--border-opacity))
}

.focus\\:border-indigo-700:focus{
  --border-opacity:1;
  border-color:#6c2bd9;
  border-color:rgba(108,43,217,var(--border-opacity))
}

.focus\\:border-indigo-800:focus{
  --border-opacity:1;
  border-color:#5521b5;
  border-color:rgba(85,33,181,var(--border-opacity))
}

.focus\\:border-indigo-900:focus{
  --border-opacity:1;
  border-color:#4a1d96;
  border-color:rgba(74,29,150,var(--border-opacity))
}

.focus\\:border-pink-50:focus{
  --border-opacity:1;
  border-color:#fdf2f8;
  border-color:rgba(253,242,248,var(--border-opacity))
}

.focus\\:border-pink-100:focus{
  --border-opacity:1;
  border-color:#fce8f3;
  border-color:rgba(252,232,243,var(--border-opacity))
}

.focus\\:border-pink-200:focus{
  --border-opacity:1;
  border-color:#fad1e8;
  border-color:rgba(250,209,232,var(--border-opacity))
}

.focus\\:border-pink-300:focus{
  --border-opacity:1;
  border-color:#f8b4d9;
  border-color:rgba(248,180,217,var(--border-opacity))
}

.focus\\:border-pink-400:focus{
  --border-opacity:1;
  border-color:#f17eb8;
  border-color:rgba(241,126,184,var(--border-opacity))
}

.focus\\:border-pink-500:focus{
  --border-opacity:1;
  border-color:#e74694;
  border-color:rgba(231,70,148,var(--border-opacity))
}

.focus\\:border-pink-600:focus{
  --border-opacity:1;
  border-color:#d61f69;
  border-color:rgba(214,31,105,var(--border-opacity))
}

.focus\\:border-pink-700:focus{
  --border-opacity:1;
  border-color:#bf125d;
  border-color:rgba(191,18,93,var(--border-opacity))
}

.focus\\:border-pink-800:focus{
  --border-opacity:1;
  border-color:#99154b;
  border-color:rgba(153,21,75,var(--border-opacity))
}

.focus\\:border-pink-900:focus{
  --border-opacity:1;
  border-color:#751a3d;
  border-color:rgba(117,26,61,var(--border-opacity))
}

.theme-dark .dark\\:border-transparent{
  border-color:#0000
}

.theme-dark .dark\\:border-white{
  --border-opacity:1;
  border-color:#fff;
  border-color:rgba(255,255,255,var(--border-opacity))
}

.theme-dark .dark\\:border-black{
  --border-opacity:1;
  border-color:#000;
  border-color:rgba(0,0,0,var(--border-opacity))
}

.theme-dark .dark\\:border-gray-50{
  --border-opacity:1;
  border-color:#f9fafb;
  border-color:rgba(249,250,251,var(--border-opacity))
}

.theme-dark .dark\\:border-gray-100{
  --border-opacity:1;
  border-color:#f4f5f7;
  border-color:rgba(244,245,247,var(--border-opacity))
}

.theme-dark .dark\\:border-gray-200{
  --border-opacity:1;
  border-color:#e5e7eb;
  border-color:rgba(229,231,235,var(--border-opacity))
}

.theme-dark .dark\\:border-gray-300{
  --border-opacity:1;
  border-color:#d5d6d7;
  border-color:rgba(213,214,215,var(--border-opacity))
}

.theme-dark .dark\\:border-gray-400{
  --border-opacity:1;
  border-color:#9e9e9e;
  border-color:rgba(158,158,158,var(--border-opacity))
}

.theme-dark .dark\\:border-gray-500{
  --border-opacity:1;
  border-color:#707275;
  border-color:rgba(112,114,117,var(--border-opacity))
}

.theme-dark .dark\\:border-gray-600{
  --border-opacity:1;
  border-color:#4c4f52;
  border-color:rgba(76,79,82,var(--border-opacity))
}

.theme-dark .dark\\:border-gray-700{
  --border-opacity:1;
  border-color:#24262d;
  border-color:rgba(36,38,45,var(--border-opacity))
}

.theme-dark .dark\\:border-gray-800{
  --border-opacity:1;
  border-color:#1a1c23;
  border-color:rgba(26,28,35,var(--border-opacity))
}

.theme-dark .dark\\:border-gray-900{
  --border-opacity:1;
  border-color:#121317;
  border-color:rgba(18,19,23,var(--border-opacity))
}

.theme-dark .dark\\:border-cool-gray-50{
  --border-opacity:1;
  border-color:#fbfdfe;
  border-color:rgba(251,253,254,var(--border-opacity))
}

.theme-dark .dark\\:border-cool-gray-100{
  --border-opacity:1;
  border-color:#f1f5f9;
  border-color:rgba(241,245,249,var(--border-opacity))
}

.theme-dark .dark\\:border-cool-gray-200{
  --border-opacity:1;
  border-color:#e2e8f0;
  border-color:rgba(226,232,240,var(--border-opacity))
}

.theme-dark .dark\\:border-cool-gray-300{
  --border-opacity:1;
  border-color:#cfd8e3;
  border-color:rgba(207,216,227,var(--border-opacity))
}

.theme-dark .dark\\:border-cool-gray-400{
  --border-opacity:1;
  border-color:#97a6ba;
  border-color:rgba(151,166,186,var(--border-opacity))
}

.theme-dark .dark\\:border-cool-gray-500{
  --border-opacity:1;
  border-color:#64748b;
  border-color:rgba(100,116,139,var(--border-opacity))
}

.theme-dark .dark\\:border-cool-gray-600{
  --border-opacity:1;
  border-color:#475569;
  border-color:rgba(71,85,105,var(--border-opacity))
}

.theme-dark .dark\\:border-cool-gray-700{
  --border-opacity:1;
  border-color:#364152;
  border-color:rgba(54,65,82,var(--border-opacity))
}

.theme-dark .dark\\:border-cool-gray-800{
  --border-opacity:1;
  border-color:#27303f;
  border-color:rgba(39,48,63,var(--border-opacity))
}

.theme-dark .dark\\:border-cool-gray-900{
  --border-opacity:1;
  border-color:#1a202e;
  border-color:rgba(26,32,46,var(--border-opacity))
}

.theme-dark .dark\\:border-red-50{
  --border-opacity:1;
  border-color:#fdf2f2;
  border-color:rgba(253,242,242,var(--border-opacity))
}

.theme-dark .dark\\:border-red-100{
  --border-opacity:1;
  border-color:#fde8e8;
  border-color:rgba(253,232,232,var(--border-opacity))
}

.theme-dark .dark\\:border-red-200{
  --border-opacity:1;
  border-color:#fbd5d5;
  border-color:rgba(251,213,213,var(--border-opacity))
}

.theme-dark .dark\\:border-red-300{
  --border-opacity:1;
  border-color:#f8b4b4;
  border-color:rgba(248,180,180,var(--border-opacity))
}

.theme-dark .dark\\:border-red-400{
  --border-opacity:1;
  border-color:#f98080;
  border-color:rgba(249,128,128,var(--border-opacity))
}

.theme-dark .dark\\:border-red-500{
  --border-opacity:1;
  border-color:#f05252;
  border-color:rgba(240,82,82,var(--border-opacity))
}

.theme-dark .dark\\:border-red-600{
  --border-opacity:1;
  border-color:#e02424;
  border-color:rgba(224,36,36,var(--border-opacity))
}

.theme-dark .dark\\:border-red-700{
  --border-opacity:1;
  border-color:#c81e1e;
  border-color:rgba(200,30,30,var(--border-opacity))
}

.theme-dark .dark\\:border-red-800{
  --border-opacity:1;
  border-color:#9b1c1c;
  border-color:rgba(155,28,28,var(--border-opacity))
}

.theme-dark .dark\\:border-red-900{
  --border-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--border-opacity))
}

.theme-dark .dark\\:border-orange-50{
  --border-opacity:1;
  border-color:#fff8f1;
  border-color:rgba(255,248,241,var(--border-opacity))
}

.theme-dark .dark\\:border-orange-100{
  --border-opacity:1;
  border-color:#feecdc;
  border-color:rgba(254,236,220,var(--border-opacity))
}

.theme-dark .dark\\:border-orange-200{
  --border-opacity:1;
  border-color:#fcd9bd;
  border-color:rgba(252,217,189,var(--border-opacity))
}

.theme-dark .dark\\:border-orange-300{
  --border-opacity:1;
  border-color:#fdba8c;
  border-color:rgba(253,186,140,var(--border-opacity))
}

.theme-dark .dark\\:border-orange-400{
  --border-opacity:1;
  border-color:#ff8a4c;
  border-color:rgba(255,138,76,var(--border-opacity))
}

.theme-dark .dark\\:border-orange-500{
  --border-opacity:1;
  border-color:#ff5a1f;
  border-color:rgba(255,90,31,var(--border-opacity))
}

.theme-dark .dark\\:border-orange-600{
  --border-opacity:1;
  border-color:#d03801;
  border-color:rgba(208,56,1,var(--border-opacity))
}

.theme-dark .dark\\:border-orange-700{
  --border-opacity:1;
  border-color:#b43403;
  border-color:rgba(180,52,3,var(--border-opacity))
}

.theme-dark .dark\\:border-orange-800{
  --border-opacity:1;
  border-color:#8a2c0d;
  border-color:rgba(138,44,13,var(--border-opacity))
}

.theme-dark .dark\\:border-orange-900{
  --border-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--border-opacity))
}

.theme-dark .dark\\:border-yellow-50{
  --border-opacity:1;
  border-color:#fdfdea;
  border-color:rgba(253,253,234,var(--border-opacity))
}

.theme-dark .dark\\:border-yellow-100{
  --border-opacity:1;
  border-color:#fdf6b2;
  border-color:rgba(253,246,178,var(--border-opacity))
}

.theme-dark .dark\\:border-yellow-200{
  --border-opacity:1;
  border-color:#fce96a;
  border-color:rgba(252,233,106,var(--border-opacity))
}

.theme-dark .dark\\:border-yellow-300{
  --border-opacity:1;
  border-color:#faca15;
  border-color:rgba(250,202,21,var(--border-opacity))
}

.theme-dark .dark\\:border-yellow-400{
  --border-opacity:1;
  border-color:#e3a008;
  border-color:rgba(227,160,8,var(--border-opacity))
}

.theme-dark .dark\\:border-yellow-500{
  --border-opacity:1;
  border-color:#c27803;
  border-color:rgba(194,120,3,var(--border-opacity))
}

.theme-dark .dark\\:border-yellow-600{
  --border-opacity:1;
  border-color:#9f580a;
  border-color:rgba(159,88,10,var(--border-opacity))
}

.theme-dark .dark\\:border-yellow-700{
  --border-opacity:1;
  border-color:#8e4b10;
  border-color:rgba(142,75,16,var(--border-opacity))
}

.theme-dark .dark\\:border-yellow-800{
  --border-opacity:1;
  border-color:#723b13;
  border-color:rgba(114,59,19,var(--border-opacity))
}

.theme-dark .dark\\:border-yellow-900{
  --border-opacity:1;
  border-color:#633112;
  border-color:rgba(99,49,18,var(--border-opacity))
}

.theme-dark .dark\\:border-green-50{
  --border-opacity:1;
  border-color:#f3faf7;
  border-color:rgba(243,250,247,var(--border-opacity))
}

.theme-dark .dark\\:border-green-100{
  --border-opacity:1;
  border-color:#def7ec;
  border-color:rgba(222,247,236,var(--border-opacity))
}

.theme-dark .dark\\:border-green-200{
  --border-opacity:1;
  border-color:#bcf0da;
  border-color:rgba(188,240,218,var(--border-opacity))
}

.theme-dark .dark\\:border-green-300{
  --border-opacity:1;
  border-color:#84e1bc;
  border-color:rgba(132,225,188,var(--border-opacity))
}

.theme-dark .dark\\:border-green-400{
  --border-opacity:1;
  border-color:#31c48d;
  border-color:rgba(49,196,141,var(--border-opacity))
}

.theme-dark .dark\\:border-green-500{
  --border-opacity:1;
  border-color:#0e9f6e;
  border-color:rgba(14,159,110,var(--border-opacity))
}

.theme-dark .dark\\:border-green-600{
  --border-opacity:1;
  border-color:#057a55;
  border-color:rgba(5,122,85,var(--border-opacity))
}

.theme-dark .dark\\:border-green-700{
  --border-opacity:1;
  border-color:#046c4e;
  border-color:rgba(4,108,78,var(--border-opacity))
}

.theme-dark .dark\\:border-green-800{
  --border-opacity:1;
  border-color:#03543f;
  border-color:rgba(3,84,63,var(--border-opacity))
}

.theme-dark .dark\\:border-green-900{
  --border-opacity:1;
  border-color:#014737;
  border-color:rgba(1,71,55,var(--border-opacity))
}

.theme-dark .dark\\:border-teal-50{
  --border-opacity:1;
  border-color:#edfafa;
  border-color:rgba(237,250,250,var(--border-opacity))
}

.theme-dark .dark\\:border-teal-100{
  --border-opacity:1;
  border-color:#d5f5f6;
  border-color:rgba(213,245,246,var(--border-opacity))
}

.theme-dark .dark\\:border-teal-200{
  --border-opacity:1;
  border-color:#afecef;
  border-color:rgba(175,236,239,var(--border-opacity))
}

.theme-dark .dark\\:border-teal-300{
  --border-opacity:1;
  border-color:#7edce2;
  border-color:rgba(126,220,226,var(--border-opacity))
}

.theme-dark .dark\\:border-teal-400{
  --border-opacity:1;
  border-color:#16bdca;
  border-color:rgba(22,189,202,var(--border-opacity))
}

.theme-dark .dark\\:border-teal-500{
  --border-opacity:1;
  border-color:#0694a2;
  border-color:rgba(6,148,162,var(--border-opacity))
}

.theme-dark .dark\\:border-teal-600{
  --border-opacity:1;
  border-color:#047481;
  border-color:rgba(4,116,129,var(--border-opacity))
}

.theme-dark .dark\\:border-teal-700{
  --border-opacity:1;
  border-color:#036672;
  border-color:rgba(3,102,114,var(--border-opacity))
}

.theme-dark .dark\\:border-teal-800{
  --border-opacity:1;
  border-color:#05505c;
  border-color:rgba(5,80,92,var(--border-opacity))
}

.theme-dark .dark\\:border-teal-900{
  --border-opacity:1;
  border-color:#014451;
  border-color:rgba(1,68,81,var(--border-opacity))
}

.theme-dark .dark\\:border-blue-50{
  --border-opacity:1;
  border-color:#ebf5ff;
  border-color:rgba(235,245,255,var(--border-opacity))
}

.theme-dark .dark\\:border-blue-100{
  --border-opacity:1;
  border-color:#e1effe;
  border-color:rgba(225,239,254,var(--border-opacity))
}

.theme-dark .dark\\:border-blue-200{
  --border-opacity:1;
  border-color:#c3ddfd;
  border-color:rgba(195,221,253,var(--border-opacity))
}

.theme-dark .dark\\:border-blue-300{
  --border-opacity:1;
  border-color:#a4cafe;
  border-color:rgba(164,202,254,var(--border-opacity))
}

.theme-dark .dark\\:border-blue-400{
  --border-opacity:1;
  border-color:#76a9fa;
  border-color:rgba(118,169,250,var(--border-opacity))
}

.theme-dark .dark\\:border-blue-500{
  --border-opacity:1;
  border-color:#3f83f8;
  border-color:rgba(63,131,248,var(--border-opacity))
}

.theme-dark .dark\\:border-blue-600{
  --border-opacity:1;
  border-color:#1c64f2;
  border-color:rgba(28,100,242,var(--border-opacity))
}

.theme-dark .dark\\:border-blue-700{
  --border-opacity:1;
  border-color:#1a56db;
  border-color:rgba(26,86,219,var(--border-opacity))
}

.theme-dark .dark\\:border-blue-800{
  --border-opacity:1;
  border-color:#1e429f;
  border-color:rgba(30,66,159,var(--border-opacity))
}

.theme-dark .dark\\:border-blue-900{
  --border-opacity:1;
  border-color:#233876;
  border-color:rgba(35,56,118,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-50{
  --border-opacity:1;
  border-color:#f0f5ff;
  border-color:rgba(240,245,255,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-100{
  --border-opacity:1;
  border-color:#e5edff;
  border-color:rgba(229,237,255,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-200{
  --border-opacity:1;
  border-color:#cddbfe;
  border-color:rgba(205,219,254,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-300{
  --border-opacity:1;
  border-color:#b4c6fc;
  border-color:rgba(180,198,252,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-400{
  --border-opacity:1;
  border-color:#8da2fb;
  border-color:rgba(141,162,251,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-500{
  --border-opacity:1;
  border-color:#6875f5;
  border-color:rgba(104,117,245,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-600{
  --border-opacity:1;
  border-color:#5850ec;
  border-color:rgba(88,80,236,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-700{
  --border-opacity:1;
  border-color:#5145cd;
  border-color:rgba(81,69,205,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-800{
  --border-opacity:1;
  border-color:#42389d;
  border-color:rgba(66,56,157,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-900{
  --border-opacity:1;
  border-color:#362f78;
  border-color:rgba(54,47,120,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-50{
  --border-opacity:1;
  border-color:#f6f5ff;
  border-color:rgba(246,245,255,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-100{
  --border-opacity:1;
  border-color:#edebfe;
  border-color:rgba(237,235,254,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-200{
  --border-opacity:1;
  border-color:#dcd7fe;
  border-color:rgba(220,215,254,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-300{
  --border-opacity:1;
  border-color:#cabffd;
  border-color:rgba(202,191,253,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-400{
  --border-opacity:1;
  border-color:#ac94fa;
  border-color:rgba(172,148,250,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-500{
  --border-opacity:1;
  border-color:#9061f9;
  border-color:rgba(144,97,249,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-600{
  --border-opacity:1;
  border-color:#7e3af2;
  border-color:rgba(126,58,242,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-700{
  --border-opacity:1;
  border-color:#6c2bd9;
  border-color:rgba(108,43,217,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-800{
  --border-opacity:1;
  border-color:#5521b5;
  border-color:rgba(85,33,181,var(--border-opacity))
}

.theme-dark .dark\\:border-indigo-900{
  --border-opacity:1;
  border-color:#4a1d96;
  border-color:rgba(74,29,150,var(--border-opacity))
}

.theme-dark .dark\\:border-pink-50{
  --border-opacity:1;
  border-color:#fdf2f8;
  border-color:rgba(253,242,248,var(--border-opacity))
}

.theme-dark .dark\\:border-pink-100{
  --border-opacity:1;
  border-color:#fce8f3;
  border-color:rgba(252,232,243,var(--border-opacity))
}

.theme-dark .dark\\:border-pink-200{
  --border-opacity:1;
  border-color:#fad1e8;
  border-color:rgba(250,209,232,var(--border-opacity))
}

.theme-dark .dark\\:border-pink-300{
  --border-opacity:1;
  border-color:#f8b4d9;
  border-color:rgba(248,180,217,var(--border-opacity))
}

.theme-dark .dark\\:border-pink-400{
  --border-opacity:1;
  border-color:#f17eb8;
  border-color:rgba(241,126,184,var(--border-opacity))
}

.theme-dark .dark\\:border-pink-500{
  --border-opacity:1;
  border-color:#e74694;
  border-color:rgba(231,70,148,var(--border-opacity))
}

.theme-dark .dark\\:border-pink-600{
  --border-opacity:1;
  border-color:#d61f69;
  border-color:rgba(214,31,105,var(--border-opacity))
}

.theme-dark .dark\\:border-pink-700{
  --border-opacity:1;
  border-color:#bf125d;
  border-color:rgba(191,18,93,var(--border-opacity))
}

.theme-dark .dark\\:border-pink-800{
  --border-opacity:1;
  border-color:#99154b;
  border-color:rgba(153,21,75,var(--border-opacity))
}

.theme-dark .dark\\:border-pink-900{
  --border-opacity:1;
  border-color:#751a3d;
  border-color:rgba(117,26,61,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-transparent:focus{
  border-color:#0000
}

.theme-dark .dark\\:focus\\:border-white:focus{
  --border-opacity:1;
  border-color:#fff;
  border-color:rgba(255,255,255,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-black:focus{
  --border-opacity:1;
  border-color:#000;
  border-color:rgba(0,0,0,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-gray-50:focus{
  --border-opacity:1;
  border-color:#f9fafb;
  border-color:rgba(249,250,251,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-gray-100:focus{
  --border-opacity:1;
  border-color:#f4f5f7;
  border-color:rgba(244,245,247,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-gray-200:focus{
  --border-opacity:1;
  border-color:#e5e7eb;
  border-color:rgba(229,231,235,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-gray-300:focus{
  --border-opacity:1;
  border-color:#d5d6d7;
  border-color:rgba(213,214,215,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-gray-400:focus{
  --border-opacity:1;
  border-color:#9e9e9e;
  border-color:rgba(158,158,158,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-gray-500:focus{
  --border-opacity:1;
  border-color:#707275;
  border-color:rgba(112,114,117,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-gray-600:focus{
  --border-opacity:1;
  border-color:#4c4f52;
  border-color:rgba(76,79,82,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-gray-700:focus{
  --border-opacity:1;
  border-color:#24262d;
  border-color:rgba(36,38,45,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-gray-800:focus{
  --border-opacity:1;
  border-color:#1a1c23;
  border-color:rgba(26,28,35,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-gray-900:focus{
  --border-opacity:1;
  border-color:#121317;
  border-color:rgba(18,19,23,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-cool-gray-50:focus{
  --border-opacity:1;
  border-color:#fbfdfe;
  border-color:rgba(251,253,254,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-cool-gray-100:focus{
  --border-opacity:1;
  border-color:#f1f5f9;
  border-color:rgba(241,245,249,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-cool-gray-200:focus{
  --border-opacity:1;
  border-color:#e2e8f0;
  border-color:rgba(226,232,240,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-cool-gray-300:focus{
  --border-opacity:1;
  border-color:#cfd8e3;
  border-color:rgba(207,216,227,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-cool-gray-400:focus{
  --border-opacity:1;
  border-color:#97a6ba;
  border-color:rgba(151,166,186,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-cool-gray-500:focus{
  --border-opacity:1;
  border-color:#64748b;
  border-color:rgba(100,116,139,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-cool-gray-600:focus{
  --border-opacity:1;
  border-color:#475569;
  border-color:rgba(71,85,105,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-cool-gray-700:focus{
  --border-opacity:1;
  border-color:#364152;
  border-color:rgba(54,65,82,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-cool-gray-800:focus{
  --border-opacity:1;
  border-color:#27303f;
  border-color:rgba(39,48,63,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-cool-gray-900:focus{
  --border-opacity:1;
  border-color:#1a202e;
  border-color:rgba(26,32,46,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-red-50:focus{
  --border-opacity:1;
  border-color:#fdf2f2;
  border-color:rgba(253,242,242,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-red-100:focus{
  --border-opacity:1;
  border-color:#fde8e8;
  border-color:rgba(253,232,232,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-red-200:focus{
  --border-opacity:1;
  border-color:#fbd5d5;
  border-color:rgba(251,213,213,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-red-300:focus{
  --border-opacity:1;
  border-color:#f8b4b4;
  border-color:rgba(248,180,180,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-red-400:focus{
  --border-opacity:1;
  border-color:#f98080;
  border-color:rgba(249,128,128,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-red-500:focus{
  --border-opacity:1;
  border-color:#f05252;
  border-color:rgba(240,82,82,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-red-600:focus{
  --border-opacity:1;
  border-color:#e02424;
  border-color:rgba(224,36,36,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-red-700:focus{
  --border-opacity:1;
  border-color:#c81e1e;
  border-color:rgba(200,30,30,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-red-800:focus{
  --border-opacity:1;
  border-color:#9b1c1c;
  border-color:rgba(155,28,28,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-red-900:focus{
  --border-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-orange-50:focus{
  --border-opacity:1;
  border-color:#fff8f1;
  border-color:rgba(255,248,241,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-orange-100:focus{
  --border-opacity:1;
  border-color:#feecdc;
  border-color:rgba(254,236,220,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-orange-200:focus{
  --border-opacity:1;
  border-color:#fcd9bd;
  border-color:rgba(252,217,189,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-orange-300:focus{
  --border-opacity:1;
  border-color:#fdba8c;
  border-color:rgba(253,186,140,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-orange-400:focus{
  --border-opacity:1;
  border-color:#ff8a4c;
  border-color:rgba(255,138,76,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-orange-500:focus{
  --border-opacity:1;
  border-color:#ff5a1f;
  border-color:rgba(255,90,31,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-orange-600:focus{
  --border-opacity:1;
  border-color:#d03801;
  border-color:rgba(208,56,1,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-orange-700:focus{
  --border-opacity:1;
  border-color:#b43403;
  border-color:rgba(180,52,3,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-orange-800:focus{
  --border-opacity:1;
  border-color:#8a2c0d;
  border-color:rgba(138,44,13,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-orange-900:focus{
  --border-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-yellow-50:focus{
  --border-opacity:1;
  border-color:#fdfdea;
  border-color:rgba(253,253,234,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-yellow-100:focus{
  --border-opacity:1;
  border-color:#fdf6b2;
  border-color:rgba(253,246,178,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-yellow-200:focus{
  --border-opacity:1;
  border-color:#fce96a;
  border-color:rgba(252,233,106,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-yellow-300:focus{
  --border-opacity:1;
  border-color:#faca15;
  border-color:rgba(250,202,21,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-yellow-400:focus{
  --border-opacity:1;
  border-color:#e3a008;
  border-color:rgba(227,160,8,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-yellow-500:focus{
  --border-opacity:1;
  border-color:#c27803;
  border-color:rgba(194,120,3,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-yellow-600:focus{
  --border-opacity:1;
  border-color:#9f580a;
  border-color:rgba(159,88,10,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-yellow-700:focus{
  --border-opacity:1;
  border-color:#8e4b10;
  border-color:rgba(142,75,16,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-yellow-800:focus{
  --border-opacity:1;
  border-color:#723b13;
  border-color:rgba(114,59,19,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-yellow-900:focus{
  --border-opacity:1;
  border-color:#633112;
  border-color:rgba(99,49,18,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-green-50:focus{
  --border-opacity:1;
  border-color:#f3faf7;
  border-color:rgba(243,250,247,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-green-100:focus{
  --border-opacity:1;
  border-color:#def7ec;
  border-color:rgba(222,247,236,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-green-200:focus{
  --border-opacity:1;
  border-color:#bcf0da;
  border-color:rgba(188,240,218,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-green-300:focus{
  --border-opacity:1;
  border-color:#84e1bc;
  border-color:rgba(132,225,188,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-green-400:focus{
  --border-opacity:1;
  border-color:#31c48d;
  border-color:rgba(49,196,141,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-green-500:focus{
  --border-opacity:1;
  border-color:#0e9f6e;
  border-color:rgba(14,159,110,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-green-600:focus{
  --border-opacity:1;
  border-color:#057a55;
  border-color:rgba(5,122,85,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-green-700:focus{
  --border-opacity:1;
  border-color:#046c4e;
  border-color:rgba(4,108,78,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-green-800:focus{
  --border-opacity:1;
  border-color:#03543f;
  border-color:rgba(3,84,63,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-green-900:focus{
  --border-opacity:1;
  border-color:#014737;
  border-color:rgba(1,71,55,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-teal-50:focus{
  --border-opacity:1;
  border-color:#edfafa;
  border-color:rgba(237,250,250,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-teal-100:focus{
  --border-opacity:1;
  border-color:#d5f5f6;
  border-color:rgba(213,245,246,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-teal-200:focus{
  --border-opacity:1;
  border-color:#afecef;
  border-color:rgba(175,236,239,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-teal-300:focus{
  --border-opacity:1;
  border-color:#7edce2;
  border-color:rgba(126,220,226,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-teal-400:focus{
  --border-opacity:1;
  border-color:#16bdca;
  border-color:rgba(22,189,202,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-teal-500:focus{
  --border-opacity:1;
  border-color:#0694a2;
  border-color:rgba(6,148,162,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-teal-600:focus{
  --border-opacity:1;
  border-color:#047481;
  border-color:rgba(4,116,129,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-teal-700:focus{
  --border-opacity:1;
  border-color:#036672;
  border-color:rgba(3,102,114,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-teal-800:focus{
  --border-opacity:1;
  border-color:#05505c;
  border-color:rgba(5,80,92,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-teal-900:focus{
  --border-opacity:1;
  border-color:#014451;
  border-color:rgba(1,68,81,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-blue-50:focus{
  --border-opacity:1;
  border-color:#ebf5ff;
  border-color:rgba(235,245,255,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-blue-100:focus{
  --border-opacity:1;
  border-color:#e1effe;
  border-color:rgba(225,239,254,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-blue-200:focus{
  --border-opacity:1;
  border-color:#c3ddfd;
  border-color:rgba(195,221,253,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-blue-300:focus{
  --border-opacity:1;
  border-color:#a4cafe;
  border-color:rgba(164,202,254,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-blue-400:focus{
  --border-opacity:1;
  border-color:#76a9fa;
  border-color:rgba(118,169,250,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-blue-500:focus{
  --border-opacity:1;
  border-color:#3f83f8;
  border-color:rgba(63,131,248,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-blue-600:focus{
  --border-opacity:1;
  border-color:#1c64f2;
  border-color:rgba(28,100,242,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-blue-700:focus{
  --border-opacity:1;
  border-color:#1a56db;
  border-color:rgba(26,86,219,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-blue-800:focus{
  --border-opacity:1;
  border-color:#1e429f;
  border-color:rgba(30,66,159,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-blue-900:focus{
  --border-opacity:1;
  border-color:#233876;
  border-color:rgba(35,56,118,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-50:focus{
  --border-opacity:1;
  border-color:#f0f5ff;
  border-color:rgba(240,245,255,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-100:focus{
  --border-opacity:1;
  border-color:#e5edff;
  border-color:rgba(229,237,255,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-200:focus{
  --border-opacity:1;
  border-color:#cddbfe;
  border-color:rgba(205,219,254,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-300:focus{
  --border-opacity:1;
  border-color:#b4c6fc;
  border-color:rgba(180,198,252,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-400:focus{
  --border-opacity:1;
  border-color:#8da2fb;
  border-color:rgba(141,162,251,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-500:focus{
  --border-opacity:1;
  border-color:#6875f5;
  border-color:rgba(104,117,245,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-600:focus{
  --border-opacity:1;
  border-color:#5850ec;
  border-color:rgba(88,80,236,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-700:focus{
  --border-opacity:1;
  border-color:#5145cd;
  border-color:rgba(81,69,205,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-800:focus{
  --border-opacity:1;
  border-color:#42389d;
  border-color:rgba(66,56,157,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-900:focus{
  --border-opacity:1;
  border-color:#362f78;
  border-color:rgba(54,47,120,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-50:focus{
  --border-opacity:1;
  border-color:#f6f5ff;
  border-color:rgba(246,245,255,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-100:focus{
  --border-opacity:1;
  border-color:#edebfe;
  border-color:rgba(237,235,254,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-200:focus{
  --border-opacity:1;
  border-color:#dcd7fe;
  border-color:rgba(220,215,254,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-300:focus{
  --border-opacity:1;
  border-color:#cabffd;
  border-color:rgba(202,191,253,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-400:focus{
  --border-opacity:1;
  border-color:#ac94fa;
  border-color:rgba(172,148,250,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-500:focus{
  --border-opacity:1;
  border-color:#9061f9;
  border-color:rgba(144,97,249,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-600:focus{
  --border-opacity:1;
  border-color:#7e3af2;
  border-color:rgba(126,58,242,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-700:focus{
  --border-opacity:1;
  border-color:#6c2bd9;
  border-color:rgba(108,43,217,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-800:focus{
  --border-opacity:1;
  border-color:#5521b5;
  border-color:rgba(85,33,181,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-indigo-900:focus{
  --border-opacity:1;
  border-color:#4a1d96;
  border-color:rgba(74,29,150,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-pink-50:focus{
  --border-opacity:1;
  border-color:#fdf2f8;
  border-color:rgba(253,242,248,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-pink-100:focus{
  --border-opacity:1;
  border-color:#fce8f3;
  border-color:rgba(252,232,243,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-pink-200:focus{
  --border-opacity:1;
  border-color:#fad1e8;
  border-color:rgba(250,209,232,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-pink-300:focus{
  --border-opacity:1;
  border-color:#f8b4d9;
  border-color:rgba(248,180,217,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-pink-400:focus{
  --border-opacity:1;
  border-color:#f17eb8;
  border-color:rgba(241,126,184,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-pink-500:focus{
  --border-opacity:1;
  border-color:#e74694;
  border-color:rgba(231,70,148,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-pink-600:focus{
  --border-opacity:1;
  border-color:#d61f69;
  border-color:rgba(214,31,105,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-pink-700:focus{
  --border-opacity:1;
  border-color:#bf125d;
  border-color:rgba(191,18,93,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-pink-800:focus{
  --border-opacity:1;
  border-color:#99154b;
  border-color:rgba(153,21,75,var(--border-opacity))
}

.theme-dark .dark\\:focus\\:border-pink-900:focus{
  --border-opacity:1;
  border-color:#751a3d;
  border-color:rgba(117,26,61,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-transparent:hover{
  border-color:#0000
}

.theme-dark .dark\\:hover\\:border-white:hover{
  --border-opacity:1;
  border-color:#fff;
  border-color:rgba(255,255,255,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-black:hover{
  --border-opacity:1;
  border-color:#000;
  border-color:rgba(0,0,0,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-gray-50:hover{
  --border-opacity:1;
  border-color:#f9fafb;
  border-color:rgba(249,250,251,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-gray-100:hover{
  --border-opacity:1;
  border-color:#f4f5f7;
  border-color:rgba(244,245,247,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-gray-200:hover{
  --border-opacity:1;
  border-color:#e5e7eb;
  border-color:rgba(229,231,235,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-gray-300:hover{
  --border-opacity:1;
  border-color:#d5d6d7;
  border-color:rgba(213,214,215,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-gray-400:hover{
  --border-opacity:1;
  border-color:#9e9e9e;
  border-color:rgba(158,158,158,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-gray-500:hover{
  --border-opacity:1;
  border-color:#707275;
  border-color:rgba(112,114,117,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-gray-600:hover{
  --border-opacity:1;
  border-color:#4c4f52;
  border-color:rgba(76,79,82,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-gray-700:hover{
  --border-opacity:1;
  border-color:#24262d;
  border-color:rgba(36,38,45,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-gray-800:hover{
  --border-opacity:1;
  border-color:#1a1c23;
  border-color:rgba(26,28,35,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-gray-900:hover{
  --border-opacity:1;
  border-color:#121317;
  border-color:rgba(18,19,23,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-cool-gray-50:hover{
  --border-opacity:1;
  border-color:#fbfdfe;
  border-color:rgba(251,253,254,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-cool-gray-100:hover{
  --border-opacity:1;
  border-color:#f1f5f9;
  border-color:rgba(241,245,249,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-cool-gray-200:hover{
  --border-opacity:1;
  border-color:#e2e8f0;
  border-color:rgba(226,232,240,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-cool-gray-300:hover{
  --border-opacity:1;
  border-color:#cfd8e3;
  border-color:rgba(207,216,227,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-cool-gray-400:hover{
  --border-opacity:1;
  border-color:#97a6ba;
  border-color:rgba(151,166,186,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-cool-gray-500:hover{
  --border-opacity:1;
  border-color:#64748b;
  border-color:rgba(100,116,139,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-cool-gray-600:hover{
  --border-opacity:1;
  border-color:#475569;
  border-color:rgba(71,85,105,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-cool-gray-700:hover{
  --border-opacity:1;
  border-color:#364152;
  border-color:rgba(54,65,82,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-cool-gray-800:hover{
  --border-opacity:1;
  border-color:#27303f;
  border-color:rgba(39,48,63,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-cool-gray-900:hover{
  --border-opacity:1;
  border-color:#1a202e;
  border-color:rgba(26,32,46,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-red-50:hover{
  --border-opacity:1;
  border-color:#fdf2f2;
  border-color:rgba(253,242,242,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-red-100:hover{
  --border-opacity:1;
  border-color:#fde8e8;
  border-color:rgba(253,232,232,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-red-200:hover{
  --border-opacity:1;
  border-color:#fbd5d5;
  border-color:rgba(251,213,213,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-red-300:hover{
  --border-opacity:1;
  border-color:#f8b4b4;
  border-color:rgba(248,180,180,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-red-400:hover{
  --border-opacity:1;
  border-color:#f98080;
  border-color:rgba(249,128,128,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-red-500:hover{
  --border-opacity:1;
  border-color:#f05252;
  border-color:rgba(240,82,82,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-red-600:hover{
  --border-opacity:1;
  border-color:#e02424;
  border-color:rgba(224,36,36,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-red-700:hover{
  --border-opacity:1;
  border-color:#c81e1e;
  border-color:rgba(200,30,30,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-red-800:hover{
  --border-opacity:1;
  border-color:#9b1c1c;
  border-color:rgba(155,28,28,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-red-900:hover{
  --border-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-orange-50:hover{
  --border-opacity:1;
  border-color:#fff8f1;
  border-color:rgba(255,248,241,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-orange-100:hover{
  --border-opacity:1;
  border-color:#feecdc;
  border-color:rgba(254,236,220,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-orange-200:hover{
  --border-opacity:1;
  border-color:#fcd9bd;
  border-color:rgba(252,217,189,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-orange-300:hover{
  --border-opacity:1;
  border-color:#fdba8c;
  border-color:rgba(253,186,140,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-orange-400:hover{
  --border-opacity:1;
  border-color:#ff8a4c;
  border-color:rgba(255,138,76,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-orange-500:hover{
  --border-opacity:1;
  border-color:#ff5a1f;
  border-color:rgba(255,90,31,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-orange-600:hover{
  --border-opacity:1;
  border-color:#d03801;
  border-color:rgba(208,56,1,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-orange-700:hover{
  --border-opacity:1;
  border-color:#b43403;
  border-color:rgba(180,52,3,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-orange-800:hover{
  --border-opacity:1;
  border-color:#8a2c0d;
  border-color:rgba(138,44,13,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-orange-900:hover{
  --border-opacity:1;
  border-color:#771d1d;
  border-color:rgba(119,29,29,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-yellow-50:hover{
  --border-opacity:1;
  border-color:#fdfdea;
  border-color:rgba(253,253,234,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-yellow-100:hover{
  --border-opacity:1;
  border-color:#fdf6b2;
  border-color:rgba(253,246,178,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-yellow-200:hover{
  --border-opacity:1;
  border-color:#fce96a;
  border-color:rgba(252,233,106,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-yellow-300:hover{
  --border-opacity:1;
  border-color:#faca15;
  border-color:rgba(250,202,21,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-yellow-400:hover{
  --border-opacity:1;
  border-color:#e3a008;
  border-color:rgba(227,160,8,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-yellow-500:hover{
  --border-opacity:1;
  border-color:#c27803;
  border-color:rgba(194,120,3,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-yellow-600:hover{
  --border-opacity:1;
  border-color:#9f580a;
  border-color:rgba(159,88,10,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-yellow-700:hover{
  --border-opacity:1;
  border-color:#8e4b10;
  border-color:rgba(142,75,16,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-yellow-800:hover{
  --border-opacity:1;
  border-color:#723b13;
  border-color:rgba(114,59,19,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-yellow-900:hover{
  --border-opacity:1;
  border-color:#633112;
  border-color:rgba(99,49,18,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-green-50:hover{
  --border-opacity:1;
  border-color:#f3faf7;
  border-color:rgba(243,250,247,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-green-100:hover{
  --border-opacity:1;
  border-color:#def7ec;
  border-color:rgba(222,247,236,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-green-200:hover{
  --border-opacity:1;
  border-color:#bcf0da;
  border-color:rgba(188,240,218,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-green-300:hover{
  --border-opacity:1;
  border-color:#84e1bc;
  border-color:rgba(132,225,188,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-green-400:hover{
  --border-opacity:1;
  border-color:#31c48d;
  border-color:rgba(49,196,141,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-green-500:hover{
  --border-opacity:1;
  border-color:#0e9f6e;
  border-color:rgba(14,159,110,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-green-600:hover{
  --border-opacity:1;
  border-color:#057a55;
  border-color:rgba(5,122,85,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-green-700:hover{
  --border-opacity:1;
  border-color:#046c4e;
  border-color:rgba(4,108,78,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-green-800:hover{
  --border-opacity:1;
  border-color:#03543f;
  border-color:rgba(3,84,63,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-green-900:hover{
  --border-opacity:1;
  border-color:#014737;
  border-color:rgba(1,71,55,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-teal-50:hover{
  --border-opacity:1;
  border-color:#edfafa;
  border-color:rgba(237,250,250,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-teal-100:hover{
  --border-opacity:1;
  border-color:#d5f5f6;
  border-color:rgba(213,245,246,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-teal-200:hover{
  --border-opacity:1;
  border-color:#afecef;
  border-color:rgba(175,236,239,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-teal-300:hover{
  --border-opacity:1;
  border-color:#7edce2;
  border-color:rgba(126,220,226,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-teal-400:hover{
  --border-opacity:1;
  border-color:#16bdca;
  border-color:rgba(22,189,202,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-teal-500:hover{
  --border-opacity:1;
  border-color:#0694a2;
  border-color:rgba(6,148,162,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-teal-600:hover{
  --border-opacity:1;
  border-color:#047481;
  border-color:rgba(4,116,129,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-teal-700:hover{
  --border-opacity:1;
  border-color:#036672;
  border-color:rgba(3,102,114,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-teal-800:hover{
  --border-opacity:1;
  border-color:#05505c;
  border-color:rgba(5,80,92,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-teal-900:hover{
  --border-opacity:1;
  border-color:#014451;
  border-color:rgba(1,68,81,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-blue-50:hover{
  --border-opacity:1;
  border-color:#ebf5ff;
  border-color:rgba(235,245,255,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-blue-100:hover{
  --border-opacity:1;
  border-color:#e1effe;
  border-color:rgba(225,239,254,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-blue-200:hover{
  --border-opacity:1;
  border-color:#c3ddfd;
  border-color:rgba(195,221,253,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-blue-300:hover{
  --border-opacity:1;
  border-color:#a4cafe;
  border-color:rgba(164,202,254,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-blue-400:hover{
  --border-opacity:1;
  border-color:#76a9fa;
  border-color:rgba(118,169,250,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-blue-500:hover{
  --border-opacity:1;
  border-color:#3f83f8;
  border-color:rgba(63,131,248,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-blue-600:hover{
  --border-opacity:1;
  border-color:#1c64f2;
  border-color:rgba(28,100,242,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-blue-700:hover{
  --border-opacity:1;
  border-color:#1a56db;
  border-color:rgba(26,86,219,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-blue-800:hover{
  --border-opacity:1;
  border-color:#1e429f;
  border-color:rgba(30,66,159,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-blue-900:hover{
  --border-opacity:1;
  border-color:#233876;
  border-color:rgba(35,56,118,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-50:hover{
  --border-opacity:1;
  border-color:#f0f5ff;
  border-color:rgba(240,245,255,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-100:hover{
  --border-opacity:1;
  border-color:#e5edff;
  border-color:rgba(229,237,255,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-200:hover{
  --border-opacity:1;
  border-color:#cddbfe;
  border-color:rgba(205,219,254,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-300:hover{
  --border-opacity:1;
  border-color:#b4c6fc;
  border-color:rgba(180,198,252,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-400:hover{
  --border-opacity:1;
  border-color:#8da2fb;
  border-color:rgba(141,162,251,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-500:hover{
  --border-opacity:1;
  border-color:#6875f5;
  border-color:rgba(104,117,245,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-600:hover{
  --border-opacity:1;
  border-color:#5850ec;
  border-color:rgba(88,80,236,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-700:hover{
  --border-opacity:1;
  border-color:#5145cd;
  border-color:rgba(81,69,205,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-800:hover{
  --border-opacity:1;
  border-color:#42389d;
  border-color:rgba(66,56,157,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-900:hover{
  --border-opacity:1;
  border-color:#362f78;
  border-color:rgba(54,47,120,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-50:hover{
  --border-opacity:1;
  border-color:#f6f5ff;
  border-color:rgba(246,245,255,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-100:hover{
  --border-opacity:1;
  border-color:#edebfe;
  border-color:rgba(237,235,254,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-200:hover{
  --border-opacity:1;
  border-color:#dcd7fe;
  border-color:rgba(220,215,254,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-300:hover{
  --border-opacity:1;
  border-color:#cabffd;
  border-color:rgba(202,191,253,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-400:hover{
  --border-opacity:1;
  border-color:#ac94fa;
  border-color:rgba(172,148,250,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-500:hover{
  --border-opacity:1;
  border-color:#9061f9;
  border-color:rgba(144,97,249,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-600:hover{
  --border-opacity:1;
  border-color:#7e3af2;
  border-color:rgba(126,58,242,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-700:hover{
  --border-opacity:1;
  border-color:#6c2bd9;
  border-color:rgba(108,43,217,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-800:hover{
  --border-opacity:1;
  border-color:#5521b5;
  border-color:rgba(85,33,181,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-indigo-900:hover{
  --border-opacity:1;
  border-color:#4a1d96;
  border-color:rgba(74,29,150,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-pink-50:hover{
  --border-opacity:1;
  border-color:#fdf2f8;
  border-color:rgba(253,242,248,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-pink-100:hover{
  --border-opacity:1;
  border-color:#fce8f3;
  border-color:rgba(252,232,243,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-pink-200:hover{
  --border-opacity:1;
  border-color:#fad1e8;
  border-color:rgba(250,209,232,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-pink-300:hover{
  --border-opacity:1;
  border-color:#f8b4d9;
  border-color:rgba(248,180,217,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-pink-400:hover{
  --border-opacity:1;
  border-color:#f17eb8;
  border-color:rgba(241,126,184,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-pink-500:hover{
  --border-opacity:1;
  border-color:#e74694;
  border-color:rgba(231,70,148,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-pink-600:hover{
  --border-opacity:1;
  border-color:#d61f69;
  border-color:rgba(214,31,105,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-pink-700:hover{
  --border-opacity:1;
  border-color:#bf125d;
  border-color:rgba(191,18,93,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-pink-800:hover{
  --border-opacity:1;
  border-color:#99154b;
  border-color:rgba(153,21,75,var(--border-opacity))
}

.theme-dark .dark\\:hover\\:border-pink-900:hover{
  --border-opacity:1;
  border-color:#751a3d;
  border-color:rgba(117,26,61,var(--border-opacity))
}

.border-opacity-0{
  --border-opacity:0
}

.border-opacity-25{
  --border-opacity:0.25
}

.border-opacity-50{
  --border-opacity:0.5
}

.border-opacity-75{
  --border-opacity:0.75
}

.border-opacity-100{
  --border-opacity:1
}

.hover\\:border-opacity-0:hover{
  --border-opacity:0
}

.hover\\:border-opacity-25:hover{
  --border-opacity:0.25
}

.hover\\:border-opacity-50:hover{
  --border-opacity:0.5
}

.hover\\:border-opacity-75:hover{
  --border-opacity:0.75
}

.hover\\:border-opacity-100:hover{
  --border-opacity:1
}

.focus\\:border-opacity-0:focus{
  --border-opacity:0
}

.focus\\:border-opacity-25:focus{
  --border-opacity:0.25
}

.focus\\:border-opacity-50:focus{
  --border-opacity:0.5
}

.focus\\:border-opacity-75:focus{
  --border-opacity:0.75
}

.focus\\:border-opacity-100:focus{
  --border-opacity:1
}

.rounded-none{
  border-radius:0
}

.rounded-sm{
  border-radius:.125rem
}

.rounded{
  border-radius:.25rem
}

.rounded-md{
  border-radius:.375rem
}

.rounded-lg{
  border-radius:.5rem
}

.rounded-full{
  border-radius:9999px
}

.rounded-t-none{
  border-top-left-radius:0;
  border-top-right-radius:0
}

.rounded-r-none{
  border-bottom-right-radius:0;
  border-top-right-radius:0
}

.rounded-b-none{
  border-bottom-left-radius:0;
  border-bottom-right-radius:0
}

.rounded-l-none{
  border-bottom-left-radius:0;
  border-top-left-radius:0
}

.rounded-t-sm{
  border-top-left-radius:.125rem
}

.rounded-r-sm,.rounded-t-sm{
  border-top-right-radius:.125rem
}

.rounded-b-sm,.rounded-r-sm{
  border-bottom-right-radius:.125rem
}

.rounded-b-sm,.rounded-l-sm{
  border-bottom-left-radius:.125rem
}

.rounded-l-sm{
  border-top-left-radius:.125rem
}

.rounded-t{
  border-top-left-radius:.25rem
}

.rounded-r,.rounded-t{
  border-top-right-radius:.25rem
}

.rounded-b,.rounded-r{
  border-bottom-right-radius:.25rem
}

.rounded-b,.rounded-l{
  border-bottom-left-radius:.25rem
}

.rounded-l{
  border-top-left-radius:.25rem
}

.rounded-t-md{
  border-top-left-radius:.375rem
}

.rounded-r-md,.rounded-t-md{
  border-top-right-radius:.375rem
}

.rounded-b-md,.rounded-r-md{
  border-bottom-right-radius:.375rem
}

.rounded-b-md,.rounded-l-md{
  border-bottom-left-radius:.375rem
}

.rounded-l-md{
  border-top-left-radius:.375rem
}

.rounded-t-lg{
  border-top-left-radius:.5rem
}

.rounded-r-lg,.rounded-t-lg{
  border-top-right-radius:.5rem
}

.rounded-b-lg,.rounded-r-lg{
  border-bottom-right-radius:.5rem
}

.rounded-b-lg,.rounded-l-lg{
  border-bottom-left-radius:.5rem
}

.rounded-l-lg{
  border-top-left-radius:.5rem
}

.rounded-t-full{
  border-top-left-radius:9999px
}

.rounded-r-full,.rounded-t-full{
  border-top-right-radius:9999px
}

.rounded-b-full,.rounded-r-full{
  border-bottom-right-radius:9999px
}

.rounded-b-full,.rounded-l-full{
  border-bottom-left-radius:9999px
}

.rounded-l-full{
  border-top-left-radius:9999px
}

.rounded-tl-none{
  border-top-left-radius:0
}

.rounded-tr-none{
  border-top-right-radius:0
}

.rounded-br-none{
  border-bottom-right-radius:0
}

.rounded-bl-none{
  border-bottom-left-radius:0
}

.rounded-tl-sm{
  border-top-left-radius:.125rem
}

.rounded-tr-sm{
  border-top-right-radius:.125rem
}

.rounded-br-sm{
  border-bottom-right-radius:.125rem
}

.rounded-bl-sm{
  border-bottom-left-radius:.125rem
}

.rounded-tl{
  border-top-left-radius:.25rem
}

.rounded-tr{
  border-top-right-radius:.25rem
}

.rounded-br{
  border-bottom-right-radius:.25rem
}

.rounded-bl{
  border-bottom-left-radius:.25rem
}

.rounded-tl-md{
  border-top-left-radius:.375rem
}

.rounded-tr-md{
  border-top-right-radius:.375rem
}

.rounded-br-md{
  border-bottom-right-radius:.375rem
}

.rounded-bl-md{
  border-bottom-left-radius:.375rem
}

.rounded-tl-lg{
  border-top-left-radius:.5rem
}

.rounded-tr-lg{
  border-top-right-radius:.5rem
}

.rounded-br-lg{
  border-bottom-right-radius:.5rem
}

.rounded-bl-lg{
  border-bottom-left-radius:.5rem
}

.rounded-tl-full{
  border-top-left-radius:9999px
}

.rounded-tr-full{
  border-top-right-radius:9999px
}

.rounded-br-full{
  border-bottom-right-radius:9999px
}

.rounded-bl-full{
  border-bottom-left-radius:9999px
}

.border-solid{
  border-style:solid
}

.border-dashed{
  border-style:dashed
}

.border-dotted{
  border-style:dotted
}

.border-double{
  border-style:double
}

.border-none{
  border-style:none
}

.border-0{
  border-width:0
}

.border-2{
  border-width:2px
}

.border-4{
  border-width:4px
}

.border-8{
  border-width:8px
}

.border{
  border-width:1px
}

.border-t-0{
  border-top-width:0
}

.border-r-0{
  border-right-width:0
}

.border-b-0{
  border-bottom-width:0
}

.border-l-0{
  border-left-width:0
}

.border-t-2{
  border-top-width:2px
}

.border-r-2{
  border-right-width:2px
}

.border-b-2{
  border-bottom-width:2px
}

.border-l-2{
  border-left-width:2px
}

.border-t-4{
  border-top-width:4px
}

.border-r-4{
  border-right-width:4px
}

.border-b-4{
  border-bottom-width:4px
}

.border-l-4{
  border-left-width:4px
}

.border-t-8{
  border-top-width:8px
}

.border-r-8{
  border-right-width:8px
}

.border-b-8{
  border-bottom-width:8px
}

.border-l-8{
  border-left-width:8px
}

.border-t{
  border-top-width:1px
}

.border-r{
  border-right-width:1px
}

.border-b{
  border-bottom-width:1px
}

.border-l{
  border-left-width:1px
}

.box-border{
  box-sizing:border-box
}

.box-content{
  box-sizing:initial
}

.cursor-auto{
  cursor:auto
}

.cursor-default{
  cursor:default
}

.cursor-pointer{
  cursor:pointer
}

.cursor-wait{
  cursor:wait
}

.cursor-text{
  cursor:text
}

.cursor-move{
  cursor:move
}

.cursor-not-allowed{
  cursor:not-allowed
}

.block{
  display:block
}

.inline-block{
  display:inline-block
}

.inline{
  display:inline
}

.flex{
  display:flex
}

.inline-flex{
  display:inline-flex
}

.table{
  display:table
}

.table-caption{
  display:table-caption
}

.table-cell{
  display:table-cell
}

.table-column{
  display:table-column
}

.table-column-group{
  display:table-column-group
}

.table-footer-group{
  display:table-footer-group
}

.table-header-group{
  display:table-header-group
}

.table-row-group{
  display:table-row-group
}

.table-row{
  display:table-row
}

.flow-root{
  display:flow-root
}

.grid{
  display:grid
}

.inline-grid{
  display:inline-grid
}

.hidden{
  display:none
}

.theme-dark .dark\\:block{
  display:block
}

.theme-dark .dark\\:inline-block{
  display:inline-block
}

.theme-dark .dark\\:inline{
  display:inline
}

.theme-dark .dark\\:flex{
  display:flex
}

.theme-dark .dark\\:inline-flex{
  display:inline-flex
}

.theme-dark .dark\\:table{
  display:table
}

.theme-dark .dark\\:table-caption{
  display:table-caption
}

.theme-dark .dark\\:table-cell{
  display:table-cell
}

.theme-dark .dark\\:table-column{
  display:table-column
}

.theme-dark .dark\\:table-column-group{
  display:table-column-group
}

.theme-dark .dark\\:table-footer-group{
  display:table-footer-group
}

.theme-dark .dark\\:table-header-group{
  display:table-header-group
}

.theme-dark .dark\\:table-row-group{
  display:table-row-group
}

.theme-dark .dark\\:table-row{
  display:table-row
}

.theme-dark .dark\\:flow-root{
  display:flow-root
}

.theme-dark .dark\\:grid{
  display:grid
}

.theme-dark .dark\\:inline-grid{
  display:inline-grid
}

.theme-dark .dark\\:hidden{
  display:none
}

.flex-row{
  flex-direction:row
}

.flex-row-reverse{
  flex-direction:row-reverse
}

.flex-col{
  flex-direction:column
}

.flex-col-reverse{
  flex-direction:column-reverse
}

.flex-wrap{
  flex-wrap:wrap
}

.flex-wrap-reverse{
  flex-wrap:wrap-reverse
}

.flex-no-wrap{
  flex-wrap:nowrap
}

.items-start{
  align-items:flex-start
}

.items-end{
  align-items:flex-end
}

.items-center{
  align-items:center
}

.items-baseline{
  align-items:baseline
}

.items-stretch{
  align-items:stretch
}

.self-auto{
  align-self:auto
}

.self-start{
  align-self:flex-start
}

.self-end{
  align-self:flex-end
}

.self-center{
  align-self:center
}

.self-stretch{
  align-self:stretch
}

.justify-start{
  justify-content:flex-start
}

.justify-end{
  justify-content:flex-end
}

.justify-center{
  justify-content:center
}

.justify-between{
  justify-content:space-between
}

.justify-around{
  justify-content:space-around
}

.justify-evenly{
  justify-content:space-evenly
}

.content-center{
  align-content:center
}

.content-start{
  align-content:flex-start
}

.content-end{
  align-content:flex-end
}

.content-between{
  align-content:space-between
}

.content-around{
  align-content:space-around
}

.flex-1{
  flex:1 1
}

.flex-auto{
  flex:1 1 auto
}

.flex-initial{
  flex:0 1 auto
}

.flex-none{
  flex:none
}

.flex-grow-0{
  flex-grow:0
}

.flex-grow{
  flex-grow:1
}

.flex-shrink-0{
  flex-shrink:0
}

.flex-shrink{
  flex-shrink:1
}

.order-1{
  order:1
}

.order-2{
  order:2
}

.order-3{
  order:3
}

.order-4{
  order:4
}

.order-5{
  order:5
}

.order-6{
  order:6
}

.order-7{
  order:7
}

.order-8{
  order:8
}

.order-9{
  order:9
}

.order-10{
  order:10
}

.order-11{
  order:11
}

.order-12{
  order:12
}

.order-first{
  order:-9999
}

.order-last{
  order:9999
}

.order-none{
  order:0
}

.float-right{
  float:right
}

.float-left{
  float:left
}

.float-none{
  float:none
}

.clearfix:after{
  clear:both;
  content:"";
  display:table
}

.clear-left{
  clear:left
}

.clear-right{
  clear:right
}

.clear-both{
  clear:both
}

.clear-none{
  clear:none
}

.font-sans{
  font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji
}

.font-serif{
  font-family:Georgia,Cambria,Times New Roman,Times,serif
}

.font-mono{
  font-family:Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace
}

.font-hairline{
  font-weight:100
}

.font-thin{
  font-weight:200
}

.font-light{
  font-weight:300
}

.font-normal{
  font-weight:400
}

.font-medium{
  font-weight:500
}

.font-semibold{
  font-weight:600
}

.font-bold{
  font-weight:700
}

.font-extrabold{
  font-weight:800
}

.font-black{
  font-weight:900
}

.hover\\:font-hairline:hover{
  font-weight:100
}

.hover\\:font-thin:hover{
  font-weight:200
}

.hover\\:font-light:hover{
  font-weight:300
}

.hover\\:font-normal:hover{
  font-weight:400
}

.hover\\:font-medium:hover{
  font-weight:500
}

.hover\\:font-semibold:hover{
  font-weight:600
}

.hover\\:font-bold:hover{
  font-weight:700
}

.hover\\:font-extrabold:hover{
  font-weight:800
}

.hover\\:font-black:hover{
  font-weight:900
}

.focus\\:font-hairline:focus{
  font-weight:100
}

.focus\\:font-thin:focus{
  font-weight:200
}

.focus\\:font-light:focus{
  font-weight:300
}

.focus\\:font-normal:focus{
  font-weight:400
}

.focus\\:font-medium:focus{
  font-weight:500
}

.focus\\:font-semibold:focus{
  font-weight:600
}

.focus\\:font-bold:focus{
  font-weight:700
}

.focus\\:font-extrabold:focus{
  font-weight:800
}

.focus\\:font-black:focus{
  font-weight:900
}

.h-0{
  height:0
}

.h-1{
  height:.25rem
}

.h-2{
  height:.5rem
}

.h-3{
  height:.75rem
}

.h-4{
  height:1rem
}

.h-5{
  height:1.25rem
}

.h-6{
  height:1.5rem
}

.h-8{
  height:2rem
}

.h-10{
  height:2.5rem
}

.h-12{
  height:3rem
}

.h-16{
  height:4rem
}

.h-20{
  height:5rem
}

.h-24{
  height:6rem
}

.h-32{
  height:8rem
}

.h-40{
  height:10rem
}

.h-48{
  height:12rem
}

.h-56{
  height:14rem
}

.h-64{
  height:16rem
}

.h-auto{
  height:auto
}

.h-px{
  height:1px
}

.h-full{
  height:100%
}

.h-screen{
  height:100vh
}

.text-xs{
  font-size:.75rem
}

.text-sm{
  font-size:.875rem
}

.text-base{
  font-size:1rem
}

.text-lg{
  font-size:1.125rem
}

.text-xl{
  font-size:1.25rem
}

.text-2xl{
  font-size:1.5rem
}

.text-3xl{
  font-size:1.875rem
}

.text-4xl{
  font-size:2.25rem
}

.text-5xl{
  font-size:3rem
}

.text-6xl{
  font-size:4rem
}

.leading-3{
  line-height:.75rem
}

.leading-4{
  line-height:1rem
}

.leading-5{
  line-height:1.25rem
}

.leading-6{
  line-height:1.5rem
}

.leading-7{
  line-height:1.75rem
}

.leading-8{
  line-height:2rem
}

.leading-9{
  line-height:2.25rem
}

.leading-10{
  line-height:2.5rem
}

.leading-none{
  line-height:1
}

.leading-tight{
  line-height:1.25
}

.leading-snug{
  line-height:1.375
}

.leading-normal{
  line-height:1.5
}

.leading-relaxed{
  line-height:1.625
}

.leading-loose{
  line-height:2
}

.list-inside{
  list-style-position:inside
}

.list-outside{
  list-style-position:outside
}

.list-none{
  list-style-type:none
}

.list-disc{
  list-style-type:disc
}

.list-decimal{
  list-style-type:decimal
}

.m-0{
  margin:0
}

.m-1{
  margin:.25rem
}

.m-2{
  margin:.5rem
}

.m-3{
  margin:.75rem
}

.m-4{
  margin:1rem
}

.m-5{
  margin:1.25rem
}

.m-6{
  margin:1.5rem
}

.m-8{
  margin:2rem
}

.m-10{
  margin:2.5rem
}

.m-12{
  margin:3rem
}

.m-16{
  margin:4rem
}

.m-20{
  margin:5rem
}

.m-24{
  margin:6rem
}

.m-32{
  margin:8rem
}

.m-40{
  margin:10rem
}

.m-48{
  margin:12rem
}

.m-56{
  margin:14rem
}

.m-64{
  margin:16rem
}

.m-auto{
  margin:auto
}

.m-px{
  margin:1px
}

.-m-1{
  margin:-.25rem
}

.-m-2{
  margin:-.5rem
}

.-m-3{
  margin:-.75rem
}

.-m-4{
  margin:-1rem
}

.-m-5{
  margin:-1.25rem
}

.-m-6{
  margin:-1.5rem
}

.-m-8{
  margin:-2rem
}

.-m-10{
  margin:-2.5rem
}

.-m-12{
  margin:-3rem
}

.-m-16{
  margin:-4rem
}

.-m-20{
  margin:-5rem
}

.-m-24{
  margin:-6rem
}

.-m-32{
  margin:-8rem
}

.-m-40{
  margin:-10rem
}

.-m-48{
  margin:-12rem
}

.-m-56{
  margin:-14rem
}

.-m-64{
  margin:-16rem
}

.-m-px{
  margin:-1px
}

.my-0{
  margin-bottom:0;
  margin-top:0
}

.mx-0{
  margin-left:0;
  margin-right:0
}

.my-1{
  margin-bottom:.25rem;
  margin-top:.25rem
}

.mx-1{
  margin-left:.25rem;
  margin-right:.25rem
}

.my-2{
  margin-bottom:.5rem;
  margin-top:.5rem
}

.mx-2{
  margin-left:.5rem;
  margin-right:.5rem
}

.my-3{
  margin-bottom:.75rem;
  margin-top:.75rem
}

.mx-3{
  margin-left:.75rem;
  margin-right:.75rem
}

.my-4{
  margin-bottom:1rem;
  margin-top:1rem
}

.mx-4{
  margin-left:1rem;
  margin-right:1rem
}

.my-5{
  margin-bottom:1.25rem;
  margin-top:1.25rem
}

.mx-5{
  margin-left:1.25rem;
  margin-right:1.25rem
}

.my-6{
  margin-bottom:1.5rem;
  margin-top:1.5rem
}

.mx-6{
  margin-left:1.5rem;
  margin-right:1.5rem
}

.my-8{
  margin-bottom:2rem;
  margin-top:2rem
}

.mx-8{
  margin-left:2rem;
  margin-right:2rem
}

.my-10{
  margin-bottom:2.5rem;
  margin-top:2.5rem
}

.mx-10{
  margin-left:2.5rem;
  margin-right:2.5rem
}

.my-12{
  margin-bottom:3rem;
  margin-top:3rem
}

.mx-12{
  margin-left:3rem;
  margin-right:3rem
}

.my-16{
  margin-bottom:4rem;
  margin-top:4rem
}

.mx-16{
  margin-left:4rem;
  margin-right:4rem
}

.my-20{
  margin-bottom:5rem;
  margin-top:5rem
}

.mx-20{
  margin-left:5rem;
  margin-right:5rem
}

.my-24{
  margin-bottom:6rem;
  margin-top:6rem
}

.mx-24{
  margin-left:6rem;
  margin-right:6rem
}

.my-32{
  margin-bottom:8rem;
  margin-top:8rem
}

.mx-32{
  margin-left:8rem;
  margin-right:8rem
}

.my-40{
  margin-bottom:10rem;
  margin-top:10rem
}

.mx-40{
  margin-left:10rem;
  margin-right:10rem
}

.my-48{
  margin-bottom:12rem;
  margin-top:12rem
}

.mx-48{
  margin-left:12rem;
  margin-right:12rem
}

.my-56{
  margin-bottom:14rem;
  margin-top:14rem
}

.mx-56{
  margin-left:14rem;
  margin-right:14rem
}

.my-64{
  margin-bottom:16rem;
  margin-top:16rem
}

.mx-64{
  margin-left:16rem;
  margin-right:16rem
}

.my-auto{
  margin-bottom:auto;
  margin-top:auto
}

.mx-auto{
  margin-left:auto;
  margin-right:auto
}

.my-px{
  margin-bottom:1px;
  margin-top:1px
}

.mx-px{
  margin-left:1px;
  margin-right:1px
}

.-my-1{
  margin-bottom:-.25rem;
  margin-top:-.25rem
}

.-mx-1{
  margin-left:-.25rem;
  margin-right:-.25rem
}

.-my-2{
  margin-bottom:-.5rem;
  margin-top:-.5rem
}

.-mx-2{
  margin-left:-.5rem;
  margin-right:-.5rem
}

.-my-3{
  margin-bottom:-.75rem;
  margin-top:-.75rem
}

.-mx-3{
  margin-left:-.75rem;
  margin-right:-.75rem
}

.-my-4{
  margin-bottom:-1rem;
  margin-top:-1rem
}

.-mx-4{
  margin-left:-1rem;
  margin-right:-1rem
}

.-my-5{
  margin-bottom:-1.25rem;
  margin-top:-1.25rem
}

.-mx-5{
  margin-left:-1.25rem;
  margin-right:-1.25rem
}

.-my-6{
  margin-bottom:-1.5rem;
  margin-top:-1.5rem
}

.-mx-6{
  margin-left:-1.5rem;
  margin-right:-1.5rem
}

.-my-8{
  margin-bottom:-2rem;
  margin-top:-2rem
}

.-mx-8{
  margin-left:-2rem;
  margin-right:-2rem
}

.-my-10{
  margin-bottom:-2.5rem;
  margin-top:-2.5rem
}

.-mx-10{
  margin-left:-2.5rem;
  margin-right:-2.5rem
}

.-my-12{
  margin-bottom:-3rem;
  margin-top:-3rem
}

.-mx-12{
  margin-left:-3rem;
  margin-right:-3rem
}

.-my-16{
  margin-bottom:-4rem;
  margin-top:-4rem
}

.-mx-16{
  margin-left:-4rem;
  margin-right:-4rem
}

.-my-20{
  margin-bottom:-5rem;
  margin-top:-5rem
}

.-mx-20{
  margin-left:-5rem;
  margin-right:-5rem
}

.-my-24{
  margin-bottom:-6rem;
  margin-top:-6rem
}

.-mx-24{
  margin-left:-6rem;
  margin-right:-6rem
}

.-my-32{
  margin-bottom:-8rem;
  margin-top:-8rem
}

.-mx-32{
  margin-left:-8rem;
  margin-right:-8rem
}

.-my-40{
  margin-bottom:-10rem;
  margin-top:-10rem
}

.-mx-40{
  margin-left:-10rem;
  margin-right:-10rem
}

.-my-48{
  margin-bottom:-12rem;
  margin-top:-12rem
}

.-mx-48{
  margin-left:-12rem;
  margin-right:-12rem
}

.-my-56{
  margin-bottom:-14rem;
  margin-top:-14rem
}

.-mx-56{
  margin-left:-14rem;
  margin-right:-14rem
}

.-my-64{
  margin-bottom:-16rem;
  margin-top:-16rem
}

.-mx-64{
  margin-left:-16rem;
  margin-right:-16rem
}

.-my-px{
  margin-bottom:-1px;
  margin-top:-1px
}

.-mx-px{
  margin-left:-1px;
  margin-right:-1px
}

.mt-0{
  margin-top:0
}

.mr-0{
  margin-right:0
}

.mb-0{
  margin-bottom:0
}

.ml-0{
  margin-left:0
}

.mt-1{
  margin-top:.25rem
}

.mr-1{
  margin-right:.25rem
}

.mb-1{
  margin-bottom:.25rem
}

.ml-1{
  margin-left:.25rem
}

.mt-2{
  margin-top:.5rem
}

.mr-2{
  margin-right:.5rem
}

.mb-2{
  margin-bottom:.5rem
}

.ml-2{
  margin-left:.5rem
}

.mt-3{
  margin-top:.75rem
}

.mr-3{
  margin-right:.75rem
}

.mb-3{
  margin-bottom:.75rem
}

.ml-3{
  margin-left:.75rem
}

.mt-4{
  margin-top:1rem
}

.mr-4{
  margin-right:1rem
}

.mb-4{
  margin-bottom:1rem
}

.ml-4{
  margin-left:1rem
}

.mt-5{
  margin-top:1.25rem
}

.mr-5{
  margin-right:1.25rem
}

.mb-5{
  margin-bottom:1.25rem
}

.ml-5{
  margin-left:1.25rem
}

.mt-6{
  margin-top:1.5rem
}

.mr-6{
  margin-right:1.5rem
}

.mb-6{
  margin-bottom:1.5rem
}

.ml-6{
  margin-left:1.5rem
}

.mt-8{
  margin-top:2rem
}

.mr-8{
  margin-right:2rem
}

.mb-8{
  margin-bottom:2rem
}

.ml-8{
  margin-left:2rem
}

.mt-10{
  margin-top:2.5rem
}

.mr-10{
  margin-right:2.5rem
}

.mb-10{
  margin-bottom:2.5rem
}

.ml-10{
  margin-left:2.5rem
}

.mt-12{
  margin-top:3rem
}

.mr-12{
  margin-right:3rem
}

.mb-12{
  margin-bottom:3rem
}

.ml-12{
  margin-left:3rem
}

.mt-16{
  margin-top:4rem
}

.mr-16{
  margin-right:4rem
}

.mb-16{
  margin-bottom:4rem
}

.ml-16{
  margin-left:4rem
}

.mt-20{
  margin-top:5rem
}

.mr-20{
  margin-right:5rem
}

.mb-20{
  margin-bottom:5rem
}

.ml-20{
  margin-left:5rem
}

.mt-24{
  margin-top:6rem
}

.mr-24{
  margin-right:6rem
}

.mb-24{
  margin-bottom:6rem
}

.ml-24{
  margin-left:6rem
}

.mt-32{
  margin-top:8rem
}

.mr-32{
  margin-right:8rem
}

.mb-32{
  margin-bottom:8rem
}

.ml-32{
  margin-left:8rem
}

.mt-40{
  margin-top:10rem
}

.mr-40{
  margin-right:10rem
}

.mb-40{
  margin-bottom:10rem
}

.ml-40{
  margin-left:10rem
}

.mt-48{
  margin-top:12rem
}

.mr-48{
  margin-right:12rem
}

.mb-48{
  margin-bottom:12rem
}

.ml-48{
  margin-left:12rem
}

.mt-56{
  margin-top:14rem
}

.mr-56{
  margin-right:14rem
}

.mb-56{
  margin-bottom:14rem
}

.ml-56{
  margin-left:14rem
}

.mt-64{
  margin-top:16rem
}

.mr-64{
  margin-right:16rem
}

.mb-64{
  margin-bottom:16rem
}

.ml-64{
  margin-left:16rem
}

.mt-auto{
  margin-top:auto
}

.mr-auto{
  margin-right:auto
}

.mb-auto{
  margin-bottom:auto
}

.ml-auto{
  margin-left:auto
}

.mt-px{
  margin-top:1px
}

.mr-px{
  margin-right:1px
}

.mb-px{
  margin-bottom:1px
}

.ml-px{
  margin-left:1px
}

.-mt-1{
  margin-top:-.25rem
}

.-mr-1{
  margin-right:-.25rem
}

.-mb-1{
  margin-bottom:-.25rem
}

.-ml-1{
  margin-left:-.25rem
}

.-mt-2{
  margin-top:-.5rem
}

.-mr-2{
  margin-right:-.5rem
}

.-mb-2{
  margin-bottom:-.5rem
}

.-ml-2{
  margin-left:-.5rem
}

.-mt-3{
  margin-top:-.75rem
}

.-mr-3{
  margin-right:-.75rem
}

.-mb-3{
  margin-bottom:-.75rem
}

.-ml-3{
  margin-left:-.75rem
}

.-mt-4{
  margin-top:-1rem
}

.-mr-4{
  margin-right:-1rem
}

.-mb-4{
  margin-bottom:-1rem
}

.-ml-4{
  margin-left:-1rem
}

.-mt-5{
  margin-top:-1.25rem
}

.-mr-5{
  margin-right:-1.25rem
}

.-mb-5{
  margin-bottom:-1.25rem
}

.-ml-5{
  margin-left:-1.25rem
}

.-mt-6{
  margin-top:-1.5rem
}

.-mr-6{
  margin-right:-1.5rem
}

.-mb-6{
  margin-bottom:-1.5rem
}

.-ml-6{
  margin-left:-1.5rem
}

.-mt-8{
  margin-top:-2rem
}

.-mr-8{
  margin-right:-2rem
}

.-mb-8{
  margin-bottom:-2rem
}

.-ml-8{
  margin-left:-2rem
}

.-mt-10{
  margin-top:-2.5rem
}

.-mr-10{
  margin-right:-2.5rem
}

.-mb-10{
  margin-bottom:-2.5rem
}

.-ml-10{
  margin-left:-2.5rem
}

.-mt-12{
  margin-top:-3rem
}

.-mr-12{
  margin-right:-3rem
}

.-mb-12{
  margin-bottom:-3rem
}

.-ml-12{
  margin-left:-3rem
}

.-mt-16{
  margin-top:-4rem
}

.-mr-16{
  margin-right:-4rem
}

.-mb-16{
  margin-bottom:-4rem
}

.-ml-16{
  margin-left:-4rem
}

.-mt-20{
  margin-top:-5rem
}

.-mr-20{
  margin-right:-5rem
}

.-mb-20{
  margin-bottom:-5rem
}

.-ml-20{
  margin-left:-5rem
}

.-mt-24{
  margin-top:-6rem
}

.-mr-24{
  margin-right:-6rem
}

.-mb-24{
  margin-bottom:-6rem
}

.-ml-24{
  margin-left:-6rem
}

.-mt-32{
  margin-top:-8rem
}

.-mr-32{
  margin-right:-8rem
}

.-mb-32{
  margin-bottom:-8rem
}

.-ml-32{
  margin-left:-8rem
}

.-mt-40{
  margin-top:-10rem
}

.-mr-40{
  margin-right:-10rem
}

.-mb-40{
  margin-bottom:-10rem
}

.-ml-40{
  margin-left:-10rem
}

.-mt-48{
  margin-top:-12rem
}

.-mr-48{
  margin-right:-12rem
}

.-mb-48{
  margin-bottom:-12rem
}

.-ml-48{
  margin-left:-12rem
}

.-mt-56{
  margin-top:-14rem
}

.-mr-56{
  margin-right:-14rem
}

.-mb-56{
  margin-bottom:-14rem
}

.-ml-56{
  margin-left:-14rem
}

.-mt-64{
  margin-top:-16rem
}

.-mr-64{
  margin-right:-16rem
}

.-mb-64{
  margin-bottom:-16rem
}

.-ml-64{
  margin-left:-16rem
}

.-mt-px{
  margin-top:-1px
}

.-mr-px{
  margin-right:-1px
}

.-mb-px{
  margin-bottom:-1px
}

.-ml-px{
  margin-left:-1px
}

.last\\:m-0:last-child{
  margin:0
}

.last\\:m-1:last-child{
  margin:.25rem
}

.last\\:m-2:last-child{
  margin:.5rem
}

.last\\:m-3:last-child{
  margin:.75rem
}

.last\\:m-4:last-child{
  margin:1rem
}

.last\\:m-5:last-child{
  margin:1.25rem
}

.last\\:m-6:last-child{
  margin:1.5rem
}

.last\\:m-8:last-child{
  margin:2rem
}

.last\\:m-10:last-child{
  margin:2.5rem
}

.last\\:m-12:last-child{
  margin:3rem
}

.last\\:m-16:last-child{
  margin:4rem
}

.last\\:m-20:last-child{
  margin:5rem
}

.last\\:m-24:last-child{
  margin:6rem
}

.last\\:m-32:last-child{
  margin:8rem
}

.last\\:m-40:last-child{
  margin:10rem
}

.last\\:m-48:last-child{
  margin:12rem
}

.last\\:m-56:last-child{
  margin:14rem
}

.last\\:m-64:last-child{
  margin:16rem
}

.last\\:m-auto:last-child{
  margin:auto
}

.last\\:m-px:last-child{
  margin:1px
}

.last\\:-m-1:last-child{
  margin:-.25rem
}

.last\\:-m-2:last-child{
  margin:-.5rem
}

.last\\:-m-3:last-child{
  margin:-.75rem
}

.last\\:-m-4:last-child{
  margin:-1rem
}

.last\\:-m-5:last-child{
  margin:-1.25rem
}

.last\\:-m-6:last-child{
  margin:-1.5rem
}

.last\\:-m-8:last-child{
  margin:-2rem
}

.last\\:-m-10:last-child{
  margin:-2.5rem
}

.last\\:-m-12:last-child{
  margin:-3rem
}

.last\\:-m-16:last-child{
  margin:-4rem
}

.last\\:-m-20:last-child{
  margin:-5rem
}

.last\\:-m-24:last-child{
  margin:-6rem
}

.last\\:-m-32:last-child{
  margin:-8rem
}

.last\\:-m-40:last-child{
  margin:-10rem
}

.last\\:-m-48:last-child{
  margin:-12rem
}

.last\\:-m-56:last-child{
  margin:-14rem
}

.last\\:-m-64:last-child{
  margin:-16rem
}

.last\\:-m-px:last-child{
  margin:-1px
}

.last\\:my-0:last-child{
  margin-bottom:0;
  margin-top:0
}

.last\\:mx-0:last-child{
  margin-left:0;
  margin-right:0
}

.last\\:my-1:last-child{
  margin-bottom:.25rem;
  margin-top:.25rem
}

.last\\:mx-1:last-child{
  margin-left:.25rem;
  margin-right:.25rem
}

.last\\:my-2:last-child{
  margin-bottom:.5rem;
  margin-top:.5rem
}

.last\\:mx-2:last-child{
  margin-left:.5rem;
  margin-right:.5rem
}

.last\\:my-3:last-child{
  margin-bottom:.75rem;
  margin-top:.75rem
}

.last\\:mx-3:last-child{
  margin-left:.75rem;
  margin-right:.75rem
}

.last\\:my-4:last-child{
  margin-bottom:1rem;
  margin-top:1rem
}

.last\\:mx-4:last-child{
  margin-left:1rem;
  margin-right:1rem
}

.last\\:my-5:last-child{
  margin-bottom:1.25rem;
  margin-top:1.25rem
}

.last\\:mx-5:last-child{
  margin-left:1.25rem;
  margin-right:1.25rem
}

.last\\:my-6:last-child{
  margin-bottom:1.5rem;
  margin-top:1.5rem
}

.last\\:mx-6:last-child{
  margin-left:1.5rem;
  margin-right:1.5rem
}

.last\\:my-8:last-child{
  margin-bottom:2rem;
  margin-top:2rem
}

.last\\:mx-8:last-child{
  margin-left:2rem;
  margin-right:2rem
}

.last\\:my-10:last-child{
  margin-bottom:2.5rem;
  margin-top:2.5rem
}

.last\\:mx-10:last-child{
  margin-left:2.5rem;
  margin-right:2.5rem
}

.last\\:my-12:last-child{
  margin-bottom:3rem;
  margin-top:3rem
}

.last\\:mx-12:last-child{
  margin-left:3rem;
  margin-right:3rem
}

.last\\:my-16:last-child{
  margin-bottom:4rem;
  margin-top:4rem
}

.last\\:mx-16:last-child{
  margin-left:4rem;
  margin-right:4rem
}

.last\\:my-20:last-child{
  margin-bottom:5rem;
  margin-top:5rem
}

.last\\:mx-20:last-child{
  margin-left:5rem;
  margin-right:5rem
}

.last\\:my-24:last-child{
  margin-bottom:6rem;
  margin-top:6rem
}

.last\\:mx-24:last-child{
  margin-left:6rem;
  margin-right:6rem
}

.last\\:my-32:last-child{
  margin-bottom:8rem;
  margin-top:8rem
}

.last\\:mx-32:last-child{
  margin-left:8rem;
  margin-right:8rem
}

.last\\:my-40:last-child{
  margin-bottom:10rem;
  margin-top:10rem
}

.last\\:mx-40:last-child{
  margin-left:10rem;
  margin-right:10rem
}

.last\\:my-48:last-child{
  margin-bottom:12rem;
  margin-top:12rem
}

.last\\:mx-48:last-child{
  margin-left:12rem;
  margin-right:12rem
}

.last\\:my-56:last-child{
  margin-bottom:14rem;
  margin-top:14rem
}

.last\\:mx-56:last-child{
  margin-left:14rem;
  margin-right:14rem
}

.last\\:my-64:last-child{
  margin-bottom:16rem;
  margin-top:16rem
}

.last\\:mx-64:last-child{
  margin-left:16rem;
  margin-right:16rem
}

.last\\:my-auto:last-child{
  margin-bottom:auto;
  margin-top:auto
}

.last\\:mx-auto:last-child{
  margin-left:auto;
  margin-right:auto
}

.last\\:my-px:last-child{
  margin-bottom:1px;
  margin-top:1px
}

.last\\:mx-px:last-child{
  margin-left:1px;
  margin-right:1px
}

.last\\:-my-1:last-child{
  margin-bottom:-.25rem;
  margin-top:-.25rem
}

.last\\:-mx-1:last-child{
  margin-left:-.25rem;
  margin-right:-.25rem
}

.last\\:-my-2:last-child{
  margin-bottom:-.5rem;
  margin-top:-.5rem
}

.last\\:-mx-2:last-child{
  margin-left:-.5rem;
  margin-right:-.5rem
}

.last\\:-my-3:last-child{
  margin-bottom:-.75rem;
  margin-top:-.75rem
}

.last\\:-mx-3:last-child{
  margin-left:-.75rem;
  margin-right:-.75rem
}

.last\\:-my-4:last-child{
  margin-bottom:-1rem;
  margin-top:-1rem
}

.last\\:-mx-4:last-child{
  margin-left:-1rem;
  margin-right:-1rem
}

.last\\:-my-5:last-child{
  margin-bottom:-1.25rem;
  margin-top:-1.25rem
}

.last\\:-mx-5:last-child{
  margin-left:-1.25rem;
  margin-right:-1.25rem
}

.last\\:-my-6:last-child{
  margin-bottom:-1.5rem;
  margin-top:-1.5rem
}

.last\\:-mx-6:last-child{
  margin-left:-1.5rem;
  margin-right:-1.5rem
}

.last\\:-my-8:last-child{
  margin-bottom:-2rem;
  margin-top:-2rem
}

.last\\:-mx-8:last-child{
  margin-left:-2rem;
  margin-right:-2rem
}

.last\\:-my-10:last-child{
  margin-bottom:-2.5rem;
  margin-top:-2.5rem
}

.last\\:-mx-10:last-child{
  margin-left:-2.5rem;
  margin-right:-2.5rem
}

.last\\:-my-12:last-child{
  margin-bottom:-3rem;
  margin-top:-3rem
}

.last\\:-mx-12:last-child{
  margin-left:-3rem;
  margin-right:-3rem
}

.last\\:-my-16:last-child{
  margin-bottom:-4rem;
  margin-top:-4rem
}

.last\\:-mx-16:last-child{
  margin-left:-4rem;
  margin-right:-4rem
}

.last\\:-my-20:last-child{
  margin-bottom:-5rem;
  margin-top:-5rem
}

.last\\:-mx-20:last-child{
  margin-left:-5rem;
  margin-right:-5rem
}

.last\\:-my-24:last-child{
  margin-bottom:-6rem;
  margin-top:-6rem
}

.last\\:-mx-24:last-child{
  margin-left:-6rem;
  margin-right:-6rem
}

.last\\:-my-32:last-child{
  margin-bottom:-8rem;
  margin-top:-8rem
}

.last\\:-mx-32:last-child{
  margin-left:-8rem;
  margin-right:-8rem
}

.last\\:-my-40:last-child{
  margin-bottom:-10rem;
  margin-top:-10rem
}

.last\\:-mx-40:last-child{
  margin-left:-10rem;
  margin-right:-10rem
}

.last\\:-my-48:last-child{
  margin-bottom:-12rem;
  margin-top:-12rem
}

.last\\:-mx-48:last-child{
  margin-left:-12rem;
  margin-right:-12rem
}

.last\\:-my-56:last-child{
  margin-bottom:-14rem;
  margin-top:-14rem
}

.last\\:-mx-56:last-child{
  margin-left:-14rem;
  margin-right:-14rem
}

.last\\:-my-64:last-child{
  margin-bottom:-16rem;
  margin-top:-16rem
}

.last\\:-mx-64:last-child{
  margin-left:-16rem;
  margin-right:-16rem
}

.last\\:-my-px:last-child{
  margin-bottom:-1px;
  margin-top:-1px
}

.last\\:-mx-px:last-child{
  margin-left:-1px;
  margin-right:-1px
}

.last\\:mt-0:last-child{
  margin-top:0
}

.last\\:mr-0:last-child{
  margin-right:0
}

.last\\:mb-0:last-child{
  margin-bottom:0
}

.last\\:ml-0:last-child{
  margin-left:0
}

.last\\:mt-1:last-child{
  margin-top:.25rem
}

.last\\:mr-1:last-child{
  margin-right:.25rem
}

.last\\:mb-1:last-child{
  margin-bottom:.25rem
}

.last\\:ml-1:last-child{
  margin-left:.25rem
}

.last\\:mt-2:last-child{
  margin-top:.5rem
}

.last\\:mr-2:last-child{
  margin-right:.5rem
}

.last\\:mb-2:last-child{
  margin-bottom:.5rem
}

.last\\:ml-2:last-child{
  margin-left:.5rem
}

.last\\:mt-3:last-child{
  margin-top:.75rem
}

.last\\:mr-3:last-child{
  margin-right:.75rem
}

.last\\:mb-3:last-child{
  margin-bottom:.75rem
}

.last\\:ml-3:last-child{
  margin-left:.75rem
}

.last\\:mt-4:last-child{
  margin-top:1rem
}

.last\\:mr-4:last-child{
  margin-right:1rem
}

.last\\:mb-4:last-child{
  margin-bottom:1rem
}

.last\\:ml-4:last-child{
  margin-left:1rem
}

.last\\:mt-5:last-child{
  margin-top:1.25rem
}

.last\\:mr-5:last-child{
  margin-right:1.25rem
}

.last\\:mb-5:last-child{
  margin-bottom:1.25rem
}

.last\\:ml-5:last-child{
  margin-left:1.25rem
}

.last\\:mt-6:last-child{
  margin-top:1.5rem
}

.last\\:mr-6:last-child{
  margin-right:1.5rem
}

.last\\:mb-6:last-child{
  margin-bottom:1.5rem
}

.last\\:ml-6:last-child{
  margin-left:1.5rem
}

.last\\:mt-8:last-child{
  margin-top:2rem
}

.last\\:mr-8:last-child{
  margin-right:2rem
}

.last\\:mb-8:last-child{
  margin-bottom:2rem
}

.last\\:ml-8:last-child{
  margin-left:2rem
}

.last\\:mt-10:last-child{
  margin-top:2.5rem
}

.last\\:mr-10:last-child{
  margin-right:2.5rem
}

.last\\:mb-10:last-child{
  margin-bottom:2.5rem
}

.last\\:ml-10:last-child{
  margin-left:2.5rem
}

.last\\:mt-12:last-child{
  margin-top:3rem
}

.last\\:mr-12:last-child{
  margin-right:3rem
}

.last\\:mb-12:last-child{
  margin-bottom:3rem
}

.last\\:ml-12:last-child{
  margin-left:3rem
}

.last\\:mt-16:last-child{
  margin-top:4rem
}

.last\\:mr-16:last-child{
  margin-right:4rem
}

.last\\:mb-16:last-child{
  margin-bottom:4rem
}

.last\\:ml-16:last-child{
  margin-left:4rem
}

.last\\:mt-20:last-child{
  margin-top:5rem
}

.last\\:mr-20:last-child{
  margin-right:5rem
}

.last\\:mb-20:last-child{
  margin-bottom:5rem
}

.last\\:ml-20:last-child{
  margin-left:5rem
}

.last\\:mt-24:last-child{
  margin-top:6rem
}

.last\\:mr-24:last-child{
  margin-right:6rem
}

.last\\:mb-24:last-child{
  margin-bottom:6rem
}

.last\\:ml-24:last-child{
  margin-left:6rem
}

.last\\:mt-32:last-child{
  margin-top:8rem
}

.last\\:mr-32:last-child{
  margin-right:8rem
}

.last\\:mb-32:last-child{
  margin-bottom:8rem
}

.last\\:ml-32:last-child{
  margin-left:8rem
}

.last\\:mt-40:last-child{
  margin-top:10rem
}

.last\\:mr-40:last-child{
  margin-right:10rem
}

.last\\:mb-40:last-child{
  margin-bottom:10rem
}

.last\\:ml-40:last-child{
  margin-left:10rem
}

.last\\:mt-48:last-child{
  margin-top:12rem
}

.last\\:mr-48:last-child{
  margin-right:12rem
}

.last\\:mb-48:last-child{
  margin-bottom:12rem
}

.last\\:ml-48:last-child{
  margin-left:12rem
}

.last\\:mt-56:last-child{
  margin-top:14rem
}

.last\\:mr-56:last-child{
  margin-right:14rem
}

.last\\:mb-56:last-child{
  margin-bottom:14rem
}

.last\\:ml-56:last-child{
  margin-left:14rem
}

.last\\:mt-64:last-child{
  margin-top:16rem
}

.last\\:mr-64:last-child{
  margin-right:16rem
}

.last\\:mb-64:last-child{
  margin-bottom:16rem
}

.last\\:ml-64:last-child{
  margin-left:16rem
}

.last\\:mt-auto:last-child{
  margin-top:auto
}

.last\\:mr-auto:last-child{
  margin-right:auto
}

.last\\:mb-auto:last-child{
  margin-bottom:auto
}

.last\\:ml-auto:last-child{
  margin-left:auto
}

.last\\:mt-px:last-child{
  margin-top:1px
}

.last\\:mr-px:last-child{
  margin-right:1px
}

.last\\:mb-px:last-child{
  margin-bottom:1px
}

.last\\:ml-px:last-child{
  margin-left:1px
}

.last\\:-mt-1:last-child{
  margin-top:-.25rem
}

.last\\:-mr-1:last-child{
  margin-right:-.25rem
}

.last\\:-mb-1:last-child{
  margin-bottom:-.25rem
}

.last\\:-ml-1:last-child{
  margin-left:-.25rem
}

.last\\:-mt-2:last-child{
  margin-top:-.5rem
}

.last\\:-mr-2:last-child{
  margin-right:-.5rem
}

.last\\:-mb-2:last-child{
  margin-bottom:-.5rem
}

.last\\:-ml-2:last-child{
  margin-left:-.5rem
}

.last\\:-mt-3:last-child{
  margin-top:-.75rem
}

.last\\:-mr-3:last-child{
  margin-right:-.75rem
}

.last\\:-mb-3:last-child{
  margin-bottom:-.75rem
}

.last\\:-ml-3:last-child{
  margin-left:-.75rem
}

.last\\:-mt-4:last-child{
  margin-top:-1rem
}

.last\\:-mr-4:last-child{
  margin-right:-1rem
}

.last\\:-mb-4:last-child{
  margin-bottom:-1rem
}

.last\\:-ml-4:last-child{
  margin-left:-1rem
}

.last\\:-mt-5:last-child{
  margin-top:-1.25rem
}

.last\\:-mr-5:last-child{
  margin-right:-1.25rem
}

.last\\:-mb-5:last-child{
  margin-bottom:-1.25rem
}

.last\\:-ml-5:last-child{
  margin-left:-1.25rem
}

.last\\:-mt-6:last-child{
  margin-top:-1.5rem
}

.last\\:-mr-6:last-child{
  margin-right:-1.5rem
}

.last\\:-mb-6:last-child{
  margin-bottom:-1.5rem
}

.last\\:-ml-6:last-child{
  margin-left:-1.5rem
}

.last\\:-mt-8:last-child{
  margin-top:-2rem
}

.last\\:-mr-8:last-child{
  margin-right:-2rem
}

.last\\:-mb-8:last-child{
  margin-bottom:-2rem
}

.last\\:-ml-8:last-child{
  margin-left:-2rem
}

.last\\:-mt-10:last-child{
  margin-top:-2.5rem
}

.last\\:-mr-10:last-child{
  margin-right:-2.5rem
}

.last\\:-mb-10:last-child{
  margin-bottom:-2.5rem
}

.last\\:-ml-10:last-child{
  margin-left:-2.5rem
}

.last\\:-mt-12:last-child{
  margin-top:-3rem
}

.last\\:-mr-12:last-child{
  margin-right:-3rem
}

.last\\:-mb-12:last-child{
  margin-bottom:-3rem
}

.last\\:-ml-12:last-child{
  margin-left:-3rem
}

.last\\:-mt-16:last-child{
  margin-top:-4rem
}

.last\\:-mr-16:last-child{
  margin-right:-4rem
}

.last\\:-mb-16:last-child{
  margin-bottom:-4rem
}

.last\\:-ml-16:last-child{
  margin-left:-4rem
}

.last\\:-mt-20:last-child{
  margin-top:-5rem
}

.last\\:-mr-20:last-child{
  margin-right:-5rem
}

.last\\:-mb-20:last-child{
  margin-bottom:-5rem
}

.last\\:-ml-20:last-child{
  margin-left:-5rem
}

.last\\:-mt-24:last-child{
  margin-top:-6rem
}

.last\\:-mr-24:last-child{
  margin-right:-6rem
}

.last\\:-mb-24:last-child{
  margin-bottom:-6rem
}

.last\\:-ml-24:last-child{
  margin-left:-6rem
}

.last\\:-mt-32:last-child{
  margin-top:-8rem
}

.last\\:-mr-32:last-child{
  margin-right:-8rem
}

.last\\:-mb-32:last-child{
  margin-bottom:-8rem
}

.last\\:-ml-32:last-child{
  margin-left:-8rem
}

.last\\:-mt-40:last-child{
  margin-top:-10rem
}

.last\\:-mr-40:last-child{
  margin-right:-10rem
}

.last\\:-mb-40:last-child{
  margin-bottom:-10rem
}

.last\\:-ml-40:last-child{
  margin-left:-10rem
}

.last\\:-mt-48:last-child{
  margin-top:-12rem
}

.last\\:-mr-48:last-child{
  margin-right:-12rem
}

.last\\:-mb-48:last-child{
  margin-bottom:-12rem
}

.last\\:-ml-48:last-child{
  margin-left:-12rem
}

.last\\:-mt-56:last-child{
  margin-top:-14rem
}

.last\\:-mr-56:last-child{
  margin-right:-14rem
}

.last\\:-mb-56:last-child{
  margin-bottom:-14rem
}

.last\\:-ml-56:last-child{
  margin-left:-14rem
}

.last\\:-mt-64:last-child{
  margin-top:-16rem
}

.last\\:-mr-64:last-child{
  margin-right:-16rem
}

.last\\:-mb-64:last-child{
  margin-bottom:-16rem
}

.last\\:-ml-64:last-child{
  margin-left:-16rem
}

.last\\:-mt-px:last-child{
  margin-top:-1px
}

.last\\:-mr-px:last-child{
  margin-right:-1px
}

.last\\:-mb-px:last-child{
  margin-bottom:-1px
}

.last\\:-ml-px:last-child{
  margin-left:-1px
}

.max-h-0{
  max-height:0
}

.max-h-1{
  max-height:.25rem
}

.max-h-2{
  max-height:.5rem
}

.max-h-3{
  max-height:.75rem
}

.max-h-4{
  max-height:1rem
}

.max-h-5{
  max-height:1.25rem
}

.max-h-6{
  max-height:1.5rem
}

.max-h-8{
  max-height:2rem
}

.max-h-10{
  max-height:2.5rem
}

.max-h-12{
  max-height:3rem
}

.max-h-16{
  max-height:4rem
}

.max-h-20{
  max-height:5rem
}

.max-h-24{
  max-height:6rem
}

.max-h-32{
  max-height:8rem
}

.max-h-40{
  max-height:10rem
}

.max-h-48{
  max-height:12rem
}

.max-h-56{
  max-height:14rem
}

.max-h-64{
  max-height:16rem
}

.max-h-xl{
  max-height:36rem
}

.max-h-px{
  max-height:1px
}

.max-w-none{
  max-width:none
}

.max-w-xs{
  max-width:20rem
}

.max-w-sm{
  max-width:24rem
}

.max-w-md{
  max-width:28rem
}

.max-w-lg{
  max-width:32rem
}

.max-w-xl{
  max-width:36rem
}

.max-w-2xl{
  max-width:42rem
}

.max-w-3xl{
  max-width:48rem
}

.max-w-4xl{
  max-width:56rem
}

.max-w-5xl{
  max-width:64rem
}

.max-w-6xl{
  max-width:72rem
}

.max-w-full{
  max-width:100%
}

.max-w-screen-sm{
  max-width:640px
}

.max-w-screen-md{
  max-width:768px
}

.max-w-screen-lg{
  max-width:1024px
}

.max-w-screen-xl{
  max-width:1280px
}

.min-h-0{
  min-height:0
}

.min-h-full{
  min-height:100%
}

.min-h-screen{
  min-height:100vh
}

.min-w-0{
  min-width:0
}

.min-w-1{
  min-width:.25rem
}

.min-w-2{
  min-width:.5rem
}

.min-w-3{
  min-width:.75rem
}

.min-w-4{
  min-width:1rem
}

.min-w-5{
  min-width:1.25rem
}

.min-w-6{
  min-width:1.5rem
}

.min-w-8{
  min-width:2rem
}

.min-w-10{
  min-width:2.5rem
}

.min-w-12{
  min-width:3rem
}

.min-w-16{
  min-width:4rem
}

.min-w-20{
  min-width:5rem
}

.min-w-24{
  min-width:6rem
}

.min-w-32{
  min-width:8rem
}

.min-w-40{
  min-width:10rem
}

.min-w-48{
  min-width:12rem
}

.min-w-56{
  min-width:14rem
}

.min-w-64{
  min-width:16rem
}

.min-w-max-content{
  min-width:max-content
}

.min-w-px{
  min-width:1px
}

.object-contain{
  object-fit:contain
}

.object-cover{
  object-fit:cover
}

.object-fill{
  object-fit:fill
}

.object-none{
  object-fit:none
}

.object-scale-down{
  object-fit:scale-down
}

.object-bottom{
  object-position:bottom
}

.object-center{
  object-position:center
}

.object-left{
  object-position:left
}

.object-left-bottom{
  object-position:left bottom
}

.object-left-top{
  object-position:left top
}

.object-right{
  object-position:right
}

.object-right-bottom{
  object-position:right bottom
}

.object-right-top{
  object-position:right top
}

.object-top{
  object-position:top
}

.opacity-0{
  opacity:0
}

.opacity-25{
  opacity:.25
}

.opacity-50{
  opacity:.5
}

.opacity-75{
  opacity:.75
}

.opacity-100{
  opacity:1
}

.hover\\:opacity-0:hover{
  opacity:0
}

.hover\\:opacity-25:hover{
  opacity:.25
}

.hover\\:opacity-50:hover{
  opacity:.5
}

.hover\\:opacity-75:hover{
  opacity:.75
}

.hover\\:opacity-100:hover{
  opacity:1
}

.focus\\:opacity-0:focus{
  opacity:0
}

.focus\\:opacity-25:focus{
  opacity:.25
}

.focus\\:opacity-50:focus{
  opacity:.5
}

.focus\\:opacity-75:focus{
  opacity:.75
}

.focus\\:opacity-100:focus{
  opacity:1
}

.focus\\:outline-none:focus,.outline-none{
  outline:0
}

.overflow-auto{
  overflow:auto
}

.overflow-hidden{
  overflow:hidden
}

.overflow-visible{
  overflow:visible
}

.overflow-scroll{
  overflow:scroll
}

.overflow-x-auto{
  overflow-x:auto
}

.overflow-y-auto{
  overflow-y:auto
}

.overflow-x-hidden{
  overflow-x:hidden
}

.overflow-y-hidden{
  overflow-y:hidden
}

.overflow-x-visible{
  overflow-x:visible
}

.overflow-y-visible{
  overflow-y:visible
}

.overflow-x-scroll{
  overflow-x:scroll
}

.overflow-y-scroll{
  overflow-y:scroll
}

.scrolling-touch{
  -webkit-overflow-scrolling:touch
}

.scrolling-auto{
  -webkit-overflow-scrolling:auto
}

.p-0{
  padding:0
}

.p-1{
  padding:.25rem
}

.p-2{
  padding:.5rem
}

.p-3{
  padding:.75rem
}

.p-4{
  padding:1rem
}

.p-5{
  padding:1.25rem
}

.p-6{
  padding:1.5rem
}

.p-8{
  padding:2rem
}

.p-10{
  padding:2.5rem
}

.p-12{
  padding:3rem
}

.p-16{
  padding:4rem
}

.p-20{
  padding:5rem
}

.p-24{
  padding:6rem
}

.p-32{
  padding:8rem
}

.p-40{
  padding:10rem
}

.p-48{
  padding:12rem
}

.p-56{
  padding:14rem
}

.p-64{
  padding:16rem
}

.p-px{
  padding:1px
}

.py-0{
  padding-bottom:0;
  padding-top:0
}

.px-0{
  padding-left:0;
  padding-right:0
}

.py-1{
  padding-bottom:.25rem;
  padding-top:.25rem
}

.px-1{
  padding-left:.25rem;
  padding-right:.25rem
}

.py-2{
  padding-bottom:.5rem;
  padding-top:.5rem
}

.px-2{
  padding-left:.5rem;
  padding-right:.5rem
}

.py-3{
  padding-bottom:.75rem;
  padding-top:.75rem
}

.px-3{
  padding-left:.75rem;
  padding-right:.75rem
}

.py-4{
  padding-bottom:1rem;
  padding-top:1rem
}

.px-4{
  padding-left:1rem;
  padding-right:1rem
}

.py-5{
  padding-bottom:1.25rem;
  padding-top:1.25rem
}

.px-5{
  padding-left:1.25rem;
  padding-right:1.25rem
}

.py-6{
  padding-bottom:1.5rem;
  padding-top:1.5rem
}

.px-6{
  padding-left:1.5rem;
  padding-right:1.5rem
}

.py-8{
  padding-bottom:2rem;
  padding-top:2rem
}

.px-8{
  padding-left:2rem;
  padding-right:2rem
}

.py-10{
  padding-bottom:2.5rem;
  padding-top:2.5rem
}

.px-10{
  padding-left:2.5rem;
  padding-right:2.5rem
}

.py-12{
  padding-bottom:3rem;
  padding-top:3rem
}

.px-12{
  padding-left:3rem;
  padding-right:3rem
}

.py-16{
  padding-bottom:4rem;
  padding-top:4rem
}

.px-16{
  padding-left:4rem;
  padding-right:4rem
}

.py-20{
  padding-bottom:5rem;
  padding-top:5rem
}

.px-20{
  padding-left:5rem;
  padding-right:5rem
}

.py-24{
  padding-bottom:6rem;
  padding-top:6rem
}

.px-24{
  padding-left:6rem;
  padding-right:6rem
}

.py-32{
  padding-bottom:8rem;
  padding-top:8rem
}

.px-32{
  padding-left:8rem;
  padding-right:8rem
}

.py-40{
  padding-bottom:10rem;
  padding-top:10rem
}

.px-40{
  padding-left:10rem;
  padding-right:10rem
}

.py-48{
  padding-bottom:12rem;
  padding-top:12rem
}

.px-48{
  padding-left:12rem;
  padding-right:12rem
}

.py-56{
  padding-bottom:14rem;
  padding-top:14rem
}

.px-56{
  padding-left:14rem;
  padding-right:14rem
}

.py-64{
  padding-bottom:16rem;
  padding-top:16rem
}

.px-64{
  padding-left:16rem;
  padding-right:16rem
}

.py-px{
  padding-bottom:1px;
  padding-top:1px
}

.px-px{
  padding-left:1px;
  padding-right:1px
}

.pt-0{
  padding-top:0
}

.pr-0{
  padding-right:0
}

.pb-0{
  padding-bottom:0
}

.pl-0{
  padding-left:0
}

.pt-1{
  padding-top:.25rem
}

.pr-1{
  padding-right:.25rem
}

.pb-1{
  padding-bottom:.25rem
}

.pl-1{
  padding-left:.25rem
}

.pt-2{
  padding-top:.5rem
}

.pr-2{
  padding-right:.5rem
}

.pb-2{
  padding-bottom:.5rem
}

.pl-2{
  padding-left:.5rem
}

.pt-3{
  padding-top:.75rem
}

.pr-3{
  padding-right:.75rem
}

.pb-3{
  padding-bottom:.75rem
}

.pl-3{
  padding-left:.75rem
}

.pt-4{
  padding-top:1rem
}

.pr-4{
  padding-right:1rem
}

.pb-4{
  padding-bottom:1rem
}

.pl-4{
  padding-left:1rem
}

.pt-5{
  padding-top:1.25rem
}

.pr-5{
  padding-right:1.25rem
}

.pb-5{
  padding-bottom:1.25rem
}

.pl-5{
  padding-left:1.25rem
}

.pt-6{
  padding-top:1.5rem
}

.pr-6{
  padding-right:1.5rem
}

.pb-6{
  padding-bottom:1.5rem
}

.pl-6{
  padding-left:1.5rem
}

.pt-8{
  padding-top:2rem
}

.pr-8{
  padding-right:2rem
}

.pb-8{
  padding-bottom:2rem
}

.pl-8{
  padding-left:2rem
}

.pt-10{
  padding-top:2.5rem
}

.pr-10{
  padding-right:2.5rem
}

.pb-10{
  padding-bottom:2.5rem
}

.pl-10{
  padding-left:2.5rem
}

.pt-12{
  padding-top:3rem
}

.pr-12{
  padding-right:3rem
}

.pb-12{
  padding-bottom:3rem
}

.pl-12{
  padding-left:3rem
}

.pt-16{
  padding-top:4rem
}

.pr-16{
  padding-right:4rem
}

.pb-16{
  padding-bottom:4rem
}

.pl-16{
  padding-left:4rem
}

.pt-20{
  padding-top:5rem
}

.pr-20{
  padding-right:5rem
}

.pb-20{
  padding-bottom:5rem
}

.pl-20{
  padding-left:5rem
}

.pt-24{
  padding-top:6rem
}

.pr-24{
  padding-right:6rem
}

.pb-24{
  padding-bottom:6rem
}

.pl-24{
  padding-left:6rem
}

.pt-32{
  padding-top:8rem
}

.pr-32{
  padding-right:8rem
}

.pb-32{
  padding-bottom:8rem
}

.pl-32{
  padding-left:8rem
}

.pt-40{
  padding-top:10rem
}

.pr-40{
  padding-right:10rem
}

.pb-40{
  padding-bottom:10rem
}

.pl-40{
  padding-left:10rem
}

.pt-48{
  padding-top:12rem
}

.pr-48{
  padding-right:12rem
}

.pb-48{
  padding-bottom:12rem
}

.pl-48{
  padding-left:12rem
}

.pt-56{
  padding-top:14rem
}

.pr-56{
  padding-right:14rem
}

.pb-56{
  padding-bottom:14rem
}

.pl-56{
  padding-left:14rem
}

.pt-64{
  padding-top:16rem
}

.pr-64{
  padding-right:16rem
}

.pb-64{
  padding-bottom:16rem
}

.pl-64{
  padding-left:16rem
}

.pt-px{
  padding-top:1px
}

.pr-px{
  padding-right:1px
}

.pb-px{
  padding-bottom:1px
}

.pl-px{
  padding-left:1px
}

.placeholder-transparent::placeholder{
  color:#0000
}

.placeholder-white::placeholder{
  --placeholder-opacity:1;
  color:#fff;
  color:rgba(255,255,255,var(--placeholder-opacity))
}

.placeholder-black::placeholder{
  --placeholder-opacity:1;
  color:#000;
  color:rgba(0,0,0,var(--placeholder-opacity))
}

.placeholder-gray-50::placeholder{
  --placeholder-opacity:1;
  color:#f9fafb;
  color:rgba(249,250,251,var(--placeholder-opacity))
}

.placeholder-gray-100::placeholder{
  --placeholder-opacity:1;
  color:#f4f5f7;
  color:rgba(244,245,247,var(--placeholder-opacity))
}

.placeholder-gray-200::placeholder{
  --placeholder-opacity:1;
  color:#e5e7eb;
  color:rgba(229,231,235,var(--placeholder-opacity))
}

.placeholder-gray-300::placeholder{
  --placeholder-opacity:1;
  color:#d5d6d7;
  color:rgba(213,214,215,var(--placeholder-opacity))
}

.placeholder-gray-400::placeholder{
  --placeholder-opacity:1;
  color:#9e9e9e;
  color:rgba(158,158,158,var(--placeholder-opacity))
}

.placeholder-gray-500::placeholder{
  --placeholder-opacity:1;
  color:#707275;
  color:rgba(112,114,117,var(--placeholder-opacity))
}

.placeholder-gray-600::placeholder{
  --placeholder-opacity:1;
  color:#4c4f52;
  color:rgba(76,79,82,var(--placeholder-opacity))
}

.placeholder-gray-700::placeholder{
  --placeholder-opacity:1;
  color:#24262d;
  color:rgba(36,38,45,var(--placeholder-opacity))
}

.placeholder-gray-800::placeholder{
  --placeholder-opacity:1;
  color:#1a1c23;
  color:rgba(26,28,35,var(--placeholder-opacity))
}

.placeholder-gray-900::placeholder{
  --placeholder-opacity:1;
  color:#121317;
  color:rgba(18,19,23,var(--placeholder-opacity))
}

.placeholder-cool-gray-50::placeholder{
  --placeholder-opacity:1;
  color:#fbfdfe;
  color:rgba(251,253,254,var(--placeholder-opacity))
}

.placeholder-cool-gray-100::placeholder{
  --placeholder-opacity:1;
  color:#f1f5f9;
  color:rgba(241,245,249,var(--placeholder-opacity))
}

.placeholder-cool-gray-200::placeholder{
  --placeholder-opacity:1;
  color:#e2e8f0;
  color:rgba(226,232,240,var(--placeholder-opacity))
}

.placeholder-cool-gray-300::placeholder{
  --placeholder-opacity:1;
  color:#cfd8e3;
  color:rgba(207,216,227,var(--placeholder-opacity))
}

.placeholder-cool-gray-400::placeholder{
  --placeholder-opacity:1;
  color:#97a6ba;
  color:rgba(151,166,186,var(--placeholder-opacity))
}

.placeholder-cool-gray-500::placeholder{
  --placeholder-opacity:1;
  color:#64748b;
  color:rgba(100,116,139,var(--placeholder-opacity))
}

.placeholder-cool-gray-600::placeholder{
  --placeholder-opacity:1;
  color:#475569;
  color:rgba(71,85,105,var(--placeholder-opacity))
}

.placeholder-cool-gray-700::placeholder{
  --placeholder-opacity:1;
  color:#364152;
  color:rgba(54,65,82,var(--placeholder-opacity))
}

.placeholder-cool-gray-800::placeholder{
  --placeholder-opacity:1;
  color:#27303f;
  color:rgba(39,48,63,var(--placeholder-opacity))
}

.placeholder-cool-gray-900::placeholder{
  --placeholder-opacity:1;
  color:#1a202e;
  color:rgba(26,32,46,var(--placeholder-opacity))
}

.placeholder-red-50::placeholder{
  --placeholder-opacity:1;
  color:#fdf2f2;
  color:rgba(253,242,242,var(--placeholder-opacity))
}

.placeholder-red-100::placeholder{
  --placeholder-opacity:1;
  color:#fde8e8;
  color:rgba(253,232,232,var(--placeholder-opacity))
}

.placeholder-red-200::placeholder{
  --placeholder-opacity:1;
  color:#fbd5d5;
  color:rgba(251,213,213,var(--placeholder-opacity))
}

.placeholder-red-300::placeholder{
  --placeholder-opacity:1;
  color:#f8b4b4;
  color:rgba(248,180,180,var(--placeholder-opacity))
}

.placeholder-red-400::placeholder{
  --placeholder-opacity:1;
  color:#f98080;
  color:rgba(249,128,128,var(--placeholder-opacity))
}

.placeholder-red-500::placeholder{
  --placeholder-opacity:1;
  color:#f05252;
  color:rgba(240,82,82,var(--placeholder-opacity))
}

.placeholder-red-600::placeholder{
  --placeholder-opacity:1;
  color:#e02424;
  color:rgba(224,36,36,var(--placeholder-opacity))
}

.placeholder-red-700::placeholder{
  --placeholder-opacity:1;
  color:#c81e1e;
  color:rgba(200,30,30,var(--placeholder-opacity))
}

.placeholder-red-800::placeholder{
  --placeholder-opacity:1;
  color:#9b1c1c;
  color:rgba(155,28,28,var(--placeholder-opacity))
}

.placeholder-red-900::placeholder{
  --placeholder-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--placeholder-opacity))
}

.placeholder-orange-50::placeholder{
  --placeholder-opacity:1;
  color:#fff8f1;
  color:rgba(255,248,241,var(--placeholder-opacity))
}

.placeholder-orange-100::placeholder{
  --placeholder-opacity:1;
  color:#feecdc;
  color:rgba(254,236,220,var(--placeholder-opacity))
}

.placeholder-orange-200::placeholder{
  --placeholder-opacity:1;
  color:#fcd9bd;
  color:rgba(252,217,189,var(--placeholder-opacity))
}

.placeholder-orange-300::placeholder{
  --placeholder-opacity:1;
  color:#fdba8c;
  color:rgba(253,186,140,var(--placeholder-opacity))
}

.placeholder-orange-400::placeholder{
  --placeholder-opacity:1;
  color:#ff8a4c;
  color:rgba(255,138,76,var(--placeholder-opacity))
}

.placeholder-orange-500::placeholder{
  --placeholder-opacity:1;
  color:#ff5a1f;
  color:rgba(255,90,31,var(--placeholder-opacity))
}

.placeholder-orange-600::placeholder{
  --placeholder-opacity:1;
  color:#d03801;
  color:rgba(208,56,1,var(--placeholder-opacity))
}

.placeholder-orange-700::placeholder{
  --placeholder-opacity:1;
  color:#b43403;
  color:rgba(180,52,3,var(--placeholder-opacity))
}

.placeholder-orange-800::placeholder{
  --placeholder-opacity:1;
  color:#8a2c0d;
  color:rgba(138,44,13,var(--placeholder-opacity))
}

.placeholder-orange-900::placeholder{
  --placeholder-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--placeholder-opacity))
}

.placeholder-yellow-50::placeholder{
  --placeholder-opacity:1;
  color:#fdfdea;
  color:rgba(253,253,234,var(--placeholder-opacity))
}

.placeholder-yellow-100::placeholder{
  --placeholder-opacity:1;
  color:#fdf6b2;
  color:rgba(253,246,178,var(--placeholder-opacity))
}

.placeholder-yellow-200::placeholder{
  --placeholder-opacity:1;
  color:#fce96a;
  color:rgba(252,233,106,var(--placeholder-opacity))
}

.placeholder-yellow-300::placeholder{
  --placeholder-opacity:1;
  color:#faca15;
  color:rgba(250,202,21,var(--placeholder-opacity))
}

.placeholder-yellow-400::placeholder{
  --placeholder-opacity:1;
  color:#e3a008;
  color:rgba(227,160,8,var(--placeholder-opacity))
}

.placeholder-yellow-500::placeholder{
  --placeholder-opacity:1;
  color:#c27803;
  color:rgba(194,120,3,var(--placeholder-opacity))
}

.placeholder-yellow-600::placeholder{
  --placeholder-opacity:1;
  color:#9f580a;
  color:rgba(159,88,10,var(--placeholder-opacity))
}

.placeholder-yellow-700::placeholder{
  --placeholder-opacity:1;
  color:#8e4b10;
  color:rgba(142,75,16,var(--placeholder-opacity))
}

.placeholder-yellow-800::placeholder{
  --placeholder-opacity:1;
  color:#723b13;
  color:rgba(114,59,19,var(--placeholder-opacity))
}

.placeholder-yellow-900::placeholder{
  --placeholder-opacity:1;
  color:#633112;
  color:rgba(99,49,18,var(--placeholder-opacity))
}

.placeholder-green-50::placeholder{
  --placeholder-opacity:1;
  color:#f3faf7;
  color:rgba(243,250,247,var(--placeholder-opacity))
}

.placeholder-green-100::placeholder{
  --placeholder-opacity:1;
  color:#def7ec;
  color:rgba(222,247,236,var(--placeholder-opacity))
}

.placeholder-green-200::placeholder{
  --placeholder-opacity:1;
  color:#bcf0da;
  color:rgba(188,240,218,var(--placeholder-opacity))
}

.placeholder-green-300::placeholder{
  --placeholder-opacity:1;
  color:#84e1bc;
  color:rgba(132,225,188,var(--placeholder-opacity))
}

.placeholder-green-400::placeholder{
  --placeholder-opacity:1;
  color:#31c48d;
  color:rgba(49,196,141,var(--placeholder-opacity))
}

.placeholder-green-500::placeholder{
  --placeholder-opacity:1;
  color:#0e9f6e;
  color:rgba(14,159,110,var(--placeholder-opacity))
}

.placeholder-green-600::placeholder{
  --placeholder-opacity:1;
  color:#057a55;
  color:rgba(5,122,85,var(--placeholder-opacity))
}

.placeholder-green-700::placeholder{
  --placeholder-opacity:1;
  color:#046c4e;
  color:rgba(4,108,78,var(--placeholder-opacity))
}

.placeholder-green-800::placeholder{
  --placeholder-opacity:1;
  color:#03543f;
  color:rgba(3,84,63,var(--placeholder-opacity))
}

.placeholder-green-900::placeholder{
  --placeholder-opacity:1;
  color:#014737;
  color:rgba(1,71,55,var(--placeholder-opacity))
}

.placeholder-teal-50::placeholder{
  --placeholder-opacity:1;
  color:#edfafa;
  color:rgba(237,250,250,var(--placeholder-opacity))
}

.placeholder-teal-100::placeholder{
  --placeholder-opacity:1;
  color:#d5f5f6;
  color:rgba(213,245,246,var(--placeholder-opacity))
}

.placeholder-teal-200::placeholder{
  --placeholder-opacity:1;
  color:#afecef;
  color:rgba(175,236,239,var(--placeholder-opacity))
}

.placeholder-teal-300::placeholder{
  --placeholder-opacity:1;
  color:#7edce2;
  color:rgba(126,220,226,var(--placeholder-opacity))
}

.placeholder-teal-400::placeholder{
  --placeholder-opacity:1;
  color:#16bdca;
  color:rgba(22,189,202,var(--placeholder-opacity))
}

.placeholder-teal-500::placeholder{
  --placeholder-opacity:1;
  color:#0694a2;
  color:rgba(6,148,162,var(--placeholder-opacity))
}

.placeholder-teal-600::placeholder{
  --placeholder-opacity:1;
  color:#047481;
  color:rgba(4,116,129,var(--placeholder-opacity))
}

.placeholder-teal-700::placeholder{
  --placeholder-opacity:1;
  color:#036672;
  color:rgba(3,102,114,var(--placeholder-opacity))
}

.placeholder-teal-800::placeholder{
  --placeholder-opacity:1;
  color:#05505c;
  color:rgba(5,80,92,var(--placeholder-opacity))
}

.placeholder-teal-900::placeholder{
  --placeholder-opacity:1;
  color:#014451;
  color:rgba(1,68,81,var(--placeholder-opacity))
}

.placeholder-blue-50::placeholder{
  --placeholder-opacity:1;
  color:#ebf5ff;
  color:rgba(235,245,255,var(--placeholder-opacity))
}

.placeholder-blue-100::placeholder{
  --placeholder-opacity:1;
  color:#e1effe;
  color:rgba(225,239,254,var(--placeholder-opacity))
}

.placeholder-blue-200::placeholder{
  --placeholder-opacity:1;
  color:#c3ddfd;
  color:rgba(195,221,253,var(--placeholder-opacity))
}

.placeholder-blue-300::placeholder{
  --placeholder-opacity:1;
  color:#a4cafe;
  color:rgba(164,202,254,var(--placeholder-opacity))
}

.placeholder-blue-400::placeholder{
  --placeholder-opacity:1;
  color:#76a9fa;
  color:rgba(118,169,250,var(--placeholder-opacity))
}

.placeholder-blue-500::placeholder{
  --placeholder-opacity:1;
  color:#3f83f8;
  color:rgba(63,131,248,var(--placeholder-opacity))
}

.placeholder-blue-600::placeholder{
  --placeholder-opacity:1;
  color:#1c64f2;
  color:rgba(28,100,242,var(--placeholder-opacity))
}

.placeholder-blue-700::placeholder{
  --placeholder-opacity:1;
  color:#1a56db;
  color:rgba(26,86,219,var(--placeholder-opacity))
}

.placeholder-blue-800::placeholder{
  --placeholder-opacity:1;
  color:#1e429f;
  color:rgba(30,66,159,var(--placeholder-opacity))
}

.placeholder-blue-900::placeholder{
  --placeholder-opacity:1;
  color:#233876;
  color:rgba(35,56,118,var(--placeholder-opacity))
}

.placeholder-indigo-50::placeholder{
  --placeholder-opacity:1;
  color:#f0f5ff;
  color:rgba(240,245,255,var(--placeholder-opacity))
}

.placeholder-indigo-100::placeholder{
  --placeholder-opacity:1;
  color:#e5edff;
  color:rgba(229,237,255,var(--placeholder-opacity))
}

.placeholder-indigo-200::placeholder{
  --placeholder-opacity:1;
  color:#cddbfe;
  color:rgba(205,219,254,var(--placeholder-opacity))
}

.placeholder-indigo-300::placeholder{
  --placeholder-opacity:1;
  color:#b4c6fc;
  color:rgba(180,198,252,var(--placeholder-opacity))
}

.placeholder-indigo-400::placeholder{
  --placeholder-opacity:1;
  color:#8da2fb;
  color:rgba(141,162,251,var(--placeholder-opacity))
}

.placeholder-indigo-500::placeholder{
  --placeholder-opacity:1;
  color:#6875f5;
  color:rgba(104,117,245,var(--placeholder-opacity))
}

.placeholder-indigo-600::placeholder{
  --placeholder-opacity:1;
  color:#5850ec;
  color:rgba(88,80,236,var(--placeholder-opacity))
}

.placeholder-indigo-700::placeholder{
  --placeholder-opacity:1;
  color:#5145cd;
  color:rgba(81,69,205,var(--placeholder-opacity))
}

.placeholder-indigo-800::placeholder{
  --placeholder-opacity:1;
  color:#42389d;
  color:rgba(66,56,157,var(--placeholder-opacity))
}

.placeholder-indigo-900::placeholder{
  --placeholder-opacity:1;
  color:#362f78;
  color:rgba(54,47,120,var(--placeholder-opacity))
}

.placeholder-indigo-50::placeholder{
  --placeholder-opacity:1;
  color:#f6f5ff;
  color:rgba(246,245,255,var(--placeholder-opacity))
}

.placeholder-indigo-100::placeholder{
  --placeholder-opacity:1;
  color:#edebfe;
  color:rgba(237,235,254,var(--placeholder-opacity))
}

.placeholder-indigo-200::placeholder{
  --placeholder-opacity:1;
  color:#dcd7fe;
  color:rgba(220,215,254,var(--placeholder-opacity))
}

.placeholder-indigo-300::placeholder{
  --placeholder-opacity:1;
  color:#cabffd;
  color:rgba(202,191,253,var(--placeholder-opacity))
}

.placeholder-indigo-400::placeholder{
  --placeholder-opacity:1;
  color:#ac94fa;
  color:rgba(172,148,250,var(--placeholder-opacity))
}

.placeholder-indigo-500::placeholder{
  --placeholder-opacity:1;
  color:#9061f9;
  color:rgba(144,97,249,var(--placeholder-opacity))
}

.placeholder-indigo-600::placeholder{
  --placeholder-opacity:1;
  color:#7e3af2;
  color:rgba(126,58,242,var(--placeholder-opacity))
}

.placeholder-indigo-700::placeholder{
  --placeholder-opacity:1;
  color:#6c2bd9;
  color:rgba(108,43,217,var(--placeholder-opacity))
}

.placeholder-indigo-800::placeholder{
  --placeholder-opacity:1;
  color:#5521b5;
  color:rgba(85,33,181,var(--placeholder-opacity))
}

.placeholder-indigo-900::placeholder{
  --placeholder-opacity:1;
  color:#4a1d96;
  color:rgba(74,29,150,var(--placeholder-opacity))
}

.placeholder-pink-50::placeholder{
  --placeholder-opacity:1;
  color:#fdf2f8;
  color:rgba(253,242,248,var(--placeholder-opacity))
}

.placeholder-pink-100::placeholder{
  --placeholder-opacity:1;
  color:#fce8f3;
  color:rgba(252,232,243,var(--placeholder-opacity))
}

.placeholder-pink-200::placeholder{
  --placeholder-opacity:1;
  color:#fad1e8;
  color:rgba(250,209,232,var(--placeholder-opacity))
}

.placeholder-pink-300::placeholder{
  --placeholder-opacity:1;
  color:#f8b4d9;
  color:rgba(248,180,217,var(--placeholder-opacity))
}

.placeholder-pink-400::placeholder{
  --placeholder-opacity:1;
  color:#f17eb8;
  color:rgba(241,126,184,var(--placeholder-opacity))
}

.placeholder-pink-500::placeholder{
  --placeholder-opacity:1;
  color:#e74694;
  color:rgba(231,70,148,var(--placeholder-opacity))
}

.placeholder-pink-600::placeholder{
  --placeholder-opacity:1;
  color:#d61f69;
  color:rgba(214,31,105,var(--placeholder-opacity))
}

.placeholder-pink-700::placeholder{
  --placeholder-opacity:1;
  color:#bf125d;
  color:rgba(191,18,93,var(--placeholder-opacity))
}

.placeholder-pink-800::placeholder{
  --placeholder-opacity:1;
  color:#99154b;
  color:rgba(153,21,75,var(--placeholder-opacity))
}

.placeholder-pink-900::placeholder{
  --placeholder-opacity:1;
  color:#751a3d;
  color:rgba(117,26,61,var(--placeholder-opacity))
}

.focus\\:placeholder-transparent:focus::placeholder{
  color:#0000
}

.focus\\:placeholder-white:focus::placeholder{
  --placeholder-opacity:1;
  color:#fff;
  color:rgba(255,255,255,var(--placeholder-opacity))
}

.focus\\:placeholder-black:focus::placeholder{
  --placeholder-opacity:1;
  color:#000;
  color:rgba(0,0,0,var(--placeholder-opacity))
}

.focus\\:placeholder-gray-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#f9fafb;
  color:rgba(249,250,251,var(--placeholder-opacity))
}

.focus\\:placeholder-gray-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#f4f5f7;
  color:rgba(244,245,247,var(--placeholder-opacity))
}

.focus\\:placeholder-gray-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#e5e7eb;
  color:rgba(229,231,235,var(--placeholder-opacity))
}

.focus\\:placeholder-gray-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#d5d6d7;
  color:rgba(213,214,215,var(--placeholder-opacity))
}

.focus\\:placeholder-gray-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#9e9e9e;
  color:rgba(158,158,158,var(--placeholder-opacity))
}

.focus\\:placeholder-gray-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#707275;
  color:rgba(112,114,117,var(--placeholder-opacity))
}

.focus\\:placeholder-gray-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#4c4f52;
  color:rgba(76,79,82,var(--placeholder-opacity))
}

.focus\\:placeholder-gray-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#24262d;
  color:rgba(36,38,45,var(--placeholder-opacity))
}

.focus\\:placeholder-gray-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#1a1c23;
  color:rgba(26,28,35,var(--placeholder-opacity))
}

.focus\\:placeholder-gray-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#121317;
  color:rgba(18,19,23,var(--placeholder-opacity))
}

.focus\\:placeholder-cool-gray-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#fbfdfe;
  color:rgba(251,253,254,var(--placeholder-opacity))
}

.focus\\:placeholder-cool-gray-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#f1f5f9;
  color:rgba(241,245,249,var(--placeholder-opacity))
}

.focus\\:placeholder-cool-gray-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#e2e8f0;
  color:rgba(226,232,240,var(--placeholder-opacity))
}

.focus\\:placeholder-cool-gray-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#cfd8e3;
  color:rgba(207,216,227,var(--placeholder-opacity))
}

.focus\\:placeholder-cool-gray-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#97a6ba;
  color:rgba(151,166,186,var(--placeholder-opacity))
}

.focus\\:placeholder-cool-gray-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#64748b;
  color:rgba(100,116,139,var(--placeholder-opacity))
}

.focus\\:placeholder-cool-gray-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#475569;
  color:rgba(71,85,105,var(--placeholder-opacity))
}

.focus\\:placeholder-cool-gray-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#364152;
  color:rgba(54,65,82,var(--placeholder-opacity))
}

.focus\\:placeholder-cool-gray-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#27303f;
  color:rgba(39,48,63,var(--placeholder-opacity))
}

.focus\\:placeholder-cool-gray-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#1a202e;
  color:rgba(26,32,46,var(--placeholder-opacity))
}

.focus\\:placeholder-red-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#fdf2f2;
  color:rgba(253,242,242,var(--placeholder-opacity))
}

.focus\\:placeholder-red-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#fde8e8;
  color:rgba(253,232,232,var(--placeholder-opacity))
}

.focus\\:placeholder-red-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#fbd5d5;
  color:rgba(251,213,213,var(--placeholder-opacity))
}

.focus\\:placeholder-red-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#f8b4b4;
  color:rgba(248,180,180,var(--placeholder-opacity))
}

.focus\\:placeholder-red-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#f98080;
  color:rgba(249,128,128,var(--placeholder-opacity))
}

.focus\\:placeholder-red-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#f05252;
  color:rgba(240,82,82,var(--placeholder-opacity))
}

.focus\\:placeholder-red-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#e02424;
  color:rgba(224,36,36,var(--placeholder-opacity))
}

.focus\\:placeholder-red-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#c81e1e;
  color:rgba(200,30,30,var(--placeholder-opacity))
}

.focus\\:placeholder-red-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#9b1c1c;
  color:rgba(155,28,28,var(--placeholder-opacity))
}

.focus\\:placeholder-red-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--placeholder-opacity))
}

.focus\\:placeholder-orange-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#fff8f1;
  color:rgba(255,248,241,var(--placeholder-opacity))
}

.focus\\:placeholder-orange-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#feecdc;
  color:rgba(254,236,220,var(--placeholder-opacity))
}

.focus\\:placeholder-orange-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#fcd9bd;
  color:rgba(252,217,189,var(--placeholder-opacity))
}

.focus\\:placeholder-orange-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#fdba8c;
  color:rgba(253,186,140,var(--placeholder-opacity))
}

.focus\\:placeholder-orange-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#ff8a4c;
  color:rgba(255,138,76,var(--placeholder-opacity))
}

.focus\\:placeholder-orange-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#ff5a1f;
  color:rgba(255,90,31,var(--placeholder-opacity))
}

.focus\\:placeholder-orange-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#d03801;
  color:rgba(208,56,1,var(--placeholder-opacity))
}

.focus\\:placeholder-orange-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#b43403;
  color:rgba(180,52,3,var(--placeholder-opacity))
}

.focus\\:placeholder-orange-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#8a2c0d;
  color:rgba(138,44,13,var(--placeholder-opacity))
}

.focus\\:placeholder-orange-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--placeholder-opacity))
}

.focus\\:placeholder-yellow-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#fdfdea;
  color:rgba(253,253,234,var(--placeholder-opacity))
}

.focus\\:placeholder-yellow-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#fdf6b2;
  color:rgba(253,246,178,var(--placeholder-opacity))
}

.focus\\:placeholder-yellow-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#fce96a;
  color:rgba(252,233,106,var(--placeholder-opacity))
}

.focus\\:placeholder-yellow-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#faca15;
  color:rgba(250,202,21,var(--placeholder-opacity))
}

.focus\\:placeholder-yellow-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#e3a008;
  color:rgba(227,160,8,var(--placeholder-opacity))
}

.focus\\:placeholder-yellow-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#c27803;
  color:rgba(194,120,3,var(--placeholder-opacity))
}

.focus\\:placeholder-yellow-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#9f580a;
  color:rgba(159,88,10,var(--placeholder-opacity))
}

.focus\\:placeholder-yellow-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#8e4b10;
  color:rgba(142,75,16,var(--placeholder-opacity))
}

.focus\\:placeholder-yellow-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#723b13;
  color:rgba(114,59,19,var(--placeholder-opacity))
}

.focus\\:placeholder-yellow-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#633112;
  color:rgba(99,49,18,var(--placeholder-opacity))
}

.focus\\:placeholder-green-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#f3faf7;
  color:rgba(243,250,247,var(--placeholder-opacity))
}

.focus\\:placeholder-green-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#def7ec;
  color:rgba(222,247,236,var(--placeholder-opacity))
}

.focus\\:placeholder-green-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#bcf0da;
  color:rgba(188,240,218,var(--placeholder-opacity))
}

.focus\\:placeholder-green-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#84e1bc;
  color:rgba(132,225,188,var(--placeholder-opacity))
}

.focus\\:placeholder-green-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#31c48d;
  color:rgba(49,196,141,var(--placeholder-opacity))
}

.focus\\:placeholder-green-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#0e9f6e;
  color:rgba(14,159,110,var(--placeholder-opacity))
}

.focus\\:placeholder-green-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#057a55;
  color:rgba(5,122,85,var(--placeholder-opacity))
}

.focus\\:placeholder-green-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#046c4e;
  color:rgba(4,108,78,var(--placeholder-opacity))
}

.focus\\:placeholder-green-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#03543f;
  color:rgba(3,84,63,var(--placeholder-opacity))
}

.focus\\:placeholder-green-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#014737;
  color:rgba(1,71,55,var(--placeholder-opacity))
}

.focus\\:placeholder-teal-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#edfafa;
  color:rgba(237,250,250,var(--placeholder-opacity))
}

.focus\\:placeholder-teal-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#d5f5f6;
  color:rgba(213,245,246,var(--placeholder-opacity))
}

.focus\\:placeholder-teal-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#afecef;
  color:rgba(175,236,239,var(--placeholder-opacity))
}

.focus\\:placeholder-teal-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#7edce2;
  color:rgba(126,220,226,var(--placeholder-opacity))
}

.focus\\:placeholder-teal-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#16bdca;
  color:rgba(22,189,202,var(--placeholder-opacity))
}

.focus\\:placeholder-teal-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#0694a2;
  color:rgba(6,148,162,var(--placeholder-opacity))
}

.focus\\:placeholder-teal-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#047481;
  color:rgba(4,116,129,var(--placeholder-opacity))
}

.focus\\:placeholder-teal-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#036672;
  color:rgba(3,102,114,var(--placeholder-opacity))
}

.focus\\:placeholder-teal-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#05505c;
  color:rgba(5,80,92,var(--placeholder-opacity))
}

.focus\\:placeholder-teal-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#014451;
  color:rgba(1,68,81,var(--placeholder-opacity))
}

.focus\\:placeholder-blue-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#ebf5ff;
  color:rgba(235,245,255,var(--placeholder-opacity))
}

.focus\\:placeholder-blue-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#e1effe;
  color:rgba(225,239,254,var(--placeholder-opacity))
}

.focus\\:placeholder-blue-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#c3ddfd;
  color:rgba(195,221,253,var(--placeholder-opacity))
}

.focus\\:placeholder-blue-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#a4cafe;
  color:rgba(164,202,254,var(--placeholder-opacity))
}

.focus\\:placeholder-blue-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#76a9fa;
  color:rgba(118,169,250,var(--placeholder-opacity))
}

.focus\\:placeholder-blue-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#3f83f8;
  color:rgba(63,131,248,var(--placeholder-opacity))
}

.focus\\:placeholder-blue-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#1c64f2;
  color:rgba(28,100,242,var(--placeholder-opacity))
}

.focus\\:placeholder-blue-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#1a56db;
  color:rgba(26,86,219,var(--placeholder-opacity))
}

.focus\\:placeholder-blue-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#1e429f;
  color:rgba(30,66,159,var(--placeholder-opacity))
}

.focus\\:placeholder-blue-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#233876;
  color:rgba(35,56,118,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#f0f5ff;
  color:rgba(240,245,255,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#e5edff;
  color:rgba(229,237,255,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#cddbfe;
  color:rgba(205,219,254,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#b4c6fc;
  color:rgba(180,198,252,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#8da2fb;
  color:rgba(141,162,251,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#6875f5;
  color:rgba(104,117,245,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#5850ec;
  color:rgba(88,80,236,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#5145cd;
  color:rgba(81,69,205,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#42389d;
  color:rgba(66,56,157,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#362f78;
  color:rgba(54,47,120,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#f6f5ff;
  color:rgba(246,245,255,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#edebfe;
  color:rgba(237,235,254,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#dcd7fe;
  color:rgba(220,215,254,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#cabffd;
  color:rgba(202,191,253,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#ac94fa;
  color:rgba(172,148,250,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#9061f9;
  color:rgba(144,97,249,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#7e3af2;
  color:rgba(126,58,242,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#6c2bd9;
  color:rgba(108,43,217,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#5521b5;
  color:rgba(85,33,181,var(--placeholder-opacity))
}

.focus\\:placeholder-indigo-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#4a1d96;
  color:rgba(74,29,150,var(--placeholder-opacity))
}

.focus\\:placeholder-pink-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#fdf2f8;
  color:rgba(253,242,248,var(--placeholder-opacity))
}

.focus\\:placeholder-pink-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#fce8f3;
  color:rgba(252,232,243,var(--placeholder-opacity))
}

.focus\\:placeholder-pink-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#fad1e8;
  color:rgba(250,209,232,var(--placeholder-opacity))
}

.focus\\:placeholder-pink-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#f8b4d9;
  color:rgba(248,180,217,var(--placeholder-opacity))
}

.focus\\:placeholder-pink-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#f17eb8;
  color:rgba(241,126,184,var(--placeholder-opacity))
}

.focus\\:placeholder-pink-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#e74694;
  color:rgba(231,70,148,var(--placeholder-opacity))
}

.focus\\:placeholder-pink-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#d61f69;
  color:rgba(214,31,105,var(--placeholder-opacity))
}

.focus\\:placeholder-pink-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#bf125d;
  color:rgba(191,18,93,var(--placeholder-opacity))
}

.focus\\:placeholder-pink-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#99154b;
  color:rgba(153,21,75,var(--placeholder-opacity))
}

.focus\\:placeholder-pink-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#751a3d;
  color:rgba(117,26,61,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-transparent::placeholder{
  color:#0000
}

.theme-dark .dark\\:placeholder-white::placeholder{
  --placeholder-opacity:1;
  color:#fff;
  color:rgba(255,255,255,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-black::placeholder{
  --placeholder-opacity:1;
  color:#000;
  color:rgba(0,0,0,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-gray-50::placeholder{
  --placeholder-opacity:1;
  color:#f9fafb;
  color:rgba(249,250,251,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-gray-100::placeholder{
  --placeholder-opacity:1;
  color:#f4f5f7;
  color:rgba(244,245,247,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-gray-200::placeholder{
  --placeholder-opacity:1;
  color:#e5e7eb;
  color:rgba(229,231,235,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-gray-300::placeholder{
  --placeholder-opacity:1;
  color:#d5d6d7;
  color:rgba(213,214,215,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-gray-400::placeholder{
  --placeholder-opacity:1;
  color:#9e9e9e;
  color:rgba(158,158,158,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-gray-500::placeholder{
  --placeholder-opacity:1;
  color:#707275;
  color:rgba(112,114,117,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-gray-600::placeholder{
  --placeholder-opacity:1;
  color:#4c4f52;
  color:rgba(76,79,82,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-gray-700::placeholder{
  --placeholder-opacity:1;
  color:#24262d;
  color:rgba(36,38,45,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-gray-800::placeholder{
  --placeholder-opacity:1;
  color:#1a1c23;
  color:rgba(26,28,35,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-gray-900::placeholder{
  --placeholder-opacity:1;
  color:#121317;
  color:rgba(18,19,23,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-cool-gray-50::placeholder{
  --placeholder-opacity:1;
  color:#fbfdfe;
  color:rgba(251,253,254,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-cool-gray-100::placeholder{
  --placeholder-opacity:1;
  color:#f1f5f9;
  color:rgba(241,245,249,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-cool-gray-200::placeholder{
  --placeholder-opacity:1;
  color:#e2e8f0;
  color:rgba(226,232,240,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-cool-gray-300::placeholder{
  --placeholder-opacity:1;
  color:#cfd8e3;
  color:rgba(207,216,227,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-cool-gray-400::placeholder{
  --placeholder-opacity:1;
  color:#97a6ba;
  color:rgba(151,166,186,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-cool-gray-500::placeholder{
  --placeholder-opacity:1;
  color:#64748b;
  color:rgba(100,116,139,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-cool-gray-600::placeholder{
  --placeholder-opacity:1;
  color:#475569;
  color:rgba(71,85,105,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-cool-gray-700::placeholder{
  --placeholder-opacity:1;
  color:#364152;
  color:rgba(54,65,82,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-cool-gray-800::placeholder{
  --placeholder-opacity:1;
  color:#27303f;
  color:rgba(39,48,63,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-cool-gray-900::placeholder{
  --placeholder-opacity:1;
  color:#1a202e;
  color:rgba(26,32,46,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-red-50::placeholder{
  --placeholder-opacity:1;
  color:#fdf2f2;
  color:rgba(253,242,242,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-red-100::placeholder{
  --placeholder-opacity:1;
  color:#fde8e8;
  color:rgba(253,232,232,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-red-200::placeholder{
  --placeholder-opacity:1;
  color:#fbd5d5;
  color:rgba(251,213,213,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-red-300::placeholder{
  --placeholder-opacity:1;
  color:#f8b4b4;
  color:rgba(248,180,180,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-red-400::placeholder{
  --placeholder-opacity:1;
  color:#f98080;
  color:rgba(249,128,128,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-red-500::placeholder{
  --placeholder-opacity:1;
  color:#f05252;
  color:rgba(240,82,82,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-red-600::placeholder{
  --placeholder-opacity:1;
  color:#e02424;
  color:rgba(224,36,36,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-red-700::placeholder{
  --placeholder-opacity:1;
  color:#c81e1e;
  color:rgba(200,30,30,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-red-800::placeholder{
  --placeholder-opacity:1;
  color:#9b1c1c;
  color:rgba(155,28,28,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-red-900::placeholder{
  --placeholder-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-orange-50::placeholder{
  --placeholder-opacity:1;
  color:#fff8f1;
  color:rgba(255,248,241,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-orange-100::placeholder{
  --placeholder-opacity:1;
  color:#feecdc;
  color:rgba(254,236,220,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-orange-200::placeholder{
  --placeholder-opacity:1;
  color:#fcd9bd;
  color:rgba(252,217,189,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-orange-300::placeholder{
  --placeholder-opacity:1;
  color:#fdba8c;
  color:rgba(253,186,140,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-orange-400::placeholder{
  --placeholder-opacity:1;
  color:#ff8a4c;
  color:rgba(255,138,76,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-orange-500::placeholder{
  --placeholder-opacity:1;
  color:#ff5a1f;
  color:rgba(255,90,31,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-orange-600::placeholder{
  --placeholder-opacity:1;
  color:#d03801;
  color:rgba(208,56,1,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-orange-700::placeholder{
  --placeholder-opacity:1;
  color:#b43403;
  color:rgba(180,52,3,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-orange-800::placeholder{
  --placeholder-opacity:1;
  color:#8a2c0d;
  color:rgba(138,44,13,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-orange-900::placeholder{
  --placeholder-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-yellow-50::placeholder{
  --placeholder-opacity:1;
  color:#fdfdea;
  color:rgba(253,253,234,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-yellow-100::placeholder{
  --placeholder-opacity:1;
  color:#fdf6b2;
  color:rgba(253,246,178,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-yellow-200::placeholder{
  --placeholder-opacity:1;
  color:#fce96a;
  color:rgba(252,233,106,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-yellow-300::placeholder{
  --placeholder-opacity:1;
  color:#faca15;
  color:rgba(250,202,21,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-yellow-400::placeholder{
  --placeholder-opacity:1;
  color:#e3a008;
  color:rgba(227,160,8,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-yellow-500::placeholder{
  --placeholder-opacity:1;
  color:#c27803;
  color:rgba(194,120,3,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-yellow-600::placeholder{
  --placeholder-opacity:1;
  color:#9f580a;
  color:rgba(159,88,10,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-yellow-700::placeholder{
  --placeholder-opacity:1;
  color:#8e4b10;
  color:rgba(142,75,16,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-yellow-800::placeholder{
  --placeholder-opacity:1;
  color:#723b13;
  color:rgba(114,59,19,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-yellow-900::placeholder{
  --placeholder-opacity:1;
  color:#633112;
  color:rgba(99,49,18,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-green-50::placeholder{
  --placeholder-opacity:1;
  color:#f3faf7;
  color:rgba(243,250,247,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-green-100::placeholder{
  --placeholder-opacity:1;
  color:#def7ec;
  color:rgba(222,247,236,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-green-200::placeholder{
  --placeholder-opacity:1;
  color:#bcf0da;
  color:rgba(188,240,218,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-green-300::placeholder{
  --placeholder-opacity:1;
  color:#84e1bc;
  color:rgba(132,225,188,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-green-400::placeholder{
  --placeholder-opacity:1;
  color:#31c48d;
  color:rgba(49,196,141,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-green-500::placeholder{
  --placeholder-opacity:1;
  color:#0e9f6e;
  color:rgba(14,159,110,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-green-600::placeholder{
  --placeholder-opacity:1;
  color:#057a55;
  color:rgba(5,122,85,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-green-700::placeholder{
  --placeholder-opacity:1;
  color:#046c4e;
  color:rgba(4,108,78,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-green-800::placeholder{
  --placeholder-opacity:1;
  color:#03543f;
  color:rgba(3,84,63,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-green-900::placeholder{
  --placeholder-opacity:1;
  color:#014737;
  color:rgba(1,71,55,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-teal-50::placeholder{
  --placeholder-opacity:1;
  color:#edfafa;
  color:rgba(237,250,250,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-teal-100::placeholder{
  --placeholder-opacity:1;
  color:#d5f5f6;
  color:rgba(213,245,246,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-teal-200::placeholder{
  --placeholder-opacity:1;
  color:#afecef;
  color:rgba(175,236,239,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-teal-300::placeholder{
  --placeholder-opacity:1;
  color:#7edce2;
  color:rgba(126,220,226,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-teal-400::placeholder{
  --placeholder-opacity:1;
  color:#16bdca;
  color:rgba(22,189,202,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-teal-500::placeholder{
  --placeholder-opacity:1;
  color:#0694a2;
  color:rgba(6,148,162,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-teal-600::placeholder{
  --placeholder-opacity:1;
  color:#047481;
  color:rgba(4,116,129,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-teal-700::placeholder{
  --placeholder-opacity:1;
  color:#036672;
  color:rgba(3,102,114,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-teal-800::placeholder{
  --placeholder-opacity:1;
  color:#05505c;
  color:rgba(5,80,92,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-teal-900::placeholder{
  --placeholder-opacity:1;
  color:#014451;
  color:rgba(1,68,81,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-blue-50::placeholder{
  --placeholder-opacity:1;
  color:#ebf5ff;
  color:rgba(235,245,255,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-blue-100::placeholder{
  --placeholder-opacity:1;
  color:#e1effe;
  color:rgba(225,239,254,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-blue-200::placeholder{
  --placeholder-opacity:1;
  color:#c3ddfd;
  color:rgba(195,221,253,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-blue-300::placeholder{
  --placeholder-opacity:1;
  color:#a4cafe;
  color:rgba(164,202,254,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-blue-400::placeholder{
  --placeholder-opacity:1;
  color:#76a9fa;
  color:rgba(118,169,250,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-blue-500::placeholder{
  --placeholder-opacity:1;
  color:#3f83f8;
  color:rgba(63,131,248,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-blue-600::placeholder{
  --placeholder-opacity:1;
  color:#1c64f2;
  color:rgba(28,100,242,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-blue-700::placeholder{
  --placeholder-opacity:1;
  color:#1a56db;
  color:rgba(26,86,219,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-blue-800::placeholder{
  --placeholder-opacity:1;
  color:#1e429f;
  color:rgba(30,66,159,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-blue-900::placeholder{
  --placeholder-opacity:1;
  color:#233876;
  color:rgba(35,56,118,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-50::placeholder{
  --placeholder-opacity:1;
  color:#f0f5ff;
  color:rgba(240,245,255,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-100::placeholder{
  --placeholder-opacity:1;
  color:#e5edff;
  color:rgba(229,237,255,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-200::placeholder{
  --placeholder-opacity:1;
  color:#cddbfe;
  color:rgba(205,219,254,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-300::placeholder{
  --placeholder-opacity:1;
  color:#b4c6fc;
  color:rgba(180,198,252,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-400::placeholder{
  --placeholder-opacity:1;
  color:#8da2fb;
  color:rgba(141,162,251,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-500::placeholder{
  --placeholder-opacity:1;
  color:#6875f5;
  color:rgba(104,117,245,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-600::placeholder{
  --placeholder-opacity:1;
  color:#5850ec;
  color:rgba(88,80,236,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-700::placeholder{
  --placeholder-opacity:1;
  color:#5145cd;
  color:rgba(81,69,205,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-800::placeholder{
  --placeholder-opacity:1;
  color:#42389d;
  color:rgba(66,56,157,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-900::placeholder{
  --placeholder-opacity:1;
  color:#362f78;
  color:rgba(54,47,120,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-50::placeholder{
  --placeholder-opacity:1;
  color:#f6f5ff;
  color:rgba(246,245,255,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-100::placeholder{
  --placeholder-opacity:1;
  color:#edebfe;
  color:rgba(237,235,254,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-200::placeholder{
  --placeholder-opacity:1;
  color:#dcd7fe;
  color:rgba(220,215,254,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-300::placeholder{
  --placeholder-opacity:1;
  color:#cabffd;
  color:rgba(202,191,253,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-400::placeholder{
  --placeholder-opacity:1;
  color:#ac94fa;
  color:rgba(172,148,250,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-500::placeholder{
  --placeholder-opacity:1;
  color:#9061f9;
  color:rgba(144,97,249,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-600::placeholder{
  --placeholder-opacity:1;
  color:#7e3af2;
  color:rgba(126,58,242,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-700::placeholder{
  --placeholder-opacity:1;
  color:#6c2bd9;
  color:rgba(108,43,217,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-800::placeholder{
  --placeholder-opacity:1;
  color:#5521b5;
  color:rgba(85,33,181,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-indigo-900::placeholder{
  --placeholder-opacity:1;
  color:#4a1d96;
  color:rgba(74,29,150,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-pink-50::placeholder{
  --placeholder-opacity:1;
  color:#fdf2f8;
  color:rgba(253,242,248,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-pink-100::placeholder{
  --placeholder-opacity:1;
  color:#fce8f3;
  color:rgba(252,232,243,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-pink-200::placeholder{
  --placeholder-opacity:1;
  color:#fad1e8;
  color:rgba(250,209,232,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-pink-300::placeholder{
  --placeholder-opacity:1;
  color:#f8b4d9;
  color:rgba(248,180,217,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-pink-400::placeholder{
  --placeholder-opacity:1;
  color:#f17eb8;
  color:rgba(241,126,184,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-pink-500::placeholder{
  --placeholder-opacity:1;
  color:#e74694;
  color:rgba(231,70,148,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-pink-600::placeholder{
  --placeholder-opacity:1;
  color:#d61f69;
  color:rgba(214,31,105,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-pink-700::placeholder{
  --placeholder-opacity:1;
  color:#bf125d;
  color:rgba(191,18,93,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-pink-800::placeholder{
  --placeholder-opacity:1;
  color:#99154b;
  color:rgba(153,21,75,var(--placeholder-opacity))
}

.theme-dark .dark\\:placeholder-pink-900::placeholder{
  --placeholder-opacity:1;
  color:#751a3d;
  color:rgba(117,26,61,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-transparent:focus::placeholder{
  color:#0000
}

.theme-dark .dark\\:focus\\:placeholder-white:focus::placeholder{
  --placeholder-opacity:1;
  color:#fff;
  color:rgba(255,255,255,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-black:focus::placeholder{
  --placeholder-opacity:1;
  color:#000;
  color:rgba(0,0,0,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-gray-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#f9fafb;
  color:rgba(249,250,251,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-gray-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#f4f5f7;
  color:rgba(244,245,247,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-gray-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#e5e7eb;
  color:rgba(229,231,235,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-gray-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#d5d6d7;
  color:rgba(213,214,215,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-gray-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#9e9e9e;
  color:rgba(158,158,158,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-gray-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#707275;
  color:rgba(112,114,117,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-gray-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#4c4f52;
  color:rgba(76,79,82,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-gray-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#24262d;
  color:rgba(36,38,45,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-gray-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#1a1c23;
  color:rgba(26,28,35,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-gray-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#121317;
  color:rgba(18,19,23,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-cool-gray-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#fbfdfe;
  color:rgba(251,253,254,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-cool-gray-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#f1f5f9;
  color:rgba(241,245,249,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-cool-gray-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#e2e8f0;
  color:rgba(226,232,240,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-cool-gray-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#cfd8e3;
  color:rgba(207,216,227,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-cool-gray-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#97a6ba;
  color:rgba(151,166,186,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-cool-gray-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#64748b;
  color:rgba(100,116,139,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-cool-gray-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#475569;
  color:rgba(71,85,105,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-cool-gray-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#364152;
  color:rgba(54,65,82,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-cool-gray-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#27303f;
  color:rgba(39,48,63,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-cool-gray-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#1a202e;
  color:rgba(26,32,46,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-red-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#fdf2f2;
  color:rgba(253,242,242,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-red-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#fde8e8;
  color:rgba(253,232,232,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-red-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#fbd5d5;
  color:rgba(251,213,213,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-red-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#f8b4b4;
  color:rgba(248,180,180,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-red-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#f98080;
  color:rgba(249,128,128,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-red-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#f05252;
  color:rgba(240,82,82,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-red-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#e02424;
  color:rgba(224,36,36,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-red-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#c81e1e;
  color:rgba(200,30,30,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-red-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#9b1c1c;
  color:rgba(155,28,28,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-red-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-orange-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#fff8f1;
  color:rgba(255,248,241,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-orange-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#feecdc;
  color:rgba(254,236,220,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-orange-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#fcd9bd;
  color:rgba(252,217,189,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-orange-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#fdba8c;
  color:rgba(253,186,140,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-orange-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#ff8a4c;
  color:rgba(255,138,76,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-orange-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#ff5a1f;
  color:rgba(255,90,31,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-orange-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#d03801;
  color:rgba(208,56,1,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-orange-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#b43403;
  color:rgba(180,52,3,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-orange-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#8a2c0d;
  color:rgba(138,44,13,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-orange-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-yellow-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#fdfdea;
  color:rgba(253,253,234,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-yellow-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#fdf6b2;
  color:rgba(253,246,178,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-yellow-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#fce96a;
  color:rgba(252,233,106,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-yellow-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#faca15;
  color:rgba(250,202,21,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-yellow-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#e3a008;
  color:rgba(227,160,8,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-yellow-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#c27803;
  color:rgba(194,120,3,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-yellow-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#9f580a;
  color:rgba(159,88,10,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-yellow-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#8e4b10;
  color:rgba(142,75,16,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-yellow-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#723b13;
  color:rgba(114,59,19,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-yellow-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#633112;
  color:rgba(99,49,18,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-green-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#f3faf7;
  color:rgba(243,250,247,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-green-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#def7ec;
  color:rgba(222,247,236,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-green-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#bcf0da;
  color:rgba(188,240,218,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-green-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#84e1bc;
  color:rgba(132,225,188,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-green-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#31c48d;
  color:rgba(49,196,141,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-green-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#0e9f6e;
  color:rgba(14,159,110,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-green-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#057a55;
  color:rgba(5,122,85,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-green-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#046c4e;
  color:rgba(4,108,78,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-green-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#03543f;
  color:rgba(3,84,63,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-green-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#014737;
  color:rgba(1,71,55,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-teal-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#edfafa;
  color:rgba(237,250,250,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-teal-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#d5f5f6;
  color:rgba(213,245,246,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-teal-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#afecef;
  color:rgba(175,236,239,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-teal-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#7edce2;
  color:rgba(126,220,226,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-teal-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#16bdca;
  color:rgba(22,189,202,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-teal-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#0694a2;
  color:rgba(6,148,162,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-teal-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#047481;
  color:rgba(4,116,129,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-teal-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#036672;
  color:rgba(3,102,114,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-teal-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#05505c;
  color:rgba(5,80,92,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-teal-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#014451;
  color:rgba(1,68,81,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-blue-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#ebf5ff;
  color:rgba(235,245,255,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-blue-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#e1effe;
  color:rgba(225,239,254,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-blue-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#c3ddfd;
  color:rgba(195,221,253,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-blue-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#a4cafe;
  color:rgba(164,202,254,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-blue-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#76a9fa;
  color:rgba(118,169,250,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-blue-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#3f83f8;
  color:rgba(63,131,248,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-blue-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#1c64f2;
  color:rgba(28,100,242,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-blue-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#1a56db;
  color:rgba(26,86,219,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-blue-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#1e429f;
  color:rgba(30,66,159,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-blue-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#233876;
  color:rgba(35,56,118,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#f0f5ff;
  color:rgba(240,245,255,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#e5edff;
  color:rgba(229,237,255,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#cddbfe;
  color:rgba(205,219,254,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#b4c6fc;
  color:rgba(180,198,252,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#8da2fb;
  color:rgba(141,162,251,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#6875f5;
  color:rgba(104,117,245,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#5850ec;
  color:rgba(88,80,236,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#5145cd;
  color:rgba(81,69,205,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#42389d;
  color:rgba(66,56,157,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#362f78;
  color:rgba(54,47,120,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#f6f5ff;
  color:rgba(246,245,255,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#edebfe;
  color:rgba(237,235,254,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#dcd7fe;
  color:rgba(220,215,254,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#cabffd;
  color:rgba(202,191,253,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#ac94fa;
  color:rgba(172,148,250,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#9061f9;
  color:rgba(144,97,249,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#7e3af2;
  color:rgba(126,58,242,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#6c2bd9;
  color:rgba(108,43,217,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#5521b5;
  color:rgba(85,33,181,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-indigo-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#4a1d96;
  color:rgba(74,29,150,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-pink-50:focus::placeholder{
  --placeholder-opacity:1;
  color:#fdf2f8;
  color:rgba(253,242,248,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-pink-100:focus::placeholder{
  --placeholder-opacity:1;
  color:#fce8f3;
  color:rgba(252,232,243,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-pink-200:focus::placeholder{
  --placeholder-opacity:1;
  color:#fad1e8;
  color:rgba(250,209,232,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-pink-300:focus::placeholder{
  --placeholder-opacity:1;
  color:#f8b4d9;
  color:rgba(248,180,217,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-pink-400:focus::placeholder{
  --placeholder-opacity:1;
  color:#f17eb8;
  color:rgba(241,126,184,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-pink-500:focus::placeholder{
  --placeholder-opacity:1;
  color:#e74694;
  color:rgba(231,70,148,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-pink-600:focus::placeholder{
  --placeholder-opacity:1;
  color:#d61f69;
  color:rgba(214,31,105,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-pink-700:focus::placeholder{
  --placeholder-opacity:1;
  color:#bf125d;
  color:rgba(191,18,93,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-pink-800:focus::placeholder{
  --placeholder-opacity:1;
  color:#99154b;
  color:rgba(153,21,75,var(--placeholder-opacity))
}

.theme-dark .dark\\:focus\\:placeholder-pink-900:focus::placeholder{
  --placeholder-opacity:1;
  color:#751a3d;
  color:rgba(117,26,61,var(--placeholder-opacity))
}

.placeholder-opacity-0::placeholder{
  --placeholder-opacity:0
}

.placeholder-opacity-25::placeholder{
  --placeholder-opacity:0.25
}

.placeholder-opacity-50::placeholder{
  --placeholder-opacity:0.5
}

.placeholder-opacity-75::placeholder{
  --placeholder-opacity:0.75
}

.placeholder-opacity-100::placeholder{
  --placeholder-opacity:1
}

.focus\\:placeholder-opacity-0:focus::placeholder{
  --placeholder-opacity:0
}

.focus\\:placeholder-opacity-25:focus::placeholder{
  --placeholder-opacity:0.25
}

.focus\\:placeholder-opacity-50:focus::placeholder{
  --placeholder-opacity:0.5
}

.focus\\:placeholder-opacity-75:focus::placeholder{
  --placeholder-opacity:0.75
}

.focus\\:placeholder-opacity-100:focus::placeholder{
  --placeholder-opacity:1
}

.pointer-events-none{
  pointer-events:none
}

.pointer-events-auto{
  pointer-events:auto
}

.static{
  position:static
}

.fixed{
  position:fixed
}

.absolute{
  position:absolute
}

.relative{
  position:relative
}

.sticky{
  position:sticky
}

.inset-0{
  bottom:0;
  left:0;
  right:0;
  top:0
}

.inset-auto{
  bottom:auto;
  left:auto;
  right:auto;
  top:auto
}

.inset-y-0{
  bottom:0;
  top:0
}

.inset-x-0{
  left:0;
  right:0
}

.inset-y-auto{
  bottom:auto;
  top:auto
}

.inset-x-auto{
  left:auto;
  right:auto
}

.top-0{
  top:0
}

.right-0{
  right:0
}

.bottom-0{
  bottom:0
}

.left-0{
  left:0
}

.top-auto{
  top:auto
}

.right-auto{
  right:auto
}

.bottom-auto{
  bottom:auto
}

.left-auto{
  left:auto
}

.resize-none{
  resize:none
}

.resize-y{
  resize:vertical
}

.resize-x{
  resize:horizontal
}

.resize{
  resize:both
}

.shadow-xs{
  box-shadow:0 0 0 1px #0000000d
}

.shadow-sm{
  box-shadow:0 1px 2px 0 #0000000d
}

.shadow{
  box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
}

.shadow-md{
  box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
}

.shadow-lg{
  box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
}

.shadow-xl{
  box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
}

.shadow-2xl{
  box-shadow:0 25px 50px -12px #00000040
}

.shadow-inner{
  box-shadow:inset 0 2px 4px 0 #0000000f
}

.shadow-outline{
  box-shadow:0 0 0 3px #4299e180
}

.shadow-none{
  box-shadow:none
}

.shadow-bottom{
  box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
}

.hover\\:shadow-xs:hover{
  box-shadow:0 0 0 1px #0000000d
}

.hover\\:shadow-sm:hover{
  box-shadow:0 1px 2px 0 #0000000d
}

.hover\\:shadow:hover{
  box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
}

.hover\\:shadow-md:hover{
  box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
}

.hover\\:shadow-lg:hover{
  box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
}

.hover\\:shadow-xl:hover{
  box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
}

.hover\\:shadow-2xl:hover{
  box-shadow:0 25px 50px -12px #00000040
}

.hover\\:shadow-inner:hover{
  box-shadow:inset 0 2px 4px 0 #0000000f
}

.hover\\:shadow-outline:hover{
  box-shadow:0 0 0 3px #4299e180
}

.hover\\:shadow-none:hover{
  box-shadow:none
}

.hover\\:shadow-bottom:hover{
  box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
}

.focus\\:shadow-xs:focus{
  box-shadow:0 0 0 1px #0000000d
}

.focus\\:shadow-sm:focus{
  box-shadow:0 1px 2px 0 #0000000d
}

.focus\\:shadow:focus{
  box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
}

.focus\\:shadow-md:focus{
  box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
}

.focus\\:shadow-lg:focus{
  box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
}

.focus\\:shadow-xl:focus{
  box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
}

.focus\\:shadow-2xl:focus{
  box-shadow:0 25px 50px -12px #00000040
}

.focus\\:shadow-inner:focus{
  box-shadow:inset 0 2px 4px 0 #0000000f
}

.focus\\:shadow-outline:focus{
  box-shadow:0 0 0 3px #4299e180
}

.focus\\:shadow-none:focus{
  box-shadow:none
}

.focus\\:shadow-bottom:focus{
  box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
}

.theme-dark .dark\\:focus\\:shadow-xs:focus{
  box-shadow:0 0 0 1px #0000000d
}

.theme-dark .dark\\:focus\\:shadow-sm:focus{
  box-shadow:0 1px 2px 0 #0000000d
}

.theme-dark .dark\\:focus\\:shadow:focus{
  box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
}

.theme-dark .dark\\:focus\\:shadow-md:focus{
  box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
}

.theme-dark .dark\\:focus\\:shadow-lg:focus{
  box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
}

.theme-dark .dark\\:focus\\:shadow-xl:focus{
  box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
}

.theme-dark .dark\\:focus\\:shadow-2xl:focus{
  box-shadow:0 25px 50px -12px #00000040
}

.theme-dark .dark\\:focus\\:shadow-inner:focus{
  box-shadow:inset 0 2px 4px 0 #0000000f
}

.theme-dark .dark\\:focus\\:shadow-outline:focus{
  box-shadow:0 0 0 3px #4299e180
}

.theme-dark .dark\\:focus\\:shadow-none:focus{
  box-shadow:none
}

.theme-dark .dark\\:focus\\:shadow-bottom:focus{
  box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
}

.fill-current{
  fill:currentColor
}

.stroke-current{
  stroke:currentColor
}

.stroke-0{
  stroke-width:0
}

.stroke-1{
  stroke-width:1
}

.stroke-2{
  stroke-width:2
}

.table-auto{
  table-layout:auto
}

.table-fixed{
  table-layout:fixed
}

.text-left{
  text-align:left
}

.text-center{
  text-align:center
}

.text-right{
  text-align:right
}

.text-justify{
  text-align:justify
}

.text-transparent{
  color:#0000
}

.text-white{
  --text-opacity:1;
  color:#fff;
  color:rgba(255,255,255,var(--text-opacity))
}

.text-black{
  --text-opacity:1;
  color:#000;
  color:rgba(0,0,0,var(--text-opacity))
}

.text-gray-50{
  --text-opacity:1;
  color:#f9fafb;
  color:rgba(249,250,251,var(--text-opacity))
}

.text-gray-100{
  --text-opacity:1;
  color:#f4f5f7;
  color:rgba(244,245,247,var(--text-opacity))
}

.text-gray-200{
  --text-opacity:1;
  color:#e5e7eb;
  color:rgba(229,231,235,var(--text-opacity))
}

.text-gray-300{
  --text-opacity:1;
  color:#d5d6d7;
  color:rgba(213,214,215,var(--text-opacity))
}

.text-gray-400{
  --text-opacity:1;
  color:#9e9e9e;
  color:rgba(158,158,158,var(--text-opacity))
}

.text-gray-500{
  --text-opacity:1;
  color:#707275;
  color:rgba(112,114,117,var(--text-opacity))
}

.text-gray-600{
  --text-opacity:1;
  color:#4c4f52;
  color:rgba(76,79,82,var(--text-opacity))
}

.text-gray-700{
  --text-opacity:1;
  color:#24262d;
  color:rgba(36,38,45,var(--text-opacity))
}

.text-gray-800{
  --text-opacity:1;
  color:#1a1c23;
  color:rgba(26,28,35,var(--text-opacity))
}

.text-gray-900{
  --text-opacity:1;
  color:#121317;
  color:rgba(18,19,23,var(--text-opacity))
}

.text-cool-gray-50{
  --text-opacity:1;
  color:#fbfdfe;
  color:rgba(251,253,254,var(--text-opacity))
}

.text-cool-gray-100{
  --text-opacity:1;
  color:#f1f5f9;
  color:rgba(241,245,249,var(--text-opacity))
}

.text-cool-gray-200{
  --text-opacity:1;
  color:#e2e8f0;
  color:rgba(226,232,240,var(--text-opacity))
}

.text-cool-gray-300{
  --text-opacity:1;
  color:#cfd8e3;
  color:rgba(207,216,227,var(--text-opacity))
}

.text-cool-gray-400{
  --text-opacity:1;
  color:#97a6ba;
  color:rgba(151,166,186,var(--text-opacity))
}

.text-cool-gray-500{
  --text-opacity:1;
  color:#64748b;
  color:rgba(100,116,139,var(--text-opacity))
}

.text-cool-gray-600{
  --text-opacity:1;
  color:#475569;
  color:rgba(71,85,105,var(--text-opacity))
}

.text-cool-gray-700{
  --text-opacity:1;
  color:#364152;
  color:rgba(54,65,82,var(--text-opacity))
}

.text-cool-gray-800{
  --text-opacity:1;
  color:#27303f;
  color:rgba(39,48,63,var(--text-opacity))
}

.text-cool-gray-900{
  --text-opacity:1;
  color:#1a202e;
  color:rgba(26,32,46,var(--text-opacity))
}

.text-red-50{
  --text-opacity:1;
  color:#fdf2f2;
  color:rgba(253,242,242,var(--text-opacity))
}

.text-red-100{
  --text-opacity:1;
  color:#fde8e8;
  color:rgba(253,232,232,var(--text-opacity))
}

.text-red-200{
  --text-opacity:1;
  color:#fbd5d5;
  color:rgba(251,213,213,var(--text-opacity))
}

.text-red-300{
  --text-opacity:1;
  color:#f8b4b4;
  color:rgba(248,180,180,var(--text-opacity))
}

.text-red-400{
  --text-opacity:1;
  color:#f98080;
  color:rgba(249,128,128,var(--text-opacity))
}

.text-red-500{
  --text-opacity:1;
  color:#f05252;
  color:rgba(240,82,82,var(--text-opacity))
}

.text-red-600{
  --text-opacity:1;
  color:#e02424;
  color:rgba(224,36,36,var(--text-opacity))
}

.text-red-700{
  --text-opacity:1;
  color:#c81e1e;
  color:rgba(200,30,30,var(--text-opacity))
}

.text-red-800{
  --text-opacity:1;
  color:#9b1c1c;
  color:rgba(155,28,28,var(--text-opacity))
}

.text-red-900{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.text-orange-50{
  --text-opacity:1;
  color:#fff8f1;
  color:rgba(255,248,241,var(--text-opacity))
}

.text-orange-100{
  --text-opacity:1;
  color:#feecdc;
  color:rgba(254,236,220,var(--text-opacity))
}

.text-orange-200{
  --text-opacity:1;
  color:#fcd9bd;
  color:rgba(252,217,189,var(--text-opacity))
}

.text-orange-300{
  --text-opacity:1;
  color:#fdba8c;
  color:rgba(253,186,140,var(--text-opacity))
}

.text-orange-400{
  --text-opacity:1;
  color:#ff8a4c;
  color:rgba(255,138,76,var(--text-opacity))
}

.text-orange-500{
  --text-opacity:1;
  color:#ff5a1f;
  color:rgba(255,90,31,var(--text-opacity))
}

.text-orange-600{
  --text-opacity:1;
  color:#d03801;
  color:rgba(208,56,1,var(--text-opacity))
}

.text-orange-700{
  --text-opacity:1;
  color:#b43403;
  color:rgba(180,52,3,var(--text-opacity))
}

.text-orange-800{
  --text-opacity:1;
  color:#8a2c0d;
  color:rgba(138,44,13,var(--text-opacity))
}

.text-orange-900{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.text-yellow-50{
  --text-opacity:1;
  color:#fdfdea;
  color:rgba(253,253,234,var(--text-opacity))
}

.text-yellow-100{
  --text-opacity:1;
  color:#fdf6b2;
  color:rgba(253,246,178,var(--text-opacity))
}

.text-yellow-200{
  --text-opacity:1;
  color:#fce96a;
  color:rgba(252,233,106,var(--text-opacity))
}

.text-yellow-300{
  --text-opacity:1;
  color:#faca15;
  color:rgba(250,202,21,var(--text-opacity))
}

.text-yellow-400{
  --text-opacity:1;
  color:#e3a008;
  color:rgba(227,160,8,var(--text-opacity))
}

.text-yellow-500{
  --text-opacity:1;
  color:#c27803;
  color:rgba(194,120,3,var(--text-opacity))
}

.text-yellow-600{
  --text-opacity:1;
  color:#9f580a;
  color:rgba(159,88,10,var(--text-opacity))
}

.text-yellow-700{
  --text-opacity:1;
  color:#8e4b10;
  color:rgba(142,75,16,var(--text-opacity))
}

.text-yellow-800{
  --text-opacity:1;
  color:#723b13;
  color:rgba(114,59,19,var(--text-opacity))
}

.text-yellow-900{
  --text-opacity:1;
  color:#633112;
  color:rgba(99,49,18,var(--text-opacity))
}

.text-green-50{
  --text-opacity:1;
  color:#f3faf7;
  color:rgba(243,250,247,var(--text-opacity))
}

.text-green-100{
  --text-opacity:1;
  color:#def7ec;
  color:rgba(222,247,236,var(--text-opacity))
}

.text-green-200{
  --text-opacity:1;
  color:#bcf0da;
  color:rgba(188,240,218,var(--text-opacity))
}

.text-green-300{
  --text-opacity:1;
  color:#84e1bc;
  color:rgba(132,225,188,var(--text-opacity))
}

.text-green-400{
  --text-opacity:1;
  color:#31c48d;
  color:rgba(49,196,141,var(--text-opacity))
}

.text-green-500{
  --text-opacity:1;
  color:#0e9f6e;
  color:rgba(14,159,110,var(--text-opacity))
}

.text-green-600{
  --text-opacity:1;
  color:#057a55;
  color:rgba(5,122,85,var(--text-opacity))
}

.text-green-700{
  --text-opacity:1;
  color:#046c4e;
  color:rgba(4,108,78,var(--text-opacity))
}

.text-green-800{
  --text-opacity:1;
  color:#03543f;
  color:rgba(3,84,63,var(--text-opacity))
}

.text-green-900{
  --text-opacity:1;
  color:#014737;
  color:rgba(1,71,55,var(--text-opacity))
}

.text-teal-50{
  --text-opacity:1;
  color:#edfafa;
  color:rgba(237,250,250,var(--text-opacity))
}

.text-teal-100{
  --text-opacity:1;
  color:#d5f5f6;
  color:rgba(213,245,246,var(--text-opacity))
}

.text-teal-200{
  --text-opacity:1;
  color:#afecef;
  color:rgba(175,236,239,var(--text-opacity))
}

.text-teal-300{
  --text-opacity:1;
  color:#7edce2;
  color:rgba(126,220,226,var(--text-opacity))
}

.text-teal-400{
  --text-opacity:1;
  color:#16bdca;
  color:rgba(22,189,202,var(--text-opacity))
}

.text-teal-500{
  --text-opacity:1;
  color:#0694a2;
  color:rgba(6,148,162,var(--text-opacity))
}

.text-teal-600{
  --text-opacity:1;
  color:#047481;
  color:rgba(4,116,129,var(--text-opacity))
}

.text-teal-700{
  --text-opacity:1;
  color:#036672;
  color:rgba(3,102,114,var(--text-opacity))
}

.text-teal-800{
  --text-opacity:1;
  color:#05505c;
  color:rgba(5,80,92,var(--text-opacity))
}

.text-teal-900{
  --text-opacity:1;
  color:#014451;
  color:rgba(1,68,81,var(--text-opacity))
}

.text-blue-50{
  --text-opacity:1;
  color:#ebf5ff;
  color:rgba(235,245,255,var(--text-opacity))
}

.text-blue-100{
  --text-opacity:1;
  color:#e1effe;
  color:rgba(225,239,254,var(--text-opacity))
}

.text-blue-200{
  --text-opacity:1;
  color:#c3ddfd;
  color:rgba(195,221,253,var(--text-opacity))
}

.text-blue-300{
  --text-opacity:1;
  color:#a4cafe;
  color:rgba(164,202,254,var(--text-opacity))
}

.text-blue-400{
  --text-opacity:1;
  color:#76a9fa;
  color:rgba(118,169,250,var(--text-opacity))
}

.text-blue-500{
  --text-opacity:1;
  color:#3f83f8;
  color:rgba(63,131,248,var(--text-opacity))
}

.text-blue-600{
  --text-opacity:1;
  color:#1c64f2;
  color:rgba(28,100,242,var(--text-opacity))
}

.text-blue-700{
  --text-opacity:1;
  color:#1a56db;
  color:rgba(26,86,219,var(--text-opacity))
}

.text-blue-800{
  --text-opacity:1;
  color:#1e429f;
  color:rgba(30,66,159,var(--text-opacity))
}

.text-blue-900{
  --text-opacity:1;
  color:#233876;
  color:rgba(35,56,118,var(--text-opacity))
}

.text-indigo-50{
  --text-opacity:1;
  color:#f0f5ff;
  color:rgba(240,245,255,var(--text-opacity))
}

.text-indigo-100{
  --text-opacity:1;
  color:#e5edff;
  color:rgba(229,237,255,var(--text-opacity))
}

.text-indigo-200{
  --text-opacity:1;
  color:#cddbfe;
  color:rgba(205,219,254,var(--text-opacity))
}

.text-indigo-300{
  --text-opacity:1;
  color:#b4c6fc;
  color:rgba(180,198,252,var(--text-opacity))
}

.text-indigo-400{
  --text-opacity:1;
  color:#8da2fb;
  color:rgba(141,162,251,var(--text-opacity))
}

.text-indigo-500{
  --text-opacity:1;
  color:#6875f5;
  color:rgba(104,117,245,var(--text-opacity))
}

.text-indigo-600{
  --text-opacity:1;
  color:#5850ec;
  color:rgba(88,80,236,var(--text-opacity))
}

.text-indigo-700{
  --text-opacity:1;
  color:#5145cd;
  color:rgba(81,69,205,var(--text-opacity))
}

.text-indigo-800{
  --text-opacity:1;
  color:#42389d;
  color:rgba(66,56,157,var(--text-opacity))
}

.text-indigo-900{
  --text-opacity:1;
  color:#362f78;
  color:rgba(54,47,120,var(--text-opacity))
}

.text-indigo-50{
  --text-opacity:1;
  color:#f6f5ff;
  color:rgba(246,245,255,var(--text-opacity))
}

.text-indigo-100{
  --text-opacity:1;
  color:#edebfe;
  color:rgba(237,235,254,var(--text-opacity))
}

.text-indigo-200{
  --text-opacity:1;
  color:#dcd7fe;
  color:rgba(220,215,254,var(--text-opacity))
}

.text-indigo-300{
  --text-opacity:1;
  color:#cabffd;
  color:rgba(202,191,253,var(--text-opacity))
}

.text-indigo-400{
  --text-opacity:1;
  color:#ac94fa;
  color:rgba(172,148,250,var(--text-opacity))
}

.text-indigo-500{
  --text-opacity:1;
  color:#9061f9;
  color:rgba(144,97,249,var(--text-opacity))
}

.text-indigo-600{
  --text-opacity:1;
  color:#7e3af2;
  color:rgba(126,58,242,var(--text-opacity))
}

.text-indigo-700{
  --text-opacity:1;
  color:#6c2bd9;
  color:rgba(108,43,217,var(--text-opacity))
}

.text-indigo-800{
  --text-opacity:1;
  color:#5521b5;
  color:rgba(85,33,181,var(--text-opacity))
}

.text-indigo-900{
  --text-opacity:1;
  color:#4a1d96;
  color:rgba(74,29,150,var(--text-opacity))
}

.text-pink-50{
  --text-opacity:1;
  color:#fdf2f8;
  color:rgba(253,242,248,var(--text-opacity))
}

.text-pink-100{
  --text-opacity:1;
  color:#fce8f3;
  color:rgba(252,232,243,var(--text-opacity))
}

.text-pink-200{
  --text-opacity:1;
  color:#fad1e8;
  color:rgba(250,209,232,var(--text-opacity))
}

.text-pink-300{
  --text-opacity:1;
  color:#f8b4d9;
  color:rgba(248,180,217,var(--text-opacity))
}

.text-pink-400{
  --text-opacity:1;
  color:#f17eb8;
  color:rgba(241,126,184,var(--text-opacity))
}

.text-pink-500{
  --text-opacity:1;
  color:#e74694;
  color:rgba(231,70,148,var(--text-opacity))
}

.text-pink-600{
  --text-opacity:1;
  color:#d61f69;
  color:rgba(214,31,105,var(--text-opacity))
}

.text-pink-700{
  --text-opacity:1;
  color:#bf125d;
  color:rgba(191,18,93,var(--text-opacity))
}

.text-pink-800{
  --text-opacity:1;
  color:#99154b;
  color:rgba(153,21,75,var(--text-opacity))
}

.text-pink-900{
  --text-opacity:1;
  color:#751a3d;
  color:rgba(117,26,61,var(--text-opacity))
}

.focus\\:text-transparent:focus{
  color:#0000
}

.focus\\:text-white:focus{
  --text-opacity:1;
  color:#fff;
  color:rgba(255,255,255,var(--text-opacity))
}

.focus\\:text-black:focus{
  --text-opacity:1;
  color:#000;
  color:rgba(0,0,0,var(--text-opacity))
}

.focus\\:text-gray-50:focus{
  --text-opacity:1;
  color:#f9fafb;
  color:rgba(249,250,251,var(--text-opacity))
}

.focus\\:text-gray-100:focus{
  --text-opacity:1;
  color:#f4f5f7;
  color:rgba(244,245,247,var(--text-opacity))
}

.focus\\:text-gray-200:focus{
  --text-opacity:1;
  color:#e5e7eb;
  color:rgba(229,231,235,var(--text-opacity))
}

.focus\\:text-gray-300:focus{
  --text-opacity:1;
  color:#d5d6d7;
  color:rgba(213,214,215,var(--text-opacity))
}

.focus\\:text-gray-400:focus{
  --text-opacity:1;
  color:#9e9e9e;
  color:rgba(158,158,158,var(--text-opacity))
}

.focus\\:text-gray-500:focus{
  --text-opacity:1;
  color:#707275;
  color:rgba(112,114,117,var(--text-opacity))
}

.focus\\:text-gray-600:focus{
  --text-opacity:1;
  color:#4c4f52;
  color:rgba(76,79,82,var(--text-opacity))
}

.focus\\:text-gray-700:focus{
  --text-opacity:1;
  color:#24262d;
  color:rgba(36,38,45,var(--text-opacity))
}

.focus\\:text-gray-800:focus{
  --text-opacity:1;
  color:#1a1c23;
  color:rgba(26,28,35,var(--text-opacity))
}

.focus\\:text-gray-900:focus{
  --text-opacity:1;
  color:#121317;
  color:rgba(18,19,23,var(--text-opacity))
}

.focus\\:text-cool-gray-50:focus{
  --text-opacity:1;
  color:#fbfdfe;
  color:rgba(251,253,254,var(--text-opacity))
}

.focus\\:text-cool-gray-100:focus{
  --text-opacity:1;
  color:#f1f5f9;
  color:rgba(241,245,249,var(--text-opacity))
}

.focus\\:text-cool-gray-200:focus{
  --text-opacity:1;
  color:#e2e8f0;
  color:rgba(226,232,240,var(--text-opacity))
}

.focus\\:text-cool-gray-300:focus{
  --text-opacity:1;
  color:#cfd8e3;
  color:rgba(207,216,227,var(--text-opacity))
}

.focus\\:text-cool-gray-400:focus{
  --text-opacity:1;
  color:#97a6ba;
  color:rgba(151,166,186,var(--text-opacity))
}

.focus\\:text-cool-gray-500:focus{
  --text-opacity:1;
  color:#64748b;
  color:rgba(100,116,139,var(--text-opacity))
}

.focus\\:text-cool-gray-600:focus{
  --text-opacity:1;
  color:#475569;
  color:rgba(71,85,105,var(--text-opacity))
}

.focus\\:text-cool-gray-700:focus{
  --text-opacity:1;
  color:#364152;
  color:rgba(54,65,82,var(--text-opacity))
}

.focus\\:text-cool-gray-800:focus{
  --text-opacity:1;
  color:#27303f;
  color:rgba(39,48,63,var(--text-opacity))
}

.focus\\:text-cool-gray-900:focus{
  --text-opacity:1;
  color:#1a202e;
  color:rgba(26,32,46,var(--text-opacity))
}

.focus\\:text-red-50:focus{
  --text-opacity:1;
  color:#fdf2f2;
  color:rgba(253,242,242,var(--text-opacity))
}

.focus\\:text-red-100:focus{
  --text-opacity:1;
  color:#fde8e8;
  color:rgba(253,232,232,var(--text-opacity))
}

.focus\\:text-red-200:focus{
  --text-opacity:1;
  color:#fbd5d5;
  color:rgba(251,213,213,var(--text-opacity))
}

.focus\\:text-red-300:focus{
  --text-opacity:1;
  color:#f8b4b4;
  color:rgba(248,180,180,var(--text-opacity))
}

.focus\\:text-red-400:focus{
  --text-opacity:1;
  color:#f98080;
  color:rgba(249,128,128,var(--text-opacity))
}

.focus\\:text-red-500:focus{
  --text-opacity:1;
  color:#f05252;
  color:rgba(240,82,82,var(--text-opacity))
}

.focus\\:text-red-600:focus{
  --text-opacity:1;
  color:#e02424;
  color:rgba(224,36,36,var(--text-opacity))
}

.focus\\:text-red-700:focus{
  --text-opacity:1;
  color:#c81e1e;
  color:rgba(200,30,30,var(--text-opacity))
}

.focus\\:text-red-800:focus{
  --text-opacity:1;
  color:#9b1c1c;
  color:rgba(155,28,28,var(--text-opacity))
}

.focus\\:text-red-900:focus{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.focus\\:text-orange-50:focus{
  --text-opacity:1;
  color:#fff8f1;
  color:rgba(255,248,241,var(--text-opacity))
}

.focus\\:text-orange-100:focus{
  --text-opacity:1;
  color:#feecdc;
  color:rgba(254,236,220,var(--text-opacity))
}

.focus\\:text-orange-200:focus{
  --text-opacity:1;
  color:#fcd9bd;
  color:rgba(252,217,189,var(--text-opacity))
}

.focus\\:text-orange-300:focus{
  --text-opacity:1;
  color:#fdba8c;
  color:rgba(253,186,140,var(--text-opacity))
}

.focus\\:text-orange-400:focus{
  --text-opacity:1;
  color:#ff8a4c;
  color:rgba(255,138,76,var(--text-opacity))
}

.focus\\:text-orange-500:focus{
  --text-opacity:1;
  color:#ff5a1f;
  color:rgba(255,90,31,var(--text-opacity))
}

.focus\\:text-orange-600:focus{
  --text-opacity:1;
  color:#d03801;
  color:rgba(208,56,1,var(--text-opacity))
}

.focus\\:text-orange-700:focus{
  --text-opacity:1;
  color:#b43403;
  color:rgba(180,52,3,var(--text-opacity))
}

.focus\\:text-orange-800:focus{
  --text-opacity:1;
  color:#8a2c0d;
  color:rgba(138,44,13,var(--text-opacity))
}

.focus\\:text-orange-900:focus{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.focus\\:text-yellow-50:focus{
  --text-opacity:1;
  color:#fdfdea;
  color:rgba(253,253,234,var(--text-opacity))
}

.focus\\:text-yellow-100:focus{
  --text-opacity:1;
  color:#fdf6b2;
  color:rgba(253,246,178,var(--text-opacity))
}

.focus\\:text-yellow-200:focus{
  --text-opacity:1;
  color:#fce96a;
  color:rgba(252,233,106,var(--text-opacity))
}

.focus\\:text-yellow-300:focus{
  --text-opacity:1;
  color:#faca15;
  color:rgba(250,202,21,var(--text-opacity))
}

.focus\\:text-yellow-400:focus{
  --text-opacity:1;
  color:#e3a008;
  color:rgba(227,160,8,var(--text-opacity))
}

.focus\\:text-yellow-500:focus{
  --text-opacity:1;
  color:#c27803;
  color:rgba(194,120,3,var(--text-opacity))
}

.focus\\:text-yellow-600:focus{
  --text-opacity:1;
  color:#9f580a;
  color:rgba(159,88,10,var(--text-opacity))
}

.focus\\:text-yellow-700:focus{
  --text-opacity:1;
  color:#8e4b10;
  color:rgba(142,75,16,var(--text-opacity))
}

.focus\\:text-yellow-800:focus{
  --text-opacity:1;
  color:#723b13;
  color:rgba(114,59,19,var(--text-opacity))
}

.focus\\:text-yellow-900:focus{
  --text-opacity:1;
  color:#633112;
  color:rgba(99,49,18,var(--text-opacity))
}

.focus\\:text-green-50:focus{
  --text-opacity:1;
  color:#f3faf7;
  color:rgba(243,250,247,var(--text-opacity))
}

.focus\\:text-green-100:focus{
  --text-opacity:1;
  color:#def7ec;
  color:rgba(222,247,236,var(--text-opacity))
}

.focus\\:text-green-200:focus{
  --text-opacity:1;
  color:#bcf0da;
  color:rgba(188,240,218,var(--text-opacity))
}

.focus\\:text-green-300:focus{
  --text-opacity:1;
  color:#84e1bc;
  color:rgba(132,225,188,var(--text-opacity))
}

.focus\\:text-green-400:focus{
  --text-opacity:1;
  color:#31c48d;
  color:rgba(49,196,141,var(--text-opacity))
}

.focus\\:text-green-500:focus{
  --text-opacity:1;
  color:#0e9f6e;
  color:rgba(14,159,110,var(--text-opacity))
}

.focus\\:text-green-600:focus{
  --text-opacity:1;
  color:#057a55;
  color:rgba(5,122,85,var(--text-opacity))
}

.focus\\:text-green-700:focus{
  --text-opacity:1;
  color:#046c4e;
  color:rgba(4,108,78,var(--text-opacity))
}

.focus\\:text-green-800:focus{
  --text-opacity:1;
  color:#03543f;
  color:rgba(3,84,63,var(--text-opacity))
}

.focus\\:text-green-900:focus{
  --text-opacity:1;
  color:#014737;
  color:rgba(1,71,55,var(--text-opacity))
}

.focus\\:text-teal-50:focus{
  --text-opacity:1;
  color:#edfafa;
  color:rgba(237,250,250,var(--text-opacity))
}

.focus\\:text-teal-100:focus{
  --text-opacity:1;
  color:#d5f5f6;
  color:rgba(213,245,246,var(--text-opacity))
}

.focus\\:text-teal-200:focus{
  --text-opacity:1;
  color:#afecef;
  color:rgba(175,236,239,var(--text-opacity))
}

.focus\\:text-teal-300:focus{
  --text-opacity:1;
  color:#7edce2;
  color:rgba(126,220,226,var(--text-opacity))
}

.focus\\:text-teal-400:focus{
  --text-opacity:1;
  color:#16bdca;
  color:rgba(22,189,202,var(--text-opacity))
}

.focus\\:text-teal-500:focus{
  --text-opacity:1;
  color:#0694a2;
  color:rgba(6,148,162,var(--text-opacity))
}

.focus\\:text-teal-600:focus{
  --text-opacity:1;
  color:#047481;
  color:rgba(4,116,129,var(--text-opacity))
}

.focus\\:text-teal-700:focus{
  --text-opacity:1;
  color:#036672;
  color:rgba(3,102,114,var(--text-opacity))
}

.focus\\:text-teal-800:focus{
  --text-opacity:1;
  color:#05505c;
  color:rgba(5,80,92,var(--text-opacity))
}

.focus\\:text-teal-900:focus{
  --text-opacity:1;
  color:#014451;
  color:rgba(1,68,81,var(--text-opacity))
}

.focus\\:text-blue-50:focus{
  --text-opacity:1;
  color:#ebf5ff;
  color:rgba(235,245,255,var(--text-opacity))
}

.focus\\:text-blue-100:focus{
  --text-opacity:1;
  color:#e1effe;
  color:rgba(225,239,254,var(--text-opacity))
}

.focus\\:text-blue-200:focus{
  --text-opacity:1;
  color:#c3ddfd;
  color:rgba(195,221,253,var(--text-opacity))
}

.focus\\:text-blue-300:focus{
  --text-opacity:1;
  color:#a4cafe;
  color:rgba(164,202,254,var(--text-opacity))
}

.focus\\:text-blue-400:focus{
  --text-opacity:1;
  color:#76a9fa;
  color:rgba(118,169,250,var(--text-opacity))
}

.focus\\:text-blue-500:focus{
  --text-opacity:1;
  color:#3f83f8;
  color:rgba(63,131,248,var(--text-opacity))
}

.focus\\:text-blue-600:focus{
  --text-opacity:1;
  color:#1c64f2;
  color:rgba(28,100,242,var(--text-opacity))
}

.focus\\:text-blue-700:focus{
  --text-opacity:1;
  color:#1a56db;
  color:rgba(26,86,219,var(--text-opacity))
}

.focus\\:text-blue-800:focus{
  --text-opacity:1;
  color:#1e429f;
  color:rgba(30,66,159,var(--text-opacity))
}

.focus\\:text-blue-900:focus{
  --text-opacity:1;
  color:#233876;
  color:rgba(35,56,118,var(--text-opacity))
}

.focus\\:text-indigo-50:focus{
  --text-opacity:1;
  color:#f0f5ff;
  color:rgba(240,245,255,var(--text-opacity))
}

.focus\\:text-indigo-100:focus{
  --text-opacity:1;
  color:#e5edff;
  color:rgba(229,237,255,var(--text-opacity))
}

.focus\\:text-indigo-200:focus{
  --text-opacity:1;
  color:#cddbfe;
  color:rgba(205,219,254,var(--text-opacity))
}

.focus\\:text-indigo-300:focus{
  --text-opacity:1;
  color:#b4c6fc;
  color:rgba(180,198,252,var(--text-opacity))
}

.focus\\:text-indigo-400:focus{
  --text-opacity:1;
  color:#8da2fb;
  color:rgba(141,162,251,var(--text-opacity))
}

.focus\\:text-indigo-500:focus{
  --text-opacity:1;
  color:#6875f5;
  color:rgba(104,117,245,var(--text-opacity))
}

.focus\\:text-indigo-600:focus{
  --text-opacity:1;
  color:#5850ec;
  color:rgba(88,80,236,var(--text-opacity))
}

.focus\\:text-indigo-700:focus{
  --text-opacity:1;
  color:#5145cd;
  color:rgba(81,69,205,var(--text-opacity))
}

.focus\\:text-indigo-800:focus{
  --text-opacity:1;
  color:#42389d;
  color:rgba(66,56,157,var(--text-opacity))
}

.focus\\:text-indigo-900:focus{
  --text-opacity:1;
  color:#362f78;
  color:rgba(54,47,120,var(--text-opacity))
}

.focus\\:text-indigo-50:focus{
  --text-opacity:1;
  color:#f6f5ff;
  color:rgba(246,245,255,var(--text-opacity))
}

.focus\\:text-indigo-100:focus{
  --text-opacity:1;
  color:#edebfe;
  color:rgba(237,235,254,var(--text-opacity))
}

.focus\\:text-indigo-200:focus{
  --text-opacity:1;
  color:#dcd7fe;
  color:rgba(220,215,254,var(--text-opacity))
}

.focus\\:text-indigo-300:focus{
  --text-opacity:1;
  color:#cabffd;
  color:rgba(202,191,253,var(--text-opacity))
}

.focus\\:text-indigo-400:focus{
  --text-opacity:1;
  color:#ac94fa;
  color:rgba(172,148,250,var(--text-opacity))
}

.focus\\:text-indigo-500:focus{
  --text-opacity:1;
  color:#9061f9;
  color:rgba(144,97,249,var(--text-opacity))
}

.focus\\:text-indigo-600:focus{
  --text-opacity:1;
  color:#7e3af2;
  color:rgba(126,58,242,var(--text-opacity))
}

.focus\\:text-indigo-700:focus{
  --text-opacity:1;
  color:#6c2bd9;
  color:rgba(108,43,217,var(--text-opacity))
}

.focus\\:text-indigo-800:focus{
  --text-opacity:1;
  color:#5521b5;
  color:rgba(85,33,181,var(--text-opacity))
}

.focus\\:text-indigo-900:focus{
  --text-opacity:1;
  color:#4a1d96;
  color:rgba(74,29,150,var(--text-opacity))
}

.focus\\:text-pink-50:focus{
  --text-opacity:1;
  color:#fdf2f8;
  color:rgba(253,242,248,var(--text-opacity))
}

.focus\\:text-pink-100:focus{
  --text-opacity:1;
  color:#fce8f3;
  color:rgba(252,232,243,var(--text-opacity))
}

.focus\\:text-pink-200:focus{
  --text-opacity:1;
  color:#fad1e8;
  color:rgba(250,209,232,var(--text-opacity))
}

.focus\\:text-pink-300:focus{
  --text-opacity:1;
  color:#f8b4d9;
  color:rgba(248,180,217,var(--text-opacity))
}

.focus\\:text-pink-400:focus{
  --text-opacity:1;
  color:#f17eb8;
  color:rgba(241,126,184,var(--text-opacity))
}

.focus\\:text-pink-500:focus{
  --text-opacity:1;
  color:#e74694;
  color:rgba(231,70,148,var(--text-opacity))
}

.focus\\:text-pink-600:focus{
  --text-opacity:1;
  color:#d61f69;
  color:rgba(214,31,105,var(--text-opacity))
}

.focus\\:text-pink-700:focus{
  --text-opacity:1;
  color:#bf125d;
  color:rgba(191,18,93,var(--text-opacity))
}

.focus\\:text-pink-800:focus{
  --text-opacity:1;
  color:#99154b;
  color:rgba(153,21,75,var(--text-opacity))
}

.focus\\:text-pink-900:focus{
  --text-opacity:1;
  color:#751a3d;
  color:rgba(117,26,61,var(--text-opacity))
}

.focus-within\\:text-transparent:focus-within{
  color:#0000
}

.focus-within\\:text-white:focus-within{
  --text-opacity:1;
  color:#fff;
  color:rgba(255,255,255,var(--text-opacity))
}

.focus-within\\:text-black:focus-within{
  --text-opacity:1;
  color:#000;
  color:rgba(0,0,0,var(--text-opacity))
}

.focus-within\\:text-gray-50:focus-within{
  --text-opacity:1;
  color:#f9fafb;
  color:rgba(249,250,251,var(--text-opacity))
}

.focus-within\\:text-gray-100:focus-within{
  --text-opacity:1;
  color:#f4f5f7;
  color:rgba(244,245,247,var(--text-opacity))
}

.focus-within\\:text-gray-200:focus-within{
  --text-opacity:1;
  color:#e5e7eb;
  color:rgba(229,231,235,var(--text-opacity))
}

.focus-within\\:text-gray-300:focus-within{
  --text-opacity:1;
  color:#d5d6d7;
  color:rgba(213,214,215,var(--text-opacity))
}

.focus-within\\:text-gray-400:focus-within{
  --text-opacity:1;
  color:#9e9e9e;
  color:rgba(158,158,158,var(--text-opacity))
}

.focus-within\\:text-gray-500:focus-within{
  --text-opacity:1;
  color:#707275;
  color:rgba(112,114,117,var(--text-opacity))
}

.focus-within\\:text-gray-600:focus-within{
  --text-opacity:1;
  color:#4c4f52;
  color:rgba(76,79,82,var(--text-opacity))
}

.focus-within\\:text-gray-700:focus-within{
  --text-opacity:1;
  color:#24262d;
  color:rgba(36,38,45,var(--text-opacity))
}

.focus-within\\:text-gray-800:focus-within{
  --text-opacity:1;
  color:#1a1c23;
  color:rgba(26,28,35,var(--text-opacity))
}

.focus-within\\:text-gray-900:focus-within{
  --text-opacity:1;
  color:#121317;
  color:rgba(18,19,23,var(--text-opacity))
}

.focus-within\\:text-cool-gray-50:focus-within{
  --text-opacity:1;
  color:#fbfdfe;
  color:rgba(251,253,254,var(--text-opacity))
}

.focus-within\\:text-cool-gray-100:focus-within{
  --text-opacity:1;
  color:#f1f5f9;
  color:rgba(241,245,249,var(--text-opacity))
}

.focus-within\\:text-cool-gray-200:focus-within{
  --text-opacity:1;
  color:#e2e8f0;
  color:rgba(226,232,240,var(--text-opacity))
}

.focus-within\\:text-cool-gray-300:focus-within{
  --text-opacity:1;
  color:#cfd8e3;
  color:rgba(207,216,227,var(--text-opacity))
}

.focus-within\\:text-cool-gray-400:focus-within{
  --text-opacity:1;
  color:#97a6ba;
  color:rgba(151,166,186,var(--text-opacity))
}

.focus-within\\:text-cool-gray-500:focus-within{
  --text-opacity:1;
  color:#64748b;
  color:rgba(100,116,139,var(--text-opacity))
}

.focus-within\\:text-cool-gray-600:focus-within{
  --text-opacity:1;
  color:#475569;
  color:rgba(71,85,105,var(--text-opacity))
}

.focus-within\\:text-cool-gray-700:focus-within{
  --text-opacity:1;
  color:#364152;
  color:rgba(54,65,82,var(--text-opacity))
}

.focus-within\\:text-cool-gray-800:focus-within{
  --text-opacity:1;
  color:#27303f;
  color:rgba(39,48,63,var(--text-opacity))
}

.focus-within\\:text-cool-gray-900:focus-within{
  --text-opacity:1;
  color:#1a202e;
  color:rgba(26,32,46,var(--text-opacity))
}

.focus-within\\:text-red-50:focus-within{
  --text-opacity:1;
  color:#fdf2f2;
  color:rgba(253,242,242,var(--text-opacity))
}

.focus-within\\:text-red-100:focus-within{
  --text-opacity:1;
  color:#fde8e8;
  color:rgba(253,232,232,var(--text-opacity))
}

.focus-within\\:text-red-200:focus-within{
  --text-opacity:1;
  color:#fbd5d5;
  color:rgba(251,213,213,var(--text-opacity))
}

.focus-within\\:text-red-300:focus-within{
  --text-opacity:1;
  color:#f8b4b4;
  color:rgba(248,180,180,var(--text-opacity))
}

.focus-within\\:text-red-400:focus-within{
  --text-opacity:1;
  color:#f98080;
  color:rgba(249,128,128,var(--text-opacity))
}

.focus-within\\:text-red-500:focus-within{
  --text-opacity:1;
  color:#f05252;
  color:rgba(240,82,82,var(--text-opacity))
}

.focus-within\\:text-red-600:focus-within{
  --text-opacity:1;
  color:#e02424;
  color:rgba(224,36,36,var(--text-opacity))
}

.focus-within\\:text-red-700:focus-within{
  --text-opacity:1;
  color:#c81e1e;
  color:rgba(200,30,30,var(--text-opacity))
}

.focus-within\\:text-red-800:focus-within{
  --text-opacity:1;
  color:#9b1c1c;
  color:rgba(155,28,28,var(--text-opacity))
}

.focus-within\\:text-red-900:focus-within{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.focus-within\\:text-orange-50:focus-within{
  --text-opacity:1;
  color:#fff8f1;
  color:rgba(255,248,241,var(--text-opacity))
}

.focus-within\\:text-orange-100:focus-within{
  --text-opacity:1;
  color:#feecdc;
  color:rgba(254,236,220,var(--text-opacity))
}

.focus-within\\:text-orange-200:focus-within{
  --text-opacity:1;
  color:#fcd9bd;
  color:rgba(252,217,189,var(--text-opacity))
}

.focus-within\\:text-orange-300:focus-within{
  --text-opacity:1;
  color:#fdba8c;
  color:rgba(253,186,140,var(--text-opacity))
}

.focus-within\\:text-orange-400:focus-within{
  --text-opacity:1;
  color:#ff8a4c;
  color:rgba(255,138,76,var(--text-opacity))
}

.focus-within\\:text-orange-500:focus-within{
  --text-opacity:1;
  color:#ff5a1f;
  color:rgba(255,90,31,var(--text-opacity))
}

.focus-within\\:text-orange-600:focus-within{
  --text-opacity:1;
  color:#d03801;
  color:rgba(208,56,1,var(--text-opacity))
}

.focus-within\\:text-orange-700:focus-within{
  --text-opacity:1;
  color:#b43403;
  color:rgba(180,52,3,var(--text-opacity))
}

.focus-within\\:text-orange-800:focus-within{
  --text-opacity:1;
  color:#8a2c0d;
  color:rgba(138,44,13,var(--text-opacity))
}

.focus-within\\:text-orange-900:focus-within{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.focus-within\\:text-yellow-50:focus-within{
  --text-opacity:1;
  color:#fdfdea;
  color:rgba(253,253,234,var(--text-opacity))
}

.focus-within\\:text-yellow-100:focus-within{
  --text-opacity:1;
  color:#fdf6b2;
  color:rgba(253,246,178,var(--text-opacity))
}

.focus-within\\:text-yellow-200:focus-within{
  --text-opacity:1;
  color:#fce96a;
  color:rgba(252,233,106,var(--text-opacity))
}

.focus-within\\:text-yellow-300:focus-within{
  --text-opacity:1;
  color:#faca15;
  color:rgba(250,202,21,var(--text-opacity))
}

.focus-within\\:text-yellow-400:focus-within{
  --text-opacity:1;
  color:#e3a008;
  color:rgba(227,160,8,var(--text-opacity))
}

.focus-within\\:text-yellow-500:focus-within{
  --text-opacity:1;
  color:#c27803;
  color:rgba(194,120,3,var(--text-opacity))
}

.focus-within\\:text-yellow-600:focus-within{
  --text-opacity:1;
  color:#9f580a;
  color:rgba(159,88,10,var(--text-opacity))
}

.focus-within\\:text-yellow-700:focus-within{
  --text-opacity:1;
  color:#8e4b10;
  color:rgba(142,75,16,var(--text-opacity))
}

.focus-within\\:text-yellow-800:focus-within{
  --text-opacity:1;
  color:#723b13;
  color:rgba(114,59,19,var(--text-opacity))
}

.focus-within\\:text-yellow-900:focus-within{
  --text-opacity:1;
  color:#633112;
  color:rgba(99,49,18,var(--text-opacity))
}

.focus-within\\:text-green-50:focus-within{
  --text-opacity:1;
  color:#f3faf7;
  color:rgba(243,250,247,var(--text-opacity))
}

.focus-within\\:text-green-100:focus-within{
  --text-opacity:1;
  color:#def7ec;
  color:rgba(222,247,236,var(--text-opacity))
}

.focus-within\\:text-green-200:focus-within{
  --text-opacity:1;
  color:#bcf0da;
  color:rgba(188,240,218,var(--text-opacity))
}

.focus-within\\:text-green-300:focus-within{
  --text-opacity:1;
  color:#84e1bc;
  color:rgba(132,225,188,var(--text-opacity))
}

.focus-within\\:text-green-400:focus-within{
  --text-opacity:1;
  color:#31c48d;
  color:rgba(49,196,141,var(--text-opacity))
}

.focus-within\\:text-green-500:focus-within{
  --text-opacity:1;
  color:#0e9f6e;
  color:rgba(14,159,110,var(--text-opacity))
}

.focus-within\\:text-green-600:focus-within{
  --text-opacity:1;
  color:#057a55;
  color:rgba(5,122,85,var(--text-opacity))
}

.focus-within\\:text-green-700:focus-within{
  --text-opacity:1;
  color:#046c4e;
  color:rgba(4,108,78,var(--text-opacity))
}

.focus-within\\:text-green-800:focus-within{
  --text-opacity:1;
  color:#03543f;
  color:rgba(3,84,63,var(--text-opacity))
}

.focus-within\\:text-green-900:focus-within{
  --text-opacity:1;
  color:#014737;
  color:rgba(1,71,55,var(--text-opacity))
}

.focus-within\\:text-teal-50:focus-within{
  --text-opacity:1;
  color:#edfafa;
  color:rgba(237,250,250,var(--text-opacity))
}

.focus-within\\:text-teal-100:focus-within{
  --text-opacity:1;
  color:#d5f5f6;
  color:rgba(213,245,246,var(--text-opacity))
}

.focus-within\\:text-teal-200:focus-within{
  --text-opacity:1;
  color:#afecef;
  color:rgba(175,236,239,var(--text-opacity))
}

.focus-within\\:text-teal-300:focus-within{
  --text-opacity:1;
  color:#7edce2;
  color:rgba(126,220,226,var(--text-opacity))
}

.focus-within\\:text-teal-400:focus-within{
  --text-opacity:1;
  color:#16bdca;
  color:rgba(22,189,202,var(--text-opacity))
}

.focus-within\\:text-teal-500:focus-within{
  --text-opacity:1;
  color:#0694a2;
  color:rgba(6,148,162,var(--text-opacity))
}

.focus-within\\:text-teal-600:focus-within{
  --text-opacity:1;
  color:#047481;
  color:rgba(4,116,129,var(--text-opacity))
}

.focus-within\\:text-teal-700:focus-within{
  --text-opacity:1;
  color:#036672;
  color:rgba(3,102,114,var(--text-opacity))
}

.focus-within\\:text-teal-800:focus-within{
  --text-opacity:1;
  color:#05505c;
  color:rgba(5,80,92,var(--text-opacity))
}

.focus-within\\:text-teal-900:focus-within{
  --text-opacity:1;
  color:#014451;
  color:rgba(1,68,81,var(--text-opacity))
}

.focus-within\\:text-blue-50:focus-within{
  --text-opacity:1;
  color:#ebf5ff;
  color:rgba(235,245,255,var(--text-opacity))
}

.focus-within\\:text-blue-100:focus-within{
  --text-opacity:1;
  color:#e1effe;
  color:rgba(225,239,254,var(--text-opacity))
}

.focus-within\\:text-blue-200:focus-within{
  --text-opacity:1;
  color:#c3ddfd;
  color:rgba(195,221,253,var(--text-opacity))
}

.focus-within\\:text-blue-300:focus-within{
  --text-opacity:1;
  color:#a4cafe;
  color:rgba(164,202,254,var(--text-opacity))
}

.focus-within\\:text-blue-400:focus-within{
  --text-opacity:1;
  color:#76a9fa;
  color:rgba(118,169,250,var(--text-opacity))
}

.focus-within\\:text-blue-500:focus-within{
  --text-opacity:1;
  color:#3f83f8;
  color:rgba(63,131,248,var(--text-opacity))
}

.focus-within\\:text-blue-600:focus-within{
  --text-opacity:1;
  color:#1c64f2;
  color:rgba(28,100,242,var(--text-opacity))
}

.focus-within\\:text-blue-700:focus-within{
  --text-opacity:1;
  color:#1a56db;
  color:rgba(26,86,219,var(--text-opacity))
}

.focus-within\\:text-blue-800:focus-within{
  --text-opacity:1;
  color:#1e429f;
  color:rgba(30,66,159,var(--text-opacity))
}

.focus-within\\:text-blue-900:focus-within{
  --text-opacity:1;
  color:#233876;
  color:rgba(35,56,118,var(--text-opacity))
}

.focus-within\\:text-indigo-50:focus-within{
  --text-opacity:1;
  color:#f0f5ff;
  color:rgba(240,245,255,var(--text-opacity))
}

.focus-within\\:text-indigo-100:focus-within{
  --text-opacity:1;
  color:#e5edff;
  color:rgba(229,237,255,var(--text-opacity))
}

.focus-within\\:text-indigo-200:focus-within{
  --text-opacity:1;
  color:#cddbfe;
  color:rgba(205,219,254,var(--text-opacity))
}

.focus-within\\:text-indigo-300:focus-within{
  --text-opacity:1;
  color:#b4c6fc;
  color:rgba(180,198,252,var(--text-opacity))
}

.focus-within\\:text-indigo-400:focus-within{
  --text-opacity:1;
  color:#8da2fb;
  color:rgba(141,162,251,var(--text-opacity))
}

.focus-within\\:text-indigo-500:focus-within{
  --text-opacity:1;
  color:#6875f5;
  color:rgba(104,117,245,var(--text-opacity))
}

.focus-within\\:text-indigo-600:focus-within{
  --text-opacity:1;
  color:#5850ec;
  color:rgba(88,80,236,var(--text-opacity))
}

.focus-within\\:text-indigo-700:focus-within{
  --text-opacity:1;
  color:#5145cd;
  color:rgba(81,69,205,var(--text-opacity))
}

.focus-within\\:text-indigo-800:focus-within{
  --text-opacity:1;
  color:#42389d;
  color:rgba(66,56,157,var(--text-opacity))
}

.focus-within\\:text-indigo-900:focus-within{
  --text-opacity:1;
  color:#362f78;
  color:rgba(54,47,120,var(--text-opacity))
}

.focus-within\\:text-indigo-50:focus-within{
  --text-opacity:1;
  color:#f6f5ff;
  color:rgba(246,245,255,var(--text-opacity))
}

.focus-within\\:text-indigo-100:focus-within{
  --text-opacity:1;
  color:#edebfe;
  color:rgba(237,235,254,var(--text-opacity))
}

.focus-within\\:text-indigo-200:focus-within{
  --text-opacity:1;
  color:#dcd7fe;
  color:rgba(220,215,254,var(--text-opacity))
}

.focus-within\\:text-indigo-300:focus-within{
  --text-opacity:1;
  color:#cabffd;
  color:rgba(202,191,253,var(--text-opacity))
}

.focus-within\\:text-indigo-400:focus-within{
  --text-opacity:1;
  color:#ac94fa;
  color:rgba(172,148,250,var(--text-opacity))
}

.focus-within\\:text-indigo-500:focus-within{
  --text-opacity:1;
  color:#9061f9;
  color:rgba(144,97,249,var(--text-opacity))
}

.focus-within\\:text-indigo-600:focus-within{
  --text-opacity:1;
  color:#7e3af2;
  color:rgba(126,58,242,var(--text-opacity))
}

.focus-within\\:text-indigo-700:focus-within{
  --text-opacity:1;
  color:#6c2bd9;
  color:rgba(108,43,217,var(--text-opacity))
}

.focus-within\\:text-indigo-800:focus-within{
  --text-opacity:1;
  color:#5521b5;
  color:rgba(85,33,181,var(--text-opacity))
}

.focus-within\\:text-indigo-900:focus-within{
  --text-opacity:1;
  color:#4a1d96;
  color:rgba(74,29,150,var(--text-opacity))
}

.focus-within\\:text-pink-50:focus-within{
  --text-opacity:1;
  color:#fdf2f8;
  color:rgba(253,242,248,var(--text-opacity))
}

.focus-within\\:text-pink-100:focus-within{
  --text-opacity:1;
  color:#fce8f3;
  color:rgba(252,232,243,var(--text-opacity))
}

.focus-within\\:text-pink-200:focus-within{
  --text-opacity:1;
  color:#fad1e8;
  color:rgba(250,209,232,var(--text-opacity))
}

.focus-within\\:text-pink-300:focus-within{
  --text-opacity:1;
  color:#f8b4d9;
  color:rgba(248,180,217,var(--text-opacity))
}

.focus-within\\:text-pink-400:focus-within{
  --text-opacity:1;
  color:#f17eb8;
  color:rgba(241,126,184,var(--text-opacity))
}

.focus-within\\:text-pink-500:focus-within{
  --text-opacity:1;
  color:#e74694;
  color:rgba(231,70,148,var(--text-opacity))
}

.focus-within\\:text-pink-600:focus-within{
  --text-opacity:1;
  color:#d61f69;
  color:rgba(214,31,105,var(--text-opacity))
}

.focus-within\\:text-pink-700:focus-within{
  --text-opacity:1;
  color:#bf125d;
  color:rgba(191,18,93,var(--text-opacity))
}

.focus-within\\:text-pink-800:focus-within{
  --text-opacity:1;
  color:#99154b;
  color:rgba(153,21,75,var(--text-opacity))
}

.focus-within\\:text-pink-900:focus-within{
  --text-opacity:1;
  color:#751a3d;
  color:rgba(117,26,61,var(--text-opacity))
}

.hover\\:text-transparent:hover{
  color:#0000
}

.hover\\:text-white:hover{
  --text-opacity:1;
  color:#fff;
  color:rgba(255,255,255,var(--text-opacity))
}

.hover\\:text-black:hover{
  --text-opacity:1;
  color:#000;
  color:rgba(0,0,0,var(--text-opacity))
}

.hover\\:text-gray-50:hover{
  --text-opacity:1;
  color:#f9fafb;
  color:rgba(249,250,251,var(--text-opacity))
}

.hover\\:text-gray-100:hover{
  --text-opacity:1;
  color:#f4f5f7;
  color:rgba(244,245,247,var(--text-opacity))
}

.hover\\:text-gray-200:hover{
  --text-opacity:1;
  color:#e5e7eb;
  color:rgba(229,231,235,var(--text-opacity))
}

.hover\\:text-gray-300:hover{
  --text-opacity:1;
  color:#d5d6d7;
  color:rgba(213,214,215,var(--text-opacity))
}

.hover\\:text-gray-400:hover{
  --text-opacity:1;
  color:#9e9e9e;
  color:rgba(158,158,158,var(--text-opacity))
}

.hover\\:text-gray-500:hover{
  --text-opacity:1;
  color:#707275;
  color:rgba(112,114,117,var(--text-opacity))
}

.hover\\:text-gray-600:hover{
  --text-opacity:1;
  color:#4c4f52;
  color:rgba(76,79,82,var(--text-opacity))
}

.hover\\:text-gray-700:hover{
  --text-opacity:1;
  color:#24262d;
  color:rgba(36,38,45,var(--text-opacity))
}

.hover\\:text-gray-800:hover{
  --text-opacity:1;
  color:#1a1c23;
  color:rgba(26,28,35,var(--text-opacity))
}

.hover\\:text-gray-900:hover{
  --text-opacity:1;
  color:#121317;
  color:rgba(18,19,23,var(--text-opacity))
}

.hover\\:text-cool-gray-50:hover{
  --text-opacity:1;
  color:#fbfdfe;
  color:rgba(251,253,254,var(--text-opacity))
}

.hover\\:text-cool-gray-100:hover{
  --text-opacity:1;
  color:#f1f5f9;
  color:rgba(241,245,249,var(--text-opacity))
}

.hover\\:text-cool-gray-200:hover{
  --text-opacity:1;
  color:#e2e8f0;
  color:rgba(226,232,240,var(--text-opacity))
}

.hover\\:text-cool-gray-300:hover{
  --text-opacity:1;
  color:#cfd8e3;
  color:rgba(207,216,227,var(--text-opacity))
}

.hover\\:text-cool-gray-400:hover{
  --text-opacity:1;
  color:#97a6ba;
  color:rgba(151,166,186,var(--text-opacity))
}

.hover\\:text-cool-gray-500:hover{
  --text-opacity:1;
  color:#64748b;
  color:rgba(100,116,139,var(--text-opacity))
}

.hover\\:text-cool-gray-600:hover{
  --text-opacity:1;
  color:#475569;
  color:rgba(71,85,105,var(--text-opacity))
}

.hover\\:text-cool-gray-700:hover{
  --text-opacity:1;
  color:#364152;
  color:rgba(54,65,82,var(--text-opacity))
}

.hover\\:text-cool-gray-800:hover{
  --text-opacity:1;
  color:#27303f;
  color:rgba(39,48,63,var(--text-opacity))
}

.hover\\:text-cool-gray-900:hover{
  --text-opacity:1;
  color:#1a202e;
  color:rgba(26,32,46,var(--text-opacity))
}

.hover\\:text-red-50:hover{
  --text-opacity:1;
  color:#fdf2f2;
  color:rgba(253,242,242,var(--text-opacity))
}

.hover\\:text-red-100:hover{
  --text-opacity:1;
  color:#fde8e8;
  color:rgba(253,232,232,var(--text-opacity))
}

.hover\\:text-red-200:hover{
  --text-opacity:1;
  color:#fbd5d5;
  color:rgba(251,213,213,var(--text-opacity))
}

.hover\\:text-red-300:hover{
  --text-opacity:1;
  color:#f8b4b4;
  color:rgba(248,180,180,var(--text-opacity))
}

.hover\\:text-red-400:hover{
  --text-opacity:1;
  color:#f98080;
  color:rgba(249,128,128,var(--text-opacity))
}

.hover\\:text-red-500:hover{
  --text-opacity:1;
  color:#f05252;
  color:rgba(240,82,82,var(--text-opacity))
}

.hover\\:text-red-600:hover{
  --text-opacity:1;
  color:#e02424;
  color:rgba(224,36,36,var(--text-opacity))
}

.hover\\:text-red-700:hover{
  --text-opacity:1;
  color:#c81e1e;
  color:rgba(200,30,30,var(--text-opacity))
}

.hover\\:text-red-800:hover{
  --text-opacity:1;
  color:#9b1c1c;
  color:rgba(155,28,28,var(--text-opacity))
}

.hover\\:text-red-900:hover{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.hover\\:text-orange-50:hover{
  --text-opacity:1;
  color:#fff8f1;
  color:rgba(255,248,241,var(--text-opacity))
}

.hover\\:text-orange-100:hover{
  --text-opacity:1;
  color:#feecdc;
  color:rgba(254,236,220,var(--text-opacity))
}

.hover\\:text-orange-200:hover{
  --text-opacity:1;
  color:#fcd9bd;
  color:rgba(252,217,189,var(--text-opacity))
}

.hover\\:text-orange-300:hover{
  --text-opacity:1;
  color:#fdba8c;
  color:rgba(253,186,140,var(--text-opacity))
}

.hover\\:text-orange-400:hover{
  --text-opacity:1;
  color:#ff8a4c;
  color:rgba(255,138,76,var(--text-opacity))
}

.hover\\:text-orange-500:hover{
  --text-opacity:1;
  color:#ff5a1f;
  color:rgba(255,90,31,var(--text-opacity))
}

.hover\\:text-orange-600:hover{
  --text-opacity:1;
  color:#d03801;
  color:rgba(208,56,1,var(--text-opacity))
}

.hover\\:text-orange-700:hover{
  --text-opacity:1;
  color:#b43403;
  color:rgba(180,52,3,var(--text-opacity))
}

.hover\\:text-orange-800:hover{
  --text-opacity:1;
  color:#8a2c0d;
  color:rgba(138,44,13,var(--text-opacity))
}

.hover\\:text-orange-900:hover{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.hover\\:text-yellow-50:hover{
  --text-opacity:1;
  color:#fdfdea;
  color:rgba(253,253,234,var(--text-opacity))
}

.hover\\:text-yellow-100:hover{
  --text-opacity:1;
  color:#fdf6b2;
  color:rgba(253,246,178,var(--text-opacity))
}

.hover\\:text-yellow-200:hover{
  --text-opacity:1;
  color:#fce96a;
  color:rgba(252,233,106,var(--text-opacity))
}

.hover\\:text-yellow-300:hover{
  --text-opacity:1;
  color:#faca15;
  color:rgba(250,202,21,var(--text-opacity))
}

.hover\\:text-yellow-400:hover{
  --text-opacity:1;
  color:#e3a008;
  color:rgba(227,160,8,var(--text-opacity))
}

.hover\\:text-yellow-500:hover{
  --text-opacity:1;
  color:#c27803;
  color:rgba(194,120,3,var(--text-opacity))
}

.hover\\:text-yellow-600:hover{
  --text-opacity:1;
  color:#9f580a;
  color:rgba(159,88,10,var(--text-opacity))
}

.hover\\:text-yellow-700:hover{
  --text-opacity:1;
  color:#8e4b10;
  color:rgba(142,75,16,var(--text-opacity))
}

.hover\\:text-yellow-800:hover{
  --text-opacity:1;
  color:#723b13;
  color:rgba(114,59,19,var(--text-opacity))
}

.hover\\:text-yellow-900:hover{
  --text-opacity:1;
  color:#633112;
  color:rgba(99,49,18,var(--text-opacity))
}

.hover\\:text-green-50:hover{
  --text-opacity:1;
  color:#f3faf7;
  color:rgba(243,250,247,var(--text-opacity))
}

.hover\\:text-green-100:hover{
  --text-opacity:1;
  color:#def7ec;
  color:rgba(222,247,236,var(--text-opacity))
}

.hover\\:text-green-200:hover{
  --text-opacity:1;
  color:#bcf0da;
  color:rgba(188,240,218,var(--text-opacity))
}

.hover\\:text-green-300:hover{
  --text-opacity:1;
  color:#84e1bc;
  color:rgba(132,225,188,var(--text-opacity))
}

.hover\\:text-green-400:hover{
  --text-opacity:1;
  color:#31c48d;
  color:rgba(49,196,141,var(--text-opacity))
}

.hover\\:text-green-500:hover{
  --text-opacity:1;
  color:#0e9f6e;
  color:rgba(14,159,110,var(--text-opacity))
}

.hover\\:text-green-600:hover{
  --text-opacity:1;
  color:#057a55;
  color:rgba(5,122,85,var(--text-opacity))
}

.hover\\:text-green-700:hover{
  --text-opacity:1;
  color:#046c4e;
  color:rgba(4,108,78,var(--text-opacity))
}

.hover\\:text-green-800:hover{
  --text-opacity:1;
  color:#03543f;
  color:rgba(3,84,63,var(--text-opacity))
}

.hover\\:text-green-900:hover{
  --text-opacity:1;
  color:#014737;
  color:rgba(1,71,55,var(--text-opacity))
}

.hover\\:text-teal-50:hover{
  --text-opacity:1;
  color:#edfafa;
  color:rgba(237,250,250,var(--text-opacity))
}

.hover\\:text-teal-100:hover{
  --text-opacity:1;
  color:#d5f5f6;
  color:rgba(213,245,246,var(--text-opacity))
}

.hover\\:text-teal-200:hover{
  --text-opacity:1;
  color:#afecef;
  color:rgba(175,236,239,var(--text-opacity))
}

.hover\\:text-teal-300:hover{
  --text-opacity:1;
  color:#7edce2;
  color:rgba(126,220,226,var(--text-opacity))
}

.hover\\:text-teal-400:hover{
  --text-opacity:1;
  color:#16bdca;
  color:rgba(22,189,202,var(--text-opacity))
}

.hover\\:text-teal-500:hover{
  --text-opacity:1;
  color:#0694a2;
  color:rgba(6,148,162,var(--text-opacity))
}

.hover\\:text-teal-600:hover{
  --text-opacity:1;
  color:#047481;
  color:rgba(4,116,129,var(--text-opacity))
}

.hover\\:text-teal-700:hover{
  --text-opacity:1;
  color:#036672;
  color:rgba(3,102,114,var(--text-opacity))
}

.hover\\:text-teal-800:hover{
  --text-opacity:1;
  color:#05505c;
  color:rgba(5,80,92,var(--text-opacity))
}

.hover\\:text-teal-900:hover{
  --text-opacity:1;
  color:#014451;
  color:rgba(1,68,81,var(--text-opacity))
}

.hover\\:text-blue-50:hover{
  --text-opacity:1;
  color:#ebf5ff;
  color:rgba(235,245,255,var(--text-opacity))
}

.hover\\:text-blue-100:hover{
  --text-opacity:1;
  color:#e1effe;
  color:rgba(225,239,254,var(--text-opacity))
}

.hover\\:text-blue-200:hover{
  --text-opacity:1;
  color:#c3ddfd;
  color:rgba(195,221,253,var(--text-opacity))
}

.hover\\:text-blue-300:hover{
  --text-opacity:1;
  color:#a4cafe;
  color:rgba(164,202,254,var(--text-opacity))
}

.hover\\:text-blue-400:hover{
  --text-opacity:1;
  color:#76a9fa;
  color:rgba(118,169,250,var(--text-opacity))
}

.hover\\:text-blue-500:hover{
  --text-opacity:1;
  color:#3f83f8;
  color:rgba(63,131,248,var(--text-opacity))
}

.hover\\:text-blue-600:hover{
  --text-opacity:1;
  color:#1c64f2;
  color:rgba(28,100,242,var(--text-opacity))
}

.hover\\:text-blue-700:hover{
  --text-opacity:1;
  color:#1a56db;
  color:rgba(26,86,219,var(--text-opacity))
}

.hover\\:text-blue-800:hover{
  --text-opacity:1;
  color:#1e429f;
  color:rgba(30,66,159,var(--text-opacity))
}

.hover\\:text-blue-900:hover{
  --text-opacity:1;
  color:#233876;
  color:rgba(35,56,118,var(--text-opacity))
}

.hover\\:text-indigo-50:hover{
  --text-opacity:1;
  color:#f0f5ff;
  color:rgba(240,245,255,var(--text-opacity))
}

.hover\\:text-indigo-100:hover{
  --text-opacity:1;
  color:#e5edff;
  color:rgba(229,237,255,var(--text-opacity))
}

.hover\\:text-indigo-200:hover{
  --text-opacity:1;
  color:#cddbfe;
  color:rgba(205,219,254,var(--text-opacity))
}

.hover\\:text-indigo-300:hover{
  --text-opacity:1;
  color:#b4c6fc;
  color:rgba(180,198,252,var(--text-opacity))
}

.hover\\:text-indigo-400:hover{
  --text-opacity:1;
  color:#8da2fb;
  color:rgba(141,162,251,var(--text-opacity))
}

.hover\\:text-indigo-500:hover{
  --text-opacity:1;
  color:#6875f5;
  color:rgba(104,117,245,var(--text-opacity))
}

.hover\\:text-indigo-600:hover{
  --text-opacity:1;
  color:#5850ec;
  color:rgba(88,80,236,var(--text-opacity))
}

.hover\\:text-indigo-700:hover{
  --text-opacity:1;
  color:#5145cd;
  color:rgba(81,69,205,var(--text-opacity))
}

.hover\\:text-indigo-800:hover{
  --text-opacity:1;
  color:#42389d;
  color:rgba(66,56,157,var(--text-opacity))
}

.hover\\:text-indigo-900:hover{
  --text-opacity:1;
  color:#362f78;
  color:rgba(54,47,120,var(--text-opacity))
}

.hover\\:text-indigo-50:hover{
  --text-opacity:1;
  color:#f6f5ff;
  color:rgba(246,245,255,var(--text-opacity))
}

.hover\\:text-indigo-100:hover{
  --text-opacity:1;
  color:#edebfe;
  color:rgba(237,235,254,var(--text-opacity))
}

.hover\\:text-indigo-200:hover{
  --text-opacity:1;
  color:#dcd7fe;
  color:rgba(220,215,254,var(--text-opacity))
}

.hover\\:text-indigo-300:hover{
  --text-opacity:1;
  color:#cabffd;
  color:rgba(202,191,253,var(--text-opacity))
}

.hover\\:text-indigo-400:hover{
  --text-opacity:1;
  color:#ac94fa;
  color:rgba(172,148,250,var(--text-opacity))
}

.hover\\:text-indigo-500:hover{
  --text-opacity:1;
  color:#9061f9;
  color:rgba(144,97,249,var(--text-opacity))
}

.hover\\:text-indigo-600:hover{
  --text-opacity:1;
  color:#7e3af2;
  color:rgba(126,58,242,var(--text-opacity))
}

.hover\\:text-indigo-700:hover{
  --text-opacity:1;
  color:#6c2bd9;
  color:rgba(108,43,217,var(--text-opacity))
}

.hover\\:text-indigo-800:hover{
  --text-opacity:1;
  color:#5521b5;
  color:rgba(85,33,181,var(--text-opacity))
}

.hover\\:text-indigo-900:hover{
  --text-opacity:1;
  color:#4a1d96;
  color:rgba(74,29,150,var(--text-opacity))
}

.hover\\:text-pink-50:hover{
  --text-opacity:1;
  color:#fdf2f8;
  color:rgba(253,242,248,var(--text-opacity))
}

.hover\\:text-pink-100:hover{
  --text-opacity:1;
  color:#fce8f3;
  color:rgba(252,232,243,var(--text-opacity))
}

.hover\\:text-pink-200:hover{
  --text-opacity:1;
  color:#fad1e8;
  color:rgba(250,209,232,var(--text-opacity))
}

.hover\\:text-pink-300:hover{
  --text-opacity:1;
  color:#f8b4d9;
  color:rgba(248,180,217,var(--text-opacity))
}

.hover\\:text-pink-400:hover{
  --text-opacity:1;
  color:#f17eb8;
  color:rgba(241,126,184,var(--text-opacity))
}

.hover\\:text-pink-500:hover{
  --text-opacity:1;
  color:#e74694;
  color:rgba(231,70,148,var(--text-opacity))
}

.hover\\:text-pink-600:hover{
  --text-opacity:1;
  color:#d61f69;
  color:rgba(214,31,105,var(--text-opacity))
}

.hover\\:text-pink-700:hover{
  --text-opacity:1;
  color:#bf125d;
  color:rgba(191,18,93,var(--text-opacity))
}

.hover\\:text-pink-800:hover{
  --text-opacity:1;
  color:#99154b;
  color:rgba(153,21,75,var(--text-opacity))
}

.hover\\:text-pink-900:hover{
  --text-opacity:1;
  color:#751a3d;
  color:rgba(117,26,61,var(--text-opacity))
}

.active\\:text-transparent:active{
  color:#0000
}

.active\\:text-white:active{
  --text-opacity:1;
  color:#fff;
  color:rgba(255,255,255,var(--text-opacity))
}

.active\\:text-black:active{
  --text-opacity:1;
  color:#000;
  color:rgba(0,0,0,var(--text-opacity))
}

.active\\:text-gray-50:active{
  --text-opacity:1;
  color:#f9fafb;
  color:rgba(249,250,251,var(--text-opacity))
}

.active\\:text-gray-100:active{
  --text-opacity:1;
  color:#f4f5f7;
  color:rgba(244,245,247,var(--text-opacity))
}

.active\\:text-gray-200:active{
  --text-opacity:1;
  color:#e5e7eb;
  color:rgba(229,231,235,var(--text-opacity))
}

.active\\:text-gray-300:active{
  --text-opacity:1;
  color:#d5d6d7;
  color:rgba(213,214,215,var(--text-opacity))
}

.active\\:text-gray-400:active{
  --text-opacity:1;
  color:#9e9e9e;
  color:rgba(158,158,158,var(--text-opacity))
}

.active\\:text-gray-500:active{
  --text-opacity:1;
  color:#707275;
  color:rgba(112,114,117,var(--text-opacity))
}

.active\\:text-gray-600:active{
  --text-opacity:1;
  color:#4c4f52;
  color:rgba(76,79,82,var(--text-opacity))
}

.active\\:text-gray-700:active{
  --text-opacity:1;
  color:#24262d;
  color:rgba(36,38,45,var(--text-opacity))
}

.active\\:text-gray-800:active{
  --text-opacity:1;
  color:#1a1c23;
  color:rgba(26,28,35,var(--text-opacity))
}

.active\\:text-gray-900:active{
  --text-opacity:1;
  color:#121317;
  color:rgba(18,19,23,var(--text-opacity))
}

.active\\:text-cool-gray-50:active{
  --text-opacity:1;
  color:#fbfdfe;
  color:rgba(251,253,254,var(--text-opacity))
}

.active\\:text-cool-gray-100:active{
  --text-opacity:1;
  color:#f1f5f9;
  color:rgba(241,245,249,var(--text-opacity))
}

.active\\:text-cool-gray-200:active{
  --text-opacity:1;
  color:#e2e8f0;
  color:rgba(226,232,240,var(--text-opacity))
}

.active\\:text-cool-gray-300:active{
  --text-opacity:1;
  color:#cfd8e3;
  color:rgba(207,216,227,var(--text-opacity))
}

.active\\:text-cool-gray-400:active{
  --text-opacity:1;
  color:#97a6ba;
  color:rgba(151,166,186,var(--text-opacity))
}

.active\\:text-cool-gray-500:active{
  --text-opacity:1;
  color:#64748b;
  color:rgba(100,116,139,var(--text-opacity))
}

.active\\:text-cool-gray-600:active{
  --text-opacity:1;
  color:#475569;
  color:rgba(71,85,105,var(--text-opacity))
}

.active\\:text-cool-gray-700:active{
  --text-opacity:1;
  color:#364152;
  color:rgba(54,65,82,var(--text-opacity))
}

.active\\:text-cool-gray-800:active{
  --text-opacity:1;
  color:#27303f;
  color:rgba(39,48,63,var(--text-opacity))
}

.active\\:text-cool-gray-900:active{
  --text-opacity:1;
  color:#1a202e;
  color:rgba(26,32,46,var(--text-opacity))
}

.active\\:text-red-50:active{
  --text-opacity:1;
  color:#fdf2f2;
  color:rgba(253,242,242,var(--text-opacity))
}

.active\\:text-red-100:active{
  --text-opacity:1;
  color:#fde8e8;
  color:rgba(253,232,232,var(--text-opacity))
}

.active\\:text-red-200:active{
  --text-opacity:1;
  color:#fbd5d5;
  color:rgba(251,213,213,var(--text-opacity))
}

.active\\:text-red-300:active{
  --text-opacity:1;
  color:#f8b4b4;
  color:rgba(248,180,180,var(--text-opacity))
}

.active\\:text-red-400:active{
  --text-opacity:1;
  color:#f98080;
  color:rgba(249,128,128,var(--text-opacity))
}

.active\\:text-red-500:active{
  --text-opacity:1;
  color:#f05252;
  color:rgba(240,82,82,var(--text-opacity))
}

.active\\:text-red-600:active{
  --text-opacity:1;
  color:#e02424;
  color:rgba(224,36,36,var(--text-opacity))
}

.active\\:text-red-700:active{
  --text-opacity:1;
  color:#c81e1e;
  color:rgba(200,30,30,var(--text-opacity))
}

.active\\:text-red-800:active{
  --text-opacity:1;
  color:#9b1c1c;
  color:rgba(155,28,28,var(--text-opacity))
}

.active\\:text-red-900:active{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.active\\:text-orange-50:active{
  --text-opacity:1;
  color:#fff8f1;
  color:rgba(255,248,241,var(--text-opacity))
}

.active\\:text-orange-100:active{
  --text-opacity:1;
  color:#feecdc;
  color:rgba(254,236,220,var(--text-opacity))
}

.active\\:text-orange-200:active{
  --text-opacity:1;
  color:#fcd9bd;
  color:rgba(252,217,189,var(--text-opacity))
}

.active\\:text-orange-300:active{
  --text-opacity:1;
  color:#fdba8c;
  color:rgba(253,186,140,var(--text-opacity))
}

.active\\:text-orange-400:active{
  --text-opacity:1;
  color:#ff8a4c;
  color:rgba(255,138,76,var(--text-opacity))
}

.active\\:text-orange-500:active{
  --text-opacity:1;
  color:#ff5a1f;
  color:rgba(255,90,31,var(--text-opacity))
}

.active\\:text-orange-600:active{
  --text-opacity:1;
  color:#d03801;
  color:rgba(208,56,1,var(--text-opacity))
}

.active\\:text-orange-700:active{
  --text-opacity:1;
  color:#b43403;
  color:rgba(180,52,3,var(--text-opacity))
}

.active\\:text-orange-800:active{
  --text-opacity:1;
  color:#8a2c0d;
  color:rgba(138,44,13,var(--text-opacity))
}

.active\\:text-orange-900:active{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.active\\:text-yellow-50:active{
  --text-opacity:1;
  color:#fdfdea;
  color:rgba(253,253,234,var(--text-opacity))
}

.active\\:text-yellow-100:active{
  --text-opacity:1;
  color:#fdf6b2;
  color:rgba(253,246,178,var(--text-opacity))
}

.active\\:text-yellow-200:active{
  --text-opacity:1;
  color:#fce96a;
  color:rgba(252,233,106,var(--text-opacity))
}

.active\\:text-yellow-300:active{
  --text-opacity:1;
  color:#faca15;
  color:rgba(250,202,21,var(--text-opacity))
}

.active\\:text-yellow-400:active{
  --text-opacity:1;
  color:#e3a008;
  color:rgba(227,160,8,var(--text-opacity))
}

.active\\:text-yellow-500:active{
  --text-opacity:1;
  color:#c27803;
  color:rgba(194,120,3,var(--text-opacity))
}

.active\\:text-yellow-600:active{
  --text-opacity:1;
  color:#9f580a;
  color:rgba(159,88,10,var(--text-opacity))
}

.active\\:text-yellow-700:active{
  --text-opacity:1;
  color:#8e4b10;
  color:rgba(142,75,16,var(--text-opacity))
}

.active\\:text-yellow-800:active{
  --text-opacity:1;
  color:#723b13;
  color:rgba(114,59,19,var(--text-opacity))
}

.active\\:text-yellow-900:active{
  --text-opacity:1;
  color:#633112;
  color:rgba(99,49,18,var(--text-opacity))
}

.active\\:text-green-50:active{
  --text-opacity:1;
  color:#f3faf7;
  color:rgba(243,250,247,var(--text-opacity))
}

.active\\:text-green-100:active{
  --text-opacity:1;
  color:#def7ec;
  color:rgba(222,247,236,var(--text-opacity))
}

.active\\:text-green-200:active{
  --text-opacity:1;
  color:#bcf0da;
  color:rgba(188,240,218,var(--text-opacity))
}

.active\\:text-green-300:active{
  --text-opacity:1;
  color:#84e1bc;
  color:rgba(132,225,188,var(--text-opacity))
}

.active\\:text-green-400:active{
  --text-opacity:1;
  color:#31c48d;
  color:rgba(49,196,141,var(--text-opacity))
}

.active\\:text-green-500:active{
  --text-opacity:1;
  color:#0e9f6e;
  color:rgba(14,159,110,var(--text-opacity))
}

.active\\:text-green-600:active{
  --text-opacity:1;
  color:#057a55;
  color:rgba(5,122,85,var(--text-opacity))
}

.active\\:text-green-700:active{
  --text-opacity:1;
  color:#046c4e;
  color:rgba(4,108,78,var(--text-opacity))
}

.active\\:text-green-800:active{
  --text-opacity:1;
  color:#03543f;
  color:rgba(3,84,63,var(--text-opacity))
}

.active\\:text-green-900:active{
  --text-opacity:1;
  color:#014737;
  color:rgba(1,71,55,var(--text-opacity))
}

.active\\:text-teal-50:active{
  --text-opacity:1;
  color:#edfafa;
  color:rgba(237,250,250,var(--text-opacity))
}

.active\\:text-teal-100:active{
  --text-opacity:1;
  color:#d5f5f6;
  color:rgba(213,245,246,var(--text-opacity))
}

.active\\:text-teal-200:active{
  --text-opacity:1;
  color:#afecef;
  color:rgba(175,236,239,var(--text-opacity))
}

.active\\:text-teal-300:active{
  --text-opacity:1;
  color:#7edce2;
  color:rgba(126,220,226,var(--text-opacity))
}

.active\\:text-teal-400:active{
  --text-opacity:1;
  color:#16bdca;
  color:rgba(22,189,202,var(--text-opacity))
}

.active\\:text-teal-500:active{
  --text-opacity:1;
  color:#0694a2;
  color:rgba(6,148,162,var(--text-opacity))
}

.active\\:text-teal-600:active{
  --text-opacity:1;
  color:#047481;
  color:rgba(4,116,129,var(--text-opacity))
}

.active\\:text-teal-700:active{
  --text-opacity:1;
  color:#036672;
  color:rgba(3,102,114,var(--text-opacity))
}

.active\\:text-teal-800:active{
  --text-opacity:1;
  color:#05505c;
  color:rgba(5,80,92,var(--text-opacity))
}

.active\\:text-teal-900:active{
  --text-opacity:1;
  color:#014451;
  color:rgba(1,68,81,var(--text-opacity))
}

.active\\:text-blue-50:active{
  --text-opacity:1;
  color:#ebf5ff;
  color:rgba(235,245,255,var(--text-opacity))
}

.active\\:text-blue-100:active{
  --text-opacity:1;
  color:#e1effe;
  color:rgba(225,239,254,var(--text-opacity))
}

.active\\:text-blue-200:active{
  --text-opacity:1;
  color:#c3ddfd;
  color:rgba(195,221,253,var(--text-opacity))
}

.active\\:text-blue-300:active{
  --text-opacity:1;
  color:#a4cafe;
  color:rgba(164,202,254,var(--text-opacity))
}

.active\\:text-blue-400:active{
  --text-opacity:1;
  color:#76a9fa;
  color:rgba(118,169,250,var(--text-opacity))
}

.active\\:text-blue-500:active{
  --text-opacity:1;
  color:#3f83f8;
  color:rgba(63,131,248,var(--text-opacity))
}

.active\\:text-blue-600:active{
  --text-opacity:1;
  color:#1c64f2;
  color:rgba(28,100,242,var(--text-opacity))
}

.active\\:text-blue-700:active{
  --text-opacity:1;
  color:#1a56db;
  color:rgba(26,86,219,var(--text-opacity))
}

.active\\:text-blue-800:active{
  --text-opacity:1;
  color:#1e429f;
  color:rgba(30,66,159,var(--text-opacity))
}

.active\\:text-blue-900:active{
  --text-opacity:1;
  color:#233876;
  color:rgba(35,56,118,var(--text-opacity))
}

.active\\:text-indigo-50:active{
  --text-opacity:1;
  color:#f0f5ff;
  color:rgba(240,245,255,var(--text-opacity))
}

.active\\:text-indigo-100:active{
  --text-opacity:1;
  color:#e5edff;
  color:rgba(229,237,255,var(--text-opacity))
}

.active\\:text-indigo-200:active{
  --text-opacity:1;
  color:#cddbfe;
  color:rgba(205,219,254,var(--text-opacity))
}

.active\\:text-indigo-300:active{
  --text-opacity:1;
  color:#b4c6fc;
  color:rgba(180,198,252,var(--text-opacity))
}

.active\\:text-indigo-400:active{
  --text-opacity:1;
  color:#8da2fb;
  color:rgba(141,162,251,var(--text-opacity))
}

.active\\:text-indigo-500:active{
  --text-opacity:1;
  color:#6875f5;
  color:rgba(104,117,245,var(--text-opacity))
}

.active\\:text-indigo-600:active{
  --text-opacity:1;
  color:#5850ec;
  color:rgba(88,80,236,var(--text-opacity))
}

.active\\:text-indigo-700:active{
  --text-opacity:1;
  color:#5145cd;
  color:rgba(81,69,205,var(--text-opacity))
}

.active\\:text-indigo-800:active{
  --text-opacity:1;
  color:#42389d;
  color:rgba(66,56,157,var(--text-opacity))
}

.active\\:text-indigo-900:active{
  --text-opacity:1;
  color:#362f78;
  color:rgba(54,47,120,var(--text-opacity))
}

.active\\:text-indigo-50:active{
  --text-opacity:1;
  color:#f6f5ff;
  color:rgba(246,245,255,var(--text-opacity))
}

.active\\:text-indigo-100:active{
  --text-opacity:1;
  color:#edebfe;
  color:rgba(237,235,254,var(--text-opacity))
}

.active\\:text-indigo-200:active{
  --text-opacity:1;
  color:#dcd7fe;
  color:rgba(220,215,254,var(--text-opacity))
}

.active\\:text-indigo-300:active{
  --text-opacity:1;
  color:#cabffd;
  color:rgba(202,191,253,var(--text-opacity))
}

.active\\:text-indigo-400:active{
  --text-opacity:1;
  color:#ac94fa;
  color:rgba(172,148,250,var(--text-opacity))
}

.active\\:text-indigo-500:active{
  --text-opacity:1;
  color:#9061f9;
  color:rgba(144,97,249,var(--text-opacity))
}

.active\\:text-indigo-600:active{
  --text-opacity:1;
  color:#7e3af2;
  color:rgba(126,58,242,var(--text-opacity))
}

.active\\:text-indigo-700:active{
  --text-opacity:1;
  color:#6c2bd9;
  color:rgba(108,43,217,var(--text-opacity))
}

.active\\:text-indigo-800:active{
  --text-opacity:1;
  color:#5521b5;
  color:rgba(85,33,181,var(--text-opacity))
}

.active\\:text-indigo-900:active{
  --text-opacity:1;
  color:#4a1d96;
  color:rgba(74,29,150,var(--text-opacity))
}

.active\\:text-pink-50:active{
  --text-opacity:1;
  color:#fdf2f8;
  color:rgba(253,242,248,var(--text-opacity))
}

.active\\:text-pink-100:active{
  --text-opacity:1;
  color:#fce8f3;
  color:rgba(252,232,243,var(--text-opacity))
}

.active\\:text-pink-200:active{
  --text-opacity:1;
  color:#fad1e8;
  color:rgba(250,209,232,var(--text-opacity))
}

.active\\:text-pink-300:active{
  --text-opacity:1;
  color:#f8b4d9;
  color:rgba(248,180,217,var(--text-opacity))
}

.active\\:text-pink-400:active{
  --text-opacity:1;
  color:#f17eb8;
  color:rgba(241,126,184,var(--text-opacity))
}

.active\\:text-pink-500:active{
  --text-opacity:1;
  color:#e74694;
  color:rgba(231,70,148,var(--text-opacity))
}

.active\\:text-pink-600:active{
  --text-opacity:1;
  color:#d61f69;
  color:rgba(214,31,105,var(--text-opacity))
}

.active\\:text-pink-700:active{
  --text-opacity:1;
  color:#bf125d;
  color:rgba(191,18,93,var(--text-opacity))
}

.active\\:text-pink-800:active{
  --text-opacity:1;
  color:#99154b;
  color:rgba(153,21,75,var(--text-opacity))
}

.active\\:text-pink-900:active{
  --text-opacity:1;
  color:#751a3d;
  color:rgba(117,26,61,var(--text-opacity))
}

.theme-dark .dark\\:text-transparent{
  color:#0000
}

.theme-dark .dark\\:text-white{
  --text-opacity:1;
  color:#fff;
  color:rgba(255,255,255,var(--text-opacity))
}

.theme-dark .dark\\:text-black{
  --text-opacity:1;
  color:#000;
  color:rgba(0,0,0,var(--text-opacity))
}

.theme-dark .dark\\:text-gray-50{
  --text-opacity:1;
  color:#f9fafb;
  color:rgba(249,250,251,var(--text-opacity))
}

.theme-dark .dark\\:text-gray-100{
  --text-opacity:1;
  color:#f4f5f7;
  color:rgba(244,245,247,var(--text-opacity))
}

.theme-dark .dark\\:text-gray-200{
  --text-opacity:1;
  color:#e5e7eb;
  color:rgba(229,231,235,var(--text-opacity))
}

.theme-dark .dark\\:text-gray-300{
  --text-opacity:1;
  color:#d5d6d7;
  color:rgba(213,214,215,var(--text-opacity))
}

.theme-dark .dark\\:text-gray-400{
  --text-opacity:1;
  color:#9e9e9e;
  color:rgba(158,158,158,var(--text-opacity))
}

.theme-dark .dark\\:text-gray-500{
  --text-opacity:1;
  color:#707275;
  color:rgba(112,114,117,var(--text-opacity))
}

.theme-dark .dark\\:text-gray-600{
  --text-opacity:1;
  color:#4c4f52;
  color:rgba(76,79,82,var(--text-opacity))
}

.theme-dark .dark\\:text-gray-700{
  --text-opacity:1;
  color:#24262d;
  color:rgba(36,38,45,var(--text-opacity))
}

.theme-dark .dark\\:text-gray-800{
  --text-opacity:1;
  color:#1a1c23;
  color:rgba(26,28,35,var(--text-opacity))
}

.theme-dark .dark\\:text-gray-900{
  --text-opacity:1;
  color:#121317;
  color:rgba(18,19,23,var(--text-opacity))
}

.theme-dark .dark\\:text-cool-gray-50{
  --text-opacity:1;
  color:#fbfdfe;
  color:rgba(251,253,254,var(--text-opacity))
}

.theme-dark .dark\\:text-cool-gray-100{
  --text-opacity:1;
  color:#f1f5f9;
  color:rgba(241,245,249,var(--text-opacity))
}

.theme-dark .dark\\:text-cool-gray-200{
  --text-opacity:1;
  color:#e2e8f0;
  color:rgba(226,232,240,var(--text-opacity))
}

.theme-dark .dark\\:text-cool-gray-300{
  --text-opacity:1;
  color:#cfd8e3;
  color:rgba(207,216,227,var(--text-opacity))
}

.theme-dark .dark\\:text-cool-gray-400{
  --text-opacity:1;
  color:#97a6ba;
  color:rgba(151,166,186,var(--text-opacity))
}

.theme-dark .dark\\:text-cool-gray-500{
  --text-opacity:1;
  color:#64748b;
  color:rgba(100,116,139,var(--text-opacity))
}

.theme-dark .dark\\:text-cool-gray-600{
  --text-opacity:1;
  color:#475569;
  color:rgba(71,85,105,var(--text-opacity))
}

.theme-dark .dark\\:text-cool-gray-700{
  --text-opacity:1;
  color:#364152;
  color:rgba(54,65,82,var(--text-opacity))
}

.theme-dark .dark\\:text-cool-gray-800{
  --text-opacity:1;
  color:#27303f;
  color:rgba(39,48,63,var(--text-opacity))
}

.theme-dark .dark\\:text-cool-gray-900{
  --text-opacity:1;
  color:#1a202e;
  color:rgba(26,32,46,var(--text-opacity))
}

.theme-dark .dark\\:text-red-50{
  --text-opacity:1;
  color:#fdf2f2;
  color:rgba(253,242,242,var(--text-opacity))
}

.theme-dark .dark\\:text-red-100{
  --text-opacity:1;
  color:#fde8e8;
  color:rgba(253,232,232,var(--text-opacity))
}

.theme-dark .dark\\:text-red-200{
  --text-opacity:1;
  color:#fbd5d5;
  color:rgba(251,213,213,var(--text-opacity))
}

.theme-dark .dark\\:text-red-300{
  --text-opacity:1;
  color:#f8b4b4;
  color:rgba(248,180,180,var(--text-opacity))
}

.theme-dark .dark\\:text-red-400{
  --text-opacity:1;
  color:#f98080;
  color:rgba(249,128,128,var(--text-opacity))
}

.theme-dark .dark\\:text-red-500{
  --text-opacity:1;
  color:#f05252;
  color:rgba(240,82,82,var(--text-opacity))
}

.theme-dark .dark\\:text-red-600{
  --text-opacity:1;
  color:#e02424;
  color:rgba(224,36,36,var(--text-opacity))
}

.theme-dark .dark\\:text-red-700{
  --text-opacity:1;
  color:#c81e1e;
  color:rgba(200,30,30,var(--text-opacity))
}

.theme-dark .dark\\:text-red-800{
  --text-opacity:1;
  color:#9b1c1c;
  color:rgba(155,28,28,var(--text-opacity))
}

.theme-dark .dark\\:text-red-900{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.theme-dark .dark\\:text-orange-50{
  --text-opacity:1;
  color:#fff8f1;
  color:rgba(255,248,241,var(--text-opacity))
}

.theme-dark .dark\\:text-orange-100{
  --text-opacity:1;
  color:#feecdc;
  color:rgba(254,236,220,var(--text-opacity))
}

.theme-dark .dark\\:text-orange-200{
  --text-opacity:1;
  color:#fcd9bd;
  color:rgba(252,217,189,var(--text-opacity))
}

.theme-dark .dark\\:text-orange-300{
  --text-opacity:1;
  color:#fdba8c;
  color:rgba(253,186,140,var(--text-opacity))
}

.theme-dark .dark\\:text-orange-400{
  --text-opacity:1;
  color:#ff8a4c;
  color:rgba(255,138,76,var(--text-opacity))
}

.theme-dark .dark\\:text-orange-500{
  --text-opacity:1;
  color:#ff5a1f;
  color:rgba(255,90,31,var(--text-opacity))
}

.theme-dark .dark\\:text-orange-600{
  --text-opacity:1;
  color:#d03801;
  color:rgba(208,56,1,var(--text-opacity))
}

.theme-dark .dark\\:text-orange-700{
  --text-opacity:1;
  color:#b43403;
  color:rgba(180,52,3,var(--text-opacity))
}

.theme-dark .dark\\:text-orange-800{
  --text-opacity:1;
  color:#8a2c0d;
  color:rgba(138,44,13,var(--text-opacity))
}

.theme-dark .dark\\:text-orange-900{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.theme-dark .dark\\:text-yellow-50{
  --text-opacity:1;
  color:#fdfdea;
  color:rgba(253,253,234,var(--text-opacity))
}

.theme-dark .dark\\:text-yellow-100{
  --text-opacity:1;
  color:#fdf6b2;
  color:rgba(253,246,178,var(--text-opacity))
}

.theme-dark .dark\\:text-yellow-200{
  --text-opacity:1;
  color:#fce96a;
  color:rgba(252,233,106,var(--text-opacity))
}

.theme-dark .dark\\:text-yellow-300{
  --text-opacity:1;
  color:#faca15;
  color:rgba(250,202,21,var(--text-opacity))
}

.theme-dark .dark\\:text-yellow-400{
  --text-opacity:1;
  color:#e3a008;
  color:rgba(227,160,8,var(--text-opacity))
}

.theme-dark .dark\\:text-yellow-500{
  --text-opacity:1;
  color:#c27803;
  color:rgba(194,120,3,var(--text-opacity))
}

.theme-dark .dark\\:text-yellow-600{
  --text-opacity:1;
  color:#9f580a;
  color:rgba(159,88,10,var(--text-opacity))
}

.theme-dark .dark\\:text-yellow-700{
  --text-opacity:1;
  color:#8e4b10;
  color:rgba(142,75,16,var(--text-opacity))
}

.theme-dark .dark\\:text-yellow-800{
  --text-opacity:1;
  color:#723b13;
  color:rgba(114,59,19,var(--text-opacity))
}

.theme-dark .dark\\:text-yellow-900{
  --text-opacity:1;
  color:#633112;
  color:rgba(99,49,18,var(--text-opacity))
}

.theme-dark .dark\\:text-green-50{
  --text-opacity:1;
  color:#f3faf7;
  color:rgba(243,250,247,var(--text-opacity))
}

.theme-dark .dark\\:text-green-100{
  --text-opacity:1;
  color:#def7ec;
  color:rgba(222,247,236,var(--text-opacity))
}

.theme-dark .dark\\:text-green-200{
  --text-opacity:1;
  color:#bcf0da;
  color:rgba(188,240,218,var(--text-opacity))
}

.theme-dark .dark\\:text-green-300{
  --text-opacity:1;
  color:#84e1bc;
  color:rgba(132,225,188,var(--text-opacity))
}

.theme-dark .dark\\:text-green-400{
  --text-opacity:1;
  color:#31c48d;
  color:rgba(49,196,141,var(--text-opacity))
}

.theme-dark .dark\\:text-green-500{
  --text-opacity:1;
  color:#0e9f6e;
  color:rgba(14,159,110,var(--text-opacity))
}

.theme-dark .dark\\:text-green-600{
  --text-opacity:1;
  color:#057a55;
  color:rgba(5,122,85,var(--text-opacity))
}

.theme-dark .dark\\:text-green-700{
  --text-opacity:1;
  color:#046c4e;
  color:rgba(4,108,78,var(--text-opacity))
}

.theme-dark .dark\\:text-green-800{
  --text-opacity:1;
  color:#03543f;
  color:rgba(3,84,63,var(--text-opacity))
}

.theme-dark .dark\\:text-green-900{
  --text-opacity:1;
  color:#014737;
  color:rgba(1,71,55,var(--text-opacity))
}

.theme-dark .dark\\:text-teal-50{
  --text-opacity:1;
  color:#edfafa;
  color:rgba(237,250,250,var(--text-opacity))
}

.theme-dark .dark\\:text-teal-100{
  --text-opacity:1;
  color:#d5f5f6;
  color:rgba(213,245,246,var(--text-opacity))
}

.theme-dark .dark\\:text-teal-200{
  --text-opacity:1;
  color:#afecef;
  color:rgba(175,236,239,var(--text-opacity))
}

.theme-dark .dark\\:text-teal-300{
  --text-opacity:1;
  color:#7edce2;
  color:rgba(126,220,226,var(--text-opacity))
}

.theme-dark .dark\\:text-teal-400{
  --text-opacity:1;
  color:#16bdca;
  color:rgba(22,189,202,var(--text-opacity))
}

.theme-dark .dark\\:text-teal-500{
  --text-opacity:1;
  color:#0694a2;
  color:rgba(6,148,162,var(--text-opacity))
}

.theme-dark .dark\\:text-teal-600{
  --text-opacity:1;
  color:#047481;
  color:rgba(4,116,129,var(--text-opacity))
}

.theme-dark .dark\\:text-teal-700{
  --text-opacity:1;
  color:#036672;
  color:rgba(3,102,114,var(--text-opacity))
}

.theme-dark .dark\\:text-teal-800{
  --text-opacity:1;
  color:#05505c;
  color:rgba(5,80,92,var(--text-opacity))
}

.theme-dark .dark\\:text-teal-900{
  --text-opacity:1;
  color:#014451;
  color:rgba(1,68,81,var(--text-opacity))
}

.theme-dark .dark\\:text-blue-50{
  --text-opacity:1;
  color:#ebf5ff;
  color:rgba(235,245,255,var(--text-opacity))
}

.theme-dark .dark\\:text-blue-100{
  --text-opacity:1;
  color:#e1effe;
  color:rgba(225,239,254,var(--text-opacity))
}

.theme-dark .dark\\:text-blue-200{
  --text-opacity:1;
  color:#c3ddfd;
  color:rgba(195,221,253,var(--text-opacity))
}

.theme-dark .dark\\:text-blue-300{
  --text-opacity:1;
  color:#a4cafe;
  color:rgba(164,202,254,var(--text-opacity))
}

.theme-dark .dark\\:text-blue-400{
  --text-opacity:1;
  color:#76a9fa;
  color:rgba(118,169,250,var(--text-opacity))
}

.theme-dark .dark\\:text-blue-500{
  --text-opacity:1;
  color:#3f83f8;
  color:rgba(63,131,248,var(--text-opacity))
}

.theme-dark .dark\\:text-blue-600{
  --text-opacity:1;
  color:#1c64f2;
  color:rgba(28,100,242,var(--text-opacity))
}

.theme-dark .dark\\:text-blue-700{
  --text-opacity:1;
  color:#1a56db;
  color:rgba(26,86,219,var(--text-opacity))
}

.theme-dark .dark\\:text-blue-800{
  --text-opacity:1;
  color:#1e429f;
  color:rgba(30,66,159,var(--text-opacity))
}

.theme-dark .dark\\:text-blue-900{
  --text-opacity:1;
  color:#233876;
  color:rgba(35,56,118,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-50{
  --text-opacity:1;
  color:#f0f5ff;
  color:rgba(240,245,255,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-100{
  --text-opacity:1;
  color:#e5edff;
  color:rgba(229,237,255,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-200{
  --text-opacity:1;
  color:#cddbfe;
  color:rgba(205,219,254,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-300{
  --text-opacity:1;
  color:#b4c6fc;
  color:rgba(180,198,252,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-400{
  --text-opacity:1;
  color:#8da2fb;
  color:rgba(141,162,251,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-500{
  --text-opacity:1;
  color:#6875f5;
  color:rgba(104,117,245,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-600{
  --text-opacity:1;
  color:#5850ec;
  color:rgba(88,80,236,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-700{
  --text-opacity:1;
  color:#5145cd;
  color:rgba(81,69,205,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-800{
  --text-opacity:1;
  color:#42389d;
  color:rgba(66,56,157,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-900{
  --text-opacity:1;
  color:#362f78;
  color:rgba(54,47,120,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-50{
  --text-opacity:1;
  color:#f6f5ff;
  color:rgba(246,245,255,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-100{
  --text-opacity:1;
  color:#edebfe;
  color:rgba(237,235,254,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-200{
  --text-opacity:1;
  color:#dcd7fe;
  color:rgba(220,215,254,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-300{
  --text-opacity:1;
  color:#cabffd;
  color:rgba(202,191,253,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-400{
  --text-opacity:1;
  color:#ac94fa;
  color:rgba(172,148,250,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-500{
  --text-opacity:1;
  color:#9061f9;
  color:rgba(144,97,249,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-600{
  --text-opacity:1;
  color:#7e3af2;
  color:rgba(126,58,242,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-700{
  --text-opacity:1;
  color:#6c2bd9;
  color:rgba(108,43,217,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-800{
  --text-opacity:1;
  color:#5521b5;
  color:rgba(85,33,181,var(--text-opacity))
}

.theme-dark .dark\\:text-indigo-900{
  --text-opacity:1;
  color:#4a1d96;
  color:rgba(74,29,150,var(--text-opacity))
}

.theme-dark .dark\\:text-pink-50{
  --text-opacity:1;
  color:#fdf2f8;
  color:rgba(253,242,248,var(--text-opacity))
}

.theme-dark .dark\\:text-pink-100{
  --text-opacity:1;
  color:#fce8f3;
  color:rgba(252,232,243,var(--text-opacity))
}

.theme-dark .dark\\:text-pink-200{
  --text-opacity:1;
  color:#fad1e8;
  color:rgba(250,209,232,var(--text-opacity))
}

.theme-dark .dark\\:text-pink-300{
  --text-opacity:1;
  color:#f8b4d9;
  color:rgba(248,180,217,var(--text-opacity))
}

.theme-dark .dark\\:text-pink-400{
  --text-opacity:1;
  color:#f17eb8;
  color:rgba(241,126,184,var(--text-opacity))
}

.theme-dark .dark\\:text-pink-500{
  --text-opacity:1;
  color:#e74694;
  color:rgba(231,70,148,var(--text-opacity))
}

.theme-dark .dark\\:text-pink-600{
  --text-opacity:1;
  color:#d61f69;
  color:rgba(214,31,105,var(--text-opacity))
}

.theme-dark .dark\\:text-pink-700{
  --text-opacity:1;
  color:#bf125d;
  color:rgba(191,18,93,var(--text-opacity))
}

.theme-dark .dark\\:text-pink-800{
  --text-opacity:1;
  color:#99154b;
  color:rgba(153,21,75,var(--text-opacity))
}

.theme-dark .dark\\:text-pink-900{
  --text-opacity:1;
  color:#751a3d;
  color:rgba(117,26,61,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-transparent:focus-within{
  color:#0000
}

.theme-dark .dark\\:focus-within\\:text-white:focus-within{
  --text-opacity:1;
  color:#fff;
  color:rgba(255,255,255,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-black:focus-within{
  --text-opacity:1;
  color:#000;
  color:rgba(0,0,0,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-gray-50:focus-within{
  --text-opacity:1;
  color:#f9fafb;
  color:rgba(249,250,251,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-gray-100:focus-within{
  --text-opacity:1;
  color:#f4f5f7;
  color:rgba(244,245,247,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-gray-200:focus-within{
  --text-opacity:1;
  color:#e5e7eb;
  color:rgba(229,231,235,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-gray-300:focus-within{
  --text-opacity:1;
  color:#d5d6d7;
  color:rgba(213,214,215,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-gray-400:focus-within{
  --text-opacity:1;
  color:#9e9e9e;
  color:rgba(158,158,158,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-gray-500:focus-within{
  --text-opacity:1;
  color:#707275;
  color:rgba(112,114,117,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-gray-600:focus-within{
  --text-opacity:1;
  color:#4c4f52;
  color:rgba(76,79,82,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-gray-700:focus-within{
  --text-opacity:1;
  color:#24262d;
  color:rgba(36,38,45,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-gray-800:focus-within{
  --text-opacity:1;
  color:#1a1c23;
  color:rgba(26,28,35,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-gray-900:focus-within{
  --text-opacity:1;
  color:#121317;
  color:rgba(18,19,23,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-cool-gray-50:focus-within{
  --text-opacity:1;
  color:#fbfdfe;
  color:rgba(251,253,254,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-cool-gray-100:focus-within{
  --text-opacity:1;
  color:#f1f5f9;
  color:rgba(241,245,249,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-cool-gray-200:focus-within{
  --text-opacity:1;
  color:#e2e8f0;
  color:rgba(226,232,240,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-cool-gray-300:focus-within{
  --text-opacity:1;
  color:#cfd8e3;
  color:rgba(207,216,227,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-cool-gray-400:focus-within{
  --text-opacity:1;
  color:#97a6ba;
  color:rgba(151,166,186,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-cool-gray-500:focus-within{
  --text-opacity:1;
  color:#64748b;
  color:rgba(100,116,139,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-cool-gray-600:focus-within{
  --text-opacity:1;
  color:#475569;
  color:rgba(71,85,105,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-cool-gray-700:focus-within{
  --text-opacity:1;
  color:#364152;
  color:rgba(54,65,82,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-cool-gray-800:focus-within{
  --text-opacity:1;
  color:#27303f;
  color:rgba(39,48,63,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-cool-gray-900:focus-within{
  --text-opacity:1;
  color:#1a202e;
  color:rgba(26,32,46,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-red-50:focus-within{
  --text-opacity:1;
  color:#fdf2f2;
  color:rgba(253,242,242,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-red-100:focus-within{
  --text-opacity:1;
  color:#fde8e8;
  color:rgba(253,232,232,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-red-200:focus-within{
  --text-opacity:1;
  color:#fbd5d5;
  color:rgba(251,213,213,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-red-300:focus-within{
  --text-opacity:1;
  color:#f8b4b4;
  color:rgba(248,180,180,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-red-400:focus-within{
  --text-opacity:1;
  color:#f98080;
  color:rgba(249,128,128,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-red-500:focus-within{
  --text-opacity:1;
  color:#f05252;
  color:rgba(240,82,82,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-red-600:focus-within{
  --text-opacity:1;
  color:#e02424;
  color:rgba(224,36,36,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-red-700:focus-within{
  --text-opacity:1;
  color:#c81e1e;
  color:rgba(200,30,30,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-red-800:focus-within{
  --text-opacity:1;
  color:#9b1c1c;
  color:rgba(155,28,28,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-red-900:focus-within{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-orange-50:focus-within{
  --text-opacity:1;
  color:#fff8f1;
  color:rgba(255,248,241,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-orange-100:focus-within{
  --text-opacity:1;
  color:#feecdc;
  color:rgba(254,236,220,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-orange-200:focus-within{
  --text-opacity:1;
  color:#fcd9bd;
  color:rgba(252,217,189,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-orange-300:focus-within{
  --text-opacity:1;
  color:#fdba8c;
  color:rgba(253,186,140,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-orange-400:focus-within{
  --text-opacity:1;
  color:#ff8a4c;
  color:rgba(255,138,76,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-orange-500:focus-within{
  --text-opacity:1;
  color:#ff5a1f;
  color:rgba(255,90,31,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-orange-600:focus-within{
  --text-opacity:1;
  color:#d03801;
  color:rgba(208,56,1,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-orange-700:focus-within{
  --text-opacity:1;
  color:#b43403;
  color:rgba(180,52,3,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-orange-800:focus-within{
  --text-opacity:1;
  color:#8a2c0d;
  color:rgba(138,44,13,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-orange-900:focus-within{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-yellow-50:focus-within{
  --text-opacity:1;
  color:#fdfdea;
  color:rgba(253,253,234,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-yellow-100:focus-within{
  --text-opacity:1;
  color:#fdf6b2;
  color:rgba(253,246,178,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-yellow-200:focus-within{
  --text-opacity:1;
  color:#fce96a;
  color:rgba(252,233,106,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-yellow-300:focus-within{
  --text-opacity:1;
  color:#faca15;
  color:rgba(250,202,21,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-yellow-400:focus-within{
  --text-opacity:1;
  color:#e3a008;
  color:rgba(227,160,8,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-yellow-500:focus-within{
  --text-opacity:1;
  color:#c27803;
  color:rgba(194,120,3,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-yellow-600:focus-within{
  --text-opacity:1;
  color:#9f580a;
  color:rgba(159,88,10,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-yellow-700:focus-within{
  --text-opacity:1;
  color:#8e4b10;
  color:rgba(142,75,16,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-yellow-800:focus-within{
  --text-opacity:1;
  color:#723b13;
  color:rgba(114,59,19,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-yellow-900:focus-within{
  --text-opacity:1;
  color:#633112;
  color:rgba(99,49,18,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-green-50:focus-within{
  --text-opacity:1;
  color:#f3faf7;
  color:rgba(243,250,247,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-green-100:focus-within{
  --text-opacity:1;
  color:#def7ec;
  color:rgba(222,247,236,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-green-200:focus-within{
  --text-opacity:1;
  color:#bcf0da;
  color:rgba(188,240,218,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-green-300:focus-within{
  --text-opacity:1;
  color:#84e1bc;
  color:rgba(132,225,188,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-green-400:focus-within{
  --text-opacity:1;
  color:#31c48d;
  color:rgba(49,196,141,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-green-500:focus-within{
  --text-opacity:1;
  color:#0e9f6e;
  color:rgba(14,159,110,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-green-600:focus-within{
  --text-opacity:1;
  color:#057a55;
  color:rgba(5,122,85,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-green-700:focus-within{
  --text-opacity:1;
  color:#046c4e;
  color:rgba(4,108,78,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-green-800:focus-within{
  --text-opacity:1;
  color:#03543f;
  color:rgba(3,84,63,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-green-900:focus-within{
  --text-opacity:1;
  color:#014737;
  color:rgba(1,71,55,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-teal-50:focus-within{
  --text-opacity:1;
  color:#edfafa;
  color:rgba(237,250,250,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-teal-100:focus-within{
  --text-opacity:1;
  color:#d5f5f6;
  color:rgba(213,245,246,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-teal-200:focus-within{
  --text-opacity:1;
  color:#afecef;
  color:rgba(175,236,239,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-teal-300:focus-within{
  --text-opacity:1;
  color:#7edce2;
  color:rgba(126,220,226,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-teal-400:focus-within{
  --text-opacity:1;
  color:#16bdca;
  color:rgba(22,189,202,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-teal-500:focus-within{
  --text-opacity:1;
  color:#0694a2;
  color:rgba(6,148,162,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-teal-600:focus-within{
  --text-opacity:1;
  color:#047481;
  color:rgba(4,116,129,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-teal-700:focus-within{
  --text-opacity:1;
  color:#036672;
  color:rgba(3,102,114,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-teal-800:focus-within{
  --text-opacity:1;
  color:#05505c;
  color:rgba(5,80,92,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-teal-900:focus-within{
  --text-opacity:1;
  color:#014451;
  color:rgba(1,68,81,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-blue-50:focus-within{
  --text-opacity:1;
  color:#ebf5ff;
  color:rgba(235,245,255,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-blue-100:focus-within{
  --text-opacity:1;
  color:#e1effe;
  color:rgba(225,239,254,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-blue-200:focus-within{
  --text-opacity:1;
  color:#c3ddfd;
  color:rgba(195,221,253,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-blue-300:focus-within{
  --text-opacity:1;
  color:#a4cafe;
  color:rgba(164,202,254,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-blue-400:focus-within{
  --text-opacity:1;
  color:#76a9fa;
  color:rgba(118,169,250,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-blue-500:focus-within{
  --text-opacity:1;
  color:#3f83f8;
  color:rgba(63,131,248,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-blue-600:focus-within{
  --text-opacity:1;
  color:#1c64f2;
  color:rgba(28,100,242,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-blue-700:focus-within{
  --text-opacity:1;
  color:#1a56db;
  color:rgba(26,86,219,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-blue-800:focus-within{
  --text-opacity:1;
  color:#1e429f;
  color:rgba(30,66,159,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-blue-900:focus-within{
  --text-opacity:1;
  color:#233876;
  color:rgba(35,56,118,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-50:focus-within{
  --text-opacity:1;
  color:#f0f5ff;
  color:rgba(240,245,255,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-100:focus-within{
  --text-opacity:1;
  color:#e5edff;
  color:rgba(229,237,255,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-200:focus-within{
  --text-opacity:1;
  color:#cddbfe;
  color:rgba(205,219,254,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-300:focus-within{
  --text-opacity:1;
  color:#b4c6fc;
  color:rgba(180,198,252,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-400:focus-within{
  --text-opacity:1;
  color:#8da2fb;
  color:rgba(141,162,251,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-500:focus-within{
  --text-opacity:1;
  color:#6875f5;
  color:rgba(104,117,245,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-600:focus-within{
  --text-opacity:1;
  color:#5850ec;
  color:rgba(88,80,236,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-700:focus-within{
  --text-opacity:1;
  color:#5145cd;
  color:rgba(81,69,205,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-800:focus-within{
  --text-opacity:1;
  color:#42389d;
  color:rgba(66,56,157,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-900:focus-within{
  --text-opacity:1;
  color:#362f78;
  color:rgba(54,47,120,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-50:focus-within{
  --text-opacity:1;
  color:#f6f5ff;
  color:rgba(246,245,255,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-100:focus-within{
  --text-opacity:1;
  color:#edebfe;
  color:rgba(237,235,254,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-200:focus-within{
  --text-opacity:1;
  color:#dcd7fe;
  color:rgba(220,215,254,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-300:focus-within{
  --text-opacity:1;
  color:#cabffd;
  color:rgba(202,191,253,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-400:focus-within{
  --text-opacity:1;
  color:#ac94fa;
  color:rgba(172,148,250,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-500:focus-within{
  --text-opacity:1;
  color:#9061f9;
  color:rgba(144,97,249,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-600:focus-within{
  --text-opacity:1;
  color:#7e3af2;
  color:rgba(126,58,242,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-700:focus-within{
  --text-opacity:1;
  color:#6c2bd9;
  color:rgba(108,43,217,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-800:focus-within{
  --text-opacity:1;
  color:#5521b5;
  color:rgba(85,33,181,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-indigo-900:focus-within{
  --text-opacity:1;
  color:#4a1d96;
  color:rgba(74,29,150,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-pink-50:focus-within{
  --text-opacity:1;
  color:#fdf2f8;
  color:rgba(253,242,248,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-pink-100:focus-within{
  --text-opacity:1;
  color:#fce8f3;
  color:rgba(252,232,243,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-pink-200:focus-within{
  --text-opacity:1;
  color:#fad1e8;
  color:rgba(250,209,232,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-pink-300:focus-within{
  --text-opacity:1;
  color:#f8b4d9;
  color:rgba(248,180,217,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-pink-400:focus-within{
  --text-opacity:1;
  color:#f17eb8;
  color:rgba(241,126,184,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-pink-500:focus-within{
  --text-opacity:1;
  color:#e74694;
  color:rgba(231,70,148,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-pink-600:focus-within{
  --text-opacity:1;
  color:#d61f69;
  color:rgba(214,31,105,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-pink-700:focus-within{
  --text-opacity:1;
  color:#bf125d;
  color:rgba(191,18,93,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-pink-800:focus-within{
  --text-opacity:1;
  color:#99154b;
  color:rgba(153,21,75,var(--text-opacity))
}

.theme-dark .dark\\:focus-within\\:text-pink-900:focus-within{
  --text-opacity:1;
  color:#751a3d;
  color:rgba(117,26,61,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-transparent:hover{
  color:#0000
}

.theme-dark .dark\\:hover\\:text-white:hover{
  --text-opacity:1;
  color:#fff;
  color:rgba(255,255,255,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-black:hover{
  --text-opacity:1;
  color:#000;
  color:rgba(0,0,0,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-gray-50:hover{
  --text-opacity:1;
  color:#f9fafb;
  color:rgba(249,250,251,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-gray-100:hover{
  --text-opacity:1;
  color:#f4f5f7;
  color:rgba(244,245,247,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-gray-200:hover{
  --text-opacity:1;
  color:#e5e7eb;
  color:rgba(229,231,235,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-gray-300:hover{
  --text-opacity:1;
  color:#d5d6d7;
  color:rgba(213,214,215,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-gray-400:hover{
  --text-opacity:1;
  color:#9e9e9e;
  color:rgba(158,158,158,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-gray-500:hover{
  --text-opacity:1;
  color:#707275;
  color:rgba(112,114,117,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-gray-600:hover{
  --text-opacity:1;
  color:#4c4f52;
  color:rgba(76,79,82,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-gray-700:hover{
  --text-opacity:1;
  color:#24262d;
  color:rgba(36,38,45,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-gray-800:hover{
  --text-opacity:1;
  color:#1a1c23;
  color:rgba(26,28,35,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-gray-900:hover{
  --text-opacity:1;
  color:#121317;
  color:rgba(18,19,23,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-cool-gray-50:hover{
  --text-opacity:1;
  color:#fbfdfe;
  color:rgba(251,253,254,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-cool-gray-100:hover{
  --text-opacity:1;
  color:#f1f5f9;
  color:rgba(241,245,249,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-cool-gray-200:hover{
  --text-opacity:1;
  color:#e2e8f0;
  color:rgba(226,232,240,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-cool-gray-300:hover{
  --text-opacity:1;
  color:#cfd8e3;
  color:rgba(207,216,227,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-cool-gray-400:hover{
  --text-opacity:1;
  color:#97a6ba;
  color:rgba(151,166,186,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-cool-gray-500:hover{
  --text-opacity:1;
  color:#64748b;
  color:rgba(100,116,139,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-cool-gray-600:hover{
  --text-opacity:1;
  color:#475569;
  color:rgba(71,85,105,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-cool-gray-700:hover{
  --text-opacity:1;
  color:#364152;
  color:rgba(54,65,82,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-cool-gray-800:hover{
  --text-opacity:1;
  color:#27303f;
  color:rgba(39,48,63,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-cool-gray-900:hover{
  --text-opacity:1;
  color:#1a202e;
  color:rgba(26,32,46,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-red-50:hover{
  --text-opacity:1;
  color:#fdf2f2;
  color:rgba(253,242,242,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-red-100:hover{
  --text-opacity:1;
  color:#fde8e8;
  color:rgba(253,232,232,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-red-200:hover{
  --text-opacity:1;
  color:#fbd5d5;
  color:rgba(251,213,213,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-red-300:hover{
  --text-opacity:1;
  color:#f8b4b4;
  color:rgba(248,180,180,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-red-400:hover{
  --text-opacity:1;
  color:#f98080;
  color:rgba(249,128,128,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-red-500:hover{
  --text-opacity:1;
  color:#f05252;
  color:rgba(240,82,82,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-red-600:hover{
  --text-opacity:1;
  color:#e02424;
  color:rgba(224,36,36,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-red-700:hover{
  --text-opacity:1;
  color:#c81e1e;
  color:rgba(200,30,30,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-red-800:hover{
  --text-opacity:1;
  color:#9b1c1c;
  color:rgba(155,28,28,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-red-900:hover{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-orange-50:hover{
  --text-opacity:1;
  color:#fff8f1;
  color:rgba(255,248,241,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-orange-100:hover{
  --text-opacity:1;
  color:#feecdc;
  color:rgba(254,236,220,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-orange-200:hover{
  --text-opacity:1;
  color:#fcd9bd;
  color:rgba(252,217,189,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-orange-300:hover{
  --text-opacity:1;
  color:#fdba8c;
  color:rgba(253,186,140,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-orange-400:hover{
  --text-opacity:1;
  color:#ff8a4c;
  color:rgba(255,138,76,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-orange-500:hover{
  --text-opacity:1;
  color:#ff5a1f;
  color:rgba(255,90,31,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-orange-600:hover{
  --text-opacity:1;
  color:#d03801;
  color:rgba(208,56,1,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-orange-700:hover{
  --text-opacity:1;
  color:#b43403;
  color:rgba(180,52,3,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-orange-800:hover{
  --text-opacity:1;
  color:#8a2c0d;
  color:rgba(138,44,13,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-orange-900:hover{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-yellow-50:hover{
  --text-opacity:1;
  color:#fdfdea;
  color:rgba(253,253,234,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-yellow-100:hover{
  --text-opacity:1;
  color:#fdf6b2;
  color:rgba(253,246,178,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-yellow-200:hover{
  --text-opacity:1;
  color:#fce96a;
  color:rgba(252,233,106,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-yellow-300:hover{
  --text-opacity:1;
  color:#faca15;
  color:rgba(250,202,21,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-yellow-400:hover{
  --text-opacity:1;
  color:#e3a008;
  color:rgba(227,160,8,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-yellow-500:hover{
  --text-opacity:1;
  color:#c27803;
  color:rgba(194,120,3,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-yellow-600:hover{
  --text-opacity:1;
  color:#9f580a;
  color:rgba(159,88,10,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-yellow-700:hover{
  --text-opacity:1;
  color:#8e4b10;
  color:rgba(142,75,16,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-yellow-800:hover{
  --text-opacity:1;
  color:#723b13;
  color:rgba(114,59,19,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-yellow-900:hover{
  --text-opacity:1;
  color:#633112;
  color:rgba(99,49,18,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-green-50:hover{
  --text-opacity:1;
  color:#f3faf7;
  color:rgba(243,250,247,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-green-100:hover{
  --text-opacity:1;
  color:#def7ec;
  color:rgba(222,247,236,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-green-200:hover{
  --text-opacity:1;
  color:#bcf0da;
  color:rgba(188,240,218,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-green-300:hover{
  --text-opacity:1;
  color:#84e1bc;
  color:rgba(132,225,188,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-green-400:hover{
  --text-opacity:1;
  color:#31c48d;
  color:rgba(49,196,141,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-green-500:hover{
  --text-opacity:1;
  color:#0e9f6e;
  color:rgba(14,159,110,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-green-600:hover{
  --text-opacity:1;
  color:#057a55;
  color:rgba(5,122,85,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-green-700:hover{
  --text-opacity:1;
  color:#046c4e;
  color:rgba(4,108,78,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-green-800:hover{
  --text-opacity:1;
  color:#03543f;
  color:rgba(3,84,63,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-green-900:hover{
  --text-opacity:1;
  color:#014737;
  color:rgba(1,71,55,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-teal-50:hover{
  --text-opacity:1;
  color:#edfafa;
  color:rgba(237,250,250,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-teal-100:hover{
  --text-opacity:1;
  color:#d5f5f6;
  color:rgba(213,245,246,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-teal-200:hover{
  --text-opacity:1;
  color:#afecef;
  color:rgba(175,236,239,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-teal-300:hover{
  --text-opacity:1;
  color:#7edce2;
  color:rgba(126,220,226,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-teal-400:hover{
  --text-opacity:1;
  color:#16bdca;
  color:rgba(22,189,202,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-teal-500:hover{
  --text-opacity:1;
  color:#0694a2;
  color:rgba(6,148,162,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-teal-600:hover{
  --text-opacity:1;
  color:#047481;
  color:rgba(4,116,129,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-teal-700:hover{
  --text-opacity:1;
  color:#036672;
  color:rgba(3,102,114,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-teal-800:hover{
  --text-opacity:1;
  color:#05505c;
  color:rgba(5,80,92,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-teal-900:hover{
  --text-opacity:1;
  color:#014451;
  color:rgba(1,68,81,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-blue-50:hover{
  --text-opacity:1;
  color:#ebf5ff;
  color:rgba(235,245,255,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-blue-100:hover{
  --text-opacity:1;
  color:#e1effe;
  color:rgba(225,239,254,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-blue-200:hover{
  --text-opacity:1;
  color:#c3ddfd;
  color:rgba(195,221,253,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-blue-300:hover{
  --text-opacity:1;
  color:#a4cafe;
  color:rgba(164,202,254,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-blue-400:hover{
  --text-opacity:1;
  color:#76a9fa;
  color:rgba(118,169,250,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-blue-500:hover{
  --text-opacity:1;
  color:#3f83f8;
  color:rgba(63,131,248,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-blue-600:hover{
  --text-opacity:1;
  color:#1c64f2;
  color:rgba(28,100,242,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-blue-700:hover{
  --text-opacity:1;
  color:#1a56db;
  color:rgba(26,86,219,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-blue-800:hover{
  --text-opacity:1;
  color:#1e429f;
  color:rgba(30,66,159,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-blue-900:hover{
  --text-opacity:1;
  color:#233876;
  color:rgba(35,56,118,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-50:hover{
  --text-opacity:1;
  color:#f0f5ff;
  color:rgba(240,245,255,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-100:hover{
  --text-opacity:1;
  color:#e5edff;
  color:rgba(229,237,255,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-200:hover{
  --text-opacity:1;
  color:#cddbfe;
  color:rgba(205,219,254,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-300:hover{
  --text-opacity:1;
  color:#b4c6fc;
  color:rgba(180,198,252,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-400:hover{
  --text-opacity:1;
  color:#8da2fb;
  color:rgba(141,162,251,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-500:hover{
  --text-opacity:1;
  color:#6875f5;
  color:rgba(104,117,245,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-600:hover{
  --text-opacity:1;
  color:#5850ec;
  color:rgba(88,80,236,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-700:hover{
  --text-opacity:1;
  color:#5145cd;
  color:rgba(81,69,205,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-800:hover{
  --text-opacity:1;
  color:#42389d;
  color:rgba(66,56,157,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-900:hover{
  --text-opacity:1;
  color:#362f78;
  color:rgba(54,47,120,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-50:hover{
  --text-opacity:1;
  color:#f6f5ff;
  color:rgba(246,245,255,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-100:hover{
  --text-opacity:1;
  color:#edebfe;
  color:rgba(237,235,254,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-200:hover{
  --text-opacity:1;
  color:#dcd7fe;
  color:rgba(220,215,254,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-300:hover{
  --text-opacity:1;
  color:#cabffd;
  color:rgba(202,191,253,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-400:hover{
  --text-opacity:1;
  color:#ac94fa;
  color:rgba(172,148,250,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-500:hover{
  --text-opacity:1;
  color:#9061f9;
  color:rgba(144,97,249,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-600:hover{
  --text-opacity:1;
  color:#7e3af2;
  color:rgba(126,58,242,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-700:hover{
  --text-opacity:1;
  color:#6c2bd9;
  color:rgba(108,43,217,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-800:hover{
  --text-opacity:1;
  color:#5521b5;
  color:rgba(85,33,181,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-indigo-900:hover{
  --text-opacity:1;
  color:#4a1d96;
  color:rgba(74,29,150,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-pink-50:hover{
  --text-opacity:1;
  color:#fdf2f8;
  color:rgba(253,242,248,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-pink-100:hover{
  --text-opacity:1;
  color:#fce8f3;
  color:rgba(252,232,243,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-pink-200:hover{
  --text-opacity:1;
  color:#fad1e8;
  color:rgba(250,209,232,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-pink-300:hover{
  --text-opacity:1;
  color:#f8b4d9;
  color:rgba(248,180,217,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-pink-400:hover{
  --text-opacity:1;
  color:#f17eb8;
  color:rgba(241,126,184,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-pink-500:hover{
  --text-opacity:1;
  color:#e74694;
  color:rgba(231,70,148,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-pink-600:hover{
  --text-opacity:1;
  color:#d61f69;
  color:rgba(214,31,105,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-pink-700:hover{
  --text-opacity:1;
  color:#bf125d;
  color:rgba(191,18,93,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-pink-800:hover{
  --text-opacity:1;
  color:#99154b;
  color:rgba(153,21,75,var(--text-opacity))
}

.theme-dark .dark\\:hover\\:text-pink-900:hover{
  --text-opacity:1;
  color:#751a3d;
  color:rgba(117,26,61,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-transparent:active{
  color:#0000
}

.theme-dark .dark\\:active\\:text-white:active{
  --text-opacity:1;
  color:#fff;
  color:rgba(255,255,255,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-black:active{
  --text-opacity:1;
  color:#000;
  color:rgba(0,0,0,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-gray-50:active{
  --text-opacity:1;
  color:#f9fafb;
  color:rgba(249,250,251,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-gray-100:active{
  --text-opacity:1;
  color:#f4f5f7;
  color:rgba(244,245,247,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-gray-200:active{
  --text-opacity:1;
  color:#e5e7eb;
  color:rgba(229,231,235,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-gray-300:active{
  --text-opacity:1;
  color:#d5d6d7;
  color:rgba(213,214,215,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-gray-400:active{
  --text-opacity:1;
  color:#9e9e9e;
  color:rgba(158,158,158,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-gray-500:active{
  --text-opacity:1;
  color:#707275;
  color:rgba(112,114,117,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-gray-600:active{
  --text-opacity:1;
  color:#4c4f52;
  color:rgba(76,79,82,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-gray-700:active{
  --text-opacity:1;
  color:#24262d;
  color:rgba(36,38,45,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-gray-800:active{
  --text-opacity:1;
  color:#1a1c23;
  color:rgba(26,28,35,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-gray-900:active{
  --text-opacity:1;
  color:#121317;
  color:rgba(18,19,23,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-cool-gray-50:active{
  --text-opacity:1;
  color:#fbfdfe;
  color:rgba(251,253,254,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-cool-gray-100:active{
  --text-opacity:1;
  color:#f1f5f9;
  color:rgba(241,245,249,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-cool-gray-200:active{
  --text-opacity:1;
  color:#e2e8f0;
  color:rgba(226,232,240,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-cool-gray-300:active{
  --text-opacity:1;
  color:#cfd8e3;
  color:rgba(207,216,227,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-cool-gray-400:active{
  --text-opacity:1;
  color:#97a6ba;
  color:rgba(151,166,186,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-cool-gray-500:active{
  --text-opacity:1;
  color:#64748b;
  color:rgba(100,116,139,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-cool-gray-600:active{
  --text-opacity:1;
  color:#475569;
  color:rgba(71,85,105,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-cool-gray-700:active{
  --text-opacity:1;
  color:#364152;
  color:rgba(54,65,82,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-cool-gray-800:active{
  --text-opacity:1;
  color:#27303f;
  color:rgba(39,48,63,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-cool-gray-900:active{
  --text-opacity:1;
  color:#1a202e;
  color:rgba(26,32,46,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-red-50:active{
  --text-opacity:1;
  color:#fdf2f2;
  color:rgba(253,242,242,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-red-100:active{
  --text-opacity:1;
  color:#fde8e8;
  color:rgba(253,232,232,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-red-200:active{
  --text-opacity:1;
  color:#fbd5d5;
  color:rgba(251,213,213,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-red-300:active{
  --text-opacity:1;
  color:#f8b4b4;
  color:rgba(248,180,180,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-red-400:active{
  --text-opacity:1;
  color:#f98080;
  color:rgba(249,128,128,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-red-500:active{
  --text-opacity:1;
  color:#f05252;
  color:rgba(240,82,82,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-red-600:active{
  --text-opacity:1;
  color:#e02424;
  color:rgba(224,36,36,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-red-700:active{
  --text-opacity:1;
  color:#c81e1e;
  color:rgba(200,30,30,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-red-800:active{
  --text-opacity:1;
  color:#9b1c1c;
  color:rgba(155,28,28,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-red-900:active{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-orange-50:active{
  --text-opacity:1;
  color:#fff8f1;
  color:rgba(255,248,241,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-orange-100:active{
  --text-opacity:1;
  color:#feecdc;
  color:rgba(254,236,220,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-orange-200:active{
  --text-opacity:1;
  color:#fcd9bd;
  color:rgba(252,217,189,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-orange-300:active{
  --text-opacity:1;
  color:#fdba8c;
  color:rgba(253,186,140,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-orange-400:active{
  --text-opacity:1;
  color:#ff8a4c;
  color:rgba(255,138,76,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-orange-500:active{
  --text-opacity:1;
  color:#ff5a1f;
  color:rgba(255,90,31,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-orange-600:active{
  --text-opacity:1;
  color:#d03801;
  color:rgba(208,56,1,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-orange-700:active{
  --text-opacity:1;
  color:#b43403;
  color:rgba(180,52,3,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-orange-800:active{
  --text-opacity:1;
  color:#8a2c0d;
  color:rgba(138,44,13,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-orange-900:active{
  --text-opacity:1;
  color:#771d1d;
  color:rgba(119,29,29,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-yellow-50:active{
  --text-opacity:1;
  color:#fdfdea;
  color:rgba(253,253,234,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-yellow-100:active{
  --text-opacity:1;
  color:#fdf6b2;
  color:rgba(253,246,178,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-yellow-200:active{
  --text-opacity:1;
  color:#fce96a;
  color:rgba(252,233,106,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-yellow-300:active{
  --text-opacity:1;
  color:#faca15;
  color:rgba(250,202,21,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-yellow-400:active{
  --text-opacity:1;
  color:#e3a008;
  color:rgba(227,160,8,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-yellow-500:active{
  --text-opacity:1;
  color:#c27803;
  color:rgba(194,120,3,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-yellow-600:active{
  --text-opacity:1;
  color:#9f580a;
  color:rgba(159,88,10,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-yellow-700:active{
  --text-opacity:1;
  color:#8e4b10;
  color:rgba(142,75,16,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-yellow-800:active{
  --text-opacity:1;
  color:#723b13;
  color:rgba(114,59,19,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-yellow-900:active{
  --text-opacity:1;
  color:#633112;
  color:rgba(99,49,18,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-green-50:active{
  --text-opacity:1;
  color:#f3faf7;
  color:rgba(243,250,247,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-green-100:active{
  --text-opacity:1;
  color:#def7ec;
  color:rgba(222,247,236,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-green-200:active{
  --text-opacity:1;
  color:#bcf0da;
  color:rgba(188,240,218,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-green-300:active{
  --text-opacity:1;
  color:#84e1bc;
  color:rgba(132,225,188,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-green-400:active{
  --text-opacity:1;
  color:#31c48d;
  color:rgba(49,196,141,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-green-500:active{
  --text-opacity:1;
  color:#0e9f6e;
  color:rgba(14,159,110,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-green-600:active{
  --text-opacity:1;
  color:#057a55;
  color:rgba(5,122,85,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-green-700:active{
  --text-opacity:1;
  color:#046c4e;
  color:rgba(4,108,78,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-green-800:active{
  --text-opacity:1;
  color:#03543f;
  color:rgba(3,84,63,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-green-900:active{
  --text-opacity:1;
  color:#014737;
  color:rgba(1,71,55,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-teal-50:active{
  --text-opacity:1;
  color:#edfafa;
  color:rgba(237,250,250,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-teal-100:active{
  --text-opacity:1;
  color:#d5f5f6;
  color:rgba(213,245,246,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-teal-200:active{
  --text-opacity:1;
  color:#afecef;
  color:rgba(175,236,239,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-teal-300:active{
  --text-opacity:1;
  color:#7edce2;
  color:rgba(126,220,226,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-teal-400:active{
  --text-opacity:1;
  color:#16bdca;
  color:rgba(22,189,202,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-teal-500:active{
  --text-opacity:1;
  color:#0694a2;
  color:rgba(6,148,162,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-teal-600:active{
  --text-opacity:1;
  color:#047481;
  color:rgba(4,116,129,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-teal-700:active{
  --text-opacity:1;
  color:#036672;
  color:rgba(3,102,114,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-teal-800:active{
  --text-opacity:1;
  color:#05505c;
  color:rgba(5,80,92,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-teal-900:active{
  --text-opacity:1;
  color:#014451;
  color:rgba(1,68,81,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-blue-50:active{
  --text-opacity:1;
  color:#ebf5ff;
  color:rgba(235,245,255,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-blue-100:active{
  --text-opacity:1;
  color:#e1effe;
  color:rgba(225,239,254,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-blue-200:active{
  --text-opacity:1;
  color:#c3ddfd;
  color:rgba(195,221,253,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-blue-300:active{
  --text-opacity:1;
  color:#a4cafe;
  color:rgba(164,202,254,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-blue-400:active{
  --text-opacity:1;
  color:#76a9fa;
  color:rgba(118,169,250,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-blue-500:active{
  --text-opacity:1;
  color:#3f83f8;
  color:rgba(63,131,248,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-blue-600:active{
  --text-opacity:1;
  color:#1c64f2;
  color:rgba(28,100,242,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-blue-700:active{
  --text-opacity:1;
  color:#1a56db;
  color:rgba(26,86,219,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-blue-800:active{
  --text-opacity:1;
  color:#1e429f;
  color:rgba(30,66,159,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-blue-900:active{
  --text-opacity:1;
  color:#233876;
  color:rgba(35,56,118,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-50:active{
  --text-opacity:1;
  color:#f0f5ff;
  color:rgba(240,245,255,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-100:active{
  --text-opacity:1;
  color:#e5edff;
  color:rgba(229,237,255,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-200:active{
  --text-opacity:1;
  color:#cddbfe;
  color:rgba(205,219,254,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-300:active{
  --text-opacity:1;
  color:#b4c6fc;
  color:rgba(180,198,252,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-400:active{
  --text-opacity:1;
  color:#8da2fb;
  color:rgba(141,162,251,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-500:active{
  --text-opacity:1;
  color:#6875f5;
  color:rgba(104,117,245,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-600:active{
  --text-opacity:1;
  color:#5850ec;
  color:rgba(88,80,236,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-700:active{
  --text-opacity:1;
  color:#5145cd;
  color:rgba(81,69,205,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-800:active{
  --text-opacity:1;
  color:#42389d;
  color:rgba(66,56,157,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-900:active{
  --text-opacity:1;
  color:#362f78;
  color:rgba(54,47,120,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-50:active{
  --text-opacity:1;
  color:#f6f5ff;
  color:rgba(246,245,255,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-100:active{
  --text-opacity:1;
  color:#edebfe;
  color:rgba(237,235,254,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-200:active{
  --text-opacity:1;
  color:#dcd7fe;
  color:rgba(220,215,254,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-300:active{
  --text-opacity:1;
  color:#cabffd;
  color:rgba(202,191,253,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-400:active{
  --text-opacity:1;
  color:#ac94fa;
  color:rgba(172,148,250,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-500:active{
  --text-opacity:1;
  color:#9061f9;
  color:rgba(144,97,249,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-600:active{
  --text-opacity:1;
  color:#7e3af2;
  color:rgba(126,58,242,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-700:active{
  --text-opacity:1;
  color:#6c2bd9;
  color:rgba(108,43,217,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-800:active{
  --text-opacity:1;
  color:#5521b5;
  color:rgba(85,33,181,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-indigo-900:active{
  --text-opacity:1;
  color:#4a1d96;
  color:rgba(74,29,150,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-pink-50:active{
  --text-opacity:1;
  color:#fdf2f8;
  color:rgba(253,242,248,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-pink-100:active{
  --text-opacity:1;
  color:#fce8f3;
  color:rgba(252,232,243,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-pink-200:active{
  --text-opacity:1;
  color:#fad1e8;
  color:rgba(250,209,232,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-pink-300:active{
  --text-opacity:1;
  color:#f8b4d9;
  color:rgba(248,180,217,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-pink-400:active{
  --text-opacity:1;
  color:#f17eb8;
  color:rgba(241,126,184,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-pink-500:active{
  --text-opacity:1;
  color:#e74694;
  color:rgba(231,70,148,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-pink-600:active{
  --text-opacity:1;
  color:#d61f69;
  color:rgba(214,31,105,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-pink-700:active{
  --text-opacity:1;
  color:#bf125d;
  color:rgba(191,18,93,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-pink-800:active{
  --text-opacity:1;
  color:#99154b;
  color:rgba(153,21,75,var(--text-opacity))
}

.theme-dark .dark\\:active\\:text-pink-900:active{
  --text-opacity:1;
  color:#751a3d;
  color:rgba(117,26,61,var(--text-opacity))
}

.text-opacity-0{
  --text-opacity:0
}

.text-opacity-25{
  --text-opacity:0.25
}

.text-opacity-50{
  --text-opacity:0.5
}

.text-opacity-75{
  --text-opacity:0.75
}

.text-opacity-100{
  --text-opacity:1
}

.hover\\:text-opacity-0:hover{
  --text-opacity:0
}

.hover\\:text-opacity-25:hover{
  --text-opacity:0.25
}

.hover\\:text-opacity-50:hover{
  --text-opacity:0.5
}

.hover\\:text-opacity-75:hover{
  --text-opacity:0.75
}

.hover\\:text-opacity-100:hover{
  --text-opacity:1
}

.focus\\:text-opacity-0:focus{
  --text-opacity:0
}

.focus\\:text-opacity-25:focus{
  --text-opacity:0.25
}

.focus\\:text-opacity-50:focus{
  --text-opacity:0.5
}

.focus\\:text-opacity-75:focus{
  --text-opacity:0.75
}

.focus\\:text-opacity-100:focus{
  --text-opacity:1
}

.italic{
  font-style:italic
}

.not-italic{
  font-style:normal
}

.uppercase{
  text-transform:uppercase
}

.lowercase{
  text-transform:lowercase
}

.capitalize{
  text-transform:capitalize
}

.normal-case{
  text-transform:none
}

.underline{
  text-decoration:underline
}

.line-through{
  text-decoration:line-through
}

.no-underline{
  text-decoration:none
}

.hover\\:underline:hover{
  text-decoration:underline
}

.hover\\:line-through:hover{
  text-decoration:line-through
}

.hover\\:no-underline:hover{
  text-decoration:none
}

.focus\\:underline:focus{
  text-decoration:underline
}

.focus\\:line-through:focus{
  text-decoration:line-through
}

.focus\\:no-underline:focus{
  text-decoration:none
}

.antialiased{
  -webkit-font-smoothing:antialiased;
  -moz-osx-font-smoothing:grayscale
}

.subpixel-antialiased{
  -webkit-font-smoothing:auto;
  -moz-osx-font-smoothing:auto
}

.tracking-tighter{
  letter-spacing:-.05em
}

.tracking-tight{
  letter-spacing:-.025em
}

.tracking-normal{
  letter-spacing:0
}

.tracking-wide{
  letter-spacing:.025em
}

.tracking-wider{
  letter-spacing:.05em
}

.tracking-widest{
  letter-spacing:.1em
}

.select-none{
  -webkit-user-select:none;
  user-select:none
}

.select-text{
  -webkit-user-select:text;
  user-select:text
}

.select-all{
  -webkit-user-select:all;
  user-select:all
}

.select-auto{
  -webkit-user-select:auto;
  user-select:auto
}

.align-baseline{
  vertical-align:initial
}

.align-top{
  vertical-align:top
}

.align-middle{
  vertical-align:middle
}

.align-bottom{
  vertical-align:bottom
}

.align-text-top{
  vertical-align:text-top
}

.align-text-bottom{
  vertical-align:text-bottom
}

.visible{
  visibility:visible
}

.invisible{
  visibility:hidden
}

.whitespace-normal{
  white-space:normal
}

.whitespace-no-wrap{
  white-space:nowrap
}

.whitespace-pre{
  white-space:pre
}

.whitespace-pre-line{
  white-space:pre-line
}

.whitespace-pre-wrap{
  white-space:pre-wrap
}

.break-normal{
  overflow-wrap:normal;
  word-break:normal
}

.break-words{
  overflow-wrap:break-word
}

.break-all{
  word-break:break-all
}

.truncate{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap
}

.w-0{
  width:0
}

.w-1{
  width:.25rem
}

.w-2{
  width:.5rem
}

.w-3{
  width:.75rem
}

.w-4{
  width:1rem
}

.w-5{
  width:1.25rem
}

.w-6{
  width:1.5rem
}

.w-8{
  width:2rem
}

.w-10{
  width:2.5rem
}

.w-12{
  width:3rem
}

.w-16{
  width:4rem
}

.w-20{
  width:5rem
}

.w-24{
  width:6rem
}

.w-32{
  width:8rem
}

.w-40{
  width:10rem
}

.w-48{
  width:12rem
}

.w-56{
  width:14rem
}

.w-64{
  width:16rem
}

.w-auto{
  width:auto
}

.w-px{
  width:1px
}

.w-1\\/2{
  width:50%
}

.w-1\\/3{
  width:33.333333%
}

.w-2\\/3{
  width:66.666667%
}

.w-1\\/4{
  width:25%
}

.w-2\\/4{
  width:50%
}

.w-3\\/4{
  width:75%
}

.w-1\\/5{
  width:20%
}

.w-2\\/5{
  width:40%
}

.w-3\\/5{
  width:60%
}

.w-4\\/5{
  width:80%
}

.w-1\\/6{
  width:16.666667%
}

.w-2\\/6{
  width:33.333333%
}

.w-3\\/6{
  width:50%
}

.w-4\\/6{
  width:66.666667%
}

.w-5\\/6{
  width:83.333333%
}

.w-1\\/12{
  width:8.333333%
}

.w-2\\/12{
  width:16.666667%
}

.w-3\\/12{
  width:25%
}

.w-4\\/12{
  width:33.333333%
}

.w-5\\/12{
  width:41.666667%
}

.w-6\\/12{
  width:50%
}

.w-7\\/12{
  width:58.333333%
}

.w-8\\/12{
  width:66.666667%
}

.w-9\\/12{
  width:75%
}

.w-10\\/12{
  width:83.333333%
}

.w-11\\/12{
  width:91.666667%
}

.w-full{
  width:100%
}

.w-screen{
  width:100vw
}

.z-0{
  z-index:0
}

.z-10{
  z-index:10
}

.z-20{
  z-index:20
}

.z-30{
  z-index:30
}

.z-40{
  z-index:40
}

.z-50{
  z-index:50
}

.z-auto{
  z-index:auto
}

.gap-0{
  grid-gap:0;
  gap:0
}

.gap-1{
  grid-gap:.25rem;
  gap:.25rem
}

.gap-2{
  grid-gap:.5rem;
  gap:.5rem
}

.gap-3{
  grid-gap:.75rem;
  gap:.75rem
}

.gap-4{
  grid-gap:1rem;
  gap:1rem
}

.gap-5{
  grid-gap:1.25rem;
  gap:1.25rem
}

.gap-6{
  grid-gap:1.5rem;
  gap:1.5rem
}

.gap-8{
  grid-gap:2rem;
  gap:2rem
}

.gap-10{
  grid-gap:2.5rem;
  gap:2.5rem
}

.gap-12{
  grid-gap:3rem;
  gap:3rem
}

.gap-16{
  grid-gap:4rem;
  gap:4rem
}

.gap-20{
  grid-gap:5rem;
  gap:5rem
}

.gap-24{
  grid-gap:6rem;
  gap:6rem
}

.gap-32{
  grid-gap:8rem;
  gap:8rem
}

.gap-40{
  grid-gap:10rem;
  gap:10rem
}

.gap-48{
  grid-gap:12rem;
  gap:12rem
}

.gap-56{
  grid-gap:14rem;
  gap:14rem
}

.gap-64{
  grid-gap:16rem;
  gap:16rem
}

.gap-px{
  grid-gap:1px;
  gap:1px
}

.col-gap-0{
  grid-column-gap:0;
  column-gap:0
}

.col-gap-1{
  grid-column-gap:.25rem;
  column-gap:.25rem
}

.col-gap-2{
  grid-column-gap:.5rem;
  column-gap:.5rem
}

.col-gap-3{
  grid-column-gap:.75rem;
  column-gap:.75rem
}

.col-gap-4{
  grid-column-gap:1rem;
  column-gap:1rem
}

.col-gap-5{
  grid-column-gap:1.25rem;
  column-gap:1.25rem
}

.col-gap-6{
  grid-column-gap:1.5rem;
  column-gap:1.5rem
}

.col-gap-8{
  grid-column-gap:2rem;
  column-gap:2rem
}

.col-gap-10{
  grid-column-gap:2.5rem;
  column-gap:2.5rem
}

.col-gap-12{
  grid-column-gap:3rem;
  column-gap:3rem
}

.col-gap-16{
  grid-column-gap:4rem;
  column-gap:4rem
}

.col-gap-20{
  grid-column-gap:5rem;
  column-gap:5rem
}

.col-gap-24{
  grid-column-gap:6rem;
  column-gap:6rem
}

.col-gap-32{
  grid-column-gap:8rem;
  column-gap:8rem
}

.col-gap-40{
  grid-column-gap:10rem;
  column-gap:10rem
}

.col-gap-48{
  grid-column-gap:12rem;
  column-gap:12rem
}

.col-gap-56{
  grid-column-gap:14rem;
  column-gap:14rem
}

.col-gap-64{
  grid-column-gap:16rem;
  column-gap:16rem
}

.col-gap-px{
  grid-column-gap:1px;
  column-gap:1px
}

.row-gap-0{
  grid-row-gap:0;
  row-gap:0
}

.row-gap-1{
  grid-row-gap:.25rem;
  row-gap:.25rem
}

.row-gap-2{
  grid-row-gap:.5rem;
  row-gap:.5rem
}

.row-gap-3{
  grid-row-gap:.75rem;
  row-gap:.75rem
}

.row-gap-4{
  grid-row-gap:1rem;
  row-gap:1rem
}

.row-gap-5{
  grid-row-gap:1.25rem;
  row-gap:1.25rem
}

.row-gap-6{
  grid-row-gap:1.5rem;
  row-gap:1.5rem
}

.row-gap-8{
  grid-row-gap:2rem;
  row-gap:2rem
}

.row-gap-10{
  grid-row-gap:2.5rem;
  row-gap:2.5rem
}

.row-gap-12{
  grid-row-gap:3rem;
  row-gap:3rem
}

.row-gap-16{
  grid-row-gap:4rem;
  row-gap:4rem
}

.row-gap-20{
  grid-row-gap:5rem;
  row-gap:5rem
}

.row-gap-24{
  grid-row-gap:6rem;
  row-gap:6rem
}

.row-gap-32{
  grid-row-gap:8rem;
  row-gap:8rem
}

.row-gap-40{
  grid-row-gap:10rem;
  row-gap:10rem
}

.row-gap-48{
  grid-row-gap:12rem;
  row-gap:12rem
}

.row-gap-56{
  grid-row-gap:14rem;
  row-gap:14rem
}

.row-gap-64{
  grid-row-gap:16rem;
  row-gap:16rem
}

.row-gap-px{
  grid-row-gap:1px;
  row-gap:1px
}

.grid-flow-row{
  grid-auto-flow:row
}

.grid-flow-col{
  grid-auto-flow:column
}

.grid-flow-row-dense{
  grid-auto-flow:row dense
}

.grid-flow-col-dense{
  grid-auto-flow:column dense
}

.grid-cols-1{
  grid-template-columns:repeat(1,minmax(0,1fr))
}

.grid-cols-2{
  grid-template-columns:repeat(2,minmax(0,1fr))
}

.grid-cols-3{
  grid-template-columns:repeat(3,minmax(0,1fr))
}

.grid-cols-4{
  grid-template-columns:repeat(4,minmax(0,1fr))
}

.grid-cols-5{
  grid-template-columns:repeat(5,minmax(0,1fr))
}

.grid-cols-6{
  grid-template-columns:repeat(6,minmax(0,1fr))
}

.grid-cols-7{
  grid-template-columns:repeat(7,minmax(0,1fr))
}

.grid-cols-8{
  grid-template-columns:repeat(8,minmax(0,1fr))
}

.grid-cols-9{
  grid-template-columns:repeat(9,minmax(0,1fr))
}

.grid-cols-10{
  grid-template-columns:repeat(10,minmax(0,1fr))
}

.grid-cols-11{
  grid-template-columns:repeat(11,minmax(0,1fr))
}

.grid-cols-12{
  grid-template-columns:repeat(12,minmax(0,1fr))
}

.grid-cols-none{
  grid-template-columns:none
}

.col-auto{
  grid-column:auto
}

.col-span-1{
  grid-column:span 1/span 1
}

.col-span-2{
  grid-column:span 2/span 2
}

.col-span-3{
  grid-column:span 3/span 3
}

.col-span-4{
  grid-column:span 4/span 4
}

.col-span-5{
  grid-column:span 5/span 5
}

.col-span-6{
  grid-column:span 6/span 6
}

.col-span-7{
  grid-column:span 7/span 7
}

.col-span-8{
  grid-column:span 8/span 8
}

.col-span-9{
  grid-column:span 9/span 9
}

.col-span-10{
  grid-column:span 10/span 10
}

.col-span-11{
  grid-column:span 11/span 11
}

.col-span-12{
  grid-column:span 12/span 12
}

.col-start-1{
  grid-column-start:1
}

.col-start-2{
  grid-column-start:2
}

.col-start-3{
  grid-column-start:3
}

.col-start-4{
  grid-column-start:4
}

.col-start-5{
  grid-column-start:5
}

.col-start-6{
  grid-column-start:6
}

.col-start-7{
  grid-column-start:7
}

.col-start-8{
  grid-column-start:8
}

.col-start-9{
  grid-column-start:9
}

.col-start-10{
  grid-column-start:10
}

.col-start-11{
  grid-column-start:11
}

.col-start-12{
  grid-column-start:12
}

.col-start-13{
  grid-column-start:13
}

.col-start-auto{
  grid-column-start:auto
}

.col-end-1{
  grid-column-end:1
}

.col-end-2{
  grid-column-end:2
}

.col-end-3{
  grid-column-end:3
}

.col-end-4{
  grid-column-end:4
}

.col-end-5{
  grid-column-end:5
}

.col-end-6{
  grid-column-end:6
}

.col-end-7{
  grid-column-end:7
}

.col-end-8{
  grid-column-end:8
}

.col-end-9{
  grid-column-end:9
}

.col-end-10{
  grid-column-end:10
}

.col-end-11{
  grid-column-end:11
}

.col-end-12{
  grid-column-end:12
}

.col-end-13{
  grid-column-end:13
}

.col-end-auto{
  grid-column-end:auto
}

.grid-rows-1{
  grid-template-rows:repeat(1,minmax(0,1fr))
}

.grid-rows-2{
  grid-template-rows:repeat(2,minmax(0,1fr))
}

.grid-rows-3{
  grid-template-rows:repeat(3,minmax(0,1fr))
}

.grid-rows-4{
  grid-template-rows:repeat(4,minmax(0,1fr))
}

.grid-rows-5{
  grid-template-rows:repeat(5,minmax(0,1fr))
}

.grid-rows-6{
  grid-template-rows:repeat(6,minmax(0,1fr))
}

.grid-rows-none{
  grid-template-rows:none
}

.row-auto{
  grid-row:auto
}

.row-span-1{
  grid-row:span 1/span 1
}

.row-span-2{
  grid-row:span 2/span 2
}

.row-span-3{
  grid-row:span 3/span 3
}

.row-span-4{
  grid-row:span 4/span 4
}

.row-span-5{
  grid-row:span 5/span 5
}

.row-span-6{
  grid-row:span 6/span 6
}

.row-start-1{
  grid-row-start:1
}

.row-start-2{
  grid-row-start:2
}

.row-start-3{
  grid-row-start:3
}

.row-start-4{
  grid-row-start:4
}

.row-start-5{
  grid-row-start:5
}

.row-start-6{
  grid-row-start:6
}

.row-start-7{
  grid-row-start:7
}

.row-start-auto{
  grid-row-start:auto
}

.row-end-1{
  grid-row-end:1
}

.row-end-2{
  grid-row-end:2
}

.row-end-3{
  grid-row-end:3
}

.row-end-4{
  grid-row-end:4
}

.row-end-5{
  grid-row-end:5
}

.row-end-6{
  grid-row-end:6
}

.row-end-7{
  grid-row-end:7
}

.row-end-auto{
  grid-row-end:auto
}

.transform{
  --transform-translate-x:0;
  --transform-translate-y:0;
  --transform-rotate:0;
  --transform-skew-x:0;
  --transform-skew-y:0;
  --transform-scale-x:1;
  --transform-scale-y:1;
  transform:translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y))
}

.transform-none{
  transform:none
}

.origin-center{
  transform-origin:center
}

.origin-top{
  transform-origin:top
}

.origin-top-right{
  transform-origin:top right
}

.origin-right{
  transform-origin:right
}

.origin-bottom-right{
  transform-origin:bottom right
}

.origin-bottom{
  transform-origin:bottom
}

.origin-bottom-left{
  transform-origin:bottom left
}

.origin-left{
  transform-origin:left
}

.origin-top-left{
  transform-origin:top left
}

.scale-0{
  --transform-scale-x:0;
  --transform-scale-y:0
}

.scale-50{
  --transform-scale-x:.5;
  --transform-scale-y:.5
}

.scale-75{
  --transform-scale-x:.75;
  --transform-scale-y:.75
}

.scale-90{
  --transform-scale-x:.9;
  --transform-scale-y:.9
}

.scale-95{
  --transform-scale-x:.95;
  --transform-scale-y:.95
}

.scale-100{
  --transform-scale-x:1;
  --transform-scale-y:1
}

.scale-105{
  --transform-scale-x:1.05;
  --transform-scale-y:1.05
}

.scale-110{
  --transform-scale-x:1.1;
  --transform-scale-y:1.1
}

.scale-125{
  --transform-scale-x:1.25;
  --transform-scale-y:1.25
}

.scale-150{
  --transform-scale-x:1.5;
  --transform-scale-y:1.5
}

.scale-x-0{
  --transform-scale-x:0
}

.scale-x-50{
  --transform-scale-x:.5
}

.scale-x-75{
  --transform-scale-x:.75
}

.scale-x-90{
  --transform-scale-x:.9
}

.scale-x-95{
  --transform-scale-x:.95
}

.scale-x-100{
  --transform-scale-x:1
}

.scale-x-105{
  --transform-scale-x:1.05
}

.scale-x-110{
  --transform-scale-x:1.1
}

.scale-x-125{
  --transform-scale-x:1.25
}

.scale-x-150{
  --transform-scale-x:1.5
}

.scale-y-0{
  --transform-scale-y:0
}

.scale-y-50{
  --transform-scale-y:.5
}

.scale-y-75{
  --transform-scale-y:.75
}

.scale-y-90{
  --transform-scale-y:.9
}

.scale-y-95{
  --transform-scale-y:.95
}

.scale-y-100{
  --transform-scale-y:1
}

.scale-y-105{
  --transform-scale-y:1.05
}

.scale-y-110{
  --transform-scale-y:1.1
}

.scale-y-125{
  --transform-scale-y:1.25
}

.scale-y-150{
  --transform-scale-y:1.5
}

.hover\\:scale-0:hover{
  --transform-scale-x:0;
  --transform-scale-y:0
}

.hover\\:scale-50:hover{
  --transform-scale-x:.5;
  --transform-scale-y:.5
}

.hover\\:scale-75:hover{
  --transform-scale-x:.75;
  --transform-scale-y:.75
}

.hover\\:scale-90:hover{
  --transform-scale-x:.9;
  --transform-scale-y:.9
}

.hover\\:scale-95:hover{
  --transform-scale-x:.95;
  --transform-scale-y:.95
}

.hover\\:scale-100:hover{
  --transform-scale-x:1;
  --transform-scale-y:1
}

.hover\\:scale-105:hover{
  --transform-scale-x:1.05;
  --transform-scale-y:1.05
}

.hover\\:scale-110:hover{
  --transform-scale-x:1.1;
  --transform-scale-y:1.1
}

.hover\\:scale-125:hover{
  --transform-scale-x:1.25;
  --transform-scale-y:1.25
}

.hover\\:scale-150:hover{
  --transform-scale-x:1.5;
  --transform-scale-y:1.5
}

.hover\\:scale-x-0:hover{
  --transform-scale-x:0
}

.hover\\:scale-x-50:hover{
  --transform-scale-x:.5
}

.hover\\:scale-x-75:hover{
  --transform-scale-x:.75
}

.hover\\:scale-x-90:hover{
  --transform-scale-x:.9
}

.hover\\:scale-x-95:hover{
  --transform-scale-x:.95
}

.hover\\:scale-x-100:hover{
  --transform-scale-x:1
}

.hover\\:scale-x-105:hover{
  --transform-scale-x:1.05
}

.hover\\:scale-x-110:hover{
  --transform-scale-x:1.1
}

.hover\\:scale-x-125:hover{
  --transform-scale-x:1.25
}

.hover\\:scale-x-150:hover{
  --transform-scale-x:1.5
}

.hover\\:scale-y-0:hover{
  --transform-scale-y:0
}

.hover\\:scale-y-50:hover{
  --transform-scale-y:.5
}

.hover\\:scale-y-75:hover{
  --transform-scale-y:.75
}

.hover\\:scale-y-90:hover{
  --transform-scale-y:.9
}

.hover\\:scale-y-95:hover{
  --transform-scale-y:.95
}

.hover\\:scale-y-100:hover{
  --transform-scale-y:1
}

.hover\\:scale-y-105:hover{
  --transform-scale-y:1.05
}

.hover\\:scale-y-110:hover{
  --transform-scale-y:1.1
}

.hover\\:scale-y-125:hover{
  --transform-scale-y:1.25
}

.hover\\:scale-y-150:hover{
  --transform-scale-y:1.5
}

.focus\\:scale-0:focus{
  --transform-scale-x:0;
  --transform-scale-y:0
}

.focus\\:scale-50:focus{
  --transform-scale-x:.5;
  --transform-scale-y:.5
}

.focus\\:scale-75:focus{
  --transform-scale-x:.75;
  --transform-scale-y:.75
}

.focus\\:scale-90:focus{
  --transform-scale-x:.9;
  --transform-scale-y:.9
}

.focus\\:scale-95:focus{
  --transform-scale-x:.95;
  --transform-scale-y:.95
}

.focus\\:scale-100:focus{
  --transform-scale-x:1;
  --transform-scale-y:1
}

.focus\\:scale-105:focus{
  --transform-scale-x:1.05;
  --transform-scale-y:1.05
}

.focus\\:scale-110:focus{
  --transform-scale-x:1.1;
  --transform-scale-y:1.1
}

.focus\\:scale-125:focus{
  --transform-scale-x:1.25;
  --transform-scale-y:1.25
}

.focus\\:scale-150:focus{
  --transform-scale-x:1.5;
  --transform-scale-y:1.5
}

.focus\\:scale-x-0:focus{
  --transform-scale-x:0
}

.focus\\:scale-x-50:focus{
  --transform-scale-x:.5
}

.focus\\:scale-x-75:focus{
  --transform-scale-x:.75
}

.focus\\:scale-x-90:focus{
  --transform-scale-x:.9
}

.focus\\:scale-x-95:focus{
  --transform-scale-x:.95
}

.focus\\:scale-x-100:focus{
  --transform-scale-x:1
}

.focus\\:scale-x-105:focus{
  --transform-scale-x:1.05
}

.focus\\:scale-x-110:focus{
  --transform-scale-x:1.1
}

.focus\\:scale-x-125:focus{
  --transform-scale-x:1.25
}

.focus\\:scale-x-150:focus{
  --transform-scale-x:1.5
}

.focus\\:scale-y-0:focus{
  --transform-scale-y:0
}

.focus\\:scale-y-50:focus{
  --transform-scale-y:.5
}

.focus\\:scale-y-75:focus{
  --transform-scale-y:.75
}

.focus\\:scale-y-90:focus{
  --transform-scale-y:.9
}

.focus\\:scale-y-95:focus{
  --transform-scale-y:.95
}

.focus\\:scale-y-100:focus{
  --transform-scale-y:1
}

.focus\\:scale-y-105:focus{
  --transform-scale-y:1.05
}

.focus\\:scale-y-110:focus{
  --transform-scale-y:1.1
}

.focus\\:scale-y-125:focus{
  --transform-scale-y:1.25
}

.focus\\:scale-y-150:focus{
  --transform-scale-y:1.5
}

.rotate-0{
  --transform-rotate:0
}

.rotate-45{
  --transform-rotate:45deg
}

.rotate-90{
  --transform-rotate:90deg
}

.rotate-180{
  --transform-rotate:180deg
}

.-rotate-180{
  --transform-rotate:-180deg
}

.-rotate-90{
  --transform-rotate:-90deg
}

.-rotate-45{
  --transform-rotate:-45deg
}

.hover\\:rotate-0:hover{
  --transform-rotate:0
}

.hover\\:rotate-45:hover{
  --transform-rotate:45deg
}

.hover\\:rotate-90:hover{
  --transform-rotate:90deg
}

.hover\\:rotate-180:hover{
  --transform-rotate:180deg
}

.hover\\:-rotate-180:hover{
  --transform-rotate:-180deg
}

.hover\\:-rotate-90:hover{
  --transform-rotate:-90deg
}

.hover\\:-rotate-45:hover{
  --transform-rotate:-45deg
}

.focus\\:rotate-0:focus{
  --transform-rotate:0
}

.focus\\:rotate-45:focus{
  --transform-rotate:45deg
}

.focus\\:rotate-90:focus{
  --transform-rotate:90deg
}

.focus\\:rotate-180:focus{
  --transform-rotate:180deg
}

.focus\\:-rotate-180:focus{
  --transform-rotate:-180deg
}

.focus\\:-rotate-90:focus{
  --transform-rotate:-90deg
}

.focus\\:-rotate-45:focus{
  --transform-rotate:-45deg
}

.translate-x-0{
  --transform-translate-x:0
}

.translate-x-1{
  --transform-translate-x:0.25rem
}

.translate-x-2{
  --transform-translate-x:0.5rem
}

.translate-x-3{
  --transform-translate-x:0.75rem
}

.translate-x-4{
  --transform-translate-x:1rem
}

.translate-x-5{
  --transform-translate-x:1.25rem
}

.translate-x-6{
  --transform-translate-x:1.5rem
}

.translate-x-8{
  --transform-translate-x:2rem
}

.translate-x-10{
  --transform-translate-x:2.5rem
}

.translate-x-12{
  --transform-translate-x:3rem
}

.translate-x-16{
  --transform-translate-x:4rem
}

.translate-x-20{
  --transform-translate-x:5rem
}

.translate-x-24{
  --transform-translate-x:6rem
}

.translate-x-32{
  --transform-translate-x:8rem
}

.translate-x-40{
  --transform-translate-x:10rem
}

.translate-x-48{
  --transform-translate-x:12rem
}

.translate-x-56{
  --transform-translate-x:14rem
}

.translate-x-64{
  --transform-translate-x:16rem
}

.translate-x-px{
  --transform-translate-x:1px
}

.-translate-x-1{
  --transform-translate-x:-0.25rem
}

.-translate-x-2{
  --transform-translate-x:-0.5rem
}

.-translate-x-3{
  --transform-translate-x:-0.75rem
}

.-translate-x-4{
  --transform-translate-x:-1rem
}

.-translate-x-5{
  --transform-translate-x:-1.25rem
}

.-translate-x-6{
  --transform-translate-x:-1.5rem
}

.-translate-x-8{
  --transform-translate-x:-2rem
}

.-translate-x-10{
  --transform-translate-x:-2.5rem
}

.-translate-x-12{
  --transform-translate-x:-3rem
}

.-translate-x-16{
  --transform-translate-x:-4rem
}

.-translate-x-20{
  --transform-translate-x:-5rem
}

.-translate-x-24{
  --transform-translate-x:-6rem
}

.-translate-x-32{
  --transform-translate-x:-8rem
}

.-translate-x-40{
  --transform-translate-x:-10rem
}

.-translate-x-48{
  --transform-translate-x:-12rem
}

.-translate-x-56{
  --transform-translate-x:-14rem
}

.-translate-x-64{
  --transform-translate-x:-16rem
}

.-translate-x-px{
  --transform-translate-x:-1px
}

.-translate-x-full{
  --transform-translate-x:-100%
}

.-translate-x-1\\/2{
  --transform-translate-x:-50%
}

.translate-x-1\\/2{
  --transform-translate-x:50%
}

.translate-x-full{
  --transform-translate-x:100%
}

.translate-y-0{
  --transform-translate-y:0
}

.translate-y-1{
  --transform-translate-y:0.25rem
}

.translate-y-2{
  --transform-translate-y:0.5rem
}

.translate-y-3{
  --transform-translate-y:0.75rem
}

.translate-y-4{
  --transform-translate-y:1rem
}

.translate-y-5{
  --transform-translate-y:1.25rem
}

.translate-y-6{
  --transform-translate-y:1.5rem
}

.translate-y-8{
  --transform-translate-y:2rem
}

.translate-y-10{
  --transform-translate-y:2.5rem
}

.translate-y-12{
  --transform-translate-y:3rem
}

.translate-y-16{
  --transform-translate-y:4rem
}

.translate-y-20{
  --transform-translate-y:5rem
}

.translate-y-24{
  --transform-translate-y:6rem
}

.translate-y-32{
  --transform-translate-y:8rem
}

.translate-y-40{
  --transform-translate-y:10rem
}

.translate-y-48{
  --transform-translate-y:12rem
}

.translate-y-56{
  --transform-translate-y:14rem
}

.translate-y-64{
  --transform-translate-y:16rem
}

.translate-y-px{
  --transform-translate-y:1px
}

.-translate-y-1{
  --transform-translate-y:-0.25rem
}

.-translate-y-2{
  --transform-translate-y:-0.5rem
}

.-translate-y-3{
  --transform-translate-y:-0.75rem
}

.-translate-y-4{
  --transform-translate-y:-1rem
}

.-translate-y-5{
  --transform-translate-y:-1.25rem
}

.-translate-y-6{
  --transform-translate-y:-1.5rem
}

.-translate-y-8{
  --transform-translate-y:-2rem
}

.-translate-y-10{
  --transform-translate-y:-2.5rem
}

.-translate-y-12{
  --transform-translate-y:-3rem
}

.-translate-y-16{
  --transform-translate-y:-4rem
}

.-translate-y-20{
  --transform-translate-y:-5rem
}

.-translate-y-24{
  --transform-translate-y:-6rem
}

.-translate-y-32{
  --transform-translate-y:-8rem
}

.-translate-y-40{
  --transform-translate-y:-10rem
}

.-translate-y-48{
  --transform-translate-y:-12rem
}

.-translate-y-56{
  --transform-translate-y:-14rem
}

.-translate-y-64{
  --transform-translate-y:-16rem
}

.-translate-y-px{
  --transform-translate-y:-1px
}

.-translate-y-full{
  --transform-translate-y:-100%
}

.-translate-y-1\\/2{
  --transform-translate-y:-50%
}

.translate-y-1\\/2{
  --transform-translate-y:50%
}

.translate-y-full{
  --transform-translate-y:100%
}

.hover\\:translate-x-0:hover{
  --transform-translate-x:0
}

.hover\\:translate-x-1:hover{
  --transform-translate-x:0.25rem
}

.hover\\:translate-x-2:hover{
  --transform-translate-x:0.5rem
}

.hover\\:translate-x-3:hover{
  --transform-translate-x:0.75rem
}

.hover\\:translate-x-4:hover{
  --transform-translate-x:1rem
}

.hover\\:translate-x-5:hover{
  --transform-translate-x:1.25rem
}

.hover\\:translate-x-6:hover{
  --transform-translate-x:1.5rem
}

.hover\\:translate-x-8:hover{
  --transform-translate-x:2rem
}

.hover\\:translate-x-10:hover{
  --transform-translate-x:2.5rem
}

.hover\\:translate-x-12:hover{
  --transform-translate-x:3rem
}

.hover\\:translate-x-16:hover{
  --transform-translate-x:4rem
}

.hover\\:translate-x-20:hover{
  --transform-translate-x:5rem
}

.hover\\:translate-x-24:hover{
  --transform-translate-x:6rem
}

.hover\\:translate-x-32:hover{
  --transform-translate-x:8rem
}

.hover\\:translate-x-40:hover{
  --transform-translate-x:10rem
}

.hover\\:translate-x-48:hover{
  --transform-translate-x:12rem
}

.hover\\:translate-x-56:hover{
  --transform-translate-x:14rem
}

.hover\\:translate-x-64:hover{
  --transform-translate-x:16rem
}

.hover\\:translate-x-px:hover{
  --transform-translate-x:1px
}

.hover\\:-translate-x-1:hover{
  --transform-translate-x:-0.25rem
}

.hover\\:-translate-x-2:hover{
  --transform-translate-x:-0.5rem
}

.hover\\:-translate-x-3:hover{
  --transform-translate-x:-0.75rem
}

.hover\\:-translate-x-4:hover{
  --transform-translate-x:-1rem
}

.hover\\:-translate-x-5:hover{
  --transform-translate-x:-1.25rem
}

.hover\\:-translate-x-6:hover{
  --transform-translate-x:-1.5rem
}

.hover\\:-translate-x-8:hover{
  --transform-translate-x:-2rem
}

.hover\\:-translate-x-10:hover{
  --transform-translate-x:-2.5rem
}

.hover\\:-translate-x-12:hover{
  --transform-translate-x:-3rem
}

.hover\\:-translate-x-16:hover{
  --transform-translate-x:-4rem
}

.hover\\:-translate-x-20:hover{
  --transform-translate-x:-5rem
}

.hover\\:-translate-x-24:hover{
  --transform-translate-x:-6rem
}

.hover\\:-translate-x-32:hover{
  --transform-translate-x:-8rem
}

.hover\\:-translate-x-40:hover{
  --transform-translate-x:-10rem
}

.hover\\:-translate-x-48:hover{
  --transform-translate-x:-12rem
}

.hover\\:-translate-x-56:hover{
  --transform-translate-x:-14rem
}

.hover\\:-translate-x-64:hover{
  --transform-translate-x:-16rem
}

.hover\\:-translate-x-px:hover{
  --transform-translate-x:-1px
}

.hover\\:-translate-x-full:hover{
  --transform-translate-x:-100%
}

.hover\\:-translate-x-1\\/2:hover{
  --transform-translate-x:-50%
}

.hover\\:translate-x-1\\/2:hover{
  --transform-translate-x:50%
}

.hover\\:translate-x-full:hover{
  --transform-translate-x:100%
}

.hover\\:translate-y-0:hover{
  --transform-translate-y:0
}

.hover\\:translate-y-1:hover{
  --transform-translate-y:0.25rem
}

.hover\\:translate-y-2:hover{
  --transform-translate-y:0.5rem
}

.hover\\:translate-y-3:hover{
  --transform-translate-y:0.75rem
}

.hover\\:translate-y-4:hover{
  --transform-translate-y:1rem
}

.hover\\:translate-y-5:hover{
  --transform-translate-y:1.25rem
}

.hover\\:translate-y-6:hover{
  --transform-translate-y:1.5rem
}

.hover\\:translate-y-8:hover{
  --transform-translate-y:2rem
}

.hover\\:translate-y-10:hover{
  --transform-translate-y:2.5rem
}

.hover\\:translate-y-12:hover{
  --transform-translate-y:3rem
}

.hover\\:translate-y-16:hover{
  --transform-translate-y:4rem
}

.hover\\:translate-y-20:hover{
  --transform-translate-y:5rem
}

.hover\\:translate-y-24:hover{
  --transform-translate-y:6rem
}

.hover\\:translate-y-32:hover{
  --transform-translate-y:8rem
}

.hover\\:translate-y-40:hover{
  --transform-translate-y:10rem
}

.hover\\:translate-y-48:hover{
  --transform-translate-y:12rem
}

.hover\\:translate-y-56:hover{
  --transform-translate-y:14rem
}

.hover\\:translate-y-64:hover{
  --transform-translate-y:16rem
}

.hover\\:translate-y-px:hover{
  --transform-translate-y:1px
}

.hover\\:-translate-y-1:hover{
  --transform-translate-y:-0.25rem
}

.hover\\:-translate-y-2:hover{
  --transform-translate-y:-0.5rem
}

.hover\\:-translate-y-3:hover{
  --transform-translate-y:-0.75rem
}

.hover\\:-translate-y-4:hover{
  --transform-translate-y:-1rem
}

.hover\\:-translate-y-5:hover{
  --transform-translate-y:-1.25rem
}

.hover\\:-translate-y-6:hover{
  --transform-translate-y:-1.5rem
}

.hover\\:-translate-y-8:hover{
  --transform-translate-y:-2rem
}

.hover\\:-translate-y-10:hover{
  --transform-translate-y:-2.5rem
}

.hover\\:-translate-y-12:hover{
  --transform-translate-y:-3rem
}

.hover\\:-translate-y-16:hover{
  --transform-translate-y:-4rem
}

.hover\\:-translate-y-20:hover{
  --transform-translate-y:-5rem
}

.hover\\:-translate-y-24:hover{
  --transform-translate-y:-6rem
}

.hover\\:-translate-y-32:hover{
  --transform-translate-y:-8rem
}

.hover\\:-translate-y-40:hover{
  --transform-translate-y:-10rem
}

.hover\\:-translate-y-48:hover{
  --transform-translate-y:-12rem
}

.hover\\:-translate-y-56:hover{
  --transform-translate-y:-14rem
}

.hover\\:-translate-y-64:hover{
  --transform-translate-y:-16rem
}

.hover\\:-translate-y-px:hover{
  --transform-translate-y:-1px
}

.hover\\:-translate-y-full:hover{
  --transform-translate-y:-100%
}

.hover\\:-translate-y-1\\/2:hover{
  --transform-translate-y:-50%
}

.hover\\:translate-y-1\\/2:hover{
  --transform-translate-y:50%
}

.hover\\:translate-y-full:hover{
  --transform-translate-y:100%
}

.focus\\:translate-x-0:focus{
  --transform-translate-x:0
}

.focus\\:translate-x-1:focus{
  --transform-translate-x:0.25rem
}

.focus\\:translate-x-2:focus{
  --transform-translate-x:0.5rem
}

.focus\\:translate-x-3:focus{
  --transform-translate-x:0.75rem
}

.focus\\:translate-x-4:focus{
  --transform-translate-x:1rem
}

.focus\\:translate-x-5:focus{
  --transform-translate-x:1.25rem
}

.focus\\:translate-x-6:focus{
  --transform-translate-x:1.5rem
}

.focus\\:translate-x-8:focus{
  --transform-translate-x:2rem
}

.focus\\:translate-x-10:focus{
  --transform-translate-x:2.5rem
}

.focus\\:translate-x-12:focus{
  --transform-translate-x:3rem
}

.focus\\:translate-x-16:focus{
  --transform-translate-x:4rem
}

.focus\\:translate-x-20:focus{
  --transform-translate-x:5rem
}

.focus\\:translate-x-24:focus{
  --transform-translate-x:6rem
}

.focus\\:translate-x-32:focus{
  --transform-translate-x:8rem
}

.focus\\:translate-x-40:focus{
  --transform-translate-x:10rem
}

.focus\\:translate-x-48:focus{
  --transform-translate-x:12rem
}

.focus\\:translate-x-56:focus{
  --transform-translate-x:14rem
}

.focus\\:translate-x-64:focus{
  --transform-translate-x:16rem
}

.focus\\:translate-x-px:focus{
  --transform-translate-x:1px
}

.focus\\:-translate-x-1:focus{
  --transform-translate-x:-0.25rem
}

.focus\\:-translate-x-2:focus{
  --transform-translate-x:-0.5rem
}

.focus\\:-translate-x-3:focus{
  --transform-translate-x:-0.75rem
}

.focus\\:-translate-x-4:focus{
  --transform-translate-x:-1rem
}

.focus\\:-translate-x-5:focus{
  --transform-translate-x:-1.25rem
}

.focus\\:-translate-x-6:focus{
  --transform-translate-x:-1.5rem
}

.focus\\:-translate-x-8:focus{
  --transform-translate-x:-2rem
}

.focus\\:-translate-x-10:focus{
  --transform-translate-x:-2.5rem
}

.focus\\:-translate-x-12:focus{
  --transform-translate-x:-3rem
}

.focus\\:-translate-x-16:focus{
  --transform-translate-x:-4rem
}

.focus\\:-translate-x-20:focus{
  --transform-translate-x:-5rem
}

.focus\\:-translate-x-24:focus{
  --transform-translate-x:-6rem
}

.focus\\:-translate-x-32:focus{
  --transform-translate-x:-8rem
}

.focus\\:-translate-x-40:focus{
  --transform-translate-x:-10rem
}

.focus\\:-translate-x-48:focus{
  --transform-translate-x:-12rem
}

.focus\\:-translate-x-56:focus{
  --transform-translate-x:-14rem
}

.focus\\:-translate-x-64:focus{
  --transform-translate-x:-16rem
}

.focus\\:-translate-x-px:focus{
  --transform-translate-x:-1px
}

.focus\\:-translate-x-full:focus{
  --transform-translate-x:-100%
}

.focus\\:-translate-x-1\\/2:focus{
  --transform-translate-x:-50%
}

.focus\\:translate-x-1\\/2:focus{
  --transform-translate-x:50%
}

.focus\\:translate-x-full:focus{
  --transform-translate-x:100%
}

.focus\\:translate-y-0:focus{
  --transform-translate-y:0
}

.focus\\:translate-y-1:focus{
  --transform-translate-y:0.25rem
}

.focus\\:translate-y-2:focus{
  --transform-translate-y:0.5rem
}

.focus\\:translate-y-3:focus{
  --transform-translate-y:0.75rem
}

.focus\\:translate-y-4:focus{
  --transform-translate-y:1rem
}

.focus\\:translate-y-5:focus{
  --transform-translate-y:1.25rem
}

.focus\\:translate-y-6:focus{
  --transform-translate-y:1.5rem
}

.focus\\:translate-y-8:focus{
  --transform-translate-y:2rem
}

.focus\\:translate-y-10:focus{
  --transform-translate-y:2.5rem
}

.focus\\:translate-y-12:focus{
  --transform-translate-y:3rem
}

.focus\\:translate-y-16:focus{
  --transform-translate-y:4rem
}

.focus\\:translate-y-20:focus{
  --transform-translate-y:5rem
}

.focus\\:translate-y-24:focus{
  --transform-translate-y:6rem
}

.focus\\:translate-y-32:focus{
  --transform-translate-y:8rem
}

.focus\\:translate-y-40:focus{
  --transform-translate-y:10rem
}

.focus\\:translate-y-48:focus{
  --transform-translate-y:12rem
}

.focus\\:translate-y-56:focus{
  --transform-translate-y:14rem
}

.focus\\:translate-y-64:focus{
  --transform-translate-y:16rem
}

.focus\\:translate-y-px:focus{
  --transform-translate-y:1px
}

.focus\\:-translate-y-1:focus{
  --transform-translate-y:-0.25rem
}

.focus\\:-translate-y-2:focus{
  --transform-translate-y:-0.5rem
}

.focus\\:-translate-y-3:focus{
  --transform-translate-y:-0.75rem
}

.focus\\:-translate-y-4:focus{
  --transform-translate-y:-1rem
}

.focus\\:-translate-y-5:focus{
  --transform-translate-y:-1.25rem
}

.focus\\:-translate-y-6:focus{
  --transform-translate-y:-1.5rem
}

.focus\\:-translate-y-8:focus{
  --transform-translate-y:-2rem
}

.focus\\:-translate-y-10:focus{
  --transform-translate-y:-2.5rem
}

.focus\\:-translate-y-12:focus{
  --transform-translate-y:-3rem
}

.focus\\:-translate-y-16:focus{
  --transform-translate-y:-4rem
}

.focus\\:-translate-y-20:focus{
  --transform-translate-y:-5rem
}

.focus\\:-translate-y-24:focus{
  --transform-translate-y:-6rem
}

.focus\\:-translate-y-32:focus{
  --transform-translate-y:-8rem
}

.focus\\:-translate-y-40:focus{
  --transform-translate-y:-10rem
}

.focus\\:-translate-y-48:focus{
  --transform-translate-y:-12rem
}

.focus\\:-translate-y-56:focus{
  --transform-translate-y:-14rem
}

.focus\\:-translate-y-64:focus{
  --transform-translate-y:-16rem
}

.focus\\:-translate-y-px:focus{
  --transform-translate-y:-1px
}

.focus\\:-translate-y-full:focus{
  --transform-translate-y:-100%
}

.focus\\:-translate-y-1\\/2:focus{
  --transform-translate-y:-50%
}

.focus\\:translate-y-1\\/2:focus{
  --transform-translate-y:50%
}

.focus\\:translate-y-full:focus{
  --transform-translate-y:100%
}

.skew-x-0{
  --transform-skew-x:0
}

.skew-x-3{
  --transform-skew-x:3deg
}

.skew-x-6{
  --transform-skew-x:6deg
}

.skew-x-12{
  --transform-skew-x:12deg
}

.-skew-x-12{
  --transform-skew-x:-12deg
}

.-skew-x-6{
  --transform-skew-x:-6deg
}

.-skew-x-3{
  --transform-skew-x:-3deg
}

.skew-y-0{
  --transform-skew-y:0
}

.skew-y-3{
  --transform-skew-y:3deg
}

.skew-y-6{
  --transform-skew-y:6deg
}

.skew-y-12{
  --transform-skew-y:12deg
}

.-skew-y-12{
  --transform-skew-y:-12deg
}

.-skew-y-6{
  --transform-skew-y:-6deg
}

.-skew-y-3{
  --transform-skew-y:-3deg
}

.hover\\:skew-x-0:hover{
  --transform-skew-x:0
}

.hover\\:skew-x-3:hover{
  --transform-skew-x:3deg
}

.hover\\:skew-x-6:hover{
  --transform-skew-x:6deg
}

.hover\\:skew-x-12:hover{
  --transform-skew-x:12deg
}

.hover\\:-skew-x-12:hover{
  --transform-skew-x:-12deg
}

.hover\\:-skew-x-6:hover{
  --transform-skew-x:-6deg
}

.hover\\:-skew-x-3:hover{
  --transform-skew-x:-3deg
}

.hover\\:skew-y-0:hover{
  --transform-skew-y:0
}

.hover\\:skew-y-3:hover{
  --transform-skew-y:3deg
}

.hover\\:skew-y-6:hover{
  --transform-skew-y:6deg
}

.hover\\:skew-y-12:hover{
  --transform-skew-y:12deg
}

.hover\\:-skew-y-12:hover{
  --transform-skew-y:-12deg
}

.hover\\:-skew-y-6:hover{
  --transform-skew-y:-6deg
}

.hover\\:-skew-y-3:hover{
  --transform-skew-y:-3deg
}

.focus\\:skew-x-0:focus{
  --transform-skew-x:0
}

.focus\\:skew-x-3:focus{
  --transform-skew-x:3deg
}

.focus\\:skew-x-6:focus{
  --transform-skew-x:6deg
}

.focus\\:skew-x-12:focus{
  --transform-skew-x:12deg
}

.focus\\:-skew-x-12:focus{
  --transform-skew-x:-12deg
}

.focus\\:-skew-x-6:focus{
  --transform-skew-x:-6deg
}

.focus\\:-skew-x-3:focus{
  --transform-skew-x:-3deg
}

.focus\\:skew-y-0:focus{
  --transform-skew-y:0
}

.focus\\:skew-y-3:focus{
  --transform-skew-y:3deg
}

.focus\\:skew-y-6:focus{
  --transform-skew-y:6deg
}

.focus\\:skew-y-12:focus{
  --transform-skew-y:12deg
}

.focus\\:-skew-y-12:focus{
  --transform-skew-y:-12deg
}

.focus\\:-skew-y-6:focus{
  --transform-skew-y:-6deg
}

.focus\\:-skew-y-3:focus{
  --transform-skew-y:-3deg
}

.transition-none{
  transition-property:none
}

.transition-all{
  transition-property:all
}

.transition{
  transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform
}

.transition-colors{
  transition-property:background-color,border-color,color,fill,stroke
}

.transition-opacity{
  transition-property:opacity
}

.transition-shadow{
  transition-property:box-shadow
}

.transition-transform{
  transition-property:transform
}

.ease-linear{
  transition-timing-function:linear
}

.ease-in{
  transition-timing-function:cubic-bezier(.4,0,1,1)
}

.ease-out{
  transition-timing-function:cubic-bezier(0,0,.2,1)
}

.ease-in-out{
  transition-timing-function:cubic-bezier(.4,0,.2,1)
}

.duration-75{
  transition-duration:75ms
}

.duration-100{
  transition-duration:.1s
}

.duration-150{
  transition-duration:.15s
}

.duration-200{
  transition-duration:.2s
}

.duration-300{
  transition-duration:.3s
}

.duration-500{
  transition-duration:.5s
}

.duration-700{
  transition-duration:.7s
}

.duration-1000{
  transition-duration:1s
}

.delay-75{
  transition-delay:75ms
}

.delay-100{
  transition-delay:.1s
}

.delay-150{
  transition-delay:.15s
}

.delay-200{
  transition-delay:.2s
}

.delay-300{
  transition-delay:.3s
}

.delay-500{
  transition-delay:.5s
}

.delay-700{
  transition-delay:.7s
}

.delay-1000{
  transition-delay:1s
}

.shadow-outline-white{
  box-shadow:0 0 0 3px #ffffff73
}

.shadow-outline-black{
  box-shadow:0 0 0 3px #00000073
}

.shadow-outline-gray{
  box-shadow:0 0 0 3px #d5d6d773
}

.shadow-outline-cool-gray{
  box-shadow:0 0 0 3px #cfd8e373
}

.shadow-outline-red{
  box-shadow:0 0 0 3px #f8b4b473
}

.shadow-outline-orange{
  box-shadow:0 0 0 3px #fdba8c73
}

.shadow-outline-yellow{
  box-shadow:0 0 0 3px #faca1573
}

.shadow-outline-green{
  box-shadow:0 0 0 3px #84e1bc73
}

.shadow-outline-teal{
  box-shadow:0 0 0 3px #7edce273
}

.shadow-outline-blue{
  box-shadow:0 0 0 3px #a4cafe73
}

.shadow-outline-indigo{
  box-shadow:0 0 0 3px #b4c6fc73
}

.shadow-outline-indigo{
  box-shadow:0 0 0 3px #cabffd73
}

.shadow-outline-pink{
  box-shadow:0 0 0 3px #f8b4d973
}

.hover\\:shadow-outline-white:hover{
  box-shadow:0 0 0 3px #ffffff73
}

.hover\\:shadow-outline-black:hover{
  box-shadow:0 0 0 3px #00000073
}

.hover\\:shadow-outline-gray:hover{
  box-shadow:0 0 0 3px #d5d6d773
}

.hover\\:shadow-outline-cool-gray:hover{
  box-shadow:0 0 0 3px #cfd8e373
}

.hover\\:shadow-outline-red:hover{
  box-shadow:0 0 0 3px #f8b4b473
}

.hover\\:shadow-outline-orange:hover{
  box-shadow:0 0 0 3px #fdba8c73
}

.hover\\:shadow-outline-yellow:hover{
  box-shadow:0 0 0 3px #faca1573
}

.hover\\:shadow-outline-green:hover{
  box-shadow:0 0 0 3px #84e1bc73
}

.hover\\:shadow-outline-teal:hover{
  box-shadow:0 0 0 3px #7edce273
}

.hover\\:shadow-outline-blue:hover{
  box-shadow:0 0 0 3px #a4cafe73
}

.hover\\:shadow-outline-indigo:hover{
  box-shadow:0 0 0 3px #b4c6fc73
}

.hover\\:shadow-outline-indigo:hover{
  box-shadow:0 0 0 3px #cabffd73
}

.hover\\:shadow-outline-pink:hover{
  box-shadow:0 0 0 3px #f8b4d973
}

.focus\\:shadow-outline-white:focus{
  box-shadow:0 0 0 3px #ffffff73
}

.focus\\:shadow-outline-black:focus{
  box-shadow:0 0 0 3px #00000073
}

.focus\\:shadow-outline-gray:focus{
  box-shadow:0 0 0 3px #d5d6d773
}

.focus\\:shadow-outline-cool-gray:focus{
  box-shadow:0 0 0 3px #cfd8e373
}

.focus\\:shadow-outline-red:focus{
  box-shadow:0 0 0 3px #f8b4b473
}

.focus\\:shadow-outline-orange:focus{
  box-shadow:0 0 0 3px #fdba8c73
}

.focus\\:shadow-outline-yellow:focus{
  box-shadow:0 0 0 3px #faca1573
}

.focus\\:shadow-outline-green:focus{
  box-shadow:0 0 0 3px #84e1bc73
}

.focus\\:shadow-outline-teal:focus{
  box-shadow:0 0 0 3px #7edce273
}

.focus\\:shadow-outline-blue:focus{
  box-shadow:0 0 0 3px #a4cafe73
}

.focus\\:shadow-outline-indigo:focus{
  box-shadow:0 0 0 3px #b4c6fc73
}

.focus\\:shadow-outline-indigo:focus{
  box-shadow:0 0 0 3px #cabffd73
}

.focus\\:shadow-outline-pink:focus{
  box-shadow:0 0 0 3px #f8b4d973
}

.theme-dark .dark\\:focus\\:shadow-outline-white:focus{
  box-shadow:0 0 0 3px #ffffff73
}

.theme-dark .dark\\:focus\\:shadow-outline-black:focus{
  box-shadow:0 0 0 3px #00000073
}

.theme-dark .dark\\:focus\\:shadow-outline-gray:focus{
  box-shadow:0 0 0 3px #d5d6d773
}

.theme-dark .dark\\:focus\\:shadow-outline-cool-gray:focus{
  box-shadow:0 0 0 3px #cfd8e373
}

.theme-dark .dark\\:focus\\:shadow-outline-red:focus{
  box-shadow:0 0 0 3px #f8b4b473
}

.theme-dark .dark\\:focus\\:shadow-outline-orange:focus{
  box-shadow:0 0 0 3px #fdba8c73
}

.theme-dark .dark\\:focus\\:shadow-outline-yellow:focus{
  box-shadow:0 0 0 3px #faca1573
}

.theme-dark .dark\\:focus\\:shadow-outline-green:focus{
  box-shadow:0 0 0 3px #84e1bc73
}

.theme-dark .dark\\:focus\\:shadow-outline-teal:focus{
  box-shadow:0 0 0 3px #7edce273
}

.theme-dark .dark\\:focus\\:shadow-outline-blue:focus{
  box-shadow:0 0 0 3px #a4cafe73
}

.theme-dark .dark\\:focus\\:shadow-outline-indigo:focus{
  box-shadow:0 0 0 3px #b4c6fc73
}

.theme-dark .dark\\:focus\\:shadow-outline-indigo:focus{
  box-shadow:0 0 0 3px #cabffd73
}

.theme-dark .dark\\:focus\\:shadow-outline-pink:focus{
  box-shadow:0 0 0 3px #f8b4d973
}

@media (min-width:640px){
  .sm\\:space-y-0>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(0px*var(--space-y-reverse));
    margin-top:calc(0px*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-0>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(0px*(1 - var(--space-x-reverse)));
    margin-right:calc(0px*var(--space-x-reverse))
  }

  .sm\\:space-y-1>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(.25rem*var(--space-y-reverse));
    margin-top:calc(.25rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-1>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(.25rem*var(--space-x-reverse))
  }

  .sm\\:space-y-2>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(.5rem*var(--space-y-reverse));
    margin-top:calc(.5rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-2>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(.5rem*var(--space-x-reverse))
  }

  .sm\\:space-y-3>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(.75rem*var(--space-y-reverse));
    margin-top:calc(.75rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-3>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(.75rem*(1 - var(--space-x-reverse)));
    margin-right:calc(.75rem*var(--space-x-reverse))
  }

  .sm\\:space-y-4>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1rem*var(--space-y-reverse));
    margin-top:calc(1rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-4>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1rem*(1 - var(--space-x-reverse)));
    margin-right:calc(1rem*var(--space-x-reverse))
  }

  .sm\\:space-y-5>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1.25rem*var(--space-y-reverse));
    margin-top:calc(1.25rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-5>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(1.25rem*var(--space-x-reverse))
  }

  .sm\\:space-y-6>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1.5rem*var(--space-y-reverse));
    margin-top:calc(1.5rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-6>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(1.5rem*var(--space-x-reverse))
  }

  .sm\\:space-y-8>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(2rem*var(--space-y-reverse));
    margin-top:calc(2rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-8>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(2rem*(1 - var(--space-x-reverse)));
    margin-right:calc(2rem*var(--space-x-reverse))
  }

  .sm\\:space-y-10>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(2.5rem*var(--space-y-reverse));
    margin-top:calc(2.5rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-10>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(2.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(2.5rem*var(--space-x-reverse))
  }

  .sm\\:space-y-12>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(3rem*var(--space-y-reverse));
    margin-top:calc(3rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-12>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(3rem*(1 - var(--space-x-reverse)));
    margin-right:calc(3rem*var(--space-x-reverse))
  }

  .sm\\:space-y-16>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(4rem*var(--space-y-reverse));
    margin-top:calc(4rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-16>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(4rem*(1 - var(--space-x-reverse)));
    margin-right:calc(4rem*var(--space-x-reverse))
  }

  .sm\\:space-y-20>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(5rem*var(--space-y-reverse));
    margin-top:calc(5rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-20>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(5rem*var(--space-x-reverse))
  }

  .sm\\:space-y-24>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(6rem*var(--space-y-reverse));
    margin-top:calc(6rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-24>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(6rem*(1 - var(--space-x-reverse)));
    margin-right:calc(6rem*var(--space-x-reverse))
  }

  .sm\\:space-y-32>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(8rem*var(--space-y-reverse));
    margin-top:calc(8rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-32>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(8rem*(1 - var(--space-x-reverse)));
    margin-right:calc(8rem*var(--space-x-reverse))
  }

  .sm\\:space-y-40>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(10rem*var(--space-y-reverse));
    margin-top:calc(10rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-40>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(10rem*(1 - var(--space-x-reverse)));
    margin-right:calc(10rem*var(--space-x-reverse))
  }

  .sm\\:space-y-48>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(12rem*var(--space-y-reverse));
    margin-top:calc(12rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-48>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(12rem*(1 - var(--space-x-reverse)));
    margin-right:calc(12rem*var(--space-x-reverse))
  }

  .sm\\:space-y-56>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(14rem*var(--space-y-reverse));
    margin-top:calc(14rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-56>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(14rem*(1 - var(--space-x-reverse)));
    margin-right:calc(14rem*var(--space-x-reverse))
  }

  .sm\\:space-y-64>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(16rem*var(--space-y-reverse));
    margin-top:calc(16rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-64>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(16rem*(1 - var(--space-x-reverse)));
    margin-right:calc(16rem*var(--space-x-reverse))
  }

  .sm\\:space-y-px>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1px*var(--space-y-reverse));
    margin-top:calc(1px*(1 - var(--space-y-reverse)))
  }

  .sm\\:space-x-px>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1px*(1 - var(--space-x-reverse)));
    margin-right:calc(1px*var(--space-x-reverse))
  }

  .sm\\:-space-y-1>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-.25rem*var(--space-y-reverse));
    margin-top:calc(-.25rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-1>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-.25rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-2>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-.5rem*var(--space-y-reverse));
    margin-top:calc(-.5rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-2>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-.5rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-3>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-.75rem*var(--space-y-reverse));
    margin-top:calc(-.75rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-3>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-.75rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-.75rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-4>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1rem*var(--space-y-reverse));
    margin-top:calc(-1rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-4>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-1rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-5>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1.25rem*var(--space-y-reverse));
    margin-top:calc(-1.25rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-5>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-1.25rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-6>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1.5rem*var(--space-y-reverse));
    margin-top:calc(-1.5rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-6>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-1.5rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-8>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-2rem*var(--space-y-reverse));
    margin-top:calc(-2rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-8>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-2rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-2rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-10>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-2.5rem*var(--space-y-reverse));
    margin-top:calc(-2.5rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-10>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-2.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-2.5rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-12>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-3rem*var(--space-y-reverse));
    margin-top:calc(-3rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-12>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-3rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-3rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-16>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-4rem*var(--space-y-reverse));
    margin-top:calc(-4rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-16>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-4rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-4rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-20>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-5rem*var(--space-y-reverse));
    margin-top:calc(-5rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-20>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-5rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-24>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-6rem*var(--space-y-reverse));
    margin-top:calc(-6rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-24>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-6rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-6rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-32>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-8rem*var(--space-y-reverse));
    margin-top:calc(-8rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-32>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-8rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-8rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-40>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-10rem*var(--space-y-reverse));
    margin-top:calc(-10rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-40>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-10rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-10rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-48>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-12rem*var(--space-y-reverse));
    margin-top:calc(-12rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-48>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-12rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-12rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-56>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-14rem*var(--space-y-reverse));
    margin-top:calc(-14rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-56>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-14rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-14rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-64>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-16rem*var(--space-y-reverse));
    margin-top:calc(-16rem*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-64>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-16rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-16rem*var(--space-x-reverse))
  }

  .sm\\:-space-y-px>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1px*var(--space-y-reverse));
    margin-top:calc(-1px*(1 - var(--space-y-reverse)))
  }

  .sm\\:-space-x-px>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1px*(1 - var(--space-x-reverse)));
    margin-right:calc(-1px*var(--space-x-reverse))
  }

  .sm\\:space-y-reverse>:not(template)~:not(template){
    --space-y-reverse:1
  }

  .sm\\:space-x-reverse>:not(template)~:not(template){
    --space-x-reverse:1
  }

  .sm\\:divide-y-0>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(0px*var(--divide-y-reverse));
    border-top-width:calc(0px*(1 - var(--divide-y-reverse)))
  }

  .sm\\:divide-x-0>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(0px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(0px*var(--divide-x-reverse))
  }

  .sm\\:divide-y-2>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(2px*var(--divide-y-reverse));
    border-top-width:calc(2px*(1 - var(--divide-y-reverse)))
  }

  .sm\\:divide-x-2>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(2px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(2px*var(--divide-x-reverse))
  }

  .sm\\:divide-y-4>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(4px*var(--divide-y-reverse));
    border-top-width:calc(4px*(1 - var(--divide-y-reverse)))
  }

  .sm\\:divide-x-4>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(4px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(4px*var(--divide-x-reverse))
  }

  .sm\\:divide-y-8>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(8px*var(--divide-y-reverse));
    border-top-width:calc(8px*(1 - var(--divide-y-reverse)))
  }

  .sm\\:divide-x-8>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(8px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(8px*var(--divide-x-reverse))
  }

  .sm\\:divide-y>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(1px*var(--divide-y-reverse));
    border-top-width:calc(1px*(1 - var(--divide-y-reverse)))
  }

  .sm\\:divide-x>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(1px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(1px*var(--divide-x-reverse))
  }

  .sm\\:divide-y-reverse>:not(template)~:not(template){
    --divide-y-reverse:1
  }

  .sm\\:divide-x-reverse>:not(template)~:not(template){
    --divide-x-reverse:1
  }

  .sm\\:divide-transparent>:not(template)~:not(template){
    border-color:#0000
  }

  .sm\\:divide-white>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--divide-opacity))
  }

  .sm\\:divide-black>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--divide-opacity))
  }

  .sm\\:divide-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--divide-opacity))
  }

  .sm\\:divide-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--divide-opacity))
  }

  .sm\\:divide-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--divide-opacity))
  }

  .sm\\:divide-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--divide-opacity))
  }

  .sm\\:divide-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--divide-opacity))
  }

  .sm\\:divide-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--divide-opacity))
  }

  .sm\\:divide-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--divide-opacity))
  }

  .sm\\:divide-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--divide-opacity))
  }

  .sm\\:divide-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--divide-opacity))
  }

  .sm\\:divide-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--divide-opacity))
  }

  .sm\\:divide-cool-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--divide-opacity))
  }

  .sm\\:divide-cool-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--divide-opacity))
  }

  .sm\\:divide-cool-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--divide-opacity))
  }

  .sm\\:divide-cool-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--divide-opacity))
  }

  .sm\\:divide-cool-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--divide-opacity))
  }

  .sm\\:divide-cool-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--divide-opacity))
  }

  .sm\\:divide-cool-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--divide-opacity))
  }

  .sm\\:divide-cool-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--divide-opacity))
  }

  .sm\\:divide-cool-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--divide-opacity))
  }

  .sm\\:divide-cool-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--divide-opacity))
  }

  .sm\\:divide-red-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--divide-opacity))
  }

  .sm\\:divide-red-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--divide-opacity))
  }

  .sm\\:divide-red-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--divide-opacity))
  }

  .sm\\:divide-red-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--divide-opacity))
  }

  .sm\\:divide-red-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--divide-opacity))
  }

  .sm\\:divide-red-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--divide-opacity))
  }

  .sm\\:divide-red-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--divide-opacity))
  }

  .sm\\:divide-red-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--divide-opacity))
  }

  .sm\\:divide-red-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--divide-opacity))
  }

  .sm\\:divide-red-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .sm\\:divide-orange-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--divide-opacity))
  }

  .sm\\:divide-orange-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--divide-opacity))
  }

  .sm\\:divide-orange-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--divide-opacity))
  }

  .sm\\:divide-orange-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--divide-opacity))
  }

  .sm\\:divide-orange-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--divide-opacity))
  }

  .sm\\:divide-orange-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--divide-opacity))
  }

  .sm\\:divide-orange-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--divide-opacity))
  }

  .sm\\:divide-orange-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--divide-opacity))
  }

  .sm\\:divide-orange-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--divide-opacity))
  }

  .sm\\:divide-orange-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .sm\\:divide-yellow-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--divide-opacity))
  }

  .sm\\:divide-yellow-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--divide-opacity))
  }

  .sm\\:divide-yellow-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--divide-opacity))
  }

  .sm\\:divide-yellow-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--divide-opacity))
  }

  .sm\\:divide-yellow-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--divide-opacity))
  }

  .sm\\:divide-yellow-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--divide-opacity))
  }

  .sm\\:divide-yellow-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--divide-opacity))
  }

  .sm\\:divide-yellow-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--divide-opacity))
  }

  .sm\\:divide-yellow-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--divide-opacity))
  }

  .sm\\:divide-yellow-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--divide-opacity))
  }

  .sm\\:divide-green-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--divide-opacity))
  }

  .sm\\:divide-green-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--divide-opacity))
  }

  .sm\\:divide-green-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--divide-opacity))
  }

  .sm\\:divide-green-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--divide-opacity))
  }

  .sm\\:divide-green-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--divide-opacity))
  }

  .sm\\:divide-green-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--divide-opacity))
  }

  .sm\\:divide-green-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--divide-opacity))
  }

  .sm\\:divide-green-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--divide-opacity))
  }

  .sm\\:divide-green-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--divide-opacity))
  }

  .sm\\:divide-green-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--divide-opacity))
  }

  .sm\\:divide-teal-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--divide-opacity))
  }

  .sm\\:divide-teal-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--divide-opacity))
  }

  .sm\\:divide-teal-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--divide-opacity))
  }

  .sm\\:divide-teal-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--divide-opacity))
  }

  .sm\\:divide-teal-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--divide-opacity))
  }

  .sm\\:divide-teal-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--divide-opacity))
  }

  .sm\\:divide-teal-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--divide-opacity))
  }

  .sm\\:divide-teal-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--divide-opacity))
  }

  .sm\\:divide-teal-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--divide-opacity))
  }

  .sm\\:divide-teal-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--divide-opacity))
  }

  .sm\\:divide-blue-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--divide-opacity))
  }

  .sm\\:divide-blue-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--divide-opacity))
  }

  .sm\\:divide-blue-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--divide-opacity))
  }

  .sm\\:divide-blue-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--divide-opacity))
  }

  .sm\\:divide-blue-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--divide-opacity))
  }

  .sm\\:divide-blue-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--divide-opacity))
  }

  .sm\\:divide-blue-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--divide-opacity))
  }

  .sm\\:divide-blue-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--divide-opacity))
  }

  .sm\\:divide-blue-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--divide-opacity))
  }

  .sm\\:divide-blue-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--divide-opacity))
  }

  .sm\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--divide-opacity))
  }

  .sm\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--divide-opacity))
  }

  .sm\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--divide-opacity))
  }

  .sm\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--divide-opacity))
  }

  .sm\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--divide-opacity))
  }

  .sm\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--divide-opacity))
  }

  .sm\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--divide-opacity))
  }

  .sm\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--divide-opacity))
  }

  .sm\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--divide-opacity))
  }

  .sm\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--divide-opacity))
  }

  .sm\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--divide-opacity))
  }

  .sm\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--divide-opacity))
  }

  .sm\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--divide-opacity))
  }

  .sm\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--divide-opacity))
  }

  .sm\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--divide-opacity))
  }

  .sm\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--divide-opacity))
  }

  .sm\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--divide-opacity))
  }

  .sm\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--divide-opacity))
  }

  .sm\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--divide-opacity))
  }

  .sm\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--divide-opacity))
  }

  .sm\\:divide-pink-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--divide-opacity))
  }

  .sm\\:divide-pink-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--divide-opacity))
  }

  .sm\\:divide-pink-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--divide-opacity))
  }

  .sm\\:divide-pink-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--divide-opacity))
  }

  .sm\\:divide-pink-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--divide-opacity))
  }

  .sm\\:divide-pink-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--divide-opacity))
  }

  .sm\\:divide-pink-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--divide-opacity))
  }

  .sm\\:divide-pink-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--divide-opacity))
  }

  .sm\\:divide-pink-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--divide-opacity))
  }

  .sm\\:divide-pink-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-transparent>:not(template)~:not(template){
    border-color:#0000
  }

  .theme-dark .sm\\:dark\\:divide-white>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-black>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-cool-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-cool-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-cool-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-cool-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-cool-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-cool-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-cool-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-cool-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-cool-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-cool-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-red-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-red-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-red-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-red-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-red-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-red-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-red-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-red-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-red-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-red-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-orange-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-orange-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-orange-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-orange-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-orange-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-orange-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-orange-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-orange-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-orange-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-orange-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-yellow-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-yellow-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-yellow-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-yellow-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-yellow-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-yellow-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-yellow-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-yellow-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-yellow-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-yellow-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-green-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-green-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-green-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-green-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-green-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-green-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-green-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-green-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-green-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-green-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-teal-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-teal-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-teal-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-teal-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-teal-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-teal-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-teal-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-teal-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-teal-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-teal-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-blue-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-blue-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-blue-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-blue-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-blue-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-blue-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-blue-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-blue-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-blue-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-blue-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-pink-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-pink-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-pink-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-pink-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-pink-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-pink-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-pink-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-pink-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-pink-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--divide-opacity))
  }

  .theme-dark .sm\\:dark\\:divide-pink-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--divide-opacity))
  }

  .sm\\:divide-opacity-0>:not(template)~:not(template){
    --divide-opacity:0
  }

  .sm\\:divide-opacity-25>:not(template)~:not(template){
    --divide-opacity:0.25
  }

  .sm\\:divide-opacity-50>:not(template)~:not(template){
    --divide-opacity:0.5
  }

  .sm\\:divide-opacity-75>:not(template)~:not(template){
    --divide-opacity:0.75
  }

  .sm\\:divide-opacity-100>:not(template)~:not(template){
    --divide-opacity:1
  }

  .sm\\:sr-only{
    height:1px;
    margin:-1px;
    overflow:hidden;
    padding:0;
    position:absolute;
    width:1px;
    clip:rect(0,0,0,0);
    border-width:0;
    white-space:nowrap
  }

  .sm\\:not-sr-only{
    height:auto;
    margin:0;
    overflow:visible;
    padding:0;
    position:static;
    width:auto;
    clip:auto;
    white-space:normal
  }

  .sm\\:focus\\:sr-only:focus{
    height:1px;
    margin:-1px;
    overflow:hidden;
    padding:0;
    position:absolute;
    width:1px;
    clip:rect(0,0,0,0);
    border-width:0;
    white-space:nowrap
  }

  .sm\\:focus\\:not-sr-only:focus{
    height:auto;
    margin:0;
    overflow:visible;
    padding:0;
    position:static;
    width:auto;
    clip:auto;
    white-space:normal
  }

  .sm\\:appearance-none{
    appearance:none
  }

  .sm\\:bg-fixed{
    background-attachment:fixed
  }

  .sm\\:bg-local{
    background-attachment:local
  }

  .sm\\:bg-scroll{
    background-attachment:scroll
  }

  .sm\\:bg-transparent{
    background-color:initial
  }

  .sm\\:bg-white{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .sm\\:bg-black{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .sm\\:bg-gray-50{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .sm\\:bg-gray-100{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .sm\\:bg-gray-200{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .sm\\:bg-gray-300{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .sm\\:bg-gray-400{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .sm\\:bg-gray-500{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .sm\\:bg-gray-600{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .sm\\:bg-gray-700{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .sm\\:bg-gray-800{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .sm\\:bg-gray-900{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .sm\\:bg-cool-gray-50{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .sm\\:bg-cool-gray-100{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .sm\\:bg-cool-gray-200{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .sm\\:bg-cool-gray-300{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .sm\\:bg-cool-gray-400{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .sm\\:bg-cool-gray-500{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .sm\\:bg-cool-gray-600{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .sm\\:bg-cool-gray-700{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .sm\\:bg-cool-gray-800{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .sm\\:bg-cool-gray-900{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .sm\\:bg-red-50{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .sm\\:bg-red-100{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .sm\\:bg-red-200{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .sm\\:bg-red-300{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .sm\\:bg-red-400{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .sm\\:bg-red-500{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .sm\\:bg-red-600{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .sm\\:bg-red-700{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .sm\\:bg-red-800{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .sm\\:bg-red-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .sm\\:bg-orange-50{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .sm\\:bg-orange-100{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .sm\\:bg-orange-200{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .sm\\:bg-orange-300{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .sm\\:bg-orange-400{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .sm\\:bg-orange-500{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .sm\\:bg-orange-600{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .sm\\:bg-orange-700{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .sm\\:bg-orange-800{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .sm\\:bg-orange-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .sm\\:bg-yellow-50{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .sm\\:bg-yellow-100{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .sm\\:bg-yellow-200{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .sm\\:bg-yellow-300{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .sm\\:bg-yellow-400{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .sm\\:bg-yellow-500{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .sm\\:bg-yellow-600{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .sm\\:bg-yellow-700{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .sm\\:bg-yellow-800{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .sm\\:bg-yellow-900{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .sm\\:bg-green-50{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .sm\\:bg-green-100{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .sm\\:bg-green-200{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .sm\\:bg-green-300{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .sm\\:bg-green-400{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .sm\\:bg-green-500{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .sm\\:bg-green-600{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .sm\\:bg-green-700{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .sm\\:bg-green-800{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .sm\\:bg-green-900{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .sm\\:bg-teal-50{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .sm\\:bg-teal-100{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .sm\\:bg-teal-200{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .sm\\:bg-teal-300{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .sm\\:bg-teal-400{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .sm\\:bg-teal-500{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .sm\\:bg-teal-600{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .sm\\:bg-teal-700{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .sm\\:bg-teal-800{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .sm\\:bg-teal-900{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .sm\\:bg-blue-50{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .sm\\:bg-blue-100{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .sm\\:bg-blue-200{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .sm\\:bg-blue-300{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .sm\\:bg-blue-400{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .sm\\:bg-blue-500{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .sm\\:bg-blue-600{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .sm\\:bg-blue-700{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .sm\\:bg-blue-800{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .sm\\:bg-blue-900{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .sm\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .sm\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .sm\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .sm\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .sm\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .sm\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .sm\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .sm\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .sm\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .sm\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .sm\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .sm\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .sm\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .sm\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .sm\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .sm\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .sm\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .sm\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .sm\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .sm\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .sm\\:bg-pink-50{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .sm\\:bg-pink-100{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .sm\\:bg-pink-200{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .sm\\:bg-pink-300{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .sm\\:bg-pink-400{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .sm\\:bg-pink-500{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .sm\\:bg-pink-600{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .sm\\:bg-pink-700{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .sm\\:bg-pink-800{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .sm\\:bg-pink-900{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-transparent:hover{
    background-color:initial
  }

  .sm\\:hover\\:bg-white:hover{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-black:hover{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-gray-50:hover{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-gray-100:hover{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-gray-200:hover{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-gray-300:hover{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-gray-400:hover{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-gray-500:hover{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-gray-600:hover{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-gray-700:hover{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-gray-800:hover{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-gray-900:hover{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-cool-gray-50:hover{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-cool-gray-100:hover{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-cool-gray-200:hover{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-cool-gray-300:hover{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-cool-gray-400:hover{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-cool-gray-500:hover{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-cool-gray-600:hover{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-cool-gray-700:hover{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-cool-gray-800:hover{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-cool-gray-900:hover{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-red-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-red-100:hover{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-red-200:hover{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-red-300:hover{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-red-400:hover{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-red-500:hover{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-red-600:hover{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-red-700:hover{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-red-800:hover{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-red-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-orange-50:hover{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-orange-100:hover{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-orange-200:hover{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-orange-300:hover{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-orange-400:hover{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-orange-500:hover{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-orange-600:hover{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-orange-700:hover{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-orange-800:hover{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-orange-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-yellow-50:hover{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-yellow-100:hover{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-yellow-200:hover{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-yellow-300:hover{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-yellow-400:hover{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-yellow-500:hover{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-yellow-600:hover{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-yellow-700:hover{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-yellow-800:hover{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-yellow-900:hover{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-green-50:hover{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-green-100:hover{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-green-200:hover{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-green-300:hover{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-green-400:hover{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-green-500:hover{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-green-600:hover{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-green-700:hover{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-green-800:hover{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-green-900:hover{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-teal-50:hover{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-teal-100:hover{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-teal-200:hover{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-teal-300:hover{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-teal-400:hover{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-teal-500:hover{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-teal-600:hover{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-teal-700:hover{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-teal-800:hover{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-teal-900:hover{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-blue-50:hover{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-blue-100:hover{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-blue-200:hover{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-blue-300:hover{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-blue-400:hover{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-blue-500:hover{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-blue-600:hover{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-blue-700:hover{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-blue-800:hover{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-blue-900:hover{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-pink-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-pink-100:hover{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-pink-200:hover{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-pink-300:hover{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-pink-400:hover{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-pink-500:hover{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-pink-600:hover{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-pink-700:hover{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-pink-800:hover{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .sm\\:hover\\:bg-pink-900:hover{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-transparent:focus{
    background-color:initial
  }

  .sm\\:focus\\:bg-white:focus{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-black:focus{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-gray-50:focus{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-gray-100:focus{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-gray-200:focus{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-gray-300:focus{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-gray-400:focus{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-gray-500:focus{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-gray-600:focus{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-gray-700:focus{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-gray-800:focus{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-gray-900:focus{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-cool-gray-50:focus{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-cool-gray-100:focus{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-cool-gray-200:focus{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-cool-gray-300:focus{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-cool-gray-400:focus{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-cool-gray-500:focus{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-cool-gray-600:focus{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-cool-gray-700:focus{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-cool-gray-800:focus{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-cool-gray-900:focus{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-red-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-red-100:focus{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-red-200:focus{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-red-300:focus{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-red-400:focus{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-red-500:focus{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-red-600:focus{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-red-700:focus{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-red-800:focus{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-red-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-orange-50:focus{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-orange-100:focus{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-orange-200:focus{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-orange-300:focus{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-orange-400:focus{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-orange-500:focus{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-orange-600:focus{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-orange-700:focus{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-orange-800:focus{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-orange-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-yellow-50:focus{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-yellow-100:focus{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-yellow-200:focus{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-yellow-300:focus{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-yellow-400:focus{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-yellow-500:focus{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-yellow-600:focus{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-yellow-700:focus{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-yellow-800:focus{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-yellow-900:focus{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-green-50:focus{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-green-100:focus{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-green-200:focus{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-green-300:focus{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-green-400:focus{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-green-500:focus{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-green-600:focus{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-green-700:focus{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-green-800:focus{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-green-900:focus{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-teal-50:focus{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-teal-100:focus{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-teal-200:focus{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-teal-300:focus{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-teal-400:focus{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-teal-500:focus{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-teal-600:focus{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-teal-700:focus{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-teal-800:focus{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-teal-900:focus{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-blue-50:focus{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-blue-100:focus{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-blue-200:focus{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-blue-300:focus{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-blue-400:focus{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-blue-500:focus{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-blue-600:focus{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-blue-700:focus{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-blue-800:focus{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-blue-900:focus{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-pink-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-pink-100:focus{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-pink-200:focus{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-pink-300:focus{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-pink-400:focus{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-pink-500:focus{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-pink-600:focus{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-pink-700:focus{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-pink-800:focus{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .sm\\:focus\\:bg-pink-900:focus{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .sm\\:active\\:bg-transparent:active{
    background-color:initial
  }

  .sm\\:active\\:bg-white:active{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .sm\\:active\\:bg-black:active{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .sm\\:active\\:bg-gray-50:active{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .sm\\:active\\:bg-gray-100:active{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .sm\\:active\\:bg-gray-200:active{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .sm\\:active\\:bg-gray-300:active{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .sm\\:active\\:bg-gray-400:active{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .sm\\:active\\:bg-gray-500:active{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .sm\\:active\\:bg-gray-600:active{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .sm\\:active\\:bg-gray-700:active{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .sm\\:active\\:bg-gray-800:active{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .sm\\:active\\:bg-gray-900:active{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .sm\\:active\\:bg-cool-gray-50:active{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .sm\\:active\\:bg-cool-gray-100:active{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .sm\\:active\\:bg-cool-gray-200:active{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .sm\\:active\\:bg-cool-gray-300:active{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .sm\\:active\\:bg-cool-gray-400:active{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .sm\\:active\\:bg-cool-gray-500:active{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .sm\\:active\\:bg-cool-gray-600:active{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .sm\\:active\\:bg-cool-gray-700:active{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .sm\\:active\\:bg-cool-gray-800:active{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .sm\\:active\\:bg-cool-gray-900:active{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .sm\\:active\\:bg-red-50:active{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .sm\\:active\\:bg-red-100:active{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .sm\\:active\\:bg-red-200:active{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .sm\\:active\\:bg-red-300:active{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .sm\\:active\\:bg-red-400:active{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .sm\\:active\\:bg-red-500:active{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .sm\\:active\\:bg-red-600:active{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .sm\\:active\\:bg-red-700:active{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .sm\\:active\\:bg-red-800:active{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .sm\\:active\\:bg-red-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .sm\\:active\\:bg-orange-50:active{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .sm\\:active\\:bg-orange-100:active{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .sm\\:active\\:bg-orange-200:active{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .sm\\:active\\:bg-orange-300:active{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .sm\\:active\\:bg-orange-400:active{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .sm\\:active\\:bg-orange-500:active{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .sm\\:active\\:bg-orange-600:active{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .sm\\:active\\:bg-orange-700:active{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .sm\\:active\\:bg-orange-800:active{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .sm\\:active\\:bg-orange-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .sm\\:active\\:bg-yellow-50:active{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .sm\\:active\\:bg-yellow-100:active{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .sm\\:active\\:bg-yellow-200:active{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .sm\\:active\\:bg-yellow-300:active{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .sm\\:active\\:bg-yellow-400:active{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .sm\\:active\\:bg-yellow-500:active{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .sm\\:active\\:bg-yellow-600:active{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .sm\\:active\\:bg-yellow-700:active{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .sm\\:active\\:bg-yellow-800:active{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .sm\\:active\\:bg-yellow-900:active{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .sm\\:active\\:bg-green-50:active{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .sm\\:active\\:bg-green-100:active{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .sm\\:active\\:bg-green-200:active{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .sm\\:active\\:bg-green-300:active{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .sm\\:active\\:bg-green-400:active{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .sm\\:active\\:bg-green-500:active{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .sm\\:active\\:bg-green-600:active{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .sm\\:active\\:bg-green-700:active{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .sm\\:active\\:bg-green-800:active{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .sm\\:active\\:bg-green-900:active{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .sm\\:active\\:bg-teal-50:active{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .sm\\:active\\:bg-teal-100:active{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .sm\\:active\\:bg-teal-200:active{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .sm\\:active\\:bg-teal-300:active{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .sm\\:active\\:bg-teal-400:active{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .sm\\:active\\:bg-teal-500:active{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .sm\\:active\\:bg-teal-600:active{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .sm\\:active\\:bg-teal-700:active{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .sm\\:active\\:bg-teal-800:active{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .sm\\:active\\:bg-teal-900:active{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .sm\\:active\\:bg-blue-50:active{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .sm\\:active\\:bg-blue-100:active{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .sm\\:active\\:bg-blue-200:active{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .sm\\:active\\:bg-blue-300:active{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .sm\\:active\\:bg-blue-400:active{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .sm\\:active\\:bg-blue-500:active{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .sm\\:active\\:bg-blue-600:active{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .sm\\:active\\:bg-blue-700:active{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .sm\\:active\\:bg-blue-800:active{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .sm\\:active\\:bg-blue-900:active{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .sm\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .sm\\:active\\:bg-pink-50:active{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .sm\\:active\\:bg-pink-100:active{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .sm\\:active\\:bg-pink-200:active{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .sm\\:active\\:bg-pink-300:active{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .sm\\:active\\:bg-pink-400:active{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .sm\\:active\\:bg-pink-500:active{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .sm\\:active\\:bg-pink-600:active{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .sm\\:active\\:bg-pink-700:active{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .sm\\:active\\:bg-pink-800:active{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .sm\\:active\\:bg-pink-900:active{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-transparent:nth-child(odd){
    background-color:initial
  }

  .sm\\:odd\\:bg-white:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-black:nth-child(odd){
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-cool-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-cool-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-cool-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-cool-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-cool-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-cool-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-cool-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-cool-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-cool-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-cool-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-red-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-red-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-red-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-red-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-red-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-red-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-red-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-red-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-red-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-red-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-orange-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-orange-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-orange-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-orange-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-orange-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-orange-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-orange-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-orange-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-orange-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-orange-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-yellow-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-yellow-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-yellow-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-yellow-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-yellow-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-yellow-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-yellow-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-yellow-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-yellow-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-yellow-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-green-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-green-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-green-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-green-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-green-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-green-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-green-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-green-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-green-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-green-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-teal-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-teal-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-teal-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-teal-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-teal-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-teal-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-teal-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-teal-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-teal-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-teal-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-blue-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-blue-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-blue-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-blue-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-blue-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-blue-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-blue-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-blue-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-blue-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-blue-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-pink-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-pink-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-pink-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-pink-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-pink-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-pink-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-pink-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-pink-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-pink-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .sm\\:odd\\:bg-pink-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-transparent{
    background-color:initial
  }

  .theme-dark .sm\\:dark\\:bg-white{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-black{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-gray-50{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-gray-100{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-gray-200{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-gray-300{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-gray-400{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-gray-500{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-gray-600{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-gray-700{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-gray-800{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-gray-900{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-cool-gray-50{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-cool-gray-100{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-cool-gray-200{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-cool-gray-300{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-cool-gray-400{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-cool-gray-500{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-cool-gray-600{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-cool-gray-700{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-cool-gray-800{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-cool-gray-900{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-red-50{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-red-100{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-red-200{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-red-300{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-red-400{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-red-500{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-red-600{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-red-700{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-red-800{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-red-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-orange-50{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-orange-100{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-orange-200{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-orange-300{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-orange-400{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-orange-500{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-orange-600{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-orange-700{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-orange-800{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-orange-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-yellow-50{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-yellow-100{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-yellow-200{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-yellow-300{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-yellow-400{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-yellow-500{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-yellow-600{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-yellow-700{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-yellow-800{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-yellow-900{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-green-50{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-green-100{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-green-200{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-green-300{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-green-400{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-green-500{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-green-600{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-green-700{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-green-800{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-green-900{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-teal-50{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-teal-100{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-teal-200{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-teal-300{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-teal-400{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-teal-500{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-teal-600{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-teal-700{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-teal-800{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-teal-900{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-blue-50{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-blue-100{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-blue-200{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-blue-300{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-blue-400{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-blue-500{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-blue-600{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-blue-700{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-blue-800{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-blue-900{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-pink-50{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-pink-100{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-pink-200{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-pink-300{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-pink-400{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-pink-500{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-pink-600{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-pink-700{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-pink-800{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:bg-pink-900{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-transparent:hover{
    background-color:initial
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-white:hover{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-black:hover{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-gray-50:hover{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-gray-100:hover{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-gray-200:hover{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-gray-300:hover{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-gray-400:hover{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-gray-500:hover{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-gray-600:hover{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-gray-700:hover{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-gray-800:hover{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-gray-900:hover{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-50:hover{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-100:hover{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-200:hover{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-300:hover{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-400:hover{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-500:hover{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-600:hover{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-700:hover{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-800:hover{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-900:hover{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-red-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-red-100:hover{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-red-200:hover{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-red-300:hover{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-red-400:hover{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-red-500:hover{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-red-600:hover{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-red-700:hover{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-red-800:hover{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-red-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-orange-50:hover{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-orange-100:hover{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-orange-200:hover{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-orange-300:hover{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-orange-400:hover{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-orange-500:hover{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-orange-600:hover{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-orange-700:hover{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-orange-800:hover{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-orange-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-yellow-50:hover{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-yellow-100:hover{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-yellow-200:hover{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-yellow-300:hover{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-yellow-400:hover{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-yellow-500:hover{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-yellow-600:hover{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-yellow-700:hover{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-yellow-800:hover{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-yellow-900:hover{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-green-50:hover{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-green-100:hover{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-green-200:hover{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-green-300:hover{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-green-400:hover{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-green-500:hover{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-green-600:hover{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-green-700:hover{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-green-800:hover{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-green-900:hover{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-teal-50:hover{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-teal-100:hover{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-teal-200:hover{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-teal-300:hover{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-teal-400:hover{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-teal-500:hover{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-teal-600:hover{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-teal-700:hover{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-teal-800:hover{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-teal-900:hover{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-blue-50:hover{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-blue-100:hover{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-blue-200:hover{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-blue-300:hover{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-blue-400:hover{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-blue-500:hover{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-blue-600:hover{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-blue-700:hover{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-blue-800:hover{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-blue-900:hover{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-pink-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-pink-100:hover{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-pink-200:hover{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-pink-300:hover{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-pink-400:hover{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-pink-500:hover{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-pink-600:hover{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-pink-700:hover{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-pink-800:hover{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-pink-900:hover{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-transparent:focus{
    background-color:initial
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-white:focus{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-black:focus{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-gray-50:focus{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-gray-100:focus{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-gray-200:focus{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-gray-300:focus{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-gray-400:focus{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-gray-500:focus{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-gray-600:focus{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-gray-700:focus{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-gray-800:focus{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-gray-900:focus{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-50:focus{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-100:focus{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-200:focus{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-300:focus{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-400:focus{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-500:focus{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-600:focus{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-700:focus{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-800:focus{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-900:focus{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-red-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-red-100:focus{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-red-200:focus{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-red-300:focus{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-red-400:focus{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-red-500:focus{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-red-600:focus{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-red-700:focus{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-red-800:focus{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-red-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-orange-50:focus{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-orange-100:focus{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-orange-200:focus{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-orange-300:focus{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-orange-400:focus{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-orange-500:focus{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-orange-600:focus{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-orange-700:focus{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-orange-800:focus{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-orange-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-yellow-50:focus{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-yellow-100:focus{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-yellow-200:focus{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-yellow-300:focus{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-yellow-400:focus{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-yellow-500:focus{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-yellow-600:focus{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-yellow-700:focus{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-yellow-800:focus{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-yellow-900:focus{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-green-50:focus{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-green-100:focus{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-green-200:focus{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-green-300:focus{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-green-400:focus{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-green-500:focus{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-green-600:focus{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-green-700:focus{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-green-800:focus{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-green-900:focus{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-teal-50:focus{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-teal-100:focus{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-teal-200:focus{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-teal-300:focus{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-teal-400:focus{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-teal-500:focus{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-teal-600:focus{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-teal-700:focus{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-teal-800:focus{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-teal-900:focus{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-blue-50:focus{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-blue-100:focus{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-blue-200:focus{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-blue-300:focus{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-blue-400:focus{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-blue-500:focus{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-blue-600:focus{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-blue-700:focus{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-blue-800:focus{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-blue-900:focus{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-pink-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-pink-100:focus{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-pink-200:focus{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-pink-300:focus{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-pink-400:focus{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-pink-500:focus{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-pink-600:focus{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-pink-700:focus{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-pink-800:focus{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:bg-pink-900:focus{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-transparent:active{
    background-color:initial
  }

  .theme-dark .sm\\:dark\\:active\\:bg-white:active{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-black:active{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-gray-50:active{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-gray-100:active{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-gray-200:active{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-gray-300:active{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-gray-400:active{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-gray-500:active{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-gray-600:active{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-gray-700:active{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-gray-800:active{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-gray-900:active{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-cool-gray-50:active{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-cool-gray-100:active{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-cool-gray-200:active{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-cool-gray-300:active{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-cool-gray-400:active{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-cool-gray-500:active{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-cool-gray-600:active{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-cool-gray-700:active{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-cool-gray-800:active{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-cool-gray-900:active{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-red-50:active{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-red-100:active{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-red-200:active{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-red-300:active{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-red-400:active{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-red-500:active{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-red-600:active{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-red-700:active{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-red-800:active{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-red-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-orange-50:active{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-orange-100:active{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-orange-200:active{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-orange-300:active{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-orange-400:active{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-orange-500:active{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-orange-600:active{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-orange-700:active{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-orange-800:active{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-orange-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-yellow-50:active{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-yellow-100:active{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-yellow-200:active{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-yellow-300:active{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-yellow-400:active{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-yellow-500:active{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-yellow-600:active{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-yellow-700:active{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-yellow-800:active{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-yellow-900:active{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-green-50:active{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-green-100:active{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-green-200:active{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-green-300:active{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-green-400:active{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-green-500:active{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-green-600:active{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-green-700:active{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-green-800:active{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-green-900:active{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-teal-50:active{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-teal-100:active{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-teal-200:active{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-teal-300:active{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-teal-400:active{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-teal-500:active{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-teal-600:active{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-teal-700:active{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-teal-800:active{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-teal-900:active{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-blue-50:active{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-blue-100:active{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-blue-200:active{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-blue-300:active{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-blue-400:active{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-blue-500:active{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-blue-600:active{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-blue-700:active{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-blue-800:active{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-blue-900:active{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-pink-50:active{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-pink-100:active{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-pink-200:active{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-pink-300:active{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-pink-400:active{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-pink-500:active{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-pink-600:active{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-pink-700:active{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-pink-800:active{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:bg-pink-900:active{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-transparent:nth-child(odd){
    background-color:initial
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-white:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-black:nth-child(odd){
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-red-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-red-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-red-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-red-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-red-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-red-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-red-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-red-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-red-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-red-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-orange-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-orange-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-orange-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-orange-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-orange-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-orange-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-orange-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-orange-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-orange-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-orange-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-yellow-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-yellow-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-yellow-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-yellow-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-yellow-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-yellow-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-yellow-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-yellow-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-yellow-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-yellow-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-green-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-green-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-green-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-green-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-green-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-green-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-green-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-green-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-green-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-green-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-teal-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-teal-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-teal-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-teal-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-teal-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-teal-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-teal-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-teal-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-teal-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-teal-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-blue-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-blue-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-blue-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-blue-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-blue-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-blue-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-blue-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-blue-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-blue-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-blue-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-pink-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-pink-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-pink-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-pink-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-pink-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-pink-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-pink-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-pink-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-pink-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .sm\\:dark\\:odd\\:bg-pink-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .sm\\:bg-opacity-0{
    --bg-opacity:0
  }

  .sm\\:bg-opacity-10{
    --bg-opacity:0.1
  }

  .sm\\:bg-opacity-25{
    --bg-opacity:0.25
  }

  .sm\\:bg-opacity-50{
    --bg-opacity:0.5
  }

  .sm\\:bg-opacity-75{
    --bg-opacity:0.75
  }

  .sm\\:bg-opacity-100{
    --bg-opacity:1
  }

  .sm\\:hover\\:bg-opacity-0:hover{
    --bg-opacity:0
  }

  .sm\\:hover\\:bg-opacity-10:hover{
    --bg-opacity:0.1
  }

  .sm\\:hover\\:bg-opacity-25:hover{
    --bg-opacity:0.25
  }

  .sm\\:hover\\:bg-opacity-50:hover{
    --bg-opacity:0.5
  }

  .sm\\:hover\\:bg-opacity-75:hover{
    --bg-opacity:0.75
  }

  .sm\\:hover\\:bg-opacity-100:hover{
    --bg-opacity:1
  }

  .sm\\:focus\\:bg-opacity-0:focus{
    --bg-opacity:0
  }

  .sm\\:focus\\:bg-opacity-10:focus{
    --bg-opacity:0.1
  }

  .sm\\:focus\\:bg-opacity-25:focus{
    --bg-opacity:0.25
  }

  .sm\\:focus\\:bg-opacity-50:focus{
    --bg-opacity:0.5
  }

  .sm\\:focus\\:bg-opacity-75:focus{
    --bg-opacity:0.75
  }

  .sm\\:focus\\:bg-opacity-100:focus{
    --bg-opacity:1
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-opacity-0:hover{
    --bg-opacity:0
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-opacity-10:hover{
    --bg-opacity:0.1
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-opacity-25:hover{
    --bg-opacity:0.25
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-opacity-50:hover{
    --bg-opacity:0.5
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-opacity-75:hover{
    --bg-opacity:0.75
  }

  .theme-dark .sm\\:dark\\:hover\\:bg-opacity-100:hover{
    --bg-opacity:1
  }

  .sm\\:bg-bottom{
    background-position:bottom
  }

  .sm\\:bg-center{
    background-position:50%
  }

  .sm\\:bg-left{
    background-position:0
  }

  .sm\\:bg-left-bottom{
    background-position:0 100%
  }

  .sm\\:bg-left-top{
    background-position:0 0
  }

  .sm\\:bg-right{
    background-position:100%
  }

  .sm\\:bg-right-bottom{
    background-position:100% 100%
  }

  .sm\\:bg-right-top{
    background-position:100% 0
  }

  .sm\\:bg-top{
    background-position:top
  }

  .sm\\:bg-repeat{
    background-repeat:repeat
  }

  .sm\\:bg-no-repeat{
    background-repeat:no-repeat
  }

  .sm\\:bg-repeat-x{
    background-repeat:repeat-x
  }

  .sm\\:bg-repeat-y{
    background-repeat:repeat-y
  }

  .sm\\:bg-repeat-round{
    background-repeat:round
  }

  .sm\\:bg-repeat-space{
    background-repeat:space
  }

  .sm\\:bg-auto{
    background-size:auto
  }

  .sm\\:bg-cover{
    background-size:cover
  }

  .sm\\:bg-contain{
    background-size:contain
  }

  .sm\\:border-collapse{
    border-collapse:collapse
  }

  .sm\\:border-separate{
    border-collapse:initial
  }

  .sm\\:border-transparent{
    border-color:#0000
  }

  .sm\\:border-white{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .sm\\:border-black{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .sm\\:border-gray-50{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .sm\\:border-gray-100{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .sm\\:border-gray-200{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .sm\\:border-gray-300{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .sm\\:border-gray-400{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .sm\\:border-gray-500{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .sm\\:border-gray-600{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .sm\\:border-gray-700{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .sm\\:border-gray-800{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .sm\\:border-gray-900{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .sm\\:border-cool-gray-50{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .sm\\:border-cool-gray-100{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .sm\\:border-cool-gray-200{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .sm\\:border-cool-gray-300{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .sm\\:border-cool-gray-400{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .sm\\:border-cool-gray-500{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .sm\\:border-cool-gray-600{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .sm\\:border-cool-gray-700{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .sm\\:border-cool-gray-800{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .sm\\:border-cool-gray-900{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .sm\\:border-red-50{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .sm\\:border-red-100{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .sm\\:border-red-200{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .sm\\:border-red-300{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .sm\\:border-red-400{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .sm\\:border-red-500{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .sm\\:border-red-600{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .sm\\:border-red-700{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .sm\\:border-red-800{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .sm\\:border-red-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .sm\\:border-orange-50{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .sm\\:border-orange-100{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .sm\\:border-orange-200{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .sm\\:border-orange-300{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .sm\\:border-orange-400{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .sm\\:border-orange-500{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .sm\\:border-orange-600{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .sm\\:border-orange-700{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .sm\\:border-orange-800{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .sm\\:border-orange-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .sm\\:border-yellow-50{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .sm\\:border-yellow-100{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .sm\\:border-yellow-200{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .sm\\:border-yellow-300{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .sm\\:border-yellow-400{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .sm\\:border-yellow-500{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .sm\\:border-yellow-600{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .sm\\:border-yellow-700{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .sm\\:border-yellow-800{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .sm\\:border-yellow-900{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .sm\\:border-green-50{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .sm\\:border-green-100{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .sm\\:border-green-200{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .sm\\:border-green-300{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .sm\\:border-green-400{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .sm\\:border-green-500{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .sm\\:border-green-600{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .sm\\:border-green-700{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .sm\\:border-green-800{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .sm\\:border-green-900{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .sm\\:border-teal-50{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .sm\\:border-teal-100{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .sm\\:border-teal-200{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .sm\\:border-teal-300{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .sm\\:border-teal-400{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .sm\\:border-teal-500{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .sm\\:border-teal-600{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .sm\\:border-teal-700{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .sm\\:border-teal-800{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .sm\\:border-teal-900{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .sm\\:border-blue-50{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .sm\\:border-blue-100{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .sm\\:border-blue-200{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .sm\\:border-blue-300{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .sm\\:border-blue-400{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .sm\\:border-blue-500{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .sm\\:border-blue-600{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .sm\\:border-blue-700{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .sm\\:border-blue-800{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .sm\\:border-blue-900{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .sm\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .sm\\:border-indigo-100{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .sm\\:border-indigo-200{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .sm\\:border-indigo-300{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .sm\\:border-indigo-400{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .sm\\:border-indigo-500{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .sm\\:border-indigo-600{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .sm\\:border-indigo-700{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .sm\\:border-indigo-800{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .sm\\:border-indigo-900{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .sm\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .sm\\:border-indigo-100{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .sm\\:border-indigo-200{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .sm\\:border-indigo-300{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .sm\\:border-indigo-400{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .sm\\:border-indigo-500{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .sm\\:border-indigo-600{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .sm\\:border-indigo-700{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .sm\\:border-indigo-800{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .sm\\:border-indigo-900{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .sm\\:border-pink-50{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .sm\\:border-pink-100{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .sm\\:border-pink-200{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .sm\\:border-pink-300{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .sm\\:border-pink-400{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .sm\\:border-pink-500{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .sm\\:border-pink-600{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .sm\\:border-pink-700{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .sm\\:border-pink-800{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .sm\\:border-pink-900{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .sm\\:hover\\:border-transparent:hover{
    border-color:#0000
  }

  .sm\\:hover\\:border-white:hover{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .sm\\:hover\\:border-black:hover{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .sm\\:hover\\:border-gray-50:hover{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .sm\\:hover\\:border-gray-100:hover{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .sm\\:hover\\:border-gray-200:hover{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .sm\\:hover\\:border-gray-300:hover{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .sm\\:hover\\:border-gray-400:hover{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .sm\\:hover\\:border-gray-500:hover{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .sm\\:hover\\:border-gray-600:hover{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .sm\\:hover\\:border-gray-700:hover{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .sm\\:hover\\:border-gray-800:hover{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .sm\\:hover\\:border-gray-900:hover{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .sm\\:hover\\:border-cool-gray-50:hover{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .sm\\:hover\\:border-cool-gray-100:hover{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .sm\\:hover\\:border-cool-gray-200:hover{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .sm\\:hover\\:border-cool-gray-300:hover{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .sm\\:hover\\:border-cool-gray-400:hover{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .sm\\:hover\\:border-cool-gray-500:hover{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .sm\\:hover\\:border-cool-gray-600:hover{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .sm\\:hover\\:border-cool-gray-700:hover{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .sm\\:hover\\:border-cool-gray-800:hover{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .sm\\:hover\\:border-cool-gray-900:hover{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .sm\\:hover\\:border-red-50:hover{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .sm\\:hover\\:border-red-100:hover{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .sm\\:hover\\:border-red-200:hover{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .sm\\:hover\\:border-red-300:hover{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .sm\\:hover\\:border-red-400:hover{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .sm\\:hover\\:border-red-500:hover{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .sm\\:hover\\:border-red-600:hover{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .sm\\:hover\\:border-red-700:hover{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .sm\\:hover\\:border-red-800:hover{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .sm\\:hover\\:border-red-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .sm\\:hover\\:border-orange-50:hover{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .sm\\:hover\\:border-orange-100:hover{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .sm\\:hover\\:border-orange-200:hover{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .sm\\:hover\\:border-orange-300:hover{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .sm\\:hover\\:border-orange-400:hover{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .sm\\:hover\\:border-orange-500:hover{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .sm\\:hover\\:border-orange-600:hover{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .sm\\:hover\\:border-orange-700:hover{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .sm\\:hover\\:border-orange-800:hover{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .sm\\:hover\\:border-orange-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .sm\\:hover\\:border-yellow-50:hover{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .sm\\:hover\\:border-yellow-100:hover{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .sm\\:hover\\:border-yellow-200:hover{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .sm\\:hover\\:border-yellow-300:hover{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .sm\\:hover\\:border-yellow-400:hover{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .sm\\:hover\\:border-yellow-500:hover{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .sm\\:hover\\:border-yellow-600:hover{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .sm\\:hover\\:border-yellow-700:hover{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .sm\\:hover\\:border-yellow-800:hover{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .sm\\:hover\\:border-yellow-900:hover{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .sm\\:hover\\:border-green-50:hover{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .sm\\:hover\\:border-green-100:hover{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .sm\\:hover\\:border-green-200:hover{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .sm\\:hover\\:border-green-300:hover{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .sm\\:hover\\:border-green-400:hover{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .sm\\:hover\\:border-green-500:hover{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .sm\\:hover\\:border-green-600:hover{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .sm\\:hover\\:border-green-700:hover{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .sm\\:hover\\:border-green-800:hover{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .sm\\:hover\\:border-green-900:hover{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .sm\\:hover\\:border-teal-50:hover{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .sm\\:hover\\:border-teal-100:hover{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .sm\\:hover\\:border-teal-200:hover{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .sm\\:hover\\:border-teal-300:hover{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .sm\\:hover\\:border-teal-400:hover{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .sm\\:hover\\:border-teal-500:hover{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .sm\\:hover\\:border-teal-600:hover{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .sm\\:hover\\:border-teal-700:hover{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .sm\\:hover\\:border-teal-800:hover{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .sm\\:hover\\:border-teal-900:hover{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .sm\\:hover\\:border-blue-50:hover{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .sm\\:hover\\:border-blue-100:hover{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .sm\\:hover\\:border-blue-200:hover{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .sm\\:hover\\:border-blue-300:hover{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .sm\\:hover\\:border-blue-400:hover{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .sm\\:hover\\:border-blue-500:hover{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .sm\\:hover\\:border-blue-600:hover{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .sm\\:hover\\:border-blue-700:hover{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .sm\\:hover\\:border-blue-800:hover{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .sm\\:hover\\:border-blue-900:hover{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .sm\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .sm\\:hover\\:border-pink-50:hover{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .sm\\:hover\\:border-pink-100:hover{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .sm\\:hover\\:border-pink-200:hover{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .sm\\:hover\\:border-pink-300:hover{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .sm\\:hover\\:border-pink-400:hover{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .sm\\:hover\\:border-pink-500:hover{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .sm\\:hover\\:border-pink-600:hover{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .sm\\:hover\\:border-pink-700:hover{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .sm\\:hover\\:border-pink-800:hover{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .sm\\:hover\\:border-pink-900:hover{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .sm\\:focus\\:border-transparent:focus{
    border-color:#0000
  }

  .sm\\:focus\\:border-white:focus{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .sm\\:focus\\:border-black:focus{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .sm\\:focus\\:border-gray-50:focus{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .sm\\:focus\\:border-gray-100:focus{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .sm\\:focus\\:border-gray-200:focus{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .sm\\:focus\\:border-gray-300:focus{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .sm\\:focus\\:border-gray-400:focus{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .sm\\:focus\\:border-gray-500:focus{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .sm\\:focus\\:border-gray-600:focus{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .sm\\:focus\\:border-gray-700:focus{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .sm\\:focus\\:border-gray-800:focus{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .sm\\:focus\\:border-gray-900:focus{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .sm\\:focus\\:border-cool-gray-50:focus{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .sm\\:focus\\:border-cool-gray-100:focus{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .sm\\:focus\\:border-cool-gray-200:focus{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .sm\\:focus\\:border-cool-gray-300:focus{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .sm\\:focus\\:border-cool-gray-400:focus{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .sm\\:focus\\:border-cool-gray-500:focus{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .sm\\:focus\\:border-cool-gray-600:focus{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .sm\\:focus\\:border-cool-gray-700:focus{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .sm\\:focus\\:border-cool-gray-800:focus{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .sm\\:focus\\:border-cool-gray-900:focus{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .sm\\:focus\\:border-red-50:focus{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .sm\\:focus\\:border-red-100:focus{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .sm\\:focus\\:border-red-200:focus{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .sm\\:focus\\:border-red-300:focus{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .sm\\:focus\\:border-red-400:focus{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .sm\\:focus\\:border-red-500:focus{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .sm\\:focus\\:border-red-600:focus{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .sm\\:focus\\:border-red-700:focus{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .sm\\:focus\\:border-red-800:focus{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .sm\\:focus\\:border-red-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .sm\\:focus\\:border-orange-50:focus{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .sm\\:focus\\:border-orange-100:focus{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .sm\\:focus\\:border-orange-200:focus{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .sm\\:focus\\:border-orange-300:focus{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .sm\\:focus\\:border-orange-400:focus{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .sm\\:focus\\:border-orange-500:focus{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .sm\\:focus\\:border-orange-600:focus{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .sm\\:focus\\:border-orange-700:focus{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .sm\\:focus\\:border-orange-800:focus{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .sm\\:focus\\:border-orange-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .sm\\:focus\\:border-yellow-50:focus{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .sm\\:focus\\:border-yellow-100:focus{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .sm\\:focus\\:border-yellow-200:focus{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .sm\\:focus\\:border-yellow-300:focus{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .sm\\:focus\\:border-yellow-400:focus{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .sm\\:focus\\:border-yellow-500:focus{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .sm\\:focus\\:border-yellow-600:focus{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .sm\\:focus\\:border-yellow-700:focus{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .sm\\:focus\\:border-yellow-800:focus{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .sm\\:focus\\:border-yellow-900:focus{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .sm\\:focus\\:border-green-50:focus{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .sm\\:focus\\:border-green-100:focus{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .sm\\:focus\\:border-green-200:focus{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .sm\\:focus\\:border-green-300:focus{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .sm\\:focus\\:border-green-400:focus{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .sm\\:focus\\:border-green-500:focus{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .sm\\:focus\\:border-green-600:focus{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .sm\\:focus\\:border-green-700:focus{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .sm\\:focus\\:border-green-800:focus{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .sm\\:focus\\:border-green-900:focus{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .sm\\:focus\\:border-teal-50:focus{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .sm\\:focus\\:border-teal-100:focus{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .sm\\:focus\\:border-teal-200:focus{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .sm\\:focus\\:border-teal-300:focus{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .sm\\:focus\\:border-teal-400:focus{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .sm\\:focus\\:border-teal-500:focus{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .sm\\:focus\\:border-teal-600:focus{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .sm\\:focus\\:border-teal-700:focus{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .sm\\:focus\\:border-teal-800:focus{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .sm\\:focus\\:border-teal-900:focus{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .sm\\:focus\\:border-blue-50:focus{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .sm\\:focus\\:border-blue-100:focus{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .sm\\:focus\\:border-blue-200:focus{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .sm\\:focus\\:border-blue-300:focus{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .sm\\:focus\\:border-blue-400:focus{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .sm\\:focus\\:border-blue-500:focus{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .sm\\:focus\\:border-blue-600:focus{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .sm\\:focus\\:border-blue-700:focus{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .sm\\:focus\\:border-blue-800:focus{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .sm\\:focus\\:border-blue-900:focus{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .sm\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .sm\\:focus\\:border-pink-50:focus{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .sm\\:focus\\:border-pink-100:focus{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .sm\\:focus\\:border-pink-200:focus{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .sm\\:focus\\:border-pink-300:focus{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .sm\\:focus\\:border-pink-400:focus{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .sm\\:focus\\:border-pink-500:focus{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .sm\\:focus\\:border-pink-600:focus{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .sm\\:focus\\:border-pink-700:focus{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .sm\\:focus\\:border-pink-800:focus{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .sm\\:focus\\:border-pink-900:focus{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-transparent{
    border-color:#0000
  }

  .theme-dark .sm\\:dark\\:border-white{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-black{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-gray-50{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-gray-100{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-gray-200{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-gray-300{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-gray-400{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-gray-500{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-gray-600{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-gray-700{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-gray-800{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-gray-900{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-cool-gray-50{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-cool-gray-100{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-cool-gray-200{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-cool-gray-300{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-cool-gray-400{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-cool-gray-500{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-cool-gray-600{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-cool-gray-700{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-cool-gray-800{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-cool-gray-900{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-red-50{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-red-100{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-red-200{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-red-300{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-red-400{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-red-500{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-red-600{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-red-700{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-red-800{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-red-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-orange-50{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-orange-100{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-orange-200{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-orange-300{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-orange-400{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-orange-500{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-orange-600{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-orange-700{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-orange-800{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-orange-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-yellow-50{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-yellow-100{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-yellow-200{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-yellow-300{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-yellow-400{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-yellow-500{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-yellow-600{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-yellow-700{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-yellow-800{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-yellow-900{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-green-50{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-green-100{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-green-200{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-green-300{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-green-400{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-green-500{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-green-600{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-green-700{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-green-800{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-green-900{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-teal-50{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-teal-100{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-teal-200{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-teal-300{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-teal-400{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-teal-500{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-teal-600{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-teal-700{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-teal-800{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-teal-900{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-blue-50{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-blue-100{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-blue-200{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-blue-300{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-blue-400{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-blue-500{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-blue-600{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-blue-700{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-blue-800{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-blue-900{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-100{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-200{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-300{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-400{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-500{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-600{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-700{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-800{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-900{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-100{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-200{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-300{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-400{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-500{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-600{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-700{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-800{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-indigo-900{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-pink-50{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-pink-100{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-pink-200{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-pink-300{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-pink-400{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-pink-500{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-pink-600{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-pink-700{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-pink-800{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:border-pink-900{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-transparent:focus{
    border-color:#0000
  }

  .theme-dark .sm\\:dark\\:focus\\:border-white:focus{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-black:focus{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-gray-50:focus{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-gray-100:focus{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-gray-200:focus{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-gray-300:focus{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-gray-400:focus{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-gray-500:focus{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-gray-600:focus{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-gray-700:focus{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-gray-800:focus{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-gray-900:focus{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-cool-gray-50:focus{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-cool-gray-100:focus{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-cool-gray-200:focus{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-cool-gray-300:focus{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-cool-gray-400:focus{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-cool-gray-500:focus{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-cool-gray-600:focus{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-cool-gray-700:focus{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-cool-gray-800:focus{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-cool-gray-900:focus{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-red-50:focus{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-red-100:focus{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-red-200:focus{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-red-300:focus{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-red-400:focus{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-red-500:focus{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-red-600:focus{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-red-700:focus{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-red-800:focus{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-red-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-orange-50:focus{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-orange-100:focus{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-orange-200:focus{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-orange-300:focus{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-orange-400:focus{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-orange-500:focus{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-orange-600:focus{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-orange-700:focus{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-orange-800:focus{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-orange-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-yellow-50:focus{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-yellow-100:focus{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-yellow-200:focus{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-yellow-300:focus{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-yellow-400:focus{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-yellow-500:focus{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-yellow-600:focus{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-yellow-700:focus{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-yellow-800:focus{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-yellow-900:focus{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-green-50:focus{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-green-100:focus{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-green-200:focus{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-green-300:focus{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-green-400:focus{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-green-500:focus{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-green-600:focus{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-green-700:focus{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-green-800:focus{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-green-900:focus{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-teal-50:focus{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-teal-100:focus{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-teal-200:focus{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-teal-300:focus{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-teal-400:focus{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-teal-500:focus{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-teal-600:focus{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-teal-700:focus{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-teal-800:focus{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-teal-900:focus{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-blue-50:focus{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-blue-100:focus{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-blue-200:focus{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-blue-300:focus{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-blue-400:focus{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-blue-500:focus{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-blue-600:focus{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-blue-700:focus{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-blue-800:focus{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-blue-900:focus{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-pink-50:focus{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-pink-100:focus{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-pink-200:focus{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-pink-300:focus{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-pink-400:focus{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-pink-500:focus{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-pink-600:focus{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-pink-700:focus{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-pink-800:focus{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:border-pink-900:focus{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-transparent:hover{
    border-color:#0000
  }

  .theme-dark .sm\\:dark\\:hover\\:border-white:hover{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-black:hover{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-gray-50:hover{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-gray-100:hover{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-gray-200:hover{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-gray-300:hover{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-gray-400:hover{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-gray-500:hover{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-gray-600:hover{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-gray-700:hover{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-gray-800:hover{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-gray-900:hover{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-cool-gray-50:hover{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-cool-gray-100:hover{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-cool-gray-200:hover{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-cool-gray-300:hover{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-cool-gray-400:hover{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-cool-gray-500:hover{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-cool-gray-600:hover{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-cool-gray-700:hover{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-cool-gray-800:hover{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-cool-gray-900:hover{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-red-50:hover{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-red-100:hover{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-red-200:hover{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-red-300:hover{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-red-400:hover{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-red-500:hover{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-red-600:hover{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-red-700:hover{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-red-800:hover{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-red-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-orange-50:hover{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-orange-100:hover{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-orange-200:hover{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-orange-300:hover{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-orange-400:hover{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-orange-500:hover{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-orange-600:hover{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-orange-700:hover{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-orange-800:hover{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-orange-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-yellow-50:hover{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-yellow-100:hover{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-yellow-200:hover{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-yellow-300:hover{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-yellow-400:hover{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-yellow-500:hover{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-yellow-600:hover{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-yellow-700:hover{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-yellow-800:hover{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-yellow-900:hover{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-green-50:hover{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-green-100:hover{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-green-200:hover{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-green-300:hover{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-green-400:hover{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-green-500:hover{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-green-600:hover{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-green-700:hover{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-green-800:hover{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-green-900:hover{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-teal-50:hover{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-teal-100:hover{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-teal-200:hover{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-teal-300:hover{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-teal-400:hover{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-teal-500:hover{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-teal-600:hover{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-teal-700:hover{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-teal-800:hover{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-teal-900:hover{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-blue-50:hover{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-blue-100:hover{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-blue-200:hover{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-blue-300:hover{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-blue-400:hover{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-blue-500:hover{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-blue-600:hover{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-blue-700:hover{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-blue-800:hover{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-blue-900:hover{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-pink-50:hover{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-pink-100:hover{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-pink-200:hover{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-pink-300:hover{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-pink-400:hover{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-pink-500:hover{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-pink-600:hover{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-pink-700:hover{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-pink-800:hover{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:border-pink-900:hover{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .sm\\:border-opacity-0{
    --border-opacity:0
  }

  .sm\\:border-opacity-25{
    --border-opacity:0.25
  }

  .sm\\:border-opacity-50{
    --border-opacity:0.5
  }

  .sm\\:border-opacity-75{
    --border-opacity:0.75
  }

  .sm\\:border-opacity-100{
    --border-opacity:1
  }

  .sm\\:hover\\:border-opacity-0:hover{
    --border-opacity:0
  }

  .sm\\:hover\\:border-opacity-25:hover{
    --border-opacity:0.25
  }

  .sm\\:hover\\:border-opacity-50:hover{
    --border-opacity:0.5
  }

  .sm\\:hover\\:border-opacity-75:hover{
    --border-opacity:0.75
  }

  .sm\\:hover\\:border-opacity-100:hover{
    --border-opacity:1
  }

  .sm\\:focus\\:border-opacity-0:focus{
    --border-opacity:0
  }

  .sm\\:focus\\:border-opacity-25:focus{
    --border-opacity:0.25
  }

  .sm\\:focus\\:border-opacity-50:focus{
    --border-opacity:0.5
  }

  .sm\\:focus\\:border-opacity-75:focus{
    --border-opacity:0.75
  }

  .sm\\:focus\\:border-opacity-100:focus{
    --border-opacity:1
  }

  .sm\\:rounded-none{
    border-radius:0
  }

  .sm\\:rounded-sm{
    border-radius:.125rem
  }

  .sm\\:rounded{
    border-radius:.25rem
  }

  .sm\\:rounded-md{
    border-radius:.375rem
  }

  .sm\\:rounded-lg{
    border-radius:.5rem
  }

  .sm\\:rounded-full{
    border-radius:9999px
  }

  .sm\\:rounded-t-none{
    border-top-left-radius:0;
    border-top-right-radius:0
  }

  .sm\\:rounded-r-none{
    border-bottom-right-radius:0;
    border-top-right-radius:0
  }

  .sm\\:rounded-b-none{
    border-bottom-left-radius:0;
    border-bottom-right-radius:0
  }

  .sm\\:rounded-l-none{
    border-bottom-left-radius:0;
    border-top-left-radius:0
  }

  .sm\\:rounded-t-sm{
    border-top-left-radius:.125rem;
    border-top-right-radius:.125rem
  }

  .sm\\:rounded-r-sm{
    border-bottom-right-radius:.125rem;
    border-top-right-radius:.125rem
  }

  .sm\\:rounded-b-sm{
    border-bottom-left-radius:.125rem;
    border-bottom-right-radius:.125rem
  }

  .sm\\:rounded-l-sm{
    border-bottom-left-radius:.125rem;
    border-top-left-radius:.125rem
  }

  .sm\\:rounded-t{
    border-top-left-radius:.25rem
  }

  .sm\\:rounded-r,.sm\\:rounded-t{
    border-top-right-radius:.25rem
  }

  .sm\\:rounded-b,.sm\\:rounded-r{
    border-bottom-right-radius:.25rem
  }

  .sm\\:rounded-b,.sm\\:rounded-l{
    border-bottom-left-radius:.25rem
  }

  .sm\\:rounded-l{
    border-top-left-radius:.25rem
  }

  .sm\\:rounded-t-md{
    border-top-left-radius:.375rem;
    border-top-right-radius:.375rem
  }

  .sm\\:rounded-r-md{
    border-bottom-right-radius:.375rem;
    border-top-right-radius:.375rem
  }

  .sm\\:rounded-b-md{
    border-bottom-left-radius:.375rem;
    border-bottom-right-radius:.375rem
  }

  .sm\\:rounded-l-md{
    border-bottom-left-radius:.375rem;
    border-top-left-radius:.375rem
  }

  .sm\\:rounded-t-lg{
    border-top-left-radius:.5rem;
    border-top-right-radius:.5rem
  }

  .sm\\:rounded-r-lg{
    border-bottom-right-radius:.5rem;
    border-top-right-radius:.5rem
  }

  .sm\\:rounded-b-lg{
    border-bottom-left-radius:.5rem;
    border-bottom-right-radius:.5rem
  }

  .sm\\:rounded-l-lg{
    border-bottom-left-radius:.5rem;
    border-top-left-radius:.5rem
  }

  .sm\\:rounded-t-full{
    border-top-left-radius:9999px;
    border-top-right-radius:9999px
  }

  .sm\\:rounded-r-full{
    border-bottom-right-radius:9999px;
    border-top-right-radius:9999px
  }

  .sm\\:rounded-b-full{
    border-bottom-left-radius:9999px;
    border-bottom-right-radius:9999px
  }

  .sm\\:rounded-l-full{
    border-bottom-left-radius:9999px;
    border-top-left-radius:9999px
  }

  .sm\\:rounded-tl-none{
    border-top-left-radius:0
  }

  .sm\\:rounded-tr-none{
    border-top-right-radius:0
  }

  .sm\\:rounded-br-none{
    border-bottom-right-radius:0
  }

  .sm\\:rounded-bl-none{
    border-bottom-left-radius:0
  }

  .sm\\:rounded-tl-sm{
    border-top-left-radius:.125rem
  }

  .sm\\:rounded-tr-sm{
    border-top-right-radius:.125rem
  }

  .sm\\:rounded-br-sm{
    border-bottom-right-radius:.125rem
  }

  .sm\\:rounded-bl-sm{
    border-bottom-left-radius:.125rem
  }

  .sm\\:rounded-tl{
    border-top-left-radius:.25rem
  }

  .sm\\:rounded-tr{
    border-top-right-radius:.25rem
  }

  .sm\\:rounded-br{
    border-bottom-right-radius:.25rem
  }

  .sm\\:rounded-bl{
    border-bottom-left-radius:.25rem
  }

  .sm\\:rounded-tl-md{
    border-top-left-radius:.375rem
  }

  .sm\\:rounded-tr-md{
    border-top-right-radius:.375rem
  }

  .sm\\:rounded-br-md{
    border-bottom-right-radius:.375rem
  }

  .sm\\:rounded-bl-md{
    border-bottom-left-radius:.375rem
  }

  .sm\\:rounded-tl-lg{
    border-top-left-radius:.5rem
  }

  .sm\\:rounded-tr-lg{
    border-top-right-radius:.5rem
  }

  .sm\\:rounded-br-lg{
    border-bottom-right-radius:.5rem
  }

  .sm\\:rounded-bl-lg{
    border-bottom-left-radius:.5rem
  }

  .sm\\:rounded-tl-full{
    border-top-left-radius:9999px
  }

  .sm\\:rounded-tr-full{
    border-top-right-radius:9999px
  }

  .sm\\:rounded-br-full{
    border-bottom-right-radius:9999px
  }

  .sm\\:rounded-bl-full{
    border-bottom-left-radius:9999px
  }

  .sm\\:border-solid{
    border-style:solid
  }

  .sm\\:border-dashed{
    border-style:dashed
  }

  .sm\\:border-dotted{
    border-style:dotted
  }

  .sm\\:border-double{
    border-style:double
  }

  .sm\\:border-none{
    border-style:none
  }

  .sm\\:border-0{
    border-width:0
  }

  .sm\\:border-2{
    border-width:2px
  }

  .sm\\:border-4{
    border-width:4px
  }

  .sm\\:border-8{
    border-width:8px
  }

  .sm\\:border{
    border-width:1px
  }

  .sm\\:border-t-0{
    border-top-width:0
  }

  .sm\\:border-r-0{
    border-right-width:0
  }

  .sm\\:border-b-0{
    border-bottom-width:0
  }

  .sm\\:border-l-0{
    border-left-width:0
  }

  .sm\\:border-t-2{
    border-top-width:2px
  }

  .sm\\:border-r-2{
    border-right-width:2px
  }

  .sm\\:border-b-2{
    border-bottom-width:2px
  }

  .sm\\:border-l-2{
    border-left-width:2px
  }

  .sm\\:border-t-4{
    border-top-width:4px
  }

  .sm\\:border-r-4{
    border-right-width:4px
  }

  .sm\\:border-b-4{
    border-bottom-width:4px
  }

  .sm\\:border-l-4{
    border-left-width:4px
  }

  .sm\\:border-t-8{
    border-top-width:8px
  }

  .sm\\:border-r-8{
    border-right-width:8px
  }

  .sm\\:border-b-8{
    border-bottom-width:8px
  }

  .sm\\:border-l-8{
    border-left-width:8px
  }

  .sm\\:border-t{
    border-top-width:1px
  }

  .sm\\:border-r{
    border-right-width:1px
  }

  .sm\\:border-b{
    border-bottom-width:1px
  }

  .sm\\:border-l{
    border-left-width:1px
  }

  .sm\\:box-border{
    box-sizing:border-box
  }

  .sm\\:box-content{
    box-sizing:initial
  }

  .sm\\:cursor-auto{
    cursor:auto
  }

  .sm\\:cursor-default{
    cursor:default
  }

  .sm\\:cursor-pointer{
    cursor:pointer
  }

  .sm\\:cursor-wait{
    cursor:wait
  }

  .sm\\:cursor-text{
    cursor:text
  }

  .sm\\:cursor-move{
    cursor:move
  }

  .sm\\:cursor-not-allowed{
    cursor:not-allowed
  }

  .sm\\:block{
    display:block
  }

  .sm\\:inline-block{
    display:inline-block
  }

  .sm\\:inline{
    display:inline
  }

  .sm\\:flex{
    display:flex
  }

  .sm\\:inline-flex{
    display:inline-flex
  }

  .sm\\:table{
    display:table
  }

  .sm\\:table-caption{
    display:table-caption
  }

  .sm\\:table-cell{
    display:table-cell
  }

  .sm\\:table-column{
    display:table-column
  }

  .sm\\:table-column-group{
    display:table-column-group
  }

  .sm\\:table-footer-group{
    display:table-footer-group
  }

  .sm\\:table-header-group{
    display:table-header-group
  }

  .sm\\:table-row-group{
    display:table-row-group
  }

  .sm\\:table-row{
    display:table-row
  }

  .sm\\:flow-root{
    display:flow-root
  }

  .sm\\:grid{
    display:grid
  }

  .sm\\:inline-grid{
    display:inline-grid
  }

  .sm\\:hidden{
    display:none
  }

  .theme-dark .sm\\:dark\\:block{
    display:block
  }

  .theme-dark .sm\\:dark\\:inline-block{
    display:inline-block
  }

  .theme-dark .sm\\:dark\\:inline{
    display:inline
  }

  .theme-dark .sm\\:dark\\:flex{
    display:flex
  }

  .theme-dark .sm\\:dark\\:inline-flex{
    display:inline-flex
  }

  .theme-dark .sm\\:dark\\:table{
    display:table
  }

  .theme-dark .sm\\:dark\\:table-caption{
    display:table-caption
  }

  .theme-dark .sm\\:dark\\:table-cell{
    display:table-cell
  }

  .theme-dark .sm\\:dark\\:table-column{
    display:table-column
  }

  .theme-dark .sm\\:dark\\:table-column-group{
    display:table-column-group
  }

  .theme-dark .sm\\:dark\\:table-footer-group{
    display:table-footer-group
  }

  .theme-dark .sm\\:dark\\:table-header-group{
    display:table-header-group
  }

  .theme-dark .sm\\:dark\\:table-row-group{
    display:table-row-group
  }

  .theme-dark .sm\\:dark\\:table-row{
    display:table-row
  }

  .theme-dark .sm\\:dark\\:flow-root{
    display:flow-root
  }

  .theme-dark .sm\\:dark\\:grid{
    display:grid
  }

  .theme-dark .sm\\:dark\\:inline-grid{
    display:inline-grid
  }

  .theme-dark .sm\\:dark\\:hidden{
    display:none
  }

  .sm\\:flex-row{
    flex-direction:row
  }

  .sm\\:flex-row-reverse{
    flex-direction:row-reverse
  }

  .sm\\:flex-col{
    flex-direction:column
  }

  .sm\\:flex-col-reverse{
    flex-direction:column-reverse
  }

  .sm\\:flex-wrap{
    flex-wrap:wrap
  }

  .sm\\:flex-wrap-reverse{
    flex-wrap:wrap-reverse
  }

  .sm\\:flex-no-wrap{
    flex-wrap:nowrap
  }

  .sm\\:items-start{
    align-items:flex-start
  }

  .sm\\:items-end{
    align-items:flex-end
  }

  .sm\\:items-center{
    align-items:center
  }

  .sm\\:items-baseline{
    align-items:baseline
  }

  .sm\\:items-stretch{
    align-items:stretch
  }

  .sm\\:self-auto{
    align-self:auto
  }

  .sm\\:self-start{
    align-self:flex-start
  }

  .sm\\:self-end{
    align-self:flex-end
  }

  .sm\\:self-center{
    align-self:center
  }

  .sm\\:self-stretch{
    align-self:stretch
  }

  .sm\\:justify-start{
    justify-content:flex-start
  }

  .sm\\:justify-end{
    justify-content:flex-end
  }

  .sm\\:justify-center{
    justify-content:center
  }

  .sm\\:justify-between{
    justify-content:space-between
  }

  .sm\\:justify-around{
    justify-content:space-around
  }

  .sm\\:justify-evenly{
    justify-content:space-evenly
  }

  .sm\\:content-center{
    align-content:center
  }

  .sm\\:content-start{
    align-content:flex-start
  }

  .sm\\:content-end{
    align-content:flex-end
  }

  .sm\\:content-between{
    align-content:space-between
  }

  .sm\\:content-around{
    align-content:space-around
  }

  .sm\\:flex-1{
    flex:1 1
  }

  .sm\\:flex-auto{
    flex:1 1 auto
  }

  .sm\\:flex-initial{
    flex:0 1 auto
  }

  .sm\\:flex-none{
    flex:none
  }

  .sm\\:flex-grow-0{
    flex-grow:0
  }

  .sm\\:flex-grow{
    flex-grow:1
  }

  .sm\\:flex-shrink-0{
    flex-shrink:0
  }

  .sm\\:flex-shrink{
    flex-shrink:1
  }

  .sm\\:order-1{
    order:1
  }

  .sm\\:order-2{
    order:2
  }

  .sm\\:order-3{
    order:3
  }

  .sm\\:order-4{
    order:4
  }

  .sm\\:order-5{
    order:5
  }

  .sm\\:order-6{
    order:6
  }

  .sm\\:order-7{
    order:7
  }

  .sm\\:order-8{
    order:8
  }

  .sm\\:order-9{
    order:9
  }

  .sm\\:order-10{
    order:10
  }

  .sm\\:order-11{
    order:11
  }

  .sm\\:order-12{
    order:12
  }

  .sm\\:order-first{
    order:-9999
  }

  .sm\\:order-last{
    order:9999
  }

  .sm\\:order-none{
    order:0
  }

  .sm\\:float-right{
    float:right
  }

  .sm\\:float-left{
    float:left
  }

  .sm\\:float-none{
    float:none
  }

  .sm\\:clearfix:after{
    clear:both;
    content:"";
    display:table
  }

  .sm\\:clear-left{
    clear:left
  }

  .sm\\:clear-right{
    clear:right
  }

  .sm\\:clear-both{
    clear:both
  }

  .sm\\:clear-none{
    clear:none
  }

  .sm\\:font-sans{
    font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji
  }

  .sm\\:font-serif{
    font-family:Georgia,Cambria,Times New Roman,Times,serif
  }

  .sm\\:font-mono{
    font-family:Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace
  }

  .sm\\:font-hairline{
    font-weight:100
  }

  .sm\\:font-thin{
    font-weight:200
  }

  .sm\\:font-light{
    font-weight:300
  }

  .sm\\:font-normal{
    font-weight:400
  }

  .sm\\:font-medium{
    font-weight:500
  }

  .sm\\:font-semibold{
    font-weight:600
  }

  .sm\\:font-bold{
    font-weight:700
  }

  .sm\\:font-extrabold{
    font-weight:800
  }

  .sm\\:font-black{
    font-weight:900
  }

  .sm\\:hover\\:font-hairline:hover{
    font-weight:100
  }

  .sm\\:hover\\:font-thin:hover{
    font-weight:200
  }

  .sm\\:hover\\:font-light:hover{
    font-weight:300
  }

  .sm\\:hover\\:font-normal:hover{
    font-weight:400
  }

  .sm\\:hover\\:font-medium:hover{
    font-weight:500
  }

  .sm\\:hover\\:font-semibold:hover{
    font-weight:600
  }

  .sm\\:hover\\:font-bold:hover{
    font-weight:700
  }

  .sm\\:hover\\:font-extrabold:hover{
    font-weight:800
  }

  .sm\\:hover\\:font-black:hover{
    font-weight:900
  }

  .sm\\:focus\\:font-hairline:focus{
    font-weight:100
  }

  .sm\\:focus\\:font-thin:focus{
    font-weight:200
  }

  .sm\\:focus\\:font-light:focus{
    font-weight:300
  }

  .sm\\:focus\\:font-normal:focus{
    font-weight:400
  }

  .sm\\:focus\\:font-medium:focus{
    font-weight:500
  }

  .sm\\:focus\\:font-semibold:focus{
    font-weight:600
  }

  .sm\\:focus\\:font-bold:focus{
    font-weight:700
  }

  .sm\\:focus\\:font-extrabold:focus{
    font-weight:800
  }

  .sm\\:focus\\:font-black:focus{
    font-weight:900
  }

  .sm\\:h-0{
    height:0
  }

  .sm\\:h-1{
    height:.25rem
  }

  .sm\\:h-2{
    height:.5rem
  }

  .sm\\:h-3{
    height:.75rem
  }

  .sm\\:h-4{
    height:1rem
  }

  .sm\\:h-5{
    height:1.25rem
  }

  .sm\\:h-6{
    height:1.5rem
  }

  .sm\\:h-8{
    height:2rem
  }

  .sm\\:h-10{
    height:2.5rem
  }

  .sm\\:h-12{
    height:3rem
  }

  .sm\\:h-16{
    height:4rem
  }

  .sm\\:h-20{
    height:5rem
  }

  .sm\\:h-24{
    height:6rem
  }

  .sm\\:h-32{
    height:8rem
  }

  .sm\\:h-40{
    height:10rem
  }

  .sm\\:h-48{
    height:12rem
  }

  .sm\\:h-56{
    height:14rem
  }

  .sm\\:h-64{
    height:16rem
  }

  .sm\\:h-auto{
    height:auto
  }

  .sm\\:h-px{
    height:1px
  }

  .sm\\:h-full{
    height:100%
  }

  .sm\\:h-screen{
    height:100vh
  }

  .sm\\:text-xs{
    font-size:.75rem
  }

  .sm\\:text-sm{
    font-size:.875rem
  }

  .sm\\:text-base{
    font-size:1rem
  }

  .sm\\:text-lg{
    font-size:1.125rem
  }

  .sm\\:text-xl{
    font-size:1.25rem
  }

  .sm\\:text-2xl{
    font-size:1.5rem
  }

  .sm\\:text-3xl{
    font-size:1.875rem
  }

  .sm\\:text-4xl{
    font-size:2.25rem
  }

  .sm\\:text-5xl{
    font-size:3rem
  }

  .sm\\:text-6xl{
    font-size:4rem
  }

  .sm\\:leading-3{
    line-height:.75rem
  }

  .sm\\:leading-4{
    line-height:1rem
  }

  .sm\\:leading-5{
    line-height:1.25rem
  }

  .sm\\:leading-6{
    line-height:1.5rem
  }

  .sm\\:leading-7{
    line-height:1.75rem
  }

  .sm\\:leading-8{
    line-height:2rem
  }

  .sm\\:leading-9{
    line-height:2.25rem
  }

  .sm\\:leading-10{
    line-height:2.5rem
  }

  .sm\\:leading-none{
    line-height:1
  }

  .sm\\:leading-tight{
    line-height:1.25
  }

  .sm\\:leading-snug{
    line-height:1.375
  }

  .sm\\:leading-normal{
    line-height:1.5
  }

  .sm\\:leading-relaxed{
    line-height:1.625
  }

  .sm\\:leading-loose{
    line-height:2
  }

  .sm\\:list-inside{
    list-style-position:inside
  }

  .sm\\:list-outside{
    list-style-position:outside
  }

  .sm\\:list-none{
    list-style-type:none
  }

  .sm\\:list-disc{
    list-style-type:disc
  }

  .sm\\:list-decimal{
    list-style-type:decimal
  }

  .sm\\:m-0{
    margin:0
  }

  .sm\\:m-1{
    margin:.25rem
  }

  .sm\\:m-2{
    margin:.5rem
  }

  .sm\\:m-3{
    margin:.75rem
  }

  .sm\\:m-4{
    margin:1rem
  }

  .sm\\:m-5{
    margin:1.25rem
  }

  .sm\\:m-6{
    margin:1.5rem
  }

  .sm\\:m-8{
    margin:2rem
  }

  .sm\\:m-10{
    margin:2.5rem
  }

  .sm\\:m-12{
    margin:3rem
  }

  .sm\\:m-16{
    margin:4rem
  }

  .sm\\:m-20{
    margin:5rem
  }

  .sm\\:m-24{
    margin:6rem
  }

  .sm\\:m-32{
    margin:8rem
  }

  .sm\\:m-40{
    margin:10rem
  }

  .sm\\:m-48{
    margin:12rem
  }

  .sm\\:m-56{
    margin:14rem
  }

  .sm\\:m-64{
    margin:16rem
  }

  .sm\\:m-auto{
    margin:auto
  }

  .sm\\:m-px{
    margin:1px
  }

  .sm\\:-m-1{
    margin:-.25rem
  }

  .sm\\:-m-2{
    margin:-.5rem
  }

  .sm\\:-m-3{
    margin:-.75rem
  }

  .sm\\:-m-4{
    margin:-1rem
  }

  .sm\\:-m-5{
    margin:-1.25rem
  }

  .sm\\:-m-6{
    margin:-1.5rem
  }

  .sm\\:-m-8{
    margin:-2rem
  }

  .sm\\:-m-10{
    margin:-2.5rem
  }

  .sm\\:-m-12{
    margin:-3rem
  }

  .sm\\:-m-16{
    margin:-4rem
  }

  .sm\\:-m-20{
    margin:-5rem
  }

  .sm\\:-m-24{
    margin:-6rem
  }

  .sm\\:-m-32{
    margin:-8rem
  }

  .sm\\:-m-40{
    margin:-10rem
  }

  .sm\\:-m-48{
    margin:-12rem
  }

  .sm\\:-m-56{
    margin:-14rem
  }

  .sm\\:-m-64{
    margin:-16rem
  }

  .sm\\:-m-px{
    margin:-1px
  }

  .sm\\:my-0{
    margin-bottom:0;
    margin-top:0
  }

  .sm\\:mx-0{
    margin-left:0;
    margin-right:0
  }

  .sm\\:my-1{
    margin-bottom:.25rem;
    margin-top:.25rem
  }

  .sm\\:mx-1{
    margin-left:.25rem;
    margin-right:.25rem
  }

  .sm\\:my-2{
    margin-bottom:.5rem;
    margin-top:.5rem
  }

  .sm\\:mx-2{
    margin-left:.5rem;
    margin-right:.5rem
  }

  .sm\\:my-3{
    margin-bottom:.75rem;
    margin-top:.75rem
  }

  .sm\\:mx-3{
    margin-left:.75rem;
    margin-right:.75rem
  }

  .sm\\:my-4{
    margin-bottom:1rem;
    margin-top:1rem
  }

  .sm\\:mx-4{
    margin-left:1rem;
    margin-right:1rem
  }

  .sm\\:my-5{
    margin-bottom:1.25rem;
    margin-top:1.25rem
  }

  .sm\\:mx-5{
    margin-left:1.25rem;
    margin-right:1.25rem
  }

  .sm\\:my-6{
    margin-bottom:1.5rem;
    margin-top:1.5rem
  }

  .sm\\:mx-6{
    margin-left:1.5rem;
    margin-right:1.5rem
  }

  .sm\\:my-8{
    margin-bottom:2rem;
    margin-top:2rem
  }

  .sm\\:mx-8{
    margin-left:2rem;
    margin-right:2rem
  }

  .sm\\:my-10{
    margin-bottom:2.5rem;
    margin-top:2.5rem
  }

  .sm\\:mx-10{
    margin-left:2.5rem;
    margin-right:2.5rem
  }

  .sm\\:my-12{
    margin-bottom:3rem;
    margin-top:3rem
  }

  .sm\\:mx-12{
    margin-left:3rem;
    margin-right:3rem
  }

  .sm\\:my-16{
    margin-bottom:4rem;
    margin-top:4rem
  }

  .sm\\:mx-16{
    margin-left:4rem;
    margin-right:4rem
  }

  .sm\\:my-20{
    margin-bottom:5rem;
    margin-top:5rem
  }

  .sm\\:mx-20{
    margin-left:5rem;
    margin-right:5rem
  }

  .sm\\:my-24{
    margin-bottom:6rem;
    margin-top:6rem
  }

  .sm\\:mx-24{
    margin-left:6rem;
    margin-right:6rem
  }

  .sm\\:my-32{
    margin-bottom:8rem;
    margin-top:8rem
  }

  .sm\\:mx-32{
    margin-left:8rem;
    margin-right:8rem
  }

  .sm\\:my-40{
    margin-bottom:10rem;
    margin-top:10rem
  }

  .sm\\:mx-40{
    margin-left:10rem;
    margin-right:10rem
  }

  .sm\\:my-48{
    margin-bottom:12rem;
    margin-top:12rem
  }

  .sm\\:mx-48{
    margin-left:12rem;
    margin-right:12rem
  }

  .sm\\:my-56{
    margin-bottom:14rem;
    margin-top:14rem
  }

  .sm\\:mx-56{
    margin-left:14rem;
    margin-right:14rem
  }

  .sm\\:my-64{
    margin-bottom:16rem;
    margin-top:16rem
  }

  .sm\\:mx-64{
    margin-left:16rem;
    margin-right:16rem
  }

  .sm\\:my-auto{
    margin-bottom:auto;
    margin-top:auto
  }

  .sm\\:mx-auto{
    margin-left:auto;
    margin-right:auto
  }

  .sm\\:my-px{
    margin-bottom:1px;
    margin-top:1px
  }

  .sm\\:mx-px{
    margin-left:1px;
    margin-right:1px
  }

  .sm\\:-my-1{
    margin-bottom:-.25rem;
    margin-top:-.25rem
  }

  .sm\\:-mx-1{
    margin-left:-.25rem;
    margin-right:-.25rem
  }

  .sm\\:-my-2{
    margin-bottom:-.5rem;
    margin-top:-.5rem
  }

  .sm\\:-mx-2{
    margin-left:-.5rem;
    margin-right:-.5rem
  }

  .sm\\:-my-3{
    margin-bottom:-.75rem;
    margin-top:-.75rem
  }

  .sm\\:-mx-3{
    margin-left:-.75rem;
    margin-right:-.75rem
  }

  .sm\\:-my-4{
    margin-bottom:-1rem;
    margin-top:-1rem
  }

  .sm\\:-mx-4{
    margin-left:-1rem;
    margin-right:-1rem
  }

  .sm\\:-my-5{
    margin-bottom:-1.25rem;
    margin-top:-1.25rem
  }

  .sm\\:-mx-5{
    margin-left:-1.25rem;
    margin-right:-1.25rem
  }

  .sm\\:-my-6{
    margin-bottom:-1.5rem;
    margin-top:-1.5rem
  }

  .sm\\:-mx-6{
    margin-left:-1.5rem;
    margin-right:-1.5rem
  }

  .sm\\:-my-8{
    margin-bottom:-2rem;
    margin-top:-2rem
  }

  .sm\\:-mx-8{
    margin-left:-2rem;
    margin-right:-2rem
  }

  .sm\\:-my-10{
    margin-bottom:-2.5rem;
    margin-top:-2.5rem
  }

  .sm\\:-mx-10{
    margin-left:-2.5rem;
    margin-right:-2.5rem
  }

  .sm\\:-my-12{
    margin-bottom:-3rem;
    margin-top:-3rem
  }

  .sm\\:-mx-12{
    margin-left:-3rem;
    margin-right:-3rem
  }

  .sm\\:-my-16{
    margin-bottom:-4rem;
    margin-top:-4rem
  }

  .sm\\:-mx-16{
    margin-left:-4rem;
    margin-right:-4rem
  }

  .sm\\:-my-20{
    margin-bottom:-5rem;
    margin-top:-5rem
  }

  .sm\\:-mx-20{
    margin-left:-5rem;
    margin-right:-5rem
  }

  .sm\\:-my-24{
    margin-bottom:-6rem;
    margin-top:-6rem
  }

  .sm\\:-mx-24{
    margin-left:-6rem;
    margin-right:-6rem
  }

  .sm\\:-my-32{
    margin-bottom:-8rem;
    margin-top:-8rem
  }

  .sm\\:-mx-32{
    margin-left:-8rem;
    margin-right:-8rem
  }

  .sm\\:-my-40{
    margin-bottom:-10rem;
    margin-top:-10rem
  }

  .sm\\:-mx-40{
    margin-left:-10rem;
    margin-right:-10rem
  }

  .sm\\:-my-48{
    margin-bottom:-12rem;
    margin-top:-12rem
  }

  .sm\\:-mx-48{
    margin-left:-12rem;
    margin-right:-12rem
  }

  .sm\\:-my-56{
    margin-bottom:-14rem;
    margin-top:-14rem
  }

  .sm\\:-mx-56{
    margin-left:-14rem;
    margin-right:-14rem
  }

  .sm\\:-my-64{
    margin-bottom:-16rem;
    margin-top:-16rem
  }

  .sm\\:-mx-64{
    margin-left:-16rem;
    margin-right:-16rem
  }

  .sm\\:-my-px{
    margin-bottom:-1px;
    margin-top:-1px
  }

  .sm\\:-mx-px{
    margin-left:-1px;
    margin-right:-1px
  }

  .sm\\:mt-0{
    margin-top:0
  }

  .sm\\:mr-0{
    margin-right:0
  }

  .sm\\:mb-0{
    margin-bottom:0
  }

  .sm\\:ml-0{
    margin-left:0
  }

  .sm\\:mt-1{
    margin-top:.25rem
  }

  .sm\\:mr-1{
    margin-right:.25rem
  }

  .sm\\:mb-1{
    margin-bottom:.25rem
  }

  .sm\\:ml-1{
    margin-left:.25rem
  }

  .sm\\:mt-2{
    margin-top:.5rem
  }

  .sm\\:mr-2{
    margin-right:.5rem
  }

  .sm\\:mb-2{
    margin-bottom:.5rem
  }

  .sm\\:ml-2{
    margin-left:.5rem
  }

  .sm\\:mt-3{
    margin-top:.75rem
  }

  .sm\\:mr-3{
    margin-right:.75rem
  }

  .sm\\:mb-3{
    margin-bottom:.75rem
  }

  .sm\\:ml-3{
    margin-left:.75rem
  }

  .sm\\:mt-4{
    margin-top:1rem
  }

  .sm\\:mr-4{
    margin-right:1rem
  }

  .sm\\:mb-4{
    margin-bottom:1rem
  }

  .sm\\:ml-4{
    margin-left:1rem
  }

  .sm\\:mt-5{
    margin-top:1.25rem
  }

  .sm\\:mr-5{
    margin-right:1.25rem
  }

  .sm\\:mb-5{
    margin-bottom:1.25rem
  }

  .sm\\:ml-5{
    margin-left:1.25rem
  }

  .sm\\:mt-6{
    margin-top:1.5rem
  }

  .sm\\:mr-6{
    margin-right:1.5rem
  }

  .sm\\:mb-6{
    margin-bottom:1.5rem
  }

  .sm\\:ml-6{
    margin-left:1.5rem
  }

  .sm\\:mt-8{
    margin-top:2rem
  }

  .sm\\:mr-8{
    margin-right:2rem
  }

  .sm\\:mb-8{
    margin-bottom:2rem
  }

  .sm\\:ml-8{
    margin-left:2rem
  }

  .sm\\:mt-10{
    margin-top:2.5rem
  }

  .sm\\:mr-10{
    margin-right:2.5rem
  }

  .sm\\:mb-10{
    margin-bottom:2.5rem
  }

  .sm\\:ml-10{
    margin-left:2.5rem
  }

  .sm\\:mt-12{
    margin-top:3rem
  }

  .sm\\:mr-12{
    margin-right:3rem
  }

  .sm\\:mb-12{
    margin-bottom:3rem
  }

  .sm\\:ml-12{
    margin-left:3rem
  }

  .sm\\:mt-16{
    margin-top:4rem
  }

  .sm\\:mr-16{
    margin-right:4rem
  }

  .sm\\:mb-16{
    margin-bottom:4rem
  }

  .sm\\:ml-16{
    margin-left:4rem
  }

  .sm\\:mt-20{
    margin-top:5rem
  }

  .sm\\:mr-20{
    margin-right:5rem
  }

  .sm\\:mb-20{
    margin-bottom:5rem
  }

  .sm\\:ml-20{
    margin-left:5rem
  }

  .sm\\:mt-24{
    margin-top:6rem
  }

  .sm\\:mr-24{
    margin-right:6rem
  }

  .sm\\:mb-24{
    margin-bottom:6rem
  }

  .sm\\:ml-24{
    margin-left:6rem
  }

  .sm\\:mt-32{
    margin-top:8rem
  }

  .sm\\:mr-32{
    margin-right:8rem
  }

  .sm\\:mb-32{
    margin-bottom:8rem
  }

  .sm\\:ml-32{
    margin-left:8rem
  }

  .sm\\:mt-40{
    margin-top:10rem
  }

  .sm\\:mr-40{
    margin-right:10rem
  }

  .sm\\:mb-40{
    margin-bottom:10rem
  }

  .sm\\:ml-40{
    margin-left:10rem
  }

  .sm\\:mt-48{
    margin-top:12rem
  }

  .sm\\:mr-48{
    margin-right:12rem
  }

  .sm\\:mb-48{
    margin-bottom:12rem
  }

  .sm\\:ml-48{
    margin-left:12rem
  }

  .sm\\:mt-56{
    margin-top:14rem
  }

  .sm\\:mr-56{
    margin-right:14rem
  }

  .sm\\:mb-56{
    margin-bottom:14rem
  }

  .sm\\:ml-56{
    margin-left:14rem
  }

  .sm\\:mt-64{
    margin-top:16rem
  }

  .sm\\:mr-64{
    margin-right:16rem
  }

  .sm\\:mb-64{
    margin-bottom:16rem
  }

  .sm\\:ml-64{
    margin-left:16rem
  }

  .sm\\:mt-auto{
    margin-top:auto
  }

  .sm\\:mr-auto{
    margin-right:auto
  }

  .sm\\:mb-auto{
    margin-bottom:auto
  }

  .sm\\:ml-auto{
    margin-left:auto
  }

  .sm\\:mt-px{
    margin-top:1px
  }

  .sm\\:mr-px{
    margin-right:1px
  }

  .sm\\:mb-px{
    margin-bottom:1px
  }

  .sm\\:ml-px{
    margin-left:1px
  }

  .sm\\:-mt-1{
    margin-top:-.25rem
  }

  .sm\\:-mr-1{
    margin-right:-.25rem
  }

  .sm\\:-mb-1{
    margin-bottom:-.25rem
  }

  .sm\\:-ml-1{
    margin-left:-.25rem
  }

  .sm\\:-mt-2{
    margin-top:-.5rem
  }

  .sm\\:-mr-2{
    margin-right:-.5rem
  }

  .sm\\:-mb-2{
    margin-bottom:-.5rem
  }

  .sm\\:-ml-2{
    margin-left:-.5rem
  }

  .sm\\:-mt-3{
    margin-top:-.75rem
  }

  .sm\\:-mr-3{
    margin-right:-.75rem
  }

  .sm\\:-mb-3{
    margin-bottom:-.75rem
  }

  .sm\\:-ml-3{
    margin-left:-.75rem
  }

  .sm\\:-mt-4{
    margin-top:-1rem
  }

  .sm\\:-mr-4{
    margin-right:-1rem
  }

  .sm\\:-mb-4{
    margin-bottom:-1rem
  }

  .sm\\:-ml-4{
    margin-left:-1rem
  }

  .sm\\:-mt-5{
    margin-top:-1.25rem
  }

  .sm\\:-mr-5{
    margin-right:-1.25rem
  }

  .sm\\:-mb-5{
    margin-bottom:-1.25rem
  }

  .sm\\:-ml-5{
    margin-left:-1.25rem
  }

  .sm\\:-mt-6{
    margin-top:-1.5rem
  }

  .sm\\:-mr-6{
    margin-right:-1.5rem
  }

  .sm\\:-mb-6{
    margin-bottom:-1.5rem
  }

  .sm\\:-ml-6{
    margin-left:-1.5rem
  }

  .sm\\:-mt-8{
    margin-top:-2rem
  }

  .sm\\:-mr-8{
    margin-right:-2rem
  }

  .sm\\:-mb-8{
    margin-bottom:-2rem
  }

  .sm\\:-ml-8{
    margin-left:-2rem
  }

  .sm\\:-mt-10{
    margin-top:-2.5rem
  }

  .sm\\:-mr-10{
    margin-right:-2.5rem
  }

  .sm\\:-mb-10{
    margin-bottom:-2.5rem
  }

  .sm\\:-ml-10{
    margin-left:-2.5rem
  }

  .sm\\:-mt-12{
    margin-top:-3rem
  }

  .sm\\:-mr-12{
    margin-right:-3rem
  }

  .sm\\:-mb-12{
    margin-bottom:-3rem
  }

  .sm\\:-ml-12{
    margin-left:-3rem
  }

  .sm\\:-mt-16{
    margin-top:-4rem
  }

  .sm\\:-mr-16{
    margin-right:-4rem
  }

  .sm\\:-mb-16{
    margin-bottom:-4rem
  }

  .sm\\:-ml-16{
    margin-left:-4rem
  }

  .sm\\:-mt-20{
    margin-top:-5rem
  }

  .sm\\:-mr-20{
    margin-right:-5rem
  }

  .sm\\:-mb-20{
    margin-bottom:-5rem
  }

  .sm\\:-ml-20{
    margin-left:-5rem
  }

  .sm\\:-mt-24{
    margin-top:-6rem
  }

  .sm\\:-mr-24{
    margin-right:-6rem
  }

  .sm\\:-mb-24{
    margin-bottom:-6rem
  }

  .sm\\:-ml-24{
    margin-left:-6rem
  }

  .sm\\:-mt-32{
    margin-top:-8rem
  }

  .sm\\:-mr-32{
    margin-right:-8rem
  }

  .sm\\:-mb-32{
    margin-bottom:-8rem
  }

  .sm\\:-ml-32{
    margin-left:-8rem
  }

  .sm\\:-mt-40{
    margin-top:-10rem
  }

  .sm\\:-mr-40{
    margin-right:-10rem
  }

  .sm\\:-mb-40{
    margin-bottom:-10rem
  }

  .sm\\:-ml-40{
    margin-left:-10rem
  }

  .sm\\:-mt-48{
    margin-top:-12rem
  }

  .sm\\:-mr-48{
    margin-right:-12rem
  }

  .sm\\:-mb-48{
    margin-bottom:-12rem
  }

  .sm\\:-ml-48{
    margin-left:-12rem
  }

  .sm\\:-mt-56{
    margin-top:-14rem
  }

  .sm\\:-mr-56{
    margin-right:-14rem
  }

  .sm\\:-mb-56{
    margin-bottom:-14rem
  }

  .sm\\:-ml-56{
    margin-left:-14rem
  }

  .sm\\:-mt-64{
    margin-top:-16rem
  }

  .sm\\:-mr-64{
    margin-right:-16rem
  }

  .sm\\:-mb-64{
    margin-bottom:-16rem
  }

  .sm\\:-ml-64{
    margin-left:-16rem
  }

  .sm\\:-mt-px{
    margin-top:-1px
  }

  .sm\\:-mr-px{
    margin-right:-1px
  }

  .sm\\:-mb-px{
    margin-bottom:-1px
  }

  .sm\\:-ml-px{
    margin-left:-1px
  }

  .sm\\:last\\:m-0:last-child{
    margin:0
  }

  .sm\\:last\\:m-1:last-child{
    margin:.25rem
  }

  .sm\\:last\\:m-2:last-child{
    margin:.5rem
  }

  .sm\\:last\\:m-3:last-child{
    margin:.75rem
  }

  .sm\\:last\\:m-4:last-child{
    margin:1rem
  }

  .sm\\:last\\:m-5:last-child{
    margin:1.25rem
  }

  .sm\\:last\\:m-6:last-child{
    margin:1.5rem
  }

  .sm\\:last\\:m-8:last-child{
    margin:2rem
  }

  .sm\\:last\\:m-10:last-child{
    margin:2.5rem
  }

  .sm\\:last\\:m-12:last-child{
    margin:3rem
  }

  .sm\\:last\\:m-16:last-child{
    margin:4rem
  }

  .sm\\:last\\:m-20:last-child{
    margin:5rem
  }

  .sm\\:last\\:m-24:last-child{
    margin:6rem
  }

  .sm\\:last\\:m-32:last-child{
    margin:8rem
  }

  .sm\\:last\\:m-40:last-child{
    margin:10rem
  }

  .sm\\:last\\:m-48:last-child{
    margin:12rem
  }

  .sm\\:last\\:m-56:last-child{
    margin:14rem
  }

  .sm\\:last\\:m-64:last-child{
    margin:16rem
  }

  .sm\\:last\\:m-auto:last-child{
    margin:auto
  }

  .sm\\:last\\:m-px:last-child{
    margin:1px
  }

  .sm\\:last\\:-m-1:last-child{
    margin:-.25rem
  }

  .sm\\:last\\:-m-2:last-child{
    margin:-.5rem
  }

  .sm\\:last\\:-m-3:last-child{
    margin:-.75rem
  }

  .sm\\:last\\:-m-4:last-child{
    margin:-1rem
  }

  .sm\\:last\\:-m-5:last-child{
    margin:-1.25rem
  }

  .sm\\:last\\:-m-6:last-child{
    margin:-1.5rem
  }

  .sm\\:last\\:-m-8:last-child{
    margin:-2rem
  }

  .sm\\:last\\:-m-10:last-child{
    margin:-2.5rem
  }

  .sm\\:last\\:-m-12:last-child{
    margin:-3rem
  }

  .sm\\:last\\:-m-16:last-child{
    margin:-4rem
  }

  .sm\\:last\\:-m-20:last-child{
    margin:-5rem
  }

  .sm\\:last\\:-m-24:last-child{
    margin:-6rem
  }

  .sm\\:last\\:-m-32:last-child{
    margin:-8rem
  }

  .sm\\:last\\:-m-40:last-child{
    margin:-10rem
  }

  .sm\\:last\\:-m-48:last-child{
    margin:-12rem
  }

  .sm\\:last\\:-m-56:last-child{
    margin:-14rem
  }

  .sm\\:last\\:-m-64:last-child{
    margin:-16rem
  }

  .sm\\:last\\:-m-px:last-child{
    margin:-1px
  }

  .sm\\:last\\:my-0:last-child{
    margin-bottom:0;
    margin-top:0
  }

  .sm\\:last\\:mx-0:last-child{
    margin-left:0;
    margin-right:0
  }

  .sm\\:last\\:my-1:last-child{
    margin-bottom:.25rem;
    margin-top:.25rem
  }

  .sm\\:last\\:mx-1:last-child{
    margin-left:.25rem;
    margin-right:.25rem
  }

  .sm\\:last\\:my-2:last-child{
    margin-bottom:.5rem;
    margin-top:.5rem
  }

  .sm\\:last\\:mx-2:last-child{
    margin-left:.5rem;
    margin-right:.5rem
  }

  .sm\\:last\\:my-3:last-child{
    margin-bottom:.75rem;
    margin-top:.75rem
  }

  .sm\\:last\\:mx-3:last-child{
    margin-left:.75rem;
    margin-right:.75rem
  }

  .sm\\:last\\:my-4:last-child{
    margin-bottom:1rem;
    margin-top:1rem
  }

  .sm\\:last\\:mx-4:last-child{
    margin-left:1rem;
    margin-right:1rem
  }

  .sm\\:last\\:my-5:last-child{
    margin-bottom:1.25rem;
    margin-top:1.25rem
  }

  .sm\\:last\\:mx-5:last-child{
    margin-left:1.25rem;
    margin-right:1.25rem
  }

  .sm\\:last\\:my-6:last-child{
    margin-bottom:1.5rem;
    margin-top:1.5rem
  }

  .sm\\:last\\:mx-6:last-child{
    margin-left:1.5rem;
    margin-right:1.5rem
  }

  .sm\\:last\\:my-8:last-child{
    margin-bottom:2rem;
    margin-top:2rem
  }

  .sm\\:last\\:mx-8:last-child{
    margin-left:2rem;
    margin-right:2rem
  }

  .sm\\:last\\:my-10:last-child{
    margin-bottom:2.5rem;
    margin-top:2.5rem
  }

  .sm\\:last\\:mx-10:last-child{
    margin-left:2.5rem;
    margin-right:2.5rem
  }

  .sm\\:last\\:my-12:last-child{
    margin-bottom:3rem;
    margin-top:3rem
  }

  .sm\\:last\\:mx-12:last-child{
    margin-left:3rem;
    margin-right:3rem
  }

  .sm\\:last\\:my-16:last-child{
    margin-bottom:4rem;
    margin-top:4rem
  }

  .sm\\:last\\:mx-16:last-child{
    margin-left:4rem;
    margin-right:4rem
  }

  .sm\\:last\\:my-20:last-child{
    margin-bottom:5rem;
    margin-top:5rem
  }

  .sm\\:last\\:mx-20:last-child{
    margin-left:5rem;
    margin-right:5rem
  }

  .sm\\:last\\:my-24:last-child{
    margin-bottom:6rem;
    margin-top:6rem
  }

  .sm\\:last\\:mx-24:last-child{
    margin-left:6rem;
    margin-right:6rem
  }

  .sm\\:last\\:my-32:last-child{
    margin-bottom:8rem;
    margin-top:8rem
  }

  .sm\\:last\\:mx-32:last-child{
    margin-left:8rem;
    margin-right:8rem
  }

  .sm\\:last\\:my-40:last-child{
    margin-bottom:10rem;
    margin-top:10rem
  }

  .sm\\:last\\:mx-40:last-child{
    margin-left:10rem;
    margin-right:10rem
  }

  .sm\\:last\\:my-48:last-child{
    margin-bottom:12rem;
    margin-top:12rem
  }

  .sm\\:last\\:mx-48:last-child{
    margin-left:12rem;
    margin-right:12rem
  }

  .sm\\:last\\:my-56:last-child{
    margin-bottom:14rem;
    margin-top:14rem
  }

  .sm\\:last\\:mx-56:last-child{
    margin-left:14rem;
    margin-right:14rem
  }

  .sm\\:last\\:my-64:last-child{
    margin-bottom:16rem;
    margin-top:16rem
  }

  .sm\\:last\\:mx-64:last-child{
    margin-left:16rem;
    margin-right:16rem
  }

  .sm\\:last\\:my-auto:last-child{
    margin-bottom:auto;
    margin-top:auto
  }

  .sm\\:last\\:mx-auto:last-child{
    margin-left:auto;
    margin-right:auto
  }

  .sm\\:last\\:my-px:last-child{
    margin-bottom:1px;
    margin-top:1px
  }

  .sm\\:last\\:mx-px:last-child{
    margin-left:1px;
    margin-right:1px
  }

  .sm\\:last\\:-my-1:last-child{
    margin-bottom:-.25rem;
    margin-top:-.25rem
  }

  .sm\\:last\\:-mx-1:last-child{
    margin-left:-.25rem;
    margin-right:-.25rem
  }

  .sm\\:last\\:-my-2:last-child{
    margin-bottom:-.5rem;
    margin-top:-.5rem
  }

  .sm\\:last\\:-mx-2:last-child{
    margin-left:-.5rem;
    margin-right:-.5rem
  }

  .sm\\:last\\:-my-3:last-child{
    margin-bottom:-.75rem;
    margin-top:-.75rem
  }

  .sm\\:last\\:-mx-3:last-child{
    margin-left:-.75rem;
    margin-right:-.75rem
  }

  .sm\\:last\\:-my-4:last-child{
    margin-bottom:-1rem;
    margin-top:-1rem
  }

  .sm\\:last\\:-mx-4:last-child{
    margin-left:-1rem;
    margin-right:-1rem
  }

  .sm\\:last\\:-my-5:last-child{
    margin-bottom:-1.25rem;
    margin-top:-1.25rem
  }

  .sm\\:last\\:-mx-5:last-child{
    margin-left:-1.25rem;
    margin-right:-1.25rem
  }

  .sm\\:last\\:-my-6:last-child{
    margin-bottom:-1.5rem;
    margin-top:-1.5rem
  }

  .sm\\:last\\:-mx-6:last-child{
    margin-left:-1.5rem;
    margin-right:-1.5rem
  }

  .sm\\:last\\:-my-8:last-child{
    margin-bottom:-2rem;
    margin-top:-2rem
  }

  .sm\\:last\\:-mx-8:last-child{
    margin-left:-2rem;
    margin-right:-2rem
  }

  .sm\\:last\\:-my-10:last-child{
    margin-bottom:-2.5rem;
    margin-top:-2.5rem
  }

  .sm\\:last\\:-mx-10:last-child{
    margin-left:-2.5rem;
    margin-right:-2.5rem
  }

  .sm\\:last\\:-my-12:last-child{
    margin-bottom:-3rem;
    margin-top:-3rem
  }

  .sm\\:last\\:-mx-12:last-child{
    margin-left:-3rem;
    margin-right:-3rem
  }

  .sm\\:last\\:-my-16:last-child{
    margin-bottom:-4rem;
    margin-top:-4rem
  }

  .sm\\:last\\:-mx-16:last-child{
    margin-left:-4rem;
    margin-right:-4rem
  }

  .sm\\:last\\:-my-20:last-child{
    margin-bottom:-5rem;
    margin-top:-5rem
  }

  .sm\\:last\\:-mx-20:last-child{
    margin-left:-5rem;
    margin-right:-5rem
  }

  .sm\\:last\\:-my-24:last-child{
    margin-bottom:-6rem;
    margin-top:-6rem
  }

  .sm\\:last\\:-mx-24:last-child{
    margin-left:-6rem;
    margin-right:-6rem
  }

  .sm\\:last\\:-my-32:last-child{
    margin-bottom:-8rem;
    margin-top:-8rem
  }

  .sm\\:last\\:-mx-32:last-child{
    margin-left:-8rem;
    margin-right:-8rem
  }

  .sm\\:last\\:-my-40:last-child{
    margin-bottom:-10rem;
    margin-top:-10rem
  }

  .sm\\:last\\:-mx-40:last-child{
    margin-left:-10rem;
    margin-right:-10rem
  }

  .sm\\:last\\:-my-48:last-child{
    margin-bottom:-12rem;
    margin-top:-12rem
  }

  .sm\\:last\\:-mx-48:last-child{
    margin-left:-12rem;
    margin-right:-12rem
  }

  .sm\\:last\\:-my-56:last-child{
    margin-bottom:-14rem;
    margin-top:-14rem
  }

  .sm\\:last\\:-mx-56:last-child{
    margin-left:-14rem;
    margin-right:-14rem
  }

  .sm\\:last\\:-my-64:last-child{
    margin-bottom:-16rem;
    margin-top:-16rem
  }

  .sm\\:last\\:-mx-64:last-child{
    margin-left:-16rem;
    margin-right:-16rem
  }

  .sm\\:last\\:-my-px:last-child{
    margin-bottom:-1px;
    margin-top:-1px
  }

  .sm\\:last\\:-mx-px:last-child{
    margin-left:-1px;
    margin-right:-1px
  }

  .sm\\:last\\:mt-0:last-child{
    margin-top:0
  }

  .sm\\:last\\:mr-0:last-child{
    margin-right:0
  }

  .sm\\:last\\:mb-0:last-child{
    margin-bottom:0
  }

  .sm\\:last\\:ml-0:last-child{
    margin-left:0
  }

  .sm\\:last\\:mt-1:last-child{
    margin-top:.25rem
  }

  .sm\\:last\\:mr-1:last-child{
    margin-right:.25rem
  }

  .sm\\:last\\:mb-1:last-child{
    margin-bottom:.25rem
  }

  .sm\\:last\\:ml-1:last-child{
    margin-left:.25rem
  }

  .sm\\:last\\:mt-2:last-child{
    margin-top:.5rem
  }

  .sm\\:last\\:mr-2:last-child{
    margin-right:.5rem
  }

  .sm\\:last\\:mb-2:last-child{
    margin-bottom:.5rem
  }

  .sm\\:last\\:ml-2:last-child{
    margin-left:.5rem
  }

  .sm\\:last\\:mt-3:last-child{
    margin-top:.75rem
  }

  .sm\\:last\\:mr-3:last-child{
    margin-right:.75rem
  }

  .sm\\:last\\:mb-3:last-child{
    margin-bottom:.75rem
  }

  .sm\\:last\\:ml-3:last-child{
    margin-left:.75rem
  }

  .sm\\:last\\:mt-4:last-child{
    margin-top:1rem
  }

  .sm\\:last\\:mr-4:last-child{
    margin-right:1rem
  }

  .sm\\:last\\:mb-4:last-child{
    margin-bottom:1rem
  }

  .sm\\:last\\:ml-4:last-child{
    margin-left:1rem
  }

  .sm\\:last\\:mt-5:last-child{
    margin-top:1.25rem
  }

  .sm\\:last\\:mr-5:last-child{
    margin-right:1.25rem
  }

  .sm\\:last\\:mb-5:last-child{
    margin-bottom:1.25rem
  }

  .sm\\:last\\:ml-5:last-child{
    margin-left:1.25rem
  }

  .sm\\:last\\:mt-6:last-child{
    margin-top:1.5rem
  }

  .sm\\:last\\:mr-6:last-child{
    margin-right:1.5rem
  }

  .sm\\:last\\:mb-6:last-child{
    margin-bottom:1.5rem
  }

  .sm\\:last\\:ml-6:last-child{
    margin-left:1.5rem
  }

  .sm\\:last\\:mt-8:last-child{
    margin-top:2rem
  }

  .sm\\:last\\:mr-8:last-child{
    margin-right:2rem
  }

  .sm\\:last\\:mb-8:last-child{
    margin-bottom:2rem
  }

  .sm\\:last\\:ml-8:last-child{
    margin-left:2rem
  }

  .sm\\:last\\:mt-10:last-child{
    margin-top:2.5rem
  }

  .sm\\:last\\:mr-10:last-child{
    margin-right:2.5rem
  }

  .sm\\:last\\:mb-10:last-child{
    margin-bottom:2.5rem
  }

  .sm\\:last\\:ml-10:last-child{
    margin-left:2.5rem
  }

  .sm\\:last\\:mt-12:last-child{
    margin-top:3rem
  }

  .sm\\:last\\:mr-12:last-child{
    margin-right:3rem
  }

  .sm\\:last\\:mb-12:last-child{
    margin-bottom:3rem
  }

  .sm\\:last\\:ml-12:last-child{
    margin-left:3rem
  }

  .sm\\:last\\:mt-16:last-child{
    margin-top:4rem
  }

  .sm\\:last\\:mr-16:last-child{
    margin-right:4rem
  }

  .sm\\:last\\:mb-16:last-child{
    margin-bottom:4rem
  }

  .sm\\:last\\:ml-16:last-child{
    margin-left:4rem
  }

  .sm\\:last\\:mt-20:last-child{
    margin-top:5rem
  }

  .sm\\:last\\:mr-20:last-child{
    margin-right:5rem
  }

  .sm\\:last\\:mb-20:last-child{
    margin-bottom:5rem
  }

  .sm\\:last\\:ml-20:last-child{
    margin-left:5rem
  }

  .sm\\:last\\:mt-24:last-child{
    margin-top:6rem
  }

  .sm\\:last\\:mr-24:last-child{
    margin-right:6rem
  }

  .sm\\:last\\:mb-24:last-child{
    margin-bottom:6rem
  }

  .sm\\:last\\:ml-24:last-child{
    margin-left:6rem
  }

  .sm\\:last\\:mt-32:last-child{
    margin-top:8rem
  }

  .sm\\:last\\:mr-32:last-child{
    margin-right:8rem
  }

  .sm\\:last\\:mb-32:last-child{
    margin-bottom:8rem
  }

  .sm\\:last\\:ml-32:last-child{
    margin-left:8rem
  }

  .sm\\:last\\:mt-40:last-child{
    margin-top:10rem
  }

  .sm\\:last\\:mr-40:last-child{
    margin-right:10rem
  }

  .sm\\:last\\:mb-40:last-child{
    margin-bottom:10rem
  }

  .sm\\:last\\:ml-40:last-child{
    margin-left:10rem
  }

  .sm\\:last\\:mt-48:last-child{
    margin-top:12rem
  }

  .sm\\:last\\:mr-48:last-child{
    margin-right:12rem
  }

  .sm\\:last\\:mb-48:last-child{
    margin-bottom:12rem
  }

  .sm\\:last\\:ml-48:last-child{
    margin-left:12rem
  }

  .sm\\:last\\:mt-56:last-child{
    margin-top:14rem
  }

  .sm\\:last\\:mr-56:last-child{
    margin-right:14rem
  }

  .sm\\:last\\:mb-56:last-child{
    margin-bottom:14rem
  }

  .sm\\:last\\:ml-56:last-child{
    margin-left:14rem
  }

  .sm\\:last\\:mt-64:last-child{
    margin-top:16rem
  }

  .sm\\:last\\:mr-64:last-child{
    margin-right:16rem
  }

  .sm\\:last\\:mb-64:last-child{
    margin-bottom:16rem
  }

  .sm\\:last\\:ml-64:last-child{
    margin-left:16rem
  }

  .sm\\:last\\:mt-auto:last-child{
    margin-top:auto
  }

  .sm\\:last\\:mr-auto:last-child{
    margin-right:auto
  }

  .sm\\:last\\:mb-auto:last-child{
    margin-bottom:auto
  }

  .sm\\:last\\:ml-auto:last-child{
    margin-left:auto
  }

  .sm\\:last\\:mt-px:last-child{
    margin-top:1px
  }

  .sm\\:last\\:mr-px:last-child{
    margin-right:1px
  }

  .sm\\:last\\:mb-px:last-child{
    margin-bottom:1px
  }

  .sm\\:last\\:ml-px:last-child{
    margin-left:1px
  }

  .sm\\:last\\:-mt-1:last-child{
    margin-top:-.25rem
  }

  .sm\\:last\\:-mr-1:last-child{
    margin-right:-.25rem
  }

  .sm\\:last\\:-mb-1:last-child{
    margin-bottom:-.25rem
  }

  .sm\\:last\\:-ml-1:last-child{
    margin-left:-.25rem
  }

  .sm\\:last\\:-mt-2:last-child{
    margin-top:-.5rem
  }

  .sm\\:last\\:-mr-2:last-child{
    margin-right:-.5rem
  }

  .sm\\:last\\:-mb-2:last-child{
    margin-bottom:-.5rem
  }

  .sm\\:last\\:-ml-2:last-child{
    margin-left:-.5rem
  }

  .sm\\:last\\:-mt-3:last-child{
    margin-top:-.75rem
  }

  .sm\\:last\\:-mr-3:last-child{
    margin-right:-.75rem
  }

  .sm\\:last\\:-mb-3:last-child{
    margin-bottom:-.75rem
  }

  .sm\\:last\\:-ml-3:last-child{
    margin-left:-.75rem
  }

  .sm\\:last\\:-mt-4:last-child{
    margin-top:-1rem
  }

  .sm\\:last\\:-mr-4:last-child{
    margin-right:-1rem
  }

  .sm\\:last\\:-mb-4:last-child{
    margin-bottom:-1rem
  }

  .sm\\:last\\:-ml-4:last-child{
    margin-left:-1rem
  }

  .sm\\:last\\:-mt-5:last-child{
    margin-top:-1.25rem
  }

  .sm\\:last\\:-mr-5:last-child{
    margin-right:-1.25rem
  }

  .sm\\:last\\:-mb-5:last-child{
    margin-bottom:-1.25rem
  }

  .sm\\:last\\:-ml-5:last-child{
    margin-left:-1.25rem
  }

  .sm\\:last\\:-mt-6:last-child{
    margin-top:-1.5rem
  }

  .sm\\:last\\:-mr-6:last-child{
    margin-right:-1.5rem
  }

  .sm\\:last\\:-mb-6:last-child{
    margin-bottom:-1.5rem
  }

  .sm\\:last\\:-ml-6:last-child{
    margin-left:-1.5rem
  }

  .sm\\:last\\:-mt-8:last-child{
    margin-top:-2rem
  }

  .sm\\:last\\:-mr-8:last-child{
    margin-right:-2rem
  }

  .sm\\:last\\:-mb-8:last-child{
    margin-bottom:-2rem
  }

  .sm\\:last\\:-ml-8:last-child{
    margin-left:-2rem
  }

  .sm\\:last\\:-mt-10:last-child{
    margin-top:-2.5rem
  }

  .sm\\:last\\:-mr-10:last-child{
    margin-right:-2.5rem
  }

  .sm\\:last\\:-mb-10:last-child{
    margin-bottom:-2.5rem
  }

  .sm\\:last\\:-ml-10:last-child{
    margin-left:-2.5rem
  }

  .sm\\:last\\:-mt-12:last-child{
    margin-top:-3rem
  }

  .sm\\:last\\:-mr-12:last-child{
    margin-right:-3rem
  }

  .sm\\:last\\:-mb-12:last-child{
    margin-bottom:-3rem
  }

  .sm\\:last\\:-ml-12:last-child{
    margin-left:-3rem
  }

  .sm\\:last\\:-mt-16:last-child{
    margin-top:-4rem
  }

  .sm\\:last\\:-mr-16:last-child{
    margin-right:-4rem
  }

  .sm\\:last\\:-mb-16:last-child{
    margin-bottom:-4rem
  }

  .sm\\:last\\:-ml-16:last-child{
    margin-left:-4rem
  }

  .sm\\:last\\:-mt-20:last-child{
    margin-top:-5rem
  }

  .sm\\:last\\:-mr-20:last-child{
    margin-right:-5rem
  }

  .sm\\:last\\:-mb-20:last-child{
    margin-bottom:-5rem
  }

  .sm\\:last\\:-ml-20:last-child{
    margin-left:-5rem
  }

  .sm\\:last\\:-mt-24:last-child{
    margin-top:-6rem
  }

  .sm\\:last\\:-mr-24:last-child{
    margin-right:-6rem
  }

  .sm\\:last\\:-mb-24:last-child{
    margin-bottom:-6rem
  }

  .sm\\:last\\:-ml-24:last-child{
    margin-left:-6rem
  }

  .sm\\:last\\:-mt-32:last-child{
    margin-top:-8rem
  }

  .sm\\:last\\:-mr-32:last-child{
    margin-right:-8rem
  }

  .sm\\:last\\:-mb-32:last-child{
    margin-bottom:-8rem
  }

  .sm\\:last\\:-ml-32:last-child{
    margin-left:-8rem
  }

  .sm\\:last\\:-mt-40:last-child{
    margin-top:-10rem
  }

  .sm\\:last\\:-mr-40:last-child{
    margin-right:-10rem
  }

  .sm\\:last\\:-mb-40:last-child{
    margin-bottom:-10rem
  }

  .sm\\:last\\:-ml-40:last-child{
    margin-left:-10rem
  }

  .sm\\:last\\:-mt-48:last-child{
    margin-top:-12rem
  }

  .sm\\:last\\:-mr-48:last-child{
    margin-right:-12rem
  }

  .sm\\:last\\:-mb-48:last-child{
    margin-bottom:-12rem
  }

  .sm\\:last\\:-ml-48:last-child{
    margin-left:-12rem
  }

  .sm\\:last\\:-mt-56:last-child{
    margin-top:-14rem
  }

  .sm\\:last\\:-mr-56:last-child{
    margin-right:-14rem
  }

  .sm\\:last\\:-mb-56:last-child{
    margin-bottom:-14rem
  }

  .sm\\:last\\:-ml-56:last-child{
    margin-left:-14rem
  }

  .sm\\:last\\:-mt-64:last-child{
    margin-top:-16rem
  }

  .sm\\:last\\:-mr-64:last-child{
    margin-right:-16rem
  }

  .sm\\:last\\:-mb-64:last-child{
    margin-bottom:-16rem
  }

  .sm\\:last\\:-ml-64:last-child{
    margin-left:-16rem
  }

  .sm\\:last\\:-mt-px:last-child{
    margin-top:-1px
  }

  .sm\\:last\\:-mr-px:last-child{
    margin-right:-1px
  }

  .sm\\:last\\:-mb-px:last-child{
    margin-bottom:-1px
  }

  .sm\\:last\\:-ml-px:last-child{
    margin-left:-1px
  }

  .sm\\:max-h-0{
    max-height:0
  }

  .sm\\:max-h-1{
    max-height:.25rem
  }

  .sm\\:max-h-2{
    max-height:.5rem
  }

  .sm\\:max-h-3{
    max-height:.75rem
  }

  .sm\\:max-h-4{
    max-height:1rem
  }

  .sm\\:max-h-5{
    max-height:1.25rem
  }

  .sm\\:max-h-6{
    max-height:1.5rem
  }

  .sm\\:max-h-8{
    max-height:2rem
  }

  .sm\\:max-h-10{
    max-height:2.5rem
  }

  .sm\\:max-h-12{
    max-height:3rem
  }

  .sm\\:max-h-16{
    max-height:4rem
  }

  .sm\\:max-h-20{
    max-height:5rem
  }

  .sm\\:max-h-24{
    max-height:6rem
  }

  .sm\\:max-h-32{
    max-height:8rem
  }

  .sm\\:max-h-40{
    max-height:10rem
  }

  .sm\\:max-h-48{
    max-height:12rem
  }

  .sm\\:max-h-56{
    max-height:14rem
  }

  .sm\\:max-h-64{
    max-height:16rem
  }

  .sm\\:max-h-xl{
    max-height:36rem
  }

  .sm\\:max-h-px{
    max-height:1px
  }

  .sm\\:max-w-none{
    max-width:none
  }

  .sm\\:max-w-xs{
    max-width:20rem
  }

  .sm\\:max-w-sm{
    max-width:24rem
  }

  .sm\\:max-w-md{
    max-width:28rem
  }

  .sm\\:max-w-lg{
    max-width:32rem
  }

  .sm\\:max-w-xl{
    max-width:36rem
  }

  .sm\\:max-w-2xl{
    max-width:42rem
  }

  .sm\\:max-w-3xl{
    max-width:48rem
  }

  .sm\\:max-w-4xl{
    max-width:56rem
  }

  .sm\\:max-w-5xl{
    max-width:64rem
  }

  .sm\\:max-w-6xl{
    max-width:72rem
  }

  .sm\\:max-w-full{
    max-width:100%
  }

  .sm\\:max-w-screen-sm{
    max-width:640px
  }

  .sm\\:max-w-screen-md{
    max-width:768px
  }

  .sm\\:max-w-screen-lg{
    max-width:1024px
  }

  .sm\\:max-w-screen-xl{
    max-width:1280px
  }

  .sm\\:min-h-0{
    min-height:0
  }

  .sm\\:min-h-full{
    min-height:100%
  }

  .sm\\:min-h-screen{
    min-height:100vh
  }

  .sm\\:min-w-0{
    min-width:0
  }

  .sm\\:min-w-1{
    min-width:.25rem
  }

  .sm\\:min-w-2{
    min-width:.5rem
  }

  .sm\\:min-w-3{
    min-width:.75rem
  }

  .sm\\:min-w-4{
    min-width:1rem
  }

  .sm\\:min-w-5{
    min-width:1.25rem
  }

  .sm\\:min-w-6{
    min-width:1.5rem
  }

  .sm\\:min-w-8{
    min-width:2rem
  }

  .sm\\:min-w-10{
    min-width:2.5rem
  }

  .sm\\:min-w-12{
    min-width:3rem
  }

  .sm\\:min-w-16{
    min-width:4rem
  }

  .sm\\:min-w-20{
    min-width:5rem
  }

  .sm\\:min-w-24{
    min-width:6rem
  }

  .sm\\:min-w-32{
    min-width:8rem
  }

  .sm\\:min-w-40{
    min-width:10rem
  }

  .sm\\:min-w-48{
    min-width:12rem
  }

  .sm\\:min-w-56{
    min-width:14rem
  }

  .sm\\:min-w-64{
    min-width:16rem
  }

  .sm\\:min-w-max-content{
    min-width:max-content
  }

  .sm\\:min-w-px{
    min-width:1px
  }

  .sm\\:object-contain{
    object-fit:contain
  }

  .sm\\:object-cover{
    object-fit:cover
  }

  .sm\\:object-fill{
    object-fit:fill
  }

  .sm\\:object-none{
    object-fit:none
  }

  .sm\\:object-scale-down{
    object-fit:scale-down
  }

  .sm\\:object-bottom{
    object-position:bottom
  }

  .sm\\:object-center{
    object-position:center
  }

  .sm\\:object-left{
    object-position:left
  }

  .sm\\:object-left-bottom{
    object-position:left bottom
  }

  .sm\\:object-left-top{
    object-position:left top
  }

  .sm\\:object-right{
    object-position:right
  }

  .sm\\:object-right-bottom{
    object-position:right bottom
  }

  .sm\\:object-right-top{
    object-position:right top
  }

  .sm\\:object-top{
    object-position:top
  }

  .sm\\:opacity-0{
    opacity:0
  }

  .sm\\:opacity-25{
    opacity:.25
  }

  .sm\\:opacity-50{
    opacity:.5
  }

  .sm\\:opacity-75{
    opacity:.75
  }

  .sm\\:opacity-100{
    opacity:1
  }

  .sm\\:hover\\:opacity-0:hover{
    opacity:0
  }

  .sm\\:hover\\:opacity-25:hover{
    opacity:.25
  }

  .sm\\:hover\\:opacity-50:hover{
    opacity:.5
  }

  .sm\\:hover\\:opacity-75:hover{
    opacity:.75
  }

  .sm\\:hover\\:opacity-100:hover{
    opacity:1
  }

  .sm\\:focus\\:opacity-0:focus{
    opacity:0
  }

  .sm\\:focus\\:opacity-25:focus{
    opacity:.25
  }

  .sm\\:focus\\:opacity-50:focus{
    opacity:.5
  }

  .sm\\:focus\\:opacity-75:focus{
    opacity:.75
  }

  .sm\\:focus\\:opacity-100:focus{
    opacity:1
  }

  .sm\\:focus\\:outline-none:focus,.sm\\:outline-none{
    outline:0
  }

  .sm\\:overflow-auto{
    overflow:auto
  }

  .sm\\:overflow-hidden{
    overflow:hidden
  }

  .sm\\:overflow-visible{
    overflow:visible
  }

  .sm\\:overflow-scroll{
    overflow:scroll
  }

  .sm\\:overflow-x-auto{
    overflow-x:auto
  }

  .sm\\:overflow-y-auto{
    overflow-y:auto
  }

  .sm\\:overflow-x-hidden{
    overflow-x:hidden
  }

  .sm\\:overflow-y-hidden{
    overflow-y:hidden
  }

  .sm\\:overflow-x-visible{
    overflow-x:visible
  }

  .sm\\:overflow-y-visible{
    overflow-y:visible
  }

  .sm\\:overflow-x-scroll{
    overflow-x:scroll
  }

  .sm\\:overflow-y-scroll{
    overflow-y:scroll
  }

  .sm\\:scrolling-touch{
    -webkit-overflow-scrolling:touch
  }

  .sm\\:scrolling-auto{
    -webkit-overflow-scrolling:auto
  }

  .sm\\:p-0{
    padding:0
  }

  .sm\\:p-1{
    padding:.25rem
  }

  .sm\\:p-2{
    padding:.5rem
  }

  .sm\\:p-3{
    padding:.75rem
  }

  .sm\\:p-4{
    padding:1rem
  }

  .sm\\:p-5{
    padding:1.25rem
  }

  .sm\\:p-6{
    padding:1.5rem
  }

  .sm\\:p-8{
    padding:2rem
  }

  .sm\\:p-10{
    padding:2.5rem
  }

  .sm\\:p-12{
    padding:3rem
  }

  .sm\\:p-16{
    padding:4rem
  }

  .sm\\:p-20{
    padding:5rem
  }

  .sm\\:p-24{
    padding:6rem
  }

  .sm\\:p-32{
    padding:8rem
  }

  .sm\\:p-40{
    padding:10rem
  }

  .sm\\:p-48{
    padding:12rem
  }

  .sm\\:p-56{
    padding:14rem
  }

  .sm\\:p-64{
    padding:16rem
  }

  .sm\\:p-px{
    padding:1px
  }

  .sm\\:py-0{
    padding-bottom:0;
    padding-top:0
  }

  .sm\\:px-0{
    padding-left:0;
    padding-right:0
  }

  .sm\\:py-1{
    padding-bottom:.25rem;
    padding-top:.25rem
  }

  .sm\\:px-1{
    padding-left:.25rem;
    padding-right:.25rem
  }

  .sm\\:py-2{
    padding-bottom:.5rem;
    padding-top:.5rem
  }

  .sm\\:px-2{
    padding-left:.5rem;
    padding-right:.5rem
  }

  .sm\\:py-3{
    padding-bottom:.75rem;
    padding-top:.75rem
  }

  .sm\\:px-3{
    padding-left:.75rem;
    padding-right:.75rem
  }

  .sm\\:py-4{
    padding-bottom:1rem;
    padding-top:1rem
  }

  .sm\\:px-4{
    padding-left:1rem;
    padding-right:1rem
  }

  .sm\\:py-5{
    padding-bottom:1.25rem;
    padding-top:1.25rem
  }

  .sm\\:px-5{
    padding-left:1.25rem;
    padding-right:1.25rem
  }

  .sm\\:py-6{
    padding-bottom:1.5rem;
    padding-top:1.5rem
  }

  .sm\\:px-6{
    padding-left:1.5rem;
    padding-right:1.5rem
  }

  .sm\\:py-8{
    padding-bottom:2rem;
    padding-top:2rem
  }

  .sm\\:px-8{
    padding-left:2rem;
    padding-right:2rem
  }

  .sm\\:py-10{
    padding-bottom:2.5rem;
    padding-top:2.5rem
  }

  .sm\\:px-10{
    padding-left:2.5rem;
    padding-right:2.5rem
  }

  .sm\\:py-12{
    padding-bottom:3rem;
    padding-top:3rem
  }

  .sm\\:px-12{
    padding-left:3rem;
    padding-right:3rem
  }

  .sm\\:py-16{
    padding-bottom:4rem;
    padding-top:4rem
  }

  .sm\\:px-16{
    padding-left:4rem;
    padding-right:4rem
  }

  .sm\\:py-20{
    padding-bottom:5rem;
    padding-top:5rem
  }

  .sm\\:px-20{
    padding-left:5rem;
    padding-right:5rem
  }

  .sm\\:py-24{
    padding-bottom:6rem;
    padding-top:6rem
  }

  .sm\\:px-24{
    padding-left:6rem;
    padding-right:6rem
  }

  .sm\\:py-32{
    padding-bottom:8rem;
    padding-top:8rem
  }

  .sm\\:px-32{
    padding-left:8rem;
    padding-right:8rem
  }

  .sm\\:py-40{
    padding-bottom:10rem;
    padding-top:10rem
  }

  .sm\\:px-40{
    padding-left:10rem;
    padding-right:10rem
  }

  .sm\\:py-48{
    padding-bottom:12rem;
    padding-top:12rem
  }

  .sm\\:px-48{
    padding-left:12rem;
    padding-right:12rem
  }

  .sm\\:py-56{
    padding-bottom:14rem;
    padding-top:14rem
  }

  .sm\\:px-56{
    padding-left:14rem;
    padding-right:14rem
  }

  .sm\\:py-64{
    padding-bottom:16rem;
    padding-top:16rem
  }

  .sm\\:px-64{
    padding-left:16rem;
    padding-right:16rem
  }

  .sm\\:py-px{
    padding-bottom:1px;
    padding-top:1px
  }

  .sm\\:px-px{
    padding-left:1px;
    padding-right:1px
  }

  .sm\\:pt-0{
    padding-top:0
  }

  .sm\\:pr-0{
    padding-right:0
  }

  .sm\\:pb-0{
    padding-bottom:0
  }

  .sm\\:pl-0{
    padding-left:0
  }

  .sm\\:pt-1{
    padding-top:.25rem
  }

  .sm\\:pr-1{
    padding-right:.25rem
  }

  .sm\\:pb-1{
    padding-bottom:.25rem
  }

  .sm\\:pl-1{
    padding-left:.25rem
  }

  .sm\\:pt-2{
    padding-top:.5rem
  }

  .sm\\:pr-2{
    padding-right:.5rem
  }

  .sm\\:pb-2{
    padding-bottom:.5rem
  }

  .sm\\:pl-2{
    padding-left:.5rem
  }

  .sm\\:pt-3{
    padding-top:.75rem
  }

  .sm\\:pr-3{
    padding-right:.75rem
  }

  .sm\\:pb-3{
    padding-bottom:.75rem
  }

  .sm\\:pl-3{
    padding-left:.75rem
  }

  .sm\\:pt-4{
    padding-top:1rem
  }

  .sm\\:pr-4{
    padding-right:1rem
  }

  .sm\\:pb-4{
    padding-bottom:1rem
  }

  .sm\\:pl-4{
    padding-left:1rem
  }

  .sm\\:pt-5{
    padding-top:1.25rem
  }

  .sm\\:pr-5{
    padding-right:1.25rem
  }

  .sm\\:pb-5{
    padding-bottom:1.25rem
  }

  .sm\\:pl-5{
    padding-left:1.25rem
  }

  .sm\\:pt-6{
    padding-top:1.5rem
  }

  .sm\\:pr-6{
    padding-right:1.5rem
  }

  .sm\\:pb-6{
    padding-bottom:1.5rem
  }

  .sm\\:pl-6{
    padding-left:1.5rem
  }

  .sm\\:pt-8{
    padding-top:2rem
  }

  .sm\\:pr-8{
    padding-right:2rem
  }

  .sm\\:pb-8{
    padding-bottom:2rem
  }

  .sm\\:pl-8{
    padding-left:2rem
  }

  .sm\\:pt-10{
    padding-top:2.5rem
  }

  .sm\\:pr-10{
    padding-right:2.5rem
  }

  .sm\\:pb-10{
    padding-bottom:2.5rem
  }

  .sm\\:pl-10{
    padding-left:2.5rem
  }

  .sm\\:pt-12{
    padding-top:3rem
  }

  .sm\\:pr-12{
    padding-right:3rem
  }

  .sm\\:pb-12{
    padding-bottom:3rem
  }

  .sm\\:pl-12{
    padding-left:3rem
  }

  .sm\\:pt-16{
    padding-top:4rem
  }

  .sm\\:pr-16{
    padding-right:4rem
  }

  .sm\\:pb-16{
    padding-bottom:4rem
  }

  .sm\\:pl-16{
    padding-left:4rem
  }

  .sm\\:pt-20{
    padding-top:5rem
  }

  .sm\\:pr-20{
    padding-right:5rem
  }

  .sm\\:pb-20{
    padding-bottom:5rem
  }

  .sm\\:pl-20{
    padding-left:5rem
  }

  .sm\\:pt-24{
    padding-top:6rem
  }

  .sm\\:pr-24{
    padding-right:6rem
  }

  .sm\\:pb-24{
    padding-bottom:6rem
  }

  .sm\\:pl-24{
    padding-left:6rem
  }

  .sm\\:pt-32{
    padding-top:8rem
  }

  .sm\\:pr-32{
    padding-right:8rem
  }

  .sm\\:pb-32{
    padding-bottom:8rem
  }

  .sm\\:pl-32{
    padding-left:8rem
  }

  .sm\\:pt-40{
    padding-top:10rem
  }

  .sm\\:pr-40{
    padding-right:10rem
  }

  .sm\\:pb-40{
    padding-bottom:10rem
  }

  .sm\\:pl-40{
    padding-left:10rem
  }

  .sm\\:pt-48{
    padding-top:12rem
  }

  .sm\\:pr-48{
    padding-right:12rem
  }

  .sm\\:pb-48{
    padding-bottom:12rem
  }

  .sm\\:pl-48{
    padding-left:12rem
  }

  .sm\\:pt-56{
    padding-top:14rem
  }

  .sm\\:pr-56{
    padding-right:14rem
  }

  .sm\\:pb-56{
    padding-bottom:14rem
  }

  .sm\\:pl-56{
    padding-left:14rem
  }

  .sm\\:pt-64{
    padding-top:16rem
  }

  .sm\\:pr-64{
    padding-right:16rem
  }

  .sm\\:pb-64{
    padding-bottom:16rem
  }

  .sm\\:pl-64{
    padding-left:16rem
  }

  .sm\\:pt-px{
    padding-top:1px
  }

  .sm\\:pr-px{
    padding-right:1px
  }

  .sm\\:pb-px{
    padding-bottom:1px
  }

  .sm\\:pl-px{
    padding-left:1px
  }

  .sm\\:placeholder-transparent::placeholder{
    color:#0000
  }

  .sm\\:placeholder-white::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .sm\\:placeholder-black::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .sm\\:placeholder-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .sm\\:placeholder-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .sm\\:placeholder-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .sm\\:placeholder-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .sm\\:placeholder-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .sm\\:placeholder-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .sm\\:placeholder-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .sm\\:placeholder-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .sm\\:placeholder-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .sm\\:placeholder-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .sm\\:placeholder-cool-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .sm\\:placeholder-cool-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .sm\\:placeholder-cool-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .sm\\:placeholder-cool-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .sm\\:placeholder-cool-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .sm\\:placeholder-cool-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .sm\\:placeholder-cool-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .sm\\:placeholder-cool-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .sm\\:placeholder-cool-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .sm\\:placeholder-cool-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .sm\\:placeholder-red-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .sm\\:placeholder-red-100::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .sm\\:placeholder-red-200::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .sm\\:placeholder-red-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .sm\\:placeholder-red-400::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .sm\\:placeholder-red-500::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .sm\\:placeholder-red-600::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .sm\\:placeholder-red-700::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .sm\\:placeholder-red-800::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .sm\\:placeholder-red-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .sm\\:placeholder-orange-50::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .sm\\:placeholder-orange-100::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .sm\\:placeholder-orange-200::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .sm\\:placeholder-orange-300::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .sm\\:placeholder-orange-400::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .sm\\:placeholder-orange-500::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .sm\\:placeholder-orange-600::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .sm\\:placeholder-orange-700::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .sm\\:placeholder-orange-800::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .sm\\:placeholder-orange-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .sm\\:placeholder-yellow-50::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .sm\\:placeholder-yellow-100::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .sm\\:placeholder-yellow-200::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .sm\\:placeholder-yellow-300::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .sm\\:placeholder-yellow-400::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .sm\\:placeholder-yellow-500::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .sm\\:placeholder-yellow-600::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .sm\\:placeholder-yellow-700::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .sm\\:placeholder-yellow-800::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .sm\\:placeholder-yellow-900::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .sm\\:placeholder-green-50::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .sm\\:placeholder-green-100::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .sm\\:placeholder-green-200::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .sm\\:placeholder-green-300::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .sm\\:placeholder-green-400::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .sm\\:placeholder-green-500::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .sm\\:placeholder-green-600::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .sm\\:placeholder-green-700::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .sm\\:placeholder-green-800::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .sm\\:placeholder-green-900::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .sm\\:placeholder-teal-50::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .sm\\:placeholder-teal-100::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .sm\\:placeholder-teal-200::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .sm\\:placeholder-teal-300::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .sm\\:placeholder-teal-400::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .sm\\:placeholder-teal-500::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .sm\\:placeholder-teal-600::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .sm\\:placeholder-teal-700::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .sm\\:placeholder-teal-800::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .sm\\:placeholder-teal-900::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .sm\\:placeholder-blue-50::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .sm\\:placeholder-blue-100::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .sm\\:placeholder-blue-200::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .sm\\:placeholder-blue-300::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .sm\\:placeholder-blue-400::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .sm\\:placeholder-blue-500::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .sm\\:placeholder-blue-600::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .sm\\:placeholder-blue-700::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .sm\\:placeholder-blue-800::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .sm\\:placeholder-blue-900::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .sm\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .sm\\:placeholder-pink-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .sm\\:placeholder-pink-100::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .sm\\:placeholder-pink-200::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .sm\\:placeholder-pink-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .sm\\:placeholder-pink-400::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .sm\\:placeholder-pink-500::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .sm\\:placeholder-pink-600::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .sm\\:placeholder-pink-700::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .sm\\:placeholder-pink-800::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .sm\\:placeholder-pink-900::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-transparent:focus::placeholder{
    color:#0000
  }

  .sm\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-cool-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-cool-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-cool-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-cool-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-cool-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-cool-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-cool-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-cool-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-cool-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-cool-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-red-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-red-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-red-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-red-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-red-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-red-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-red-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-red-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-red-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-red-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-orange-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-orange-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-orange-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-orange-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-orange-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-orange-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-orange-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-orange-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-orange-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-orange-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-yellow-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-yellow-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-yellow-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-yellow-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-yellow-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-yellow-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-yellow-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-yellow-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-yellow-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-yellow-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-green-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-green-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-green-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-green-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-green-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-green-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-green-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-green-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-green-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-green-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-teal-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-teal-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-teal-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-teal-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-teal-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-teal-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-teal-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-teal-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-teal-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-teal-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-blue-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-blue-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-blue-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-blue-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-blue-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-blue-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-blue-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-blue-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-blue-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-blue-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-pink-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-pink-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-pink-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-pink-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-pink-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-pink-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-pink-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-pink-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-pink-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .sm\\:focus\\:placeholder-pink-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-transparent::placeholder{
    color:#0000
  }

  .theme-dark .sm\\:dark\\:placeholder-white::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-black::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-cool-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-cool-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-cool-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-cool-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-cool-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-cool-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-cool-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-cool-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-cool-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-cool-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-red-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-red-100::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-red-200::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-red-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-red-400::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-red-500::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-red-600::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-red-700::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-red-800::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-red-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-orange-50::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-orange-100::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-orange-200::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-orange-300::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-orange-400::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-orange-500::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-orange-600::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-orange-700::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-orange-800::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-orange-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-yellow-50::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-yellow-100::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-yellow-200::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-yellow-300::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-yellow-400::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-yellow-500::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-yellow-600::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-yellow-700::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-yellow-800::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-yellow-900::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-green-50::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-green-100::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-green-200::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-green-300::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-green-400::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-green-500::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-green-600::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-green-700::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-green-800::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-green-900::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-teal-50::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-teal-100::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-teal-200::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-teal-300::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-teal-400::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-teal-500::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-teal-600::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-teal-700::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-teal-800::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-teal-900::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-blue-50::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-blue-100::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-blue-200::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-blue-300::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-blue-400::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-blue-500::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-blue-600::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-blue-700::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-blue-800::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-blue-900::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-pink-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-pink-100::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-pink-200::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-pink-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-pink-400::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-pink-500::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-pink-600::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-pink-700::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-pink-800::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:placeholder-pink-900::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-transparent:focus::placeholder{
    color:#0000
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-red-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-red-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-red-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-red-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-red-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-red-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-red-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-red-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-red-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-red-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-orange-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-orange-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-orange-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-orange-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-orange-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-orange-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-orange-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-orange-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-orange-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-orange-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-green-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-green-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-green-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-green-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-green-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-green-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-green-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-green-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-green-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-green-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-teal-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-teal-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-teal-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-teal-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-teal-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-teal-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-teal-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-teal-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-teal-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-teal-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-blue-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-blue-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-blue-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-blue-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-blue-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-blue-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-blue-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-blue-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-blue-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-blue-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-pink-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-pink-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-pink-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-pink-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-pink-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-pink-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-pink-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-pink-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-pink-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .theme-dark .sm\\:dark\\:focus\\:placeholder-pink-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .sm\\:placeholder-opacity-0::placeholder{
    --placeholder-opacity:0
  }

  .sm\\:placeholder-opacity-25::placeholder{
    --placeholder-opacity:0.25
  }

  .sm\\:placeholder-opacity-50::placeholder{
    --placeholder-opacity:0.5
  }

  .sm\\:placeholder-opacity-75::placeholder{
    --placeholder-opacity:0.75
  }

  .sm\\:placeholder-opacity-100::placeholder{
    --placeholder-opacity:1
  }

  .sm\\:focus\\:placeholder-opacity-0:focus::placeholder{
    --placeholder-opacity:0
  }

  .sm\\:focus\\:placeholder-opacity-25:focus::placeholder{
    --placeholder-opacity:0.25
  }

  .sm\\:focus\\:placeholder-opacity-50:focus::placeholder{
    --placeholder-opacity:0.5
  }

  .sm\\:focus\\:placeholder-opacity-75:focus::placeholder{
    --placeholder-opacity:0.75
  }

  .sm\\:focus\\:placeholder-opacity-100:focus::placeholder{
    --placeholder-opacity:1
  }

  .sm\\:pointer-events-none{
    pointer-events:none
  }

  .sm\\:pointer-events-auto{
    pointer-events:auto
  }

  .sm\\:static{
    position:static
  }

  .sm\\:fixed{
    position:fixed
  }

  .sm\\:absolute{
    position:absolute
  }

  .sm\\:relative{
    position:relative
  }

  .sm\\:sticky{
    position:sticky
  }

  .sm\\:inset-0{
    bottom:0;
    left:0;
    right:0;
    top:0
  }

  .sm\\:inset-auto{
    bottom:auto;
    left:auto;
    right:auto;
    top:auto
  }

  .sm\\:inset-y-0{
    bottom:0;
    top:0
  }

  .sm\\:inset-x-0{
    left:0;
    right:0
  }

  .sm\\:inset-y-auto{
    bottom:auto;
    top:auto
  }

  .sm\\:inset-x-auto{
    left:auto;
    right:auto
  }

  .sm\\:top-0{
    top:0
  }

  .sm\\:right-0{
    right:0
  }

  .sm\\:bottom-0{
    bottom:0
  }

  .sm\\:left-0{
    left:0
  }

  .sm\\:top-auto{
    top:auto
  }

  .sm\\:right-auto{
    right:auto
  }

  .sm\\:bottom-auto{
    bottom:auto
  }

  .sm\\:left-auto{
    left:auto
  }

  .sm\\:resize-none{
    resize:none
  }

  .sm\\:resize-y{
    resize:vertical
  }

  .sm\\:resize-x{
    resize:horizontal
  }

  .sm\\:resize{
    resize:both
  }

  .sm\\:shadow-xs{
    box-shadow:0 0 0 1px #0000000d
  }

  .sm\\:shadow-sm{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .sm\\:shadow{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .sm\\:shadow-md{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .sm\\:shadow-lg{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .sm\\:shadow-xl{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .sm\\:shadow-2xl{
    box-shadow:0 25px 50px -12px #00000040
  }

  .sm\\:shadow-inner{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .sm\\:shadow-outline{
    box-shadow:0 0 0 3px #4299e180
  }

  .sm\\:shadow-none{
    box-shadow:none
  }

  .sm\\:shadow-bottom{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .sm\\:hover\\:shadow-xs:hover{
    box-shadow:0 0 0 1px #0000000d
  }

  .sm\\:hover\\:shadow-sm:hover{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .sm\\:hover\\:shadow:hover{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .sm\\:hover\\:shadow-md:hover{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .sm\\:hover\\:shadow-lg:hover{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .sm\\:hover\\:shadow-xl:hover{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .sm\\:hover\\:shadow-2xl:hover{
    box-shadow:0 25px 50px -12px #00000040
  }

  .sm\\:hover\\:shadow-inner:hover{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .sm\\:hover\\:shadow-outline:hover{
    box-shadow:0 0 0 3px #4299e180
  }

  .sm\\:hover\\:shadow-none:hover{
    box-shadow:none
  }

  .sm\\:hover\\:shadow-bottom:hover{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .sm\\:focus\\:shadow-xs:focus{
    box-shadow:0 0 0 1px #0000000d
  }

  .sm\\:focus\\:shadow-sm:focus{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .sm\\:focus\\:shadow:focus{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .sm\\:focus\\:shadow-md:focus{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .sm\\:focus\\:shadow-lg:focus{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .sm\\:focus\\:shadow-xl:focus{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .sm\\:focus\\:shadow-2xl:focus{
    box-shadow:0 25px 50px -12px #00000040
  }

  .sm\\:focus\\:shadow-inner:focus{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .sm\\:focus\\:shadow-outline:focus{
    box-shadow:0 0 0 3px #4299e180
  }

  .sm\\:focus\\:shadow-none:focus{
    box-shadow:none
  }

  .sm\\:focus\\:shadow-bottom:focus{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-xs:focus{
    box-shadow:0 0 0 1px #0000000d
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-sm:focus{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow:focus{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-md:focus{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-lg:focus{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-xl:focus{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-2xl:focus{
    box-shadow:0 25px 50px -12px #00000040
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-inner:focus{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-outline:focus{
    box-shadow:0 0 0 3px #4299e180
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-none:focus{
    box-shadow:none
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-bottom:focus{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .sm\\:fill-current{
    fill:currentColor
  }

  .sm\\:stroke-current{
    stroke:currentColor
  }

  .sm\\:stroke-0{
    stroke-width:0
  }

  .sm\\:stroke-1{
    stroke-width:1
  }

  .sm\\:stroke-2{
    stroke-width:2
  }

  .sm\\:table-auto{
    table-layout:auto
  }

  .sm\\:table-fixed{
    table-layout:fixed
  }

  .sm\\:text-left{
    text-align:left
  }

  .sm\\:text-center{
    text-align:center
  }

  .sm\\:text-right{
    text-align:right
  }

  .sm\\:text-justify{
    text-align:justify
  }

  .sm\\:text-transparent{
    color:#0000
  }

  .sm\\:text-white{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .sm\\:text-black{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .sm\\:text-gray-50{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .sm\\:text-gray-100{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .sm\\:text-gray-200{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .sm\\:text-gray-300{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .sm\\:text-gray-400{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .sm\\:text-gray-500{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .sm\\:text-gray-600{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .sm\\:text-gray-700{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .sm\\:text-gray-800{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .sm\\:text-gray-900{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .sm\\:text-cool-gray-50{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .sm\\:text-cool-gray-100{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .sm\\:text-cool-gray-200{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .sm\\:text-cool-gray-300{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .sm\\:text-cool-gray-400{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .sm\\:text-cool-gray-500{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .sm\\:text-cool-gray-600{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .sm\\:text-cool-gray-700{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .sm\\:text-cool-gray-800{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .sm\\:text-cool-gray-900{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .sm\\:text-red-50{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .sm\\:text-red-100{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .sm\\:text-red-200{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .sm\\:text-red-300{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .sm\\:text-red-400{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .sm\\:text-red-500{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .sm\\:text-red-600{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .sm\\:text-red-700{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .sm\\:text-red-800{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .sm\\:text-red-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .sm\\:text-orange-50{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .sm\\:text-orange-100{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .sm\\:text-orange-200{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .sm\\:text-orange-300{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .sm\\:text-orange-400{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .sm\\:text-orange-500{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .sm\\:text-orange-600{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .sm\\:text-orange-700{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .sm\\:text-orange-800{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .sm\\:text-orange-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .sm\\:text-yellow-50{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .sm\\:text-yellow-100{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .sm\\:text-yellow-200{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .sm\\:text-yellow-300{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .sm\\:text-yellow-400{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .sm\\:text-yellow-500{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .sm\\:text-yellow-600{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .sm\\:text-yellow-700{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .sm\\:text-yellow-800{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .sm\\:text-yellow-900{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .sm\\:text-green-50{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .sm\\:text-green-100{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .sm\\:text-green-200{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .sm\\:text-green-300{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .sm\\:text-green-400{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .sm\\:text-green-500{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .sm\\:text-green-600{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .sm\\:text-green-700{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .sm\\:text-green-800{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .sm\\:text-green-900{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .sm\\:text-teal-50{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .sm\\:text-teal-100{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .sm\\:text-teal-200{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .sm\\:text-teal-300{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .sm\\:text-teal-400{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .sm\\:text-teal-500{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .sm\\:text-teal-600{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .sm\\:text-teal-700{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .sm\\:text-teal-800{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .sm\\:text-teal-900{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .sm\\:text-blue-50{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .sm\\:text-blue-100{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .sm\\:text-blue-200{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .sm\\:text-blue-300{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .sm\\:text-blue-400{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .sm\\:text-blue-500{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .sm\\:text-blue-600{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .sm\\:text-blue-700{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .sm\\:text-blue-800{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .sm\\:text-blue-900{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .sm\\:text-indigo-50{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .sm\\:text-indigo-100{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .sm\\:text-indigo-200{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .sm\\:text-indigo-300{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .sm\\:text-indigo-400{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .sm\\:text-indigo-500{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .sm\\:text-indigo-600{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .sm\\:text-indigo-700{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .sm\\:text-indigo-800{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .sm\\:text-indigo-900{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .sm\\:text-indigo-50{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .sm\\:text-indigo-100{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .sm\\:text-indigo-200{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .sm\\:text-indigo-300{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .sm\\:text-indigo-400{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .sm\\:text-indigo-500{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .sm\\:text-indigo-600{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .sm\\:text-indigo-700{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .sm\\:text-indigo-800{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .sm\\:text-indigo-900{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .sm\\:text-pink-50{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .sm\\:text-pink-100{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .sm\\:text-pink-200{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .sm\\:text-pink-300{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .sm\\:text-pink-400{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .sm\\:text-pink-500{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .sm\\:text-pink-600{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .sm\\:text-pink-700{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .sm\\:text-pink-800{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .sm\\:text-pink-900{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .sm\\:focus\\:text-transparent:focus{
    color:#0000
  }

  .sm\\:focus\\:text-white:focus{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .sm\\:focus\\:text-black:focus{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .sm\\:focus\\:text-gray-50:focus{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .sm\\:focus\\:text-gray-100:focus{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .sm\\:focus\\:text-gray-200:focus{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .sm\\:focus\\:text-gray-300:focus{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .sm\\:focus\\:text-gray-400:focus{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .sm\\:focus\\:text-gray-500:focus{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .sm\\:focus\\:text-gray-600:focus{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .sm\\:focus\\:text-gray-700:focus{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .sm\\:focus\\:text-gray-800:focus{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .sm\\:focus\\:text-gray-900:focus{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .sm\\:focus\\:text-cool-gray-50:focus{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .sm\\:focus\\:text-cool-gray-100:focus{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .sm\\:focus\\:text-cool-gray-200:focus{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .sm\\:focus\\:text-cool-gray-300:focus{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .sm\\:focus\\:text-cool-gray-400:focus{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .sm\\:focus\\:text-cool-gray-500:focus{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .sm\\:focus\\:text-cool-gray-600:focus{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .sm\\:focus\\:text-cool-gray-700:focus{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .sm\\:focus\\:text-cool-gray-800:focus{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .sm\\:focus\\:text-cool-gray-900:focus{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .sm\\:focus\\:text-red-50:focus{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .sm\\:focus\\:text-red-100:focus{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .sm\\:focus\\:text-red-200:focus{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .sm\\:focus\\:text-red-300:focus{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .sm\\:focus\\:text-red-400:focus{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .sm\\:focus\\:text-red-500:focus{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .sm\\:focus\\:text-red-600:focus{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .sm\\:focus\\:text-red-700:focus{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .sm\\:focus\\:text-red-800:focus{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .sm\\:focus\\:text-red-900:focus{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .sm\\:focus\\:text-orange-50:focus{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .sm\\:focus\\:text-orange-100:focus{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .sm\\:focus\\:text-orange-200:focus{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .sm\\:focus\\:text-orange-300:focus{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .sm\\:focus\\:text-orange-400:focus{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .sm\\:focus\\:text-orange-500:focus{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .sm\\:focus\\:text-orange-600:focus{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .sm\\:focus\\:text-orange-700:focus{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .sm\\:focus\\:text-orange-800:focus{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .sm\\:focus\\:text-orange-900:focus{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .sm\\:focus\\:text-yellow-50:focus{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .sm\\:focus\\:text-yellow-100:focus{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .sm\\:focus\\:text-yellow-200:focus{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .sm\\:focus\\:text-yellow-300:focus{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .sm\\:focus\\:text-yellow-400:focus{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .sm\\:focus\\:text-yellow-500:focus{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .sm\\:focus\\:text-yellow-600:focus{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .sm\\:focus\\:text-yellow-700:focus{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .sm\\:focus\\:text-yellow-800:focus{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .sm\\:focus\\:text-yellow-900:focus{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .sm\\:focus\\:text-green-50:focus{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .sm\\:focus\\:text-green-100:focus{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .sm\\:focus\\:text-green-200:focus{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .sm\\:focus\\:text-green-300:focus{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .sm\\:focus\\:text-green-400:focus{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .sm\\:focus\\:text-green-500:focus{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .sm\\:focus\\:text-green-600:focus{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .sm\\:focus\\:text-green-700:focus{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .sm\\:focus\\:text-green-800:focus{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .sm\\:focus\\:text-green-900:focus{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .sm\\:focus\\:text-teal-50:focus{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .sm\\:focus\\:text-teal-100:focus{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .sm\\:focus\\:text-teal-200:focus{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .sm\\:focus\\:text-teal-300:focus{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .sm\\:focus\\:text-teal-400:focus{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .sm\\:focus\\:text-teal-500:focus{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .sm\\:focus\\:text-teal-600:focus{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .sm\\:focus\\:text-teal-700:focus{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .sm\\:focus\\:text-teal-800:focus{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .sm\\:focus\\:text-teal-900:focus{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .sm\\:focus\\:text-blue-50:focus{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .sm\\:focus\\:text-blue-100:focus{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .sm\\:focus\\:text-blue-200:focus{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .sm\\:focus\\:text-blue-300:focus{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .sm\\:focus\\:text-blue-400:focus{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .sm\\:focus\\:text-blue-500:focus{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .sm\\:focus\\:text-blue-600:focus{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .sm\\:focus\\:text-blue-700:focus{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .sm\\:focus\\:text-blue-800:focus{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .sm\\:focus\\:text-blue-900:focus{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-50:focus{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-100:focus{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-200:focus{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-300:focus{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-400:focus{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-500:focus{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-600:focus{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-700:focus{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-800:focus{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-900:focus{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-50:focus{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-100:focus{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-200:focus{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-300:focus{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-400:focus{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-500:focus{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-600:focus{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-700:focus{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-800:focus{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .sm\\:focus\\:text-indigo-900:focus{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .sm\\:focus\\:text-pink-50:focus{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .sm\\:focus\\:text-pink-100:focus{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .sm\\:focus\\:text-pink-200:focus{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .sm\\:focus\\:text-pink-300:focus{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .sm\\:focus\\:text-pink-400:focus{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .sm\\:focus\\:text-pink-500:focus{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .sm\\:focus\\:text-pink-600:focus{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .sm\\:focus\\:text-pink-700:focus{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .sm\\:focus\\:text-pink-800:focus{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .sm\\:focus\\:text-pink-900:focus{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-transparent:focus-within{
    color:#0000
  }

  .sm\\:focus-within\\:text-white:focus-within{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-black:focus-within{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-gray-50:focus-within{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-gray-100:focus-within{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-gray-200:focus-within{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-gray-300:focus-within{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-gray-400:focus-within{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-gray-500:focus-within{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-gray-600:focus-within{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-gray-700:focus-within{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-gray-800:focus-within{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-gray-900:focus-within{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-cool-gray-50:focus-within{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-cool-gray-100:focus-within{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-cool-gray-200:focus-within{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-cool-gray-300:focus-within{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-cool-gray-400:focus-within{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-cool-gray-500:focus-within{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-cool-gray-600:focus-within{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-cool-gray-700:focus-within{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-cool-gray-800:focus-within{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-cool-gray-900:focus-within{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-red-50:focus-within{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-red-100:focus-within{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-red-200:focus-within{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-red-300:focus-within{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-red-400:focus-within{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-red-500:focus-within{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-red-600:focus-within{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-red-700:focus-within{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-red-800:focus-within{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-red-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-orange-50:focus-within{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-orange-100:focus-within{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-orange-200:focus-within{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-orange-300:focus-within{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-orange-400:focus-within{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-orange-500:focus-within{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-orange-600:focus-within{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-orange-700:focus-within{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-orange-800:focus-within{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-orange-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-yellow-50:focus-within{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-yellow-100:focus-within{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-yellow-200:focus-within{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-yellow-300:focus-within{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-yellow-400:focus-within{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-yellow-500:focus-within{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-yellow-600:focus-within{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-yellow-700:focus-within{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-yellow-800:focus-within{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-yellow-900:focus-within{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-green-50:focus-within{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-green-100:focus-within{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-green-200:focus-within{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-green-300:focus-within{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-green-400:focus-within{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-green-500:focus-within{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-green-600:focus-within{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-green-700:focus-within{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-green-800:focus-within{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-green-900:focus-within{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-teal-50:focus-within{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-teal-100:focus-within{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-teal-200:focus-within{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-teal-300:focus-within{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-teal-400:focus-within{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-teal-500:focus-within{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-teal-600:focus-within{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-teal-700:focus-within{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-teal-800:focus-within{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-teal-900:focus-within{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-blue-50:focus-within{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-blue-100:focus-within{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-blue-200:focus-within{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-blue-300:focus-within{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-blue-400:focus-within{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-blue-500:focus-within{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-blue-600:focus-within{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-blue-700:focus-within{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-blue-800:focus-within{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-blue-900:focus-within{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-pink-50:focus-within{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-pink-100:focus-within{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-pink-200:focus-within{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-pink-300:focus-within{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-pink-400:focus-within{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-pink-500:focus-within{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-pink-600:focus-within{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-pink-700:focus-within{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-pink-800:focus-within{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .sm\\:focus-within\\:text-pink-900:focus-within{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .sm\\:hover\\:text-transparent:hover{
    color:#0000
  }

  .sm\\:hover\\:text-white:hover{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .sm\\:hover\\:text-black:hover{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .sm\\:hover\\:text-gray-50:hover{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .sm\\:hover\\:text-gray-100:hover{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .sm\\:hover\\:text-gray-200:hover{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .sm\\:hover\\:text-gray-300:hover{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .sm\\:hover\\:text-gray-400:hover{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .sm\\:hover\\:text-gray-500:hover{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .sm\\:hover\\:text-gray-600:hover{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .sm\\:hover\\:text-gray-700:hover{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .sm\\:hover\\:text-gray-800:hover{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .sm\\:hover\\:text-gray-900:hover{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .sm\\:hover\\:text-cool-gray-50:hover{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .sm\\:hover\\:text-cool-gray-100:hover{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .sm\\:hover\\:text-cool-gray-200:hover{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .sm\\:hover\\:text-cool-gray-300:hover{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .sm\\:hover\\:text-cool-gray-400:hover{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .sm\\:hover\\:text-cool-gray-500:hover{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .sm\\:hover\\:text-cool-gray-600:hover{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .sm\\:hover\\:text-cool-gray-700:hover{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .sm\\:hover\\:text-cool-gray-800:hover{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .sm\\:hover\\:text-cool-gray-900:hover{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .sm\\:hover\\:text-red-50:hover{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .sm\\:hover\\:text-red-100:hover{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .sm\\:hover\\:text-red-200:hover{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .sm\\:hover\\:text-red-300:hover{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .sm\\:hover\\:text-red-400:hover{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .sm\\:hover\\:text-red-500:hover{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .sm\\:hover\\:text-red-600:hover{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .sm\\:hover\\:text-red-700:hover{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .sm\\:hover\\:text-red-800:hover{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .sm\\:hover\\:text-red-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .sm\\:hover\\:text-orange-50:hover{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .sm\\:hover\\:text-orange-100:hover{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .sm\\:hover\\:text-orange-200:hover{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .sm\\:hover\\:text-orange-300:hover{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .sm\\:hover\\:text-orange-400:hover{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .sm\\:hover\\:text-orange-500:hover{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .sm\\:hover\\:text-orange-600:hover{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .sm\\:hover\\:text-orange-700:hover{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .sm\\:hover\\:text-orange-800:hover{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .sm\\:hover\\:text-orange-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .sm\\:hover\\:text-yellow-50:hover{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .sm\\:hover\\:text-yellow-100:hover{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .sm\\:hover\\:text-yellow-200:hover{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .sm\\:hover\\:text-yellow-300:hover{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .sm\\:hover\\:text-yellow-400:hover{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .sm\\:hover\\:text-yellow-500:hover{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .sm\\:hover\\:text-yellow-600:hover{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .sm\\:hover\\:text-yellow-700:hover{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .sm\\:hover\\:text-yellow-800:hover{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .sm\\:hover\\:text-yellow-900:hover{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .sm\\:hover\\:text-green-50:hover{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .sm\\:hover\\:text-green-100:hover{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .sm\\:hover\\:text-green-200:hover{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .sm\\:hover\\:text-green-300:hover{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .sm\\:hover\\:text-green-400:hover{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .sm\\:hover\\:text-green-500:hover{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .sm\\:hover\\:text-green-600:hover{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .sm\\:hover\\:text-green-700:hover{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .sm\\:hover\\:text-green-800:hover{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .sm\\:hover\\:text-green-900:hover{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .sm\\:hover\\:text-teal-50:hover{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .sm\\:hover\\:text-teal-100:hover{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .sm\\:hover\\:text-teal-200:hover{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .sm\\:hover\\:text-teal-300:hover{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .sm\\:hover\\:text-teal-400:hover{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .sm\\:hover\\:text-teal-500:hover{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .sm\\:hover\\:text-teal-600:hover{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .sm\\:hover\\:text-teal-700:hover{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .sm\\:hover\\:text-teal-800:hover{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .sm\\:hover\\:text-teal-900:hover{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .sm\\:hover\\:text-blue-50:hover{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .sm\\:hover\\:text-blue-100:hover{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .sm\\:hover\\:text-blue-200:hover{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .sm\\:hover\\:text-blue-300:hover{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .sm\\:hover\\:text-blue-400:hover{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .sm\\:hover\\:text-blue-500:hover{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .sm\\:hover\\:text-blue-600:hover{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .sm\\:hover\\:text-blue-700:hover{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .sm\\:hover\\:text-blue-800:hover{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .sm\\:hover\\:text-blue-900:hover{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .sm\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .sm\\:hover\\:text-pink-50:hover{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .sm\\:hover\\:text-pink-100:hover{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .sm\\:hover\\:text-pink-200:hover{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .sm\\:hover\\:text-pink-300:hover{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .sm\\:hover\\:text-pink-400:hover{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .sm\\:hover\\:text-pink-500:hover{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .sm\\:hover\\:text-pink-600:hover{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .sm\\:hover\\:text-pink-700:hover{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .sm\\:hover\\:text-pink-800:hover{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .sm\\:hover\\:text-pink-900:hover{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .sm\\:active\\:text-transparent:active{
    color:#0000
  }

  .sm\\:active\\:text-white:active{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .sm\\:active\\:text-black:active{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .sm\\:active\\:text-gray-50:active{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .sm\\:active\\:text-gray-100:active{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .sm\\:active\\:text-gray-200:active{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .sm\\:active\\:text-gray-300:active{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .sm\\:active\\:text-gray-400:active{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .sm\\:active\\:text-gray-500:active{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .sm\\:active\\:text-gray-600:active{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .sm\\:active\\:text-gray-700:active{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .sm\\:active\\:text-gray-800:active{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .sm\\:active\\:text-gray-900:active{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .sm\\:active\\:text-cool-gray-50:active{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .sm\\:active\\:text-cool-gray-100:active{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .sm\\:active\\:text-cool-gray-200:active{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .sm\\:active\\:text-cool-gray-300:active{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .sm\\:active\\:text-cool-gray-400:active{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .sm\\:active\\:text-cool-gray-500:active{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .sm\\:active\\:text-cool-gray-600:active{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .sm\\:active\\:text-cool-gray-700:active{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .sm\\:active\\:text-cool-gray-800:active{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .sm\\:active\\:text-cool-gray-900:active{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .sm\\:active\\:text-red-50:active{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .sm\\:active\\:text-red-100:active{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .sm\\:active\\:text-red-200:active{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .sm\\:active\\:text-red-300:active{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .sm\\:active\\:text-red-400:active{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .sm\\:active\\:text-red-500:active{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .sm\\:active\\:text-red-600:active{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .sm\\:active\\:text-red-700:active{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .sm\\:active\\:text-red-800:active{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .sm\\:active\\:text-red-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .sm\\:active\\:text-orange-50:active{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .sm\\:active\\:text-orange-100:active{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .sm\\:active\\:text-orange-200:active{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .sm\\:active\\:text-orange-300:active{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .sm\\:active\\:text-orange-400:active{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .sm\\:active\\:text-orange-500:active{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .sm\\:active\\:text-orange-600:active{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .sm\\:active\\:text-orange-700:active{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .sm\\:active\\:text-orange-800:active{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .sm\\:active\\:text-orange-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .sm\\:active\\:text-yellow-50:active{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .sm\\:active\\:text-yellow-100:active{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .sm\\:active\\:text-yellow-200:active{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .sm\\:active\\:text-yellow-300:active{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .sm\\:active\\:text-yellow-400:active{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .sm\\:active\\:text-yellow-500:active{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .sm\\:active\\:text-yellow-600:active{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .sm\\:active\\:text-yellow-700:active{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .sm\\:active\\:text-yellow-800:active{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .sm\\:active\\:text-yellow-900:active{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .sm\\:active\\:text-green-50:active{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .sm\\:active\\:text-green-100:active{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .sm\\:active\\:text-green-200:active{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .sm\\:active\\:text-green-300:active{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .sm\\:active\\:text-green-400:active{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .sm\\:active\\:text-green-500:active{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .sm\\:active\\:text-green-600:active{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .sm\\:active\\:text-green-700:active{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .sm\\:active\\:text-green-800:active{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .sm\\:active\\:text-green-900:active{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .sm\\:active\\:text-teal-50:active{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .sm\\:active\\:text-teal-100:active{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .sm\\:active\\:text-teal-200:active{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .sm\\:active\\:text-teal-300:active{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .sm\\:active\\:text-teal-400:active{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .sm\\:active\\:text-teal-500:active{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .sm\\:active\\:text-teal-600:active{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .sm\\:active\\:text-teal-700:active{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .sm\\:active\\:text-teal-800:active{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .sm\\:active\\:text-teal-900:active{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .sm\\:active\\:text-blue-50:active{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .sm\\:active\\:text-blue-100:active{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .sm\\:active\\:text-blue-200:active{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .sm\\:active\\:text-blue-300:active{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .sm\\:active\\:text-blue-400:active{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .sm\\:active\\:text-blue-500:active{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .sm\\:active\\:text-blue-600:active{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .sm\\:active\\:text-blue-700:active{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .sm\\:active\\:text-blue-800:active{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .sm\\:active\\:text-blue-900:active{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .sm\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .sm\\:active\\:text-pink-50:active{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .sm\\:active\\:text-pink-100:active{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .sm\\:active\\:text-pink-200:active{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .sm\\:active\\:text-pink-300:active{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .sm\\:active\\:text-pink-400:active{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .sm\\:active\\:text-pink-500:active{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .sm\\:active\\:text-pink-600:active{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .sm\\:active\\:text-pink-700:active{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .sm\\:active\\:text-pink-800:active{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .sm\\:active\\:text-pink-900:active{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-transparent{
    color:#0000
  }

  .theme-dark .sm\\:dark\\:text-white{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-black{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-gray-50{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-gray-100{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-gray-200{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-gray-300{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-gray-400{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-gray-500{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-gray-600{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-gray-700{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-gray-800{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-gray-900{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-cool-gray-50{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-cool-gray-100{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-cool-gray-200{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-cool-gray-300{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-cool-gray-400{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-cool-gray-500{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-cool-gray-600{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-cool-gray-700{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-cool-gray-800{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-cool-gray-900{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-red-50{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-red-100{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-red-200{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-red-300{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-red-400{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-red-500{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-red-600{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-red-700{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-red-800{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-red-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-orange-50{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-orange-100{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-orange-200{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-orange-300{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-orange-400{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-orange-500{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-orange-600{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-orange-700{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-orange-800{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-orange-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-yellow-50{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-yellow-100{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-yellow-200{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-yellow-300{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-yellow-400{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-yellow-500{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-yellow-600{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-yellow-700{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-yellow-800{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-yellow-900{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-green-50{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-green-100{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-green-200{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-green-300{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-green-400{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-green-500{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-green-600{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-green-700{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-green-800{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-green-900{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-teal-50{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-teal-100{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-teal-200{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-teal-300{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-teal-400{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-teal-500{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-teal-600{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-teal-700{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-teal-800{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-teal-900{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-blue-50{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-blue-100{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-blue-200{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-blue-300{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-blue-400{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-blue-500{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-blue-600{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-blue-700{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-blue-800{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-blue-900{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-50{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-100{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-200{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-300{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-400{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-500{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-600{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-700{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-800{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-900{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-50{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-100{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-200{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-300{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-400{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-500{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-600{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-700{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-800{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-indigo-900{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-pink-50{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-pink-100{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-pink-200{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-pink-300{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-pink-400{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-pink-500{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-pink-600{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-pink-700{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-pink-800{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:text-pink-900{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-transparent:focus-within{
    color:#0000
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-white:focus-within{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-black:focus-within{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-gray-50:focus-within{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-gray-100:focus-within{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-gray-200:focus-within{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-gray-300:focus-within{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-gray-400:focus-within{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-gray-500:focus-within{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-gray-600:focus-within{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-gray-700:focus-within{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-gray-800:focus-within{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-gray-900:focus-within{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-50:focus-within{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-100:focus-within{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-200:focus-within{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-300:focus-within{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-400:focus-within{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-500:focus-within{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-600:focus-within{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-700:focus-within{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-800:focus-within{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-900:focus-within{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-red-50:focus-within{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-red-100:focus-within{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-red-200:focus-within{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-red-300:focus-within{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-red-400:focus-within{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-red-500:focus-within{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-red-600:focus-within{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-red-700:focus-within{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-red-800:focus-within{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-red-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-orange-50:focus-within{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-orange-100:focus-within{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-orange-200:focus-within{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-orange-300:focus-within{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-orange-400:focus-within{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-orange-500:focus-within{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-orange-600:focus-within{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-orange-700:focus-within{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-orange-800:focus-within{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-orange-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-yellow-50:focus-within{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-yellow-100:focus-within{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-yellow-200:focus-within{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-yellow-300:focus-within{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-yellow-400:focus-within{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-yellow-500:focus-within{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-yellow-600:focus-within{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-yellow-700:focus-within{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-yellow-800:focus-within{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-yellow-900:focus-within{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-green-50:focus-within{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-green-100:focus-within{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-green-200:focus-within{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-green-300:focus-within{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-green-400:focus-within{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-green-500:focus-within{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-green-600:focus-within{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-green-700:focus-within{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-green-800:focus-within{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-green-900:focus-within{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-teal-50:focus-within{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-teal-100:focus-within{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-teal-200:focus-within{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-teal-300:focus-within{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-teal-400:focus-within{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-teal-500:focus-within{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-teal-600:focus-within{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-teal-700:focus-within{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-teal-800:focus-within{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-teal-900:focus-within{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-blue-50:focus-within{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-blue-100:focus-within{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-blue-200:focus-within{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-blue-300:focus-within{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-blue-400:focus-within{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-blue-500:focus-within{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-blue-600:focus-within{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-blue-700:focus-within{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-blue-800:focus-within{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-blue-900:focus-within{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-pink-50:focus-within{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-pink-100:focus-within{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-pink-200:focus-within{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-pink-300:focus-within{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-pink-400:focus-within{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-pink-500:focus-within{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-pink-600:focus-within{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-pink-700:focus-within{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-pink-800:focus-within{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:focus-within\\:text-pink-900:focus-within{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-transparent:hover{
    color:#0000
  }

  .theme-dark .sm\\:dark\\:hover\\:text-white:hover{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-black:hover{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-gray-50:hover{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-gray-100:hover{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-gray-200:hover{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-gray-300:hover{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-gray-400:hover{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-gray-500:hover{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-gray-600:hover{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-gray-700:hover{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-gray-800:hover{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-gray-900:hover{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-cool-gray-50:hover{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-cool-gray-100:hover{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-cool-gray-200:hover{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-cool-gray-300:hover{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-cool-gray-400:hover{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-cool-gray-500:hover{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-cool-gray-600:hover{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-cool-gray-700:hover{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-cool-gray-800:hover{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-cool-gray-900:hover{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-red-50:hover{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-red-100:hover{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-red-200:hover{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-red-300:hover{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-red-400:hover{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-red-500:hover{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-red-600:hover{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-red-700:hover{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-red-800:hover{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-red-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-orange-50:hover{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-orange-100:hover{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-orange-200:hover{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-orange-300:hover{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-orange-400:hover{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-orange-500:hover{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-orange-600:hover{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-orange-700:hover{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-orange-800:hover{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-orange-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-yellow-50:hover{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-yellow-100:hover{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-yellow-200:hover{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-yellow-300:hover{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-yellow-400:hover{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-yellow-500:hover{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-yellow-600:hover{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-yellow-700:hover{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-yellow-800:hover{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-yellow-900:hover{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-green-50:hover{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-green-100:hover{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-green-200:hover{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-green-300:hover{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-green-400:hover{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-green-500:hover{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-green-600:hover{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-green-700:hover{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-green-800:hover{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-green-900:hover{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-teal-50:hover{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-teal-100:hover{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-teal-200:hover{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-teal-300:hover{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-teal-400:hover{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-teal-500:hover{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-teal-600:hover{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-teal-700:hover{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-teal-800:hover{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-teal-900:hover{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-blue-50:hover{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-blue-100:hover{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-blue-200:hover{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-blue-300:hover{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-blue-400:hover{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-blue-500:hover{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-blue-600:hover{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-blue-700:hover{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-blue-800:hover{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-blue-900:hover{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-pink-50:hover{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-pink-100:hover{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-pink-200:hover{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-pink-300:hover{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-pink-400:hover{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-pink-500:hover{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-pink-600:hover{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-pink-700:hover{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-pink-800:hover{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:hover\\:text-pink-900:hover{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-transparent:active{
    color:#0000
  }

  .theme-dark .sm\\:dark\\:active\\:text-white:active{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-black:active{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-gray-50:active{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-gray-100:active{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-gray-200:active{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-gray-300:active{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-gray-400:active{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-gray-500:active{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-gray-600:active{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-gray-700:active{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-gray-800:active{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-gray-900:active{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-cool-gray-50:active{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-cool-gray-100:active{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-cool-gray-200:active{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-cool-gray-300:active{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-cool-gray-400:active{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-cool-gray-500:active{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-cool-gray-600:active{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-cool-gray-700:active{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-cool-gray-800:active{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-cool-gray-900:active{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-red-50:active{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-red-100:active{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-red-200:active{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-red-300:active{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-red-400:active{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-red-500:active{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-red-600:active{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-red-700:active{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-red-800:active{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-red-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-orange-50:active{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-orange-100:active{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-orange-200:active{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-orange-300:active{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-orange-400:active{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-orange-500:active{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-orange-600:active{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-orange-700:active{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-orange-800:active{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-orange-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-yellow-50:active{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-yellow-100:active{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-yellow-200:active{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-yellow-300:active{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-yellow-400:active{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-yellow-500:active{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-yellow-600:active{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-yellow-700:active{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-yellow-800:active{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-yellow-900:active{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-green-50:active{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-green-100:active{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-green-200:active{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-green-300:active{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-green-400:active{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-green-500:active{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-green-600:active{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-green-700:active{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-green-800:active{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-green-900:active{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-teal-50:active{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-teal-100:active{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-teal-200:active{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-teal-300:active{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-teal-400:active{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-teal-500:active{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-teal-600:active{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-teal-700:active{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-teal-800:active{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-teal-900:active{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-blue-50:active{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-blue-100:active{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-blue-200:active{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-blue-300:active{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-blue-400:active{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-blue-500:active{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-blue-600:active{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-blue-700:active{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-blue-800:active{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-blue-900:active{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-pink-50:active{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-pink-100:active{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-pink-200:active{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-pink-300:active{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-pink-400:active{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-pink-500:active{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-pink-600:active{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-pink-700:active{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-pink-800:active{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .sm\\:dark\\:active\\:text-pink-900:active{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .sm\\:text-opacity-0{
    --text-opacity:0
  }

  .sm\\:text-opacity-25{
    --text-opacity:0.25
  }

  .sm\\:text-opacity-50{
    --text-opacity:0.5
  }

  .sm\\:text-opacity-75{
    --text-opacity:0.75
  }

  .sm\\:text-opacity-100{
    --text-opacity:1
  }

  .sm\\:hover\\:text-opacity-0:hover{
    --text-opacity:0
  }

  .sm\\:hover\\:text-opacity-25:hover{
    --text-opacity:0.25
  }

  .sm\\:hover\\:text-opacity-50:hover{
    --text-opacity:0.5
  }

  .sm\\:hover\\:text-opacity-75:hover{
    --text-opacity:0.75
  }

  .sm\\:hover\\:text-opacity-100:hover{
    --text-opacity:1
  }

  .sm\\:focus\\:text-opacity-0:focus{
    --text-opacity:0
  }

  .sm\\:focus\\:text-opacity-25:focus{
    --text-opacity:0.25
  }

  .sm\\:focus\\:text-opacity-50:focus{
    --text-opacity:0.5
  }

  .sm\\:focus\\:text-opacity-75:focus{
    --text-opacity:0.75
  }

  .sm\\:focus\\:text-opacity-100:focus{
    --text-opacity:1
  }

  .sm\\:italic{
    font-style:italic
  }

  .sm\\:not-italic{
    font-style:normal
  }

  .sm\\:uppercase{
    text-transform:uppercase
  }

  .sm\\:lowercase{
    text-transform:lowercase
  }

  .sm\\:capitalize{
    text-transform:capitalize
  }

  .sm\\:normal-case{
    text-transform:none
  }

  .sm\\:underline{
    text-decoration:underline
  }

  .sm\\:line-through{
    text-decoration:line-through
  }

  .sm\\:no-underline{
    text-decoration:none
  }

  .sm\\:hover\\:underline:hover{
    text-decoration:underline
  }

  .sm\\:hover\\:line-through:hover{
    text-decoration:line-through
  }

  .sm\\:hover\\:no-underline:hover{
    text-decoration:none
  }

  .sm\\:focus\\:underline:focus{
    text-decoration:underline
  }

  .sm\\:focus\\:line-through:focus{
    text-decoration:line-through
  }

  .sm\\:focus\\:no-underline:focus{
    text-decoration:none
  }

  .sm\\:antialiased{
    -webkit-font-smoothing:antialiased;
    -moz-osx-font-smoothing:grayscale
  }

  .sm\\:subpixel-antialiased{
    -webkit-font-smoothing:auto;
    -moz-osx-font-smoothing:auto
  }

  .sm\\:tracking-tighter{
    letter-spacing:-.05em
  }

  .sm\\:tracking-tight{
    letter-spacing:-.025em
  }

  .sm\\:tracking-normal{
    letter-spacing:0
  }

  .sm\\:tracking-wide{
    letter-spacing:.025em
  }

  .sm\\:tracking-wider{
    letter-spacing:.05em
  }

  .sm\\:tracking-widest{
    letter-spacing:.1em
  }

  .sm\\:select-none{
    -webkit-user-select:none;
    user-select:none
  }

  .sm\\:select-text{
    -webkit-user-select:text;
    user-select:text
  }

  .sm\\:select-all{
    -webkit-user-select:all;
    user-select:all
  }

  .sm\\:select-auto{
    -webkit-user-select:auto;
    user-select:auto
  }

  .sm\\:align-baseline{
    vertical-align:initial
  }

  .sm\\:align-top{
    vertical-align:top
  }

  .sm\\:align-middle{
    vertical-align:middle
  }

  .sm\\:align-bottom{
    vertical-align:bottom
  }

  .sm\\:align-text-top{
    vertical-align:text-top
  }

  .sm\\:align-text-bottom{
    vertical-align:text-bottom
  }

  .sm\\:visible{
    visibility:visible
  }

  .sm\\:invisible{
    visibility:hidden
  }

  .sm\\:whitespace-normal{
    white-space:normal
  }

  .sm\\:whitespace-no-wrap{
    white-space:nowrap
  }

  .sm\\:whitespace-pre{
    white-space:pre
  }

  .sm\\:whitespace-pre-line{
    white-space:pre-line
  }

  .sm\\:whitespace-pre-wrap{
    white-space:pre-wrap
  }

  .sm\\:break-normal{
    overflow-wrap:normal;
    word-break:normal
  }

  .sm\\:break-words{
    overflow-wrap:break-word
  }

  .sm\\:break-all{
    word-break:break-all
  }

  .sm\\:truncate{
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
  }

  .sm\\:w-0{
    width:0
  }

  .sm\\:w-1{
    width:.25rem
  }

  .sm\\:w-2{
    width:.5rem
  }

  .sm\\:w-3{
    width:.75rem
  }

  .sm\\:w-4{
    width:1rem
  }

  .sm\\:w-5{
    width:1.25rem
  }

  .sm\\:w-6{
    width:1.5rem
  }

  .sm\\:w-8{
    width:2rem
  }

  .sm\\:w-10{
    width:2.5rem
  }

  .sm\\:w-12{
    width:3rem
  }

  .sm\\:w-16{
    width:4rem
  }

  .sm\\:w-20{
    width:5rem
  }

  .sm\\:w-24{
    width:6rem
  }

  .sm\\:w-32{
    width:8rem
  }

  .sm\\:w-40{
    width:10rem
  }

  .sm\\:w-48{
    width:12rem
  }

  .sm\\:w-56{
    width:14rem
  }

  .sm\\:w-64{
    width:16rem
  }

  .sm\\:w-auto{
    width:auto
  }

  .sm\\:w-px{
    width:1px
  }

  .sm\\:w-1\\/2{
    width:50%
  }

  .sm\\:w-1\\/3{
    width:33.333333%
  }

  .sm\\:w-2\\/3{
    width:66.666667%
  }

  .sm\\:w-1\\/4{
    width:25%
  }

  .sm\\:w-2\\/4{
    width:50%
  }

  .sm\\:w-3\\/4{
    width:75%
  }

  .sm\\:w-1\\/5{
    width:20%
  }

  .sm\\:w-2\\/5{
    width:40%
  }

  .sm\\:w-3\\/5{
    width:60%
  }

  .sm\\:w-4\\/5{
    width:80%
  }

  .sm\\:w-1\\/6{
    width:16.666667%
  }

  .sm\\:w-2\\/6{
    width:33.333333%
  }

  .sm\\:w-3\\/6{
    width:50%
  }

  .sm\\:w-4\\/6{
    width:66.666667%
  }

  .sm\\:w-5\\/6{
    width:83.333333%
  }

  .sm\\:w-1\\/12{
    width:8.333333%
  }

  .sm\\:w-2\\/12{
    width:16.666667%
  }

  .sm\\:w-3\\/12{
    width:25%
  }

  .sm\\:w-4\\/12{
    width:33.333333%
  }

  .sm\\:w-5\\/12{
    width:41.666667%
  }

  .sm\\:w-6\\/12{
    width:50%
  }

  .sm\\:w-7\\/12{
    width:58.333333%
  }

  .sm\\:w-8\\/12{
    width:66.666667%
  }

  .sm\\:w-9\\/12{
    width:75%
  }

  .sm\\:w-10\\/12{
    width:83.333333%
  }

  .sm\\:w-11\\/12{
    width:91.666667%
  }

  .sm\\:w-full{
    width:100%
  }

  .sm\\:w-screen{
    width:100vw
  }

  .sm\\:z-0{
    z-index:0
  }

  .sm\\:z-10{
    z-index:10
  }

  .sm\\:z-20{
    z-index:20
  }

  .sm\\:z-30{
    z-index:30
  }

  .sm\\:z-40{
    z-index:40
  }

  .sm\\:z-50{
    z-index:50
  }

  .sm\\:z-auto{
    z-index:auto
  }

  .sm\\:gap-0{
    grid-gap:0;
    gap:0
  }

  .sm\\:gap-1{
    grid-gap:.25rem;
    gap:.25rem
  }

  .sm\\:gap-2{
    grid-gap:.5rem;
    gap:.5rem
  }

  .sm\\:gap-3{
    grid-gap:.75rem;
    gap:.75rem
  }

  .sm\\:gap-4{
    grid-gap:1rem;
    gap:1rem
  }

  .sm\\:gap-5{
    grid-gap:1.25rem;
    gap:1.25rem
  }

  .sm\\:gap-6{
    grid-gap:1.5rem;
    gap:1.5rem
  }

  .sm\\:gap-8{
    grid-gap:2rem;
    gap:2rem
  }

  .sm\\:gap-10{
    grid-gap:2.5rem;
    gap:2.5rem
  }

  .sm\\:gap-12{
    grid-gap:3rem;
    gap:3rem
  }

  .sm\\:gap-16{
    grid-gap:4rem;
    gap:4rem
  }

  .sm\\:gap-20{
    grid-gap:5rem;
    gap:5rem
  }

  .sm\\:gap-24{
    grid-gap:6rem;
    gap:6rem
  }

  .sm\\:gap-32{
    grid-gap:8rem;
    gap:8rem
  }

  .sm\\:gap-40{
    grid-gap:10rem;
    gap:10rem
  }

  .sm\\:gap-48{
    grid-gap:12rem;
    gap:12rem
  }

  .sm\\:gap-56{
    grid-gap:14rem;
    gap:14rem
  }

  .sm\\:gap-64{
    grid-gap:16rem;
    gap:16rem
  }

  .sm\\:gap-px{
    grid-gap:1px;
    gap:1px
  }

  .sm\\:col-gap-0{
    grid-column-gap:0;
    column-gap:0
  }

  .sm\\:col-gap-1{
    grid-column-gap:.25rem;
    column-gap:.25rem
  }

  .sm\\:col-gap-2{
    grid-column-gap:.5rem;
    column-gap:.5rem
  }

  .sm\\:col-gap-3{
    grid-column-gap:.75rem;
    column-gap:.75rem
  }

  .sm\\:col-gap-4{
    grid-column-gap:1rem;
    column-gap:1rem
  }

  .sm\\:col-gap-5{
    grid-column-gap:1.25rem;
    column-gap:1.25rem
  }

  .sm\\:col-gap-6{
    grid-column-gap:1.5rem;
    column-gap:1.5rem
  }

  .sm\\:col-gap-8{
    grid-column-gap:2rem;
    column-gap:2rem
  }

  .sm\\:col-gap-10{
    grid-column-gap:2.5rem;
    column-gap:2.5rem
  }

  .sm\\:col-gap-12{
    grid-column-gap:3rem;
    column-gap:3rem
  }

  .sm\\:col-gap-16{
    grid-column-gap:4rem;
    column-gap:4rem
  }

  .sm\\:col-gap-20{
    grid-column-gap:5rem;
    column-gap:5rem
  }

  .sm\\:col-gap-24{
    grid-column-gap:6rem;
    column-gap:6rem
  }

  .sm\\:col-gap-32{
    grid-column-gap:8rem;
    column-gap:8rem
  }

  .sm\\:col-gap-40{
    grid-column-gap:10rem;
    column-gap:10rem
  }

  .sm\\:col-gap-48{
    grid-column-gap:12rem;
    column-gap:12rem
  }

  .sm\\:col-gap-56{
    grid-column-gap:14rem;
    column-gap:14rem
  }

  .sm\\:col-gap-64{
    grid-column-gap:16rem;
    column-gap:16rem
  }

  .sm\\:col-gap-px{
    grid-column-gap:1px;
    column-gap:1px
  }

  .sm\\:row-gap-0{
    grid-row-gap:0;
    row-gap:0
  }

  .sm\\:row-gap-1{
    grid-row-gap:.25rem;
    row-gap:.25rem
  }

  .sm\\:row-gap-2{
    grid-row-gap:.5rem;
    row-gap:.5rem
  }

  .sm\\:row-gap-3{
    grid-row-gap:.75rem;
    row-gap:.75rem
  }

  .sm\\:row-gap-4{
    grid-row-gap:1rem;
    row-gap:1rem
  }

  .sm\\:row-gap-5{
    grid-row-gap:1.25rem;
    row-gap:1.25rem
  }

  .sm\\:row-gap-6{
    grid-row-gap:1.5rem;
    row-gap:1.5rem
  }

  .sm\\:row-gap-8{
    grid-row-gap:2rem;
    row-gap:2rem
  }

  .sm\\:row-gap-10{
    grid-row-gap:2.5rem;
    row-gap:2.5rem
  }

  .sm\\:row-gap-12{
    grid-row-gap:3rem;
    row-gap:3rem
  }

  .sm\\:row-gap-16{
    grid-row-gap:4rem;
    row-gap:4rem
  }

  .sm\\:row-gap-20{
    grid-row-gap:5rem;
    row-gap:5rem
  }

  .sm\\:row-gap-24{
    grid-row-gap:6rem;
    row-gap:6rem
  }

  .sm\\:row-gap-32{
    grid-row-gap:8rem;
    row-gap:8rem
  }

  .sm\\:row-gap-40{
    grid-row-gap:10rem;
    row-gap:10rem
  }

  .sm\\:row-gap-48{
    grid-row-gap:12rem;
    row-gap:12rem
  }

  .sm\\:row-gap-56{
    grid-row-gap:14rem;
    row-gap:14rem
  }

  .sm\\:row-gap-64{
    grid-row-gap:16rem;
    row-gap:16rem
  }

  .sm\\:row-gap-px{
    grid-row-gap:1px;
    row-gap:1px
  }

  .sm\\:grid-flow-row{
    grid-auto-flow:row
  }

  .sm\\:grid-flow-col{
    grid-auto-flow:column
  }

  .sm\\:grid-flow-row-dense{
    grid-auto-flow:row dense
  }

  .sm\\:grid-flow-col-dense{
    grid-auto-flow:column dense
  }

  .sm\\:grid-cols-1{
    grid-template-columns:repeat(1,minmax(0,1fr))
  }

  .sm\\:grid-cols-2{
    grid-template-columns:repeat(2,minmax(0,1fr))
  }

  .sm\\:grid-cols-3{
    grid-template-columns:repeat(3,minmax(0,1fr))
  }

  .sm\\:grid-cols-4{
    grid-template-columns:repeat(4,minmax(0,1fr))
  }

  .sm\\:grid-cols-5{
    grid-template-columns:repeat(5,minmax(0,1fr))
  }

  .sm\\:grid-cols-6{
    grid-template-columns:repeat(6,minmax(0,1fr))
  }

  .sm\\:grid-cols-7{
    grid-template-columns:repeat(7,minmax(0,1fr))
  }

  .sm\\:grid-cols-8{
    grid-template-columns:repeat(8,minmax(0,1fr))
  }

  .sm\\:grid-cols-9{
    grid-template-columns:repeat(9,minmax(0,1fr))
  }

  .sm\\:grid-cols-10{
    grid-template-columns:repeat(10,minmax(0,1fr))
  }

  .sm\\:grid-cols-11{
    grid-template-columns:repeat(11,minmax(0,1fr))
  }

  .sm\\:grid-cols-12{
    grid-template-columns:repeat(12,minmax(0,1fr))
  }

  .sm\\:grid-cols-none{
    grid-template-columns:none
  }

  .sm\\:col-auto{
    grid-column:auto
  }

  .sm\\:col-span-1{
    grid-column:span 1/span 1
  }

  .sm\\:col-span-2{
    grid-column:span 2/span 2
  }

  .sm\\:col-span-3{
    grid-column:span 3/span 3
  }

  .sm\\:col-span-4{
    grid-column:span 4/span 4
  }

  .sm\\:col-span-5{
    grid-column:span 5/span 5
  }

  .sm\\:col-span-6{
    grid-column:span 6/span 6
  }

  .sm\\:col-span-7{
    grid-column:span 7/span 7
  }

  .sm\\:col-span-8{
    grid-column:span 8/span 8
  }

  .sm\\:col-span-9{
    grid-column:span 9/span 9
  }

  .sm\\:col-span-10{
    grid-column:span 10/span 10
  }

  .sm\\:col-span-11{
    grid-column:span 11/span 11
  }

  .sm\\:col-span-12{
    grid-column:span 12/span 12
  }

  .sm\\:col-start-1{
    grid-column-start:1
  }

  .sm\\:col-start-2{
    grid-column-start:2
  }

  .sm\\:col-start-3{
    grid-column-start:3
  }

  .sm\\:col-start-4{
    grid-column-start:4
  }

  .sm\\:col-start-5{
    grid-column-start:5
  }

  .sm\\:col-start-6{
    grid-column-start:6
  }

  .sm\\:col-start-7{
    grid-column-start:7
  }

  .sm\\:col-start-8{
    grid-column-start:8
  }

  .sm\\:col-start-9{
    grid-column-start:9
  }

  .sm\\:col-start-10{
    grid-column-start:10
  }

  .sm\\:col-start-11{
    grid-column-start:11
  }

  .sm\\:col-start-12{
    grid-column-start:12
  }

  .sm\\:col-start-13{
    grid-column-start:13
  }

  .sm\\:col-start-auto{
    grid-column-start:auto
  }

  .sm\\:col-end-1{
    grid-column-end:1
  }

  .sm\\:col-end-2{
    grid-column-end:2
  }

  .sm\\:col-end-3{
    grid-column-end:3
  }

  .sm\\:col-end-4{
    grid-column-end:4
  }

  .sm\\:col-end-5{
    grid-column-end:5
  }

  .sm\\:col-end-6{
    grid-column-end:6
  }

  .sm\\:col-end-7{
    grid-column-end:7
  }

  .sm\\:col-end-8{
    grid-column-end:8
  }

  .sm\\:col-end-9{
    grid-column-end:9
  }

  .sm\\:col-end-10{
    grid-column-end:10
  }

  .sm\\:col-end-11{
    grid-column-end:11
  }

  .sm\\:col-end-12{
    grid-column-end:12
  }

  .sm\\:col-end-13{
    grid-column-end:13
  }

  .sm\\:col-end-auto{
    grid-column-end:auto
  }

  .sm\\:grid-rows-1{
    grid-template-rows:repeat(1,minmax(0,1fr))
  }

  .sm\\:grid-rows-2{
    grid-template-rows:repeat(2,minmax(0,1fr))
  }

  .sm\\:grid-rows-3{
    grid-template-rows:repeat(3,minmax(0,1fr))
  }

  .sm\\:grid-rows-4{
    grid-template-rows:repeat(4,minmax(0,1fr))
  }

  .sm\\:grid-rows-5{
    grid-template-rows:repeat(5,minmax(0,1fr))
  }

  .sm\\:grid-rows-6{
    grid-template-rows:repeat(6,minmax(0,1fr))
  }

  .sm\\:grid-rows-none{
    grid-template-rows:none
  }

  .sm\\:row-auto{
    grid-row:auto
  }

  .sm\\:row-span-1{
    grid-row:span 1/span 1
  }

  .sm\\:row-span-2{
    grid-row:span 2/span 2
  }

  .sm\\:row-span-3{
    grid-row:span 3/span 3
  }

  .sm\\:row-span-4{
    grid-row:span 4/span 4
  }

  .sm\\:row-span-5{
    grid-row:span 5/span 5
  }

  .sm\\:row-span-6{
    grid-row:span 6/span 6
  }

  .sm\\:row-start-1{
    grid-row-start:1
  }

  .sm\\:row-start-2{
    grid-row-start:2
  }

  .sm\\:row-start-3{
    grid-row-start:3
  }

  .sm\\:row-start-4{
    grid-row-start:4
  }

  .sm\\:row-start-5{
    grid-row-start:5
  }

  .sm\\:row-start-6{
    grid-row-start:6
  }

  .sm\\:row-start-7{
    grid-row-start:7
  }

  .sm\\:row-start-auto{
    grid-row-start:auto
  }

  .sm\\:row-end-1{
    grid-row-end:1
  }

  .sm\\:row-end-2{
    grid-row-end:2
  }

  .sm\\:row-end-3{
    grid-row-end:3
  }

  .sm\\:row-end-4{
    grid-row-end:4
  }

  .sm\\:row-end-5{
    grid-row-end:5
  }

  .sm\\:row-end-6{
    grid-row-end:6
  }

  .sm\\:row-end-7{
    grid-row-end:7
  }

  .sm\\:row-end-auto{
    grid-row-end:auto
  }

  .sm\\:transform{
    --transform-translate-x:0;
    --transform-translate-y:0;
    --transform-rotate:0;
    --transform-skew-x:0;
    --transform-skew-y:0;
    --transform-scale-x:1;
    --transform-scale-y:1;
    transform:translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y))
  }

  .sm\\:transform-none{
    transform:none
  }

  .sm\\:origin-center{
    transform-origin:center
  }

  .sm\\:origin-top{
    transform-origin:top
  }

  .sm\\:origin-top-right{
    transform-origin:top right
  }

  .sm\\:origin-right{
    transform-origin:right
  }

  .sm\\:origin-bottom-right{
    transform-origin:bottom right
  }

  .sm\\:origin-bottom{
    transform-origin:bottom
  }

  .sm\\:origin-bottom-left{
    transform-origin:bottom left
  }

  .sm\\:origin-left{
    transform-origin:left
  }

  .sm\\:origin-top-left{
    transform-origin:top left
  }

  .sm\\:scale-0{
    --transform-scale-x:0;
    --transform-scale-y:0
  }

  .sm\\:scale-50{
    --transform-scale-x:.5;
    --transform-scale-y:.5
  }

  .sm\\:scale-75{
    --transform-scale-x:.75;
    --transform-scale-y:.75
  }

  .sm\\:scale-90{
    --transform-scale-x:.9;
    --transform-scale-y:.9
  }

  .sm\\:scale-95{
    --transform-scale-x:.95;
    --transform-scale-y:.95
  }

  .sm\\:scale-100{
    --transform-scale-x:1;
    --transform-scale-y:1
  }

  .sm\\:scale-105{
    --transform-scale-x:1.05;
    --transform-scale-y:1.05
  }

  .sm\\:scale-110{
    --transform-scale-x:1.1;
    --transform-scale-y:1.1
  }

  .sm\\:scale-125{
    --transform-scale-x:1.25;
    --transform-scale-y:1.25
  }

  .sm\\:scale-150{
    --transform-scale-x:1.5;
    --transform-scale-y:1.5
  }

  .sm\\:scale-x-0{
    --transform-scale-x:0
  }

  .sm\\:scale-x-50{
    --transform-scale-x:.5
  }

  .sm\\:scale-x-75{
    --transform-scale-x:.75
  }

  .sm\\:scale-x-90{
    --transform-scale-x:.9
  }

  .sm\\:scale-x-95{
    --transform-scale-x:.95
  }

  .sm\\:scale-x-100{
    --transform-scale-x:1
  }

  .sm\\:scale-x-105{
    --transform-scale-x:1.05
  }

  .sm\\:scale-x-110{
    --transform-scale-x:1.1
  }

  .sm\\:scale-x-125{
    --transform-scale-x:1.25
  }

  .sm\\:scale-x-150{
    --transform-scale-x:1.5
  }

  .sm\\:scale-y-0{
    --transform-scale-y:0
  }

  .sm\\:scale-y-50{
    --transform-scale-y:.5
  }

  .sm\\:scale-y-75{
    --transform-scale-y:.75
  }

  .sm\\:scale-y-90{
    --transform-scale-y:.9
  }

  .sm\\:scale-y-95{
    --transform-scale-y:.95
  }

  .sm\\:scale-y-100{
    --transform-scale-y:1
  }

  .sm\\:scale-y-105{
    --transform-scale-y:1.05
  }

  .sm\\:scale-y-110{
    --transform-scale-y:1.1
  }

  .sm\\:scale-y-125{
    --transform-scale-y:1.25
  }

  .sm\\:scale-y-150{
    --transform-scale-y:1.5
  }

  .sm\\:hover\\:scale-0:hover{
    --transform-scale-x:0;
    --transform-scale-y:0
  }

  .sm\\:hover\\:scale-50:hover{
    --transform-scale-x:.5;
    --transform-scale-y:.5
  }

  .sm\\:hover\\:scale-75:hover{
    --transform-scale-x:.75;
    --transform-scale-y:.75
  }

  .sm\\:hover\\:scale-90:hover{
    --transform-scale-x:.9;
    --transform-scale-y:.9
  }

  .sm\\:hover\\:scale-95:hover{
    --transform-scale-x:.95;
    --transform-scale-y:.95
  }

  .sm\\:hover\\:scale-100:hover{
    --transform-scale-x:1;
    --transform-scale-y:1
  }

  .sm\\:hover\\:scale-105:hover{
    --transform-scale-x:1.05;
    --transform-scale-y:1.05
  }

  .sm\\:hover\\:scale-110:hover{
    --transform-scale-x:1.1;
    --transform-scale-y:1.1
  }

  .sm\\:hover\\:scale-125:hover{
    --transform-scale-x:1.25;
    --transform-scale-y:1.25
  }

  .sm\\:hover\\:scale-150:hover{
    --transform-scale-x:1.5;
    --transform-scale-y:1.5
  }

  .sm\\:hover\\:scale-x-0:hover{
    --transform-scale-x:0
  }

  .sm\\:hover\\:scale-x-50:hover{
    --transform-scale-x:.5
  }

  .sm\\:hover\\:scale-x-75:hover{
    --transform-scale-x:.75
  }

  .sm\\:hover\\:scale-x-90:hover{
    --transform-scale-x:.9
  }

  .sm\\:hover\\:scale-x-95:hover{
    --transform-scale-x:.95
  }

  .sm\\:hover\\:scale-x-100:hover{
    --transform-scale-x:1
  }

  .sm\\:hover\\:scale-x-105:hover{
    --transform-scale-x:1.05
  }

  .sm\\:hover\\:scale-x-110:hover{
    --transform-scale-x:1.1
  }

  .sm\\:hover\\:scale-x-125:hover{
    --transform-scale-x:1.25
  }

  .sm\\:hover\\:scale-x-150:hover{
    --transform-scale-x:1.5
  }

  .sm\\:hover\\:scale-y-0:hover{
    --transform-scale-y:0
  }

  .sm\\:hover\\:scale-y-50:hover{
    --transform-scale-y:.5
  }

  .sm\\:hover\\:scale-y-75:hover{
    --transform-scale-y:.75
  }

  .sm\\:hover\\:scale-y-90:hover{
    --transform-scale-y:.9
  }

  .sm\\:hover\\:scale-y-95:hover{
    --transform-scale-y:.95
  }

  .sm\\:hover\\:scale-y-100:hover{
    --transform-scale-y:1
  }

  .sm\\:hover\\:scale-y-105:hover{
    --transform-scale-y:1.05
  }

  .sm\\:hover\\:scale-y-110:hover{
    --transform-scale-y:1.1
  }

  .sm\\:hover\\:scale-y-125:hover{
    --transform-scale-y:1.25
  }

  .sm\\:hover\\:scale-y-150:hover{
    --transform-scale-y:1.5
  }

  .sm\\:focus\\:scale-0:focus{
    --transform-scale-x:0;
    --transform-scale-y:0
  }

  .sm\\:focus\\:scale-50:focus{
    --transform-scale-x:.5;
    --transform-scale-y:.5
  }

  .sm\\:focus\\:scale-75:focus{
    --transform-scale-x:.75;
    --transform-scale-y:.75
  }

  .sm\\:focus\\:scale-90:focus{
    --transform-scale-x:.9;
    --transform-scale-y:.9
  }

  .sm\\:focus\\:scale-95:focus{
    --transform-scale-x:.95;
    --transform-scale-y:.95
  }

  .sm\\:focus\\:scale-100:focus{
    --transform-scale-x:1;
    --transform-scale-y:1
  }

  .sm\\:focus\\:scale-105:focus{
    --transform-scale-x:1.05;
    --transform-scale-y:1.05
  }

  .sm\\:focus\\:scale-110:focus{
    --transform-scale-x:1.1;
    --transform-scale-y:1.1
  }

  .sm\\:focus\\:scale-125:focus{
    --transform-scale-x:1.25;
    --transform-scale-y:1.25
  }

  .sm\\:focus\\:scale-150:focus{
    --transform-scale-x:1.5;
    --transform-scale-y:1.5
  }

  .sm\\:focus\\:scale-x-0:focus{
    --transform-scale-x:0
  }

  .sm\\:focus\\:scale-x-50:focus{
    --transform-scale-x:.5
  }

  .sm\\:focus\\:scale-x-75:focus{
    --transform-scale-x:.75
  }

  .sm\\:focus\\:scale-x-90:focus{
    --transform-scale-x:.9
  }

  .sm\\:focus\\:scale-x-95:focus{
    --transform-scale-x:.95
  }

  .sm\\:focus\\:scale-x-100:focus{
    --transform-scale-x:1
  }

  .sm\\:focus\\:scale-x-105:focus{
    --transform-scale-x:1.05
  }

  .sm\\:focus\\:scale-x-110:focus{
    --transform-scale-x:1.1
  }

  .sm\\:focus\\:scale-x-125:focus{
    --transform-scale-x:1.25
  }

  .sm\\:focus\\:scale-x-150:focus{
    --transform-scale-x:1.5
  }

  .sm\\:focus\\:scale-y-0:focus{
    --transform-scale-y:0
  }

  .sm\\:focus\\:scale-y-50:focus{
    --transform-scale-y:.5
  }

  .sm\\:focus\\:scale-y-75:focus{
    --transform-scale-y:.75
  }

  .sm\\:focus\\:scale-y-90:focus{
    --transform-scale-y:.9
  }

  .sm\\:focus\\:scale-y-95:focus{
    --transform-scale-y:.95
  }

  .sm\\:focus\\:scale-y-100:focus{
    --transform-scale-y:1
  }

  .sm\\:focus\\:scale-y-105:focus{
    --transform-scale-y:1.05
  }

  .sm\\:focus\\:scale-y-110:focus{
    --transform-scale-y:1.1
  }

  .sm\\:focus\\:scale-y-125:focus{
    --transform-scale-y:1.25
  }

  .sm\\:focus\\:scale-y-150:focus{
    --transform-scale-y:1.5
  }

  .sm\\:rotate-0{
    --transform-rotate:0
  }

  .sm\\:rotate-45{
    --transform-rotate:45deg
  }

  .sm\\:rotate-90{
    --transform-rotate:90deg
  }

  .sm\\:rotate-180{
    --transform-rotate:180deg
  }

  .sm\\:-rotate-180{
    --transform-rotate:-180deg
  }

  .sm\\:-rotate-90{
    --transform-rotate:-90deg
  }

  .sm\\:-rotate-45{
    --transform-rotate:-45deg
  }

  .sm\\:hover\\:rotate-0:hover{
    --transform-rotate:0
  }

  .sm\\:hover\\:rotate-45:hover{
    --transform-rotate:45deg
  }

  .sm\\:hover\\:rotate-90:hover{
    --transform-rotate:90deg
  }

  .sm\\:hover\\:rotate-180:hover{
    --transform-rotate:180deg
  }

  .sm\\:hover\\:-rotate-180:hover{
    --transform-rotate:-180deg
  }

  .sm\\:hover\\:-rotate-90:hover{
    --transform-rotate:-90deg
  }

  .sm\\:hover\\:-rotate-45:hover{
    --transform-rotate:-45deg
  }

  .sm\\:focus\\:rotate-0:focus{
    --transform-rotate:0
  }

  .sm\\:focus\\:rotate-45:focus{
    --transform-rotate:45deg
  }

  .sm\\:focus\\:rotate-90:focus{
    --transform-rotate:90deg
  }

  .sm\\:focus\\:rotate-180:focus{
    --transform-rotate:180deg
  }

  .sm\\:focus\\:-rotate-180:focus{
    --transform-rotate:-180deg
  }

  .sm\\:focus\\:-rotate-90:focus{
    --transform-rotate:-90deg
  }

  .sm\\:focus\\:-rotate-45:focus{
    --transform-rotate:-45deg
  }

  .sm\\:translate-x-0{
    --transform-translate-x:0
  }

  .sm\\:translate-x-1{
    --transform-translate-x:0.25rem
  }

  .sm\\:translate-x-2{
    --transform-translate-x:0.5rem
  }

  .sm\\:translate-x-3{
    --transform-translate-x:0.75rem
  }

  .sm\\:translate-x-4{
    --transform-translate-x:1rem
  }

  .sm\\:translate-x-5{
    --transform-translate-x:1.25rem
  }

  .sm\\:translate-x-6{
    --transform-translate-x:1.5rem
  }

  .sm\\:translate-x-8{
    --transform-translate-x:2rem
  }

  .sm\\:translate-x-10{
    --transform-translate-x:2.5rem
  }

  .sm\\:translate-x-12{
    --transform-translate-x:3rem
  }

  .sm\\:translate-x-16{
    --transform-translate-x:4rem
  }

  .sm\\:translate-x-20{
    --transform-translate-x:5rem
  }

  .sm\\:translate-x-24{
    --transform-translate-x:6rem
  }

  .sm\\:translate-x-32{
    --transform-translate-x:8rem
  }

  .sm\\:translate-x-40{
    --transform-translate-x:10rem
  }

  .sm\\:translate-x-48{
    --transform-translate-x:12rem
  }

  .sm\\:translate-x-56{
    --transform-translate-x:14rem
  }

  .sm\\:translate-x-64{
    --transform-translate-x:16rem
  }

  .sm\\:translate-x-px{
    --transform-translate-x:1px
  }

  .sm\\:-translate-x-1{
    --transform-translate-x:-0.25rem
  }

  .sm\\:-translate-x-2{
    --transform-translate-x:-0.5rem
  }

  .sm\\:-translate-x-3{
    --transform-translate-x:-0.75rem
  }

  .sm\\:-translate-x-4{
    --transform-translate-x:-1rem
  }

  .sm\\:-translate-x-5{
    --transform-translate-x:-1.25rem
  }

  .sm\\:-translate-x-6{
    --transform-translate-x:-1.5rem
  }

  .sm\\:-translate-x-8{
    --transform-translate-x:-2rem
  }

  .sm\\:-translate-x-10{
    --transform-translate-x:-2.5rem
  }

  .sm\\:-translate-x-12{
    --transform-translate-x:-3rem
  }

  .sm\\:-translate-x-16{
    --transform-translate-x:-4rem
  }

  .sm\\:-translate-x-20{
    --transform-translate-x:-5rem
  }

  .sm\\:-translate-x-24{
    --transform-translate-x:-6rem
  }

  .sm\\:-translate-x-32{
    --transform-translate-x:-8rem
  }

  .sm\\:-translate-x-40{
    --transform-translate-x:-10rem
  }

  .sm\\:-translate-x-48{
    --transform-translate-x:-12rem
  }

  .sm\\:-translate-x-56{
    --transform-translate-x:-14rem
  }

  .sm\\:-translate-x-64{
    --transform-translate-x:-16rem
  }

  .sm\\:-translate-x-px{
    --transform-translate-x:-1px
  }

  .sm\\:-translate-x-full{
    --transform-translate-x:-100%
  }

  .sm\\:-translate-x-1\\/2{
    --transform-translate-x:-50%
  }

  .sm\\:translate-x-1\\/2{
    --transform-translate-x:50%
  }

  .sm\\:translate-x-full{
    --transform-translate-x:100%
  }

  .sm\\:translate-y-0{
    --transform-translate-y:0
  }

  .sm\\:translate-y-1{
    --transform-translate-y:0.25rem
  }

  .sm\\:translate-y-2{
    --transform-translate-y:0.5rem
  }

  .sm\\:translate-y-3{
    --transform-translate-y:0.75rem
  }

  .sm\\:translate-y-4{
    --transform-translate-y:1rem
  }

  .sm\\:translate-y-5{
    --transform-translate-y:1.25rem
  }

  .sm\\:translate-y-6{
    --transform-translate-y:1.5rem
  }

  .sm\\:translate-y-8{
    --transform-translate-y:2rem
  }

  .sm\\:translate-y-10{
    --transform-translate-y:2.5rem
  }

  .sm\\:translate-y-12{
    --transform-translate-y:3rem
  }

  .sm\\:translate-y-16{
    --transform-translate-y:4rem
  }

  .sm\\:translate-y-20{
    --transform-translate-y:5rem
  }

  .sm\\:translate-y-24{
    --transform-translate-y:6rem
  }

  .sm\\:translate-y-32{
    --transform-translate-y:8rem
  }

  .sm\\:translate-y-40{
    --transform-translate-y:10rem
  }

  .sm\\:translate-y-48{
    --transform-translate-y:12rem
  }

  .sm\\:translate-y-56{
    --transform-translate-y:14rem
  }

  .sm\\:translate-y-64{
    --transform-translate-y:16rem
  }

  .sm\\:translate-y-px{
    --transform-translate-y:1px
  }

  .sm\\:-translate-y-1{
    --transform-translate-y:-0.25rem
  }

  .sm\\:-translate-y-2{
    --transform-translate-y:-0.5rem
  }

  .sm\\:-translate-y-3{
    --transform-translate-y:-0.75rem
  }

  .sm\\:-translate-y-4{
    --transform-translate-y:-1rem
  }

  .sm\\:-translate-y-5{
    --transform-translate-y:-1.25rem
  }

  .sm\\:-translate-y-6{
    --transform-translate-y:-1.5rem
  }

  .sm\\:-translate-y-8{
    --transform-translate-y:-2rem
  }

  .sm\\:-translate-y-10{
    --transform-translate-y:-2.5rem
  }

  .sm\\:-translate-y-12{
    --transform-translate-y:-3rem
  }

  .sm\\:-translate-y-16{
    --transform-translate-y:-4rem
  }

  .sm\\:-translate-y-20{
    --transform-translate-y:-5rem
  }

  .sm\\:-translate-y-24{
    --transform-translate-y:-6rem
  }

  .sm\\:-translate-y-32{
    --transform-translate-y:-8rem
  }

  .sm\\:-translate-y-40{
    --transform-translate-y:-10rem
  }

  .sm\\:-translate-y-48{
    --transform-translate-y:-12rem
  }

  .sm\\:-translate-y-56{
    --transform-translate-y:-14rem
  }

  .sm\\:-translate-y-64{
    --transform-translate-y:-16rem
  }

  .sm\\:-translate-y-px{
    --transform-translate-y:-1px
  }

  .sm\\:-translate-y-full{
    --transform-translate-y:-100%
  }

  .sm\\:-translate-y-1\\/2{
    --transform-translate-y:-50%
  }

  .sm\\:translate-y-1\\/2{
    --transform-translate-y:50%
  }

  .sm\\:translate-y-full{
    --transform-translate-y:100%
  }

  .sm\\:hover\\:translate-x-0:hover{
    --transform-translate-x:0
  }

  .sm\\:hover\\:translate-x-1:hover{
    --transform-translate-x:0.25rem
  }

  .sm\\:hover\\:translate-x-2:hover{
    --transform-translate-x:0.5rem
  }

  .sm\\:hover\\:translate-x-3:hover{
    --transform-translate-x:0.75rem
  }

  .sm\\:hover\\:translate-x-4:hover{
    --transform-translate-x:1rem
  }

  .sm\\:hover\\:translate-x-5:hover{
    --transform-translate-x:1.25rem
  }

  .sm\\:hover\\:translate-x-6:hover{
    --transform-translate-x:1.5rem
  }

  .sm\\:hover\\:translate-x-8:hover{
    --transform-translate-x:2rem
  }

  .sm\\:hover\\:translate-x-10:hover{
    --transform-translate-x:2.5rem
  }

  .sm\\:hover\\:translate-x-12:hover{
    --transform-translate-x:3rem
  }

  .sm\\:hover\\:translate-x-16:hover{
    --transform-translate-x:4rem
  }

  .sm\\:hover\\:translate-x-20:hover{
    --transform-translate-x:5rem
  }

  .sm\\:hover\\:translate-x-24:hover{
    --transform-translate-x:6rem
  }

  .sm\\:hover\\:translate-x-32:hover{
    --transform-translate-x:8rem
  }

  .sm\\:hover\\:translate-x-40:hover{
    --transform-translate-x:10rem
  }

  .sm\\:hover\\:translate-x-48:hover{
    --transform-translate-x:12rem
  }

  .sm\\:hover\\:translate-x-56:hover{
    --transform-translate-x:14rem
  }

  .sm\\:hover\\:translate-x-64:hover{
    --transform-translate-x:16rem
  }

  .sm\\:hover\\:translate-x-px:hover{
    --transform-translate-x:1px
  }

  .sm\\:hover\\:-translate-x-1:hover{
    --transform-translate-x:-0.25rem
  }

  .sm\\:hover\\:-translate-x-2:hover{
    --transform-translate-x:-0.5rem
  }

  .sm\\:hover\\:-translate-x-3:hover{
    --transform-translate-x:-0.75rem
  }

  .sm\\:hover\\:-translate-x-4:hover{
    --transform-translate-x:-1rem
  }

  .sm\\:hover\\:-translate-x-5:hover{
    --transform-translate-x:-1.25rem
  }

  .sm\\:hover\\:-translate-x-6:hover{
    --transform-translate-x:-1.5rem
  }

  .sm\\:hover\\:-translate-x-8:hover{
    --transform-translate-x:-2rem
  }

  .sm\\:hover\\:-translate-x-10:hover{
    --transform-translate-x:-2.5rem
  }

  .sm\\:hover\\:-translate-x-12:hover{
    --transform-translate-x:-3rem
  }

  .sm\\:hover\\:-translate-x-16:hover{
    --transform-translate-x:-4rem
  }

  .sm\\:hover\\:-translate-x-20:hover{
    --transform-translate-x:-5rem
  }

  .sm\\:hover\\:-translate-x-24:hover{
    --transform-translate-x:-6rem
  }

  .sm\\:hover\\:-translate-x-32:hover{
    --transform-translate-x:-8rem
  }

  .sm\\:hover\\:-translate-x-40:hover{
    --transform-translate-x:-10rem
  }

  .sm\\:hover\\:-translate-x-48:hover{
    --transform-translate-x:-12rem
  }

  .sm\\:hover\\:-translate-x-56:hover{
    --transform-translate-x:-14rem
  }

  .sm\\:hover\\:-translate-x-64:hover{
    --transform-translate-x:-16rem
  }

  .sm\\:hover\\:-translate-x-px:hover{
    --transform-translate-x:-1px
  }

  .sm\\:hover\\:-translate-x-full:hover{
    --transform-translate-x:-100%
  }

  .sm\\:hover\\:-translate-x-1\\/2:hover{
    --transform-translate-x:-50%
  }

  .sm\\:hover\\:translate-x-1\\/2:hover{
    --transform-translate-x:50%
  }

  .sm\\:hover\\:translate-x-full:hover{
    --transform-translate-x:100%
  }

  .sm\\:hover\\:translate-y-0:hover{
    --transform-translate-y:0
  }

  .sm\\:hover\\:translate-y-1:hover{
    --transform-translate-y:0.25rem
  }

  .sm\\:hover\\:translate-y-2:hover{
    --transform-translate-y:0.5rem
  }

  .sm\\:hover\\:translate-y-3:hover{
    --transform-translate-y:0.75rem
  }

  .sm\\:hover\\:translate-y-4:hover{
    --transform-translate-y:1rem
  }

  .sm\\:hover\\:translate-y-5:hover{
    --transform-translate-y:1.25rem
  }

  .sm\\:hover\\:translate-y-6:hover{
    --transform-translate-y:1.5rem
  }

  .sm\\:hover\\:translate-y-8:hover{
    --transform-translate-y:2rem
  }

  .sm\\:hover\\:translate-y-10:hover{
    --transform-translate-y:2.5rem
  }

  .sm\\:hover\\:translate-y-12:hover{
    --transform-translate-y:3rem
  }

  .sm\\:hover\\:translate-y-16:hover{
    --transform-translate-y:4rem
  }

  .sm\\:hover\\:translate-y-20:hover{
    --transform-translate-y:5rem
  }

  .sm\\:hover\\:translate-y-24:hover{
    --transform-translate-y:6rem
  }

  .sm\\:hover\\:translate-y-32:hover{
    --transform-translate-y:8rem
  }

  .sm\\:hover\\:translate-y-40:hover{
    --transform-translate-y:10rem
  }

  .sm\\:hover\\:translate-y-48:hover{
    --transform-translate-y:12rem
  }

  .sm\\:hover\\:translate-y-56:hover{
    --transform-translate-y:14rem
  }

  .sm\\:hover\\:translate-y-64:hover{
    --transform-translate-y:16rem
  }

  .sm\\:hover\\:translate-y-px:hover{
    --transform-translate-y:1px
  }

  .sm\\:hover\\:-translate-y-1:hover{
    --transform-translate-y:-0.25rem
  }

  .sm\\:hover\\:-translate-y-2:hover{
    --transform-translate-y:-0.5rem
  }

  .sm\\:hover\\:-translate-y-3:hover{
    --transform-translate-y:-0.75rem
  }

  .sm\\:hover\\:-translate-y-4:hover{
    --transform-translate-y:-1rem
  }

  .sm\\:hover\\:-translate-y-5:hover{
    --transform-translate-y:-1.25rem
  }

  .sm\\:hover\\:-translate-y-6:hover{
    --transform-translate-y:-1.5rem
  }

  .sm\\:hover\\:-translate-y-8:hover{
    --transform-translate-y:-2rem
  }

  .sm\\:hover\\:-translate-y-10:hover{
    --transform-translate-y:-2.5rem
  }

  .sm\\:hover\\:-translate-y-12:hover{
    --transform-translate-y:-3rem
  }

  .sm\\:hover\\:-translate-y-16:hover{
    --transform-translate-y:-4rem
  }

  .sm\\:hover\\:-translate-y-20:hover{
    --transform-translate-y:-5rem
  }

  .sm\\:hover\\:-translate-y-24:hover{
    --transform-translate-y:-6rem
  }

  .sm\\:hover\\:-translate-y-32:hover{
    --transform-translate-y:-8rem
  }

  .sm\\:hover\\:-translate-y-40:hover{
    --transform-translate-y:-10rem
  }

  .sm\\:hover\\:-translate-y-48:hover{
    --transform-translate-y:-12rem
  }

  .sm\\:hover\\:-translate-y-56:hover{
    --transform-translate-y:-14rem
  }

  .sm\\:hover\\:-translate-y-64:hover{
    --transform-translate-y:-16rem
  }

  .sm\\:hover\\:-translate-y-px:hover{
    --transform-translate-y:-1px
  }

  .sm\\:hover\\:-translate-y-full:hover{
    --transform-translate-y:-100%
  }

  .sm\\:hover\\:-translate-y-1\\/2:hover{
    --transform-translate-y:-50%
  }

  .sm\\:hover\\:translate-y-1\\/2:hover{
    --transform-translate-y:50%
  }

  .sm\\:hover\\:translate-y-full:hover{
    --transform-translate-y:100%
  }

  .sm\\:focus\\:translate-x-0:focus{
    --transform-translate-x:0
  }

  .sm\\:focus\\:translate-x-1:focus{
    --transform-translate-x:0.25rem
  }

  .sm\\:focus\\:translate-x-2:focus{
    --transform-translate-x:0.5rem
  }

  .sm\\:focus\\:translate-x-3:focus{
    --transform-translate-x:0.75rem
  }

  .sm\\:focus\\:translate-x-4:focus{
    --transform-translate-x:1rem
  }

  .sm\\:focus\\:translate-x-5:focus{
    --transform-translate-x:1.25rem
  }

  .sm\\:focus\\:translate-x-6:focus{
    --transform-translate-x:1.5rem
  }

  .sm\\:focus\\:translate-x-8:focus{
    --transform-translate-x:2rem
  }

  .sm\\:focus\\:translate-x-10:focus{
    --transform-translate-x:2.5rem
  }

  .sm\\:focus\\:translate-x-12:focus{
    --transform-translate-x:3rem
  }

  .sm\\:focus\\:translate-x-16:focus{
    --transform-translate-x:4rem
  }

  .sm\\:focus\\:translate-x-20:focus{
    --transform-translate-x:5rem
  }

  .sm\\:focus\\:translate-x-24:focus{
    --transform-translate-x:6rem
  }

  .sm\\:focus\\:translate-x-32:focus{
    --transform-translate-x:8rem
  }

  .sm\\:focus\\:translate-x-40:focus{
    --transform-translate-x:10rem
  }

  .sm\\:focus\\:translate-x-48:focus{
    --transform-translate-x:12rem
  }

  .sm\\:focus\\:translate-x-56:focus{
    --transform-translate-x:14rem
  }

  .sm\\:focus\\:translate-x-64:focus{
    --transform-translate-x:16rem
  }

  .sm\\:focus\\:translate-x-px:focus{
    --transform-translate-x:1px
  }

  .sm\\:focus\\:-translate-x-1:focus{
    --transform-translate-x:-0.25rem
  }

  .sm\\:focus\\:-translate-x-2:focus{
    --transform-translate-x:-0.5rem
  }

  .sm\\:focus\\:-translate-x-3:focus{
    --transform-translate-x:-0.75rem
  }

  .sm\\:focus\\:-translate-x-4:focus{
    --transform-translate-x:-1rem
  }

  .sm\\:focus\\:-translate-x-5:focus{
    --transform-translate-x:-1.25rem
  }

  .sm\\:focus\\:-translate-x-6:focus{
    --transform-translate-x:-1.5rem
  }

  .sm\\:focus\\:-translate-x-8:focus{
    --transform-translate-x:-2rem
  }

  .sm\\:focus\\:-translate-x-10:focus{
    --transform-translate-x:-2.5rem
  }

  .sm\\:focus\\:-translate-x-12:focus{
    --transform-translate-x:-3rem
  }

  .sm\\:focus\\:-translate-x-16:focus{
    --transform-translate-x:-4rem
  }

  .sm\\:focus\\:-translate-x-20:focus{
    --transform-translate-x:-5rem
  }

  .sm\\:focus\\:-translate-x-24:focus{
    --transform-translate-x:-6rem
  }

  .sm\\:focus\\:-translate-x-32:focus{
    --transform-translate-x:-8rem
  }

  .sm\\:focus\\:-translate-x-40:focus{
    --transform-translate-x:-10rem
  }

  .sm\\:focus\\:-translate-x-48:focus{
    --transform-translate-x:-12rem
  }

  .sm\\:focus\\:-translate-x-56:focus{
    --transform-translate-x:-14rem
  }

  .sm\\:focus\\:-translate-x-64:focus{
    --transform-translate-x:-16rem
  }

  .sm\\:focus\\:-translate-x-px:focus{
    --transform-translate-x:-1px
  }

  .sm\\:focus\\:-translate-x-full:focus{
    --transform-translate-x:-100%
  }

  .sm\\:focus\\:-translate-x-1\\/2:focus{
    --transform-translate-x:-50%
  }

  .sm\\:focus\\:translate-x-1\\/2:focus{
    --transform-translate-x:50%
  }

  .sm\\:focus\\:translate-x-full:focus{
    --transform-translate-x:100%
  }

  .sm\\:focus\\:translate-y-0:focus{
    --transform-translate-y:0
  }

  .sm\\:focus\\:translate-y-1:focus{
    --transform-translate-y:0.25rem
  }

  .sm\\:focus\\:translate-y-2:focus{
    --transform-translate-y:0.5rem
  }

  .sm\\:focus\\:translate-y-3:focus{
    --transform-translate-y:0.75rem
  }

  .sm\\:focus\\:translate-y-4:focus{
    --transform-translate-y:1rem
  }

  .sm\\:focus\\:translate-y-5:focus{
    --transform-translate-y:1.25rem
  }

  .sm\\:focus\\:translate-y-6:focus{
    --transform-translate-y:1.5rem
  }

  .sm\\:focus\\:translate-y-8:focus{
    --transform-translate-y:2rem
  }

  .sm\\:focus\\:translate-y-10:focus{
    --transform-translate-y:2.5rem
  }

  .sm\\:focus\\:translate-y-12:focus{
    --transform-translate-y:3rem
  }

  .sm\\:focus\\:translate-y-16:focus{
    --transform-translate-y:4rem
  }

  .sm\\:focus\\:translate-y-20:focus{
    --transform-translate-y:5rem
  }

  .sm\\:focus\\:translate-y-24:focus{
    --transform-translate-y:6rem
  }

  .sm\\:focus\\:translate-y-32:focus{
    --transform-translate-y:8rem
  }

  .sm\\:focus\\:translate-y-40:focus{
    --transform-translate-y:10rem
  }

  .sm\\:focus\\:translate-y-48:focus{
    --transform-translate-y:12rem
  }

  .sm\\:focus\\:translate-y-56:focus{
    --transform-translate-y:14rem
  }

  .sm\\:focus\\:translate-y-64:focus{
    --transform-translate-y:16rem
  }

  .sm\\:focus\\:translate-y-px:focus{
    --transform-translate-y:1px
  }

  .sm\\:focus\\:-translate-y-1:focus{
    --transform-translate-y:-0.25rem
  }

  .sm\\:focus\\:-translate-y-2:focus{
    --transform-translate-y:-0.5rem
  }

  .sm\\:focus\\:-translate-y-3:focus{
    --transform-translate-y:-0.75rem
  }

  .sm\\:focus\\:-translate-y-4:focus{
    --transform-translate-y:-1rem
  }

  .sm\\:focus\\:-translate-y-5:focus{
    --transform-translate-y:-1.25rem
  }

  .sm\\:focus\\:-translate-y-6:focus{
    --transform-translate-y:-1.5rem
  }

  .sm\\:focus\\:-translate-y-8:focus{
    --transform-translate-y:-2rem
  }

  .sm\\:focus\\:-translate-y-10:focus{
    --transform-translate-y:-2.5rem
  }

  .sm\\:focus\\:-translate-y-12:focus{
    --transform-translate-y:-3rem
  }

  .sm\\:focus\\:-translate-y-16:focus{
    --transform-translate-y:-4rem
  }

  .sm\\:focus\\:-translate-y-20:focus{
    --transform-translate-y:-5rem
  }

  .sm\\:focus\\:-translate-y-24:focus{
    --transform-translate-y:-6rem
  }

  .sm\\:focus\\:-translate-y-32:focus{
    --transform-translate-y:-8rem
  }

  .sm\\:focus\\:-translate-y-40:focus{
    --transform-translate-y:-10rem
  }

  .sm\\:focus\\:-translate-y-48:focus{
    --transform-translate-y:-12rem
  }

  .sm\\:focus\\:-translate-y-56:focus{
    --transform-translate-y:-14rem
  }

  .sm\\:focus\\:-translate-y-64:focus{
    --transform-translate-y:-16rem
  }

  .sm\\:focus\\:-translate-y-px:focus{
    --transform-translate-y:-1px
  }

  .sm\\:focus\\:-translate-y-full:focus{
    --transform-translate-y:-100%
  }

  .sm\\:focus\\:-translate-y-1\\/2:focus{
    --transform-translate-y:-50%
  }

  .sm\\:focus\\:translate-y-1\\/2:focus{
    --transform-translate-y:50%
  }

  .sm\\:focus\\:translate-y-full:focus{
    --transform-translate-y:100%
  }

  .sm\\:skew-x-0{
    --transform-skew-x:0
  }

  .sm\\:skew-x-3{
    --transform-skew-x:3deg
  }

  .sm\\:skew-x-6{
    --transform-skew-x:6deg
  }

  .sm\\:skew-x-12{
    --transform-skew-x:12deg
  }

  .sm\\:-skew-x-12{
    --transform-skew-x:-12deg
  }

  .sm\\:-skew-x-6{
    --transform-skew-x:-6deg
  }

  .sm\\:-skew-x-3{
    --transform-skew-x:-3deg
  }

  .sm\\:skew-y-0{
    --transform-skew-y:0
  }

  .sm\\:skew-y-3{
    --transform-skew-y:3deg
  }

  .sm\\:skew-y-6{
    --transform-skew-y:6deg
  }

  .sm\\:skew-y-12{
    --transform-skew-y:12deg
  }

  .sm\\:-skew-y-12{
    --transform-skew-y:-12deg
  }

  .sm\\:-skew-y-6{
    --transform-skew-y:-6deg
  }

  .sm\\:-skew-y-3{
    --transform-skew-y:-3deg
  }

  .sm\\:hover\\:skew-x-0:hover{
    --transform-skew-x:0
  }

  .sm\\:hover\\:skew-x-3:hover{
    --transform-skew-x:3deg
  }

  .sm\\:hover\\:skew-x-6:hover{
    --transform-skew-x:6deg
  }

  .sm\\:hover\\:skew-x-12:hover{
    --transform-skew-x:12deg
  }

  .sm\\:hover\\:-skew-x-12:hover{
    --transform-skew-x:-12deg
  }

  .sm\\:hover\\:-skew-x-6:hover{
    --transform-skew-x:-6deg
  }

  .sm\\:hover\\:-skew-x-3:hover{
    --transform-skew-x:-3deg
  }

  .sm\\:hover\\:skew-y-0:hover{
    --transform-skew-y:0
  }

  .sm\\:hover\\:skew-y-3:hover{
    --transform-skew-y:3deg
  }

  .sm\\:hover\\:skew-y-6:hover{
    --transform-skew-y:6deg
  }

  .sm\\:hover\\:skew-y-12:hover{
    --transform-skew-y:12deg
  }

  .sm\\:hover\\:-skew-y-12:hover{
    --transform-skew-y:-12deg
  }

  .sm\\:hover\\:-skew-y-6:hover{
    --transform-skew-y:-6deg
  }

  .sm\\:hover\\:-skew-y-3:hover{
    --transform-skew-y:-3deg
  }

  .sm\\:focus\\:skew-x-0:focus{
    --transform-skew-x:0
  }

  .sm\\:focus\\:skew-x-3:focus{
    --transform-skew-x:3deg
  }

  .sm\\:focus\\:skew-x-6:focus{
    --transform-skew-x:6deg
  }

  .sm\\:focus\\:skew-x-12:focus{
    --transform-skew-x:12deg
  }

  .sm\\:focus\\:-skew-x-12:focus{
    --transform-skew-x:-12deg
  }

  .sm\\:focus\\:-skew-x-6:focus{
    --transform-skew-x:-6deg
  }

  .sm\\:focus\\:-skew-x-3:focus{
    --transform-skew-x:-3deg
  }

  .sm\\:focus\\:skew-y-0:focus{
    --transform-skew-y:0
  }

  .sm\\:focus\\:skew-y-3:focus{
    --transform-skew-y:3deg
  }

  .sm\\:focus\\:skew-y-6:focus{
    --transform-skew-y:6deg
  }

  .sm\\:focus\\:skew-y-12:focus{
    --transform-skew-y:12deg
  }

  .sm\\:focus\\:-skew-y-12:focus{
    --transform-skew-y:-12deg
  }

  .sm\\:focus\\:-skew-y-6:focus{
    --transform-skew-y:-6deg
  }

  .sm\\:focus\\:-skew-y-3:focus{
    --transform-skew-y:-3deg
  }

  .sm\\:transition-none{
    transition-property:none
  }

  .sm\\:transition-all{
    transition-property:all
  }

  .sm\\:transition{
    transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform
  }

  .sm\\:transition-colors{
    transition-property:background-color,border-color,color,fill,stroke
  }

  .sm\\:transition-opacity{
    transition-property:opacity
  }

  .sm\\:transition-shadow{
    transition-property:box-shadow
  }

  .sm\\:transition-transform{
    transition-property:transform
  }

  .sm\\:ease-linear{
    transition-timing-function:linear
  }

  .sm\\:ease-in{
    transition-timing-function:cubic-bezier(.4,0,1,1)
  }

  .sm\\:ease-out{
    transition-timing-function:cubic-bezier(0,0,.2,1)
  }

  .sm\\:ease-in-out{
    transition-timing-function:cubic-bezier(.4,0,.2,1)
  }

  .sm\\:duration-75{
    transition-duration:75ms
  }

  .sm\\:duration-100{
    transition-duration:.1s
  }

  .sm\\:duration-150{
    transition-duration:.15s
  }

  .sm\\:duration-200{
    transition-duration:.2s
  }

  .sm\\:duration-300{
    transition-duration:.3s
  }

  .sm\\:duration-500{
    transition-duration:.5s
  }

  .sm\\:duration-700{
    transition-duration:.7s
  }

  .sm\\:duration-1000{
    transition-duration:1s
  }

  .sm\\:delay-75{
    transition-delay:75ms
  }

  .sm\\:delay-100{
    transition-delay:.1s
  }

  .sm\\:delay-150{
    transition-delay:.15s
  }

  .sm\\:delay-200{
    transition-delay:.2s
  }

  .sm\\:delay-300{
    transition-delay:.3s
  }

  .sm\\:delay-500{
    transition-delay:.5s
  }

  .sm\\:delay-700{
    transition-delay:.7s
  }

  .sm\\:delay-1000{
    transition-delay:1s
  }

  .sm\\:shadow-outline-white{
    box-shadow:0 0 0 3px #ffffff73
  }

  .sm\\:shadow-outline-black{
    box-shadow:0 0 0 3px #00000073
  }

  .sm\\:shadow-outline-gray{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .sm\\:shadow-outline-cool-gray{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .sm\\:shadow-outline-red{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .sm\\:shadow-outline-orange{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .sm\\:shadow-outline-yellow{
    box-shadow:0 0 0 3px #faca1573
  }

  .sm\\:shadow-outline-green{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .sm\\:shadow-outline-teal{
    box-shadow:0 0 0 3px #7edce273
  }

  .sm\\:shadow-outline-blue{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .sm\\:shadow-outline-indigo{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .sm\\:shadow-outline-indigo{
    box-shadow:0 0 0 3px #cabffd73
  }

  .sm\\:shadow-outline-pink{
    box-shadow:0 0 0 3px #f8b4d973
  }

  .sm\\:hover\\:shadow-outline-white:hover{
    box-shadow:0 0 0 3px #ffffff73
  }

  .sm\\:hover\\:shadow-outline-black:hover{
    box-shadow:0 0 0 3px #00000073
  }

  .sm\\:hover\\:shadow-outline-gray:hover{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .sm\\:hover\\:shadow-outline-cool-gray:hover{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .sm\\:hover\\:shadow-outline-red:hover{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .sm\\:hover\\:shadow-outline-orange:hover{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .sm\\:hover\\:shadow-outline-yellow:hover{
    box-shadow:0 0 0 3px #faca1573
  }

  .sm\\:hover\\:shadow-outline-green:hover{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .sm\\:hover\\:shadow-outline-teal:hover{
    box-shadow:0 0 0 3px #7edce273
  }

  .sm\\:hover\\:shadow-outline-blue:hover{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .sm\\:hover\\:shadow-outline-indigo:hover{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .sm\\:hover\\:shadow-outline-indigo:hover{
    box-shadow:0 0 0 3px #cabffd73
  }

  .sm\\:hover\\:shadow-outline-pink:hover{
    box-shadow:0 0 0 3px #f8b4d973
  }

  .sm\\:focus\\:shadow-outline-white:focus{
    box-shadow:0 0 0 3px #ffffff73
  }

  .sm\\:focus\\:shadow-outline-black:focus{
    box-shadow:0 0 0 3px #00000073
  }

  .sm\\:focus\\:shadow-outline-gray:focus{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .sm\\:focus\\:shadow-outline-cool-gray:focus{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .sm\\:focus\\:shadow-outline-red:focus{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .sm\\:focus\\:shadow-outline-orange:focus{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .sm\\:focus\\:shadow-outline-yellow:focus{
    box-shadow:0 0 0 3px #faca1573
  }

  .sm\\:focus\\:shadow-outline-green:focus{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .sm\\:focus\\:shadow-outline-teal:focus{
    box-shadow:0 0 0 3px #7edce273
  }

  .sm\\:focus\\:shadow-outline-blue:focus{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .sm\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .sm\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #cabffd73
  }

  .sm\\:focus\\:shadow-outline-pink:focus{
    box-shadow:0 0 0 3px #f8b4d973
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-outline-white:focus{
    box-shadow:0 0 0 3px #ffffff73
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-outline-black:focus{
    box-shadow:0 0 0 3px #00000073
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-outline-gray:focus{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-outline-cool-gray:focus{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-outline-red:focus{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-outline-orange:focus{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-outline-yellow:focus{
    box-shadow:0 0 0 3px #faca1573
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-outline-green:focus{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-outline-teal:focus{
    box-shadow:0 0 0 3px #7edce273
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-outline-blue:focus{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #cabffd73
  }

  .theme-dark .sm\\:dark\\:focus\\:shadow-outline-pink:focus{
    box-shadow:0 0 0 3px #f8b4d973
  }
}

@media (min-width:768px){
  .md\\:space-y-0>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(0px*var(--space-y-reverse));
    margin-top:calc(0px*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-0>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(0px*(1 - var(--space-x-reverse)));
    margin-right:calc(0px*var(--space-x-reverse))
  }

  .md\\:space-y-1>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(.25rem*var(--space-y-reverse));
    margin-top:calc(.25rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-1>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(.25rem*var(--space-x-reverse))
  }

  .md\\:space-y-2>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(.5rem*var(--space-y-reverse));
    margin-top:calc(.5rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-2>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(.5rem*var(--space-x-reverse))
  }

  .md\\:space-y-3>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(.75rem*var(--space-y-reverse));
    margin-top:calc(.75rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-3>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(.75rem*(1 - var(--space-x-reverse)));
    margin-right:calc(.75rem*var(--space-x-reverse))
  }

  .md\\:space-y-4>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1rem*var(--space-y-reverse));
    margin-top:calc(1rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-4>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1rem*(1 - var(--space-x-reverse)));
    margin-right:calc(1rem*var(--space-x-reverse))
  }

  .md\\:space-y-5>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1.25rem*var(--space-y-reverse));
    margin-top:calc(1.25rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-5>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(1.25rem*var(--space-x-reverse))
  }

  .md\\:space-y-6>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1.5rem*var(--space-y-reverse));
    margin-top:calc(1.5rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-6>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(1.5rem*var(--space-x-reverse))
  }

  .md\\:space-y-8>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(2rem*var(--space-y-reverse));
    margin-top:calc(2rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-8>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(2rem*(1 - var(--space-x-reverse)));
    margin-right:calc(2rem*var(--space-x-reverse))
  }

  .md\\:space-y-10>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(2.5rem*var(--space-y-reverse));
    margin-top:calc(2.5rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-10>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(2.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(2.5rem*var(--space-x-reverse))
  }

  .md\\:space-y-12>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(3rem*var(--space-y-reverse));
    margin-top:calc(3rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-12>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(3rem*(1 - var(--space-x-reverse)));
    margin-right:calc(3rem*var(--space-x-reverse))
  }

  .md\\:space-y-16>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(4rem*var(--space-y-reverse));
    margin-top:calc(4rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-16>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(4rem*(1 - var(--space-x-reverse)));
    margin-right:calc(4rem*var(--space-x-reverse))
  }

  .md\\:space-y-20>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(5rem*var(--space-y-reverse));
    margin-top:calc(5rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-20>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(5rem*var(--space-x-reverse))
  }

  .md\\:space-y-24>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(6rem*var(--space-y-reverse));
    margin-top:calc(6rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-24>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(6rem*(1 - var(--space-x-reverse)));
    margin-right:calc(6rem*var(--space-x-reverse))
  }

  .md\\:space-y-32>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(8rem*var(--space-y-reverse));
    margin-top:calc(8rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-32>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(8rem*(1 - var(--space-x-reverse)));
    margin-right:calc(8rem*var(--space-x-reverse))
  }

  .md\\:space-y-40>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(10rem*var(--space-y-reverse));
    margin-top:calc(10rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-40>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(10rem*(1 - var(--space-x-reverse)));
    margin-right:calc(10rem*var(--space-x-reverse))
  }

  .md\\:space-y-48>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(12rem*var(--space-y-reverse));
    margin-top:calc(12rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-48>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(12rem*(1 - var(--space-x-reverse)));
    margin-right:calc(12rem*var(--space-x-reverse))
  }

  .md\\:space-y-56>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(14rem*var(--space-y-reverse));
    margin-top:calc(14rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-56>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(14rem*(1 - var(--space-x-reverse)));
    margin-right:calc(14rem*var(--space-x-reverse))
  }

  .md\\:space-y-64>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(16rem*var(--space-y-reverse));
    margin-top:calc(16rem*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-64>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(16rem*(1 - var(--space-x-reverse)));
    margin-right:calc(16rem*var(--space-x-reverse))
  }

  .md\\:space-y-px>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1px*var(--space-y-reverse));
    margin-top:calc(1px*(1 - var(--space-y-reverse)))
  }

  .md\\:space-x-px>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1px*(1 - var(--space-x-reverse)));
    margin-right:calc(1px*var(--space-x-reverse))
  }

  .md\\:-space-y-1>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-.25rem*var(--space-y-reverse));
    margin-top:calc(-.25rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-1>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-.25rem*var(--space-x-reverse))
  }

  .md\\:-space-y-2>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-.5rem*var(--space-y-reverse));
    margin-top:calc(-.5rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-2>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-.5rem*var(--space-x-reverse))
  }

  .md\\:-space-y-3>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-.75rem*var(--space-y-reverse));
    margin-top:calc(-.75rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-3>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-.75rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-.75rem*var(--space-x-reverse))
  }

  .md\\:-space-y-4>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1rem*var(--space-y-reverse));
    margin-top:calc(-1rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-4>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-1rem*var(--space-x-reverse))
  }

  .md\\:-space-y-5>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1.25rem*var(--space-y-reverse));
    margin-top:calc(-1.25rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-5>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-1.25rem*var(--space-x-reverse))
  }

  .md\\:-space-y-6>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1.5rem*var(--space-y-reverse));
    margin-top:calc(-1.5rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-6>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-1.5rem*var(--space-x-reverse))
  }

  .md\\:-space-y-8>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-2rem*var(--space-y-reverse));
    margin-top:calc(-2rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-8>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-2rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-2rem*var(--space-x-reverse))
  }

  .md\\:-space-y-10>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-2.5rem*var(--space-y-reverse));
    margin-top:calc(-2.5rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-10>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-2.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-2.5rem*var(--space-x-reverse))
  }

  .md\\:-space-y-12>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-3rem*var(--space-y-reverse));
    margin-top:calc(-3rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-12>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-3rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-3rem*var(--space-x-reverse))
  }

  .md\\:-space-y-16>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-4rem*var(--space-y-reverse));
    margin-top:calc(-4rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-16>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-4rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-4rem*var(--space-x-reverse))
  }

  .md\\:-space-y-20>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-5rem*var(--space-y-reverse));
    margin-top:calc(-5rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-20>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-5rem*var(--space-x-reverse))
  }

  .md\\:-space-y-24>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-6rem*var(--space-y-reverse));
    margin-top:calc(-6rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-24>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-6rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-6rem*var(--space-x-reverse))
  }

  .md\\:-space-y-32>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-8rem*var(--space-y-reverse));
    margin-top:calc(-8rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-32>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-8rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-8rem*var(--space-x-reverse))
  }

  .md\\:-space-y-40>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-10rem*var(--space-y-reverse));
    margin-top:calc(-10rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-40>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-10rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-10rem*var(--space-x-reverse))
  }

  .md\\:-space-y-48>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-12rem*var(--space-y-reverse));
    margin-top:calc(-12rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-48>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-12rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-12rem*var(--space-x-reverse))
  }

  .md\\:-space-y-56>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-14rem*var(--space-y-reverse));
    margin-top:calc(-14rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-56>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-14rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-14rem*var(--space-x-reverse))
  }

  .md\\:-space-y-64>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-16rem*var(--space-y-reverse));
    margin-top:calc(-16rem*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-64>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-16rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-16rem*var(--space-x-reverse))
  }

  .md\\:-space-y-px>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1px*var(--space-y-reverse));
    margin-top:calc(-1px*(1 - var(--space-y-reverse)))
  }

  .md\\:-space-x-px>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1px*(1 - var(--space-x-reverse)));
    margin-right:calc(-1px*var(--space-x-reverse))
  }

  .md\\:space-y-reverse>:not(template)~:not(template){
    --space-y-reverse:1
  }

  .md\\:space-x-reverse>:not(template)~:not(template){
    --space-x-reverse:1
  }

  .md\\:divide-y-0>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(0px*var(--divide-y-reverse));
    border-top-width:calc(0px*(1 - var(--divide-y-reverse)))
  }

  .md\\:divide-x-0>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(0px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(0px*var(--divide-x-reverse))
  }

  .md\\:divide-y-2>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(2px*var(--divide-y-reverse));
    border-top-width:calc(2px*(1 - var(--divide-y-reverse)))
  }

  .md\\:divide-x-2>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(2px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(2px*var(--divide-x-reverse))
  }

  .md\\:divide-y-4>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(4px*var(--divide-y-reverse));
    border-top-width:calc(4px*(1 - var(--divide-y-reverse)))
  }

  .md\\:divide-x-4>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(4px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(4px*var(--divide-x-reverse))
  }

  .md\\:divide-y-8>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(8px*var(--divide-y-reverse));
    border-top-width:calc(8px*(1 - var(--divide-y-reverse)))
  }

  .md\\:divide-x-8>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(8px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(8px*var(--divide-x-reverse))
  }

  .md\\:divide-y>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(1px*var(--divide-y-reverse));
    border-top-width:calc(1px*(1 - var(--divide-y-reverse)))
  }

  .md\\:divide-x>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(1px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(1px*var(--divide-x-reverse))
  }

  .md\\:divide-y-reverse>:not(template)~:not(template){
    --divide-y-reverse:1
  }

  .md\\:divide-x-reverse>:not(template)~:not(template){
    --divide-x-reverse:1
  }

  .md\\:divide-transparent>:not(template)~:not(template){
    border-color:#0000
  }

  .md\\:divide-white>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--divide-opacity))
  }

  .md\\:divide-black>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--divide-opacity))
  }

  .md\\:divide-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--divide-opacity))
  }

  .md\\:divide-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--divide-opacity))
  }

  .md\\:divide-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--divide-opacity))
  }

  .md\\:divide-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--divide-opacity))
  }

  .md\\:divide-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--divide-opacity))
  }

  .md\\:divide-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--divide-opacity))
  }

  .md\\:divide-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--divide-opacity))
  }

  .md\\:divide-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--divide-opacity))
  }

  .md\\:divide-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--divide-opacity))
  }

  .md\\:divide-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--divide-opacity))
  }

  .md\\:divide-cool-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--divide-opacity))
  }

  .md\\:divide-cool-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--divide-opacity))
  }

  .md\\:divide-cool-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--divide-opacity))
  }

  .md\\:divide-cool-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--divide-opacity))
  }

  .md\\:divide-cool-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--divide-opacity))
  }

  .md\\:divide-cool-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--divide-opacity))
  }

  .md\\:divide-cool-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--divide-opacity))
  }

  .md\\:divide-cool-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--divide-opacity))
  }

  .md\\:divide-cool-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--divide-opacity))
  }

  .md\\:divide-cool-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--divide-opacity))
  }

  .md\\:divide-red-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--divide-opacity))
  }

  .md\\:divide-red-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--divide-opacity))
  }

  .md\\:divide-red-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--divide-opacity))
  }

  .md\\:divide-red-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--divide-opacity))
  }

  .md\\:divide-red-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--divide-opacity))
  }

  .md\\:divide-red-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--divide-opacity))
  }

  .md\\:divide-red-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--divide-opacity))
  }

  .md\\:divide-red-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--divide-opacity))
  }

  .md\\:divide-red-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--divide-opacity))
  }

  .md\\:divide-red-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .md\\:divide-orange-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--divide-opacity))
  }

  .md\\:divide-orange-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--divide-opacity))
  }

  .md\\:divide-orange-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--divide-opacity))
  }

  .md\\:divide-orange-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--divide-opacity))
  }

  .md\\:divide-orange-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--divide-opacity))
  }

  .md\\:divide-orange-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--divide-opacity))
  }

  .md\\:divide-orange-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--divide-opacity))
  }

  .md\\:divide-orange-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--divide-opacity))
  }

  .md\\:divide-orange-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--divide-opacity))
  }

  .md\\:divide-orange-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .md\\:divide-yellow-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--divide-opacity))
  }

  .md\\:divide-yellow-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--divide-opacity))
  }

  .md\\:divide-yellow-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--divide-opacity))
  }

  .md\\:divide-yellow-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--divide-opacity))
  }

  .md\\:divide-yellow-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--divide-opacity))
  }

  .md\\:divide-yellow-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--divide-opacity))
  }

  .md\\:divide-yellow-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--divide-opacity))
  }

  .md\\:divide-yellow-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--divide-opacity))
  }

  .md\\:divide-yellow-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--divide-opacity))
  }

  .md\\:divide-yellow-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--divide-opacity))
  }

  .md\\:divide-green-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--divide-opacity))
  }

  .md\\:divide-green-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--divide-opacity))
  }

  .md\\:divide-green-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--divide-opacity))
  }

  .md\\:divide-green-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--divide-opacity))
  }

  .md\\:divide-green-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--divide-opacity))
  }

  .md\\:divide-green-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--divide-opacity))
  }

  .md\\:divide-green-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--divide-opacity))
  }

  .md\\:divide-green-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--divide-opacity))
  }

  .md\\:divide-green-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--divide-opacity))
  }

  .md\\:divide-green-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--divide-opacity))
  }

  .md\\:divide-teal-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--divide-opacity))
  }

  .md\\:divide-teal-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--divide-opacity))
  }

  .md\\:divide-teal-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--divide-opacity))
  }

  .md\\:divide-teal-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--divide-opacity))
  }

  .md\\:divide-teal-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--divide-opacity))
  }

  .md\\:divide-teal-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--divide-opacity))
  }

  .md\\:divide-teal-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--divide-opacity))
  }

  .md\\:divide-teal-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--divide-opacity))
  }

  .md\\:divide-teal-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--divide-opacity))
  }

  .md\\:divide-teal-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--divide-opacity))
  }

  .md\\:divide-blue-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--divide-opacity))
  }

  .md\\:divide-blue-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--divide-opacity))
  }

  .md\\:divide-blue-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--divide-opacity))
  }

  .md\\:divide-blue-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--divide-opacity))
  }

  .md\\:divide-blue-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--divide-opacity))
  }

  .md\\:divide-blue-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--divide-opacity))
  }

  .md\\:divide-blue-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--divide-opacity))
  }

  .md\\:divide-blue-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--divide-opacity))
  }

  .md\\:divide-blue-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--divide-opacity))
  }

  .md\\:divide-blue-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--divide-opacity))
  }

  .md\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--divide-opacity))
  }

  .md\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--divide-opacity))
  }

  .md\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--divide-opacity))
  }

  .md\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--divide-opacity))
  }

  .md\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--divide-opacity))
  }

  .md\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--divide-opacity))
  }

  .md\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--divide-opacity))
  }

  .md\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--divide-opacity))
  }

  .md\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--divide-opacity))
  }

  .md\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--divide-opacity))
  }

  .md\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--divide-opacity))
  }

  .md\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--divide-opacity))
  }

  .md\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--divide-opacity))
  }

  .md\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--divide-opacity))
  }

  .md\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--divide-opacity))
  }

  .md\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--divide-opacity))
  }

  .md\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--divide-opacity))
  }

  .md\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--divide-opacity))
  }

  .md\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--divide-opacity))
  }

  .md\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--divide-opacity))
  }

  .md\\:divide-pink-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--divide-opacity))
  }

  .md\\:divide-pink-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--divide-opacity))
  }

  .md\\:divide-pink-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--divide-opacity))
  }

  .md\\:divide-pink-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--divide-opacity))
  }

  .md\\:divide-pink-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--divide-opacity))
  }

  .md\\:divide-pink-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--divide-opacity))
  }

  .md\\:divide-pink-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--divide-opacity))
  }

  .md\\:divide-pink-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--divide-opacity))
  }

  .md\\:divide-pink-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--divide-opacity))
  }

  .md\\:divide-pink-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-transparent>:not(template)~:not(template){
    border-color:#0000
  }

  .theme-dark .md\\:dark\\:divide-white>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-black>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-cool-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-cool-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-cool-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-cool-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-cool-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-cool-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-cool-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-cool-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-cool-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-cool-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-red-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-red-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-red-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-red-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-red-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-red-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-red-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-red-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-red-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-red-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-orange-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-orange-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-orange-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-orange-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-orange-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-orange-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-orange-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-orange-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-orange-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-orange-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-yellow-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-yellow-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-yellow-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-yellow-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-yellow-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-yellow-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-yellow-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-yellow-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-yellow-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-yellow-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-green-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-green-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-green-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-green-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-green-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-green-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-green-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-green-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-green-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-green-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-teal-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-teal-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-teal-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-teal-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-teal-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-teal-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-teal-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-teal-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-teal-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-teal-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-blue-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-blue-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-blue-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-blue-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-blue-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-blue-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-blue-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-blue-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-blue-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-blue-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-pink-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-pink-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-pink-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-pink-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-pink-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-pink-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-pink-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-pink-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-pink-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--divide-opacity))
  }

  .theme-dark .md\\:dark\\:divide-pink-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--divide-opacity))
  }

  .md\\:divide-opacity-0>:not(template)~:not(template){
    --divide-opacity:0
  }

  .md\\:divide-opacity-25>:not(template)~:not(template){
    --divide-opacity:0.25
  }

  .md\\:divide-opacity-50>:not(template)~:not(template){
    --divide-opacity:0.5
  }

  .md\\:divide-opacity-75>:not(template)~:not(template){
    --divide-opacity:0.75
  }

  .md\\:divide-opacity-100>:not(template)~:not(template){
    --divide-opacity:1
  }

  .md\\:sr-only{
    height:1px;
    margin:-1px;
    overflow:hidden;
    padding:0;
    position:absolute;
    width:1px;
    clip:rect(0,0,0,0);
    border-width:0;
    white-space:nowrap
  }

  .md\\:not-sr-only{
    height:auto;
    margin:0;
    overflow:visible;
    padding:0;
    position:static;
    width:auto;
    clip:auto;
    white-space:normal
  }

  .md\\:focus\\:sr-only:focus{
    height:1px;
    margin:-1px;
    overflow:hidden;
    padding:0;
    position:absolute;
    width:1px;
    clip:rect(0,0,0,0);
    border-width:0;
    white-space:nowrap
  }

  .md\\:focus\\:not-sr-only:focus{
    height:auto;
    margin:0;
    overflow:visible;
    padding:0;
    position:static;
    width:auto;
    clip:auto;
    white-space:normal
  }

  .md\\:appearance-none{
    appearance:none
  }

  .md\\:bg-fixed{
    background-attachment:fixed
  }

  .md\\:bg-local{
    background-attachment:local
  }

  .md\\:bg-scroll{
    background-attachment:scroll
  }

  .md\\:bg-transparent{
    background-color:initial
  }

  .md\\:bg-white{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .md\\:bg-black{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .md\\:bg-gray-50{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .md\\:bg-gray-100{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .md\\:bg-gray-200{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .md\\:bg-gray-300{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .md\\:bg-gray-400{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .md\\:bg-gray-500{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .md\\:bg-gray-600{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .md\\:bg-gray-700{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .md\\:bg-gray-800{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .md\\:bg-gray-900{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .md\\:bg-cool-gray-50{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .md\\:bg-cool-gray-100{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .md\\:bg-cool-gray-200{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .md\\:bg-cool-gray-300{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .md\\:bg-cool-gray-400{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .md\\:bg-cool-gray-500{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .md\\:bg-cool-gray-600{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .md\\:bg-cool-gray-700{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .md\\:bg-cool-gray-800{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .md\\:bg-cool-gray-900{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .md\\:bg-red-50{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .md\\:bg-red-100{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .md\\:bg-red-200{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .md\\:bg-red-300{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .md\\:bg-red-400{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .md\\:bg-red-500{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .md\\:bg-red-600{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .md\\:bg-red-700{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .md\\:bg-red-800{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .md\\:bg-red-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .md\\:bg-orange-50{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .md\\:bg-orange-100{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .md\\:bg-orange-200{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .md\\:bg-orange-300{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .md\\:bg-orange-400{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .md\\:bg-orange-500{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .md\\:bg-orange-600{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .md\\:bg-orange-700{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .md\\:bg-orange-800{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .md\\:bg-orange-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .md\\:bg-yellow-50{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .md\\:bg-yellow-100{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .md\\:bg-yellow-200{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .md\\:bg-yellow-300{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .md\\:bg-yellow-400{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .md\\:bg-yellow-500{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .md\\:bg-yellow-600{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .md\\:bg-yellow-700{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .md\\:bg-yellow-800{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .md\\:bg-yellow-900{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .md\\:bg-green-50{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .md\\:bg-green-100{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .md\\:bg-green-200{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .md\\:bg-green-300{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .md\\:bg-green-400{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .md\\:bg-green-500{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .md\\:bg-green-600{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .md\\:bg-green-700{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .md\\:bg-green-800{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .md\\:bg-green-900{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .md\\:bg-teal-50{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .md\\:bg-teal-100{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .md\\:bg-teal-200{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .md\\:bg-teal-300{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .md\\:bg-teal-400{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .md\\:bg-teal-500{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .md\\:bg-teal-600{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .md\\:bg-teal-700{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .md\\:bg-teal-800{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .md\\:bg-teal-900{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .md\\:bg-blue-50{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .md\\:bg-blue-100{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .md\\:bg-blue-200{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .md\\:bg-blue-300{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .md\\:bg-blue-400{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .md\\:bg-blue-500{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .md\\:bg-blue-600{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .md\\:bg-blue-700{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .md\\:bg-blue-800{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .md\\:bg-blue-900{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .md\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .md\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .md\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .md\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .md\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .md\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .md\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .md\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .md\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .md\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .md\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .md\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .md\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .md\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .md\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .md\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .md\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .md\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .md\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .md\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .md\\:bg-pink-50{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .md\\:bg-pink-100{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .md\\:bg-pink-200{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .md\\:bg-pink-300{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .md\\:bg-pink-400{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .md\\:bg-pink-500{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .md\\:bg-pink-600{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .md\\:bg-pink-700{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .md\\:bg-pink-800{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .md\\:bg-pink-900{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .md\\:hover\\:bg-transparent:hover{
    background-color:initial
  }

  .md\\:hover\\:bg-white:hover{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .md\\:hover\\:bg-black:hover{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .md\\:hover\\:bg-gray-50:hover{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .md\\:hover\\:bg-gray-100:hover{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .md\\:hover\\:bg-gray-200:hover{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .md\\:hover\\:bg-gray-300:hover{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .md\\:hover\\:bg-gray-400:hover{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .md\\:hover\\:bg-gray-500:hover{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .md\\:hover\\:bg-gray-600:hover{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .md\\:hover\\:bg-gray-700:hover{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .md\\:hover\\:bg-gray-800:hover{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .md\\:hover\\:bg-gray-900:hover{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .md\\:hover\\:bg-cool-gray-50:hover{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .md\\:hover\\:bg-cool-gray-100:hover{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .md\\:hover\\:bg-cool-gray-200:hover{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .md\\:hover\\:bg-cool-gray-300:hover{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .md\\:hover\\:bg-cool-gray-400:hover{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .md\\:hover\\:bg-cool-gray-500:hover{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .md\\:hover\\:bg-cool-gray-600:hover{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .md\\:hover\\:bg-cool-gray-700:hover{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .md\\:hover\\:bg-cool-gray-800:hover{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .md\\:hover\\:bg-cool-gray-900:hover{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .md\\:hover\\:bg-red-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .md\\:hover\\:bg-red-100:hover{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .md\\:hover\\:bg-red-200:hover{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .md\\:hover\\:bg-red-300:hover{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .md\\:hover\\:bg-red-400:hover{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .md\\:hover\\:bg-red-500:hover{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .md\\:hover\\:bg-red-600:hover{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .md\\:hover\\:bg-red-700:hover{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .md\\:hover\\:bg-red-800:hover{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .md\\:hover\\:bg-red-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .md\\:hover\\:bg-orange-50:hover{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .md\\:hover\\:bg-orange-100:hover{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .md\\:hover\\:bg-orange-200:hover{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .md\\:hover\\:bg-orange-300:hover{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .md\\:hover\\:bg-orange-400:hover{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .md\\:hover\\:bg-orange-500:hover{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .md\\:hover\\:bg-orange-600:hover{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .md\\:hover\\:bg-orange-700:hover{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .md\\:hover\\:bg-orange-800:hover{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .md\\:hover\\:bg-orange-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .md\\:hover\\:bg-yellow-50:hover{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .md\\:hover\\:bg-yellow-100:hover{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .md\\:hover\\:bg-yellow-200:hover{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .md\\:hover\\:bg-yellow-300:hover{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .md\\:hover\\:bg-yellow-400:hover{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .md\\:hover\\:bg-yellow-500:hover{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .md\\:hover\\:bg-yellow-600:hover{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .md\\:hover\\:bg-yellow-700:hover{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .md\\:hover\\:bg-yellow-800:hover{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .md\\:hover\\:bg-yellow-900:hover{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .md\\:hover\\:bg-green-50:hover{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .md\\:hover\\:bg-green-100:hover{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .md\\:hover\\:bg-green-200:hover{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .md\\:hover\\:bg-green-300:hover{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .md\\:hover\\:bg-green-400:hover{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .md\\:hover\\:bg-green-500:hover{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .md\\:hover\\:bg-green-600:hover{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .md\\:hover\\:bg-green-700:hover{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .md\\:hover\\:bg-green-800:hover{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .md\\:hover\\:bg-green-900:hover{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .md\\:hover\\:bg-teal-50:hover{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .md\\:hover\\:bg-teal-100:hover{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .md\\:hover\\:bg-teal-200:hover{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .md\\:hover\\:bg-teal-300:hover{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .md\\:hover\\:bg-teal-400:hover{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .md\\:hover\\:bg-teal-500:hover{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .md\\:hover\\:bg-teal-600:hover{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .md\\:hover\\:bg-teal-700:hover{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .md\\:hover\\:bg-teal-800:hover{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .md\\:hover\\:bg-teal-900:hover{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .md\\:hover\\:bg-blue-50:hover{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .md\\:hover\\:bg-blue-100:hover{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .md\\:hover\\:bg-blue-200:hover{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .md\\:hover\\:bg-blue-300:hover{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .md\\:hover\\:bg-blue-400:hover{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .md\\:hover\\:bg-blue-500:hover{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .md\\:hover\\:bg-blue-600:hover{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .md\\:hover\\:bg-blue-700:hover{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .md\\:hover\\:bg-blue-800:hover{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .md\\:hover\\:bg-blue-900:hover{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .md\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .md\\:hover\\:bg-pink-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .md\\:hover\\:bg-pink-100:hover{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .md\\:hover\\:bg-pink-200:hover{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .md\\:hover\\:bg-pink-300:hover{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .md\\:hover\\:bg-pink-400:hover{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .md\\:hover\\:bg-pink-500:hover{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .md\\:hover\\:bg-pink-600:hover{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .md\\:hover\\:bg-pink-700:hover{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .md\\:hover\\:bg-pink-800:hover{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .md\\:hover\\:bg-pink-900:hover{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .md\\:focus\\:bg-transparent:focus{
    background-color:initial
  }

  .md\\:focus\\:bg-white:focus{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .md\\:focus\\:bg-black:focus{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .md\\:focus\\:bg-gray-50:focus{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .md\\:focus\\:bg-gray-100:focus{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .md\\:focus\\:bg-gray-200:focus{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .md\\:focus\\:bg-gray-300:focus{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .md\\:focus\\:bg-gray-400:focus{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .md\\:focus\\:bg-gray-500:focus{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .md\\:focus\\:bg-gray-600:focus{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .md\\:focus\\:bg-gray-700:focus{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .md\\:focus\\:bg-gray-800:focus{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .md\\:focus\\:bg-gray-900:focus{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .md\\:focus\\:bg-cool-gray-50:focus{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .md\\:focus\\:bg-cool-gray-100:focus{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .md\\:focus\\:bg-cool-gray-200:focus{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .md\\:focus\\:bg-cool-gray-300:focus{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .md\\:focus\\:bg-cool-gray-400:focus{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .md\\:focus\\:bg-cool-gray-500:focus{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .md\\:focus\\:bg-cool-gray-600:focus{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .md\\:focus\\:bg-cool-gray-700:focus{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .md\\:focus\\:bg-cool-gray-800:focus{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .md\\:focus\\:bg-cool-gray-900:focus{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .md\\:focus\\:bg-red-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .md\\:focus\\:bg-red-100:focus{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .md\\:focus\\:bg-red-200:focus{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .md\\:focus\\:bg-red-300:focus{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .md\\:focus\\:bg-red-400:focus{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .md\\:focus\\:bg-red-500:focus{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .md\\:focus\\:bg-red-600:focus{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .md\\:focus\\:bg-red-700:focus{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .md\\:focus\\:bg-red-800:focus{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .md\\:focus\\:bg-red-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .md\\:focus\\:bg-orange-50:focus{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .md\\:focus\\:bg-orange-100:focus{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .md\\:focus\\:bg-orange-200:focus{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .md\\:focus\\:bg-orange-300:focus{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .md\\:focus\\:bg-orange-400:focus{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .md\\:focus\\:bg-orange-500:focus{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .md\\:focus\\:bg-orange-600:focus{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .md\\:focus\\:bg-orange-700:focus{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .md\\:focus\\:bg-orange-800:focus{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .md\\:focus\\:bg-orange-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .md\\:focus\\:bg-yellow-50:focus{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .md\\:focus\\:bg-yellow-100:focus{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .md\\:focus\\:bg-yellow-200:focus{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .md\\:focus\\:bg-yellow-300:focus{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .md\\:focus\\:bg-yellow-400:focus{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .md\\:focus\\:bg-yellow-500:focus{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .md\\:focus\\:bg-yellow-600:focus{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .md\\:focus\\:bg-yellow-700:focus{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .md\\:focus\\:bg-yellow-800:focus{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .md\\:focus\\:bg-yellow-900:focus{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .md\\:focus\\:bg-green-50:focus{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .md\\:focus\\:bg-green-100:focus{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .md\\:focus\\:bg-green-200:focus{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .md\\:focus\\:bg-green-300:focus{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .md\\:focus\\:bg-green-400:focus{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .md\\:focus\\:bg-green-500:focus{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .md\\:focus\\:bg-green-600:focus{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .md\\:focus\\:bg-green-700:focus{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .md\\:focus\\:bg-green-800:focus{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .md\\:focus\\:bg-green-900:focus{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .md\\:focus\\:bg-teal-50:focus{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .md\\:focus\\:bg-teal-100:focus{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .md\\:focus\\:bg-teal-200:focus{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .md\\:focus\\:bg-teal-300:focus{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .md\\:focus\\:bg-teal-400:focus{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .md\\:focus\\:bg-teal-500:focus{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .md\\:focus\\:bg-teal-600:focus{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .md\\:focus\\:bg-teal-700:focus{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .md\\:focus\\:bg-teal-800:focus{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .md\\:focus\\:bg-teal-900:focus{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .md\\:focus\\:bg-blue-50:focus{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .md\\:focus\\:bg-blue-100:focus{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .md\\:focus\\:bg-blue-200:focus{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .md\\:focus\\:bg-blue-300:focus{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .md\\:focus\\:bg-blue-400:focus{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .md\\:focus\\:bg-blue-500:focus{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .md\\:focus\\:bg-blue-600:focus{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .md\\:focus\\:bg-blue-700:focus{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .md\\:focus\\:bg-blue-800:focus{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .md\\:focus\\:bg-blue-900:focus{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .md\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .md\\:focus\\:bg-pink-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .md\\:focus\\:bg-pink-100:focus{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .md\\:focus\\:bg-pink-200:focus{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .md\\:focus\\:bg-pink-300:focus{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .md\\:focus\\:bg-pink-400:focus{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .md\\:focus\\:bg-pink-500:focus{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .md\\:focus\\:bg-pink-600:focus{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .md\\:focus\\:bg-pink-700:focus{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .md\\:focus\\:bg-pink-800:focus{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .md\\:focus\\:bg-pink-900:focus{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .md\\:active\\:bg-transparent:active{
    background-color:initial
  }

  .md\\:active\\:bg-white:active{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .md\\:active\\:bg-black:active{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .md\\:active\\:bg-gray-50:active{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .md\\:active\\:bg-gray-100:active{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .md\\:active\\:bg-gray-200:active{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .md\\:active\\:bg-gray-300:active{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .md\\:active\\:bg-gray-400:active{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .md\\:active\\:bg-gray-500:active{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .md\\:active\\:bg-gray-600:active{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .md\\:active\\:bg-gray-700:active{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .md\\:active\\:bg-gray-800:active{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .md\\:active\\:bg-gray-900:active{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .md\\:active\\:bg-cool-gray-50:active{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .md\\:active\\:bg-cool-gray-100:active{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .md\\:active\\:bg-cool-gray-200:active{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .md\\:active\\:bg-cool-gray-300:active{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .md\\:active\\:bg-cool-gray-400:active{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .md\\:active\\:bg-cool-gray-500:active{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .md\\:active\\:bg-cool-gray-600:active{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .md\\:active\\:bg-cool-gray-700:active{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .md\\:active\\:bg-cool-gray-800:active{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .md\\:active\\:bg-cool-gray-900:active{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .md\\:active\\:bg-red-50:active{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .md\\:active\\:bg-red-100:active{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .md\\:active\\:bg-red-200:active{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .md\\:active\\:bg-red-300:active{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .md\\:active\\:bg-red-400:active{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .md\\:active\\:bg-red-500:active{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .md\\:active\\:bg-red-600:active{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .md\\:active\\:bg-red-700:active{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .md\\:active\\:bg-red-800:active{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .md\\:active\\:bg-red-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .md\\:active\\:bg-orange-50:active{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .md\\:active\\:bg-orange-100:active{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .md\\:active\\:bg-orange-200:active{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .md\\:active\\:bg-orange-300:active{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .md\\:active\\:bg-orange-400:active{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .md\\:active\\:bg-orange-500:active{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .md\\:active\\:bg-orange-600:active{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .md\\:active\\:bg-orange-700:active{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .md\\:active\\:bg-orange-800:active{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .md\\:active\\:bg-orange-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .md\\:active\\:bg-yellow-50:active{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .md\\:active\\:bg-yellow-100:active{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .md\\:active\\:bg-yellow-200:active{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .md\\:active\\:bg-yellow-300:active{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .md\\:active\\:bg-yellow-400:active{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .md\\:active\\:bg-yellow-500:active{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .md\\:active\\:bg-yellow-600:active{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .md\\:active\\:bg-yellow-700:active{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .md\\:active\\:bg-yellow-800:active{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .md\\:active\\:bg-yellow-900:active{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .md\\:active\\:bg-green-50:active{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .md\\:active\\:bg-green-100:active{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .md\\:active\\:bg-green-200:active{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .md\\:active\\:bg-green-300:active{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .md\\:active\\:bg-green-400:active{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .md\\:active\\:bg-green-500:active{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .md\\:active\\:bg-green-600:active{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .md\\:active\\:bg-green-700:active{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .md\\:active\\:bg-green-800:active{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .md\\:active\\:bg-green-900:active{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .md\\:active\\:bg-teal-50:active{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .md\\:active\\:bg-teal-100:active{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .md\\:active\\:bg-teal-200:active{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .md\\:active\\:bg-teal-300:active{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .md\\:active\\:bg-teal-400:active{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .md\\:active\\:bg-teal-500:active{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .md\\:active\\:bg-teal-600:active{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .md\\:active\\:bg-teal-700:active{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .md\\:active\\:bg-teal-800:active{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .md\\:active\\:bg-teal-900:active{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .md\\:active\\:bg-blue-50:active{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .md\\:active\\:bg-blue-100:active{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .md\\:active\\:bg-blue-200:active{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .md\\:active\\:bg-blue-300:active{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .md\\:active\\:bg-blue-400:active{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .md\\:active\\:bg-blue-500:active{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .md\\:active\\:bg-blue-600:active{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .md\\:active\\:bg-blue-700:active{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .md\\:active\\:bg-blue-800:active{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .md\\:active\\:bg-blue-900:active{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .md\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .md\\:active\\:bg-pink-50:active{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .md\\:active\\:bg-pink-100:active{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .md\\:active\\:bg-pink-200:active{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .md\\:active\\:bg-pink-300:active{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .md\\:active\\:bg-pink-400:active{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .md\\:active\\:bg-pink-500:active{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .md\\:active\\:bg-pink-600:active{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .md\\:active\\:bg-pink-700:active{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .md\\:active\\:bg-pink-800:active{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .md\\:active\\:bg-pink-900:active{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .md\\:odd\\:bg-transparent:nth-child(odd){
    background-color:initial
  }

  .md\\:odd\\:bg-white:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .md\\:odd\\:bg-black:nth-child(odd){
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .md\\:odd\\:bg-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .md\\:odd\\:bg-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .md\\:odd\\:bg-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .md\\:odd\\:bg-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .md\\:odd\\:bg-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .md\\:odd\\:bg-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .md\\:odd\\:bg-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .md\\:odd\\:bg-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .md\\:odd\\:bg-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .md\\:odd\\:bg-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .md\\:odd\\:bg-cool-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .md\\:odd\\:bg-cool-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .md\\:odd\\:bg-cool-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .md\\:odd\\:bg-cool-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .md\\:odd\\:bg-cool-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .md\\:odd\\:bg-cool-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .md\\:odd\\:bg-cool-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .md\\:odd\\:bg-cool-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .md\\:odd\\:bg-cool-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .md\\:odd\\:bg-cool-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .md\\:odd\\:bg-red-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .md\\:odd\\:bg-red-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .md\\:odd\\:bg-red-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .md\\:odd\\:bg-red-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .md\\:odd\\:bg-red-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .md\\:odd\\:bg-red-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .md\\:odd\\:bg-red-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .md\\:odd\\:bg-red-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .md\\:odd\\:bg-red-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .md\\:odd\\:bg-red-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .md\\:odd\\:bg-orange-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .md\\:odd\\:bg-orange-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .md\\:odd\\:bg-orange-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .md\\:odd\\:bg-orange-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .md\\:odd\\:bg-orange-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .md\\:odd\\:bg-orange-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .md\\:odd\\:bg-orange-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .md\\:odd\\:bg-orange-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .md\\:odd\\:bg-orange-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .md\\:odd\\:bg-orange-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .md\\:odd\\:bg-yellow-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .md\\:odd\\:bg-yellow-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .md\\:odd\\:bg-yellow-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .md\\:odd\\:bg-yellow-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .md\\:odd\\:bg-yellow-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .md\\:odd\\:bg-yellow-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .md\\:odd\\:bg-yellow-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .md\\:odd\\:bg-yellow-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .md\\:odd\\:bg-yellow-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .md\\:odd\\:bg-yellow-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .md\\:odd\\:bg-green-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .md\\:odd\\:bg-green-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .md\\:odd\\:bg-green-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .md\\:odd\\:bg-green-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .md\\:odd\\:bg-green-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .md\\:odd\\:bg-green-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .md\\:odd\\:bg-green-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .md\\:odd\\:bg-green-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .md\\:odd\\:bg-green-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .md\\:odd\\:bg-green-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .md\\:odd\\:bg-teal-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .md\\:odd\\:bg-teal-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .md\\:odd\\:bg-teal-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .md\\:odd\\:bg-teal-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .md\\:odd\\:bg-teal-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .md\\:odd\\:bg-teal-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .md\\:odd\\:bg-teal-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .md\\:odd\\:bg-teal-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .md\\:odd\\:bg-teal-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .md\\:odd\\:bg-teal-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .md\\:odd\\:bg-blue-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .md\\:odd\\:bg-blue-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .md\\:odd\\:bg-blue-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .md\\:odd\\:bg-blue-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .md\\:odd\\:bg-blue-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .md\\:odd\\:bg-blue-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .md\\:odd\\:bg-blue-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .md\\:odd\\:bg-blue-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .md\\:odd\\:bg-blue-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .md\\:odd\\:bg-blue-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .md\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .md\\:odd\\:bg-pink-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .md\\:odd\\:bg-pink-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .md\\:odd\\:bg-pink-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .md\\:odd\\:bg-pink-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .md\\:odd\\:bg-pink-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .md\\:odd\\:bg-pink-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .md\\:odd\\:bg-pink-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .md\\:odd\\:bg-pink-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .md\\:odd\\:bg-pink-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .md\\:odd\\:bg-pink-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-transparent{
    background-color:initial
  }

  .theme-dark .md\\:dark\\:bg-white{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-black{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-gray-50{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-gray-100{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-gray-200{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-gray-300{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-gray-400{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-gray-500{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-gray-600{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-gray-700{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-gray-800{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-gray-900{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-cool-gray-50{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-cool-gray-100{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-cool-gray-200{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-cool-gray-300{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-cool-gray-400{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-cool-gray-500{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-cool-gray-600{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-cool-gray-700{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-cool-gray-800{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-cool-gray-900{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-red-50{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-red-100{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-red-200{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-red-300{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-red-400{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-red-500{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-red-600{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-red-700{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-red-800{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-red-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-orange-50{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-orange-100{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-orange-200{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-orange-300{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-orange-400{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-orange-500{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-orange-600{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-orange-700{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-orange-800{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-orange-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-yellow-50{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-yellow-100{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-yellow-200{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-yellow-300{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-yellow-400{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-yellow-500{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-yellow-600{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-yellow-700{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-yellow-800{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-yellow-900{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-green-50{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-green-100{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-green-200{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-green-300{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-green-400{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-green-500{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-green-600{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-green-700{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-green-800{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-green-900{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-teal-50{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-teal-100{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-teal-200{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-teal-300{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-teal-400{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-teal-500{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-teal-600{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-teal-700{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-teal-800{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-teal-900{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-blue-50{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-blue-100{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-blue-200{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-blue-300{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-blue-400{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-blue-500{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-blue-600{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-blue-700{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-blue-800{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-blue-900{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-pink-50{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-pink-100{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-pink-200{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-pink-300{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-pink-400{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-pink-500{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-pink-600{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-pink-700{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-pink-800{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:bg-pink-900{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-transparent:hover{
    background-color:initial
  }

  .theme-dark .md\\:dark\\:hover\\:bg-white:hover{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-black:hover{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-gray-50:hover{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-gray-100:hover{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-gray-200:hover{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-gray-300:hover{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-gray-400:hover{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-gray-500:hover{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-gray-600:hover{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-gray-700:hover{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-gray-800:hover{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-gray-900:hover{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-cool-gray-50:hover{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-cool-gray-100:hover{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-cool-gray-200:hover{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-cool-gray-300:hover{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-cool-gray-400:hover{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-cool-gray-500:hover{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-cool-gray-600:hover{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-cool-gray-700:hover{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-cool-gray-800:hover{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-cool-gray-900:hover{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-red-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-red-100:hover{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-red-200:hover{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-red-300:hover{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-red-400:hover{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-red-500:hover{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-red-600:hover{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-red-700:hover{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-red-800:hover{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-red-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-orange-50:hover{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-orange-100:hover{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-orange-200:hover{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-orange-300:hover{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-orange-400:hover{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-orange-500:hover{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-orange-600:hover{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-orange-700:hover{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-orange-800:hover{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-orange-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-yellow-50:hover{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-yellow-100:hover{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-yellow-200:hover{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-yellow-300:hover{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-yellow-400:hover{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-yellow-500:hover{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-yellow-600:hover{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-yellow-700:hover{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-yellow-800:hover{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-yellow-900:hover{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-green-50:hover{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-green-100:hover{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-green-200:hover{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-green-300:hover{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-green-400:hover{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-green-500:hover{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-green-600:hover{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-green-700:hover{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-green-800:hover{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-green-900:hover{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-teal-50:hover{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-teal-100:hover{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-teal-200:hover{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-teal-300:hover{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-teal-400:hover{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-teal-500:hover{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-teal-600:hover{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-teal-700:hover{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-teal-800:hover{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-teal-900:hover{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-blue-50:hover{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-blue-100:hover{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-blue-200:hover{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-blue-300:hover{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-blue-400:hover{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-blue-500:hover{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-blue-600:hover{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-blue-700:hover{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-blue-800:hover{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-blue-900:hover{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-pink-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-pink-100:hover{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-pink-200:hover{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-pink-300:hover{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-pink-400:hover{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-pink-500:hover{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-pink-600:hover{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-pink-700:hover{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-pink-800:hover{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:bg-pink-900:hover{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-transparent:focus{
    background-color:initial
  }

  .theme-dark .md\\:dark\\:focus\\:bg-white:focus{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-black:focus{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-gray-50:focus{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-gray-100:focus{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-gray-200:focus{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-gray-300:focus{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-gray-400:focus{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-gray-500:focus{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-gray-600:focus{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-gray-700:focus{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-gray-800:focus{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-gray-900:focus{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-cool-gray-50:focus{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-cool-gray-100:focus{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-cool-gray-200:focus{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-cool-gray-300:focus{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-cool-gray-400:focus{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-cool-gray-500:focus{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-cool-gray-600:focus{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-cool-gray-700:focus{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-cool-gray-800:focus{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-cool-gray-900:focus{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-red-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-red-100:focus{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-red-200:focus{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-red-300:focus{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-red-400:focus{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-red-500:focus{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-red-600:focus{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-red-700:focus{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-red-800:focus{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-red-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-orange-50:focus{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-orange-100:focus{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-orange-200:focus{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-orange-300:focus{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-orange-400:focus{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-orange-500:focus{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-orange-600:focus{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-orange-700:focus{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-orange-800:focus{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-orange-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-yellow-50:focus{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-yellow-100:focus{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-yellow-200:focus{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-yellow-300:focus{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-yellow-400:focus{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-yellow-500:focus{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-yellow-600:focus{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-yellow-700:focus{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-yellow-800:focus{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-yellow-900:focus{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-green-50:focus{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-green-100:focus{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-green-200:focus{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-green-300:focus{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-green-400:focus{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-green-500:focus{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-green-600:focus{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-green-700:focus{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-green-800:focus{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-green-900:focus{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-teal-50:focus{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-teal-100:focus{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-teal-200:focus{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-teal-300:focus{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-teal-400:focus{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-teal-500:focus{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-teal-600:focus{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-teal-700:focus{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-teal-800:focus{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-teal-900:focus{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-blue-50:focus{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-blue-100:focus{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-blue-200:focus{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-blue-300:focus{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-blue-400:focus{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-blue-500:focus{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-blue-600:focus{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-blue-700:focus{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-blue-800:focus{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-blue-900:focus{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-pink-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-pink-100:focus{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-pink-200:focus{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-pink-300:focus{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-pink-400:focus{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-pink-500:focus{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-pink-600:focus{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-pink-700:focus{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-pink-800:focus{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:bg-pink-900:focus{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-transparent:active{
    background-color:initial
  }

  .theme-dark .md\\:dark\\:active\\:bg-white:active{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-black:active{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-gray-50:active{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-gray-100:active{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-gray-200:active{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-gray-300:active{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-gray-400:active{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-gray-500:active{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-gray-600:active{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-gray-700:active{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-gray-800:active{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-gray-900:active{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-cool-gray-50:active{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-cool-gray-100:active{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-cool-gray-200:active{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-cool-gray-300:active{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-cool-gray-400:active{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-cool-gray-500:active{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-cool-gray-600:active{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-cool-gray-700:active{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-cool-gray-800:active{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-cool-gray-900:active{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-red-50:active{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-red-100:active{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-red-200:active{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-red-300:active{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-red-400:active{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-red-500:active{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-red-600:active{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-red-700:active{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-red-800:active{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-red-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-orange-50:active{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-orange-100:active{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-orange-200:active{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-orange-300:active{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-orange-400:active{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-orange-500:active{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-orange-600:active{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-orange-700:active{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-orange-800:active{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-orange-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-yellow-50:active{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-yellow-100:active{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-yellow-200:active{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-yellow-300:active{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-yellow-400:active{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-yellow-500:active{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-yellow-600:active{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-yellow-700:active{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-yellow-800:active{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-yellow-900:active{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-green-50:active{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-green-100:active{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-green-200:active{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-green-300:active{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-green-400:active{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-green-500:active{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-green-600:active{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-green-700:active{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-green-800:active{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-green-900:active{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-teal-50:active{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-teal-100:active{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-teal-200:active{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-teal-300:active{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-teal-400:active{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-teal-500:active{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-teal-600:active{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-teal-700:active{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-teal-800:active{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-teal-900:active{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-blue-50:active{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-blue-100:active{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-blue-200:active{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-blue-300:active{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-blue-400:active{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-blue-500:active{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-blue-600:active{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-blue-700:active{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-blue-800:active{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-blue-900:active{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-pink-50:active{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-pink-100:active{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-pink-200:active{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-pink-300:active{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-pink-400:active{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-pink-500:active{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-pink-600:active{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-pink-700:active{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-pink-800:active{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:bg-pink-900:active{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-transparent:nth-child(odd){
    background-color:initial
  }

  .theme-dark .md\\:dark\\:odd\\:bg-white:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-black:nth-child(odd){
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-cool-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-cool-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-cool-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-cool-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-cool-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-cool-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-cool-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-cool-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-cool-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-cool-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-red-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-red-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-red-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-red-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-red-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-red-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-red-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-red-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-red-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-red-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-orange-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-orange-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-orange-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-orange-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-orange-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-orange-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-orange-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-orange-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-orange-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-orange-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-yellow-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-yellow-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-yellow-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-yellow-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-yellow-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-yellow-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-yellow-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-yellow-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-yellow-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-yellow-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-green-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-green-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-green-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-green-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-green-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-green-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-green-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-green-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-green-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-green-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-teal-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-teal-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-teal-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-teal-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-teal-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-teal-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-teal-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-teal-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-teal-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-teal-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-blue-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-blue-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-blue-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-blue-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-blue-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-blue-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-blue-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-blue-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-blue-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-blue-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-pink-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-pink-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-pink-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-pink-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-pink-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-pink-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-pink-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-pink-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-pink-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .md\\:dark\\:odd\\:bg-pink-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .md\\:bg-opacity-0{
    --bg-opacity:0
  }

  .md\\:bg-opacity-10{
    --bg-opacity:0.1
  }

  .md\\:bg-opacity-25{
    --bg-opacity:0.25
  }

  .md\\:bg-opacity-50{
    --bg-opacity:0.5
  }

  .md\\:bg-opacity-75{
    --bg-opacity:0.75
  }

  .md\\:bg-opacity-100{
    --bg-opacity:1
  }

  .md\\:hover\\:bg-opacity-0:hover{
    --bg-opacity:0
  }

  .md\\:hover\\:bg-opacity-10:hover{
    --bg-opacity:0.1
  }

  .md\\:hover\\:bg-opacity-25:hover{
    --bg-opacity:0.25
  }

  .md\\:hover\\:bg-opacity-50:hover{
    --bg-opacity:0.5
  }

  .md\\:hover\\:bg-opacity-75:hover{
    --bg-opacity:0.75
  }

  .md\\:hover\\:bg-opacity-100:hover{
    --bg-opacity:1
  }

  .md\\:focus\\:bg-opacity-0:focus{
    --bg-opacity:0
  }

  .md\\:focus\\:bg-opacity-10:focus{
    --bg-opacity:0.1
  }

  .md\\:focus\\:bg-opacity-25:focus{
    --bg-opacity:0.25
  }

  .md\\:focus\\:bg-opacity-50:focus{
    --bg-opacity:0.5
  }

  .md\\:focus\\:bg-opacity-75:focus{
    --bg-opacity:0.75
  }

  .md\\:focus\\:bg-opacity-100:focus{
    --bg-opacity:1
  }

  .theme-dark .md\\:dark\\:hover\\:bg-opacity-0:hover{
    --bg-opacity:0
  }

  .theme-dark .md\\:dark\\:hover\\:bg-opacity-10:hover{
    --bg-opacity:0.1
  }

  .theme-dark .md\\:dark\\:hover\\:bg-opacity-25:hover{
    --bg-opacity:0.25
  }

  .theme-dark .md\\:dark\\:hover\\:bg-opacity-50:hover{
    --bg-opacity:0.5
  }

  .theme-dark .md\\:dark\\:hover\\:bg-opacity-75:hover{
    --bg-opacity:0.75
  }

  .theme-dark .md\\:dark\\:hover\\:bg-opacity-100:hover{
    --bg-opacity:1
  }

  .md\\:bg-bottom{
    background-position:bottom
  }

  .md\\:bg-center{
    background-position:50%
  }

  .md\\:bg-left{
    background-position:0
  }

  .md\\:bg-left-bottom{
    background-position:0 100%
  }

  .md\\:bg-left-top{
    background-position:0 0
  }

  .md\\:bg-right{
    background-position:100%
  }

  .md\\:bg-right-bottom{
    background-position:100% 100%
  }

  .md\\:bg-right-top{
    background-position:100% 0
  }

  .md\\:bg-top{
    background-position:top
  }

  .md\\:bg-repeat{
    background-repeat:repeat
  }

  .md\\:bg-no-repeat{
    background-repeat:no-repeat
  }

  .md\\:bg-repeat-x{
    background-repeat:repeat-x
  }

  .md\\:bg-repeat-y{
    background-repeat:repeat-y
  }

  .md\\:bg-repeat-round{
    background-repeat:round
  }

  .md\\:bg-repeat-space{
    background-repeat:space
  }

  .md\\:bg-auto{
    background-size:auto
  }

  .md\\:bg-cover{
    background-size:cover
  }

  .md\\:bg-contain{
    background-size:contain
  }

  .md\\:border-collapse{
    border-collapse:collapse
  }

  .md\\:border-separate{
    border-collapse:initial
  }

  .md\\:border-transparent{
    border-color:#0000
  }

  .md\\:border-white{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .md\\:border-black{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .md\\:border-gray-50{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .md\\:border-gray-100{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .md\\:border-gray-200{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .md\\:border-gray-300{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .md\\:border-gray-400{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .md\\:border-gray-500{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .md\\:border-gray-600{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .md\\:border-gray-700{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .md\\:border-gray-800{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .md\\:border-gray-900{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .md\\:border-cool-gray-50{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .md\\:border-cool-gray-100{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .md\\:border-cool-gray-200{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .md\\:border-cool-gray-300{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .md\\:border-cool-gray-400{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .md\\:border-cool-gray-500{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .md\\:border-cool-gray-600{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .md\\:border-cool-gray-700{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .md\\:border-cool-gray-800{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .md\\:border-cool-gray-900{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .md\\:border-red-50{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .md\\:border-red-100{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .md\\:border-red-200{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .md\\:border-red-300{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .md\\:border-red-400{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .md\\:border-red-500{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .md\\:border-red-600{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .md\\:border-red-700{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .md\\:border-red-800{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .md\\:border-red-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .md\\:border-orange-50{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .md\\:border-orange-100{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .md\\:border-orange-200{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .md\\:border-orange-300{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .md\\:border-orange-400{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .md\\:border-orange-500{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .md\\:border-orange-600{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .md\\:border-orange-700{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .md\\:border-orange-800{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .md\\:border-orange-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .md\\:border-yellow-50{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .md\\:border-yellow-100{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .md\\:border-yellow-200{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .md\\:border-yellow-300{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .md\\:border-yellow-400{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .md\\:border-yellow-500{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .md\\:border-yellow-600{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .md\\:border-yellow-700{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .md\\:border-yellow-800{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .md\\:border-yellow-900{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .md\\:border-green-50{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .md\\:border-green-100{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .md\\:border-green-200{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .md\\:border-green-300{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .md\\:border-green-400{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .md\\:border-green-500{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .md\\:border-green-600{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .md\\:border-green-700{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .md\\:border-green-800{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .md\\:border-green-900{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .md\\:border-teal-50{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .md\\:border-teal-100{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .md\\:border-teal-200{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .md\\:border-teal-300{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .md\\:border-teal-400{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .md\\:border-teal-500{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .md\\:border-teal-600{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .md\\:border-teal-700{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .md\\:border-teal-800{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .md\\:border-teal-900{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .md\\:border-blue-50{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .md\\:border-blue-100{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .md\\:border-blue-200{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .md\\:border-blue-300{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .md\\:border-blue-400{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .md\\:border-blue-500{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .md\\:border-blue-600{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .md\\:border-blue-700{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .md\\:border-blue-800{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .md\\:border-blue-900{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .md\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .md\\:border-indigo-100{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .md\\:border-indigo-200{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .md\\:border-indigo-300{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .md\\:border-indigo-400{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .md\\:border-indigo-500{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .md\\:border-indigo-600{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .md\\:border-indigo-700{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .md\\:border-indigo-800{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .md\\:border-indigo-900{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .md\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .md\\:border-indigo-100{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .md\\:border-indigo-200{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .md\\:border-indigo-300{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .md\\:border-indigo-400{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .md\\:border-indigo-500{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .md\\:border-indigo-600{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .md\\:border-indigo-700{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .md\\:border-indigo-800{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .md\\:border-indigo-900{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .md\\:border-pink-50{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .md\\:border-pink-100{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .md\\:border-pink-200{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .md\\:border-pink-300{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .md\\:border-pink-400{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .md\\:border-pink-500{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .md\\:border-pink-600{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .md\\:border-pink-700{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .md\\:border-pink-800{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .md\\:border-pink-900{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .md\\:hover\\:border-transparent:hover{
    border-color:#0000
  }

  .md\\:hover\\:border-white:hover{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .md\\:hover\\:border-black:hover{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .md\\:hover\\:border-gray-50:hover{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .md\\:hover\\:border-gray-100:hover{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .md\\:hover\\:border-gray-200:hover{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .md\\:hover\\:border-gray-300:hover{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .md\\:hover\\:border-gray-400:hover{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .md\\:hover\\:border-gray-500:hover{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .md\\:hover\\:border-gray-600:hover{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .md\\:hover\\:border-gray-700:hover{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .md\\:hover\\:border-gray-800:hover{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .md\\:hover\\:border-gray-900:hover{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .md\\:hover\\:border-cool-gray-50:hover{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .md\\:hover\\:border-cool-gray-100:hover{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .md\\:hover\\:border-cool-gray-200:hover{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .md\\:hover\\:border-cool-gray-300:hover{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .md\\:hover\\:border-cool-gray-400:hover{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .md\\:hover\\:border-cool-gray-500:hover{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .md\\:hover\\:border-cool-gray-600:hover{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .md\\:hover\\:border-cool-gray-700:hover{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .md\\:hover\\:border-cool-gray-800:hover{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .md\\:hover\\:border-cool-gray-900:hover{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .md\\:hover\\:border-red-50:hover{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .md\\:hover\\:border-red-100:hover{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .md\\:hover\\:border-red-200:hover{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .md\\:hover\\:border-red-300:hover{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .md\\:hover\\:border-red-400:hover{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .md\\:hover\\:border-red-500:hover{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .md\\:hover\\:border-red-600:hover{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .md\\:hover\\:border-red-700:hover{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .md\\:hover\\:border-red-800:hover{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .md\\:hover\\:border-red-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .md\\:hover\\:border-orange-50:hover{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .md\\:hover\\:border-orange-100:hover{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .md\\:hover\\:border-orange-200:hover{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .md\\:hover\\:border-orange-300:hover{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .md\\:hover\\:border-orange-400:hover{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .md\\:hover\\:border-orange-500:hover{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .md\\:hover\\:border-orange-600:hover{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .md\\:hover\\:border-orange-700:hover{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .md\\:hover\\:border-orange-800:hover{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .md\\:hover\\:border-orange-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .md\\:hover\\:border-yellow-50:hover{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .md\\:hover\\:border-yellow-100:hover{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .md\\:hover\\:border-yellow-200:hover{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .md\\:hover\\:border-yellow-300:hover{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .md\\:hover\\:border-yellow-400:hover{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .md\\:hover\\:border-yellow-500:hover{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .md\\:hover\\:border-yellow-600:hover{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .md\\:hover\\:border-yellow-700:hover{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .md\\:hover\\:border-yellow-800:hover{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .md\\:hover\\:border-yellow-900:hover{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .md\\:hover\\:border-green-50:hover{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .md\\:hover\\:border-green-100:hover{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .md\\:hover\\:border-green-200:hover{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .md\\:hover\\:border-green-300:hover{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .md\\:hover\\:border-green-400:hover{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .md\\:hover\\:border-green-500:hover{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .md\\:hover\\:border-green-600:hover{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .md\\:hover\\:border-green-700:hover{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .md\\:hover\\:border-green-800:hover{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .md\\:hover\\:border-green-900:hover{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .md\\:hover\\:border-teal-50:hover{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .md\\:hover\\:border-teal-100:hover{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .md\\:hover\\:border-teal-200:hover{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .md\\:hover\\:border-teal-300:hover{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .md\\:hover\\:border-teal-400:hover{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .md\\:hover\\:border-teal-500:hover{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .md\\:hover\\:border-teal-600:hover{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .md\\:hover\\:border-teal-700:hover{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .md\\:hover\\:border-teal-800:hover{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .md\\:hover\\:border-teal-900:hover{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .md\\:hover\\:border-blue-50:hover{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .md\\:hover\\:border-blue-100:hover{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .md\\:hover\\:border-blue-200:hover{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .md\\:hover\\:border-blue-300:hover{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .md\\:hover\\:border-blue-400:hover{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .md\\:hover\\:border-blue-500:hover{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .md\\:hover\\:border-blue-600:hover{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .md\\:hover\\:border-blue-700:hover{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .md\\:hover\\:border-blue-800:hover{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .md\\:hover\\:border-blue-900:hover{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .md\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .md\\:hover\\:border-pink-50:hover{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .md\\:hover\\:border-pink-100:hover{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .md\\:hover\\:border-pink-200:hover{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .md\\:hover\\:border-pink-300:hover{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .md\\:hover\\:border-pink-400:hover{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .md\\:hover\\:border-pink-500:hover{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .md\\:hover\\:border-pink-600:hover{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .md\\:hover\\:border-pink-700:hover{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .md\\:hover\\:border-pink-800:hover{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .md\\:hover\\:border-pink-900:hover{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .md\\:focus\\:border-transparent:focus{
    border-color:#0000
  }

  .md\\:focus\\:border-white:focus{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .md\\:focus\\:border-black:focus{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .md\\:focus\\:border-gray-50:focus{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .md\\:focus\\:border-gray-100:focus{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .md\\:focus\\:border-gray-200:focus{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .md\\:focus\\:border-gray-300:focus{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .md\\:focus\\:border-gray-400:focus{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .md\\:focus\\:border-gray-500:focus{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .md\\:focus\\:border-gray-600:focus{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .md\\:focus\\:border-gray-700:focus{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .md\\:focus\\:border-gray-800:focus{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .md\\:focus\\:border-gray-900:focus{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .md\\:focus\\:border-cool-gray-50:focus{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .md\\:focus\\:border-cool-gray-100:focus{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .md\\:focus\\:border-cool-gray-200:focus{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .md\\:focus\\:border-cool-gray-300:focus{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .md\\:focus\\:border-cool-gray-400:focus{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .md\\:focus\\:border-cool-gray-500:focus{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .md\\:focus\\:border-cool-gray-600:focus{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .md\\:focus\\:border-cool-gray-700:focus{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .md\\:focus\\:border-cool-gray-800:focus{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .md\\:focus\\:border-cool-gray-900:focus{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .md\\:focus\\:border-red-50:focus{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .md\\:focus\\:border-red-100:focus{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .md\\:focus\\:border-red-200:focus{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .md\\:focus\\:border-red-300:focus{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .md\\:focus\\:border-red-400:focus{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .md\\:focus\\:border-red-500:focus{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .md\\:focus\\:border-red-600:focus{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .md\\:focus\\:border-red-700:focus{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .md\\:focus\\:border-red-800:focus{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .md\\:focus\\:border-red-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .md\\:focus\\:border-orange-50:focus{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .md\\:focus\\:border-orange-100:focus{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .md\\:focus\\:border-orange-200:focus{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .md\\:focus\\:border-orange-300:focus{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .md\\:focus\\:border-orange-400:focus{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .md\\:focus\\:border-orange-500:focus{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .md\\:focus\\:border-orange-600:focus{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .md\\:focus\\:border-orange-700:focus{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .md\\:focus\\:border-orange-800:focus{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .md\\:focus\\:border-orange-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .md\\:focus\\:border-yellow-50:focus{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .md\\:focus\\:border-yellow-100:focus{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .md\\:focus\\:border-yellow-200:focus{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .md\\:focus\\:border-yellow-300:focus{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .md\\:focus\\:border-yellow-400:focus{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .md\\:focus\\:border-yellow-500:focus{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .md\\:focus\\:border-yellow-600:focus{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .md\\:focus\\:border-yellow-700:focus{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .md\\:focus\\:border-yellow-800:focus{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .md\\:focus\\:border-yellow-900:focus{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .md\\:focus\\:border-green-50:focus{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .md\\:focus\\:border-green-100:focus{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .md\\:focus\\:border-green-200:focus{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .md\\:focus\\:border-green-300:focus{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .md\\:focus\\:border-green-400:focus{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .md\\:focus\\:border-green-500:focus{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .md\\:focus\\:border-green-600:focus{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .md\\:focus\\:border-green-700:focus{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .md\\:focus\\:border-green-800:focus{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .md\\:focus\\:border-green-900:focus{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .md\\:focus\\:border-teal-50:focus{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .md\\:focus\\:border-teal-100:focus{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .md\\:focus\\:border-teal-200:focus{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .md\\:focus\\:border-teal-300:focus{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .md\\:focus\\:border-teal-400:focus{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .md\\:focus\\:border-teal-500:focus{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .md\\:focus\\:border-teal-600:focus{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .md\\:focus\\:border-teal-700:focus{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .md\\:focus\\:border-teal-800:focus{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .md\\:focus\\:border-teal-900:focus{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .md\\:focus\\:border-blue-50:focus{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .md\\:focus\\:border-blue-100:focus{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .md\\:focus\\:border-blue-200:focus{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .md\\:focus\\:border-blue-300:focus{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .md\\:focus\\:border-blue-400:focus{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .md\\:focus\\:border-blue-500:focus{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .md\\:focus\\:border-blue-600:focus{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .md\\:focus\\:border-blue-700:focus{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .md\\:focus\\:border-blue-800:focus{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .md\\:focus\\:border-blue-900:focus{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .md\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .md\\:focus\\:border-pink-50:focus{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .md\\:focus\\:border-pink-100:focus{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .md\\:focus\\:border-pink-200:focus{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .md\\:focus\\:border-pink-300:focus{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .md\\:focus\\:border-pink-400:focus{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .md\\:focus\\:border-pink-500:focus{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .md\\:focus\\:border-pink-600:focus{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .md\\:focus\\:border-pink-700:focus{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .md\\:focus\\:border-pink-800:focus{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .md\\:focus\\:border-pink-900:focus{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-transparent{
    border-color:#0000
  }

  .theme-dark .md\\:dark\\:border-white{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-black{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-gray-50{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-gray-100{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-gray-200{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-gray-300{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-gray-400{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-gray-500{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-gray-600{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-gray-700{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-gray-800{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-gray-900{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-cool-gray-50{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-cool-gray-100{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-cool-gray-200{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-cool-gray-300{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-cool-gray-400{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-cool-gray-500{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-cool-gray-600{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-cool-gray-700{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-cool-gray-800{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-cool-gray-900{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-red-50{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-red-100{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-red-200{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-red-300{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-red-400{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-red-500{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-red-600{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-red-700{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-red-800{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-red-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-orange-50{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-orange-100{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-orange-200{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-orange-300{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-orange-400{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-orange-500{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-orange-600{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-orange-700{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-orange-800{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-orange-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-yellow-50{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-yellow-100{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-yellow-200{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-yellow-300{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-yellow-400{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-yellow-500{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-yellow-600{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-yellow-700{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-yellow-800{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-yellow-900{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-green-50{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-green-100{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-green-200{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-green-300{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-green-400{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-green-500{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-green-600{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-green-700{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-green-800{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-green-900{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-teal-50{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-teal-100{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-teal-200{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-teal-300{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-teal-400{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-teal-500{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-teal-600{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-teal-700{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-teal-800{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-teal-900{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-blue-50{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-blue-100{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-blue-200{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-blue-300{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-blue-400{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-blue-500{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-blue-600{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-blue-700{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-blue-800{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-blue-900{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-100{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-200{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-300{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-400{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-500{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-600{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-700{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-800{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-900{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-100{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-200{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-300{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-400{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-500{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-600{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-700{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-800{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-indigo-900{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-pink-50{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-pink-100{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-pink-200{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-pink-300{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-pink-400{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-pink-500{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-pink-600{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-pink-700{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-pink-800{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:border-pink-900{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-transparent:focus{
    border-color:#0000
  }

  .theme-dark .md\\:dark\\:focus\\:border-white:focus{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-black:focus{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-gray-50:focus{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-gray-100:focus{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-gray-200:focus{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-gray-300:focus{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-gray-400:focus{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-gray-500:focus{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-gray-600:focus{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-gray-700:focus{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-gray-800:focus{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-gray-900:focus{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-cool-gray-50:focus{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-cool-gray-100:focus{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-cool-gray-200:focus{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-cool-gray-300:focus{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-cool-gray-400:focus{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-cool-gray-500:focus{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-cool-gray-600:focus{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-cool-gray-700:focus{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-cool-gray-800:focus{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-cool-gray-900:focus{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-red-50:focus{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-red-100:focus{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-red-200:focus{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-red-300:focus{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-red-400:focus{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-red-500:focus{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-red-600:focus{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-red-700:focus{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-red-800:focus{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-red-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-orange-50:focus{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-orange-100:focus{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-orange-200:focus{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-orange-300:focus{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-orange-400:focus{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-orange-500:focus{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-orange-600:focus{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-orange-700:focus{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-orange-800:focus{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-orange-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-yellow-50:focus{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-yellow-100:focus{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-yellow-200:focus{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-yellow-300:focus{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-yellow-400:focus{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-yellow-500:focus{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-yellow-600:focus{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-yellow-700:focus{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-yellow-800:focus{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-yellow-900:focus{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-green-50:focus{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-green-100:focus{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-green-200:focus{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-green-300:focus{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-green-400:focus{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-green-500:focus{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-green-600:focus{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-green-700:focus{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-green-800:focus{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-green-900:focus{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-teal-50:focus{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-teal-100:focus{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-teal-200:focus{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-teal-300:focus{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-teal-400:focus{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-teal-500:focus{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-teal-600:focus{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-teal-700:focus{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-teal-800:focus{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-teal-900:focus{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-blue-50:focus{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-blue-100:focus{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-blue-200:focus{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-blue-300:focus{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-blue-400:focus{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-blue-500:focus{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-blue-600:focus{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-blue-700:focus{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-blue-800:focus{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-blue-900:focus{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-pink-50:focus{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-pink-100:focus{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-pink-200:focus{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-pink-300:focus{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-pink-400:focus{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-pink-500:focus{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-pink-600:focus{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-pink-700:focus{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-pink-800:focus{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:border-pink-900:focus{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-transparent:hover{
    border-color:#0000
  }

  .theme-dark .md\\:dark\\:hover\\:border-white:hover{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-black:hover{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-gray-50:hover{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-gray-100:hover{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-gray-200:hover{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-gray-300:hover{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-gray-400:hover{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-gray-500:hover{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-gray-600:hover{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-gray-700:hover{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-gray-800:hover{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-gray-900:hover{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-cool-gray-50:hover{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-cool-gray-100:hover{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-cool-gray-200:hover{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-cool-gray-300:hover{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-cool-gray-400:hover{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-cool-gray-500:hover{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-cool-gray-600:hover{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-cool-gray-700:hover{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-cool-gray-800:hover{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-cool-gray-900:hover{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-red-50:hover{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-red-100:hover{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-red-200:hover{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-red-300:hover{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-red-400:hover{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-red-500:hover{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-red-600:hover{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-red-700:hover{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-red-800:hover{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-red-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-orange-50:hover{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-orange-100:hover{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-orange-200:hover{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-orange-300:hover{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-orange-400:hover{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-orange-500:hover{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-orange-600:hover{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-orange-700:hover{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-orange-800:hover{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-orange-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-yellow-50:hover{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-yellow-100:hover{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-yellow-200:hover{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-yellow-300:hover{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-yellow-400:hover{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-yellow-500:hover{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-yellow-600:hover{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-yellow-700:hover{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-yellow-800:hover{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-yellow-900:hover{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-green-50:hover{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-green-100:hover{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-green-200:hover{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-green-300:hover{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-green-400:hover{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-green-500:hover{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-green-600:hover{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-green-700:hover{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-green-800:hover{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-green-900:hover{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-teal-50:hover{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-teal-100:hover{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-teal-200:hover{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-teal-300:hover{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-teal-400:hover{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-teal-500:hover{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-teal-600:hover{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-teal-700:hover{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-teal-800:hover{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-teal-900:hover{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-blue-50:hover{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-blue-100:hover{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-blue-200:hover{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-blue-300:hover{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-blue-400:hover{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-blue-500:hover{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-blue-600:hover{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-blue-700:hover{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-blue-800:hover{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-blue-900:hover{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-pink-50:hover{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-pink-100:hover{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-pink-200:hover{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-pink-300:hover{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-pink-400:hover{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-pink-500:hover{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-pink-600:hover{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-pink-700:hover{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-pink-800:hover{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:border-pink-900:hover{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .md\\:border-opacity-0{
    --border-opacity:0
  }

  .md\\:border-opacity-25{
    --border-opacity:0.25
  }

  .md\\:border-opacity-50{
    --border-opacity:0.5
  }

  .md\\:border-opacity-75{
    --border-opacity:0.75
  }

  .md\\:border-opacity-100{
    --border-opacity:1
  }

  .md\\:hover\\:border-opacity-0:hover{
    --border-opacity:0
  }

  .md\\:hover\\:border-opacity-25:hover{
    --border-opacity:0.25
  }

  .md\\:hover\\:border-opacity-50:hover{
    --border-opacity:0.5
  }

  .md\\:hover\\:border-opacity-75:hover{
    --border-opacity:0.75
  }

  .md\\:hover\\:border-opacity-100:hover{
    --border-opacity:1
  }

  .md\\:focus\\:border-opacity-0:focus{
    --border-opacity:0
  }

  .md\\:focus\\:border-opacity-25:focus{
    --border-opacity:0.25
  }

  .md\\:focus\\:border-opacity-50:focus{
    --border-opacity:0.5
  }

  .md\\:focus\\:border-opacity-75:focus{
    --border-opacity:0.75
  }

  .md\\:focus\\:border-opacity-100:focus{
    --border-opacity:1
  }

  .md\\:rounded-none{
    border-radius:0
  }

  .md\\:rounded-sm{
    border-radius:.125rem
  }

  .md\\:rounded{
    border-radius:.25rem
  }

  .md\\:rounded-md{
    border-radius:.375rem
  }

  .md\\:rounded-lg{
    border-radius:.5rem
  }

  .md\\:rounded-full{
    border-radius:9999px
  }

  .md\\:rounded-t-none{
    border-top-left-radius:0;
    border-top-right-radius:0
  }

  .md\\:rounded-r-none{
    border-bottom-right-radius:0;
    border-top-right-radius:0
  }

  .md\\:rounded-b-none{
    border-bottom-left-radius:0;
    border-bottom-right-radius:0
  }

  .md\\:rounded-l-none{
    border-bottom-left-radius:0;
    border-top-left-radius:0
  }

  .md\\:rounded-t-sm{
    border-top-left-radius:.125rem;
    border-top-right-radius:.125rem
  }

  .md\\:rounded-r-sm{
    border-bottom-right-radius:.125rem;
    border-top-right-radius:.125rem
  }

  .md\\:rounded-b-sm{
    border-bottom-left-radius:.125rem;
    border-bottom-right-radius:.125rem
  }

  .md\\:rounded-l-sm{
    border-bottom-left-radius:.125rem;
    border-top-left-radius:.125rem
  }

  .md\\:rounded-t{
    border-top-left-radius:.25rem
  }

  .md\\:rounded-r,.md\\:rounded-t{
    border-top-right-radius:.25rem
  }

  .md\\:rounded-b,.md\\:rounded-r{
    border-bottom-right-radius:.25rem
  }

  .md\\:rounded-b,.md\\:rounded-l{
    border-bottom-left-radius:.25rem
  }

  .md\\:rounded-l{
    border-top-left-radius:.25rem
  }

  .md\\:rounded-t-md{
    border-top-left-radius:.375rem;
    border-top-right-radius:.375rem
  }

  .md\\:rounded-r-md{
    border-bottom-right-radius:.375rem;
    border-top-right-radius:.375rem
  }

  .md\\:rounded-b-md{
    border-bottom-left-radius:.375rem;
    border-bottom-right-radius:.375rem
  }

  .md\\:rounded-l-md{
    border-bottom-left-radius:.375rem;
    border-top-left-radius:.375rem
  }

  .md\\:rounded-t-lg{
    border-top-left-radius:.5rem;
    border-top-right-radius:.5rem
  }

  .md\\:rounded-r-lg{
    border-bottom-right-radius:.5rem;
    border-top-right-radius:.5rem
  }

  .md\\:rounded-b-lg{
    border-bottom-left-radius:.5rem;
    border-bottom-right-radius:.5rem
  }

  .md\\:rounded-l-lg{
    border-bottom-left-radius:.5rem;
    border-top-left-radius:.5rem
  }

  .md\\:rounded-t-full{
    border-top-left-radius:9999px;
    border-top-right-radius:9999px
  }

  .md\\:rounded-r-full{
    border-bottom-right-radius:9999px;
    border-top-right-radius:9999px
  }

  .md\\:rounded-b-full{
    border-bottom-left-radius:9999px;
    border-bottom-right-radius:9999px
  }

  .md\\:rounded-l-full{
    border-bottom-left-radius:9999px;
    border-top-left-radius:9999px
  }

  .md\\:rounded-tl-none{
    border-top-left-radius:0
  }

  .md\\:rounded-tr-none{
    border-top-right-radius:0
  }

  .md\\:rounded-br-none{
    border-bottom-right-radius:0
  }

  .md\\:rounded-bl-none{
    border-bottom-left-radius:0
  }

  .md\\:rounded-tl-sm{
    border-top-left-radius:.125rem
  }

  .md\\:rounded-tr-sm{
    border-top-right-radius:.125rem
  }

  .md\\:rounded-br-sm{
    border-bottom-right-radius:.125rem
  }

  .md\\:rounded-bl-sm{
    border-bottom-left-radius:.125rem
  }

  .md\\:rounded-tl{
    border-top-left-radius:.25rem
  }

  .md\\:rounded-tr{
    border-top-right-radius:.25rem
  }

  .md\\:rounded-br{
    border-bottom-right-radius:.25rem
  }

  .md\\:rounded-bl{
    border-bottom-left-radius:.25rem
  }

  .md\\:rounded-tl-md{
    border-top-left-radius:.375rem
  }

  .md\\:rounded-tr-md{
    border-top-right-radius:.375rem
  }

  .md\\:rounded-br-md{
    border-bottom-right-radius:.375rem
  }

  .md\\:rounded-bl-md{
    border-bottom-left-radius:.375rem
  }

  .md\\:rounded-tl-lg{
    border-top-left-radius:.5rem
  }

  .md\\:rounded-tr-lg{
    border-top-right-radius:.5rem
  }

  .md\\:rounded-br-lg{
    border-bottom-right-radius:.5rem
  }

  .md\\:rounded-bl-lg{
    border-bottom-left-radius:.5rem
  }

  .md\\:rounded-tl-full{
    border-top-left-radius:9999px
  }

  .md\\:rounded-tr-full{
    border-top-right-radius:9999px
  }

  .md\\:rounded-br-full{
    border-bottom-right-radius:9999px
  }

  .md\\:rounded-bl-full{
    border-bottom-left-radius:9999px
  }

  .md\\:border-solid{
    border-style:solid
  }

  .md\\:border-dashed{
    border-style:dashed
  }

  .md\\:border-dotted{
    border-style:dotted
  }

  .md\\:border-double{
    border-style:double
  }

  .md\\:border-none{
    border-style:none
  }

  .md\\:border-0{
    border-width:0
  }

  .md\\:border-2{
    border-width:2px
  }

  .md\\:border-4{
    border-width:4px
  }

  .md\\:border-8{
    border-width:8px
  }

  .md\\:border{
    border-width:1px
  }

  .md\\:border-t-0{
    border-top-width:0
  }

  .md\\:border-r-0{
    border-right-width:0
  }

  .md\\:border-b-0{
    border-bottom-width:0
  }

  .md\\:border-l-0{
    border-left-width:0
  }

  .md\\:border-t-2{
    border-top-width:2px
  }

  .md\\:border-r-2{
    border-right-width:2px
  }

  .md\\:border-b-2{
    border-bottom-width:2px
  }

  .md\\:border-l-2{
    border-left-width:2px
  }

  .md\\:border-t-4{
    border-top-width:4px
  }

  .md\\:border-r-4{
    border-right-width:4px
  }

  .md\\:border-b-4{
    border-bottom-width:4px
  }

  .md\\:border-l-4{
    border-left-width:4px
  }

  .md\\:border-t-8{
    border-top-width:8px
  }

  .md\\:border-r-8{
    border-right-width:8px
  }

  .md\\:border-b-8{
    border-bottom-width:8px
  }

  .md\\:border-l-8{
    border-left-width:8px
  }

  .md\\:border-t{
    border-top-width:1px
  }

  .md\\:border-r{
    border-right-width:1px
  }

  .md\\:border-b{
    border-bottom-width:1px
  }

  .md\\:border-l{
    border-left-width:1px
  }

  .md\\:box-border{
    box-sizing:border-box
  }

  .md\\:box-content{
    box-sizing:initial
  }

  .md\\:cursor-auto{
    cursor:auto
  }

  .md\\:cursor-default{
    cursor:default
  }

  .md\\:cursor-pointer{
    cursor:pointer
  }

  .md\\:cursor-wait{
    cursor:wait
  }

  .md\\:cursor-text{
    cursor:text
  }

  .md\\:cursor-move{
    cursor:move
  }

  .md\\:cursor-not-allowed{
    cursor:not-allowed
  }

  .md\\:block{
    display:block
  }

  .md\\:inline-block{
    display:inline-block
  }

  .md\\:inline{
    display:inline
  }

  .md\\:flex{
    display:flex
  }

  .md\\:inline-flex{
    display:inline-flex
  }

  .md\\:table{
    display:table
  }

  .md\\:table-caption{
    display:table-caption
  }

  .md\\:table-cell{
    display:table-cell
  }

  .md\\:table-column{
    display:table-column
  }

  .md\\:table-column-group{
    display:table-column-group
  }

  .md\\:table-footer-group{
    display:table-footer-group
  }

  .md\\:table-header-group{
    display:table-header-group
  }

  .md\\:table-row-group{
    display:table-row-group
  }

  .md\\:table-row{
    display:table-row
  }

  .md\\:flow-root{
    display:flow-root
  }

  .md\\:grid{
    display:grid
  }

  .md\\:inline-grid{
    display:inline-grid
  }

  .md\\:hidden{
    display:none
  }

  .theme-dark .md\\:dark\\:block{
    display:block
  }

  .theme-dark .md\\:dark\\:inline-block{
    display:inline-block
  }

  .theme-dark .md\\:dark\\:inline{
    display:inline
  }

  .theme-dark .md\\:dark\\:flex{
    display:flex
  }

  .theme-dark .md\\:dark\\:inline-flex{
    display:inline-flex
  }

  .theme-dark .md\\:dark\\:table{
    display:table
  }

  .theme-dark .md\\:dark\\:table-caption{
    display:table-caption
  }

  .theme-dark .md\\:dark\\:table-cell{
    display:table-cell
  }

  .theme-dark .md\\:dark\\:table-column{
    display:table-column
  }

  .theme-dark .md\\:dark\\:table-column-group{
    display:table-column-group
  }

  .theme-dark .md\\:dark\\:table-footer-group{
    display:table-footer-group
  }

  .theme-dark .md\\:dark\\:table-header-group{
    display:table-header-group
  }

  .theme-dark .md\\:dark\\:table-row-group{
    display:table-row-group
  }

  .theme-dark .md\\:dark\\:table-row{
    display:table-row
  }

  .theme-dark .md\\:dark\\:flow-root{
    display:flow-root
  }

  .theme-dark .md\\:dark\\:grid{
    display:grid
  }

  .theme-dark .md\\:dark\\:inline-grid{
    display:inline-grid
  }

  .theme-dark .md\\:dark\\:hidden{
    display:none
  }

  .md\\:flex-row{
    flex-direction:row
  }

  .md\\:flex-row-reverse{
    flex-direction:row-reverse
  }

  .md\\:flex-col{
    flex-direction:column
  }

  .md\\:flex-col-reverse{
    flex-direction:column-reverse
  }

  .md\\:flex-wrap{
    flex-wrap:wrap
  }

  .md\\:flex-wrap-reverse{
    flex-wrap:wrap-reverse
  }

  .md\\:flex-no-wrap{
    flex-wrap:nowrap
  }

  .md\\:items-start{
    align-items:flex-start
  }

  .md\\:items-end{
    align-items:flex-end
  }

  .md\\:items-center{
    align-items:center
  }

  .md\\:items-baseline{
    align-items:baseline
  }

  .md\\:items-stretch{
    align-items:stretch
  }

  .md\\:self-auto{
    align-self:auto
  }

  .md\\:self-start{
    align-self:flex-start
  }

  .md\\:self-end{
    align-self:flex-end
  }

  .md\\:self-center{
    align-self:center
  }

  .md\\:self-stretch{
    align-self:stretch
  }

  .md\\:justify-start{
    justify-content:flex-start
  }

  .md\\:justify-end{
    justify-content:flex-end
  }

  .md\\:justify-center{
    justify-content:center
  }

  .md\\:justify-between{
    justify-content:space-between
  }

  .md\\:justify-around{
    justify-content:space-around
  }

  .md\\:justify-evenly{
    justify-content:space-evenly
  }

  .md\\:content-center{
    align-content:center
  }

  .md\\:content-start{
    align-content:flex-start
  }

  .md\\:content-end{
    align-content:flex-end
  }

  .md\\:content-between{
    align-content:space-between
  }

  .md\\:content-around{
    align-content:space-around
  }

  .md\\:flex-1{
    flex:1 1
  }

  .md\\:flex-auto{
    flex:1 1 auto
  }

  .md\\:flex-initial{
    flex:0 1 auto
  }

  .md\\:flex-none{
    flex:none
  }

  .md\\:flex-grow-0{
    flex-grow:0
  }

  .md\\:flex-grow{
    flex-grow:1
  }

  .md\\:flex-shrink-0{
    flex-shrink:0
  }

  .md\\:flex-shrink{
    flex-shrink:1
  }

  .md\\:order-1{
    order:1
  }

  .md\\:order-2{
    order:2
  }

  .md\\:order-3{
    order:3
  }

  .md\\:order-4{
    order:4
  }

  .md\\:order-5{
    order:5
  }

  .md\\:order-6{
    order:6
  }

  .md\\:order-7{
    order:7
  }

  .md\\:order-8{
    order:8
  }

  .md\\:order-9{
    order:9
  }

  .md\\:order-10{
    order:10
  }

  .md\\:order-11{
    order:11
  }

  .md\\:order-12{
    order:12
  }

  .md\\:order-first{
    order:-9999
  }

  .md\\:order-last{
    order:9999
  }

  .md\\:order-none{
    order:0
  }

  .md\\:float-right{
    float:right
  }

  .md\\:float-left{
    float:left
  }

  .md\\:float-none{
    float:none
  }

  .md\\:clearfix:after{
    clear:both;
    content:"";
    display:table
  }

  .md\\:clear-left{
    clear:left
  }

  .md\\:clear-right{
    clear:right
  }

  .md\\:clear-both{
    clear:both
  }

  .md\\:clear-none{
    clear:none
  }

  .md\\:font-sans{
    font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji
  }

  .md\\:font-serif{
    font-family:Georgia,Cambria,Times New Roman,Times,serif
  }

  .md\\:font-mono{
    font-family:Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace
  }

  .md\\:font-hairline{
    font-weight:100
  }

  .md\\:font-thin{
    font-weight:200
  }

  .md\\:font-light{
    font-weight:300
  }

  .md\\:font-normal{
    font-weight:400
  }

  .md\\:font-medium{
    font-weight:500
  }

  .md\\:font-semibold{
    font-weight:600
  }

  .md\\:font-bold{
    font-weight:700
  }

  .md\\:font-extrabold{
    font-weight:800
  }

  .md\\:font-black{
    font-weight:900
  }

  .md\\:hover\\:font-hairline:hover{
    font-weight:100
  }

  .md\\:hover\\:font-thin:hover{
    font-weight:200
  }

  .md\\:hover\\:font-light:hover{
    font-weight:300
  }

  .md\\:hover\\:font-normal:hover{
    font-weight:400
  }

  .md\\:hover\\:font-medium:hover{
    font-weight:500
  }

  .md\\:hover\\:font-semibold:hover{
    font-weight:600
  }

  .md\\:hover\\:font-bold:hover{
    font-weight:700
  }

  .md\\:hover\\:font-extrabold:hover{
    font-weight:800
  }

  .md\\:hover\\:font-black:hover{
    font-weight:900
  }

  .md\\:focus\\:font-hairline:focus{
    font-weight:100
  }

  .md\\:focus\\:font-thin:focus{
    font-weight:200
  }

  .md\\:focus\\:font-light:focus{
    font-weight:300
  }

  .md\\:focus\\:font-normal:focus{
    font-weight:400
  }

  .md\\:focus\\:font-medium:focus{
    font-weight:500
  }

  .md\\:focus\\:font-semibold:focus{
    font-weight:600
  }

  .md\\:focus\\:font-bold:focus{
    font-weight:700
  }

  .md\\:focus\\:font-extrabold:focus{
    font-weight:800
  }

  .md\\:focus\\:font-black:focus{
    font-weight:900
  }

  .md\\:h-0{
    height:0
  }

  .md\\:h-1{
    height:.25rem
  }

  .md\\:h-2{
    height:.5rem
  }

  .md\\:h-3{
    height:.75rem
  }

  .md\\:h-4{
    height:1rem
  }

  .md\\:h-5{
    height:1.25rem
  }

  .md\\:h-6{
    height:1.5rem
  }

  .md\\:h-8{
    height:2rem
  }

  .md\\:h-10{
    height:2.5rem
  }

  .md\\:h-12{
    height:3rem
  }

  .md\\:h-16{
    height:4rem
  }

  .md\\:h-20{
    height:5rem
  }

  .md\\:h-24{
    height:6rem
  }

  .md\\:h-32{
    height:8rem
  }

  .md\\:h-40{
    height:10rem
  }

  .md\\:h-48{
    height:12rem
  }

  .md\\:h-56{
    height:14rem
  }

  .md\\:h-64{
    height:16rem
  }

  .md\\:h-auto{
    height:auto
  }

  .md\\:h-px{
    height:1px
  }

  .md\\:h-full{
    height:100%
  }

  .md\\:h-screen{
    height:100vh
  }

  .md\\:text-xs{
    font-size:.75rem
  }

  .md\\:text-sm{
    font-size:.875rem
  }

  .md\\:text-base{
    font-size:1rem
  }

  .md\\:text-lg{
    font-size:1.125rem
  }

  .md\\:text-xl{
    font-size:1.25rem
  }

  .md\\:text-2xl{
    font-size:1.5rem
  }

  .md\\:text-3xl{
    font-size:1.875rem
  }

  .md\\:text-4xl{
    font-size:2.25rem
  }

  .md\\:text-5xl{
    font-size:3rem
  }

  .md\\:text-6xl{
    font-size:4rem
  }

  .md\\:leading-3{
    line-height:.75rem
  }

  .md\\:leading-4{
    line-height:1rem
  }

  .md\\:leading-5{
    line-height:1.25rem
  }

  .md\\:leading-6{
    line-height:1.5rem
  }

  .md\\:leading-7{
    line-height:1.75rem
  }

  .md\\:leading-8{
    line-height:2rem
  }

  .md\\:leading-9{
    line-height:2.25rem
  }

  .md\\:leading-10{
    line-height:2.5rem
  }

  .md\\:leading-none{
    line-height:1
  }

  .md\\:leading-tight{
    line-height:1.25
  }

  .md\\:leading-snug{
    line-height:1.375
  }

  .md\\:leading-normal{
    line-height:1.5
  }

  .md\\:leading-relaxed{
    line-height:1.625
  }

  .md\\:leading-loose{
    line-height:2
  }

  .md\\:list-inside{
    list-style-position:inside
  }

  .md\\:list-outside{
    list-style-position:outside
  }

  .md\\:list-none{
    list-style-type:none
  }

  .md\\:list-disc{
    list-style-type:disc
  }

  .md\\:list-decimal{
    list-style-type:decimal
  }

  .md\\:m-0{
    margin:0
  }

  .md\\:m-1{
    margin:.25rem
  }

  .md\\:m-2{
    margin:.5rem
  }

  .md\\:m-3{
    margin:.75rem
  }

  .md\\:m-4{
    margin:1rem
  }

  .md\\:m-5{
    margin:1.25rem
  }

  .md\\:m-6{
    margin:1.5rem
  }

  .md\\:m-8{
    margin:2rem
  }

  .md\\:m-10{
    margin:2.5rem
  }

  .md\\:m-12{
    margin:3rem
  }

  .md\\:m-16{
    margin:4rem
  }

  .md\\:m-20{
    margin:5rem
  }

  .md\\:m-24{
    margin:6rem
  }

  .md\\:m-32{
    margin:8rem
  }

  .md\\:m-40{
    margin:10rem
  }

  .md\\:m-48{
    margin:12rem
  }

  .md\\:m-56{
    margin:14rem
  }

  .md\\:m-64{
    margin:16rem
  }

  .md\\:m-auto{
    margin:auto
  }

  .md\\:m-px{
    margin:1px
  }

  .md\\:-m-1{
    margin:-.25rem
  }

  .md\\:-m-2{
    margin:-.5rem
  }

  .md\\:-m-3{
    margin:-.75rem
  }

  .md\\:-m-4{
    margin:-1rem
  }

  .md\\:-m-5{
    margin:-1.25rem
  }

  .md\\:-m-6{
    margin:-1.5rem
  }

  .md\\:-m-8{
    margin:-2rem
  }

  .md\\:-m-10{
    margin:-2.5rem
  }

  .md\\:-m-12{
    margin:-3rem
  }

  .md\\:-m-16{
    margin:-4rem
  }

  .md\\:-m-20{
    margin:-5rem
  }

  .md\\:-m-24{
    margin:-6rem
  }

  .md\\:-m-32{
    margin:-8rem
  }

  .md\\:-m-40{
    margin:-10rem
  }

  .md\\:-m-48{
    margin:-12rem
  }

  .md\\:-m-56{
    margin:-14rem
  }

  .md\\:-m-64{
    margin:-16rem
  }

  .md\\:-m-px{
    margin:-1px
  }

  .md\\:my-0{
    margin-bottom:0;
    margin-top:0
  }

  .md\\:mx-0{
    margin-left:0;
    margin-right:0
  }

  .md\\:my-1{
    margin-bottom:.25rem;
    margin-top:.25rem
  }

  .md\\:mx-1{
    margin-left:.25rem;
    margin-right:.25rem
  }

  .md\\:my-2{
    margin-bottom:.5rem;
    margin-top:.5rem
  }

  .md\\:mx-2{
    margin-left:.5rem;
    margin-right:.5rem
  }

  .md\\:my-3{
    margin-bottom:.75rem;
    margin-top:.75rem
  }

  .md\\:mx-3{
    margin-left:.75rem;
    margin-right:.75rem
  }

  .md\\:my-4{
    margin-bottom:1rem;
    margin-top:1rem
  }

  .md\\:mx-4{
    margin-left:1rem;
    margin-right:1rem
  }

  .md\\:my-5{
    margin-bottom:1.25rem;
    margin-top:1.25rem
  }

  .md\\:mx-5{
    margin-left:1.25rem;
    margin-right:1.25rem
  }

  .md\\:my-6{
    margin-bottom:1.5rem;
    margin-top:1.5rem
  }

  .md\\:mx-6{
    margin-left:1.5rem;
    margin-right:1.5rem
  }

  .md\\:my-8{
    margin-bottom:2rem;
    margin-top:2rem
  }

  .md\\:mx-8{
    margin-left:2rem;
    margin-right:2rem
  }

  .md\\:my-10{
    margin-bottom:2.5rem;
    margin-top:2.5rem
  }

  .md\\:mx-10{
    margin-left:2.5rem;
    margin-right:2.5rem
  }

  .md\\:my-12{
    margin-bottom:3rem;
    margin-top:3rem
  }

  .md\\:mx-12{
    margin-left:3rem;
    margin-right:3rem
  }

  .md\\:my-16{
    margin-bottom:4rem;
    margin-top:4rem
  }

  .md\\:mx-16{
    margin-left:4rem;
    margin-right:4rem
  }

  .md\\:my-20{
    margin-bottom:5rem;
    margin-top:5rem
  }

  .md\\:mx-20{
    margin-left:5rem;
    margin-right:5rem
  }

  .md\\:my-24{
    margin-bottom:6rem;
    margin-top:6rem
  }

  .md\\:mx-24{
    margin-left:6rem;
    margin-right:6rem
  }

  .md\\:my-32{
    margin-bottom:8rem;
    margin-top:8rem
  }

  .md\\:mx-32{
    margin-left:8rem;
    margin-right:8rem
  }

  .md\\:my-40{
    margin-bottom:10rem;
    margin-top:10rem
  }

  .md\\:mx-40{
    margin-left:10rem;
    margin-right:10rem
  }

  .md\\:my-48{
    margin-bottom:12rem;
    margin-top:12rem
  }

  .md\\:mx-48{
    margin-left:12rem;
    margin-right:12rem
  }

  .md\\:my-56{
    margin-bottom:14rem;
    margin-top:14rem
  }

  .md\\:mx-56{
    margin-left:14rem;
    margin-right:14rem
  }

  .md\\:my-64{
    margin-bottom:16rem;
    margin-top:16rem
  }

  .md\\:mx-64{
    margin-left:16rem;
    margin-right:16rem
  }

  .md\\:my-auto{
    margin-bottom:auto;
    margin-top:auto
  }

  .md\\:mx-auto{
    margin-left:auto;
    margin-right:auto
  }

  .md\\:my-px{
    margin-bottom:1px;
    margin-top:1px
  }

  .md\\:mx-px{
    margin-left:1px;
    margin-right:1px
  }

  .md\\:-my-1{
    margin-bottom:-.25rem;
    margin-top:-.25rem
  }

  .md\\:-mx-1{
    margin-left:-.25rem;
    margin-right:-.25rem
  }

  .md\\:-my-2{
    margin-bottom:-.5rem;
    margin-top:-.5rem
  }

  .md\\:-mx-2{
    margin-left:-.5rem;
    margin-right:-.5rem
  }

  .md\\:-my-3{
    margin-bottom:-.75rem;
    margin-top:-.75rem
  }

  .md\\:-mx-3{
    margin-left:-.75rem;
    margin-right:-.75rem
  }

  .md\\:-my-4{
    margin-bottom:-1rem;
    margin-top:-1rem
  }

  .md\\:-mx-4{
    margin-left:-1rem;
    margin-right:-1rem
  }

  .md\\:-my-5{
    margin-bottom:-1.25rem;
    margin-top:-1.25rem
  }

  .md\\:-mx-5{
    margin-left:-1.25rem;
    margin-right:-1.25rem
  }

  .md\\:-my-6{
    margin-bottom:-1.5rem;
    margin-top:-1.5rem
  }

  .md\\:-mx-6{
    margin-left:-1.5rem;
    margin-right:-1.5rem
  }

  .md\\:-my-8{
    margin-bottom:-2rem;
    margin-top:-2rem
  }

  .md\\:-mx-8{
    margin-left:-2rem;
    margin-right:-2rem
  }

  .md\\:-my-10{
    margin-bottom:-2.5rem;
    margin-top:-2.5rem
  }

  .md\\:-mx-10{
    margin-left:-2.5rem;
    margin-right:-2.5rem
  }

  .md\\:-my-12{
    margin-bottom:-3rem;
    margin-top:-3rem
  }

  .md\\:-mx-12{
    margin-left:-3rem;
    margin-right:-3rem
  }

  .md\\:-my-16{
    margin-bottom:-4rem;
    margin-top:-4rem
  }

  .md\\:-mx-16{
    margin-left:-4rem;
    margin-right:-4rem
  }

  .md\\:-my-20{
    margin-bottom:-5rem;
    margin-top:-5rem
  }

  .md\\:-mx-20{
    margin-left:-5rem;
    margin-right:-5rem
  }

  .md\\:-my-24{
    margin-bottom:-6rem;
    margin-top:-6rem
  }

  .md\\:-mx-24{
    margin-left:-6rem;
    margin-right:-6rem
  }

  .md\\:-my-32{
    margin-bottom:-8rem;
    margin-top:-8rem
  }

  .md\\:-mx-32{
    margin-left:-8rem;
    margin-right:-8rem
  }

  .md\\:-my-40{
    margin-bottom:-10rem;
    margin-top:-10rem
  }

  .md\\:-mx-40{
    margin-left:-10rem;
    margin-right:-10rem
  }

  .md\\:-my-48{
    margin-bottom:-12rem;
    margin-top:-12rem
  }

  .md\\:-mx-48{
    margin-left:-12rem;
    margin-right:-12rem
  }

  .md\\:-my-56{
    margin-bottom:-14rem;
    margin-top:-14rem
  }

  .md\\:-mx-56{
    margin-left:-14rem;
    margin-right:-14rem
  }

  .md\\:-my-64{
    margin-bottom:-16rem;
    margin-top:-16rem
  }

  .md\\:-mx-64{
    margin-left:-16rem;
    margin-right:-16rem
  }

  .md\\:-my-px{
    margin-bottom:-1px;
    margin-top:-1px
  }

  .md\\:-mx-px{
    margin-left:-1px;
    margin-right:-1px
  }

  .md\\:mt-0{
    margin-top:0
  }

  .md\\:mr-0{
    margin-right:0
  }

  .md\\:mb-0{
    margin-bottom:0
  }

  .md\\:ml-0{
    margin-left:0
  }

  .md\\:mt-1{
    margin-top:.25rem
  }

  .md\\:mr-1{
    margin-right:.25rem
  }

  .md\\:mb-1{
    margin-bottom:.25rem
  }

  .md\\:ml-1{
    margin-left:.25rem
  }

  .md\\:mt-2{
    margin-top:.5rem
  }

  .md\\:mr-2{
    margin-right:.5rem
  }

  .md\\:mb-2{
    margin-bottom:.5rem
  }

  .md\\:ml-2{
    margin-left:.5rem
  }

  .md\\:mt-3{
    margin-top:.75rem
  }

  .md\\:mr-3{
    margin-right:.75rem
  }

  .md\\:mb-3{
    margin-bottom:.75rem
  }

  .md\\:ml-3{
    margin-left:.75rem
  }

  .md\\:mt-4{
    margin-top:1rem
  }

  .md\\:mr-4{
    margin-right:1rem
  }

  .md\\:mb-4{
    margin-bottom:1rem
  }

  .md\\:ml-4{
    margin-left:1rem
  }

  .md\\:mt-5{
    margin-top:1.25rem
  }

  .md\\:mr-5{
    margin-right:1.25rem
  }

  .md\\:mb-5{
    margin-bottom:1.25rem
  }

  .md\\:ml-5{
    margin-left:1.25rem
  }

  .md\\:mt-6{
    margin-top:1.5rem
  }

  .md\\:mr-6{
    margin-right:1.5rem
  }

  .md\\:mb-6{
    margin-bottom:1.5rem
  }

  .md\\:ml-6{
    margin-left:1.5rem
  }

  .md\\:mt-8{
    margin-top:2rem
  }

  .md\\:mr-8{
    margin-right:2rem
  }

  .md\\:mb-8{
    margin-bottom:2rem
  }

  .md\\:ml-8{
    margin-left:2rem
  }

  .md\\:mt-10{
    margin-top:2.5rem
  }

  .md\\:mr-10{
    margin-right:2.5rem
  }

  .md\\:mb-10{
    margin-bottom:2.5rem
  }

  .md\\:ml-10{
    margin-left:2.5rem
  }

  .md\\:mt-12{
    margin-top:3rem
  }

  .md\\:mr-12{
    margin-right:3rem
  }

  .md\\:mb-12{
    margin-bottom:3rem
  }

  .md\\:ml-12{
    margin-left:3rem
  }

  .md\\:mt-16{
    margin-top:4rem
  }

  .md\\:mr-16{
    margin-right:4rem
  }

  .md\\:mb-16{
    margin-bottom:4rem
  }

  .md\\:ml-16{
    margin-left:4rem
  }

  .md\\:mt-20{
    margin-top:5rem
  }

  .md\\:mr-20{
    margin-right:5rem
  }

  .md\\:mb-20{
    margin-bottom:5rem
  }

  .md\\:ml-20{
    margin-left:5rem
  }

  .md\\:mt-24{
    margin-top:6rem
  }

  .md\\:mr-24{
    margin-right:6rem
  }

  .md\\:mb-24{
    margin-bottom:6rem
  }

  .md\\:ml-24{
    margin-left:6rem
  }

  .md\\:mt-32{
    margin-top:8rem
  }

  .md\\:mr-32{
    margin-right:8rem
  }

  .md\\:mb-32{
    margin-bottom:8rem
  }

  .md\\:ml-32{
    margin-left:8rem
  }

  .md\\:mt-40{
    margin-top:10rem
  }

  .md\\:mr-40{
    margin-right:10rem
  }

  .md\\:mb-40{
    margin-bottom:10rem
  }

  .md\\:ml-40{
    margin-left:10rem
  }

  .md\\:mt-48{
    margin-top:12rem
  }

  .md\\:mr-48{
    margin-right:12rem
  }

  .md\\:mb-48{
    margin-bottom:12rem
  }

  .md\\:ml-48{
    margin-left:12rem
  }

  .md\\:mt-56{
    margin-top:14rem
  }

  .md\\:mr-56{
    margin-right:14rem
  }

  .md\\:mb-56{
    margin-bottom:14rem
  }

  .md\\:ml-56{
    margin-left:14rem
  }

  .md\\:mt-64{
    margin-top:16rem
  }

  .md\\:mr-64{
    margin-right:16rem
  }

  .md\\:mb-64{
    margin-bottom:16rem
  }

  .md\\:ml-64{
    margin-left:16rem
  }

  .md\\:mt-auto{
    margin-top:auto
  }

  .md\\:mr-auto{
    margin-right:auto
  }

  .md\\:mb-auto{
    margin-bottom:auto
  }

  .md\\:ml-auto{
    margin-left:auto
  }

  .md\\:mt-px{
    margin-top:1px
  }

  .md\\:mr-px{
    margin-right:1px
  }

  .md\\:mb-px{
    margin-bottom:1px
  }

  .md\\:ml-px{
    margin-left:1px
  }

  .md\\:-mt-1{
    margin-top:-.25rem
  }

  .md\\:-mr-1{
    margin-right:-.25rem
  }

  .md\\:-mb-1{
    margin-bottom:-.25rem
  }

  .md\\:-ml-1{
    margin-left:-.25rem
  }

  .md\\:-mt-2{
    margin-top:-.5rem
  }

  .md\\:-mr-2{
    margin-right:-.5rem
  }

  .md\\:-mb-2{
    margin-bottom:-.5rem
  }

  .md\\:-ml-2{
    margin-left:-.5rem
  }

  .md\\:-mt-3{
    margin-top:-.75rem
  }

  .md\\:-mr-3{
    margin-right:-.75rem
  }

  .md\\:-mb-3{
    margin-bottom:-.75rem
  }

  .md\\:-ml-3{
    margin-left:-.75rem
  }

  .md\\:-mt-4{
    margin-top:-1rem
  }

  .md\\:-mr-4{
    margin-right:-1rem
  }

  .md\\:-mb-4{
    margin-bottom:-1rem
  }

  .md\\:-ml-4{
    margin-left:-1rem
  }

  .md\\:-mt-5{
    margin-top:-1.25rem
  }

  .md\\:-mr-5{
    margin-right:-1.25rem
  }

  .md\\:-mb-5{
    margin-bottom:-1.25rem
  }

  .md\\:-ml-5{
    margin-left:-1.25rem
  }

  .md\\:-mt-6{
    margin-top:-1.5rem
  }

  .md\\:-mr-6{
    margin-right:-1.5rem
  }

  .md\\:-mb-6{
    margin-bottom:-1.5rem
  }

  .md\\:-ml-6{
    margin-left:-1.5rem
  }

  .md\\:-mt-8{
    margin-top:-2rem
  }

  .md\\:-mr-8{
    margin-right:-2rem
  }

  .md\\:-mb-8{
    margin-bottom:-2rem
  }

  .md\\:-ml-8{
    margin-left:-2rem
  }

  .md\\:-mt-10{
    margin-top:-2.5rem
  }

  .md\\:-mr-10{
    margin-right:-2.5rem
  }

  .md\\:-mb-10{
    margin-bottom:-2.5rem
  }

  .md\\:-ml-10{
    margin-left:-2.5rem
  }

  .md\\:-mt-12{
    margin-top:-3rem
  }

  .md\\:-mr-12{
    margin-right:-3rem
  }

  .md\\:-mb-12{
    margin-bottom:-3rem
  }

  .md\\:-ml-12{
    margin-left:-3rem
  }

  .md\\:-mt-16{
    margin-top:-4rem
  }

  .md\\:-mr-16{
    margin-right:-4rem
  }

  .md\\:-mb-16{
    margin-bottom:-4rem
  }

  .md\\:-ml-16{
    margin-left:-4rem
  }

  .md\\:-mt-20{
    margin-top:-5rem
  }

  .md\\:-mr-20{
    margin-right:-5rem
  }

  .md\\:-mb-20{
    margin-bottom:-5rem
  }

  .md\\:-ml-20{
    margin-left:-5rem
  }

  .md\\:-mt-24{
    margin-top:-6rem
  }

  .md\\:-mr-24{
    margin-right:-6rem
  }

  .md\\:-mb-24{
    margin-bottom:-6rem
  }

  .md\\:-ml-24{
    margin-left:-6rem
  }

  .md\\:-mt-32{
    margin-top:-8rem
  }

  .md\\:-mr-32{
    margin-right:-8rem
  }

  .md\\:-mb-32{
    margin-bottom:-8rem
  }

  .md\\:-ml-32{
    margin-left:-8rem
  }

  .md\\:-mt-40{
    margin-top:-10rem
  }

  .md\\:-mr-40{
    margin-right:-10rem
  }

  .md\\:-mb-40{
    margin-bottom:-10rem
  }

  .md\\:-ml-40{
    margin-left:-10rem
  }

  .md\\:-mt-48{
    margin-top:-12rem
  }

  .md\\:-mr-48{
    margin-right:-12rem
  }

  .md\\:-mb-48{
    margin-bottom:-12rem
  }

  .md\\:-ml-48{
    margin-left:-12rem
  }

  .md\\:-mt-56{
    margin-top:-14rem
  }

  .md\\:-mr-56{
    margin-right:-14rem
  }

  .md\\:-mb-56{
    margin-bottom:-14rem
  }

  .md\\:-ml-56{
    margin-left:-14rem
  }

  .md\\:-mt-64{
    margin-top:-16rem
  }

  .md\\:-mr-64{
    margin-right:-16rem
  }

  .md\\:-mb-64{
    margin-bottom:-16rem
  }

  .md\\:-ml-64{
    margin-left:-16rem
  }

  .md\\:-mt-px{
    margin-top:-1px
  }

  .md\\:-mr-px{
    margin-right:-1px
  }

  .md\\:-mb-px{
    margin-bottom:-1px
  }

  .md\\:-ml-px{
    margin-left:-1px
  }

  .md\\:last\\:m-0:last-child{
    margin:0
  }

  .md\\:last\\:m-1:last-child{
    margin:.25rem
  }

  .md\\:last\\:m-2:last-child{
    margin:.5rem
  }

  .md\\:last\\:m-3:last-child{
    margin:.75rem
  }

  .md\\:last\\:m-4:last-child{
    margin:1rem
  }

  .md\\:last\\:m-5:last-child{
    margin:1.25rem
  }

  .md\\:last\\:m-6:last-child{
    margin:1.5rem
  }

  .md\\:last\\:m-8:last-child{
    margin:2rem
  }

  .md\\:last\\:m-10:last-child{
    margin:2.5rem
  }

  .md\\:last\\:m-12:last-child{
    margin:3rem
  }

  .md\\:last\\:m-16:last-child{
    margin:4rem
  }

  .md\\:last\\:m-20:last-child{
    margin:5rem
  }

  .md\\:last\\:m-24:last-child{
    margin:6rem
  }

  .md\\:last\\:m-32:last-child{
    margin:8rem
  }

  .md\\:last\\:m-40:last-child{
    margin:10rem
  }

  .md\\:last\\:m-48:last-child{
    margin:12rem
  }

  .md\\:last\\:m-56:last-child{
    margin:14rem
  }

  .md\\:last\\:m-64:last-child{
    margin:16rem
  }

  .md\\:last\\:m-auto:last-child{
    margin:auto
  }

  .md\\:last\\:m-px:last-child{
    margin:1px
  }

  .md\\:last\\:-m-1:last-child{
    margin:-.25rem
  }

  .md\\:last\\:-m-2:last-child{
    margin:-.5rem
  }

  .md\\:last\\:-m-3:last-child{
    margin:-.75rem
  }

  .md\\:last\\:-m-4:last-child{
    margin:-1rem
  }

  .md\\:last\\:-m-5:last-child{
    margin:-1.25rem
  }

  .md\\:last\\:-m-6:last-child{
    margin:-1.5rem
  }

  .md\\:last\\:-m-8:last-child{
    margin:-2rem
  }

  .md\\:last\\:-m-10:last-child{
    margin:-2.5rem
  }

  .md\\:last\\:-m-12:last-child{
    margin:-3rem
  }

  .md\\:last\\:-m-16:last-child{
    margin:-4rem
  }

  .md\\:last\\:-m-20:last-child{
    margin:-5rem
  }

  .md\\:last\\:-m-24:last-child{
    margin:-6rem
  }

  .md\\:last\\:-m-32:last-child{
    margin:-8rem
  }

  .md\\:last\\:-m-40:last-child{
    margin:-10rem
  }

  .md\\:last\\:-m-48:last-child{
    margin:-12rem
  }

  .md\\:last\\:-m-56:last-child{
    margin:-14rem
  }

  .md\\:last\\:-m-64:last-child{
    margin:-16rem
  }

  .md\\:last\\:-m-px:last-child{
    margin:-1px
  }

  .md\\:last\\:my-0:last-child{
    margin-bottom:0;
    margin-top:0
  }

  .md\\:last\\:mx-0:last-child{
    margin-left:0;
    margin-right:0
  }

  .md\\:last\\:my-1:last-child{
    margin-bottom:.25rem;
    margin-top:.25rem
  }

  .md\\:last\\:mx-1:last-child{
    margin-left:.25rem;
    margin-right:.25rem
  }

  .md\\:last\\:my-2:last-child{
    margin-bottom:.5rem;
    margin-top:.5rem
  }

  .md\\:last\\:mx-2:last-child{
    margin-left:.5rem;
    margin-right:.5rem
  }

  .md\\:last\\:my-3:last-child{
    margin-bottom:.75rem;
    margin-top:.75rem
  }

  .md\\:last\\:mx-3:last-child{
    margin-left:.75rem;
    margin-right:.75rem
  }

  .md\\:last\\:my-4:last-child{
    margin-bottom:1rem;
    margin-top:1rem
  }

  .md\\:last\\:mx-4:last-child{
    margin-left:1rem;
    margin-right:1rem
  }

  .md\\:last\\:my-5:last-child{
    margin-bottom:1.25rem;
    margin-top:1.25rem
  }

  .md\\:last\\:mx-5:last-child{
    margin-left:1.25rem;
    margin-right:1.25rem
  }

  .md\\:last\\:my-6:last-child{
    margin-bottom:1.5rem;
    margin-top:1.5rem
  }

  .md\\:last\\:mx-6:last-child{
    margin-left:1.5rem;
    margin-right:1.5rem
  }

  .md\\:last\\:my-8:last-child{
    margin-bottom:2rem;
    margin-top:2rem
  }

  .md\\:last\\:mx-8:last-child{
    margin-left:2rem;
    margin-right:2rem
  }

  .md\\:last\\:my-10:last-child{
    margin-bottom:2.5rem;
    margin-top:2.5rem
  }

  .md\\:last\\:mx-10:last-child{
    margin-left:2.5rem;
    margin-right:2.5rem
  }

  .md\\:last\\:my-12:last-child{
    margin-bottom:3rem;
    margin-top:3rem
  }

  .md\\:last\\:mx-12:last-child{
    margin-left:3rem;
    margin-right:3rem
  }

  .md\\:last\\:my-16:last-child{
    margin-bottom:4rem;
    margin-top:4rem
  }

  .md\\:last\\:mx-16:last-child{
    margin-left:4rem;
    margin-right:4rem
  }

  .md\\:last\\:my-20:last-child{
    margin-bottom:5rem;
    margin-top:5rem
  }

  .md\\:last\\:mx-20:last-child{
    margin-left:5rem;
    margin-right:5rem
  }

  .md\\:last\\:my-24:last-child{
    margin-bottom:6rem;
    margin-top:6rem
  }

  .md\\:last\\:mx-24:last-child{
    margin-left:6rem;
    margin-right:6rem
  }

  .md\\:last\\:my-32:last-child{
    margin-bottom:8rem;
    margin-top:8rem
  }

  .md\\:last\\:mx-32:last-child{
    margin-left:8rem;
    margin-right:8rem
  }

  .md\\:last\\:my-40:last-child{
    margin-bottom:10rem;
    margin-top:10rem
  }

  .md\\:last\\:mx-40:last-child{
    margin-left:10rem;
    margin-right:10rem
  }

  .md\\:last\\:my-48:last-child{
    margin-bottom:12rem;
    margin-top:12rem
  }

  .md\\:last\\:mx-48:last-child{
    margin-left:12rem;
    margin-right:12rem
  }

  .md\\:last\\:my-56:last-child{
    margin-bottom:14rem;
    margin-top:14rem
  }

  .md\\:last\\:mx-56:last-child{
    margin-left:14rem;
    margin-right:14rem
  }

  .md\\:last\\:my-64:last-child{
    margin-bottom:16rem;
    margin-top:16rem
  }

  .md\\:last\\:mx-64:last-child{
    margin-left:16rem;
    margin-right:16rem
  }

  .md\\:last\\:my-auto:last-child{
    margin-bottom:auto;
    margin-top:auto
  }

  .md\\:last\\:mx-auto:last-child{
    margin-left:auto;
    margin-right:auto
  }

  .md\\:last\\:my-px:last-child{
    margin-bottom:1px;
    margin-top:1px
  }

  .md\\:last\\:mx-px:last-child{
    margin-left:1px;
    margin-right:1px
  }

  .md\\:last\\:-my-1:last-child{
    margin-bottom:-.25rem;
    margin-top:-.25rem
  }

  .md\\:last\\:-mx-1:last-child{
    margin-left:-.25rem;
    margin-right:-.25rem
  }

  .md\\:last\\:-my-2:last-child{
    margin-bottom:-.5rem;
    margin-top:-.5rem
  }

  .md\\:last\\:-mx-2:last-child{
    margin-left:-.5rem;
    margin-right:-.5rem
  }

  .md\\:last\\:-my-3:last-child{
    margin-bottom:-.75rem;
    margin-top:-.75rem
  }

  .md\\:last\\:-mx-3:last-child{
    margin-left:-.75rem;
    margin-right:-.75rem
  }

  .md\\:last\\:-my-4:last-child{
    margin-bottom:-1rem;
    margin-top:-1rem
  }

  .md\\:last\\:-mx-4:last-child{
    margin-left:-1rem;
    margin-right:-1rem
  }

  .md\\:last\\:-my-5:last-child{
    margin-bottom:-1.25rem;
    margin-top:-1.25rem
  }

  .md\\:last\\:-mx-5:last-child{
    margin-left:-1.25rem;
    margin-right:-1.25rem
  }

  .md\\:last\\:-my-6:last-child{
    margin-bottom:-1.5rem;
    margin-top:-1.5rem
  }

  .md\\:last\\:-mx-6:last-child{
    margin-left:-1.5rem;
    margin-right:-1.5rem
  }

  .md\\:last\\:-my-8:last-child{
    margin-bottom:-2rem;
    margin-top:-2rem
  }

  .md\\:last\\:-mx-8:last-child{
    margin-left:-2rem;
    margin-right:-2rem
  }

  .md\\:last\\:-my-10:last-child{
    margin-bottom:-2.5rem;
    margin-top:-2.5rem
  }

  .md\\:last\\:-mx-10:last-child{
    margin-left:-2.5rem;
    margin-right:-2.5rem
  }

  .md\\:last\\:-my-12:last-child{
    margin-bottom:-3rem;
    margin-top:-3rem
  }

  .md\\:last\\:-mx-12:last-child{
    margin-left:-3rem;
    margin-right:-3rem
  }

  .md\\:last\\:-my-16:last-child{
    margin-bottom:-4rem;
    margin-top:-4rem
  }

  .md\\:last\\:-mx-16:last-child{
    margin-left:-4rem;
    margin-right:-4rem
  }

  .md\\:last\\:-my-20:last-child{
    margin-bottom:-5rem;
    margin-top:-5rem
  }

  .md\\:last\\:-mx-20:last-child{
    margin-left:-5rem;
    margin-right:-5rem
  }

  .md\\:last\\:-my-24:last-child{
    margin-bottom:-6rem;
    margin-top:-6rem
  }

  .md\\:last\\:-mx-24:last-child{
    margin-left:-6rem;
    margin-right:-6rem
  }

  .md\\:last\\:-my-32:last-child{
    margin-bottom:-8rem;
    margin-top:-8rem
  }

  .md\\:last\\:-mx-32:last-child{
    margin-left:-8rem;
    margin-right:-8rem
  }

  .md\\:last\\:-my-40:last-child{
    margin-bottom:-10rem;
    margin-top:-10rem
  }

  .md\\:last\\:-mx-40:last-child{
    margin-left:-10rem;
    margin-right:-10rem
  }

  .md\\:last\\:-my-48:last-child{
    margin-bottom:-12rem;
    margin-top:-12rem
  }

  .md\\:last\\:-mx-48:last-child{
    margin-left:-12rem;
    margin-right:-12rem
  }

  .md\\:last\\:-my-56:last-child{
    margin-bottom:-14rem;
    margin-top:-14rem
  }

  .md\\:last\\:-mx-56:last-child{
    margin-left:-14rem;
    margin-right:-14rem
  }

  .md\\:last\\:-my-64:last-child{
    margin-bottom:-16rem;
    margin-top:-16rem
  }

  .md\\:last\\:-mx-64:last-child{
    margin-left:-16rem;
    margin-right:-16rem
  }

  .md\\:last\\:-my-px:last-child{
    margin-bottom:-1px;
    margin-top:-1px
  }

  .md\\:last\\:-mx-px:last-child{
    margin-left:-1px;
    margin-right:-1px
  }

  .md\\:last\\:mt-0:last-child{
    margin-top:0
  }

  .md\\:last\\:mr-0:last-child{
    margin-right:0
  }

  .md\\:last\\:mb-0:last-child{
    margin-bottom:0
  }

  .md\\:last\\:ml-0:last-child{
    margin-left:0
  }

  .md\\:last\\:mt-1:last-child{
    margin-top:.25rem
  }

  .md\\:last\\:mr-1:last-child{
    margin-right:.25rem
  }

  .md\\:last\\:mb-1:last-child{
    margin-bottom:.25rem
  }

  .md\\:last\\:ml-1:last-child{
    margin-left:.25rem
  }

  .md\\:last\\:mt-2:last-child{
    margin-top:.5rem
  }

  .md\\:last\\:mr-2:last-child{
    margin-right:.5rem
  }

  .md\\:last\\:mb-2:last-child{
    margin-bottom:.5rem
  }

  .md\\:last\\:ml-2:last-child{
    margin-left:.5rem
  }

  .md\\:last\\:mt-3:last-child{
    margin-top:.75rem
  }

  .md\\:last\\:mr-3:last-child{
    margin-right:.75rem
  }

  .md\\:last\\:mb-3:last-child{
    margin-bottom:.75rem
  }

  .md\\:last\\:ml-3:last-child{
    margin-left:.75rem
  }

  .md\\:last\\:mt-4:last-child{
    margin-top:1rem
  }

  .md\\:last\\:mr-4:last-child{
    margin-right:1rem
  }

  .md\\:last\\:mb-4:last-child{
    margin-bottom:1rem
  }

  .md\\:last\\:ml-4:last-child{
    margin-left:1rem
  }

  .md\\:last\\:mt-5:last-child{
    margin-top:1.25rem
  }

  .md\\:last\\:mr-5:last-child{
    margin-right:1.25rem
  }

  .md\\:last\\:mb-5:last-child{
    margin-bottom:1.25rem
  }

  .md\\:last\\:ml-5:last-child{
    margin-left:1.25rem
  }

  .md\\:last\\:mt-6:last-child{
    margin-top:1.5rem
  }

  .md\\:last\\:mr-6:last-child{
    margin-right:1.5rem
  }

  .md\\:last\\:mb-6:last-child{
    margin-bottom:1.5rem
  }

  .md\\:last\\:ml-6:last-child{
    margin-left:1.5rem
  }

  .md\\:last\\:mt-8:last-child{
    margin-top:2rem
  }

  .md\\:last\\:mr-8:last-child{
    margin-right:2rem
  }

  .md\\:last\\:mb-8:last-child{
    margin-bottom:2rem
  }

  .md\\:last\\:ml-8:last-child{
    margin-left:2rem
  }

  .md\\:last\\:mt-10:last-child{
    margin-top:2.5rem
  }

  .md\\:last\\:mr-10:last-child{
    margin-right:2.5rem
  }

  .md\\:last\\:mb-10:last-child{
    margin-bottom:2.5rem
  }

  .md\\:last\\:ml-10:last-child{
    margin-left:2.5rem
  }

  .md\\:last\\:mt-12:last-child{
    margin-top:3rem
  }

  .md\\:last\\:mr-12:last-child{
    margin-right:3rem
  }

  .md\\:last\\:mb-12:last-child{
    margin-bottom:3rem
  }

  .md\\:last\\:ml-12:last-child{
    margin-left:3rem
  }

  .md\\:last\\:mt-16:last-child{
    margin-top:4rem
  }

  .md\\:last\\:mr-16:last-child{
    margin-right:4rem
  }

  .md\\:last\\:mb-16:last-child{
    margin-bottom:4rem
  }

  .md\\:last\\:ml-16:last-child{
    margin-left:4rem
  }

  .md\\:last\\:mt-20:last-child{
    margin-top:5rem
  }

  .md\\:last\\:mr-20:last-child{
    margin-right:5rem
  }

  .md\\:last\\:mb-20:last-child{
    margin-bottom:5rem
  }

  .md\\:last\\:ml-20:last-child{
    margin-left:5rem
  }

  .md\\:last\\:mt-24:last-child{
    margin-top:6rem
  }

  .md\\:last\\:mr-24:last-child{
    margin-right:6rem
  }

  .md\\:last\\:mb-24:last-child{
    margin-bottom:6rem
  }

  .md\\:last\\:ml-24:last-child{
    margin-left:6rem
  }

  .md\\:last\\:mt-32:last-child{
    margin-top:8rem
  }

  .md\\:last\\:mr-32:last-child{
    margin-right:8rem
  }

  .md\\:last\\:mb-32:last-child{
    margin-bottom:8rem
  }

  .md\\:last\\:ml-32:last-child{
    margin-left:8rem
  }

  .md\\:last\\:mt-40:last-child{
    margin-top:10rem
  }

  .md\\:last\\:mr-40:last-child{
    margin-right:10rem
  }

  .md\\:last\\:mb-40:last-child{
    margin-bottom:10rem
  }

  .md\\:last\\:ml-40:last-child{
    margin-left:10rem
  }

  .md\\:last\\:mt-48:last-child{
    margin-top:12rem
  }

  .md\\:last\\:mr-48:last-child{
    margin-right:12rem
  }

  .md\\:last\\:mb-48:last-child{
    margin-bottom:12rem
  }

  .md\\:last\\:ml-48:last-child{
    margin-left:12rem
  }

  .md\\:last\\:mt-56:last-child{
    margin-top:14rem
  }

  .md\\:last\\:mr-56:last-child{
    margin-right:14rem
  }

  .md\\:last\\:mb-56:last-child{
    margin-bottom:14rem
  }

  .md\\:last\\:ml-56:last-child{
    margin-left:14rem
  }

  .md\\:last\\:mt-64:last-child{
    margin-top:16rem
  }

  .md\\:last\\:mr-64:last-child{
    margin-right:16rem
  }

  .md\\:last\\:mb-64:last-child{
    margin-bottom:16rem
  }

  .md\\:last\\:ml-64:last-child{
    margin-left:16rem
  }

  .md\\:last\\:mt-auto:last-child{
    margin-top:auto
  }

  .md\\:last\\:mr-auto:last-child{
    margin-right:auto
  }

  .md\\:last\\:mb-auto:last-child{
    margin-bottom:auto
  }

  .md\\:last\\:ml-auto:last-child{
    margin-left:auto
  }

  .md\\:last\\:mt-px:last-child{
    margin-top:1px
  }

  .md\\:last\\:mr-px:last-child{
    margin-right:1px
  }

  .md\\:last\\:mb-px:last-child{
    margin-bottom:1px
  }

  .md\\:last\\:ml-px:last-child{
    margin-left:1px
  }

  .md\\:last\\:-mt-1:last-child{
    margin-top:-.25rem
  }

  .md\\:last\\:-mr-1:last-child{
    margin-right:-.25rem
  }

  .md\\:last\\:-mb-1:last-child{
    margin-bottom:-.25rem
  }

  .md\\:last\\:-ml-1:last-child{
    margin-left:-.25rem
  }

  .md\\:last\\:-mt-2:last-child{
    margin-top:-.5rem
  }

  .md\\:last\\:-mr-2:last-child{
    margin-right:-.5rem
  }

  .md\\:last\\:-mb-2:last-child{
    margin-bottom:-.5rem
  }

  .md\\:last\\:-ml-2:last-child{
    margin-left:-.5rem
  }

  .md\\:last\\:-mt-3:last-child{
    margin-top:-.75rem
  }

  .md\\:last\\:-mr-3:last-child{
    margin-right:-.75rem
  }

  .md\\:last\\:-mb-3:last-child{
    margin-bottom:-.75rem
  }

  .md\\:last\\:-ml-3:last-child{
    margin-left:-.75rem
  }

  .md\\:last\\:-mt-4:last-child{
    margin-top:-1rem
  }

  .md\\:last\\:-mr-4:last-child{
    margin-right:-1rem
  }

  .md\\:last\\:-mb-4:last-child{
    margin-bottom:-1rem
  }

  .md\\:last\\:-ml-4:last-child{
    margin-left:-1rem
  }

  .md\\:last\\:-mt-5:last-child{
    margin-top:-1.25rem
  }

  .md\\:last\\:-mr-5:last-child{
    margin-right:-1.25rem
  }

  .md\\:last\\:-mb-5:last-child{
    margin-bottom:-1.25rem
  }

  .md\\:last\\:-ml-5:last-child{
    margin-left:-1.25rem
  }

  .md\\:last\\:-mt-6:last-child{
    margin-top:-1.5rem
  }

  .md\\:last\\:-mr-6:last-child{
    margin-right:-1.5rem
  }

  .md\\:last\\:-mb-6:last-child{
    margin-bottom:-1.5rem
  }

  .md\\:last\\:-ml-6:last-child{
    margin-left:-1.5rem
  }

  .md\\:last\\:-mt-8:last-child{
    margin-top:-2rem
  }

  .md\\:last\\:-mr-8:last-child{
    margin-right:-2rem
  }

  .md\\:last\\:-mb-8:last-child{
    margin-bottom:-2rem
  }

  .md\\:last\\:-ml-8:last-child{
    margin-left:-2rem
  }

  .md\\:last\\:-mt-10:last-child{
    margin-top:-2.5rem
  }

  .md\\:last\\:-mr-10:last-child{
    margin-right:-2.5rem
  }

  .md\\:last\\:-mb-10:last-child{
    margin-bottom:-2.5rem
  }

  .md\\:last\\:-ml-10:last-child{
    margin-left:-2.5rem
  }

  .md\\:last\\:-mt-12:last-child{
    margin-top:-3rem
  }

  .md\\:last\\:-mr-12:last-child{
    margin-right:-3rem
  }

  .md\\:last\\:-mb-12:last-child{
    margin-bottom:-3rem
  }

  .md\\:last\\:-ml-12:last-child{
    margin-left:-3rem
  }

  .md\\:last\\:-mt-16:last-child{
    margin-top:-4rem
  }

  .md\\:last\\:-mr-16:last-child{
    margin-right:-4rem
  }

  .md\\:last\\:-mb-16:last-child{
    margin-bottom:-4rem
  }

  .md\\:last\\:-ml-16:last-child{
    margin-left:-4rem
  }

  .md\\:last\\:-mt-20:last-child{
    margin-top:-5rem
  }

  .md\\:last\\:-mr-20:last-child{
    margin-right:-5rem
  }

  .md\\:last\\:-mb-20:last-child{
    margin-bottom:-5rem
  }

  .md\\:last\\:-ml-20:last-child{
    margin-left:-5rem
  }

  .md\\:last\\:-mt-24:last-child{
    margin-top:-6rem
  }

  .md\\:last\\:-mr-24:last-child{
    margin-right:-6rem
  }

  .md\\:last\\:-mb-24:last-child{
    margin-bottom:-6rem
  }

  .md\\:last\\:-ml-24:last-child{
    margin-left:-6rem
  }

  .md\\:last\\:-mt-32:last-child{
    margin-top:-8rem
  }

  .md\\:last\\:-mr-32:last-child{
    margin-right:-8rem
  }

  .md\\:last\\:-mb-32:last-child{
    margin-bottom:-8rem
  }

  .md\\:last\\:-ml-32:last-child{
    margin-left:-8rem
  }

  .md\\:last\\:-mt-40:last-child{
    margin-top:-10rem
  }

  .md\\:last\\:-mr-40:last-child{
    margin-right:-10rem
  }

  .md\\:last\\:-mb-40:last-child{
    margin-bottom:-10rem
  }

  .md\\:last\\:-ml-40:last-child{
    margin-left:-10rem
  }

  .md\\:last\\:-mt-48:last-child{
    margin-top:-12rem
  }

  .md\\:last\\:-mr-48:last-child{
    margin-right:-12rem
  }

  .md\\:last\\:-mb-48:last-child{
    margin-bottom:-12rem
  }

  .md\\:last\\:-ml-48:last-child{
    margin-left:-12rem
  }

  .md\\:last\\:-mt-56:last-child{
    margin-top:-14rem
  }

  .md\\:last\\:-mr-56:last-child{
    margin-right:-14rem
  }

  .md\\:last\\:-mb-56:last-child{
    margin-bottom:-14rem
  }

  .md\\:last\\:-ml-56:last-child{
    margin-left:-14rem
  }

  .md\\:last\\:-mt-64:last-child{
    margin-top:-16rem
  }

  .md\\:last\\:-mr-64:last-child{
    margin-right:-16rem
  }

  .md\\:last\\:-mb-64:last-child{
    margin-bottom:-16rem
  }

  .md\\:last\\:-ml-64:last-child{
    margin-left:-16rem
  }

  .md\\:last\\:-mt-px:last-child{
    margin-top:-1px
  }

  .md\\:last\\:-mr-px:last-child{
    margin-right:-1px
  }

  .md\\:last\\:-mb-px:last-child{
    margin-bottom:-1px
  }

  .md\\:last\\:-ml-px:last-child{
    margin-left:-1px
  }

  .md\\:max-h-0{
    max-height:0
  }

  .md\\:max-h-1{
    max-height:.25rem
  }

  .md\\:max-h-2{
    max-height:.5rem
  }

  .md\\:max-h-3{
    max-height:.75rem
  }

  .md\\:max-h-4{
    max-height:1rem
  }

  .md\\:max-h-5{
    max-height:1.25rem
  }

  .md\\:max-h-6{
    max-height:1.5rem
  }

  .md\\:max-h-8{
    max-height:2rem
  }

  .md\\:max-h-10{
    max-height:2.5rem
  }

  .md\\:max-h-12{
    max-height:3rem
  }

  .md\\:max-h-16{
    max-height:4rem
  }

  .md\\:max-h-20{
    max-height:5rem
  }

  .md\\:max-h-24{
    max-height:6rem
  }

  .md\\:max-h-32{
    max-height:8rem
  }

  .md\\:max-h-40{
    max-height:10rem
  }

  .md\\:max-h-48{
    max-height:12rem
  }

  .md\\:max-h-56{
    max-height:14rem
  }

  .md\\:max-h-64{
    max-height:16rem
  }

  .md\\:max-h-xl{
    max-height:36rem
  }

  .md\\:max-h-px{
    max-height:1px
  }

  .md\\:max-w-none{
    max-width:none
  }

  .md\\:max-w-xs{
    max-width:20rem
  }

  .md\\:max-w-sm{
    max-width:24rem
  }

  .md\\:max-w-md{
    max-width:28rem
  }

  .md\\:max-w-lg{
    max-width:32rem
  }

  .md\\:max-w-xl{
    max-width:36rem
  }

  .md\\:max-w-2xl{
    max-width:42rem
  }

  .md\\:max-w-3xl{
    max-width:48rem
  }

  .md\\:max-w-4xl{
    max-width:56rem
  }

  .md\\:max-w-5xl{
    max-width:64rem
  }

  .md\\:max-w-6xl{
    max-width:72rem
  }

  .md\\:max-w-full{
    max-width:100%
  }

  .md\\:max-w-screen-sm{
    max-width:640px
  }

  .md\\:max-w-screen-md{
    max-width:768px
  }

  .md\\:max-w-screen-lg{
    max-width:1024px
  }

  .md\\:max-w-screen-xl{
    max-width:1280px
  }

  .md\\:min-h-0{
    min-height:0
  }

  .md\\:min-h-full{
    min-height:100%
  }

  .md\\:min-h-screen{
    min-height:100vh
  }

  .md\\:min-w-0{
    min-width:0
  }

  .md\\:min-w-1{
    min-width:.25rem
  }

  .md\\:min-w-2{
    min-width:.5rem
  }

  .md\\:min-w-3{
    min-width:.75rem
  }

  .md\\:min-w-4{
    min-width:1rem
  }

  .md\\:min-w-5{
    min-width:1.25rem
  }

  .md\\:min-w-6{
    min-width:1.5rem
  }

  .md\\:min-w-8{
    min-width:2rem
  }

  .md\\:min-w-10{
    min-width:2.5rem
  }

  .md\\:min-w-12{
    min-width:3rem
  }

  .md\\:min-w-16{
    min-width:4rem
  }

  .md\\:min-w-20{
    min-width:5rem
  }

  .md\\:min-w-24{
    min-width:6rem
  }

  .md\\:min-w-32{
    min-width:8rem
  }

  .md\\:min-w-40{
    min-width:10rem
  }

  .md\\:min-w-48{
    min-width:12rem
  }

  .md\\:min-w-56{
    min-width:14rem
  }

  .md\\:min-w-64{
    min-width:16rem
  }

  .md\\:min-w-max-content{
    min-width:max-content
  }

  .md\\:min-w-px{
    min-width:1px
  }

  .md\\:object-contain{
    object-fit:contain
  }

  .md\\:object-cover{
    object-fit:cover
  }

  .md\\:object-fill{
    object-fit:fill
  }

  .md\\:object-none{
    object-fit:none
  }

  .md\\:object-scale-down{
    object-fit:scale-down
  }

  .md\\:object-bottom{
    object-position:bottom
  }

  .md\\:object-center{
    object-position:center
  }

  .md\\:object-left{
    object-position:left
  }

  .md\\:object-left-bottom{
    object-position:left bottom
  }

  .md\\:object-left-top{
    object-position:left top
  }

  .md\\:object-right{
    object-position:right
  }

  .md\\:object-right-bottom{
    object-position:right bottom
  }

  .md\\:object-right-top{
    object-position:right top
  }

  .md\\:object-top{
    object-position:top
  }

  .md\\:opacity-0{
    opacity:0
  }

  .md\\:opacity-25{
    opacity:.25
  }

  .md\\:opacity-50{
    opacity:.5
  }

  .md\\:opacity-75{
    opacity:.75
  }

  .md\\:opacity-100{
    opacity:1
  }

  .md\\:hover\\:opacity-0:hover{
    opacity:0
  }

  .md\\:hover\\:opacity-25:hover{
    opacity:.25
  }

  .md\\:hover\\:opacity-50:hover{
    opacity:.5
  }

  .md\\:hover\\:opacity-75:hover{
    opacity:.75
  }

  .md\\:hover\\:opacity-100:hover{
    opacity:1
  }

  .md\\:focus\\:opacity-0:focus{
    opacity:0
  }

  .md\\:focus\\:opacity-25:focus{
    opacity:.25
  }

  .md\\:focus\\:opacity-50:focus{
    opacity:.5
  }

  .md\\:focus\\:opacity-75:focus{
    opacity:.75
  }

  .md\\:focus\\:opacity-100:focus{
    opacity:1
  }

  .md\\:focus\\:outline-none:focus,.md\\:outline-none{
    outline:0
  }

  .md\\:overflow-auto{
    overflow:auto
  }

  .md\\:overflow-hidden{
    overflow:hidden
  }

  .md\\:overflow-visible{
    overflow:visible
  }

  .md\\:overflow-scroll{
    overflow:scroll
  }

  .md\\:overflow-x-auto{
    overflow-x:auto
  }

  .md\\:overflow-y-auto{
    overflow-y:auto
  }

  .md\\:overflow-x-hidden{
    overflow-x:hidden
  }

  .md\\:overflow-y-hidden{
    overflow-y:hidden
  }

  .md\\:overflow-x-visible{
    overflow-x:visible
  }

  .md\\:overflow-y-visible{
    overflow-y:visible
  }

  .md\\:overflow-x-scroll{
    overflow-x:scroll
  }

  .md\\:overflow-y-scroll{
    overflow-y:scroll
  }

  .md\\:scrolling-touch{
    -webkit-overflow-scrolling:touch
  }

  .md\\:scrolling-auto{
    -webkit-overflow-scrolling:auto
  }

  .md\\:p-0{
    padding:0
  }

  .md\\:p-1{
    padding:.25rem
  }

  .md\\:p-2{
    padding:.5rem
  }

  .md\\:p-3{
    padding:.75rem
  }

  .md\\:p-4{
    padding:1rem
  }

  .md\\:p-5{
    padding:1.25rem
  }

  .md\\:p-6{
    padding:1.5rem
  }

  .md\\:p-8{
    padding:2rem
  }

  .md\\:p-10{
    padding:2.5rem
  }

  .md\\:p-12{
    padding:3rem
  }

  .md\\:p-16{
    padding:4rem
  }

  .md\\:p-20{
    padding:5rem
  }

  .md\\:p-24{
    padding:6rem
  }

  .md\\:p-32{
    padding:8rem
  }

  .md\\:p-40{
    padding:10rem
  }

  .md\\:p-48{
    padding:12rem
  }

  .md\\:p-56{
    padding:14rem
  }

  .md\\:p-64{
    padding:16rem
  }

  .md\\:p-px{
    padding:1px
  }

  .md\\:py-0{
    padding-bottom:0;
    padding-top:0
  }

  .md\\:px-0{
    padding-left:0;
    padding-right:0
  }

  .md\\:py-1{
    padding-bottom:.25rem;
    padding-top:.25rem
  }

  .md\\:px-1{
    padding-left:.25rem;
    padding-right:.25rem
  }

  .md\\:py-2{
    padding-bottom:.5rem;
    padding-top:.5rem
  }

  .md\\:px-2{
    padding-left:.5rem;
    padding-right:.5rem
  }

  .md\\:py-3{
    padding-bottom:.75rem;
    padding-top:.75rem
  }

  .md\\:px-3{
    padding-left:.75rem;
    padding-right:.75rem
  }

  .md\\:py-4{
    padding-bottom:1rem;
    padding-top:1rem
  }

  .md\\:px-4{
    padding-left:1rem;
    padding-right:1rem
  }

  .md\\:py-5{
    padding-bottom:1.25rem;
    padding-top:1.25rem
  }

  .md\\:px-5{
    padding-left:1.25rem;
    padding-right:1.25rem
  }

  .md\\:py-6{
    padding-bottom:1.5rem;
    padding-top:1.5rem
  }

  .md\\:px-6{
    padding-left:1.5rem;
    padding-right:1.5rem
  }

  .md\\:py-8{
    padding-bottom:2rem;
    padding-top:2rem
  }

  .md\\:px-8{
    padding-left:2rem;
    padding-right:2rem
  }

  .md\\:py-10{
    padding-bottom:2.5rem;
    padding-top:2.5rem
  }

  .md\\:px-10{
    padding-left:2.5rem;
    padding-right:2.5rem
  }

  .md\\:py-12{
    padding-bottom:3rem;
    padding-top:3rem
  }

  .md\\:px-12{
    padding-left:3rem;
    padding-right:3rem
  }

  .md\\:py-16{
    padding-bottom:4rem;
    padding-top:4rem
  }

  .md\\:px-16{
    padding-left:4rem;
    padding-right:4rem
  }

  .md\\:py-20{
    padding-bottom:5rem;
    padding-top:5rem
  }

  .md\\:px-20{
    padding-left:5rem;
    padding-right:5rem
  }

  .md\\:py-24{
    padding-bottom:6rem;
    padding-top:6rem
  }

  .md\\:px-24{
    padding-left:6rem;
    padding-right:6rem
  }

  .md\\:py-32{
    padding-bottom:8rem;
    padding-top:8rem
  }

  .md\\:px-32{
    padding-left:8rem;
    padding-right:8rem
  }

  .md\\:py-40{
    padding-bottom:10rem;
    padding-top:10rem
  }

  .md\\:px-40{
    padding-left:10rem;
    padding-right:10rem
  }

  .md\\:py-48{
    padding-bottom:12rem;
    padding-top:12rem
  }

  .md\\:px-48{
    padding-left:12rem;
    padding-right:12rem
  }

  .md\\:py-56{
    padding-bottom:14rem;
    padding-top:14rem
  }

  .md\\:px-56{
    padding-left:14rem;
    padding-right:14rem
  }

  .md\\:py-64{
    padding-bottom:16rem;
    padding-top:16rem
  }

  .md\\:px-64{
    padding-left:16rem;
    padding-right:16rem
  }

  .md\\:py-px{
    padding-bottom:1px;
    padding-top:1px
  }

  .md\\:px-px{
    padding-left:1px;
    padding-right:1px
  }

  .md\\:pt-0{
    padding-top:0
  }

  .md\\:pr-0{
    padding-right:0
  }

  .md\\:pb-0{
    padding-bottom:0
  }

  .md\\:pl-0{
    padding-left:0
  }

  .md\\:pt-1{
    padding-top:.25rem
  }

  .md\\:pr-1{
    padding-right:.25rem
  }

  .md\\:pb-1{
    padding-bottom:.25rem
  }

  .md\\:pl-1{
    padding-left:.25rem
  }

  .md\\:pt-2{
    padding-top:.5rem
  }

  .md\\:pr-2{
    padding-right:.5rem
  }

  .md\\:pb-2{
    padding-bottom:.5rem
  }

  .md\\:pl-2{
    padding-left:.5rem
  }

  .md\\:pt-3{
    padding-top:.75rem
  }

  .md\\:pr-3{
    padding-right:.75rem
  }

  .md\\:pb-3{
    padding-bottom:.75rem
  }

  .md\\:pl-3{
    padding-left:.75rem
  }

  .md\\:pt-4{
    padding-top:1rem
  }

  .md\\:pr-4{
    padding-right:1rem
  }

  .md\\:pb-4{
    padding-bottom:1rem
  }

  .md\\:pl-4{
    padding-left:1rem
  }

  .md\\:pt-5{
    padding-top:1.25rem
  }

  .md\\:pr-5{
    padding-right:1.25rem
  }

  .md\\:pb-5{
    padding-bottom:1.25rem
  }

  .md\\:pl-5{
    padding-left:1.25rem
  }

  .md\\:pt-6{
    padding-top:1.5rem
  }

  .md\\:pr-6{
    padding-right:1.5rem
  }

  .md\\:pb-6{
    padding-bottom:1.5rem
  }

  .md\\:pl-6{
    padding-left:1.5rem
  }

  .md\\:pt-8{
    padding-top:2rem
  }

  .md\\:pr-8{
    padding-right:2rem
  }

  .md\\:pb-8{
    padding-bottom:2rem
  }

  .md\\:pl-8{
    padding-left:2rem
  }

  .md\\:pt-10{
    padding-top:2.5rem
  }

  .md\\:pr-10{
    padding-right:2.5rem
  }

  .md\\:pb-10{
    padding-bottom:2.5rem
  }

  .md\\:pl-10{
    padding-left:2.5rem
  }

  .md\\:pt-12{
    padding-top:3rem
  }

  .md\\:pr-12{
    padding-right:3rem
  }

  .md\\:pb-12{
    padding-bottom:3rem
  }

  .md\\:pl-12{
    padding-left:3rem
  }

  .md\\:pt-16{
    padding-top:4rem
  }

  .md\\:pr-16{
    padding-right:4rem
  }

  .md\\:pb-16{
    padding-bottom:4rem
  }

  .md\\:pl-16{
    padding-left:4rem
  }

  .md\\:pt-20{
    padding-top:5rem
  }

  .md\\:pr-20{
    padding-right:5rem
  }

  .md\\:pb-20{
    padding-bottom:5rem
  }

  .md\\:pl-20{
    padding-left:5rem
  }

  .md\\:pt-24{
    padding-top:6rem
  }

  .md\\:pr-24{
    padding-right:6rem
  }

  .md\\:pb-24{
    padding-bottom:6rem
  }

  .md\\:pl-24{
    padding-left:6rem
  }

  .md\\:pt-32{
    padding-top:8rem
  }

  .md\\:pr-32{
    padding-right:8rem
  }

  .md\\:pb-32{
    padding-bottom:8rem
  }

  .md\\:pl-32{
    padding-left:8rem
  }

  .md\\:pt-40{
    padding-top:10rem
  }

  .md\\:pr-40{
    padding-right:10rem
  }

  .md\\:pb-40{
    padding-bottom:10rem
  }

  .md\\:pl-40{
    padding-left:10rem
  }

  .md\\:pt-48{
    padding-top:12rem
  }

  .md\\:pr-48{
    padding-right:12rem
  }

  .md\\:pb-48{
    padding-bottom:12rem
  }

  .md\\:pl-48{
    padding-left:12rem
  }

  .md\\:pt-56{
    padding-top:14rem
  }

  .md\\:pr-56{
    padding-right:14rem
  }

  .md\\:pb-56{
    padding-bottom:14rem
  }

  .md\\:pl-56{
    padding-left:14rem
  }

  .md\\:pt-64{
    padding-top:16rem
  }

  .md\\:pr-64{
    padding-right:16rem
  }

  .md\\:pb-64{
    padding-bottom:16rem
  }

  .md\\:pl-64{
    padding-left:16rem
  }

  .md\\:pt-px{
    padding-top:1px
  }

  .md\\:pr-px{
    padding-right:1px
  }

  .md\\:pb-px{
    padding-bottom:1px
  }

  .md\\:pl-px{
    padding-left:1px
  }

  .md\\:placeholder-transparent::placeholder{
    color:#0000
  }

  .md\\:placeholder-white::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .md\\:placeholder-black::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .md\\:placeholder-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .md\\:placeholder-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .md\\:placeholder-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .md\\:placeholder-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .md\\:placeholder-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .md\\:placeholder-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .md\\:placeholder-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .md\\:placeholder-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .md\\:placeholder-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .md\\:placeholder-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .md\\:placeholder-cool-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .md\\:placeholder-cool-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .md\\:placeholder-cool-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .md\\:placeholder-cool-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .md\\:placeholder-cool-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .md\\:placeholder-cool-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .md\\:placeholder-cool-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .md\\:placeholder-cool-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .md\\:placeholder-cool-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .md\\:placeholder-cool-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .md\\:placeholder-red-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .md\\:placeholder-red-100::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .md\\:placeholder-red-200::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .md\\:placeholder-red-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .md\\:placeholder-red-400::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .md\\:placeholder-red-500::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .md\\:placeholder-red-600::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .md\\:placeholder-red-700::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .md\\:placeholder-red-800::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .md\\:placeholder-red-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .md\\:placeholder-orange-50::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .md\\:placeholder-orange-100::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .md\\:placeholder-orange-200::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .md\\:placeholder-orange-300::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .md\\:placeholder-orange-400::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .md\\:placeholder-orange-500::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .md\\:placeholder-orange-600::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .md\\:placeholder-orange-700::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .md\\:placeholder-orange-800::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .md\\:placeholder-orange-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .md\\:placeholder-yellow-50::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .md\\:placeholder-yellow-100::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .md\\:placeholder-yellow-200::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .md\\:placeholder-yellow-300::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .md\\:placeholder-yellow-400::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .md\\:placeholder-yellow-500::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .md\\:placeholder-yellow-600::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .md\\:placeholder-yellow-700::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .md\\:placeholder-yellow-800::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .md\\:placeholder-yellow-900::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .md\\:placeholder-green-50::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .md\\:placeholder-green-100::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .md\\:placeholder-green-200::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .md\\:placeholder-green-300::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .md\\:placeholder-green-400::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .md\\:placeholder-green-500::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .md\\:placeholder-green-600::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .md\\:placeholder-green-700::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .md\\:placeholder-green-800::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .md\\:placeholder-green-900::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .md\\:placeholder-teal-50::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .md\\:placeholder-teal-100::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .md\\:placeholder-teal-200::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .md\\:placeholder-teal-300::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .md\\:placeholder-teal-400::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .md\\:placeholder-teal-500::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .md\\:placeholder-teal-600::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .md\\:placeholder-teal-700::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .md\\:placeholder-teal-800::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .md\\:placeholder-teal-900::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .md\\:placeholder-blue-50::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .md\\:placeholder-blue-100::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .md\\:placeholder-blue-200::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .md\\:placeholder-blue-300::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .md\\:placeholder-blue-400::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .md\\:placeholder-blue-500::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .md\\:placeholder-blue-600::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .md\\:placeholder-blue-700::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .md\\:placeholder-blue-800::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .md\\:placeholder-blue-900::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .md\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .md\\:placeholder-pink-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .md\\:placeholder-pink-100::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .md\\:placeholder-pink-200::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .md\\:placeholder-pink-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .md\\:placeholder-pink-400::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .md\\:placeholder-pink-500::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .md\\:placeholder-pink-600::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .md\\:placeholder-pink-700::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .md\\:placeholder-pink-800::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .md\\:placeholder-pink-900::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-transparent:focus::placeholder{
    color:#0000
  }

  .md\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-cool-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-cool-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-cool-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-cool-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-cool-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-cool-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-cool-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-cool-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-cool-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-cool-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-red-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-red-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-red-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-red-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-red-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-red-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-red-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-red-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-red-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-red-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-orange-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-orange-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-orange-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-orange-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-orange-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-orange-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-orange-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-orange-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-orange-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-orange-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-yellow-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-yellow-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-yellow-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-yellow-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-yellow-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-yellow-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-yellow-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-yellow-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-yellow-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-yellow-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-green-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-green-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-green-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-green-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-green-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-green-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-green-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-green-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-green-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-green-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-teal-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-teal-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-teal-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-teal-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-teal-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-teal-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-teal-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-teal-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-teal-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-teal-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-blue-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-blue-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-blue-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-blue-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-blue-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-blue-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-blue-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-blue-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-blue-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-blue-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-pink-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-pink-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-pink-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-pink-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-pink-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-pink-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-pink-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-pink-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-pink-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .md\\:focus\\:placeholder-pink-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-transparent::placeholder{
    color:#0000
  }

  .theme-dark .md\\:dark\\:placeholder-white::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-black::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-cool-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-cool-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-cool-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-cool-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-cool-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-cool-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-cool-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-cool-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-cool-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-cool-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-red-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-red-100::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-red-200::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-red-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-red-400::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-red-500::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-red-600::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-red-700::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-red-800::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-red-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-orange-50::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-orange-100::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-orange-200::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-orange-300::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-orange-400::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-orange-500::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-orange-600::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-orange-700::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-orange-800::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-orange-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-yellow-50::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-yellow-100::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-yellow-200::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-yellow-300::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-yellow-400::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-yellow-500::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-yellow-600::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-yellow-700::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-yellow-800::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-yellow-900::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-green-50::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-green-100::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-green-200::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-green-300::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-green-400::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-green-500::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-green-600::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-green-700::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-green-800::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-green-900::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-teal-50::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-teal-100::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-teal-200::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-teal-300::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-teal-400::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-teal-500::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-teal-600::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-teal-700::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-teal-800::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-teal-900::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-blue-50::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-blue-100::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-blue-200::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-blue-300::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-blue-400::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-blue-500::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-blue-600::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-blue-700::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-blue-800::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-blue-900::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-pink-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-pink-100::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-pink-200::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-pink-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-pink-400::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-pink-500::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-pink-600::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-pink-700::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-pink-800::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:placeholder-pink-900::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-transparent:focus::placeholder{
    color:#0000
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-red-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-red-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-red-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-red-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-red-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-red-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-red-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-red-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-red-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-red-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-orange-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-orange-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-orange-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-orange-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-orange-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-orange-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-orange-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-orange-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-orange-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-orange-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-yellow-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-yellow-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-yellow-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-yellow-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-yellow-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-yellow-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-yellow-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-yellow-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-yellow-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-yellow-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-green-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-green-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-green-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-green-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-green-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-green-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-green-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-green-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-green-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-green-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-teal-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-teal-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-teal-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-teal-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-teal-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-teal-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-teal-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-teal-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-teal-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-teal-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-blue-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-blue-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-blue-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-blue-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-blue-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-blue-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-blue-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-blue-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-blue-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-blue-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-pink-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-pink-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-pink-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-pink-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-pink-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-pink-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-pink-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-pink-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-pink-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .theme-dark .md\\:dark\\:focus\\:placeholder-pink-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .md\\:placeholder-opacity-0::placeholder{
    --placeholder-opacity:0
  }

  .md\\:placeholder-opacity-25::placeholder{
    --placeholder-opacity:0.25
  }

  .md\\:placeholder-opacity-50::placeholder{
    --placeholder-opacity:0.5
  }

  .md\\:placeholder-opacity-75::placeholder{
    --placeholder-opacity:0.75
  }

  .md\\:placeholder-opacity-100::placeholder{
    --placeholder-opacity:1
  }

  .md\\:focus\\:placeholder-opacity-0:focus::placeholder{
    --placeholder-opacity:0
  }

  .md\\:focus\\:placeholder-opacity-25:focus::placeholder{
    --placeholder-opacity:0.25
  }

  .md\\:focus\\:placeholder-opacity-50:focus::placeholder{
    --placeholder-opacity:0.5
  }

  .md\\:focus\\:placeholder-opacity-75:focus::placeholder{
    --placeholder-opacity:0.75
  }

  .md\\:focus\\:placeholder-opacity-100:focus::placeholder{
    --placeholder-opacity:1
  }

  .md\\:pointer-events-none{
    pointer-events:none
  }

  .md\\:pointer-events-auto{
    pointer-events:auto
  }

  .md\\:static{
    position:static
  }

  .md\\:fixed{
    position:fixed
  }

  .md\\:absolute{
    position:absolute
  }

  .md\\:relative{
    position:relative
  }

  .md\\:sticky{
    position:sticky
  }

  .md\\:inset-0{
    bottom:0;
    left:0;
    right:0;
    top:0
  }

  .md\\:inset-auto{
    bottom:auto;
    left:auto;
    right:auto;
    top:auto
  }

  .md\\:inset-y-0{
    bottom:0;
    top:0
  }

  .md\\:inset-x-0{
    left:0;
    right:0
  }

  .md\\:inset-y-auto{
    bottom:auto;
    top:auto
  }

  .md\\:inset-x-auto{
    left:auto;
    right:auto
  }

  .md\\:top-0{
    top:0
  }

  .md\\:right-0{
    right:0
  }

  .md\\:bottom-0{
    bottom:0
  }

  .md\\:left-0{
    left:0
  }

  .md\\:top-auto{
    top:auto
  }

  .md\\:right-auto{
    right:auto
  }

  .md\\:bottom-auto{
    bottom:auto
  }

  .md\\:left-auto{
    left:auto
  }

  .md\\:resize-none{
    resize:none
  }

  .md\\:resize-y{
    resize:vertical
  }

  .md\\:resize-x{
    resize:horizontal
  }

  .md\\:resize{
    resize:both
  }

  .md\\:shadow-xs{
    box-shadow:0 0 0 1px #0000000d
  }

  .md\\:shadow-sm{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .md\\:shadow{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .md\\:shadow-md{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .md\\:shadow-lg{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .md\\:shadow-xl{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .md\\:shadow-2xl{
    box-shadow:0 25px 50px -12px #00000040
  }

  .md\\:shadow-inner{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .md\\:shadow-outline{
    box-shadow:0 0 0 3px #4299e180
  }

  .md\\:shadow-none{
    box-shadow:none
  }

  .md\\:shadow-bottom{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .md\\:hover\\:shadow-xs:hover{
    box-shadow:0 0 0 1px #0000000d
  }

  .md\\:hover\\:shadow-sm:hover{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .md\\:hover\\:shadow:hover{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .md\\:hover\\:shadow-md:hover{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .md\\:hover\\:shadow-lg:hover{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .md\\:hover\\:shadow-xl:hover{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .md\\:hover\\:shadow-2xl:hover{
    box-shadow:0 25px 50px -12px #00000040
  }

  .md\\:hover\\:shadow-inner:hover{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .md\\:hover\\:shadow-outline:hover{
    box-shadow:0 0 0 3px #4299e180
  }

  .md\\:hover\\:shadow-none:hover{
    box-shadow:none
  }

  .md\\:hover\\:shadow-bottom:hover{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .md\\:focus\\:shadow-xs:focus{
    box-shadow:0 0 0 1px #0000000d
  }

  .md\\:focus\\:shadow-sm:focus{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .md\\:focus\\:shadow:focus{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .md\\:focus\\:shadow-md:focus{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .md\\:focus\\:shadow-lg:focus{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .md\\:focus\\:shadow-xl:focus{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .md\\:focus\\:shadow-2xl:focus{
    box-shadow:0 25px 50px -12px #00000040
  }

  .md\\:focus\\:shadow-inner:focus{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .md\\:focus\\:shadow-outline:focus{
    box-shadow:0 0 0 3px #4299e180
  }

  .md\\:focus\\:shadow-none:focus{
    box-shadow:none
  }

  .md\\:focus\\:shadow-bottom:focus{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-xs:focus{
    box-shadow:0 0 0 1px #0000000d
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-sm:focus{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .theme-dark .md\\:dark\\:focus\\:shadow:focus{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-md:focus{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-lg:focus{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-xl:focus{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-2xl:focus{
    box-shadow:0 25px 50px -12px #00000040
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-inner:focus{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-outline:focus{
    box-shadow:0 0 0 3px #4299e180
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-none:focus{
    box-shadow:none
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-bottom:focus{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .md\\:fill-current{
    fill:currentColor
  }

  .md\\:stroke-current{
    stroke:currentColor
  }

  .md\\:stroke-0{
    stroke-width:0
  }

  .md\\:stroke-1{
    stroke-width:1
  }

  .md\\:stroke-2{
    stroke-width:2
  }

  .md\\:table-auto{
    table-layout:auto
  }

  .md\\:table-fixed{
    table-layout:fixed
  }

  .md\\:text-left{
    text-align:left
  }

  .md\\:text-center{
    text-align:center
  }

  .md\\:text-right{
    text-align:right
  }

  .md\\:text-justify{
    text-align:justify
  }

  .md\\:text-transparent{
    color:#0000
  }

  .md\\:text-white{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .md\\:text-black{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .md\\:text-gray-50{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .md\\:text-gray-100{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .md\\:text-gray-200{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .md\\:text-gray-300{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .md\\:text-gray-400{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .md\\:text-gray-500{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .md\\:text-gray-600{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .md\\:text-gray-700{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .md\\:text-gray-800{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .md\\:text-gray-900{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .md\\:text-cool-gray-50{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .md\\:text-cool-gray-100{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .md\\:text-cool-gray-200{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .md\\:text-cool-gray-300{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .md\\:text-cool-gray-400{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .md\\:text-cool-gray-500{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .md\\:text-cool-gray-600{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .md\\:text-cool-gray-700{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .md\\:text-cool-gray-800{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .md\\:text-cool-gray-900{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .md\\:text-red-50{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .md\\:text-red-100{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .md\\:text-red-200{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .md\\:text-red-300{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .md\\:text-red-400{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .md\\:text-red-500{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .md\\:text-red-600{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .md\\:text-red-700{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .md\\:text-red-800{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .md\\:text-red-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .md\\:text-orange-50{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .md\\:text-orange-100{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .md\\:text-orange-200{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .md\\:text-orange-300{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .md\\:text-orange-400{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .md\\:text-orange-500{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .md\\:text-orange-600{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .md\\:text-orange-700{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .md\\:text-orange-800{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .md\\:text-orange-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .md\\:text-yellow-50{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .md\\:text-yellow-100{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .md\\:text-yellow-200{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .md\\:text-yellow-300{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .md\\:text-yellow-400{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .md\\:text-yellow-500{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .md\\:text-yellow-600{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .md\\:text-yellow-700{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .md\\:text-yellow-800{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .md\\:text-yellow-900{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .md\\:text-green-50{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .md\\:text-green-100{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .md\\:text-green-200{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .md\\:text-green-300{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .md\\:text-green-400{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .md\\:text-green-500{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .md\\:text-green-600{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .md\\:text-green-700{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .md\\:text-green-800{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .md\\:text-green-900{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .md\\:text-teal-50{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .md\\:text-teal-100{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .md\\:text-teal-200{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .md\\:text-teal-300{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .md\\:text-teal-400{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .md\\:text-teal-500{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .md\\:text-teal-600{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .md\\:text-teal-700{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .md\\:text-teal-800{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .md\\:text-teal-900{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .md\\:text-blue-50{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .md\\:text-blue-100{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .md\\:text-blue-200{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .md\\:text-blue-300{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .md\\:text-blue-400{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .md\\:text-blue-500{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .md\\:text-blue-600{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .md\\:text-blue-700{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .md\\:text-blue-800{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .md\\:text-blue-900{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .md\\:text-indigo-50{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .md\\:text-indigo-100{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .md\\:text-indigo-200{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .md\\:text-indigo-300{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .md\\:text-indigo-400{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .md\\:text-indigo-500{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .md\\:text-indigo-600{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .md\\:text-indigo-700{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .md\\:text-indigo-800{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .md\\:text-indigo-900{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .md\\:text-indigo-50{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .md\\:text-indigo-100{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .md\\:text-indigo-200{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .md\\:text-indigo-300{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .md\\:text-indigo-400{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .md\\:text-indigo-500{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .md\\:text-indigo-600{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .md\\:text-indigo-700{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .md\\:text-indigo-800{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .md\\:text-indigo-900{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .md\\:text-pink-50{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .md\\:text-pink-100{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .md\\:text-pink-200{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .md\\:text-pink-300{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .md\\:text-pink-400{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .md\\:text-pink-500{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .md\\:text-pink-600{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .md\\:text-pink-700{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .md\\:text-pink-800{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .md\\:text-pink-900{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .md\\:focus\\:text-transparent:focus{
    color:#0000
  }

  .md\\:focus\\:text-white:focus{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .md\\:focus\\:text-black:focus{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .md\\:focus\\:text-gray-50:focus{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .md\\:focus\\:text-gray-100:focus{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .md\\:focus\\:text-gray-200:focus{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .md\\:focus\\:text-gray-300:focus{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .md\\:focus\\:text-gray-400:focus{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .md\\:focus\\:text-gray-500:focus{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .md\\:focus\\:text-gray-600:focus{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .md\\:focus\\:text-gray-700:focus{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .md\\:focus\\:text-gray-800:focus{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .md\\:focus\\:text-gray-900:focus{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .md\\:focus\\:text-cool-gray-50:focus{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .md\\:focus\\:text-cool-gray-100:focus{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .md\\:focus\\:text-cool-gray-200:focus{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .md\\:focus\\:text-cool-gray-300:focus{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .md\\:focus\\:text-cool-gray-400:focus{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .md\\:focus\\:text-cool-gray-500:focus{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .md\\:focus\\:text-cool-gray-600:focus{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .md\\:focus\\:text-cool-gray-700:focus{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .md\\:focus\\:text-cool-gray-800:focus{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .md\\:focus\\:text-cool-gray-900:focus{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .md\\:focus\\:text-red-50:focus{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .md\\:focus\\:text-red-100:focus{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .md\\:focus\\:text-red-200:focus{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .md\\:focus\\:text-red-300:focus{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .md\\:focus\\:text-red-400:focus{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .md\\:focus\\:text-red-500:focus{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .md\\:focus\\:text-red-600:focus{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .md\\:focus\\:text-red-700:focus{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .md\\:focus\\:text-red-800:focus{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .md\\:focus\\:text-red-900:focus{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .md\\:focus\\:text-orange-50:focus{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .md\\:focus\\:text-orange-100:focus{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .md\\:focus\\:text-orange-200:focus{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .md\\:focus\\:text-orange-300:focus{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .md\\:focus\\:text-orange-400:focus{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .md\\:focus\\:text-orange-500:focus{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .md\\:focus\\:text-orange-600:focus{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .md\\:focus\\:text-orange-700:focus{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .md\\:focus\\:text-orange-800:focus{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .md\\:focus\\:text-orange-900:focus{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .md\\:focus\\:text-yellow-50:focus{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .md\\:focus\\:text-yellow-100:focus{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .md\\:focus\\:text-yellow-200:focus{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .md\\:focus\\:text-yellow-300:focus{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .md\\:focus\\:text-yellow-400:focus{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .md\\:focus\\:text-yellow-500:focus{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .md\\:focus\\:text-yellow-600:focus{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .md\\:focus\\:text-yellow-700:focus{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .md\\:focus\\:text-yellow-800:focus{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .md\\:focus\\:text-yellow-900:focus{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .md\\:focus\\:text-green-50:focus{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .md\\:focus\\:text-green-100:focus{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .md\\:focus\\:text-green-200:focus{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .md\\:focus\\:text-green-300:focus{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .md\\:focus\\:text-green-400:focus{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .md\\:focus\\:text-green-500:focus{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .md\\:focus\\:text-green-600:focus{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .md\\:focus\\:text-green-700:focus{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .md\\:focus\\:text-green-800:focus{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .md\\:focus\\:text-green-900:focus{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .md\\:focus\\:text-teal-50:focus{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .md\\:focus\\:text-teal-100:focus{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .md\\:focus\\:text-teal-200:focus{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .md\\:focus\\:text-teal-300:focus{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .md\\:focus\\:text-teal-400:focus{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .md\\:focus\\:text-teal-500:focus{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .md\\:focus\\:text-teal-600:focus{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .md\\:focus\\:text-teal-700:focus{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .md\\:focus\\:text-teal-800:focus{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .md\\:focus\\:text-teal-900:focus{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .md\\:focus\\:text-blue-50:focus{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .md\\:focus\\:text-blue-100:focus{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .md\\:focus\\:text-blue-200:focus{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .md\\:focus\\:text-blue-300:focus{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .md\\:focus\\:text-blue-400:focus{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .md\\:focus\\:text-blue-500:focus{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .md\\:focus\\:text-blue-600:focus{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .md\\:focus\\:text-blue-700:focus{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .md\\:focus\\:text-blue-800:focus{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .md\\:focus\\:text-blue-900:focus{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-50:focus{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-100:focus{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-200:focus{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-300:focus{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-400:focus{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-500:focus{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-600:focus{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-700:focus{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-800:focus{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-900:focus{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-50:focus{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-100:focus{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-200:focus{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-300:focus{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-400:focus{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-500:focus{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-600:focus{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-700:focus{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-800:focus{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .md\\:focus\\:text-indigo-900:focus{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .md\\:focus\\:text-pink-50:focus{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .md\\:focus\\:text-pink-100:focus{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .md\\:focus\\:text-pink-200:focus{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .md\\:focus\\:text-pink-300:focus{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .md\\:focus\\:text-pink-400:focus{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .md\\:focus\\:text-pink-500:focus{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .md\\:focus\\:text-pink-600:focus{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .md\\:focus\\:text-pink-700:focus{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .md\\:focus\\:text-pink-800:focus{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .md\\:focus\\:text-pink-900:focus{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .md\\:focus-within\\:text-transparent:focus-within{
    color:#0000
  }

  .md\\:focus-within\\:text-white:focus-within{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .md\\:focus-within\\:text-black:focus-within{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .md\\:focus-within\\:text-gray-50:focus-within{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .md\\:focus-within\\:text-gray-100:focus-within{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .md\\:focus-within\\:text-gray-200:focus-within{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .md\\:focus-within\\:text-gray-300:focus-within{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .md\\:focus-within\\:text-gray-400:focus-within{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .md\\:focus-within\\:text-gray-500:focus-within{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .md\\:focus-within\\:text-gray-600:focus-within{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .md\\:focus-within\\:text-gray-700:focus-within{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .md\\:focus-within\\:text-gray-800:focus-within{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .md\\:focus-within\\:text-gray-900:focus-within{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .md\\:focus-within\\:text-cool-gray-50:focus-within{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .md\\:focus-within\\:text-cool-gray-100:focus-within{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .md\\:focus-within\\:text-cool-gray-200:focus-within{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .md\\:focus-within\\:text-cool-gray-300:focus-within{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .md\\:focus-within\\:text-cool-gray-400:focus-within{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .md\\:focus-within\\:text-cool-gray-500:focus-within{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .md\\:focus-within\\:text-cool-gray-600:focus-within{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .md\\:focus-within\\:text-cool-gray-700:focus-within{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .md\\:focus-within\\:text-cool-gray-800:focus-within{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .md\\:focus-within\\:text-cool-gray-900:focus-within{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .md\\:focus-within\\:text-red-50:focus-within{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .md\\:focus-within\\:text-red-100:focus-within{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .md\\:focus-within\\:text-red-200:focus-within{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .md\\:focus-within\\:text-red-300:focus-within{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .md\\:focus-within\\:text-red-400:focus-within{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .md\\:focus-within\\:text-red-500:focus-within{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .md\\:focus-within\\:text-red-600:focus-within{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .md\\:focus-within\\:text-red-700:focus-within{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .md\\:focus-within\\:text-red-800:focus-within{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .md\\:focus-within\\:text-red-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .md\\:focus-within\\:text-orange-50:focus-within{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .md\\:focus-within\\:text-orange-100:focus-within{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .md\\:focus-within\\:text-orange-200:focus-within{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .md\\:focus-within\\:text-orange-300:focus-within{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .md\\:focus-within\\:text-orange-400:focus-within{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .md\\:focus-within\\:text-orange-500:focus-within{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .md\\:focus-within\\:text-orange-600:focus-within{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .md\\:focus-within\\:text-orange-700:focus-within{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .md\\:focus-within\\:text-orange-800:focus-within{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .md\\:focus-within\\:text-orange-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .md\\:focus-within\\:text-yellow-50:focus-within{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .md\\:focus-within\\:text-yellow-100:focus-within{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .md\\:focus-within\\:text-yellow-200:focus-within{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .md\\:focus-within\\:text-yellow-300:focus-within{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .md\\:focus-within\\:text-yellow-400:focus-within{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .md\\:focus-within\\:text-yellow-500:focus-within{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .md\\:focus-within\\:text-yellow-600:focus-within{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .md\\:focus-within\\:text-yellow-700:focus-within{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .md\\:focus-within\\:text-yellow-800:focus-within{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .md\\:focus-within\\:text-yellow-900:focus-within{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .md\\:focus-within\\:text-green-50:focus-within{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .md\\:focus-within\\:text-green-100:focus-within{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .md\\:focus-within\\:text-green-200:focus-within{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .md\\:focus-within\\:text-green-300:focus-within{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .md\\:focus-within\\:text-green-400:focus-within{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .md\\:focus-within\\:text-green-500:focus-within{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .md\\:focus-within\\:text-green-600:focus-within{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .md\\:focus-within\\:text-green-700:focus-within{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .md\\:focus-within\\:text-green-800:focus-within{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .md\\:focus-within\\:text-green-900:focus-within{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .md\\:focus-within\\:text-teal-50:focus-within{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .md\\:focus-within\\:text-teal-100:focus-within{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .md\\:focus-within\\:text-teal-200:focus-within{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .md\\:focus-within\\:text-teal-300:focus-within{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .md\\:focus-within\\:text-teal-400:focus-within{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .md\\:focus-within\\:text-teal-500:focus-within{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .md\\:focus-within\\:text-teal-600:focus-within{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .md\\:focus-within\\:text-teal-700:focus-within{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .md\\:focus-within\\:text-teal-800:focus-within{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .md\\:focus-within\\:text-teal-900:focus-within{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .md\\:focus-within\\:text-blue-50:focus-within{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .md\\:focus-within\\:text-blue-100:focus-within{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .md\\:focus-within\\:text-blue-200:focus-within{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .md\\:focus-within\\:text-blue-300:focus-within{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .md\\:focus-within\\:text-blue-400:focus-within{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .md\\:focus-within\\:text-blue-500:focus-within{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .md\\:focus-within\\:text-blue-600:focus-within{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .md\\:focus-within\\:text-blue-700:focus-within{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .md\\:focus-within\\:text-blue-800:focus-within{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .md\\:focus-within\\:text-blue-900:focus-within{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .md\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .md\\:focus-within\\:text-pink-50:focus-within{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .md\\:focus-within\\:text-pink-100:focus-within{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .md\\:focus-within\\:text-pink-200:focus-within{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .md\\:focus-within\\:text-pink-300:focus-within{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .md\\:focus-within\\:text-pink-400:focus-within{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .md\\:focus-within\\:text-pink-500:focus-within{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .md\\:focus-within\\:text-pink-600:focus-within{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .md\\:focus-within\\:text-pink-700:focus-within{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .md\\:focus-within\\:text-pink-800:focus-within{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .md\\:focus-within\\:text-pink-900:focus-within{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .md\\:hover\\:text-transparent:hover{
    color:#0000
  }

  .md\\:hover\\:text-white:hover{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .md\\:hover\\:text-black:hover{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .md\\:hover\\:text-gray-50:hover{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .md\\:hover\\:text-gray-100:hover{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .md\\:hover\\:text-gray-200:hover{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .md\\:hover\\:text-gray-300:hover{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .md\\:hover\\:text-gray-400:hover{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .md\\:hover\\:text-gray-500:hover{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .md\\:hover\\:text-gray-600:hover{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .md\\:hover\\:text-gray-700:hover{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .md\\:hover\\:text-gray-800:hover{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .md\\:hover\\:text-gray-900:hover{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .md\\:hover\\:text-cool-gray-50:hover{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .md\\:hover\\:text-cool-gray-100:hover{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .md\\:hover\\:text-cool-gray-200:hover{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .md\\:hover\\:text-cool-gray-300:hover{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .md\\:hover\\:text-cool-gray-400:hover{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .md\\:hover\\:text-cool-gray-500:hover{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .md\\:hover\\:text-cool-gray-600:hover{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .md\\:hover\\:text-cool-gray-700:hover{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .md\\:hover\\:text-cool-gray-800:hover{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .md\\:hover\\:text-cool-gray-900:hover{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .md\\:hover\\:text-red-50:hover{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .md\\:hover\\:text-red-100:hover{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .md\\:hover\\:text-red-200:hover{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .md\\:hover\\:text-red-300:hover{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .md\\:hover\\:text-red-400:hover{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .md\\:hover\\:text-red-500:hover{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .md\\:hover\\:text-red-600:hover{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .md\\:hover\\:text-red-700:hover{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .md\\:hover\\:text-red-800:hover{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .md\\:hover\\:text-red-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .md\\:hover\\:text-orange-50:hover{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .md\\:hover\\:text-orange-100:hover{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .md\\:hover\\:text-orange-200:hover{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .md\\:hover\\:text-orange-300:hover{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .md\\:hover\\:text-orange-400:hover{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .md\\:hover\\:text-orange-500:hover{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .md\\:hover\\:text-orange-600:hover{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .md\\:hover\\:text-orange-700:hover{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .md\\:hover\\:text-orange-800:hover{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .md\\:hover\\:text-orange-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .md\\:hover\\:text-yellow-50:hover{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .md\\:hover\\:text-yellow-100:hover{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .md\\:hover\\:text-yellow-200:hover{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .md\\:hover\\:text-yellow-300:hover{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .md\\:hover\\:text-yellow-400:hover{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .md\\:hover\\:text-yellow-500:hover{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .md\\:hover\\:text-yellow-600:hover{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .md\\:hover\\:text-yellow-700:hover{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .md\\:hover\\:text-yellow-800:hover{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .md\\:hover\\:text-yellow-900:hover{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .md\\:hover\\:text-green-50:hover{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .md\\:hover\\:text-green-100:hover{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .md\\:hover\\:text-green-200:hover{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .md\\:hover\\:text-green-300:hover{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .md\\:hover\\:text-green-400:hover{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .md\\:hover\\:text-green-500:hover{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .md\\:hover\\:text-green-600:hover{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .md\\:hover\\:text-green-700:hover{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .md\\:hover\\:text-green-800:hover{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .md\\:hover\\:text-green-900:hover{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .md\\:hover\\:text-teal-50:hover{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .md\\:hover\\:text-teal-100:hover{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .md\\:hover\\:text-teal-200:hover{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .md\\:hover\\:text-teal-300:hover{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .md\\:hover\\:text-teal-400:hover{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .md\\:hover\\:text-teal-500:hover{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .md\\:hover\\:text-teal-600:hover{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .md\\:hover\\:text-teal-700:hover{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .md\\:hover\\:text-teal-800:hover{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .md\\:hover\\:text-teal-900:hover{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .md\\:hover\\:text-blue-50:hover{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .md\\:hover\\:text-blue-100:hover{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .md\\:hover\\:text-blue-200:hover{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .md\\:hover\\:text-blue-300:hover{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .md\\:hover\\:text-blue-400:hover{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .md\\:hover\\:text-blue-500:hover{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .md\\:hover\\:text-blue-600:hover{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .md\\:hover\\:text-blue-700:hover{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .md\\:hover\\:text-blue-800:hover{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .md\\:hover\\:text-blue-900:hover{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .md\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .md\\:hover\\:text-pink-50:hover{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .md\\:hover\\:text-pink-100:hover{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .md\\:hover\\:text-pink-200:hover{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .md\\:hover\\:text-pink-300:hover{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .md\\:hover\\:text-pink-400:hover{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .md\\:hover\\:text-pink-500:hover{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .md\\:hover\\:text-pink-600:hover{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .md\\:hover\\:text-pink-700:hover{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .md\\:hover\\:text-pink-800:hover{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .md\\:hover\\:text-pink-900:hover{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .md\\:active\\:text-transparent:active{
    color:#0000
  }

  .md\\:active\\:text-white:active{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .md\\:active\\:text-black:active{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .md\\:active\\:text-gray-50:active{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .md\\:active\\:text-gray-100:active{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .md\\:active\\:text-gray-200:active{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .md\\:active\\:text-gray-300:active{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .md\\:active\\:text-gray-400:active{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .md\\:active\\:text-gray-500:active{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .md\\:active\\:text-gray-600:active{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .md\\:active\\:text-gray-700:active{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .md\\:active\\:text-gray-800:active{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .md\\:active\\:text-gray-900:active{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .md\\:active\\:text-cool-gray-50:active{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .md\\:active\\:text-cool-gray-100:active{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .md\\:active\\:text-cool-gray-200:active{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .md\\:active\\:text-cool-gray-300:active{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .md\\:active\\:text-cool-gray-400:active{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .md\\:active\\:text-cool-gray-500:active{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .md\\:active\\:text-cool-gray-600:active{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .md\\:active\\:text-cool-gray-700:active{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .md\\:active\\:text-cool-gray-800:active{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .md\\:active\\:text-cool-gray-900:active{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .md\\:active\\:text-red-50:active{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .md\\:active\\:text-red-100:active{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .md\\:active\\:text-red-200:active{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .md\\:active\\:text-red-300:active{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .md\\:active\\:text-red-400:active{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .md\\:active\\:text-red-500:active{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .md\\:active\\:text-red-600:active{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .md\\:active\\:text-red-700:active{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .md\\:active\\:text-red-800:active{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .md\\:active\\:text-red-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .md\\:active\\:text-orange-50:active{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .md\\:active\\:text-orange-100:active{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .md\\:active\\:text-orange-200:active{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .md\\:active\\:text-orange-300:active{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .md\\:active\\:text-orange-400:active{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .md\\:active\\:text-orange-500:active{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .md\\:active\\:text-orange-600:active{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .md\\:active\\:text-orange-700:active{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .md\\:active\\:text-orange-800:active{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .md\\:active\\:text-orange-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .md\\:active\\:text-yellow-50:active{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .md\\:active\\:text-yellow-100:active{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .md\\:active\\:text-yellow-200:active{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .md\\:active\\:text-yellow-300:active{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .md\\:active\\:text-yellow-400:active{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .md\\:active\\:text-yellow-500:active{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .md\\:active\\:text-yellow-600:active{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .md\\:active\\:text-yellow-700:active{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .md\\:active\\:text-yellow-800:active{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .md\\:active\\:text-yellow-900:active{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .md\\:active\\:text-green-50:active{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .md\\:active\\:text-green-100:active{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .md\\:active\\:text-green-200:active{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .md\\:active\\:text-green-300:active{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .md\\:active\\:text-green-400:active{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .md\\:active\\:text-green-500:active{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .md\\:active\\:text-green-600:active{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .md\\:active\\:text-green-700:active{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .md\\:active\\:text-green-800:active{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .md\\:active\\:text-green-900:active{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .md\\:active\\:text-teal-50:active{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .md\\:active\\:text-teal-100:active{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .md\\:active\\:text-teal-200:active{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .md\\:active\\:text-teal-300:active{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .md\\:active\\:text-teal-400:active{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .md\\:active\\:text-teal-500:active{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .md\\:active\\:text-teal-600:active{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .md\\:active\\:text-teal-700:active{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .md\\:active\\:text-teal-800:active{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .md\\:active\\:text-teal-900:active{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .md\\:active\\:text-blue-50:active{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .md\\:active\\:text-blue-100:active{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .md\\:active\\:text-blue-200:active{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .md\\:active\\:text-blue-300:active{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .md\\:active\\:text-blue-400:active{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .md\\:active\\:text-blue-500:active{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .md\\:active\\:text-blue-600:active{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .md\\:active\\:text-blue-700:active{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .md\\:active\\:text-blue-800:active{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .md\\:active\\:text-blue-900:active{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .md\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .md\\:active\\:text-pink-50:active{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .md\\:active\\:text-pink-100:active{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .md\\:active\\:text-pink-200:active{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .md\\:active\\:text-pink-300:active{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .md\\:active\\:text-pink-400:active{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .md\\:active\\:text-pink-500:active{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .md\\:active\\:text-pink-600:active{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .md\\:active\\:text-pink-700:active{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .md\\:active\\:text-pink-800:active{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .md\\:active\\:text-pink-900:active{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-transparent{
    color:#0000
  }

  .theme-dark .md\\:dark\\:text-white{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-black{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-gray-50{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-gray-100{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-gray-200{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-gray-300{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-gray-400{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-gray-500{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-gray-600{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-gray-700{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-gray-800{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-gray-900{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-cool-gray-50{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-cool-gray-100{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-cool-gray-200{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-cool-gray-300{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-cool-gray-400{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-cool-gray-500{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-cool-gray-600{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-cool-gray-700{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-cool-gray-800{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-cool-gray-900{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-red-50{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-red-100{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-red-200{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-red-300{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-red-400{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-red-500{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-red-600{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-red-700{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-red-800{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-red-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-orange-50{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-orange-100{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-orange-200{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-orange-300{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-orange-400{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-orange-500{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-orange-600{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-orange-700{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-orange-800{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-orange-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-yellow-50{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-yellow-100{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-yellow-200{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-yellow-300{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-yellow-400{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-yellow-500{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-yellow-600{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-yellow-700{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-yellow-800{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-yellow-900{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-green-50{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-green-100{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-green-200{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-green-300{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-green-400{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-green-500{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-green-600{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-green-700{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-green-800{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-green-900{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-teal-50{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-teal-100{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-teal-200{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-teal-300{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-teal-400{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-teal-500{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-teal-600{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-teal-700{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-teal-800{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-teal-900{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-blue-50{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-blue-100{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-blue-200{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-blue-300{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-blue-400{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-blue-500{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-blue-600{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-blue-700{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-blue-800{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-blue-900{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-50{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-100{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-200{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-300{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-400{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-500{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-600{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-700{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-800{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-900{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-50{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-100{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-200{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-300{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-400{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-500{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-600{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-700{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-800{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-indigo-900{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-pink-50{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-pink-100{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-pink-200{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-pink-300{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-pink-400{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-pink-500{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-pink-600{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-pink-700{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-pink-800{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:text-pink-900{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-transparent:focus-within{
    color:#0000
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-white:focus-within{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-black:focus-within{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-gray-50:focus-within{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-gray-100:focus-within{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-gray-200:focus-within{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-gray-300:focus-within{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-gray-400:focus-within{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-gray-500:focus-within{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-gray-600:focus-within{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-gray-700:focus-within{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-gray-800:focus-within{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-gray-900:focus-within{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-50:focus-within{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-100:focus-within{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-200:focus-within{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-300:focus-within{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-400:focus-within{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-500:focus-within{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-600:focus-within{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-700:focus-within{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-800:focus-within{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-900:focus-within{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-red-50:focus-within{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-red-100:focus-within{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-red-200:focus-within{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-red-300:focus-within{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-red-400:focus-within{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-red-500:focus-within{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-red-600:focus-within{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-red-700:focus-within{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-red-800:focus-within{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-red-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-orange-50:focus-within{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-orange-100:focus-within{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-orange-200:focus-within{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-orange-300:focus-within{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-orange-400:focus-within{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-orange-500:focus-within{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-orange-600:focus-within{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-orange-700:focus-within{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-orange-800:focus-within{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-orange-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-yellow-50:focus-within{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-yellow-100:focus-within{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-yellow-200:focus-within{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-yellow-300:focus-within{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-yellow-400:focus-within{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-yellow-500:focus-within{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-yellow-600:focus-within{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-yellow-700:focus-within{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-yellow-800:focus-within{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-yellow-900:focus-within{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-green-50:focus-within{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-green-100:focus-within{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-green-200:focus-within{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-green-300:focus-within{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-green-400:focus-within{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-green-500:focus-within{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-green-600:focus-within{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-green-700:focus-within{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-green-800:focus-within{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-green-900:focus-within{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-teal-50:focus-within{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-teal-100:focus-within{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-teal-200:focus-within{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-teal-300:focus-within{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-teal-400:focus-within{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-teal-500:focus-within{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-teal-600:focus-within{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-teal-700:focus-within{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-teal-800:focus-within{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-teal-900:focus-within{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-blue-50:focus-within{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-blue-100:focus-within{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-blue-200:focus-within{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-blue-300:focus-within{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-blue-400:focus-within{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-blue-500:focus-within{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-blue-600:focus-within{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-blue-700:focus-within{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-blue-800:focus-within{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-blue-900:focus-within{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-pink-50:focus-within{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-pink-100:focus-within{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-pink-200:focus-within{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-pink-300:focus-within{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-pink-400:focus-within{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-pink-500:focus-within{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-pink-600:focus-within{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-pink-700:focus-within{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-pink-800:focus-within{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:focus-within\\:text-pink-900:focus-within{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-transparent:hover{
    color:#0000
  }

  .theme-dark .md\\:dark\\:hover\\:text-white:hover{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-black:hover{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-gray-50:hover{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-gray-100:hover{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-gray-200:hover{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-gray-300:hover{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-gray-400:hover{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-gray-500:hover{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-gray-600:hover{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-gray-700:hover{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-gray-800:hover{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-gray-900:hover{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-cool-gray-50:hover{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-cool-gray-100:hover{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-cool-gray-200:hover{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-cool-gray-300:hover{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-cool-gray-400:hover{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-cool-gray-500:hover{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-cool-gray-600:hover{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-cool-gray-700:hover{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-cool-gray-800:hover{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-cool-gray-900:hover{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-red-50:hover{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-red-100:hover{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-red-200:hover{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-red-300:hover{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-red-400:hover{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-red-500:hover{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-red-600:hover{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-red-700:hover{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-red-800:hover{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-red-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-orange-50:hover{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-orange-100:hover{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-orange-200:hover{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-orange-300:hover{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-orange-400:hover{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-orange-500:hover{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-orange-600:hover{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-orange-700:hover{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-orange-800:hover{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-orange-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-yellow-50:hover{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-yellow-100:hover{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-yellow-200:hover{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-yellow-300:hover{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-yellow-400:hover{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-yellow-500:hover{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-yellow-600:hover{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-yellow-700:hover{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-yellow-800:hover{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-yellow-900:hover{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-green-50:hover{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-green-100:hover{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-green-200:hover{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-green-300:hover{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-green-400:hover{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-green-500:hover{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-green-600:hover{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-green-700:hover{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-green-800:hover{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-green-900:hover{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-teal-50:hover{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-teal-100:hover{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-teal-200:hover{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-teal-300:hover{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-teal-400:hover{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-teal-500:hover{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-teal-600:hover{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-teal-700:hover{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-teal-800:hover{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-teal-900:hover{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-blue-50:hover{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-blue-100:hover{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-blue-200:hover{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-blue-300:hover{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-blue-400:hover{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-blue-500:hover{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-blue-600:hover{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-blue-700:hover{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-blue-800:hover{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-blue-900:hover{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-pink-50:hover{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-pink-100:hover{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-pink-200:hover{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-pink-300:hover{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-pink-400:hover{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-pink-500:hover{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-pink-600:hover{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-pink-700:hover{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-pink-800:hover{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:hover\\:text-pink-900:hover{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-transparent:active{
    color:#0000
  }

  .theme-dark .md\\:dark\\:active\\:text-white:active{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-black:active{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-gray-50:active{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-gray-100:active{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-gray-200:active{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-gray-300:active{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-gray-400:active{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-gray-500:active{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-gray-600:active{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-gray-700:active{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-gray-800:active{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-gray-900:active{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-cool-gray-50:active{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-cool-gray-100:active{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-cool-gray-200:active{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-cool-gray-300:active{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-cool-gray-400:active{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-cool-gray-500:active{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-cool-gray-600:active{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-cool-gray-700:active{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-cool-gray-800:active{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-cool-gray-900:active{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-red-50:active{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-red-100:active{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-red-200:active{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-red-300:active{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-red-400:active{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-red-500:active{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-red-600:active{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-red-700:active{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-red-800:active{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-red-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-orange-50:active{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-orange-100:active{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-orange-200:active{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-orange-300:active{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-orange-400:active{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-orange-500:active{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-orange-600:active{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-orange-700:active{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-orange-800:active{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-orange-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-yellow-50:active{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-yellow-100:active{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-yellow-200:active{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-yellow-300:active{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-yellow-400:active{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-yellow-500:active{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-yellow-600:active{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-yellow-700:active{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-yellow-800:active{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-yellow-900:active{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-green-50:active{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-green-100:active{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-green-200:active{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-green-300:active{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-green-400:active{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-green-500:active{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-green-600:active{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-green-700:active{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-green-800:active{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-green-900:active{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-teal-50:active{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-teal-100:active{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-teal-200:active{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-teal-300:active{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-teal-400:active{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-teal-500:active{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-teal-600:active{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-teal-700:active{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-teal-800:active{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-teal-900:active{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-blue-50:active{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-blue-100:active{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-blue-200:active{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-blue-300:active{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-blue-400:active{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-blue-500:active{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-blue-600:active{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-blue-700:active{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-blue-800:active{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-blue-900:active{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-pink-50:active{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-pink-100:active{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-pink-200:active{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-pink-300:active{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-pink-400:active{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-pink-500:active{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-pink-600:active{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-pink-700:active{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-pink-800:active{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .md\\:dark\\:active\\:text-pink-900:active{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .md\\:text-opacity-0{
    --text-opacity:0
  }

  .md\\:text-opacity-25{
    --text-opacity:0.25
  }

  .md\\:text-opacity-50{
    --text-opacity:0.5
  }

  .md\\:text-opacity-75{
    --text-opacity:0.75
  }

  .md\\:text-opacity-100{
    --text-opacity:1
  }

  .md\\:hover\\:text-opacity-0:hover{
    --text-opacity:0
  }

  .md\\:hover\\:text-opacity-25:hover{
    --text-opacity:0.25
  }

  .md\\:hover\\:text-opacity-50:hover{
    --text-opacity:0.5
  }

  .md\\:hover\\:text-opacity-75:hover{
    --text-opacity:0.75
  }

  .md\\:hover\\:text-opacity-100:hover{
    --text-opacity:1
  }

  .md\\:focus\\:text-opacity-0:focus{
    --text-opacity:0
  }

  .md\\:focus\\:text-opacity-25:focus{
    --text-opacity:0.25
  }

  .md\\:focus\\:text-opacity-50:focus{
    --text-opacity:0.5
  }

  .md\\:focus\\:text-opacity-75:focus{
    --text-opacity:0.75
  }

  .md\\:focus\\:text-opacity-100:focus{
    --text-opacity:1
  }

  .md\\:italic{
    font-style:italic
  }

  .md\\:not-italic{
    font-style:normal
  }

  .md\\:uppercase{
    text-transform:uppercase
  }

  .md\\:lowercase{
    text-transform:lowercase
  }

  .md\\:capitalize{
    text-transform:capitalize
  }

  .md\\:normal-case{
    text-transform:none
  }

  .md\\:underline{
    text-decoration:underline
  }

  .md\\:line-through{
    text-decoration:line-through
  }

  .md\\:no-underline{
    text-decoration:none
  }

  .md\\:hover\\:underline:hover{
    text-decoration:underline
  }

  .md\\:hover\\:line-through:hover{
    text-decoration:line-through
  }

  .md\\:hover\\:no-underline:hover{
    text-decoration:none
  }

  .md\\:focus\\:underline:focus{
    text-decoration:underline
  }

  .md\\:focus\\:line-through:focus{
    text-decoration:line-through
  }

  .md\\:focus\\:no-underline:focus{
    text-decoration:none
  }

  .md\\:antialiased{
    -webkit-font-smoothing:antialiased;
    -moz-osx-font-smoothing:grayscale
  }

  .md\\:subpixel-antialiased{
    -webkit-font-smoothing:auto;
    -moz-osx-font-smoothing:auto
  }

  .md\\:tracking-tighter{
    letter-spacing:-.05em
  }

  .md\\:tracking-tight{
    letter-spacing:-.025em
  }

  .md\\:tracking-normal{
    letter-spacing:0
  }

  .md\\:tracking-wide{
    letter-spacing:.025em
  }

  .md\\:tracking-wider{
    letter-spacing:.05em
  }

  .md\\:tracking-widest{
    letter-spacing:.1em
  }

  .md\\:select-none{
    -webkit-user-select:none;
    user-select:none
  }

  .md\\:select-text{
    -webkit-user-select:text;
    user-select:text
  }

  .md\\:select-all{
    -webkit-user-select:all;
    user-select:all
  }

  .md\\:select-auto{
    -webkit-user-select:auto;
    user-select:auto
  }

  .md\\:align-baseline{
    vertical-align:initial
  }

  .md\\:align-top{
    vertical-align:top
  }

  .md\\:align-middle{
    vertical-align:middle
  }

  .md\\:align-bottom{
    vertical-align:bottom
  }

  .md\\:align-text-top{
    vertical-align:text-top
  }

  .md\\:align-text-bottom{
    vertical-align:text-bottom
  }

  .md\\:visible{
    visibility:visible
  }

  .md\\:invisible{
    visibility:hidden
  }

  .md\\:whitespace-normal{
    white-space:normal
  }

  .md\\:whitespace-no-wrap{
    white-space:nowrap
  }

  .md\\:whitespace-pre{
    white-space:pre
  }

  .md\\:whitespace-pre-line{
    white-space:pre-line
  }

  .md\\:whitespace-pre-wrap{
    white-space:pre-wrap
  }

  .md\\:break-normal{
    overflow-wrap:normal;
    word-break:normal
  }

  .md\\:break-words{
    overflow-wrap:break-word
  }

  .md\\:break-all{
    word-break:break-all
  }

  .md\\:truncate{
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
  }

  .md\\:w-0{
    width:0
  }

  .md\\:w-1{
    width:.25rem
  }

  .md\\:w-2{
    width:.5rem
  }

  .md\\:w-3{
    width:.75rem
  }

  .md\\:w-4{
    width:1rem
  }

  .md\\:w-5{
    width:1.25rem
  }

  .md\\:w-6{
    width:1.5rem
  }

  .md\\:w-8{
    width:2rem
  }

  .md\\:w-10{
    width:2.5rem
  }

  .md\\:w-12{
    width:3rem
  }

  .md\\:w-16{
    width:4rem
  }

  .md\\:w-20{
    width:5rem
  }

  .md\\:w-24{
    width:6rem
  }

  .md\\:w-32{
    width:8rem
  }

  .md\\:w-40{
    width:10rem
  }

  .md\\:w-48{
    width:12rem
  }

  .md\\:w-56{
    width:14rem
  }

  .md\\:w-64{
    width:16rem
  }

  .md\\:w-auto{
    width:auto
  }

  .md\\:w-px{
    width:1px
  }

  .md\\:w-1\\/2{
    width:50%
  }

  .md\\:w-1\\/3{
    width:33.333333%
  }

  .md\\:w-2\\/3{
    width:66.666667%
  }

  .md\\:w-1\\/4{
    width:25%
  }

  .md\\:w-2\\/4{
    width:50%
  }

  .md\\:w-3\\/4{
    width:75%
  }

  .md\\:w-1\\/5{
    width:20%
  }

  .md\\:w-2\\/5{
    width:40%
  }

  .md\\:w-3\\/5{
    width:60%
  }

  .md\\:w-4\\/5{
    width:80%
  }

  .md\\:w-1\\/6{
    width:16.666667%
  }

  .md\\:w-2\\/6{
    width:33.333333%
  }

  .md\\:w-3\\/6{
    width:50%
  }

  .md\\:w-4\\/6{
    width:66.666667%
  }

  .md\\:w-5\\/6{
    width:83.333333%
  }

  .md\\:w-1\\/12{
    width:8.333333%
  }

  .md\\:w-2\\/12{
    width:16.666667%
  }

  .md\\:w-3\\/12{
    width:25%
  }

  .md\\:w-4\\/12{
    width:33.333333%
  }

  .md\\:w-5\\/12{
    width:41.666667%
  }

  .md\\:w-6\\/12{
    width:50%
  }

  .md\\:w-7\\/12{
    width:58.333333%
  }

  .md\\:w-8\\/12{
    width:66.666667%
  }

  .md\\:w-9\\/12{
    width:75%
  }

  .md\\:w-10\\/12{
    width:83.333333%
  }

  .md\\:w-11\\/12{
    width:91.666667%
  }

  .md\\:w-full{
    width:100%
  }

  .md\\:w-screen{
    width:100vw
  }

  .md\\:z-0{
    z-index:0
  }

  .md\\:z-10{
    z-index:10
  }

  .md\\:z-20{
    z-index:20
  }

  .md\\:z-30{
    z-index:30
  }

  .md\\:z-40{
    z-index:40
  }

  .md\\:z-50{
    z-index:50
  }

  .md\\:z-auto{
    z-index:auto
  }

  .md\\:gap-0{
    grid-gap:0;
    gap:0
  }

  .md\\:gap-1{
    grid-gap:.25rem;
    gap:.25rem
  }

  .md\\:gap-2{
    grid-gap:.5rem;
    gap:.5rem
  }

  .md\\:gap-3{
    grid-gap:.75rem;
    gap:.75rem
  }

  .md\\:gap-4{
    grid-gap:1rem;
    gap:1rem
  }

  .md\\:gap-5{
    grid-gap:1.25rem;
    gap:1.25rem
  }

  .md\\:gap-6{
    grid-gap:1.5rem;
    gap:1.5rem
  }

  .md\\:gap-8{
    grid-gap:2rem;
    gap:2rem
  }

  .md\\:gap-10{
    grid-gap:2.5rem;
    gap:2.5rem
  }

  .md\\:gap-12{
    grid-gap:3rem;
    gap:3rem
  }

  .md\\:gap-16{
    grid-gap:4rem;
    gap:4rem
  }

  .md\\:gap-20{
    grid-gap:5rem;
    gap:5rem
  }

  .md\\:gap-24{
    grid-gap:6rem;
    gap:6rem
  }

  .md\\:gap-32{
    grid-gap:8rem;
    gap:8rem
  }

  .md\\:gap-40{
    grid-gap:10rem;
    gap:10rem
  }

  .md\\:gap-48{
    grid-gap:12rem;
    gap:12rem
  }

  .md\\:gap-56{
    grid-gap:14rem;
    gap:14rem
  }

  .md\\:gap-64{
    grid-gap:16rem;
    gap:16rem
  }

  .md\\:gap-px{
    grid-gap:1px;
    gap:1px
  }

  .md\\:col-gap-0{
    grid-column-gap:0;
    column-gap:0
  }

  .md\\:col-gap-1{
    grid-column-gap:.25rem;
    column-gap:.25rem
  }

  .md\\:col-gap-2{
    grid-column-gap:.5rem;
    column-gap:.5rem
  }

  .md\\:col-gap-3{
    grid-column-gap:.75rem;
    column-gap:.75rem
  }

  .md\\:col-gap-4{
    grid-column-gap:1rem;
    column-gap:1rem
  }

  .md\\:col-gap-5{
    grid-column-gap:1.25rem;
    column-gap:1.25rem
  }

  .md\\:col-gap-6{
    grid-column-gap:1.5rem;
    column-gap:1.5rem
  }

  .md\\:col-gap-8{
    grid-column-gap:2rem;
    column-gap:2rem
  }

  .md\\:col-gap-10{
    grid-column-gap:2.5rem;
    column-gap:2.5rem
  }

  .md\\:col-gap-12{
    grid-column-gap:3rem;
    column-gap:3rem
  }

  .md\\:col-gap-16{
    grid-column-gap:4rem;
    column-gap:4rem
  }

  .md\\:col-gap-20{
    grid-column-gap:5rem;
    column-gap:5rem
  }

  .md\\:col-gap-24{
    grid-column-gap:6rem;
    column-gap:6rem
  }

  .md\\:col-gap-32{
    grid-column-gap:8rem;
    column-gap:8rem
  }

  .md\\:col-gap-40{
    grid-column-gap:10rem;
    column-gap:10rem
  }

  .md\\:col-gap-48{
    grid-column-gap:12rem;
    column-gap:12rem
  }

  .md\\:col-gap-56{
    grid-column-gap:14rem;
    column-gap:14rem
  }

  .md\\:col-gap-64{
    grid-column-gap:16rem;
    column-gap:16rem
  }

  .md\\:col-gap-px{
    grid-column-gap:1px;
    column-gap:1px
  }

  .md\\:row-gap-0{
    grid-row-gap:0;
    row-gap:0
  }

  .md\\:row-gap-1{
    grid-row-gap:.25rem;
    row-gap:.25rem
  }

  .md\\:row-gap-2{
    grid-row-gap:.5rem;
    row-gap:.5rem
  }

  .md\\:row-gap-3{
    grid-row-gap:.75rem;
    row-gap:.75rem
  }

  .md\\:row-gap-4{
    grid-row-gap:1rem;
    row-gap:1rem
  }

  .md\\:row-gap-5{
    grid-row-gap:1.25rem;
    row-gap:1.25rem
  }

  .md\\:row-gap-6{
    grid-row-gap:1.5rem;
    row-gap:1.5rem
  }

  .md\\:row-gap-8{
    grid-row-gap:2rem;
    row-gap:2rem
  }

  .md\\:row-gap-10{
    grid-row-gap:2.5rem;
    row-gap:2.5rem
  }

  .md\\:row-gap-12{
    grid-row-gap:3rem;
    row-gap:3rem
  }

  .md\\:row-gap-16{
    grid-row-gap:4rem;
    row-gap:4rem
  }

  .md\\:row-gap-20{
    grid-row-gap:5rem;
    row-gap:5rem
  }

  .md\\:row-gap-24{
    grid-row-gap:6rem;
    row-gap:6rem
  }

  .md\\:row-gap-32{
    grid-row-gap:8rem;
    row-gap:8rem
  }

  .md\\:row-gap-40{
    grid-row-gap:10rem;
    row-gap:10rem
  }

  .md\\:row-gap-48{
    grid-row-gap:12rem;
    row-gap:12rem
  }

  .md\\:row-gap-56{
    grid-row-gap:14rem;
    row-gap:14rem
  }

  .md\\:row-gap-64{
    grid-row-gap:16rem;
    row-gap:16rem
  }

  .md\\:row-gap-px{
    grid-row-gap:1px;
    row-gap:1px
  }

  .md\\:grid-flow-row{
    grid-auto-flow:row
  }

  .md\\:grid-flow-col{
    grid-auto-flow:column
  }

  .md\\:grid-flow-row-dense{
    grid-auto-flow:row dense
  }

  .md\\:grid-flow-col-dense{
    grid-auto-flow:column dense
  }

  .md\\:grid-cols-1{
    grid-template-columns:repeat(1,minmax(0,1fr))
  }

  .md\\:grid-cols-2{
    grid-template-columns:repeat(2,minmax(0,1fr))
  }

  .md\\:grid-cols-3{
    grid-template-columns:repeat(3,minmax(0,1fr))
  }

  .md\\:grid-cols-4{
    grid-template-columns:repeat(4,minmax(0,1fr))
  }

  .md\\:grid-cols-5{
    grid-template-columns:repeat(5,minmax(0,1fr))
  }

  .md\\:grid-cols-6{
    grid-template-columns:repeat(6,minmax(0,1fr))
  }

  .md\\:grid-cols-7{
    grid-template-columns:repeat(7,minmax(0,1fr))
  }

  .md\\:grid-cols-8{
    grid-template-columns:repeat(8,minmax(0,1fr))
  }

  .md\\:grid-cols-9{
    grid-template-columns:repeat(9,minmax(0,1fr))
  }

  .md\\:grid-cols-10{
    grid-template-columns:repeat(10,minmax(0,1fr))
  }

  .md\\:grid-cols-11{
    grid-template-columns:repeat(11,minmax(0,1fr))
  }

  .md\\:grid-cols-12{
    grid-template-columns:repeat(12,minmax(0,1fr))
  }

  .md\\:grid-cols-none{
    grid-template-columns:none
  }

  .md\\:col-auto{
    grid-column:auto
  }

  .md\\:col-span-1{
    grid-column:span 1/span 1
  }

  .md\\:col-span-2{
    grid-column:span 2/span 2
  }

  .md\\:col-span-3{
    grid-column:span 3/span 3
  }

  .md\\:col-span-4{
    grid-column:span 4/span 4
  }

  .md\\:col-span-5{
    grid-column:span 5/span 5
  }

  .md\\:col-span-6{
    grid-column:span 6/span 6
  }

  .md\\:col-span-7{
    grid-column:span 7/span 7
  }

  .md\\:col-span-8{
    grid-column:span 8/span 8
  }

  .md\\:col-span-9{
    grid-column:span 9/span 9
  }

  .md\\:col-span-10{
    grid-column:span 10/span 10
  }

  .md\\:col-span-11{
    grid-column:span 11/span 11
  }

  .md\\:col-span-12{
    grid-column:span 12/span 12
  }

  .md\\:col-start-1{
    grid-column-start:1
  }

  .md\\:col-start-2{
    grid-column-start:2
  }

  .md\\:col-start-3{
    grid-column-start:3
  }

  .md\\:col-start-4{
    grid-column-start:4
  }

  .md\\:col-start-5{
    grid-column-start:5
  }

  .md\\:col-start-6{
    grid-column-start:6
  }

  .md\\:col-start-7{
    grid-column-start:7
  }

  .md\\:col-start-8{
    grid-column-start:8
  }

  .md\\:col-start-9{
    grid-column-start:9
  }

  .md\\:col-start-10{
    grid-column-start:10
  }

  .md\\:col-start-11{
    grid-column-start:11
  }

  .md\\:col-start-12{
    grid-column-start:12
  }

  .md\\:col-start-13{
    grid-column-start:13
  }

  .md\\:col-start-auto{
    grid-column-start:auto
  }

  .md\\:col-end-1{
    grid-column-end:1
  }

  .md\\:col-end-2{
    grid-column-end:2
  }

  .md\\:col-end-3{
    grid-column-end:3
  }

  .md\\:col-end-4{
    grid-column-end:4
  }

  .md\\:col-end-5{
    grid-column-end:5
  }

  .md\\:col-end-6{
    grid-column-end:6
  }

  .md\\:col-end-7{
    grid-column-end:7
  }

  .md\\:col-end-8{
    grid-column-end:8
  }

  .md\\:col-end-9{
    grid-column-end:9
  }

  .md\\:col-end-10{
    grid-column-end:10
  }

  .md\\:col-end-11{
    grid-column-end:11
  }

  .md\\:col-end-12{
    grid-column-end:12
  }

  .md\\:col-end-13{
    grid-column-end:13
  }

  .md\\:col-end-auto{
    grid-column-end:auto
  }

  .md\\:grid-rows-1{
    grid-template-rows:repeat(1,minmax(0,1fr))
  }

  .md\\:grid-rows-2{
    grid-template-rows:repeat(2,minmax(0,1fr))
  }

  .md\\:grid-rows-3{
    grid-template-rows:repeat(3,minmax(0,1fr))
  }

  .md\\:grid-rows-4{
    grid-template-rows:repeat(4,minmax(0,1fr))
  }

  .md\\:grid-rows-5{
    grid-template-rows:repeat(5,minmax(0,1fr))
  }

  .md\\:grid-rows-6{
    grid-template-rows:repeat(6,minmax(0,1fr))
  }

  .md\\:grid-rows-none{
    grid-template-rows:none
  }

  .md\\:row-auto{
    grid-row:auto
  }

  .md\\:row-span-1{
    grid-row:span 1/span 1
  }

  .md\\:row-span-2{
    grid-row:span 2/span 2
  }

  .md\\:row-span-3{
    grid-row:span 3/span 3
  }

  .md\\:row-span-4{
    grid-row:span 4/span 4
  }

  .md\\:row-span-5{
    grid-row:span 5/span 5
  }

  .md\\:row-span-6{
    grid-row:span 6/span 6
  }

  .md\\:row-start-1{
    grid-row-start:1
  }

  .md\\:row-start-2{
    grid-row-start:2
  }

  .md\\:row-start-3{
    grid-row-start:3
  }

  .md\\:row-start-4{
    grid-row-start:4
  }

  .md\\:row-start-5{
    grid-row-start:5
  }

  .md\\:row-start-6{
    grid-row-start:6
  }

  .md\\:row-start-7{
    grid-row-start:7
  }

  .md\\:row-start-auto{
    grid-row-start:auto
  }

  .md\\:row-end-1{
    grid-row-end:1
  }

  .md\\:row-end-2{
    grid-row-end:2
  }

  .md\\:row-end-3{
    grid-row-end:3
  }

  .md\\:row-end-4{
    grid-row-end:4
  }

  .md\\:row-end-5{
    grid-row-end:5
  }

  .md\\:row-end-6{
    grid-row-end:6
  }

  .md\\:row-end-7{
    grid-row-end:7
  }

  .md\\:row-end-auto{
    grid-row-end:auto
  }

  .md\\:transform{
    --transform-translate-x:0;
    --transform-translate-y:0;
    --transform-rotate:0;
    --transform-skew-x:0;
    --transform-skew-y:0;
    --transform-scale-x:1;
    --transform-scale-y:1;
    transform:translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y))
  }

  .md\\:transform-none{
    transform:none
  }

  .md\\:origin-center{
    transform-origin:center
  }

  .md\\:origin-top{
    transform-origin:top
  }

  .md\\:origin-top-right{
    transform-origin:top right
  }

  .md\\:origin-right{
    transform-origin:right
  }

  .md\\:origin-bottom-right{
    transform-origin:bottom right
  }

  .md\\:origin-bottom{
    transform-origin:bottom
  }

  .md\\:origin-bottom-left{
    transform-origin:bottom left
  }

  .md\\:origin-left{
    transform-origin:left
  }

  .md\\:origin-top-left{
    transform-origin:top left
  }

  .md\\:scale-0{
    --transform-scale-x:0;
    --transform-scale-y:0
  }

  .md\\:scale-50{
    --transform-scale-x:.5;
    --transform-scale-y:.5
  }

  .md\\:scale-75{
    --transform-scale-x:.75;
    --transform-scale-y:.75
  }

  .md\\:scale-90{
    --transform-scale-x:.9;
    --transform-scale-y:.9
  }

  .md\\:scale-95{
    --transform-scale-x:.95;
    --transform-scale-y:.95
  }

  .md\\:scale-100{
    --transform-scale-x:1;
    --transform-scale-y:1
  }

  .md\\:scale-105{
    --transform-scale-x:1.05;
    --transform-scale-y:1.05
  }

  .md\\:scale-110{
    --transform-scale-x:1.1;
    --transform-scale-y:1.1
  }

  .md\\:scale-125{
    --transform-scale-x:1.25;
    --transform-scale-y:1.25
  }

  .md\\:scale-150{
    --transform-scale-x:1.5;
    --transform-scale-y:1.5
  }

  .md\\:scale-x-0{
    --transform-scale-x:0
  }

  .md\\:scale-x-50{
    --transform-scale-x:.5
  }

  .md\\:scale-x-75{
    --transform-scale-x:.75
  }

  .md\\:scale-x-90{
    --transform-scale-x:.9
  }

  .md\\:scale-x-95{
    --transform-scale-x:.95
  }

  .md\\:scale-x-100{
    --transform-scale-x:1
  }

  .md\\:scale-x-105{
    --transform-scale-x:1.05
  }

  .md\\:scale-x-110{
    --transform-scale-x:1.1
  }

  .md\\:scale-x-125{
    --transform-scale-x:1.25
  }

  .md\\:scale-x-150{
    --transform-scale-x:1.5
  }

  .md\\:scale-y-0{
    --transform-scale-y:0
  }

  .md\\:scale-y-50{
    --transform-scale-y:.5
  }

  .md\\:scale-y-75{
    --transform-scale-y:.75
  }

  .md\\:scale-y-90{
    --transform-scale-y:.9
  }

  .md\\:scale-y-95{
    --transform-scale-y:.95
  }

  .md\\:scale-y-100{
    --transform-scale-y:1
  }

  .md\\:scale-y-105{
    --transform-scale-y:1.05
  }

  .md\\:scale-y-110{
    --transform-scale-y:1.1
  }

  .md\\:scale-y-125{
    --transform-scale-y:1.25
  }

  .md\\:scale-y-150{
    --transform-scale-y:1.5
  }

  .md\\:hover\\:scale-0:hover{
    --transform-scale-x:0;
    --transform-scale-y:0
  }

  .md\\:hover\\:scale-50:hover{
    --transform-scale-x:.5;
    --transform-scale-y:.5
  }

  .md\\:hover\\:scale-75:hover{
    --transform-scale-x:.75;
    --transform-scale-y:.75
  }

  .md\\:hover\\:scale-90:hover{
    --transform-scale-x:.9;
    --transform-scale-y:.9
  }

  .md\\:hover\\:scale-95:hover{
    --transform-scale-x:.95;
    --transform-scale-y:.95
  }

  .md\\:hover\\:scale-100:hover{
    --transform-scale-x:1;
    --transform-scale-y:1
  }

  .md\\:hover\\:scale-105:hover{
    --transform-scale-x:1.05;
    --transform-scale-y:1.05
  }

  .md\\:hover\\:scale-110:hover{
    --transform-scale-x:1.1;
    --transform-scale-y:1.1
  }

  .md\\:hover\\:scale-125:hover{
    --transform-scale-x:1.25;
    --transform-scale-y:1.25
  }

  .md\\:hover\\:scale-150:hover{
    --transform-scale-x:1.5;
    --transform-scale-y:1.5
  }

  .md\\:hover\\:scale-x-0:hover{
    --transform-scale-x:0
  }

  .md\\:hover\\:scale-x-50:hover{
    --transform-scale-x:.5
  }

  .md\\:hover\\:scale-x-75:hover{
    --transform-scale-x:.75
  }

  .md\\:hover\\:scale-x-90:hover{
    --transform-scale-x:.9
  }

  .md\\:hover\\:scale-x-95:hover{
    --transform-scale-x:.95
  }

  .md\\:hover\\:scale-x-100:hover{
    --transform-scale-x:1
  }

  .md\\:hover\\:scale-x-105:hover{
    --transform-scale-x:1.05
  }

  .md\\:hover\\:scale-x-110:hover{
    --transform-scale-x:1.1
  }

  .md\\:hover\\:scale-x-125:hover{
    --transform-scale-x:1.25
  }

  .md\\:hover\\:scale-x-150:hover{
    --transform-scale-x:1.5
  }

  .md\\:hover\\:scale-y-0:hover{
    --transform-scale-y:0
  }

  .md\\:hover\\:scale-y-50:hover{
    --transform-scale-y:.5
  }

  .md\\:hover\\:scale-y-75:hover{
    --transform-scale-y:.75
  }

  .md\\:hover\\:scale-y-90:hover{
    --transform-scale-y:.9
  }

  .md\\:hover\\:scale-y-95:hover{
    --transform-scale-y:.95
  }

  .md\\:hover\\:scale-y-100:hover{
    --transform-scale-y:1
  }

  .md\\:hover\\:scale-y-105:hover{
    --transform-scale-y:1.05
  }

  .md\\:hover\\:scale-y-110:hover{
    --transform-scale-y:1.1
  }

  .md\\:hover\\:scale-y-125:hover{
    --transform-scale-y:1.25
  }

  .md\\:hover\\:scale-y-150:hover{
    --transform-scale-y:1.5
  }

  .md\\:focus\\:scale-0:focus{
    --transform-scale-x:0;
    --transform-scale-y:0
  }

  .md\\:focus\\:scale-50:focus{
    --transform-scale-x:.5;
    --transform-scale-y:.5
  }

  .md\\:focus\\:scale-75:focus{
    --transform-scale-x:.75;
    --transform-scale-y:.75
  }

  .md\\:focus\\:scale-90:focus{
    --transform-scale-x:.9;
    --transform-scale-y:.9
  }

  .md\\:focus\\:scale-95:focus{
    --transform-scale-x:.95;
    --transform-scale-y:.95
  }

  .md\\:focus\\:scale-100:focus{
    --transform-scale-x:1;
    --transform-scale-y:1
  }

  .md\\:focus\\:scale-105:focus{
    --transform-scale-x:1.05;
    --transform-scale-y:1.05
  }

  .md\\:focus\\:scale-110:focus{
    --transform-scale-x:1.1;
    --transform-scale-y:1.1
  }

  .md\\:focus\\:scale-125:focus{
    --transform-scale-x:1.25;
    --transform-scale-y:1.25
  }

  .md\\:focus\\:scale-150:focus{
    --transform-scale-x:1.5;
    --transform-scale-y:1.5
  }

  .md\\:focus\\:scale-x-0:focus{
    --transform-scale-x:0
  }

  .md\\:focus\\:scale-x-50:focus{
    --transform-scale-x:.5
  }

  .md\\:focus\\:scale-x-75:focus{
    --transform-scale-x:.75
  }

  .md\\:focus\\:scale-x-90:focus{
    --transform-scale-x:.9
  }

  .md\\:focus\\:scale-x-95:focus{
    --transform-scale-x:.95
  }

  .md\\:focus\\:scale-x-100:focus{
    --transform-scale-x:1
  }

  .md\\:focus\\:scale-x-105:focus{
    --transform-scale-x:1.05
  }

  .md\\:focus\\:scale-x-110:focus{
    --transform-scale-x:1.1
  }

  .md\\:focus\\:scale-x-125:focus{
    --transform-scale-x:1.25
  }

  .md\\:focus\\:scale-x-150:focus{
    --transform-scale-x:1.5
  }

  .md\\:focus\\:scale-y-0:focus{
    --transform-scale-y:0
  }

  .md\\:focus\\:scale-y-50:focus{
    --transform-scale-y:.5
  }

  .md\\:focus\\:scale-y-75:focus{
    --transform-scale-y:.75
  }

  .md\\:focus\\:scale-y-90:focus{
    --transform-scale-y:.9
  }

  .md\\:focus\\:scale-y-95:focus{
    --transform-scale-y:.95
  }

  .md\\:focus\\:scale-y-100:focus{
    --transform-scale-y:1
  }

  .md\\:focus\\:scale-y-105:focus{
    --transform-scale-y:1.05
  }

  .md\\:focus\\:scale-y-110:focus{
    --transform-scale-y:1.1
  }

  .md\\:focus\\:scale-y-125:focus{
    --transform-scale-y:1.25
  }

  .md\\:focus\\:scale-y-150:focus{
    --transform-scale-y:1.5
  }

  .md\\:rotate-0{
    --transform-rotate:0
  }

  .md\\:rotate-45{
    --transform-rotate:45deg
  }

  .md\\:rotate-90{
    --transform-rotate:90deg
  }

  .md\\:rotate-180{
    --transform-rotate:180deg
  }

  .md\\:-rotate-180{
    --transform-rotate:-180deg
  }

  .md\\:-rotate-90{
    --transform-rotate:-90deg
  }

  .md\\:-rotate-45{
    --transform-rotate:-45deg
  }

  .md\\:hover\\:rotate-0:hover{
    --transform-rotate:0
  }

  .md\\:hover\\:rotate-45:hover{
    --transform-rotate:45deg
  }

  .md\\:hover\\:rotate-90:hover{
    --transform-rotate:90deg
  }

  .md\\:hover\\:rotate-180:hover{
    --transform-rotate:180deg
  }

  .md\\:hover\\:-rotate-180:hover{
    --transform-rotate:-180deg
  }

  .md\\:hover\\:-rotate-90:hover{
    --transform-rotate:-90deg
  }

  .md\\:hover\\:-rotate-45:hover{
    --transform-rotate:-45deg
  }

  .md\\:focus\\:rotate-0:focus{
    --transform-rotate:0
  }

  .md\\:focus\\:rotate-45:focus{
    --transform-rotate:45deg
  }

  .md\\:focus\\:rotate-90:focus{
    --transform-rotate:90deg
  }

  .md\\:focus\\:rotate-180:focus{
    --transform-rotate:180deg
  }

  .md\\:focus\\:-rotate-180:focus{
    --transform-rotate:-180deg
  }

  .md\\:focus\\:-rotate-90:focus{
    --transform-rotate:-90deg
  }

  .md\\:focus\\:-rotate-45:focus{
    --transform-rotate:-45deg
  }

  .md\\:translate-x-0{
    --transform-translate-x:0
  }

  .md\\:translate-x-1{
    --transform-translate-x:0.25rem
  }

  .md\\:translate-x-2{
    --transform-translate-x:0.5rem
  }

  .md\\:translate-x-3{
    --transform-translate-x:0.75rem
  }

  .md\\:translate-x-4{
    --transform-translate-x:1rem
  }

  .md\\:translate-x-5{
    --transform-translate-x:1.25rem
  }

  .md\\:translate-x-6{
    --transform-translate-x:1.5rem
  }

  .md\\:translate-x-8{
    --transform-translate-x:2rem
  }

  .md\\:translate-x-10{
    --transform-translate-x:2.5rem
  }

  .md\\:translate-x-12{
    --transform-translate-x:3rem
  }

  .md\\:translate-x-16{
    --transform-translate-x:4rem
  }

  .md\\:translate-x-20{
    --transform-translate-x:5rem
  }

  .md\\:translate-x-24{
    --transform-translate-x:6rem
  }

  .md\\:translate-x-32{
    --transform-translate-x:8rem
  }

  .md\\:translate-x-40{
    --transform-translate-x:10rem
  }

  .md\\:translate-x-48{
    --transform-translate-x:12rem
  }

  .md\\:translate-x-56{
    --transform-translate-x:14rem
  }

  .md\\:translate-x-64{
    --transform-translate-x:16rem
  }

  .md\\:translate-x-px{
    --transform-translate-x:1px
  }

  .md\\:-translate-x-1{
    --transform-translate-x:-0.25rem
  }

  .md\\:-translate-x-2{
    --transform-translate-x:-0.5rem
  }

  .md\\:-translate-x-3{
    --transform-translate-x:-0.75rem
  }

  .md\\:-translate-x-4{
    --transform-translate-x:-1rem
  }

  .md\\:-translate-x-5{
    --transform-translate-x:-1.25rem
  }

  .md\\:-translate-x-6{
    --transform-translate-x:-1.5rem
  }

  .md\\:-translate-x-8{
    --transform-translate-x:-2rem
  }

  .md\\:-translate-x-10{
    --transform-translate-x:-2.5rem
  }

  .md\\:-translate-x-12{
    --transform-translate-x:-3rem
  }

  .md\\:-translate-x-16{
    --transform-translate-x:-4rem
  }

  .md\\:-translate-x-20{
    --transform-translate-x:-5rem
  }

  .md\\:-translate-x-24{
    --transform-translate-x:-6rem
  }

  .md\\:-translate-x-32{
    --transform-translate-x:-8rem
  }

  .md\\:-translate-x-40{
    --transform-translate-x:-10rem
  }

  .md\\:-translate-x-48{
    --transform-translate-x:-12rem
  }

  .md\\:-translate-x-56{
    --transform-translate-x:-14rem
  }

  .md\\:-translate-x-64{
    --transform-translate-x:-16rem
  }

  .md\\:-translate-x-px{
    --transform-translate-x:-1px
  }

  .md\\:-translate-x-full{
    --transform-translate-x:-100%
  }

  .md\\:-translate-x-1\\/2{
    --transform-translate-x:-50%
  }

  .md\\:translate-x-1\\/2{
    --transform-translate-x:50%
  }

  .md\\:translate-x-full{
    --transform-translate-x:100%
  }

  .md\\:translate-y-0{
    --transform-translate-y:0
  }

  .md\\:translate-y-1{
    --transform-translate-y:0.25rem
  }

  .md\\:translate-y-2{
    --transform-translate-y:0.5rem
  }

  .md\\:translate-y-3{
    --transform-translate-y:0.75rem
  }

  .md\\:translate-y-4{
    --transform-translate-y:1rem
  }

  .md\\:translate-y-5{
    --transform-translate-y:1.25rem
  }

  .md\\:translate-y-6{
    --transform-translate-y:1.5rem
  }

  .md\\:translate-y-8{
    --transform-translate-y:2rem
  }

  .md\\:translate-y-10{
    --transform-translate-y:2.5rem
  }

  .md\\:translate-y-12{
    --transform-translate-y:3rem
  }

  .md\\:translate-y-16{
    --transform-translate-y:4rem
  }

  .md\\:translate-y-20{
    --transform-translate-y:5rem
  }

  .md\\:translate-y-24{
    --transform-translate-y:6rem
  }

  .md\\:translate-y-32{
    --transform-translate-y:8rem
  }

  .md\\:translate-y-40{
    --transform-translate-y:10rem
  }

  .md\\:translate-y-48{
    --transform-translate-y:12rem
  }

  .md\\:translate-y-56{
    --transform-translate-y:14rem
  }

  .md\\:translate-y-64{
    --transform-translate-y:16rem
  }

  .md\\:translate-y-px{
    --transform-translate-y:1px
  }

  .md\\:-translate-y-1{
    --transform-translate-y:-0.25rem
  }

  .md\\:-translate-y-2{
    --transform-translate-y:-0.5rem
  }

  .md\\:-translate-y-3{
    --transform-translate-y:-0.75rem
  }

  .md\\:-translate-y-4{
    --transform-translate-y:-1rem
  }

  .md\\:-translate-y-5{
    --transform-translate-y:-1.25rem
  }

  .md\\:-translate-y-6{
    --transform-translate-y:-1.5rem
  }

  .md\\:-translate-y-8{
    --transform-translate-y:-2rem
  }

  .md\\:-translate-y-10{
    --transform-translate-y:-2.5rem
  }

  .md\\:-translate-y-12{
    --transform-translate-y:-3rem
  }

  .md\\:-translate-y-16{
    --transform-translate-y:-4rem
  }

  .md\\:-translate-y-20{
    --transform-translate-y:-5rem
  }

  .md\\:-translate-y-24{
    --transform-translate-y:-6rem
  }

  .md\\:-translate-y-32{
    --transform-translate-y:-8rem
  }

  .md\\:-translate-y-40{
    --transform-translate-y:-10rem
  }

  .md\\:-translate-y-48{
    --transform-translate-y:-12rem
  }

  .md\\:-translate-y-56{
    --transform-translate-y:-14rem
  }

  .md\\:-translate-y-64{
    --transform-translate-y:-16rem
  }

  .md\\:-translate-y-px{
    --transform-translate-y:-1px
  }

  .md\\:-translate-y-full{
    --transform-translate-y:-100%
  }

  .md\\:-translate-y-1\\/2{
    --transform-translate-y:-50%
  }

  .md\\:translate-y-1\\/2{
    --transform-translate-y:50%
  }

  .md\\:translate-y-full{
    --transform-translate-y:100%
  }

  .md\\:hover\\:translate-x-0:hover{
    --transform-translate-x:0
  }

  .md\\:hover\\:translate-x-1:hover{
    --transform-translate-x:0.25rem
  }

  .md\\:hover\\:translate-x-2:hover{
    --transform-translate-x:0.5rem
  }

  .md\\:hover\\:translate-x-3:hover{
    --transform-translate-x:0.75rem
  }

  .md\\:hover\\:translate-x-4:hover{
    --transform-translate-x:1rem
  }

  .md\\:hover\\:translate-x-5:hover{
    --transform-translate-x:1.25rem
  }

  .md\\:hover\\:translate-x-6:hover{
    --transform-translate-x:1.5rem
  }

  .md\\:hover\\:translate-x-8:hover{
    --transform-translate-x:2rem
  }

  .md\\:hover\\:translate-x-10:hover{
    --transform-translate-x:2.5rem
  }

  .md\\:hover\\:translate-x-12:hover{
    --transform-translate-x:3rem
  }

  .md\\:hover\\:translate-x-16:hover{
    --transform-translate-x:4rem
  }

  .md\\:hover\\:translate-x-20:hover{
    --transform-translate-x:5rem
  }

  .md\\:hover\\:translate-x-24:hover{
    --transform-translate-x:6rem
  }

  .md\\:hover\\:translate-x-32:hover{
    --transform-translate-x:8rem
  }

  .md\\:hover\\:translate-x-40:hover{
    --transform-translate-x:10rem
  }

  .md\\:hover\\:translate-x-48:hover{
    --transform-translate-x:12rem
  }

  .md\\:hover\\:translate-x-56:hover{
    --transform-translate-x:14rem
  }

  .md\\:hover\\:translate-x-64:hover{
    --transform-translate-x:16rem
  }

  .md\\:hover\\:translate-x-px:hover{
    --transform-translate-x:1px
  }

  .md\\:hover\\:-translate-x-1:hover{
    --transform-translate-x:-0.25rem
  }

  .md\\:hover\\:-translate-x-2:hover{
    --transform-translate-x:-0.5rem
  }

  .md\\:hover\\:-translate-x-3:hover{
    --transform-translate-x:-0.75rem
  }

  .md\\:hover\\:-translate-x-4:hover{
    --transform-translate-x:-1rem
  }

  .md\\:hover\\:-translate-x-5:hover{
    --transform-translate-x:-1.25rem
  }

  .md\\:hover\\:-translate-x-6:hover{
    --transform-translate-x:-1.5rem
  }

  .md\\:hover\\:-translate-x-8:hover{
    --transform-translate-x:-2rem
  }

  .md\\:hover\\:-translate-x-10:hover{
    --transform-translate-x:-2.5rem
  }

  .md\\:hover\\:-translate-x-12:hover{
    --transform-translate-x:-3rem
  }

  .md\\:hover\\:-translate-x-16:hover{
    --transform-translate-x:-4rem
  }

  .md\\:hover\\:-translate-x-20:hover{
    --transform-translate-x:-5rem
  }

  .md\\:hover\\:-translate-x-24:hover{
    --transform-translate-x:-6rem
  }

  .md\\:hover\\:-translate-x-32:hover{
    --transform-translate-x:-8rem
  }

  .md\\:hover\\:-translate-x-40:hover{
    --transform-translate-x:-10rem
  }

  .md\\:hover\\:-translate-x-48:hover{
    --transform-translate-x:-12rem
  }

  .md\\:hover\\:-translate-x-56:hover{
    --transform-translate-x:-14rem
  }

  .md\\:hover\\:-translate-x-64:hover{
    --transform-translate-x:-16rem
  }

  .md\\:hover\\:-translate-x-px:hover{
    --transform-translate-x:-1px
  }

  .md\\:hover\\:-translate-x-full:hover{
    --transform-translate-x:-100%
  }

  .md\\:hover\\:-translate-x-1\\/2:hover{
    --transform-translate-x:-50%
  }

  .md\\:hover\\:translate-x-1\\/2:hover{
    --transform-translate-x:50%
  }

  .md\\:hover\\:translate-x-full:hover{
    --transform-translate-x:100%
  }

  .md\\:hover\\:translate-y-0:hover{
    --transform-translate-y:0
  }

  .md\\:hover\\:translate-y-1:hover{
    --transform-translate-y:0.25rem
  }

  .md\\:hover\\:translate-y-2:hover{
    --transform-translate-y:0.5rem
  }

  .md\\:hover\\:translate-y-3:hover{
    --transform-translate-y:0.75rem
  }

  .md\\:hover\\:translate-y-4:hover{
    --transform-translate-y:1rem
  }

  .md\\:hover\\:translate-y-5:hover{
    --transform-translate-y:1.25rem
  }

  .md\\:hover\\:translate-y-6:hover{
    --transform-translate-y:1.5rem
  }

  .md\\:hover\\:translate-y-8:hover{
    --transform-translate-y:2rem
  }

  .md\\:hover\\:translate-y-10:hover{
    --transform-translate-y:2.5rem
  }

  .md\\:hover\\:translate-y-12:hover{
    --transform-translate-y:3rem
  }

  .md\\:hover\\:translate-y-16:hover{
    --transform-translate-y:4rem
  }

  .md\\:hover\\:translate-y-20:hover{
    --transform-translate-y:5rem
  }

  .md\\:hover\\:translate-y-24:hover{
    --transform-translate-y:6rem
  }

  .md\\:hover\\:translate-y-32:hover{
    --transform-translate-y:8rem
  }

  .md\\:hover\\:translate-y-40:hover{
    --transform-translate-y:10rem
  }

  .md\\:hover\\:translate-y-48:hover{
    --transform-translate-y:12rem
  }

  .md\\:hover\\:translate-y-56:hover{
    --transform-translate-y:14rem
  }

  .md\\:hover\\:translate-y-64:hover{
    --transform-translate-y:16rem
  }

  .md\\:hover\\:translate-y-px:hover{
    --transform-translate-y:1px
  }

  .md\\:hover\\:-translate-y-1:hover{
    --transform-translate-y:-0.25rem
  }

  .md\\:hover\\:-translate-y-2:hover{
    --transform-translate-y:-0.5rem
  }

  .md\\:hover\\:-translate-y-3:hover{
    --transform-translate-y:-0.75rem
  }

  .md\\:hover\\:-translate-y-4:hover{
    --transform-translate-y:-1rem
  }

  .md\\:hover\\:-translate-y-5:hover{
    --transform-translate-y:-1.25rem
  }

  .md\\:hover\\:-translate-y-6:hover{
    --transform-translate-y:-1.5rem
  }

  .md\\:hover\\:-translate-y-8:hover{
    --transform-translate-y:-2rem
  }

  .md\\:hover\\:-translate-y-10:hover{
    --transform-translate-y:-2.5rem
  }

  .md\\:hover\\:-translate-y-12:hover{
    --transform-translate-y:-3rem
  }

  .md\\:hover\\:-translate-y-16:hover{
    --transform-translate-y:-4rem
  }

  .md\\:hover\\:-translate-y-20:hover{
    --transform-translate-y:-5rem
  }

  .md\\:hover\\:-translate-y-24:hover{
    --transform-translate-y:-6rem
  }

  .md\\:hover\\:-translate-y-32:hover{
    --transform-translate-y:-8rem
  }

  .md\\:hover\\:-translate-y-40:hover{
    --transform-translate-y:-10rem
  }

  .md\\:hover\\:-translate-y-48:hover{
    --transform-translate-y:-12rem
  }

  .md\\:hover\\:-translate-y-56:hover{
    --transform-translate-y:-14rem
  }

  .md\\:hover\\:-translate-y-64:hover{
    --transform-translate-y:-16rem
  }

  .md\\:hover\\:-translate-y-px:hover{
    --transform-translate-y:-1px
  }

  .md\\:hover\\:-translate-y-full:hover{
    --transform-translate-y:-100%
  }

  .md\\:hover\\:-translate-y-1\\/2:hover{
    --transform-translate-y:-50%
  }

  .md\\:hover\\:translate-y-1\\/2:hover{
    --transform-translate-y:50%
  }

  .md\\:hover\\:translate-y-full:hover{
    --transform-translate-y:100%
  }

  .md\\:focus\\:translate-x-0:focus{
    --transform-translate-x:0
  }

  .md\\:focus\\:translate-x-1:focus{
    --transform-translate-x:0.25rem
  }

  .md\\:focus\\:translate-x-2:focus{
    --transform-translate-x:0.5rem
  }

  .md\\:focus\\:translate-x-3:focus{
    --transform-translate-x:0.75rem
  }

  .md\\:focus\\:translate-x-4:focus{
    --transform-translate-x:1rem
  }

  .md\\:focus\\:translate-x-5:focus{
    --transform-translate-x:1.25rem
  }

  .md\\:focus\\:translate-x-6:focus{
    --transform-translate-x:1.5rem
  }

  .md\\:focus\\:translate-x-8:focus{
    --transform-translate-x:2rem
  }

  .md\\:focus\\:translate-x-10:focus{
    --transform-translate-x:2.5rem
  }

  .md\\:focus\\:translate-x-12:focus{
    --transform-translate-x:3rem
  }

  .md\\:focus\\:translate-x-16:focus{
    --transform-translate-x:4rem
  }

  .md\\:focus\\:translate-x-20:focus{
    --transform-translate-x:5rem
  }

  .md\\:focus\\:translate-x-24:focus{
    --transform-translate-x:6rem
  }

  .md\\:focus\\:translate-x-32:focus{
    --transform-translate-x:8rem
  }

  .md\\:focus\\:translate-x-40:focus{
    --transform-translate-x:10rem
  }

  .md\\:focus\\:translate-x-48:focus{
    --transform-translate-x:12rem
  }

  .md\\:focus\\:translate-x-56:focus{
    --transform-translate-x:14rem
  }

  .md\\:focus\\:translate-x-64:focus{
    --transform-translate-x:16rem
  }

  .md\\:focus\\:translate-x-px:focus{
    --transform-translate-x:1px
  }

  .md\\:focus\\:-translate-x-1:focus{
    --transform-translate-x:-0.25rem
  }

  .md\\:focus\\:-translate-x-2:focus{
    --transform-translate-x:-0.5rem
  }

  .md\\:focus\\:-translate-x-3:focus{
    --transform-translate-x:-0.75rem
  }

  .md\\:focus\\:-translate-x-4:focus{
    --transform-translate-x:-1rem
  }

  .md\\:focus\\:-translate-x-5:focus{
    --transform-translate-x:-1.25rem
  }

  .md\\:focus\\:-translate-x-6:focus{
    --transform-translate-x:-1.5rem
  }

  .md\\:focus\\:-translate-x-8:focus{
    --transform-translate-x:-2rem
  }

  .md\\:focus\\:-translate-x-10:focus{
    --transform-translate-x:-2.5rem
  }

  .md\\:focus\\:-translate-x-12:focus{
    --transform-translate-x:-3rem
  }

  .md\\:focus\\:-translate-x-16:focus{
    --transform-translate-x:-4rem
  }

  .md\\:focus\\:-translate-x-20:focus{
    --transform-translate-x:-5rem
  }

  .md\\:focus\\:-translate-x-24:focus{
    --transform-translate-x:-6rem
  }

  .md\\:focus\\:-translate-x-32:focus{
    --transform-translate-x:-8rem
  }

  .md\\:focus\\:-translate-x-40:focus{
    --transform-translate-x:-10rem
  }

  .md\\:focus\\:-translate-x-48:focus{
    --transform-translate-x:-12rem
  }

  .md\\:focus\\:-translate-x-56:focus{
    --transform-translate-x:-14rem
  }

  .md\\:focus\\:-translate-x-64:focus{
    --transform-translate-x:-16rem
  }

  .md\\:focus\\:-translate-x-px:focus{
    --transform-translate-x:-1px
  }

  .md\\:focus\\:-translate-x-full:focus{
    --transform-translate-x:-100%
  }

  .md\\:focus\\:-translate-x-1\\/2:focus{
    --transform-translate-x:-50%
  }

  .md\\:focus\\:translate-x-1\\/2:focus{
    --transform-translate-x:50%
  }

  .md\\:focus\\:translate-x-full:focus{
    --transform-translate-x:100%
  }

  .md\\:focus\\:translate-y-0:focus{
    --transform-translate-y:0
  }

  .md\\:focus\\:translate-y-1:focus{
    --transform-translate-y:0.25rem
  }

  .md\\:focus\\:translate-y-2:focus{
    --transform-translate-y:0.5rem
  }

  .md\\:focus\\:translate-y-3:focus{
    --transform-translate-y:0.75rem
  }

  .md\\:focus\\:translate-y-4:focus{
    --transform-translate-y:1rem
  }

  .md\\:focus\\:translate-y-5:focus{
    --transform-translate-y:1.25rem
  }

  .md\\:focus\\:translate-y-6:focus{
    --transform-translate-y:1.5rem
  }

  .md\\:focus\\:translate-y-8:focus{
    --transform-translate-y:2rem
  }

  .md\\:focus\\:translate-y-10:focus{
    --transform-translate-y:2.5rem
  }

  .md\\:focus\\:translate-y-12:focus{
    --transform-translate-y:3rem
  }

  .md\\:focus\\:translate-y-16:focus{
    --transform-translate-y:4rem
  }

  .md\\:focus\\:translate-y-20:focus{
    --transform-translate-y:5rem
  }

  .md\\:focus\\:translate-y-24:focus{
    --transform-translate-y:6rem
  }

  .md\\:focus\\:translate-y-32:focus{
    --transform-translate-y:8rem
  }

  .md\\:focus\\:translate-y-40:focus{
    --transform-translate-y:10rem
  }

  .md\\:focus\\:translate-y-48:focus{
    --transform-translate-y:12rem
  }

  .md\\:focus\\:translate-y-56:focus{
    --transform-translate-y:14rem
  }

  .md\\:focus\\:translate-y-64:focus{
    --transform-translate-y:16rem
  }

  .md\\:focus\\:translate-y-px:focus{
    --transform-translate-y:1px
  }

  .md\\:focus\\:-translate-y-1:focus{
    --transform-translate-y:-0.25rem
  }

  .md\\:focus\\:-translate-y-2:focus{
    --transform-translate-y:-0.5rem
  }

  .md\\:focus\\:-translate-y-3:focus{
    --transform-translate-y:-0.75rem
  }

  .md\\:focus\\:-translate-y-4:focus{
    --transform-translate-y:-1rem
  }

  .md\\:focus\\:-translate-y-5:focus{
    --transform-translate-y:-1.25rem
  }

  .md\\:focus\\:-translate-y-6:focus{
    --transform-translate-y:-1.5rem
  }

  .md\\:focus\\:-translate-y-8:focus{
    --transform-translate-y:-2rem
  }

  .md\\:focus\\:-translate-y-10:focus{
    --transform-translate-y:-2.5rem
  }

  .md\\:focus\\:-translate-y-12:focus{
    --transform-translate-y:-3rem
  }

  .md\\:focus\\:-translate-y-16:focus{
    --transform-translate-y:-4rem
  }

  .md\\:focus\\:-translate-y-20:focus{
    --transform-translate-y:-5rem
  }

  .md\\:focus\\:-translate-y-24:focus{
    --transform-translate-y:-6rem
  }

  .md\\:focus\\:-translate-y-32:focus{
    --transform-translate-y:-8rem
  }

  .md\\:focus\\:-translate-y-40:focus{
    --transform-translate-y:-10rem
  }

  .md\\:focus\\:-translate-y-48:focus{
    --transform-translate-y:-12rem
  }

  .md\\:focus\\:-translate-y-56:focus{
    --transform-translate-y:-14rem
  }

  .md\\:focus\\:-translate-y-64:focus{
    --transform-translate-y:-16rem
  }

  .md\\:focus\\:-translate-y-px:focus{
    --transform-translate-y:-1px
  }

  .md\\:focus\\:-translate-y-full:focus{
    --transform-translate-y:-100%
  }

  .md\\:focus\\:-translate-y-1\\/2:focus{
    --transform-translate-y:-50%
  }

  .md\\:focus\\:translate-y-1\\/2:focus{
    --transform-translate-y:50%
  }

  .md\\:focus\\:translate-y-full:focus{
    --transform-translate-y:100%
  }

  .md\\:skew-x-0{
    --transform-skew-x:0
  }

  .md\\:skew-x-3{
    --transform-skew-x:3deg
  }

  .md\\:skew-x-6{
    --transform-skew-x:6deg
  }

  .md\\:skew-x-12{
    --transform-skew-x:12deg
  }

  .md\\:-skew-x-12{
    --transform-skew-x:-12deg
  }

  .md\\:-skew-x-6{
    --transform-skew-x:-6deg
  }

  .md\\:-skew-x-3{
    --transform-skew-x:-3deg
  }

  .md\\:skew-y-0{
    --transform-skew-y:0
  }

  .md\\:skew-y-3{
    --transform-skew-y:3deg
  }

  .md\\:skew-y-6{
    --transform-skew-y:6deg
  }

  .md\\:skew-y-12{
    --transform-skew-y:12deg
  }

  .md\\:-skew-y-12{
    --transform-skew-y:-12deg
  }

  .md\\:-skew-y-6{
    --transform-skew-y:-6deg
  }

  .md\\:-skew-y-3{
    --transform-skew-y:-3deg
  }

  .md\\:hover\\:skew-x-0:hover{
    --transform-skew-x:0
  }

  .md\\:hover\\:skew-x-3:hover{
    --transform-skew-x:3deg
  }

  .md\\:hover\\:skew-x-6:hover{
    --transform-skew-x:6deg
  }

  .md\\:hover\\:skew-x-12:hover{
    --transform-skew-x:12deg
  }

  .md\\:hover\\:-skew-x-12:hover{
    --transform-skew-x:-12deg
  }

  .md\\:hover\\:-skew-x-6:hover{
    --transform-skew-x:-6deg
  }

  .md\\:hover\\:-skew-x-3:hover{
    --transform-skew-x:-3deg
  }

  .md\\:hover\\:skew-y-0:hover{
    --transform-skew-y:0
  }

  .md\\:hover\\:skew-y-3:hover{
    --transform-skew-y:3deg
  }

  .md\\:hover\\:skew-y-6:hover{
    --transform-skew-y:6deg
  }

  .md\\:hover\\:skew-y-12:hover{
    --transform-skew-y:12deg
  }

  .md\\:hover\\:-skew-y-12:hover{
    --transform-skew-y:-12deg
  }

  .md\\:hover\\:-skew-y-6:hover{
    --transform-skew-y:-6deg
  }

  .md\\:hover\\:-skew-y-3:hover{
    --transform-skew-y:-3deg
  }

  .md\\:focus\\:skew-x-0:focus{
    --transform-skew-x:0
  }

  .md\\:focus\\:skew-x-3:focus{
    --transform-skew-x:3deg
  }

  .md\\:focus\\:skew-x-6:focus{
    --transform-skew-x:6deg
  }

  .md\\:focus\\:skew-x-12:focus{
    --transform-skew-x:12deg
  }

  .md\\:focus\\:-skew-x-12:focus{
    --transform-skew-x:-12deg
  }

  .md\\:focus\\:-skew-x-6:focus{
    --transform-skew-x:-6deg
  }

  .md\\:focus\\:-skew-x-3:focus{
    --transform-skew-x:-3deg
  }

  .md\\:focus\\:skew-y-0:focus{
    --transform-skew-y:0
  }

  .md\\:focus\\:skew-y-3:focus{
    --transform-skew-y:3deg
  }

  .md\\:focus\\:skew-y-6:focus{
    --transform-skew-y:6deg
  }

  .md\\:focus\\:skew-y-12:focus{
    --transform-skew-y:12deg
  }

  .md\\:focus\\:-skew-y-12:focus{
    --transform-skew-y:-12deg
  }

  .md\\:focus\\:-skew-y-6:focus{
    --transform-skew-y:-6deg
  }

  .md\\:focus\\:-skew-y-3:focus{
    --transform-skew-y:-3deg
  }

  .md\\:transition-none{
    transition-property:none
  }

  .md\\:transition-all{
    transition-property:all
  }

  .md\\:transition{
    transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform
  }

  .md\\:transition-colors{
    transition-property:background-color,border-color,color,fill,stroke
  }

  .md\\:transition-opacity{
    transition-property:opacity
  }

  .md\\:transition-shadow{
    transition-property:box-shadow
  }

  .md\\:transition-transform{
    transition-property:transform
  }

  .md\\:ease-linear{
    transition-timing-function:linear
  }

  .md\\:ease-in{
    transition-timing-function:cubic-bezier(.4,0,1,1)
  }

  .md\\:ease-out{
    transition-timing-function:cubic-bezier(0,0,.2,1)
  }

  .md\\:ease-in-out{
    transition-timing-function:cubic-bezier(.4,0,.2,1)
  }

  .md\\:duration-75{
    transition-duration:75ms
  }

  .md\\:duration-100{
    transition-duration:.1s
  }

  .md\\:duration-150{
    transition-duration:.15s
  }

  .md\\:duration-200{
    transition-duration:.2s
  }

  .md\\:duration-300{
    transition-duration:.3s
  }

  .md\\:duration-500{
    transition-duration:.5s
  }

  .md\\:duration-700{
    transition-duration:.7s
  }

  .md\\:duration-1000{
    transition-duration:1s
  }

  .md\\:delay-75{
    transition-delay:75ms
  }

  .md\\:delay-100{
    transition-delay:.1s
  }

  .md\\:delay-150{
    transition-delay:.15s
  }

  .md\\:delay-200{
    transition-delay:.2s
  }

  .md\\:delay-300{
    transition-delay:.3s
  }

  .md\\:delay-500{
    transition-delay:.5s
  }

  .md\\:delay-700{
    transition-delay:.7s
  }

  .md\\:delay-1000{
    transition-delay:1s
  }

  .md\\:shadow-outline-white{
    box-shadow:0 0 0 3px #ffffff73
  }

  .md\\:shadow-outline-black{
    box-shadow:0 0 0 3px #00000073
  }

  .md\\:shadow-outline-gray{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .md\\:shadow-outline-cool-gray{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .md\\:shadow-outline-red{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .md\\:shadow-outline-orange{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .md\\:shadow-outline-yellow{
    box-shadow:0 0 0 3px #faca1573
  }

  .md\\:shadow-outline-green{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .md\\:shadow-outline-teal{
    box-shadow:0 0 0 3px #7edce273
  }

  .md\\:shadow-outline-blue{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .md\\:shadow-outline-indigo{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .md\\:shadow-outline-indigo{
    box-shadow:0 0 0 3px #cabffd73
  }

  .md\\:shadow-outline-pink{
    box-shadow:0 0 0 3px #f8b4d973
  }

  .md\\:hover\\:shadow-outline-white:hover{
    box-shadow:0 0 0 3px #ffffff73
  }

  .md\\:hover\\:shadow-outline-black:hover{
    box-shadow:0 0 0 3px #00000073
  }

  .md\\:hover\\:shadow-outline-gray:hover{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .md\\:hover\\:shadow-outline-cool-gray:hover{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .md\\:hover\\:shadow-outline-red:hover{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .md\\:hover\\:shadow-outline-orange:hover{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .md\\:hover\\:shadow-outline-yellow:hover{
    box-shadow:0 0 0 3px #faca1573
  }

  .md\\:hover\\:shadow-outline-green:hover{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .md\\:hover\\:shadow-outline-teal:hover{
    box-shadow:0 0 0 3px #7edce273
  }

  .md\\:hover\\:shadow-outline-blue:hover{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .md\\:hover\\:shadow-outline-indigo:hover{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .md\\:hover\\:shadow-outline-indigo:hover{
    box-shadow:0 0 0 3px #cabffd73
  }

  .md\\:hover\\:shadow-outline-pink:hover{
    box-shadow:0 0 0 3px #f8b4d973
  }

  .md\\:focus\\:shadow-outline-white:focus{
    box-shadow:0 0 0 3px #ffffff73
  }

  .md\\:focus\\:shadow-outline-black:focus{
    box-shadow:0 0 0 3px #00000073
  }

  .md\\:focus\\:shadow-outline-gray:focus{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .md\\:focus\\:shadow-outline-cool-gray:focus{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .md\\:focus\\:shadow-outline-red:focus{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .md\\:focus\\:shadow-outline-orange:focus{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .md\\:focus\\:shadow-outline-yellow:focus{
    box-shadow:0 0 0 3px #faca1573
  }

  .md\\:focus\\:shadow-outline-green:focus{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .md\\:focus\\:shadow-outline-teal:focus{
    box-shadow:0 0 0 3px #7edce273
  }

  .md\\:focus\\:shadow-outline-blue:focus{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .md\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .md\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #cabffd73
  }

  .md\\:focus\\:shadow-outline-pink:focus{
    box-shadow:0 0 0 3px #f8b4d973
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-outline-white:focus{
    box-shadow:0 0 0 3px #ffffff73
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-outline-black:focus{
    box-shadow:0 0 0 3px #00000073
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-outline-gray:focus{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-outline-cool-gray:focus{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-outline-red:focus{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-outline-orange:focus{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-outline-yellow:focus{
    box-shadow:0 0 0 3px #faca1573
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-outline-green:focus{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-outline-teal:focus{
    box-shadow:0 0 0 3px #7edce273
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-outline-blue:focus{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #cabffd73
  }

  .theme-dark .md\\:dark\\:focus\\:shadow-outline-pink:focus{
    box-shadow:0 0 0 3px #f8b4d973
  }
}

@media (min-width:1024px){
  .lg\\:space-y-0>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(0px*var(--space-y-reverse));
    margin-top:calc(0px*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-0>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(0px*(1 - var(--space-x-reverse)));
    margin-right:calc(0px*var(--space-x-reverse))
  }

  .lg\\:space-y-1>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(.25rem*var(--space-y-reverse));
    margin-top:calc(.25rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-1>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(.25rem*var(--space-x-reverse))
  }

  .lg\\:space-y-2>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(.5rem*var(--space-y-reverse));
    margin-top:calc(.5rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-2>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(.5rem*var(--space-x-reverse))
  }

  .lg\\:space-y-3>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(.75rem*var(--space-y-reverse));
    margin-top:calc(.75rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-3>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(.75rem*(1 - var(--space-x-reverse)));
    margin-right:calc(.75rem*var(--space-x-reverse))
  }

  .lg\\:space-y-4>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1rem*var(--space-y-reverse));
    margin-top:calc(1rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-4>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1rem*(1 - var(--space-x-reverse)));
    margin-right:calc(1rem*var(--space-x-reverse))
  }

  .lg\\:space-y-5>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1.25rem*var(--space-y-reverse));
    margin-top:calc(1.25rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-5>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(1.25rem*var(--space-x-reverse))
  }

  .lg\\:space-y-6>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1.5rem*var(--space-y-reverse));
    margin-top:calc(1.5rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-6>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(1.5rem*var(--space-x-reverse))
  }

  .lg\\:space-y-8>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(2rem*var(--space-y-reverse));
    margin-top:calc(2rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-8>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(2rem*(1 - var(--space-x-reverse)));
    margin-right:calc(2rem*var(--space-x-reverse))
  }

  .lg\\:space-y-10>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(2.5rem*var(--space-y-reverse));
    margin-top:calc(2.5rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-10>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(2.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(2.5rem*var(--space-x-reverse))
  }

  .lg\\:space-y-12>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(3rem*var(--space-y-reverse));
    margin-top:calc(3rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-12>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(3rem*(1 - var(--space-x-reverse)));
    margin-right:calc(3rem*var(--space-x-reverse))
  }

  .lg\\:space-y-16>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(4rem*var(--space-y-reverse));
    margin-top:calc(4rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-16>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(4rem*(1 - var(--space-x-reverse)));
    margin-right:calc(4rem*var(--space-x-reverse))
  }

  .lg\\:space-y-20>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(5rem*var(--space-y-reverse));
    margin-top:calc(5rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-20>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(5rem*var(--space-x-reverse))
  }

  .lg\\:space-y-24>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(6rem*var(--space-y-reverse));
    margin-top:calc(6rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-24>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(6rem*(1 - var(--space-x-reverse)));
    margin-right:calc(6rem*var(--space-x-reverse))
  }

  .lg\\:space-y-32>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(8rem*var(--space-y-reverse));
    margin-top:calc(8rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-32>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(8rem*(1 - var(--space-x-reverse)));
    margin-right:calc(8rem*var(--space-x-reverse))
  }

  .lg\\:space-y-40>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(10rem*var(--space-y-reverse));
    margin-top:calc(10rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-40>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(10rem*(1 - var(--space-x-reverse)));
    margin-right:calc(10rem*var(--space-x-reverse))
  }

  .lg\\:space-y-48>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(12rem*var(--space-y-reverse));
    margin-top:calc(12rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-48>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(12rem*(1 - var(--space-x-reverse)));
    margin-right:calc(12rem*var(--space-x-reverse))
  }

  .lg\\:space-y-56>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(14rem*var(--space-y-reverse));
    margin-top:calc(14rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-56>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(14rem*(1 - var(--space-x-reverse)));
    margin-right:calc(14rem*var(--space-x-reverse))
  }

  .lg\\:space-y-64>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(16rem*var(--space-y-reverse));
    margin-top:calc(16rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-64>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(16rem*(1 - var(--space-x-reverse)));
    margin-right:calc(16rem*var(--space-x-reverse))
  }

  .lg\\:space-y-px>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1px*var(--space-y-reverse));
    margin-top:calc(1px*(1 - var(--space-y-reverse)))
  }

  .lg\\:space-x-px>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1px*(1 - var(--space-x-reverse)));
    margin-right:calc(1px*var(--space-x-reverse))
  }

  .lg\\:-space-y-1>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-.25rem*var(--space-y-reverse));
    margin-top:calc(-.25rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-1>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-.25rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-2>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-.5rem*var(--space-y-reverse));
    margin-top:calc(-.5rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-2>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-.5rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-3>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-.75rem*var(--space-y-reverse));
    margin-top:calc(-.75rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-3>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-.75rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-.75rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-4>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1rem*var(--space-y-reverse));
    margin-top:calc(-1rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-4>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-1rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-5>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1.25rem*var(--space-y-reverse));
    margin-top:calc(-1.25rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-5>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-1.25rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-6>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1.5rem*var(--space-y-reverse));
    margin-top:calc(-1.5rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-6>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-1.5rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-8>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-2rem*var(--space-y-reverse));
    margin-top:calc(-2rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-8>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-2rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-2rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-10>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-2.5rem*var(--space-y-reverse));
    margin-top:calc(-2.5rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-10>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-2.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-2.5rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-12>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-3rem*var(--space-y-reverse));
    margin-top:calc(-3rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-12>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-3rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-3rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-16>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-4rem*var(--space-y-reverse));
    margin-top:calc(-4rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-16>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-4rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-4rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-20>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-5rem*var(--space-y-reverse));
    margin-top:calc(-5rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-20>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-5rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-24>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-6rem*var(--space-y-reverse));
    margin-top:calc(-6rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-24>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-6rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-6rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-32>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-8rem*var(--space-y-reverse));
    margin-top:calc(-8rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-32>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-8rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-8rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-40>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-10rem*var(--space-y-reverse));
    margin-top:calc(-10rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-40>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-10rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-10rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-48>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-12rem*var(--space-y-reverse));
    margin-top:calc(-12rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-48>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-12rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-12rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-56>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-14rem*var(--space-y-reverse));
    margin-top:calc(-14rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-56>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-14rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-14rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-64>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-16rem*var(--space-y-reverse));
    margin-top:calc(-16rem*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-64>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-16rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-16rem*var(--space-x-reverse))
  }

  .lg\\:-space-y-px>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1px*var(--space-y-reverse));
    margin-top:calc(-1px*(1 - var(--space-y-reverse)))
  }

  .lg\\:-space-x-px>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1px*(1 - var(--space-x-reverse)));
    margin-right:calc(-1px*var(--space-x-reverse))
  }

  .lg\\:space-y-reverse>:not(template)~:not(template){
    --space-y-reverse:1
  }

  .lg\\:space-x-reverse>:not(template)~:not(template){
    --space-x-reverse:1
  }

  .lg\\:divide-y-0>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(0px*var(--divide-y-reverse));
    border-top-width:calc(0px*(1 - var(--divide-y-reverse)))
  }

  .lg\\:divide-x-0>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(0px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(0px*var(--divide-x-reverse))
  }

  .lg\\:divide-y-2>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(2px*var(--divide-y-reverse));
    border-top-width:calc(2px*(1 - var(--divide-y-reverse)))
  }

  .lg\\:divide-x-2>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(2px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(2px*var(--divide-x-reverse))
  }

  .lg\\:divide-y-4>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(4px*var(--divide-y-reverse));
    border-top-width:calc(4px*(1 - var(--divide-y-reverse)))
  }

  .lg\\:divide-x-4>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(4px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(4px*var(--divide-x-reverse))
  }

  .lg\\:divide-y-8>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(8px*var(--divide-y-reverse));
    border-top-width:calc(8px*(1 - var(--divide-y-reverse)))
  }

  .lg\\:divide-x-8>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(8px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(8px*var(--divide-x-reverse))
  }

  .lg\\:divide-y>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(1px*var(--divide-y-reverse));
    border-top-width:calc(1px*(1 - var(--divide-y-reverse)))
  }

  .lg\\:divide-x>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(1px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(1px*var(--divide-x-reverse))
  }

  .lg\\:divide-y-reverse>:not(template)~:not(template){
    --divide-y-reverse:1
  }

  .lg\\:divide-x-reverse>:not(template)~:not(template){
    --divide-x-reverse:1
  }

  .lg\\:divide-transparent>:not(template)~:not(template){
    border-color:#0000
  }

  .lg\\:divide-white>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--divide-opacity))
  }

  .lg\\:divide-black>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--divide-opacity))
  }

  .lg\\:divide-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--divide-opacity))
  }

  .lg\\:divide-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--divide-opacity))
  }

  .lg\\:divide-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--divide-opacity))
  }

  .lg\\:divide-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--divide-opacity))
  }

  .lg\\:divide-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--divide-opacity))
  }

  .lg\\:divide-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--divide-opacity))
  }

  .lg\\:divide-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--divide-opacity))
  }

  .lg\\:divide-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--divide-opacity))
  }

  .lg\\:divide-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--divide-opacity))
  }

  .lg\\:divide-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--divide-opacity))
  }

  .lg\\:divide-cool-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--divide-opacity))
  }

  .lg\\:divide-cool-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--divide-opacity))
  }

  .lg\\:divide-cool-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--divide-opacity))
  }

  .lg\\:divide-cool-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--divide-opacity))
  }

  .lg\\:divide-cool-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--divide-opacity))
  }

  .lg\\:divide-cool-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--divide-opacity))
  }

  .lg\\:divide-cool-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--divide-opacity))
  }

  .lg\\:divide-cool-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--divide-opacity))
  }

  .lg\\:divide-cool-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--divide-opacity))
  }

  .lg\\:divide-cool-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--divide-opacity))
  }

  .lg\\:divide-red-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--divide-opacity))
  }

  .lg\\:divide-red-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--divide-opacity))
  }

  .lg\\:divide-red-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--divide-opacity))
  }

  .lg\\:divide-red-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--divide-opacity))
  }

  .lg\\:divide-red-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--divide-opacity))
  }

  .lg\\:divide-red-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--divide-opacity))
  }

  .lg\\:divide-red-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--divide-opacity))
  }

  .lg\\:divide-red-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--divide-opacity))
  }

  .lg\\:divide-red-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--divide-opacity))
  }

  .lg\\:divide-red-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .lg\\:divide-orange-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--divide-opacity))
  }

  .lg\\:divide-orange-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--divide-opacity))
  }

  .lg\\:divide-orange-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--divide-opacity))
  }

  .lg\\:divide-orange-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--divide-opacity))
  }

  .lg\\:divide-orange-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--divide-opacity))
  }

  .lg\\:divide-orange-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--divide-opacity))
  }

  .lg\\:divide-orange-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--divide-opacity))
  }

  .lg\\:divide-orange-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--divide-opacity))
  }

  .lg\\:divide-orange-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--divide-opacity))
  }

  .lg\\:divide-orange-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .lg\\:divide-yellow-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--divide-opacity))
  }

  .lg\\:divide-yellow-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--divide-opacity))
  }

  .lg\\:divide-yellow-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--divide-opacity))
  }

  .lg\\:divide-yellow-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--divide-opacity))
  }

  .lg\\:divide-yellow-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--divide-opacity))
  }

  .lg\\:divide-yellow-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--divide-opacity))
  }

  .lg\\:divide-yellow-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--divide-opacity))
  }

  .lg\\:divide-yellow-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--divide-opacity))
  }

  .lg\\:divide-yellow-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--divide-opacity))
  }

  .lg\\:divide-yellow-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--divide-opacity))
  }

  .lg\\:divide-green-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--divide-opacity))
  }

  .lg\\:divide-green-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--divide-opacity))
  }

  .lg\\:divide-green-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--divide-opacity))
  }

  .lg\\:divide-green-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--divide-opacity))
  }

  .lg\\:divide-green-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--divide-opacity))
  }

  .lg\\:divide-green-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--divide-opacity))
  }

  .lg\\:divide-green-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--divide-opacity))
  }

  .lg\\:divide-green-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--divide-opacity))
  }

  .lg\\:divide-green-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--divide-opacity))
  }

  .lg\\:divide-green-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--divide-opacity))
  }

  .lg\\:divide-teal-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--divide-opacity))
  }

  .lg\\:divide-teal-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--divide-opacity))
  }

  .lg\\:divide-teal-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--divide-opacity))
  }

  .lg\\:divide-teal-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--divide-opacity))
  }

  .lg\\:divide-teal-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--divide-opacity))
  }

  .lg\\:divide-teal-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--divide-opacity))
  }

  .lg\\:divide-teal-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--divide-opacity))
  }

  .lg\\:divide-teal-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--divide-opacity))
  }

  .lg\\:divide-teal-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--divide-opacity))
  }

  .lg\\:divide-teal-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--divide-opacity))
  }

  .lg\\:divide-blue-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--divide-opacity))
  }

  .lg\\:divide-blue-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--divide-opacity))
  }

  .lg\\:divide-blue-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--divide-opacity))
  }

  .lg\\:divide-blue-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--divide-opacity))
  }

  .lg\\:divide-blue-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--divide-opacity))
  }

  .lg\\:divide-blue-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--divide-opacity))
  }

  .lg\\:divide-blue-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--divide-opacity))
  }

  .lg\\:divide-blue-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--divide-opacity))
  }

  .lg\\:divide-blue-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--divide-opacity))
  }

  .lg\\:divide-blue-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--divide-opacity))
  }

  .lg\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--divide-opacity))
  }

  .lg\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--divide-opacity))
  }

  .lg\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--divide-opacity))
  }

  .lg\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--divide-opacity))
  }

  .lg\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--divide-opacity))
  }

  .lg\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--divide-opacity))
  }

  .lg\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--divide-opacity))
  }

  .lg\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--divide-opacity))
  }

  .lg\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--divide-opacity))
  }

  .lg\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--divide-opacity))
  }

  .lg\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--divide-opacity))
  }

  .lg\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--divide-opacity))
  }

  .lg\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--divide-opacity))
  }

  .lg\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--divide-opacity))
  }

  .lg\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--divide-opacity))
  }

  .lg\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--divide-opacity))
  }

  .lg\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--divide-opacity))
  }

  .lg\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--divide-opacity))
  }

  .lg\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--divide-opacity))
  }

  .lg\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--divide-opacity))
  }

  .lg\\:divide-pink-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--divide-opacity))
  }

  .lg\\:divide-pink-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--divide-opacity))
  }

  .lg\\:divide-pink-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--divide-opacity))
  }

  .lg\\:divide-pink-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--divide-opacity))
  }

  .lg\\:divide-pink-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--divide-opacity))
  }

  .lg\\:divide-pink-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--divide-opacity))
  }

  .lg\\:divide-pink-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--divide-opacity))
  }

  .lg\\:divide-pink-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--divide-opacity))
  }

  .lg\\:divide-pink-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--divide-opacity))
  }

  .lg\\:divide-pink-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-transparent>:not(template)~:not(template){
    border-color:#0000
  }

  .theme-dark .lg\\:dark\\:divide-white>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-black>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-cool-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-cool-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-cool-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-cool-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-cool-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-cool-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-cool-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-cool-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-cool-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-cool-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-red-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-red-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-red-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-red-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-red-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-red-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-red-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-red-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-red-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-red-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-orange-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-orange-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-orange-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-orange-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-orange-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-orange-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-orange-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-orange-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-orange-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-orange-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-yellow-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-yellow-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-yellow-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-yellow-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-yellow-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-yellow-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-yellow-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-yellow-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-yellow-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-yellow-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-green-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-green-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-green-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-green-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-green-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-green-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-green-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-green-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-green-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-green-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-teal-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-teal-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-teal-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-teal-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-teal-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-teal-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-teal-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-teal-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-teal-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-teal-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-blue-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-blue-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-blue-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-blue-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-blue-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-blue-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-blue-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-blue-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-blue-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-blue-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-pink-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-pink-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-pink-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-pink-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-pink-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-pink-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-pink-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-pink-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-pink-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--divide-opacity))
  }

  .theme-dark .lg\\:dark\\:divide-pink-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--divide-opacity))
  }

  .lg\\:divide-opacity-0>:not(template)~:not(template){
    --divide-opacity:0
  }

  .lg\\:divide-opacity-25>:not(template)~:not(template){
    --divide-opacity:0.25
  }

  .lg\\:divide-opacity-50>:not(template)~:not(template){
    --divide-opacity:0.5
  }

  .lg\\:divide-opacity-75>:not(template)~:not(template){
    --divide-opacity:0.75
  }

  .lg\\:divide-opacity-100>:not(template)~:not(template){
    --divide-opacity:1
  }

  .lg\\:sr-only{
    height:1px;
    margin:-1px;
    overflow:hidden;
    padding:0;
    position:absolute;
    width:1px;
    clip:rect(0,0,0,0);
    border-width:0;
    white-space:nowrap
  }

  .lg\\:not-sr-only{
    height:auto;
    margin:0;
    overflow:visible;
    padding:0;
    position:static;
    width:auto;
    clip:auto;
    white-space:normal
  }

  .lg\\:focus\\:sr-only:focus{
    height:1px;
    margin:-1px;
    overflow:hidden;
    padding:0;
    position:absolute;
    width:1px;
    clip:rect(0,0,0,0);
    border-width:0;
    white-space:nowrap
  }

  .lg\\:focus\\:not-sr-only:focus{
    height:auto;
    margin:0;
    overflow:visible;
    padding:0;
    position:static;
    width:auto;
    clip:auto;
    white-space:normal
  }

  .lg\\:appearance-none{
    appearance:none
  }

  .lg\\:bg-fixed{
    background-attachment:fixed
  }

  .lg\\:bg-local{
    background-attachment:local
  }

  .lg\\:bg-scroll{
    background-attachment:scroll
  }

  .lg\\:bg-transparent{
    background-color:initial
  }

  .lg\\:bg-white{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .lg\\:bg-black{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .lg\\:bg-gray-50{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .lg\\:bg-gray-100{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .lg\\:bg-gray-200{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .lg\\:bg-gray-300{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .lg\\:bg-gray-400{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .lg\\:bg-gray-500{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .lg\\:bg-gray-600{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .lg\\:bg-gray-700{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .lg\\:bg-gray-800{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .lg\\:bg-gray-900{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .lg\\:bg-cool-gray-50{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .lg\\:bg-cool-gray-100{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .lg\\:bg-cool-gray-200{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .lg\\:bg-cool-gray-300{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .lg\\:bg-cool-gray-400{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .lg\\:bg-cool-gray-500{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .lg\\:bg-cool-gray-600{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .lg\\:bg-cool-gray-700{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .lg\\:bg-cool-gray-800{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .lg\\:bg-cool-gray-900{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .lg\\:bg-red-50{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .lg\\:bg-red-100{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .lg\\:bg-red-200{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .lg\\:bg-red-300{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .lg\\:bg-red-400{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .lg\\:bg-red-500{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .lg\\:bg-red-600{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .lg\\:bg-red-700{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .lg\\:bg-red-800{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .lg\\:bg-red-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .lg\\:bg-orange-50{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .lg\\:bg-orange-100{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .lg\\:bg-orange-200{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .lg\\:bg-orange-300{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .lg\\:bg-orange-400{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .lg\\:bg-orange-500{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .lg\\:bg-orange-600{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .lg\\:bg-orange-700{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .lg\\:bg-orange-800{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .lg\\:bg-orange-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .lg\\:bg-yellow-50{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .lg\\:bg-yellow-100{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .lg\\:bg-yellow-200{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .lg\\:bg-yellow-300{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .lg\\:bg-yellow-400{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .lg\\:bg-yellow-500{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .lg\\:bg-yellow-600{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .lg\\:bg-yellow-700{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .lg\\:bg-yellow-800{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .lg\\:bg-yellow-900{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .lg\\:bg-green-50{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .lg\\:bg-green-100{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .lg\\:bg-green-200{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .lg\\:bg-green-300{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .lg\\:bg-green-400{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .lg\\:bg-green-500{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .lg\\:bg-green-600{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .lg\\:bg-green-700{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .lg\\:bg-green-800{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .lg\\:bg-green-900{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .lg\\:bg-teal-50{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .lg\\:bg-teal-100{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .lg\\:bg-teal-200{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .lg\\:bg-teal-300{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .lg\\:bg-teal-400{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .lg\\:bg-teal-500{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .lg\\:bg-teal-600{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .lg\\:bg-teal-700{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .lg\\:bg-teal-800{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .lg\\:bg-teal-900{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .lg\\:bg-blue-50{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .lg\\:bg-blue-100{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .lg\\:bg-blue-200{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .lg\\:bg-blue-300{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .lg\\:bg-blue-400{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .lg\\:bg-blue-500{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .lg\\:bg-blue-600{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .lg\\:bg-blue-700{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .lg\\:bg-blue-800{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .lg\\:bg-blue-900{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .lg\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .lg\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .lg\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .lg\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .lg\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .lg\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .lg\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .lg\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .lg\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .lg\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .lg\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .lg\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .lg\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .lg\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .lg\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .lg\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .lg\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .lg\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .lg\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .lg\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .lg\\:bg-pink-50{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .lg\\:bg-pink-100{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .lg\\:bg-pink-200{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .lg\\:bg-pink-300{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .lg\\:bg-pink-400{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .lg\\:bg-pink-500{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .lg\\:bg-pink-600{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .lg\\:bg-pink-700{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .lg\\:bg-pink-800{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .lg\\:bg-pink-900{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-transparent:hover{
    background-color:initial
  }

  .lg\\:hover\\:bg-white:hover{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-black:hover{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-gray-50:hover{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-gray-100:hover{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-gray-200:hover{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-gray-300:hover{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-gray-400:hover{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-gray-500:hover{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-gray-600:hover{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-gray-700:hover{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-gray-800:hover{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-gray-900:hover{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-cool-gray-50:hover{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-cool-gray-100:hover{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-cool-gray-200:hover{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-cool-gray-300:hover{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-cool-gray-400:hover{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-cool-gray-500:hover{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-cool-gray-600:hover{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-cool-gray-700:hover{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-cool-gray-800:hover{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-cool-gray-900:hover{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-red-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-red-100:hover{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-red-200:hover{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-red-300:hover{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-red-400:hover{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-red-500:hover{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-red-600:hover{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-red-700:hover{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-red-800:hover{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-red-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-orange-50:hover{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-orange-100:hover{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-orange-200:hover{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-orange-300:hover{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-orange-400:hover{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-orange-500:hover{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-orange-600:hover{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-orange-700:hover{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-orange-800:hover{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-orange-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-yellow-50:hover{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-yellow-100:hover{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-yellow-200:hover{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-yellow-300:hover{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-yellow-400:hover{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-yellow-500:hover{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-yellow-600:hover{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-yellow-700:hover{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-yellow-800:hover{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-yellow-900:hover{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-green-50:hover{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-green-100:hover{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-green-200:hover{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-green-300:hover{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-green-400:hover{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-green-500:hover{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-green-600:hover{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-green-700:hover{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-green-800:hover{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-green-900:hover{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-teal-50:hover{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-teal-100:hover{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-teal-200:hover{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-teal-300:hover{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-teal-400:hover{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-teal-500:hover{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-teal-600:hover{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-teal-700:hover{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-teal-800:hover{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-teal-900:hover{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-blue-50:hover{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-blue-100:hover{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-blue-200:hover{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-blue-300:hover{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-blue-400:hover{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-blue-500:hover{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-blue-600:hover{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-blue-700:hover{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-blue-800:hover{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-blue-900:hover{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-pink-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-pink-100:hover{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-pink-200:hover{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-pink-300:hover{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-pink-400:hover{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-pink-500:hover{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-pink-600:hover{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-pink-700:hover{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-pink-800:hover{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .lg\\:hover\\:bg-pink-900:hover{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-transparent:focus{
    background-color:initial
  }

  .lg\\:focus\\:bg-white:focus{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-black:focus{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-gray-50:focus{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-gray-100:focus{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-gray-200:focus{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-gray-300:focus{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-gray-400:focus{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-gray-500:focus{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-gray-600:focus{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-gray-700:focus{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-gray-800:focus{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-gray-900:focus{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-cool-gray-50:focus{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-cool-gray-100:focus{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-cool-gray-200:focus{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-cool-gray-300:focus{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-cool-gray-400:focus{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-cool-gray-500:focus{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-cool-gray-600:focus{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-cool-gray-700:focus{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-cool-gray-800:focus{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-cool-gray-900:focus{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-red-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-red-100:focus{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-red-200:focus{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-red-300:focus{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-red-400:focus{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-red-500:focus{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-red-600:focus{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-red-700:focus{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-red-800:focus{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-red-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-orange-50:focus{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-orange-100:focus{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-orange-200:focus{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-orange-300:focus{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-orange-400:focus{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-orange-500:focus{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-orange-600:focus{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-orange-700:focus{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-orange-800:focus{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-orange-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-yellow-50:focus{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-yellow-100:focus{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-yellow-200:focus{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-yellow-300:focus{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-yellow-400:focus{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-yellow-500:focus{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-yellow-600:focus{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-yellow-700:focus{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-yellow-800:focus{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-yellow-900:focus{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-green-50:focus{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-green-100:focus{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-green-200:focus{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-green-300:focus{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-green-400:focus{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-green-500:focus{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-green-600:focus{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-green-700:focus{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-green-800:focus{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-green-900:focus{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-teal-50:focus{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-teal-100:focus{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-teal-200:focus{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-teal-300:focus{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-teal-400:focus{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-teal-500:focus{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-teal-600:focus{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-teal-700:focus{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-teal-800:focus{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-teal-900:focus{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-blue-50:focus{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-blue-100:focus{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-blue-200:focus{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-blue-300:focus{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-blue-400:focus{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-blue-500:focus{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-blue-600:focus{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-blue-700:focus{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-blue-800:focus{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-blue-900:focus{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-pink-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-pink-100:focus{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-pink-200:focus{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-pink-300:focus{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-pink-400:focus{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-pink-500:focus{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-pink-600:focus{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-pink-700:focus{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-pink-800:focus{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .lg\\:focus\\:bg-pink-900:focus{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .lg\\:active\\:bg-transparent:active{
    background-color:initial
  }

  .lg\\:active\\:bg-white:active{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .lg\\:active\\:bg-black:active{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .lg\\:active\\:bg-gray-50:active{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .lg\\:active\\:bg-gray-100:active{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .lg\\:active\\:bg-gray-200:active{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .lg\\:active\\:bg-gray-300:active{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .lg\\:active\\:bg-gray-400:active{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .lg\\:active\\:bg-gray-500:active{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .lg\\:active\\:bg-gray-600:active{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .lg\\:active\\:bg-gray-700:active{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .lg\\:active\\:bg-gray-800:active{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .lg\\:active\\:bg-gray-900:active{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .lg\\:active\\:bg-cool-gray-50:active{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .lg\\:active\\:bg-cool-gray-100:active{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .lg\\:active\\:bg-cool-gray-200:active{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .lg\\:active\\:bg-cool-gray-300:active{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .lg\\:active\\:bg-cool-gray-400:active{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .lg\\:active\\:bg-cool-gray-500:active{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .lg\\:active\\:bg-cool-gray-600:active{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .lg\\:active\\:bg-cool-gray-700:active{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .lg\\:active\\:bg-cool-gray-800:active{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .lg\\:active\\:bg-cool-gray-900:active{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .lg\\:active\\:bg-red-50:active{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .lg\\:active\\:bg-red-100:active{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .lg\\:active\\:bg-red-200:active{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .lg\\:active\\:bg-red-300:active{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .lg\\:active\\:bg-red-400:active{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .lg\\:active\\:bg-red-500:active{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .lg\\:active\\:bg-red-600:active{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .lg\\:active\\:bg-red-700:active{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .lg\\:active\\:bg-red-800:active{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .lg\\:active\\:bg-red-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .lg\\:active\\:bg-orange-50:active{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .lg\\:active\\:bg-orange-100:active{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .lg\\:active\\:bg-orange-200:active{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .lg\\:active\\:bg-orange-300:active{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .lg\\:active\\:bg-orange-400:active{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .lg\\:active\\:bg-orange-500:active{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .lg\\:active\\:bg-orange-600:active{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .lg\\:active\\:bg-orange-700:active{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .lg\\:active\\:bg-orange-800:active{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .lg\\:active\\:bg-orange-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .lg\\:active\\:bg-yellow-50:active{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .lg\\:active\\:bg-yellow-100:active{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .lg\\:active\\:bg-yellow-200:active{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .lg\\:active\\:bg-yellow-300:active{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .lg\\:active\\:bg-yellow-400:active{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .lg\\:active\\:bg-yellow-500:active{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .lg\\:active\\:bg-yellow-600:active{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .lg\\:active\\:bg-yellow-700:active{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .lg\\:active\\:bg-yellow-800:active{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .lg\\:active\\:bg-yellow-900:active{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .lg\\:active\\:bg-green-50:active{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .lg\\:active\\:bg-green-100:active{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .lg\\:active\\:bg-green-200:active{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .lg\\:active\\:bg-green-300:active{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .lg\\:active\\:bg-green-400:active{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .lg\\:active\\:bg-green-500:active{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .lg\\:active\\:bg-green-600:active{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .lg\\:active\\:bg-green-700:active{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .lg\\:active\\:bg-green-800:active{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .lg\\:active\\:bg-green-900:active{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .lg\\:active\\:bg-teal-50:active{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .lg\\:active\\:bg-teal-100:active{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .lg\\:active\\:bg-teal-200:active{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .lg\\:active\\:bg-teal-300:active{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .lg\\:active\\:bg-teal-400:active{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .lg\\:active\\:bg-teal-500:active{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .lg\\:active\\:bg-teal-600:active{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .lg\\:active\\:bg-teal-700:active{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .lg\\:active\\:bg-teal-800:active{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .lg\\:active\\:bg-teal-900:active{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .lg\\:active\\:bg-blue-50:active{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .lg\\:active\\:bg-blue-100:active{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .lg\\:active\\:bg-blue-200:active{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .lg\\:active\\:bg-blue-300:active{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .lg\\:active\\:bg-blue-400:active{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .lg\\:active\\:bg-blue-500:active{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .lg\\:active\\:bg-blue-600:active{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .lg\\:active\\:bg-blue-700:active{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .lg\\:active\\:bg-blue-800:active{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .lg\\:active\\:bg-blue-900:active{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .lg\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .lg\\:active\\:bg-pink-50:active{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .lg\\:active\\:bg-pink-100:active{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .lg\\:active\\:bg-pink-200:active{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .lg\\:active\\:bg-pink-300:active{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .lg\\:active\\:bg-pink-400:active{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .lg\\:active\\:bg-pink-500:active{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .lg\\:active\\:bg-pink-600:active{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .lg\\:active\\:bg-pink-700:active{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .lg\\:active\\:bg-pink-800:active{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .lg\\:active\\:bg-pink-900:active{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-transparent:nth-child(odd){
    background-color:initial
  }

  .lg\\:odd\\:bg-white:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-black:nth-child(odd){
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-cool-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-cool-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-cool-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-cool-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-cool-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-cool-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-cool-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-cool-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-cool-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-cool-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-red-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-red-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-red-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-red-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-red-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-red-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-red-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-red-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-red-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-red-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-orange-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-orange-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-orange-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-orange-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-orange-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-orange-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-orange-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-orange-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-orange-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-orange-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-yellow-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-yellow-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-yellow-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-yellow-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-yellow-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-yellow-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-yellow-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-yellow-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-yellow-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-yellow-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-green-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-green-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-green-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-green-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-green-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-green-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-green-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-green-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-green-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-green-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-teal-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-teal-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-teal-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-teal-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-teal-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-teal-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-teal-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-teal-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-teal-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-teal-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-blue-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-blue-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-blue-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-blue-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-blue-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-blue-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-blue-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-blue-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-blue-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-blue-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-pink-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-pink-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-pink-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-pink-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-pink-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-pink-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-pink-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-pink-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-pink-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .lg\\:odd\\:bg-pink-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-transparent{
    background-color:initial
  }

  .theme-dark .lg\\:dark\\:bg-white{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-black{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-gray-50{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-gray-100{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-gray-200{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-gray-300{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-gray-400{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-gray-500{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-gray-600{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-gray-700{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-gray-800{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-gray-900{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-cool-gray-50{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-cool-gray-100{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-cool-gray-200{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-cool-gray-300{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-cool-gray-400{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-cool-gray-500{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-cool-gray-600{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-cool-gray-700{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-cool-gray-800{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-cool-gray-900{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-red-50{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-red-100{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-red-200{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-red-300{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-red-400{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-red-500{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-red-600{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-red-700{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-red-800{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-red-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-orange-50{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-orange-100{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-orange-200{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-orange-300{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-orange-400{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-orange-500{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-orange-600{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-orange-700{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-orange-800{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-orange-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-yellow-50{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-yellow-100{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-yellow-200{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-yellow-300{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-yellow-400{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-yellow-500{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-yellow-600{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-yellow-700{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-yellow-800{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-yellow-900{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-green-50{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-green-100{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-green-200{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-green-300{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-green-400{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-green-500{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-green-600{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-green-700{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-green-800{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-green-900{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-teal-50{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-teal-100{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-teal-200{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-teal-300{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-teal-400{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-teal-500{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-teal-600{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-teal-700{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-teal-800{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-teal-900{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-blue-50{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-blue-100{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-blue-200{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-blue-300{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-blue-400{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-blue-500{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-blue-600{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-blue-700{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-blue-800{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-blue-900{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-pink-50{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-pink-100{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-pink-200{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-pink-300{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-pink-400{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-pink-500{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-pink-600{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-pink-700{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-pink-800{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:bg-pink-900{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-transparent:hover{
    background-color:initial
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-white:hover{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-black:hover{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-gray-50:hover{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-gray-100:hover{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-gray-200:hover{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-gray-300:hover{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-gray-400:hover{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-gray-500:hover{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-gray-600:hover{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-gray-700:hover{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-gray-800:hover{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-gray-900:hover{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-50:hover{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-100:hover{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-200:hover{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-300:hover{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-400:hover{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-500:hover{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-600:hover{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-700:hover{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-800:hover{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-900:hover{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-red-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-red-100:hover{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-red-200:hover{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-red-300:hover{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-red-400:hover{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-red-500:hover{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-red-600:hover{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-red-700:hover{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-red-800:hover{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-red-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-orange-50:hover{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-orange-100:hover{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-orange-200:hover{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-orange-300:hover{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-orange-400:hover{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-orange-500:hover{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-orange-600:hover{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-orange-700:hover{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-orange-800:hover{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-orange-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-yellow-50:hover{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-yellow-100:hover{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-yellow-200:hover{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-yellow-300:hover{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-yellow-400:hover{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-yellow-500:hover{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-yellow-600:hover{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-yellow-700:hover{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-yellow-800:hover{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-yellow-900:hover{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-green-50:hover{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-green-100:hover{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-green-200:hover{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-green-300:hover{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-green-400:hover{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-green-500:hover{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-green-600:hover{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-green-700:hover{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-green-800:hover{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-green-900:hover{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-teal-50:hover{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-teal-100:hover{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-teal-200:hover{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-teal-300:hover{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-teal-400:hover{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-teal-500:hover{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-teal-600:hover{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-teal-700:hover{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-teal-800:hover{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-teal-900:hover{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-blue-50:hover{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-blue-100:hover{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-blue-200:hover{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-blue-300:hover{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-blue-400:hover{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-blue-500:hover{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-blue-600:hover{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-blue-700:hover{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-blue-800:hover{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-blue-900:hover{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-pink-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-pink-100:hover{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-pink-200:hover{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-pink-300:hover{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-pink-400:hover{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-pink-500:hover{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-pink-600:hover{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-pink-700:hover{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-pink-800:hover{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-pink-900:hover{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-transparent:focus{
    background-color:initial
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-white:focus{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-black:focus{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-gray-50:focus{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-gray-100:focus{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-gray-200:focus{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-gray-300:focus{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-gray-400:focus{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-gray-500:focus{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-gray-600:focus{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-gray-700:focus{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-gray-800:focus{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-gray-900:focus{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-50:focus{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-100:focus{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-200:focus{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-300:focus{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-400:focus{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-500:focus{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-600:focus{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-700:focus{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-800:focus{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-900:focus{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-red-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-red-100:focus{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-red-200:focus{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-red-300:focus{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-red-400:focus{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-red-500:focus{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-red-600:focus{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-red-700:focus{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-red-800:focus{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-red-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-orange-50:focus{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-orange-100:focus{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-orange-200:focus{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-orange-300:focus{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-orange-400:focus{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-orange-500:focus{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-orange-600:focus{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-orange-700:focus{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-orange-800:focus{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-orange-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-yellow-50:focus{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-yellow-100:focus{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-yellow-200:focus{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-yellow-300:focus{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-yellow-400:focus{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-yellow-500:focus{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-yellow-600:focus{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-yellow-700:focus{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-yellow-800:focus{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-yellow-900:focus{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-green-50:focus{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-green-100:focus{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-green-200:focus{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-green-300:focus{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-green-400:focus{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-green-500:focus{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-green-600:focus{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-green-700:focus{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-green-800:focus{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-green-900:focus{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-teal-50:focus{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-teal-100:focus{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-teal-200:focus{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-teal-300:focus{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-teal-400:focus{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-teal-500:focus{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-teal-600:focus{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-teal-700:focus{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-teal-800:focus{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-teal-900:focus{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-blue-50:focus{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-blue-100:focus{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-blue-200:focus{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-blue-300:focus{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-blue-400:focus{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-blue-500:focus{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-blue-600:focus{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-blue-700:focus{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-blue-800:focus{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-blue-900:focus{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-pink-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-pink-100:focus{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-pink-200:focus{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-pink-300:focus{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-pink-400:focus{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-pink-500:focus{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-pink-600:focus{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-pink-700:focus{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-pink-800:focus{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:bg-pink-900:focus{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-transparent:active{
    background-color:initial
  }

  .theme-dark .lg\\:dark\\:active\\:bg-white:active{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-black:active{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-gray-50:active{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-gray-100:active{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-gray-200:active{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-gray-300:active{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-gray-400:active{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-gray-500:active{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-gray-600:active{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-gray-700:active{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-gray-800:active{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-gray-900:active{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-cool-gray-50:active{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-cool-gray-100:active{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-cool-gray-200:active{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-cool-gray-300:active{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-cool-gray-400:active{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-cool-gray-500:active{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-cool-gray-600:active{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-cool-gray-700:active{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-cool-gray-800:active{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-cool-gray-900:active{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-red-50:active{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-red-100:active{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-red-200:active{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-red-300:active{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-red-400:active{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-red-500:active{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-red-600:active{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-red-700:active{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-red-800:active{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-red-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-orange-50:active{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-orange-100:active{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-orange-200:active{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-orange-300:active{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-orange-400:active{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-orange-500:active{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-orange-600:active{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-orange-700:active{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-orange-800:active{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-orange-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-yellow-50:active{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-yellow-100:active{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-yellow-200:active{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-yellow-300:active{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-yellow-400:active{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-yellow-500:active{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-yellow-600:active{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-yellow-700:active{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-yellow-800:active{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-yellow-900:active{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-green-50:active{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-green-100:active{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-green-200:active{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-green-300:active{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-green-400:active{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-green-500:active{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-green-600:active{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-green-700:active{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-green-800:active{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-green-900:active{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-teal-50:active{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-teal-100:active{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-teal-200:active{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-teal-300:active{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-teal-400:active{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-teal-500:active{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-teal-600:active{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-teal-700:active{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-teal-800:active{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-teal-900:active{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-blue-50:active{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-blue-100:active{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-blue-200:active{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-blue-300:active{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-blue-400:active{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-blue-500:active{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-blue-600:active{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-blue-700:active{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-blue-800:active{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-blue-900:active{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-pink-50:active{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-pink-100:active{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-pink-200:active{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-pink-300:active{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-pink-400:active{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-pink-500:active{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-pink-600:active{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-pink-700:active{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-pink-800:active{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:bg-pink-900:active{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-transparent:nth-child(odd){
    background-color:initial
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-white:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-black:nth-child(odd){
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-red-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-red-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-red-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-red-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-red-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-red-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-red-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-red-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-red-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-red-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-orange-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-orange-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-orange-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-orange-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-orange-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-orange-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-orange-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-orange-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-orange-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-orange-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-yellow-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-yellow-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-yellow-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-yellow-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-yellow-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-yellow-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-yellow-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-yellow-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-yellow-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-yellow-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-green-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-green-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-green-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-green-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-green-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-green-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-green-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-green-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-green-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-green-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-teal-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-teal-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-teal-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-teal-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-teal-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-teal-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-teal-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-teal-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-teal-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-teal-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-blue-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-blue-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-blue-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-blue-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-blue-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-blue-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-blue-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-blue-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-blue-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-blue-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-pink-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-pink-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-pink-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-pink-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-pink-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-pink-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-pink-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-pink-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-pink-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .lg\\:dark\\:odd\\:bg-pink-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .lg\\:bg-opacity-0{
    --bg-opacity:0
  }

  .lg\\:bg-opacity-10{
    --bg-opacity:0.1
  }

  .lg\\:bg-opacity-25{
    --bg-opacity:0.25
  }

  .lg\\:bg-opacity-50{
    --bg-opacity:0.5
  }

  .lg\\:bg-opacity-75{
    --bg-opacity:0.75
  }

  .lg\\:bg-opacity-100{
    --bg-opacity:1
  }

  .lg\\:hover\\:bg-opacity-0:hover{
    --bg-opacity:0
  }

  .lg\\:hover\\:bg-opacity-10:hover{
    --bg-opacity:0.1
  }

  .lg\\:hover\\:bg-opacity-25:hover{
    --bg-opacity:0.25
  }

  .lg\\:hover\\:bg-opacity-50:hover{
    --bg-opacity:0.5
  }

  .lg\\:hover\\:bg-opacity-75:hover{
    --bg-opacity:0.75
  }

  .lg\\:hover\\:bg-opacity-100:hover{
    --bg-opacity:1
  }

  .lg\\:focus\\:bg-opacity-0:focus{
    --bg-opacity:0
  }

  .lg\\:focus\\:bg-opacity-10:focus{
    --bg-opacity:0.1
  }

  .lg\\:focus\\:bg-opacity-25:focus{
    --bg-opacity:0.25
  }

  .lg\\:focus\\:bg-opacity-50:focus{
    --bg-opacity:0.5
  }

  .lg\\:focus\\:bg-opacity-75:focus{
    --bg-opacity:0.75
  }

  .lg\\:focus\\:bg-opacity-100:focus{
    --bg-opacity:1
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-opacity-0:hover{
    --bg-opacity:0
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-opacity-10:hover{
    --bg-opacity:0.1
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-opacity-25:hover{
    --bg-opacity:0.25
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-opacity-50:hover{
    --bg-opacity:0.5
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-opacity-75:hover{
    --bg-opacity:0.75
  }

  .theme-dark .lg\\:dark\\:hover\\:bg-opacity-100:hover{
    --bg-opacity:1
  }

  .lg\\:bg-bottom{
    background-position:bottom
  }

  .lg\\:bg-center{
    background-position:50%
  }

  .lg\\:bg-left{
    background-position:0
  }

  .lg\\:bg-left-bottom{
    background-position:0 100%
  }

  .lg\\:bg-left-top{
    background-position:0 0
  }

  .lg\\:bg-right{
    background-position:100%
  }

  .lg\\:bg-right-bottom{
    background-position:100% 100%
  }

  .lg\\:bg-right-top{
    background-position:100% 0
  }

  .lg\\:bg-top{
    background-position:top
  }

  .lg\\:bg-repeat{
    background-repeat:repeat
  }

  .lg\\:bg-no-repeat{
    background-repeat:no-repeat
  }

  .lg\\:bg-repeat-x{
    background-repeat:repeat-x
  }

  .lg\\:bg-repeat-y{
    background-repeat:repeat-y
  }

  .lg\\:bg-repeat-round{
    background-repeat:round
  }

  .lg\\:bg-repeat-space{
    background-repeat:space
  }

  .lg\\:bg-auto{
    background-size:auto
  }

  .lg\\:bg-cover{
    background-size:cover
  }

  .lg\\:bg-contain{
    background-size:contain
  }

  .lg\\:border-collapse{
    border-collapse:collapse
  }

  .lg\\:border-separate{
    border-collapse:initial
  }

  .lg\\:border-transparent{
    border-color:#0000
  }

  .lg\\:border-white{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .lg\\:border-black{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .lg\\:border-gray-50{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .lg\\:border-gray-100{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .lg\\:border-gray-200{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .lg\\:border-gray-300{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .lg\\:border-gray-400{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .lg\\:border-gray-500{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .lg\\:border-gray-600{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .lg\\:border-gray-700{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .lg\\:border-gray-800{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .lg\\:border-gray-900{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .lg\\:border-cool-gray-50{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .lg\\:border-cool-gray-100{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .lg\\:border-cool-gray-200{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .lg\\:border-cool-gray-300{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .lg\\:border-cool-gray-400{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .lg\\:border-cool-gray-500{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .lg\\:border-cool-gray-600{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .lg\\:border-cool-gray-700{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .lg\\:border-cool-gray-800{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .lg\\:border-cool-gray-900{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .lg\\:border-red-50{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .lg\\:border-red-100{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .lg\\:border-red-200{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .lg\\:border-red-300{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .lg\\:border-red-400{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .lg\\:border-red-500{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .lg\\:border-red-600{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .lg\\:border-red-700{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .lg\\:border-red-800{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .lg\\:border-red-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .lg\\:border-orange-50{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .lg\\:border-orange-100{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .lg\\:border-orange-200{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .lg\\:border-orange-300{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .lg\\:border-orange-400{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .lg\\:border-orange-500{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .lg\\:border-orange-600{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .lg\\:border-orange-700{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .lg\\:border-orange-800{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .lg\\:border-orange-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .lg\\:border-yellow-50{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .lg\\:border-yellow-100{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .lg\\:border-yellow-200{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .lg\\:border-yellow-300{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .lg\\:border-yellow-400{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .lg\\:border-yellow-500{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .lg\\:border-yellow-600{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .lg\\:border-yellow-700{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .lg\\:border-yellow-800{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .lg\\:border-yellow-900{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .lg\\:border-green-50{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .lg\\:border-green-100{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .lg\\:border-green-200{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .lg\\:border-green-300{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .lg\\:border-green-400{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .lg\\:border-green-500{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .lg\\:border-green-600{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .lg\\:border-green-700{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .lg\\:border-green-800{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .lg\\:border-green-900{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .lg\\:border-teal-50{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .lg\\:border-teal-100{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .lg\\:border-teal-200{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .lg\\:border-teal-300{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .lg\\:border-teal-400{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .lg\\:border-teal-500{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .lg\\:border-teal-600{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .lg\\:border-teal-700{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .lg\\:border-teal-800{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .lg\\:border-teal-900{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .lg\\:border-blue-50{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .lg\\:border-blue-100{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .lg\\:border-blue-200{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .lg\\:border-blue-300{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .lg\\:border-blue-400{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .lg\\:border-blue-500{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .lg\\:border-blue-600{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .lg\\:border-blue-700{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .lg\\:border-blue-800{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .lg\\:border-blue-900{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .lg\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .lg\\:border-indigo-100{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .lg\\:border-indigo-200{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .lg\\:border-indigo-300{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .lg\\:border-indigo-400{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .lg\\:border-indigo-500{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .lg\\:border-indigo-600{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .lg\\:border-indigo-700{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .lg\\:border-indigo-800{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .lg\\:border-indigo-900{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .lg\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .lg\\:border-indigo-100{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .lg\\:border-indigo-200{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .lg\\:border-indigo-300{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .lg\\:border-indigo-400{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .lg\\:border-indigo-500{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .lg\\:border-indigo-600{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .lg\\:border-indigo-700{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .lg\\:border-indigo-800{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .lg\\:border-indigo-900{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .lg\\:border-pink-50{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .lg\\:border-pink-100{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .lg\\:border-pink-200{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .lg\\:border-pink-300{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .lg\\:border-pink-400{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .lg\\:border-pink-500{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .lg\\:border-pink-600{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .lg\\:border-pink-700{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .lg\\:border-pink-800{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .lg\\:border-pink-900{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .lg\\:hover\\:border-transparent:hover{
    border-color:#0000
  }

  .lg\\:hover\\:border-white:hover{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .lg\\:hover\\:border-black:hover{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .lg\\:hover\\:border-gray-50:hover{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .lg\\:hover\\:border-gray-100:hover{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .lg\\:hover\\:border-gray-200:hover{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .lg\\:hover\\:border-gray-300:hover{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .lg\\:hover\\:border-gray-400:hover{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .lg\\:hover\\:border-gray-500:hover{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .lg\\:hover\\:border-gray-600:hover{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .lg\\:hover\\:border-gray-700:hover{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .lg\\:hover\\:border-gray-800:hover{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .lg\\:hover\\:border-gray-900:hover{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .lg\\:hover\\:border-cool-gray-50:hover{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .lg\\:hover\\:border-cool-gray-100:hover{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .lg\\:hover\\:border-cool-gray-200:hover{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .lg\\:hover\\:border-cool-gray-300:hover{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .lg\\:hover\\:border-cool-gray-400:hover{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .lg\\:hover\\:border-cool-gray-500:hover{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .lg\\:hover\\:border-cool-gray-600:hover{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .lg\\:hover\\:border-cool-gray-700:hover{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .lg\\:hover\\:border-cool-gray-800:hover{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .lg\\:hover\\:border-cool-gray-900:hover{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .lg\\:hover\\:border-red-50:hover{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .lg\\:hover\\:border-red-100:hover{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .lg\\:hover\\:border-red-200:hover{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .lg\\:hover\\:border-red-300:hover{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .lg\\:hover\\:border-red-400:hover{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .lg\\:hover\\:border-red-500:hover{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .lg\\:hover\\:border-red-600:hover{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .lg\\:hover\\:border-red-700:hover{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .lg\\:hover\\:border-red-800:hover{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .lg\\:hover\\:border-red-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .lg\\:hover\\:border-orange-50:hover{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .lg\\:hover\\:border-orange-100:hover{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .lg\\:hover\\:border-orange-200:hover{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .lg\\:hover\\:border-orange-300:hover{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .lg\\:hover\\:border-orange-400:hover{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .lg\\:hover\\:border-orange-500:hover{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .lg\\:hover\\:border-orange-600:hover{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .lg\\:hover\\:border-orange-700:hover{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .lg\\:hover\\:border-orange-800:hover{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .lg\\:hover\\:border-orange-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .lg\\:hover\\:border-yellow-50:hover{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .lg\\:hover\\:border-yellow-100:hover{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .lg\\:hover\\:border-yellow-200:hover{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .lg\\:hover\\:border-yellow-300:hover{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .lg\\:hover\\:border-yellow-400:hover{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .lg\\:hover\\:border-yellow-500:hover{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .lg\\:hover\\:border-yellow-600:hover{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .lg\\:hover\\:border-yellow-700:hover{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .lg\\:hover\\:border-yellow-800:hover{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .lg\\:hover\\:border-yellow-900:hover{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .lg\\:hover\\:border-green-50:hover{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .lg\\:hover\\:border-green-100:hover{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .lg\\:hover\\:border-green-200:hover{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .lg\\:hover\\:border-green-300:hover{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .lg\\:hover\\:border-green-400:hover{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .lg\\:hover\\:border-green-500:hover{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .lg\\:hover\\:border-green-600:hover{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .lg\\:hover\\:border-green-700:hover{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .lg\\:hover\\:border-green-800:hover{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .lg\\:hover\\:border-green-900:hover{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .lg\\:hover\\:border-teal-50:hover{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .lg\\:hover\\:border-teal-100:hover{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .lg\\:hover\\:border-teal-200:hover{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .lg\\:hover\\:border-teal-300:hover{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .lg\\:hover\\:border-teal-400:hover{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .lg\\:hover\\:border-teal-500:hover{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .lg\\:hover\\:border-teal-600:hover{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .lg\\:hover\\:border-teal-700:hover{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .lg\\:hover\\:border-teal-800:hover{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .lg\\:hover\\:border-teal-900:hover{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .lg\\:hover\\:border-blue-50:hover{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .lg\\:hover\\:border-blue-100:hover{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .lg\\:hover\\:border-blue-200:hover{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .lg\\:hover\\:border-blue-300:hover{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .lg\\:hover\\:border-blue-400:hover{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .lg\\:hover\\:border-blue-500:hover{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .lg\\:hover\\:border-blue-600:hover{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .lg\\:hover\\:border-blue-700:hover{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .lg\\:hover\\:border-blue-800:hover{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .lg\\:hover\\:border-blue-900:hover{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .lg\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .lg\\:hover\\:border-pink-50:hover{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .lg\\:hover\\:border-pink-100:hover{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .lg\\:hover\\:border-pink-200:hover{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .lg\\:hover\\:border-pink-300:hover{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .lg\\:hover\\:border-pink-400:hover{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .lg\\:hover\\:border-pink-500:hover{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .lg\\:hover\\:border-pink-600:hover{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .lg\\:hover\\:border-pink-700:hover{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .lg\\:hover\\:border-pink-800:hover{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .lg\\:hover\\:border-pink-900:hover{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .lg\\:focus\\:border-transparent:focus{
    border-color:#0000
  }

  .lg\\:focus\\:border-white:focus{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .lg\\:focus\\:border-black:focus{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .lg\\:focus\\:border-gray-50:focus{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .lg\\:focus\\:border-gray-100:focus{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .lg\\:focus\\:border-gray-200:focus{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .lg\\:focus\\:border-gray-300:focus{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .lg\\:focus\\:border-gray-400:focus{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .lg\\:focus\\:border-gray-500:focus{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .lg\\:focus\\:border-gray-600:focus{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .lg\\:focus\\:border-gray-700:focus{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .lg\\:focus\\:border-gray-800:focus{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .lg\\:focus\\:border-gray-900:focus{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .lg\\:focus\\:border-cool-gray-50:focus{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .lg\\:focus\\:border-cool-gray-100:focus{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .lg\\:focus\\:border-cool-gray-200:focus{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .lg\\:focus\\:border-cool-gray-300:focus{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .lg\\:focus\\:border-cool-gray-400:focus{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .lg\\:focus\\:border-cool-gray-500:focus{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .lg\\:focus\\:border-cool-gray-600:focus{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .lg\\:focus\\:border-cool-gray-700:focus{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .lg\\:focus\\:border-cool-gray-800:focus{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .lg\\:focus\\:border-cool-gray-900:focus{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .lg\\:focus\\:border-red-50:focus{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .lg\\:focus\\:border-red-100:focus{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .lg\\:focus\\:border-red-200:focus{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .lg\\:focus\\:border-red-300:focus{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .lg\\:focus\\:border-red-400:focus{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .lg\\:focus\\:border-red-500:focus{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .lg\\:focus\\:border-red-600:focus{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .lg\\:focus\\:border-red-700:focus{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .lg\\:focus\\:border-red-800:focus{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .lg\\:focus\\:border-red-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .lg\\:focus\\:border-orange-50:focus{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .lg\\:focus\\:border-orange-100:focus{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .lg\\:focus\\:border-orange-200:focus{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .lg\\:focus\\:border-orange-300:focus{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .lg\\:focus\\:border-orange-400:focus{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .lg\\:focus\\:border-orange-500:focus{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .lg\\:focus\\:border-orange-600:focus{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .lg\\:focus\\:border-orange-700:focus{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .lg\\:focus\\:border-orange-800:focus{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .lg\\:focus\\:border-orange-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .lg\\:focus\\:border-yellow-50:focus{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .lg\\:focus\\:border-yellow-100:focus{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .lg\\:focus\\:border-yellow-200:focus{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .lg\\:focus\\:border-yellow-300:focus{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .lg\\:focus\\:border-yellow-400:focus{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .lg\\:focus\\:border-yellow-500:focus{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .lg\\:focus\\:border-yellow-600:focus{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .lg\\:focus\\:border-yellow-700:focus{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .lg\\:focus\\:border-yellow-800:focus{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .lg\\:focus\\:border-yellow-900:focus{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .lg\\:focus\\:border-green-50:focus{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .lg\\:focus\\:border-green-100:focus{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .lg\\:focus\\:border-green-200:focus{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .lg\\:focus\\:border-green-300:focus{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .lg\\:focus\\:border-green-400:focus{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .lg\\:focus\\:border-green-500:focus{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .lg\\:focus\\:border-green-600:focus{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .lg\\:focus\\:border-green-700:focus{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .lg\\:focus\\:border-green-800:focus{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .lg\\:focus\\:border-green-900:focus{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .lg\\:focus\\:border-teal-50:focus{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .lg\\:focus\\:border-teal-100:focus{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .lg\\:focus\\:border-teal-200:focus{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .lg\\:focus\\:border-teal-300:focus{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .lg\\:focus\\:border-teal-400:focus{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .lg\\:focus\\:border-teal-500:focus{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .lg\\:focus\\:border-teal-600:focus{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .lg\\:focus\\:border-teal-700:focus{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .lg\\:focus\\:border-teal-800:focus{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .lg\\:focus\\:border-teal-900:focus{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .lg\\:focus\\:border-blue-50:focus{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .lg\\:focus\\:border-blue-100:focus{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .lg\\:focus\\:border-blue-200:focus{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .lg\\:focus\\:border-blue-300:focus{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .lg\\:focus\\:border-blue-400:focus{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .lg\\:focus\\:border-blue-500:focus{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .lg\\:focus\\:border-blue-600:focus{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .lg\\:focus\\:border-blue-700:focus{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .lg\\:focus\\:border-blue-800:focus{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .lg\\:focus\\:border-blue-900:focus{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .lg\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .lg\\:focus\\:border-pink-50:focus{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .lg\\:focus\\:border-pink-100:focus{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .lg\\:focus\\:border-pink-200:focus{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .lg\\:focus\\:border-pink-300:focus{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .lg\\:focus\\:border-pink-400:focus{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .lg\\:focus\\:border-pink-500:focus{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .lg\\:focus\\:border-pink-600:focus{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .lg\\:focus\\:border-pink-700:focus{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .lg\\:focus\\:border-pink-800:focus{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .lg\\:focus\\:border-pink-900:focus{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-transparent{
    border-color:#0000
  }

  .theme-dark .lg\\:dark\\:border-white{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-black{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-gray-50{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-gray-100{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-gray-200{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-gray-300{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-gray-400{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-gray-500{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-gray-600{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-gray-700{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-gray-800{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-gray-900{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-cool-gray-50{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-cool-gray-100{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-cool-gray-200{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-cool-gray-300{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-cool-gray-400{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-cool-gray-500{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-cool-gray-600{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-cool-gray-700{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-cool-gray-800{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-cool-gray-900{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-red-50{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-red-100{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-red-200{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-red-300{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-red-400{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-red-500{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-red-600{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-red-700{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-red-800{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-red-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-orange-50{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-orange-100{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-orange-200{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-orange-300{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-orange-400{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-orange-500{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-orange-600{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-orange-700{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-orange-800{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-orange-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-yellow-50{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-yellow-100{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-yellow-200{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-yellow-300{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-yellow-400{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-yellow-500{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-yellow-600{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-yellow-700{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-yellow-800{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-yellow-900{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-green-50{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-green-100{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-green-200{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-green-300{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-green-400{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-green-500{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-green-600{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-green-700{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-green-800{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-green-900{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-teal-50{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-teal-100{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-teal-200{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-teal-300{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-teal-400{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-teal-500{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-teal-600{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-teal-700{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-teal-800{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-teal-900{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-blue-50{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-blue-100{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-blue-200{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-blue-300{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-blue-400{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-blue-500{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-blue-600{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-blue-700{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-blue-800{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-blue-900{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-100{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-200{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-300{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-400{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-500{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-600{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-700{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-800{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-900{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-100{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-200{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-300{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-400{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-500{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-600{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-700{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-800{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-indigo-900{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-pink-50{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-pink-100{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-pink-200{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-pink-300{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-pink-400{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-pink-500{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-pink-600{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-pink-700{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-pink-800{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:border-pink-900{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-transparent:focus{
    border-color:#0000
  }

  .theme-dark .lg\\:dark\\:focus\\:border-white:focus{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-black:focus{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-gray-50:focus{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-gray-100:focus{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-gray-200:focus{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-gray-300:focus{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-gray-400:focus{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-gray-500:focus{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-gray-600:focus{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-gray-700:focus{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-gray-800:focus{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-gray-900:focus{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-cool-gray-50:focus{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-cool-gray-100:focus{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-cool-gray-200:focus{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-cool-gray-300:focus{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-cool-gray-400:focus{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-cool-gray-500:focus{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-cool-gray-600:focus{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-cool-gray-700:focus{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-cool-gray-800:focus{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-cool-gray-900:focus{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-red-50:focus{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-red-100:focus{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-red-200:focus{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-red-300:focus{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-red-400:focus{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-red-500:focus{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-red-600:focus{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-red-700:focus{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-red-800:focus{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-red-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-orange-50:focus{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-orange-100:focus{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-orange-200:focus{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-orange-300:focus{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-orange-400:focus{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-orange-500:focus{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-orange-600:focus{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-orange-700:focus{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-orange-800:focus{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-orange-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-yellow-50:focus{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-yellow-100:focus{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-yellow-200:focus{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-yellow-300:focus{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-yellow-400:focus{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-yellow-500:focus{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-yellow-600:focus{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-yellow-700:focus{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-yellow-800:focus{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-yellow-900:focus{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-green-50:focus{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-green-100:focus{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-green-200:focus{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-green-300:focus{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-green-400:focus{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-green-500:focus{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-green-600:focus{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-green-700:focus{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-green-800:focus{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-green-900:focus{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-teal-50:focus{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-teal-100:focus{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-teal-200:focus{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-teal-300:focus{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-teal-400:focus{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-teal-500:focus{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-teal-600:focus{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-teal-700:focus{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-teal-800:focus{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-teal-900:focus{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-blue-50:focus{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-blue-100:focus{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-blue-200:focus{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-blue-300:focus{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-blue-400:focus{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-blue-500:focus{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-blue-600:focus{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-blue-700:focus{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-blue-800:focus{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-blue-900:focus{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-pink-50:focus{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-pink-100:focus{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-pink-200:focus{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-pink-300:focus{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-pink-400:focus{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-pink-500:focus{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-pink-600:focus{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-pink-700:focus{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-pink-800:focus{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:border-pink-900:focus{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-transparent:hover{
    border-color:#0000
  }

  .theme-dark .lg\\:dark\\:hover\\:border-white:hover{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-black:hover{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-gray-50:hover{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-gray-100:hover{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-gray-200:hover{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-gray-300:hover{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-gray-400:hover{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-gray-500:hover{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-gray-600:hover{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-gray-700:hover{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-gray-800:hover{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-gray-900:hover{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-cool-gray-50:hover{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-cool-gray-100:hover{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-cool-gray-200:hover{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-cool-gray-300:hover{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-cool-gray-400:hover{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-cool-gray-500:hover{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-cool-gray-600:hover{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-cool-gray-700:hover{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-cool-gray-800:hover{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-cool-gray-900:hover{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-red-50:hover{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-red-100:hover{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-red-200:hover{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-red-300:hover{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-red-400:hover{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-red-500:hover{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-red-600:hover{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-red-700:hover{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-red-800:hover{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-red-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-orange-50:hover{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-orange-100:hover{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-orange-200:hover{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-orange-300:hover{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-orange-400:hover{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-orange-500:hover{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-orange-600:hover{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-orange-700:hover{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-orange-800:hover{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-orange-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-yellow-50:hover{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-yellow-100:hover{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-yellow-200:hover{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-yellow-300:hover{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-yellow-400:hover{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-yellow-500:hover{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-yellow-600:hover{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-yellow-700:hover{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-yellow-800:hover{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-yellow-900:hover{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-green-50:hover{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-green-100:hover{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-green-200:hover{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-green-300:hover{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-green-400:hover{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-green-500:hover{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-green-600:hover{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-green-700:hover{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-green-800:hover{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-green-900:hover{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-teal-50:hover{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-teal-100:hover{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-teal-200:hover{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-teal-300:hover{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-teal-400:hover{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-teal-500:hover{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-teal-600:hover{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-teal-700:hover{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-teal-800:hover{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-teal-900:hover{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-blue-50:hover{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-blue-100:hover{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-blue-200:hover{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-blue-300:hover{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-blue-400:hover{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-blue-500:hover{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-blue-600:hover{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-blue-700:hover{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-blue-800:hover{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-blue-900:hover{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-pink-50:hover{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-pink-100:hover{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-pink-200:hover{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-pink-300:hover{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-pink-400:hover{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-pink-500:hover{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-pink-600:hover{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-pink-700:hover{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-pink-800:hover{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:border-pink-900:hover{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .lg\\:border-opacity-0{
    --border-opacity:0
  }

  .lg\\:border-opacity-25{
    --border-opacity:0.25
  }

  .lg\\:border-opacity-50{
    --border-opacity:0.5
  }

  .lg\\:border-opacity-75{
    --border-opacity:0.75
  }

  .lg\\:border-opacity-100{
    --border-opacity:1
  }

  .lg\\:hover\\:border-opacity-0:hover{
    --border-opacity:0
  }

  .lg\\:hover\\:border-opacity-25:hover{
    --border-opacity:0.25
  }

  .lg\\:hover\\:border-opacity-50:hover{
    --border-opacity:0.5
  }

  .lg\\:hover\\:border-opacity-75:hover{
    --border-opacity:0.75
  }

  .lg\\:hover\\:border-opacity-100:hover{
    --border-opacity:1
  }

  .lg\\:focus\\:border-opacity-0:focus{
    --border-opacity:0
  }

  .lg\\:focus\\:border-opacity-25:focus{
    --border-opacity:0.25
  }

  .lg\\:focus\\:border-opacity-50:focus{
    --border-opacity:0.5
  }

  .lg\\:focus\\:border-opacity-75:focus{
    --border-opacity:0.75
  }

  .lg\\:focus\\:border-opacity-100:focus{
    --border-opacity:1
  }

  .lg\\:rounded-none{
    border-radius:0
  }

  .lg\\:rounded-sm{
    border-radius:.125rem
  }

  .lg\\:rounded{
    border-radius:.25rem
  }

  .lg\\:rounded-md{
    border-radius:.375rem
  }

  .lg\\:rounded-lg{
    border-radius:.5rem
  }

  .lg\\:rounded-full{
    border-radius:9999px
  }

  .lg\\:rounded-t-none{
    border-top-left-radius:0;
    border-top-right-radius:0
  }

  .lg\\:rounded-r-none{
    border-bottom-right-radius:0;
    border-top-right-radius:0
  }

  .lg\\:rounded-b-none{
    border-bottom-left-radius:0;
    border-bottom-right-radius:0
  }

  .lg\\:rounded-l-none{
    border-bottom-left-radius:0;
    border-top-left-radius:0
  }

  .lg\\:rounded-t-sm{
    border-top-left-radius:.125rem;
    border-top-right-radius:.125rem
  }

  .lg\\:rounded-r-sm{
    border-bottom-right-radius:.125rem;
    border-top-right-radius:.125rem
  }

  .lg\\:rounded-b-sm{
    border-bottom-left-radius:.125rem;
    border-bottom-right-radius:.125rem
  }

  .lg\\:rounded-l-sm{
    border-bottom-left-radius:.125rem;
    border-top-left-radius:.125rem
  }

  .lg\\:rounded-t{
    border-top-left-radius:.25rem
  }

  .lg\\:rounded-r,.lg\\:rounded-t{
    border-top-right-radius:.25rem
  }

  .lg\\:rounded-b,.lg\\:rounded-r{
    border-bottom-right-radius:.25rem
  }

  .lg\\:rounded-b,.lg\\:rounded-l{
    border-bottom-left-radius:.25rem
  }

  .lg\\:rounded-l{
    border-top-left-radius:.25rem
  }

  .lg\\:rounded-t-md{
    border-top-left-radius:.375rem;
    border-top-right-radius:.375rem
  }

  .lg\\:rounded-r-md{
    border-bottom-right-radius:.375rem;
    border-top-right-radius:.375rem
  }

  .lg\\:rounded-b-md{
    border-bottom-left-radius:.375rem;
    border-bottom-right-radius:.375rem
  }

  .lg\\:rounded-l-md{
    border-bottom-left-radius:.375rem;
    border-top-left-radius:.375rem
  }

  .lg\\:rounded-t-lg{
    border-top-left-radius:.5rem;
    border-top-right-radius:.5rem
  }

  .lg\\:rounded-r-lg{
    border-bottom-right-radius:.5rem;
    border-top-right-radius:.5rem
  }

  .lg\\:rounded-b-lg{
    border-bottom-left-radius:.5rem;
    border-bottom-right-radius:.5rem
  }

  .lg\\:rounded-l-lg{
    border-bottom-left-radius:.5rem;
    border-top-left-radius:.5rem
  }

  .lg\\:rounded-t-full{
    border-top-left-radius:9999px;
    border-top-right-radius:9999px
  }

  .lg\\:rounded-r-full{
    border-bottom-right-radius:9999px;
    border-top-right-radius:9999px
  }

  .lg\\:rounded-b-full{
    border-bottom-left-radius:9999px;
    border-bottom-right-radius:9999px
  }

  .lg\\:rounded-l-full{
    border-bottom-left-radius:9999px;
    border-top-left-radius:9999px
  }

  .lg\\:rounded-tl-none{
    border-top-left-radius:0
  }

  .lg\\:rounded-tr-none{
    border-top-right-radius:0
  }

  .lg\\:rounded-br-none{
    border-bottom-right-radius:0
  }

  .lg\\:rounded-bl-none{
    border-bottom-left-radius:0
  }

  .lg\\:rounded-tl-sm{
    border-top-left-radius:.125rem
  }

  .lg\\:rounded-tr-sm{
    border-top-right-radius:.125rem
  }

  .lg\\:rounded-br-sm{
    border-bottom-right-radius:.125rem
  }

  .lg\\:rounded-bl-sm{
    border-bottom-left-radius:.125rem
  }

  .lg\\:rounded-tl{
    border-top-left-radius:.25rem
  }

  .lg\\:rounded-tr{
    border-top-right-radius:.25rem
  }

  .lg\\:rounded-br{
    border-bottom-right-radius:.25rem
  }

  .lg\\:rounded-bl{
    border-bottom-left-radius:.25rem
  }

  .lg\\:rounded-tl-md{
    border-top-left-radius:.375rem
  }

  .lg\\:rounded-tr-md{
    border-top-right-radius:.375rem
  }

  .lg\\:rounded-br-md{
    border-bottom-right-radius:.375rem
  }

  .lg\\:rounded-bl-md{
    border-bottom-left-radius:.375rem
  }

  .lg\\:rounded-tl-lg{
    border-top-left-radius:.5rem
  }

  .lg\\:rounded-tr-lg{
    border-top-right-radius:.5rem
  }

  .lg\\:rounded-br-lg{
    border-bottom-right-radius:.5rem
  }

  .lg\\:rounded-bl-lg{
    border-bottom-left-radius:.5rem
  }

  .lg\\:rounded-tl-full{
    border-top-left-radius:9999px
  }

  .lg\\:rounded-tr-full{
    border-top-right-radius:9999px
  }

  .lg\\:rounded-br-full{
    border-bottom-right-radius:9999px
  }

  .lg\\:rounded-bl-full{
    border-bottom-left-radius:9999px
  }

  .lg\\:border-solid{
    border-style:solid
  }

  .lg\\:border-dashed{
    border-style:dashed
  }

  .lg\\:border-dotted{
    border-style:dotted
  }

  .lg\\:border-double{
    border-style:double
  }

  .lg\\:border-none{
    border-style:none
  }

  .lg\\:border-0{
    border-width:0
  }

  .lg\\:border-2{
    border-width:2px
  }

  .lg\\:border-4{
    border-width:4px
  }

  .lg\\:border-8{
    border-width:8px
  }

  .lg\\:border{
    border-width:1px
  }

  .lg\\:border-t-0{
    border-top-width:0
  }

  .lg\\:border-r-0{
    border-right-width:0
  }

  .lg\\:border-b-0{
    border-bottom-width:0
  }

  .lg\\:border-l-0{
    border-left-width:0
  }

  .lg\\:border-t-2{
    border-top-width:2px
  }

  .lg\\:border-r-2{
    border-right-width:2px
  }

  .lg\\:border-b-2{
    border-bottom-width:2px
  }

  .lg\\:border-l-2{
    border-left-width:2px
  }

  .lg\\:border-t-4{
    border-top-width:4px
  }

  .lg\\:border-r-4{
    border-right-width:4px
  }

  .lg\\:border-b-4{
    border-bottom-width:4px
  }

  .lg\\:border-l-4{
    border-left-width:4px
  }

  .lg\\:border-t-8{
    border-top-width:8px
  }

  .lg\\:border-r-8{
    border-right-width:8px
  }

  .lg\\:border-b-8{
    border-bottom-width:8px
  }

  .lg\\:border-l-8{
    border-left-width:8px
  }

  .lg\\:border-t{
    border-top-width:1px
  }

  .lg\\:border-r{
    border-right-width:1px
  }

  .lg\\:border-b{
    border-bottom-width:1px
  }

  .lg\\:border-l{
    border-left-width:1px
  }

  .lg\\:box-border{
    box-sizing:border-box
  }

  .lg\\:box-content{
    box-sizing:initial
  }

  .lg\\:cursor-auto{
    cursor:auto
  }

  .lg\\:cursor-default{
    cursor:default
  }

  .lg\\:cursor-pointer{
    cursor:pointer
  }

  .lg\\:cursor-wait{
    cursor:wait
  }

  .lg\\:cursor-text{
    cursor:text
  }

  .lg\\:cursor-move{
    cursor:move
  }

  .lg\\:cursor-not-allowed{
    cursor:not-allowed
  }

  .lg\\:block{
    display:block
  }

  .lg\\:inline-block{
    display:inline-block
  }

  .lg\\:inline{
    display:inline
  }

  .lg\\:flex{
    display:flex
  }

  .lg\\:inline-flex{
    display:inline-flex
  }

  .lg\\:table{
    display:table
  }

  .lg\\:table-caption{
    display:table-caption
  }

  .lg\\:table-cell{
    display:table-cell
  }

  .lg\\:table-column{
    display:table-column
  }

  .lg\\:table-column-group{
    display:table-column-group
  }

  .lg\\:table-footer-group{
    display:table-footer-group
  }

  .lg\\:table-header-group{
    display:table-header-group
  }

  .lg\\:table-row-group{
    display:table-row-group
  }

  .lg\\:table-row{
    display:table-row
  }

  .lg\\:flow-root{
    display:flow-root
  }

  .lg\\:grid{
    display:grid
  }

  .lg\\:inline-grid{
    display:inline-grid
  }

  .lg\\:hidden{
    display:none
  }

  .theme-dark .lg\\:dark\\:block{
    display:block
  }

  .theme-dark .lg\\:dark\\:inline-block{
    display:inline-block
  }

  .theme-dark .lg\\:dark\\:inline{
    display:inline
  }

  .theme-dark .lg\\:dark\\:flex{
    display:flex
  }

  .theme-dark .lg\\:dark\\:inline-flex{
    display:inline-flex
  }

  .theme-dark .lg\\:dark\\:table{
    display:table
  }

  .theme-dark .lg\\:dark\\:table-caption{
    display:table-caption
  }

  .theme-dark .lg\\:dark\\:table-cell{
    display:table-cell
  }

  .theme-dark .lg\\:dark\\:table-column{
    display:table-column
  }

  .theme-dark .lg\\:dark\\:table-column-group{
    display:table-column-group
  }

  .theme-dark .lg\\:dark\\:table-footer-group{
    display:table-footer-group
  }

  .theme-dark .lg\\:dark\\:table-header-group{
    display:table-header-group
  }

  .theme-dark .lg\\:dark\\:table-row-group{
    display:table-row-group
  }

  .theme-dark .lg\\:dark\\:table-row{
    display:table-row
  }

  .theme-dark .lg\\:dark\\:flow-root{
    display:flow-root
  }

  .theme-dark .lg\\:dark\\:grid{
    display:grid
  }

  .theme-dark .lg\\:dark\\:inline-grid{
    display:inline-grid
  }

  .theme-dark .lg\\:dark\\:hidden{
    display:none
  }

  .lg\\:flex-row{
    flex-direction:row
  }

  .lg\\:flex-row-reverse{
    flex-direction:row-reverse
  }

  .lg\\:flex-col{
    flex-direction:column
  }

  .lg\\:flex-col-reverse{
    flex-direction:column-reverse
  }

  .lg\\:flex-wrap{
    flex-wrap:wrap
  }

  .lg\\:flex-wrap-reverse{
    flex-wrap:wrap-reverse
  }

  .lg\\:flex-no-wrap{
    flex-wrap:nowrap
  }

  .lg\\:items-start{
    align-items:flex-start
  }

  .lg\\:items-end{
    align-items:flex-end
  }

  .lg\\:items-center{
    align-items:center
  }

  .lg\\:items-baseline{
    align-items:baseline
  }

  .lg\\:items-stretch{
    align-items:stretch
  }

  .lg\\:self-auto{
    align-self:auto
  }

  .lg\\:self-start{
    align-self:flex-start
  }

  .lg\\:self-end{
    align-self:flex-end
  }

  .lg\\:self-center{
    align-self:center
  }

  .lg\\:self-stretch{
    align-self:stretch
  }

  .lg\\:justify-start{
    justify-content:flex-start
  }

  .lg\\:justify-end{
    justify-content:flex-end
  }

  .lg\\:justify-center{
    justify-content:center
  }

  .lg\\:justify-between{
    justify-content:space-between
  }

  .lg\\:justify-around{
    justify-content:space-around
  }

  .lg\\:justify-evenly{
    justify-content:space-evenly
  }

  .lg\\:content-center{
    align-content:center
  }

  .lg\\:content-start{
    align-content:flex-start
  }

  .lg\\:content-end{
    align-content:flex-end
  }

  .lg\\:content-between{
    align-content:space-between
  }

  .lg\\:content-around{
    align-content:space-around
  }

  .lg\\:flex-1{
    flex:1 1
  }

  .lg\\:flex-auto{
    flex:1 1 auto
  }

  .lg\\:flex-initial{
    flex:0 1 auto
  }

  .lg\\:flex-none{
    flex:none
  }

  .lg\\:flex-grow-0{
    flex-grow:0
  }

  .lg\\:flex-grow{
    flex-grow:1
  }

  .lg\\:flex-shrink-0{
    flex-shrink:0
  }

  .lg\\:flex-shrink{
    flex-shrink:1
  }

  .lg\\:order-1{
    order:1
  }

  .lg\\:order-2{
    order:2
  }

  .lg\\:order-3{
    order:3
  }

  .lg\\:order-4{
    order:4
  }

  .lg\\:order-5{
    order:5
  }

  .lg\\:order-6{
    order:6
  }

  .lg\\:order-7{
    order:7
  }

  .lg\\:order-8{
    order:8
  }

  .lg\\:order-9{
    order:9
  }

  .lg\\:order-10{
    order:10
  }

  .lg\\:order-11{
    order:11
  }

  .lg\\:order-12{
    order:12
  }

  .lg\\:order-first{
    order:-9999
  }

  .lg\\:order-last{
    order:9999
  }

  .lg\\:order-none{
    order:0
  }

  .lg\\:float-right{
    float:right
  }

  .lg\\:float-left{
    float:left
  }

  .lg\\:float-none{
    float:none
  }

  .lg\\:clearfix:after{
    clear:both;
    content:"";
    display:table
  }

  .lg\\:clear-left{
    clear:left
  }

  .lg\\:clear-right{
    clear:right
  }

  .lg\\:clear-both{
    clear:both
  }

  .lg\\:clear-none{
    clear:none
  }

  .lg\\:font-sans{
    font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji
  }

  .lg\\:font-serif{
    font-family:Georgia,Cambria,Times New Roman,Times,serif
  }

  .lg\\:font-mono{
    font-family:Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace
  }

  .lg\\:font-hairline{
    font-weight:100
  }

  .lg\\:font-thin{
    font-weight:200
  }

  .lg\\:font-light{
    font-weight:300
  }

  .lg\\:font-normal{
    font-weight:400
  }

  .lg\\:font-medium{
    font-weight:500
  }

  .lg\\:font-semibold{
    font-weight:600
  }

  .lg\\:font-bold{
    font-weight:700
  }

  .lg\\:font-extrabold{
    font-weight:800
  }

  .lg\\:font-black{
    font-weight:900
  }

  .lg\\:hover\\:font-hairline:hover{
    font-weight:100
  }

  .lg\\:hover\\:font-thin:hover{
    font-weight:200
  }

  .lg\\:hover\\:font-light:hover{
    font-weight:300
  }

  .lg\\:hover\\:font-normal:hover{
    font-weight:400
  }

  .lg\\:hover\\:font-medium:hover{
    font-weight:500
  }

  .lg\\:hover\\:font-semibold:hover{
    font-weight:600
  }

  .lg\\:hover\\:font-bold:hover{
    font-weight:700
  }

  .lg\\:hover\\:font-extrabold:hover{
    font-weight:800
  }

  .lg\\:hover\\:font-black:hover{
    font-weight:900
  }

  .lg\\:focus\\:font-hairline:focus{
    font-weight:100
  }

  .lg\\:focus\\:font-thin:focus{
    font-weight:200
  }

  .lg\\:focus\\:font-light:focus{
    font-weight:300
  }

  .lg\\:focus\\:font-normal:focus{
    font-weight:400
  }

  .lg\\:focus\\:font-medium:focus{
    font-weight:500
  }

  .lg\\:focus\\:font-semibold:focus{
    font-weight:600
  }

  .lg\\:focus\\:font-bold:focus{
    font-weight:700
  }

  .lg\\:focus\\:font-extrabold:focus{
    font-weight:800
  }

  .lg\\:focus\\:font-black:focus{
    font-weight:900
  }

  .lg\\:h-0{
    height:0
  }

  .lg\\:h-1{
    height:.25rem
  }

  .lg\\:h-2{
    height:.5rem
  }

  .lg\\:h-3{
    height:.75rem
  }

  .lg\\:h-4{
    height:1rem
  }

  .lg\\:h-5{
    height:1.25rem
  }

  .lg\\:h-6{
    height:1.5rem
  }

  .lg\\:h-8{
    height:2rem
  }

  .lg\\:h-10{
    height:2.5rem
  }

  .lg\\:h-12{
    height:3rem
  }

  .lg\\:h-16{
    height:4rem
  }

  .lg\\:h-20{
    height:5rem
  }

  .lg\\:h-24{
    height:6rem
  }

  .lg\\:h-32{
    height:8rem
  }

  .lg\\:h-40{
    height:10rem
  }

  .lg\\:h-48{
    height:12rem
  }

  .lg\\:h-56{
    height:14rem
  }

  .lg\\:h-64{
    height:16rem
  }

  .lg\\:h-auto{
    height:auto
  }

  .lg\\:h-px{
    height:1px
  }

  .lg\\:h-full{
    height:100%
  }

  .lg\\:h-screen{
    height:100vh
  }

  .lg\\:text-xs{
    font-size:.75rem
  }

  .lg\\:text-sm{
    font-size:.875rem
  }

  .lg\\:text-base{
    font-size:1rem
  }

  .lg\\:text-lg{
    font-size:1.125rem
  }

  .lg\\:text-xl{
    font-size:1.25rem
  }

  .lg\\:text-2xl{
    font-size:1.5rem
  }

  .lg\\:text-3xl{
    font-size:1.875rem
  }

  .lg\\:text-4xl{
    font-size:2.25rem
  }

  .lg\\:text-5xl{
    font-size:3rem
  }

  .lg\\:text-6xl{
    font-size:4rem
  }

  .lg\\:leading-3{
    line-height:.75rem
  }

  .lg\\:leading-4{
    line-height:1rem
  }

  .lg\\:leading-5{
    line-height:1.25rem
  }

  .lg\\:leading-6{
    line-height:1.5rem
  }

  .lg\\:leading-7{
    line-height:1.75rem
  }

  .lg\\:leading-8{
    line-height:2rem
  }

  .lg\\:leading-9{
    line-height:2.25rem
  }

  .lg\\:leading-10{
    line-height:2.5rem
  }

  .lg\\:leading-none{
    line-height:1
  }

  .lg\\:leading-tight{
    line-height:1.25
  }

  .lg\\:leading-snug{
    line-height:1.375
  }

  .lg\\:leading-normal{
    line-height:1.5
  }

  .lg\\:leading-relaxed{
    line-height:1.625
  }

  .lg\\:leading-loose{
    line-height:2
  }

  .lg\\:list-inside{
    list-style-position:inside
  }

  .lg\\:list-outside{
    list-style-position:outside
  }

  .lg\\:list-none{
    list-style-type:none
  }

  .lg\\:list-disc{
    list-style-type:disc
  }

  .lg\\:list-decimal{
    list-style-type:decimal
  }

  .lg\\:m-0{
    margin:0
  }

  .lg\\:m-1{
    margin:.25rem
  }

  .lg\\:m-2{
    margin:.5rem
  }

  .lg\\:m-3{
    margin:.75rem
  }

  .lg\\:m-4{
    margin:1rem
  }

  .lg\\:m-5{
    margin:1.25rem
  }

  .lg\\:m-6{
    margin:1.5rem
  }

  .lg\\:m-8{
    margin:2rem
  }

  .lg\\:m-10{
    margin:2.5rem
  }

  .lg\\:m-12{
    margin:3rem
  }

  .lg\\:m-16{
    margin:4rem
  }

  .lg\\:m-20{
    margin:5rem
  }

  .lg\\:m-24{
    margin:6rem
  }

  .lg\\:m-32{
    margin:8rem
  }

  .lg\\:m-40{
    margin:10rem
  }

  .lg\\:m-48{
    margin:12rem
  }

  .lg\\:m-56{
    margin:14rem
  }

  .lg\\:m-64{
    margin:16rem
  }

  .lg\\:m-auto{
    margin:auto
  }

  .lg\\:m-px{
    margin:1px
  }

  .lg\\:-m-1{
    margin:-.25rem
  }

  .lg\\:-m-2{
    margin:-.5rem
  }

  .lg\\:-m-3{
    margin:-.75rem
  }

  .lg\\:-m-4{
    margin:-1rem
  }

  .lg\\:-m-5{
    margin:-1.25rem
  }

  .lg\\:-m-6{
    margin:-1.5rem
  }

  .lg\\:-m-8{
    margin:-2rem
  }

  .lg\\:-m-10{
    margin:-2.5rem
  }

  .lg\\:-m-12{
    margin:-3rem
  }

  .lg\\:-m-16{
    margin:-4rem
  }

  .lg\\:-m-20{
    margin:-5rem
  }

  .lg\\:-m-24{
    margin:-6rem
  }

  .lg\\:-m-32{
    margin:-8rem
  }

  .lg\\:-m-40{
    margin:-10rem
  }

  .lg\\:-m-48{
    margin:-12rem
  }

  .lg\\:-m-56{
    margin:-14rem
  }

  .lg\\:-m-64{
    margin:-16rem
  }

  .lg\\:-m-px{
    margin:-1px
  }

  .lg\\:my-0{
    margin-bottom:0;
    margin-top:0
  }

  .lg\\:mx-0{
    margin-left:0;
    margin-right:0
  }

  .lg\\:my-1{
    margin-bottom:.25rem;
    margin-top:.25rem
  }

  .lg\\:mx-1{
    margin-left:.25rem;
    margin-right:.25rem
  }

  .lg\\:my-2{
    margin-bottom:.5rem;
    margin-top:.5rem
  }

  .lg\\:mx-2{
    margin-left:.5rem;
    margin-right:.5rem
  }

  .lg\\:my-3{
    margin-bottom:.75rem;
    margin-top:.75rem
  }

  .lg\\:mx-3{
    margin-left:.75rem;
    margin-right:.75rem
  }

  .lg\\:my-4{
    margin-bottom:1rem;
    margin-top:1rem
  }

  .lg\\:mx-4{
    margin-left:1rem;
    margin-right:1rem
  }

  .lg\\:my-5{
    margin-bottom:1.25rem;
    margin-top:1.25rem
  }

  .lg\\:mx-5{
    margin-left:1.25rem;
    margin-right:1.25rem
  }

  .lg\\:my-6{
    margin-bottom:1.5rem;
    margin-top:1.5rem
  }

  .lg\\:mx-6{
    margin-left:1.5rem;
    margin-right:1.5rem
  }

  .lg\\:my-8{
    margin-bottom:2rem;
    margin-top:2rem
  }

  .lg\\:mx-8{
    margin-left:2rem;
    margin-right:2rem
  }

  .lg\\:my-10{
    margin-bottom:2.5rem;
    margin-top:2.5rem
  }

  .lg\\:mx-10{
    margin-left:2.5rem;
    margin-right:2.5rem
  }

  .lg\\:my-12{
    margin-bottom:3rem;
    margin-top:3rem
  }

  .lg\\:mx-12{
    margin-left:3rem;
    margin-right:3rem
  }

  .lg\\:my-16{
    margin-bottom:4rem;
    margin-top:4rem
  }

  .lg\\:mx-16{
    margin-left:4rem;
    margin-right:4rem
  }

  .lg\\:my-20{
    margin-bottom:5rem;
    margin-top:5rem
  }

  .lg\\:mx-20{
    margin-left:5rem;
    margin-right:5rem
  }

  .lg\\:my-24{
    margin-bottom:6rem;
    margin-top:6rem
  }

  .lg\\:mx-24{
    margin-left:6rem;
    margin-right:6rem
  }

  .lg\\:my-32{
    margin-bottom:8rem;
    margin-top:8rem
  }

  .lg\\:mx-32{
    margin-left:8rem;
    margin-right:8rem
  }

  .lg\\:my-40{
    margin-bottom:10rem;
    margin-top:10rem
  }

  .lg\\:mx-40{
    margin-left:10rem;
    margin-right:10rem
  }

  .lg\\:my-48{
    margin-bottom:12rem;
    margin-top:12rem
  }

  .lg\\:mx-48{
    margin-left:12rem;
    margin-right:12rem
  }

  .lg\\:my-56{
    margin-bottom:14rem;
    margin-top:14rem
  }

  .lg\\:mx-56{
    margin-left:14rem;
    margin-right:14rem
  }

  .lg\\:my-64{
    margin-bottom:16rem;
    margin-top:16rem
  }

  .lg\\:mx-64{
    margin-left:16rem;
    margin-right:16rem
  }

  .lg\\:my-auto{
    margin-bottom:auto;
    margin-top:auto
  }

  .lg\\:mx-auto{
    margin-left:auto;
    margin-right:auto
  }

  .lg\\:my-px{
    margin-bottom:1px;
    margin-top:1px
  }

  .lg\\:mx-px{
    margin-left:1px;
    margin-right:1px
  }

  .lg\\:-my-1{
    margin-bottom:-.25rem;
    margin-top:-.25rem
  }

  .lg\\:-mx-1{
    margin-left:-.25rem;
    margin-right:-.25rem
  }

  .lg\\:-my-2{
    margin-bottom:-.5rem;
    margin-top:-.5rem
  }

  .lg\\:-mx-2{
    margin-left:-.5rem;
    margin-right:-.5rem
  }

  .lg\\:-my-3{
    margin-bottom:-.75rem;
    margin-top:-.75rem
  }

  .lg\\:-mx-3{
    margin-left:-.75rem;
    margin-right:-.75rem
  }

  .lg\\:-my-4{
    margin-bottom:-1rem;
    margin-top:-1rem
  }

  .lg\\:-mx-4{
    margin-left:-1rem;
    margin-right:-1rem
  }

  .lg\\:-my-5{
    margin-bottom:-1.25rem;
    margin-top:-1.25rem
  }

  .lg\\:-mx-5{
    margin-left:-1.25rem;
    margin-right:-1.25rem
  }

  .lg\\:-my-6{
    margin-bottom:-1.5rem;
    margin-top:-1.5rem
  }

  .lg\\:-mx-6{
    margin-left:-1.5rem;
    margin-right:-1.5rem
  }

  .lg\\:-my-8{
    margin-bottom:-2rem;
    margin-top:-2rem
  }

  .lg\\:-mx-8{
    margin-left:-2rem;
    margin-right:-2rem
  }

  .lg\\:-my-10{
    margin-bottom:-2.5rem;
    margin-top:-2.5rem
  }

  .lg\\:-mx-10{
    margin-left:-2.5rem;
    margin-right:-2.5rem
  }

  .lg\\:-my-12{
    margin-bottom:-3rem;
    margin-top:-3rem
  }

  .lg\\:-mx-12{
    margin-left:-3rem;
    margin-right:-3rem
  }

  .lg\\:-my-16{
    margin-bottom:-4rem;
    margin-top:-4rem
  }

  .lg\\:-mx-16{
    margin-left:-4rem;
    margin-right:-4rem
  }

  .lg\\:-my-20{
    margin-bottom:-5rem;
    margin-top:-5rem
  }

  .lg\\:-mx-20{
    margin-left:-5rem;
    margin-right:-5rem
  }

  .lg\\:-my-24{
    margin-bottom:-6rem;
    margin-top:-6rem
  }

  .lg\\:-mx-24{
    margin-left:-6rem;
    margin-right:-6rem
  }

  .lg\\:-my-32{
    margin-bottom:-8rem;
    margin-top:-8rem
  }

  .lg\\:-mx-32{
    margin-left:-8rem;
    margin-right:-8rem
  }

  .lg\\:-my-40{
    margin-bottom:-10rem;
    margin-top:-10rem
  }

  .lg\\:-mx-40{
    margin-left:-10rem;
    margin-right:-10rem
  }

  .lg\\:-my-48{
    margin-bottom:-12rem;
    margin-top:-12rem
  }

  .lg\\:-mx-48{
    margin-left:-12rem;
    margin-right:-12rem
  }

  .lg\\:-my-56{
    margin-bottom:-14rem;
    margin-top:-14rem
  }

  .lg\\:-mx-56{
    margin-left:-14rem;
    margin-right:-14rem
  }

  .lg\\:-my-64{
    margin-bottom:-16rem;
    margin-top:-16rem
  }

  .lg\\:-mx-64{
    margin-left:-16rem;
    margin-right:-16rem
  }

  .lg\\:-my-px{
    margin-bottom:-1px;
    margin-top:-1px
  }

  .lg\\:-mx-px{
    margin-left:-1px;
    margin-right:-1px
  }

  .lg\\:mt-0{
    margin-top:0
  }

  .lg\\:mr-0{
    margin-right:0
  }

  .lg\\:mb-0{
    margin-bottom:0
  }

  .lg\\:ml-0{
    margin-left:0
  }

  .lg\\:mt-1{
    margin-top:.25rem
  }

  .lg\\:mr-1{
    margin-right:.25rem
  }

  .lg\\:mb-1{
    margin-bottom:.25rem
  }

  .lg\\:ml-1{
    margin-left:.25rem
  }

  .lg\\:mt-2{
    margin-top:.5rem
  }

  .lg\\:mr-2{
    margin-right:.5rem
  }

  .lg\\:mb-2{
    margin-bottom:.5rem
  }

  .lg\\:ml-2{
    margin-left:.5rem
  }

  .lg\\:mt-3{
    margin-top:.75rem
  }

  .lg\\:mr-3{
    margin-right:.75rem
  }

  .lg\\:mb-3{
    margin-bottom:.75rem
  }

  .lg\\:ml-3{
    margin-left:.75rem
  }

  .lg\\:mt-4{
    margin-top:1rem
  }

  .lg\\:mr-4{
    margin-right:1rem
  }

  .lg\\:mb-4{
    margin-bottom:1rem
  }

  .lg\\:ml-4{
    margin-left:1rem
  }

  .lg\\:mt-5{
    margin-top:1.25rem
  }

  .lg\\:mr-5{
    margin-right:1.25rem
  }

  .lg\\:mb-5{
    margin-bottom:1.25rem
  }

  .lg\\:ml-5{
    margin-left:1.25rem
  }

  .lg\\:mt-6{
    margin-top:1.5rem
  }

  .lg\\:mr-6{
    margin-right:1.5rem
  }

  .lg\\:mb-6{
    margin-bottom:1.5rem
  }

  .lg\\:ml-6{
    margin-left:1.5rem
  }

  .lg\\:mt-8{
    margin-top:2rem
  }

  .lg\\:mr-8{
    margin-right:2rem
  }

  .lg\\:mb-8{
    margin-bottom:2rem
  }

  .lg\\:ml-8{
    margin-left:2rem
  }

  .lg\\:mt-10{
    margin-top:2.5rem
  }

  .lg\\:mr-10{
    margin-right:2.5rem
  }

  .lg\\:mb-10{
    margin-bottom:2.5rem
  }

  .lg\\:ml-10{
    margin-left:2.5rem
  }

  .lg\\:mt-12{
    margin-top:3rem
  }

  .lg\\:mr-12{
    margin-right:3rem
  }

  .lg\\:mb-12{
    margin-bottom:3rem
  }

  .lg\\:ml-12{
    margin-left:3rem
  }

  .lg\\:mt-16{
    margin-top:4rem
  }

  .lg\\:mr-16{
    margin-right:4rem
  }

  .lg\\:mb-16{
    margin-bottom:4rem
  }

  .lg\\:ml-16{
    margin-left:4rem
  }

  .lg\\:mt-20{
    margin-top:5rem
  }

  .lg\\:mr-20{
    margin-right:5rem
  }

  .lg\\:mb-20{
    margin-bottom:5rem
  }

  .lg\\:ml-20{
    margin-left:5rem
  }

  .lg\\:mt-24{
    margin-top:6rem
  }

  .lg\\:mr-24{
    margin-right:6rem
  }

  .lg\\:mb-24{
    margin-bottom:6rem
  }

  .lg\\:ml-24{
    margin-left:6rem
  }

  .lg\\:mt-32{
    margin-top:8rem
  }

  .lg\\:mr-32{
    margin-right:8rem
  }

  .lg\\:mb-32{
    margin-bottom:8rem
  }

  .lg\\:ml-32{
    margin-left:8rem
  }

  .lg\\:mt-40{
    margin-top:10rem
  }

  .lg\\:mr-40{
    margin-right:10rem
  }

  .lg\\:mb-40{
    margin-bottom:10rem
  }

  .lg\\:ml-40{
    margin-left:10rem
  }

  .lg\\:mt-48{
    margin-top:12rem
  }

  .lg\\:mr-48{
    margin-right:12rem
  }

  .lg\\:mb-48{
    margin-bottom:12rem
  }

  .lg\\:ml-48{
    margin-left:12rem
  }

  .lg\\:mt-56{
    margin-top:14rem
  }

  .lg\\:mr-56{
    margin-right:14rem
  }

  .lg\\:mb-56{
    margin-bottom:14rem
  }

  .lg\\:ml-56{
    margin-left:14rem
  }

  .lg\\:mt-64{
    margin-top:16rem
  }

  .lg\\:mr-64{
    margin-right:16rem
  }

  .lg\\:mb-64{
    margin-bottom:16rem
  }

  .lg\\:ml-64{
    margin-left:16rem
  }

  .lg\\:mt-auto{
    margin-top:auto
  }

  .lg\\:mr-auto{
    margin-right:auto
  }

  .lg\\:mb-auto{
    margin-bottom:auto
  }

  .lg\\:ml-auto{
    margin-left:auto
  }

  .lg\\:mt-px{
    margin-top:1px
  }

  .lg\\:mr-px{
    margin-right:1px
  }

  .lg\\:mb-px{
    margin-bottom:1px
  }

  .lg\\:ml-px{
    margin-left:1px
  }

  .lg\\:-mt-1{
    margin-top:-.25rem
  }

  .lg\\:-mr-1{
    margin-right:-.25rem
  }

  .lg\\:-mb-1{
    margin-bottom:-.25rem
  }

  .lg\\:-ml-1{
    margin-left:-.25rem
  }

  .lg\\:-mt-2{
    margin-top:-.5rem
  }

  .lg\\:-mr-2{
    margin-right:-.5rem
  }

  .lg\\:-mb-2{
    margin-bottom:-.5rem
  }

  .lg\\:-ml-2{
    margin-left:-.5rem
  }

  .lg\\:-mt-3{
    margin-top:-.75rem
  }

  .lg\\:-mr-3{
    margin-right:-.75rem
  }

  .lg\\:-mb-3{
    margin-bottom:-.75rem
  }

  .lg\\:-ml-3{
    margin-left:-.75rem
  }

  .lg\\:-mt-4{
    margin-top:-1rem
  }

  .lg\\:-mr-4{
    margin-right:-1rem
  }

  .lg\\:-mb-4{
    margin-bottom:-1rem
  }

  .lg\\:-ml-4{
    margin-left:-1rem
  }

  .lg\\:-mt-5{
    margin-top:-1.25rem
  }

  .lg\\:-mr-5{
    margin-right:-1.25rem
  }

  .lg\\:-mb-5{
    margin-bottom:-1.25rem
  }

  .lg\\:-ml-5{
    margin-left:-1.25rem
  }

  .lg\\:-mt-6{
    margin-top:-1.5rem
  }

  .lg\\:-mr-6{
    margin-right:-1.5rem
  }

  .lg\\:-mb-6{
    margin-bottom:-1.5rem
  }

  .lg\\:-ml-6{
    margin-left:-1.5rem
  }

  .lg\\:-mt-8{
    margin-top:-2rem
  }

  .lg\\:-mr-8{
    margin-right:-2rem
  }

  .lg\\:-mb-8{
    margin-bottom:-2rem
  }

  .lg\\:-ml-8{
    margin-left:-2rem
  }

  .lg\\:-mt-10{
    margin-top:-2.5rem
  }

  .lg\\:-mr-10{
    margin-right:-2.5rem
  }

  .lg\\:-mb-10{
    margin-bottom:-2.5rem
  }

  .lg\\:-ml-10{
    margin-left:-2.5rem
  }

  .lg\\:-mt-12{
    margin-top:-3rem
  }

  .lg\\:-mr-12{
    margin-right:-3rem
  }

  .lg\\:-mb-12{
    margin-bottom:-3rem
  }

  .lg\\:-ml-12{
    margin-left:-3rem
  }

  .lg\\:-mt-16{
    margin-top:-4rem
  }

  .lg\\:-mr-16{
    margin-right:-4rem
  }

  .lg\\:-mb-16{
    margin-bottom:-4rem
  }

  .lg\\:-ml-16{
    margin-left:-4rem
  }

  .lg\\:-mt-20{
    margin-top:-5rem
  }

  .lg\\:-mr-20{
    margin-right:-5rem
  }

  .lg\\:-mb-20{
    margin-bottom:-5rem
  }

  .lg\\:-ml-20{
    margin-left:-5rem
  }

  .lg\\:-mt-24{
    margin-top:-6rem
  }

  .lg\\:-mr-24{
    margin-right:-6rem
  }

  .lg\\:-mb-24{
    margin-bottom:-6rem
  }

  .lg\\:-ml-24{
    margin-left:-6rem
  }

  .lg\\:-mt-32{
    margin-top:-8rem
  }

  .lg\\:-mr-32{
    margin-right:-8rem
  }

  .lg\\:-mb-32{
    margin-bottom:-8rem
  }

  .lg\\:-ml-32{
    margin-left:-8rem
  }

  .lg\\:-mt-40{
    margin-top:-10rem
  }

  .lg\\:-mr-40{
    margin-right:-10rem
  }

  .lg\\:-mb-40{
    margin-bottom:-10rem
  }

  .lg\\:-ml-40{
    margin-left:-10rem
  }

  .lg\\:-mt-48{
    margin-top:-12rem
  }

  .lg\\:-mr-48{
    margin-right:-12rem
  }

  .lg\\:-mb-48{
    margin-bottom:-12rem
  }

  .lg\\:-ml-48{
    margin-left:-12rem
  }

  .lg\\:-mt-56{
    margin-top:-14rem
  }

  .lg\\:-mr-56{
    margin-right:-14rem
  }

  .lg\\:-mb-56{
    margin-bottom:-14rem
  }

  .lg\\:-ml-56{
    margin-left:-14rem
  }

  .lg\\:-mt-64{
    margin-top:-16rem
  }

  .lg\\:-mr-64{
    margin-right:-16rem
  }

  .lg\\:-mb-64{
    margin-bottom:-16rem
  }

  .lg\\:-ml-64{
    margin-left:-16rem
  }

  .lg\\:-mt-px{
    margin-top:-1px
  }

  .lg\\:-mr-px{
    margin-right:-1px
  }

  .lg\\:-mb-px{
    margin-bottom:-1px
  }

  .lg\\:-ml-px{
    margin-left:-1px
  }

  .lg\\:last\\:m-0:last-child{
    margin:0
  }

  .lg\\:last\\:m-1:last-child{
    margin:.25rem
  }

  .lg\\:last\\:m-2:last-child{
    margin:.5rem
  }

  .lg\\:last\\:m-3:last-child{
    margin:.75rem
  }

  .lg\\:last\\:m-4:last-child{
    margin:1rem
  }

  .lg\\:last\\:m-5:last-child{
    margin:1.25rem
  }

  .lg\\:last\\:m-6:last-child{
    margin:1.5rem
  }

  .lg\\:last\\:m-8:last-child{
    margin:2rem
  }

  .lg\\:last\\:m-10:last-child{
    margin:2.5rem
  }

  .lg\\:last\\:m-12:last-child{
    margin:3rem
  }

  .lg\\:last\\:m-16:last-child{
    margin:4rem
  }

  .lg\\:last\\:m-20:last-child{
    margin:5rem
  }

  .lg\\:last\\:m-24:last-child{
    margin:6rem
  }

  .lg\\:last\\:m-32:last-child{
    margin:8rem
  }

  .lg\\:last\\:m-40:last-child{
    margin:10rem
  }

  .lg\\:last\\:m-48:last-child{
    margin:12rem
  }

  .lg\\:last\\:m-56:last-child{
    margin:14rem
  }

  .lg\\:last\\:m-64:last-child{
    margin:16rem
  }

  .lg\\:last\\:m-auto:last-child{
    margin:auto
  }

  .lg\\:last\\:m-px:last-child{
    margin:1px
  }

  .lg\\:last\\:-m-1:last-child{
    margin:-.25rem
  }

  .lg\\:last\\:-m-2:last-child{
    margin:-.5rem
  }

  .lg\\:last\\:-m-3:last-child{
    margin:-.75rem
  }

  .lg\\:last\\:-m-4:last-child{
    margin:-1rem
  }

  .lg\\:last\\:-m-5:last-child{
    margin:-1.25rem
  }

  .lg\\:last\\:-m-6:last-child{
    margin:-1.5rem
  }

  .lg\\:last\\:-m-8:last-child{
    margin:-2rem
  }

  .lg\\:last\\:-m-10:last-child{
    margin:-2.5rem
  }

  .lg\\:last\\:-m-12:last-child{
    margin:-3rem
  }

  .lg\\:last\\:-m-16:last-child{
    margin:-4rem
  }

  .lg\\:last\\:-m-20:last-child{
    margin:-5rem
  }

  .lg\\:last\\:-m-24:last-child{
    margin:-6rem
  }

  .lg\\:last\\:-m-32:last-child{
    margin:-8rem
  }

  .lg\\:last\\:-m-40:last-child{
    margin:-10rem
  }

  .lg\\:last\\:-m-48:last-child{
    margin:-12rem
  }

  .lg\\:last\\:-m-56:last-child{
    margin:-14rem
  }

  .lg\\:last\\:-m-64:last-child{
    margin:-16rem
  }

  .lg\\:last\\:-m-px:last-child{
    margin:-1px
  }

  .lg\\:last\\:my-0:last-child{
    margin-bottom:0;
    margin-top:0
  }

  .lg\\:last\\:mx-0:last-child{
    margin-left:0;
    margin-right:0
  }

  .lg\\:last\\:my-1:last-child{
    margin-bottom:.25rem;
    margin-top:.25rem
  }

  .lg\\:last\\:mx-1:last-child{
    margin-left:.25rem;
    margin-right:.25rem
  }

  .lg\\:last\\:my-2:last-child{
    margin-bottom:.5rem;
    margin-top:.5rem
  }

  .lg\\:last\\:mx-2:last-child{
    margin-left:.5rem;
    margin-right:.5rem
  }

  .lg\\:last\\:my-3:last-child{
    margin-bottom:.75rem;
    margin-top:.75rem
  }

  .lg\\:last\\:mx-3:last-child{
    margin-left:.75rem;
    margin-right:.75rem
  }

  .lg\\:last\\:my-4:last-child{
    margin-bottom:1rem;
    margin-top:1rem
  }

  .lg\\:last\\:mx-4:last-child{
    margin-left:1rem;
    margin-right:1rem
  }

  .lg\\:last\\:my-5:last-child{
    margin-bottom:1.25rem;
    margin-top:1.25rem
  }

  .lg\\:last\\:mx-5:last-child{
    margin-left:1.25rem;
    margin-right:1.25rem
  }

  .lg\\:last\\:my-6:last-child{
    margin-bottom:1.5rem;
    margin-top:1.5rem
  }

  .lg\\:last\\:mx-6:last-child{
    margin-left:1.5rem;
    margin-right:1.5rem
  }

  .lg\\:last\\:my-8:last-child{
    margin-bottom:2rem;
    margin-top:2rem
  }

  .lg\\:last\\:mx-8:last-child{
    margin-left:2rem;
    margin-right:2rem
  }

  .lg\\:last\\:my-10:last-child{
    margin-bottom:2.5rem;
    margin-top:2.5rem
  }

  .lg\\:last\\:mx-10:last-child{
    margin-left:2.5rem;
    margin-right:2.5rem
  }

  .lg\\:last\\:my-12:last-child{
    margin-bottom:3rem;
    margin-top:3rem
  }

  .lg\\:last\\:mx-12:last-child{
    margin-left:3rem;
    margin-right:3rem
  }

  .lg\\:last\\:my-16:last-child{
    margin-bottom:4rem;
    margin-top:4rem
  }

  .lg\\:last\\:mx-16:last-child{
    margin-left:4rem;
    margin-right:4rem
  }

  .lg\\:last\\:my-20:last-child{
    margin-bottom:5rem;
    margin-top:5rem
  }

  .lg\\:last\\:mx-20:last-child{
    margin-left:5rem;
    margin-right:5rem
  }

  .lg\\:last\\:my-24:last-child{
    margin-bottom:6rem;
    margin-top:6rem
  }

  .lg\\:last\\:mx-24:last-child{
    margin-left:6rem;
    margin-right:6rem
  }

  .lg\\:last\\:my-32:last-child{
    margin-bottom:8rem;
    margin-top:8rem
  }

  .lg\\:last\\:mx-32:last-child{
    margin-left:8rem;
    margin-right:8rem
  }

  .lg\\:last\\:my-40:last-child{
    margin-bottom:10rem;
    margin-top:10rem
  }

  .lg\\:last\\:mx-40:last-child{
    margin-left:10rem;
    margin-right:10rem
  }

  .lg\\:last\\:my-48:last-child{
    margin-bottom:12rem;
    margin-top:12rem
  }

  .lg\\:last\\:mx-48:last-child{
    margin-left:12rem;
    margin-right:12rem
  }

  .lg\\:last\\:my-56:last-child{
    margin-bottom:14rem;
    margin-top:14rem
  }

  .lg\\:last\\:mx-56:last-child{
    margin-left:14rem;
    margin-right:14rem
  }

  .lg\\:last\\:my-64:last-child{
    margin-bottom:16rem;
    margin-top:16rem
  }

  .lg\\:last\\:mx-64:last-child{
    margin-left:16rem;
    margin-right:16rem
  }

  .lg\\:last\\:my-auto:last-child{
    margin-bottom:auto;
    margin-top:auto
  }

  .lg\\:last\\:mx-auto:last-child{
    margin-left:auto;
    margin-right:auto
  }

  .lg\\:last\\:my-px:last-child{
    margin-bottom:1px;
    margin-top:1px
  }

  .lg\\:last\\:mx-px:last-child{
    margin-left:1px;
    margin-right:1px
  }

  .lg\\:last\\:-my-1:last-child{
    margin-bottom:-.25rem;
    margin-top:-.25rem
  }

  .lg\\:last\\:-mx-1:last-child{
    margin-left:-.25rem;
    margin-right:-.25rem
  }

  .lg\\:last\\:-my-2:last-child{
    margin-bottom:-.5rem;
    margin-top:-.5rem
  }

  .lg\\:last\\:-mx-2:last-child{
    margin-left:-.5rem;
    margin-right:-.5rem
  }

  .lg\\:last\\:-my-3:last-child{
    margin-bottom:-.75rem;
    margin-top:-.75rem
  }

  .lg\\:last\\:-mx-3:last-child{
    margin-left:-.75rem;
    margin-right:-.75rem
  }

  .lg\\:last\\:-my-4:last-child{
    margin-bottom:-1rem;
    margin-top:-1rem
  }

  .lg\\:last\\:-mx-4:last-child{
    margin-left:-1rem;
    margin-right:-1rem
  }

  .lg\\:last\\:-my-5:last-child{
    margin-bottom:-1.25rem;
    margin-top:-1.25rem
  }

  .lg\\:last\\:-mx-5:last-child{
    margin-left:-1.25rem;
    margin-right:-1.25rem
  }

  .lg\\:last\\:-my-6:last-child{
    margin-bottom:-1.5rem;
    margin-top:-1.5rem
  }

  .lg\\:last\\:-mx-6:last-child{
    margin-left:-1.5rem;
    margin-right:-1.5rem
  }

  .lg\\:last\\:-my-8:last-child{
    margin-bottom:-2rem;
    margin-top:-2rem
  }

  .lg\\:last\\:-mx-8:last-child{
    margin-left:-2rem;
    margin-right:-2rem
  }

  .lg\\:last\\:-my-10:last-child{
    margin-bottom:-2.5rem;
    margin-top:-2.5rem
  }

  .lg\\:last\\:-mx-10:last-child{
    margin-left:-2.5rem;
    margin-right:-2.5rem
  }

  .lg\\:last\\:-my-12:last-child{
    margin-bottom:-3rem;
    margin-top:-3rem
  }

  .lg\\:last\\:-mx-12:last-child{
    margin-left:-3rem;
    margin-right:-3rem
  }

  .lg\\:last\\:-my-16:last-child{
    margin-bottom:-4rem;
    margin-top:-4rem
  }

  .lg\\:last\\:-mx-16:last-child{
    margin-left:-4rem;
    margin-right:-4rem
  }

  .lg\\:last\\:-my-20:last-child{
    margin-bottom:-5rem;
    margin-top:-5rem
  }

  .lg\\:last\\:-mx-20:last-child{
    margin-left:-5rem;
    margin-right:-5rem
  }

  .lg\\:last\\:-my-24:last-child{
    margin-bottom:-6rem;
    margin-top:-6rem
  }

  .lg\\:last\\:-mx-24:last-child{
    margin-left:-6rem;
    margin-right:-6rem
  }

  .lg\\:last\\:-my-32:last-child{
    margin-bottom:-8rem;
    margin-top:-8rem
  }

  .lg\\:last\\:-mx-32:last-child{
    margin-left:-8rem;
    margin-right:-8rem
  }

  .lg\\:last\\:-my-40:last-child{
    margin-bottom:-10rem;
    margin-top:-10rem
  }

  .lg\\:last\\:-mx-40:last-child{
    margin-left:-10rem;
    margin-right:-10rem
  }

  .lg\\:last\\:-my-48:last-child{
    margin-bottom:-12rem;
    margin-top:-12rem
  }

  .lg\\:last\\:-mx-48:last-child{
    margin-left:-12rem;
    margin-right:-12rem
  }

  .lg\\:last\\:-my-56:last-child{
    margin-bottom:-14rem;
    margin-top:-14rem
  }

  .lg\\:last\\:-mx-56:last-child{
    margin-left:-14rem;
    margin-right:-14rem
  }

  .lg\\:last\\:-my-64:last-child{
    margin-bottom:-16rem;
    margin-top:-16rem
  }

  .lg\\:last\\:-mx-64:last-child{
    margin-left:-16rem;
    margin-right:-16rem
  }

  .lg\\:last\\:-my-px:last-child{
    margin-bottom:-1px;
    margin-top:-1px
  }

  .lg\\:last\\:-mx-px:last-child{
    margin-left:-1px;
    margin-right:-1px
  }

  .lg\\:last\\:mt-0:last-child{
    margin-top:0
  }

  .lg\\:last\\:mr-0:last-child{
    margin-right:0
  }

  .lg\\:last\\:mb-0:last-child{
    margin-bottom:0
  }

  .lg\\:last\\:ml-0:last-child{
    margin-left:0
  }

  .lg\\:last\\:mt-1:last-child{
    margin-top:.25rem
  }

  .lg\\:last\\:mr-1:last-child{
    margin-right:.25rem
  }

  .lg\\:last\\:mb-1:last-child{
    margin-bottom:.25rem
  }

  .lg\\:last\\:ml-1:last-child{
    margin-left:.25rem
  }

  .lg\\:last\\:mt-2:last-child{
    margin-top:.5rem
  }

  .lg\\:last\\:mr-2:last-child{
    margin-right:.5rem
  }

  .lg\\:last\\:mb-2:last-child{
    margin-bottom:.5rem
  }

  .lg\\:last\\:ml-2:last-child{
    margin-left:.5rem
  }

  .lg\\:last\\:mt-3:last-child{
    margin-top:.75rem
  }

  .lg\\:last\\:mr-3:last-child{
    margin-right:.75rem
  }

  .lg\\:last\\:mb-3:last-child{
    margin-bottom:.75rem
  }

  .lg\\:last\\:ml-3:last-child{
    margin-left:.75rem
  }

  .lg\\:last\\:mt-4:last-child{
    margin-top:1rem
  }

  .lg\\:last\\:mr-4:last-child{
    margin-right:1rem
  }

  .lg\\:last\\:mb-4:last-child{
    margin-bottom:1rem
  }

  .lg\\:last\\:ml-4:last-child{
    margin-left:1rem
  }

  .lg\\:last\\:mt-5:last-child{
    margin-top:1.25rem
  }

  .lg\\:last\\:mr-5:last-child{
    margin-right:1.25rem
  }

  .lg\\:last\\:mb-5:last-child{
    margin-bottom:1.25rem
  }

  .lg\\:last\\:ml-5:last-child{
    margin-left:1.25rem
  }

  .lg\\:last\\:mt-6:last-child{
    margin-top:1.5rem
  }

  .lg\\:last\\:mr-6:last-child{
    margin-right:1.5rem
  }

  .lg\\:last\\:mb-6:last-child{
    margin-bottom:1.5rem
  }

  .lg\\:last\\:ml-6:last-child{
    margin-left:1.5rem
  }

  .lg\\:last\\:mt-8:last-child{
    margin-top:2rem
  }

  .lg\\:last\\:mr-8:last-child{
    margin-right:2rem
  }

  .lg\\:last\\:mb-8:last-child{
    margin-bottom:2rem
  }

  .lg\\:last\\:ml-8:last-child{
    margin-left:2rem
  }

  .lg\\:last\\:mt-10:last-child{
    margin-top:2.5rem
  }

  .lg\\:last\\:mr-10:last-child{
    margin-right:2.5rem
  }

  .lg\\:last\\:mb-10:last-child{
    margin-bottom:2.5rem
  }

  .lg\\:last\\:ml-10:last-child{
    margin-left:2.5rem
  }

  .lg\\:last\\:mt-12:last-child{
    margin-top:3rem
  }

  .lg\\:last\\:mr-12:last-child{
    margin-right:3rem
  }

  .lg\\:last\\:mb-12:last-child{
    margin-bottom:3rem
  }

  .lg\\:last\\:ml-12:last-child{
    margin-left:3rem
  }

  .lg\\:last\\:mt-16:last-child{
    margin-top:4rem
  }

  .lg\\:last\\:mr-16:last-child{
    margin-right:4rem
  }

  .lg\\:last\\:mb-16:last-child{
    margin-bottom:4rem
  }

  .lg\\:last\\:ml-16:last-child{
    margin-left:4rem
  }

  .lg\\:last\\:mt-20:last-child{
    margin-top:5rem
  }

  .lg\\:last\\:mr-20:last-child{
    margin-right:5rem
  }

  .lg\\:last\\:mb-20:last-child{
    margin-bottom:5rem
  }

  .lg\\:last\\:ml-20:last-child{
    margin-left:5rem
  }

  .lg\\:last\\:mt-24:last-child{
    margin-top:6rem
  }

  .lg\\:last\\:mr-24:last-child{
    margin-right:6rem
  }

  .lg\\:last\\:mb-24:last-child{
    margin-bottom:6rem
  }

  .lg\\:last\\:ml-24:last-child{
    margin-left:6rem
  }

  .lg\\:last\\:mt-32:last-child{
    margin-top:8rem
  }

  .lg\\:last\\:mr-32:last-child{
    margin-right:8rem
  }

  .lg\\:last\\:mb-32:last-child{
    margin-bottom:8rem
  }

  .lg\\:last\\:ml-32:last-child{
    margin-left:8rem
  }

  .lg\\:last\\:mt-40:last-child{
    margin-top:10rem
  }

  .lg\\:last\\:mr-40:last-child{
    margin-right:10rem
  }

  .lg\\:last\\:mb-40:last-child{
    margin-bottom:10rem
  }

  .lg\\:last\\:ml-40:last-child{
    margin-left:10rem
  }

  .lg\\:last\\:mt-48:last-child{
    margin-top:12rem
  }

  .lg\\:last\\:mr-48:last-child{
    margin-right:12rem
  }

  .lg\\:last\\:mb-48:last-child{
    margin-bottom:12rem
  }

  .lg\\:last\\:ml-48:last-child{
    margin-left:12rem
  }

  .lg\\:last\\:mt-56:last-child{
    margin-top:14rem
  }

  .lg\\:last\\:mr-56:last-child{
    margin-right:14rem
  }

  .lg\\:last\\:mb-56:last-child{
    margin-bottom:14rem
  }

  .lg\\:last\\:ml-56:last-child{
    margin-left:14rem
  }

  .lg\\:last\\:mt-64:last-child{
    margin-top:16rem
  }

  .lg\\:last\\:mr-64:last-child{
    margin-right:16rem
  }

  .lg\\:last\\:mb-64:last-child{
    margin-bottom:16rem
  }

  .lg\\:last\\:ml-64:last-child{
    margin-left:16rem
  }

  .lg\\:last\\:mt-auto:last-child{
    margin-top:auto
  }

  .lg\\:last\\:mr-auto:last-child{
    margin-right:auto
  }

  .lg\\:last\\:mb-auto:last-child{
    margin-bottom:auto
  }

  .lg\\:last\\:ml-auto:last-child{
    margin-left:auto
  }

  .lg\\:last\\:mt-px:last-child{
    margin-top:1px
  }

  .lg\\:last\\:mr-px:last-child{
    margin-right:1px
  }

  .lg\\:last\\:mb-px:last-child{
    margin-bottom:1px
  }

  .lg\\:last\\:ml-px:last-child{
    margin-left:1px
  }

  .lg\\:last\\:-mt-1:last-child{
    margin-top:-.25rem
  }

  .lg\\:last\\:-mr-1:last-child{
    margin-right:-.25rem
  }

  .lg\\:last\\:-mb-1:last-child{
    margin-bottom:-.25rem
  }

  .lg\\:last\\:-ml-1:last-child{
    margin-left:-.25rem
  }

  .lg\\:last\\:-mt-2:last-child{
    margin-top:-.5rem
  }

  .lg\\:last\\:-mr-2:last-child{
    margin-right:-.5rem
  }

  .lg\\:last\\:-mb-2:last-child{
    margin-bottom:-.5rem
  }

  .lg\\:last\\:-ml-2:last-child{
    margin-left:-.5rem
  }

  .lg\\:last\\:-mt-3:last-child{
    margin-top:-.75rem
  }

  .lg\\:last\\:-mr-3:last-child{
    margin-right:-.75rem
  }

  .lg\\:last\\:-mb-3:last-child{
    margin-bottom:-.75rem
  }

  .lg\\:last\\:-ml-3:last-child{
    margin-left:-.75rem
  }

  .lg\\:last\\:-mt-4:last-child{
    margin-top:-1rem
  }

  .lg\\:last\\:-mr-4:last-child{
    margin-right:-1rem
  }

  .lg\\:last\\:-mb-4:last-child{
    margin-bottom:-1rem
  }

  .lg\\:last\\:-ml-4:last-child{
    margin-left:-1rem
  }

  .lg\\:last\\:-mt-5:last-child{
    margin-top:-1.25rem
  }

  .lg\\:last\\:-mr-5:last-child{
    margin-right:-1.25rem
  }

  .lg\\:last\\:-mb-5:last-child{
    margin-bottom:-1.25rem
  }

  .lg\\:last\\:-ml-5:last-child{
    margin-left:-1.25rem
  }

  .lg\\:last\\:-mt-6:last-child{
    margin-top:-1.5rem
  }

  .lg\\:last\\:-mr-6:last-child{
    margin-right:-1.5rem
  }

  .lg\\:last\\:-mb-6:last-child{
    margin-bottom:-1.5rem
  }

  .lg\\:last\\:-ml-6:last-child{
    margin-left:-1.5rem
  }

  .lg\\:last\\:-mt-8:last-child{
    margin-top:-2rem
  }

  .lg\\:last\\:-mr-8:last-child{
    margin-right:-2rem
  }

  .lg\\:last\\:-mb-8:last-child{
    margin-bottom:-2rem
  }

  .lg\\:last\\:-ml-8:last-child{
    margin-left:-2rem
  }

  .lg\\:last\\:-mt-10:last-child{
    margin-top:-2.5rem
  }

  .lg\\:last\\:-mr-10:last-child{
    margin-right:-2.5rem
  }

  .lg\\:last\\:-mb-10:last-child{
    margin-bottom:-2.5rem
  }

  .lg\\:last\\:-ml-10:last-child{
    margin-left:-2.5rem
  }

  .lg\\:last\\:-mt-12:last-child{
    margin-top:-3rem
  }

  .lg\\:last\\:-mr-12:last-child{
    margin-right:-3rem
  }

  .lg\\:last\\:-mb-12:last-child{
    margin-bottom:-3rem
  }

  .lg\\:last\\:-ml-12:last-child{
    margin-left:-3rem
  }

  .lg\\:last\\:-mt-16:last-child{
    margin-top:-4rem
  }

  .lg\\:last\\:-mr-16:last-child{
    margin-right:-4rem
  }

  .lg\\:last\\:-mb-16:last-child{
    margin-bottom:-4rem
  }

  .lg\\:last\\:-ml-16:last-child{
    margin-left:-4rem
  }

  .lg\\:last\\:-mt-20:last-child{
    margin-top:-5rem
  }

  .lg\\:last\\:-mr-20:last-child{
    margin-right:-5rem
  }

  .lg\\:last\\:-mb-20:last-child{
    margin-bottom:-5rem
  }

  .lg\\:last\\:-ml-20:last-child{
    margin-left:-5rem
  }

  .lg\\:last\\:-mt-24:last-child{
    margin-top:-6rem
  }

  .lg\\:last\\:-mr-24:last-child{
    margin-right:-6rem
  }

  .lg\\:last\\:-mb-24:last-child{
    margin-bottom:-6rem
  }

  .lg\\:last\\:-ml-24:last-child{
    margin-left:-6rem
  }

  .lg\\:last\\:-mt-32:last-child{
    margin-top:-8rem
  }

  .lg\\:last\\:-mr-32:last-child{
    margin-right:-8rem
  }

  .lg\\:last\\:-mb-32:last-child{
    margin-bottom:-8rem
  }

  .lg\\:last\\:-ml-32:last-child{
    margin-left:-8rem
  }

  .lg\\:last\\:-mt-40:last-child{
    margin-top:-10rem
  }

  .lg\\:last\\:-mr-40:last-child{
    margin-right:-10rem
  }

  .lg\\:last\\:-mb-40:last-child{
    margin-bottom:-10rem
  }

  .lg\\:last\\:-ml-40:last-child{
    margin-left:-10rem
  }

  .lg\\:last\\:-mt-48:last-child{
    margin-top:-12rem
  }

  .lg\\:last\\:-mr-48:last-child{
    margin-right:-12rem
  }

  .lg\\:last\\:-mb-48:last-child{
    margin-bottom:-12rem
  }

  .lg\\:last\\:-ml-48:last-child{
    margin-left:-12rem
  }

  .lg\\:last\\:-mt-56:last-child{
    margin-top:-14rem
  }

  .lg\\:last\\:-mr-56:last-child{
    margin-right:-14rem
  }

  .lg\\:last\\:-mb-56:last-child{
    margin-bottom:-14rem
  }

  .lg\\:last\\:-ml-56:last-child{
    margin-left:-14rem
  }

  .lg\\:last\\:-mt-64:last-child{
    margin-top:-16rem
  }

  .lg\\:last\\:-mr-64:last-child{
    margin-right:-16rem
  }

  .lg\\:last\\:-mb-64:last-child{
    margin-bottom:-16rem
  }

  .lg\\:last\\:-ml-64:last-child{
    margin-left:-16rem
  }

  .lg\\:last\\:-mt-px:last-child{
    margin-top:-1px
  }

  .lg\\:last\\:-mr-px:last-child{
    margin-right:-1px
  }

  .lg\\:last\\:-mb-px:last-child{
    margin-bottom:-1px
  }

  .lg\\:last\\:-ml-px:last-child{
    margin-left:-1px
  }

  .lg\\:max-h-0{
    max-height:0
  }

  .lg\\:max-h-1{
    max-height:.25rem
  }

  .lg\\:max-h-2{
    max-height:.5rem
  }

  .lg\\:max-h-3{
    max-height:.75rem
  }

  .lg\\:max-h-4{
    max-height:1rem
  }

  .lg\\:max-h-5{
    max-height:1.25rem
  }

  .lg\\:max-h-6{
    max-height:1.5rem
  }

  .lg\\:max-h-8{
    max-height:2rem
  }

  .lg\\:max-h-10{
    max-height:2.5rem
  }

  .lg\\:max-h-12{
    max-height:3rem
  }

  .lg\\:max-h-16{
    max-height:4rem
  }

  .lg\\:max-h-20{
    max-height:5rem
  }

  .lg\\:max-h-24{
    max-height:6rem
  }

  .lg\\:max-h-32{
    max-height:8rem
  }

  .lg\\:max-h-40{
    max-height:10rem
  }

  .lg\\:max-h-48{
    max-height:12rem
  }

  .lg\\:max-h-56{
    max-height:14rem
  }

  .lg\\:max-h-64{
    max-height:16rem
  }

  .lg\\:max-h-xl{
    max-height:36rem
  }

  .lg\\:max-h-px{
    max-height:1px
  }

  .lg\\:max-w-none{
    max-width:none
  }

  .lg\\:max-w-xs{
    max-width:20rem
  }

  .lg\\:max-w-sm{
    max-width:24rem
  }

  .lg\\:max-w-md{
    max-width:28rem
  }

  .lg\\:max-w-lg{
    max-width:32rem
  }

  .lg\\:max-w-xl{
    max-width:36rem
  }

  .lg\\:max-w-2xl{
    max-width:42rem
  }

  .lg\\:max-w-3xl{
    max-width:48rem
  }

  .lg\\:max-w-4xl{
    max-width:56rem
  }

  .lg\\:max-w-5xl{
    max-width:64rem
  }

  .lg\\:max-w-6xl{
    max-width:72rem
  }

  .lg\\:max-w-full{
    max-width:100%
  }

  .lg\\:max-w-screen-sm{
    max-width:640px
  }

  .lg\\:max-w-screen-md{
    max-width:768px
  }

  .lg\\:max-w-screen-lg{
    max-width:1024px
  }

  .lg\\:max-w-screen-xl{
    max-width:1280px
  }

  .lg\\:min-h-0{
    min-height:0
  }

  .lg\\:min-h-full{
    min-height:100%
  }

  .lg\\:min-h-screen{
    min-height:100vh
  }

  .lg\\:min-w-0{
    min-width:0
  }

  .lg\\:min-w-1{
    min-width:.25rem
  }

  .lg\\:min-w-2{
    min-width:.5rem
  }

  .lg\\:min-w-3{
    min-width:.75rem
  }

  .lg\\:min-w-4{
    min-width:1rem
  }

  .lg\\:min-w-5{
    min-width:1.25rem
  }

  .lg\\:min-w-6{
    min-width:1.5rem
  }

  .lg\\:min-w-8{
    min-width:2rem
  }

  .lg\\:min-w-10{
    min-width:2.5rem
  }

  .lg\\:min-w-12{
    min-width:3rem
  }

  .lg\\:min-w-16{
    min-width:4rem
  }

  .lg\\:min-w-20{
    min-width:5rem
  }

  .lg\\:min-w-24{
    min-width:6rem
  }

  .lg\\:min-w-32{
    min-width:8rem
  }

  .lg\\:min-w-40{
    min-width:10rem
  }

  .lg\\:min-w-48{
    min-width:12rem
  }

  .lg\\:min-w-56{
    min-width:14rem
  }

  .lg\\:min-w-64{
    min-width:16rem
  }

  .lg\\:min-w-max-content{
    min-width:max-content
  }

  .lg\\:min-w-px{
    min-width:1px
  }

  .lg\\:object-contain{
    object-fit:contain
  }

  .lg\\:object-cover{
    object-fit:cover
  }

  .lg\\:object-fill{
    object-fit:fill
  }

  .lg\\:object-none{
    object-fit:none
  }

  .lg\\:object-scale-down{
    object-fit:scale-down
  }

  .lg\\:object-bottom{
    object-position:bottom
  }

  .lg\\:object-center{
    object-position:center
  }

  .lg\\:object-left{
    object-position:left
  }

  .lg\\:object-left-bottom{
    object-position:left bottom
  }

  .lg\\:object-left-top{
    object-position:left top
  }

  .lg\\:object-right{
    object-position:right
  }

  .lg\\:object-right-bottom{
    object-position:right bottom
  }

  .lg\\:object-right-top{
    object-position:right top
  }

  .lg\\:object-top{
    object-position:top
  }

  .lg\\:opacity-0{
    opacity:0
  }

  .lg\\:opacity-25{
    opacity:.25
  }

  .lg\\:opacity-50{
    opacity:.5
  }

  .lg\\:opacity-75{
    opacity:.75
  }

  .lg\\:opacity-100{
    opacity:1
  }

  .lg\\:hover\\:opacity-0:hover{
    opacity:0
  }

  .lg\\:hover\\:opacity-25:hover{
    opacity:.25
  }

  .lg\\:hover\\:opacity-50:hover{
    opacity:.5
  }

  .lg\\:hover\\:opacity-75:hover{
    opacity:.75
  }

  .lg\\:hover\\:opacity-100:hover{
    opacity:1
  }

  .lg\\:focus\\:opacity-0:focus{
    opacity:0
  }

  .lg\\:focus\\:opacity-25:focus{
    opacity:.25
  }

  .lg\\:focus\\:opacity-50:focus{
    opacity:.5
  }

  .lg\\:focus\\:opacity-75:focus{
    opacity:.75
  }

  .lg\\:focus\\:opacity-100:focus{
    opacity:1
  }

  .lg\\:focus\\:outline-none:focus,.lg\\:outline-none{
    outline:0
  }

  .lg\\:overflow-auto{
    overflow:auto
  }

  .lg\\:overflow-hidden{
    overflow:hidden
  }

  .lg\\:overflow-visible{
    overflow:visible
  }

  .lg\\:overflow-scroll{
    overflow:scroll
  }

  .lg\\:overflow-x-auto{
    overflow-x:auto
  }

  .lg\\:overflow-y-auto{
    overflow-y:auto
  }

  .lg\\:overflow-x-hidden{
    overflow-x:hidden
  }

  .lg\\:overflow-y-hidden{
    overflow-y:hidden
  }

  .lg\\:overflow-x-visible{
    overflow-x:visible
  }

  .lg\\:overflow-y-visible{
    overflow-y:visible
  }

  .lg\\:overflow-x-scroll{
    overflow-x:scroll
  }

  .lg\\:overflow-y-scroll{
    overflow-y:scroll
  }

  .lg\\:scrolling-touch{
    -webkit-overflow-scrolling:touch
  }

  .lg\\:scrolling-auto{
    -webkit-overflow-scrolling:auto
  }

  .lg\\:p-0{
    padding:0
  }

  .lg\\:p-1{
    padding:.25rem
  }

  .lg\\:p-2{
    padding:.5rem
  }

  .lg\\:p-3{
    padding:.75rem
  }

  .lg\\:p-4{
    padding:1rem
  }

  .lg\\:p-5{
    padding:1.25rem
  }

  .lg\\:p-6{
    padding:1.5rem
  }

  .lg\\:p-8{
    padding:2rem
  }

  .lg\\:p-10{
    padding:2.5rem
  }

  .lg\\:p-12{
    padding:3rem
  }

  .lg\\:p-16{
    padding:4rem
  }

  .lg\\:p-20{
    padding:5rem
  }

  .lg\\:p-24{
    padding:6rem
  }

  .lg\\:p-32{
    padding:8rem
  }

  .lg\\:p-40{
    padding:10rem
  }

  .lg\\:p-48{
    padding:12rem
  }

  .lg\\:p-56{
    padding:14rem
  }

  .lg\\:p-64{
    padding:16rem
  }

  .lg\\:p-px{
    padding:1px
  }

  .lg\\:py-0{
    padding-bottom:0;
    padding-top:0
  }

  .lg\\:px-0{
    padding-left:0;
    padding-right:0
  }

  .lg\\:py-1{
    padding-bottom:.25rem;
    padding-top:.25rem
  }

  .lg\\:px-1{
    padding-left:.25rem;
    padding-right:.25rem
  }

  .lg\\:py-2{
    padding-bottom:.5rem;
    padding-top:.5rem
  }

  .lg\\:px-2{
    padding-left:.5rem;
    padding-right:.5rem
  }

  .lg\\:py-3{
    padding-bottom:.75rem;
    padding-top:.75rem
  }

  .lg\\:px-3{
    padding-left:.75rem;
    padding-right:.75rem
  }

  .lg\\:py-4{
    padding-bottom:1rem;
    padding-top:1rem
  }

  .lg\\:px-4{
    padding-left:1rem;
    padding-right:1rem
  }

  .lg\\:py-5{
    padding-bottom:1.25rem;
    padding-top:1.25rem
  }

  .lg\\:px-5{
    padding-left:1.25rem;
    padding-right:1.25rem
  }

  .lg\\:py-6{
    padding-bottom:1.5rem;
    padding-top:1.5rem
  }

  .lg\\:px-6{
    padding-left:1.5rem;
    padding-right:1.5rem
  }

  .lg\\:py-8{
    padding-bottom:2rem;
    padding-top:2rem
  }

  .lg\\:px-8{
    padding-left:2rem;
    padding-right:2rem
  }

  .lg\\:py-10{
    padding-bottom:2.5rem;
    padding-top:2.5rem
  }

  .lg\\:px-10{
    padding-left:2.5rem;
    padding-right:2.5rem
  }

  .lg\\:py-12{
    padding-bottom:3rem;
    padding-top:3rem
  }

  .lg\\:px-12{
    padding-left:3rem;
    padding-right:3rem
  }

  .lg\\:py-16{
    padding-bottom:4rem;
    padding-top:4rem
  }

  .lg\\:px-16{
    padding-left:4rem;
    padding-right:4rem
  }

  .lg\\:py-20{
    padding-bottom:5rem;
    padding-top:5rem
  }

  .lg\\:px-20{
    padding-left:5rem;
    padding-right:5rem
  }

  .lg\\:py-24{
    padding-bottom:6rem;
    padding-top:6rem
  }

  .lg\\:px-24{
    padding-left:6rem;
    padding-right:6rem
  }

  .lg\\:py-32{
    padding-bottom:8rem;
    padding-top:8rem
  }

  .lg\\:px-32{
    padding-left:8rem;
    padding-right:8rem
  }

  .lg\\:py-40{
    padding-bottom:10rem;
    padding-top:10rem
  }

  .lg\\:px-40{
    padding-left:10rem;
    padding-right:10rem
  }

  .lg\\:py-48{
    padding-bottom:12rem;
    padding-top:12rem
  }

  .lg\\:px-48{
    padding-left:12rem;
    padding-right:12rem
  }

  .lg\\:py-56{
    padding-bottom:14rem;
    padding-top:14rem
  }

  .lg\\:px-56{
    padding-left:14rem;
    padding-right:14rem
  }

  .lg\\:py-64{
    padding-bottom:16rem;
    padding-top:16rem
  }

  .lg\\:px-64{
    padding-left:16rem;
    padding-right:16rem
  }

  .lg\\:py-px{
    padding-bottom:1px;
    padding-top:1px
  }

  .lg\\:px-px{
    padding-left:1px;
    padding-right:1px
  }

  .lg\\:pt-0{
    padding-top:0
  }

  .lg\\:pr-0{
    padding-right:0
  }

  .lg\\:pb-0{
    padding-bottom:0
  }

  .lg\\:pl-0{
    padding-left:0
  }

  .lg\\:pt-1{
    padding-top:.25rem
  }

  .lg\\:pr-1{
    padding-right:.25rem
  }

  .lg\\:pb-1{
    padding-bottom:.25rem
  }

  .lg\\:pl-1{
    padding-left:.25rem
  }

  .lg\\:pt-2{
    padding-top:.5rem
  }

  .lg\\:pr-2{
    padding-right:.5rem
  }

  .lg\\:pb-2{
    padding-bottom:.5rem
  }

  .lg\\:pl-2{
    padding-left:.5rem
  }

  .lg\\:pt-3{
    padding-top:.75rem
  }

  .lg\\:pr-3{
    padding-right:.75rem
  }

  .lg\\:pb-3{
    padding-bottom:.75rem
  }

  .lg\\:pl-3{
    padding-left:.75rem
  }

  .lg\\:pt-4{
    padding-top:1rem
  }

  .lg\\:pr-4{
    padding-right:1rem
  }

  .lg\\:pb-4{
    padding-bottom:1rem
  }

  .lg\\:pl-4{
    padding-left:1rem
  }

  .lg\\:pt-5{
    padding-top:1.25rem
  }

  .lg\\:pr-5{
    padding-right:1.25rem
  }

  .lg\\:pb-5{
    padding-bottom:1.25rem
  }

  .lg\\:pl-5{
    padding-left:1.25rem
  }

  .lg\\:pt-6{
    padding-top:1.5rem
  }

  .lg\\:pr-6{
    padding-right:1.5rem
  }

  .lg\\:pb-6{
    padding-bottom:1.5rem
  }

  .lg\\:pl-6{
    padding-left:1.5rem
  }

  .lg\\:pt-8{
    padding-top:2rem
  }

  .lg\\:pr-8{
    padding-right:2rem
  }

  .lg\\:pb-8{
    padding-bottom:2rem
  }

  .lg\\:pl-8{
    padding-left:2rem
  }

  .lg\\:pt-10{
    padding-top:2.5rem
  }

  .lg\\:pr-10{
    padding-right:2.5rem
  }

  .lg\\:pb-10{
    padding-bottom:2.5rem
  }

  .lg\\:pl-10{
    padding-left:2.5rem
  }

  .lg\\:pt-12{
    padding-top:3rem
  }

  .lg\\:pr-12{
    padding-right:3rem
  }

  .lg\\:pb-12{
    padding-bottom:3rem
  }

  .lg\\:pl-12{
    padding-left:3rem
  }

  .lg\\:pt-16{
    padding-top:4rem
  }

  .lg\\:pr-16{
    padding-right:4rem
  }

  .lg\\:pb-16{
    padding-bottom:4rem
  }

  .lg\\:pl-16{
    padding-left:4rem
  }

  .lg\\:pt-20{
    padding-top:5rem
  }

  .lg\\:pr-20{
    padding-right:5rem
  }

  .lg\\:pb-20{
    padding-bottom:5rem
  }

  .lg\\:pl-20{
    padding-left:5rem
  }

  .lg\\:pt-24{
    padding-top:6rem
  }

  .lg\\:pr-24{
    padding-right:6rem
  }

  .lg\\:pb-24{
    padding-bottom:6rem
  }

  .lg\\:pl-24{
    padding-left:6rem
  }

  .lg\\:pt-32{
    padding-top:8rem
  }

  .lg\\:pr-32{
    padding-right:8rem
  }

  .lg\\:pb-32{
    padding-bottom:8rem
  }

  .lg\\:pl-32{
    padding-left:8rem
  }

  .lg\\:pt-40{
    padding-top:10rem
  }

  .lg\\:pr-40{
    padding-right:10rem
  }

  .lg\\:pb-40{
    padding-bottom:10rem
  }

  .lg\\:pl-40{
    padding-left:10rem
  }

  .lg\\:pt-48{
    padding-top:12rem
  }

  .lg\\:pr-48{
    padding-right:12rem
  }

  .lg\\:pb-48{
    padding-bottom:12rem
  }

  .lg\\:pl-48{
    padding-left:12rem
  }

  .lg\\:pt-56{
    padding-top:14rem
  }

  .lg\\:pr-56{
    padding-right:14rem
  }

  .lg\\:pb-56{
    padding-bottom:14rem
  }

  .lg\\:pl-56{
    padding-left:14rem
  }

  .lg\\:pt-64{
    padding-top:16rem
  }

  .lg\\:pr-64{
    padding-right:16rem
  }

  .lg\\:pb-64{
    padding-bottom:16rem
  }

  .lg\\:pl-64{
    padding-left:16rem
  }

  .lg\\:pt-px{
    padding-top:1px
  }

  .lg\\:pr-px{
    padding-right:1px
  }

  .lg\\:pb-px{
    padding-bottom:1px
  }

  .lg\\:pl-px{
    padding-left:1px
  }

  .lg\\:placeholder-transparent::placeholder{
    color:#0000
  }

  .lg\\:placeholder-white::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .lg\\:placeholder-black::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .lg\\:placeholder-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .lg\\:placeholder-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .lg\\:placeholder-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .lg\\:placeholder-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .lg\\:placeholder-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .lg\\:placeholder-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .lg\\:placeholder-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .lg\\:placeholder-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .lg\\:placeholder-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .lg\\:placeholder-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .lg\\:placeholder-cool-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .lg\\:placeholder-cool-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .lg\\:placeholder-cool-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .lg\\:placeholder-cool-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .lg\\:placeholder-cool-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .lg\\:placeholder-cool-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .lg\\:placeholder-cool-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .lg\\:placeholder-cool-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .lg\\:placeholder-cool-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .lg\\:placeholder-cool-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .lg\\:placeholder-red-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .lg\\:placeholder-red-100::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .lg\\:placeholder-red-200::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .lg\\:placeholder-red-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .lg\\:placeholder-red-400::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .lg\\:placeholder-red-500::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .lg\\:placeholder-red-600::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .lg\\:placeholder-red-700::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .lg\\:placeholder-red-800::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .lg\\:placeholder-red-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .lg\\:placeholder-orange-50::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .lg\\:placeholder-orange-100::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .lg\\:placeholder-orange-200::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .lg\\:placeholder-orange-300::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .lg\\:placeholder-orange-400::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .lg\\:placeholder-orange-500::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .lg\\:placeholder-orange-600::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .lg\\:placeholder-orange-700::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .lg\\:placeholder-orange-800::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .lg\\:placeholder-orange-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .lg\\:placeholder-yellow-50::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .lg\\:placeholder-yellow-100::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .lg\\:placeholder-yellow-200::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .lg\\:placeholder-yellow-300::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .lg\\:placeholder-yellow-400::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .lg\\:placeholder-yellow-500::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .lg\\:placeholder-yellow-600::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .lg\\:placeholder-yellow-700::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .lg\\:placeholder-yellow-800::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .lg\\:placeholder-yellow-900::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .lg\\:placeholder-green-50::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .lg\\:placeholder-green-100::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .lg\\:placeholder-green-200::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .lg\\:placeholder-green-300::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .lg\\:placeholder-green-400::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .lg\\:placeholder-green-500::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .lg\\:placeholder-green-600::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .lg\\:placeholder-green-700::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .lg\\:placeholder-green-800::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .lg\\:placeholder-green-900::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .lg\\:placeholder-teal-50::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .lg\\:placeholder-teal-100::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .lg\\:placeholder-teal-200::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .lg\\:placeholder-teal-300::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .lg\\:placeholder-teal-400::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .lg\\:placeholder-teal-500::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .lg\\:placeholder-teal-600::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .lg\\:placeholder-teal-700::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .lg\\:placeholder-teal-800::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .lg\\:placeholder-teal-900::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .lg\\:placeholder-blue-50::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .lg\\:placeholder-blue-100::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .lg\\:placeholder-blue-200::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .lg\\:placeholder-blue-300::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .lg\\:placeholder-blue-400::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .lg\\:placeholder-blue-500::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .lg\\:placeholder-blue-600::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .lg\\:placeholder-blue-700::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .lg\\:placeholder-blue-800::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .lg\\:placeholder-blue-900::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .lg\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .lg\\:placeholder-pink-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .lg\\:placeholder-pink-100::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .lg\\:placeholder-pink-200::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .lg\\:placeholder-pink-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .lg\\:placeholder-pink-400::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .lg\\:placeholder-pink-500::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .lg\\:placeholder-pink-600::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .lg\\:placeholder-pink-700::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .lg\\:placeholder-pink-800::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .lg\\:placeholder-pink-900::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-transparent:focus::placeholder{
    color:#0000
  }

  .lg\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-cool-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-cool-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-cool-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-cool-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-cool-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-cool-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-cool-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-cool-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-cool-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-cool-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-red-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-red-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-red-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-red-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-red-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-red-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-red-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-red-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-red-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-red-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-orange-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-orange-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-orange-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-orange-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-orange-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-orange-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-orange-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-orange-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-orange-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-orange-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-yellow-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-yellow-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-yellow-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-yellow-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-yellow-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-yellow-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-yellow-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-yellow-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-yellow-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-yellow-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-green-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-green-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-green-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-green-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-green-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-green-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-green-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-green-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-green-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-green-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-teal-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-teal-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-teal-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-teal-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-teal-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-teal-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-teal-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-teal-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-teal-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-teal-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-blue-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-blue-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-blue-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-blue-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-blue-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-blue-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-blue-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-blue-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-blue-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-blue-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-pink-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-pink-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-pink-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-pink-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-pink-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-pink-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-pink-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-pink-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-pink-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .lg\\:focus\\:placeholder-pink-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-transparent::placeholder{
    color:#0000
  }

  .theme-dark .lg\\:dark\\:placeholder-white::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-black::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-cool-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-cool-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-cool-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-cool-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-cool-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-cool-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-cool-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-cool-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-cool-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-cool-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-red-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-red-100::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-red-200::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-red-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-red-400::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-red-500::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-red-600::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-red-700::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-red-800::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-red-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-orange-50::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-orange-100::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-orange-200::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-orange-300::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-orange-400::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-orange-500::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-orange-600::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-orange-700::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-orange-800::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-orange-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-yellow-50::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-yellow-100::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-yellow-200::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-yellow-300::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-yellow-400::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-yellow-500::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-yellow-600::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-yellow-700::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-yellow-800::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-yellow-900::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-green-50::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-green-100::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-green-200::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-green-300::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-green-400::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-green-500::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-green-600::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-green-700::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-green-800::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-green-900::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-teal-50::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-teal-100::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-teal-200::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-teal-300::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-teal-400::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-teal-500::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-teal-600::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-teal-700::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-teal-800::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-teal-900::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-blue-50::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-blue-100::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-blue-200::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-blue-300::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-blue-400::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-blue-500::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-blue-600::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-blue-700::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-blue-800::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-blue-900::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-pink-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-pink-100::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-pink-200::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-pink-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-pink-400::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-pink-500::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-pink-600::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-pink-700::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-pink-800::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:placeholder-pink-900::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-transparent:focus::placeholder{
    color:#0000
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-red-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-red-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-red-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-red-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-red-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-red-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-red-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-red-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-red-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-red-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-orange-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-orange-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-orange-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-orange-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-orange-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-orange-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-orange-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-orange-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-orange-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-orange-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-green-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-green-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-green-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-green-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-green-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-green-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-green-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-green-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-green-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-green-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-teal-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-teal-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-teal-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-teal-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-teal-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-teal-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-teal-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-teal-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-teal-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-teal-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-blue-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-blue-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-blue-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-blue-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-blue-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-blue-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-blue-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-blue-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-blue-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-blue-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-pink-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-pink-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-pink-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-pink-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-pink-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-pink-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-pink-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-pink-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-pink-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .theme-dark .lg\\:dark\\:focus\\:placeholder-pink-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .lg\\:placeholder-opacity-0::placeholder{
    --placeholder-opacity:0
  }

  .lg\\:placeholder-opacity-25::placeholder{
    --placeholder-opacity:0.25
  }

  .lg\\:placeholder-opacity-50::placeholder{
    --placeholder-opacity:0.5
  }

  .lg\\:placeholder-opacity-75::placeholder{
    --placeholder-opacity:0.75
  }

  .lg\\:placeholder-opacity-100::placeholder{
    --placeholder-opacity:1
  }

  .lg\\:focus\\:placeholder-opacity-0:focus::placeholder{
    --placeholder-opacity:0
  }

  .lg\\:focus\\:placeholder-opacity-25:focus::placeholder{
    --placeholder-opacity:0.25
  }

  .lg\\:focus\\:placeholder-opacity-50:focus::placeholder{
    --placeholder-opacity:0.5
  }

  .lg\\:focus\\:placeholder-opacity-75:focus::placeholder{
    --placeholder-opacity:0.75
  }

  .lg\\:focus\\:placeholder-opacity-100:focus::placeholder{
    --placeholder-opacity:1
  }

  .lg\\:pointer-events-none{
    pointer-events:none
  }

  .lg\\:pointer-events-auto{
    pointer-events:auto
  }

  .lg\\:static{
    position:static
  }

  .lg\\:fixed{
    position:fixed
  }

  .lg\\:absolute{
    position:absolute
  }

  .lg\\:relative{
    position:relative
  }

  .lg\\:sticky{
    position:sticky
  }

  .lg\\:inset-0{
    bottom:0;
    left:0;
    right:0;
    top:0
  }

  .lg\\:inset-auto{
    bottom:auto;
    left:auto;
    right:auto;
    top:auto
  }

  .lg\\:inset-y-0{
    bottom:0;
    top:0
  }

  .lg\\:inset-x-0{
    left:0;
    right:0
  }

  .lg\\:inset-y-auto{
    bottom:auto;
    top:auto
  }

  .lg\\:inset-x-auto{
    left:auto;
    right:auto
  }

  .lg\\:top-0{
    top:0
  }

  .lg\\:right-0{
    right:0
  }

  .lg\\:bottom-0{
    bottom:0
  }

  .lg\\:left-0{
    left:0
  }

  .lg\\:top-auto{
    top:auto
  }

  .lg\\:right-auto{
    right:auto
  }

  .lg\\:bottom-auto{
    bottom:auto
  }

  .lg\\:left-auto{
    left:auto
  }

  .lg\\:resize-none{
    resize:none
  }

  .lg\\:resize-y{
    resize:vertical
  }

  .lg\\:resize-x{
    resize:horizontal
  }

  .lg\\:resize{
    resize:both
  }

  .lg\\:shadow-xs{
    box-shadow:0 0 0 1px #0000000d
  }

  .lg\\:shadow-sm{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .lg\\:shadow{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .lg\\:shadow-md{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .lg\\:shadow-lg{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .lg\\:shadow-xl{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .lg\\:shadow-2xl{
    box-shadow:0 25px 50px -12px #00000040
  }

  .lg\\:shadow-inner{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .lg\\:shadow-outline{
    box-shadow:0 0 0 3px #4299e180
  }

  .lg\\:shadow-none{
    box-shadow:none
  }

  .lg\\:shadow-bottom{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .lg\\:hover\\:shadow-xs:hover{
    box-shadow:0 0 0 1px #0000000d
  }

  .lg\\:hover\\:shadow-sm:hover{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .lg\\:hover\\:shadow:hover{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .lg\\:hover\\:shadow-md:hover{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .lg\\:hover\\:shadow-lg:hover{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .lg\\:hover\\:shadow-xl:hover{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .lg\\:hover\\:shadow-2xl:hover{
    box-shadow:0 25px 50px -12px #00000040
  }

  .lg\\:hover\\:shadow-inner:hover{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .lg\\:hover\\:shadow-outline:hover{
    box-shadow:0 0 0 3px #4299e180
  }

  .lg\\:hover\\:shadow-none:hover{
    box-shadow:none
  }

  .lg\\:hover\\:shadow-bottom:hover{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .lg\\:focus\\:shadow-xs:focus{
    box-shadow:0 0 0 1px #0000000d
  }

  .lg\\:focus\\:shadow-sm:focus{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .lg\\:focus\\:shadow:focus{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .lg\\:focus\\:shadow-md:focus{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .lg\\:focus\\:shadow-lg:focus{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .lg\\:focus\\:shadow-xl:focus{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .lg\\:focus\\:shadow-2xl:focus{
    box-shadow:0 25px 50px -12px #00000040
  }

  .lg\\:focus\\:shadow-inner:focus{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .lg\\:focus\\:shadow-outline:focus{
    box-shadow:0 0 0 3px #4299e180
  }

  .lg\\:focus\\:shadow-none:focus{
    box-shadow:none
  }

  .lg\\:focus\\:shadow-bottom:focus{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-xs:focus{
    box-shadow:0 0 0 1px #0000000d
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-sm:focus{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow:focus{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-md:focus{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-lg:focus{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-xl:focus{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-2xl:focus{
    box-shadow:0 25px 50px -12px #00000040
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-inner:focus{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-outline:focus{
    box-shadow:0 0 0 3px #4299e180
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-none:focus{
    box-shadow:none
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-bottom:focus{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .lg\\:fill-current{
    fill:currentColor
  }

  .lg\\:stroke-current{
    stroke:currentColor
  }

  .lg\\:stroke-0{
    stroke-width:0
  }

  .lg\\:stroke-1{
    stroke-width:1
  }

  .lg\\:stroke-2{
    stroke-width:2
  }

  .lg\\:table-auto{
    table-layout:auto
  }

  .lg\\:table-fixed{
    table-layout:fixed
  }

  .lg\\:text-left{
    text-align:left
  }

  .lg\\:text-center{
    text-align:center
  }

  .lg\\:text-right{
    text-align:right
  }

  .lg\\:text-justify{
    text-align:justify
  }

  .lg\\:text-transparent{
    color:#0000
  }

  .lg\\:text-white{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .lg\\:text-black{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .lg\\:text-gray-50{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .lg\\:text-gray-100{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .lg\\:text-gray-200{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .lg\\:text-gray-300{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .lg\\:text-gray-400{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .lg\\:text-gray-500{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .lg\\:text-gray-600{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .lg\\:text-gray-700{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .lg\\:text-gray-800{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .lg\\:text-gray-900{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .lg\\:text-cool-gray-50{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .lg\\:text-cool-gray-100{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .lg\\:text-cool-gray-200{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .lg\\:text-cool-gray-300{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .lg\\:text-cool-gray-400{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .lg\\:text-cool-gray-500{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .lg\\:text-cool-gray-600{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .lg\\:text-cool-gray-700{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .lg\\:text-cool-gray-800{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .lg\\:text-cool-gray-900{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .lg\\:text-red-50{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .lg\\:text-red-100{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .lg\\:text-red-200{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .lg\\:text-red-300{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .lg\\:text-red-400{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .lg\\:text-red-500{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .lg\\:text-red-600{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .lg\\:text-red-700{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .lg\\:text-red-800{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .lg\\:text-red-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .lg\\:text-orange-50{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .lg\\:text-orange-100{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .lg\\:text-orange-200{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .lg\\:text-orange-300{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .lg\\:text-orange-400{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .lg\\:text-orange-500{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .lg\\:text-orange-600{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .lg\\:text-orange-700{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .lg\\:text-orange-800{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .lg\\:text-orange-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .lg\\:text-yellow-50{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .lg\\:text-yellow-100{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .lg\\:text-yellow-200{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .lg\\:text-yellow-300{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .lg\\:text-yellow-400{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .lg\\:text-yellow-500{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .lg\\:text-yellow-600{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .lg\\:text-yellow-700{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .lg\\:text-yellow-800{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .lg\\:text-yellow-900{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .lg\\:text-green-50{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .lg\\:text-green-100{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .lg\\:text-green-200{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .lg\\:text-green-300{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .lg\\:text-green-400{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .lg\\:text-green-500{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .lg\\:text-green-600{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .lg\\:text-green-700{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .lg\\:text-green-800{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .lg\\:text-green-900{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .lg\\:text-teal-50{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .lg\\:text-teal-100{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .lg\\:text-teal-200{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .lg\\:text-teal-300{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .lg\\:text-teal-400{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .lg\\:text-teal-500{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .lg\\:text-teal-600{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .lg\\:text-teal-700{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .lg\\:text-teal-800{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .lg\\:text-teal-900{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .lg\\:text-blue-50{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .lg\\:text-blue-100{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .lg\\:text-blue-200{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .lg\\:text-blue-300{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .lg\\:text-blue-400{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .lg\\:text-blue-500{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .lg\\:text-blue-600{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .lg\\:text-blue-700{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .lg\\:text-blue-800{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .lg\\:text-blue-900{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .lg\\:text-indigo-50{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .lg\\:text-indigo-100{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .lg\\:text-indigo-200{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .lg\\:text-indigo-300{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .lg\\:text-indigo-400{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .lg\\:text-indigo-500{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .lg\\:text-indigo-600{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .lg\\:text-indigo-700{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .lg\\:text-indigo-800{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .lg\\:text-indigo-900{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .lg\\:text-indigo-50{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .lg\\:text-indigo-100{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .lg\\:text-indigo-200{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .lg\\:text-indigo-300{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .lg\\:text-indigo-400{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .lg\\:text-indigo-500{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .lg\\:text-indigo-600{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .lg\\:text-indigo-700{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .lg\\:text-indigo-800{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .lg\\:text-indigo-900{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .lg\\:text-pink-50{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .lg\\:text-pink-100{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .lg\\:text-pink-200{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .lg\\:text-pink-300{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .lg\\:text-pink-400{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .lg\\:text-pink-500{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .lg\\:text-pink-600{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .lg\\:text-pink-700{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .lg\\:text-pink-800{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .lg\\:text-pink-900{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .lg\\:focus\\:text-transparent:focus{
    color:#0000
  }

  .lg\\:focus\\:text-white:focus{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .lg\\:focus\\:text-black:focus{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .lg\\:focus\\:text-gray-50:focus{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .lg\\:focus\\:text-gray-100:focus{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .lg\\:focus\\:text-gray-200:focus{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .lg\\:focus\\:text-gray-300:focus{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .lg\\:focus\\:text-gray-400:focus{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .lg\\:focus\\:text-gray-500:focus{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .lg\\:focus\\:text-gray-600:focus{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .lg\\:focus\\:text-gray-700:focus{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .lg\\:focus\\:text-gray-800:focus{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .lg\\:focus\\:text-gray-900:focus{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .lg\\:focus\\:text-cool-gray-50:focus{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .lg\\:focus\\:text-cool-gray-100:focus{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .lg\\:focus\\:text-cool-gray-200:focus{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .lg\\:focus\\:text-cool-gray-300:focus{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .lg\\:focus\\:text-cool-gray-400:focus{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .lg\\:focus\\:text-cool-gray-500:focus{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .lg\\:focus\\:text-cool-gray-600:focus{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .lg\\:focus\\:text-cool-gray-700:focus{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .lg\\:focus\\:text-cool-gray-800:focus{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .lg\\:focus\\:text-cool-gray-900:focus{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .lg\\:focus\\:text-red-50:focus{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .lg\\:focus\\:text-red-100:focus{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .lg\\:focus\\:text-red-200:focus{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .lg\\:focus\\:text-red-300:focus{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .lg\\:focus\\:text-red-400:focus{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .lg\\:focus\\:text-red-500:focus{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .lg\\:focus\\:text-red-600:focus{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .lg\\:focus\\:text-red-700:focus{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .lg\\:focus\\:text-red-800:focus{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .lg\\:focus\\:text-red-900:focus{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .lg\\:focus\\:text-orange-50:focus{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .lg\\:focus\\:text-orange-100:focus{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .lg\\:focus\\:text-orange-200:focus{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .lg\\:focus\\:text-orange-300:focus{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .lg\\:focus\\:text-orange-400:focus{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .lg\\:focus\\:text-orange-500:focus{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .lg\\:focus\\:text-orange-600:focus{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .lg\\:focus\\:text-orange-700:focus{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .lg\\:focus\\:text-orange-800:focus{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .lg\\:focus\\:text-orange-900:focus{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .lg\\:focus\\:text-yellow-50:focus{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .lg\\:focus\\:text-yellow-100:focus{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .lg\\:focus\\:text-yellow-200:focus{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .lg\\:focus\\:text-yellow-300:focus{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .lg\\:focus\\:text-yellow-400:focus{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .lg\\:focus\\:text-yellow-500:focus{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .lg\\:focus\\:text-yellow-600:focus{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .lg\\:focus\\:text-yellow-700:focus{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .lg\\:focus\\:text-yellow-800:focus{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .lg\\:focus\\:text-yellow-900:focus{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .lg\\:focus\\:text-green-50:focus{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .lg\\:focus\\:text-green-100:focus{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .lg\\:focus\\:text-green-200:focus{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .lg\\:focus\\:text-green-300:focus{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .lg\\:focus\\:text-green-400:focus{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .lg\\:focus\\:text-green-500:focus{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .lg\\:focus\\:text-green-600:focus{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .lg\\:focus\\:text-green-700:focus{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .lg\\:focus\\:text-green-800:focus{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .lg\\:focus\\:text-green-900:focus{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .lg\\:focus\\:text-teal-50:focus{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .lg\\:focus\\:text-teal-100:focus{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .lg\\:focus\\:text-teal-200:focus{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .lg\\:focus\\:text-teal-300:focus{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .lg\\:focus\\:text-teal-400:focus{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .lg\\:focus\\:text-teal-500:focus{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .lg\\:focus\\:text-teal-600:focus{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .lg\\:focus\\:text-teal-700:focus{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .lg\\:focus\\:text-teal-800:focus{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .lg\\:focus\\:text-teal-900:focus{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .lg\\:focus\\:text-blue-50:focus{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .lg\\:focus\\:text-blue-100:focus{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .lg\\:focus\\:text-blue-200:focus{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .lg\\:focus\\:text-blue-300:focus{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .lg\\:focus\\:text-blue-400:focus{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .lg\\:focus\\:text-blue-500:focus{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .lg\\:focus\\:text-blue-600:focus{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .lg\\:focus\\:text-blue-700:focus{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .lg\\:focus\\:text-blue-800:focus{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .lg\\:focus\\:text-blue-900:focus{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-50:focus{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-100:focus{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-200:focus{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-300:focus{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-400:focus{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-500:focus{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-600:focus{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-700:focus{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-800:focus{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-900:focus{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-50:focus{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-100:focus{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-200:focus{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-300:focus{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-400:focus{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-500:focus{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-600:focus{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-700:focus{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-800:focus{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .lg\\:focus\\:text-indigo-900:focus{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .lg\\:focus\\:text-pink-50:focus{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .lg\\:focus\\:text-pink-100:focus{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .lg\\:focus\\:text-pink-200:focus{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .lg\\:focus\\:text-pink-300:focus{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .lg\\:focus\\:text-pink-400:focus{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .lg\\:focus\\:text-pink-500:focus{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .lg\\:focus\\:text-pink-600:focus{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .lg\\:focus\\:text-pink-700:focus{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .lg\\:focus\\:text-pink-800:focus{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .lg\\:focus\\:text-pink-900:focus{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-transparent:focus-within{
    color:#0000
  }

  .lg\\:focus-within\\:text-white:focus-within{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-black:focus-within{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-gray-50:focus-within{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-gray-100:focus-within{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-gray-200:focus-within{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-gray-300:focus-within{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-gray-400:focus-within{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-gray-500:focus-within{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-gray-600:focus-within{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-gray-700:focus-within{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-gray-800:focus-within{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-gray-900:focus-within{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-cool-gray-50:focus-within{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-cool-gray-100:focus-within{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-cool-gray-200:focus-within{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-cool-gray-300:focus-within{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-cool-gray-400:focus-within{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-cool-gray-500:focus-within{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-cool-gray-600:focus-within{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-cool-gray-700:focus-within{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-cool-gray-800:focus-within{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-cool-gray-900:focus-within{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-red-50:focus-within{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-red-100:focus-within{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-red-200:focus-within{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-red-300:focus-within{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-red-400:focus-within{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-red-500:focus-within{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-red-600:focus-within{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-red-700:focus-within{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-red-800:focus-within{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-red-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-orange-50:focus-within{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-orange-100:focus-within{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-orange-200:focus-within{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-orange-300:focus-within{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-orange-400:focus-within{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-orange-500:focus-within{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-orange-600:focus-within{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-orange-700:focus-within{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-orange-800:focus-within{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-orange-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-yellow-50:focus-within{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-yellow-100:focus-within{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-yellow-200:focus-within{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-yellow-300:focus-within{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-yellow-400:focus-within{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-yellow-500:focus-within{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-yellow-600:focus-within{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-yellow-700:focus-within{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-yellow-800:focus-within{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-yellow-900:focus-within{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-green-50:focus-within{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-green-100:focus-within{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-green-200:focus-within{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-green-300:focus-within{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-green-400:focus-within{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-green-500:focus-within{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-green-600:focus-within{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-green-700:focus-within{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-green-800:focus-within{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-green-900:focus-within{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-teal-50:focus-within{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-teal-100:focus-within{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-teal-200:focus-within{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-teal-300:focus-within{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-teal-400:focus-within{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-teal-500:focus-within{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-teal-600:focus-within{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-teal-700:focus-within{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-teal-800:focus-within{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-teal-900:focus-within{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-blue-50:focus-within{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-blue-100:focus-within{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-blue-200:focus-within{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-blue-300:focus-within{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-blue-400:focus-within{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-blue-500:focus-within{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-blue-600:focus-within{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-blue-700:focus-within{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-blue-800:focus-within{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-blue-900:focus-within{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-pink-50:focus-within{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-pink-100:focus-within{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-pink-200:focus-within{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-pink-300:focus-within{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-pink-400:focus-within{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-pink-500:focus-within{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-pink-600:focus-within{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-pink-700:focus-within{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-pink-800:focus-within{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .lg\\:focus-within\\:text-pink-900:focus-within{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .lg\\:hover\\:text-transparent:hover{
    color:#0000
  }

  .lg\\:hover\\:text-white:hover{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .lg\\:hover\\:text-black:hover{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .lg\\:hover\\:text-gray-50:hover{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .lg\\:hover\\:text-gray-100:hover{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .lg\\:hover\\:text-gray-200:hover{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .lg\\:hover\\:text-gray-300:hover{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .lg\\:hover\\:text-gray-400:hover{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .lg\\:hover\\:text-gray-500:hover{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .lg\\:hover\\:text-gray-600:hover{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .lg\\:hover\\:text-gray-700:hover{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .lg\\:hover\\:text-gray-800:hover{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .lg\\:hover\\:text-gray-900:hover{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .lg\\:hover\\:text-cool-gray-50:hover{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .lg\\:hover\\:text-cool-gray-100:hover{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .lg\\:hover\\:text-cool-gray-200:hover{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .lg\\:hover\\:text-cool-gray-300:hover{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .lg\\:hover\\:text-cool-gray-400:hover{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .lg\\:hover\\:text-cool-gray-500:hover{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .lg\\:hover\\:text-cool-gray-600:hover{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .lg\\:hover\\:text-cool-gray-700:hover{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .lg\\:hover\\:text-cool-gray-800:hover{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .lg\\:hover\\:text-cool-gray-900:hover{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .lg\\:hover\\:text-red-50:hover{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .lg\\:hover\\:text-red-100:hover{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .lg\\:hover\\:text-red-200:hover{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .lg\\:hover\\:text-red-300:hover{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .lg\\:hover\\:text-red-400:hover{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .lg\\:hover\\:text-red-500:hover{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .lg\\:hover\\:text-red-600:hover{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .lg\\:hover\\:text-red-700:hover{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .lg\\:hover\\:text-red-800:hover{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .lg\\:hover\\:text-red-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .lg\\:hover\\:text-orange-50:hover{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .lg\\:hover\\:text-orange-100:hover{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .lg\\:hover\\:text-orange-200:hover{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .lg\\:hover\\:text-orange-300:hover{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .lg\\:hover\\:text-orange-400:hover{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .lg\\:hover\\:text-orange-500:hover{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .lg\\:hover\\:text-orange-600:hover{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .lg\\:hover\\:text-orange-700:hover{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .lg\\:hover\\:text-orange-800:hover{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .lg\\:hover\\:text-orange-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .lg\\:hover\\:text-yellow-50:hover{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .lg\\:hover\\:text-yellow-100:hover{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .lg\\:hover\\:text-yellow-200:hover{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .lg\\:hover\\:text-yellow-300:hover{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .lg\\:hover\\:text-yellow-400:hover{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .lg\\:hover\\:text-yellow-500:hover{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .lg\\:hover\\:text-yellow-600:hover{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .lg\\:hover\\:text-yellow-700:hover{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .lg\\:hover\\:text-yellow-800:hover{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .lg\\:hover\\:text-yellow-900:hover{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .lg\\:hover\\:text-green-50:hover{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .lg\\:hover\\:text-green-100:hover{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .lg\\:hover\\:text-green-200:hover{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .lg\\:hover\\:text-green-300:hover{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .lg\\:hover\\:text-green-400:hover{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .lg\\:hover\\:text-green-500:hover{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .lg\\:hover\\:text-green-600:hover{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .lg\\:hover\\:text-green-700:hover{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .lg\\:hover\\:text-green-800:hover{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .lg\\:hover\\:text-green-900:hover{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .lg\\:hover\\:text-teal-50:hover{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .lg\\:hover\\:text-teal-100:hover{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .lg\\:hover\\:text-teal-200:hover{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .lg\\:hover\\:text-teal-300:hover{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .lg\\:hover\\:text-teal-400:hover{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .lg\\:hover\\:text-teal-500:hover{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .lg\\:hover\\:text-teal-600:hover{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .lg\\:hover\\:text-teal-700:hover{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .lg\\:hover\\:text-teal-800:hover{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .lg\\:hover\\:text-teal-900:hover{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .lg\\:hover\\:text-blue-50:hover{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .lg\\:hover\\:text-blue-100:hover{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .lg\\:hover\\:text-blue-200:hover{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .lg\\:hover\\:text-blue-300:hover{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .lg\\:hover\\:text-blue-400:hover{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .lg\\:hover\\:text-blue-500:hover{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .lg\\:hover\\:text-blue-600:hover{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .lg\\:hover\\:text-blue-700:hover{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .lg\\:hover\\:text-blue-800:hover{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .lg\\:hover\\:text-blue-900:hover{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .lg\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .lg\\:hover\\:text-pink-50:hover{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .lg\\:hover\\:text-pink-100:hover{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .lg\\:hover\\:text-pink-200:hover{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .lg\\:hover\\:text-pink-300:hover{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .lg\\:hover\\:text-pink-400:hover{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .lg\\:hover\\:text-pink-500:hover{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .lg\\:hover\\:text-pink-600:hover{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .lg\\:hover\\:text-pink-700:hover{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .lg\\:hover\\:text-pink-800:hover{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .lg\\:hover\\:text-pink-900:hover{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .lg\\:active\\:text-transparent:active{
    color:#0000
  }

  .lg\\:active\\:text-white:active{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .lg\\:active\\:text-black:active{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .lg\\:active\\:text-gray-50:active{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .lg\\:active\\:text-gray-100:active{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .lg\\:active\\:text-gray-200:active{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .lg\\:active\\:text-gray-300:active{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .lg\\:active\\:text-gray-400:active{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .lg\\:active\\:text-gray-500:active{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .lg\\:active\\:text-gray-600:active{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .lg\\:active\\:text-gray-700:active{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .lg\\:active\\:text-gray-800:active{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .lg\\:active\\:text-gray-900:active{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .lg\\:active\\:text-cool-gray-50:active{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .lg\\:active\\:text-cool-gray-100:active{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .lg\\:active\\:text-cool-gray-200:active{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .lg\\:active\\:text-cool-gray-300:active{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .lg\\:active\\:text-cool-gray-400:active{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .lg\\:active\\:text-cool-gray-500:active{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .lg\\:active\\:text-cool-gray-600:active{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .lg\\:active\\:text-cool-gray-700:active{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .lg\\:active\\:text-cool-gray-800:active{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .lg\\:active\\:text-cool-gray-900:active{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .lg\\:active\\:text-red-50:active{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .lg\\:active\\:text-red-100:active{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .lg\\:active\\:text-red-200:active{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .lg\\:active\\:text-red-300:active{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .lg\\:active\\:text-red-400:active{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .lg\\:active\\:text-red-500:active{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .lg\\:active\\:text-red-600:active{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .lg\\:active\\:text-red-700:active{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .lg\\:active\\:text-red-800:active{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .lg\\:active\\:text-red-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .lg\\:active\\:text-orange-50:active{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .lg\\:active\\:text-orange-100:active{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .lg\\:active\\:text-orange-200:active{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .lg\\:active\\:text-orange-300:active{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .lg\\:active\\:text-orange-400:active{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .lg\\:active\\:text-orange-500:active{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .lg\\:active\\:text-orange-600:active{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .lg\\:active\\:text-orange-700:active{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .lg\\:active\\:text-orange-800:active{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .lg\\:active\\:text-orange-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .lg\\:active\\:text-yellow-50:active{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .lg\\:active\\:text-yellow-100:active{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .lg\\:active\\:text-yellow-200:active{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .lg\\:active\\:text-yellow-300:active{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .lg\\:active\\:text-yellow-400:active{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .lg\\:active\\:text-yellow-500:active{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .lg\\:active\\:text-yellow-600:active{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .lg\\:active\\:text-yellow-700:active{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .lg\\:active\\:text-yellow-800:active{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .lg\\:active\\:text-yellow-900:active{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .lg\\:active\\:text-green-50:active{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .lg\\:active\\:text-green-100:active{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .lg\\:active\\:text-green-200:active{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .lg\\:active\\:text-green-300:active{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .lg\\:active\\:text-green-400:active{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .lg\\:active\\:text-green-500:active{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .lg\\:active\\:text-green-600:active{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .lg\\:active\\:text-green-700:active{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .lg\\:active\\:text-green-800:active{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .lg\\:active\\:text-green-900:active{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .lg\\:active\\:text-teal-50:active{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .lg\\:active\\:text-teal-100:active{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .lg\\:active\\:text-teal-200:active{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .lg\\:active\\:text-teal-300:active{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .lg\\:active\\:text-teal-400:active{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .lg\\:active\\:text-teal-500:active{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .lg\\:active\\:text-teal-600:active{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .lg\\:active\\:text-teal-700:active{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .lg\\:active\\:text-teal-800:active{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .lg\\:active\\:text-teal-900:active{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .lg\\:active\\:text-blue-50:active{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .lg\\:active\\:text-blue-100:active{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .lg\\:active\\:text-blue-200:active{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .lg\\:active\\:text-blue-300:active{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .lg\\:active\\:text-blue-400:active{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .lg\\:active\\:text-blue-500:active{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .lg\\:active\\:text-blue-600:active{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .lg\\:active\\:text-blue-700:active{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .lg\\:active\\:text-blue-800:active{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .lg\\:active\\:text-blue-900:active{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .lg\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .lg\\:active\\:text-pink-50:active{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .lg\\:active\\:text-pink-100:active{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .lg\\:active\\:text-pink-200:active{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .lg\\:active\\:text-pink-300:active{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .lg\\:active\\:text-pink-400:active{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .lg\\:active\\:text-pink-500:active{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .lg\\:active\\:text-pink-600:active{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .lg\\:active\\:text-pink-700:active{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .lg\\:active\\:text-pink-800:active{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .lg\\:active\\:text-pink-900:active{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-transparent{
    color:#0000
  }

  .theme-dark .lg\\:dark\\:text-white{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-black{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-gray-50{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-gray-100{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-gray-200{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-gray-300{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-gray-400{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-gray-500{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-gray-600{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-gray-700{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-gray-800{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-gray-900{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-cool-gray-50{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-cool-gray-100{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-cool-gray-200{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-cool-gray-300{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-cool-gray-400{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-cool-gray-500{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-cool-gray-600{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-cool-gray-700{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-cool-gray-800{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-cool-gray-900{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-red-50{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-red-100{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-red-200{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-red-300{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-red-400{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-red-500{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-red-600{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-red-700{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-red-800{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-red-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-orange-50{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-orange-100{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-orange-200{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-orange-300{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-orange-400{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-orange-500{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-orange-600{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-orange-700{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-orange-800{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-orange-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-yellow-50{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-yellow-100{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-yellow-200{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-yellow-300{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-yellow-400{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-yellow-500{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-yellow-600{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-yellow-700{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-yellow-800{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-yellow-900{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-green-50{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-green-100{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-green-200{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-green-300{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-green-400{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-green-500{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-green-600{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-green-700{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-green-800{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-green-900{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-teal-50{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-teal-100{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-teal-200{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-teal-300{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-teal-400{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-teal-500{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-teal-600{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-teal-700{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-teal-800{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-teal-900{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-blue-50{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-blue-100{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-blue-200{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-blue-300{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-blue-400{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-blue-500{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-blue-600{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-blue-700{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-blue-800{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-blue-900{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-50{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-100{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-200{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-300{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-400{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-500{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-600{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-700{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-800{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-900{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-50{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-100{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-200{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-300{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-400{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-500{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-600{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-700{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-800{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-indigo-900{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-pink-50{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-pink-100{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-pink-200{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-pink-300{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-pink-400{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-pink-500{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-pink-600{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-pink-700{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-pink-800{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:text-pink-900{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-transparent:focus-within{
    color:#0000
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-white:focus-within{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-black:focus-within{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-gray-50:focus-within{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-gray-100:focus-within{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-gray-200:focus-within{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-gray-300:focus-within{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-gray-400:focus-within{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-gray-500:focus-within{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-gray-600:focus-within{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-gray-700:focus-within{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-gray-800:focus-within{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-gray-900:focus-within{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-50:focus-within{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-100:focus-within{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-200:focus-within{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-300:focus-within{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-400:focus-within{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-500:focus-within{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-600:focus-within{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-700:focus-within{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-800:focus-within{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-900:focus-within{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-red-50:focus-within{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-red-100:focus-within{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-red-200:focus-within{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-red-300:focus-within{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-red-400:focus-within{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-red-500:focus-within{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-red-600:focus-within{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-red-700:focus-within{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-red-800:focus-within{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-red-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-orange-50:focus-within{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-orange-100:focus-within{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-orange-200:focus-within{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-orange-300:focus-within{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-orange-400:focus-within{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-orange-500:focus-within{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-orange-600:focus-within{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-orange-700:focus-within{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-orange-800:focus-within{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-orange-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-yellow-50:focus-within{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-yellow-100:focus-within{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-yellow-200:focus-within{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-yellow-300:focus-within{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-yellow-400:focus-within{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-yellow-500:focus-within{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-yellow-600:focus-within{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-yellow-700:focus-within{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-yellow-800:focus-within{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-yellow-900:focus-within{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-green-50:focus-within{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-green-100:focus-within{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-green-200:focus-within{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-green-300:focus-within{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-green-400:focus-within{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-green-500:focus-within{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-green-600:focus-within{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-green-700:focus-within{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-green-800:focus-within{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-green-900:focus-within{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-teal-50:focus-within{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-teal-100:focus-within{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-teal-200:focus-within{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-teal-300:focus-within{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-teal-400:focus-within{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-teal-500:focus-within{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-teal-600:focus-within{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-teal-700:focus-within{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-teal-800:focus-within{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-teal-900:focus-within{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-blue-50:focus-within{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-blue-100:focus-within{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-blue-200:focus-within{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-blue-300:focus-within{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-blue-400:focus-within{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-blue-500:focus-within{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-blue-600:focus-within{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-blue-700:focus-within{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-blue-800:focus-within{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-blue-900:focus-within{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-pink-50:focus-within{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-pink-100:focus-within{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-pink-200:focus-within{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-pink-300:focus-within{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-pink-400:focus-within{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-pink-500:focus-within{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-pink-600:focus-within{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-pink-700:focus-within{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-pink-800:focus-within{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:focus-within\\:text-pink-900:focus-within{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-transparent:hover{
    color:#0000
  }

  .theme-dark .lg\\:dark\\:hover\\:text-white:hover{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-black:hover{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-gray-50:hover{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-gray-100:hover{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-gray-200:hover{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-gray-300:hover{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-gray-400:hover{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-gray-500:hover{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-gray-600:hover{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-gray-700:hover{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-gray-800:hover{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-gray-900:hover{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-cool-gray-50:hover{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-cool-gray-100:hover{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-cool-gray-200:hover{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-cool-gray-300:hover{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-cool-gray-400:hover{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-cool-gray-500:hover{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-cool-gray-600:hover{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-cool-gray-700:hover{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-cool-gray-800:hover{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-cool-gray-900:hover{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-red-50:hover{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-red-100:hover{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-red-200:hover{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-red-300:hover{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-red-400:hover{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-red-500:hover{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-red-600:hover{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-red-700:hover{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-red-800:hover{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-red-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-orange-50:hover{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-orange-100:hover{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-orange-200:hover{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-orange-300:hover{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-orange-400:hover{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-orange-500:hover{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-orange-600:hover{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-orange-700:hover{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-orange-800:hover{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-orange-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-yellow-50:hover{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-yellow-100:hover{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-yellow-200:hover{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-yellow-300:hover{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-yellow-400:hover{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-yellow-500:hover{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-yellow-600:hover{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-yellow-700:hover{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-yellow-800:hover{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-yellow-900:hover{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-green-50:hover{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-green-100:hover{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-green-200:hover{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-green-300:hover{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-green-400:hover{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-green-500:hover{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-green-600:hover{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-green-700:hover{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-green-800:hover{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-green-900:hover{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-teal-50:hover{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-teal-100:hover{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-teal-200:hover{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-teal-300:hover{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-teal-400:hover{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-teal-500:hover{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-teal-600:hover{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-teal-700:hover{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-teal-800:hover{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-teal-900:hover{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-blue-50:hover{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-blue-100:hover{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-blue-200:hover{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-blue-300:hover{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-blue-400:hover{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-blue-500:hover{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-blue-600:hover{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-blue-700:hover{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-blue-800:hover{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-blue-900:hover{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-pink-50:hover{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-pink-100:hover{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-pink-200:hover{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-pink-300:hover{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-pink-400:hover{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-pink-500:hover{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-pink-600:hover{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-pink-700:hover{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-pink-800:hover{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:hover\\:text-pink-900:hover{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-transparent:active{
    color:#0000
  }

  .theme-dark .lg\\:dark\\:active\\:text-white:active{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-black:active{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-gray-50:active{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-gray-100:active{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-gray-200:active{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-gray-300:active{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-gray-400:active{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-gray-500:active{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-gray-600:active{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-gray-700:active{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-gray-800:active{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-gray-900:active{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-cool-gray-50:active{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-cool-gray-100:active{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-cool-gray-200:active{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-cool-gray-300:active{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-cool-gray-400:active{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-cool-gray-500:active{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-cool-gray-600:active{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-cool-gray-700:active{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-cool-gray-800:active{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-cool-gray-900:active{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-red-50:active{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-red-100:active{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-red-200:active{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-red-300:active{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-red-400:active{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-red-500:active{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-red-600:active{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-red-700:active{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-red-800:active{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-red-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-orange-50:active{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-orange-100:active{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-orange-200:active{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-orange-300:active{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-orange-400:active{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-orange-500:active{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-orange-600:active{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-orange-700:active{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-orange-800:active{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-orange-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-yellow-50:active{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-yellow-100:active{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-yellow-200:active{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-yellow-300:active{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-yellow-400:active{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-yellow-500:active{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-yellow-600:active{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-yellow-700:active{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-yellow-800:active{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-yellow-900:active{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-green-50:active{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-green-100:active{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-green-200:active{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-green-300:active{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-green-400:active{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-green-500:active{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-green-600:active{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-green-700:active{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-green-800:active{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-green-900:active{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-teal-50:active{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-teal-100:active{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-teal-200:active{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-teal-300:active{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-teal-400:active{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-teal-500:active{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-teal-600:active{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-teal-700:active{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-teal-800:active{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-teal-900:active{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-blue-50:active{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-blue-100:active{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-blue-200:active{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-blue-300:active{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-blue-400:active{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-blue-500:active{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-blue-600:active{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-blue-700:active{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-blue-800:active{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-blue-900:active{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-pink-50:active{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-pink-100:active{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-pink-200:active{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-pink-300:active{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-pink-400:active{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-pink-500:active{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-pink-600:active{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-pink-700:active{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-pink-800:active{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .lg\\:dark\\:active\\:text-pink-900:active{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .lg\\:text-opacity-0{
    --text-opacity:0
  }

  .lg\\:text-opacity-25{
    --text-opacity:0.25
  }

  .lg\\:text-opacity-50{
    --text-opacity:0.5
  }

  .lg\\:text-opacity-75{
    --text-opacity:0.75
  }

  .lg\\:text-opacity-100{
    --text-opacity:1
  }

  .lg\\:hover\\:text-opacity-0:hover{
    --text-opacity:0
  }

  .lg\\:hover\\:text-opacity-25:hover{
    --text-opacity:0.25
  }

  .lg\\:hover\\:text-opacity-50:hover{
    --text-opacity:0.5
  }

  .lg\\:hover\\:text-opacity-75:hover{
    --text-opacity:0.75
  }

  .lg\\:hover\\:text-opacity-100:hover{
    --text-opacity:1
  }

  .lg\\:focus\\:text-opacity-0:focus{
    --text-opacity:0
  }

  .lg\\:focus\\:text-opacity-25:focus{
    --text-opacity:0.25
  }

  .lg\\:focus\\:text-opacity-50:focus{
    --text-opacity:0.5
  }

  .lg\\:focus\\:text-opacity-75:focus{
    --text-opacity:0.75
  }

  .lg\\:focus\\:text-opacity-100:focus{
    --text-opacity:1
  }

  .lg\\:italic{
    font-style:italic
  }

  .lg\\:not-italic{
    font-style:normal
  }

  .lg\\:uppercase{
    text-transform:uppercase
  }

  .lg\\:lowercase{
    text-transform:lowercase
  }

  .lg\\:capitalize{
    text-transform:capitalize
  }

  .lg\\:normal-case{
    text-transform:none
  }

  .lg\\:underline{
    text-decoration:underline
  }

  .lg\\:line-through{
    text-decoration:line-through
  }

  .lg\\:no-underline{
    text-decoration:none
  }

  .lg\\:hover\\:underline:hover{
    text-decoration:underline
  }

  .lg\\:hover\\:line-through:hover{
    text-decoration:line-through
  }

  .lg\\:hover\\:no-underline:hover{
    text-decoration:none
  }

  .lg\\:focus\\:underline:focus{
    text-decoration:underline
  }

  .lg\\:focus\\:line-through:focus{
    text-decoration:line-through
  }

  .lg\\:focus\\:no-underline:focus{
    text-decoration:none
  }

  .lg\\:antialiased{
    -webkit-font-smoothing:antialiased;
    -moz-osx-font-smoothing:grayscale
  }

  .lg\\:subpixel-antialiased{
    -webkit-font-smoothing:auto;
    -moz-osx-font-smoothing:auto
  }

  .lg\\:tracking-tighter{
    letter-spacing:-.05em
  }

  .lg\\:tracking-tight{
    letter-spacing:-.025em
  }

  .lg\\:tracking-normal{
    letter-spacing:0
  }

  .lg\\:tracking-wide{
    letter-spacing:.025em
  }

  .lg\\:tracking-wider{
    letter-spacing:.05em
  }

  .lg\\:tracking-widest{
    letter-spacing:.1em
  }

  .lg\\:select-none{
    -webkit-user-select:none;
    user-select:none
  }

  .lg\\:select-text{
    -webkit-user-select:text;
    user-select:text
  }

  .lg\\:select-all{
    -webkit-user-select:all;
    user-select:all
  }

  .lg\\:select-auto{
    -webkit-user-select:auto;
    user-select:auto
  }

  .lg\\:align-baseline{
    vertical-align:initial
  }

  .lg\\:align-top{
    vertical-align:top
  }

  .lg\\:align-middle{
    vertical-align:middle
  }

  .lg\\:align-bottom{
    vertical-align:bottom
  }

  .lg\\:align-text-top{
    vertical-align:text-top
  }

  .lg\\:align-text-bottom{
    vertical-align:text-bottom
  }

  .lg\\:visible{
    visibility:visible
  }

  .lg\\:invisible{
    visibility:hidden
  }

  .lg\\:whitespace-normal{
    white-space:normal
  }

  .lg\\:whitespace-no-wrap{
    white-space:nowrap
  }

  .lg\\:whitespace-pre{
    white-space:pre
  }

  .lg\\:whitespace-pre-line{
    white-space:pre-line
  }

  .lg\\:whitespace-pre-wrap{
    white-space:pre-wrap
  }

  .lg\\:break-normal{
    overflow-wrap:normal;
    word-break:normal
  }

  .lg\\:break-words{
    overflow-wrap:break-word
  }

  .lg\\:break-all{
    word-break:break-all
  }

  .lg\\:truncate{
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
  }

  .lg\\:w-0{
    width:0
  }

  .lg\\:w-1{
    width:.25rem
  }

  .lg\\:w-2{
    width:.5rem
  }

  .lg\\:w-3{
    width:.75rem
  }

  .lg\\:w-4{
    width:1rem
  }

  .lg\\:w-5{
    width:1.25rem
  }

  .lg\\:w-6{
    width:1.5rem
  }

  .lg\\:w-8{
    width:2rem
  }

  .lg\\:w-10{
    width:2.5rem
  }

  .lg\\:w-12{
    width:3rem
  }

  .lg\\:w-16{
    width:4rem
  }

  .lg\\:w-20{
    width:5rem
  }

  .lg\\:w-24{
    width:6rem
  }

  .lg\\:w-32{
    width:8rem
  }

  .lg\\:w-40{
    width:10rem
  }

  .lg\\:w-48{
    width:12rem
  }

  .lg\\:w-56{
    width:14rem
  }

  .lg\\:w-64{
    width:16rem
  }

  .lg\\:w-auto{
    width:auto
  }

  .lg\\:w-px{
    width:1px
  }

  .lg\\:w-1\\/2{
    width:50%
  }

  .lg\\:w-1\\/3{
    width:33.333333%
  }

  .lg\\:w-2\\/3{
    width:66.666667%
  }

  .lg\\:w-1\\/4{
    width:25%
  }

  .lg\\:w-2\\/4{
    width:50%
  }

  .lg\\:w-3\\/4{
    width:75%
  }

  .lg\\:w-1\\/5{
    width:20%
  }

  .lg\\:w-2\\/5{
    width:40%
  }

  .lg\\:w-3\\/5{
    width:60%
  }

  .lg\\:w-4\\/5{
    width:80%
  }

  .lg\\:w-1\\/6{
    width:16.666667%
  }

  .lg\\:w-2\\/6{
    width:33.333333%
  }

  .lg\\:w-3\\/6{
    width:50%
  }

  .lg\\:w-4\\/6{
    width:66.666667%
  }

  .lg\\:w-5\\/6{
    width:83.333333%
  }

  .lg\\:w-1\\/12{
    width:8.333333%
  }

  .lg\\:w-2\\/12{
    width:16.666667%
  }

  .lg\\:w-3\\/12{
    width:25%
  }

  .lg\\:w-4\\/12{
    width:33.333333%
  }

  .lg\\:w-5\\/12{
    width:41.666667%
  }

  .lg\\:w-6\\/12{
    width:50%
  }

  .lg\\:w-7\\/12{
    width:58.333333%
  }

  .lg\\:w-8\\/12{
    width:66.666667%
  }

  .lg\\:w-9\\/12{
    width:75%
  }

  .lg\\:w-10\\/12{
    width:83.333333%
  }

  .lg\\:w-11\\/12{
    width:91.666667%
  }

  .lg\\:w-full{
    width:100%
  }

  .lg\\:w-screen{
    width:100vw
  }

  .lg\\:z-0{
    z-index:0
  }

  .lg\\:z-10{
    z-index:10
  }

  .lg\\:z-20{
    z-index:20
  }

  .lg\\:z-30{
    z-index:30
  }

  .lg\\:z-40{
    z-index:40
  }

  .lg\\:z-50{
    z-index:50
  }

  .lg\\:z-auto{
    z-index:auto
  }

  .lg\\:gap-0{
    grid-gap:0;
    gap:0
  }

  .lg\\:gap-1{
    grid-gap:.25rem;
    gap:.25rem
  }

  .lg\\:gap-2{
    grid-gap:.5rem;
    gap:.5rem
  }

  .lg\\:gap-3{
    grid-gap:.75rem;
    gap:.75rem
  }

  .lg\\:gap-4{
    grid-gap:1rem;
    gap:1rem
  }

  .lg\\:gap-5{
    grid-gap:1.25rem;
    gap:1.25rem
  }

  .lg\\:gap-6{
    grid-gap:1.5rem;
    gap:1.5rem
  }

  .lg\\:gap-8{
    grid-gap:2rem;
    gap:2rem
  }

  .lg\\:gap-10{
    grid-gap:2.5rem;
    gap:2.5rem
  }

  .lg\\:gap-12{
    grid-gap:3rem;
    gap:3rem
  }

  .lg\\:gap-16{
    grid-gap:4rem;
    gap:4rem
  }

  .lg\\:gap-20{
    grid-gap:5rem;
    gap:5rem
  }

  .lg\\:gap-24{
    grid-gap:6rem;
    gap:6rem
  }

  .lg\\:gap-32{
    grid-gap:8rem;
    gap:8rem
  }

  .lg\\:gap-40{
    grid-gap:10rem;
    gap:10rem
  }

  .lg\\:gap-48{
    grid-gap:12rem;
    gap:12rem
  }

  .lg\\:gap-56{
    grid-gap:14rem;
    gap:14rem
  }

  .lg\\:gap-64{
    grid-gap:16rem;
    gap:16rem
  }

  .lg\\:gap-px{
    grid-gap:1px;
    gap:1px
  }

  .lg\\:col-gap-0{
    grid-column-gap:0;
    column-gap:0
  }

  .lg\\:col-gap-1{
    grid-column-gap:.25rem;
    column-gap:.25rem
  }

  .lg\\:col-gap-2{
    grid-column-gap:.5rem;
    column-gap:.5rem
  }

  .lg\\:col-gap-3{
    grid-column-gap:.75rem;
    column-gap:.75rem
  }

  .lg\\:col-gap-4{
    grid-column-gap:1rem;
    column-gap:1rem
  }

  .lg\\:col-gap-5{
    grid-column-gap:1.25rem;
    column-gap:1.25rem
  }

  .lg\\:col-gap-6{
    grid-column-gap:1.5rem;
    column-gap:1.5rem
  }

  .lg\\:col-gap-8{
    grid-column-gap:2rem;
    column-gap:2rem
  }

  .lg\\:col-gap-10{
    grid-column-gap:2.5rem;
    column-gap:2.5rem
  }

  .lg\\:col-gap-12{
    grid-column-gap:3rem;
    column-gap:3rem
  }

  .lg\\:col-gap-16{
    grid-column-gap:4rem;
    column-gap:4rem
  }

  .lg\\:col-gap-20{
    grid-column-gap:5rem;
    column-gap:5rem
  }

  .lg\\:col-gap-24{
    grid-column-gap:6rem;
    column-gap:6rem
  }

  .lg\\:col-gap-32{
    grid-column-gap:8rem;
    column-gap:8rem
  }

  .lg\\:col-gap-40{
    grid-column-gap:10rem;
    column-gap:10rem
  }

  .lg\\:col-gap-48{
    grid-column-gap:12rem;
    column-gap:12rem
  }

  .lg\\:col-gap-56{
    grid-column-gap:14rem;
    column-gap:14rem
  }

  .lg\\:col-gap-64{
    grid-column-gap:16rem;
    column-gap:16rem
  }

  .lg\\:col-gap-px{
    grid-column-gap:1px;
    column-gap:1px
  }

  .lg\\:row-gap-0{
    grid-row-gap:0;
    row-gap:0
  }

  .lg\\:row-gap-1{
    grid-row-gap:.25rem;
    row-gap:.25rem
  }

  .lg\\:row-gap-2{
    grid-row-gap:.5rem;
    row-gap:.5rem
  }

  .lg\\:row-gap-3{
    grid-row-gap:.75rem;
    row-gap:.75rem
  }

  .lg\\:row-gap-4{
    grid-row-gap:1rem;
    row-gap:1rem
  }

  .lg\\:row-gap-5{
    grid-row-gap:1.25rem;
    row-gap:1.25rem
  }

  .lg\\:row-gap-6{
    grid-row-gap:1.5rem;
    row-gap:1.5rem
  }

  .lg\\:row-gap-8{
    grid-row-gap:2rem;
    row-gap:2rem
  }

  .lg\\:row-gap-10{
    grid-row-gap:2.5rem;
    row-gap:2.5rem
  }

  .lg\\:row-gap-12{
    grid-row-gap:3rem;
    row-gap:3rem
  }

  .lg\\:row-gap-16{
    grid-row-gap:4rem;
    row-gap:4rem
  }

  .lg\\:row-gap-20{
    grid-row-gap:5rem;
    row-gap:5rem
  }

  .lg\\:row-gap-24{
    grid-row-gap:6rem;
    row-gap:6rem
  }

  .lg\\:row-gap-32{
    grid-row-gap:8rem;
    row-gap:8rem
  }

  .lg\\:row-gap-40{
    grid-row-gap:10rem;
    row-gap:10rem
  }

  .lg\\:row-gap-48{
    grid-row-gap:12rem;
    row-gap:12rem
  }

  .lg\\:row-gap-56{
    grid-row-gap:14rem;
    row-gap:14rem
  }

  .lg\\:row-gap-64{
    grid-row-gap:16rem;
    row-gap:16rem
  }

  .lg\\:row-gap-px{
    grid-row-gap:1px;
    row-gap:1px
  }

  .lg\\:grid-flow-row{
    grid-auto-flow:row
  }

  .lg\\:grid-flow-col{
    grid-auto-flow:column
  }

  .lg\\:grid-flow-row-dense{
    grid-auto-flow:row dense
  }

  .lg\\:grid-flow-col-dense{
    grid-auto-flow:column dense
  }

  .lg\\:grid-cols-1{
    grid-template-columns:repeat(1,minmax(0,1fr))
  }

  .lg\\:grid-cols-2{
    grid-template-columns:repeat(2,minmax(0,1fr))
  }

  .lg\\:grid-cols-3{
    grid-template-columns:repeat(3,minmax(0,1fr))
  }

  .lg\\:grid-cols-4{
    grid-template-columns:repeat(4,minmax(0,1fr))
  }

  .lg\\:grid-cols-5{
    grid-template-columns:repeat(5,minmax(0,1fr))
  }

  .lg\\:grid-cols-6{
    grid-template-columns:repeat(6,minmax(0,1fr))
  }

  .lg\\:grid-cols-7{
    grid-template-columns:repeat(7,minmax(0,1fr))
  }

  .lg\\:grid-cols-8{
    grid-template-columns:repeat(8,minmax(0,1fr))
  }

  .lg\\:grid-cols-9{
    grid-template-columns:repeat(9,minmax(0,1fr))
  }

  .lg\\:grid-cols-10{
    grid-template-columns:repeat(10,minmax(0,1fr))
  }

  .lg\\:grid-cols-11{
    grid-template-columns:repeat(11,minmax(0,1fr))
  }

  .lg\\:grid-cols-12{
    grid-template-columns:repeat(12,minmax(0,1fr))
  }

  .lg\\:grid-cols-none{
    grid-template-columns:none
  }

  .lg\\:col-auto{
    grid-column:auto
  }

  .lg\\:col-span-1{
    grid-column:span 1/span 1
  }

  .lg\\:col-span-2{
    grid-column:span 2/span 2
  }

  .lg\\:col-span-3{
    grid-column:span 3/span 3
  }

  .lg\\:col-span-4{
    grid-column:span 4/span 4
  }

  .lg\\:col-span-5{
    grid-column:span 5/span 5
  }

  .lg\\:col-span-6{
    grid-column:span 6/span 6
  }

  .lg\\:col-span-7{
    grid-column:span 7/span 7
  }

  .lg\\:col-span-8{
    grid-column:span 8/span 8
  }

  .lg\\:col-span-9{
    grid-column:span 9/span 9
  }

  .lg\\:col-span-10{
    grid-column:span 10/span 10
  }

  .lg\\:col-span-11{
    grid-column:span 11/span 11
  }

  .lg\\:col-span-12{
    grid-column:span 12/span 12
  }

  .lg\\:col-start-1{
    grid-column-start:1
  }

  .lg\\:col-start-2{
    grid-column-start:2
  }

  .lg\\:col-start-3{
    grid-column-start:3
  }

  .lg\\:col-start-4{
    grid-column-start:4
  }

  .lg\\:col-start-5{
    grid-column-start:5
  }

  .lg\\:col-start-6{
    grid-column-start:6
  }

  .lg\\:col-start-7{
    grid-column-start:7
  }

  .lg\\:col-start-8{
    grid-column-start:8
  }

  .lg\\:col-start-9{
    grid-column-start:9
  }

  .lg\\:col-start-10{
    grid-column-start:10
  }

  .lg\\:col-start-11{
    grid-column-start:11
  }

  .lg\\:col-start-12{
    grid-column-start:12
  }

  .lg\\:col-start-13{
    grid-column-start:13
  }

  .lg\\:col-start-auto{
    grid-column-start:auto
  }

  .lg\\:col-end-1{
    grid-column-end:1
  }

  .lg\\:col-end-2{
    grid-column-end:2
  }

  .lg\\:col-end-3{
    grid-column-end:3
  }

  .lg\\:col-end-4{
    grid-column-end:4
  }

  .lg\\:col-end-5{
    grid-column-end:5
  }

  .lg\\:col-end-6{
    grid-column-end:6
  }

  .lg\\:col-end-7{
    grid-column-end:7
  }

  .lg\\:col-end-8{
    grid-column-end:8
  }

  .lg\\:col-end-9{
    grid-column-end:9
  }

  .lg\\:col-end-10{
    grid-column-end:10
  }

  .lg\\:col-end-11{
    grid-column-end:11
  }

  .lg\\:col-end-12{
    grid-column-end:12
  }

  .lg\\:col-end-13{
    grid-column-end:13
  }

  .lg\\:col-end-auto{
    grid-column-end:auto
  }

  .lg\\:grid-rows-1{
    grid-template-rows:repeat(1,minmax(0,1fr))
  }

  .lg\\:grid-rows-2{
    grid-template-rows:repeat(2,minmax(0,1fr))
  }

  .lg\\:grid-rows-3{
    grid-template-rows:repeat(3,minmax(0,1fr))
  }

  .lg\\:grid-rows-4{
    grid-template-rows:repeat(4,minmax(0,1fr))
  }

  .lg\\:grid-rows-5{
    grid-template-rows:repeat(5,minmax(0,1fr))
  }

  .lg\\:grid-rows-6{
    grid-template-rows:repeat(6,minmax(0,1fr))
  }

  .lg\\:grid-rows-none{
    grid-template-rows:none
  }

  .lg\\:row-auto{
    grid-row:auto
  }

  .lg\\:row-span-1{
    grid-row:span 1/span 1
  }

  .lg\\:row-span-2{
    grid-row:span 2/span 2
  }

  .lg\\:row-span-3{
    grid-row:span 3/span 3
  }

  .lg\\:row-span-4{
    grid-row:span 4/span 4
  }

  .lg\\:row-span-5{
    grid-row:span 5/span 5
  }

  .lg\\:row-span-6{
    grid-row:span 6/span 6
  }

  .lg\\:row-start-1{
    grid-row-start:1
  }

  .lg\\:row-start-2{
    grid-row-start:2
  }

  .lg\\:row-start-3{
    grid-row-start:3
  }

  .lg\\:row-start-4{
    grid-row-start:4
  }

  .lg\\:row-start-5{
    grid-row-start:5
  }

  .lg\\:row-start-6{
    grid-row-start:6
  }

  .lg\\:row-start-7{
    grid-row-start:7
  }

  .lg\\:row-start-auto{
    grid-row-start:auto
  }

  .lg\\:row-end-1{
    grid-row-end:1
  }

  .lg\\:row-end-2{
    grid-row-end:2
  }

  .lg\\:row-end-3{
    grid-row-end:3
  }

  .lg\\:row-end-4{
    grid-row-end:4
  }

  .lg\\:row-end-5{
    grid-row-end:5
  }

  .lg\\:row-end-6{
    grid-row-end:6
  }

  .lg\\:row-end-7{
    grid-row-end:7
  }

  .lg\\:row-end-auto{
    grid-row-end:auto
  }

  .lg\\:transform{
    --transform-translate-x:0;
    --transform-translate-y:0;
    --transform-rotate:0;
    --transform-skew-x:0;
    --transform-skew-y:0;
    --transform-scale-x:1;
    --transform-scale-y:1;
    transform:translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y))
  }

  .lg\\:transform-none{
    transform:none
  }

  .lg\\:origin-center{
    transform-origin:center
  }

  .lg\\:origin-top{
    transform-origin:top
  }

  .lg\\:origin-top-right{
    transform-origin:top right
  }

  .lg\\:origin-right{
    transform-origin:right
  }

  .lg\\:origin-bottom-right{
    transform-origin:bottom right
  }

  .lg\\:origin-bottom{
    transform-origin:bottom
  }

  .lg\\:origin-bottom-left{
    transform-origin:bottom left
  }

  .lg\\:origin-left{
    transform-origin:left
  }

  .lg\\:origin-top-left{
    transform-origin:top left
  }

  .lg\\:scale-0{
    --transform-scale-x:0;
    --transform-scale-y:0
  }

  .lg\\:scale-50{
    --transform-scale-x:.5;
    --transform-scale-y:.5
  }

  .lg\\:scale-75{
    --transform-scale-x:.75;
    --transform-scale-y:.75
  }

  .lg\\:scale-90{
    --transform-scale-x:.9;
    --transform-scale-y:.9
  }

  .lg\\:scale-95{
    --transform-scale-x:.95;
    --transform-scale-y:.95
  }

  .lg\\:scale-100{
    --transform-scale-x:1;
    --transform-scale-y:1
  }

  .lg\\:scale-105{
    --transform-scale-x:1.05;
    --transform-scale-y:1.05
  }

  .lg\\:scale-110{
    --transform-scale-x:1.1;
    --transform-scale-y:1.1
  }

  .lg\\:scale-125{
    --transform-scale-x:1.25;
    --transform-scale-y:1.25
  }

  .lg\\:scale-150{
    --transform-scale-x:1.5;
    --transform-scale-y:1.5
  }

  .lg\\:scale-x-0{
    --transform-scale-x:0
  }

  .lg\\:scale-x-50{
    --transform-scale-x:.5
  }

  .lg\\:scale-x-75{
    --transform-scale-x:.75
  }

  .lg\\:scale-x-90{
    --transform-scale-x:.9
  }

  .lg\\:scale-x-95{
    --transform-scale-x:.95
  }

  .lg\\:scale-x-100{
    --transform-scale-x:1
  }

  .lg\\:scale-x-105{
    --transform-scale-x:1.05
  }

  .lg\\:scale-x-110{
    --transform-scale-x:1.1
  }

  .lg\\:scale-x-125{
    --transform-scale-x:1.25
  }

  .lg\\:scale-x-150{
    --transform-scale-x:1.5
  }

  .lg\\:scale-y-0{
    --transform-scale-y:0
  }

  .lg\\:scale-y-50{
    --transform-scale-y:.5
  }

  .lg\\:scale-y-75{
    --transform-scale-y:.75
  }

  .lg\\:scale-y-90{
    --transform-scale-y:.9
  }

  .lg\\:scale-y-95{
    --transform-scale-y:.95
  }

  .lg\\:scale-y-100{
    --transform-scale-y:1
  }

  .lg\\:scale-y-105{
    --transform-scale-y:1.05
  }

  .lg\\:scale-y-110{
    --transform-scale-y:1.1
  }

  .lg\\:scale-y-125{
    --transform-scale-y:1.25
  }

  .lg\\:scale-y-150{
    --transform-scale-y:1.5
  }

  .lg\\:hover\\:scale-0:hover{
    --transform-scale-x:0;
    --transform-scale-y:0
  }

  .lg\\:hover\\:scale-50:hover{
    --transform-scale-x:.5;
    --transform-scale-y:.5
  }

  .lg\\:hover\\:scale-75:hover{
    --transform-scale-x:.75;
    --transform-scale-y:.75
  }

  .lg\\:hover\\:scale-90:hover{
    --transform-scale-x:.9;
    --transform-scale-y:.9
  }

  .lg\\:hover\\:scale-95:hover{
    --transform-scale-x:.95;
    --transform-scale-y:.95
  }

  .lg\\:hover\\:scale-100:hover{
    --transform-scale-x:1;
    --transform-scale-y:1
  }

  .lg\\:hover\\:scale-105:hover{
    --transform-scale-x:1.05;
    --transform-scale-y:1.05
  }

  .lg\\:hover\\:scale-110:hover{
    --transform-scale-x:1.1;
    --transform-scale-y:1.1
  }

  .lg\\:hover\\:scale-125:hover{
    --transform-scale-x:1.25;
    --transform-scale-y:1.25
  }

  .lg\\:hover\\:scale-150:hover{
    --transform-scale-x:1.5;
    --transform-scale-y:1.5
  }

  .lg\\:hover\\:scale-x-0:hover{
    --transform-scale-x:0
  }

  .lg\\:hover\\:scale-x-50:hover{
    --transform-scale-x:.5
  }

  .lg\\:hover\\:scale-x-75:hover{
    --transform-scale-x:.75
  }

  .lg\\:hover\\:scale-x-90:hover{
    --transform-scale-x:.9
  }

  .lg\\:hover\\:scale-x-95:hover{
    --transform-scale-x:.95
  }

  .lg\\:hover\\:scale-x-100:hover{
    --transform-scale-x:1
  }

  .lg\\:hover\\:scale-x-105:hover{
    --transform-scale-x:1.05
  }

  .lg\\:hover\\:scale-x-110:hover{
    --transform-scale-x:1.1
  }

  .lg\\:hover\\:scale-x-125:hover{
    --transform-scale-x:1.25
  }

  .lg\\:hover\\:scale-x-150:hover{
    --transform-scale-x:1.5
  }

  .lg\\:hover\\:scale-y-0:hover{
    --transform-scale-y:0
  }

  .lg\\:hover\\:scale-y-50:hover{
    --transform-scale-y:.5
  }

  .lg\\:hover\\:scale-y-75:hover{
    --transform-scale-y:.75
  }

  .lg\\:hover\\:scale-y-90:hover{
    --transform-scale-y:.9
  }

  .lg\\:hover\\:scale-y-95:hover{
    --transform-scale-y:.95
  }

  .lg\\:hover\\:scale-y-100:hover{
    --transform-scale-y:1
  }

  .lg\\:hover\\:scale-y-105:hover{
    --transform-scale-y:1.05
  }

  .lg\\:hover\\:scale-y-110:hover{
    --transform-scale-y:1.1
  }

  .lg\\:hover\\:scale-y-125:hover{
    --transform-scale-y:1.25
  }

  .lg\\:hover\\:scale-y-150:hover{
    --transform-scale-y:1.5
  }

  .lg\\:focus\\:scale-0:focus{
    --transform-scale-x:0;
    --transform-scale-y:0
  }

  .lg\\:focus\\:scale-50:focus{
    --transform-scale-x:.5;
    --transform-scale-y:.5
  }

  .lg\\:focus\\:scale-75:focus{
    --transform-scale-x:.75;
    --transform-scale-y:.75
  }

  .lg\\:focus\\:scale-90:focus{
    --transform-scale-x:.9;
    --transform-scale-y:.9
  }

  .lg\\:focus\\:scale-95:focus{
    --transform-scale-x:.95;
    --transform-scale-y:.95
  }

  .lg\\:focus\\:scale-100:focus{
    --transform-scale-x:1;
    --transform-scale-y:1
  }

  .lg\\:focus\\:scale-105:focus{
    --transform-scale-x:1.05;
    --transform-scale-y:1.05
  }

  .lg\\:focus\\:scale-110:focus{
    --transform-scale-x:1.1;
    --transform-scale-y:1.1
  }

  .lg\\:focus\\:scale-125:focus{
    --transform-scale-x:1.25;
    --transform-scale-y:1.25
  }

  .lg\\:focus\\:scale-150:focus{
    --transform-scale-x:1.5;
    --transform-scale-y:1.5
  }

  .lg\\:focus\\:scale-x-0:focus{
    --transform-scale-x:0
  }

  .lg\\:focus\\:scale-x-50:focus{
    --transform-scale-x:.5
  }

  .lg\\:focus\\:scale-x-75:focus{
    --transform-scale-x:.75
  }

  .lg\\:focus\\:scale-x-90:focus{
    --transform-scale-x:.9
  }

  .lg\\:focus\\:scale-x-95:focus{
    --transform-scale-x:.95
  }

  .lg\\:focus\\:scale-x-100:focus{
    --transform-scale-x:1
  }

  .lg\\:focus\\:scale-x-105:focus{
    --transform-scale-x:1.05
  }

  .lg\\:focus\\:scale-x-110:focus{
    --transform-scale-x:1.1
  }

  .lg\\:focus\\:scale-x-125:focus{
    --transform-scale-x:1.25
  }

  .lg\\:focus\\:scale-x-150:focus{
    --transform-scale-x:1.5
  }

  .lg\\:focus\\:scale-y-0:focus{
    --transform-scale-y:0
  }

  .lg\\:focus\\:scale-y-50:focus{
    --transform-scale-y:.5
  }

  .lg\\:focus\\:scale-y-75:focus{
    --transform-scale-y:.75
  }

  .lg\\:focus\\:scale-y-90:focus{
    --transform-scale-y:.9
  }

  .lg\\:focus\\:scale-y-95:focus{
    --transform-scale-y:.95
  }

  .lg\\:focus\\:scale-y-100:focus{
    --transform-scale-y:1
  }

  .lg\\:focus\\:scale-y-105:focus{
    --transform-scale-y:1.05
  }

  .lg\\:focus\\:scale-y-110:focus{
    --transform-scale-y:1.1
  }

  .lg\\:focus\\:scale-y-125:focus{
    --transform-scale-y:1.25
  }

  .lg\\:focus\\:scale-y-150:focus{
    --transform-scale-y:1.5
  }

  .lg\\:rotate-0{
    --transform-rotate:0
  }

  .lg\\:rotate-45{
    --transform-rotate:45deg
  }

  .lg\\:rotate-90{
    --transform-rotate:90deg
  }

  .lg\\:rotate-180{
    --transform-rotate:180deg
  }

  .lg\\:-rotate-180{
    --transform-rotate:-180deg
  }

  .lg\\:-rotate-90{
    --transform-rotate:-90deg
  }

  .lg\\:-rotate-45{
    --transform-rotate:-45deg
  }

  .lg\\:hover\\:rotate-0:hover{
    --transform-rotate:0
  }

  .lg\\:hover\\:rotate-45:hover{
    --transform-rotate:45deg
  }

  .lg\\:hover\\:rotate-90:hover{
    --transform-rotate:90deg
  }

  .lg\\:hover\\:rotate-180:hover{
    --transform-rotate:180deg
  }

  .lg\\:hover\\:-rotate-180:hover{
    --transform-rotate:-180deg
  }

  .lg\\:hover\\:-rotate-90:hover{
    --transform-rotate:-90deg
  }

  .lg\\:hover\\:-rotate-45:hover{
    --transform-rotate:-45deg
  }

  .lg\\:focus\\:rotate-0:focus{
    --transform-rotate:0
  }

  .lg\\:focus\\:rotate-45:focus{
    --transform-rotate:45deg
  }

  .lg\\:focus\\:rotate-90:focus{
    --transform-rotate:90deg
  }

  .lg\\:focus\\:rotate-180:focus{
    --transform-rotate:180deg
  }

  .lg\\:focus\\:-rotate-180:focus{
    --transform-rotate:-180deg
  }

  .lg\\:focus\\:-rotate-90:focus{
    --transform-rotate:-90deg
  }

  .lg\\:focus\\:-rotate-45:focus{
    --transform-rotate:-45deg
  }

  .lg\\:translate-x-0{
    --transform-translate-x:0
  }

  .lg\\:translate-x-1{
    --transform-translate-x:0.25rem
  }

  .lg\\:translate-x-2{
    --transform-translate-x:0.5rem
  }

  .lg\\:translate-x-3{
    --transform-translate-x:0.75rem
  }

  .lg\\:translate-x-4{
    --transform-translate-x:1rem
  }

  .lg\\:translate-x-5{
    --transform-translate-x:1.25rem
  }

  .lg\\:translate-x-6{
    --transform-translate-x:1.5rem
  }

  .lg\\:translate-x-8{
    --transform-translate-x:2rem
  }

  .lg\\:translate-x-10{
    --transform-translate-x:2.5rem
  }

  .lg\\:translate-x-12{
    --transform-translate-x:3rem
  }

  .lg\\:translate-x-16{
    --transform-translate-x:4rem
  }

  .lg\\:translate-x-20{
    --transform-translate-x:5rem
  }

  .lg\\:translate-x-24{
    --transform-translate-x:6rem
  }

  .lg\\:translate-x-32{
    --transform-translate-x:8rem
  }

  .lg\\:translate-x-40{
    --transform-translate-x:10rem
  }

  .lg\\:translate-x-48{
    --transform-translate-x:12rem
  }

  .lg\\:translate-x-56{
    --transform-translate-x:14rem
  }

  .lg\\:translate-x-64{
    --transform-translate-x:16rem
  }

  .lg\\:translate-x-px{
    --transform-translate-x:1px
  }

  .lg\\:-translate-x-1{
    --transform-translate-x:-0.25rem
  }

  .lg\\:-translate-x-2{
    --transform-translate-x:-0.5rem
  }

  .lg\\:-translate-x-3{
    --transform-translate-x:-0.75rem
  }

  .lg\\:-translate-x-4{
    --transform-translate-x:-1rem
  }

  .lg\\:-translate-x-5{
    --transform-translate-x:-1.25rem
  }

  .lg\\:-translate-x-6{
    --transform-translate-x:-1.5rem
  }

  .lg\\:-translate-x-8{
    --transform-translate-x:-2rem
  }

  .lg\\:-translate-x-10{
    --transform-translate-x:-2.5rem
  }

  .lg\\:-translate-x-12{
    --transform-translate-x:-3rem
  }

  .lg\\:-translate-x-16{
    --transform-translate-x:-4rem
  }

  .lg\\:-translate-x-20{
    --transform-translate-x:-5rem
  }

  .lg\\:-translate-x-24{
    --transform-translate-x:-6rem
  }

  .lg\\:-translate-x-32{
    --transform-translate-x:-8rem
  }

  .lg\\:-translate-x-40{
    --transform-translate-x:-10rem
  }

  .lg\\:-translate-x-48{
    --transform-translate-x:-12rem
  }

  .lg\\:-translate-x-56{
    --transform-translate-x:-14rem
  }

  .lg\\:-translate-x-64{
    --transform-translate-x:-16rem
  }

  .lg\\:-translate-x-px{
    --transform-translate-x:-1px
  }

  .lg\\:-translate-x-full{
    --transform-translate-x:-100%
  }

  .lg\\:-translate-x-1\\/2{
    --transform-translate-x:-50%
  }

  .lg\\:translate-x-1\\/2{
    --transform-translate-x:50%
  }

  .lg\\:translate-x-full{
    --transform-translate-x:100%
  }

  .lg\\:translate-y-0{
    --transform-translate-y:0
  }

  .lg\\:translate-y-1{
    --transform-translate-y:0.25rem
  }

  .lg\\:translate-y-2{
    --transform-translate-y:0.5rem
  }

  .lg\\:translate-y-3{
    --transform-translate-y:0.75rem
  }

  .lg\\:translate-y-4{
    --transform-translate-y:1rem
  }

  .lg\\:translate-y-5{
    --transform-translate-y:1.25rem
  }

  .lg\\:translate-y-6{
    --transform-translate-y:1.5rem
  }

  .lg\\:translate-y-8{
    --transform-translate-y:2rem
  }

  .lg\\:translate-y-10{
    --transform-translate-y:2.5rem
  }

  .lg\\:translate-y-12{
    --transform-translate-y:3rem
  }

  .lg\\:translate-y-16{
    --transform-translate-y:4rem
  }

  .lg\\:translate-y-20{
    --transform-translate-y:5rem
  }

  .lg\\:translate-y-24{
    --transform-translate-y:6rem
  }

  .lg\\:translate-y-32{
    --transform-translate-y:8rem
  }

  .lg\\:translate-y-40{
    --transform-translate-y:10rem
  }

  .lg\\:translate-y-48{
    --transform-translate-y:12rem
  }

  .lg\\:translate-y-56{
    --transform-translate-y:14rem
  }

  .lg\\:translate-y-64{
    --transform-translate-y:16rem
  }

  .lg\\:translate-y-px{
    --transform-translate-y:1px
  }

  .lg\\:-translate-y-1{
    --transform-translate-y:-0.25rem
  }

  .lg\\:-translate-y-2{
    --transform-translate-y:-0.5rem
  }

  .lg\\:-translate-y-3{
    --transform-translate-y:-0.75rem
  }

  .lg\\:-translate-y-4{
    --transform-translate-y:-1rem
  }

  .lg\\:-translate-y-5{
    --transform-translate-y:-1.25rem
  }

  .lg\\:-translate-y-6{
    --transform-translate-y:-1.5rem
  }

  .lg\\:-translate-y-8{
    --transform-translate-y:-2rem
  }

  .lg\\:-translate-y-10{
    --transform-translate-y:-2.5rem
  }

  .lg\\:-translate-y-12{
    --transform-translate-y:-3rem
  }

  .lg\\:-translate-y-16{
    --transform-translate-y:-4rem
  }

  .lg\\:-translate-y-20{
    --transform-translate-y:-5rem
  }

  .lg\\:-translate-y-24{
    --transform-translate-y:-6rem
  }

  .lg\\:-translate-y-32{
    --transform-translate-y:-8rem
  }

  .lg\\:-translate-y-40{
    --transform-translate-y:-10rem
  }

  .lg\\:-translate-y-48{
    --transform-translate-y:-12rem
  }

  .lg\\:-translate-y-56{
    --transform-translate-y:-14rem
  }

  .lg\\:-translate-y-64{
    --transform-translate-y:-16rem
  }

  .lg\\:-translate-y-px{
    --transform-translate-y:-1px
  }

  .lg\\:-translate-y-full{
    --transform-translate-y:-100%
  }

  .lg\\:-translate-y-1\\/2{
    --transform-translate-y:-50%
  }

  .lg\\:translate-y-1\\/2{
    --transform-translate-y:50%
  }

  .lg\\:translate-y-full{
    --transform-translate-y:100%
  }

  .lg\\:hover\\:translate-x-0:hover{
    --transform-translate-x:0
  }

  .lg\\:hover\\:translate-x-1:hover{
    --transform-translate-x:0.25rem
  }

  .lg\\:hover\\:translate-x-2:hover{
    --transform-translate-x:0.5rem
  }

  .lg\\:hover\\:translate-x-3:hover{
    --transform-translate-x:0.75rem
  }

  .lg\\:hover\\:translate-x-4:hover{
    --transform-translate-x:1rem
  }

  .lg\\:hover\\:translate-x-5:hover{
    --transform-translate-x:1.25rem
  }

  .lg\\:hover\\:translate-x-6:hover{
    --transform-translate-x:1.5rem
  }

  .lg\\:hover\\:translate-x-8:hover{
    --transform-translate-x:2rem
  }

  .lg\\:hover\\:translate-x-10:hover{
    --transform-translate-x:2.5rem
  }

  .lg\\:hover\\:translate-x-12:hover{
    --transform-translate-x:3rem
  }

  .lg\\:hover\\:translate-x-16:hover{
    --transform-translate-x:4rem
  }

  .lg\\:hover\\:translate-x-20:hover{
    --transform-translate-x:5rem
  }

  .lg\\:hover\\:translate-x-24:hover{
    --transform-translate-x:6rem
  }

  .lg\\:hover\\:translate-x-32:hover{
    --transform-translate-x:8rem
  }

  .lg\\:hover\\:translate-x-40:hover{
    --transform-translate-x:10rem
  }

  .lg\\:hover\\:translate-x-48:hover{
    --transform-translate-x:12rem
  }

  .lg\\:hover\\:translate-x-56:hover{
    --transform-translate-x:14rem
  }

  .lg\\:hover\\:translate-x-64:hover{
    --transform-translate-x:16rem
  }

  .lg\\:hover\\:translate-x-px:hover{
    --transform-translate-x:1px
  }

  .lg\\:hover\\:-translate-x-1:hover{
    --transform-translate-x:-0.25rem
  }

  .lg\\:hover\\:-translate-x-2:hover{
    --transform-translate-x:-0.5rem
  }

  .lg\\:hover\\:-translate-x-3:hover{
    --transform-translate-x:-0.75rem
  }

  .lg\\:hover\\:-translate-x-4:hover{
    --transform-translate-x:-1rem
  }

  .lg\\:hover\\:-translate-x-5:hover{
    --transform-translate-x:-1.25rem
  }

  .lg\\:hover\\:-translate-x-6:hover{
    --transform-translate-x:-1.5rem
  }

  .lg\\:hover\\:-translate-x-8:hover{
    --transform-translate-x:-2rem
  }

  .lg\\:hover\\:-translate-x-10:hover{
    --transform-translate-x:-2.5rem
  }

  .lg\\:hover\\:-translate-x-12:hover{
    --transform-translate-x:-3rem
  }

  .lg\\:hover\\:-translate-x-16:hover{
    --transform-translate-x:-4rem
  }

  .lg\\:hover\\:-translate-x-20:hover{
    --transform-translate-x:-5rem
  }

  .lg\\:hover\\:-translate-x-24:hover{
    --transform-translate-x:-6rem
  }

  .lg\\:hover\\:-translate-x-32:hover{
    --transform-translate-x:-8rem
  }

  .lg\\:hover\\:-translate-x-40:hover{
    --transform-translate-x:-10rem
  }

  .lg\\:hover\\:-translate-x-48:hover{
    --transform-translate-x:-12rem
  }

  .lg\\:hover\\:-translate-x-56:hover{
    --transform-translate-x:-14rem
  }

  .lg\\:hover\\:-translate-x-64:hover{
    --transform-translate-x:-16rem
  }

  .lg\\:hover\\:-translate-x-px:hover{
    --transform-translate-x:-1px
  }

  .lg\\:hover\\:-translate-x-full:hover{
    --transform-translate-x:-100%
  }

  .lg\\:hover\\:-translate-x-1\\/2:hover{
    --transform-translate-x:-50%
  }

  .lg\\:hover\\:translate-x-1\\/2:hover{
    --transform-translate-x:50%
  }

  .lg\\:hover\\:translate-x-full:hover{
    --transform-translate-x:100%
  }

  .lg\\:hover\\:translate-y-0:hover{
    --transform-translate-y:0
  }

  .lg\\:hover\\:translate-y-1:hover{
    --transform-translate-y:0.25rem
  }

  .lg\\:hover\\:translate-y-2:hover{
    --transform-translate-y:0.5rem
  }

  .lg\\:hover\\:translate-y-3:hover{
    --transform-translate-y:0.75rem
  }

  .lg\\:hover\\:translate-y-4:hover{
    --transform-translate-y:1rem
  }

  .lg\\:hover\\:translate-y-5:hover{
    --transform-translate-y:1.25rem
  }

  .lg\\:hover\\:translate-y-6:hover{
    --transform-translate-y:1.5rem
  }

  .lg\\:hover\\:translate-y-8:hover{
    --transform-translate-y:2rem
  }

  .lg\\:hover\\:translate-y-10:hover{
    --transform-translate-y:2.5rem
  }

  .lg\\:hover\\:translate-y-12:hover{
    --transform-translate-y:3rem
  }

  .lg\\:hover\\:translate-y-16:hover{
    --transform-translate-y:4rem
  }

  .lg\\:hover\\:translate-y-20:hover{
    --transform-translate-y:5rem
  }

  .lg\\:hover\\:translate-y-24:hover{
    --transform-translate-y:6rem
  }

  .lg\\:hover\\:translate-y-32:hover{
    --transform-translate-y:8rem
  }

  .lg\\:hover\\:translate-y-40:hover{
    --transform-translate-y:10rem
  }

  .lg\\:hover\\:translate-y-48:hover{
    --transform-translate-y:12rem
  }

  .lg\\:hover\\:translate-y-56:hover{
    --transform-translate-y:14rem
  }

  .lg\\:hover\\:translate-y-64:hover{
    --transform-translate-y:16rem
  }

  .lg\\:hover\\:translate-y-px:hover{
    --transform-translate-y:1px
  }

  .lg\\:hover\\:-translate-y-1:hover{
    --transform-translate-y:-0.25rem
  }

  .lg\\:hover\\:-translate-y-2:hover{
    --transform-translate-y:-0.5rem
  }

  .lg\\:hover\\:-translate-y-3:hover{
    --transform-translate-y:-0.75rem
  }

  .lg\\:hover\\:-translate-y-4:hover{
    --transform-translate-y:-1rem
  }

  .lg\\:hover\\:-translate-y-5:hover{
    --transform-translate-y:-1.25rem
  }

  .lg\\:hover\\:-translate-y-6:hover{
    --transform-translate-y:-1.5rem
  }

  .lg\\:hover\\:-translate-y-8:hover{
    --transform-translate-y:-2rem
  }

  .lg\\:hover\\:-translate-y-10:hover{
    --transform-translate-y:-2.5rem
  }

  .lg\\:hover\\:-translate-y-12:hover{
    --transform-translate-y:-3rem
  }

  .lg\\:hover\\:-translate-y-16:hover{
    --transform-translate-y:-4rem
  }

  .lg\\:hover\\:-translate-y-20:hover{
    --transform-translate-y:-5rem
  }

  .lg\\:hover\\:-translate-y-24:hover{
    --transform-translate-y:-6rem
  }

  .lg\\:hover\\:-translate-y-32:hover{
    --transform-translate-y:-8rem
  }

  .lg\\:hover\\:-translate-y-40:hover{
    --transform-translate-y:-10rem
  }

  .lg\\:hover\\:-translate-y-48:hover{
    --transform-translate-y:-12rem
  }

  .lg\\:hover\\:-translate-y-56:hover{
    --transform-translate-y:-14rem
  }

  .lg\\:hover\\:-translate-y-64:hover{
    --transform-translate-y:-16rem
  }

  .lg\\:hover\\:-translate-y-px:hover{
    --transform-translate-y:-1px
  }

  .lg\\:hover\\:-translate-y-full:hover{
    --transform-translate-y:-100%
  }

  .lg\\:hover\\:-translate-y-1\\/2:hover{
    --transform-translate-y:-50%
  }

  .lg\\:hover\\:translate-y-1\\/2:hover{
    --transform-translate-y:50%
  }

  .lg\\:hover\\:translate-y-full:hover{
    --transform-translate-y:100%
  }

  .lg\\:focus\\:translate-x-0:focus{
    --transform-translate-x:0
  }

  .lg\\:focus\\:translate-x-1:focus{
    --transform-translate-x:0.25rem
  }

  .lg\\:focus\\:translate-x-2:focus{
    --transform-translate-x:0.5rem
  }

  .lg\\:focus\\:translate-x-3:focus{
    --transform-translate-x:0.75rem
  }

  .lg\\:focus\\:translate-x-4:focus{
    --transform-translate-x:1rem
  }

  .lg\\:focus\\:translate-x-5:focus{
    --transform-translate-x:1.25rem
  }

  .lg\\:focus\\:translate-x-6:focus{
    --transform-translate-x:1.5rem
  }

  .lg\\:focus\\:translate-x-8:focus{
    --transform-translate-x:2rem
  }

  .lg\\:focus\\:translate-x-10:focus{
    --transform-translate-x:2.5rem
  }

  .lg\\:focus\\:translate-x-12:focus{
    --transform-translate-x:3rem
  }

  .lg\\:focus\\:translate-x-16:focus{
    --transform-translate-x:4rem
  }

  .lg\\:focus\\:translate-x-20:focus{
    --transform-translate-x:5rem
  }

  .lg\\:focus\\:translate-x-24:focus{
    --transform-translate-x:6rem
  }

  .lg\\:focus\\:translate-x-32:focus{
    --transform-translate-x:8rem
  }

  .lg\\:focus\\:translate-x-40:focus{
    --transform-translate-x:10rem
  }

  .lg\\:focus\\:translate-x-48:focus{
    --transform-translate-x:12rem
  }

  .lg\\:focus\\:translate-x-56:focus{
    --transform-translate-x:14rem
  }

  .lg\\:focus\\:translate-x-64:focus{
    --transform-translate-x:16rem
  }

  .lg\\:focus\\:translate-x-px:focus{
    --transform-translate-x:1px
  }

  .lg\\:focus\\:-translate-x-1:focus{
    --transform-translate-x:-0.25rem
  }

  .lg\\:focus\\:-translate-x-2:focus{
    --transform-translate-x:-0.5rem
  }

  .lg\\:focus\\:-translate-x-3:focus{
    --transform-translate-x:-0.75rem
  }

  .lg\\:focus\\:-translate-x-4:focus{
    --transform-translate-x:-1rem
  }

  .lg\\:focus\\:-translate-x-5:focus{
    --transform-translate-x:-1.25rem
  }

  .lg\\:focus\\:-translate-x-6:focus{
    --transform-translate-x:-1.5rem
  }

  .lg\\:focus\\:-translate-x-8:focus{
    --transform-translate-x:-2rem
  }

  .lg\\:focus\\:-translate-x-10:focus{
    --transform-translate-x:-2.5rem
  }

  .lg\\:focus\\:-translate-x-12:focus{
    --transform-translate-x:-3rem
  }

  .lg\\:focus\\:-translate-x-16:focus{
    --transform-translate-x:-4rem
  }

  .lg\\:focus\\:-translate-x-20:focus{
    --transform-translate-x:-5rem
  }

  .lg\\:focus\\:-translate-x-24:focus{
    --transform-translate-x:-6rem
  }

  .lg\\:focus\\:-translate-x-32:focus{
    --transform-translate-x:-8rem
  }

  .lg\\:focus\\:-translate-x-40:focus{
    --transform-translate-x:-10rem
  }

  .lg\\:focus\\:-translate-x-48:focus{
    --transform-translate-x:-12rem
  }

  .lg\\:focus\\:-translate-x-56:focus{
    --transform-translate-x:-14rem
  }

  .lg\\:focus\\:-translate-x-64:focus{
    --transform-translate-x:-16rem
  }

  .lg\\:focus\\:-translate-x-px:focus{
    --transform-translate-x:-1px
  }

  .lg\\:focus\\:-translate-x-full:focus{
    --transform-translate-x:-100%
  }

  .lg\\:focus\\:-translate-x-1\\/2:focus{
    --transform-translate-x:-50%
  }

  .lg\\:focus\\:translate-x-1\\/2:focus{
    --transform-translate-x:50%
  }

  .lg\\:focus\\:translate-x-full:focus{
    --transform-translate-x:100%
  }

  .lg\\:focus\\:translate-y-0:focus{
    --transform-translate-y:0
  }

  .lg\\:focus\\:translate-y-1:focus{
    --transform-translate-y:0.25rem
  }

  .lg\\:focus\\:translate-y-2:focus{
    --transform-translate-y:0.5rem
  }

  .lg\\:focus\\:translate-y-3:focus{
    --transform-translate-y:0.75rem
  }

  .lg\\:focus\\:translate-y-4:focus{
    --transform-translate-y:1rem
  }

  .lg\\:focus\\:translate-y-5:focus{
    --transform-translate-y:1.25rem
  }

  .lg\\:focus\\:translate-y-6:focus{
    --transform-translate-y:1.5rem
  }

  .lg\\:focus\\:translate-y-8:focus{
    --transform-translate-y:2rem
  }

  .lg\\:focus\\:translate-y-10:focus{
    --transform-translate-y:2.5rem
  }

  .lg\\:focus\\:translate-y-12:focus{
    --transform-translate-y:3rem
  }

  .lg\\:focus\\:translate-y-16:focus{
    --transform-translate-y:4rem
  }

  .lg\\:focus\\:translate-y-20:focus{
    --transform-translate-y:5rem
  }

  .lg\\:focus\\:translate-y-24:focus{
    --transform-translate-y:6rem
  }

  .lg\\:focus\\:translate-y-32:focus{
    --transform-translate-y:8rem
  }

  .lg\\:focus\\:translate-y-40:focus{
    --transform-translate-y:10rem
  }

  .lg\\:focus\\:translate-y-48:focus{
    --transform-translate-y:12rem
  }

  .lg\\:focus\\:translate-y-56:focus{
    --transform-translate-y:14rem
  }

  .lg\\:focus\\:translate-y-64:focus{
    --transform-translate-y:16rem
  }

  .lg\\:focus\\:translate-y-px:focus{
    --transform-translate-y:1px
  }

  .lg\\:focus\\:-translate-y-1:focus{
    --transform-translate-y:-0.25rem
  }

  .lg\\:focus\\:-translate-y-2:focus{
    --transform-translate-y:-0.5rem
  }

  .lg\\:focus\\:-translate-y-3:focus{
    --transform-translate-y:-0.75rem
  }

  .lg\\:focus\\:-translate-y-4:focus{
    --transform-translate-y:-1rem
  }

  .lg\\:focus\\:-translate-y-5:focus{
    --transform-translate-y:-1.25rem
  }

  .lg\\:focus\\:-translate-y-6:focus{
    --transform-translate-y:-1.5rem
  }

  .lg\\:focus\\:-translate-y-8:focus{
    --transform-translate-y:-2rem
  }

  .lg\\:focus\\:-translate-y-10:focus{
    --transform-translate-y:-2.5rem
  }

  .lg\\:focus\\:-translate-y-12:focus{
    --transform-translate-y:-3rem
  }

  .lg\\:focus\\:-translate-y-16:focus{
    --transform-translate-y:-4rem
  }

  .lg\\:focus\\:-translate-y-20:focus{
    --transform-translate-y:-5rem
  }

  .lg\\:focus\\:-translate-y-24:focus{
    --transform-translate-y:-6rem
  }

  .lg\\:focus\\:-translate-y-32:focus{
    --transform-translate-y:-8rem
  }

  .lg\\:focus\\:-translate-y-40:focus{
    --transform-translate-y:-10rem
  }

  .lg\\:focus\\:-translate-y-48:focus{
    --transform-translate-y:-12rem
  }

  .lg\\:focus\\:-translate-y-56:focus{
    --transform-translate-y:-14rem
  }

  .lg\\:focus\\:-translate-y-64:focus{
    --transform-translate-y:-16rem
  }

  .lg\\:focus\\:-translate-y-px:focus{
    --transform-translate-y:-1px
  }

  .lg\\:focus\\:-translate-y-full:focus{
    --transform-translate-y:-100%
  }

  .lg\\:focus\\:-translate-y-1\\/2:focus{
    --transform-translate-y:-50%
  }

  .lg\\:focus\\:translate-y-1\\/2:focus{
    --transform-translate-y:50%
  }

  .lg\\:focus\\:translate-y-full:focus{
    --transform-translate-y:100%
  }

  .lg\\:skew-x-0{
    --transform-skew-x:0
  }

  .lg\\:skew-x-3{
    --transform-skew-x:3deg
  }

  .lg\\:skew-x-6{
    --transform-skew-x:6deg
  }

  .lg\\:skew-x-12{
    --transform-skew-x:12deg
  }

  .lg\\:-skew-x-12{
    --transform-skew-x:-12deg
  }

  .lg\\:-skew-x-6{
    --transform-skew-x:-6deg
  }

  .lg\\:-skew-x-3{
    --transform-skew-x:-3deg
  }

  .lg\\:skew-y-0{
    --transform-skew-y:0
  }

  .lg\\:skew-y-3{
    --transform-skew-y:3deg
  }

  .lg\\:skew-y-6{
    --transform-skew-y:6deg
  }

  .lg\\:skew-y-12{
    --transform-skew-y:12deg
  }

  .lg\\:-skew-y-12{
    --transform-skew-y:-12deg
  }

  .lg\\:-skew-y-6{
    --transform-skew-y:-6deg
  }

  .lg\\:-skew-y-3{
    --transform-skew-y:-3deg
  }

  .lg\\:hover\\:skew-x-0:hover{
    --transform-skew-x:0
  }

  .lg\\:hover\\:skew-x-3:hover{
    --transform-skew-x:3deg
  }

  .lg\\:hover\\:skew-x-6:hover{
    --transform-skew-x:6deg
  }

  .lg\\:hover\\:skew-x-12:hover{
    --transform-skew-x:12deg
  }

  .lg\\:hover\\:-skew-x-12:hover{
    --transform-skew-x:-12deg
  }

  .lg\\:hover\\:-skew-x-6:hover{
    --transform-skew-x:-6deg
  }

  .lg\\:hover\\:-skew-x-3:hover{
    --transform-skew-x:-3deg
  }

  .lg\\:hover\\:skew-y-0:hover{
    --transform-skew-y:0
  }

  .lg\\:hover\\:skew-y-3:hover{
    --transform-skew-y:3deg
  }

  .lg\\:hover\\:skew-y-6:hover{
    --transform-skew-y:6deg
  }

  .lg\\:hover\\:skew-y-12:hover{
    --transform-skew-y:12deg
  }

  .lg\\:hover\\:-skew-y-12:hover{
    --transform-skew-y:-12deg
  }

  .lg\\:hover\\:-skew-y-6:hover{
    --transform-skew-y:-6deg
  }

  .lg\\:hover\\:-skew-y-3:hover{
    --transform-skew-y:-3deg
  }

  .lg\\:focus\\:skew-x-0:focus{
    --transform-skew-x:0
  }

  .lg\\:focus\\:skew-x-3:focus{
    --transform-skew-x:3deg
  }

  .lg\\:focus\\:skew-x-6:focus{
    --transform-skew-x:6deg
  }

  .lg\\:focus\\:skew-x-12:focus{
    --transform-skew-x:12deg
  }

  .lg\\:focus\\:-skew-x-12:focus{
    --transform-skew-x:-12deg
  }

  .lg\\:focus\\:-skew-x-6:focus{
    --transform-skew-x:-6deg
  }

  .lg\\:focus\\:-skew-x-3:focus{
    --transform-skew-x:-3deg
  }

  .lg\\:focus\\:skew-y-0:focus{
    --transform-skew-y:0
  }

  .lg\\:focus\\:skew-y-3:focus{
    --transform-skew-y:3deg
  }

  .lg\\:focus\\:skew-y-6:focus{
    --transform-skew-y:6deg
  }

  .lg\\:focus\\:skew-y-12:focus{
    --transform-skew-y:12deg
  }

  .lg\\:focus\\:-skew-y-12:focus{
    --transform-skew-y:-12deg
  }

  .lg\\:focus\\:-skew-y-6:focus{
    --transform-skew-y:-6deg
  }

  .lg\\:focus\\:-skew-y-3:focus{
    --transform-skew-y:-3deg
  }

  .lg\\:transition-none{
    transition-property:none
  }

  .lg\\:transition-all{
    transition-property:all
  }

  .lg\\:transition{
    transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform
  }

  .lg\\:transition-colors{
    transition-property:background-color,border-color,color,fill,stroke
  }

  .lg\\:transition-opacity{
    transition-property:opacity
  }

  .lg\\:transition-shadow{
    transition-property:box-shadow
  }

  .lg\\:transition-transform{
    transition-property:transform
  }

  .lg\\:ease-linear{
    transition-timing-function:linear
  }

  .lg\\:ease-in{
    transition-timing-function:cubic-bezier(.4,0,1,1)
  }

  .lg\\:ease-out{
    transition-timing-function:cubic-bezier(0,0,.2,1)
  }

  .lg\\:ease-in-out{
    transition-timing-function:cubic-bezier(.4,0,.2,1)
  }

  .lg\\:duration-75{
    transition-duration:75ms
  }

  .lg\\:duration-100{
    transition-duration:.1s
  }

  .lg\\:duration-150{
    transition-duration:.15s
  }

  .lg\\:duration-200{
    transition-duration:.2s
  }

  .lg\\:duration-300{
    transition-duration:.3s
  }

  .lg\\:duration-500{
    transition-duration:.5s
  }

  .lg\\:duration-700{
    transition-duration:.7s
  }

  .lg\\:duration-1000{
    transition-duration:1s
  }

  .lg\\:delay-75{
    transition-delay:75ms
  }

  .lg\\:delay-100{
    transition-delay:.1s
  }

  .lg\\:delay-150{
    transition-delay:.15s
  }

  .lg\\:delay-200{
    transition-delay:.2s
  }

  .lg\\:delay-300{
    transition-delay:.3s
  }

  .lg\\:delay-500{
    transition-delay:.5s
  }

  .lg\\:delay-700{
    transition-delay:.7s
  }

  .lg\\:delay-1000{
    transition-delay:1s
  }

  .lg\\:shadow-outline-white{
    box-shadow:0 0 0 3px #ffffff73
  }

  .lg\\:shadow-outline-black{
    box-shadow:0 0 0 3px #00000073
  }

  .lg\\:shadow-outline-gray{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .lg\\:shadow-outline-cool-gray{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .lg\\:shadow-outline-red{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .lg\\:shadow-outline-orange{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .lg\\:shadow-outline-yellow{
    box-shadow:0 0 0 3px #faca1573
  }

  .lg\\:shadow-outline-green{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .lg\\:shadow-outline-teal{
    box-shadow:0 0 0 3px #7edce273
  }

  .lg\\:shadow-outline-blue{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .lg\\:shadow-outline-indigo{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .lg\\:shadow-outline-indigo{
    box-shadow:0 0 0 3px #cabffd73
  }

  .lg\\:shadow-outline-pink{
    box-shadow:0 0 0 3px #f8b4d973
  }

  .lg\\:hover\\:shadow-outline-white:hover{
    box-shadow:0 0 0 3px #ffffff73
  }

  .lg\\:hover\\:shadow-outline-black:hover{
    box-shadow:0 0 0 3px #00000073
  }

  .lg\\:hover\\:shadow-outline-gray:hover{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .lg\\:hover\\:shadow-outline-cool-gray:hover{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .lg\\:hover\\:shadow-outline-red:hover{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .lg\\:hover\\:shadow-outline-orange:hover{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .lg\\:hover\\:shadow-outline-yellow:hover{
    box-shadow:0 0 0 3px #faca1573
  }

  .lg\\:hover\\:shadow-outline-green:hover{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .lg\\:hover\\:shadow-outline-teal:hover{
    box-shadow:0 0 0 3px #7edce273
  }

  .lg\\:hover\\:shadow-outline-blue:hover{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .lg\\:hover\\:shadow-outline-indigo:hover{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .lg\\:hover\\:shadow-outline-indigo:hover{
    box-shadow:0 0 0 3px #cabffd73
  }

  .lg\\:hover\\:shadow-outline-pink:hover{
    box-shadow:0 0 0 3px #f8b4d973
  }

  .lg\\:focus\\:shadow-outline-white:focus{
    box-shadow:0 0 0 3px #ffffff73
  }

  .lg\\:focus\\:shadow-outline-black:focus{
    box-shadow:0 0 0 3px #00000073
  }

  .lg\\:focus\\:shadow-outline-gray:focus{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .lg\\:focus\\:shadow-outline-cool-gray:focus{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .lg\\:focus\\:shadow-outline-red:focus{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .lg\\:focus\\:shadow-outline-orange:focus{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .lg\\:focus\\:shadow-outline-yellow:focus{
    box-shadow:0 0 0 3px #faca1573
  }

  .lg\\:focus\\:shadow-outline-green:focus{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .lg\\:focus\\:shadow-outline-teal:focus{
    box-shadow:0 0 0 3px #7edce273
  }

  .lg\\:focus\\:shadow-outline-blue:focus{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .lg\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .lg\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #cabffd73
  }

  .lg\\:focus\\:shadow-outline-pink:focus{
    box-shadow:0 0 0 3px #f8b4d973
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-outline-white:focus{
    box-shadow:0 0 0 3px #ffffff73
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-outline-black:focus{
    box-shadow:0 0 0 3px #00000073
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-outline-gray:focus{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-outline-cool-gray:focus{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-outline-red:focus{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-outline-orange:focus{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-outline-yellow:focus{
    box-shadow:0 0 0 3px #faca1573
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-outline-green:focus{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-outline-teal:focus{
    box-shadow:0 0 0 3px #7edce273
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-outline-blue:focus{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #cabffd73
  }

  .theme-dark .lg\\:dark\\:focus\\:shadow-outline-pink:focus{
    box-shadow:0 0 0 3px #f8b4d973
  }
}

@media (min-width:1280px){
  .xl\\:space-y-0>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(0px*var(--space-y-reverse));
    margin-top:calc(0px*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-0>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(0px*(1 - var(--space-x-reverse)));
    margin-right:calc(0px*var(--space-x-reverse))
  }

  .xl\\:space-y-1>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(.25rem*var(--space-y-reverse));
    margin-top:calc(.25rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-1>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(.25rem*var(--space-x-reverse))
  }

  .xl\\:space-y-2>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(.5rem*var(--space-y-reverse));
    margin-top:calc(.5rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-2>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(.5rem*var(--space-x-reverse))
  }

  .xl\\:space-y-3>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(.75rem*var(--space-y-reverse));
    margin-top:calc(.75rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-3>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(.75rem*(1 - var(--space-x-reverse)));
    margin-right:calc(.75rem*var(--space-x-reverse))
  }

  .xl\\:space-y-4>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1rem*var(--space-y-reverse));
    margin-top:calc(1rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-4>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1rem*(1 - var(--space-x-reverse)));
    margin-right:calc(1rem*var(--space-x-reverse))
  }

  .xl\\:space-y-5>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1.25rem*var(--space-y-reverse));
    margin-top:calc(1.25rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-5>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(1.25rem*var(--space-x-reverse))
  }

  .xl\\:space-y-6>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1.5rem*var(--space-y-reverse));
    margin-top:calc(1.5rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-6>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(1.5rem*var(--space-x-reverse))
  }

  .xl\\:space-y-8>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(2rem*var(--space-y-reverse));
    margin-top:calc(2rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-8>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(2rem*(1 - var(--space-x-reverse)));
    margin-right:calc(2rem*var(--space-x-reverse))
  }

  .xl\\:space-y-10>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(2.5rem*var(--space-y-reverse));
    margin-top:calc(2.5rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-10>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(2.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(2.5rem*var(--space-x-reverse))
  }

  .xl\\:space-y-12>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(3rem*var(--space-y-reverse));
    margin-top:calc(3rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-12>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(3rem*(1 - var(--space-x-reverse)));
    margin-right:calc(3rem*var(--space-x-reverse))
  }

  .xl\\:space-y-16>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(4rem*var(--space-y-reverse));
    margin-top:calc(4rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-16>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(4rem*(1 - var(--space-x-reverse)));
    margin-right:calc(4rem*var(--space-x-reverse))
  }

  .xl\\:space-y-20>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(5rem*var(--space-y-reverse));
    margin-top:calc(5rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-20>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(5rem*var(--space-x-reverse))
  }

  .xl\\:space-y-24>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(6rem*var(--space-y-reverse));
    margin-top:calc(6rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-24>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(6rem*(1 - var(--space-x-reverse)));
    margin-right:calc(6rem*var(--space-x-reverse))
  }

  .xl\\:space-y-32>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(8rem*var(--space-y-reverse));
    margin-top:calc(8rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-32>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(8rem*(1 - var(--space-x-reverse)));
    margin-right:calc(8rem*var(--space-x-reverse))
  }

  .xl\\:space-y-40>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(10rem*var(--space-y-reverse));
    margin-top:calc(10rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-40>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(10rem*(1 - var(--space-x-reverse)));
    margin-right:calc(10rem*var(--space-x-reverse))
  }

  .xl\\:space-y-48>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(12rem*var(--space-y-reverse));
    margin-top:calc(12rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-48>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(12rem*(1 - var(--space-x-reverse)));
    margin-right:calc(12rem*var(--space-x-reverse))
  }

  .xl\\:space-y-56>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(14rem*var(--space-y-reverse));
    margin-top:calc(14rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-56>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(14rem*(1 - var(--space-x-reverse)));
    margin-right:calc(14rem*var(--space-x-reverse))
  }

  .xl\\:space-y-64>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(16rem*var(--space-y-reverse));
    margin-top:calc(16rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-64>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(16rem*(1 - var(--space-x-reverse)));
    margin-right:calc(16rem*var(--space-x-reverse))
  }

  .xl\\:space-y-px>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(1px*var(--space-y-reverse));
    margin-top:calc(1px*(1 - var(--space-y-reverse)))
  }

  .xl\\:space-x-px>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(1px*(1 - var(--space-x-reverse)));
    margin-right:calc(1px*var(--space-x-reverse))
  }

  .xl\\:-space-y-1>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-.25rem*var(--space-y-reverse));
    margin-top:calc(-.25rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-1>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-.25rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-2>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-.5rem*var(--space-y-reverse));
    margin-top:calc(-.5rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-2>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-.5rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-3>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-.75rem*var(--space-y-reverse));
    margin-top:calc(-.75rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-3>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-.75rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-.75rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-4>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1rem*var(--space-y-reverse));
    margin-top:calc(-1rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-4>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-1rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-5>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1.25rem*var(--space-y-reverse));
    margin-top:calc(-1.25rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-5>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1.25rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-1.25rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-6>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1.5rem*var(--space-y-reverse));
    margin-top:calc(-1.5rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-6>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-1.5rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-8>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-2rem*var(--space-y-reverse));
    margin-top:calc(-2rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-8>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-2rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-2rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-10>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-2.5rem*var(--space-y-reverse));
    margin-top:calc(-2.5rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-10>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-2.5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-2.5rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-12>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-3rem*var(--space-y-reverse));
    margin-top:calc(-3rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-12>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-3rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-3rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-16>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-4rem*var(--space-y-reverse));
    margin-top:calc(-4rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-16>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-4rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-4rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-20>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-5rem*var(--space-y-reverse));
    margin-top:calc(-5rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-20>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-5rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-5rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-24>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-6rem*var(--space-y-reverse));
    margin-top:calc(-6rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-24>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-6rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-6rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-32>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-8rem*var(--space-y-reverse));
    margin-top:calc(-8rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-32>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-8rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-8rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-40>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-10rem*var(--space-y-reverse));
    margin-top:calc(-10rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-40>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-10rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-10rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-48>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-12rem*var(--space-y-reverse));
    margin-top:calc(-12rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-48>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-12rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-12rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-56>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-14rem*var(--space-y-reverse));
    margin-top:calc(-14rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-56>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-14rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-14rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-64>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-16rem*var(--space-y-reverse));
    margin-top:calc(-16rem*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-64>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-16rem*(1 - var(--space-x-reverse)));
    margin-right:calc(-16rem*var(--space-x-reverse))
  }

  .xl\\:-space-y-px>:not(template)~:not(template){
    --space-y-reverse:0;
    margin-bottom:calc(-1px*var(--space-y-reverse));
    margin-top:calc(-1px*(1 - var(--space-y-reverse)))
  }

  .xl\\:-space-x-px>:not(template)~:not(template){
    --space-x-reverse:0;
    margin-left:calc(-1px*(1 - var(--space-x-reverse)));
    margin-right:calc(-1px*var(--space-x-reverse))
  }

  .xl\\:space-y-reverse>:not(template)~:not(template){
    --space-y-reverse:1
  }

  .xl\\:space-x-reverse>:not(template)~:not(template){
    --space-x-reverse:1
  }

  .xl\\:divide-y-0>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(0px*var(--divide-y-reverse));
    border-top-width:calc(0px*(1 - var(--divide-y-reverse)))
  }

  .xl\\:divide-x-0>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(0px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(0px*var(--divide-x-reverse))
  }

  .xl\\:divide-y-2>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(2px*var(--divide-y-reverse));
    border-top-width:calc(2px*(1 - var(--divide-y-reverse)))
  }

  .xl\\:divide-x-2>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(2px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(2px*var(--divide-x-reverse))
  }

  .xl\\:divide-y-4>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(4px*var(--divide-y-reverse));
    border-top-width:calc(4px*(1 - var(--divide-y-reverse)))
  }

  .xl\\:divide-x-4>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(4px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(4px*var(--divide-x-reverse))
  }

  .xl\\:divide-y-8>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(8px*var(--divide-y-reverse));
    border-top-width:calc(8px*(1 - var(--divide-y-reverse)))
  }

  .xl\\:divide-x-8>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(8px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(8px*var(--divide-x-reverse))
  }

  .xl\\:divide-y>:not(template)~:not(template){
    --divide-y-reverse:0;
    border-bottom-width:calc(1px*var(--divide-y-reverse));
    border-top-width:calc(1px*(1 - var(--divide-y-reverse)))
  }

  .xl\\:divide-x>:not(template)~:not(template){
    --divide-x-reverse:0;
    border-left-width:calc(1px*(1 - var(--divide-x-reverse)));
    border-right-width:calc(1px*var(--divide-x-reverse))
  }

  .xl\\:divide-y-reverse>:not(template)~:not(template){
    --divide-y-reverse:1
  }

  .xl\\:divide-x-reverse>:not(template)~:not(template){
    --divide-x-reverse:1
  }

  .xl\\:divide-transparent>:not(template)~:not(template){
    border-color:#0000
  }

  .xl\\:divide-white>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--divide-opacity))
  }

  .xl\\:divide-black>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--divide-opacity))
  }

  .xl\\:divide-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--divide-opacity))
  }

  .xl\\:divide-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--divide-opacity))
  }

  .xl\\:divide-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--divide-opacity))
  }

  .xl\\:divide-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--divide-opacity))
  }

  .xl\\:divide-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--divide-opacity))
  }

  .xl\\:divide-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--divide-opacity))
  }

  .xl\\:divide-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--divide-opacity))
  }

  .xl\\:divide-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--divide-opacity))
  }

  .xl\\:divide-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--divide-opacity))
  }

  .xl\\:divide-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--divide-opacity))
  }

  .xl\\:divide-cool-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--divide-opacity))
  }

  .xl\\:divide-cool-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--divide-opacity))
  }

  .xl\\:divide-cool-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--divide-opacity))
  }

  .xl\\:divide-cool-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--divide-opacity))
  }

  .xl\\:divide-cool-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--divide-opacity))
  }

  .xl\\:divide-cool-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--divide-opacity))
  }

  .xl\\:divide-cool-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--divide-opacity))
  }

  .xl\\:divide-cool-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--divide-opacity))
  }

  .xl\\:divide-cool-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--divide-opacity))
  }

  .xl\\:divide-cool-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--divide-opacity))
  }

  .xl\\:divide-red-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--divide-opacity))
  }

  .xl\\:divide-red-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--divide-opacity))
  }

  .xl\\:divide-red-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--divide-opacity))
  }

  .xl\\:divide-red-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--divide-opacity))
  }

  .xl\\:divide-red-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--divide-opacity))
  }

  .xl\\:divide-red-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--divide-opacity))
  }

  .xl\\:divide-red-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--divide-opacity))
  }

  .xl\\:divide-red-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--divide-opacity))
  }

  .xl\\:divide-red-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--divide-opacity))
  }

  .xl\\:divide-red-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .xl\\:divide-orange-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--divide-opacity))
  }

  .xl\\:divide-orange-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--divide-opacity))
  }

  .xl\\:divide-orange-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--divide-opacity))
  }

  .xl\\:divide-orange-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--divide-opacity))
  }

  .xl\\:divide-orange-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--divide-opacity))
  }

  .xl\\:divide-orange-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--divide-opacity))
  }

  .xl\\:divide-orange-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--divide-opacity))
  }

  .xl\\:divide-orange-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--divide-opacity))
  }

  .xl\\:divide-orange-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--divide-opacity))
  }

  .xl\\:divide-orange-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .xl\\:divide-yellow-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--divide-opacity))
  }

  .xl\\:divide-yellow-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--divide-opacity))
  }

  .xl\\:divide-yellow-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--divide-opacity))
  }

  .xl\\:divide-yellow-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--divide-opacity))
  }

  .xl\\:divide-yellow-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--divide-opacity))
  }

  .xl\\:divide-yellow-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--divide-opacity))
  }

  .xl\\:divide-yellow-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--divide-opacity))
  }

  .xl\\:divide-yellow-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--divide-opacity))
  }

  .xl\\:divide-yellow-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--divide-opacity))
  }

  .xl\\:divide-yellow-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--divide-opacity))
  }

  .xl\\:divide-green-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--divide-opacity))
  }

  .xl\\:divide-green-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--divide-opacity))
  }

  .xl\\:divide-green-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--divide-opacity))
  }

  .xl\\:divide-green-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--divide-opacity))
  }

  .xl\\:divide-green-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--divide-opacity))
  }

  .xl\\:divide-green-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--divide-opacity))
  }

  .xl\\:divide-green-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--divide-opacity))
  }

  .xl\\:divide-green-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--divide-opacity))
  }

  .xl\\:divide-green-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--divide-opacity))
  }

  .xl\\:divide-green-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--divide-opacity))
  }

  .xl\\:divide-teal-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--divide-opacity))
  }

  .xl\\:divide-teal-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--divide-opacity))
  }

  .xl\\:divide-teal-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--divide-opacity))
  }

  .xl\\:divide-teal-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--divide-opacity))
  }

  .xl\\:divide-teal-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--divide-opacity))
  }

  .xl\\:divide-teal-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--divide-opacity))
  }

  .xl\\:divide-teal-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--divide-opacity))
  }

  .xl\\:divide-teal-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--divide-opacity))
  }

  .xl\\:divide-teal-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--divide-opacity))
  }

  .xl\\:divide-teal-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--divide-opacity))
  }

  .xl\\:divide-blue-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--divide-opacity))
  }

  .xl\\:divide-blue-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--divide-opacity))
  }

  .xl\\:divide-blue-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--divide-opacity))
  }

  .xl\\:divide-blue-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--divide-opacity))
  }

  .xl\\:divide-blue-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--divide-opacity))
  }

  .xl\\:divide-blue-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--divide-opacity))
  }

  .xl\\:divide-blue-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--divide-opacity))
  }

  .xl\\:divide-blue-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--divide-opacity))
  }

  .xl\\:divide-blue-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--divide-opacity))
  }

  .xl\\:divide-blue-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--divide-opacity))
  }

  .xl\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--divide-opacity))
  }

  .xl\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--divide-opacity))
  }

  .xl\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--divide-opacity))
  }

  .xl\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--divide-opacity))
  }

  .xl\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--divide-opacity))
  }

  .xl\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--divide-opacity))
  }

  .xl\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--divide-opacity))
  }

  .xl\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--divide-opacity))
  }

  .xl\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--divide-opacity))
  }

  .xl\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--divide-opacity))
  }

  .xl\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--divide-opacity))
  }

  .xl\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--divide-opacity))
  }

  .xl\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--divide-opacity))
  }

  .xl\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--divide-opacity))
  }

  .xl\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--divide-opacity))
  }

  .xl\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--divide-opacity))
  }

  .xl\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--divide-opacity))
  }

  .xl\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--divide-opacity))
  }

  .xl\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--divide-opacity))
  }

  .xl\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--divide-opacity))
  }

  .xl\\:divide-pink-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--divide-opacity))
  }

  .xl\\:divide-pink-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--divide-opacity))
  }

  .xl\\:divide-pink-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--divide-opacity))
  }

  .xl\\:divide-pink-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--divide-opacity))
  }

  .xl\\:divide-pink-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--divide-opacity))
  }

  .xl\\:divide-pink-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--divide-opacity))
  }

  .xl\\:divide-pink-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--divide-opacity))
  }

  .xl\\:divide-pink-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--divide-opacity))
  }

  .xl\\:divide-pink-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--divide-opacity))
  }

  .xl\\:divide-pink-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-transparent>:not(template)~:not(template){
    border-color:#0000
  }

  .theme-dark .xl\\:dark\\:divide-white>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-black>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-cool-gray-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-cool-gray-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-cool-gray-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-cool-gray-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-cool-gray-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-cool-gray-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-cool-gray-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-cool-gray-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-cool-gray-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-cool-gray-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-red-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-red-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-red-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-red-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-red-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-red-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-red-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-red-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-red-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-red-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-orange-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-orange-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-orange-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-orange-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-orange-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-orange-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-orange-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-orange-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-orange-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-orange-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-yellow-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-yellow-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-yellow-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-yellow-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-yellow-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-yellow-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-yellow-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-yellow-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-yellow-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-yellow-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-green-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-green-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-green-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-green-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-green-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-green-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-green-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-green-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-green-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-green-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-teal-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-teal-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-teal-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-teal-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-teal-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-teal-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-teal-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-teal-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-teal-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-teal-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-blue-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-blue-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-blue-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-blue-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-blue-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-blue-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-blue-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-blue-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-blue-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-blue-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-indigo-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-pink-50>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-pink-100>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-pink-200>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-pink-300>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-pink-400>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-pink-500>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-pink-600>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-pink-700>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-pink-800>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--divide-opacity))
  }

  .theme-dark .xl\\:dark\\:divide-pink-900>:not(template)~:not(template){
    --divide-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--divide-opacity))
  }

  .xl\\:divide-opacity-0>:not(template)~:not(template){
    --divide-opacity:0
  }

  .xl\\:divide-opacity-25>:not(template)~:not(template){
    --divide-opacity:0.25
  }

  .xl\\:divide-opacity-50>:not(template)~:not(template){
    --divide-opacity:0.5
  }

  .xl\\:divide-opacity-75>:not(template)~:not(template){
    --divide-opacity:0.75
  }

  .xl\\:divide-opacity-100>:not(template)~:not(template){
    --divide-opacity:1
  }

  .xl\\:sr-only{
    height:1px;
    margin:-1px;
    overflow:hidden;
    padding:0;
    position:absolute;
    width:1px;
    clip:rect(0,0,0,0);
    border-width:0;
    white-space:nowrap
  }

  .xl\\:not-sr-only{
    height:auto;
    margin:0;
    overflow:visible;
    padding:0;
    position:static;
    width:auto;
    clip:auto;
    white-space:normal
  }

  .xl\\:focus\\:sr-only:focus{
    height:1px;
    margin:-1px;
    overflow:hidden;
    padding:0;
    position:absolute;
    width:1px;
    clip:rect(0,0,0,0);
    border-width:0;
    white-space:nowrap
  }

  .xl\\:focus\\:not-sr-only:focus{
    height:auto;
    margin:0;
    overflow:visible;
    padding:0;
    position:static;
    width:auto;
    clip:auto;
    white-space:normal
  }

  .xl\\:appearance-none{
    appearance:none
  }

  .xl\\:bg-fixed{
    background-attachment:fixed
  }

  .xl\\:bg-local{
    background-attachment:local
  }

  .xl\\:bg-scroll{
    background-attachment:scroll
  }

  .xl\\:bg-transparent{
    background-color:initial
  }

  .xl\\:bg-white{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .xl\\:bg-black{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .xl\\:bg-gray-50{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .xl\\:bg-gray-100{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .xl\\:bg-gray-200{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .xl\\:bg-gray-300{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .xl\\:bg-gray-400{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .xl\\:bg-gray-500{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .xl\\:bg-gray-600{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .xl\\:bg-gray-700{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .xl\\:bg-gray-800{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .xl\\:bg-gray-900{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .xl\\:bg-cool-gray-50{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .xl\\:bg-cool-gray-100{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .xl\\:bg-cool-gray-200{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .xl\\:bg-cool-gray-300{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .xl\\:bg-cool-gray-400{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .xl\\:bg-cool-gray-500{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .xl\\:bg-cool-gray-600{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .xl\\:bg-cool-gray-700{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .xl\\:bg-cool-gray-800{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .xl\\:bg-cool-gray-900{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .xl\\:bg-red-50{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .xl\\:bg-red-100{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .xl\\:bg-red-200{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .xl\\:bg-red-300{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .xl\\:bg-red-400{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .xl\\:bg-red-500{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .xl\\:bg-red-600{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .xl\\:bg-red-700{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .xl\\:bg-red-800{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .xl\\:bg-red-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .xl\\:bg-orange-50{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .xl\\:bg-orange-100{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .xl\\:bg-orange-200{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .xl\\:bg-orange-300{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .xl\\:bg-orange-400{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .xl\\:bg-orange-500{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .xl\\:bg-orange-600{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .xl\\:bg-orange-700{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .xl\\:bg-orange-800{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .xl\\:bg-orange-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .xl\\:bg-yellow-50{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .xl\\:bg-yellow-100{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .xl\\:bg-yellow-200{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .xl\\:bg-yellow-300{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .xl\\:bg-yellow-400{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .xl\\:bg-yellow-500{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .xl\\:bg-yellow-600{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .xl\\:bg-yellow-700{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .xl\\:bg-yellow-800{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .xl\\:bg-yellow-900{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .xl\\:bg-green-50{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .xl\\:bg-green-100{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .xl\\:bg-green-200{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .xl\\:bg-green-300{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .xl\\:bg-green-400{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .xl\\:bg-green-500{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .xl\\:bg-green-600{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .xl\\:bg-green-700{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .xl\\:bg-green-800{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .xl\\:bg-green-900{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .xl\\:bg-teal-50{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .xl\\:bg-teal-100{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .xl\\:bg-teal-200{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .xl\\:bg-teal-300{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .xl\\:bg-teal-400{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .xl\\:bg-teal-500{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .xl\\:bg-teal-600{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .xl\\:bg-teal-700{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .xl\\:bg-teal-800{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .xl\\:bg-teal-900{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .xl\\:bg-blue-50{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .xl\\:bg-blue-100{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .xl\\:bg-blue-200{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .xl\\:bg-blue-300{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .xl\\:bg-blue-400{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .xl\\:bg-blue-500{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .xl\\:bg-blue-600{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .xl\\:bg-blue-700{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .xl\\:bg-blue-800{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .xl\\:bg-blue-900{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .xl\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .xl\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .xl\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .xl\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .xl\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .xl\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .xl\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .xl\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .xl\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .xl\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .xl\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .xl\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .xl\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .xl\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .xl\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .xl\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .xl\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .xl\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .xl\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .xl\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .xl\\:bg-pink-50{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .xl\\:bg-pink-100{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .xl\\:bg-pink-200{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .xl\\:bg-pink-300{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .xl\\:bg-pink-400{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .xl\\:bg-pink-500{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .xl\\:bg-pink-600{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .xl\\:bg-pink-700{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .xl\\:bg-pink-800{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .xl\\:bg-pink-900{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-transparent:hover{
    background-color:initial
  }

  .xl\\:hover\\:bg-white:hover{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-black:hover{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-gray-50:hover{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-gray-100:hover{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-gray-200:hover{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-gray-300:hover{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-gray-400:hover{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-gray-500:hover{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-gray-600:hover{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-gray-700:hover{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-gray-800:hover{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-gray-900:hover{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-cool-gray-50:hover{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-cool-gray-100:hover{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-cool-gray-200:hover{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-cool-gray-300:hover{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-cool-gray-400:hover{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-cool-gray-500:hover{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-cool-gray-600:hover{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-cool-gray-700:hover{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-cool-gray-800:hover{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-cool-gray-900:hover{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-red-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-red-100:hover{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-red-200:hover{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-red-300:hover{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-red-400:hover{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-red-500:hover{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-red-600:hover{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-red-700:hover{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-red-800:hover{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-red-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-orange-50:hover{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-orange-100:hover{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-orange-200:hover{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-orange-300:hover{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-orange-400:hover{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-orange-500:hover{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-orange-600:hover{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-orange-700:hover{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-orange-800:hover{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-orange-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-yellow-50:hover{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-yellow-100:hover{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-yellow-200:hover{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-yellow-300:hover{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-yellow-400:hover{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-yellow-500:hover{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-yellow-600:hover{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-yellow-700:hover{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-yellow-800:hover{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-yellow-900:hover{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-green-50:hover{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-green-100:hover{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-green-200:hover{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-green-300:hover{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-green-400:hover{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-green-500:hover{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-green-600:hover{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-green-700:hover{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-green-800:hover{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-green-900:hover{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-teal-50:hover{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-teal-100:hover{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-teal-200:hover{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-teal-300:hover{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-teal-400:hover{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-teal-500:hover{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-teal-600:hover{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-teal-700:hover{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-teal-800:hover{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-teal-900:hover{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-blue-50:hover{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-blue-100:hover{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-blue-200:hover{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-blue-300:hover{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-blue-400:hover{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-blue-500:hover{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-blue-600:hover{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-blue-700:hover{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-blue-800:hover{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-blue-900:hover{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-pink-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-pink-100:hover{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-pink-200:hover{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-pink-300:hover{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-pink-400:hover{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-pink-500:hover{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-pink-600:hover{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-pink-700:hover{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-pink-800:hover{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .xl\\:hover\\:bg-pink-900:hover{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-transparent:focus{
    background-color:initial
  }

  .xl\\:focus\\:bg-white:focus{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-black:focus{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-gray-50:focus{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-gray-100:focus{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-gray-200:focus{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-gray-300:focus{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-gray-400:focus{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-gray-500:focus{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-gray-600:focus{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-gray-700:focus{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-gray-800:focus{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-gray-900:focus{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-cool-gray-50:focus{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-cool-gray-100:focus{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-cool-gray-200:focus{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-cool-gray-300:focus{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-cool-gray-400:focus{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-cool-gray-500:focus{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-cool-gray-600:focus{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-cool-gray-700:focus{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-cool-gray-800:focus{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-cool-gray-900:focus{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-red-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-red-100:focus{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-red-200:focus{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-red-300:focus{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-red-400:focus{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-red-500:focus{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-red-600:focus{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-red-700:focus{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-red-800:focus{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-red-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-orange-50:focus{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-orange-100:focus{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-orange-200:focus{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-orange-300:focus{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-orange-400:focus{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-orange-500:focus{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-orange-600:focus{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-orange-700:focus{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-orange-800:focus{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-orange-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-yellow-50:focus{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-yellow-100:focus{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-yellow-200:focus{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-yellow-300:focus{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-yellow-400:focus{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-yellow-500:focus{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-yellow-600:focus{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-yellow-700:focus{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-yellow-800:focus{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-yellow-900:focus{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-green-50:focus{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-green-100:focus{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-green-200:focus{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-green-300:focus{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-green-400:focus{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-green-500:focus{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-green-600:focus{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-green-700:focus{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-green-800:focus{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-green-900:focus{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-teal-50:focus{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-teal-100:focus{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-teal-200:focus{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-teal-300:focus{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-teal-400:focus{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-teal-500:focus{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-teal-600:focus{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-teal-700:focus{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-teal-800:focus{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-teal-900:focus{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-blue-50:focus{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-blue-100:focus{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-blue-200:focus{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-blue-300:focus{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-blue-400:focus{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-blue-500:focus{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-blue-600:focus{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-blue-700:focus{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-blue-800:focus{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-blue-900:focus{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-pink-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-pink-100:focus{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-pink-200:focus{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-pink-300:focus{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-pink-400:focus{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-pink-500:focus{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-pink-600:focus{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-pink-700:focus{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-pink-800:focus{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .xl\\:focus\\:bg-pink-900:focus{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .xl\\:active\\:bg-transparent:active{
    background-color:initial
  }

  .xl\\:active\\:bg-white:active{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .xl\\:active\\:bg-black:active{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .xl\\:active\\:bg-gray-50:active{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .xl\\:active\\:bg-gray-100:active{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .xl\\:active\\:bg-gray-200:active{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .xl\\:active\\:bg-gray-300:active{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .xl\\:active\\:bg-gray-400:active{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .xl\\:active\\:bg-gray-500:active{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .xl\\:active\\:bg-gray-600:active{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .xl\\:active\\:bg-gray-700:active{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .xl\\:active\\:bg-gray-800:active{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .xl\\:active\\:bg-gray-900:active{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .xl\\:active\\:bg-cool-gray-50:active{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .xl\\:active\\:bg-cool-gray-100:active{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .xl\\:active\\:bg-cool-gray-200:active{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .xl\\:active\\:bg-cool-gray-300:active{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .xl\\:active\\:bg-cool-gray-400:active{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .xl\\:active\\:bg-cool-gray-500:active{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .xl\\:active\\:bg-cool-gray-600:active{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .xl\\:active\\:bg-cool-gray-700:active{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .xl\\:active\\:bg-cool-gray-800:active{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .xl\\:active\\:bg-cool-gray-900:active{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .xl\\:active\\:bg-red-50:active{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .xl\\:active\\:bg-red-100:active{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .xl\\:active\\:bg-red-200:active{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .xl\\:active\\:bg-red-300:active{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .xl\\:active\\:bg-red-400:active{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .xl\\:active\\:bg-red-500:active{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .xl\\:active\\:bg-red-600:active{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .xl\\:active\\:bg-red-700:active{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .xl\\:active\\:bg-red-800:active{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .xl\\:active\\:bg-red-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .xl\\:active\\:bg-orange-50:active{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .xl\\:active\\:bg-orange-100:active{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .xl\\:active\\:bg-orange-200:active{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .xl\\:active\\:bg-orange-300:active{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .xl\\:active\\:bg-orange-400:active{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .xl\\:active\\:bg-orange-500:active{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .xl\\:active\\:bg-orange-600:active{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .xl\\:active\\:bg-orange-700:active{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .xl\\:active\\:bg-orange-800:active{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .xl\\:active\\:bg-orange-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .xl\\:active\\:bg-yellow-50:active{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .xl\\:active\\:bg-yellow-100:active{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .xl\\:active\\:bg-yellow-200:active{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .xl\\:active\\:bg-yellow-300:active{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .xl\\:active\\:bg-yellow-400:active{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .xl\\:active\\:bg-yellow-500:active{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .xl\\:active\\:bg-yellow-600:active{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .xl\\:active\\:bg-yellow-700:active{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .xl\\:active\\:bg-yellow-800:active{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .xl\\:active\\:bg-yellow-900:active{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .xl\\:active\\:bg-green-50:active{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .xl\\:active\\:bg-green-100:active{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .xl\\:active\\:bg-green-200:active{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .xl\\:active\\:bg-green-300:active{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .xl\\:active\\:bg-green-400:active{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .xl\\:active\\:bg-green-500:active{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .xl\\:active\\:bg-green-600:active{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .xl\\:active\\:bg-green-700:active{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .xl\\:active\\:bg-green-800:active{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .xl\\:active\\:bg-green-900:active{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .xl\\:active\\:bg-teal-50:active{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .xl\\:active\\:bg-teal-100:active{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .xl\\:active\\:bg-teal-200:active{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .xl\\:active\\:bg-teal-300:active{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .xl\\:active\\:bg-teal-400:active{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .xl\\:active\\:bg-teal-500:active{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .xl\\:active\\:bg-teal-600:active{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .xl\\:active\\:bg-teal-700:active{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .xl\\:active\\:bg-teal-800:active{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .xl\\:active\\:bg-teal-900:active{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .xl\\:active\\:bg-blue-50:active{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .xl\\:active\\:bg-blue-100:active{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .xl\\:active\\:bg-blue-200:active{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .xl\\:active\\:bg-blue-300:active{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .xl\\:active\\:bg-blue-400:active{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .xl\\:active\\:bg-blue-500:active{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .xl\\:active\\:bg-blue-600:active{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .xl\\:active\\:bg-blue-700:active{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .xl\\:active\\:bg-blue-800:active{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .xl\\:active\\:bg-blue-900:active{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .xl\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .xl\\:active\\:bg-pink-50:active{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .xl\\:active\\:bg-pink-100:active{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .xl\\:active\\:bg-pink-200:active{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .xl\\:active\\:bg-pink-300:active{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .xl\\:active\\:bg-pink-400:active{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .xl\\:active\\:bg-pink-500:active{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .xl\\:active\\:bg-pink-600:active{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .xl\\:active\\:bg-pink-700:active{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .xl\\:active\\:bg-pink-800:active{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .xl\\:active\\:bg-pink-900:active{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-transparent:nth-child(odd){
    background-color:initial
  }

  .xl\\:odd\\:bg-white:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-black:nth-child(odd){
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-cool-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-cool-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-cool-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-cool-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-cool-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-cool-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-cool-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-cool-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-cool-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-cool-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-red-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-red-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-red-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-red-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-red-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-red-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-red-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-red-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-red-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-red-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-orange-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-orange-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-orange-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-orange-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-orange-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-orange-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-orange-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-orange-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-orange-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-orange-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-yellow-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-yellow-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-yellow-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-yellow-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-yellow-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-yellow-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-yellow-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-yellow-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-yellow-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-yellow-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-green-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-green-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-green-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-green-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-green-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-green-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-green-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-green-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-green-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-green-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-teal-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-teal-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-teal-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-teal-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-teal-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-teal-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-teal-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-teal-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-teal-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-teal-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-blue-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-blue-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-blue-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-blue-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-blue-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-blue-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-blue-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-blue-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-blue-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-blue-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-pink-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-pink-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-pink-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-pink-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-pink-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-pink-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-pink-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-pink-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-pink-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .xl\\:odd\\:bg-pink-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-transparent{
    background-color:initial
  }

  .theme-dark .xl\\:dark\\:bg-white{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-black{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-gray-50{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-gray-100{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-gray-200{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-gray-300{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-gray-400{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-gray-500{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-gray-600{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-gray-700{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-gray-800{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-gray-900{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-cool-gray-50{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-cool-gray-100{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-cool-gray-200{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-cool-gray-300{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-cool-gray-400{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-cool-gray-500{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-cool-gray-600{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-cool-gray-700{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-cool-gray-800{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-cool-gray-900{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-red-50{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-red-100{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-red-200{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-red-300{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-red-400{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-red-500{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-red-600{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-red-700{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-red-800{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-red-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-orange-50{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-orange-100{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-orange-200{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-orange-300{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-orange-400{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-orange-500{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-orange-600{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-orange-700{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-orange-800{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-orange-900{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-yellow-50{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-yellow-100{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-yellow-200{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-yellow-300{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-yellow-400{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-yellow-500{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-yellow-600{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-yellow-700{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-yellow-800{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-yellow-900{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-green-50{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-green-100{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-green-200{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-green-300{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-green-400{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-green-500{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-green-600{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-green-700{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-green-800{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-green-900{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-teal-50{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-teal-100{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-teal-200{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-teal-300{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-teal-400{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-teal-500{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-teal-600{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-teal-700{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-teal-800{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-teal-900{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-blue-50{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-blue-100{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-blue-200{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-blue-300{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-blue-400{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-blue-500{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-blue-600{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-blue-700{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-blue-800{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-blue-900{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-50{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-100{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-200{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-300{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-400{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-500{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-600{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-700{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-800{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-indigo-900{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-pink-50{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-pink-100{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-pink-200{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-pink-300{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-pink-400{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-pink-500{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-pink-600{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-pink-700{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-pink-800{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:bg-pink-900{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-transparent:hover{
    background-color:initial
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-white:hover{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-black:hover{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-gray-50:hover{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-gray-100:hover{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-gray-200:hover{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-gray-300:hover{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-gray-400:hover{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-gray-500:hover{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-gray-600:hover{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-gray-700:hover{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-gray-800:hover{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-gray-900:hover{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-50:hover{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-100:hover{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-200:hover{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-300:hover{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-400:hover{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-500:hover{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-600:hover{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-700:hover{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-800:hover{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-900:hover{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-red-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-red-100:hover{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-red-200:hover{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-red-300:hover{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-red-400:hover{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-red-500:hover{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-red-600:hover{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-red-700:hover{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-red-800:hover{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-red-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-orange-50:hover{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-orange-100:hover{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-orange-200:hover{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-orange-300:hover{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-orange-400:hover{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-orange-500:hover{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-orange-600:hover{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-orange-700:hover{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-orange-800:hover{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-orange-900:hover{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-yellow-50:hover{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-yellow-100:hover{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-yellow-200:hover{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-yellow-300:hover{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-yellow-400:hover{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-yellow-500:hover{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-yellow-600:hover{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-yellow-700:hover{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-yellow-800:hover{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-yellow-900:hover{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-green-50:hover{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-green-100:hover{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-green-200:hover{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-green-300:hover{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-green-400:hover{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-green-500:hover{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-green-600:hover{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-green-700:hover{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-green-800:hover{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-green-900:hover{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-teal-50:hover{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-teal-100:hover{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-teal-200:hover{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-teal-300:hover{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-teal-400:hover{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-teal-500:hover{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-teal-600:hover{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-teal-700:hover{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-teal-800:hover{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-teal-900:hover{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-blue-50:hover{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-blue-100:hover{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-blue-200:hover{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-blue-300:hover{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-blue-400:hover{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-blue-500:hover{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-blue-600:hover{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-blue-700:hover{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-blue-800:hover{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-blue-900:hover{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-50:hover{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-100:hover{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-200:hover{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-300:hover{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-400:hover{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-500:hover{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-600:hover{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-700:hover{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-800:hover{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-indigo-900:hover{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-pink-50:hover{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-pink-100:hover{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-pink-200:hover{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-pink-300:hover{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-pink-400:hover{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-pink-500:hover{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-pink-600:hover{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-pink-700:hover{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-pink-800:hover{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-pink-900:hover{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-transparent:focus{
    background-color:initial
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-white:focus{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-black:focus{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-gray-50:focus{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-gray-100:focus{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-gray-200:focus{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-gray-300:focus{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-gray-400:focus{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-gray-500:focus{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-gray-600:focus{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-gray-700:focus{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-gray-800:focus{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-gray-900:focus{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-50:focus{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-100:focus{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-200:focus{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-300:focus{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-400:focus{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-500:focus{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-600:focus{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-700:focus{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-800:focus{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-900:focus{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-red-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-red-100:focus{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-red-200:focus{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-red-300:focus{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-red-400:focus{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-red-500:focus{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-red-600:focus{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-red-700:focus{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-red-800:focus{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-red-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-orange-50:focus{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-orange-100:focus{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-orange-200:focus{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-orange-300:focus{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-orange-400:focus{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-orange-500:focus{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-orange-600:focus{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-orange-700:focus{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-orange-800:focus{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-orange-900:focus{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-yellow-50:focus{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-yellow-100:focus{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-yellow-200:focus{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-yellow-300:focus{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-yellow-400:focus{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-yellow-500:focus{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-yellow-600:focus{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-yellow-700:focus{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-yellow-800:focus{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-yellow-900:focus{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-green-50:focus{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-green-100:focus{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-green-200:focus{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-green-300:focus{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-green-400:focus{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-green-500:focus{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-green-600:focus{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-green-700:focus{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-green-800:focus{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-green-900:focus{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-teal-50:focus{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-teal-100:focus{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-teal-200:focus{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-teal-300:focus{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-teal-400:focus{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-teal-500:focus{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-teal-600:focus{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-teal-700:focus{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-teal-800:focus{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-teal-900:focus{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-blue-50:focus{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-blue-100:focus{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-blue-200:focus{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-blue-300:focus{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-blue-400:focus{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-blue-500:focus{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-blue-600:focus{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-blue-700:focus{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-blue-800:focus{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-blue-900:focus{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-50:focus{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-100:focus{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-200:focus{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-300:focus{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-400:focus{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-500:focus{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-600:focus{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-700:focus{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-800:focus{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-indigo-900:focus{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-pink-50:focus{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-pink-100:focus{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-pink-200:focus{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-pink-300:focus{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-pink-400:focus{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-pink-500:focus{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-pink-600:focus{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-pink-700:focus{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-pink-800:focus{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:bg-pink-900:focus{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-transparent:active{
    background-color:initial
  }

  .theme-dark .xl\\:dark\\:active\\:bg-white:active{
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-black:active{
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-gray-50:active{
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-gray-100:active{
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-gray-200:active{
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-gray-300:active{
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-gray-400:active{
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-gray-500:active{
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-gray-600:active{
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-gray-700:active{
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-gray-800:active{
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-gray-900:active{
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-cool-gray-50:active{
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-cool-gray-100:active{
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-cool-gray-200:active{
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-cool-gray-300:active{
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-cool-gray-400:active{
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-cool-gray-500:active{
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-cool-gray-600:active{
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-cool-gray-700:active{
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-cool-gray-800:active{
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-cool-gray-900:active{
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-red-50:active{
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-red-100:active{
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-red-200:active{
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-red-300:active{
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-red-400:active{
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-red-500:active{
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-red-600:active{
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-red-700:active{
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-red-800:active{
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-red-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-orange-50:active{
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-orange-100:active{
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-orange-200:active{
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-orange-300:active{
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-orange-400:active{
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-orange-500:active{
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-orange-600:active{
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-orange-700:active{
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-orange-800:active{
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-orange-900:active{
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-yellow-50:active{
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-yellow-100:active{
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-yellow-200:active{
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-yellow-300:active{
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-yellow-400:active{
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-yellow-500:active{
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-yellow-600:active{
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-yellow-700:active{
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-yellow-800:active{
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-yellow-900:active{
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-green-50:active{
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-green-100:active{
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-green-200:active{
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-green-300:active{
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-green-400:active{
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-green-500:active{
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-green-600:active{
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-green-700:active{
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-green-800:active{
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-green-900:active{
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-teal-50:active{
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-teal-100:active{
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-teal-200:active{
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-teal-300:active{
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-teal-400:active{
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-teal-500:active{
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-teal-600:active{
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-teal-700:active{
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-teal-800:active{
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-teal-900:active{
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-blue-50:active{
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-blue-100:active{
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-blue-200:active{
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-blue-300:active{
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-blue-400:active{
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-blue-500:active{
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-blue-600:active{
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-blue-700:active{
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-blue-800:active{
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-blue-900:active{
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-50:active{
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-100:active{
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-200:active{
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-300:active{
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-400:active{
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-500:active{
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-600:active{
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-700:active{
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-800:active{
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-indigo-900:active{
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-pink-50:active{
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-pink-100:active{
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-pink-200:active{
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-pink-300:active{
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-pink-400:active{
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-pink-500:active{
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-pink-600:active{
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-pink-700:active{
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-pink-800:active{
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:bg-pink-900:active{
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-transparent:nth-child(odd){
    background-color:initial
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-white:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff;
    background-color:rgba(255,255,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-black:nth-child(odd){
    --bg-opacity:1;
    background-color:#000;
    background-color:rgba(0,0,0,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f9fafb;
    background-color:rgba(249,250,251,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f4f5f7;
    background-color:rgba(244,245,247,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5e7eb;
    background-color:rgba(229,231,235,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5d6d7;
    background-color:rgba(213,214,215,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#9e9e9e;
    background-color:rgba(158,158,158,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#707275;
    background-color:rgba(112,114,117,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#4c4f52;
    background-color:rgba(76,79,82,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#24262d;
    background-color:rgba(36,38,45,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a1c23;
    background-color:rgba(26,28,35,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#121317;
    background-color:rgba(18,19,23,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbfdfe;
    background-color:rgba(251,253,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#f1f5f9;
    background-color:rgba(241,245,249,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#e2e8f0;
    background-color:rgba(226,232,240,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cfd8e3;
    background-color:rgba(207,216,227,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#97a6ba;
    background-color:rgba(151,166,186,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#64748b;
    background-color:rgba(100,116,139,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#475569;
    background-color:rgba(71,85,105,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#364152;
    background-color:rgba(54,65,82,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#27303f;
    background-color:rgba(39,48,63,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a202e;
    background-color:rgba(26,32,46,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-red-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f2;
    background-color:rgba(253,242,242,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-red-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fde8e8;
    background-color:rgba(253,232,232,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-red-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fbd5d5;
    background-color:rgba(251,213,213,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-red-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4b4;
    background-color:rgba(248,180,180,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-red-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f98080;
    background-color:rgba(249,128,128,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-red-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#f05252;
    background-color:rgba(240,82,82,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-red-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#e02424;
    background-color:rgba(224,36,36,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-red-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#c81e1e;
    background-color:rgba(200,30,30,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-red-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#9b1c1c;
    background-color:rgba(155,28,28,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-red-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-orange-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fff8f1;
    background-color:rgba(255,248,241,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-orange-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#feecdc;
    background-color:rgba(254,236,220,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-orange-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fcd9bd;
    background-color:rgba(252,217,189,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-orange-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdba8c;
    background-color:rgba(253,186,140,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-orange-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff8a4c;
    background-color:rgba(255,138,76,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-orange-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#ff5a1f;
    background-color:rgba(255,90,31,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-orange-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d03801;
    background-color:rgba(208,56,1,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-orange-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#b43403;
    background-color:rgba(180,52,3,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-orange-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#8a2c0d;
    background-color:rgba(138,44,13,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-orange-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#771d1d;
    background-color:rgba(119,29,29,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-yellow-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdfdea;
    background-color:rgba(253,253,234,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-yellow-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf6b2;
    background-color:rgba(253,246,178,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-yellow-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce96a;
    background-color:rgba(252,233,106,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-yellow-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#faca15;
    background-color:rgba(250,202,21,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-yellow-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#e3a008;
    background-color:rgba(227,160,8,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-yellow-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#c27803;
    background-color:rgba(194,120,3,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-yellow-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#9f580a;
    background-color:rgba(159,88,10,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-yellow-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#8e4b10;
    background-color:rgba(142,75,16,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-yellow-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#723b13;
    background-color:rgba(114,59,19,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-yellow-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#633112;
    background-color:rgba(99,49,18,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-green-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f3faf7;
    background-color:rgba(243,250,247,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-green-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#def7ec;
    background-color:rgba(222,247,236,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-green-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#bcf0da;
    background-color:rgba(188,240,218,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-green-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#84e1bc;
    background-color:rgba(132,225,188,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-green-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#31c48d;
    background-color:rgba(49,196,141,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-green-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0e9f6e;
    background-color:rgba(14,159,110,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-green-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#057a55;
    background-color:rgba(5,122,85,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-green-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#046c4e;
    background-color:rgba(4,108,78,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-green-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#03543f;
    background-color:rgba(3,84,63,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-green-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014737;
    background-color:rgba(1,71,55,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-teal-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#edfafa;
    background-color:rgba(237,250,250,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-teal-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#d5f5f6;
    background-color:rgba(213,245,246,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-teal-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#afecef;
    background-color:rgba(175,236,239,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-teal-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#7edce2;
    background-color:rgba(126,220,226,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-teal-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#16bdca;
    background-color:rgba(22,189,202,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-teal-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#0694a2;
    background-color:rgba(6,148,162,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-teal-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#047481;
    background-color:rgba(4,116,129,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-teal-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#036672;
    background-color:rgba(3,102,114,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-teal-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#05505c;
    background-color:rgba(5,80,92,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-teal-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#014451;
    background-color:rgba(1,68,81,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-blue-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#ebf5ff;
    background-color:rgba(235,245,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-blue-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e1effe;
    background-color:rgba(225,239,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-blue-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#c3ddfd;
    background-color:rgba(195,221,253,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-blue-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#a4cafe;
    background-color:rgba(164,202,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-blue-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#76a9fa;
    background-color:rgba(118,169,250,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-blue-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#3f83f8;
    background-color:rgba(63,131,248,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-blue-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#1c64f2;
    background-color:rgba(28,100,242,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-blue-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#1a56db;
    background-color:rgba(26,86,219,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-blue-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#1e429f;
    background-color:rgba(30,66,159,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-blue-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#233876;
    background-color:rgba(35,56,118,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f0f5ff;
    background-color:rgba(240,245,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#e5edff;
    background-color:rgba(229,237,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#cddbfe;
    background-color:rgba(205,219,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#b4c6fc;
    background-color:rgba(180,198,252,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#8da2fb;
    background-color:rgba(141,162,251,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#6875f5;
    background-color:rgba(104,117,245,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#5850ec;
    background-color:rgba(88,80,236,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#5145cd;
    background-color:rgba(81,69,205,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#42389d;
    background-color:rgba(66,56,157,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#362f78;
    background-color:rgba(54,47,120,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#f6f5ff;
    background-color:rgba(246,245,255,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#edebfe;
    background-color:rgba(237,235,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#dcd7fe;
    background-color:rgba(220,215,254,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#cabffd;
    background-color:rgba(202,191,253,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#ac94fa;
    background-color:rgba(172,148,250,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#9061f9;
    background-color:rgba(144,97,249,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#7e3af2;
    background-color:rgba(126,58,242,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#6c2bd9;
    background-color:rgba(108,43,217,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#5521b5;
    background-color:rgba(85,33,181,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#4a1d96;
    background-color:rgba(74,29,150,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-pink-50:nth-child(odd){
    --bg-opacity:1;
    background-color:#fdf2f8;
    background-color:rgba(253,242,248,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-pink-100:nth-child(odd){
    --bg-opacity:1;
    background-color:#fce8f3;
    background-color:rgba(252,232,243,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-pink-200:nth-child(odd){
    --bg-opacity:1;
    background-color:#fad1e8;
    background-color:rgba(250,209,232,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-pink-300:nth-child(odd){
    --bg-opacity:1;
    background-color:#f8b4d9;
    background-color:rgba(248,180,217,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-pink-400:nth-child(odd){
    --bg-opacity:1;
    background-color:#f17eb8;
    background-color:rgba(241,126,184,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-pink-500:nth-child(odd){
    --bg-opacity:1;
    background-color:#e74694;
    background-color:rgba(231,70,148,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-pink-600:nth-child(odd){
    --bg-opacity:1;
    background-color:#d61f69;
    background-color:rgba(214,31,105,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-pink-700:nth-child(odd){
    --bg-opacity:1;
    background-color:#bf125d;
    background-color:rgba(191,18,93,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-pink-800:nth-child(odd){
    --bg-opacity:1;
    background-color:#99154b;
    background-color:rgba(153,21,75,var(--bg-opacity))
  }

  .theme-dark .xl\\:dark\\:odd\\:bg-pink-900:nth-child(odd){
    --bg-opacity:1;
    background-color:#751a3d;
    background-color:rgba(117,26,61,var(--bg-opacity))
  }

  .xl\\:bg-opacity-0{
    --bg-opacity:0
  }

  .xl\\:bg-opacity-10{
    --bg-opacity:0.1
  }

  .xl\\:bg-opacity-25{
    --bg-opacity:0.25
  }

  .xl\\:bg-opacity-50{
    --bg-opacity:0.5
  }

  .xl\\:bg-opacity-75{
    --bg-opacity:0.75
  }

  .xl\\:bg-opacity-100{
    --bg-opacity:1
  }

  .xl\\:hover\\:bg-opacity-0:hover{
    --bg-opacity:0
  }

  .xl\\:hover\\:bg-opacity-10:hover{
    --bg-opacity:0.1
  }

  .xl\\:hover\\:bg-opacity-25:hover{
    --bg-opacity:0.25
  }

  .xl\\:hover\\:bg-opacity-50:hover{
    --bg-opacity:0.5
  }

  .xl\\:hover\\:bg-opacity-75:hover{
    --bg-opacity:0.75
  }

  .xl\\:hover\\:bg-opacity-100:hover{
    --bg-opacity:1
  }

  .xl\\:focus\\:bg-opacity-0:focus{
    --bg-opacity:0
  }

  .xl\\:focus\\:bg-opacity-10:focus{
    --bg-opacity:0.1
  }

  .xl\\:focus\\:bg-opacity-25:focus{
    --bg-opacity:0.25
  }

  .xl\\:focus\\:bg-opacity-50:focus{
    --bg-opacity:0.5
  }

  .xl\\:focus\\:bg-opacity-75:focus{
    --bg-opacity:0.75
  }

  .xl\\:focus\\:bg-opacity-100:focus{
    --bg-opacity:1
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-opacity-0:hover{
    --bg-opacity:0
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-opacity-10:hover{
    --bg-opacity:0.1
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-opacity-25:hover{
    --bg-opacity:0.25
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-opacity-50:hover{
    --bg-opacity:0.5
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-opacity-75:hover{
    --bg-opacity:0.75
  }

  .theme-dark .xl\\:dark\\:hover\\:bg-opacity-100:hover{
    --bg-opacity:1
  }

  .xl\\:bg-bottom{
    background-position:bottom
  }

  .xl\\:bg-center{
    background-position:50%
  }

  .xl\\:bg-left{
    background-position:0
  }

  .xl\\:bg-left-bottom{
    background-position:0 100%
  }

  .xl\\:bg-left-top{
    background-position:0 0
  }

  .xl\\:bg-right{
    background-position:100%
  }

  .xl\\:bg-right-bottom{
    background-position:100% 100%
  }

  .xl\\:bg-right-top{
    background-position:100% 0
  }

  .xl\\:bg-top{
    background-position:top
  }

  .xl\\:bg-repeat{
    background-repeat:repeat
  }

  .xl\\:bg-no-repeat{
    background-repeat:no-repeat
  }

  .xl\\:bg-repeat-x{
    background-repeat:repeat-x
  }

  .xl\\:bg-repeat-y{
    background-repeat:repeat-y
  }

  .xl\\:bg-repeat-round{
    background-repeat:round
  }

  .xl\\:bg-repeat-space{
    background-repeat:space
  }

  .xl\\:bg-auto{
    background-size:auto
  }

  .xl\\:bg-cover{
    background-size:cover
  }

  .xl\\:bg-contain{
    background-size:contain
  }

  .xl\\:border-collapse{
    border-collapse:collapse
  }

  .xl\\:border-separate{
    border-collapse:initial
  }

  .xl\\:border-transparent{
    border-color:#0000
  }

  .xl\\:border-white{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .xl\\:border-black{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .xl\\:border-gray-50{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .xl\\:border-gray-100{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .xl\\:border-gray-200{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .xl\\:border-gray-300{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .xl\\:border-gray-400{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .xl\\:border-gray-500{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .xl\\:border-gray-600{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .xl\\:border-gray-700{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .xl\\:border-gray-800{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .xl\\:border-gray-900{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .xl\\:border-cool-gray-50{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .xl\\:border-cool-gray-100{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .xl\\:border-cool-gray-200{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .xl\\:border-cool-gray-300{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .xl\\:border-cool-gray-400{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .xl\\:border-cool-gray-500{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .xl\\:border-cool-gray-600{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .xl\\:border-cool-gray-700{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .xl\\:border-cool-gray-800{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .xl\\:border-cool-gray-900{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .xl\\:border-red-50{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .xl\\:border-red-100{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .xl\\:border-red-200{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .xl\\:border-red-300{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .xl\\:border-red-400{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .xl\\:border-red-500{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .xl\\:border-red-600{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .xl\\:border-red-700{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .xl\\:border-red-800{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .xl\\:border-red-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .xl\\:border-orange-50{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .xl\\:border-orange-100{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .xl\\:border-orange-200{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .xl\\:border-orange-300{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .xl\\:border-orange-400{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .xl\\:border-orange-500{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .xl\\:border-orange-600{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .xl\\:border-orange-700{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .xl\\:border-orange-800{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .xl\\:border-orange-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .xl\\:border-yellow-50{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .xl\\:border-yellow-100{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .xl\\:border-yellow-200{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .xl\\:border-yellow-300{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .xl\\:border-yellow-400{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .xl\\:border-yellow-500{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .xl\\:border-yellow-600{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .xl\\:border-yellow-700{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .xl\\:border-yellow-800{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .xl\\:border-yellow-900{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .xl\\:border-green-50{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .xl\\:border-green-100{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .xl\\:border-green-200{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .xl\\:border-green-300{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .xl\\:border-green-400{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .xl\\:border-green-500{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .xl\\:border-green-600{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .xl\\:border-green-700{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .xl\\:border-green-800{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .xl\\:border-green-900{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .xl\\:border-teal-50{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .xl\\:border-teal-100{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .xl\\:border-teal-200{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .xl\\:border-teal-300{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .xl\\:border-teal-400{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .xl\\:border-teal-500{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .xl\\:border-teal-600{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .xl\\:border-teal-700{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .xl\\:border-teal-800{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .xl\\:border-teal-900{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .xl\\:border-blue-50{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .xl\\:border-blue-100{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .xl\\:border-blue-200{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .xl\\:border-blue-300{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .xl\\:border-blue-400{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .xl\\:border-blue-500{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .xl\\:border-blue-600{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .xl\\:border-blue-700{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .xl\\:border-blue-800{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .xl\\:border-blue-900{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .xl\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .xl\\:border-indigo-100{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .xl\\:border-indigo-200{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .xl\\:border-indigo-300{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .xl\\:border-indigo-400{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .xl\\:border-indigo-500{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .xl\\:border-indigo-600{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .xl\\:border-indigo-700{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .xl\\:border-indigo-800{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .xl\\:border-indigo-900{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .xl\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .xl\\:border-indigo-100{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .xl\\:border-indigo-200{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .xl\\:border-indigo-300{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .xl\\:border-indigo-400{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .xl\\:border-indigo-500{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .xl\\:border-indigo-600{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .xl\\:border-indigo-700{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .xl\\:border-indigo-800{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .xl\\:border-indigo-900{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .xl\\:border-pink-50{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .xl\\:border-pink-100{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .xl\\:border-pink-200{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .xl\\:border-pink-300{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .xl\\:border-pink-400{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .xl\\:border-pink-500{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .xl\\:border-pink-600{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .xl\\:border-pink-700{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .xl\\:border-pink-800{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .xl\\:border-pink-900{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .xl\\:hover\\:border-transparent:hover{
    border-color:#0000
  }

  .xl\\:hover\\:border-white:hover{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .xl\\:hover\\:border-black:hover{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .xl\\:hover\\:border-gray-50:hover{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .xl\\:hover\\:border-gray-100:hover{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .xl\\:hover\\:border-gray-200:hover{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .xl\\:hover\\:border-gray-300:hover{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .xl\\:hover\\:border-gray-400:hover{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .xl\\:hover\\:border-gray-500:hover{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .xl\\:hover\\:border-gray-600:hover{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .xl\\:hover\\:border-gray-700:hover{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .xl\\:hover\\:border-gray-800:hover{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .xl\\:hover\\:border-gray-900:hover{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .xl\\:hover\\:border-cool-gray-50:hover{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .xl\\:hover\\:border-cool-gray-100:hover{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .xl\\:hover\\:border-cool-gray-200:hover{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .xl\\:hover\\:border-cool-gray-300:hover{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .xl\\:hover\\:border-cool-gray-400:hover{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .xl\\:hover\\:border-cool-gray-500:hover{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .xl\\:hover\\:border-cool-gray-600:hover{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .xl\\:hover\\:border-cool-gray-700:hover{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .xl\\:hover\\:border-cool-gray-800:hover{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .xl\\:hover\\:border-cool-gray-900:hover{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .xl\\:hover\\:border-red-50:hover{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .xl\\:hover\\:border-red-100:hover{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .xl\\:hover\\:border-red-200:hover{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .xl\\:hover\\:border-red-300:hover{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .xl\\:hover\\:border-red-400:hover{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .xl\\:hover\\:border-red-500:hover{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .xl\\:hover\\:border-red-600:hover{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .xl\\:hover\\:border-red-700:hover{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .xl\\:hover\\:border-red-800:hover{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .xl\\:hover\\:border-red-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .xl\\:hover\\:border-orange-50:hover{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .xl\\:hover\\:border-orange-100:hover{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .xl\\:hover\\:border-orange-200:hover{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .xl\\:hover\\:border-orange-300:hover{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .xl\\:hover\\:border-orange-400:hover{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .xl\\:hover\\:border-orange-500:hover{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .xl\\:hover\\:border-orange-600:hover{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .xl\\:hover\\:border-orange-700:hover{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .xl\\:hover\\:border-orange-800:hover{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .xl\\:hover\\:border-orange-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .xl\\:hover\\:border-yellow-50:hover{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .xl\\:hover\\:border-yellow-100:hover{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .xl\\:hover\\:border-yellow-200:hover{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .xl\\:hover\\:border-yellow-300:hover{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .xl\\:hover\\:border-yellow-400:hover{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .xl\\:hover\\:border-yellow-500:hover{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .xl\\:hover\\:border-yellow-600:hover{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .xl\\:hover\\:border-yellow-700:hover{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .xl\\:hover\\:border-yellow-800:hover{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .xl\\:hover\\:border-yellow-900:hover{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .xl\\:hover\\:border-green-50:hover{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .xl\\:hover\\:border-green-100:hover{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .xl\\:hover\\:border-green-200:hover{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .xl\\:hover\\:border-green-300:hover{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .xl\\:hover\\:border-green-400:hover{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .xl\\:hover\\:border-green-500:hover{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .xl\\:hover\\:border-green-600:hover{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .xl\\:hover\\:border-green-700:hover{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .xl\\:hover\\:border-green-800:hover{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .xl\\:hover\\:border-green-900:hover{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .xl\\:hover\\:border-teal-50:hover{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .xl\\:hover\\:border-teal-100:hover{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .xl\\:hover\\:border-teal-200:hover{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .xl\\:hover\\:border-teal-300:hover{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .xl\\:hover\\:border-teal-400:hover{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .xl\\:hover\\:border-teal-500:hover{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .xl\\:hover\\:border-teal-600:hover{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .xl\\:hover\\:border-teal-700:hover{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .xl\\:hover\\:border-teal-800:hover{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .xl\\:hover\\:border-teal-900:hover{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .xl\\:hover\\:border-blue-50:hover{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .xl\\:hover\\:border-blue-100:hover{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .xl\\:hover\\:border-blue-200:hover{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .xl\\:hover\\:border-blue-300:hover{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .xl\\:hover\\:border-blue-400:hover{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .xl\\:hover\\:border-blue-500:hover{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .xl\\:hover\\:border-blue-600:hover{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .xl\\:hover\\:border-blue-700:hover{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .xl\\:hover\\:border-blue-800:hover{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .xl\\:hover\\:border-blue-900:hover{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .xl\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .xl\\:hover\\:border-pink-50:hover{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .xl\\:hover\\:border-pink-100:hover{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .xl\\:hover\\:border-pink-200:hover{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .xl\\:hover\\:border-pink-300:hover{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .xl\\:hover\\:border-pink-400:hover{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .xl\\:hover\\:border-pink-500:hover{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .xl\\:hover\\:border-pink-600:hover{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .xl\\:hover\\:border-pink-700:hover{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .xl\\:hover\\:border-pink-800:hover{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .xl\\:hover\\:border-pink-900:hover{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .xl\\:focus\\:border-transparent:focus{
    border-color:#0000
  }

  .xl\\:focus\\:border-white:focus{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .xl\\:focus\\:border-black:focus{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .xl\\:focus\\:border-gray-50:focus{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .xl\\:focus\\:border-gray-100:focus{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .xl\\:focus\\:border-gray-200:focus{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .xl\\:focus\\:border-gray-300:focus{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .xl\\:focus\\:border-gray-400:focus{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .xl\\:focus\\:border-gray-500:focus{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .xl\\:focus\\:border-gray-600:focus{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .xl\\:focus\\:border-gray-700:focus{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .xl\\:focus\\:border-gray-800:focus{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .xl\\:focus\\:border-gray-900:focus{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .xl\\:focus\\:border-cool-gray-50:focus{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .xl\\:focus\\:border-cool-gray-100:focus{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .xl\\:focus\\:border-cool-gray-200:focus{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .xl\\:focus\\:border-cool-gray-300:focus{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .xl\\:focus\\:border-cool-gray-400:focus{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .xl\\:focus\\:border-cool-gray-500:focus{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .xl\\:focus\\:border-cool-gray-600:focus{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .xl\\:focus\\:border-cool-gray-700:focus{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .xl\\:focus\\:border-cool-gray-800:focus{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .xl\\:focus\\:border-cool-gray-900:focus{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .xl\\:focus\\:border-red-50:focus{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .xl\\:focus\\:border-red-100:focus{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .xl\\:focus\\:border-red-200:focus{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .xl\\:focus\\:border-red-300:focus{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .xl\\:focus\\:border-red-400:focus{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .xl\\:focus\\:border-red-500:focus{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .xl\\:focus\\:border-red-600:focus{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .xl\\:focus\\:border-red-700:focus{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .xl\\:focus\\:border-red-800:focus{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .xl\\:focus\\:border-red-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .xl\\:focus\\:border-orange-50:focus{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .xl\\:focus\\:border-orange-100:focus{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .xl\\:focus\\:border-orange-200:focus{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .xl\\:focus\\:border-orange-300:focus{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .xl\\:focus\\:border-orange-400:focus{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .xl\\:focus\\:border-orange-500:focus{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .xl\\:focus\\:border-orange-600:focus{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .xl\\:focus\\:border-orange-700:focus{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .xl\\:focus\\:border-orange-800:focus{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .xl\\:focus\\:border-orange-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .xl\\:focus\\:border-yellow-50:focus{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .xl\\:focus\\:border-yellow-100:focus{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .xl\\:focus\\:border-yellow-200:focus{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .xl\\:focus\\:border-yellow-300:focus{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .xl\\:focus\\:border-yellow-400:focus{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .xl\\:focus\\:border-yellow-500:focus{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .xl\\:focus\\:border-yellow-600:focus{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .xl\\:focus\\:border-yellow-700:focus{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .xl\\:focus\\:border-yellow-800:focus{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .xl\\:focus\\:border-yellow-900:focus{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .xl\\:focus\\:border-green-50:focus{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .xl\\:focus\\:border-green-100:focus{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .xl\\:focus\\:border-green-200:focus{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .xl\\:focus\\:border-green-300:focus{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .xl\\:focus\\:border-green-400:focus{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .xl\\:focus\\:border-green-500:focus{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .xl\\:focus\\:border-green-600:focus{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .xl\\:focus\\:border-green-700:focus{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .xl\\:focus\\:border-green-800:focus{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .xl\\:focus\\:border-green-900:focus{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .xl\\:focus\\:border-teal-50:focus{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .xl\\:focus\\:border-teal-100:focus{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .xl\\:focus\\:border-teal-200:focus{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .xl\\:focus\\:border-teal-300:focus{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .xl\\:focus\\:border-teal-400:focus{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .xl\\:focus\\:border-teal-500:focus{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .xl\\:focus\\:border-teal-600:focus{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .xl\\:focus\\:border-teal-700:focus{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .xl\\:focus\\:border-teal-800:focus{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .xl\\:focus\\:border-teal-900:focus{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .xl\\:focus\\:border-blue-50:focus{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .xl\\:focus\\:border-blue-100:focus{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .xl\\:focus\\:border-blue-200:focus{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .xl\\:focus\\:border-blue-300:focus{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .xl\\:focus\\:border-blue-400:focus{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .xl\\:focus\\:border-blue-500:focus{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .xl\\:focus\\:border-blue-600:focus{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .xl\\:focus\\:border-blue-700:focus{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .xl\\:focus\\:border-blue-800:focus{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .xl\\:focus\\:border-blue-900:focus{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .xl\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .xl\\:focus\\:border-pink-50:focus{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .xl\\:focus\\:border-pink-100:focus{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .xl\\:focus\\:border-pink-200:focus{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .xl\\:focus\\:border-pink-300:focus{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .xl\\:focus\\:border-pink-400:focus{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .xl\\:focus\\:border-pink-500:focus{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .xl\\:focus\\:border-pink-600:focus{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .xl\\:focus\\:border-pink-700:focus{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .xl\\:focus\\:border-pink-800:focus{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .xl\\:focus\\:border-pink-900:focus{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-transparent{
    border-color:#0000
  }

  .theme-dark .xl\\:dark\\:border-white{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-black{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-gray-50{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-gray-100{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-gray-200{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-gray-300{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-gray-400{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-gray-500{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-gray-600{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-gray-700{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-gray-800{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-gray-900{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-cool-gray-50{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-cool-gray-100{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-cool-gray-200{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-cool-gray-300{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-cool-gray-400{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-cool-gray-500{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-cool-gray-600{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-cool-gray-700{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-cool-gray-800{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-cool-gray-900{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-red-50{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-red-100{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-red-200{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-red-300{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-red-400{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-red-500{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-red-600{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-red-700{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-red-800{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-red-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-orange-50{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-orange-100{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-orange-200{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-orange-300{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-orange-400{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-orange-500{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-orange-600{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-orange-700{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-orange-800{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-orange-900{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-yellow-50{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-yellow-100{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-yellow-200{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-yellow-300{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-yellow-400{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-yellow-500{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-yellow-600{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-yellow-700{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-yellow-800{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-yellow-900{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-green-50{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-green-100{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-green-200{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-green-300{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-green-400{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-green-500{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-green-600{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-green-700{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-green-800{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-green-900{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-teal-50{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-teal-100{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-teal-200{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-teal-300{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-teal-400{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-teal-500{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-teal-600{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-teal-700{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-teal-800{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-teal-900{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-blue-50{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-blue-100{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-blue-200{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-blue-300{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-blue-400{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-blue-500{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-blue-600{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-blue-700{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-blue-800{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-blue-900{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-100{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-200{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-300{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-400{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-500{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-600{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-700{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-800{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-900{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-50{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-100{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-200{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-300{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-400{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-500{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-600{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-700{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-800{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-indigo-900{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-pink-50{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-pink-100{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-pink-200{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-pink-300{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-pink-400{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-pink-500{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-pink-600{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-pink-700{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-pink-800{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:border-pink-900{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-transparent:focus{
    border-color:#0000
  }

  .theme-dark .xl\\:dark\\:focus\\:border-white:focus{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-black:focus{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-gray-50:focus{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-gray-100:focus{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-gray-200:focus{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-gray-300:focus{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-gray-400:focus{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-gray-500:focus{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-gray-600:focus{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-gray-700:focus{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-gray-800:focus{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-gray-900:focus{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-cool-gray-50:focus{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-cool-gray-100:focus{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-cool-gray-200:focus{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-cool-gray-300:focus{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-cool-gray-400:focus{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-cool-gray-500:focus{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-cool-gray-600:focus{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-cool-gray-700:focus{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-cool-gray-800:focus{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-cool-gray-900:focus{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-red-50:focus{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-red-100:focus{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-red-200:focus{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-red-300:focus{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-red-400:focus{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-red-500:focus{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-red-600:focus{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-red-700:focus{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-red-800:focus{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-red-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-orange-50:focus{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-orange-100:focus{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-orange-200:focus{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-orange-300:focus{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-orange-400:focus{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-orange-500:focus{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-orange-600:focus{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-orange-700:focus{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-orange-800:focus{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-orange-900:focus{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-yellow-50:focus{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-yellow-100:focus{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-yellow-200:focus{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-yellow-300:focus{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-yellow-400:focus{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-yellow-500:focus{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-yellow-600:focus{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-yellow-700:focus{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-yellow-800:focus{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-yellow-900:focus{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-green-50:focus{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-green-100:focus{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-green-200:focus{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-green-300:focus{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-green-400:focus{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-green-500:focus{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-green-600:focus{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-green-700:focus{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-green-800:focus{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-green-900:focus{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-teal-50:focus{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-teal-100:focus{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-teal-200:focus{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-teal-300:focus{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-teal-400:focus{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-teal-500:focus{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-teal-600:focus{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-teal-700:focus{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-teal-800:focus{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-teal-900:focus{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-blue-50:focus{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-blue-100:focus{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-blue-200:focus{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-blue-300:focus{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-blue-400:focus{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-blue-500:focus{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-blue-600:focus{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-blue-700:focus{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-blue-800:focus{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-blue-900:focus{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-50:focus{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-100:focus{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-200:focus{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-300:focus{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-400:focus{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-500:focus{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-600:focus{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-700:focus{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-800:focus{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-indigo-900:focus{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-pink-50:focus{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-pink-100:focus{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-pink-200:focus{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-pink-300:focus{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-pink-400:focus{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-pink-500:focus{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-pink-600:focus{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-pink-700:focus{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-pink-800:focus{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:border-pink-900:focus{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-transparent:hover{
    border-color:#0000
  }

  .theme-dark .xl\\:dark\\:hover\\:border-white:hover{
    --border-opacity:1;
    border-color:#fff;
    border-color:rgba(255,255,255,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-black:hover{
    --border-opacity:1;
    border-color:#000;
    border-color:rgba(0,0,0,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-gray-50:hover{
    --border-opacity:1;
    border-color:#f9fafb;
    border-color:rgba(249,250,251,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-gray-100:hover{
    --border-opacity:1;
    border-color:#f4f5f7;
    border-color:rgba(244,245,247,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-gray-200:hover{
    --border-opacity:1;
    border-color:#e5e7eb;
    border-color:rgba(229,231,235,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-gray-300:hover{
    --border-opacity:1;
    border-color:#d5d6d7;
    border-color:rgba(213,214,215,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-gray-400:hover{
    --border-opacity:1;
    border-color:#9e9e9e;
    border-color:rgba(158,158,158,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-gray-500:hover{
    --border-opacity:1;
    border-color:#707275;
    border-color:rgba(112,114,117,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-gray-600:hover{
    --border-opacity:1;
    border-color:#4c4f52;
    border-color:rgba(76,79,82,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-gray-700:hover{
    --border-opacity:1;
    border-color:#24262d;
    border-color:rgba(36,38,45,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-gray-800:hover{
    --border-opacity:1;
    border-color:#1a1c23;
    border-color:rgba(26,28,35,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-gray-900:hover{
    --border-opacity:1;
    border-color:#121317;
    border-color:rgba(18,19,23,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-cool-gray-50:hover{
    --border-opacity:1;
    border-color:#fbfdfe;
    border-color:rgba(251,253,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-cool-gray-100:hover{
    --border-opacity:1;
    border-color:#f1f5f9;
    border-color:rgba(241,245,249,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-cool-gray-200:hover{
    --border-opacity:1;
    border-color:#e2e8f0;
    border-color:rgba(226,232,240,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-cool-gray-300:hover{
    --border-opacity:1;
    border-color:#cfd8e3;
    border-color:rgba(207,216,227,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-cool-gray-400:hover{
    --border-opacity:1;
    border-color:#97a6ba;
    border-color:rgba(151,166,186,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-cool-gray-500:hover{
    --border-opacity:1;
    border-color:#64748b;
    border-color:rgba(100,116,139,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-cool-gray-600:hover{
    --border-opacity:1;
    border-color:#475569;
    border-color:rgba(71,85,105,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-cool-gray-700:hover{
    --border-opacity:1;
    border-color:#364152;
    border-color:rgba(54,65,82,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-cool-gray-800:hover{
    --border-opacity:1;
    border-color:#27303f;
    border-color:rgba(39,48,63,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-cool-gray-900:hover{
    --border-opacity:1;
    border-color:#1a202e;
    border-color:rgba(26,32,46,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-red-50:hover{
    --border-opacity:1;
    border-color:#fdf2f2;
    border-color:rgba(253,242,242,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-red-100:hover{
    --border-opacity:1;
    border-color:#fde8e8;
    border-color:rgba(253,232,232,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-red-200:hover{
    --border-opacity:1;
    border-color:#fbd5d5;
    border-color:rgba(251,213,213,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-red-300:hover{
    --border-opacity:1;
    border-color:#f8b4b4;
    border-color:rgba(248,180,180,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-red-400:hover{
    --border-opacity:1;
    border-color:#f98080;
    border-color:rgba(249,128,128,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-red-500:hover{
    --border-opacity:1;
    border-color:#f05252;
    border-color:rgba(240,82,82,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-red-600:hover{
    --border-opacity:1;
    border-color:#e02424;
    border-color:rgba(224,36,36,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-red-700:hover{
    --border-opacity:1;
    border-color:#c81e1e;
    border-color:rgba(200,30,30,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-red-800:hover{
    --border-opacity:1;
    border-color:#9b1c1c;
    border-color:rgba(155,28,28,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-red-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-orange-50:hover{
    --border-opacity:1;
    border-color:#fff8f1;
    border-color:rgba(255,248,241,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-orange-100:hover{
    --border-opacity:1;
    border-color:#feecdc;
    border-color:rgba(254,236,220,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-orange-200:hover{
    --border-opacity:1;
    border-color:#fcd9bd;
    border-color:rgba(252,217,189,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-orange-300:hover{
    --border-opacity:1;
    border-color:#fdba8c;
    border-color:rgba(253,186,140,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-orange-400:hover{
    --border-opacity:1;
    border-color:#ff8a4c;
    border-color:rgba(255,138,76,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-orange-500:hover{
    --border-opacity:1;
    border-color:#ff5a1f;
    border-color:rgba(255,90,31,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-orange-600:hover{
    --border-opacity:1;
    border-color:#d03801;
    border-color:rgba(208,56,1,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-orange-700:hover{
    --border-opacity:1;
    border-color:#b43403;
    border-color:rgba(180,52,3,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-orange-800:hover{
    --border-opacity:1;
    border-color:#8a2c0d;
    border-color:rgba(138,44,13,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-orange-900:hover{
    --border-opacity:1;
    border-color:#771d1d;
    border-color:rgba(119,29,29,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-yellow-50:hover{
    --border-opacity:1;
    border-color:#fdfdea;
    border-color:rgba(253,253,234,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-yellow-100:hover{
    --border-opacity:1;
    border-color:#fdf6b2;
    border-color:rgba(253,246,178,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-yellow-200:hover{
    --border-opacity:1;
    border-color:#fce96a;
    border-color:rgba(252,233,106,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-yellow-300:hover{
    --border-opacity:1;
    border-color:#faca15;
    border-color:rgba(250,202,21,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-yellow-400:hover{
    --border-opacity:1;
    border-color:#e3a008;
    border-color:rgba(227,160,8,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-yellow-500:hover{
    --border-opacity:1;
    border-color:#c27803;
    border-color:rgba(194,120,3,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-yellow-600:hover{
    --border-opacity:1;
    border-color:#9f580a;
    border-color:rgba(159,88,10,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-yellow-700:hover{
    --border-opacity:1;
    border-color:#8e4b10;
    border-color:rgba(142,75,16,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-yellow-800:hover{
    --border-opacity:1;
    border-color:#723b13;
    border-color:rgba(114,59,19,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-yellow-900:hover{
    --border-opacity:1;
    border-color:#633112;
    border-color:rgba(99,49,18,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-green-50:hover{
    --border-opacity:1;
    border-color:#f3faf7;
    border-color:rgba(243,250,247,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-green-100:hover{
    --border-opacity:1;
    border-color:#def7ec;
    border-color:rgba(222,247,236,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-green-200:hover{
    --border-opacity:1;
    border-color:#bcf0da;
    border-color:rgba(188,240,218,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-green-300:hover{
    --border-opacity:1;
    border-color:#84e1bc;
    border-color:rgba(132,225,188,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-green-400:hover{
    --border-opacity:1;
    border-color:#31c48d;
    border-color:rgba(49,196,141,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-green-500:hover{
    --border-opacity:1;
    border-color:#0e9f6e;
    border-color:rgba(14,159,110,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-green-600:hover{
    --border-opacity:1;
    border-color:#057a55;
    border-color:rgba(5,122,85,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-green-700:hover{
    --border-opacity:1;
    border-color:#046c4e;
    border-color:rgba(4,108,78,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-green-800:hover{
    --border-opacity:1;
    border-color:#03543f;
    border-color:rgba(3,84,63,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-green-900:hover{
    --border-opacity:1;
    border-color:#014737;
    border-color:rgba(1,71,55,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-teal-50:hover{
    --border-opacity:1;
    border-color:#edfafa;
    border-color:rgba(237,250,250,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-teal-100:hover{
    --border-opacity:1;
    border-color:#d5f5f6;
    border-color:rgba(213,245,246,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-teal-200:hover{
    --border-opacity:1;
    border-color:#afecef;
    border-color:rgba(175,236,239,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-teal-300:hover{
    --border-opacity:1;
    border-color:#7edce2;
    border-color:rgba(126,220,226,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-teal-400:hover{
    --border-opacity:1;
    border-color:#16bdca;
    border-color:rgba(22,189,202,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-teal-500:hover{
    --border-opacity:1;
    border-color:#0694a2;
    border-color:rgba(6,148,162,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-teal-600:hover{
    --border-opacity:1;
    border-color:#047481;
    border-color:rgba(4,116,129,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-teal-700:hover{
    --border-opacity:1;
    border-color:#036672;
    border-color:rgba(3,102,114,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-teal-800:hover{
    --border-opacity:1;
    border-color:#05505c;
    border-color:rgba(5,80,92,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-teal-900:hover{
    --border-opacity:1;
    border-color:#014451;
    border-color:rgba(1,68,81,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-blue-50:hover{
    --border-opacity:1;
    border-color:#ebf5ff;
    border-color:rgba(235,245,255,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-blue-100:hover{
    --border-opacity:1;
    border-color:#e1effe;
    border-color:rgba(225,239,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-blue-200:hover{
    --border-opacity:1;
    border-color:#c3ddfd;
    border-color:rgba(195,221,253,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-blue-300:hover{
    --border-opacity:1;
    border-color:#a4cafe;
    border-color:rgba(164,202,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-blue-400:hover{
    --border-opacity:1;
    border-color:#76a9fa;
    border-color:rgba(118,169,250,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-blue-500:hover{
    --border-opacity:1;
    border-color:#3f83f8;
    border-color:rgba(63,131,248,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-blue-600:hover{
    --border-opacity:1;
    border-color:#1c64f2;
    border-color:rgba(28,100,242,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-blue-700:hover{
    --border-opacity:1;
    border-color:#1a56db;
    border-color:rgba(26,86,219,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-blue-800:hover{
    --border-opacity:1;
    border-color:#1e429f;
    border-color:rgba(30,66,159,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-blue-900:hover{
    --border-opacity:1;
    border-color:#233876;
    border-color:rgba(35,56,118,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f0f5ff;
    border-color:rgba(240,245,255,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#e5edff;
    border-color:rgba(229,237,255,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#cddbfe;
    border-color:rgba(205,219,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#b4c6fc;
    border-color:rgba(180,198,252,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#8da2fb;
    border-color:rgba(141,162,251,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#6875f5;
    border-color:rgba(104,117,245,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#5850ec;
    border-color:rgba(88,80,236,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#5145cd;
    border-color:rgba(81,69,205,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#42389d;
    border-color:rgba(66,56,157,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#362f78;
    border-color:rgba(54,47,120,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-50:hover{
    --border-opacity:1;
    border-color:#f6f5ff;
    border-color:rgba(246,245,255,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-100:hover{
    --border-opacity:1;
    border-color:#edebfe;
    border-color:rgba(237,235,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-200:hover{
    --border-opacity:1;
    border-color:#dcd7fe;
    border-color:rgba(220,215,254,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-300:hover{
    --border-opacity:1;
    border-color:#cabffd;
    border-color:rgba(202,191,253,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-400:hover{
    --border-opacity:1;
    border-color:#ac94fa;
    border-color:rgba(172,148,250,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-500:hover{
    --border-opacity:1;
    border-color:#9061f9;
    border-color:rgba(144,97,249,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-600:hover{
    --border-opacity:1;
    border-color:#7e3af2;
    border-color:rgba(126,58,242,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-700:hover{
    --border-opacity:1;
    border-color:#6c2bd9;
    border-color:rgba(108,43,217,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-800:hover{
    --border-opacity:1;
    border-color:#5521b5;
    border-color:rgba(85,33,181,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-indigo-900:hover{
    --border-opacity:1;
    border-color:#4a1d96;
    border-color:rgba(74,29,150,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-pink-50:hover{
    --border-opacity:1;
    border-color:#fdf2f8;
    border-color:rgba(253,242,248,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-pink-100:hover{
    --border-opacity:1;
    border-color:#fce8f3;
    border-color:rgba(252,232,243,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-pink-200:hover{
    --border-opacity:1;
    border-color:#fad1e8;
    border-color:rgba(250,209,232,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-pink-300:hover{
    --border-opacity:1;
    border-color:#f8b4d9;
    border-color:rgba(248,180,217,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-pink-400:hover{
    --border-opacity:1;
    border-color:#f17eb8;
    border-color:rgba(241,126,184,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-pink-500:hover{
    --border-opacity:1;
    border-color:#e74694;
    border-color:rgba(231,70,148,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-pink-600:hover{
    --border-opacity:1;
    border-color:#d61f69;
    border-color:rgba(214,31,105,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-pink-700:hover{
    --border-opacity:1;
    border-color:#bf125d;
    border-color:rgba(191,18,93,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-pink-800:hover{
    --border-opacity:1;
    border-color:#99154b;
    border-color:rgba(153,21,75,var(--border-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:border-pink-900:hover{
    --border-opacity:1;
    border-color:#751a3d;
    border-color:rgba(117,26,61,var(--border-opacity))
  }

  .xl\\:border-opacity-0{
    --border-opacity:0
  }

  .xl\\:border-opacity-25{
    --border-opacity:0.25
  }

  .xl\\:border-opacity-50{
    --border-opacity:0.5
  }

  .xl\\:border-opacity-75{
    --border-opacity:0.75
  }

  .xl\\:border-opacity-100{
    --border-opacity:1
  }

  .xl\\:hover\\:border-opacity-0:hover{
    --border-opacity:0
  }

  .xl\\:hover\\:border-opacity-25:hover{
    --border-opacity:0.25
  }

  .xl\\:hover\\:border-opacity-50:hover{
    --border-opacity:0.5
  }

  .xl\\:hover\\:border-opacity-75:hover{
    --border-opacity:0.75
  }

  .xl\\:hover\\:border-opacity-100:hover{
    --border-opacity:1
  }

  .xl\\:focus\\:border-opacity-0:focus{
    --border-opacity:0
  }

  .xl\\:focus\\:border-opacity-25:focus{
    --border-opacity:0.25
  }

  .xl\\:focus\\:border-opacity-50:focus{
    --border-opacity:0.5
  }

  .xl\\:focus\\:border-opacity-75:focus{
    --border-opacity:0.75
  }

  .xl\\:focus\\:border-opacity-100:focus{
    --border-opacity:1
  }

  .xl\\:rounded-none{
    border-radius:0
  }

  .xl\\:rounded-sm{
    border-radius:.125rem
  }

  .xl\\:rounded{
    border-radius:.25rem
  }

  .xl\\:rounded-md{
    border-radius:.375rem
  }

  .xl\\:rounded-lg{
    border-radius:.5rem
  }

  .xl\\:rounded-full{
    border-radius:9999px
  }

  .xl\\:rounded-t-none{
    border-top-left-radius:0;
    border-top-right-radius:0
  }

  .xl\\:rounded-r-none{
    border-bottom-right-radius:0;
    border-top-right-radius:0
  }

  .xl\\:rounded-b-none{
    border-bottom-left-radius:0;
    border-bottom-right-radius:0
  }

  .xl\\:rounded-l-none{
    border-bottom-left-radius:0;
    border-top-left-radius:0
  }

  .xl\\:rounded-t-sm{
    border-top-left-radius:.125rem;
    border-top-right-radius:.125rem
  }

  .xl\\:rounded-r-sm{
    border-bottom-right-radius:.125rem;
    border-top-right-radius:.125rem
  }

  .xl\\:rounded-b-sm{
    border-bottom-left-radius:.125rem;
    border-bottom-right-radius:.125rem
  }

  .xl\\:rounded-l-sm{
    border-bottom-left-radius:.125rem;
    border-top-left-radius:.125rem
  }

  .xl\\:rounded-t{
    border-top-left-radius:.25rem
  }

  .xl\\:rounded-r,.xl\\:rounded-t{
    border-top-right-radius:.25rem
  }

  .xl\\:rounded-b,.xl\\:rounded-r{
    border-bottom-right-radius:.25rem
  }

  .xl\\:rounded-b,.xl\\:rounded-l{
    border-bottom-left-radius:.25rem
  }

  .xl\\:rounded-l{
    border-top-left-radius:.25rem
  }

  .xl\\:rounded-t-md{
    border-top-left-radius:.375rem;
    border-top-right-radius:.375rem
  }

  .xl\\:rounded-r-md{
    border-bottom-right-radius:.375rem;
    border-top-right-radius:.375rem
  }

  .xl\\:rounded-b-md{
    border-bottom-left-radius:.375rem;
    border-bottom-right-radius:.375rem
  }

  .xl\\:rounded-l-md{
    border-bottom-left-radius:.375rem;
    border-top-left-radius:.375rem
  }

  .xl\\:rounded-t-lg{
    border-top-left-radius:.5rem;
    border-top-right-radius:.5rem
  }

  .xl\\:rounded-r-lg{
    border-bottom-right-radius:.5rem;
    border-top-right-radius:.5rem
  }

  .xl\\:rounded-b-lg{
    border-bottom-left-radius:.5rem;
    border-bottom-right-radius:.5rem
  }

  .xl\\:rounded-l-lg{
    border-bottom-left-radius:.5rem;
    border-top-left-radius:.5rem
  }

  .xl\\:rounded-t-full{
    border-top-left-radius:9999px;
    border-top-right-radius:9999px
  }

  .xl\\:rounded-r-full{
    border-bottom-right-radius:9999px;
    border-top-right-radius:9999px
  }

  .xl\\:rounded-b-full{
    border-bottom-left-radius:9999px;
    border-bottom-right-radius:9999px
  }

  .xl\\:rounded-l-full{
    border-bottom-left-radius:9999px;
    border-top-left-radius:9999px
  }

  .xl\\:rounded-tl-none{
    border-top-left-radius:0
  }

  .xl\\:rounded-tr-none{
    border-top-right-radius:0
  }

  .xl\\:rounded-br-none{
    border-bottom-right-radius:0
  }

  .xl\\:rounded-bl-none{
    border-bottom-left-radius:0
  }

  .xl\\:rounded-tl-sm{
    border-top-left-radius:.125rem
  }

  .xl\\:rounded-tr-sm{
    border-top-right-radius:.125rem
  }

  .xl\\:rounded-br-sm{
    border-bottom-right-radius:.125rem
  }

  .xl\\:rounded-bl-sm{
    border-bottom-left-radius:.125rem
  }

  .xl\\:rounded-tl{
    border-top-left-radius:.25rem
  }

  .xl\\:rounded-tr{
    border-top-right-radius:.25rem
  }

  .xl\\:rounded-br{
    border-bottom-right-radius:.25rem
  }

  .xl\\:rounded-bl{
    border-bottom-left-radius:.25rem
  }

  .xl\\:rounded-tl-md{
    border-top-left-radius:.375rem
  }

  .xl\\:rounded-tr-md{
    border-top-right-radius:.375rem
  }

  .xl\\:rounded-br-md{
    border-bottom-right-radius:.375rem
  }

  .xl\\:rounded-bl-md{
    border-bottom-left-radius:.375rem
  }

  .xl\\:rounded-tl-lg{
    border-top-left-radius:.5rem
  }

  .xl\\:rounded-tr-lg{
    border-top-right-radius:.5rem
  }

  .xl\\:rounded-br-lg{
    border-bottom-right-radius:.5rem
  }

  .xl\\:rounded-bl-lg{
    border-bottom-left-radius:.5rem
  }

  .xl\\:rounded-tl-full{
    border-top-left-radius:9999px
  }

  .xl\\:rounded-tr-full{
    border-top-right-radius:9999px
  }

  .xl\\:rounded-br-full{
    border-bottom-right-radius:9999px
  }

  .xl\\:rounded-bl-full{
    border-bottom-left-radius:9999px
  }

  .xl\\:border-solid{
    border-style:solid
  }

  .xl\\:border-dashed{
    border-style:dashed
  }

  .xl\\:border-dotted{
    border-style:dotted
  }

  .xl\\:border-double{
    border-style:double
  }

  .xl\\:border-none{
    border-style:none
  }

  .xl\\:border-0{
    border-width:0
  }

  .xl\\:border-2{
    border-width:2px
  }

  .xl\\:border-4{
    border-width:4px
  }

  .xl\\:border-8{
    border-width:8px
  }

  .xl\\:border{
    border-width:1px
  }

  .xl\\:border-t-0{
    border-top-width:0
  }

  .xl\\:border-r-0{
    border-right-width:0
  }

  .xl\\:border-b-0{
    border-bottom-width:0
  }

  .xl\\:border-l-0{
    border-left-width:0
  }

  .xl\\:border-t-2{
    border-top-width:2px
  }

  .xl\\:border-r-2{
    border-right-width:2px
  }

  .xl\\:border-b-2{
    border-bottom-width:2px
  }

  .xl\\:border-l-2{
    border-left-width:2px
  }

  .xl\\:border-t-4{
    border-top-width:4px
  }

  .xl\\:border-r-4{
    border-right-width:4px
  }

  .xl\\:border-b-4{
    border-bottom-width:4px
  }

  .xl\\:border-l-4{
    border-left-width:4px
  }

  .xl\\:border-t-8{
    border-top-width:8px
  }

  .xl\\:border-r-8{
    border-right-width:8px
  }

  .xl\\:border-b-8{
    border-bottom-width:8px
  }

  .xl\\:border-l-8{
    border-left-width:8px
  }

  .xl\\:border-t{
    border-top-width:1px
  }

  .xl\\:border-r{
    border-right-width:1px
  }

  .xl\\:border-b{
    border-bottom-width:1px
  }

  .xl\\:border-l{
    border-left-width:1px
  }

  .xl\\:box-border{
    box-sizing:border-box
  }

  .xl\\:box-content{
    box-sizing:initial
  }

  .xl\\:cursor-auto{
    cursor:auto
  }

  .xl\\:cursor-default{
    cursor:default
  }

  .xl\\:cursor-pointer{
    cursor:pointer
  }

  .xl\\:cursor-wait{
    cursor:wait
  }

  .xl\\:cursor-text{
    cursor:text
  }

  .xl\\:cursor-move{
    cursor:move
  }

  .xl\\:cursor-not-allowed{
    cursor:not-allowed
  }

  .xl\\:block{
    display:block
  }

  .xl\\:inline-block{
    display:inline-block
  }

  .xl\\:inline{
    display:inline
  }

  .xl\\:flex{
    display:flex
  }

  .xl\\:inline-flex{
    display:inline-flex
  }

  .xl\\:table{
    display:table
  }

  .xl\\:table-caption{
    display:table-caption
  }

  .xl\\:table-cell{
    display:table-cell
  }

  .xl\\:table-column{
    display:table-column
  }

  .xl\\:table-column-group{
    display:table-column-group
  }

  .xl\\:table-footer-group{
    display:table-footer-group
  }

  .xl\\:table-header-group{
    display:table-header-group
  }

  .xl\\:table-row-group{
    display:table-row-group
  }

  .xl\\:table-row{
    display:table-row
  }

  .xl\\:flow-root{
    display:flow-root
  }

  .xl\\:grid{
    display:grid
  }

  .xl\\:inline-grid{
    display:inline-grid
  }

  .xl\\:hidden{
    display:none
  }

  .theme-dark .xl\\:dark\\:block{
    display:block
  }

  .theme-dark .xl\\:dark\\:inline-block{
    display:inline-block
  }

  .theme-dark .xl\\:dark\\:inline{
    display:inline
  }

  .theme-dark .xl\\:dark\\:flex{
    display:flex
  }

  .theme-dark .xl\\:dark\\:inline-flex{
    display:inline-flex
  }

  .theme-dark .xl\\:dark\\:table{
    display:table
  }

  .theme-dark .xl\\:dark\\:table-caption{
    display:table-caption
  }

  .theme-dark .xl\\:dark\\:table-cell{
    display:table-cell
  }

  .theme-dark .xl\\:dark\\:table-column{
    display:table-column
  }

  .theme-dark .xl\\:dark\\:table-column-group{
    display:table-column-group
  }

  .theme-dark .xl\\:dark\\:table-footer-group{
    display:table-footer-group
  }

  .theme-dark .xl\\:dark\\:table-header-group{
    display:table-header-group
  }

  .theme-dark .xl\\:dark\\:table-row-group{
    display:table-row-group
  }

  .theme-dark .xl\\:dark\\:table-row{
    display:table-row
  }

  .theme-dark .xl\\:dark\\:flow-root{
    display:flow-root
  }

  .theme-dark .xl\\:dark\\:grid{
    display:grid
  }

  .theme-dark .xl\\:dark\\:inline-grid{
    display:inline-grid
  }

  .theme-dark .xl\\:dark\\:hidden{
    display:none
  }

  .xl\\:flex-row{
    flex-direction:row
  }

  .xl\\:flex-row-reverse{
    flex-direction:row-reverse
  }

  .xl\\:flex-col{
    flex-direction:column
  }

  .xl\\:flex-col-reverse{
    flex-direction:column-reverse
  }

  .xl\\:flex-wrap{
    flex-wrap:wrap
  }

  .xl\\:flex-wrap-reverse{
    flex-wrap:wrap-reverse
  }

  .xl\\:flex-no-wrap{
    flex-wrap:nowrap
  }

  .xl\\:items-start{
    align-items:flex-start
  }

  .xl\\:items-end{
    align-items:flex-end
  }

  .xl\\:items-center{
    align-items:center
  }

  .xl\\:items-baseline{
    align-items:baseline
  }

  .xl\\:items-stretch{
    align-items:stretch
  }

  .xl\\:self-auto{
    align-self:auto
  }

  .xl\\:self-start{
    align-self:flex-start
  }

  .xl\\:self-end{
    align-self:flex-end
  }

  .xl\\:self-center{
    align-self:center
  }

  .xl\\:self-stretch{
    align-self:stretch
  }

  .xl\\:justify-start{
    justify-content:flex-start
  }

  .xl\\:justify-end{
    justify-content:flex-end
  }

  .xl\\:justify-center{
    justify-content:center
  }

  .xl\\:justify-between{
    justify-content:space-between
  }

  .xl\\:justify-around{
    justify-content:space-around
  }

  .xl\\:justify-evenly{
    justify-content:space-evenly
  }

  .xl\\:content-center{
    align-content:center
  }

  .xl\\:content-start{
    align-content:flex-start
  }

  .xl\\:content-end{
    align-content:flex-end
  }

  .xl\\:content-between{
    align-content:space-between
  }

  .xl\\:content-around{
    align-content:space-around
  }

  .xl\\:flex-1{
    flex:1 1
  }

  .xl\\:flex-auto{
    flex:1 1 auto
  }

  .xl\\:flex-initial{
    flex:0 1 auto
  }

  .xl\\:flex-none{
    flex:none
  }

  .xl\\:flex-grow-0{
    flex-grow:0
  }

  .xl\\:flex-grow{
    flex-grow:1
  }

  .xl\\:flex-shrink-0{
    flex-shrink:0
  }

  .xl\\:flex-shrink{
    flex-shrink:1
  }

  .xl\\:order-1{
    order:1
  }

  .xl\\:order-2{
    order:2
  }

  .xl\\:order-3{
    order:3
  }

  .xl\\:order-4{
    order:4
  }

  .xl\\:order-5{
    order:5
  }

  .xl\\:order-6{
    order:6
  }

  .xl\\:order-7{
    order:7
  }

  .xl\\:order-8{
    order:8
  }

  .xl\\:order-9{
    order:9
  }

  .xl\\:order-10{
    order:10
  }

  .xl\\:order-11{
    order:11
  }

  .xl\\:order-12{
    order:12
  }

  .xl\\:order-first{
    order:-9999
  }

  .xl\\:order-last{
    order:9999
  }

  .xl\\:order-none{
    order:0
  }

  .xl\\:float-right{
    float:right
  }

  .xl\\:float-left{
    float:left
  }

  .xl\\:float-none{
    float:none
  }

  .xl\\:clearfix:after{
    clear:both;
    content:"";
    display:table
  }

  .xl\\:clear-left{
    clear:left
  }

  .xl\\:clear-right{
    clear:right
  }

  .xl\\:clear-both{
    clear:both
  }

  .xl\\:clear-none{
    clear:none
  }

  .xl\\:font-sans{
    font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji
  }

  .xl\\:font-serif{
    font-family:Georgia,Cambria,Times New Roman,Times,serif
  }

  .xl\\:font-mono{
    font-family:Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace
  }

  .xl\\:font-hairline{
    font-weight:100
  }

  .xl\\:font-thin{
    font-weight:200
  }

  .xl\\:font-light{
    font-weight:300
  }

  .xl\\:font-normal{
    font-weight:400
  }

  .xl\\:font-medium{
    font-weight:500
  }

  .xl\\:font-semibold{
    font-weight:600
  }

  .xl\\:font-bold{
    font-weight:700
  }

  .xl\\:font-extrabold{
    font-weight:800
  }

  .xl\\:font-black{
    font-weight:900
  }

  .xl\\:hover\\:font-hairline:hover{
    font-weight:100
  }

  .xl\\:hover\\:font-thin:hover{
    font-weight:200
  }

  .xl\\:hover\\:font-light:hover{
    font-weight:300
  }

  .xl\\:hover\\:font-normal:hover{
    font-weight:400
  }

  .xl\\:hover\\:font-medium:hover{
    font-weight:500
  }

  .xl\\:hover\\:font-semibold:hover{
    font-weight:600
  }

  .xl\\:hover\\:font-bold:hover{
    font-weight:700
  }

  .xl\\:hover\\:font-extrabold:hover{
    font-weight:800
  }

  .xl\\:hover\\:font-black:hover{
    font-weight:900
  }

  .xl\\:focus\\:font-hairline:focus{
    font-weight:100
  }

  .xl\\:focus\\:font-thin:focus{
    font-weight:200
  }

  .xl\\:focus\\:font-light:focus{
    font-weight:300
  }

  .xl\\:focus\\:font-normal:focus{
    font-weight:400
  }

  .xl\\:focus\\:font-medium:focus{
    font-weight:500
  }

  .xl\\:focus\\:font-semibold:focus{
    font-weight:600
  }

  .xl\\:focus\\:font-bold:focus{
    font-weight:700
  }

  .xl\\:focus\\:font-extrabold:focus{
    font-weight:800
  }

  .xl\\:focus\\:font-black:focus{
    font-weight:900
  }

  .xl\\:h-0{
    height:0
  }

  .xl\\:h-1{
    height:.25rem
  }

  .xl\\:h-2{
    height:.5rem
  }

  .xl\\:h-3{
    height:.75rem
  }

  .xl\\:h-4{
    height:1rem
  }

  .xl\\:h-5{
    height:1.25rem
  }

  .xl\\:h-6{
    height:1.5rem
  }

  .xl\\:h-8{
    height:2rem
  }

  .xl\\:h-10{
    height:2.5rem
  }

  .xl\\:h-12{
    height:3rem
  }

  .xl\\:h-16{
    height:4rem
  }

  .xl\\:h-20{
    height:5rem
  }

  .xl\\:h-24{
    height:6rem
  }

  .xl\\:h-32{
    height:8rem
  }

  .xl\\:h-40{
    height:10rem
  }

  .xl\\:h-48{
    height:12rem
  }

  .xl\\:h-56{
    height:14rem
  }

  .xl\\:h-64{
    height:16rem
  }

  .xl\\:h-auto{
    height:auto
  }

  .xl\\:h-px{
    height:1px
  }

  .xl\\:h-full{
    height:100%
  }

  .xl\\:h-screen{
    height:100vh
  }

  .xl\\:text-xs{
    font-size:.75rem
  }

  .xl\\:text-sm{
    font-size:.875rem
  }

  .xl\\:text-base{
    font-size:1rem
  }

  .xl\\:text-lg{
    font-size:1.125rem
  }

  .xl\\:text-xl{
    font-size:1.25rem
  }

  .xl\\:text-2xl{
    font-size:1.5rem
  }

  .xl\\:text-3xl{
    font-size:1.875rem
  }

  .xl\\:text-4xl{
    font-size:2.25rem
  }

  .xl\\:text-5xl{
    font-size:3rem
  }

  .xl\\:text-6xl{
    font-size:4rem
  }

  .xl\\:leading-3{
    line-height:.75rem
  }

  .xl\\:leading-4{
    line-height:1rem
  }

  .xl\\:leading-5{
    line-height:1.25rem
  }

  .xl\\:leading-6{
    line-height:1.5rem
  }

  .xl\\:leading-7{
    line-height:1.75rem
  }

  .xl\\:leading-8{
    line-height:2rem
  }

  .xl\\:leading-9{
    line-height:2.25rem
  }

  .xl\\:leading-10{
    line-height:2.5rem
  }

  .xl\\:leading-none{
    line-height:1
  }

  .xl\\:leading-tight{
    line-height:1.25
  }

  .xl\\:leading-snug{
    line-height:1.375
  }

  .xl\\:leading-normal{
    line-height:1.5
  }

  .xl\\:leading-relaxed{
    line-height:1.625
  }

  .xl\\:leading-loose{
    line-height:2
  }

  .xl\\:list-inside{
    list-style-position:inside
  }

  .xl\\:list-outside{
    list-style-position:outside
  }

  .xl\\:list-none{
    list-style-type:none
  }

  .xl\\:list-disc{
    list-style-type:disc
  }

  .xl\\:list-decimal{
    list-style-type:decimal
  }

  .xl\\:m-0{
    margin:0
  }

  .xl\\:m-1{
    margin:.25rem
  }

  .xl\\:m-2{
    margin:.5rem
  }

  .xl\\:m-3{
    margin:.75rem
  }

  .xl\\:m-4{
    margin:1rem
  }

  .xl\\:m-5{
    margin:1.25rem
  }

  .xl\\:m-6{
    margin:1.5rem
  }

  .xl\\:m-8{
    margin:2rem
  }

  .xl\\:m-10{
    margin:2.5rem
  }

  .xl\\:m-12{
    margin:3rem
  }

  .xl\\:m-16{
    margin:4rem
  }

  .xl\\:m-20{
    margin:5rem
  }

  .xl\\:m-24{
    margin:6rem
  }

  .xl\\:m-32{
    margin:8rem
  }

  .xl\\:m-40{
    margin:10rem
  }

  .xl\\:m-48{
    margin:12rem
  }

  .xl\\:m-56{
    margin:14rem
  }

  .xl\\:m-64{
    margin:16rem
  }

  .xl\\:m-auto{
    margin:auto
  }

  .xl\\:m-px{
    margin:1px
  }

  .xl\\:-m-1{
    margin:-.25rem
  }

  .xl\\:-m-2{
    margin:-.5rem
  }

  .xl\\:-m-3{
    margin:-.75rem
  }

  .xl\\:-m-4{
    margin:-1rem
  }

  .xl\\:-m-5{
    margin:-1.25rem
  }

  .xl\\:-m-6{
    margin:-1.5rem
  }

  .xl\\:-m-8{
    margin:-2rem
  }

  .xl\\:-m-10{
    margin:-2.5rem
  }

  .xl\\:-m-12{
    margin:-3rem
  }

  .xl\\:-m-16{
    margin:-4rem
  }

  .xl\\:-m-20{
    margin:-5rem
  }

  .xl\\:-m-24{
    margin:-6rem
  }

  .xl\\:-m-32{
    margin:-8rem
  }

  .xl\\:-m-40{
    margin:-10rem
  }

  .xl\\:-m-48{
    margin:-12rem
  }

  .xl\\:-m-56{
    margin:-14rem
  }

  .xl\\:-m-64{
    margin:-16rem
  }

  .xl\\:-m-px{
    margin:-1px
  }

  .xl\\:my-0{
    margin-bottom:0;
    margin-top:0
  }

  .xl\\:mx-0{
    margin-left:0;
    margin-right:0
  }

  .xl\\:my-1{
    margin-bottom:.25rem;
    margin-top:.25rem
  }

  .xl\\:mx-1{
    margin-left:.25rem;
    margin-right:.25rem
  }

  .xl\\:my-2{
    margin-bottom:.5rem;
    margin-top:.5rem
  }

  .xl\\:mx-2{
    margin-left:.5rem;
    margin-right:.5rem
  }

  .xl\\:my-3{
    margin-bottom:.75rem;
    margin-top:.75rem
  }

  .xl\\:mx-3{
    margin-left:.75rem;
    margin-right:.75rem
  }

  .xl\\:my-4{
    margin-bottom:1rem;
    margin-top:1rem
  }

  .xl\\:mx-4{
    margin-left:1rem;
    margin-right:1rem
  }

  .xl\\:my-5{
    margin-bottom:1.25rem;
    margin-top:1.25rem
  }

  .xl\\:mx-5{
    margin-left:1.25rem;
    margin-right:1.25rem
  }

  .xl\\:my-6{
    margin-bottom:1.5rem;
    margin-top:1.5rem
  }

  .xl\\:mx-6{
    margin-left:1.5rem;
    margin-right:1.5rem
  }

  .xl\\:my-8{
    margin-bottom:2rem;
    margin-top:2rem
  }

  .xl\\:mx-8{
    margin-left:2rem;
    margin-right:2rem
  }

  .xl\\:my-10{
    margin-bottom:2.5rem;
    margin-top:2.5rem
  }

  .xl\\:mx-10{
    margin-left:2.5rem;
    margin-right:2.5rem
  }

  .xl\\:my-12{
    margin-bottom:3rem;
    margin-top:3rem
  }

  .xl\\:mx-12{
    margin-left:3rem;
    margin-right:3rem
  }

  .xl\\:my-16{
    margin-bottom:4rem;
    margin-top:4rem
  }

  .xl\\:mx-16{
    margin-left:4rem;
    margin-right:4rem
  }

  .xl\\:my-20{
    margin-bottom:5rem;
    margin-top:5rem
  }

  .xl\\:mx-20{
    margin-left:5rem;
    margin-right:5rem
  }

  .xl\\:my-24{
    margin-bottom:6rem;
    margin-top:6rem
  }

  .xl\\:mx-24{
    margin-left:6rem;
    margin-right:6rem
  }

  .xl\\:my-32{
    margin-bottom:8rem;
    margin-top:8rem
  }

  .xl\\:mx-32{
    margin-left:8rem;
    margin-right:8rem
  }

  .xl\\:my-40{
    margin-bottom:10rem;
    margin-top:10rem
  }

  .xl\\:mx-40{
    margin-left:10rem;
    margin-right:10rem
  }

  .xl\\:my-48{
    margin-bottom:12rem;
    margin-top:12rem
  }

  .xl\\:mx-48{
    margin-left:12rem;
    margin-right:12rem
  }

  .xl\\:my-56{
    margin-bottom:14rem;
    margin-top:14rem
  }

  .xl\\:mx-56{
    margin-left:14rem;
    margin-right:14rem
  }

  .xl\\:my-64{
    margin-bottom:16rem;
    margin-top:16rem
  }

  .xl\\:mx-64{
    margin-left:16rem;
    margin-right:16rem
  }

  .xl\\:my-auto{
    margin-bottom:auto;
    margin-top:auto
  }

  .xl\\:mx-auto{
    margin-left:auto;
    margin-right:auto
  }

  .xl\\:my-px{
    margin-bottom:1px;
    margin-top:1px
  }

  .xl\\:mx-px{
    margin-left:1px;
    margin-right:1px
  }

  .xl\\:-my-1{
    margin-bottom:-.25rem;
    margin-top:-.25rem
  }

  .xl\\:-mx-1{
    margin-left:-.25rem;
    margin-right:-.25rem
  }

  .xl\\:-my-2{
    margin-bottom:-.5rem;
    margin-top:-.5rem
  }

  .xl\\:-mx-2{
    margin-left:-.5rem;
    margin-right:-.5rem
  }

  .xl\\:-my-3{
    margin-bottom:-.75rem;
    margin-top:-.75rem
  }

  .xl\\:-mx-3{
    margin-left:-.75rem;
    margin-right:-.75rem
  }

  .xl\\:-my-4{
    margin-bottom:-1rem;
    margin-top:-1rem
  }

  .xl\\:-mx-4{
    margin-left:-1rem;
    margin-right:-1rem
  }

  .xl\\:-my-5{
    margin-bottom:-1.25rem;
    margin-top:-1.25rem
  }

  .xl\\:-mx-5{
    margin-left:-1.25rem;
    margin-right:-1.25rem
  }

  .xl\\:-my-6{
    margin-bottom:-1.5rem;
    margin-top:-1.5rem
  }

  .xl\\:-mx-6{
    margin-left:-1.5rem;
    margin-right:-1.5rem
  }

  .xl\\:-my-8{
    margin-bottom:-2rem;
    margin-top:-2rem
  }

  .xl\\:-mx-8{
    margin-left:-2rem;
    margin-right:-2rem
  }

  .xl\\:-my-10{
    margin-bottom:-2.5rem;
    margin-top:-2.5rem
  }

  .xl\\:-mx-10{
    margin-left:-2.5rem;
    margin-right:-2.5rem
  }

  .xl\\:-my-12{
    margin-bottom:-3rem;
    margin-top:-3rem
  }

  .xl\\:-mx-12{
    margin-left:-3rem;
    margin-right:-3rem
  }

  .xl\\:-my-16{
    margin-bottom:-4rem;
    margin-top:-4rem
  }

  .xl\\:-mx-16{
    margin-left:-4rem;
    margin-right:-4rem
  }

  .xl\\:-my-20{
    margin-bottom:-5rem;
    margin-top:-5rem
  }

  .xl\\:-mx-20{
    margin-left:-5rem;
    margin-right:-5rem
  }

  .xl\\:-my-24{
    margin-bottom:-6rem;
    margin-top:-6rem
  }

  .xl\\:-mx-24{
    margin-left:-6rem;
    margin-right:-6rem
  }

  .xl\\:-my-32{
    margin-bottom:-8rem;
    margin-top:-8rem
  }

  .xl\\:-mx-32{
    margin-left:-8rem;
    margin-right:-8rem
  }

  .xl\\:-my-40{
    margin-bottom:-10rem;
    margin-top:-10rem
  }

  .xl\\:-mx-40{
    margin-left:-10rem;
    margin-right:-10rem
  }

  .xl\\:-my-48{
    margin-bottom:-12rem;
    margin-top:-12rem
  }

  .xl\\:-mx-48{
    margin-left:-12rem;
    margin-right:-12rem
  }

  .xl\\:-my-56{
    margin-bottom:-14rem;
    margin-top:-14rem
  }

  .xl\\:-mx-56{
    margin-left:-14rem;
    margin-right:-14rem
  }

  .xl\\:-my-64{
    margin-bottom:-16rem;
    margin-top:-16rem
  }

  .xl\\:-mx-64{
    margin-left:-16rem;
    margin-right:-16rem
  }

  .xl\\:-my-px{
    margin-bottom:-1px;
    margin-top:-1px
  }

  .xl\\:-mx-px{
    margin-left:-1px;
    margin-right:-1px
  }

  .xl\\:mt-0{
    margin-top:0
  }

  .xl\\:mr-0{
    margin-right:0
  }

  .xl\\:mb-0{
    margin-bottom:0
  }

  .xl\\:ml-0{
    margin-left:0
  }

  .xl\\:mt-1{
    margin-top:.25rem
  }

  .xl\\:mr-1{
    margin-right:.25rem
  }

  .xl\\:mb-1{
    margin-bottom:.25rem
  }

  .xl\\:ml-1{
    margin-left:.25rem
  }

  .xl\\:mt-2{
    margin-top:.5rem
  }

  .xl\\:mr-2{
    margin-right:.5rem
  }

  .xl\\:mb-2{
    margin-bottom:.5rem
  }

  .xl\\:ml-2{
    margin-left:.5rem
  }

  .xl\\:mt-3{
    margin-top:.75rem
  }

  .xl\\:mr-3{
    margin-right:.75rem
  }

  .xl\\:mb-3{
    margin-bottom:.75rem
  }

  .xl\\:ml-3{
    margin-left:.75rem
  }

  .xl\\:mt-4{
    margin-top:1rem
  }

  .xl\\:mr-4{
    margin-right:1rem
  }

  .xl\\:mb-4{
    margin-bottom:1rem
  }

  .xl\\:ml-4{
    margin-left:1rem
  }

  .xl\\:mt-5{
    margin-top:1.25rem
  }

  .xl\\:mr-5{
    margin-right:1.25rem
  }

  .xl\\:mb-5{
    margin-bottom:1.25rem
  }

  .xl\\:ml-5{
    margin-left:1.25rem
  }

  .xl\\:mt-6{
    margin-top:1.5rem
  }

  .xl\\:mr-6{
    margin-right:1.5rem
  }

  .xl\\:mb-6{
    margin-bottom:1.5rem
  }

  .xl\\:ml-6{
    margin-left:1.5rem
  }

  .xl\\:mt-8{
    margin-top:2rem
  }

  .xl\\:mr-8{
    margin-right:2rem
  }

  .xl\\:mb-8{
    margin-bottom:2rem
  }

  .xl\\:ml-8{
    margin-left:2rem
  }

  .xl\\:mt-10{
    margin-top:2.5rem
  }

  .xl\\:mr-10{
    margin-right:2.5rem
  }

  .xl\\:mb-10{
    margin-bottom:2.5rem
  }

  .xl\\:ml-10{
    margin-left:2.5rem
  }

  .xl\\:mt-12{
    margin-top:3rem
  }

  .xl\\:mr-12{
    margin-right:3rem
  }

  .xl\\:mb-12{
    margin-bottom:3rem
  }

  .xl\\:ml-12{
    margin-left:3rem
  }

  .xl\\:mt-16{
    margin-top:4rem
  }

  .xl\\:mr-16{
    margin-right:4rem
  }

  .xl\\:mb-16{
    margin-bottom:4rem
  }

  .xl\\:ml-16{
    margin-left:4rem
  }

  .xl\\:mt-20{
    margin-top:5rem
  }

  .xl\\:mr-20{
    margin-right:5rem
  }

  .xl\\:mb-20{
    margin-bottom:5rem
  }

  .xl\\:ml-20{
    margin-left:5rem
  }

  .xl\\:mt-24{
    margin-top:6rem
  }

  .xl\\:mr-24{
    margin-right:6rem
  }

  .xl\\:mb-24{
    margin-bottom:6rem
  }

  .xl\\:ml-24{
    margin-left:6rem
  }

  .xl\\:mt-32{
    margin-top:8rem
  }

  .xl\\:mr-32{
    margin-right:8rem
  }

  .xl\\:mb-32{
    margin-bottom:8rem
  }

  .xl\\:ml-32{
    margin-left:8rem
  }

  .xl\\:mt-40{
    margin-top:10rem
  }

  .xl\\:mr-40{
    margin-right:10rem
  }

  .xl\\:mb-40{
    margin-bottom:10rem
  }

  .xl\\:ml-40{
    margin-left:10rem
  }

  .xl\\:mt-48{
    margin-top:12rem
  }

  .xl\\:mr-48{
    margin-right:12rem
  }

  .xl\\:mb-48{
    margin-bottom:12rem
  }

  .xl\\:ml-48{
    margin-left:12rem
  }

  .xl\\:mt-56{
    margin-top:14rem
  }

  .xl\\:mr-56{
    margin-right:14rem
  }

  .xl\\:mb-56{
    margin-bottom:14rem
  }

  .xl\\:ml-56{
    margin-left:14rem
  }

  .xl\\:mt-64{
    margin-top:16rem
  }

  .xl\\:mr-64{
    margin-right:16rem
  }

  .xl\\:mb-64{
    margin-bottom:16rem
  }

  .xl\\:ml-64{
    margin-left:16rem
  }

  .xl\\:mt-auto{
    margin-top:auto
  }

  .xl\\:mr-auto{
    margin-right:auto
  }

  .xl\\:mb-auto{
    margin-bottom:auto
  }

  .xl\\:ml-auto{
    margin-left:auto
  }

  .xl\\:mt-px{
    margin-top:1px
  }

  .xl\\:mr-px{
    margin-right:1px
  }

  .xl\\:mb-px{
    margin-bottom:1px
  }

  .xl\\:ml-px{
    margin-left:1px
  }

  .xl\\:-mt-1{
    margin-top:-.25rem
  }

  .xl\\:-mr-1{
    margin-right:-.25rem
  }

  .xl\\:-mb-1{
    margin-bottom:-.25rem
  }

  .xl\\:-ml-1{
    margin-left:-.25rem
  }

  .xl\\:-mt-2{
    margin-top:-.5rem
  }

  .xl\\:-mr-2{
    margin-right:-.5rem
  }

  .xl\\:-mb-2{
    margin-bottom:-.5rem
  }

  .xl\\:-ml-2{
    margin-left:-.5rem
  }

  .xl\\:-mt-3{
    margin-top:-.75rem
  }

  .xl\\:-mr-3{
    margin-right:-.75rem
  }

  .xl\\:-mb-3{
    margin-bottom:-.75rem
  }

  .xl\\:-ml-3{
    margin-left:-.75rem
  }

  .xl\\:-mt-4{
    margin-top:-1rem
  }

  .xl\\:-mr-4{
    margin-right:-1rem
  }

  .xl\\:-mb-4{
    margin-bottom:-1rem
  }

  .xl\\:-ml-4{
    margin-left:-1rem
  }

  .xl\\:-mt-5{
    margin-top:-1.25rem
  }

  .xl\\:-mr-5{
    margin-right:-1.25rem
  }

  .xl\\:-mb-5{
    margin-bottom:-1.25rem
  }

  .xl\\:-ml-5{
    margin-left:-1.25rem
  }

  .xl\\:-mt-6{
    margin-top:-1.5rem
  }

  .xl\\:-mr-6{
    margin-right:-1.5rem
  }

  .xl\\:-mb-6{
    margin-bottom:-1.5rem
  }

  .xl\\:-ml-6{
    margin-left:-1.5rem
  }

  .xl\\:-mt-8{
    margin-top:-2rem
  }

  .xl\\:-mr-8{
    margin-right:-2rem
  }

  .xl\\:-mb-8{
    margin-bottom:-2rem
  }

  .xl\\:-ml-8{
    margin-left:-2rem
  }

  .xl\\:-mt-10{
    margin-top:-2.5rem
  }

  .xl\\:-mr-10{
    margin-right:-2.5rem
  }

  .xl\\:-mb-10{
    margin-bottom:-2.5rem
  }

  .xl\\:-ml-10{
    margin-left:-2.5rem
  }

  .xl\\:-mt-12{
    margin-top:-3rem
  }

  .xl\\:-mr-12{
    margin-right:-3rem
  }

  .xl\\:-mb-12{
    margin-bottom:-3rem
  }

  .xl\\:-ml-12{
    margin-left:-3rem
  }

  .xl\\:-mt-16{
    margin-top:-4rem
  }

  .xl\\:-mr-16{
    margin-right:-4rem
  }

  .xl\\:-mb-16{
    margin-bottom:-4rem
  }

  .xl\\:-ml-16{
    margin-left:-4rem
  }

  .xl\\:-mt-20{
    margin-top:-5rem
  }

  .xl\\:-mr-20{
    margin-right:-5rem
  }

  .xl\\:-mb-20{
    margin-bottom:-5rem
  }

  .xl\\:-ml-20{
    margin-left:-5rem
  }

  .xl\\:-mt-24{
    margin-top:-6rem
  }

  .xl\\:-mr-24{
    margin-right:-6rem
  }

  .xl\\:-mb-24{
    margin-bottom:-6rem
  }

  .xl\\:-ml-24{
    margin-left:-6rem
  }

  .xl\\:-mt-32{
    margin-top:-8rem
  }

  .xl\\:-mr-32{
    margin-right:-8rem
  }

  .xl\\:-mb-32{
    margin-bottom:-8rem
  }

  .xl\\:-ml-32{
    margin-left:-8rem
  }

  .xl\\:-mt-40{
    margin-top:-10rem
  }

  .xl\\:-mr-40{
    margin-right:-10rem
  }

  .xl\\:-mb-40{
    margin-bottom:-10rem
  }

  .xl\\:-ml-40{
    margin-left:-10rem
  }

  .xl\\:-mt-48{
    margin-top:-12rem
  }

  .xl\\:-mr-48{
    margin-right:-12rem
  }

  .xl\\:-mb-48{
    margin-bottom:-12rem
  }

  .xl\\:-ml-48{
    margin-left:-12rem
  }

  .xl\\:-mt-56{
    margin-top:-14rem
  }

  .xl\\:-mr-56{
    margin-right:-14rem
  }

  .xl\\:-mb-56{
    margin-bottom:-14rem
  }

  .xl\\:-ml-56{
    margin-left:-14rem
  }

  .xl\\:-mt-64{
    margin-top:-16rem
  }

  .xl\\:-mr-64{
    margin-right:-16rem
  }

  .xl\\:-mb-64{
    margin-bottom:-16rem
  }

  .xl\\:-ml-64{
    margin-left:-16rem
  }

  .xl\\:-mt-px{
    margin-top:-1px
  }

  .xl\\:-mr-px{
    margin-right:-1px
  }

  .xl\\:-mb-px{
    margin-bottom:-1px
  }

  .xl\\:-ml-px{
    margin-left:-1px
  }

  .xl\\:last\\:m-0:last-child{
    margin:0
  }

  .xl\\:last\\:m-1:last-child{
    margin:.25rem
  }

  .xl\\:last\\:m-2:last-child{
    margin:.5rem
  }

  .xl\\:last\\:m-3:last-child{
    margin:.75rem
  }

  .xl\\:last\\:m-4:last-child{
    margin:1rem
  }

  .xl\\:last\\:m-5:last-child{
    margin:1.25rem
  }

  .xl\\:last\\:m-6:last-child{
    margin:1.5rem
  }

  .xl\\:last\\:m-8:last-child{
    margin:2rem
  }

  .xl\\:last\\:m-10:last-child{
    margin:2.5rem
  }

  .xl\\:last\\:m-12:last-child{
    margin:3rem
  }

  .xl\\:last\\:m-16:last-child{
    margin:4rem
  }

  .xl\\:last\\:m-20:last-child{
    margin:5rem
  }

  .xl\\:last\\:m-24:last-child{
    margin:6rem
  }

  .xl\\:last\\:m-32:last-child{
    margin:8rem
  }

  .xl\\:last\\:m-40:last-child{
    margin:10rem
  }

  .xl\\:last\\:m-48:last-child{
    margin:12rem
  }

  .xl\\:last\\:m-56:last-child{
    margin:14rem
  }

  .xl\\:last\\:m-64:last-child{
    margin:16rem
  }

  .xl\\:last\\:m-auto:last-child{
    margin:auto
  }

  .xl\\:last\\:m-px:last-child{
    margin:1px
  }

  .xl\\:last\\:-m-1:last-child{
    margin:-.25rem
  }

  .xl\\:last\\:-m-2:last-child{
    margin:-.5rem
  }

  .xl\\:last\\:-m-3:last-child{
    margin:-.75rem
  }

  .xl\\:last\\:-m-4:last-child{
    margin:-1rem
  }

  .xl\\:last\\:-m-5:last-child{
    margin:-1.25rem
  }

  .xl\\:last\\:-m-6:last-child{
    margin:-1.5rem
  }

  .xl\\:last\\:-m-8:last-child{
    margin:-2rem
  }

  .xl\\:last\\:-m-10:last-child{
    margin:-2.5rem
  }

  .xl\\:last\\:-m-12:last-child{
    margin:-3rem
  }

  .xl\\:last\\:-m-16:last-child{
    margin:-4rem
  }

  .xl\\:last\\:-m-20:last-child{
    margin:-5rem
  }

  .xl\\:last\\:-m-24:last-child{
    margin:-6rem
  }

  .xl\\:last\\:-m-32:last-child{
    margin:-8rem
  }

  .xl\\:last\\:-m-40:last-child{
    margin:-10rem
  }

  .xl\\:last\\:-m-48:last-child{
    margin:-12rem
  }

  .xl\\:last\\:-m-56:last-child{
    margin:-14rem
  }

  .xl\\:last\\:-m-64:last-child{
    margin:-16rem
  }

  .xl\\:last\\:-m-px:last-child{
    margin:-1px
  }

  .xl\\:last\\:my-0:last-child{
    margin-bottom:0;
    margin-top:0
  }

  .xl\\:last\\:mx-0:last-child{
    margin-left:0;
    margin-right:0
  }

  .xl\\:last\\:my-1:last-child{
    margin-bottom:.25rem;
    margin-top:.25rem
  }

  .xl\\:last\\:mx-1:last-child{
    margin-left:.25rem;
    margin-right:.25rem
  }

  .xl\\:last\\:my-2:last-child{
    margin-bottom:.5rem;
    margin-top:.5rem
  }

  .xl\\:last\\:mx-2:last-child{
    margin-left:.5rem;
    margin-right:.5rem
  }

  .xl\\:last\\:my-3:last-child{
    margin-bottom:.75rem;
    margin-top:.75rem
  }

  .xl\\:last\\:mx-3:last-child{
    margin-left:.75rem;
    margin-right:.75rem
  }

  .xl\\:last\\:my-4:last-child{
    margin-bottom:1rem;
    margin-top:1rem
  }

  .xl\\:last\\:mx-4:last-child{
    margin-left:1rem;
    margin-right:1rem
  }

  .xl\\:last\\:my-5:last-child{
    margin-bottom:1.25rem;
    margin-top:1.25rem
  }

  .xl\\:last\\:mx-5:last-child{
    margin-left:1.25rem;
    margin-right:1.25rem
  }

  .xl\\:last\\:my-6:last-child{
    margin-bottom:1.5rem;
    margin-top:1.5rem
  }

  .xl\\:last\\:mx-6:last-child{
    margin-left:1.5rem;
    margin-right:1.5rem
  }

  .xl\\:last\\:my-8:last-child{
    margin-bottom:2rem;
    margin-top:2rem
  }

  .xl\\:last\\:mx-8:last-child{
    margin-left:2rem;
    margin-right:2rem
  }

  .xl\\:last\\:my-10:last-child{
    margin-bottom:2.5rem;
    margin-top:2.5rem
  }

  .xl\\:last\\:mx-10:last-child{
    margin-left:2.5rem;
    margin-right:2.5rem
  }

  .xl\\:last\\:my-12:last-child{
    margin-bottom:3rem;
    margin-top:3rem
  }

  .xl\\:last\\:mx-12:last-child{
    margin-left:3rem;
    margin-right:3rem
  }

  .xl\\:last\\:my-16:last-child{
    margin-bottom:4rem;
    margin-top:4rem
  }

  .xl\\:last\\:mx-16:last-child{
    margin-left:4rem;
    margin-right:4rem
  }

  .xl\\:last\\:my-20:last-child{
    margin-bottom:5rem;
    margin-top:5rem
  }

  .xl\\:last\\:mx-20:last-child{
    margin-left:5rem;
    margin-right:5rem
  }

  .xl\\:last\\:my-24:last-child{
    margin-bottom:6rem;
    margin-top:6rem
  }

  .xl\\:last\\:mx-24:last-child{
    margin-left:6rem;
    margin-right:6rem
  }

  .xl\\:last\\:my-32:last-child{
    margin-bottom:8rem;
    margin-top:8rem
  }

  .xl\\:last\\:mx-32:last-child{
    margin-left:8rem;
    margin-right:8rem
  }

  .xl\\:last\\:my-40:last-child{
    margin-bottom:10rem;
    margin-top:10rem
  }

  .xl\\:last\\:mx-40:last-child{
    margin-left:10rem;
    margin-right:10rem
  }

  .xl\\:last\\:my-48:last-child{
    margin-bottom:12rem;
    margin-top:12rem
  }

  .xl\\:last\\:mx-48:last-child{
    margin-left:12rem;
    margin-right:12rem
  }

  .xl\\:last\\:my-56:last-child{
    margin-bottom:14rem;
    margin-top:14rem
  }

  .xl\\:last\\:mx-56:last-child{
    margin-left:14rem;
    margin-right:14rem
  }

  .xl\\:last\\:my-64:last-child{
    margin-bottom:16rem;
    margin-top:16rem
  }

  .xl\\:last\\:mx-64:last-child{
    margin-left:16rem;
    margin-right:16rem
  }

  .xl\\:last\\:my-auto:last-child{
    margin-bottom:auto;
    margin-top:auto
  }

  .xl\\:last\\:mx-auto:last-child{
    margin-left:auto;
    margin-right:auto
  }

  .xl\\:last\\:my-px:last-child{
    margin-bottom:1px;
    margin-top:1px
  }

  .xl\\:last\\:mx-px:last-child{
    margin-left:1px;
    margin-right:1px
  }

  .xl\\:last\\:-my-1:last-child{
    margin-bottom:-.25rem;
    margin-top:-.25rem
  }

  .xl\\:last\\:-mx-1:last-child{
    margin-left:-.25rem;
    margin-right:-.25rem
  }

  .xl\\:last\\:-my-2:last-child{
    margin-bottom:-.5rem;
    margin-top:-.5rem
  }

  .xl\\:last\\:-mx-2:last-child{
    margin-left:-.5rem;
    margin-right:-.5rem
  }

  .xl\\:last\\:-my-3:last-child{
    margin-bottom:-.75rem;
    margin-top:-.75rem
  }

  .xl\\:last\\:-mx-3:last-child{
    margin-left:-.75rem;
    margin-right:-.75rem
  }

  .xl\\:last\\:-my-4:last-child{
    margin-bottom:-1rem;
    margin-top:-1rem
  }

  .xl\\:last\\:-mx-4:last-child{
    margin-left:-1rem;
    margin-right:-1rem
  }

  .xl\\:last\\:-my-5:last-child{
    margin-bottom:-1.25rem;
    margin-top:-1.25rem
  }

  .xl\\:last\\:-mx-5:last-child{
    margin-left:-1.25rem;
    margin-right:-1.25rem
  }

  .xl\\:last\\:-my-6:last-child{
    margin-bottom:-1.5rem;
    margin-top:-1.5rem
  }

  .xl\\:last\\:-mx-6:last-child{
    margin-left:-1.5rem;
    margin-right:-1.5rem
  }

  .xl\\:last\\:-my-8:last-child{
    margin-bottom:-2rem;
    margin-top:-2rem
  }

  .xl\\:last\\:-mx-8:last-child{
    margin-left:-2rem;
    margin-right:-2rem
  }

  .xl\\:last\\:-my-10:last-child{
    margin-bottom:-2.5rem;
    margin-top:-2.5rem
  }

  .xl\\:last\\:-mx-10:last-child{
    margin-left:-2.5rem;
    margin-right:-2.5rem
  }

  .xl\\:last\\:-my-12:last-child{
    margin-bottom:-3rem;
    margin-top:-3rem
  }

  .xl\\:last\\:-mx-12:last-child{
    margin-left:-3rem;
    margin-right:-3rem
  }

  .xl\\:last\\:-my-16:last-child{
    margin-bottom:-4rem;
    margin-top:-4rem
  }

  .xl\\:last\\:-mx-16:last-child{
    margin-left:-4rem;
    margin-right:-4rem
  }

  .xl\\:last\\:-my-20:last-child{
    margin-bottom:-5rem;
    margin-top:-5rem
  }

  .xl\\:last\\:-mx-20:last-child{
    margin-left:-5rem;
    margin-right:-5rem
  }

  .xl\\:last\\:-my-24:last-child{
    margin-bottom:-6rem;
    margin-top:-6rem
  }

  .xl\\:last\\:-mx-24:last-child{
    margin-left:-6rem;
    margin-right:-6rem
  }

  .xl\\:last\\:-my-32:last-child{
    margin-bottom:-8rem;
    margin-top:-8rem
  }

  .xl\\:last\\:-mx-32:last-child{
    margin-left:-8rem;
    margin-right:-8rem
  }

  .xl\\:last\\:-my-40:last-child{
    margin-bottom:-10rem;
    margin-top:-10rem
  }

  .xl\\:last\\:-mx-40:last-child{
    margin-left:-10rem;
    margin-right:-10rem
  }

  .xl\\:last\\:-my-48:last-child{
    margin-bottom:-12rem;
    margin-top:-12rem
  }

  .xl\\:last\\:-mx-48:last-child{
    margin-left:-12rem;
    margin-right:-12rem
  }

  .xl\\:last\\:-my-56:last-child{
    margin-bottom:-14rem;
    margin-top:-14rem
  }

  .xl\\:last\\:-mx-56:last-child{
    margin-left:-14rem;
    margin-right:-14rem
  }

  .xl\\:last\\:-my-64:last-child{
    margin-bottom:-16rem;
    margin-top:-16rem
  }

  .xl\\:last\\:-mx-64:last-child{
    margin-left:-16rem;
    margin-right:-16rem
  }

  .xl\\:last\\:-my-px:last-child{
    margin-bottom:-1px;
    margin-top:-1px
  }

  .xl\\:last\\:-mx-px:last-child{
    margin-left:-1px;
    margin-right:-1px
  }

  .xl\\:last\\:mt-0:last-child{
    margin-top:0
  }

  .xl\\:last\\:mr-0:last-child{
    margin-right:0
  }

  .xl\\:last\\:mb-0:last-child{
    margin-bottom:0
  }

  .xl\\:last\\:ml-0:last-child{
    margin-left:0
  }

  .xl\\:last\\:mt-1:last-child{
    margin-top:.25rem
  }

  .xl\\:last\\:mr-1:last-child{
    margin-right:.25rem
  }

  .xl\\:last\\:mb-1:last-child{
    margin-bottom:.25rem
  }

  .xl\\:last\\:ml-1:last-child{
    margin-left:.25rem
  }

  .xl\\:last\\:mt-2:last-child{
    margin-top:.5rem
  }

  .xl\\:last\\:mr-2:last-child{
    margin-right:.5rem
  }

  .xl\\:last\\:mb-2:last-child{
    margin-bottom:.5rem
  }

  .xl\\:last\\:ml-2:last-child{
    margin-left:.5rem
  }

  .xl\\:last\\:mt-3:last-child{
    margin-top:.75rem
  }

  .xl\\:last\\:mr-3:last-child{
    margin-right:.75rem
  }

  .xl\\:last\\:mb-3:last-child{
    margin-bottom:.75rem
  }

  .xl\\:last\\:ml-3:last-child{
    margin-left:.75rem
  }

  .xl\\:last\\:mt-4:last-child{
    margin-top:1rem
  }

  .xl\\:last\\:mr-4:last-child{
    margin-right:1rem
  }

  .xl\\:last\\:mb-4:last-child{
    margin-bottom:1rem
  }

  .xl\\:last\\:ml-4:last-child{
    margin-left:1rem
  }

  .xl\\:last\\:mt-5:last-child{
    margin-top:1.25rem
  }

  .xl\\:last\\:mr-5:last-child{
    margin-right:1.25rem
  }

  .xl\\:last\\:mb-5:last-child{
    margin-bottom:1.25rem
  }

  .xl\\:last\\:ml-5:last-child{
    margin-left:1.25rem
  }

  .xl\\:last\\:mt-6:last-child{
    margin-top:1.5rem
  }

  .xl\\:last\\:mr-6:last-child{
    margin-right:1.5rem
  }

  .xl\\:last\\:mb-6:last-child{
    margin-bottom:1.5rem
  }

  .xl\\:last\\:ml-6:last-child{
    margin-left:1.5rem
  }

  .xl\\:last\\:mt-8:last-child{
    margin-top:2rem
  }

  .xl\\:last\\:mr-8:last-child{
    margin-right:2rem
  }

  .xl\\:last\\:mb-8:last-child{
    margin-bottom:2rem
  }

  .xl\\:last\\:ml-8:last-child{
    margin-left:2rem
  }

  .xl\\:last\\:mt-10:last-child{
    margin-top:2.5rem
  }

  .xl\\:last\\:mr-10:last-child{
    margin-right:2.5rem
  }

  .xl\\:last\\:mb-10:last-child{
    margin-bottom:2.5rem
  }

  .xl\\:last\\:ml-10:last-child{
    margin-left:2.5rem
  }

  .xl\\:last\\:mt-12:last-child{
    margin-top:3rem
  }

  .xl\\:last\\:mr-12:last-child{
    margin-right:3rem
  }

  .xl\\:last\\:mb-12:last-child{
    margin-bottom:3rem
  }

  .xl\\:last\\:ml-12:last-child{
    margin-left:3rem
  }

  .xl\\:last\\:mt-16:last-child{
    margin-top:4rem
  }

  .xl\\:last\\:mr-16:last-child{
    margin-right:4rem
  }

  .xl\\:last\\:mb-16:last-child{
    margin-bottom:4rem
  }

  .xl\\:last\\:ml-16:last-child{
    margin-left:4rem
  }

  .xl\\:last\\:mt-20:last-child{
    margin-top:5rem
  }

  .xl\\:last\\:mr-20:last-child{
    margin-right:5rem
  }

  .xl\\:last\\:mb-20:last-child{
    margin-bottom:5rem
  }

  .xl\\:last\\:ml-20:last-child{
    margin-left:5rem
  }

  .xl\\:last\\:mt-24:last-child{
    margin-top:6rem
  }

  .xl\\:last\\:mr-24:last-child{
    margin-right:6rem
  }

  .xl\\:last\\:mb-24:last-child{
    margin-bottom:6rem
  }

  .xl\\:last\\:ml-24:last-child{
    margin-left:6rem
  }

  .xl\\:last\\:mt-32:last-child{
    margin-top:8rem
  }

  .xl\\:last\\:mr-32:last-child{
    margin-right:8rem
  }

  .xl\\:last\\:mb-32:last-child{
    margin-bottom:8rem
  }

  .xl\\:last\\:ml-32:last-child{
    margin-left:8rem
  }

  .xl\\:last\\:mt-40:last-child{
    margin-top:10rem
  }

  .xl\\:last\\:mr-40:last-child{
    margin-right:10rem
  }

  .xl\\:last\\:mb-40:last-child{
    margin-bottom:10rem
  }

  .xl\\:last\\:ml-40:last-child{
    margin-left:10rem
  }

  .xl\\:last\\:mt-48:last-child{
    margin-top:12rem
  }

  .xl\\:last\\:mr-48:last-child{
    margin-right:12rem
  }

  .xl\\:last\\:mb-48:last-child{
    margin-bottom:12rem
  }

  .xl\\:last\\:ml-48:last-child{
    margin-left:12rem
  }

  .xl\\:last\\:mt-56:last-child{
    margin-top:14rem
  }

  .xl\\:last\\:mr-56:last-child{
    margin-right:14rem
  }

  .xl\\:last\\:mb-56:last-child{
    margin-bottom:14rem
  }

  .xl\\:last\\:ml-56:last-child{
    margin-left:14rem
  }

  .xl\\:last\\:mt-64:last-child{
    margin-top:16rem
  }

  .xl\\:last\\:mr-64:last-child{
    margin-right:16rem
  }

  .xl\\:last\\:mb-64:last-child{
    margin-bottom:16rem
  }

  .xl\\:last\\:ml-64:last-child{
    margin-left:16rem
  }

  .xl\\:last\\:mt-auto:last-child{
    margin-top:auto
  }

  .xl\\:last\\:mr-auto:last-child{
    margin-right:auto
  }

  .xl\\:last\\:mb-auto:last-child{
    margin-bottom:auto
  }

  .xl\\:last\\:ml-auto:last-child{
    margin-left:auto
  }

  .xl\\:last\\:mt-px:last-child{
    margin-top:1px
  }

  .xl\\:last\\:mr-px:last-child{
    margin-right:1px
  }

  .xl\\:last\\:mb-px:last-child{
    margin-bottom:1px
  }

  .xl\\:last\\:ml-px:last-child{
    margin-left:1px
  }

  .xl\\:last\\:-mt-1:last-child{
    margin-top:-.25rem
  }

  .xl\\:last\\:-mr-1:last-child{
    margin-right:-.25rem
  }

  .xl\\:last\\:-mb-1:last-child{
    margin-bottom:-.25rem
  }

  .xl\\:last\\:-ml-1:last-child{
    margin-left:-.25rem
  }

  .xl\\:last\\:-mt-2:last-child{
    margin-top:-.5rem
  }

  .xl\\:last\\:-mr-2:last-child{
    margin-right:-.5rem
  }

  .xl\\:last\\:-mb-2:last-child{
    margin-bottom:-.5rem
  }

  .xl\\:last\\:-ml-2:last-child{
    margin-left:-.5rem
  }

  .xl\\:last\\:-mt-3:last-child{
    margin-top:-.75rem
  }

  .xl\\:last\\:-mr-3:last-child{
    margin-right:-.75rem
  }

  .xl\\:last\\:-mb-3:last-child{
    margin-bottom:-.75rem
  }

  .xl\\:last\\:-ml-3:last-child{
    margin-left:-.75rem
  }

  .xl\\:last\\:-mt-4:last-child{
    margin-top:-1rem
  }

  .xl\\:last\\:-mr-4:last-child{
    margin-right:-1rem
  }

  .xl\\:last\\:-mb-4:last-child{
    margin-bottom:-1rem
  }

  .xl\\:last\\:-ml-4:last-child{
    margin-left:-1rem
  }

  .xl\\:last\\:-mt-5:last-child{
    margin-top:-1.25rem
  }

  .xl\\:last\\:-mr-5:last-child{
    margin-right:-1.25rem
  }

  .xl\\:last\\:-mb-5:last-child{
    margin-bottom:-1.25rem
  }

  .xl\\:last\\:-ml-5:last-child{
    margin-left:-1.25rem
  }

  .xl\\:last\\:-mt-6:last-child{
    margin-top:-1.5rem
  }

  .xl\\:last\\:-mr-6:last-child{
    margin-right:-1.5rem
  }

  .xl\\:last\\:-mb-6:last-child{
    margin-bottom:-1.5rem
  }

  .xl\\:last\\:-ml-6:last-child{
    margin-left:-1.5rem
  }

  .xl\\:last\\:-mt-8:last-child{
    margin-top:-2rem
  }

  .xl\\:last\\:-mr-8:last-child{
    margin-right:-2rem
  }

  .xl\\:last\\:-mb-8:last-child{
    margin-bottom:-2rem
  }

  .xl\\:last\\:-ml-8:last-child{
    margin-left:-2rem
  }

  .xl\\:last\\:-mt-10:last-child{
    margin-top:-2.5rem
  }

  .xl\\:last\\:-mr-10:last-child{
    margin-right:-2.5rem
  }

  .xl\\:last\\:-mb-10:last-child{
    margin-bottom:-2.5rem
  }

  .xl\\:last\\:-ml-10:last-child{
    margin-left:-2.5rem
  }

  .xl\\:last\\:-mt-12:last-child{
    margin-top:-3rem
  }

  .xl\\:last\\:-mr-12:last-child{
    margin-right:-3rem
  }

  .xl\\:last\\:-mb-12:last-child{
    margin-bottom:-3rem
  }

  .xl\\:last\\:-ml-12:last-child{
    margin-left:-3rem
  }

  .xl\\:last\\:-mt-16:last-child{
    margin-top:-4rem
  }

  .xl\\:last\\:-mr-16:last-child{
    margin-right:-4rem
  }

  .xl\\:last\\:-mb-16:last-child{
    margin-bottom:-4rem
  }

  .xl\\:last\\:-ml-16:last-child{
    margin-left:-4rem
  }

  .xl\\:last\\:-mt-20:last-child{
    margin-top:-5rem
  }

  .xl\\:last\\:-mr-20:last-child{
    margin-right:-5rem
  }

  .xl\\:last\\:-mb-20:last-child{
    margin-bottom:-5rem
  }

  .xl\\:last\\:-ml-20:last-child{
    margin-left:-5rem
  }

  .xl\\:last\\:-mt-24:last-child{
    margin-top:-6rem
  }

  .xl\\:last\\:-mr-24:last-child{
    margin-right:-6rem
  }

  .xl\\:last\\:-mb-24:last-child{
    margin-bottom:-6rem
  }

  .xl\\:last\\:-ml-24:last-child{
    margin-left:-6rem
  }

  .xl\\:last\\:-mt-32:last-child{
    margin-top:-8rem
  }

  .xl\\:last\\:-mr-32:last-child{
    margin-right:-8rem
  }

  .xl\\:last\\:-mb-32:last-child{
    margin-bottom:-8rem
  }

  .xl\\:last\\:-ml-32:last-child{
    margin-left:-8rem
  }

  .xl\\:last\\:-mt-40:last-child{
    margin-top:-10rem
  }

  .xl\\:last\\:-mr-40:last-child{
    margin-right:-10rem
  }

  .xl\\:last\\:-mb-40:last-child{
    margin-bottom:-10rem
  }

  .xl\\:last\\:-ml-40:last-child{
    margin-left:-10rem
  }

  .xl\\:last\\:-mt-48:last-child{
    margin-top:-12rem
  }

  .xl\\:last\\:-mr-48:last-child{
    margin-right:-12rem
  }

  .xl\\:last\\:-mb-48:last-child{
    margin-bottom:-12rem
  }

  .xl\\:last\\:-ml-48:last-child{
    margin-left:-12rem
  }

  .xl\\:last\\:-mt-56:last-child{
    margin-top:-14rem
  }

  .xl\\:last\\:-mr-56:last-child{
    margin-right:-14rem
  }

  .xl\\:last\\:-mb-56:last-child{
    margin-bottom:-14rem
  }

  .xl\\:last\\:-ml-56:last-child{
    margin-left:-14rem
  }

  .xl\\:last\\:-mt-64:last-child{
    margin-top:-16rem
  }

  .xl\\:last\\:-mr-64:last-child{
    margin-right:-16rem
  }

  .xl\\:last\\:-mb-64:last-child{
    margin-bottom:-16rem
  }

  .xl\\:last\\:-ml-64:last-child{
    margin-left:-16rem
  }

  .xl\\:last\\:-mt-px:last-child{
    margin-top:-1px
  }

  .xl\\:last\\:-mr-px:last-child{
    margin-right:-1px
  }

  .xl\\:last\\:-mb-px:last-child{
    margin-bottom:-1px
  }

  .xl\\:last\\:-ml-px:last-child{
    margin-left:-1px
  }

  .xl\\:max-h-0{
    max-height:0
  }

  .xl\\:max-h-1{
    max-height:.25rem
  }

  .xl\\:max-h-2{
    max-height:.5rem
  }

  .xl\\:max-h-3{
    max-height:.75rem
  }

  .xl\\:max-h-4{
    max-height:1rem
  }

  .xl\\:max-h-5{
    max-height:1.25rem
  }

  .xl\\:max-h-6{
    max-height:1.5rem
  }

  .xl\\:max-h-8{
    max-height:2rem
  }

  .xl\\:max-h-10{
    max-height:2.5rem
  }

  .xl\\:max-h-12{
    max-height:3rem
  }

  .xl\\:max-h-16{
    max-height:4rem
  }

  .xl\\:max-h-20{
    max-height:5rem
  }

  .xl\\:max-h-24{
    max-height:6rem
  }

  .xl\\:max-h-32{
    max-height:8rem
  }

  .xl\\:max-h-40{
    max-height:10rem
  }

  .xl\\:max-h-48{
    max-height:12rem
  }

  .xl\\:max-h-56{
    max-height:14rem
  }

  .xl\\:max-h-64{
    max-height:16rem
  }

  .xl\\:max-h-xl{
    max-height:36rem
  }

  .xl\\:max-h-px{
    max-height:1px
  }

  .xl\\:max-w-none{
    max-width:none
  }

  .xl\\:max-w-xs{
    max-width:20rem
  }

  .xl\\:max-w-sm{
    max-width:24rem
  }

  .xl\\:max-w-md{
    max-width:28rem
  }

  .xl\\:max-w-lg{
    max-width:32rem
  }

  .xl\\:max-w-xl{
    max-width:36rem
  }

  .xl\\:max-w-2xl{
    max-width:42rem
  }

  .xl\\:max-w-3xl{
    max-width:48rem
  }

  .xl\\:max-w-4xl{
    max-width:56rem
  }

  .xl\\:max-w-5xl{
    max-width:64rem
  }

  .xl\\:max-w-6xl{
    max-width:72rem
  }

  .xl\\:max-w-full{
    max-width:100%
  }

  .xl\\:max-w-screen-sm{
    max-width:640px
  }

  .xl\\:max-w-screen-md{
    max-width:768px
  }

  .xl\\:max-w-screen-lg{
    max-width:1024px
  }

  .xl\\:max-w-screen-xl{
    max-width:1280px
  }

  .xl\\:min-h-0{
    min-height:0
  }

  .xl\\:min-h-full{
    min-height:100%
  }

  .xl\\:min-h-screen{
    min-height:100vh
  }

  .xl\\:min-w-0{
    min-width:0
  }

  .xl\\:min-w-1{
    min-width:.25rem
  }

  .xl\\:min-w-2{
    min-width:.5rem
  }

  .xl\\:min-w-3{
    min-width:.75rem
  }

  .xl\\:min-w-4{
    min-width:1rem
  }

  .xl\\:min-w-5{
    min-width:1.25rem
  }

  .xl\\:min-w-6{
    min-width:1.5rem
  }

  .xl\\:min-w-8{
    min-width:2rem
  }

  .xl\\:min-w-10{
    min-width:2.5rem
  }

  .xl\\:min-w-12{
    min-width:3rem
  }

  .xl\\:min-w-16{
    min-width:4rem
  }

  .xl\\:min-w-20{
    min-width:5rem
  }

  .xl\\:min-w-24{
    min-width:6rem
  }

  .xl\\:min-w-32{
    min-width:8rem
  }

  .xl\\:min-w-40{
    min-width:10rem
  }

  .xl\\:min-w-48{
    min-width:12rem
  }

  .xl\\:min-w-56{
    min-width:14rem
  }

  .xl\\:min-w-64{
    min-width:16rem
  }

  .xl\\:min-w-max-content{
    min-width:max-content
  }

  .xl\\:min-w-px{
    min-width:1px
  }

  .xl\\:object-contain{
    object-fit:contain
  }

  .xl\\:object-cover{
    object-fit:cover
  }

  .xl\\:object-fill{
    object-fit:fill
  }

  .xl\\:object-none{
    object-fit:none
  }

  .xl\\:object-scale-down{
    object-fit:scale-down
  }

  .xl\\:object-bottom{
    object-position:bottom
  }

  .xl\\:object-center{
    object-position:center
  }

  .xl\\:object-left{
    object-position:left
  }

  .xl\\:object-left-bottom{
    object-position:left bottom
  }

  .xl\\:object-left-top{
    object-position:left top
  }

  .xl\\:object-right{
    object-position:right
  }

  .xl\\:object-right-bottom{
    object-position:right bottom
  }

  .xl\\:object-right-top{
    object-position:right top
  }

  .xl\\:object-top{
    object-position:top
  }

  .xl\\:opacity-0{
    opacity:0
  }

  .xl\\:opacity-25{
    opacity:.25
  }

  .xl\\:opacity-50{
    opacity:.5
  }

  .xl\\:opacity-75{
    opacity:.75
  }

  .xl\\:opacity-100{
    opacity:1
  }

  .xl\\:hover\\:opacity-0:hover{
    opacity:0
  }

  .xl\\:hover\\:opacity-25:hover{
    opacity:.25
  }

  .xl\\:hover\\:opacity-50:hover{
    opacity:.5
  }

  .xl\\:hover\\:opacity-75:hover{
    opacity:.75
  }

  .xl\\:hover\\:opacity-100:hover{
    opacity:1
  }

  .xl\\:focus\\:opacity-0:focus{
    opacity:0
  }

  .xl\\:focus\\:opacity-25:focus{
    opacity:.25
  }

  .xl\\:focus\\:opacity-50:focus{
    opacity:.5
  }

  .xl\\:focus\\:opacity-75:focus{
    opacity:.75
  }

  .xl\\:focus\\:opacity-100:focus{
    opacity:1
  }

  .xl\\:focus\\:outline-none:focus,.xl\\:outline-none{
    outline:0
  }

  .xl\\:overflow-auto{
    overflow:auto
  }

  .xl\\:overflow-hidden{
    overflow:hidden
  }

  .xl\\:overflow-visible{
    overflow:visible
  }

  .xl\\:overflow-scroll{
    overflow:scroll
  }

  .xl\\:overflow-x-auto{
    overflow-x:auto
  }

  .xl\\:overflow-y-auto{
    overflow-y:auto
  }

  .xl\\:overflow-x-hidden{
    overflow-x:hidden
  }

  .xl\\:overflow-y-hidden{
    overflow-y:hidden
  }

  .xl\\:overflow-x-visible{
    overflow-x:visible
  }

  .xl\\:overflow-y-visible{
    overflow-y:visible
  }

  .xl\\:overflow-x-scroll{
    overflow-x:scroll
  }

  .xl\\:overflow-y-scroll{
    overflow-y:scroll
  }

  .xl\\:scrolling-touch{
    -webkit-overflow-scrolling:touch
  }

  .xl\\:scrolling-auto{
    -webkit-overflow-scrolling:auto
  }

  .xl\\:p-0{
    padding:0
  }

  .xl\\:p-1{
    padding:.25rem
  }

  .xl\\:p-2{
    padding:.5rem
  }

  .xl\\:p-3{
    padding:.75rem
  }

  .xl\\:p-4{
    padding:1rem
  }

  .xl\\:p-5{
    padding:1.25rem
  }

  .xl\\:p-6{
    padding:1.5rem
  }

  .xl\\:p-8{
    padding:2rem
  }

  .xl\\:p-10{
    padding:2.5rem
  }

  .xl\\:p-12{
    padding:3rem
  }

  .xl\\:p-16{
    padding:4rem
  }

  .xl\\:p-20{
    padding:5rem
  }

  .xl\\:p-24{
    padding:6rem
  }

  .xl\\:p-32{
    padding:8rem
  }

  .xl\\:p-40{
    padding:10rem
  }

  .xl\\:p-48{
    padding:12rem
  }

  .xl\\:p-56{
    padding:14rem
  }

  .xl\\:p-64{
    padding:16rem
  }

  .xl\\:p-px{
    padding:1px
  }

  .xl\\:py-0{
    padding-bottom:0;
    padding-top:0
  }

  .xl\\:px-0{
    padding-left:0;
    padding-right:0
  }

  .xl\\:py-1{
    padding-bottom:.25rem;
    padding-top:.25rem
  }

  .xl\\:px-1{
    padding-left:.25rem;
    padding-right:.25rem
  }

  .xl\\:py-2{
    padding-bottom:.5rem;
    padding-top:.5rem
  }

  .xl\\:px-2{
    padding-left:.5rem;
    padding-right:.5rem
  }

  .xl\\:py-3{
    padding-bottom:.75rem;
    padding-top:.75rem
  }

  .xl\\:px-3{
    padding-left:.75rem;
    padding-right:.75rem
  }

  .xl\\:py-4{
    padding-bottom:1rem;
    padding-top:1rem
  }

  .xl\\:px-4{
    padding-left:1rem;
    padding-right:1rem
  }

  .xl\\:py-5{
    padding-bottom:1.25rem;
    padding-top:1.25rem
  }

  .xl\\:px-5{
    padding-left:1.25rem;
    padding-right:1.25rem
  }

  .xl\\:py-6{
    padding-bottom:1.5rem;
    padding-top:1.5rem
  }

  .xl\\:px-6{
    padding-left:1.5rem;
    padding-right:1.5rem
  }

  .xl\\:py-8{
    padding-bottom:2rem;
    padding-top:2rem
  }

  .xl\\:px-8{
    padding-left:2rem;
    padding-right:2rem
  }

  .xl\\:py-10{
    padding-bottom:2.5rem;
    padding-top:2.5rem
  }

  .xl\\:px-10{
    padding-left:2.5rem;
    padding-right:2.5rem
  }

  .xl\\:py-12{
    padding-bottom:3rem;
    padding-top:3rem
  }

  .xl\\:px-12{
    padding-left:3rem;
    padding-right:3rem
  }

  .xl\\:py-16{
    padding-bottom:4rem;
    padding-top:4rem
  }

  .xl\\:px-16{
    padding-left:4rem;
    padding-right:4rem
  }

  .xl\\:py-20{
    padding-bottom:5rem;
    padding-top:5rem
  }

  .xl\\:px-20{
    padding-left:5rem;
    padding-right:5rem
  }

  .xl\\:py-24{
    padding-bottom:6rem;
    padding-top:6rem
  }

  .xl\\:px-24{
    padding-left:6rem;
    padding-right:6rem
  }

  .xl\\:py-32{
    padding-bottom:8rem;
    padding-top:8rem
  }

  .xl\\:px-32{
    padding-left:8rem;
    padding-right:8rem
  }

  .xl\\:py-40{
    padding-bottom:10rem;
    padding-top:10rem
  }

  .xl\\:px-40{
    padding-left:10rem;
    padding-right:10rem
  }

  .xl\\:py-48{
    padding-bottom:12rem;
    padding-top:12rem
  }

  .xl\\:px-48{
    padding-left:12rem;
    padding-right:12rem
  }

  .xl\\:py-56{
    padding-bottom:14rem;
    padding-top:14rem
  }

  .xl\\:px-56{
    padding-left:14rem;
    padding-right:14rem
  }

  .xl\\:py-64{
    padding-bottom:16rem;
    padding-top:16rem
  }

  .xl\\:px-64{
    padding-left:16rem;
    padding-right:16rem
  }

  .xl\\:py-px{
    padding-bottom:1px;
    padding-top:1px
  }

  .xl\\:px-px{
    padding-left:1px;
    padding-right:1px
  }

  .xl\\:pt-0{
    padding-top:0
  }

  .xl\\:pr-0{
    padding-right:0
  }

  .xl\\:pb-0{
    padding-bottom:0
  }

  .xl\\:pl-0{
    padding-left:0
  }

  .xl\\:pt-1{
    padding-top:.25rem
  }

  .xl\\:pr-1{
    padding-right:.25rem
  }

  .xl\\:pb-1{
    padding-bottom:.25rem
  }

  .xl\\:pl-1{
    padding-left:.25rem
  }

  .xl\\:pt-2{
    padding-top:.5rem
  }

  .xl\\:pr-2{
    padding-right:.5rem
  }

  .xl\\:pb-2{
    padding-bottom:.5rem
  }

  .xl\\:pl-2{
    padding-left:.5rem
  }

  .xl\\:pt-3{
    padding-top:.75rem
  }

  .xl\\:pr-3{
    padding-right:.75rem
  }

  .xl\\:pb-3{
    padding-bottom:.75rem
  }

  .xl\\:pl-3{
    padding-left:.75rem
  }

  .xl\\:pt-4{
    padding-top:1rem
  }

  .xl\\:pr-4{
    padding-right:1rem
  }

  .xl\\:pb-4{
    padding-bottom:1rem
  }

  .xl\\:pl-4{
    padding-left:1rem
  }

  .xl\\:pt-5{
    padding-top:1.25rem
  }

  .xl\\:pr-5{
    padding-right:1.25rem
  }

  .xl\\:pb-5{
    padding-bottom:1.25rem
  }

  .xl\\:pl-5{
    padding-left:1.25rem
  }

  .xl\\:pt-6{
    padding-top:1.5rem
  }

  .xl\\:pr-6{
    padding-right:1.5rem
  }

  .xl\\:pb-6{
    padding-bottom:1.5rem
  }

  .xl\\:pl-6{
    padding-left:1.5rem
  }

  .xl\\:pt-8{
    padding-top:2rem
  }

  .xl\\:pr-8{
    padding-right:2rem
  }

  .xl\\:pb-8{
    padding-bottom:2rem
  }

  .xl\\:pl-8{
    padding-left:2rem
  }

  .xl\\:pt-10{
    padding-top:2.5rem
  }

  .xl\\:pr-10{
    padding-right:2.5rem
  }

  .xl\\:pb-10{
    padding-bottom:2.5rem
  }

  .xl\\:pl-10{
    padding-left:2.5rem
  }

  .xl\\:pt-12{
    padding-top:3rem
  }

  .xl\\:pr-12{
    padding-right:3rem
  }

  .xl\\:pb-12{
    padding-bottom:3rem
  }

  .xl\\:pl-12{
    padding-left:3rem
  }

  .xl\\:pt-16{
    padding-top:4rem
  }

  .xl\\:pr-16{
    padding-right:4rem
  }

  .xl\\:pb-16{
    padding-bottom:4rem
  }

  .xl\\:pl-16{
    padding-left:4rem
  }

  .xl\\:pt-20{
    padding-top:5rem
  }

  .xl\\:pr-20{
    padding-right:5rem
  }

  .xl\\:pb-20{
    padding-bottom:5rem
  }

  .xl\\:pl-20{
    padding-left:5rem
  }

  .xl\\:pt-24{
    padding-top:6rem
  }

  .xl\\:pr-24{
    padding-right:6rem
  }

  .xl\\:pb-24{
    padding-bottom:6rem
  }

  .xl\\:pl-24{
    padding-left:6rem
  }

  .xl\\:pt-32{
    padding-top:8rem
  }

  .xl\\:pr-32{
    padding-right:8rem
  }

  .xl\\:pb-32{
    padding-bottom:8rem
  }

  .xl\\:pl-32{
    padding-left:8rem
  }

  .xl\\:pt-40{
    padding-top:10rem
  }

  .xl\\:pr-40{
    padding-right:10rem
  }

  .xl\\:pb-40{
    padding-bottom:10rem
  }

  .xl\\:pl-40{
    padding-left:10rem
  }

  .xl\\:pt-48{
    padding-top:12rem
  }

  .xl\\:pr-48{
    padding-right:12rem
  }

  .xl\\:pb-48{
    padding-bottom:12rem
  }

  .xl\\:pl-48{
    padding-left:12rem
  }

  .xl\\:pt-56{
    padding-top:14rem
  }

  .xl\\:pr-56{
    padding-right:14rem
  }

  .xl\\:pb-56{
    padding-bottom:14rem
  }

  .xl\\:pl-56{
    padding-left:14rem
  }

  .xl\\:pt-64{
    padding-top:16rem
  }

  .xl\\:pr-64{
    padding-right:16rem
  }

  .xl\\:pb-64{
    padding-bottom:16rem
  }

  .xl\\:pl-64{
    padding-left:16rem
  }

  .xl\\:pt-px{
    padding-top:1px
  }

  .xl\\:pr-px{
    padding-right:1px
  }

  .xl\\:pb-px{
    padding-bottom:1px
  }

  .xl\\:pl-px{
    padding-left:1px
  }

  .xl\\:placeholder-transparent::placeholder{
    color:#0000
  }

  .xl\\:placeholder-white::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .xl\\:placeholder-black::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .xl\\:placeholder-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .xl\\:placeholder-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .xl\\:placeholder-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .xl\\:placeholder-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .xl\\:placeholder-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .xl\\:placeholder-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .xl\\:placeholder-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .xl\\:placeholder-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .xl\\:placeholder-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .xl\\:placeholder-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .xl\\:placeholder-cool-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .xl\\:placeholder-cool-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .xl\\:placeholder-cool-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .xl\\:placeholder-cool-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .xl\\:placeholder-cool-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .xl\\:placeholder-cool-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .xl\\:placeholder-cool-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .xl\\:placeholder-cool-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .xl\\:placeholder-cool-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .xl\\:placeholder-cool-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .xl\\:placeholder-red-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .xl\\:placeholder-red-100::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .xl\\:placeholder-red-200::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .xl\\:placeholder-red-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .xl\\:placeholder-red-400::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .xl\\:placeholder-red-500::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .xl\\:placeholder-red-600::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .xl\\:placeholder-red-700::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .xl\\:placeholder-red-800::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .xl\\:placeholder-red-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .xl\\:placeholder-orange-50::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .xl\\:placeholder-orange-100::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .xl\\:placeholder-orange-200::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .xl\\:placeholder-orange-300::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .xl\\:placeholder-orange-400::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .xl\\:placeholder-orange-500::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .xl\\:placeholder-orange-600::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .xl\\:placeholder-orange-700::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .xl\\:placeholder-orange-800::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .xl\\:placeholder-orange-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .xl\\:placeholder-yellow-50::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .xl\\:placeholder-yellow-100::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .xl\\:placeholder-yellow-200::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .xl\\:placeholder-yellow-300::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .xl\\:placeholder-yellow-400::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .xl\\:placeholder-yellow-500::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .xl\\:placeholder-yellow-600::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .xl\\:placeholder-yellow-700::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .xl\\:placeholder-yellow-800::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .xl\\:placeholder-yellow-900::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .xl\\:placeholder-green-50::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .xl\\:placeholder-green-100::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .xl\\:placeholder-green-200::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .xl\\:placeholder-green-300::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .xl\\:placeholder-green-400::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .xl\\:placeholder-green-500::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .xl\\:placeholder-green-600::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .xl\\:placeholder-green-700::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .xl\\:placeholder-green-800::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .xl\\:placeholder-green-900::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .xl\\:placeholder-teal-50::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .xl\\:placeholder-teal-100::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .xl\\:placeholder-teal-200::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .xl\\:placeholder-teal-300::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .xl\\:placeholder-teal-400::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .xl\\:placeholder-teal-500::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .xl\\:placeholder-teal-600::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .xl\\:placeholder-teal-700::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .xl\\:placeholder-teal-800::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .xl\\:placeholder-teal-900::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .xl\\:placeholder-blue-50::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .xl\\:placeholder-blue-100::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .xl\\:placeholder-blue-200::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .xl\\:placeholder-blue-300::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .xl\\:placeholder-blue-400::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .xl\\:placeholder-blue-500::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .xl\\:placeholder-blue-600::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .xl\\:placeholder-blue-700::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .xl\\:placeholder-blue-800::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .xl\\:placeholder-blue-900::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .xl\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .xl\\:placeholder-pink-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .xl\\:placeholder-pink-100::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .xl\\:placeholder-pink-200::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .xl\\:placeholder-pink-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .xl\\:placeholder-pink-400::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .xl\\:placeholder-pink-500::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .xl\\:placeholder-pink-600::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .xl\\:placeholder-pink-700::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .xl\\:placeholder-pink-800::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .xl\\:placeholder-pink-900::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-transparent:focus::placeholder{
    color:#0000
  }

  .xl\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-cool-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-cool-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-cool-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-cool-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-cool-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-cool-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-cool-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-cool-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-cool-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-cool-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-red-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-red-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-red-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-red-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-red-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-red-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-red-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-red-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-red-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-red-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-orange-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-orange-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-orange-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-orange-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-orange-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-orange-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-orange-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-orange-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-orange-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-orange-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-yellow-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-yellow-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-yellow-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-yellow-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-yellow-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-yellow-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-yellow-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-yellow-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-yellow-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-yellow-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-green-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-green-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-green-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-green-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-green-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-green-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-green-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-green-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-green-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-green-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-teal-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-teal-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-teal-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-teal-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-teal-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-teal-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-teal-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-teal-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-teal-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-teal-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-blue-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-blue-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-blue-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-blue-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-blue-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-blue-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-blue-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-blue-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-blue-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-blue-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-pink-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-pink-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-pink-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-pink-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-pink-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-pink-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-pink-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-pink-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-pink-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .xl\\:focus\\:placeholder-pink-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-transparent::placeholder{
    color:#0000
  }

  .theme-dark .xl\\:dark\\:placeholder-white::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-black::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-cool-gray-50::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-cool-gray-100::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-cool-gray-200::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-cool-gray-300::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-cool-gray-400::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-cool-gray-500::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-cool-gray-600::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-cool-gray-700::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-cool-gray-800::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-cool-gray-900::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-red-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-red-100::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-red-200::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-red-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-red-400::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-red-500::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-red-600::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-red-700::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-red-800::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-red-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-orange-50::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-orange-100::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-orange-200::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-orange-300::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-orange-400::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-orange-500::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-orange-600::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-orange-700::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-orange-800::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-orange-900::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-yellow-50::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-yellow-100::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-yellow-200::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-yellow-300::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-yellow-400::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-yellow-500::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-yellow-600::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-yellow-700::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-yellow-800::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-yellow-900::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-green-50::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-green-100::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-green-200::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-green-300::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-green-400::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-green-500::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-green-600::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-green-700::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-green-800::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-green-900::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-teal-50::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-teal-100::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-teal-200::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-teal-300::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-teal-400::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-teal-500::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-teal-600::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-teal-700::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-teal-800::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-teal-900::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-blue-50::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-blue-100::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-blue-200::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-blue-300::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-blue-400::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-blue-500::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-blue-600::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-blue-700::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-blue-800::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-blue-900::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-50::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-100::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-200::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-300::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-400::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-500::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-600::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-700::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-800::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-indigo-900::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-pink-50::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-pink-100::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-pink-200::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-pink-300::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-pink-400::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-pink-500::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-pink-600::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-pink-700::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-pink-800::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:placeholder-pink-900::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-transparent:focus::placeholder{
    color:#0000
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-red-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-red-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-red-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-red-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-red-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-red-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-red-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-red-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-red-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-red-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-orange-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-orange-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-orange-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-orange-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-orange-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-orange-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-orange-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-orange-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-orange-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-orange-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-green-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-green-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-green-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-green-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-green-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-green-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-green-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-green-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-green-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-green-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-teal-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-teal-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-teal-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-teal-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-teal-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-teal-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-teal-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-teal-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-teal-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-teal-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-blue-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-blue-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-blue-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-blue-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-blue-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-blue-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-blue-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-blue-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-blue-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-blue-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-pink-50:focus::placeholder{
    --placeholder-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-pink-100:focus::placeholder{
    --placeholder-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-pink-200:focus::placeholder{
    --placeholder-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-pink-300:focus::placeholder{
    --placeholder-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-pink-400:focus::placeholder{
    --placeholder-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-pink-500:focus::placeholder{
    --placeholder-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-pink-600:focus::placeholder{
    --placeholder-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-pink-700:focus::placeholder{
    --placeholder-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-pink-800:focus::placeholder{
    --placeholder-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--placeholder-opacity))
  }

  .theme-dark .xl\\:dark\\:focus\\:placeholder-pink-900:focus::placeholder{
    --placeholder-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--placeholder-opacity))
  }

  .xl\\:placeholder-opacity-0::placeholder{
    --placeholder-opacity:0
  }

  .xl\\:placeholder-opacity-25::placeholder{
    --placeholder-opacity:0.25
  }

  .xl\\:placeholder-opacity-50::placeholder{
    --placeholder-opacity:0.5
  }

  .xl\\:placeholder-opacity-75::placeholder{
    --placeholder-opacity:0.75
  }

  .xl\\:placeholder-opacity-100::placeholder{
    --placeholder-opacity:1
  }

  .xl\\:focus\\:placeholder-opacity-0:focus::placeholder{
    --placeholder-opacity:0
  }

  .xl\\:focus\\:placeholder-opacity-25:focus::placeholder{
    --placeholder-opacity:0.25
  }

  .xl\\:focus\\:placeholder-opacity-50:focus::placeholder{
    --placeholder-opacity:0.5
  }

  .xl\\:focus\\:placeholder-opacity-75:focus::placeholder{
    --placeholder-opacity:0.75
  }

  .xl\\:focus\\:placeholder-opacity-100:focus::placeholder{
    --placeholder-opacity:1
  }

  .xl\\:pointer-events-none{
    pointer-events:none
  }

  .xl\\:pointer-events-auto{
    pointer-events:auto
  }

  .xl\\:static{
    position:static
  }

  .xl\\:fixed{
    position:fixed
  }

  .xl\\:absolute{
    position:absolute
  }

  .xl\\:relative{
    position:relative
  }

  .xl\\:sticky{
    position:sticky
  }

  .xl\\:inset-0{
    bottom:0;
    left:0;
    right:0;
    top:0
  }

  .xl\\:inset-auto{
    bottom:auto;
    left:auto;
    right:auto;
    top:auto
  }

  .xl\\:inset-y-0{
    bottom:0;
    top:0
  }

  .xl\\:inset-x-0{
    left:0;
    right:0
  }

  .xl\\:inset-y-auto{
    bottom:auto;
    top:auto
  }

  .xl\\:inset-x-auto{
    left:auto;
    right:auto
  }

  .xl\\:top-0{
    top:0
  }

  .xl\\:right-0{
    right:0
  }

  .xl\\:bottom-0{
    bottom:0
  }

  .xl\\:left-0{
    left:0
  }

  .xl\\:top-auto{
    top:auto
  }

  .xl\\:right-auto{
    right:auto
  }

  .xl\\:bottom-auto{
    bottom:auto
  }

  .xl\\:left-auto{
    left:auto
  }

  .xl\\:resize-none{
    resize:none
  }

  .xl\\:resize-y{
    resize:vertical
  }

  .xl\\:resize-x{
    resize:horizontal
  }

  .xl\\:resize{
    resize:both
  }

  .xl\\:shadow-xs{
    box-shadow:0 0 0 1px #0000000d
  }

  .xl\\:shadow-sm{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .xl\\:shadow{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .xl\\:shadow-md{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .xl\\:shadow-lg{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .xl\\:shadow-xl{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .xl\\:shadow-2xl{
    box-shadow:0 25px 50px -12px #00000040
  }

  .xl\\:shadow-inner{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .xl\\:shadow-outline{
    box-shadow:0 0 0 3px #4299e180
  }

  .xl\\:shadow-none{
    box-shadow:none
  }

  .xl\\:shadow-bottom{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .xl\\:hover\\:shadow-xs:hover{
    box-shadow:0 0 0 1px #0000000d
  }

  .xl\\:hover\\:shadow-sm:hover{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .xl\\:hover\\:shadow:hover{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .xl\\:hover\\:shadow-md:hover{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .xl\\:hover\\:shadow-lg:hover{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .xl\\:hover\\:shadow-xl:hover{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .xl\\:hover\\:shadow-2xl:hover{
    box-shadow:0 25px 50px -12px #00000040
  }

  .xl\\:hover\\:shadow-inner:hover{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .xl\\:hover\\:shadow-outline:hover{
    box-shadow:0 0 0 3px #4299e180
  }

  .xl\\:hover\\:shadow-none:hover{
    box-shadow:none
  }

  .xl\\:hover\\:shadow-bottom:hover{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .xl\\:focus\\:shadow-xs:focus{
    box-shadow:0 0 0 1px #0000000d
  }

  .xl\\:focus\\:shadow-sm:focus{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .xl\\:focus\\:shadow:focus{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .xl\\:focus\\:shadow-md:focus{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .xl\\:focus\\:shadow-lg:focus{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .xl\\:focus\\:shadow-xl:focus{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .xl\\:focus\\:shadow-2xl:focus{
    box-shadow:0 25px 50px -12px #00000040
  }

  .xl\\:focus\\:shadow-inner:focus{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .xl\\:focus\\:shadow-outline:focus{
    box-shadow:0 0 0 3px #4299e180
  }

  .xl\\:focus\\:shadow-none:focus{
    box-shadow:none
  }

  .xl\\:focus\\:shadow-bottom:focus{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-xs:focus{
    box-shadow:0 0 0 1px #0000000d
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-sm:focus{
    box-shadow:0 1px 2px 0 #0000000d
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow:focus{
    box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-md:focus{
    box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-lg:focus{
    box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-xl:focus{
    box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-2xl:focus{
    box-shadow:0 25px 50px -12px #00000040
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-inner:focus{
    box-shadow:inset 0 2px 4px 0 #0000000f
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-outline:focus{
    box-shadow:0 0 0 3px #4299e180
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-none:focus{
    box-shadow:none
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-bottom:focus{
    box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f
  }

  .xl\\:fill-current{
    fill:currentColor
  }

  .xl\\:stroke-current{
    stroke:currentColor
  }

  .xl\\:stroke-0{
    stroke-width:0
  }

  .xl\\:stroke-1{
    stroke-width:1
  }

  .xl\\:stroke-2{
    stroke-width:2
  }

  .xl\\:table-auto{
    table-layout:auto
  }

  .xl\\:table-fixed{
    table-layout:fixed
  }

  .xl\\:text-left{
    text-align:left
  }

  .xl\\:text-center{
    text-align:center
  }

  .xl\\:text-right{
    text-align:right
  }

  .xl\\:text-justify{
    text-align:justify
  }

  .xl\\:text-transparent{
    color:#0000
  }

  .xl\\:text-white{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .xl\\:text-black{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .xl\\:text-gray-50{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .xl\\:text-gray-100{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .xl\\:text-gray-200{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .xl\\:text-gray-300{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .xl\\:text-gray-400{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .xl\\:text-gray-500{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .xl\\:text-gray-600{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .xl\\:text-gray-700{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .xl\\:text-gray-800{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .xl\\:text-gray-900{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .xl\\:text-cool-gray-50{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .xl\\:text-cool-gray-100{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .xl\\:text-cool-gray-200{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .xl\\:text-cool-gray-300{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .xl\\:text-cool-gray-400{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .xl\\:text-cool-gray-500{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .xl\\:text-cool-gray-600{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .xl\\:text-cool-gray-700{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .xl\\:text-cool-gray-800{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .xl\\:text-cool-gray-900{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .xl\\:text-red-50{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .xl\\:text-red-100{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .xl\\:text-red-200{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .xl\\:text-red-300{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .xl\\:text-red-400{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .xl\\:text-red-500{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .xl\\:text-red-600{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .xl\\:text-red-700{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .xl\\:text-red-800{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .xl\\:text-red-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .xl\\:text-orange-50{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .xl\\:text-orange-100{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .xl\\:text-orange-200{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .xl\\:text-orange-300{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .xl\\:text-orange-400{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .xl\\:text-orange-500{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .xl\\:text-orange-600{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .xl\\:text-orange-700{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .xl\\:text-orange-800{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .xl\\:text-orange-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .xl\\:text-yellow-50{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .xl\\:text-yellow-100{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .xl\\:text-yellow-200{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .xl\\:text-yellow-300{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .xl\\:text-yellow-400{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .xl\\:text-yellow-500{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .xl\\:text-yellow-600{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .xl\\:text-yellow-700{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .xl\\:text-yellow-800{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .xl\\:text-yellow-900{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .xl\\:text-green-50{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .xl\\:text-green-100{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .xl\\:text-green-200{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .xl\\:text-green-300{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .xl\\:text-green-400{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .xl\\:text-green-500{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .xl\\:text-green-600{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .xl\\:text-green-700{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .xl\\:text-green-800{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .xl\\:text-green-900{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .xl\\:text-teal-50{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .xl\\:text-teal-100{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .xl\\:text-teal-200{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .xl\\:text-teal-300{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .xl\\:text-teal-400{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .xl\\:text-teal-500{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .xl\\:text-teal-600{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .xl\\:text-teal-700{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .xl\\:text-teal-800{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .xl\\:text-teal-900{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .xl\\:text-blue-50{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .xl\\:text-blue-100{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .xl\\:text-blue-200{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .xl\\:text-blue-300{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .xl\\:text-blue-400{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .xl\\:text-blue-500{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .xl\\:text-blue-600{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .xl\\:text-blue-700{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .xl\\:text-blue-800{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .xl\\:text-blue-900{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .xl\\:text-indigo-50{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .xl\\:text-indigo-100{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .xl\\:text-indigo-200{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .xl\\:text-indigo-300{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .xl\\:text-indigo-400{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .xl\\:text-indigo-500{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .xl\\:text-indigo-600{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .xl\\:text-indigo-700{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .xl\\:text-indigo-800{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .xl\\:text-indigo-900{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .xl\\:text-indigo-50{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .xl\\:text-indigo-100{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .xl\\:text-indigo-200{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .xl\\:text-indigo-300{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .xl\\:text-indigo-400{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .xl\\:text-indigo-500{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .xl\\:text-indigo-600{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .xl\\:text-indigo-700{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .xl\\:text-indigo-800{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .xl\\:text-indigo-900{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .xl\\:text-pink-50{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .xl\\:text-pink-100{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .xl\\:text-pink-200{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .xl\\:text-pink-300{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .xl\\:text-pink-400{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .xl\\:text-pink-500{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .xl\\:text-pink-600{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .xl\\:text-pink-700{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .xl\\:text-pink-800{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .xl\\:text-pink-900{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .xl\\:focus\\:text-transparent:focus{
    color:#0000
  }

  .xl\\:focus\\:text-white:focus{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .xl\\:focus\\:text-black:focus{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .xl\\:focus\\:text-gray-50:focus{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .xl\\:focus\\:text-gray-100:focus{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .xl\\:focus\\:text-gray-200:focus{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .xl\\:focus\\:text-gray-300:focus{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .xl\\:focus\\:text-gray-400:focus{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .xl\\:focus\\:text-gray-500:focus{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .xl\\:focus\\:text-gray-600:focus{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .xl\\:focus\\:text-gray-700:focus{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .xl\\:focus\\:text-gray-800:focus{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .xl\\:focus\\:text-gray-900:focus{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .xl\\:focus\\:text-cool-gray-50:focus{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .xl\\:focus\\:text-cool-gray-100:focus{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .xl\\:focus\\:text-cool-gray-200:focus{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .xl\\:focus\\:text-cool-gray-300:focus{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .xl\\:focus\\:text-cool-gray-400:focus{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .xl\\:focus\\:text-cool-gray-500:focus{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .xl\\:focus\\:text-cool-gray-600:focus{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .xl\\:focus\\:text-cool-gray-700:focus{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .xl\\:focus\\:text-cool-gray-800:focus{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .xl\\:focus\\:text-cool-gray-900:focus{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .xl\\:focus\\:text-red-50:focus{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .xl\\:focus\\:text-red-100:focus{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .xl\\:focus\\:text-red-200:focus{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .xl\\:focus\\:text-red-300:focus{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .xl\\:focus\\:text-red-400:focus{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .xl\\:focus\\:text-red-500:focus{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .xl\\:focus\\:text-red-600:focus{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .xl\\:focus\\:text-red-700:focus{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .xl\\:focus\\:text-red-800:focus{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .xl\\:focus\\:text-red-900:focus{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .xl\\:focus\\:text-orange-50:focus{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .xl\\:focus\\:text-orange-100:focus{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .xl\\:focus\\:text-orange-200:focus{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .xl\\:focus\\:text-orange-300:focus{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .xl\\:focus\\:text-orange-400:focus{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .xl\\:focus\\:text-orange-500:focus{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .xl\\:focus\\:text-orange-600:focus{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .xl\\:focus\\:text-orange-700:focus{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .xl\\:focus\\:text-orange-800:focus{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .xl\\:focus\\:text-orange-900:focus{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .xl\\:focus\\:text-yellow-50:focus{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .xl\\:focus\\:text-yellow-100:focus{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .xl\\:focus\\:text-yellow-200:focus{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .xl\\:focus\\:text-yellow-300:focus{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .xl\\:focus\\:text-yellow-400:focus{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .xl\\:focus\\:text-yellow-500:focus{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .xl\\:focus\\:text-yellow-600:focus{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .xl\\:focus\\:text-yellow-700:focus{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .xl\\:focus\\:text-yellow-800:focus{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .xl\\:focus\\:text-yellow-900:focus{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .xl\\:focus\\:text-green-50:focus{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .xl\\:focus\\:text-green-100:focus{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .xl\\:focus\\:text-green-200:focus{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .xl\\:focus\\:text-green-300:focus{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .xl\\:focus\\:text-green-400:focus{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .xl\\:focus\\:text-green-500:focus{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .xl\\:focus\\:text-green-600:focus{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .xl\\:focus\\:text-green-700:focus{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .xl\\:focus\\:text-green-800:focus{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .xl\\:focus\\:text-green-900:focus{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .xl\\:focus\\:text-teal-50:focus{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .xl\\:focus\\:text-teal-100:focus{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .xl\\:focus\\:text-teal-200:focus{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .xl\\:focus\\:text-teal-300:focus{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .xl\\:focus\\:text-teal-400:focus{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .xl\\:focus\\:text-teal-500:focus{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .xl\\:focus\\:text-teal-600:focus{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .xl\\:focus\\:text-teal-700:focus{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .xl\\:focus\\:text-teal-800:focus{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .xl\\:focus\\:text-teal-900:focus{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .xl\\:focus\\:text-blue-50:focus{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .xl\\:focus\\:text-blue-100:focus{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .xl\\:focus\\:text-blue-200:focus{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .xl\\:focus\\:text-blue-300:focus{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .xl\\:focus\\:text-blue-400:focus{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .xl\\:focus\\:text-blue-500:focus{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .xl\\:focus\\:text-blue-600:focus{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .xl\\:focus\\:text-blue-700:focus{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .xl\\:focus\\:text-blue-800:focus{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .xl\\:focus\\:text-blue-900:focus{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-50:focus{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-100:focus{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-200:focus{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-300:focus{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-400:focus{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-500:focus{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-600:focus{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-700:focus{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-800:focus{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-900:focus{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-50:focus{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-100:focus{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-200:focus{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-300:focus{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-400:focus{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-500:focus{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-600:focus{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-700:focus{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-800:focus{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .xl\\:focus\\:text-indigo-900:focus{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .xl\\:focus\\:text-pink-50:focus{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .xl\\:focus\\:text-pink-100:focus{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .xl\\:focus\\:text-pink-200:focus{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .xl\\:focus\\:text-pink-300:focus{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .xl\\:focus\\:text-pink-400:focus{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .xl\\:focus\\:text-pink-500:focus{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .xl\\:focus\\:text-pink-600:focus{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .xl\\:focus\\:text-pink-700:focus{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .xl\\:focus\\:text-pink-800:focus{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .xl\\:focus\\:text-pink-900:focus{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-transparent:focus-within{
    color:#0000
  }

  .xl\\:focus-within\\:text-white:focus-within{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-black:focus-within{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-gray-50:focus-within{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-gray-100:focus-within{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-gray-200:focus-within{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-gray-300:focus-within{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-gray-400:focus-within{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-gray-500:focus-within{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-gray-600:focus-within{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-gray-700:focus-within{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-gray-800:focus-within{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-gray-900:focus-within{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-cool-gray-50:focus-within{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-cool-gray-100:focus-within{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-cool-gray-200:focus-within{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-cool-gray-300:focus-within{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-cool-gray-400:focus-within{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-cool-gray-500:focus-within{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-cool-gray-600:focus-within{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-cool-gray-700:focus-within{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-cool-gray-800:focus-within{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-cool-gray-900:focus-within{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-red-50:focus-within{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-red-100:focus-within{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-red-200:focus-within{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-red-300:focus-within{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-red-400:focus-within{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-red-500:focus-within{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-red-600:focus-within{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-red-700:focus-within{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-red-800:focus-within{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-red-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-orange-50:focus-within{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-orange-100:focus-within{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-orange-200:focus-within{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-orange-300:focus-within{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-orange-400:focus-within{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-orange-500:focus-within{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-orange-600:focus-within{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-orange-700:focus-within{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-orange-800:focus-within{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-orange-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-yellow-50:focus-within{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-yellow-100:focus-within{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-yellow-200:focus-within{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-yellow-300:focus-within{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-yellow-400:focus-within{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-yellow-500:focus-within{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-yellow-600:focus-within{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-yellow-700:focus-within{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-yellow-800:focus-within{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-yellow-900:focus-within{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-green-50:focus-within{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-green-100:focus-within{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-green-200:focus-within{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-green-300:focus-within{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-green-400:focus-within{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-green-500:focus-within{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-green-600:focus-within{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-green-700:focus-within{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-green-800:focus-within{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-green-900:focus-within{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-teal-50:focus-within{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-teal-100:focus-within{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-teal-200:focus-within{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-teal-300:focus-within{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-teal-400:focus-within{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-teal-500:focus-within{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-teal-600:focus-within{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-teal-700:focus-within{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-teal-800:focus-within{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-teal-900:focus-within{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-blue-50:focus-within{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-blue-100:focus-within{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-blue-200:focus-within{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-blue-300:focus-within{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-blue-400:focus-within{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-blue-500:focus-within{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-blue-600:focus-within{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-blue-700:focus-within{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-blue-800:focus-within{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-blue-900:focus-within{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-pink-50:focus-within{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-pink-100:focus-within{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-pink-200:focus-within{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-pink-300:focus-within{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-pink-400:focus-within{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-pink-500:focus-within{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-pink-600:focus-within{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-pink-700:focus-within{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-pink-800:focus-within{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .xl\\:focus-within\\:text-pink-900:focus-within{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .xl\\:hover\\:text-transparent:hover{
    color:#0000
  }

  .xl\\:hover\\:text-white:hover{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .xl\\:hover\\:text-black:hover{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .xl\\:hover\\:text-gray-50:hover{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .xl\\:hover\\:text-gray-100:hover{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .xl\\:hover\\:text-gray-200:hover{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .xl\\:hover\\:text-gray-300:hover{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .xl\\:hover\\:text-gray-400:hover{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .xl\\:hover\\:text-gray-500:hover{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .xl\\:hover\\:text-gray-600:hover{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .xl\\:hover\\:text-gray-700:hover{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .xl\\:hover\\:text-gray-800:hover{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .xl\\:hover\\:text-gray-900:hover{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .xl\\:hover\\:text-cool-gray-50:hover{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .xl\\:hover\\:text-cool-gray-100:hover{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .xl\\:hover\\:text-cool-gray-200:hover{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .xl\\:hover\\:text-cool-gray-300:hover{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .xl\\:hover\\:text-cool-gray-400:hover{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .xl\\:hover\\:text-cool-gray-500:hover{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .xl\\:hover\\:text-cool-gray-600:hover{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .xl\\:hover\\:text-cool-gray-700:hover{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .xl\\:hover\\:text-cool-gray-800:hover{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .xl\\:hover\\:text-cool-gray-900:hover{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .xl\\:hover\\:text-red-50:hover{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .xl\\:hover\\:text-red-100:hover{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .xl\\:hover\\:text-red-200:hover{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .xl\\:hover\\:text-red-300:hover{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .xl\\:hover\\:text-red-400:hover{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .xl\\:hover\\:text-red-500:hover{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .xl\\:hover\\:text-red-600:hover{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .xl\\:hover\\:text-red-700:hover{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .xl\\:hover\\:text-red-800:hover{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .xl\\:hover\\:text-red-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .xl\\:hover\\:text-orange-50:hover{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .xl\\:hover\\:text-orange-100:hover{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .xl\\:hover\\:text-orange-200:hover{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .xl\\:hover\\:text-orange-300:hover{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .xl\\:hover\\:text-orange-400:hover{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .xl\\:hover\\:text-orange-500:hover{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .xl\\:hover\\:text-orange-600:hover{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .xl\\:hover\\:text-orange-700:hover{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .xl\\:hover\\:text-orange-800:hover{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .xl\\:hover\\:text-orange-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .xl\\:hover\\:text-yellow-50:hover{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .xl\\:hover\\:text-yellow-100:hover{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .xl\\:hover\\:text-yellow-200:hover{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .xl\\:hover\\:text-yellow-300:hover{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .xl\\:hover\\:text-yellow-400:hover{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .xl\\:hover\\:text-yellow-500:hover{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .xl\\:hover\\:text-yellow-600:hover{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .xl\\:hover\\:text-yellow-700:hover{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .xl\\:hover\\:text-yellow-800:hover{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .xl\\:hover\\:text-yellow-900:hover{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .xl\\:hover\\:text-green-50:hover{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .xl\\:hover\\:text-green-100:hover{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .xl\\:hover\\:text-green-200:hover{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .xl\\:hover\\:text-green-300:hover{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .xl\\:hover\\:text-green-400:hover{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .xl\\:hover\\:text-green-500:hover{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .xl\\:hover\\:text-green-600:hover{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .xl\\:hover\\:text-green-700:hover{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .xl\\:hover\\:text-green-800:hover{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .xl\\:hover\\:text-green-900:hover{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .xl\\:hover\\:text-teal-50:hover{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .xl\\:hover\\:text-teal-100:hover{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .xl\\:hover\\:text-teal-200:hover{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .xl\\:hover\\:text-teal-300:hover{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .xl\\:hover\\:text-teal-400:hover{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .xl\\:hover\\:text-teal-500:hover{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .xl\\:hover\\:text-teal-600:hover{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .xl\\:hover\\:text-teal-700:hover{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .xl\\:hover\\:text-teal-800:hover{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .xl\\:hover\\:text-teal-900:hover{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .xl\\:hover\\:text-blue-50:hover{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .xl\\:hover\\:text-blue-100:hover{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .xl\\:hover\\:text-blue-200:hover{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .xl\\:hover\\:text-blue-300:hover{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .xl\\:hover\\:text-blue-400:hover{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .xl\\:hover\\:text-blue-500:hover{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .xl\\:hover\\:text-blue-600:hover{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .xl\\:hover\\:text-blue-700:hover{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .xl\\:hover\\:text-blue-800:hover{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .xl\\:hover\\:text-blue-900:hover{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .xl\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .xl\\:hover\\:text-pink-50:hover{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .xl\\:hover\\:text-pink-100:hover{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .xl\\:hover\\:text-pink-200:hover{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .xl\\:hover\\:text-pink-300:hover{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .xl\\:hover\\:text-pink-400:hover{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .xl\\:hover\\:text-pink-500:hover{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .xl\\:hover\\:text-pink-600:hover{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .xl\\:hover\\:text-pink-700:hover{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .xl\\:hover\\:text-pink-800:hover{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .xl\\:hover\\:text-pink-900:hover{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .xl\\:active\\:text-transparent:active{
    color:#0000
  }

  .xl\\:active\\:text-white:active{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .xl\\:active\\:text-black:active{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .xl\\:active\\:text-gray-50:active{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .xl\\:active\\:text-gray-100:active{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .xl\\:active\\:text-gray-200:active{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .xl\\:active\\:text-gray-300:active{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .xl\\:active\\:text-gray-400:active{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .xl\\:active\\:text-gray-500:active{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .xl\\:active\\:text-gray-600:active{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .xl\\:active\\:text-gray-700:active{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .xl\\:active\\:text-gray-800:active{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .xl\\:active\\:text-gray-900:active{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .xl\\:active\\:text-cool-gray-50:active{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .xl\\:active\\:text-cool-gray-100:active{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .xl\\:active\\:text-cool-gray-200:active{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .xl\\:active\\:text-cool-gray-300:active{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .xl\\:active\\:text-cool-gray-400:active{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .xl\\:active\\:text-cool-gray-500:active{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .xl\\:active\\:text-cool-gray-600:active{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .xl\\:active\\:text-cool-gray-700:active{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .xl\\:active\\:text-cool-gray-800:active{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .xl\\:active\\:text-cool-gray-900:active{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .xl\\:active\\:text-red-50:active{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .xl\\:active\\:text-red-100:active{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .xl\\:active\\:text-red-200:active{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .xl\\:active\\:text-red-300:active{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .xl\\:active\\:text-red-400:active{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .xl\\:active\\:text-red-500:active{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .xl\\:active\\:text-red-600:active{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .xl\\:active\\:text-red-700:active{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .xl\\:active\\:text-red-800:active{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .xl\\:active\\:text-red-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .xl\\:active\\:text-orange-50:active{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .xl\\:active\\:text-orange-100:active{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .xl\\:active\\:text-orange-200:active{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .xl\\:active\\:text-orange-300:active{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .xl\\:active\\:text-orange-400:active{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .xl\\:active\\:text-orange-500:active{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .xl\\:active\\:text-orange-600:active{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .xl\\:active\\:text-orange-700:active{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .xl\\:active\\:text-orange-800:active{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .xl\\:active\\:text-orange-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .xl\\:active\\:text-yellow-50:active{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .xl\\:active\\:text-yellow-100:active{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .xl\\:active\\:text-yellow-200:active{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .xl\\:active\\:text-yellow-300:active{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .xl\\:active\\:text-yellow-400:active{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .xl\\:active\\:text-yellow-500:active{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .xl\\:active\\:text-yellow-600:active{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .xl\\:active\\:text-yellow-700:active{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .xl\\:active\\:text-yellow-800:active{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .xl\\:active\\:text-yellow-900:active{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .xl\\:active\\:text-green-50:active{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .xl\\:active\\:text-green-100:active{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .xl\\:active\\:text-green-200:active{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .xl\\:active\\:text-green-300:active{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .xl\\:active\\:text-green-400:active{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .xl\\:active\\:text-green-500:active{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .xl\\:active\\:text-green-600:active{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .xl\\:active\\:text-green-700:active{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .xl\\:active\\:text-green-800:active{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .xl\\:active\\:text-green-900:active{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .xl\\:active\\:text-teal-50:active{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .xl\\:active\\:text-teal-100:active{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .xl\\:active\\:text-teal-200:active{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .xl\\:active\\:text-teal-300:active{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .xl\\:active\\:text-teal-400:active{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .xl\\:active\\:text-teal-500:active{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .xl\\:active\\:text-teal-600:active{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .xl\\:active\\:text-teal-700:active{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .xl\\:active\\:text-teal-800:active{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .xl\\:active\\:text-teal-900:active{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .xl\\:active\\:text-blue-50:active{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .xl\\:active\\:text-blue-100:active{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .xl\\:active\\:text-blue-200:active{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .xl\\:active\\:text-blue-300:active{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .xl\\:active\\:text-blue-400:active{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .xl\\:active\\:text-blue-500:active{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .xl\\:active\\:text-blue-600:active{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .xl\\:active\\:text-blue-700:active{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .xl\\:active\\:text-blue-800:active{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .xl\\:active\\:text-blue-900:active{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .xl\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .xl\\:active\\:text-pink-50:active{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .xl\\:active\\:text-pink-100:active{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .xl\\:active\\:text-pink-200:active{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .xl\\:active\\:text-pink-300:active{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .xl\\:active\\:text-pink-400:active{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .xl\\:active\\:text-pink-500:active{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .xl\\:active\\:text-pink-600:active{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .xl\\:active\\:text-pink-700:active{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .xl\\:active\\:text-pink-800:active{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .xl\\:active\\:text-pink-900:active{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-transparent{
    color:#0000
  }

  .theme-dark .xl\\:dark\\:text-white{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-black{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-gray-50{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-gray-100{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-gray-200{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-gray-300{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-gray-400{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-gray-500{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-gray-600{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-gray-700{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-gray-800{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-gray-900{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-cool-gray-50{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-cool-gray-100{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-cool-gray-200{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-cool-gray-300{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-cool-gray-400{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-cool-gray-500{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-cool-gray-600{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-cool-gray-700{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-cool-gray-800{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-cool-gray-900{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-red-50{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-red-100{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-red-200{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-red-300{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-red-400{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-red-500{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-red-600{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-red-700{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-red-800{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-red-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-orange-50{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-orange-100{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-orange-200{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-orange-300{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-orange-400{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-orange-500{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-orange-600{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-orange-700{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-orange-800{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-orange-900{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-yellow-50{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-yellow-100{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-yellow-200{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-yellow-300{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-yellow-400{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-yellow-500{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-yellow-600{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-yellow-700{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-yellow-800{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-yellow-900{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-green-50{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-green-100{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-green-200{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-green-300{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-green-400{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-green-500{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-green-600{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-green-700{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-green-800{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-green-900{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-teal-50{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-teal-100{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-teal-200{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-teal-300{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-teal-400{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-teal-500{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-teal-600{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-teal-700{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-teal-800{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-teal-900{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-blue-50{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-blue-100{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-blue-200{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-blue-300{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-blue-400{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-blue-500{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-blue-600{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-blue-700{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-blue-800{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-blue-900{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-50{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-100{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-200{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-300{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-400{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-500{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-600{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-700{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-800{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-900{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-50{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-100{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-200{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-300{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-400{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-500{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-600{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-700{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-800{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-indigo-900{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-pink-50{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-pink-100{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-pink-200{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-pink-300{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-pink-400{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-pink-500{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-pink-600{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-pink-700{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-pink-800{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:text-pink-900{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-transparent:focus-within{
    color:#0000
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-white:focus-within{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-black:focus-within{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-gray-50:focus-within{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-gray-100:focus-within{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-gray-200:focus-within{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-gray-300:focus-within{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-gray-400:focus-within{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-gray-500:focus-within{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-gray-600:focus-within{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-gray-700:focus-within{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-gray-800:focus-within{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-gray-900:focus-within{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-50:focus-within{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-100:focus-within{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-200:focus-within{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-300:focus-within{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-400:focus-within{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-500:focus-within{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-600:focus-within{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-700:focus-within{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-800:focus-within{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-900:focus-within{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-red-50:focus-within{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-red-100:focus-within{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-red-200:focus-within{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-red-300:focus-within{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-red-400:focus-within{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-red-500:focus-within{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-red-600:focus-within{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-red-700:focus-within{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-red-800:focus-within{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-red-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-orange-50:focus-within{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-orange-100:focus-within{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-orange-200:focus-within{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-orange-300:focus-within{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-orange-400:focus-within{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-orange-500:focus-within{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-orange-600:focus-within{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-orange-700:focus-within{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-orange-800:focus-within{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-orange-900:focus-within{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-yellow-50:focus-within{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-yellow-100:focus-within{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-yellow-200:focus-within{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-yellow-300:focus-within{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-yellow-400:focus-within{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-yellow-500:focus-within{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-yellow-600:focus-within{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-yellow-700:focus-within{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-yellow-800:focus-within{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-yellow-900:focus-within{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-green-50:focus-within{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-green-100:focus-within{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-green-200:focus-within{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-green-300:focus-within{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-green-400:focus-within{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-green-500:focus-within{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-green-600:focus-within{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-green-700:focus-within{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-green-800:focus-within{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-green-900:focus-within{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-teal-50:focus-within{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-teal-100:focus-within{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-teal-200:focus-within{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-teal-300:focus-within{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-teal-400:focus-within{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-teal-500:focus-within{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-teal-600:focus-within{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-teal-700:focus-within{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-teal-800:focus-within{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-teal-900:focus-within{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-blue-50:focus-within{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-blue-100:focus-within{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-blue-200:focus-within{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-blue-300:focus-within{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-blue-400:focus-within{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-blue-500:focus-within{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-blue-600:focus-within{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-blue-700:focus-within{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-blue-800:focus-within{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-blue-900:focus-within{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-50:focus-within{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-100:focus-within{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-200:focus-within{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-300:focus-within{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-400:focus-within{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-500:focus-within{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-600:focus-within{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-700:focus-within{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-800:focus-within{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-indigo-900:focus-within{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-pink-50:focus-within{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-pink-100:focus-within{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-pink-200:focus-within{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-pink-300:focus-within{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-pink-400:focus-within{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-pink-500:focus-within{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-pink-600:focus-within{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-pink-700:focus-within{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-pink-800:focus-within{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:focus-within\\:text-pink-900:focus-within{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-transparent:hover{
    color:#0000
  }

  .theme-dark .xl\\:dark\\:hover\\:text-white:hover{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-black:hover{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-gray-50:hover{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-gray-100:hover{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-gray-200:hover{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-gray-300:hover{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-gray-400:hover{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-gray-500:hover{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-gray-600:hover{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-gray-700:hover{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-gray-800:hover{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-gray-900:hover{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-cool-gray-50:hover{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-cool-gray-100:hover{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-cool-gray-200:hover{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-cool-gray-300:hover{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-cool-gray-400:hover{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-cool-gray-500:hover{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-cool-gray-600:hover{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-cool-gray-700:hover{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-cool-gray-800:hover{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-cool-gray-900:hover{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-red-50:hover{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-red-100:hover{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-red-200:hover{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-red-300:hover{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-red-400:hover{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-red-500:hover{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-red-600:hover{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-red-700:hover{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-red-800:hover{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-red-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-orange-50:hover{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-orange-100:hover{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-orange-200:hover{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-orange-300:hover{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-orange-400:hover{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-orange-500:hover{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-orange-600:hover{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-orange-700:hover{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-orange-800:hover{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-orange-900:hover{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-yellow-50:hover{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-yellow-100:hover{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-yellow-200:hover{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-yellow-300:hover{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-yellow-400:hover{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-yellow-500:hover{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-yellow-600:hover{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-yellow-700:hover{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-yellow-800:hover{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-yellow-900:hover{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-green-50:hover{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-green-100:hover{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-green-200:hover{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-green-300:hover{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-green-400:hover{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-green-500:hover{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-green-600:hover{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-green-700:hover{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-green-800:hover{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-green-900:hover{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-teal-50:hover{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-teal-100:hover{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-teal-200:hover{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-teal-300:hover{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-teal-400:hover{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-teal-500:hover{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-teal-600:hover{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-teal-700:hover{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-teal-800:hover{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-teal-900:hover{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-blue-50:hover{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-blue-100:hover{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-blue-200:hover{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-blue-300:hover{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-blue-400:hover{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-blue-500:hover{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-blue-600:hover{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-blue-700:hover{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-blue-800:hover{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-blue-900:hover{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-50:hover{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-100:hover{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-200:hover{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-300:hover{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-400:hover{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-500:hover{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-600:hover{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-700:hover{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-800:hover{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-indigo-900:hover{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-pink-50:hover{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-pink-100:hover{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-pink-200:hover{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-pink-300:hover{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-pink-400:hover{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-pink-500:hover{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-pink-600:hover{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-pink-700:hover{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-pink-800:hover{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:hover\\:text-pink-900:hover{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-transparent:active{
    color:#0000
  }

  .theme-dark .xl\\:dark\\:active\\:text-white:active{
    --text-opacity:1;
    color:#fff;
    color:rgba(255,255,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-black:active{
    --text-opacity:1;
    color:#000;
    color:rgba(0,0,0,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-gray-50:active{
    --text-opacity:1;
    color:#f9fafb;
    color:rgba(249,250,251,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-gray-100:active{
    --text-opacity:1;
    color:#f4f5f7;
    color:rgba(244,245,247,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-gray-200:active{
    --text-opacity:1;
    color:#e5e7eb;
    color:rgba(229,231,235,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-gray-300:active{
    --text-opacity:1;
    color:#d5d6d7;
    color:rgba(213,214,215,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-gray-400:active{
    --text-opacity:1;
    color:#9e9e9e;
    color:rgba(158,158,158,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-gray-500:active{
    --text-opacity:1;
    color:#707275;
    color:rgba(112,114,117,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-gray-600:active{
    --text-opacity:1;
    color:#4c4f52;
    color:rgba(76,79,82,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-gray-700:active{
    --text-opacity:1;
    color:#24262d;
    color:rgba(36,38,45,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-gray-800:active{
    --text-opacity:1;
    color:#1a1c23;
    color:rgba(26,28,35,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-gray-900:active{
    --text-opacity:1;
    color:#121317;
    color:rgba(18,19,23,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-cool-gray-50:active{
    --text-opacity:1;
    color:#fbfdfe;
    color:rgba(251,253,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-cool-gray-100:active{
    --text-opacity:1;
    color:#f1f5f9;
    color:rgba(241,245,249,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-cool-gray-200:active{
    --text-opacity:1;
    color:#e2e8f0;
    color:rgba(226,232,240,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-cool-gray-300:active{
    --text-opacity:1;
    color:#cfd8e3;
    color:rgba(207,216,227,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-cool-gray-400:active{
    --text-opacity:1;
    color:#97a6ba;
    color:rgba(151,166,186,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-cool-gray-500:active{
    --text-opacity:1;
    color:#64748b;
    color:rgba(100,116,139,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-cool-gray-600:active{
    --text-opacity:1;
    color:#475569;
    color:rgba(71,85,105,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-cool-gray-700:active{
    --text-opacity:1;
    color:#364152;
    color:rgba(54,65,82,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-cool-gray-800:active{
    --text-opacity:1;
    color:#27303f;
    color:rgba(39,48,63,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-cool-gray-900:active{
    --text-opacity:1;
    color:#1a202e;
    color:rgba(26,32,46,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-red-50:active{
    --text-opacity:1;
    color:#fdf2f2;
    color:rgba(253,242,242,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-red-100:active{
    --text-opacity:1;
    color:#fde8e8;
    color:rgba(253,232,232,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-red-200:active{
    --text-opacity:1;
    color:#fbd5d5;
    color:rgba(251,213,213,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-red-300:active{
    --text-opacity:1;
    color:#f8b4b4;
    color:rgba(248,180,180,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-red-400:active{
    --text-opacity:1;
    color:#f98080;
    color:rgba(249,128,128,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-red-500:active{
    --text-opacity:1;
    color:#f05252;
    color:rgba(240,82,82,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-red-600:active{
    --text-opacity:1;
    color:#e02424;
    color:rgba(224,36,36,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-red-700:active{
    --text-opacity:1;
    color:#c81e1e;
    color:rgba(200,30,30,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-red-800:active{
    --text-opacity:1;
    color:#9b1c1c;
    color:rgba(155,28,28,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-red-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-orange-50:active{
    --text-opacity:1;
    color:#fff8f1;
    color:rgba(255,248,241,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-orange-100:active{
    --text-opacity:1;
    color:#feecdc;
    color:rgba(254,236,220,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-orange-200:active{
    --text-opacity:1;
    color:#fcd9bd;
    color:rgba(252,217,189,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-orange-300:active{
    --text-opacity:1;
    color:#fdba8c;
    color:rgba(253,186,140,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-orange-400:active{
    --text-opacity:1;
    color:#ff8a4c;
    color:rgba(255,138,76,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-orange-500:active{
    --text-opacity:1;
    color:#ff5a1f;
    color:rgba(255,90,31,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-orange-600:active{
    --text-opacity:1;
    color:#d03801;
    color:rgba(208,56,1,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-orange-700:active{
    --text-opacity:1;
    color:#b43403;
    color:rgba(180,52,3,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-orange-800:active{
    --text-opacity:1;
    color:#8a2c0d;
    color:rgba(138,44,13,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-orange-900:active{
    --text-opacity:1;
    color:#771d1d;
    color:rgba(119,29,29,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-yellow-50:active{
    --text-opacity:1;
    color:#fdfdea;
    color:rgba(253,253,234,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-yellow-100:active{
    --text-opacity:1;
    color:#fdf6b2;
    color:rgba(253,246,178,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-yellow-200:active{
    --text-opacity:1;
    color:#fce96a;
    color:rgba(252,233,106,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-yellow-300:active{
    --text-opacity:1;
    color:#faca15;
    color:rgba(250,202,21,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-yellow-400:active{
    --text-opacity:1;
    color:#e3a008;
    color:rgba(227,160,8,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-yellow-500:active{
    --text-opacity:1;
    color:#c27803;
    color:rgba(194,120,3,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-yellow-600:active{
    --text-opacity:1;
    color:#9f580a;
    color:rgba(159,88,10,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-yellow-700:active{
    --text-opacity:1;
    color:#8e4b10;
    color:rgba(142,75,16,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-yellow-800:active{
    --text-opacity:1;
    color:#723b13;
    color:rgba(114,59,19,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-yellow-900:active{
    --text-opacity:1;
    color:#633112;
    color:rgba(99,49,18,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-green-50:active{
    --text-opacity:1;
    color:#f3faf7;
    color:rgba(243,250,247,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-green-100:active{
    --text-opacity:1;
    color:#def7ec;
    color:rgba(222,247,236,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-green-200:active{
    --text-opacity:1;
    color:#bcf0da;
    color:rgba(188,240,218,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-green-300:active{
    --text-opacity:1;
    color:#84e1bc;
    color:rgba(132,225,188,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-green-400:active{
    --text-opacity:1;
    color:#31c48d;
    color:rgba(49,196,141,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-green-500:active{
    --text-opacity:1;
    color:#0e9f6e;
    color:rgba(14,159,110,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-green-600:active{
    --text-opacity:1;
    color:#057a55;
    color:rgba(5,122,85,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-green-700:active{
    --text-opacity:1;
    color:#046c4e;
    color:rgba(4,108,78,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-green-800:active{
    --text-opacity:1;
    color:#03543f;
    color:rgba(3,84,63,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-green-900:active{
    --text-opacity:1;
    color:#014737;
    color:rgba(1,71,55,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-teal-50:active{
    --text-opacity:1;
    color:#edfafa;
    color:rgba(237,250,250,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-teal-100:active{
    --text-opacity:1;
    color:#d5f5f6;
    color:rgba(213,245,246,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-teal-200:active{
    --text-opacity:1;
    color:#afecef;
    color:rgba(175,236,239,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-teal-300:active{
    --text-opacity:1;
    color:#7edce2;
    color:rgba(126,220,226,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-teal-400:active{
    --text-opacity:1;
    color:#16bdca;
    color:rgba(22,189,202,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-teal-500:active{
    --text-opacity:1;
    color:#0694a2;
    color:rgba(6,148,162,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-teal-600:active{
    --text-opacity:1;
    color:#047481;
    color:rgba(4,116,129,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-teal-700:active{
    --text-opacity:1;
    color:#036672;
    color:rgba(3,102,114,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-teal-800:active{
    --text-opacity:1;
    color:#05505c;
    color:rgba(5,80,92,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-teal-900:active{
    --text-opacity:1;
    color:#014451;
    color:rgba(1,68,81,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-blue-50:active{
    --text-opacity:1;
    color:#ebf5ff;
    color:rgba(235,245,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-blue-100:active{
    --text-opacity:1;
    color:#e1effe;
    color:rgba(225,239,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-blue-200:active{
    --text-opacity:1;
    color:#c3ddfd;
    color:rgba(195,221,253,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-blue-300:active{
    --text-opacity:1;
    color:#a4cafe;
    color:rgba(164,202,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-blue-400:active{
    --text-opacity:1;
    color:#76a9fa;
    color:rgba(118,169,250,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-blue-500:active{
    --text-opacity:1;
    color:#3f83f8;
    color:rgba(63,131,248,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-blue-600:active{
    --text-opacity:1;
    color:#1c64f2;
    color:rgba(28,100,242,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-blue-700:active{
    --text-opacity:1;
    color:#1a56db;
    color:rgba(26,86,219,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-blue-800:active{
    --text-opacity:1;
    color:#1e429f;
    color:rgba(30,66,159,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-blue-900:active{
    --text-opacity:1;
    color:#233876;
    color:rgba(35,56,118,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f0f5ff;
    color:rgba(240,245,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#e5edff;
    color:rgba(229,237,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#cddbfe;
    color:rgba(205,219,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#b4c6fc;
    color:rgba(180,198,252,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#8da2fb;
    color:rgba(141,162,251,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#6875f5;
    color:rgba(104,117,245,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#5850ec;
    color:rgba(88,80,236,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#5145cd;
    color:rgba(81,69,205,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#42389d;
    color:rgba(66,56,157,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#362f78;
    color:rgba(54,47,120,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-50:active{
    --text-opacity:1;
    color:#f6f5ff;
    color:rgba(246,245,255,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-100:active{
    --text-opacity:1;
    color:#edebfe;
    color:rgba(237,235,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-200:active{
    --text-opacity:1;
    color:#dcd7fe;
    color:rgba(220,215,254,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-300:active{
    --text-opacity:1;
    color:#cabffd;
    color:rgba(202,191,253,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-400:active{
    --text-opacity:1;
    color:#ac94fa;
    color:rgba(172,148,250,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-500:active{
    --text-opacity:1;
    color:#9061f9;
    color:rgba(144,97,249,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-600:active{
    --text-opacity:1;
    color:#7e3af2;
    color:rgba(126,58,242,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-700:active{
    --text-opacity:1;
    color:#6c2bd9;
    color:rgba(108,43,217,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-800:active{
    --text-opacity:1;
    color:#5521b5;
    color:rgba(85,33,181,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-indigo-900:active{
    --text-opacity:1;
    color:#4a1d96;
    color:rgba(74,29,150,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-pink-50:active{
    --text-opacity:1;
    color:#fdf2f8;
    color:rgba(253,242,248,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-pink-100:active{
    --text-opacity:1;
    color:#fce8f3;
    color:rgba(252,232,243,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-pink-200:active{
    --text-opacity:1;
    color:#fad1e8;
    color:rgba(250,209,232,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-pink-300:active{
    --text-opacity:1;
    color:#f8b4d9;
    color:rgba(248,180,217,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-pink-400:active{
    --text-opacity:1;
    color:#f17eb8;
    color:rgba(241,126,184,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-pink-500:active{
    --text-opacity:1;
    color:#e74694;
    color:rgba(231,70,148,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-pink-600:active{
    --text-opacity:1;
    color:#d61f69;
    color:rgba(214,31,105,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-pink-700:active{
    --text-opacity:1;
    color:#bf125d;
    color:rgba(191,18,93,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-pink-800:active{
    --text-opacity:1;
    color:#99154b;
    color:rgba(153,21,75,var(--text-opacity))
  }

  .theme-dark .xl\\:dark\\:active\\:text-pink-900:active{
    --text-opacity:1;
    color:#751a3d;
    color:rgba(117,26,61,var(--text-opacity))
  }

  .xl\\:text-opacity-0{
    --text-opacity:0
  }

  .xl\\:text-opacity-25{
    --text-opacity:0.25
  }

  .xl\\:text-opacity-50{
    --text-opacity:0.5
  }

  .xl\\:text-opacity-75{
    --text-opacity:0.75
  }

  .xl\\:text-opacity-100{
    --text-opacity:1
  }

  .xl\\:hover\\:text-opacity-0:hover{
    --text-opacity:0
  }

  .xl\\:hover\\:text-opacity-25:hover{
    --text-opacity:0.25
  }

  .xl\\:hover\\:text-opacity-50:hover{
    --text-opacity:0.5
  }

  .xl\\:hover\\:text-opacity-75:hover{
    --text-opacity:0.75
  }

  .xl\\:hover\\:text-opacity-100:hover{
    --text-opacity:1
  }

  .xl\\:focus\\:text-opacity-0:focus{
    --text-opacity:0
  }

  .xl\\:focus\\:text-opacity-25:focus{
    --text-opacity:0.25
  }

  .xl\\:focus\\:text-opacity-50:focus{
    --text-opacity:0.5
  }

  .xl\\:focus\\:text-opacity-75:focus{
    --text-opacity:0.75
  }

  .xl\\:focus\\:text-opacity-100:focus{
    --text-opacity:1
  }

  .xl\\:italic{
    font-style:italic
  }

  .xl\\:not-italic{
    font-style:normal
  }

  .xl\\:uppercase{
    text-transform:uppercase
  }

  .xl\\:lowercase{
    text-transform:lowercase
  }

  .xl\\:capitalize{
    text-transform:capitalize
  }

  .xl\\:normal-case{
    text-transform:none
  }

  .xl\\:underline{
    text-decoration:underline
  }

  .xl\\:line-through{
    text-decoration:line-through
  }

  .xl\\:no-underline{
    text-decoration:none
  }

  .xl\\:hover\\:underline:hover{
    text-decoration:underline
  }

  .xl\\:hover\\:line-through:hover{
    text-decoration:line-through
  }

  .xl\\:hover\\:no-underline:hover{
    text-decoration:none
  }

  .xl\\:focus\\:underline:focus{
    text-decoration:underline
  }

  .xl\\:focus\\:line-through:focus{
    text-decoration:line-through
  }

  .xl\\:focus\\:no-underline:focus{
    text-decoration:none
  }

  .xl\\:antialiased{
    -webkit-font-smoothing:antialiased;
    -moz-osx-font-smoothing:grayscale
  }

  .xl\\:subpixel-antialiased{
    -webkit-font-smoothing:auto;
    -moz-osx-font-smoothing:auto
  }

  .xl\\:tracking-tighter{
    letter-spacing:-.05em
  }

  .xl\\:tracking-tight{
    letter-spacing:-.025em
  }

  .xl\\:tracking-normal{
    letter-spacing:0
  }

  .xl\\:tracking-wide{
    letter-spacing:.025em
  }

  .xl\\:tracking-wider{
    letter-spacing:.05em
  }

  .xl\\:tracking-widest{
    letter-spacing:.1em
  }

  .xl\\:select-none{
    -webkit-user-select:none;
    user-select:none
  }

  .xl\\:select-text{
    -webkit-user-select:text;
    user-select:text
  }

  .xl\\:select-all{
    -webkit-user-select:all;
    user-select:all
  }

  .xl\\:select-auto{
    -webkit-user-select:auto;
    user-select:auto
  }

  .xl\\:align-baseline{
    vertical-align:initial
  }

  .xl\\:align-top{
    vertical-align:top
  }

  .xl\\:align-middle{
    vertical-align:middle
  }

  .xl\\:align-bottom{
    vertical-align:bottom
  }

  .xl\\:align-text-top{
    vertical-align:text-top
  }

  .xl\\:align-text-bottom{
    vertical-align:text-bottom
  }

  .xl\\:visible{
    visibility:visible
  }

  .xl\\:invisible{
    visibility:hidden
  }

  .xl\\:whitespace-normal{
    white-space:normal
  }

  .xl\\:whitespace-no-wrap{
    white-space:nowrap
  }

  .xl\\:whitespace-pre{
    white-space:pre
  }

  .xl\\:whitespace-pre-line{
    white-space:pre-line
  }

  .xl\\:whitespace-pre-wrap{
    white-space:pre-wrap
  }

  .xl\\:break-normal{
    overflow-wrap:normal;
    word-break:normal
  }

  .xl\\:break-words{
    overflow-wrap:break-word
  }

  .xl\\:break-all{
    word-break:break-all
  }

  .xl\\:truncate{
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
  }

  .xl\\:w-0{
    width:0
  }

  .xl\\:w-1{
    width:.25rem
  }

  .xl\\:w-2{
    width:.5rem
  }

  .xl\\:w-3{
    width:.75rem
  }

  .xl\\:w-4{
    width:1rem
  }

  .xl\\:w-5{
    width:1.25rem
  }

  .xl\\:w-6{
    width:1.5rem
  }

  .xl\\:w-8{
    width:2rem
  }

  .xl\\:w-10{
    width:2.5rem
  }

  .xl\\:w-12{
    width:3rem
  }

  .xl\\:w-16{
    width:4rem
  }

  .xl\\:w-20{
    width:5rem
  }

  .xl\\:w-24{
    width:6rem
  }

  .xl\\:w-32{
    width:8rem
  }

  .xl\\:w-40{
    width:10rem
  }

  .xl\\:w-48{
    width:12rem
  }

  .xl\\:w-56{
    width:14rem
  }

  .xl\\:w-64{
    width:16rem
  }

  .xl\\:w-auto{
    width:auto
  }

  .xl\\:w-px{
    width:1px
  }

  .xl\\:w-1\\/2{
    width:50%
  }

  .xl\\:w-1\\/3{
    width:33.333333%
  }

  .xl\\:w-2\\/3{
    width:66.666667%
  }

  .xl\\:w-1\\/4{
    width:25%
  }

  .xl\\:w-2\\/4{
    width:50%
  }

  .xl\\:w-3\\/4{
    width:75%
  }

  .xl\\:w-1\\/5{
    width:20%
  }

  .xl\\:w-2\\/5{
    width:40%
  }

  .xl\\:w-3\\/5{
    width:60%
  }

  .xl\\:w-4\\/5{
    width:80%
  }

  .xl\\:w-1\\/6{
    width:16.666667%
  }

  .xl\\:w-2\\/6{
    width:33.333333%
  }

  .xl\\:w-3\\/6{
    width:50%
  }

  .xl\\:w-4\\/6{
    width:66.666667%
  }

  .xl\\:w-5\\/6{
    width:83.333333%
  }

  .xl\\:w-1\\/12{
    width:8.333333%
  }

  .xl\\:w-2\\/12{
    width:16.666667%
  }

  .xl\\:w-3\\/12{
    width:25%
  }

  .xl\\:w-4\\/12{
    width:33.333333%
  }

  .xl\\:w-5\\/12{
    width:41.666667%
  }

  .xl\\:w-6\\/12{
    width:50%
  }

  .xl\\:w-7\\/12{
    width:58.333333%
  }

  .xl\\:w-8\\/12{
    width:66.666667%
  }

  .xl\\:w-9\\/12{
    width:75%
  }

  .xl\\:w-10\\/12{
    width:83.333333%
  }

  .xl\\:w-11\\/12{
    width:91.666667%
  }

  .xl\\:w-full{
    width:100%
  }

  .xl\\:w-screen{
    width:100vw
  }

  .xl\\:z-0{
    z-index:0
  }

  .xl\\:z-10{
    z-index:10
  }

  .xl\\:z-20{
    z-index:20
  }

  .xl\\:z-30{
    z-index:30
  }

  .xl\\:z-40{
    z-index:40
  }

  .xl\\:z-50{
    z-index:50
  }

  .xl\\:z-auto{
    z-index:auto
  }

  .xl\\:gap-0{
    grid-gap:0;
    gap:0
  }

  .xl\\:gap-1{
    grid-gap:.25rem;
    gap:.25rem
  }

  .xl\\:gap-2{
    grid-gap:.5rem;
    gap:.5rem
  }

  .xl\\:gap-3{
    grid-gap:.75rem;
    gap:.75rem
  }

  .xl\\:gap-4{
    grid-gap:1rem;
    gap:1rem
  }

  .xl\\:gap-5{
    grid-gap:1.25rem;
    gap:1.25rem
  }

  .xl\\:gap-6{
    grid-gap:1.5rem;
    gap:1.5rem
  }

  .xl\\:gap-8{
    grid-gap:2rem;
    gap:2rem
  }

  .xl\\:gap-10{
    grid-gap:2.5rem;
    gap:2.5rem
  }

  .xl\\:gap-12{
    grid-gap:3rem;
    gap:3rem
  }

  .xl\\:gap-16{
    grid-gap:4rem;
    gap:4rem
  }

  .xl\\:gap-20{
    grid-gap:5rem;
    gap:5rem
  }

  .xl\\:gap-24{
    grid-gap:6rem;
    gap:6rem
  }

  .xl\\:gap-32{
    grid-gap:8rem;
    gap:8rem
  }

  .xl\\:gap-40{
    grid-gap:10rem;
    gap:10rem
  }

  .xl\\:gap-48{
    grid-gap:12rem;
    gap:12rem
  }

  .xl\\:gap-56{
    grid-gap:14rem;
    gap:14rem
  }

  .xl\\:gap-64{
    grid-gap:16rem;
    gap:16rem
  }

  .xl\\:gap-px{
    grid-gap:1px;
    gap:1px
  }

  .xl\\:col-gap-0{
    grid-column-gap:0;
    column-gap:0
  }

  .xl\\:col-gap-1{
    grid-column-gap:.25rem;
    column-gap:.25rem
  }

  .xl\\:col-gap-2{
    grid-column-gap:.5rem;
    column-gap:.5rem
  }

  .xl\\:col-gap-3{
    grid-column-gap:.75rem;
    column-gap:.75rem
  }

  .xl\\:col-gap-4{
    grid-column-gap:1rem;
    column-gap:1rem
  }

  .xl\\:col-gap-5{
    grid-column-gap:1.25rem;
    column-gap:1.25rem
  }

  .xl\\:col-gap-6{
    grid-column-gap:1.5rem;
    column-gap:1.5rem
  }

  .xl\\:col-gap-8{
    grid-column-gap:2rem;
    column-gap:2rem
  }

  .xl\\:col-gap-10{
    grid-column-gap:2.5rem;
    column-gap:2.5rem
  }

  .xl\\:col-gap-12{
    grid-column-gap:3rem;
    column-gap:3rem
  }

  .xl\\:col-gap-16{
    grid-column-gap:4rem;
    column-gap:4rem
  }

  .xl\\:col-gap-20{
    grid-column-gap:5rem;
    column-gap:5rem
  }

  .xl\\:col-gap-24{
    grid-column-gap:6rem;
    column-gap:6rem
  }

  .xl\\:col-gap-32{
    grid-column-gap:8rem;
    column-gap:8rem
  }

  .xl\\:col-gap-40{
    grid-column-gap:10rem;
    column-gap:10rem
  }

  .xl\\:col-gap-48{
    grid-column-gap:12rem;
    column-gap:12rem
  }

  .xl\\:col-gap-56{
    grid-column-gap:14rem;
    column-gap:14rem
  }

  .xl\\:col-gap-64{
    grid-column-gap:16rem;
    column-gap:16rem
  }

  .xl\\:col-gap-px{
    grid-column-gap:1px;
    column-gap:1px
  }

  .xl\\:row-gap-0{
    grid-row-gap:0;
    row-gap:0
  }

  .xl\\:row-gap-1{
    grid-row-gap:.25rem;
    row-gap:.25rem
  }

  .xl\\:row-gap-2{
    grid-row-gap:.5rem;
    row-gap:.5rem
  }

  .xl\\:row-gap-3{
    grid-row-gap:.75rem;
    row-gap:.75rem
  }

  .xl\\:row-gap-4{
    grid-row-gap:1rem;
    row-gap:1rem
  }

  .xl\\:row-gap-5{
    grid-row-gap:1.25rem;
    row-gap:1.25rem
  }

  .xl\\:row-gap-6{
    grid-row-gap:1.5rem;
    row-gap:1.5rem
  }

  .xl\\:row-gap-8{
    grid-row-gap:2rem;
    row-gap:2rem
  }

  .xl\\:row-gap-10{
    grid-row-gap:2.5rem;
    row-gap:2.5rem
  }

  .xl\\:row-gap-12{
    grid-row-gap:3rem;
    row-gap:3rem
  }

  .xl\\:row-gap-16{
    grid-row-gap:4rem;
    row-gap:4rem
  }

  .xl\\:row-gap-20{
    grid-row-gap:5rem;
    row-gap:5rem
  }

  .xl\\:row-gap-24{
    grid-row-gap:6rem;
    row-gap:6rem
  }

  .xl\\:row-gap-32{
    grid-row-gap:8rem;
    row-gap:8rem
  }

  .xl\\:row-gap-40{
    grid-row-gap:10rem;
    row-gap:10rem
  }

  .xl\\:row-gap-48{
    grid-row-gap:12rem;
    row-gap:12rem
  }

  .xl\\:row-gap-56{
    grid-row-gap:14rem;
    row-gap:14rem
  }

  .xl\\:row-gap-64{
    grid-row-gap:16rem;
    row-gap:16rem
  }

  .xl\\:row-gap-px{
    grid-row-gap:1px;
    row-gap:1px
  }

  .xl\\:grid-flow-row{
    grid-auto-flow:row
  }

  .xl\\:grid-flow-col{
    grid-auto-flow:column
  }

  .xl\\:grid-flow-row-dense{
    grid-auto-flow:row dense
  }

  .xl\\:grid-flow-col-dense{
    grid-auto-flow:column dense
  }

  .xl\\:grid-cols-1{
    grid-template-columns:repeat(1,minmax(0,1fr))
  }

  .xl\\:grid-cols-2{
    grid-template-columns:repeat(2,minmax(0,1fr))
  }

  .xl\\:grid-cols-3{
    grid-template-columns:repeat(3,minmax(0,1fr))
  }

  .xl\\:grid-cols-4{
    grid-template-columns:repeat(4,minmax(0,1fr))
  }

  .xl\\:grid-cols-5{
    grid-template-columns:repeat(5,minmax(0,1fr))
  }

  .xl\\:grid-cols-6{
    grid-template-columns:repeat(6,minmax(0,1fr))
  }

  .xl\\:grid-cols-7{
    grid-template-columns:repeat(7,minmax(0,1fr))
  }

  .xl\\:grid-cols-8{
    grid-template-columns:repeat(8,minmax(0,1fr))
  }

  .xl\\:grid-cols-9{
    grid-template-columns:repeat(9,minmax(0,1fr))
  }

  .xl\\:grid-cols-10{
    grid-template-columns:repeat(10,minmax(0,1fr))
  }

  .xl\\:grid-cols-11{
    grid-template-columns:repeat(11,minmax(0,1fr))
  }

  .xl\\:grid-cols-12{
    grid-template-columns:repeat(12,minmax(0,1fr))
  }

  .xl\\:grid-cols-none{
    grid-template-columns:none
  }

  .xl\\:col-auto{
    grid-column:auto
  }

  .xl\\:col-span-1{
    grid-column:span 1/span 1
  }

  .xl\\:col-span-2{
    grid-column:span 2/span 2
  }

  .xl\\:col-span-3{
    grid-column:span 3/span 3
  }

  .xl\\:col-span-4{
    grid-column:span 4/span 4
  }

  .xl\\:col-span-5{
    grid-column:span 5/span 5
  }

  .xl\\:col-span-6{
    grid-column:span 6/span 6
  }

  .xl\\:col-span-7{
    grid-column:span 7/span 7
  }

  .xl\\:col-span-8{
    grid-column:span 8/span 8
  }

  .xl\\:col-span-9{
    grid-column:span 9/span 9
  }

  .xl\\:col-span-10{
    grid-column:span 10/span 10
  }

  .xl\\:col-span-11{
    grid-column:span 11/span 11
  }

  .xl\\:col-span-12{
    grid-column:span 12/span 12
  }

  .xl\\:col-start-1{
    grid-column-start:1
  }

  .xl\\:col-start-2{
    grid-column-start:2
  }

  .xl\\:col-start-3{
    grid-column-start:3
  }

  .xl\\:col-start-4{
    grid-column-start:4
  }

  .xl\\:col-start-5{
    grid-column-start:5
  }

  .xl\\:col-start-6{
    grid-column-start:6
  }

  .xl\\:col-start-7{
    grid-column-start:7
  }

  .xl\\:col-start-8{
    grid-column-start:8
  }

  .xl\\:col-start-9{
    grid-column-start:9
  }

  .xl\\:col-start-10{
    grid-column-start:10
  }

  .xl\\:col-start-11{
    grid-column-start:11
  }

  .xl\\:col-start-12{
    grid-column-start:12
  }

  .xl\\:col-start-13{
    grid-column-start:13
  }

  .xl\\:col-start-auto{
    grid-column-start:auto
  }

  .xl\\:col-end-1{
    grid-column-end:1
  }

  .xl\\:col-end-2{
    grid-column-end:2
  }

  .xl\\:col-end-3{
    grid-column-end:3
  }

  .xl\\:col-end-4{
    grid-column-end:4
  }

  .xl\\:col-end-5{
    grid-column-end:5
  }

  .xl\\:col-end-6{
    grid-column-end:6
  }

  .xl\\:col-end-7{
    grid-column-end:7
  }

  .xl\\:col-end-8{
    grid-column-end:8
  }

  .xl\\:col-end-9{
    grid-column-end:9
  }

  .xl\\:col-end-10{
    grid-column-end:10
  }

  .xl\\:col-end-11{
    grid-column-end:11
  }

  .xl\\:col-end-12{
    grid-column-end:12
  }

  .xl\\:col-end-13{
    grid-column-end:13
  }

  .xl\\:col-end-auto{
    grid-column-end:auto
  }

  .xl\\:grid-rows-1{
    grid-template-rows:repeat(1,minmax(0,1fr))
  }

  .xl\\:grid-rows-2{
    grid-template-rows:repeat(2,minmax(0,1fr))
  }

  .xl\\:grid-rows-3{
    grid-template-rows:repeat(3,minmax(0,1fr))
  }

  .xl\\:grid-rows-4{
    grid-template-rows:repeat(4,minmax(0,1fr))
  }

  .xl\\:grid-rows-5{
    grid-template-rows:repeat(5,minmax(0,1fr))
  }

  .xl\\:grid-rows-6{
    grid-template-rows:repeat(6,minmax(0,1fr))
  }

  .xl\\:grid-rows-none{
    grid-template-rows:none
  }

  .xl\\:row-auto{
    grid-row:auto
  }

  .xl\\:row-span-1{
    grid-row:span 1/span 1
  }

  .xl\\:row-span-2{
    grid-row:span 2/span 2
  }

  .xl\\:row-span-3{
    grid-row:span 3/span 3
  }

  .xl\\:row-span-4{
    grid-row:span 4/span 4
  }

  .xl\\:row-span-5{
    grid-row:span 5/span 5
  }

  .xl\\:row-span-6{
    grid-row:span 6/span 6
  }

  .xl\\:row-start-1{
    grid-row-start:1
  }

  .xl\\:row-start-2{
    grid-row-start:2
  }

  .xl\\:row-start-3{
    grid-row-start:3
  }

  .xl\\:row-start-4{
    grid-row-start:4
  }

  .xl\\:row-start-5{
    grid-row-start:5
  }

  .xl\\:row-start-6{
    grid-row-start:6
  }

  .xl\\:row-start-7{
    grid-row-start:7
  }

  .xl\\:row-start-auto{
    grid-row-start:auto
  }

  .xl\\:row-end-1{
    grid-row-end:1
  }

  .xl\\:row-end-2{
    grid-row-end:2
  }

  .xl\\:row-end-3{
    grid-row-end:3
  }

  .xl\\:row-end-4{
    grid-row-end:4
  }

  .xl\\:row-end-5{
    grid-row-end:5
  }

  .xl\\:row-end-6{
    grid-row-end:6
  }

  .xl\\:row-end-7{
    grid-row-end:7
  }

  .xl\\:row-end-auto{
    grid-row-end:auto
  }

  .xl\\:transform{
    --transform-translate-x:0;
    --transform-translate-y:0;
    --transform-rotate:0;
    --transform-skew-x:0;
    --transform-skew-y:0;
    --transform-scale-x:1;
    --transform-scale-y:1;
    transform:translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y))
  }

  .xl\\:transform-none{
    transform:none
  }

  .xl\\:origin-center{
    transform-origin:center
  }

  .xl\\:origin-top{
    transform-origin:top
  }

  .xl\\:origin-top-right{
    transform-origin:top right
  }

  .xl\\:origin-right{
    transform-origin:right
  }

  .xl\\:origin-bottom-right{
    transform-origin:bottom right
  }

  .xl\\:origin-bottom{
    transform-origin:bottom
  }

  .xl\\:origin-bottom-left{
    transform-origin:bottom left
  }

  .xl\\:origin-left{
    transform-origin:left
  }

  .xl\\:origin-top-left{
    transform-origin:top left
  }

  .xl\\:scale-0{
    --transform-scale-x:0;
    --transform-scale-y:0
  }

  .xl\\:scale-50{
    --transform-scale-x:.5;
    --transform-scale-y:.5
  }

  .xl\\:scale-75{
    --transform-scale-x:.75;
    --transform-scale-y:.75
  }

  .xl\\:scale-90{
    --transform-scale-x:.9;
    --transform-scale-y:.9
  }

  .xl\\:scale-95{
    --transform-scale-x:.95;
    --transform-scale-y:.95
  }

  .xl\\:scale-100{
    --transform-scale-x:1;
    --transform-scale-y:1
  }

  .xl\\:scale-105{
    --transform-scale-x:1.05;
    --transform-scale-y:1.05
  }

  .xl\\:scale-110{
    --transform-scale-x:1.1;
    --transform-scale-y:1.1
  }

  .xl\\:scale-125{
    --transform-scale-x:1.25;
    --transform-scale-y:1.25
  }

  .xl\\:scale-150{
    --transform-scale-x:1.5;
    --transform-scale-y:1.5
  }

  .xl\\:scale-x-0{
    --transform-scale-x:0
  }

  .xl\\:scale-x-50{
    --transform-scale-x:.5
  }

  .xl\\:scale-x-75{
    --transform-scale-x:.75
  }

  .xl\\:scale-x-90{
    --transform-scale-x:.9
  }

  .xl\\:scale-x-95{
    --transform-scale-x:.95
  }

  .xl\\:scale-x-100{
    --transform-scale-x:1
  }

  .xl\\:scale-x-105{
    --transform-scale-x:1.05
  }

  .xl\\:scale-x-110{
    --transform-scale-x:1.1
  }

  .xl\\:scale-x-125{
    --transform-scale-x:1.25
  }

  .xl\\:scale-x-150{
    --transform-scale-x:1.5
  }

  .xl\\:scale-y-0{
    --transform-scale-y:0
  }

  .xl\\:scale-y-50{
    --transform-scale-y:.5
  }

  .xl\\:scale-y-75{
    --transform-scale-y:.75
  }

  .xl\\:scale-y-90{
    --transform-scale-y:.9
  }

  .xl\\:scale-y-95{
    --transform-scale-y:.95
  }

  .xl\\:scale-y-100{
    --transform-scale-y:1
  }

  .xl\\:scale-y-105{
    --transform-scale-y:1.05
  }

  .xl\\:scale-y-110{
    --transform-scale-y:1.1
  }

  .xl\\:scale-y-125{
    --transform-scale-y:1.25
  }

  .xl\\:scale-y-150{
    --transform-scale-y:1.5
  }

  .xl\\:hover\\:scale-0:hover{
    --transform-scale-x:0;
    --transform-scale-y:0
  }

  .xl\\:hover\\:scale-50:hover{
    --transform-scale-x:.5;
    --transform-scale-y:.5
  }

  .xl\\:hover\\:scale-75:hover{
    --transform-scale-x:.75;
    --transform-scale-y:.75
  }

  .xl\\:hover\\:scale-90:hover{
    --transform-scale-x:.9;
    --transform-scale-y:.9
  }

  .xl\\:hover\\:scale-95:hover{
    --transform-scale-x:.95;
    --transform-scale-y:.95
  }

  .xl\\:hover\\:scale-100:hover{
    --transform-scale-x:1;
    --transform-scale-y:1
  }

  .xl\\:hover\\:scale-105:hover{
    --transform-scale-x:1.05;
    --transform-scale-y:1.05
  }

  .xl\\:hover\\:scale-110:hover{
    --transform-scale-x:1.1;
    --transform-scale-y:1.1
  }

  .xl\\:hover\\:scale-125:hover{
    --transform-scale-x:1.25;
    --transform-scale-y:1.25
  }

  .xl\\:hover\\:scale-150:hover{
    --transform-scale-x:1.5;
    --transform-scale-y:1.5
  }

  .xl\\:hover\\:scale-x-0:hover{
    --transform-scale-x:0
  }

  .xl\\:hover\\:scale-x-50:hover{
    --transform-scale-x:.5
  }

  .xl\\:hover\\:scale-x-75:hover{
    --transform-scale-x:.75
  }

  .xl\\:hover\\:scale-x-90:hover{
    --transform-scale-x:.9
  }

  .xl\\:hover\\:scale-x-95:hover{
    --transform-scale-x:.95
  }

  .xl\\:hover\\:scale-x-100:hover{
    --transform-scale-x:1
  }

  .xl\\:hover\\:scale-x-105:hover{
    --transform-scale-x:1.05
  }

  .xl\\:hover\\:scale-x-110:hover{
    --transform-scale-x:1.1
  }

  .xl\\:hover\\:scale-x-125:hover{
    --transform-scale-x:1.25
  }

  .xl\\:hover\\:scale-x-150:hover{
    --transform-scale-x:1.5
  }

  .xl\\:hover\\:scale-y-0:hover{
    --transform-scale-y:0
  }

  .xl\\:hover\\:scale-y-50:hover{
    --transform-scale-y:.5
  }

  .xl\\:hover\\:scale-y-75:hover{
    --transform-scale-y:.75
  }

  .xl\\:hover\\:scale-y-90:hover{
    --transform-scale-y:.9
  }

  .xl\\:hover\\:scale-y-95:hover{
    --transform-scale-y:.95
  }

  .xl\\:hover\\:scale-y-100:hover{
    --transform-scale-y:1
  }

  .xl\\:hover\\:scale-y-105:hover{
    --transform-scale-y:1.05
  }

  .xl\\:hover\\:scale-y-110:hover{
    --transform-scale-y:1.1
  }

  .xl\\:hover\\:scale-y-125:hover{
    --transform-scale-y:1.25
  }

  .xl\\:hover\\:scale-y-150:hover{
    --transform-scale-y:1.5
  }

  .xl\\:focus\\:scale-0:focus{
    --transform-scale-x:0;
    --transform-scale-y:0
  }

  .xl\\:focus\\:scale-50:focus{
    --transform-scale-x:.5;
    --transform-scale-y:.5
  }

  .xl\\:focus\\:scale-75:focus{
    --transform-scale-x:.75;
    --transform-scale-y:.75
  }

  .xl\\:focus\\:scale-90:focus{
    --transform-scale-x:.9;
    --transform-scale-y:.9
  }

  .xl\\:focus\\:scale-95:focus{
    --transform-scale-x:.95;
    --transform-scale-y:.95
  }

  .xl\\:focus\\:scale-100:focus{
    --transform-scale-x:1;
    --transform-scale-y:1
  }

  .xl\\:focus\\:scale-105:focus{
    --transform-scale-x:1.05;
    --transform-scale-y:1.05
  }

  .xl\\:focus\\:scale-110:focus{
    --transform-scale-x:1.1;
    --transform-scale-y:1.1
  }

  .xl\\:focus\\:scale-125:focus{
    --transform-scale-x:1.25;
    --transform-scale-y:1.25
  }

  .xl\\:focus\\:scale-150:focus{
    --transform-scale-x:1.5;
    --transform-scale-y:1.5
  }

  .xl\\:focus\\:scale-x-0:focus{
    --transform-scale-x:0
  }

  .xl\\:focus\\:scale-x-50:focus{
    --transform-scale-x:.5
  }

  .xl\\:focus\\:scale-x-75:focus{
    --transform-scale-x:.75
  }

  .xl\\:focus\\:scale-x-90:focus{
    --transform-scale-x:.9
  }

  .xl\\:focus\\:scale-x-95:focus{
    --transform-scale-x:.95
  }

  .xl\\:focus\\:scale-x-100:focus{
    --transform-scale-x:1
  }

  .xl\\:focus\\:scale-x-105:focus{
    --transform-scale-x:1.05
  }

  .xl\\:focus\\:scale-x-110:focus{
    --transform-scale-x:1.1
  }

  .xl\\:focus\\:scale-x-125:focus{
    --transform-scale-x:1.25
  }

  .xl\\:focus\\:scale-x-150:focus{
    --transform-scale-x:1.5
  }

  .xl\\:focus\\:scale-y-0:focus{
    --transform-scale-y:0
  }

  .xl\\:focus\\:scale-y-50:focus{
    --transform-scale-y:.5
  }

  .xl\\:focus\\:scale-y-75:focus{
    --transform-scale-y:.75
  }

  .xl\\:focus\\:scale-y-90:focus{
    --transform-scale-y:.9
  }

  .xl\\:focus\\:scale-y-95:focus{
    --transform-scale-y:.95
  }

  .xl\\:focus\\:scale-y-100:focus{
    --transform-scale-y:1
  }

  .xl\\:focus\\:scale-y-105:focus{
    --transform-scale-y:1.05
  }

  .xl\\:focus\\:scale-y-110:focus{
    --transform-scale-y:1.1
  }

  .xl\\:focus\\:scale-y-125:focus{
    --transform-scale-y:1.25
  }

  .xl\\:focus\\:scale-y-150:focus{
    --transform-scale-y:1.5
  }

  .xl\\:rotate-0{
    --transform-rotate:0
  }

  .xl\\:rotate-45{
    --transform-rotate:45deg
  }

  .xl\\:rotate-90{
    --transform-rotate:90deg
  }

  .xl\\:rotate-180{
    --transform-rotate:180deg
  }

  .xl\\:-rotate-180{
    --transform-rotate:-180deg
  }

  .xl\\:-rotate-90{
    --transform-rotate:-90deg
  }

  .xl\\:-rotate-45{
    --transform-rotate:-45deg
  }

  .xl\\:hover\\:rotate-0:hover{
    --transform-rotate:0
  }

  .xl\\:hover\\:rotate-45:hover{
    --transform-rotate:45deg
  }

  .xl\\:hover\\:rotate-90:hover{
    --transform-rotate:90deg
  }

  .xl\\:hover\\:rotate-180:hover{
    --transform-rotate:180deg
  }

  .xl\\:hover\\:-rotate-180:hover{
    --transform-rotate:-180deg
  }

  .xl\\:hover\\:-rotate-90:hover{
    --transform-rotate:-90deg
  }

  .xl\\:hover\\:-rotate-45:hover{
    --transform-rotate:-45deg
  }

  .xl\\:focus\\:rotate-0:focus{
    --transform-rotate:0
  }

  .xl\\:focus\\:rotate-45:focus{
    --transform-rotate:45deg
  }

  .xl\\:focus\\:rotate-90:focus{
    --transform-rotate:90deg
  }

  .xl\\:focus\\:rotate-180:focus{
    --transform-rotate:180deg
  }

  .xl\\:focus\\:-rotate-180:focus{
    --transform-rotate:-180deg
  }

  .xl\\:focus\\:-rotate-90:focus{
    --transform-rotate:-90deg
  }

  .xl\\:focus\\:-rotate-45:focus{
    --transform-rotate:-45deg
  }

  .xl\\:translate-x-0{
    --transform-translate-x:0
  }

  .xl\\:translate-x-1{
    --transform-translate-x:0.25rem
  }

  .xl\\:translate-x-2{
    --transform-translate-x:0.5rem
  }

  .xl\\:translate-x-3{
    --transform-translate-x:0.75rem
  }

  .xl\\:translate-x-4{
    --transform-translate-x:1rem
  }

  .xl\\:translate-x-5{
    --transform-translate-x:1.25rem
  }

  .xl\\:translate-x-6{
    --transform-translate-x:1.5rem
  }

  .xl\\:translate-x-8{
    --transform-translate-x:2rem
  }

  .xl\\:translate-x-10{
    --transform-translate-x:2.5rem
  }

  .xl\\:translate-x-12{
    --transform-translate-x:3rem
  }

  .xl\\:translate-x-16{
    --transform-translate-x:4rem
  }

  .xl\\:translate-x-20{
    --transform-translate-x:5rem
  }

  .xl\\:translate-x-24{
    --transform-translate-x:6rem
  }

  .xl\\:translate-x-32{
    --transform-translate-x:8rem
  }

  .xl\\:translate-x-40{
    --transform-translate-x:10rem
  }

  .xl\\:translate-x-48{
    --transform-translate-x:12rem
  }

  .xl\\:translate-x-56{
    --transform-translate-x:14rem
  }

  .xl\\:translate-x-64{
    --transform-translate-x:16rem
  }

  .xl\\:translate-x-px{
    --transform-translate-x:1px
  }

  .xl\\:-translate-x-1{
    --transform-translate-x:-0.25rem
  }

  .xl\\:-translate-x-2{
    --transform-translate-x:-0.5rem
  }

  .xl\\:-translate-x-3{
    --transform-translate-x:-0.75rem
  }

  .xl\\:-translate-x-4{
    --transform-translate-x:-1rem
  }

  .xl\\:-translate-x-5{
    --transform-translate-x:-1.25rem
  }

  .xl\\:-translate-x-6{
    --transform-translate-x:-1.5rem
  }

  .xl\\:-translate-x-8{
    --transform-translate-x:-2rem
  }

  .xl\\:-translate-x-10{
    --transform-translate-x:-2.5rem
  }

  .xl\\:-translate-x-12{
    --transform-translate-x:-3rem
  }

  .xl\\:-translate-x-16{
    --transform-translate-x:-4rem
  }

  .xl\\:-translate-x-20{
    --transform-translate-x:-5rem
  }

  .xl\\:-translate-x-24{
    --transform-translate-x:-6rem
  }

  .xl\\:-translate-x-32{
    --transform-translate-x:-8rem
  }

  .xl\\:-translate-x-40{
    --transform-translate-x:-10rem
  }

  .xl\\:-translate-x-48{
    --transform-translate-x:-12rem
  }

  .xl\\:-translate-x-56{
    --transform-translate-x:-14rem
  }

  .xl\\:-translate-x-64{
    --transform-translate-x:-16rem
  }

  .xl\\:-translate-x-px{
    --transform-translate-x:-1px
  }

  .xl\\:-translate-x-full{
    --transform-translate-x:-100%
  }

  .xl\\:-translate-x-1\\/2{
    --transform-translate-x:-50%
  }

  .xl\\:translate-x-1\\/2{
    --transform-translate-x:50%
  }

  .xl\\:translate-x-full{
    --transform-translate-x:100%
  }

  .xl\\:translate-y-0{
    --transform-translate-y:0
  }

  .xl\\:translate-y-1{
    --transform-translate-y:0.25rem
  }

  .xl\\:translate-y-2{
    --transform-translate-y:0.5rem
  }

  .xl\\:translate-y-3{
    --transform-translate-y:0.75rem
  }

  .xl\\:translate-y-4{
    --transform-translate-y:1rem
  }

  .xl\\:translate-y-5{
    --transform-translate-y:1.25rem
  }

  .xl\\:translate-y-6{
    --transform-translate-y:1.5rem
  }

  .xl\\:translate-y-8{
    --transform-translate-y:2rem
  }

  .xl\\:translate-y-10{
    --transform-translate-y:2.5rem
  }

  .xl\\:translate-y-12{
    --transform-translate-y:3rem
  }

  .xl\\:translate-y-16{
    --transform-translate-y:4rem
  }

  .xl\\:translate-y-20{
    --transform-translate-y:5rem
  }

  .xl\\:translate-y-24{
    --transform-translate-y:6rem
  }

  .xl\\:translate-y-32{
    --transform-translate-y:8rem
  }

  .xl\\:translate-y-40{
    --transform-translate-y:10rem
  }

  .xl\\:translate-y-48{
    --transform-translate-y:12rem
  }

  .xl\\:translate-y-56{
    --transform-translate-y:14rem
  }

  .xl\\:translate-y-64{
    --transform-translate-y:16rem
  }

  .xl\\:translate-y-px{
    --transform-translate-y:1px
  }

  .xl\\:-translate-y-1{
    --transform-translate-y:-0.25rem
  }

  .xl\\:-translate-y-2{
    --transform-translate-y:-0.5rem
  }

  .xl\\:-translate-y-3{
    --transform-translate-y:-0.75rem
  }

  .xl\\:-translate-y-4{
    --transform-translate-y:-1rem
  }

  .xl\\:-translate-y-5{
    --transform-translate-y:-1.25rem
  }

  .xl\\:-translate-y-6{
    --transform-translate-y:-1.5rem
  }

  .xl\\:-translate-y-8{
    --transform-translate-y:-2rem
  }

  .xl\\:-translate-y-10{
    --transform-translate-y:-2.5rem
  }

  .xl\\:-translate-y-12{
    --transform-translate-y:-3rem
  }

  .xl\\:-translate-y-16{
    --transform-translate-y:-4rem
  }

  .xl\\:-translate-y-20{
    --transform-translate-y:-5rem
  }

  .xl\\:-translate-y-24{
    --transform-translate-y:-6rem
  }

  .xl\\:-translate-y-32{
    --transform-translate-y:-8rem
  }

  .xl\\:-translate-y-40{
    --transform-translate-y:-10rem
  }

  .xl\\:-translate-y-48{
    --transform-translate-y:-12rem
  }

  .xl\\:-translate-y-56{
    --transform-translate-y:-14rem
  }

  .xl\\:-translate-y-64{
    --transform-translate-y:-16rem
  }

  .xl\\:-translate-y-px{
    --transform-translate-y:-1px
  }

  .xl\\:-translate-y-full{
    --transform-translate-y:-100%
  }

  .xl\\:-translate-y-1\\/2{
    --transform-translate-y:-50%
  }

  .xl\\:translate-y-1\\/2{
    --transform-translate-y:50%
  }

  .xl\\:translate-y-full{
    --transform-translate-y:100%
  }

  .xl\\:hover\\:translate-x-0:hover{
    --transform-translate-x:0
  }

  .xl\\:hover\\:translate-x-1:hover{
    --transform-translate-x:0.25rem
  }

  .xl\\:hover\\:translate-x-2:hover{
    --transform-translate-x:0.5rem
  }

  .xl\\:hover\\:translate-x-3:hover{
    --transform-translate-x:0.75rem
  }

  .xl\\:hover\\:translate-x-4:hover{
    --transform-translate-x:1rem
  }

  .xl\\:hover\\:translate-x-5:hover{
    --transform-translate-x:1.25rem
  }

  .xl\\:hover\\:translate-x-6:hover{
    --transform-translate-x:1.5rem
  }

  .xl\\:hover\\:translate-x-8:hover{
    --transform-translate-x:2rem
  }

  .xl\\:hover\\:translate-x-10:hover{
    --transform-translate-x:2.5rem
  }

  .xl\\:hover\\:translate-x-12:hover{
    --transform-translate-x:3rem
  }

  .xl\\:hover\\:translate-x-16:hover{
    --transform-translate-x:4rem
  }

  .xl\\:hover\\:translate-x-20:hover{
    --transform-translate-x:5rem
  }

  .xl\\:hover\\:translate-x-24:hover{
    --transform-translate-x:6rem
  }

  .xl\\:hover\\:translate-x-32:hover{
    --transform-translate-x:8rem
  }

  .xl\\:hover\\:translate-x-40:hover{
    --transform-translate-x:10rem
  }

  .xl\\:hover\\:translate-x-48:hover{
    --transform-translate-x:12rem
  }

  .xl\\:hover\\:translate-x-56:hover{
    --transform-translate-x:14rem
  }

  .xl\\:hover\\:translate-x-64:hover{
    --transform-translate-x:16rem
  }

  .xl\\:hover\\:translate-x-px:hover{
    --transform-translate-x:1px
  }

  .xl\\:hover\\:-translate-x-1:hover{
    --transform-translate-x:-0.25rem
  }

  .xl\\:hover\\:-translate-x-2:hover{
    --transform-translate-x:-0.5rem
  }

  .xl\\:hover\\:-translate-x-3:hover{
    --transform-translate-x:-0.75rem
  }

  .xl\\:hover\\:-translate-x-4:hover{
    --transform-translate-x:-1rem
  }

  .xl\\:hover\\:-translate-x-5:hover{
    --transform-translate-x:-1.25rem
  }

  .xl\\:hover\\:-translate-x-6:hover{
    --transform-translate-x:-1.5rem
  }

  .xl\\:hover\\:-translate-x-8:hover{
    --transform-translate-x:-2rem
  }

  .xl\\:hover\\:-translate-x-10:hover{
    --transform-translate-x:-2.5rem
  }

  .xl\\:hover\\:-translate-x-12:hover{
    --transform-translate-x:-3rem
  }

  .xl\\:hover\\:-translate-x-16:hover{
    --transform-translate-x:-4rem
  }

  .xl\\:hover\\:-translate-x-20:hover{
    --transform-translate-x:-5rem
  }

  .xl\\:hover\\:-translate-x-24:hover{
    --transform-translate-x:-6rem
  }

  .xl\\:hover\\:-translate-x-32:hover{
    --transform-translate-x:-8rem
  }

  .xl\\:hover\\:-translate-x-40:hover{
    --transform-translate-x:-10rem
  }

  .xl\\:hover\\:-translate-x-48:hover{
    --transform-translate-x:-12rem
  }

  .xl\\:hover\\:-translate-x-56:hover{
    --transform-translate-x:-14rem
  }

  .xl\\:hover\\:-translate-x-64:hover{
    --transform-translate-x:-16rem
  }

  .xl\\:hover\\:-translate-x-px:hover{
    --transform-translate-x:-1px
  }

  .xl\\:hover\\:-translate-x-full:hover{
    --transform-translate-x:-100%
  }

  .xl\\:hover\\:-translate-x-1\\/2:hover{
    --transform-translate-x:-50%
  }

  .xl\\:hover\\:translate-x-1\\/2:hover{
    --transform-translate-x:50%
  }

  .xl\\:hover\\:translate-x-full:hover{
    --transform-translate-x:100%
  }

  .xl\\:hover\\:translate-y-0:hover{
    --transform-translate-y:0
  }

  .xl\\:hover\\:translate-y-1:hover{
    --transform-translate-y:0.25rem
  }

  .xl\\:hover\\:translate-y-2:hover{
    --transform-translate-y:0.5rem
  }

  .xl\\:hover\\:translate-y-3:hover{
    --transform-translate-y:0.75rem
  }

  .xl\\:hover\\:translate-y-4:hover{
    --transform-translate-y:1rem
  }

  .xl\\:hover\\:translate-y-5:hover{
    --transform-translate-y:1.25rem
  }

  .xl\\:hover\\:translate-y-6:hover{
    --transform-translate-y:1.5rem
  }

  .xl\\:hover\\:translate-y-8:hover{
    --transform-translate-y:2rem
  }

  .xl\\:hover\\:translate-y-10:hover{
    --transform-translate-y:2.5rem
  }

  .xl\\:hover\\:translate-y-12:hover{
    --transform-translate-y:3rem
  }

  .xl\\:hover\\:translate-y-16:hover{
    --transform-translate-y:4rem
  }

  .xl\\:hover\\:translate-y-20:hover{
    --transform-translate-y:5rem
  }

  .xl\\:hover\\:translate-y-24:hover{
    --transform-translate-y:6rem
  }

  .xl\\:hover\\:translate-y-32:hover{
    --transform-translate-y:8rem
  }

  .xl\\:hover\\:translate-y-40:hover{
    --transform-translate-y:10rem
  }

  .xl\\:hover\\:translate-y-48:hover{
    --transform-translate-y:12rem
  }

  .xl\\:hover\\:translate-y-56:hover{
    --transform-translate-y:14rem
  }

  .xl\\:hover\\:translate-y-64:hover{
    --transform-translate-y:16rem
  }

  .xl\\:hover\\:translate-y-px:hover{
    --transform-translate-y:1px
  }

  .xl\\:hover\\:-translate-y-1:hover{
    --transform-translate-y:-0.25rem
  }

  .xl\\:hover\\:-translate-y-2:hover{
    --transform-translate-y:-0.5rem
  }

  .xl\\:hover\\:-translate-y-3:hover{
    --transform-translate-y:-0.75rem
  }

  .xl\\:hover\\:-translate-y-4:hover{
    --transform-translate-y:-1rem
  }

  .xl\\:hover\\:-translate-y-5:hover{
    --transform-translate-y:-1.25rem
  }

  .xl\\:hover\\:-translate-y-6:hover{
    --transform-translate-y:-1.5rem
  }

  .xl\\:hover\\:-translate-y-8:hover{
    --transform-translate-y:-2rem
  }

  .xl\\:hover\\:-translate-y-10:hover{
    --transform-translate-y:-2.5rem
  }

  .xl\\:hover\\:-translate-y-12:hover{
    --transform-translate-y:-3rem
  }

  .xl\\:hover\\:-translate-y-16:hover{
    --transform-translate-y:-4rem
  }

  .xl\\:hover\\:-translate-y-20:hover{
    --transform-translate-y:-5rem
  }

  .xl\\:hover\\:-translate-y-24:hover{
    --transform-translate-y:-6rem
  }

  .xl\\:hover\\:-translate-y-32:hover{
    --transform-translate-y:-8rem
  }

  .xl\\:hover\\:-translate-y-40:hover{
    --transform-translate-y:-10rem
  }

  .xl\\:hover\\:-translate-y-48:hover{
    --transform-translate-y:-12rem
  }

  .xl\\:hover\\:-translate-y-56:hover{
    --transform-translate-y:-14rem
  }

  .xl\\:hover\\:-translate-y-64:hover{
    --transform-translate-y:-16rem
  }

  .xl\\:hover\\:-translate-y-px:hover{
    --transform-translate-y:-1px
  }

  .xl\\:hover\\:-translate-y-full:hover{
    --transform-translate-y:-100%
  }

  .xl\\:hover\\:-translate-y-1\\/2:hover{
    --transform-translate-y:-50%
  }

  .xl\\:hover\\:translate-y-1\\/2:hover{
    --transform-translate-y:50%
  }

  .xl\\:hover\\:translate-y-full:hover{
    --transform-translate-y:100%
  }

  .xl\\:focus\\:translate-x-0:focus{
    --transform-translate-x:0
  }

  .xl\\:focus\\:translate-x-1:focus{
    --transform-translate-x:0.25rem
  }

  .xl\\:focus\\:translate-x-2:focus{
    --transform-translate-x:0.5rem
  }

  .xl\\:focus\\:translate-x-3:focus{
    --transform-translate-x:0.75rem
  }

  .xl\\:focus\\:translate-x-4:focus{
    --transform-translate-x:1rem
  }

  .xl\\:focus\\:translate-x-5:focus{
    --transform-translate-x:1.25rem
  }

  .xl\\:focus\\:translate-x-6:focus{
    --transform-translate-x:1.5rem
  }

  .xl\\:focus\\:translate-x-8:focus{
    --transform-translate-x:2rem
  }

  .xl\\:focus\\:translate-x-10:focus{
    --transform-translate-x:2.5rem
  }

  .xl\\:focus\\:translate-x-12:focus{
    --transform-translate-x:3rem
  }

  .xl\\:focus\\:translate-x-16:focus{
    --transform-translate-x:4rem
  }

  .xl\\:focus\\:translate-x-20:focus{
    --transform-translate-x:5rem
  }

  .xl\\:focus\\:translate-x-24:focus{
    --transform-translate-x:6rem
  }

  .xl\\:focus\\:translate-x-32:focus{
    --transform-translate-x:8rem
  }

  .xl\\:focus\\:translate-x-40:focus{
    --transform-translate-x:10rem
  }

  .xl\\:focus\\:translate-x-48:focus{
    --transform-translate-x:12rem
  }

  .xl\\:focus\\:translate-x-56:focus{
    --transform-translate-x:14rem
  }

  .xl\\:focus\\:translate-x-64:focus{
    --transform-translate-x:16rem
  }

  .xl\\:focus\\:translate-x-px:focus{
    --transform-translate-x:1px
  }

  .xl\\:focus\\:-translate-x-1:focus{
    --transform-translate-x:-0.25rem
  }

  .xl\\:focus\\:-translate-x-2:focus{
    --transform-translate-x:-0.5rem
  }

  .xl\\:focus\\:-translate-x-3:focus{
    --transform-translate-x:-0.75rem
  }

  .xl\\:focus\\:-translate-x-4:focus{
    --transform-translate-x:-1rem
  }

  .xl\\:focus\\:-translate-x-5:focus{
    --transform-translate-x:-1.25rem
  }

  .xl\\:focus\\:-translate-x-6:focus{
    --transform-translate-x:-1.5rem
  }

  .xl\\:focus\\:-translate-x-8:focus{
    --transform-translate-x:-2rem
  }

  .xl\\:focus\\:-translate-x-10:focus{
    --transform-translate-x:-2.5rem
  }

  .xl\\:focus\\:-translate-x-12:focus{
    --transform-translate-x:-3rem
  }

  .xl\\:focus\\:-translate-x-16:focus{
    --transform-translate-x:-4rem
  }

  .xl\\:focus\\:-translate-x-20:focus{
    --transform-translate-x:-5rem
  }

  .xl\\:focus\\:-translate-x-24:focus{
    --transform-translate-x:-6rem
  }

  .xl\\:focus\\:-translate-x-32:focus{
    --transform-translate-x:-8rem
  }

  .xl\\:focus\\:-translate-x-40:focus{
    --transform-translate-x:-10rem
  }

  .xl\\:focus\\:-translate-x-48:focus{
    --transform-translate-x:-12rem
  }

  .xl\\:focus\\:-translate-x-56:focus{
    --transform-translate-x:-14rem
  }

  .xl\\:focus\\:-translate-x-64:focus{
    --transform-translate-x:-16rem
  }

  .xl\\:focus\\:-translate-x-px:focus{
    --transform-translate-x:-1px
  }

  .xl\\:focus\\:-translate-x-full:focus{
    --transform-translate-x:-100%
  }

  .xl\\:focus\\:-translate-x-1\\/2:focus{
    --transform-translate-x:-50%
  }

  .xl\\:focus\\:translate-x-1\\/2:focus{
    --transform-translate-x:50%
  }

  .xl\\:focus\\:translate-x-full:focus{
    --transform-translate-x:100%
  }

  .xl\\:focus\\:translate-y-0:focus{
    --transform-translate-y:0
  }

  .xl\\:focus\\:translate-y-1:focus{
    --transform-translate-y:0.25rem
  }

  .xl\\:focus\\:translate-y-2:focus{
    --transform-translate-y:0.5rem
  }

  .xl\\:focus\\:translate-y-3:focus{
    --transform-translate-y:0.75rem
  }

  .xl\\:focus\\:translate-y-4:focus{
    --transform-translate-y:1rem
  }

  .xl\\:focus\\:translate-y-5:focus{
    --transform-translate-y:1.25rem
  }

  .xl\\:focus\\:translate-y-6:focus{
    --transform-translate-y:1.5rem
  }

  .xl\\:focus\\:translate-y-8:focus{
    --transform-translate-y:2rem
  }

  .xl\\:focus\\:translate-y-10:focus{
    --transform-translate-y:2.5rem
  }

  .xl\\:focus\\:translate-y-12:focus{
    --transform-translate-y:3rem
  }

  .xl\\:focus\\:translate-y-16:focus{
    --transform-translate-y:4rem
  }

  .xl\\:focus\\:translate-y-20:focus{
    --transform-translate-y:5rem
  }

  .xl\\:focus\\:translate-y-24:focus{
    --transform-translate-y:6rem
  }

  .xl\\:focus\\:translate-y-32:focus{
    --transform-translate-y:8rem
  }

  .xl\\:focus\\:translate-y-40:focus{
    --transform-translate-y:10rem
  }

  .xl\\:focus\\:translate-y-48:focus{
    --transform-translate-y:12rem
  }

  .xl\\:focus\\:translate-y-56:focus{
    --transform-translate-y:14rem
  }

  .xl\\:focus\\:translate-y-64:focus{
    --transform-translate-y:16rem
  }

  .xl\\:focus\\:translate-y-px:focus{
    --transform-translate-y:1px
  }

  .xl\\:focus\\:-translate-y-1:focus{
    --transform-translate-y:-0.25rem
  }

  .xl\\:focus\\:-translate-y-2:focus{
    --transform-translate-y:-0.5rem
  }

  .xl\\:focus\\:-translate-y-3:focus{
    --transform-translate-y:-0.75rem
  }

  .xl\\:focus\\:-translate-y-4:focus{
    --transform-translate-y:-1rem
  }

  .xl\\:focus\\:-translate-y-5:focus{
    --transform-translate-y:-1.25rem
  }

  .xl\\:focus\\:-translate-y-6:focus{
    --transform-translate-y:-1.5rem
  }

  .xl\\:focus\\:-translate-y-8:focus{
    --transform-translate-y:-2rem
  }

  .xl\\:focus\\:-translate-y-10:focus{
    --transform-translate-y:-2.5rem
  }

  .xl\\:focus\\:-translate-y-12:focus{
    --transform-translate-y:-3rem
  }

  .xl\\:focus\\:-translate-y-16:focus{
    --transform-translate-y:-4rem
  }

  .xl\\:focus\\:-translate-y-20:focus{
    --transform-translate-y:-5rem
  }

  .xl\\:focus\\:-translate-y-24:focus{
    --transform-translate-y:-6rem
  }

  .xl\\:focus\\:-translate-y-32:focus{
    --transform-translate-y:-8rem
  }

  .xl\\:focus\\:-translate-y-40:focus{
    --transform-translate-y:-10rem
  }

  .xl\\:focus\\:-translate-y-48:focus{
    --transform-translate-y:-12rem
  }

  .xl\\:focus\\:-translate-y-56:focus{
    --transform-translate-y:-14rem
  }

  .xl\\:focus\\:-translate-y-64:focus{
    --transform-translate-y:-16rem
  }

  .xl\\:focus\\:-translate-y-px:focus{
    --transform-translate-y:-1px
  }

  .xl\\:focus\\:-translate-y-full:focus{
    --transform-translate-y:-100%
  }

  .xl\\:focus\\:-translate-y-1\\/2:focus{
    --transform-translate-y:-50%
  }

  .xl\\:focus\\:translate-y-1\\/2:focus{
    --transform-translate-y:50%
  }

  .xl\\:focus\\:translate-y-full:focus{
    --transform-translate-y:100%
  }

  .xl\\:skew-x-0{
    --transform-skew-x:0
  }

  .xl\\:skew-x-3{
    --transform-skew-x:3deg
  }

  .xl\\:skew-x-6{
    --transform-skew-x:6deg
  }

  .xl\\:skew-x-12{
    --transform-skew-x:12deg
  }

  .xl\\:-skew-x-12{
    --transform-skew-x:-12deg
  }

  .xl\\:-skew-x-6{
    --transform-skew-x:-6deg
  }

  .xl\\:-skew-x-3{
    --transform-skew-x:-3deg
  }

  .xl\\:skew-y-0{
    --transform-skew-y:0
  }

  .xl\\:skew-y-3{
    --transform-skew-y:3deg
  }

  .xl\\:skew-y-6{
    --transform-skew-y:6deg
  }

  .xl\\:skew-y-12{
    --transform-skew-y:12deg
  }

  .xl\\:-skew-y-12{
    --transform-skew-y:-12deg
  }

  .xl\\:-skew-y-6{
    --transform-skew-y:-6deg
  }

  .xl\\:-skew-y-3{
    --transform-skew-y:-3deg
  }

  .xl\\:hover\\:skew-x-0:hover{
    --transform-skew-x:0
  }

  .xl\\:hover\\:skew-x-3:hover{
    --transform-skew-x:3deg
  }

  .xl\\:hover\\:skew-x-6:hover{
    --transform-skew-x:6deg
  }

  .xl\\:hover\\:skew-x-12:hover{
    --transform-skew-x:12deg
  }

  .xl\\:hover\\:-skew-x-12:hover{
    --transform-skew-x:-12deg
  }

  .xl\\:hover\\:-skew-x-6:hover{
    --transform-skew-x:-6deg
  }

  .xl\\:hover\\:-skew-x-3:hover{
    --transform-skew-x:-3deg
  }

  .xl\\:hover\\:skew-y-0:hover{
    --transform-skew-y:0
  }

  .xl\\:hover\\:skew-y-3:hover{
    --transform-skew-y:3deg
  }

  .xl\\:hover\\:skew-y-6:hover{
    --transform-skew-y:6deg
  }

  .xl\\:hover\\:skew-y-12:hover{
    --transform-skew-y:12deg
  }

  .xl\\:hover\\:-skew-y-12:hover{
    --transform-skew-y:-12deg
  }

  .xl\\:hover\\:-skew-y-6:hover{
    --transform-skew-y:-6deg
  }

  .xl\\:hover\\:-skew-y-3:hover{
    --transform-skew-y:-3deg
  }

  .xl\\:focus\\:skew-x-0:focus{
    --transform-skew-x:0
  }

  .xl\\:focus\\:skew-x-3:focus{
    --transform-skew-x:3deg
  }

  .xl\\:focus\\:skew-x-6:focus{
    --transform-skew-x:6deg
  }

  .xl\\:focus\\:skew-x-12:focus{
    --transform-skew-x:12deg
  }

  .xl\\:focus\\:-skew-x-12:focus{
    --transform-skew-x:-12deg
  }

  .xl\\:focus\\:-skew-x-6:focus{
    --transform-skew-x:-6deg
  }

  .xl\\:focus\\:-skew-x-3:focus{
    --transform-skew-x:-3deg
  }

  .xl\\:focus\\:skew-y-0:focus{
    --transform-skew-y:0
  }

  .xl\\:focus\\:skew-y-3:focus{
    --transform-skew-y:3deg
  }

  .xl\\:focus\\:skew-y-6:focus{
    --transform-skew-y:6deg
  }

  .xl\\:focus\\:skew-y-12:focus{
    --transform-skew-y:12deg
  }

  .xl\\:focus\\:-skew-y-12:focus{
    --transform-skew-y:-12deg
  }

  .xl\\:focus\\:-skew-y-6:focus{
    --transform-skew-y:-6deg
  }

  .xl\\:focus\\:-skew-y-3:focus{
    --transform-skew-y:-3deg
  }

  .xl\\:transition-none{
    transition-property:none
  }

  .xl\\:transition-all{
    transition-property:all
  }

  .xl\\:transition{
    transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform
  }

  .xl\\:transition-colors{
    transition-property:background-color,border-color,color,fill,stroke
  }

  .xl\\:transition-opacity{
    transition-property:opacity
  }

  .xl\\:transition-shadow{
    transition-property:box-shadow
  }

  .xl\\:transition-transform{
    transition-property:transform
  }

  .xl\\:ease-linear{
    transition-timing-function:linear
  }

  .xl\\:ease-in{
    transition-timing-function:cubic-bezier(.4,0,1,1)
  }

  .xl\\:ease-out{
    transition-timing-function:cubic-bezier(0,0,.2,1)
  }

  .xl\\:ease-in-out{
    transition-timing-function:cubic-bezier(.4,0,.2,1)
  }

  .xl\\:duration-75{
    transition-duration:75ms
  }

  .xl\\:duration-100{
    transition-duration:.1s
  }

  .xl\\:duration-150{
    transition-duration:.15s
  }

  .xl\\:duration-200{
    transition-duration:.2s
  }

  .xl\\:duration-300{
    transition-duration:.3s
  }

  .xl\\:duration-500{
    transition-duration:.5s
  }

  .xl\\:duration-700{
    transition-duration:.7s
  }

  .xl\\:duration-1000{
    transition-duration:1s
  }

  .xl\\:delay-75{
    transition-delay:75ms
  }

  .xl\\:delay-100{
    transition-delay:.1s
  }

  .xl\\:delay-150{
    transition-delay:.15s
  }

  .xl\\:delay-200{
    transition-delay:.2s
  }

  .xl\\:delay-300{
    transition-delay:.3s
  }

  .xl\\:delay-500{
    transition-delay:.5s
  }

  .xl\\:delay-700{
    transition-delay:.7s
  }

  .xl\\:delay-1000{
    transition-delay:1s
  }

  .xl\\:shadow-outline-white{
    box-shadow:0 0 0 3px #ffffff73
  }

  .xl\\:shadow-outline-black{
    box-shadow:0 0 0 3px #00000073
  }

  .xl\\:shadow-outline-gray{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .xl\\:shadow-outline-cool-gray{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .xl\\:shadow-outline-red{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .xl\\:shadow-outline-orange{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .xl\\:shadow-outline-yellow{
    box-shadow:0 0 0 3px #faca1573
  }

  .xl\\:shadow-outline-green{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .xl\\:shadow-outline-teal{
    box-shadow:0 0 0 3px #7edce273
  }

  .xl\\:shadow-outline-blue{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .xl\\:shadow-outline-indigo{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .xl\\:shadow-outline-indigo{
    box-shadow:0 0 0 3px #cabffd73
  }

  .xl\\:shadow-outline-pink{
    box-shadow:0 0 0 3px #f8b4d973
  }

  .xl\\:hover\\:shadow-outline-white:hover{
    box-shadow:0 0 0 3px #ffffff73
  }

  .xl\\:hover\\:shadow-outline-black:hover{
    box-shadow:0 0 0 3px #00000073
  }

  .xl\\:hover\\:shadow-outline-gray:hover{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .xl\\:hover\\:shadow-outline-cool-gray:hover{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .xl\\:hover\\:shadow-outline-red:hover{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .xl\\:hover\\:shadow-outline-orange:hover{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .xl\\:hover\\:shadow-outline-yellow:hover{
    box-shadow:0 0 0 3px #faca1573
  }

  .xl\\:hover\\:shadow-outline-green:hover{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .xl\\:hover\\:shadow-outline-teal:hover{
    box-shadow:0 0 0 3px #7edce273
  }

  .xl\\:hover\\:shadow-outline-blue:hover{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .xl\\:hover\\:shadow-outline-indigo:hover{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .xl\\:hover\\:shadow-outline-indigo:hover{
    box-shadow:0 0 0 3px #cabffd73
  }

  .xl\\:hover\\:shadow-outline-pink:hover{
    box-shadow:0 0 0 3px #f8b4d973
  }

  .xl\\:focus\\:shadow-outline-white:focus{
    box-shadow:0 0 0 3px #ffffff73
  }

  .xl\\:focus\\:shadow-outline-black:focus{
    box-shadow:0 0 0 3px #00000073
  }

  .xl\\:focus\\:shadow-outline-gray:focus{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .xl\\:focus\\:shadow-outline-cool-gray:focus{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .xl\\:focus\\:shadow-outline-red:focus{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .xl\\:focus\\:shadow-outline-orange:focus{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .xl\\:focus\\:shadow-outline-yellow:focus{
    box-shadow:0 0 0 3px #faca1573
  }

  .xl\\:focus\\:shadow-outline-green:focus{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .xl\\:focus\\:shadow-outline-teal:focus{
    box-shadow:0 0 0 3px #7edce273
  }

  .xl\\:focus\\:shadow-outline-blue:focus{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .xl\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .xl\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #cabffd73
  }

  .xl\\:focus\\:shadow-outline-pink:focus{
    box-shadow:0 0 0 3px #f8b4d973
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-outline-white:focus{
    box-shadow:0 0 0 3px #ffffff73
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-outline-black:focus{
    box-shadow:0 0 0 3px #00000073
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-outline-gray:focus{
    box-shadow:0 0 0 3px #d5d6d773
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-outline-cool-gray:focus{
    box-shadow:0 0 0 3px #cfd8e373
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-outline-red:focus{
    box-shadow:0 0 0 3px #f8b4b473
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-outline-orange:focus{
    box-shadow:0 0 0 3px #fdba8c73
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-outline-yellow:focus{
    box-shadow:0 0 0 3px #faca1573
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-outline-green:focus{
    box-shadow:0 0 0 3px #84e1bc73
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-outline-teal:focus{
    box-shadow:0 0 0 3px #7edce273
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-outline-blue:focus{
    box-shadow:0 0 0 3px #a4cafe73
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #b4c6fc73
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-outline-indigo:focus{
    box-shadow:0 0 0 3px #cabffd73
  }

  .theme-dark .xl\\:dark\\:focus\\:shadow-outline-pink:focus{
    box-shadow:0 0 0 3px #f8b4d973
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,2EAA2E;;AAE3E,2EAA2E;;AAAC;EAAK,gBAAgB;EAAC;AAA6B;;AAAC;EAAK;AAAQ;;AAAC;EAAK;AAAa;;AAAC;EAAG,aAAa;EAAC;AAAc;;AAAC;EAAG,kBAAkB;EAAC,QAAQ;EAAC;AAAgB;;AAAC;EAAI,+BAA+B;EAAC;AAAa;;AAAC;EAAE;AAAwB;;AAAC;EAAY,kBAAkB;EAA4E,yBAAyB;EAAC;AAAgC;;AAAC;EAAS;AAAkB;;AAAC;EAAc,+BAA+B;EAAC;AAAa;;AAAC;EAAM;AAAa;;AAAC;EAAQ,aAAa;EAAC,aAAa;EAAC,iBAAiB;EAAC;AAAsB;;AAAC;EAAI;AAAa;;AAAC;EAAI;AAAS;;AAAC;EAAI;AAAiB;;AAAC;EAAsC,mBAAmB;EAAC,cAAc;EAAC,gBAAgB;EAAC;AAAQ;;AAAC;EAAa;AAAgB;;AAAC;EAAc;AAAmB;;AAAC;EAAgD;AAAyB;;AAAC;EAAwH,iBAAiB;EAAC;AAAS;;AAAC;EAA4G;AAA6B;;AAAC;EAAS;AAA0B;;AAAC;EAAO,qBAAqB;EAAC,aAAa;EAAC,aAAa;EAAC,cAAc;EAAC,SAAS;EAAC;AAAkB;;AAAC;EAAS;AAAsB;;AAAC;EAAS;AAAa;;AAAC;EAA6B,qBAAqB;EAAC;AAAS;;AAAC;EAAkF;AAAW;;AAAC;EAAc,4BAA4B;EAAC;AAAmB;;AAAC;EAAyC;AAAuB;;AAAC;EAA6B,yBAAyB;EAAC;AAAY;;AAAC;EAAQ;AAAa;;AAAC;EAAQ;AAAiB;;AAAC;EAAkB;AAAY;;AAAC;EAAmD;AAAQ;;AAAC;EAAO,wBAAwB;EAAC,qBAAqB;EAAC;AAAS;;AAAC;EAAa,kBAAkB;EAAC;AAAyC;;AAAC;EAAe,QAAQ;EAAC;AAAS;;AAAC;EAAM;AAAe;;AAAC;EAAK,wLAAwL;EAAC;AAAe;;AAAC;EAAiB,sBAAsB;EAAC;AAAqB;;AAAC;EAAG;AAAoB;;AAAC;EAAI;AAAkB;;AAAC;EAAS;AAAe;;AAAC;EAAyC;AAAa;;AAAC;EAAqB;AAAc;;AAAC;EAAM;AAAwB;;AAAC;EAAkB,iBAAiB;EAAC;AAAmB;;AAAC;EAAE,aAAa;EAAC;AAAuB;;AAAC;EAAsC,aAAa;EAAC,mBAAmB;EAAC;AAAS;;AAAC;EAAkB;AAAuE;;AAAC;EAA+C,aAAa;EAAC;AAAqB;;AAAC;EAAU,WAAW;EAAC;AAAc;;AAAC;EAAW;AAAU;;AAAC;EAAyB;IAAW;EAAe;AAAC;;AAAC;EAAyB;IAAW;EAAe;AAAC;;AAAC;EAA0B;IAAW;EAAgB;AAAC;;AAAC;EAA0B;IAAW;EAAgB;AAAC;;AAAC;EAAoC,eAAe;EAAC,qBAAqB;EAAC,oBAAoB;EAAC,oBAAoB;EAAC,gBAAgB;EAAC,cAAc;EAAC,eAAe;EAAC;AAAoB;;AAAC;EAAyB,aAAa;EAAC;AAAS;;AAAC;EAAkB,oBAAoB;EAAC,8BAA8B;EAAC;AAAY;;AAAC;EAAuC,eAAe;EAAC,qBAAqB;EAAC,oBAAoB;EAAC,oBAAoB;EAAC,gBAAgB;EAAC,cAAc;EAAC,eAAe;EAAC;AAAoB;;AAAC;EAA4B,aAAa;EAAC;AAAS;;AAAC;EAAqB,oBAAoB;EAAC,8BAA8B;EAAC;AAAY;;AAAC;EAA0C,eAAe;EAAC,qBAAqB;EAAC,oBAAoB;EAAC,oBAAoB;EAAC,gBAAgB;EAAC,cAAc;EAAC,eAAe;EAAC;AAAoB;;AAAC;EAAwB,oBAAoB;EAAC,8BAA8B;EAAC;AAAY;;AAAC;EAAqC,eAAe;EAAC,wDAA6P;EAAkC,wBAAwB;EAAC,qBAAqB;EAAC,sCAAsC;EAAC,2BAA2B;EAAC,2BAA2B;EAAC,oBAAoB;EAAC,oBAAoB;EAAC,gBAAgB;EAAC,cAAc;EAAC,eAAe;EAAC;AAAiC;;AAAC;EAAyB,WAAW;EAAC;AAAa;;AAAC;EAAiB;IAAyB;EAAY;AAAC;;AAAC;EAA+E;IAAa;EAAoB;AAAC;;AAAC;EAAmB,oBAAoB;EAAC,8BAA8B;EAAC;AAAY;;AAAC;EAAuC,eAAe;EAAkC,wBAAwB;EAAC,qBAAqB;EAAC,4BAA4B;EAAC,oBAAoB;EAAC,oBAAoB;EAAC,gBAAgB;EAAC,aAAa;EAAC,oBAAoB;EAAC,aAAa;EAAC,UAAU;EAAC,wBAAwB;EAAC,gBAAgB;EAAC,qBAAqB;EAAC;AAAS;;AAAC;EAAuB,6BAA6B;EAAC,wDAA4P;EAAC,uBAAuB;EAAC,2BAA2B;EAAC,yBAAyB;EAAC;AAAkB;;AAAC;EAAiB;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC,qBAAqB;IAAC,gBAAgB;IAAC;EAAW;AAAC;;AAAC;EAAqB,oBAAoB;EAAC,8BAA8B;EAAC;AAAY;;AAAC;EAAoC,eAAe;EAAkC,wBAAwB;EAAC,qBAAqB;EAAC,4BAA4B;EAAC,oBAAoB;EAAC,kBAAkB;EAAC,gBAAgB;EAAC,aAAa;EAAC,oBAAoB;EAAC,aAAa;EAAC,UAAU;EAAC,wBAAwB;EAAC,gBAAgB;EAAC,qBAAqB;EAAC;AAAS;;AAAC;EAAoB,6BAA6B;EAAC,wDAAkL;EAAC,uBAAuB;EAAC,2BAA2B;EAAC,yBAAyB;EAAC;AAAkB;;AAAC;EAAiB;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC,qBAAqB;IAAC,gBAAgB;IAAC;EAAW;AAAC;;AAAC;EAAkB,oBAAoB;EAAC,8BAA8B;EAAC;AAAY;;AAAC;EAAyC,mBAAmB;EAAC,8CAA8C;EAAC;AAAiD;;AAAC;EAAyC,mBAAmB;EAAC,kDAAkD;EAAC;AAA6C;;AAAC;EAAyC,mBAAmB;EAAC,iDAAiD;EAAC;AAAoD;;AAAC;EAAyC,mBAAmB;EAAC,qDAAqD;EAAC;AAAgD;;AAAC;EAAyC,mBAAmB;EAAC,gDAAgD;EAAC;AAAmD;;AAAC;EAAyC,mBAAmB;EAAC,oDAAoD;EAAC;AAA+C;;AAAC;EAAyC,mBAAmB;EAAC,iDAAiD;EAAC;AAAoD;;AAAC;EAAyC,mBAAmB;EAAC,qDAAqD;EAAC;AAAgD;;AAAC;EAAyC,mBAAmB;EAAC,+CAA+C;EAAC;AAAkD;;AAAC;EAAyC,mBAAmB;EAAC,mDAAmD;EAAC;AAA8C;;AAAC;EAAyC,mBAAmB;EAAC,kDAAkD;EAAC;AAAqD;;AAAC;EAAyC,mBAAmB;EAAC,sDAAsD;EAAC;AAAiD;;AAAC;EAAyC,mBAAmB;EAAC,iDAAiD;EAAC;AAAoD;;AAAC;EAAyC,mBAAmB;EAAC,qDAAqD;EAAC;AAAgD;;AAAC;EAAyC,mBAAmB;EAAC,+CAA+C;EAAC;AAAkD;;AAAC;EAAyC,mBAAmB;EAAC,mDAAmD;EAAC;AAA8C;;AAAC;EAA0C,mBAAmB;EAAC,iDAAiD;EAAC;AAAoD;;AAAC;EAA0C,mBAAmB;EAAC,qDAAqD;EAAC;AAAgD;;AAAC;EAA0C,mBAAmB;EAAC,+CAA+C;EAAC;AAAkD;;AAAC;EAA0C,mBAAmB;EAAC,mDAAmD;EAAC;AAA8C;;AAAC;EAA0C,mBAAmB;EAAC,+CAA+C;EAAC;AAAkD;;AAAC;EAA0C,mBAAmB;EAAC,mDAAmD;EAAC;AAA8C;;AAAC;EAA0C,mBAAmB;EAAC,+CAA+C;EAAC;AAAkD;;AAAC;EAA0C,mBAAmB;EAAC,mDAAmD;EAAC;AAA8C;;AAAC;EAA0C,mBAAmB;EAAC,+CAA+C;EAAC;AAAkD;;AAAC;EAA0C,mBAAmB;EAAC,mDAAmD;EAAC;AAA8C;;AAAC;EAA0C,mBAAmB;EAAC,+CAA+C;EAAC;AAAkD;;AAAC;EAA0C,mBAAmB;EAAC,mDAAmD;EAAC;AAA8C;;AAAC;EAA0C,mBAAmB;EAAC,gDAAgD;EAAC;AAAmD;;AAAC;EAA0C,mBAAmB;EAAC,oDAAoD;EAAC;AAA+C;;AAAC;EAA0C,mBAAmB;EAAC,gDAAgD;EAAC;AAAmD;;AAAC;EAA0C,mBAAmB;EAAC,oDAAoD;EAAC;AAA+C;;AAAC;EAA0C,mBAAmB;EAAC,gDAAgD;EAAC;AAAmD;;AAAC;EAA0C,mBAAmB;EAAC,oDAAoD;EAAC;AAA+C;;AAAC;EAA0C,mBAAmB;EAAC,gDAAgD;EAAC;AAAmD;;AAAC;EAA0C,mBAAmB;EAAC,oDAAoD;EAAC;AAA+C;;AAAC;EAA0C,mBAAmB;EAAC,8CAA8C;EAAC;AAAiD;;AAAC;EAA0C,mBAAmB;EAAC,kDAAkD;EAAC;AAA6C;;AAAC;EAA0C,mBAAmB;EAAC,kDAAkD;EAAC;AAAqD;;AAAC;EAA0C,mBAAmB;EAAC,sDAAsD;EAAC;AAAiD;;AAAC;EAA0C,mBAAmB;EAAC,iDAAiD;EAAC;AAAoD;;AAAC;EAA0C,mBAAmB;EAAC,qDAAqD;EAAC;AAAgD;;AAAC;EAA0C,mBAAmB;EAAC,kDAAkD;EAAC;AAAqD;;AAAC;EAA0C,mBAAmB;EAAC,sDAAsD;EAAC;AAAiD;;AAAC;EAA0C,mBAAmB;EAAC,gDAAgD;EAAC;AAAmD;;AAAC;EAA0C,mBAAmB;EAAC,oDAAoD;EAAC;AAA+C;;AAAC;EAA0C,mBAAmB;EAAC,mDAAmD;EAAC;AAAsD;;AAAC;EAA0C,mBAAmB;EAAC,uDAAuD;EAAC;AAAkD;;AAAC;EAA0C,mBAAmB;EAAC,kDAAkD;EAAC;AAAqD;;AAAC;EAA0C,mBAAmB;EAAC,sDAAsD;EAAC;AAAiD;;AAAC;EAA0C,mBAAmB;EAAC,gDAAgD;EAAC;AAAmD;;AAAC;EAA0C,mBAAmB;EAAC,oDAAoD;EAAC;AAA+C;;AAAC;EAA2C,mBAAmB;EAAC,kDAAkD;EAAC;AAAqD;;AAAC;EAA2C,mBAAmB;EAAC,sDAAsD;EAAC;AAAiD;;AAAC;EAA2C,mBAAmB;EAAC,gDAAgD;EAAC;AAAmD;;AAAC;EAA2C,mBAAmB;EAAC,oDAAoD;EAAC;AAA+C;;AAAC;EAA2C,mBAAmB;EAAC,gDAAgD;EAAC;AAAmD;;AAAC;EAA2C,mBAAmB;EAAC,oDAAoD;EAAC;AAA+C;;AAAC;EAA2C,mBAAmB;EAAC,gDAAgD;EAAC;AAAmD;;AAAC;EAA2C,mBAAmB;EAAC,oDAAoD;EAAC;AAA+C;;AAAC;EAA2C,mBAAmB;EAAC,gDAAgD;EAAC;AAAmD;;AAAC;EAA2C,mBAAmB;EAAC,oDAAoD;EAAC;AAA+C;;AAAC;EAA2C,mBAAmB;EAAC,gDAAgD;EAAC;AAAmD;;AAAC;EAA2C,mBAAmB;EAAC,oDAAoD;EAAC;AAA+C;;AAAC;EAA2C,mBAAmB;EAAC,iDAAiD;EAAC;AAAoD;;AAAC;EAA2C,mBAAmB;EAAC,qDAAqD;EAAC;AAAgD;;AAAC;EAA2C,mBAAmB;EAAC,iDAAiD;EAAC;AAAoD;;AAAC;EAA2C,mBAAmB;EAAC,qDAAqD;EAAC;AAAgD;;AAAC;EAA2C,mBAAmB;EAAC,iDAAiD;EAAC;AAAoD;;AAAC;EAA2C,mBAAmB;EAAC,qDAAqD;EAAC;AAAgD;;AAAC;EAA2C,mBAAmB;EAAC,iDAAiD;EAAC;AAAoD;;AAAC;EAA2C,mBAAmB;EAAC,qDAAqD;EAAC;AAAgD;;AAAC;EAA2C,mBAAmB;EAAC,+CAA+C;EAAC;AAAkD;;AAAC;EAA2C,mBAAmB;EAAC,mDAAmD;EAAC;AAA8C;;AAAC;EAA+C;AAAmB;;AAAC;EAA+C;AAAmB;;AAAC;EAA0C,oBAAoB;EAAC,qDAAqD;EAAC;AAAwD;;AAAC;EAA0C,oBAAoB;EAAC,yDAAyD;EAAC;AAAoD;;AAAC;EAA0C,oBAAoB;EAAC,qDAAqD;EAAC;AAAwD;;AAAC;EAA0C,oBAAoB;EAAC,yDAAyD;EAAC;AAAoD;;AAAC;EAA0C,oBAAoB;EAAC,qDAAqD;EAAC;AAAwD;;AAAC;EAA0C,oBAAoB;EAAC,yDAAyD;EAAC;AAAoD;;AAAC;EAA0C,oBAAoB;EAAC,qDAAqD;EAAC;AAAwD;;AAAC;EAA0C,oBAAoB;EAAC,yDAAyD;EAAC;AAAoD;;AAAC;EAAwC,oBAAoB;EAAC,qDAAqD;EAAC;AAAwD;;AAAC;EAAwC,oBAAoB;EAAC,yDAAyD;EAAC;AAAoD;;AAAC;EAAgD;AAAoB;;AAAC;EAAgD;AAAoB;;AAAC;EAAkD;AAAkB;;AAAC;EAA4C,kBAAkB;EAAC,iBAAiB;EAAC;AAAoD;;AAAC;EAA4C,kBAAkB;EAAC,iBAAiB;EAAC;AAA8C;;AAAC;EAA8C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAmD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAoD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAoD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAoD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAoD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAoD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAoD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAoD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAoD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAoD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA6C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAA8C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAA8C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAoE;AAAkB;;AAAC;EAA8D,kBAAkB;EAAC,iBAAiB;EAAC;AAAoD;;AAAC;EAA8D,kBAAkB;EAAC,iBAAiB;EAAC;AAA8C;;AAAC;EAAgE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAqE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAsE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAsE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAsE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAsE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAsE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAsE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAsE,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAsE,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAsE,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA+D,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkE,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAkE,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAkE,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAkE,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAkE,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAkE,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAgE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAgE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiE,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD;AAAkB;;AAAC;EAAiD;AAAqB;;AAAC;EAAiD;AAAoB;;AAAC;EAAiD;AAAqB;;AAAC;EAAkD;AAAkB;;AAAC;EAAS,UAAU;EAAC,WAAW;EAAC,eAAe;EAAC,SAAS;EAAC,iBAAiB;EAAC,SAAS;EAAC,kBAAkB;EAAC,cAAc;EAAC;AAAkB;;AAAC;EAAa,WAAW;EAAC,QAAQ;EAAC,gBAAgB;EAAC,SAAS;EAAC,eAAe;EAAC,UAAU;EAAC,SAAS;EAAC;AAAkB;;AAAC;EAAsB,UAAU;EAAC,WAAW;EAAC,eAAe;EAAC,SAAS;EAAC,iBAAiB;EAAC,SAAS;EAAC,kBAAkB;EAAC,cAAc;EAAC;AAAkB;;AAAC;EAA0B,WAAW;EAAC,QAAQ;EAAC,gBAAgB;EAAC,SAAS;EAAC,eAAe;EAAC,UAAU;EAAC,SAAS;EAAC;AAAkB;;AAAC;EAAyC;AAAe;;AAAC;EAAU;AAA2B;;AAAC;EAAU;AAA2B;;AAAC;EAAW;AAA4B;;AAAC;EAAgB;AAAwB;;AAAC;EAAU,cAAc;EAAC,qBAAqB;EAAC;AAAoD;;AAAC;EAAU,cAAc;EAAC,qBAAqB;EAAC;AAA8C;;AAAC;EAAY,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAiB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAkB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAkB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAkB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAkB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAkB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAkB,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAkB,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAkB,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAkB,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAW,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAY,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAY,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAY,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAY,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAY,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAY,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAY,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAY,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAY,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAc,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAc,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAc,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAc,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAc,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAc,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAc,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAc,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAc,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAc,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAc,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAY,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAY,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAc,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAc,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAe,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAY,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAa,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6B;AAAwB;;AAAC;EAAuB,cAAc;EAAC,qBAAqB;EAAC;AAAoD;;AAAC;EAAuB,cAAc;EAAC,qBAAqB;EAAC;AAA8C;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAwB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6B;AAAwB;;AAAC;EAAuB,cAAc;EAAC,qBAAqB;EAAC;AAAoD;;AAAC;EAAuB,cAAc;EAAC,qBAAqB;EAAC;AAA8C;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAwB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAyB,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+B;AAAwB;;AAAC;EAAyB,cAAc;EAAC,qBAAqB;EAAC;AAAoD;;AAAC;EAAyB,cAAc;EAAC,qBAAqB;EAAC;AAA8C;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA0B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA6B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA6B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA6B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA6B,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA6B,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAoC;AAAwB;;AAAC;EAA8B,cAAc;EAAC,qBAAqB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,qBAAqB;EAAC;AAA8C;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAqC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAsC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAsC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAsC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAsC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAsC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAsC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAsC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAsC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAsC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAkC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAkC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAkC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAkC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAkC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAkC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAkC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAkC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAkC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAkC,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAkC,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAkC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAkC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAkC;AAAwB;;AAAC;EAA4B,cAAc;EAAC,qBAAqB;EAAC;AAAoD;;AAAC;EAA4B,cAAc;EAAC,qBAAqB;EAAC;AAA8C;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAmC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAoC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAoC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAoC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAoC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAoC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAoC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAoC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAoC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAoC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA6B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiC,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+B,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+C;AAAwB;;AAAC;EAAyC,cAAc;EAAC,qBAAqB;EAAC;AAAoD;;AAAC;EAAyC,cAAc;EAAC,qBAAqB;EAAC;AAA8C;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA0C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+C;AAAwB;;AAAC;EAAyC,cAAc;EAAC,qBAAqB;EAAC;AAAoD;;AAAC;EAAyC,cAAc;EAAC,qBAAqB;EAAC;AAA8C;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA0C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA2C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAiD;AAAwB;;AAAC;EAA2C,cAAc;EAAC,qBAAqB;EAAC;AAAoD;;AAAC;EAA2C,cAAc;EAAC,qBAAqB;EAAC;AAA8C;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAkD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA4C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA+C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA+C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA+C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA+C,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAA+C,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA+C,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA+C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAgD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA6C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAA8C,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAsD;AAAwB;;AAAC;EAAgD,cAAc;EAAC,qBAAqB;EAAC;AAAoD;;AAAC;EAAgD,cAAc;EAAC,qBAAqB;EAAC;AAA8C;;AAAC;EAAkD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAuD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAwD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAwD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAwD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAwD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAwD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAwD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAwD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAwD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAwD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAiD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAkD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAkD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAkD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAkD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAkD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAkD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAkD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAkD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAkD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAoD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAoD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAoD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAoD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAoD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAoD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAoD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAoD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAoD,cAAc;EAAC,wBAAwB;EAAC;AAAiD;;AAAC;EAAoD,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAoD,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAkD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAgD;;AAAC;EAAkD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAoD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAoD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAqD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAkD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAoD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAmD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAmD,cAAc;EAAC,wBAAwB;EAAC;AAAkD;;AAAC;EAAc;AAAc;;AAAC;EAAe;AAAgB;;AAAC;EAAe;AAAiB;;AAAC;EAAe;AAAgB;;AAAC;EAAe;AAAiB;;AAAC;EAAgB;AAAc;;AAAC;EAA2B;AAAc;;AAAC;EAA4B;AAAgB;;AAAC;EAA4B;AAAiB;;AAAC;EAA4B;AAAgB;;AAAC;EAA4B;AAAiB;;AAAC;EAA6B;AAAc;;AAAC;EAA2B;AAAc;;AAAC;EAA4B;AAAgB;;AAAC;EAA4B;AAAiB;;AAAC;EAA4B;AAAgB;;AAAC;EAA4B;AAAiB;;AAAC;EAA6B;AAAc;;AAAC;EAA6C;AAAc;;AAAC;EAA8C;AAAgB;;AAAC;EAA8C;AAAiB;;AAAC;EAA8C;AAAgB;;AAAC;EAA8C;AAAiB;;AAAC;EAA+C;AAAc;;AAAC;EAAW;AAA0B;;AAAC;EAAW;AAAuB;;AAAC;EAAS;AAAqB;;AAAC;EAAgB;AAA0B;;AAAC;EAAa;AAAuB;;AAAC;EAAU;AAAwB;;AAAC;EAAiB;AAA6B;;AAAC;EAAc;AAA0B;;AAAC;EAAQ;AAAuB;;AAAC;EAAW;AAAwB;;AAAC;EAAc;AAA2B;;AAAC;EAAa;AAA0B;;AAAC;EAAa;AAA0B;;AAAC;EAAiB;AAAuB;;AAAC;EAAiB;AAAuB;;AAAC;EAAS;AAAoB;;AAAC;EAAU;AAAqB;;AAAC;EAAY;AAAuB;;AAAC;EAAiB;AAAwB;;AAAC;EAAiB;AAAuB;;AAAC;EAAoB;AAAkB;;AAAC;EAAc,kBAAkB;EAAC,iBAAiB;EAAC;AAAoD;;AAAC;EAAc,kBAAkB;EAAC,iBAAiB;EAAC;AAA8C;;AAAC;EAAgB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAqB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAsB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAsB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAsB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAsB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAsB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAsB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAsB,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAsB,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAsB,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAe,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkB,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAkB,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAkB,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAkB,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAkB,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAkB,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAgB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAgB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiB,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiC;AAAkB;;AAAC;EAA2B,kBAAkB;EAAC,iBAAiB;EAAC;AAAoD;;AAAC;EAA2B,kBAAkB;EAAC,iBAAiB;EAAC;AAA8C;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAkC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA4B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiC;AAAkB;;AAAC;EAA2B,kBAAkB;EAAC,iBAAiB;EAAC;AAAoD;;AAAC;EAA2B,kBAAkB;EAAC,iBAAiB;EAAC;AAA8C;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAkC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA4B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA6B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA8B,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAsC;AAAkB;;AAAC;EAAgC,kBAAkB;EAAC,iBAAiB;EAAC;AAAoD;;AAAC;EAAgC,kBAAkB;EAAC,iBAAiB;EAAC;AAA8C;;AAAC;EAAkC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAuC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAwC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAwC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAwC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAwC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAwC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAwC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAwC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAwC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAwC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAiC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAoC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAoC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAoC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAoC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAoC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAoC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAoC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAoC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAoC,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAoC,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAoC,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAkC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAkC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAoC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAoC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAqC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmC,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmD;AAAkB;;AAAC;EAA6C,kBAAkB;EAAC,iBAAiB;EAAC;AAAoD;;AAAC;EAA6C,kBAAkB;EAAC,iBAAiB;EAAC;AAA8C;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAoD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA8C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAmD;AAAkB;;AAAC;EAA6C,kBAAkB;EAAC,iBAAiB;EAAC;AAAoD;;AAAC;EAA6C,kBAAkB;EAAC,iBAAiB;EAAC;AAA8C;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAoD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAqD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAA8C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAiD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAgD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAiD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAA+C,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAoD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAmD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAgD,kBAAkB;EAAC,oBAAoB;EAAC;AAAkD;;AAAC;EAAkB;AAAkB;;AAAC;EAAmB;AAAqB;;AAAC;EAAmB;AAAoB;;AAAC;EAAmB;AAAqB;;AAAC;EAAoB;AAAkB;;AAAC;EAA+B;AAAkB;;AAAC;EAAgC;AAAqB;;AAAC;EAAgC;AAAoB;;AAAC;EAAgC;AAAqB;;AAAC;EAAiC;AAAkB;;AAAC;EAA+B;AAAkB;;AAAC;EAAgC;AAAqB;;AAAC;EAAgC;AAAoB;;AAAC;EAAgC;AAAqB;;AAAC;EAAiC;AAAkB;;AAAC;EAAc;AAAe;;AAAC;EAAY;AAAqB;;AAAC;EAAS;AAAoB;;AAAC;EAAY;AAAqB;;AAAC;EAAY;AAAmB;;AAAC;EAAc;AAAoB;;AAAC;EAAgB,wBAAwB;EAAC;AAAyB;;AAAC;EAAgB,4BAA4B;EAAC;AAAyB;;AAAC;EAAgB,2BAA2B;EAAC;AAA4B;;AAAC;EAAgB,2BAA2B;EAAC;AAAwB;;AAAC;EAAc;AAA8B;;AAAC;EAA4B;AAA+B;;AAAC;EAA4B;AAAkC;;AAAC;EAA4B;AAAiC;;AAAC;EAAc;AAA8B;;AAAC;EAAW;AAA6B;;AAAC;EAAsB;AAA8B;;AAAC;EAAsB;AAAiC;;AAAC;EAAsB;AAAgC;;AAAC;EAAW;AAA6B;;AAAC;EAAc;AAA8B;;AAAC;EAA4B;AAA+B;;AAAC;EAA4B;AAAkC;;AAAC;EAA4B;AAAiC;;AAAC;EAAc;AAA8B;;AAAC;EAAc;AAA4B;;AAAC;EAA4B;AAA6B;;AAAC;EAA4B;AAAgC;;AAAC;EAA4B;AAA+B;;AAAC;EAAc;AAA4B;;AAAC;EAAgB;AAA6B;;AAAC;EAAgC;AAA8B;;AAAC;EAAgC;AAAiC;;AAAC;EAAgC;AAAgC;;AAAC;EAAgB;AAA6B;;AAAC;EAAiB;AAAwB;;AAAC;EAAiB;AAAyB;;AAAC;EAAiB;AAA4B;;AAAC;EAAiB;AAA2B;;AAAC;EAAe;AAA8B;;AAAC;EAAe;AAA+B;;AAAC;EAAe;AAAkC;;AAAC;EAAe;AAAiC;;AAAC;EAAY;AAA6B;;AAAC;EAAY;AAA8B;;AAAC;EAAY;AAAiC;;AAAC;EAAY;AAAgC;;AAAC;EAAe;AAA8B;;AAAC;EAAe;AAA+B;;AAAC;EAAe;AAAkC;;AAAC;EAAe;AAAiC;;AAAC;EAAe;AAA4B;;AAAC;EAAe;AAA6B;;AAAC;EAAe;AAAgC;;AAAC;EAAe;AAA+B;;AAAC;EAAiB;AAA6B;;AAAC;EAAiB;AAA8B;;AAAC;EAAiB;AAAiC;;AAAC;EAAiB;AAAgC;;AAAC;EAAc;AAAkB;;AAAC;EAAe;AAAmB;;AAAC;EAAe;AAAmB;;AAAC;EAAe;AAAmB;;AAAC;EAAa;AAAiB;;AAAC;EAAU;AAAc;;AAAC;EAAU;AAAgB;;AAAC;EAAU;AAAgB;;AAAC;EAAU;AAAgB;;AAAC;EAAQ;AAAgB;;AAAC;EAAY;AAAkB;;AAAC;EAAY;AAAoB;;AAAC;EAAY;AAAqB;;AAAC;EAAY;AAAmB;;AAAC;EAAY;AAAoB;;AAAC;EAAY;AAAsB;;AAAC;EAAY;AAAuB;;AAAC;EAAY;AAAqB;;AAAC;EAAY;AAAoB;;AAAC;EAAY;AAAsB;;AAAC;EAAY;AAAuB;;AAAC;EAAY;AAAqB;;AAAC;EAAY;AAAoB;;AAAC;EAAY;AAAsB;;AAAC;EAAY;AAAuB;;AAAC;EAAY;AAAqB;;AAAC;EAAU;AAAoB;;AAAC;EAAU;AAAsB;;AAAC;EAAU;AAAuB;;AAAC;EAAU;AAAqB;;AAAC;EAAY;AAAqB;;AAAC;EAAa;AAAkB;;AAAC;EAAa;AAAW;;AAAC;EAAgB;AAAc;;AAAC;EAAgB;AAAc;;AAAC;EAAa;AAAW;;AAAC;EAAa;AAAW;;AAAC;EAAa;AAAW;;AAAC;EAAoB;AAAkB;;AAAC;EAAO;AAAa;;AAAC;EAAc;AAAoB;;AAAC;EAAQ;AAAc;;AAAC;EAAM;AAAY;;AAAC;EAAa;AAAmB;;AAAC;EAAO;AAAa;;AAAC;EAAe;AAAqB;;AAAC;EAAY;AAAkB;;AAAC;EAAc;AAAoB;;AAAC;EAAoB;AAA0B;;AAAC;EAAoB;AAA0B;;AAAC;EAAoB;AAA0B;;AAAC;EAAiB;AAAuB;;AAAC;EAAW;AAAiB;;AAAC;EAAW;AAAiB;;AAAC;EAAM;AAAY;;AAAC;EAAa;AAAmB;;AAAC;EAAQ;AAAY;;AAAC;EAAyB;AAAa;;AAAC;EAAgC;AAAoB;;AAAC;EAA0B;AAAc;;AAAC;EAAwB;AAAY;;AAAC;EAA+B;AAAmB;;AAAC;EAAyB;AAAa;;AAAC;EAAiC;AAAqB;;AAAC;EAA8B;AAAkB;;AAAC;EAAgC;AAAoB;;AAAC;EAAsC;AAA0B;;AAAC;EAAsC;AAA0B;;AAAC;EAAsC;AAA0B;;AAAC;EAAmC;AAAuB;;AAAC;EAA6B;AAAiB;;AAAC;EAA6B;AAAiB;;AAAC;EAAwB;AAAY;;AAAC;EAA+B;AAAmB;;AAAC;EAA0B;AAAY;;AAAC;EAAU;AAAkB;;AAAC;EAAkB;AAA0B;;AAAC;EAAU;AAAqB;;AAAC;EAAkB;AAA6B;;AAAC;EAAW;AAAc;;AAAC;EAAmB;AAAsB;;AAAC;EAAc;AAAgB;;AAAC;EAAa;AAAsB;;AAAC;EAAW;AAAoB;;AAAC;EAAc;AAAkB;;AAAC;EAAgB;AAAoB;;AAAC;EAAe;AAAmB;;AAAC;EAAW;AAAe;;AAAC;EAAY;AAAqB;;AAAC;EAAU;AAAmB;;AAAC;EAAa;AAAiB;;AAAC;EAAc;AAAkB;;AAAC;EAAe;AAA0B;;AAAC;EAAa;AAAwB;;AAAC;EAAgB;AAAsB;;AAAC;EAAiB;AAA6B;;AAAC;EAAgB;AAA4B;;AAAC;EAAgB;AAA4B;;AAAC;EAAgB;AAAoB;;AAAC;EAAe;AAAwB;;AAAC;EAAa;AAAsB;;AAAC;EAAiB;AAA2B;;AAAC;EAAgB;AAA0B;;AAAC;EAAQ;AAAW;;AAAC;EAAW;AAAa;;AAAC;EAAc;AAAa;;AAAC;EAAW;AAAS;;AAAC;EAAa;AAAW;;AAAC;EAAW;AAAW;;AAAC;EAAe;AAAa;;AAAC;EAAa;AAAa;;AAAC;EAAS;AAAO;;AAAC;EAAS;AAAO;;AAAC;EAAS;AAAO;;AAAC;EAAS;AAAO;;AAAC;EAAS;AAAO;;AAAC;EAAS;AAAO;;AAAC;EAAS;AAAO;;AAAC;EAAS;AAAO;;AAAC;EAAS;AAAO;;AAAC;EAAU;AAAQ;;AAAC;EAAU;AAAQ;;AAAC;EAAU;AAAQ;;AAAC;EAAa;AAAW;;AAAC;EAAY;AAAU;;AAAC;EAAY;AAAO;;AAAC;EAAa;AAAW;;AAAC;EAAY;AAAU;;AAAC;EAAY;AAAU;;AAAC;EAAgB,UAAU;EAAC,UAAU;EAAC;AAAa;;AAAC;EAAY;AAAU;;AAAC;EAAa;AAAW;;AAAC;EAAY;AAAU;;AAAC;EAAY;AAAU;;AAAC;EAAW;AAAwL;;AAAC;EAAY;AAAuD;;AAAC;EAAW;AAAuE;;AAAC;EAAe;AAAe;;AAAC;EAAW;AAAe;;AAAC;EAAY;AAAe;;AAAC;EAAa;AAAe;;AAAC;EAAa;AAAe;;AAAC;EAAe;AAAe;;AAAC;EAAW;AAAe;;AAAC;EAAgB;AAAe;;AAAC;EAAY;AAAe;;AAAC;EAA4B;AAAe;;AAAC;EAAwB;AAAe;;AAAC;EAAyB;AAAe;;AAAC;EAA0B;AAAe;;AAAC;EAA0B;AAAe;;AAAC;EAA4B;AAAe;;AAAC;EAAwB;AAAe;;AAAC;EAA6B;AAAe;;AAAC;EAAyB;AAAe;;AAAC;EAA4B;AAAe;;AAAC;EAAwB;AAAe;;AAAC;EAAyB;AAAe;;AAAC;EAA0B;AAAe;;AAAC;EAA0B;AAAe;;AAAC;EAA4B;AAAe;;AAAC;EAAwB;AAAe;;AAAC;EAA6B;AAAe;;AAAC;EAAyB;AAAe;;AAAC;EAAK;AAAQ;;AAAC;EAAK;AAAa;;AAAC;EAAK;AAAY;;AAAC;EAAK;AAAa;;AAAC;EAAK;AAAW;;AAAC;EAAK;AAAc;;AAAC;EAAK;AAAa;;AAAC;EAAK;AAAW;;AAAC;EAAM;AAAa;;AAAC;EAAM;AAAW;;AAAC;EAAM;AAAW;;AAAC;EAAM;AAAW;;AAAC;EAAM;AAAW;;AAAC;EAAM;AAAW;;AAAC;EAAM;AAAY;;AAAC;EAAM;AAAY;;AAAC;EAAM;AAAY;;AAAC;EAAM;AAAY;;AAAC;EAAQ;AAAW;;AAAC;EAAM;AAAU;;AAAC;EAAQ;AAAW;;AAAC;EAAU;AAAY;;AAAC;EAAS;AAAgB;;AAAC;EAAS;AAAiB;;AAAC;EAAW;AAAc;;AAAC;EAAS;AAAkB;;AAAC;EAAS;AAAiB;;AAAC;EAAU;AAAgB;;AAAC;EAAU;AAAkB;;AAAC;EAAU;AAAiB;;AAAC;EAAU;AAAc;;AAAC;EAAU;AAAc;;AAAC;EAAW;AAAkB;;AAAC;EAAW;AAAgB;;AAAC;EAAW;AAAmB;;AAAC;EAAW;AAAkB;;AAAC;EAAW;AAAmB;;AAAC;EAAW;AAAgB;;AAAC;EAAW;AAAmB;;AAAC;EAAY;AAAkB;;AAAC;EAAc;AAAa;;AAAC;EAAe;AAAgB;;AAAC;EAAc;AAAiB;;AAAC;EAAgB;AAAe;;AAAC;EAAiB;AAAiB;;AAAC;EAAe;AAAa;;AAAC;EAAa;AAA0B;;AAAC;EAAc;AAA2B;;AAAC;EAAW;AAAoB;;AAAC;EAAW;AAAoB;;AAAC;EAAc;AAAuB;;AAAC;EAAK;AAAQ;;AAAC;EAAK;AAAa;;AAAC;EAAK;AAAY;;AAAC;EAAK;AAAa;;AAAC;EAAK;AAAW;;AAAC;EAAK;AAAc;;AAAC;EAAK;AAAa;;AAAC;EAAK;AAAW;;AAAC;EAAM;AAAa;;AAAC;EAAM;AAAW;;AAAC;EAAM;AAAW;;AAAC;EAAM;AAAW;;AAAC;EAAM;AAAW;;AAAC;EAAM;AAAW;;AAAC;EAAM;AAAY;;AAAC;EAAM;AAAY;;AAAC;EAAM;AAAY;;AAAC;EAAM;AAAY;;AAAC;EAAQ;AAAW;;AAAC;EAAM;AAAU;;AAAC;EAAM;AAAc;;AAAC;EAAM;AAAa;;AAAC;EAAM;AAAc;;AAAC;EAAM;AAAY;;AAAC;EAAM;AAAe;;AAAC;EAAM;AAAc;;AAAC;EAAM;AAAY;;AAAC;EAAO;AAAc;;AAAC;EAAO;AAAY;;AAAC;EAAO;AAAY;;AAAC;EAAO;AAAY;;AAAC;EAAO;AAAY;;AAAC;EAAO;AAAY;;AAAC;EAAO;AAAa;;AAAC;EAAO;AAAa;;AAAC;EAAO;AAAa;;AAAC;EAAO;AAAa;;AAAC;EAAO;AAAW;;AAAC;EAAM,eAAe;EAAC;AAAY;;AAAC;EAAM,aAAa;EAAC;AAAc;;AAAC;EAAM,oBAAoB;EAAC;AAAiB;;AAAC;EAAM,kBAAkB;EAAC;AAAmB;;AAAC;EAAM,mBAAmB;EAAC;AAAgB;;AAAC;EAAM,iBAAiB;EAAC;AAAkB;;AAAC;EAAM,oBAAoB;EAAC;AAAiB;;AAAC;EAAM,kBAAkB;EAAC;AAAmB;;AAAC;EAAM,kBAAkB;EAAC;AAAe;;AAAC;EAAM,gBAAgB;EAAC;AAAiB;;AAAC;EAAM,qBAAqB;EAAC;AAAkB;;AAAC;EAAM,mBAAmB;EAAC;AAAoB;;AAAC;EAAM,oBAAoB;EAAC;AAAiB;;AAAC;EAAM,kBAAkB;EAAC;AAAmB;;AAAC;EAAM,kBAAkB;EAAC;AAAe;;AAAC;EAAM,gBAAgB;EAAC;AAAiB;;AAAC;EAAO,oBAAoB;EAAC;AAAiB;;AAAC;EAAO,kBAAkB;EAAC;AAAmB;;AAAC;EAAO,kBAAkB;EAAC;AAAe;;AAAC;EAAO,gBAAgB;EAAC;AAAiB;;AAAC;EAAO,kBAAkB;EAAC;AAAe;;AAAC;EAAO,gBAAgB;EAAC;AAAiB;;AAAC;EAAO,kBAAkB;EAAC;AAAe;;AAAC;EAAO,gBAAgB;EAAC;AAAiB;;AAAC;EAAO,kBAAkB;EAAC;AAAe;;AAAC;EAAO,gBAAgB;EAAC;AAAiB;;AAAC;EAAO,kBAAkB;EAAC;AAAe;;AAAC;EAAO,gBAAgB;EAAC;AAAiB;;AAAC;EAAO,mBAAmB;EAAC;AAAgB;;AAAC;EAAO,iBAAiB;EAAC;AAAkB;;AAAC;EAAO,mBAAmB;EAAC;AAAgB;;AAAC;EAAO,iBAAiB;EAAC;AAAkB;;AAAC;EAAO,mBAAmB;EAAC;AAAgB;;AAAC;EAAO,iBAAiB;EAAC;AAAkB;;AAAC;EAAO,mBAAmB;EAAC;AAAgB;;AAAC;EAAO,iBAAiB;EAAC;AAAkB;;AAAC;EAAS,kBAAkB;EAAC;AAAe;;AAAC;EAAS,gBAAgB;EAAC;AAAiB;;AAAC;EAAO,iBAAiB;EAAC;AAAc;;AAAC;EAAO,eAAe;EAAC;AAAgB;;AAAC;EAAO,qBAAqB;EAAC;AAAkB;;AAAC;EAAO,mBAAmB;EAAC;AAAoB;;AAAC;EAAO,oBAAoB;EAAC;AAAiB;;AAAC;EAAO,kBAAkB;EAAC;AAAmB;;AAAC;EAAO,qBAAqB;EAAC;AAAkB;;AAAC;EAAO,mBAAmB;EAAC;AAAoB;;AAAC;EAAO,mBAAmB;EAAC;AAAgB;;AAAC;EAAO,iBAAiB;EAAC;AAAkB;;AAAC;EAAO,sBAAsB;EAAC;AAAmB;;AAAC;EAAO,oBAAoB;EAAC;AAAqB;;AAAC;EAAO,qBAAqB;EAAC;AAAkB;;AAAC;EAAO,mBAAmB;EAAC;AAAoB;;AAAC;EAAO,mBAAmB;EAAC;AAAgB;;AAAC;EAAO,iBAAiB;EAAC;AAAkB;;AAAC;EAAQ,qBAAqB;EAAC;AAAkB;;AAAC;EAAQ,mBAAmB;EAAC;AAAoB;;AAAC;EAAQ,mBAAmB;EAAC;AAAgB;;AAAC;EAAQ,iBAAiB;EAAC;AAAkB;;AAAC;EAAQ,mBAAmB;EAAC;AAAgB;;AAAC;EAAQ,iBAAiB;EAAC;AAAkB;;AAAC;EAAQ,mBAAmB;EAAC;AAAgB;;AAAC;EAAQ,iBAAiB;EAAC;AAAkB;;AAAC;EAAQ,mBAAmB;EAAC;AAAgB;;AAAC;EAAQ,iBAAiB;EAAC;AAAkB;;AAAC;EAAQ,mBAAmB;EAAC;AAAgB;;AAAC;EAAQ,iBAAiB;EAAC;AAAkB;;AAAC;EAAQ,oBAAoB;EAAC;AAAiB;;AAAC;EAAQ,kBAAkB;EAAC;AAAmB;;AAAC;EAAQ,oBAAoB;EAAC;AAAiB;;AAAC;EAAQ,kBAAkB;EAAC;AAAmB;;AAAC;EAAQ,oBAAoB;EAAC;AAAiB;;AAAC;EAAQ,kBAAkB;EAAC;AAAmB;;AAAC;EAAQ,oBAAoB;EAAC;AAAiB;;AAAC;EAAQ,kBAAkB;EAAC;AAAmB;;AAAC;EAAQ,kBAAkB;EAAC;AAAe;;AAAC;EAAQ,gBAAgB;EAAC;AAAiB;;AAAC;EAAM;AAAY;;AAAC;EAAM;AAAc;;AAAC;EAAM;AAAe;;AAAC;EAAM;AAAa;;AAAC;EAAM;AAAiB;;AAAC;EAAM;AAAmB;;AAAC;EAAM;AAAoB;;AAAC;EAAM;AAAkB;;AAAC;EAAM;AAAgB;;AAAC;EAAM;AAAkB;;AAAC;EAAM;AAAmB;;AAAC;EAAM;AAAiB;;AAAC;EAAM;AAAiB;;AAAC;EAAM;AAAmB;;AAAC;EAAM;AAAoB;;AAAC;EAAM;AAAkB;;AAAC;EAAM;AAAe;;AAAC;EAAM;AAAiB;;AAAC;EAAM;AAAkB;;AAAC;EAAM;AAAgB;;AAAC;EAAM;AAAkB;;AAAC;EAAM;AAAoB;;AAAC;EAAM;AAAqB;;AAAC;EAAM;AAAmB;;AAAC;EAAM;AAAiB;;AAAC;EAAM;AAAmB;;AAAC;EAAM;AAAoB;;AAAC;EAAM;AAAkB;;AAAC;EAAM;AAAe;;AAAC;EAAM;AAAiB;;AAAC;EAAM;AAAkB;;AAAC;EAAM;AAAgB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAoB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAe;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAe;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAe;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAe;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAe;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAiB;;AAAC;EAAS;AAAe;;AAAC;EAAS;AAAiB;;AAAC;EAAS;AAAkB;;AAAC;EAAS;AAAgB;;AAAC;EAAO;AAAc;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAe;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAoB;;AAAC;EAAO;AAAqB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAoB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAoB;;AAAC;EAAO;AAAqB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAqB;;AAAC;EAAO;AAAsB;;AAAC;EAAO;AAAoB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAoB;;AAAC;EAAO;AAAqB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAiB;;AAAC;EAAQ;AAAkB;;AAAC;EAAQ;AAAoB;;AAAC;EAAQ;AAAqB;;AAAC;EAAQ;AAAmB;;AAAC;EAAQ;AAAgB;;AAAC;EAAQ;AAAkB;;AAAC;EAAQ;AAAmB;;AAAC;EAAQ;AAAiB;;AAAC;EAAQ;AAAgB;;AAAC;EAAQ;AAAkB;;AAAC;EAAQ;AAAmB;;AAAC;EAAQ;AAAiB;;AAAC;EAAQ;AAAgB;;AAAC;EAAQ;AAAkB;;AAAC;EAAQ;AAAmB;;AAAC;EAAQ;AAAiB;;AAAC;EAAQ;AAAgB;;AAAC;EAAQ;AAAkB;;AAAC;EAAQ;AAAmB;;AAAC;EAAQ;AAAiB;;AAAC;EAAQ;AAAgB;;AAAC;EAAQ;AAAkB;;AAAC;EAAQ;AAAmB;;AAAC;EAAQ;AAAiB;;AAAC;EAAQ;AAAiB;;AAAC;EAAQ;AAAmB;;AAAC;EAAQ;AAAoB;;AAAC;EAAQ;AAAkB;;AAAC;EAAQ;AAAiB;;AAAC;EAAQ;AAAmB;;AAAC;EAAQ;AAAoB;;AAAC;EAAQ;AAAkB;;AAAC;EAAQ;AAAiB;;AAAC;EAAQ;AAAmB;;AAAC;EAAQ;AAAoB;;AAAC;EAAQ;AAAkB;;AAAC;EAAQ;AAAiB;;AAAC;EAAQ;AAAmB;;AAAC;EAAQ;AAAoB;;AAAC;EAAQ;AAAkB;;AAAC;EAAQ;AAAe;;AAAC;EAAQ;AAAiB;;AAAC;EAAQ;AAAkB;;AAAC;EAAQ;AAAgB;;AAAC;EAAsB;AAAQ;;AAAC;EAAsB;AAAa;;AAAC;EAAsB;AAAY;;AAAC;EAAsB;AAAa;;AAAC;EAAsB;AAAW;;AAAC;EAAsB;AAAc;;AAAC;EAAsB;AAAa;;AAAC;EAAsB;AAAW;;AAAC;EAAuB;AAAa;;AAAC;EAAuB;AAAW;;AAAC;EAAuB;AAAW;;AAAC;EAAuB;AAAW;;AAAC;EAAuB;AAAW;;AAAC;EAAuB;AAAW;;AAAC;EAAuB;AAAY;;AAAC;EAAuB;AAAY;;AAAC;EAAuB;AAAY;;AAAC;EAAuB;AAAY;;AAAC;EAAyB;AAAW;;AAAC;EAAuB;AAAU;;AAAC;EAAuB;AAAc;;AAAC;EAAuB;AAAa;;AAAC;EAAuB;AAAc;;AAAC;EAAuB;AAAY;;AAAC;EAAuB;AAAe;;AAAC;EAAuB;AAAc;;AAAC;EAAuB;AAAY;;AAAC;EAAwB;AAAc;;AAAC;EAAwB;AAAY;;AAAC;EAAwB;AAAY;;AAAC;EAAwB;AAAY;;AAAC;EAAwB;AAAY;;AAAC;EAAwB;AAAY;;AAAC;EAAwB;AAAa;;AAAC;EAAwB;AAAa;;AAAC;EAAwB;AAAa;;AAAC;EAAwB;AAAa;;AAAC;EAAwB;AAAW;;AAAC;EAAuB,eAAe;EAAC;AAAY;;AAAC;EAAuB,aAAa;EAAC;AAAc;;AAAC;EAAuB,oBAAoB;EAAC;AAAiB;;AAAC;EAAuB,kBAAkB;EAAC;AAAmB;;AAAC;EAAuB,mBAAmB;EAAC;AAAgB;;AAAC;EAAuB,iBAAiB;EAAC;AAAkB;;AAAC;EAAuB,oBAAoB;EAAC;AAAiB;;AAAC;EAAuB,kBAAkB;EAAC;AAAmB;;AAAC;EAAuB,kBAAkB;EAAC;AAAe;;AAAC;EAAuB,gBAAgB;EAAC;AAAiB;;AAAC;EAAuB,qBAAqB;EAAC;AAAkB;;AAAC;EAAuB,mBAAmB;EAAC;AAAoB;;AAAC;EAAuB,oBAAoB;EAAC;AAAiB;;AAAC;EAAuB,kBAAkB;EAAC;AAAmB;;AAAC;EAAuB,kBAAkB;EAAC;AAAe;;AAAC;EAAuB,gBAAgB;EAAC;AAAiB;;AAAC;EAAwB,oBAAoB;EAAC;AAAiB;;AAAC;EAAwB,kBAAkB;EAAC;AAAmB;;AAAC;EAAwB,kBAAkB;EAAC;AAAe;;AAAC;EAAwB,gBAAgB;EAAC;AAAiB;;AAAC;EAAwB,kBAAkB;EAAC;AAAe;;AAAC;EAAwB,gBAAgB;EAAC;AAAiB;;AAAC;EAAwB,kBAAkB;EAAC;AAAe;;AAAC;EAAwB,gBAAgB;EAAC;AAAiB;;AAAC;EAAwB,kBAAkB;EAAC;AAAe;;AAAC;EAAwB,gBAAgB;EAAC;AAAiB;;AAAC;EAAwB,kBAAkB;EAAC;AAAe;;AAAC;EAAwB,gBAAgB;EAAC;AAAiB;;AAAC;EAAwB,mBAAmB;EAAC;AAAgB;;AAAC;EAAwB,iBAAiB;EAAC;AAAkB;;AAAC;EAAwB,mBAAmB;EAAC;AAAgB;;AAAC;EAAwB,iBAAiB;EAAC;AAAkB;;AAAC;EAAwB,mBAAmB;EAAC;AAAgB;;AAAC;EAAwB,iBAAiB;EAAC;AAAkB;;AAAC;EAAwB,mBAAmB;EAAC;AAAgB;;AAAC;EAAwB,iBAAiB;EAAC;AAAkB;;AAAC;EAA0B,kBAAkB;EAAC;AAAe;;AAAC;EAA0B,gBAAgB;EAAC;AAAiB;;AAAC;EAAwB,iBAAiB;EAAC;AAAc;;AAAC;EAAwB,eAAe;EAAC;AAAgB;;AAAC;EAAwB,qBAAqB;EAAC;AAAkB;;AAAC;EAAwB,mBAAmB;EAAC;AAAoB;;AAAC;EAAwB,oBAAoB;EAAC;AAAiB;;AAAC;EAAwB,kBAAkB;EAAC;AAAmB;;AAAC;EAAwB,qBAAqB;EAAC;AAAkB;;AAAC;EAAwB,mBAAmB;EAAC;AAAoB;;AAAC;EAAwB,mBAAmB;EAAC;AAAgB;;AAAC;EAAwB,iBAAiB;EAAC;AAAkB;;AAAC;EAAwB,sBAAsB;EAAC;AAAmB;;AAAC;EAAwB,oBAAoB;EAAC;AAAqB;;AAAC;EAAwB,qBAAqB;EAAC;AAAkB;;AAAC;EAAwB,mBAAmB;EAAC;AAAoB;;AAAC;EAAwB,mBAAmB;EAAC;AAAgB;;AAAC;EAAwB,iBAAiB;EAAC;AAAkB;;AAAC;EAAyB,qBAAqB;EAAC;AAAkB;;AAAC;EAAyB,mBAAmB;EAAC;AAAoB;;AAAC;EAAyB,mBAAmB;EAAC;AAAgB;;AAAC;EAAyB,iBAAiB;EAAC;AAAkB;;AAAC;EAAyB,mBAAmB;EAAC;AAAgB;;AAAC;EAAyB,iBAAiB;EAAC;AAAkB;;AAAC;EAAyB,mBAAmB;EAAC;AAAgB;;AAAC;EAAyB,iBAAiB;EAAC;AAAkB;;AAAC;EAAyB,mBAAmB;EAAC;AAAgB;;AAAC;EAAyB,iBAAiB;EAAC;AAAkB;;AAAC;EAAyB,mBAAmB;EAAC;AAAgB;;AAAC;EAAyB,iBAAiB;EAAC;AAAkB;;AAAC;EAAyB,oBAAoB;EAAC;AAAiB;;AAAC;EAAyB,kBAAkB;EAAC;AAAmB;;AAAC;EAAyB,oBAAoB;EAAC;AAAiB;;AAAC;EAAyB,kBAAkB;EAAC;AAAmB;;AAAC;EAAyB,oBAAoB;EAAC;AAAiB;;AAAC;EAAyB,kBAAkB;EAAC;AAAmB;;AAAC;EAAyB,oBAAoB;EAAC;AAAiB;;AAAC;EAAyB,kBAAkB;EAAC;AAAmB;;AAAC;EAAyB,kBAAkB;EAAC;AAAe;;AAAC;EAAyB,gBAAgB;EAAC;AAAiB;;AAAC;EAAuB;AAAY;;AAAC;EAAuB;AAAc;;AAAC;EAAuB;AAAe;;AAAC;EAAuB;AAAa;;AAAC;EAAuB;AAAiB;;AAAC;EAAuB;AAAmB;;AAAC;EAAuB;AAAoB;;AAAC;EAAuB;AAAkB;;AAAC;EAAuB;AAAgB;;AAAC;EAAuB;AAAkB;;AAAC;EAAuB;AAAmB;;AAAC;EAAuB;AAAiB;;AAAC;EAAuB;AAAiB;;AAAC;EAAuB;AAAmB;;AAAC;EAAuB;AAAoB;;AAAC;EAAuB;AAAkB;;AAAC;EAAuB;AAAe;;AAAC;EAAuB;AAAiB;;AAAC;EAAuB;AAAkB;;AAAC;EAAuB;AAAgB;;AAAC;EAAuB;AAAkB;;AAAC;EAAuB;AAAoB;;AAAC;EAAuB;AAAqB;;AAAC;EAAuB;AAAmB;;AAAC;EAAuB;AAAiB;;AAAC;EAAuB;AAAmB;;AAAC;EAAuB;AAAoB;;AAAC;EAAuB;AAAkB;;AAAC;EAAuB;AAAe;;AAAC;EAAuB;AAAiB;;AAAC;EAAuB;AAAkB;;AAAC;EAAuB;AAAgB;;AAAC;EAAwB;AAAiB;;AAAC;EAAwB;AAAmB;;AAAC;EAAwB;AAAoB;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAe;;AAAC;EAAwB;AAAiB;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAgB;;AAAC;EAAwB;AAAe;;AAAC;EAAwB;AAAiB;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAgB;;AAAC;EAAwB;AAAe;;AAAC;EAAwB;AAAiB;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAgB;;AAAC;EAAwB;AAAe;;AAAC;EAAwB;AAAiB;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAgB;;AAAC;EAAwB;AAAe;;AAAC;EAAwB;AAAiB;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAgB;;AAAC;EAAwB;AAAgB;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAmB;;AAAC;EAAwB;AAAiB;;AAAC;EAAwB;AAAgB;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAmB;;AAAC;EAAwB;AAAiB;;AAAC;EAAwB;AAAgB;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAmB;;AAAC;EAAwB;AAAiB;;AAAC;EAAwB;AAAgB;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAmB;;AAAC;EAAwB;AAAiB;;AAAC;EAA0B;AAAe;;AAAC;EAA0B;AAAiB;;AAAC;EAA0B;AAAkB;;AAAC;EAA0B;AAAgB;;AAAC;EAAwB;AAAc;;AAAC;EAAwB;AAAgB;;AAAC;EAAwB;AAAiB;;AAAC;EAAwB;AAAe;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAoB;;AAAC;EAAwB;AAAqB;;AAAC;EAAwB;AAAmB;;AAAC;EAAwB;AAAiB;;AAAC;EAAwB;AAAmB;;AAAC;EAAwB;AAAoB;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAoB;;AAAC;EAAwB;AAAqB;;AAAC;EAAwB;AAAmB;;AAAC;EAAwB;AAAgB;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAmB;;AAAC;EAAwB;AAAiB;;AAAC;EAAwB;AAAmB;;AAAC;EAAwB;AAAqB;;AAAC;EAAwB;AAAsB;;AAAC;EAAwB;AAAoB;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAoB;;AAAC;EAAwB;AAAqB;;AAAC;EAAwB;AAAmB;;AAAC;EAAwB;AAAgB;;AAAC;EAAwB;AAAkB;;AAAC;EAAwB;AAAmB;;AAAC;EAAwB;AAAiB;;AAAC;EAAyB;AAAkB;;AAAC;EAAyB;AAAoB;;AAAC;EAAyB;AAAqB;;AAAC;EAAyB;AAAmB;;AAAC;EAAyB;AAAgB;;AAAC;EAAyB;AAAkB;;AAAC;EAAyB;AAAmB;;AAAC;EAAyB;AAAiB;;AAAC;EAAyB;AAAgB;;AAAC;EAAyB;AAAkB;;AAAC;EAAyB;AAAmB;;AAAC;EAAyB;AAAiB;;AAAC;EAAyB;AAAgB;;AAAC;EAAyB;AAAkB;;AAAC;EAAyB;AAAmB;;AAAC;EAAyB;AAAiB;;AAAC;EAAyB;AAAgB;;AAAC;EAAyB;AAAkB;;AAAC;EAAyB;AAAmB;;AAAC;EAAyB;AAAiB;;AAAC;EAAyB;AAAgB;;AAAC;EAAyB;AAAkB;;AAAC;EAAyB;AAAmB;;AAAC;EAAyB;AAAiB;;AAAC;EAAyB;AAAiB;;AAAC;EAAyB;AAAmB;;AAAC;EAAyB;AAAoB;;AAAC;EAAyB;AAAkB;;AAAC;EAAyB;AAAiB;;AAAC;EAAyB;AAAmB;;AAAC;EAAyB;AAAoB;;AAAC;EAAyB;AAAkB;;AAAC;EAAyB;AAAiB;;AAAC;EAAyB;AAAmB;;AAAC;EAAyB;AAAoB;;AAAC;EAAyB;AAAkB;;AAAC;EAAyB;AAAiB;;AAAC;EAAyB;AAAmB;;AAAC;EAAyB;AAAoB;;AAAC;EAAyB;AAAkB;;AAAC;EAAyB;AAAe;;AAAC;EAAyB;AAAiB;;AAAC;EAAyB;AAAkB;;AAAC;EAAyB;AAAgB;;AAAC;EAAS;AAAY;;AAAC;EAAS;AAAiB;;AAAC;EAAS;AAAgB;;AAAC;EAAS;AAAiB;;AAAC;EAAS;AAAe;;AAAC;EAAS;AAAkB;;AAAC;EAAS;AAAiB;;AAAC;EAAS;AAAe;;AAAC;EAAU;AAAiB;;AAAC;EAAU;AAAe;;AAAC;EAAU;AAAe;;AAAC;EAAU;AAAe;;AAAC;EAAU;AAAe;;AAAC;EAAU;AAAe;;AAAC;EAAU;AAAgB;;AAAC;EAAU;AAAgB;;AAAC;EAAU;AAAgB;;AAAC;EAAU;AAAgB;;AAAC;EAAU;AAAgB;;AAAC;EAAU;AAAc;;AAAC;EAAY;AAAc;;AAAC;EAAU;AAAe;;AAAC;EAAU;AAAe;;AAAC;EAAU;AAAe;;AAAC;EAAU;AAAe;;AAAC;EAAU;AAAe;;AAAC;EAAW;AAAe;;AAAC;EAAW;AAAe;;AAAC;EAAW;AAAe;;AAAC;EAAW;AAAe;;AAAC;EAAW;AAAe;;AAAC;EAAY;AAAc;;AAAC;EAAiB;AAAe;;AAAC;EAAiB;AAAe;;AAAC;EAAiB;AAAgB;;AAAC;EAAiB;AAAgB;;AAAC;EAAS;AAAY;;AAAC;EAAY;AAAe;;AAAC;EAAc;AAAgB;;AAAC;EAAS;AAAW;;AAAC;EAAS;AAAgB;;AAAC;EAAS;AAAe;;AAAC;EAAS;AAAgB;;AAAC;EAAS;AAAc;;AAAC;EAAS;AAAiB;;AAAC;EAAS;AAAgB;;AAAC;EAAS;AAAc;;AAAC;EAAU;AAAgB;;AAAC;EAAU;AAAc;;AAAC;EAAU;AAAc;;AAAC;EAAU;AAAc;;AAAC;EAAU;AAAc;;AAAC;EAAU;AAAc;;AAAC;EAAU;AAAe;;AAAC;EAAU;AAAe;;AAAC;EAAU;AAAe;;AAAC;EAAU;AAAe;;AAAC;EAAiD;AAAqB;;AAAC;EAAU;AAAa;;AAAC;EAAgB;AAAkB;;AAAC;EAAc;AAAgB;;AAAC;EAAa;AAAe;;AAAC;EAAa;AAAe;;AAAC;EAAmB;AAAqB;;AAAC;EAAe;AAAsB;;AAAC;EAAe;AAAsB;;AAAC;EAAa;AAAoB;;AAAC;EAAoB;AAA2B;;AAAC;EAAiB;AAAwB;;AAAC;EAAc;AAAqB;;AAAC;EAAqB;AAA4B;;AAAC;EAAkB;AAAyB;;AAAC;EAAY;AAAmB;;AAAC;EAAW;AAAS;;AAAC;EAAY;AAAW;;AAAC;EAAY;AAAU;;AAAC;EAAY;AAAW;;AAAC;EAAa;AAAS;;AAAC;EAAwB;AAAS;;AAAC;EAAyB;AAAW;;AAAC;EAAyB;AAAU;;AAAC;EAAyB;AAAW;;AAAC;EAA0B;AAAS;;AAAC;EAAwB;AAAS;;AAAC;EAAyB;AAAW;;AAAC;EAAyB;AAAU;;AAAC;EAAyB;AAAW;;AAAC;EAA0B;AAAS;;AAAC;EAAyC;AAAS;;AAAC;EAAe;AAAa;;AAAC;EAAiB;AAAe;;AAAC;EAAkB;AAAgB;;AAAC;EAAiB;AAAe;;AAAC;EAAiB;AAAe;;AAAC;EAAiB;AAAe;;AAAC;EAAmB;AAAiB;;AAAC;EAAmB;AAAiB;;AAAC;EAAoB;AAAkB;;AAAC;EAAoB;AAAkB;;AAAC;EAAmB;AAAiB;;AAAC;EAAmB;AAAiB;;AAAC;EAAiB;AAAgC;;AAAC;EAAgB;AAA+B;;AAAC;EAAK;AAAS;;AAAC;EAAK;AAAc;;AAAC;EAAK;AAAa;;AAAC;EAAK;AAAc;;AAAC;EAAK;AAAY;;AAAC;EAAK;AAAe;;AAAC;EAAK;AAAc;;AAAC;EAAK;AAAY;;AAAC;EAAM;AAAc;;AAAC;EAAM;AAAY;;AAAC;EAAM;AAAY;;AAAC;EAAM;AAAY;;AAAC;EAAM;AAAY;;AAAC;EAAM;AAAY;;AAAC;EAAM;AAAa;;AAAC;EAAM;AAAa;;AAAC;EAAM;AAAa;;AAAC;EAAM;AAAa;;AAAC;EAAM;AAAW;;AAAC;EAAM,gBAAgB;EAAC;AAAa;;AAAC;EAAM,cAAc;EAAC;AAAe;;AAAC;EAAM,qBAAqB;EAAC;AAAkB;;AAAC;EAAM,mBAAmB;EAAC;AAAoB;;AAAC;EAAM,oBAAoB;EAAC;AAAiB;;AAAC;EAAM,kBAAkB;EAAC;AAAmB;;AAAC;EAAM,qBAAqB;EAAC;AAAkB;;AAAC;EAAM,mBAAmB;EAAC;AAAoB;;AAAC;EAAM,mBAAmB;EAAC;AAAgB;;AAAC;EAAM,iBAAiB;EAAC;AAAkB;;AAAC;EAAM,sBAAsB;EAAC;AAAmB;;AAAC;EAAM,oBAAoB;EAAC;AAAqB;;AAAC;EAAM,qBAAqB;EAAC;AAAkB;;AAAC;EAAM,mBAAmB;EAAC;AAAoB;;AAAC;EAAM,mBAAmB;EAAC;AAAgB;;AAAC;EAAM,iBAAiB;EAAC;AAAkB;;AAAC;EAAO,qBAAqB;EAAC;AAAkB;;AAAC;EAAO,mBAAmB;EAAC;AAAoB;;AAAC;EAAO,mBAAmB;EAAC;AAAgB;;AAAC;EAAO,iBAAiB;EAAC;AAAkB;;AAAC;EAAO,mBAAmB;EAAC;AAAgB;;AAAC;EAAO,iBAAiB;EAAC;AAAkB;;AAAC;EAAO,mBAAmB;EAAC;AAAgB;;AAAC;EAAO,iBAAiB;EAAC;AAAkB;;AAAC;EAAO,mBAAmB;EAAC;AAAgB;;AAAC;EAAO,iBAAiB;EAAC;AAAkB;;AAAC;EAAO,mBAAmB;EAAC;AAAgB;;AAAC;EAAO,iBAAiB;EAAC;AAAkB;;AAAC;EAAO,oBAAoB;EAAC;AAAiB;;AAAC;EAAO,kBAAkB;EAAC;AAAmB;;AAAC;EAAO,oBAAoB;EAAC;AAAiB;;AAAC;EAAO,kBAAkB;EAAC;AAAmB;;AAAC;EAAO,oBAAoB;EAAC;AAAiB;;AAAC;EAAO,kBAAkB;EAAC;AAAmB;;AAAC;EAAO,oBAAoB;EAAC;AAAiB;;AAAC;EAAO,kBAAkB;EAAC;AAAmB;;AAAC;EAAO,kBAAkB;EAAC;AAAe;;AAAC;EAAO,gBAAgB;EAAC;AAAiB;;AAAC;EAAM;AAAa;;AAAC;EAAM;AAAe;;AAAC;EAAM;AAAgB;;AAAC;EAAM;AAAc;;AAAC;EAAM;AAAkB;;AAAC;EAAM;AAAoB;;AAAC;EAAM;AAAqB;;AAAC;EAAM;AAAmB;;AAAC;EAAM;AAAiB;;AAAC;EAAM;AAAmB;;AAAC;EAAM;AAAoB;;AAAC;EAAM;AAAkB;;AAAC;EAAM;AAAkB;;AAAC;EAAM;AAAoB;;AAAC;EAAM;AAAqB;;AAAC;EAAM;AAAmB;;AAAC;EAAM;AAAgB;;AAAC;EAAM;AAAkB;;AAAC;EAAM;AAAmB;;AAAC;EAAM;AAAiB;;AAAC;EAAM;AAAmB;;AAAC;EAAM;AAAqB;;AAAC;EAAM;AAAsB;;AAAC;EAAM;AAAoB;;AAAC;EAAM;AAAkB;;AAAC;EAAM;AAAoB;;AAAC;EAAM;AAAqB;;AAAC;EAAM;AAAmB;;AAAC;EAAM;AAAgB;;AAAC;EAAM;AAAkB;;AAAC;EAAM;AAAmB;;AAAC;EAAM;AAAiB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAoB;;AAAC;EAAO;AAAqB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAgB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAoB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAoB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAoB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAmB;;AAAC;EAAO;AAAoB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAe;;AAAC;EAAO;AAAiB;;AAAC;EAAO;AAAkB;;AAAC;EAAO;AAAgB;;AAAC;EAAsC;AAAW;;AAAC;EAAgC,uBAAuB;EAAC,UAAU;EAAC;AAAkD;;AAAC;EAAgC,uBAAuB;EAAC,UAAU;EAAC;AAA4C;;AAAC;EAAkC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAuC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAwC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAwC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAwC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAwC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAwC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAwC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAwC,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAwC,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAwC,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAiC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoC,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAoC,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAoC,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAoC,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAoC,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAAoC,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAAkC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAAkC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAmC,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAmD;AAAW;;AAAC;EAA6C,uBAAuB;EAAC,UAAU;EAAC;AAAkD;;AAAC;EAA6C,uBAAuB;EAAC,UAAU;EAAC;AAA4C;;AAAC;EAA+C,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAoD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAA8C,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAA+C,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAA+C,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAA+C,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAA+C,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAA+C,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAA+C,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAA+C,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAA+C,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAA+C,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAiD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAiD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAiD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAiD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAiD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAiD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAiD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAiD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAiD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAiD,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAAiD,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAA+C,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAA+C,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAiD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAiD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAA+C,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAgD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAwD;AAAW;;AAAC;EAAkD,uBAAuB;EAAC,UAAU;EAAC;AAAkD;;AAAC;EAAkD,uBAAuB;EAAC,UAAU;EAAC;AAA4C;;AAAC;EAAoD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAyD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAA0D,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAA0D,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAA0D,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAA0D,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAA0D,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAA0D,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAA0D,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAA0D,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAA0D,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAmD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAsD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAsD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAsD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAsD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAsD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAsD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAsD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAsD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAsD,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAsD,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAAsD,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAAoD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAAoD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAsD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAsD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAuD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqD,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAqE;AAAW;;AAAC;EAA+D,uBAAuB;EAAC,UAAU;EAAC;AAAkD;;AAAC;EAA+D,uBAAuB;EAAC,UAAU;EAAC;AAA4C;;AAAC;EAAiE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAsE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAuE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAuE,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAuE,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAuE,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAgE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAiE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAiE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAiE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAiE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAiE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAiE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAiE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAiE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAiE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAmE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAmE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAmE,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAmE,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAmE,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAmE,uBAAuB;EAAC,aAAa;EAAC;AAA+C;;AAAC;EAAmE,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAAmE,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAAiE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAA8C;;AAAC;EAAiE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAmE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAmE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAiE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAkD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAiD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAkE,uBAAuB;EAAC,aAAa;EAAC;AAAgD;;AAAC;EAAoC;AAAuB;;AAAC;EAAqC;AAA0B;;AAAC;EAAqC;AAAyB;;AAAC;EAAqC;AAA0B;;AAAC;EAAsC;AAAuB;;AAAC;EAAiD;AAAuB;;AAAC;EAAkD;AAA0B;;AAAC;EAAkD;AAAyB;;AAAC;EAAkD;AAA0B;;AAAC;EAAmD;AAAuB;;AAAC;EAAqB;AAAmB;;AAAC;EAAqB;AAAmB;;AAAC;EAAQ;AAAe;;AAAC;EAAO;AAAc;;AAAC;EAAU;AAAiB;;AAAC;EAAU;AAAiB;;AAAC;EAAgC;AAAe;;AAAC;EAAS,QAAQ;EAAC,MAAM;EAAC,OAAO;EAAC;AAAK;;AAAC;EAAY,WAAW;EAAC,SAAS;EAAC,UAAU;EAAC;AAAQ;;AAAC;EAAW,QAAQ;EAAC;AAAK;;AAAC;EAAW,MAAM;EAAC;AAAO;;AAAC;EAAc,WAAW;EAAC;AAAQ;;AAAC;EAAc,SAAS;EAAC;AAAU;;AAAC;EAAO;AAAK;;AAAC;EAAS;AAAO;;AAAC;EAAU;AAAQ;;AAAC;EAAQ;AAAM;;AAAC;EAAU;AAAQ;;AAAC;EAAY;AAAU;;AAAC;EAAa;AAAW;;AAAC;EAAW;AAAS;;AAAC;EAAa;AAAW;;AAAC;EAAU;AAAe;;AAAC;EAAU;AAAiB;;AAAC;EAAQ;AAAW;;AAAC;EAAW;AAA8B;;AAAC;EAAW;AAAgC;;AAAC;EAAQ;AAAsD;;AAAC;EAAW;AAA4D;;AAAC;EAAW;AAA8D;;AAAC;EAAW;AAAgE;;AAAC;EAAY;AAAsC;;AAAC;EAAc;AAAsC;;AAAC;EAAgB;AAA8B;;AAAC;EAAa;AAAe;;AAAC;EAAe;AAAwD;;AAAC;EAAwB;AAA8B;;AAAC;EAAwB;AAAgC;;AAAC;EAAqB;AAAsD;;AAAC;EAAwB;AAA4D;;AAAC;EAAwB;AAA8D;;AAAC;EAAwB;AAAgE;;AAAC;EAAyB;AAAsC;;AAAC;EAA2B;AAAsC;;AAAC;EAA6B;AAA8B;;AAAC;EAA0B;AAAe;;AAAC;EAA4B;AAAwD;;AAAC;EAAwB;AAA8B;;AAAC;EAAwB;AAAgC;;AAAC;EAAqB;AAAsD;;AAAC;EAAwB;AAA4D;;AAAC;EAAwB;AAA8D;;AAAC;EAAwB;AAAgE;;AAAC;EAAyB;AAAsC;;AAAC;EAA2B;AAAsC;;AAAC;EAA6B;AAA8B;;AAAC;EAA0B;AAAe;;AAAC;EAA4B;AAAwD;;AAAC;EAA0C;AAA8B;;AAAC;EAA0C;AAAgC;;AAAC;EAAuC;AAAsD;;AAAC;EAA0C;AAA4D;;AAAC;EAA0C;AAA8D;;AAAC;EAA0C;AAAgE;;AAAC;EAA2C;AAAsC;;AAAC;EAA6C;AAAsC;;AAAC;EAA+C;AAA8B;;AAAC;EAA4C;AAAe;;AAAC;EAA8C;AAAwD;;AAAC;EAAc;AAAiB;;AAAC;EAAgB;AAAmB;;AAAC;EAAU;AAAc;;AAAC;EAAU;AAAc;;AAAC;EAAU;AAAc;;AAAC;EAAY;AAAiB;;AAAC;EAAa;AAAkB;;AAAC;EAAW;AAAe;;AAAC;EAAa;AAAiB;;AAAC;EAAY;AAAgB;;AAAC;EAAc;AAAkB;;AAAC;EAAkB;AAAW;;AAAC;EAAY,gBAAgB;EAAC,UAAU;EAAC;AAA2C;;AAAC;EAAY,gBAAgB;EAAC,UAAU;EAAC;AAAqC;;AAAC;EAAc,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAmB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAoB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAoB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAoB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAoB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAoB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAoB,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAoB,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAoB,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAoB,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAa,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAc,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAc,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAc,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAc,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAc,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAc,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAc,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAc,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAc,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgB,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgB,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgB,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAgB,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAgB,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAAgB,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAAc,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAAc,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiB,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAc,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAe,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+B;AAAW;;AAAC;EAAyB,gBAAgB;EAAC,UAAU;EAAC;AAA2C;;AAAC;EAAyB,gBAAgB;EAAC,UAAU;EAAC;AAAqC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA0B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6C;AAAW;;AAAC;EAAuC,gBAAgB;EAAC,UAAU;EAAC;AAA2C;;AAAC;EAAuC,gBAAgB;EAAC,UAAU;EAAC;AAAqC;;AAAC;EAAyC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAwC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAyC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAyC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAyC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAyC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAyC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAyC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAyC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAyC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAyC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA2C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA2C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA2C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA2C,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA2C,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAAyC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAAyC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAyC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA0C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+B;AAAW;;AAAC;EAAyB,gBAAgB;EAAC,UAAU;EAAC;AAA2C;;AAAC;EAAyB,gBAAgB;EAAC,UAAU;EAAC;AAAqC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA0B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiC;AAAW;;AAAC;EAA2B,gBAAgB;EAAC,UAAU;EAAC;AAA2C;;AAAC;EAA2B,gBAAgB;EAAC,UAAU;EAAC;AAAqC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAkC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA+B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA+B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA+B,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA+B,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA+B,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8B,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAoC;AAAW;;AAAC;EAA8B,gBAAgB;EAAC,UAAU;EAAC;AAA2C;;AAAC;EAA8B,gBAAgB;EAAC,UAAU;EAAC;AAAqC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAqC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAsC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAsC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAsC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAsC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAsC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAsC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAsC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAsC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAsC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA+B,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAkC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAkC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAkC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAkC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAkC,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAkC,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAAkC,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAkC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAkC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAmC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiC,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+D;AAAW;;AAAC;EAAyD,gBAAgB;EAAC,UAAU;EAAC;AAA2C;;AAAC;EAAyD,gBAAgB;EAAC,UAAU;EAAC;AAAqC;;AAAC;EAA2D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAgE,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiE,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiE,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiE,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiE,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiE,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiE,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiE,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAiE,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAiE,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA0D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA2D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6D,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA6D,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA6D,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA6D,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA6D,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA6D,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA2D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA2D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA2D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA4D,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiD;AAAW;;AAAC;EAA2C,gBAAgB;EAAC,UAAU;EAAC;AAA2C;;AAAC;EAA2C,gBAAgB;EAAC,UAAU;EAAC;AAAqC;;AAAC;EAA6C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAmD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAmD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAmD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAmD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA4C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA6C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA6C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA6C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA6C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAmD;AAAW;;AAAC;EAA6C,gBAAgB;EAAC,UAAU;EAAC;AAA2C;;AAAC;EAA6C,gBAAgB;EAAC,UAAU;EAAC;AAAqC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAoD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAqD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAqD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAqD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAqD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAqD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAqD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAqD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAqD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAqD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAA8C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAiD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAiD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAiD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAiD,gBAAgB;EAAC,aAAa;EAAC;AAAwC;;AAAC;EAAiD,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAAiD,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAuC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAiD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAkD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAA+C,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA2C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAA0C;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgD,gBAAgB;EAAC,aAAa;EAAC;AAAyC;;AAAC;EAAgB;AAAgB;;AAAC;EAAiB;AAAmB;;AAAC;EAAiB;AAAkB;;AAAC;EAAiB;AAAmB;;AAAC;EAAkB;AAAgB;;AAAC;EAA6B;AAAgB;;AAAC;EAA8B;AAAmB;;AAAC;EAA8B;AAAkB;;AAAC;EAA8B;AAAmB;;AAAC;EAA+B;AAAgB;;AAAC;EAA6B;AAAgB;;AAAC;EAA8B;AAAmB;;AAAC;EAA8B;AAAkB;;AAAC;EAA8B;AAAmB;;AAAC;EAA+B;AAAgB;;AAAC;EAAQ;AAAiB;;AAAC;EAAY;AAAiB;;AAAC;EAAW;AAAwB;;AAAC;EAAW;AAAwB;;AAAC;EAAY;AAAyB;;AAAC;EAAa;AAAmB;;AAAC;EAA6C;AAAyB;;AAAC;EAAmD;AAA4B;;AAAC;EAA2C;AAAoB;;AAAC;EAA0D;AAAyB;;AAAC;EAAgE;AAA4B;;AAAC;EAAwD;AAAoB;;AAAC;EAA0D;AAAyB;;AAAC;EAAgE;AAA4B;;AAAC;EAAwD;AAAoB;;AAAC;EAAa,kCAAkC;EAAC;AAAiC;;AAAC;EAAsB,2BAA2B;EAAC;AAA4B;;AAAC;EAAkB;AAAqB;;AAAC;EAAgB;AAAsB;;AAAC;EAAiB;AAAgB;;AAAC;EAAe;AAAqB;;AAAC;EAAgB;AAAoB;;AAAC;EAAiB;AAAmB;;AAAC;EAAa,wBAAwB;EAAC;AAAgB;;AAAC;EAAa,wBAAwB;EAAC;AAAgB;;AAAC;EAAY,uBAAuB;EAAC;AAAe;;AAAC;EAAa,wBAAwB;EAAC;AAAgB;;AAAC;EAAgB;AAAsB;;AAAC;EAAW;AAAkB;;AAAC;EAAc;AAAqB;;AAAC;EAAc;AAAqB;;AAAC;EAAgB;AAAuB;;AAAC;EAAmB;AAA0B;;AAAC;EAAS;AAAkB;;AAAC;EAAW;AAAiB;;AAAC;EAAmB;AAAkB;;AAAC;EAAoB;AAAkB;;AAAC;EAAgB;AAAe;;AAAC;EAAqB;AAAoB;;AAAC;EAAqB;AAAoB;;AAAC;EAAc,oBAAoB;EAAC;AAAiB;;AAAC;EAAa;AAAwB;;AAAC;EAAW;AAAoB;;AAAC;EAAU,eAAe;EAAC,sBAAsB;EAAC;AAAkB;;AAAC;EAAK;AAAO;;AAAC;EAAK;AAAY;;AAAC;EAAK;AAAW;;AAAC;EAAK;AAAY;;AAAC;EAAK;AAAU;;AAAC;EAAK;AAAa;;AAAC;EAAK;AAAY;;AAAC;EAAK;AAAU;;AAAC;EAAM;AAAY;;AAAC;EAAM;AAAU;;AAAC;EAAM;AAAU;;AAAC;EAAM;AAAU;;AAAC;EAAM;AAAU;;AAAC;EAAM;AAAU;;AAAC;EAAM;AAAW;;AAAC;EAAM;AAAW;;AAAC;EAAM;AAAW;;AAAC;EAAM;AAAW;;AAAC;EAAQ;AAAU;;AAAC;EAAM;AAAS;;AAAC;EAAQ;AAAS;;AAAC;EAAQ;AAAgB;;AAAC;EAAQ;AAAgB;;AAAC;EAAQ;AAAS;;AAAC;EAAQ;AAAS;;AAAC;EAAQ;AAAS;;AAAC;EAAQ;AAAS;;AAAC;EAAQ;AAAS;;AAAC;EAAQ;AAAS;;AAAC;EAAQ;AAAS;;AAAC;EAAQ;AAAgB;;AAAC;EAAQ;AAAgB;;AAAC;EAAQ;AAAS;;AAAC;EAAQ;AAAgB;;AAAC;EAAQ;AAAgB;;AAAC;EAAS;AAAe;;AAAC;EAAS;AAAgB;;AAAC;EAAS;AAAS;;AAAC;EAAS;AAAgB;;AAAC;EAAS;AAAgB;;AAAC;EAAS;AAAS;;AAAC;EAAS;AAAgB;;AAAC;EAAS;AAAgB;;AAAC;EAAS;AAAS;;AAAC;EAAU;AAAgB;;AAAC;EAAU;AAAgB;;AAAC;EAAQ;AAAU;;AAAC;EAAU;AAAW;;AAAC;EAAK;AAAS;;AAAC;EAAM;AAAU;;AAAC;EAAM;AAAU;;AAAC;EAAM;AAAU;;AAAC;EAAM;AAAU;;AAAC;EAAM;AAAU;;AAAC;EAAQ;AAAY;;AAAC;EAAO,UAAU;EAAC;AAAK;;AAAC;EAAO,eAAe;EAAC;AAAU;;AAAC;EAAO,cAAc;EAAC;AAAS;;AAAC;EAAO,eAAe;EAAC;AAAU;;AAAC;EAAO,aAAa;EAAC;AAAQ;;AAAC;EAAO,gBAAgB;EAAC;AAAW;;AAAC;EAAO,eAAe;EAAC;AAAU;;AAAC;EAAO,aAAa;EAAC;AAAQ;;AAAC;EAAQ,eAAe;EAAC;AAAU;;AAAC;EAAQ,aAAa;EAAC;AAAQ;;AAAC;EAAQ,aAAa;EAAC;AAAQ;;AAAC;EAAQ,aAAa;EAAC;AAAQ;;AAAC;EAAQ,aAAa;EAAC;AAAQ;;AAAC;EAAQ,aAAa;EAAC;AAAQ;;AAAC;EAAQ,cAAc;EAAC;AAAS;;AAAC;EAAQ,cAAc;EAAC;AAAS;;AAAC;EAAQ,cAAc;EAAC;AAAS;;AAAC;EAAQ,cAAc;EAAC;AAAS;;AAAC;EAAQ,YAAY;EAAC;AAAO;;AAAC;EAAW,iBAAiB;EAAC;AAAY;;AAAC;EAAW,sBAAsB;EAAC;AAAiB;;AAAC;EAAW,qBAAqB;EAAC;AAAgB;;AAAC;EAAW,sBAAsB;EAAC;AAAiB;;AAAC;EAAW,oBAAoB;EAAC;AAAe;;AAAC;EAAW,uBAAuB;EAAC;AAAkB;;AAAC;EAAW,sBAAsB;EAAC;AAAiB;;AAAC;EAAW,oBAAoB;EAAC;AAAe;;AAAC;EAAY,sBAAsB;EAAC;AAAiB;;AAAC;EAAY,oBAAoB;EAAC;AAAe;;AAAC;EAAY,oBAAoB;EAAC;AAAe;;AAAC;EAAY,oBAAoB;EAAC;AAAe;;AAAC;EAAY,oBAAoB;EAAC;AAAe;;AAAC;EAAY,oBAAoB;EAAC;AAAe;;AAAC;EAAY,qBAAqB;EAAC;AAAgB;;AAAC;EAAY,qBAAqB;EAAC;AAAgB;;AAAC;EAAY,qBAAqB;EAAC;AAAgB;;AAAC;EAAY,qBAAqB;EAAC;AAAgB;;AAAC;EAAY,mBAAmB;EAAC;AAAc;;AAAC;EAAW,cAAc;EAAC;AAAS;;AAAC;EAAW,mBAAmB;EAAC;AAAc;;AAAC;EAAW,kBAAkB;EAAC;AAAa;;AAAC;EAAW,mBAAmB;EAAC;AAAc;;AAAC;EAAW,iBAAiB;EAAC;AAAY;;AAAC;EAAW,oBAAoB;EAAC;AAAe;;AAAC;EAAW,mBAAmB;EAAC;AAAc;;AAAC;EAAW,iBAAiB;EAAC;AAAY;;AAAC;EAAY,mBAAmB;EAAC;AAAc;;AAAC;EAAY,iBAAiB;EAAC;AAAY;;AAAC;EAAY,iBAAiB;EAAC;AAAY;;AAAC;EAAY,iBAAiB;EAAC;AAAY;;AAAC;EAAY,iBAAiB;EAAC;AAAY;;AAAC;EAAY,iBAAiB;EAAC;AAAY;;AAAC;EAAY,kBAAkB;EAAC;AAAa;;AAAC;EAAY,kBAAkB;EAAC;AAAa;;AAAC;EAAY,kBAAkB;EAAC;AAAa;;AAAC;EAAY,kBAAkB;EAAC;AAAa;;AAAC;EAAY,gBAAgB;EAAC;AAAW;;AAAC;EAAe;AAAkB;;AAAC;EAAe;AAAqB;;AAAC;EAAqB;AAAwB;;AAAC;EAAqB;AAA2B;;AAAC;EAAa;AAA6C;;AAAC;EAAa;AAA6C;;AAAC;EAAa;AAA6C;;AAAC;EAAa;AAA6C;;AAAC;EAAa;AAA6C;;AAAC;EAAa;AAA6C;;AAAC;EAAa;AAA6C;;AAAC;EAAa;AAA6C;;AAAC;EAAa;AAA6C;;AAAC;EAAc;AAA8C;;AAAC;EAAc;AAA8C;;AAAC;EAAc;AAA8C;;AAAC;EAAgB;AAA0B;;AAAC;EAAU;AAAgB;;AAAC;EAAY;AAAyB;;AAAC;EAAY;AAAyB;;AAAC;EAAY;AAAyB;;AAAC;EAAY;AAAyB;;AAAC;EAAY;AAAyB;;AAAC;EAAY;AAAyB;;AAAC;EAAY;AAAyB;;AAAC;EAAY;AAAyB;;AAAC;EAAY;AAAyB;;AAAC;EAAa;AAA2B;;AAAC;EAAa;AAA2B;;AAAC;EAAa;AAA2B;;AAAC;EAAa;AAAmB;;AAAC;EAAa;AAAmB;;AAAC;EAAa;AAAmB;;AAAC;EAAa;AAAmB;;AAAC;EAAa;AAAmB;;AAAC;EAAa;AAAmB;;AAAC;EAAa;AAAmB;;AAAC;EAAa;AAAmB;;AAAC;EAAa;AAAmB;;AAAC;EAAc;AAAoB;;AAAC;EAAc;AAAoB;;AAAC;EAAc;AAAoB;;AAAC;EAAc;AAAoB;;AAAC;EAAgB;AAAsB;;AAAC;EAAW;AAAiB;;AAAC;EAAW;AAAiB;;AAAC;EAAW;AAAiB;;AAAC;EAAW;AAAiB;;AAAC;EAAW;AAAiB;;AAAC;EAAW;AAAiB;;AAAC;EAAW;AAAiB;;AAAC;EAAW;AAAiB;;AAAC;EAAW;AAAiB;;AAAC;EAAY;AAAkB;;AAAC;EAAY;AAAkB;;AAAC;EAAY;AAAkB;;AAAC;EAAY;AAAkB;;AAAC;EAAc;AAAoB;;AAAC;EAAa;AAA0C;;AAAC;EAAa;AAA0C;;AAAC;EAAa;AAA0C;;AAAC;EAAa;AAA0C;;AAAC;EAAa;AAA0C;;AAAC;EAAa;AAA0C;;AAAC;EAAgB;AAAuB;;AAAC;EAAU;AAAa;;AAAC;EAAY;AAAsB;;AAAC;EAAY;AAAsB;;AAAC;EAAY;AAAsB;;AAAC;EAAY;AAAsB;;AAAC;EAAY;AAAsB;;AAAC;EAAY;AAAsB;;AAAC;EAAa;AAAgB;;AAAC;EAAa;AAAgB;;AAAC;EAAa;AAAgB;;AAAC;EAAa;AAAgB;;AAAC;EAAa;AAAgB;;AAAC;EAAa;AAAgB;;AAAC;EAAa;AAAgB;;AAAC;EAAgB;AAAmB;;AAAC;EAAW;AAAc;;AAAC;EAAW;AAAc;;AAAC;EAAW;AAAc;;AAAC;EAAW;AAAc;;AAAC;EAAW;AAAc;;AAAC;EAAW;AAAc;;AAAC;EAAW;AAAc;;AAAC;EAAc;AAAiB;;AAAC;EAAW,yBAAyB;EAAC,yBAAyB;EAAC,oBAAoB;EAAC,oBAAoB;EAAC,oBAAoB;EAAC,qBAAqB;EAAC,qBAAqB;EAAC;AAA2P;;AAAC;EAAgB;AAAc;;AAAC;EAAe;AAAuB;;AAAC;EAAY;AAAoB;;AAAC;EAAkB;AAA0B;;AAAC;EAAc;AAAsB;;AAAC;EAAqB;AAA6B;;AAAC;EAAe;AAAuB;;AAAC;EAAoB;AAA4B;;AAAC;EAAa;AAAqB;;AAAC;EAAiB;AAAyB;;AAAC;EAAS,qBAAqB;EAAC;AAAqB;;AAAC;EAAU,sBAAsB;EAAC;AAAsB;;AAAC;EAAU,uBAAuB;EAAC;AAAuB;;AAAC;EAAU,sBAAsB;EAAC;AAAsB;;AAAC;EAAU,uBAAuB;EAAC;AAAuB;;AAAC;EAAW,qBAAqB;EAAC;AAAqB;;AAAC;EAAW,wBAAwB;EAAC;AAAwB;;AAAC;EAAW,uBAAuB;EAAC;AAAuB;;AAAC;EAAW,wBAAwB;EAAC;AAAwB;;AAAC;EAAW,uBAAuB;EAAC;AAAuB;;AAAC;EAAW;AAAqB;;AAAC;EAAY;AAAsB;;AAAC;EAAY;AAAuB;;AAAC;EAAY;AAAsB;;AAAC;EAAY;AAAuB;;AAAC;EAAa;AAAqB;;AAAC;EAAa;AAAwB;;AAAC;EAAa;AAAuB;;AAAC;EAAa;AAAwB;;AAAC;EAAa;AAAuB;;AAAC;EAAW;AAAqB;;AAAC;EAAY;AAAsB;;AAAC;EAAY;AAAuB;;AAAC;EAAY;AAAsB;;AAAC;EAAY;AAAuB;;AAAC;EAAa;AAAqB;;AAAC;EAAa;AAAwB;;AAAC;EAAa;AAAuB;;AAAC;EAAa;AAAwB;;AAAC;EAAa;AAAuB;;AAAC;EAAsB,qBAAqB;EAAC;AAAqB;;AAAC;EAAuB,sBAAsB;EAAC;AAAsB;;AAAC;EAAuB,uBAAuB;EAAC;AAAuB;;AAAC;EAAuB,sBAAsB;EAAC;AAAsB;;AAAC;EAAuB,uBAAuB;EAAC;AAAuB;;AAAC;EAAwB,qBAAqB;EAAC;AAAqB;;AAAC;EAAwB,wBAAwB;EAAC;AAAwB;;AAAC;EAAwB,uBAAuB;EAAC;AAAuB;;AAAC;EAAwB,wBAAwB;EAAC;AAAwB;;AAAC;EAAwB,uBAAuB;EAAC;AAAuB;;AAAC;EAAwB;AAAqB;;AAAC;EAAyB;AAAsB;;AAAC;EAAyB;AAAuB;;AAAC;EAAyB;AAAsB;;AAAC;EAAyB;AAAuB;;AAAC;EAA0B;AAAqB;;AAAC;EAA0B;AAAwB;;AAAC;EAA0B;AAAuB;;AAAC;EAA0B;AAAwB;;AAAC;EAA0B;AAAuB;;AAAC;EAAwB;AAAqB;;AAAC;EAAyB;AAAsB;;AAAC;EAAyB;AAAuB;;AAAC;EAAyB;AAAsB;;AAAC;EAAyB;AAAuB;;AAAC;EAA0B;AAAqB;;AAAC;EAA0B;AAAwB;;AAAC;EAA0B;AAAuB;;AAAC;EAA0B;AAAwB;;AAAC;EAA0B;AAAuB;;AAAC;EAAsB,qBAAqB;EAAC;AAAqB;;AAAC;EAAuB,sBAAsB;EAAC;AAAsB;;AAAC;EAAuB,uBAAuB;EAAC;AAAuB;;AAAC;EAAuB,sBAAsB;EAAC;AAAsB;;AAAC;EAAuB,uBAAuB;EAAC;AAAuB;;AAAC;EAAwB,qBAAqB;EAAC;AAAqB;;AAAC;EAAwB,wBAAwB;EAAC;AAAwB;;AAAC;EAAwB,uBAAuB;EAAC;AAAuB;;AAAC;EAAwB,wBAAwB;EAAC;AAAwB;;AAAC;EAAwB,uBAAuB;EAAC;AAAuB;;AAAC;EAAwB;AAAqB;;AAAC;EAAyB;AAAsB;;AAAC;EAAyB;AAAuB;;AAAC;EAAyB;AAAsB;;AAAC;EAAyB;AAAuB;;AAAC;EAA0B;AAAqB;;AAAC;EAA0B;AAAwB;;AAAC;EAA0B;AAAuB;;AAAC;EAA0B;AAAwB;;AAAC;EAA0B;AAAuB;;AAAC;EAAwB;AAAqB;;AAAC;EAAyB;AAAsB;;AAAC;EAAyB;AAAuB;;AAAC;EAAyB;AAAsB;;AAAC;EAAyB;AAAuB;;AAAC;EAA0B;AAAqB;;AAAC;EAA0B;AAAwB;;AAAC;EAA0B;AAAuB;;AAAC;EAA0B;AAAwB;;AAAC;EAA0B;AAAuB;;AAAC;EAAU;AAAoB;;AAAC;EAAW;AAAwB;;AAAC;EAAW;AAAwB;;AAAC;EAAY;AAAyB;;AAAC;EAAa;AAA0B;;AAAC;EAAY;AAAyB;;AAAC;EAAY;AAAyB;;AAAC;EAAuB;AAAoB;;AAAC;EAAwB;AAAwB;;AAAC;EAAwB;AAAwB;;AAAC;EAAyB;AAAyB;;AAAC;EAA0B;AAA0B;;AAAC;EAAyB;AAAyB;;AAAC;EAAyB;AAAyB;;AAAC;EAAuB;AAAoB;;AAAC;EAAwB;AAAwB;;AAAC;EAAwB;AAAwB;;AAAC;EAAyB;AAAyB;;AAAC;EAA0B;AAA0B;;AAAC;EAAyB;AAAyB;;AAAC;EAAyB;AAAyB;;AAAC;EAAe;AAAyB;;AAAC;EAAe;AAA+B;;AAAC;EAAe;AAA8B;;AAAC;EAAe;AAA+B;;AAAC;EAAe;AAA4B;;AAAC;EAAe;AAA+B;;AAAC;EAAe;AAA8B;;AAAC;EAAe;AAA4B;;AAAC;EAAgB;AAA8B;;AAAC;EAAgB;AAA4B;;AAAC;EAAgB;AAA4B;;AAAC;EAAgB;AAA4B;;AAAC;EAAgB;AAA4B;;AAAC;EAAgB;AAA4B;;AAAC;EAAgB;AAA6B;;AAAC;EAAgB;AAA6B;;AAAC;EAAgB;AAA6B;;AAAC;EAAgB;AAA6B;;AAAC;EAAgB;AAA2B;;AAAC;EAAgB;AAAgC;;AAAC;EAAgB;AAA+B;;AAAC;EAAgB;AAAgC;;AAAC;EAAgB;AAA6B;;AAAC;EAAgB;AAAgC;;AAAC;EAAgB;AAA+B;;AAAC;EAAgB;AAA6B;;AAAC;EAAiB;AAA+B;;AAAC;EAAiB;AAA6B;;AAAC;EAAiB;AAA6B;;AAAC;EAAiB;AAA6B;;AAAC;EAAiB;AAA6B;;AAAC;EAAiB;AAA6B;;AAAC;EAAiB;AAA8B;;AAAC;EAAiB;AAA8B;;AAAC;EAAiB;AAA8B;;AAAC;EAAiB;AAA8B;;AAAC;EAAiB;AAA4B;;AAAC;EAAmB;AAA6B;;AAAC;EAAmB;AAA4B;;AAAC;EAAkB;AAA2B;;AAAC;EAAkB;AAA4B;;AAAC;EAAe;AAAyB;;AAAC;EAAe;AAA+B;;AAAC;EAAe;AAA8B;;AAAC;EAAe;AAA+B;;AAAC;EAAe;AAA4B;;AAAC;EAAe;AAA+B;;AAAC;EAAe;AAA8B;;AAAC;EAAe;AAA4B;;AAAC;EAAgB;AAA8B;;AAAC;EAAgB;AAA4B;;AAAC;EAAgB;AAA4B;;AAAC;EAAgB;AAA4B;;AAAC;EAAgB;AAA4B;;AAAC;EAAgB;AAA4B;;AAAC;EAAgB;AAA6B;;AAAC;EAAgB;AAA6B;;AAAC;EAAgB;AAA6B;;AAAC;EAAgB;AAA6B;;AAAC;EAAgB;AAA2B;;AAAC;EAAgB;AAAgC;;AAAC;EAAgB;AAA+B;;AAAC;EAAgB;AAAgC;;AAAC;EAAgB;AAA6B;;AAAC;EAAgB;AAAgC;;AAAC;EAAgB;AAA+B;;AAAC;EAAgB;AAA6B;;AAAC;EAAiB;AAA+B;;AAAC;EAAiB;AAA6B;;AAAC;EAAiB;AAA6B;;AAAC;EAAiB;AAA6B;;AAAC;EAAiB;AAA6B;;AAAC;EAAiB;AAA6B;;AAAC;EAAiB;AAA8B;;AAAC;EAAiB;AAA8B;;AAAC;EAAiB;AAA8B;;AAAC;EAAiB;AAA8B;;AAAC;EAAiB;AAA4B;;AAAC;EAAmB;AAA6B;;AAAC;EAAmB;AAA4B;;AAAC;EAAkB;AAA2B;;AAAC;EAAkB;AAA4B;;AAAC;EAA4B;AAAyB;;AAAC;EAA4B;AAA+B;;AAAC;EAA4B;AAA8B;;AAAC;EAA4B;AAA+B;;AAAC;EAA4B;AAA4B;;AAAC;EAA4B;AAA+B;;AAAC;EAA4B;AAA8B;;AAAC;EAA4B;AAA4B;;AAAC;EAA6B;AAA8B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA2B;;AAAC;EAA6B;AAAgC;;AAAC;EAA6B;AAA+B;;AAAC;EAA6B;AAAgC;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAAgC;;AAAC;EAA6B;AAA+B;;AAAC;EAA6B;AAA6B;;AAAC;EAA8B;AAA+B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA4B;;AAAC;EAAgC;AAA6B;;AAAC;EAAgC;AAA4B;;AAAC;EAA+B;AAA2B;;AAAC;EAA+B;AAA4B;;AAAC;EAA4B;AAAyB;;AAAC;EAA4B;AAA+B;;AAAC;EAA4B;AAA8B;;AAAC;EAA4B;AAA+B;;AAAC;EAA4B;AAA4B;;AAAC;EAA4B;AAA+B;;AAAC;EAA4B;AAA8B;;AAAC;EAA4B;AAA4B;;AAAC;EAA6B;AAA8B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA2B;;AAAC;EAA6B;AAAgC;;AAAC;EAA6B;AAA+B;;AAAC;EAA6B;AAAgC;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAAgC;;AAAC;EAA6B;AAA+B;;AAAC;EAA6B;AAA6B;;AAAC;EAA8B;AAA+B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA4B;;AAAC;EAAgC;AAA6B;;AAAC;EAAgC;AAA4B;;AAAC;EAA+B;AAA2B;;AAAC;EAA+B;AAA4B;;AAAC;EAA4B;AAAyB;;AAAC;EAA4B;AAA+B;;AAAC;EAA4B;AAA8B;;AAAC;EAA4B;AAA+B;;AAAC;EAA4B;AAA4B;;AAAC;EAA4B;AAA+B;;AAAC;EAA4B;AAA8B;;AAAC;EAA4B;AAA4B;;AAAC;EAA6B;AAA8B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA2B;;AAAC;EAA6B;AAAgC;;AAAC;EAA6B;AAA+B;;AAAC;EAA6B;AAAgC;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAAgC;;AAAC;EAA6B;AAA+B;;AAAC;EAA6B;AAA6B;;AAAC;EAA8B;AAA+B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA4B;;AAAC;EAAgC;AAA6B;;AAAC;EAAgC;AAA4B;;AAAC;EAA+B;AAA2B;;AAAC;EAA+B;AAA4B;;AAAC;EAA4B;AAAyB;;AAAC;EAA4B;AAA+B;;AAAC;EAA4B;AAA8B;;AAAC;EAA4B;AAA+B;;AAAC;EAA4B;AAA4B;;AAAC;EAA4B;AAA+B;;AAAC;EAA4B;AAA8B;;AAAC;EAA4B;AAA4B;;AAAC;EAA6B;AAA8B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA4B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAA2B;;AAAC;EAA6B;AAAgC;;AAAC;EAA6B;AAA+B;;AAAC;EAA6B;AAAgC;;AAAC;EAA6B;AAA6B;;AAAC;EAA6B;AAAgC;;AAAC;EAA6B;AAA+B;;AAAC;EAA6B;AAA6B;;AAAC;EAA8B;AAA+B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA6B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA8B;;AAAC;EAA8B;AAA4B;;AAAC;EAAgC;AAA6B;;AAAC;EAAgC;AAA4B;;AAAC;EAA+B;AAA2B;;AAAC;EAA+B;AAA4B;;AAAC;EAAU;AAAoB;;AAAC;EAAU;AAAuB;;AAAC;EAAU;AAAuB;;AAAC;EAAW;AAAwB;;AAAC;EAAY;AAAyB;;AAAC;EAAW;AAAwB;;AAAC;EAAW;AAAwB;;AAAC;EAAU;AAAoB;;AAAC;EAAU;AAAuB;;AAAC;EAAU;AAAuB;;AAAC;EAAW;AAAwB;;AAAC;EAAY;AAAyB;;AAAC;EAAW;AAAwB;;AAAC;EAAW;AAAwB;;AAAC;EAAuB;AAAoB;;AAAC;EAAuB;AAAuB;;AAAC;EAAuB;AAAuB;;AAAC;EAAwB;AAAwB;;AAAC;EAAyB;AAAyB;;AAAC;EAAwB;AAAwB;;AAAC;EAAwB;AAAwB;;AAAC;EAAuB;AAAoB;;AAAC;EAAuB;AAAuB;;AAAC;EAAuB;AAAuB;;AAAC;EAAwB;AAAwB;;AAAC;EAAyB;AAAyB;;AAAC;EAAwB;AAAwB;;AAAC;EAAwB;AAAwB;;AAAC;EAAuB;AAAoB;;AAAC;EAAuB;AAAuB;;AAAC;EAAuB;AAAuB;;AAAC;EAAwB;AAAwB;;AAAC;EAAyB;AAAyB;;AAAC;EAAwB;AAAwB;;AAAC;EAAwB;AAAwB;;AAAC;EAAuB;AAAoB;;AAAC;EAAuB;AAAuB;;AAAC;EAAuB;AAAuB;;AAAC;EAAwB;AAAwB;;AAAC;EAAyB;AAAyB;;AAAC;EAAwB;AAAwB;;AAAC;EAAwB;AAAwB;;AAAC;EAAiB;AAAwB;;AAAC;EAAgB;AAAuB;;AAAC;EAAY;AAAgG;;AAAC;EAAmB;AAAmE;;AAAC;EAAoB;AAA2B;;AAAC;EAAmB;AAA8B;;AAAC;EAAsB;AAA6B;;AAAC;EAAa;AAAiC;;AAAC;EAAS;AAAiD;;AAAC;EAAU;AAAiD;;AAAC;EAAa;AAAkD;;AAAC;EAAa;AAAwB;;AAAC;EAAc;AAAuB;;AAAC;EAAc;AAAwB;;AAAC;EAAc;AAAuB;;AAAC;EAAc;AAAuB;;AAAC;EAAc;AAAuB;;AAAC;EAAc;AAAuB;;AAAC;EAAe;AAAsB;;AAAC;EAAU;AAAqB;;AAAC;EAAW;AAAoB;;AAAC;EAAW;AAAqB;;AAAC;EAAW;AAAoB;;AAAC;EAAW;AAAoB;;AAAC;EAAW;AAAoB;;AAAC;EAAW;AAAoB;;AAAC;EAAY;AAAmB;;AAAC;EAAsB;AAA8B;;AAAC;EAAsB;AAA8B;;AAAC;EAAqB;AAA8B;;AAAC;EAA0B;AAA8B;;AAAC;EAAoB;AAA8B;;AAAC;EAAuB;AAA8B;;AAAC;EAAuB;AAA8B;;AAAC;EAAsB;AAA8B;;AAAC;EAAqB;AAA8B;;AAAC;EAAqB;AAA8B;;AAAC;EAAuB;AAA8B;;AAAC;EAAuB;AAA8B;;AAAC;EAAqB;AAA8B;;AAAC;EAAmC;AAA8B;;AAAC;EAAmC;AAA8B;;AAAC;EAAkC;AAA8B;;AAAC;EAAuC;AAA8B;;AAAC;EAAiC;AAA8B;;AAAC;EAAoC;AAA8B;;AAAC;EAAoC;AAA8B;;AAAC;EAAmC;AAA8B;;AAAC;EAAkC;AAA8B;;AAAC;EAAkC;AAA8B;;AAAC;EAAoC;AAA8B;;AAAC;EAAoC;AAA8B;;AAAC;EAAkC;AAA8B;;AAAC;EAAmC;AAA8B;;AAAC;EAAmC;AAA8B;;AAAC;EAAkC;AAA8B;;AAAC;EAAuC;AAA8B;;AAAC;EAAiC;AAA8B;;AAAC;EAAoC;AAA8B;;AAAC;EAAoC;AAA8B;;AAAC;EAAmC;AAA8B;;AAAC;EAAkC;AAA8B;;AAAC;EAAkC;AAA8B;;AAAC;EAAoC;AAA8B;;AAAC;EAAoC;AAA8B;;AAAC;EAAkC;AAA8B;;AAAC;EAAqD;AAA8B;;AAAC;EAAqD;AAA8B;;AAAC;EAAoD;AAA8B;;AAAC;EAAyD;AAA8B;;AAAC;EAAmD;AAA8B;;AAAC;EAAsD;AAA8B;;AAAC;EAAsD;AAA8B;;AAAC;EAAqD;AAA8B;;AAAC;EAAoD;AAA8B;;AAAC;EAAoD;AAA8B;;AAAC;EAAsD;AAA8B;;AAAC;EAAsD;AAA8B;;AAAC;EAAoD;AAA8B;;AAAC;EAAyB;IAA6C,mBAAmB;IAAC,8CAA8C;IAAC;EAAiD;;EAAC;IAA6C,mBAAmB;IAAC,kDAAkD;IAAC;EAA6C;;EAAC;IAA6C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA6C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA6C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA6C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA6C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA6C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA6C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA6C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA6C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA6C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA6C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA6C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA6C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA6C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA8C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,8CAA8C;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAA6C;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA8C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA8C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA8C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAAsD;;EAAC;IAA8C,mBAAmB;IAAC,uDAAuD;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA8C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA+C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA+C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAAmD;EAAmB;;EAAC;IAAmD;EAAmB;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA4C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA4C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAAoD;EAAoB;;EAAC;IAAoD;EAAoB;;EAAC;IAAsD;EAAkB;;EAAC;IAAgD,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAgD,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAiD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwE;EAAkB;;EAAC;IAAkE,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAkE,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD;EAAkB;;EAAC;IAAqD;EAAqB;;EAAC;IAAqD;EAAoB;;EAAC;IAAqD;EAAqB;;EAAC;IAAsD;EAAkB;;EAAC;IAAa,UAAU;IAAC,WAAW;IAAC,eAAe;IAAC,SAAS;IAAC,iBAAiB;IAAC,SAAS;IAAC,kBAAkB;IAAC,cAAc;IAAC;EAAkB;;EAAC;IAAiB,WAAW;IAAC,QAAQ;IAAC,gBAAgB;IAAC,SAAS;IAAC,eAAe;IAAC,UAAU;IAAC,SAAS;IAAC;EAAkB;;EAAC;IAA0B,UAAU;IAAC,WAAW;IAAC,eAAe;IAAC,SAAS;IAAC,iBAAiB;IAAC,SAAS;IAAC,kBAAkB;IAAC,cAAc;IAAC;EAAkB;;EAAC;IAA8B,WAAW;IAAC,QAAQ;IAAC,gBAAgB;IAAC,SAAS;IAAC,eAAe;IAAC,UAAU;IAAC,SAAS;IAAC;EAAkB;;EAAC;IAA6C;EAAe;;EAAC;IAAc;EAA2B;;EAAC;IAAc;EAA2B;;EAAC;IAAe;EAA4B;;EAAC;IAAoB;EAAwB;;EAAC;IAAc,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAc,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAe,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC;EAAwB;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC;EAAwB;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC;EAAwB;;EAAC;IAA6B,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwC;EAAwB;;EAAC;IAAkC,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAyC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC;EAAwB;;EAAC;IAAgC,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD;EAAwB;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD;EAAwB;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqD;EAAwB;;EAAC;IAA+C,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA0D;EAAwB;;EAAC;IAAoD,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA2D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB;EAAc;;EAAC;IAAmB;EAAgB;;EAAC;IAAmB;EAAiB;;EAAC;IAAmB;EAAgB;;EAAC;IAAmB;EAAiB;;EAAC;IAAoB;EAAc;;EAAC;IAA+B;EAAc;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAiC;EAAc;;EAAC;IAA+B;EAAc;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAiC;EAAc;;EAAC;IAAiD;EAAc;;EAAC;IAAkD;EAAgB;;EAAC;IAAkD;EAAiB;;EAAC;IAAkD;EAAgB;;EAAC;IAAkD;EAAiB;;EAAC;IAAmD;EAAc;;EAAC;IAAe;EAA0B;;EAAC;IAAe;EAAuB;;EAAC;IAAa;EAAqB;;EAAC;IAAoB;EAA0B;;EAAC;IAAiB;EAAuB;;EAAC;IAAc;EAAwB;;EAAC;IAAqB;EAA6B;;EAAC;IAAkB;EAA0B;;EAAC;IAAY;EAAuB;;EAAC;IAAe;EAAwB;;EAAC;IAAkB;EAA2B;;EAAC;IAAiB;EAA0B;;EAAC;IAAiB;EAA0B;;EAAC;IAAqB;EAAuB;;EAAC;IAAqB;EAAuB;;EAAC;IAAa;EAAoB;;EAAC;IAAc;EAAqB;;EAAC;IAAgB;EAAuB;;EAAC;IAAqB;EAAwB;;EAAC;IAAqB;EAAuB;;EAAC;IAAwB;EAAkB;;EAAC;IAAkB,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAkB,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqC;EAAkB;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAgC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqC;EAAkB;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAgC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA0C;EAAkB;;EAAC;IAAoC,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA2C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuD;EAAkB;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuD;EAAkB;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB;EAAkB;;EAAC;IAAuB;EAAqB;;EAAC;IAAuB;EAAoB;;EAAC;IAAuB;EAAqB;;EAAC;IAAwB;EAAkB;;EAAC;IAAmC;EAAkB;;EAAC;IAAoC;EAAqB;;EAAC;IAAoC;EAAoB;;EAAC;IAAoC;EAAqB;;EAAC;IAAqC;EAAkB;;EAAC;IAAmC;EAAkB;;EAAC;IAAoC;EAAqB;;EAAC;IAAoC;EAAoB;;EAAC;IAAoC;EAAqB;;EAAC;IAAqC;EAAkB;;EAAC;IAAkB;EAAe;;EAAC;IAAgB;EAAqB;;EAAC;IAAa;EAAoB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAmB;;EAAC;IAAkB;EAAoB;;EAAC;IAAoB,wBAAwB;IAAC;EAAyB;;EAAC;IAAoB,4BAA4B;IAAC;EAAyB;;EAAC;IAAoB,2BAA2B;IAAC;EAA4B;;EAAC;IAAoB,2BAA2B;IAAC;EAAwB;;EAAC;IAAkB,8BAA8B;IAAC;EAA+B;;EAAC;IAAkB,kCAAkC;IAAC;EAA+B;;EAAC;IAAkB,iCAAiC;IAAC;EAAkC;;EAAC;IAAkB,iCAAiC;IAAC;EAA8B;;EAAC;IAAe;EAA6B;;EAAC;IAA8B;EAA8B;;EAAC;IAA8B;EAAiC;;EAAC;IAA8B;EAAgC;;EAAC;IAAe;EAA6B;;EAAC;IAAkB,8BAA8B;IAAC;EAA+B;;EAAC;IAAkB,kCAAkC;IAAC;EAA+B;;EAAC;IAAkB,iCAAiC;IAAC;EAAkC;;EAAC;IAAkB,iCAAiC;IAAC;EAA8B;;EAAC;IAAkB,4BAA4B;IAAC;EAA6B;;EAAC;IAAkB,gCAAgC;IAAC;EAA6B;;EAAC;IAAkB,+BAA+B;IAAC;EAAgC;;EAAC;IAAkB,+BAA+B;IAAC;EAA4B;;EAAC;IAAoB,6BAA6B;IAAC;EAA8B;;EAAC;IAAoB,iCAAiC;IAAC;EAA8B;;EAAC;IAAoB,gCAAgC;IAAC;EAAiC;;EAAC;IAAoB,gCAAgC;IAAC;EAA6B;;EAAC;IAAqB;EAAwB;;EAAC;IAAqB;EAAyB;;EAAC;IAAqB;EAA4B;;EAAC;IAAqB;EAA2B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAAkC;;EAAC;IAAmB;EAAiC;;EAAC;IAAgB;EAA6B;;EAAC;IAAgB;EAA8B;;EAAC;IAAgB;EAAiC;;EAAC;IAAgB;EAAgC;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAAkC;;EAAC;IAAmB;EAAiC;;EAAC;IAAmB;EAA4B;;EAAC;IAAmB;EAA6B;;EAAC;IAAmB;EAAgC;;EAAC;IAAmB;EAA+B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAAiC;;EAAC;IAAqB;EAAgC;;EAAC;IAAkB;EAAkB;;EAAC;IAAmB;EAAmB;;EAAC;IAAmB;EAAmB;;EAAC;IAAmB;EAAmB;;EAAC;IAAiB;EAAiB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAmB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAqB;;EAAC;IAAc;EAAoB;;EAAC;IAAc;EAAsB;;EAAC;IAAc;EAAuB;;EAAC;IAAc;EAAqB;;EAAC;IAAgB;EAAqB;;EAAC;IAAiB;EAAkB;;EAAC;IAAiB;EAAW;;EAAC;IAAoB;EAAc;;EAAC;IAAoB;EAAc;;EAAC;IAAiB;EAAW;;EAAC;IAAiB;EAAW;;EAAC;IAAiB;EAAW;;EAAC;IAAwB;EAAkB;;EAAC;IAAW;EAAa;;EAAC;IAAkB;EAAoB;;EAAC;IAAY;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAiB;EAAmB;;EAAC;IAAW;EAAa;;EAAC;IAAmB;EAAqB;;EAAC;IAAgB;EAAkB;;EAAC;IAAkB;EAAoB;;EAAC;IAAwB;EAA0B;;EAAC;IAAwB;EAA0B;;EAAC;IAAwB;EAA0B;;EAAC;IAAqB;EAAuB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAU;EAAY;;EAAC;IAAiB;EAAmB;;EAAC;IAAY;EAAY;;EAAC;IAA6B;EAAa;;EAAC;IAAoC;EAAoB;;EAAC;IAA8B;EAAc;;EAAC;IAA4B;EAAY;;EAAC;IAAmC;EAAmB;;EAAC;IAA6B;EAAa;;EAAC;IAAqC;EAAqB;;EAAC;IAAkC;EAAkB;;EAAC;IAAoC;EAAoB;;EAAC;IAA0C;EAA0B;;EAAC;IAA0C;EAA0B;;EAAC;IAA0C;EAA0B;;EAAC;IAAuC;EAAuB;;EAAC;IAAiC;EAAiB;;EAAC;IAAiC;EAAiB;;EAAC;IAA4B;EAAY;;EAAC;IAAmC;EAAmB;;EAAC;IAA8B;EAAY;;EAAC;IAAc;EAAkB;;EAAC;IAAsB;EAA0B;;EAAC;IAAc;EAAqB;;EAAC;IAAsB;EAA6B;;EAAC;IAAe;EAAc;;EAAC;IAAuB;EAAsB;;EAAC;IAAkB;EAAgB;;EAAC;IAAiB;EAAsB;;EAAC;IAAe;EAAoB;;EAAC;IAAkB;EAAkB;;EAAC;IAAoB;EAAoB;;EAAC;IAAmB;EAAmB;;EAAC;IAAe;EAAe;;EAAC;IAAgB;EAAqB;;EAAC;IAAc;EAAmB;;EAAC;IAAiB;EAAiB;;EAAC;IAAkB;EAAkB;;EAAC;IAAmB;EAA0B;;EAAC;IAAiB;EAAwB;;EAAC;IAAoB;EAAsB;;EAAC;IAAqB;EAA6B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAAoB;;EAAC;IAAmB;EAAwB;;EAAC;IAAiB;EAAsB;;EAAC;IAAqB;EAA2B;;EAAC;IAAoB;EAA0B;;EAAC;IAAY;EAAW;;EAAC;IAAe;EAAa;;EAAC;IAAkB;EAAa;;EAAC;IAAe;EAAS;;EAAC;IAAiB;EAAW;;EAAC;IAAe;EAAW;;EAAC;IAAmB;EAAa;;EAAC;IAAiB;EAAa;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAc;EAAQ;;EAAC;IAAc;EAAQ;;EAAC;IAAc;EAAQ;;EAAC;IAAiB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAO;;EAAC;IAAiB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAU;;EAAC;IAAoB,UAAU;IAAC,UAAU;IAAC;EAAa;;EAAC;IAAgB;EAAU;;EAAC;IAAiB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAU;;EAAC;IAAe;EAAwL;;EAAC;IAAgB;EAAuD;;EAAC;IAAe;EAAuE;;EAAC;IAAmB;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAgB;EAAe;;EAAC;IAAiB;EAAe;;EAAC;IAAiB;EAAe;;EAAC;IAAmB;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAoB;EAAe;;EAAC;IAAgB;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAAiC;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAAiC;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAAS;EAAQ;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAY;EAAW;;EAAC;IAAU;EAAU;;EAAC;IAAY;EAAW;;EAAC;IAAc;EAAY;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAiB;;EAAC;IAAe;EAAc;;EAAC;IAAa;EAAkB;;EAAC;IAAa;EAAiB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAkB;;EAAC;IAAc;EAAiB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAe;EAAkB;;EAAC;IAAe;EAAgB;;EAAC;IAAe;EAAmB;;EAAC;IAAe;EAAkB;;EAAC;IAAe;EAAmB;;EAAC;IAAe;EAAgB;;EAAC;IAAe;EAAmB;;EAAC;IAAgB;EAAkB;;EAAC;IAAkB;EAAa;;EAAC;IAAmB;EAAgB;;EAAC;IAAkB;EAAiB;;EAAC;IAAoB;EAAe;;EAAC;IAAqB;EAAiB;;EAAC;IAAmB;EAAa;;EAAC;IAAiB;EAA0B;;EAAC;IAAkB;EAA2B;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAkB;EAAuB;;EAAC;IAAS;EAAQ;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAY;EAAW;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAW;EAAc;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAW;;EAAC;IAAU,eAAe;IAAC;EAAY;;EAAC;IAAU,aAAa;IAAC;EAAc;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,mBAAmB;IAAC;EAAgB;;EAAC;IAAU,iBAAiB;IAAC;EAAkB;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,kBAAkB;IAAC;EAAe;;EAAC;IAAU,gBAAgB;IAAC;EAAiB;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,kBAAkB;IAAC;EAAe;;EAAC;IAAU,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAa,kBAAkB;IAAC;EAAe;;EAAC;IAAa,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,iBAAiB;IAAC;EAAc;;EAAC;IAAW,eAAe;IAAC;EAAgB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,sBAAsB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAqB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,qBAAqB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAoB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,kBAAkB;IAAC;EAAe;;EAAC;IAAY,gBAAgB;IAAC;EAAiB;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAgB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAkB;;EAAC;IAAa;EAAgB;;EAAC;IAAW;EAAc;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAsB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAqB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAe;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAgB;;EAAC;IAA0B;EAAQ;;EAAC;IAA0B;EAAa;;EAAC;IAA0B;EAAY;;EAAC;IAA0B;EAAa;;EAAC;IAA0B;EAAW;;EAAC;IAA0B;EAAc;;EAAC;IAA0B;EAAa;;EAAC;IAA0B;EAAW;;EAAC;IAA2B;EAAa;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAY;;EAAC;IAA6B;EAAW;;EAAC;IAA2B;EAAU;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAa;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAY;;EAAC;IAA4B;EAAc;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAW;;EAAC;IAA2B,eAAe;IAAC;EAAY;;EAAC;IAA2B,aAAa;IAAC;EAAc;;EAAC;IAA2B,oBAAoB;IAAC;EAAiB;;EAAC;IAA2B,kBAAkB;IAAC;EAAmB;;EAAC;IAA2B,mBAAmB;IAAC;EAAgB;;EAAC;IAA2B,iBAAiB;IAAC;EAAkB;;EAAC;IAA2B,oBAAoB;IAAC;EAAiB;;EAAC;IAA2B,kBAAkB;IAAC;EAAmB;;EAAC;IAA2B,kBAAkB;IAAC;EAAe;;EAAC;IAA2B,gBAAgB;IAAC;EAAiB;;EAAC;IAA2B,qBAAqB;IAAC;EAAkB;;EAAC;IAA2B,mBAAmB;IAAC;EAAoB;;EAAC;IAA2B,oBAAoB;IAAC;EAAiB;;EAAC;IAA2B,kBAAkB;IAAC;EAAmB;;EAAC;IAA2B,kBAAkB;IAAC;EAAe;;EAAC;IAA2B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,oBAAoB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAmB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA8B,kBAAkB;IAAC;EAAe;;EAAC;IAA8B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,iBAAiB;IAAC;EAAc;;EAAC;IAA4B,eAAe;IAAC;EAAgB;;EAAC;IAA4B,qBAAqB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAoB;;EAAC;IAA4B,oBAAoB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAmB;;EAAC;IAA4B,qBAAqB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAoB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,sBAAsB;IAAC;EAAmB;;EAAC;IAA4B,oBAAoB;IAAC;EAAqB;;EAAC;IAA4B,qBAAqB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAoB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,qBAAqB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAoB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,kBAAkB;IAAC;EAAe;;EAAC;IAA6B,gBAAgB;IAAC;EAAiB;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAa;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAgB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAgB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAqB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAgB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA8B;EAAe;;EAAC;IAA8B;EAAiB;;EAAC;IAA8B;EAAkB;;EAAC;IAA8B;EAAgB;;EAAC;IAA4B;EAAc;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAsB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAqB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAe;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAgB;;EAAC;IAAa;EAAY;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAkB;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAe;;EAAC;IAAc;EAAiB;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAc;;EAAC;IAAgB;EAAc;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAgB;EAAc;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAgB;;EAAC;IAAqB;EAAgB;;EAAC;IAAa;EAAY;;EAAC;IAAgB;EAAe;;EAAC;IAAkB;EAAgB;;EAAC;IAAa;EAAW;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAc;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAc;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAqD;EAAqB;;EAAC;IAAc;EAAa;;EAAC;IAAoB;EAAkB;;EAAC;IAAkB;EAAgB;;EAAC;IAAiB;EAAe;;EAAC;IAAiB;EAAe;;EAAC;IAAuB;EAAqB;;EAAC;IAAmB;EAAsB;;EAAC;IAAmB;EAAsB;;EAAC;IAAiB;EAAoB;;EAAC;IAAwB;EAA2B;;EAAC;IAAqB;EAAwB;;EAAC;IAAkB;EAAqB;;EAAC;IAAyB;EAA4B;;EAAC;IAAsB;EAAyB;;EAAC;IAAgB;EAAmB;;EAAC;IAAe;EAAS;;EAAC;IAAgB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAW;;EAAC;IAAiB;EAAS;;EAAC;IAA4B;EAAS;;EAAC;IAA6B;EAAW;;EAAC;IAA6B;EAAU;;EAAC;IAA6B;EAAW;;EAAC;IAA8B;EAAS;;EAAC;IAA4B;EAAS;;EAAC;IAA6B;EAAW;;EAAC;IAA6B;EAAU;;EAAC;IAA6B;EAAW;;EAAC;IAA8B;EAAS;;EAAC;IAAiD;EAAS;;EAAC;IAAmB;EAAa;;EAAC;IAAqB;EAAe;;EAAC;IAAsB;EAAgB;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAe;;EAAC;IAAuB;EAAiB;;EAAC;IAAuB;EAAiB;;EAAC;IAAwB;EAAkB;;EAAC;IAAwB;EAAkB;;EAAC;IAAuB;EAAiB;;EAAC;IAAuB;EAAiB;;EAAC;IAAqB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAS;EAAS;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAe;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAY;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAW;;EAAC;IAAU,gBAAgB;IAAC;EAAa;;EAAC;IAAU,cAAc;IAAC;EAAe;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,mBAAmB;IAAC;EAAgB;;EAAC;IAAU,iBAAiB;IAAC;EAAkB;;EAAC;IAAU,sBAAsB;IAAC;EAAmB;;EAAC;IAAU,oBAAoB;IAAC;EAAqB;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,mBAAmB;IAAC;EAAgB;;EAAC;IAAU,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAsB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAA0C;EAAW;;EAAC;IAAoC,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAoC,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAqC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuD;EAAW;;EAAC;IAAiD,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAiD,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAkD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA4D;EAAW;;EAAC;IAAsD,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA6D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyE;EAAW;;EAAC;IAAmE,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAmE,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA0E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC;EAAuB;;EAAC;IAAyC;EAA0B;;EAAC;IAAyC;EAAyB;;EAAC;IAAyC;EAA0B;;EAAC;IAA0C;EAAuB;;EAAC;IAAqD;EAAuB;;EAAC;IAAsD;EAA0B;;EAAC;IAAsD;EAAyB;;EAAC;IAAsD;EAA0B;;EAAC;IAAuD;EAAuB;;EAAC;IAAyB;EAAmB;;EAAC;IAAyB;EAAmB;;EAAC;IAAY;EAAe;;EAAC;IAAW;EAAc;;EAAC;IAAc;EAAiB;;EAAC;IAAc;EAAiB;;EAAC;IAAoC;EAAe;;EAAC;IAAa,QAAQ;IAAC,MAAM;IAAC,OAAO;IAAC;EAAK;;EAAC;IAAgB,WAAW;IAAC,SAAS;IAAC,UAAU;IAAC;EAAQ;;EAAC;IAAe,QAAQ;IAAC;EAAK;;EAAC;IAAe,MAAM;IAAC;EAAO;;EAAC;IAAkB,WAAW;IAAC;EAAQ;;EAAC;IAAkB,SAAS;IAAC;EAAU;;EAAC;IAAW;EAAK;;EAAC;IAAa;EAAO;;EAAC;IAAc;EAAQ;;EAAC;IAAY;EAAM;;EAAC;IAAc;EAAQ;;EAAC;IAAgB;EAAU;;EAAC;IAAiB;EAAW;;EAAC;IAAe;EAAS;;EAAC;IAAiB;EAAW;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAiB;;EAAC;IAAY;EAAW;;EAAC;IAAe;EAA8B;;EAAC;IAAe;EAAgC;;EAAC;IAAY;EAAsD;;EAAC;IAAe;EAA4D;;EAAC;IAAe;EAA8D;;EAAC;IAAe;EAAgE;;EAAC;IAAgB;EAAsC;;EAAC;IAAkB;EAAsC;;EAAC;IAAoB;EAA8B;;EAAC;IAAiB;EAAe;;EAAC;IAAmB;EAAwD;;EAAC;IAA4B;EAA8B;;EAAC;IAA4B;EAAgC;;EAAC;IAAyB;EAAsD;;EAAC;IAA4B;EAA4D;;EAAC;IAA4B;EAA8D;;EAAC;IAA4B;EAAgE;;EAAC;IAA6B;EAAsC;;EAAC;IAA+B;EAAsC;;EAAC;IAAiC;EAA8B;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAwD;;EAAC;IAA4B;EAA8B;;EAAC;IAA4B;EAAgC;;EAAC;IAAyB;EAAsD;;EAAC;IAA4B;EAA4D;;EAAC;IAA4B;EAA8D;;EAAC;IAA4B;EAAgE;;EAAC;IAA6B;EAAsC;;EAAC;IAA+B;EAAsC;;EAAC;IAAiC;EAA8B;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAwD;;EAAC;IAA8C;EAA8B;;EAAC;IAA8C;EAAgC;;EAAC;IAA2C;EAAsD;;EAAC;IAA8C;EAA4D;;EAAC;IAA8C;EAA8D;;EAAC;IAA8C;EAAgE;;EAAC;IAA+C;EAAsC;;EAAC;IAAiD;EAAsC;;EAAC;IAAmD;EAA8B;;EAAC;IAAgD;EAAe;;EAAC;IAAkD;EAAwD;;EAAC;IAAkB;EAAiB;;EAAC;IAAoB;EAAmB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAgB;EAAiB;;EAAC;IAAiB;EAAkB;;EAAC;IAAe;EAAe;;EAAC;IAAiB;EAAiB;;EAAC;IAAgB;EAAgB;;EAAC;IAAkB;EAAkB;;EAAC;IAAsB;EAAW;;EAAC;IAAgB,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAAgB,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC;EAAW;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD;EAAW;;EAAC;IAA2C,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA2C,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA4C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC;EAAW;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC;EAAW;;EAAC;IAA+B,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAwC;EAAW;;EAAC;IAAkC,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAyC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmE;EAAW;;EAAC;IAA6D,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA6D,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD;EAAW;;EAAC;IAA+C,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuD;EAAW;;EAAC;IAAiD,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAwD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB;EAAgB;;EAAC;IAAqB;EAAmB;;EAAC;IAAqB;EAAkB;;EAAC;IAAqB;EAAmB;;EAAC;IAAsB;EAAgB;;EAAC;IAAiC;EAAgB;;EAAC;IAAkC;EAAmB;;EAAC;IAAkC;EAAkB;;EAAC;IAAkC;EAAmB;;EAAC;IAAmC;EAAgB;;EAAC;IAAiC;EAAgB;;EAAC;IAAkC;EAAmB;;EAAC;IAAkC;EAAkB;;EAAC;IAAkC;EAAmB;;EAAC;IAAmC;EAAgB;;EAAC;IAAY;EAAiB;;EAAC;IAAgB;EAAiB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiD;EAAyB;;EAAC;IAAuD;EAA4B;;EAAC;IAA+C;EAAoB;;EAAC;IAA8D;EAAyB;;EAAC;IAAoE;EAA4B;;EAAC;IAA4D;EAAoB;;EAAC;IAA8D;EAAyB;;EAAC;IAAoE;EAA4B;;EAAC;IAA4D;EAAoB;;EAAC;IAAiB,kCAAkC;IAAC;EAAiC;;EAAC;IAA0B,2BAA2B;IAAC;EAA4B;;EAAC;IAAsB;EAAqB;;EAAC;IAAoB;EAAsB;;EAAC;IAAqB;EAAgB;;EAAC;IAAmB;EAAqB;;EAAC;IAAoB;EAAoB;;EAAC;IAAqB;EAAmB;;EAAC;IAAiB,wBAAwB;IAAC;EAAgB;;EAAC;IAAiB,wBAAwB;IAAC;EAAgB;;EAAC;IAAgB,uBAAuB;IAAC;EAAe;;EAAC;IAAiB,wBAAwB;IAAC;EAAgB;;EAAC;IAAoB;EAAsB;;EAAC;IAAe;EAAkB;;EAAC;IAAkB;EAAqB;;EAAC;IAAkB;EAAqB;;EAAC;IAAoB;EAAuB;;EAAC;IAAuB;EAA0B;;EAAC;IAAa;EAAkB;;EAAC;IAAe;EAAiB;;EAAC;IAAuB;EAAkB;;EAAC;IAAwB;EAAkB;;EAAC;IAAoB;EAAe;;EAAC;IAAyB;EAAoB;;EAAC;IAAyB;EAAoB;;EAAC;IAAkB,oBAAoB;IAAC;EAAiB;;EAAC;IAAiB;EAAwB;;EAAC;IAAe;EAAoB;;EAAC;IAAc,eAAe;IAAC,sBAAsB;IAAC;EAAkB;;EAAC;IAAS;EAAO;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAW;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAU;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAU;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAY;EAAU;;EAAC;IAAU;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAS;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAS;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAS;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAY;EAAU;;EAAC;IAAc;EAAW;;EAAC;IAAS;EAAS;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAY;EAAY;;EAAC;IAAW,UAAU;IAAC;EAAK;;EAAC;IAAW,eAAe;IAAC;EAAU;;EAAC;IAAW,cAAc;IAAC;EAAS;;EAAC;IAAW,eAAe;IAAC;EAAU;;EAAC;IAAW,aAAa;IAAC;EAAQ;;EAAC;IAAW,gBAAgB;IAAC;EAAW;;EAAC;IAAW,eAAe;IAAC;EAAU;;EAAC;IAAW,aAAa;IAAC;EAAQ;;EAAC;IAAY,eAAe;IAAC;EAAU;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,YAAY;IAAC;EAAO;;EAAC;IAAe,iBAAiB;IAAC;EAAY;;EAAC;IAAe,sBAAsB;IAAC;EAAiB;;EAAC;IAAe,qBAAqB;IAAC;EAAgB;;EAAC;IAAe,sBAAsB;IAAC;EAAiB;;EAAC;IAAe,oBAAoB;IAAC;EAAe;;EAAC;IAAe,uBAAuB;IAAC;EAAkB;;EAAC;IAAe,sBAAsB;IAAC;EAAiB;;EAAC;IAAe,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,sBAAsB;IAAC;EAAiB;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,mBAAmB;IAAC;EAAc;;EAAC;IAAe,cAAc;IAAC;EAAS;;EAAC;IAAe,mBAAmB;IAAC;EAAc;;EAAC;IAAe,kBAAkB;IAAC;EAAa;;EAAC;IAAe,mBAAmB;IAAC;EAAc;;EAAC;IAAe,iBAAiB;IAAC;EAAY;;EAAC;IAAe,oBAAoB;IAAC;EAAe;;EAAC;IAAe,mBAAmB;IAAC;EAAc;;EAAC;IAAe,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,mBAAmB;IAAC;EAAc;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,gBAAgB;IAAC;EAAW;;EAAC;IAAmB;EAAkB;;EAAC;IAAmB;EAAqB;;EAAC;IAAyB;EAAwB;;EAAC;IAAyB;EAA2B;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAkB;EAA8C;;EAAC;IAAkB;EAA8C;;EAAC;IAAkB;EAA8C;;EAAC;IAAoB;EAA0B;;EAAC;IAAc;EAAgB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAiB;EAA2B;;EAAC;IAAiB;EAA2B;;EAAC;IAAiB;EAA2B;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAkB;EAAoB;;EAAC;IAAkB;EAAoB;;EAAC;IAAkB;EAAoB;;EAAC;IAAkB;EAAoB;;EAAC;IAAoB;EAAsB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAkB;;EAAC;IAAkB;EAAoB;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAoB;EAAuB;;EAAC;IAAc;EAAa;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAoB;EAAmB;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAkB;EAAiB;;EAAC;IAAe,yBAAyB;IAAC,yBAAyB;IAAC,oBAAoB;IAAC,oBAAoB;IAAC,oBAAoB;IAAC,qBAAqB;IAAC,qBAAqB;IAAC;EAA2P;;EAAC;IAAoB;EAAc;;EAAC;IAAmB;EAAuB;;EAAC;IAAgB;EAAoB;;EAAC;IAAsB;EAA0B;;EAAC;IAAkB;EAAsB;;EAAC;IAAyB;EAA6B;;EAAC;IAAmB;EAAuB;;EAAC;IAAwB;EAA4B;;EAAC;IAAiB;EAAqB;;EAAC;IAAqB;EAAyB;;EAAC;IAAa,qBAAqB;IAAC;EAAqB;;EAAC;IAAc,sBAAsB;IAAC;EAAsB;;EAAC;IAAc,uBAAuB;IAAC;EAAuB;;EAAC;IAAc,sBAAsB;IAAC;EAAsB;;EAAC;IAAc,uBAAuB;IAAC;EAAuB;;EAAC;IAAe,qBAAqB;IAAC;EAAqB;;EAAC;IAAe,wBAAwB;IAAC;EAAwB;;EAAC;IAAe,uBAAuB;IAAC;EAAuB;;EAAC;IAAe,wBAAwB;IAAC;EAAwB;;EAAC;IAAe,uBAAuB;IAAC;EAAuB;;EAAC;IAAe;EAAqB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAiB;EAAqB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAAe;EAAqB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAiB;EAAqB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAA0B,qBAAqB;IAAC;EAAqB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,qBAAqB;IAAC;EAAqB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA0B,qBAAqB;IAAC;EAAqB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,qBAAqB;IAAC;EAAqB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAAc;EAAoB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAiB;EAA0B;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAA2B;EAAoB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA8B;EAA0B;;EAAC;IAA6B;EAAyB;;EAAC;IAA6B;EAAyB;;EAAC;IAA2B;EAAoB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA8B;EAA0B;;EAAC;IAA6B;EAAyB;;EAAC;IAA6B;EAAyB;;EAAC;IAAmB;EAAyB;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA4B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA4B;;EAAC;IAAoB;EAA8B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA2B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAA6B;;EAAC;IAAqB;EAA+B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA4B;;EAAC;IAAuB;EAA6B;;EAAC;IAAuB;EAA4B;;EAAC;IAAsB;EAA2B;;EAAC;IAAsB;EAA4B;;EAAC;IAAmB;EAAyB;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA4B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA4B;;EAAC;IAAoB;EAA8B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA2B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAA6B;;EAAC;IAAqB;EAA+B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA4B;;EAAC;IAAuB;EAA6B;;EAAC;IAAuB;EAA4B;;EAAC;IAAsB;EAA2B;;EAAC;IAAsB;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAc;EAAoB;;EAAC;IAAc;EAAuB;;EAAC;IAAc;EAAuB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAAc;EAAoB;;EAAC;IAAc;EAAuB;;EAAC;IAAc;EAAuB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAAqB;EAAwB;;EAAC;IAAoB;EAAuB;;EAAC;IAAgB;EAAgG;;EAAC;IAAuB;EAAmE;;EAAC;IAAwB;EAA2B;;EAAC;IAAuB;EAA8B;;EAAC;IAA0B;EAA6B;;EAAC;IAAiB;EAAiC;;EAAC;IAAa;EAAiD;;EAAC;IAAc;EAAiD;;EAAC;IAAiB;EAAkD;;EAAC;IAAiB;EAAwB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAwB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAuB;;EAAC;IAAmB;EAAsB;;EAAC;IAAc;EAAqB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAqB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAgB;EAAmB;;EAAC;IAA0B;EAA8B;;EAAC;IAA0B;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAA8B;EAA8B;;EAAC;IAAwB;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAA0B;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAA2C;EAA8B;;EAAC;IAAqC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAA2C;EAA8B;;EAAC;IAAqC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAyD;EAA8B;;EAAC;IAAyD;EAA8B;;EAAC;IAAwD;EAA8B;;EAAC;IAA6D;EAA8B;;EAAC;IAAuD;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAAyD;EAA8B;;EAAC;IAAwD;EAA8B;;EAAC;IAAwD;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAAwD;EAA8B;AAAC;;AAAC;EAAyB;IAA6C,mBAAmB;IAAC,8CAA8C;IAAC;EAAiD;;EAAC;IAA6C,mBAAmB;IAAC,kDAAkD;IAAC;EAA6C;;EAAC;IAA6C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA6C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA6C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA6C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA6C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA6C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA6C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA6C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA6C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA6C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA6C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA6C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA6C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA6C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA8C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,8CAA8C;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAA6C;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA8C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA8C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA8C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAAsD;;EAAC;IAA8C,mBAAmB;IAAC,uDAAuD;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA8C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA+C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA+C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAAmD;EAAmB;;EAAC;IAAmD;EAAmB;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA4C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA4C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAAoD;EAAoB;;EAAC;IAAoD;EAAoB;;EAAC;IAAsD;EAAkB;;EAAC;IAAgD,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAgD,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAiD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwE;EAAkB;;EAAC;IAAkE,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAkE,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD;EAAkB;;EAAC;IAAqD;EAAqB;;EAAC;IAAqD;EAAoB;;EAAC;IAAqD;EAAqB;;EAAC;IAAsD;EAAkB;;EAAC;IAAa,UAAU;IAAC,WAAW;IAAC,eAAe;IAAC,SAAS;IAAC,iBAAiB;IAAC,SAAS;IAAC,kBAAkB;IAAC,cAAc;IAAC;EAAkB;;EAAC;IAAiB,WAAW;IAAC,QAAQ;IAAC,gBAAgB;IAAC,SAAS;IAAC,eAAe;IAAC,UAAU;IAAC,SAAS;IAAC;EAAkB;;EAAC;IAA0B,UAAU;IAAC,WAAW;IAAC,eAAe;IAAC,SAAS;IAAC,iBAAiB;IAAC,SAAS;IAAC,kBAAkB;IAAC,cAAc;IAAC;EAAkB;;EAAC;IAA8B,WAAW;IAAC,QAAQ;IAAC,gBAAgB;IAAC,SAAS;IAAC,eAAe;IAAC,UAAU;IAAC,SAAS;IAAC;EAAkB;;EAAC;IAA6C;EAAe;;EAAC;IAAc;EAA2B;;EAAC;IAAc;EAA2B;;EAAC;IAAe;EAA4B;;EAAC;IAAoB;EAAwB;;EAAC;IAAc,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAc,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAe,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC;EAAwB;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC;EAAwB;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC;EAAwB;;EAAC;IAA6B,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwC;EAAwB;;EAAC;IAAkC,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAyC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC;EAAwB;;EAAC;IAAgC,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD;EAAwB;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD;EAAwB;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqD;EAAwB;;EAAC;IAA+C,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA0D;EAAwB;;EAAC;IAAoD,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA2D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB;EAAc;;EAAC;IAAmB;EAAgB;;EAAC;IAAmB;EAAiB;;EAAC;IAAmB;EAAgB;;EAAC;IAAmB;EAAiB;;EAAC;IAAoB;EAAc;;EAAC;IAA+B;EAAc;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAiC;EAAc;;EAAC;IAA+B;EAAc;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAiC;EAAc;;EAAC;IAAiD;EAAc;;EAAC;IAAkD;EAAgB;;EAAC;IAAkD;EAAiB;;EAAC;IAAkD;EAAgB;;EAAC;IAAkD;EAAiB;;EAAC;IAAmD;EAAc;;EAAC;IAAe;EAA0B;;EAAC;IAAe;EAAuB;;EAAC;IAAa;EAAqB;;EAAC;IAAoB;EAA0B;;EAAC;IAAiB;EAAuB;;EAAC;IAAc;EAAwB;;EAAC;IAAqB;EAA6B;;EAAC;IAAkB;EAA0B;;EAAC;IAAY;EAAuB;;EAAC;IAAe;EAAwB;;EAAC;IAAkB;EAA2B;;EAAC;IAAiB;EAA0B;;EAAC;IAAiB;EAA0B;;EAAC;IAAqB;EAAuB;;EAAC;IAAqB;EAAuB;;EAAC;IAAa;EAAoB;;EAAC;IAAc;EAAqB;;EAAC;IAAgB;EAAuB;;EAAC;IAAqB;EAAwB;;EAAC;IAAqB;EAAuB;;EAAC;IAAwB;EAAkB;;EAAC;IAAkB,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAkB,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqC;EAAkB;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAgC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqC;EAAkB;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAgC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA0C;EAAkB;;EAAC;IAAoC,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA2C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuD;EAAkB;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuD;EAAkB;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB;EAAkB;;EAAC;IAAuB;EAAqB;;EAAC;IAAuB;EAAoB;;EAAC;IAAuB;EAAqB;;EAAC;IAAwB;EAAkB;;EAAC;IAAmC;EAAkB;;EAAC;IAAoC;EAAqB;;EAAC;IAAoC;EAAoB;;EAAC;IAAoC;EAAqB;;EAAC;IAAqC;EAAkB;;EAAC;IAAmC;EAAkB;;EAAC;IAAoC;EAAqB;;EAAC;IAAoC;EAAoB;;EAAC;IAAoC;EAAqB;;EAAC;IAAqC;EAAkB;;EAAC;IAAkB;EAAe;;EAAC;IAAgB;EAAqB;;EAAC;IAAa;EAAoB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAmB;;EAAC;IAAkB;EAAoB;;EAAC;IAAoB,wBAAwB;IAAC;EAAyB;;EAAC;IAAoB,4BAA4B;IAAC;EAAyB;;EAAC;IAAoB,2BAA2B;IAAC;EAA4B;;EAAC;IAAoB,2BAA2B;IAAC;EAAwB;;EAAC;IAAkB,8BAA8B;IAAC;EAA+B;;EAAC;IAAkB,kCAAkC;IAAC;EAA+B;;EAAC;IAAkB,iCAAiC;IAAC;EAAkC;;EAAC;IAAkB,iCAAiC;IAAC;EAA8B;;EAAC;IAAe;EAA6B;;EAAC;IAA8B;EAA8B;;EAAC;IAA8B;EAAiC;;EAAC;IAA8B;EAAgC;;EAAC;IAAe;EAA6B;;EAAC;IAAkB,8BAA8B;IAAC;EAA+B;;EAAC;IAAkB,kCAAkC;IAAC;EAA+B;;EAAC;IAAkB,iCAAiC;IAAC;EAAkC;;EAAC;IAAkB,iCAAiC;IAAC;EAA8B;;EAAC;IAAkB,4BAA4B;IAAC;EAA6B;;EAAC;IAAkB,gCAAgC;IAAC;EAA6B;;EAAC;IAAkB,+BAA+B;IAAC;EAAgC;;EAAC;IAAkB,+BAA+B;IAAC;EAA4B;;EAAC;IAAoB,6BAA6B;IAAC;EAA8B;;EAAC;IAAoB,iCAAiC;IAAC;EAA8B;;EAAC;IAAoB,gCAAgC;IAAC;EAAiC;;EAAC;IAAoB,gCAAgC;IAAC;EAA6B;;EAAC;IAAqB;EAAwB;;EAAC;IAAqB;EAAyB;;EAAC;IAAqB;EAA4B;;EAAC;IAAqB;EAA2B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAAkC;;EAAC;IAAmB;EAAiC;;EAAC;IAAgB;EAA6B;;EAAC;IAAgB;EAA8B;;EAAC;IAAgB;EAAiC;;EAAC;IAAgB;EAAgC;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAAkC;;EAAC;IAAmB;EAAiC;;EAAC;IAAmB;EAA4B;;EAAC;IAAmB;EAA6B;;EAAC;IAAmB;EAAgC;;EAAC;IAAmB;EAA+B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAAiC;;EAAC;IAAqB;EAAgC;;EAAC;IAAkB;EAAkB;;EAAC;IAAmB;EAAmB;;EAAC;IAAmB;EAAmB;;EAAC;IAAmB;EAAmB;;EAAC;IAAiB;EAAiB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAmB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAqB;;EAAC;IAAc;EAAoB;;EAAC;IAAc;EAAsB;;EAAC;IAAc;EAAuB;;EAAC;IAAc;EAAqB;;EAAC;IAAgB;EAAqB;;EAAC;IAAiB;EAAkB;;EAAC;IAAiB;EAAW;;EAAC;IAAoB;EAAc;;EAAC;IAAoB;EAAc;;EAAC;IAAiB;EAAW;;EAAC;IAAiB;EAAW;;EAAC;IAAiB;EAAW;;EAAC;IAAwB;EAAkB;;EAAC;IAAW;EAAa;;EAAC;IAAkB;EAAoB;;EAAC;IAAY;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAiB;EAAmB;;EAAC;IAAW;EAAa;;EAAC;IAAmB;EAAqB;;EAAC;IAAgB;EAAkB;;EAAC;IAAkB;EAAoB;;EAAC;IAAwB;EAA0B;;EAAC;IAAwB;EAA0B;;EAAC;IAAwB;EAA0B;;EAAC;IAAqB;EAAuB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAU;EAAY;;EAAC;IAAiB;EAAmB;;EAAC;IAAY;EAAY;;EAAC;IAA6B;EAAa;;EAAC;IAAoC;EAAoB;;EAAC;IAA8B;EAAc;;EAAC;IAA4B;EAAY;;EAAC;IAAmC;EAAmB;;EAAC;IAA6B;EAAa;;EAAC;IAAqC;EAAqB;;EAAC;IAAkC;EAAkB;;EAAC;IAAoC;EAAoB;;EAAC;IAA0C;EAA0B;;EAAC;IAA0C;EAA0B;;EAAC;IAA0C;EAA0B;;EAAC;IAAuC;EAAuB;;EAAC;IAAiC;EAAiB;;EAAC;IAAiC;EAAiB;;EAAC;IAA4B;EAAY;;EAAC;IAAmC;EAAmB;;EAAC;IAA8B;EAAY;;EAAC;IAAc;EAAkB;;EAAC;IAAsB;EAA0B;;EAAC;IAAc;EAAqB;;EAAC;IAAsB;EAA6B;;EAAC;IAAe;EAAc;;EAAC;IAAuB;EAAsB;;EAAC;IAAkB;EAAgB;;EAAC;IAAiB;EAAsB;;EAAC;IAAe;EAAoB;;EAAC;IAAkB;EAAkB;;EAAC;IAAoB;EAAoB;;EAAC;IAAmB;EAAmB;;EAAC;IAAe;EAAe;;EAAC;IAAgB;EAAqB;;EAAC;IAAc;EAAmB;;EAAC;IAAiB;EAAiB;;EAAC;IAAkB;EAAkB;;EAAC;IAAmB;EAA0B;;EAAC;IAAiB;EAAwB;;EAAC;IAAoB;EAAsB;;EAAC;IAAqB;EAA6B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAAoB;;EAAC;IAAmB;EAAwB;;EAAC;IAAiB;EAAsB;;EAAC;IAAqB;EAA2B;;EAAC;IAAoB;EAA0B;;EAAC;IAAY;EAAW;;EAAC;IAAe;EAAa;;EAAC;IAAkB;EAAa;;EAAC;IAAe;EAAS;;EAAC;IAAiB;EAAW;;EAAC;IAAe;EAAW;;EAAC;IAAmB;EAAa;;EAAC;IAAiB;EAAa;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAc;EAAQ;;EAAC;IAAc;EAAQ;;EAAC;IAAc;EAAQ;;EAAC;IAAiB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAO;;EAAC;IAAiB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAU;;EAAC;IAAoB,UAAU;IAAC,UAAU;IAAC;EAAa;;EAAC;IAAgB;EAAU;;EAAC;IAAiB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAU;;EAAC;IAAe;EAAwL;;EAAC;IAAgB;EAAuD;;EAAC;IAAe;EAAuE;;EAAC;IAAmB;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAgB;EAAe;;EAAC;IAAiB;EAAe;;EAAC;IAAiB;EAAe;;EAAC;IAAmB;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAoB;EAAe;;EAAC;IAAgB;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAAiC;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAAiC;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAAS;EAAQ;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAY;EAAW;;EAAC;IAAU;EAAU;;EAAC;IAAY;EAAW;;EAAC;IAAc;EAAY;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAiB;;EAAC;IAAe;EAAc;;EAAC;IAAa;EAAkB;;EAAC;IAAa;EAAiB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAkB;;EAAC;IAAc;EAAiB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAe;EAAkB;;EAAC;IAAe;EAAgB;;EAAC;IAAe;EAAmB;;EAAC;IAAe;EAAkB;;EAAC;IAAe;EAAmB;;EAAC;IAAe;EAAgB;;EAAC;IAAe;EAAmB;;EAAC;IAAgB;EAAkB;;EAAC;IAAkB;EAAa;;EAAC;IAAmB;EAAgB;;EAAC;IAAkB;EAAiB;;EAAC;IAAoB;EAAe;;EAAC;IAAqB;EAAiB;;EAAC;IAAmB;EAAa;;EAAC;IAAiB;EAA0B;;EAAC;IAAkB;EAA2B;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAkB;EAAuB;;EAAC;IAAS;EAAQ;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAY;EAAW;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAW;EAAc;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAW;;EAAC;IAAU,eAAe;IAAC;EAAY;;EAAC;IAAU,aAAa;IAAC;EAAc;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,mBAAmB;IAAC;EAAgB;;EAAC;IAAU,iBAAiB;IAAC;EAAkB;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,kBAAkB;IAAC;EAAe;;EAAC;IAAU,gBAAgB;IAAC;EAAiB;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,kBAAkB;IAAC;EAAe;;EAAC;IAAU,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAa,kBAAkB;IAAC;EAAe;;EAAC;IAAa,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,iBAAiB;IAAC;EAAc;;EAAC;IAAW,eAAe;IAAC;EAAgB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,sBAAsB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAqB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,qBAAqB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAoB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,kBAAkB;IAAC;EAAe;;EAAC;IAAY,gBAAgB;IAAC;EAAiB;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAgB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAkB;;EAAC;IAAa;EAAgB;;EAAC;IAAW;EAAc;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAsB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAqB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAe;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAgB;;EAAC;IAA0B;EAAQ;;EAAC;IAA0B;EAAa;;EAAC;IAA0B;EAAY;;EAAC;IAA0B;EAAa;;EAAC;IAA0B;EAAW;;EAAC;IAA0B;EAAc;;EAAC;IAA0B;EAAa;;EAAC;IAA0B;EAAW;;EAAC;IAA2B;EAAa;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAY;;EAAC;IAA6B;EAAW;;EAAC;IAA2B;EAAU;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAa;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAY;;EAAC;IAA4B;EAAc;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAW;;EAAC;IAA2B,eAAe;IAAC;EAAY;;EAAC;IAA2B,aAAa;IAAC;EAAc;;EAAC;IAA2B,oBAAoB;IAAC;EAAiB;;EAAC;IAA2B,kBAAkB;IAAC;EAAmB;;EAAC;IAA2B,mBAAmB;IAAC;EAAgB;;EAAC;IAA2B,iBAAiB;IAAC;EAAkB;;EAAC;IAA2B,oBAAoB;IAAC;EAAiB;;EAAC;IAA2B,kBAAkB;IAAC;EAAmB;;EAAC;IAA2B,kBAAkB;IAAC;EAAe;;EAAC;IAA2B,gBAAgB;IAAC;EAAiB;;EAAC;IAA2B,qBAAqB;IAAC;EAAkB;;EAAC;IAA2B,mBAAmB;IAAC;EAAoB;;EAAC;IAA2B,oBAAoB;IAAC;EAAiB;;EAAC;IAA2B,kBAAkB;IAAC;EAAmB;;EAAC;IAA2B,kBAAkB;IAAC;EAAe;;EAAC;IAA2B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,oBAAoB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAmB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA8B,kBAAkB;IAAC;EAAe;;EAAC;IAA8B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,iBAAiB;IAAC;EAAc;;EAAC;IAA4B,eAAe;IAAC;EAAgB;;EAAC;IAA4B,qBAAqB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAoB;;EAAC;IAA4B,oBAAoB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAmB;;EAAC;IAA4B,qBAAqB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAoB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,sBAAsB;IAAC;EAAmB;;EAAC;IAA4B,oBAAoB;IAAC;EAAqB;;EAAC;IAA4B,qBAAqB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAoB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,qBAAqB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAoB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,kBAAkB;IAAC;EAAe;;EAAC;IAA6B,gBAAgB;IAAC;EAAiB;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAa;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAgB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAgB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAqB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAgB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA8B;EAAe;;EAAC;IAA8B;EAAiB;;EAAC;IAA8B;EAAkB;;EAAC;IAA8B;EAAgB;;EAAC;IAA4B;EAAc;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAsB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAqB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAe;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAgB;;EAAC;IAAa;EAAY;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAkB;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAe;;EAAC;IAAc;EAAiB;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAc;;EAAC;IAAgB;EAAc;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAgB;EAAc;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAgB;;EAAC;IAAqB;EAAgB;;EAAC;IAAa;EAAY;;EAAC;IAAgB;EAAe;;EAAC;IAAkB;EAAgB;;EAAC;IAAa;EAAW;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAc;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAc;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAqD;EAAqB;;EAAC;IAAc;EAAa;;EAAC;IAAoB;EAAkB;;EAAC;IAAkB;EAAgB;;EAAC;IAAiB;EAAe;;EAAC;IAAiB;EAAe;;EAAC;IAAuB;EAAqB;;EAAC;IAAmB;EAAsB;;EAAC;IAAmB;EAAsB;;EAAC;IAAiB;EAAoB;;EAAC;IAAwB;EAA2B;;EAAC;IAAqB;EAAwB;;EAAC;IAAkB;EAAqB;;EAAC;IAAyB;EAA4B;;EAAC;IAAsB;EAAyB;;EAAC;IAAgB;EAAmB;;EAAC;IAAe;EAAS;;EAAC;IAAgB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAW;;EAAC;IAAiB;EAAS;;EAAC;IAA4B;EAAS;;EAAC;IAA6B;EAAW;;EAAC;IAA6B;EAAU;;EAAC;IAA6B;EAAW;;EAAC;IAA8B;EAAS;;EAAC;IAA4B;EAAS;;EAAC;IAA6B;EAAW;;EAAC;IAA6B;EAAU;;EAAC;IAA6B;EAAW;;EAAC;IAA8B;EAAS;;EAAC;IAAiD;EAAS;;EAAC;IAAmB;EAAa;;EAAC;IAAqB;EAAe;;EAAC;IAAsB;EAAgB;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAe;;EAAC;IAAuB;EAAiB;;EAAC;IAAuB;EAAiB;;EAAC;IAAwB;EAAkB;;EAAC;IAAwB;EAAkB;;EAAC;IAAuB;EAAiB;;EAAC;IAAuB;EAAiB;;EAAC;IAAqB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAS;EAAS;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAe;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAY;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAW;;EAAC;IAAU,gBAAgB;IAAC;EAAa;;EAAC;IAAU,cAAc;IAAC;EAAe;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,mBAAmB;IAAC;EAAgB;;EAAC;IAAU,iBAAiB;IAAC;EAAkB;;EAAC;IAAU,sBAAsB;IAAC;EAAmB;;EAAC;IAAU,oBAAoB;IAAC;EAAqB;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,mBAAmB;IAAC;EAAgB;;EAAC;IAAU,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAsB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAA0C;EAAW;;EAAC;IAAoC,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAoC,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAqC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuD;EAAW;;EAAC;IAAiD,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAiD,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAkD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA4D;EAAW;;EAAC;IAAsD,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA6D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyE;EAAW;;EAAC;IAAmE,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAmE,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA0E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC;EAAuB;;EAAC;IAAyC;EAA0B;;EAAC;IAAyC;EAAyB;;EAAC;IAAyC;EAA0B;;EAAC;IAA0C;EAAuB;;EAAC;IAAqD;EAAuB;;EAAC;IAAsD;EAA0B;;EAAC;IAAsD;EAAyB;;EAAC;IAAsD;EAA0B;;EAAC;IAAuD;EAAuB;;EAAC;IAAyB;EAAmB;;EAAC;IAAyB;EAAmB;;EAAC;IAAY;EAAe;;EAAC;IAAW;EAAc;;EAAC;IAAc;EAAiB;;EAAC;IAAc;EAAiB;;EAAC;IAAoC;EAAe;;EAAC;IAAa,QAAQ;IAAC,MAAM;IAAC,OAAO;IAAC;EAAK;;EAAC;IAAgB,WAAW;IAAC,SAAS;IAAC,UAAU;IAAC;EAAQ;;EAAC;IAAe,QAAQ;IAAC;EAAK;;EAAC;IAAe,MAAM;IAAC;EAAO;;EAAC;IAAkB,WAAW;IAAC;EAAQ;;EAAC;IAAkB,SAAS;IAAC;EAAU;;EAAC;IAAW;EAAK;;EAAC;IAAa;EAAO;;EAAC;IAAc;EAAQ;;EAAC;IAAY;EAAM;;EAAC;IAAc;EAAQ;;EAAC;IAAgB;EAAU;;EAAC;IAAiB;EAAW;;EAAC;IAAe;EAAS;;EAAC;IAAiB;EAAW;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAiB;;EAAC;IAAY;EAAW;;EAAC;IAAe;EAA8B;;EAAC;IAAe;EAAgC;;EAAC;IAAY;EAAsD;;EAAC;IAAe;EAA4D;;EAAC;IAAe;EAA8D;;EAAC;IAAe;EAAgE;;EAAC;IAAgB;EAAsC;;EAAC;IAAkB;EAAsC;;EAAC;IAAoB;EAA8B;;EAAC;IAAiB;EAAe;;EAAC;IAAmB;EAAwD;;EAAC;IAA4B;EAA8B;;EAAC;IAA4B;EAAgC;;EAAC;IAAyB;EAAsD;;EAAC;IAA4B;EAA4D;;EAAC;IAA4B;EAA8D;;EAAC;IAA4B;EAAgE;;EAAC;IAA6B;EAAsC;;EAAC;IAA+B;EAAsC;;EAAC;IAAiC;EAA8B;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAwD;;EAAC;IAA4B;EAA8B;;EAAC;IAA4B;EAAgC;;EAAC;IAAyB;EAAsD;;EAAC;IAA4B;EAA4D;;EAAC;IAA4B;EAA8D;;EAAC;IAA4B;EAAgE;;EAAC;IAA6B;EAAsC;;EAAC;IAA+B;EAAsC;;EAAC;IAAiC;EAA8B;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAwD;;EAAC;IAA8C;EAA8B;;EAAC;IAA8C;EAAgC;;EAAC;IAA2C;EAAsD;;EAAC;IAA8C;EAA4D;;EAAC;IAA8C;EAA8D;;EAAC;IAA8C;EAAgE;;EAAC;IAA+C;EAAsC;;EAAC;IAAiD;EAAsC;;EAAC;IAAmD;EAA8B;;EAAC;IAAgD;EAAe;;EAAC;IAAkD;EAAwD;;EAAC;IAAkB;EAAiB;;EAAC;IAAoB;EAAmB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAgB;EAAiB;;EAAC;IAAiB;EAAkB;;EAAC;IAAe;EAAe;;EAAC;IAAiB;EAAiB;;EAAC;IAAgB;EAAgB;;EAAC;IAAkB;EAAkB;;EAAC;IAAsB;EAAW;;EAAC;IAAgB,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAAgB,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC;EAAW;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD;EAAW;;EAAC;IAA2C,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA2C,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA4C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC;EAAW;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC;EAAW;;EAAC;IAA+B,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAwC;EAAW;;EAAC;IAAkC,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAyC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmE;EAAW;;EAAC;IAA6D,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA6D,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD;EAAW;;EAAC;IAA+C,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuD;EAAW;;EAAC;IAAiD,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAwD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB;EAAgB;;EAAC;IAAqB;EAAmB;;EAAC;IAAqB;EAAkB;;EAAC;IAAqB;EAAmB;;EAAC;IAAsB;EAAgB;;EAAC;IAAiC;EAAgB;;EAAC;IAAkC;EAAmB;;EAAC;IAAkC;EAAkB;;EAAC;IAAkC;EAAmB;;EAAC;IAAmC;EAAgB;;EAAC;IAAiC;EAAgB;;EAAC;IAAkC;EAAmB;;EAAC;IAAkC;EAAkB;;EAAC;IAAkC;EAAmB;;EAAC;IAAmC;EAAgB;;EAAC;IAAY;EAAiB;;EAAC;IAAgB;EAAiB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiD;EAAyB;;EAAC;IAAuD;EAA4B;;EAAC;IAA+C;EAAoB;;EAAC;IAA8D;EAAyB;;EAAC;IAAoE;EAA4B;;EAAC;IAA4D;EAAoB;;EAAC;IAA8D;EAAyB;;EAAC;IAAoE;EAA4B;;EAAC;IAA4D;EAAoB;;EAAC;IAAiB,kCAAkC;IAAC;EAAiC;;EAAC;IAA0B,2BAA2B;IAAC;EAA4B;;EAAC;IAAsB;EAAqB;;EAAC;IAAoB;EAAsB;;EAAC;IAAqB;EAAgB;;EAAC;IAAmB;EAAqB;;EAAC;IAAoB;EAAoB;;EAAC;IAAqB;EAAmB;;EAAC;IAAiB,wBAAwB;IAAC;EAAgB;;EAAC;IAAiB,wBAAwB;IAAC;EAAgB;;EAAC;IAAgB,uBAAuB;IAAC;EAAe;;EAAC;IAAiB,wBAAwB;IAAC;EAAgB;;EAAC;IAAoB;EAAsB;;EAAC;IAAe;EAAkB;;EAAC;IAAkB;EAAqB;;EAAC;IAAkB;EAAqB;;EAAC;IAAoB;EAAuB;;EAAC;IAAuB;EAA0B;;EAAC;IAAa;EAAkB;;EAAC;IAAe;EAAiB;;EAAC;IAAuB;EAAkB;;EAAC;IAAwB;EAAkB;;EAAC;IAAoB;EAAe;;EAAC;IAAyB;EAAoB;;EAAC;IAAyB;EAAoB;;EAAC;IAAkB,oBAAoB;IAAC;EAAiB;;EAAC;IAAiB;EAAwB;;EAAC;IAAe;EAAoB;;EAAC;IAAc,eAAe;IAAC,sBAAsB;IAAC;EAAkB;;EAAC;IAAS;EAAO;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAW;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAU;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAU;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAY;EAAU;;EAAC;IAAU;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAS;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAS;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAS;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAY;EAAU;;EAAC;IAAc;EAAW;;EAAC;IAAS;EAAS;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAY;EAAY;;EAAC;IAAW,UAAU;IAAC;EAAK;;EAAC;IAAW,eAAe;IAAC;EAAU;;EAAC;IAAW,cAAc;IAAC;EAAS;;EAAC;IAAW,eAAe;IAAC;EAAU;;EAAC;IAAW,aAAa;IAAC;EAAQ;;EAAC;IAAW,gBAAgB;IAAC;EAAW;;EAAC;IAAW,eAAe;IAAC;EAAU;;EAAC;IAAW,aAAa;IAAC;EAAQ;;EAAC;IAAY,eAAe;IAAC;EAAU;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,YAAY;IAAC;EAAO;;EAAC;IAAe,iBAAiB;IAAC;EAAY;;EAAC;IAAe,sBAAsB;IAAC;EAAiB;;EAAC;IAAe,qBAAqB;IAAC;EAAgB;;EAAC;IAAe,sBAAsB;IAAC;EAAiB;;EAAC;IAAe,oBAAoB;IAAC;EAAe;;EAAC;IAAe,uBAAuB;IAAC;EAAkB;;EAAC;IAAe,sBAAsB;IAAC;EAAiB;;EAAC;IAAe,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,sBAAsB;IAAC;EAAiB;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,mBAAmB;IAAC;EAAc;;EAAC;IAAe,cAAc;IAAC;EAAS;;EAAC;IAAe,mBAAmB;IAAC;EAAc;;EAAC;IAAe,kBAAkB;IAAC;EAAa;;EAAC;IAAe,mBAAmB;IAAC;EAAc;;EAAC;IAAe,iBAAiB;IAAC;EAAY;;EAAC;IAAe,oBAAoB;IAAC;EAAe;;EAAC;IAAe,mBAAmB;IAAC;EAAc;;EAAC;IAAe,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,mBAAmB;IAAC;EAAc;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,gBAAgB;IAAC;EAAW;;EAAC;IAAmB;EAAkB;;EAAC;IAAmB;EAAqB;;EAAC;IAAyB;EAAwB;;EAAC;IAAyB;EAA2B;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAkB;EAA8C;;EAAC;IAAkB;EAA8C;;EAAC;IAAkB;EAA8C;;EAAC;IAAoB;EAA0B;;EAAC;IAAc;EAAgB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAiB;EAA2B;;EAAC;IAAiB;EAA2B;;EAAC;IAAiB;EAA2B;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAkB;EAAoB;;EAAC;IAAkB;EAAoB;;EAAC;IAAkB;EAAoB;;EAAC;IAAkB;EAAoB;;EAAC;IAAoB;EAAsB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAkB;;EAAC;IAAkB;EAAoB;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAoB;EAAuB;;EAAC;IAAc;EAAa;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAoB;EAAmB;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAkB;EAAiB;;EAAC;IAAe,yBAAyB;IAAC,yBAAyB;IAAC,oBAAoB;IAAC,oBAAoB;IAAC,oBAAoB;IAAC,qBAAqB;IAAC,qBAAqB;IAAC;EAA2P;;EAAC;IAAoB;EAAc;;EAAC;IAAmB;EAAuB;;EAAC;IAAgB;EAAoB;;EAAC;IAAsB;EAA0B;;EAAC;IAAkB;EAAsB;;EAAC;IAAyB;EAA6B;;EAAC;IAAmB;EAAuB;;EAAC;IAAwB;EAA4B;;EAAC;IAAiB;EAAqB;;EAAC;IAAqB;EAAyB;;EAAC;IAAa,qBAAqB;IAAC;EAAqB;;EAAC;IAAc,sBAAsB;IAAC;EAAsB;;EAAC;IAAc,uBAAuB;IAAC;EAAuB;;EAAC;IAAc,sBAAsB;IAAC;EAAsB;;EAAC;IAAc,uBAAuB;IAAC;EAAuB;;EAAC;IAAe,qBAAqB;IAAC;EAAqB;;EAAC;IAAe,wBAAwB;IAAC;EAAwB;;EAAC;IAAe,uBAAuB;IAAC;EAAuB;;EAAC;IAAe,wBAAwB;IAAC;EAAwB;;EAAC;IAAe,uBAAuB;IAAC;EAAuB;;EAAC;IAAe;EAAqB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAiB;EAAqB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAAe;EAAqB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAiB;EAAqB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAA0B,qBAAqB;IAAC;EAAqB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,qBAAqB;IAAC;EAAqB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA0B,qBAAqB;IAAC;EAAqB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,qBAAqB;IAAC;EAAqB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAAc;EAAoB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAiB;EAA0B;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAA2B;EAAoB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA8B;EAA0B;;EAAC;IAA6B;EAAyB;;EAAC;IAA6B;EAAyB;;EAAC;IAA2B;EAAoB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA8B;EAA0B;;EAAC;IAA6B;EAAyB;;EAAC;IAA6B;EAAyB;;EAAC;IAAmB;EAAyB;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA4B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA4B;;EAAC;IAAoB;EAA8B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA2B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAA6B;;EAAC;IAAqB;EAA+B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA4B;;EAAC;IAAuB;EAA6B;;EAAC;IAAuB;EAA4B;;EAAC;IAAsB;EAA2B;;EAAC;IAAsB;EAA4B;;EAAC;IAAmB;EAAyB;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA4B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA4B;;EAAC;IAAoB;EAA8B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA2B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAA6B;;EAAC;IAAqB;EAA+B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA4B;;EAAC;IAAuB;EAA6B;;EAAC;IAAuB;EAA4B;;EAAC;IAAsB;EAA2B;;EAAC;IAAsB;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAc;EAAoB;;EAAC;IAAc;EAAuB;;EAAC;IAAc;EAAuB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAAc;EAAoB;;EAAC;IAAc;EAAuB;;EAAC;IAAc;EAAuB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAAqB;EAAwB;;EAAC;IAAoB;EAAuB;;EAAC;IAAgB;EAAgG;;EAAC;IAAuB;EAAmE;;EAAC;IAAwB;EAA2B;;EAAC;IAAuB;EAA8B;;EAAC;IAA0B;EAA6B;;EAAC;IAAiB;EAAiC;;EAAC;IAAa;EAAiD;;EAAC;IAAc;EAAiD;;EAAC;IAAiB;EAAkD;;EAAC;IAAiB;EAAwB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAwB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAuB;;EAAC;IAAmB;EAAsB;;EAAC;IAAc;EAAqB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAqB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAgB;EAAmB;;EAAC;IAA0B;EAA8B;;EAAC;IAA0B;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAA8B;EAA8B;;EAAC;IAAwB;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAA0B;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAA2C;EAA8B;;EAAC;IAAqC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAA2C;EAA8B;;EAAC;IAAqC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAyD;EAA8B;;EAAC;IAAyD;EAA8B;;EAAC;IAAwD;EAA8B;;EAAC;IAA6D;EAA8B;;EAAC;IAAuD;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAAyD;EAA8B;;EAAC;IAAwD;EAA8B;;EAAC;IAAwD;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAAwD;EAA8B;AAAC;;AAAC;EAA0B;IAA6C,mBAAmB;IAAC,8CAA8C;IAAC;EAAiD;;EAAC;IAA6C,mBAAmB;IAAC,kDAAkD;IAAC;EAA6C;;EAAC;IAA6C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA6C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA6C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA6C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA6C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA6C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA6C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA6C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA6C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA6C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA6C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA6C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA6C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA6C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA8C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,8CAA8C;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAA6C;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA8C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA8C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA8C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAAsD;;EAAC;IAA8C,mBAAmB;IAAC,uDAAuD;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA8C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA+C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA+C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAAmD;EAAmB;;EAAC;IAAmD;EAAmB;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA4C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA4C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAAoD;EAAoB;;EAAC;IAAoD;EAAoB;;EAAC;IAAsD;EAAkB;;EAAC;IAAgD,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAgD,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAiD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwE;EAAkB;;EAAC;IAAkE,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAkE,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD;EAAkB;;EAAC;IAAqD;EAAqB;;EAAC;IAAqD;EAAoB;;EAAC;IAAqD;EAAqB;;EAAC;IAAsD;EAAkB;;EAAC;IAAa,UAAU;IAAC,WAAW;IAAC,eAAe;IAAC,SAAS;IAAC,iBAAiB;IAAC,SAAS;IAAC,kBAAkB;IAAC,cAAc;IAAC;EAAkB;;EAAC;IAAiB,WAAW;IAAC,QAAQ;IAAC,gBAAgB;IAAC,SAAS;IAAC,eAAe;IAAC,UAAU;IAAC,SAAS;IAAC;EAAkB;;EAAC;IAA0B,UAAU;IAAC,WAAW;IAAC,eAAe;IAAC,SAAS;IAAC,iBAAiB;IAAC,SAAS;IAAC,kBAAkB;IAAC,cAAc;IAAC;EAAkB;;EAAC;IAA8B,WAAW;IAAC,QAAQ;IAAC,gBAAgB;IAAC,SAAS;IAAC,eAAe;IAAC,UAAU;IAAC,SAAS;IAAC;EAAkB;;EAAC;IAA6C;EAAe;;EAAC;IAAc;EAA2B;;EAAC;IAAc;EAA2B;;EAAC;IAAe;EAA4B;;EAAC;IAAoB;EAAwB;;EAAC;IAAc,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAc,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAe,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC;EAAwB;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC;EAAwB;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC;EAAwB;;EAAC;IAA6B,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwC;EAAwB;;EAAC;IAAkC,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAyC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC;EAAwB;;EAAC;IAAgC,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD;EAAwB;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD;EAAwB;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqD;EAAwB;;EAAC;IAA+C,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA0D;EAAwB;;EAAC;IAAoD,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA2D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB;EAAc;;EAAC;IAAmB;EAAgB;;EAAC;IAAmB;EAAiB;;EAAC;IAAmB;EAAgB;;EAAC;IAAmB;EAAiB;;EAAC;IAAoB;EAAc;;EAAC;IAA+B;EAAc;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAiC;EAAc;;EAAC;IAA+B;EAAc;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAiC;EAAc;;EAAC;IAAiD;EAAc;;EAAC;IAAkD;EAAgB;;EAAC;IAAkD;EAAiB;;EAAC;IAAkD;EAAgB;;EAAC;IAAkD;EAAiB;;EAAC;IAAmD;EAAc;;EAAC;IAAe;EAA0B;;EAAC;IAAe;EAAuB;;EAAC;IAAa;EAAqB;;EAAC;IAAoB;EAA0B;;EAAC;IAAiB;EAAuB;;EAAC;IAAc;EAAwB;;EAAC;IAAqB;EAA6B;;EAAC;IAAkB;EAA0B;;EAAC;IAAY;EAAuB;;EAAC;IAAe;EAAwB;;EAAC;IAAkB;EAA2B;;EAAC;IAAiB;EAA0B;;EAAC;IAAiB;EAA0B;;EAAC;IAAqB;EAAuB;;EAAC;IAAqB;EAAuB;;EAAC;IAAa;EAAoB;;EAAC;IAAc;EAAqB;;EAAC;IAAgB;EAAuB;;EAAC;IAAqB;EAAwB;;EAAC;IAAqB;EAAuB;;EAAC;IAAwB;EAAkB;;EAAC;IAAkB,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAkB,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqC;EAAkB;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAgC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqC;EAAkB;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAgC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA0C;EAAkB;;EAAC;IAAoC,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA2C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuD;EAAkB;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuD;EAAkB;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB;EAAkB;;EAAC;IAAuB;EAAqB;;EAAC;IAAuB;EAAoB;;EAAC;IAAuB;EAAqB;;EAAC;IAAwB;EAAkB;;EAAC;IAAmC;EAAkB;;EAAC;IAAoC;EAAqB;;EAAC;IAAoC;EAAoB;;EAAC;IAAoC;EAAqB;;EAAC;IAAqC;EAAkB;;EAAC;IAAmC;EAAkB;;EAAC;IAAoC;EAAqB;;EAAC;IAAoC;EAAoB;;EAAC;IAAoC;EAAqB;;EAAC;IAAqC;EAAkB;;EAAC;IAAkB;EAAe;;EAAC;IAAgB;EAAqB;;EAAC;IAAa;EAAoB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAmB;;EAAC;IAAkB;EAAoB;;EAAC;IAAoB,wBAAwB;IAAC;EAAyB;;EAAC;IAAoB,4BAA4B;IAAC;EAAyB;;EAAC;IAAoB,2BAA2B;IAAC;EAA4B;;EAAC;IAAoB,2BAA2B;IAAC;EAAwB;;EAAC;IAAkB,8BAA8B;IAAC;EAA+B;;EAAC;IAAkB,kCAAkC;IAAC;EAA+B;;EAAC;IAAkB,iCAAiC;IAAC;EAAkC;;EAAC;IAAkB,iCAAiC;IAAC;EAA8B;;EAAC;IAAe;EAA6B;;EAAC;IAA8B;EAA8B;;EAAC;IAA8B;EAAiC;;EAAC;IAA8B;EAAgC;;EAAC;IAAe;EAA6B;;EAAC;IAAkB,8BAA8B;IAAC;EAA+B;;EAAC;IAAkB,kCAAkC;IAAC;EAA+B;;EAAC;IAAkB,iCAAiC;IAAC;EAAkC;;EAAC;IAAkB,iCAAiC;IAAC;EAA8B;;EAAC;IAAkB,4BAA4B;IAAC;EAA6B;;EAAC;IAAkB,gCAAgC;IAAC;EAA6B;;EAAC;IAAkB,+BAA+B;IAAC;EAAgC;;EAAC;IAAkB,+BAA+B;IAAC;EAA4B;;EAAC;IAAoB,6BAA6B;IAAC;EAA8B;;EAAC;IAAoB,iCAAiC;IAAC;EAA8B;;EAAC;IAAoB,gCAAgC;IAAC;EAAiC;;EAAC;IAAoB,gCAAgC;IAAC;EAA6B;;EAAC;IAAqB;EAAwB;;EAAC;IAAqB;EAAyB;;EAAC;IAAqB;EAA4B;;EAAC;IAAqB;EAA2B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAAkC;;EAAC;IAAmB;EAAiC;;EAAC;IAAgB;EAA6B;;EAAC;IAAgB;EAA8B;;EAAC;IAAgB;EAAiC;;EAAC;IAAgB;EAAgC;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAAkC;;EAAC;IAAmB;EAAiC;;EAAC;IAAmB;EAA4B;;EAAC;IAAmB;EAA6B;;EAAC;IAAmB;EAAgC;;EAAC;IAAmB;EAA+B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAAiC;;EAAC;IAAqB;EAAgC;;EAAC;IAAkB;EAAkB;;EAAC;IAAmB;EAAmB;;EAAC;IAAmB;EAAmB;;EAAC;IAAmB;EAAmB;;EAAC;IAAiB;EAAiB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAmB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAqB;;EAAC;IAAc;EAAoB;;EAAC;IAAc;EAAsB;;EAAC;IAAc;EAAuB;;EAAC;IAAc;EAAqB;;EAAC;IAAgB;EAAqB;;EAAC;IAAiB;EAAkB;;EAAC;IAAiB;EAAW;;EAAC;IAAoB;EAAc;;EAAC;IAAoB;EAAc;;EAAC;IAAiB;EAAW;;EAAC;IAAiB;EAAW;;EAAC;IAAiB;EAAW;;EAAC;IAAwB;EAAkB;;EAAC;IAAW;EAAa;;EAAC;IAAkB;EAAoB;;EAAC;IAAY;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAiB;EAAmB;;EAAC;IAAW;EAAa;;EAAC;IAAmB;EAAqB;;EAAC;IAAgB;EAAkB;;EAAC;IAAkB;EAAoB;;EAAC;IAAwB;EAA0B;;EAAC;IAAwB;EAA0B;;EAAC;IAAwB;EAA0B;;EAAC;IAAqB;EAAuB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAU;EAAY;;EAAC;IAAiB;EAAmB;;EAAC;IAAY;EAAY;;EAAC;IAA6B;EAAa;;EAAC;IAAoC;EAAoB;;EAAC;IAA8B;EAAc;;EAAC;IAA4B;EAAY;;EAAC;IAAmC;EAAmB;;EAAC;IAA6B;EAAa;;EAAC;IAAqC;EAAqB;;EAAC;IAAkC;EAAkB;;EAAC;IAAoC;EAAoB;;EAAC;IAA0C;EAA0B;;EAAC;IAA0C;EAA0B;;EAAC;IAA0C;EAA0B;;EAAC;IAAuC;EAAuB;;EAAC;IAAiC;EAAiB;;EAAC;IAAiC;EAAiB;;EAAC;IAA4B;EAAY;;EAAC;IAAmC;EAAmB;;EAAC;IAA8B;EAAY;;EAAC;IAAc;EAAkB;;EAAC;IAAsB;EAA0B;;EAAC;IAAc;EAAqB;;EAAC;IAAsB;EAA6B;;EAAC;IAAe;EAAc;;EAAC;IAAuB;EAAsB;;EAAC;IAAkB;EAAgB;;EAAC;IAAiB;EAAsB;;EAAC;IAAe;EAAoB;;EAAC;IAAkB;EAAkB;;EAAC;IAAoB;EAAoB;;EAAC;IAAmB;EAAmB;;EAAC;IAAe;EAAe;;EAAC;IAAgB;EAAqB;;EAAC;IAAc;EAAmB;;EAAC;IAAiB;EAAiB;;EAAC;IAAkB;EAAkB;;EAAC;IAAmB;EAA0B;;EAAC;IAAiB;EAAwB;;EAAC;IAAoB;EAAsB;;EAAC;IAAqB;EAA6B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAAoB;;EAAC;IAAmB;EAAwB;;EAAC;IAAiB;EAAsB;;EAAC;IAAqB;EAA2B;;EAAC;IAAoB;EAA0B;;EAAC;IAAY;EAAW;;EAAC;IAAe;EAAa;;EAAC;IAAkB;EAAa;;EAAC;IAAe;EAAS;;EAAC;IAAiB;EAAW;;EAAC;IAAe;EAAW;;EAAC;IAAmB;EAAa;;EAAC;IAAiB;EAAa;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAc;EAAQ;;EAAC;IAAc;EAAQ;;EAAC;IAAc;EAAQ;;EAAC;IAAiB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAO;;EAAC;IAAiB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAU;;EAAC;IAAoB,UAAU;IAAC,UAAU;IAAC;EAAa;;EAAC;IAAgB;EAAU;;EAAC;IAAiB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAU;;EAAC;IAAe;EAAwL;;EAAC;IAAgB;EAAuD;;EAAC;IAAe;EAAuE;;EAAC;IAAmB;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAgB;EAAe;;EAAC;IAAiB;EAAe;;EAAC;IAAiB;EAAe;;EAAC;IAAmB;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAoB;EAAe;;EAAC;IAAgB;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAAiC;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAAiC;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAAS;EAAQ;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAY;EAAW;;EAAC;IAAU;EAAU;;EAAC;IAAY;EAAW;;EAAC;IAAc;EAAY;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAiB;;EAAC;IAAe;EAAc;;EAAC;IAAa;EAAkB;;EAAC;IAAa;EAAiB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAkB;;EAAC;IAAc;EAAiB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAe;EAAkB;;EAAC;IAAe;EAAgB;;EAAC;IAAe;EAAmB;;EAAC;IAAe;EAAkB;;EAAC;IAAe;EAAmB;;EAAC;IAAe;EAAgB;;EAAC;IAAe;EAAmB;;EAAC;IAAgB;EAAkB;;EAAC;IAAkB;EAAa;;EAAC;IAAmB;EAAgB;;EAAC;IAAkB;EAAiB;;EAAC;IAAoB;EAAe;;EAAC;IAAqB;EAAiB;;EAAC;IAAmB;EAAa;;EAAC;IAAiB;EAA0B;;EAAC;IAAkB;EAA2B;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAkB;EAAuB;;EAAC;IAAS;EAAQ;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAY;EAAW;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAW;EAAc;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAW;;EAAC;IAAU,eAAe;IAAC;EAAY;;EAAC;IAAU,aAAa;IAAC;EAAc;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,mBAAmB;IAAC;EAAgB;;EAAC;IAAU,iBAAiB;IAAC;EAAkB;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,kBAAkB;IAAC;EAAe;;EAAC;IAAU,gBAAgB;IAAC;EAAiB;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,kBAAkB;IAAC;EAAe;;EAAC;IAAU,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAa,kBAAkB;IAAC;EAAe;;EAAC;IAAa,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,iBAAiB;IAAC;EAAc;;EAAC;IAAW,eAAe;IAAC;EAAgB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,sBAAsB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAqB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,qBAAqB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAoB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,kBAAkB;IAAC;EAAe;;EAAC;IAAY,gBAAgB;IAAC;EAAiB;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAgB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAkB;;EAAC;IAAa;EAAgB;;EAAC;IAAW;EAAc;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAsB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAqB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAe;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAgB;;EAAC;IAA0B;EAAQ;;EAAC;IAA0B;EAAa;;EAAC;IAA0B;EAAY;;EAAC;IAA0B;EAAa;;EAAC;IAA0B;EAAW;;EAAC;IAA0B;EAAc;;EAAC;IAA0B;EAAa;;EAAC;IAA0B;EAAW;;EAAC;IAA2B;EAAa;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAY;;EAAC;IAA6B;EAAW;;EAAC;IAA2B;EAAU;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAa;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAY;;EAAC;IAA4B;EAAc;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAW;;EAAC;IAA2B,eAAe;IAAC;EAAY;;EAAC;IAA2B,aAAa;IAAC;EAAc;;EAAC;IAA2B,oBAAoB;IAAC;EAAiB;;EAAC;IAA2B,kBAAkB;IAAC;EAAmB;;EAAC;IAA2B,mBAAmB;IAAC;EAAgB;;EAAC;IAA2B,iBAAiB;IAAC;EAAkB;;EAAC;IAA2B,oBAAoB;IAAC;EAAiB;;EAAC;IAA2B,kBAAkB;IAAC;EAAmB;;EAAC;IAA2B,kBAAkB;IAAC;EAAe;;EAAC;IAA2B,gBAAgB;IAAC;EAAiB;;EAAC;IAA2B,qBAAqB;IAAC;EAAkB;;EAAC;IAA2B,mBAAmB;IAAC;EAAoB;;EAAC;IAA2B,oBAAoB;IAAC;EAAiB;;EAAC;IAA2B,kBAAkB;IAAC;EAAmB;;EAAC;IAA2B,kBAAkB;IAAC;EAAe;;EAAC;IAA2B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,oBAAoB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAmB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA8B,kBAAkB;IAAC;EAAe;;EAAC;IAA8B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,iBAAiB;IAAC;EAAc;;EAAC;IAA4B,eAAe;IAAC;EAAgB;;EAAC;IAA4B,qBAAqB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAoB;;EAAC;IAA4B,oBAAoB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAmB;;EAAC;IAA4B,qBAAqB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAoB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,sBAAsB;IAAC;EAAmB;;EAAC;IAA4B,oBAAoB;IAAC;EAAqB;;EAAC;IAA4B,qBAAqB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAoB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,qBAAqB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAoB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,kBAAkB;IAAC;EAAe;;EAAC;IAA6B,gBAAgB;IAAC;EAAiB;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAa;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAgB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAgB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAqB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAgB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA8B;EAAe;;EAAC;IAA8B;EAAiB;;EAAC;IAA8B;EAAkB;;EAAC;IAA8B;EAAgB;;EAAC;IAA4B;EAAc;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAsB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAqB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAe;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAgB;;EAAC;IAAa;EAAY;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAkB;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAe;;EAAC;IAAc;EAAiB;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAc;;EAAC;IAAgB;EAAc;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAgB;EAAc;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAgB;;EAAC;IAAqB;EAAgB;;EAAC;IAAa;EAAY;;EAAC;IAAgB;EAAe;;EAAC;IAAkB;EAAgB;;EAAC;IAAa;EAAW;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAc;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAc;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAqD;EAAqB;;EAAC;IAAc;EAAa;;EAAC;IAAoB;EAAkB;;EAAC;IAAkB;EAAgB;;EAAC;IAAiB;EAAe;;EAAC;IAAiB;EAAe;;EAAC;IAAuB;EAAqB;;EAAC;IAAmB;EAAsB;;EAAC;IAAmB;EAAsB;;EAAC;IAAiB;EAAoB;;EAAC;IAAwB;EAA2B;;EAAC;IAAqB;EAAwB;;EAAC;IAAkB;EAAqB;;EAAC;IAAyB;EAA4B;;EAAC;IAAsB;EAAyB;;EAAC;IAAgB;EAAmB;;EAAC;IAAe;EAAS;;EAAC;IAAgB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAW;;EAAC;IAAiB;EAAS;;EAAC;IAA4B;EAAS;;EAAC;IAA6B;EAAW;;EAAC;IAA6B;EAAU;;EAAC;IAA6B;EAAW;;EAAC;IAA8B;EAAS;;EAAC;IAA4B;EAAS;;EAAC;IAA6B;EAAW;;EAAC;IAA6B;EAAU;;EAAC;IAA6B;EAAW;;EAAC;IAA8B;EAAS;;EAAC;IAAiD;EAAS;;EAAC;IAAmB;EAAa;;EAAC;IAAqB;EAAe;;EAAC;IAAsB;EAAgB;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAe;;EAAC;IAAuB;EAAiB;;EAAC;IAAuB;EAAiB;;EAAC;IAAwB;EAAkB;;EAAC;IAAwB;EAAkB;;EAAC;IAAuB;EAAiB;;EAAC;IAAuB;EAAiB;;EAAC;IAAqB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAS;EAAS;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAe;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAY;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAW;;EAAC;IAAU,gBAAgB;IAAC;EAAa;;EAAC;IAAU,cAAc;IAAC;EAAe;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,mBAAmB;IAAC;EAAgB;;EAAC;IAAU,iBAAiB;IAAC;EAAkB;;EAAC;IAAU,sBAAsB;IAAC;EAAmB;;EAAC;IAAU,oBAAoB;IAAC;EAAqB;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,mBAAmB;IAAC;EAAgB;;EAAC;IAAU,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAsB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAA0C;EAAW;;EAAC;IAAoC,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAoC,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAqC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuD;EAAW;;EAAC;IAAiD,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAiD,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAkD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA4D;EAAW;;EAAC;IAAsD,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA6D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyE;EAAW;;EAAC;IAAmE,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAmE,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA0E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC;EAAuB;;EAAC;IAAyC;EAA0B;;EAAC;IAAyC;EAAyB;;EAAC;IAAyC;EAA0B;;EAAC;IAA0C;EAAuB;;EAAC;IAAqD;EAAuB;;EAAC;IAAsD;EAA0B;;EAAC;IAAsD;EAAyB;;EAAC;IAAsD;EAA0B;;EAAC;IAAuD;EAAuB;;EAAC;IAAyB;EAAmB;;EAAC;IAAyB;EAAmB;;EAAC;IAAY;EAAe;;EAAC;IAAW;EAAc;;EAAC;IAAc;EAAiB;;EAAC;IAAc;EAAiB;;EAAC;IAAoC;EAAe;;EAAC;IAAa,QAAQ;IAAC,MAAM;IAAC,OAAO;IAAC;EAAK;;EAAC;IAAgB,WAAW;IAAC,SAAS;IAAC,UAAU;IAAC;EAAQ;;EAAC;IAAe,QAAQ;IAAC;EAAK;;EAAC;IAAe,MAAM;IAAC;EAAO;;EAAC;IAAkB,WAAW;IAAC;EAAQ;;EAAC;IAAkB,SAAS;IAAC;EAAU;;EAAC;IAAW;EAAK;;EAAC;IAAa;EAAO;;EAAC;IAAc;EAAQ;;EAAC;IAAY;EAAM;;EAAC;IAAc;EAAQ;;EAAC;IAAgB;EAAU;;EAAC;IAAiB;EAAW;;EAAC;IAAe;EAAS;;EAAC;IAAiB;EAAW;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAiB;;EAAC;IAAY;EAAW;;EAAC;IAAe;EAA8B;;EAAC;IAAe;EAAgC;;EAAC;IAAY;EAAsD;;EAAC;IAAe;EAA4D;;EAAC;IAAe;EAA8D;;EAAC;IAAe;EAAgE;;EAAC;IAAgB;EAAsC;;EAAC;IAAkB;EAAsC;;EAAC;IAAoB;EAA8B;;EAAC;IAAiB;EAAe;;EAAC;IAAmB;EAAwD;;EAAC;IAA4B;EAA8B;;EAAC;IAA4B;EAAgC;;EAAC;IAAyB;EAAsD;;EAAC;IAA4B;EAA4D;;EAAC;IAA4B;EAA8D;;EAAC;IAA4B;EAAgE;;EAAC;IAA6B;EAAsC;;EAAC;IAA+B;EAAsC;;EAAC;IAAiC;EAA8B;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAwD;;EAAC;IAA4B;EAA8B;;EAAC;IAA4B;EAAgC;;EAAC;IAAyB;EAAsD;;EAAC;IAA4B;EAA4D;;EAAC;IAA4B;EAA8D;;EAAC;IAA4B;EAAgE;;EAAC;IAA6B;EAAsC;;EAAC;IAA+B;EAAsC;;EAAC;IAAiC;EAA8B;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAwD;;EAAC;IAA8C;EAA8B;;EAAC;IAA8C;EAAgC;;EAAC;IAA2C;EAAsD;;EAAC;IAA8C;EAA4D;;EAAC;IAA8C;EAA8D;;EAAC;IAA8C;EAAgE;;EAAC;IAA+C;EAAsC;;EAAC;IAAiD;EAAsC;;EAAC;IAAmD;EAA8B;;EAAC;IAAgD;EAAe;;EAAC;IAAkD;EAAwD;;EAAC;IAAkB;EAAiB;;EAAC;IAAoB;EAAmB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAgB;EAAiB;;EAAC;IAAiB;EAAkB;;EAAC;IAAe;EAAe;;EAAC;IAAiB;EAAiB;;EAAC;IAAgB;EAAgB;;EAAC;IAAkB;EAAkB;;EAAC;IAAsB;EAAW;;EAAC;IAAgB,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAAgB,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC;EAAW;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD;EAAW;;EAAC;IAA2C,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA2C,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA4C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC;EAAW;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC;EAAW;;EAAC;IAA+B,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAwC;EAAW;;EAAC;IAAkC,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAyC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmE;EAAW;;EAAC;IAA6D,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA6D,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD;EAAW;;EAAC;IAA+C,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuD;EAAW;;EAAC;IAAiD,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAwD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB;EAAgB;;EAAC;IAAqB;EAAmB;;EAAC;IAAqB;EAAkB;;EAAC;IAAqB;EAAmB;;EAAC;IAAsB;EAAgB;;EAAC;IAAiC;EAAgB;;EAAC;IAAkC;EAAmB;;EAAC;IAAkC;EAAkB;;EAAC;IAAkC;EAAmB;;EAAC;IAAmC;EAAgB;;EAAC;IAAiC;EAAgB;;EAAC;IAAkC;EAAmB;;EAAC;IAAkC;EAAkB;;EAAC;IAAkC;EAAmB;;EAAC;IAAmC;EAAgB;;EAAC;IAAY;EAAiB;;EAAC;IAAgB;EAAiB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiD;EAAyB;;EAAC;IAAuD;EAA4B;;EAAC;IAA+C;EAAoB;;EAAC;IAA8D;EAAyB;;EAAC;IAAoE;EAA4B;;EAAC;IAA4D;EAAoB;;EAAC;IAA8D;EAAyB;;EAAC;IAAoE;EAA4B;;EAAC;IAA4D;EAAoB;;EAAC;IAAiB,kCAAkC;IAAC;EAAiC;;EAAC;IAA0B,2BAA2B;IAAC;EAA4B;;EAAC;IAAsB;EAAqB;;EAAC;IAAoB;EAAsB;;EAAC;IAAqB;EAAgB;;EAAC;IAAmB;EAAqB;;EAAC;IAAoB;EAAoB;;EAAC;IAAqB;EAAmB;;EAAC;IAAiB,wBAAwB;IAAC;EAAgB;;EAAC;IAAiB,wBAAwB;IAAC;EAAgB;;EAAC;IAAgB,uBAAuB;IAAC;EAAe;;EAAC;IAAiB,wBAAwB;IAAC;EAAgB;;EAAC;IAAoB;EAAsB;;EAAC;IAAe;EAAkB;;EAAC;IAAkB;EAAqB;;EAAC;IAAkB;EAAqB;;EAAC;IAAoB;EAAuB;;EAAC;IAAuB;EAA0B;;EAAC;IAAa;EAAkB;;EAAC;IAAe;EAAiB;;EAAC;IAAuB;EAAkB;;EAAC;IAAwB;EAAkB;;EAAC;IAAoB;EAAe;;EAAC;IAAyB;EAAoB;;EAAC;IAAyB;EAAoB;;EAAC;IAAkB,oBAAoB;IAAC;EAAiB;;EAAC;IAAiB;EAAwB;;EAAC;IAAe;EAAoB;;EAAC;IAAc,eAAe;IAAC,sBAAsB;IAAC;EAAkB;;EAAC;IAAS;EAAO;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAW;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAU;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAU;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAY;EAAU;;EAAC;IAAU;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAS;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAS;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAS;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAY;EAAU;;EAAC;IAAc;EAAW;;EAAC;IAAS;EAAS;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAY;EAAY;;EAAC;IAAW,UAAU;IAAC;EAAK;;EAAC;IAAW,eAAe;IAAC;EAAU;;EAAC;IAAW,cAAc;IAAC;EAAS;;EAAC;IAAW,eAAe;IAAC;EAAU;;EAAC;IAAW,aAAa;IAAC;EAAQ;;EAAC;IAAW,gBAAgB;IAAC;EAAW;;EAAC;IAAW,eAAe;IAAC;EAAU;;EAAC;IAAW,aAAa;IAAC;EAAQ;;EAAC;IAAY,eAAe;IAAC;EAAU;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,YAAY;IAAC;EAAO;;EAAC;IAAe,iBAAiB;IAAC;EAAY;;EAAC;IAAe,sBAAsB;IAAC;EAAiB;;EAAC;IAAe,qBAAqB;IAAC;EAAgB;;EAAC;IAAe,sBAAsB;IAAC;EAAiB;;EAAC;IAAe,oBAAoB;IAAC;EAAe;;EAAC;IAAe,uBAAuB;IAAC;EAAkB;;EAAC;IAAe,sBAAsB;IAAC;EAAiB;;EAAC;IAAe,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,sBAAsB;IAAC;EAAiB;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,mBAAmB;IAAC;EAAc;;EAAC;IAAe,cAAc;IAAC;EAAS;;EAAC;IAAe,mBAAmB;IAAC;EAAc;;EAAC;IAAe,kBAAkB;IAAC;EAAa;;EAAC;IAAe,mBAAmB;IAAC;EAAc;;EAAC;IAAe,iBAAiB;IAAC;EAAY;;EAAC;IAAe,oBAAoB;IAAC;EAAe;;EAAC;IAAe,mBAAmB;IAAC;EAAc;;EAAC;IAAe,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,mBAAmB;IAAC;EAAc;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,gBAAgB;IAAC;EAAW;;EAAC;IAAmB;EAAkB;;EAAC;IAAmB;EAAqB;;EAAC;IAAyB;EAAwB;;EAAC;IAAyB;EAA2B;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAkB;EAA8C;;EAAC;IAAkB;EAA8C;;EAAC;IAAkB;EAA8C;;EAAC;IAAoB;EAA0B;;EAAC;IAAc;EAAgB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAiB;EAA2B;;EAAC;IAAiB;EAA2B;;EAAC;IAAiB;EAA2B;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAkB;EAAoB;;EAAC;IAAkB;EAAoB;;EAAC;IAAkB;EAAoB;;EAAC;IAAkB;EAAoB;;EAAC;IAAoB;EAAsB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAkB;;EAAC;IAAkB;EAAoB;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAoB;EAAuB;;EAAC;IAAc;EAAa;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAoB;EAAmB;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAkB;EAAiB;;EAAC;IAAe,yBAAyB;IAAC,yBAAyB;IAAC,oBAAoB;IAAC,oBAAoB;IAAC,oBAAoB;IAAC,qBAAqB;IAAC,qBAAqB;IAAC;EAA2P;;EAAC;IAAoB;EAAc;;EAAC;IAAmB;EAAuB;;EAAC;IAAgB;EAAoB;;EAAC;IAAsB;EAA0B;;EAAC;IAAkB;EAAsB;;EAAC;IAAyB;EAA6B;;EAAC;IAAmB;EAAuB;;EAAC;IAAwB;EAA4B;;EAAC;IAAiB;EAAqB;;EAAC;IAAqB;EAAyB;;EAAC;IAAa,qBAAqB;IAAC;EAAqB;;EAAC;IAAc,sBAAsB;IAAC;EAAsB;;EAAC;IAAc,uBAAuB;IAAC;EAAuB;;EAAC;IAAc,sBAAsB;IAAC;EAAsB;;EAAC;IAAc,uBAAuB;IAAC;EAAuB;;EAAC;IAAe,qBAAqB;IAAC;EAAqB;;EAAC;IAAe,wBAAwB;IAAC;EAAwB;;EAAC;IAAe,uBAAuB;IAAC;EAAuB;;EAAC;IAAe,wBAAwB;IAAC;EAAwB;;EAAC;IAAe,uBAAuB;IAAC;EAAuB;;EAAC;IAAe;EAAqB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAiB;EAAqB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAAe;EAAqB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAiB;EAAqB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAA0B,qBAAqB;IAAC;EAAqB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,qBAAqB;IAAC;EAAqB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA0B,qBAAqB;IAAC;EAAqB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,qBAAqB;IAAC;EAAqB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAAc;EAAoB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAiB;EAA0B;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAA2B;EAAoB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA8B;EAA0B;;EAAC;IAA6B;EAAyB;;EAAC;IAA6B;EAAyB;;EAAC;IAA2B;EAAoB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA8B;EAA0B;;EAAC;IAA6B;EAAyB;;EAAC;IAA6B;EAAyB;;EAAC;IAAmB;EAAyB;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA4B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA4B;;EAAC;IAAoB;EAA8B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA2B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAA6B;;EAAC;IAAqB;EAA+B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA4B;;EAAC;IAAuB;EAA6B;;EAAC;IAAuB;EAA4B;;EAAC;IAAsB;EAA2B;;EAAC;IAAsB;EAA4B;;EAAC;IAAmB;EAAyB;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA4B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA4B;;EAAC;IAAoB;EAA8B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA2B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAA6B;;EAAC;IAAqB;EAA+B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA4B;;EAAC;IAAuB;EAA6B;;EAAC;IAAuB;EAA4B;;EAAC;IAAsB;EAA2B;;EAAC;IAAsB;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAc;EAAoB;;EAAC;IAAc;EAAuB;;EAAC;IAAc;EAAuB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAAc;EAAoB;;EAAC;IAAc;EAAuB;;EAAC;IAAc;EAAuB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAAqB;EAAwB;;EAAC;IAAoB;EAAuB;;EAAC;IAAgB;EAAgG;;EAAC;IAAuB;EAAmE;;EAAC;IAAwB;EAA2B;;EAAC;IAAuB;EAA8B;;EAAC;IAA0B;EAA6B;;EAAC;IAAiB;EAAiC;;EAAC;IAAa;EAAiD;;EAAC;IAAc;EAAiD;;EAAC;IAAiB;EAAkD;;EAAC;IAAiB;EAAwB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAwB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAuB;;EAAC;IAAmB;EAAsB;;EAAC;IAAc;EAAqB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAqB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAgB;EAAmB;;EAAC;IAA0B;EAA8B;;EAAC;IAA0B;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAA8B;EAA8B;;EAAC;IAAwB;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAA0B;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAA2C;EAA8B;;EAAC;IAAqC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAA2C;EAA8B;;EAAC;IAAqC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAyD;EAA8B;;EAAC;IAAyD;EAA8B;;EAAC;IAAwD;EAA8B;;EAAC;IAA6D;EAA8B;;EAAC;IAAuD;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAAyD;EAA8B;;EAAC;IAAwD;EAA8B;;EAAC;IAAwD;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAAwD;EAA8B;AAAC;;AAAC;EAA0B;IAA6C,mBAAmB;IAAC,8CAA8C;IAAC;EAAiD;;EAAC;IAA6C,mBAAmB;IAAC,kDAAkD;IAAC;EAA6C;;EAAC;IAA6C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA6C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA6C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA6C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA6C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA6C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA6C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA6C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA6C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA6C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA6C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA6C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA6C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA6C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA8C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,8CAA8C;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAA6C;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA8C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA8C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA8C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA8C,mBAAmB;IAAC,mDAAmD;IAAC;EAAsD;;EAAC;IAA8C,mBAAmB;IAAC,uDAAuD;IAAC;EAAkD;;EAAC;IAA8C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA8C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA8C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA8C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,kDAAkD;IAAC;EAAqD;;EAAC;IAA+C,mBAAmB;IAAC,sDAAsD;IAAC;EAAiD;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,gDAAgD;IAAC;EAAmD;;EAAC;IAA+C,mBAAmB;IAAC,oDAAoD;IAAC;EAA+C;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,iDAAiD;IAAC;EAAoD;;EAAC;IAA+C,mBAAmB;IAAC,qDAAqD;IAAC;EAAgD;;EAAC;IAA+C,mBAAmB;IAAC,+CAA+C;IAAC;EAAkD;;EAAC;IAA+C,mBAAmB;IAAC,mDAAmD;IAAC;EAA8C;;EAAC;IAAmD;EAAmB;;EAAC;IAAmD;EAAmB;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA8C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA8C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAA4C,oBAAoB;IAAC,qDAAqD;IAAC;EAAwD;;EAAC;IAA4C,oBAAoB;IAAC,yDAAyD;IAAC;EAAoD;;EAAC;IAAoD;EAAoB;;EAAC;IAAoD;EAAoB;;EAAC;IAAsD;EAAkB;;EAAC;IAAgD,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAgD,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAiD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwE;EAAkB;;EAAC;IAAkE,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAkE,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0E,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqE,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD;EAAkB;;EAAC;IAAqD;EAAqB;;EAAC;IAAqD;EAAoB;;EAAC;IAAqD;EAAqB;;EAAC;IAAsD;EAAkB;;EAAC;IAAa,UAAU;IAAC,WAAW;IAAC,eAAe;IAAC,SAAS;IAAC,iBAAiB;IAAC,SAAS;IAAC,kBAAkB;IAAC,cAAc;IAAC;EAAkB;;EAAC;IAAiB,WAAW;IAAC,QAAQ;IAAC,gBAAgB;IAAC,SAAS;IAAC,eAAe;IAAC,UAAU;IAAC,SAAS;IAAC;EAAkB;;EAAC;IAA0B,UAAU;IAAC,WAAW;IAAC,eAAe;IAAC,SAAS;IAAC,iBAAiB;IAAC,SAAS;IAAC,kBAAkB;IAAC,cAAc;IAAC;EAAkB;;EAAC;IAA8B,WAAW;IAAC,QAAQ;IAAC,gBAAgB;IAAC,SAAS;IAAC,eAAe;IAAC,UAAU;IAAC,SAAS;IAAC;EAAkB;;EAAC;IAA6C;EAAe;;EAAC;IAAc;EAA2B;;EAAC;IAAc;EAA2B;;EAAC;IAAe;EAA4B;;EAAC;IAAoB;EAAwB;;EAAC;IAAc,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAc,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAe,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiB,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC;EAAwB;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC;EAAwB;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA2B,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA6B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC;EAAwB;;EAAC;IAA6B,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA6B,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+B,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwC;EAAwB;;EAAC;IAAkC,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAyC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA0C,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsC;EAAwB;;EAAC;IAAgC,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAgC,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmC,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD;EAAwB;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD;EAAwB;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA6C,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA8C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA+C,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAqD;EAAwB;;EAAC;IAA+C,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAA+C,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAgD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAmD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAoD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAiD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA0D;EAAwB;;EAAC;IAAoD,cAAc;IAAC,qBAAqB;IAAC;EAAoD;;EAAC;IAAoD,cAAc;IAAC,qBAAqB;IAAC;EAA8C;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA2D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAA4D,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAqD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAiD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAgD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAwD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAyD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAsD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAoD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAmD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAuD,cAAc;IAAC,wBAAwB;IAAC;EAAkD;;EAAC;IAAkB;EAAc;;EAAC;IAAmB;EAAgB;;EAAC;IAAmB;EAAiB;;EAAC;IAAmB;EAAgB;;EAAC;IAAmB;EAAiB;;EAAC;IAAoB;EAAc;;EAAC;IAA+B;EAAc;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAiC;EAAc;;EAAC;IAA+B;EAAc;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAgC;EAAgB;;EAAC;IAAgC;EAAiB;;EAAC;IAAiC;EAAc;;EAAC;IAAiD;EAAc;;EAAC;IAAkD;EAAgB;;EAAC;IAAkD;EAAiB;;EAAC;IAAkD;EAAgB;;EAAC;IAAkD;EAAiB;;EAAC;IAAmD;EAAc;;EAAC;IAAe;EAA0B;;EAAC;IAAe;EAAuB;;EAAC;IAAa;EAAqB;;EAAC;IAAoB;EAA0B;;EAAC;IAAiB;EAAuB;;EAAC;IAAc;EAAwB;;EAAC;IAAqB;EAA6B;;EAAC;IAAkB;EAA0B;;EAAC;IAAY;EAAuB;;EAAC;IAAe;EAAwB;;EAAC;IAAkB;EAA2B;;EAAC;IAAiB;EAA0B;;EAAC;IAAiB;EAA0B;;EAAC;IAAqB;EAAuB;;EAAC;IAAqB;EAAuB;;EAAC;IAAa;EAAoB;;EAAC;IAAc;EAAqB;;EAAC;IAAgB;EAAuB;;EAAC;IAAqB;EAAwB;;EAAC;IAAqB;EAAuB;;EAAC;IAAwB;EAAkB;;EAAC;IAAkB,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAkB,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA0B,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqB,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqC;EAAkB;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAgC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqC;EAAkB;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAA+B,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAgC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAiC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAkC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA0C;EAAkB;;EAAC;IAAoC,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAoC,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA2C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAA4C,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAwC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuC,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuD;EAAkB;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAuD;EAAkB;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAAoD;;EAAC;IAAiD,kBAAkB;IAAC,iBAAiB;IAAC;EAA8C;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAwD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAyD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAkD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAiD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAgD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAqD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAmD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAoD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAmD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAoD,kBAAkB;IAAC,oBAAoB;IAAC;EAAkD;;EAAC;IAAsB;EAAkB;;EAAC;IAAuB;EAAqB;;EAAC;IAAuB;EAAoB;;EAAC;IAAuB;EAAqB;;EAAC;IAAwB;EAAkB;;EAAC;IAAmC;EAAkB;;EAAC;IAAoC;EAAqB;;EAAC;IAAoC;EAAoB;;EAAC;IAAoC;EAAqB;;EAAC;IAAqC;EAAkB;;EAAC;IAAmC;EAAkB;;EAAC;IAAoC;EAAqB;;EAAC;IAAoC;EAAoB;;EAAC;IAAoC;EAAqB;;EAAC;IAAqC;EAAkB;;EAAC;IAAkB;EAAe;;EAAC;IAAgB;EAAqB;;EAAC;IAAa;EAAoB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAmB;;EAAC;IAAkB;EAAoB;;EAAC;IAAoB,wBAAwB;IAAC;EAAyB;;EAAC;IAAoB,4BAA4B;IAAC;EAAyB;;EAAC;IAAoB,2BAA2B;IAAC;EAA4B;;EAAC;IAAoB,2BAA2B;IAAC;EAAwB;;EAAC;IAAkB,8BAA8B;IAAC;EAA+B;;EAAC;IAAkB,kCAAkC;IAAC;EAA+B;;EAAC;IAAkB,iCAAiC;IAAC;EAAkC;;EAAC;IAAkB,iCAAiC;IAAC;EAA8B;;EAAC;IAAe;EAA6B;;EAAC;IAA8B;EAA8B;;EAAC;IAA8B;EAAiC;;EAAC;IAA8B;EAAgC;;EAAC;IAAe;EAA6B;;EAAC;IAAkB,8BAA8B;IAAC;EAA+B;;EAAC;IAAkB,kCAAkC;IAAC;EAA+B;;EAAC;IAAkB,iCAAiC;IAAC;EAAkC;;EAAC;IAAkB,iCAAiC;IAAC;EAA8B;;EAAC;IAAkB,4BAA4B;IAAC;EAA6B;;EAAC;IAAkB,gCAAgC;IAAC;EAA6B;;EAAC;IAAkB,+BAA+B;IAAC;EAAgC;;EAAC;IAAkB,+BAA+B;IAAC;EAA4B;;EAAC;IAAoB,6BAA6B;IAAC;EAA8B;;EAAC;IAAoB,iCAAiC;IAAC;EAA8B;;EAAC;IAAoB,gCAAgC;IAAC;EAAiC;;EAAC;IAAoB,gCAAgC;IAAC;EAA6B;;EAAC;IAAqB;EAAwB;;EAAC;IAAqB;EAAyB;;EAAC;IAAqB;EAA4B;;EAAC;IAAqB;EAA2B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAAkC;;EAAC;IAAmB;EAAiC;;EAAC;IAAgB;EAA6B;;EAAC;IAAgB;EAA8B;;EAAC;IAAgB;EAAiC;;EAAC;IAAgB;EAAgC;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAAkC;;EAAC;IAAmB;EAAiC;;EAAC;IAAmB;EAA4B;;EAAC;IAAmB;EAA6B;;EAAC;IAAmB;EAAgC;;EAAC;IAAmB;EAA+B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAAiC;;EAAC;IAAqB;EAAgC;;EAAC;IAAkB;EAAkB;;EAAC;IAAmB;EAAmB;;EAAC;IAAmB;EAAmB;;EAAC;IAAmB;EAAmB;;EAAC;IAAiB;EAAiB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAmB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAqB;;EAAC;IAAgB;EAAoB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAqB;;EAAC;IAAc;EAAoB;;EAAC;IAAc;EAAsB;;EAAC;IAAc;EAAuB;;EAAC;IAAc;EAAqB;;EAAC;IAAgB;EAAqB;;EAAC;IAAiB;EAAkB;;EAAC;IAAiB;EAAW;;EAAC;IAAoB;EAAc;;EAAC;IAAoB;EAAc;;EAAC;IAAiB;EAAW;;EAAC;IAAiB;EAAW;;EAAC;IAAiB;EAAW;;EAAC;IAAwB;EAAkB;;EAAC;IAAW;EAAa;;EAAC;IAAkB;EAAoB;;EAAC;IAAY;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAiB;EAAmB;;EAAC;IAAW;EAAa;;EAAC;IAAmB;EAAqB;;EAAC;IAAgB;EAAkB;;EAAC;IAAkB;EAAoB;;EAAC;IAAwB;EAA0B;;EAAC;IAAwB;EAA0B;;EAAC;IAAwB;EAA0B;;EAAC;IAAqB;EAAuB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAU;EAAY;;EAAC;IAAiB;EAAmB;;EAAC;IAAY;EAAY;;EAAC;IAA6B;EAAa;;EAAC;IAAoC;EAAoB;;EAAC;IAA8B;EAAc;;EAAC;IAA4B;EAAY;;EAAC;IAAmC;EAAmB;;EAAC;IAA6B;EAAa;;EAAC;IAAqC;EAAqB;;EAAC;IAAkC;EAAkB;;EAAC;IAAoC;EAAoB;;EAAC;IAA0C;EAA0B;;EAAC;IAA0C;EAA0B;;EAAC;IAA0C;EAA0B;;EAAC;IAAuC;EAAuB;;EAAC;IAAiC;EAAiB;;EAAC;IAAiC;EAAiB;;EAAC;IAA4B;EAAY;;EAAC;IAAmC;EAAmB;;EAAC;IAA8B;EAAY;;EAAC;IAAc;EAAkB;;EAAC;IAAsB;EAA0B;;EAAC;IAAc;EAAqB;;EAAC;IAAsB;EAA6B;;EAAC;IAAe;EAAc;;EAAC;IAAuB;EAAsB;;EAAC;IAAkB;EAAgB;;EAAC;IAAiB;EAAsB;;EAAC;IAAe;EAAoB;;EAAC;IAAkB;EAAkB;;EAAC;IAAoB;EAAoB;;EAAC;IAAmB;EAAmB;;EAAC;IAAe;EAAe;;EAAC;IAAgB;EAAqB;;EAAC;IAAc;EAAmB;;EAAC;IAAiB;EAAiB;;EAAC;IAAkB;EAAkB;;EAAC;IAAmB;EAA0B;;EAAC;IAAiB;EAAwB;;EAAC;IAAoB;EAAsB;;EAAC;IAAqB;EAA6B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAAoB;;EAAC;IAAmB;EAAwB;;EAAC;IAAiB;EAAsB;;EAAC;IAAqB;EAA2B;;EAAC;IAAoB;EAA0B;;EAAC;IAAY;EAAW;;EAAC;IAAe;EAAa;;EAAC;IAAkB;EAAa;;EAAC;IAAe;EAAS;;EAAC;IAAiB;EAAW;;EAAC;IAAe;EAAW;;EAAC;IAAmB;EAAa;;EAAC;IAAiB;EAAa;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAa;EAAO;;EAAC;IAAc;EAAQ;;EAAC;IAAc;EAAQ;;EAAC;IAAc;EAAQ;;EAAC;IAAiB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAO;;EAAC;IAAiB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAU;;EAAC;IAAoB,UAAU;IAAC,UAAU;IAAC;EAAa;;EAAC;IAAgB;EAAU;;EAAC;IAAiB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAU;;EAAC;IAAe;EAAwL;;EAAC;IAAgB;EAAuD;;EAAC;IAAe;EAAuE;;EAAC;IAAmB;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAgB;EAAe;;EAAC;IAAiB;EAAe;;EAAC;IAAiB;EAAe;;EAAC;IAAmB;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAoB;EAAe;;EAAC;IAAgB;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAAiC;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAe;;EAAC;IAA4B;EAAe;;EAAC;IAAiC;EAAe;;EAAC;IAA6B;EAAe;;EAAC;IAAS;EAAQ;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAY;EAAW;;EAAC;IAAU;EAAU;;EAAC;IAAY;EAAW;;EAAC;IAAc;EAAY;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAiB;;EAAC;IAAe;EAAc;;EAAC;IAAa;EAAkB;;EAAC;IAAa;EAAiB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAkB;;EAAC;IAAc;EAAiB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAe;EAAkB;;EAAC;IAAe;EAAgB;;EAAC;IAAe;EAAmB;;EAAC;IAAe;EAAkB;;EAAC;IAAe;EAAmB;;EAAC;IAAe;EAAgB;;EAAC;IAAe;EAAmB;;EAAC;IAAgB;EAAkB;;EAAC;IAAkB;EAAa;;EAAC;IAAmB;EAAgB;;EAAC;IAAkB;EAAiB;;EAAC;IAAoB;EAAe;;EAAC;IAAqB;EAAiB;;EAAC;IAAmB;EAAa;;EAAC;IAAiB;EAA0B;;EAAC;IAAkB;EAA2B;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAkB;EAAuB;;EAAC;IAAS;EAAQ;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAW;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAY;EAAW;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAW;EAAc;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAY;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAa;;EAAC;IAAW;EAAW;;EAAC;IAAU,eAAe;IAAC;EAAY;;EAAC;IAAU,aAAa;IAAC;EAAc;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,mBAAmB;IAAC;EAAgB;;EAAC;IAAU,iBAAiB;IAAC;EAAkB;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,kBAAkB;IAAC;EAAe;;EAAC;IAAU,gBAAgB;IAAC;EAAiB;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,kBAAkB;IAAC;EAAe;;EAAC;IAAU,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAa,kBAAkB;IAAC;EAAe;;EAAC;IAAa,gBAAgB;IAAC;EAAiB;;EAAC;IAAW,iBAAiB;IAAC;EAAc;;EAAC;IAAW,eAAe;IAAC;EAAgB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,sBAAsB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAqB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,qBAAqB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAoB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,mBAAmB;IAAC;EAAgB;;EAAC;IAAY,iBAAiB;IAAC;EAAkB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,oBAAoB;IAAC;EAAiB;;EAAC;IAAY,kBAAkB;IAAC;EAAmB;;EAAC;IAAY,kBAAkB;IAAC;EAAe;;EAAC;IAAY,gBAAgB;IAAC;EAAiB;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAgB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAkB;;EAAC;IAAa;EAAgB;;EAAC;IAAW;EAAc;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAsB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAqB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAmB;;EAAC;IAAY;EAAoB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAe;;EAAC;IAAY;EAAiB;;EAAC;IAAY;EAAkB;;EAAC;IAAY;EAAgB;;EAAC;IAA0B;EAAQ;;EAAC;IAA0B;EAAa;;EAAC;IAA0B;EAAY;;EAAC;IAA0B;EAAa;;EAAC;IAA0B;EAAW;;EAAC;IAA0B;EAAc;;EAAC;IAA0B;EAAa;;EAAC;IAA0B;EAAW;;EAAC;IAA2B;EAAa;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAW;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAY;;EAAC;IAA6B;EAAW;;EAAC;IAA2B;EAAU;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAa;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAY;;EAAC;IAA4B;EAAc;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAY;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAa;;EAAC;IAA4B;EAAW;;EAAC;IAA2B,eAAe;IAAC;EAAY;;EAAC;IAA2B,aAAa;IAAC;EAAc;;EAAC;IAA2B,oBAAoB;IAAC;EAAiB;;EAAC;IAA2B,kBAAkB;IAAC;EAAmB;;EAAC;IAA2B,mBAAmB;IAAC;EAAgB;;EAAC;IAA2B,iBAAiB;IAAC;EAAkB;;EAAC;IAA2B,oBAAoB;IAAC;EAAiB;;EAAC;IAA2B,kBAAkB;IAAC;EAAmB;;EAAC;IAA2B,kBAAkB;IAAC;EAAe;;EAAC;IAA2B,gBAAgB;IAAC;EAAiB;;EAAC;IAA2B,qBAAqB;IAAC;EAAkB;;EAAC;IAA2B,mBAAmB;IAAC;EAAoB;;EAAC;IAA2B,oBAAoB;IAAC;EAAiB;;EAAC;IAA2B,kBAAkB;IAAC;EAAmB;;EAAC;IAA2B,kBAAkB;IAAC;EAAe;;EAAC;IAA2B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,oBAAoB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAmB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAe;;EAAC;IAA4B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA8B,kBAAkB;IAAC;EAAe;;EAAC;IAA8B,gBAAgB;IAAC;EAAiB;;EAAC;IAA4B,iBAAiB;IAAC;EAAc;;EAAC;IAA4B,eAAe;IAAC;EAAgB;;EAAC;IAA4B,qBAAqB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAoB;;EAAC;IAA4B,oBAAoB;IAAC;EAAiB;;EAAC;IAA4B,kBAAkB;IAAC;EAAmB;;EAAC;IAA4B,qBAAqB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAoB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA4B,sBAAsB;IAAC;EAAmB;;EAAC;IAA4B,oBAAoB;IAAC;EAAqB;;EAAC;IAA4B,qBAAqB;IAAC;EAAkB;;EAAC;IAA4B,mBAAmB;IAAC;EAAoB;;EAAC;IAA4B,mBAAmB;IAAC;EAAgB;;EAAC;IAA4B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,qBAAqB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAoB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,mBAAmB;IAAC;EAAgB;;EAAC;IAA6B,iBAAiB;IAAC;EAAkB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,oBAAoB;IAAC;EAAiB;;EAAC;IAA6B,kBAAkB;IAAC;EAAmB;;EAAC;IAA6B,kBAAkB;IAAC;EAAe;;EAAC;IAA6B,gBAAgB;IAAC;EAAiB;;EAAC;IAA2B;EAAY;;EAAC;IAA2B;EAAc;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAa;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAgB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAgB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAqB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAmB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAe;;EAAC;IAA2B;EAAiB;;EAAC;IAA2B;EAAkB;;EAAC;IAA2B;EAAgB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA8B;EAAe;;EAAC;IAA8B;EAAiB;;EAAC;IAA8B;EAAkB;;EAAC;IAA8B;EAAgB;;EAAC;IAA4B;EAAc;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAe;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAsB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAoB;;EAAC;IAA4B;EAAqB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAgB;;EAAC;IAA4B;EAAkB;;EAAC;IAA4B;EAAmB;;EAAC;IAA4B;EAAiB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAqB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAgB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAmB;;EAAC;IAA6B;EAAoB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAe;;EAAC;IAA6B;EAAiB;;EAAC;IAA6B;EAAkB;;EAAC;IAA6B;EAAgB;;EAAC;IAAa;EAAY;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAkB;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAe;;EAAC;IAAc;EAAiB;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAc;;EAAC;IAAgB;EAAc;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAe;EAAe;;EAAC;IAAgB;EAAc;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAgB;;EAAC;IAAqB;EAAgB;;EAAC;IAAa;EAAY;;EAAC;IAAgB;EAAe;;EAAC;IAAkB;EAAgB;;EAAC;IAAa;EAAW;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAc;;EAAC;IAAa;EAAiB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAc;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAe;;EAAC;IAAqD;EAAqB;;EAAC;IAAc;EAAa;;EAAC;IAAoB;EAAkB;;EAAC;IAAkB;EAAgB;;EAAC;IAAiB;EAAe;;EAAC;IAAiB;EAAe;;EAAC;IAAuB;EAAqB;;EAAC;IAAmB;EAAsB;;EAAC;IAAmB;EAAsB;;EAAC;IAAiB;EAAoB;;EAAC;IAAwB;EAA2B;;EAAC;IAAqB;EAAwB;;EAAC;IAAkB;EAAqB;;EAAC;IAAyB;EAA4B;;EAAC;IAAsB;EAAyB;;EAAC;IAAgB;EAAmB;;EAAC;IAAe;EAAS;;EAAC;IAAgB;EAAW;;EAAC;IAAgB;EAAU;;EAAC;IAAgB;EAAW;;EAAC;IAAiB;EAAS;;EAAC;IAA4B;EAAS;;EAAC;IAA6B;EAAW;;EAAC;IAA6B;EAAU;;EAAC;IAA6B;EAAW;;EAAC;IAA8B;EAAS;;EAAC;IAA4B;EAAS;;EAAC;IAA6B;EAAW;;EAAC;IAA6B;EAAU;;EAAC;IAA6B;EAAW;;EAAC;IAA8B;EAAS;;EAAC;IAAiD;EAAS;;EAAC;IAAmB;EAAa;;EAAC;IAAqB;EAAe;;EAAC;IAAsB;EAAgB;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAe;;EAAC;IAAqB;EAAe;;EAAC;IAAuB;EAAiB;;EAAC;IAAuB;EAAiB;;EAAC;IAAwB;EAAkB;;EAAC;IAAwB;EAAkB;;EAAC;IAAuB;EAAiB;;EAAC;IAAuB;EAAiB;;EAAC;IAAqB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAS;EAAS;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAe;;EAAC;IAAS;EAAc;;EAAC;IAAS;EAAY;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAW;;EAAC;IAAU,gBAAgB;IAAC;EAAa;;EAAC;IAAU,cAAc;IAAC;EAAe;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,oBAAoB;IAAC;EAAiB;;EAAC;IAAU,kBAAkB;IAAC;EAAmB;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,mBAAmB;IAAC;EAAgB;;EAAC;IAAU,iBAAiB;IAAC;EAAkB;;EAAC;IAAU,sBAAsB;IAAC;EAAmB;;EAAC;IAAU,oBAAoB;IAAC;EAAqB;;EAAC;IAAU,qBAAqB;IAAC;EAAkB;;EAAC;IAAU,mBAAmB;IAAC;EAAoB;;EAAC;IAAU,mBAAmB;IAAC;EAAgB;;EAAC;IAAU,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,qBAAqB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAoB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,mBAAmB;IAAC;EAAgB;;EAAC;IAAW,iBAAiB;IAAC;EAAkB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,oBAAoB;IAAC;EAAiB;;EAAC;IAAW,kBAAkB;IAAC;EAAmB;;EAAC;IAAW,kBAAkB;IAAC;EAAe;;EAAC;IAAW,gBAAgB;IAAC;EAAiB;;EAAC;IAAU;EAAa;;EAAC;IAAU;EAAe;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAc;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAsB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAoB;;EAAC;IAAU;EAAqB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAgB;;EAAC;IAAU;EAAkB;;EAAC;IAAU;EAAmB;;EAAC;IAAU;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAqB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAgB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAmB;;EAAC;IAAW;EAAoB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAe;;EAAC;IAAW;EAAiB;;EAAC;IAAW;EAAkB;;EAAC;IAAW;EAAgB;;EAAC;IAA0C;EAAW;;EAAC;IAAoC,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAoC,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA4C,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAqC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuC,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuD;EAAW;;EAAC;IAAiD,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAiD,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAkD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAmD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAoD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA4D;EAAW;;EAAC;IAAsD,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAsD,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA6D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA8D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA0D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2D,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyD,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAyE;EAAW;;EAAC;IAAmE,uBAAuB;IAAC,UAAU;IAAC;EAAkD;;EAAC;IAAmE,uBAAuB;IAAC,UAAU;IAAC;EAA4C;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA0E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAA2E,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAoE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA+C;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAA8C;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAuE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAqE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAkD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAiD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAsE,uBAAuB;IAAC,aAAa;IAAC;EAAgD;;EAAC;IAAwC;EAAuB;;EAAC;IAAyC;EAA0B;;EAAC;IAAyC;EAAyB;;EAAC;IAAyC;EAA0B;;EAAC;IAA0C;EAAuB;;EAAC;IAAqD;EAAuB;;EAAC;IAAsD;EAA0B;;EAAC;IAAsD;EAAyB;;EAAC;IAAsD;EAA0B;;EAAC;IAAuD;EAAuB;;EAAC;IAAyB;EAAmB;;EAAC;IAAyB;EAAmB;;EAAC;IAAY;EAAe;;EAAC;IAAW;EAAc;;EAAC;IAAc;EAAiB;;EAAC;IAAc;EAAiB;;EAAC;IAAoC;EAAe;;EAAC;IAAa,QAAQ;IAAC,MAAM;IAAC,OAAO;IAAC;EAAK;;EAAC;IAAgB,WAAW;IAAC,SAAS;IAAC,UAAU;IAAC;EAAQ;;EAAC;IAAe,QAAQ;IAAC;EAAK;;EAAC;IAAe,MAAM;IAAC;EAAO;;EAAC;IAAkB,WAAW;IAAC;EAAQ;;EAAC;IAAkB,SAAS;IAAC;EAAU;;EAAC;IAAW;EAAK;;EAAC;IAAa;EAAO;;EAAC;IAAc;EAAQ;;EAAC;IAAY;EAAM;;EAAC;IAAc;EAAQ;;EAAC;IAAgB;EAAU;;EAAC;IAAiB;EAAW;;EAAC;IAAe;EAAS;;EAAC;IAAiB;EAAW;;EAAC;IAAc;EAAe;;EAAC;IAAc;EAAiB;;EAAC;IAAY;EAAW;;EAAC;IAAe;EAA8B;;EAAC;IAAe;EAAgC;;EAAC;IAAY;EAAsD;;EAAC;IAAe;EAA4D;;EAAC;IAAe;EAA8D;;EAAC;IAAe;EAAgE;;EAAC;IAAgB;EAAsC;;EAAC;IAAkB;EAAsC;;EAAC;IAAoB;EAA8B;;EAAC;IAAiB;EAAe;;EAAC;IAAmB;EAAwD;;EAAC;IAA4B;EAA8B;;EAAC;IAA4B;EAAgC;;EAAC;IAAyB;EAAsD;;EAAC;IAA4B;EAA4D;;EAAC;IAA4B;EAA8D;;EAAC;IAA4B;EAAgE;;EAAC;IAA6B;EAAsC;;EAAC;IAA+B;EAAsC;;EAAC;IAAiC;EAA8B;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAwD;;EAAC;IAA4B;EAA8B;;EAAC;IAA4B;EAAgC;;EAAC;IAAyB;EAAsD;;EAAC;IAA4B;EAA4D;;EAAC;IAA4B;EAA8D;;EAAC;IAA4B;EAAgE;;EAAC;IAA6B;EAAsC;;EAAC;IAA+B;EAAsC;;EAAC;IAAiC;EAA8B;;EAAC;IAA8B;EAAe;;EAAC;IAAgC;EAAwD;;EAAC;IAA8C;EAA8B;;EAAC;IAA8C;EAAgC;;EAAC;IAA2C;EAAsD;;EAAC;IAA8C;EAA4D;;EAAC;IAA8C;EAA8D;;EAAC;IAA8C;EAAgE;;EAAC;IAA+C;EAAsC;;EAAC;IAAiD;EAAsC;;EAAC;IAAmD;EAA8B;;EAAC;IAAgD;EAAe;;EAAC;IAAkD;EAAwD;;EAAC;IAAkB;EAAiB;;EAAC;IAAoB;EAAmB;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAc;EAAc;;EAAC;IAAgB;EAAiB;;EAAC;IAAiB;EAAkB;;EAAC;IAAe;EAAe;;EAAC;IAAiB;EAAiB;;EAAC;IAAgB;EAAgB;;EAAC;IAAkB;EAAkB;;EAAC;IAAsB;EAAW;;EAAC;IAAgB,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAAgB,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAwB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmB,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC;EAAW;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD;EAAW;;EAAC;IAA2C,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA2C,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA4C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA6C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA8C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC;EAAW;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA6B,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+B,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC;EAAW;;EAAC;IAA+B,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA+B,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAwC;EAAW;;EAAC;IAAkC,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAAkC,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAyC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA0C,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqC,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmE;EAAW;;EAAC;IAA6D,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA6D,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAA8D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAA+D,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAgE,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD;EAAW;;EAAC;IAA+C,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAA+C,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAuD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAgD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAiD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAuD;EAAW;;EAAC;IAAiD,gBAAgB;IAAC,UAAU;IAAC;EAA2C;;EAAC;IAAiD,gBAAgB;IAAC,UAAU;IAAC;EAAqC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAwD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAyD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAkD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAwC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAuC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAqD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAsD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAmD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA2C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAA0C;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoD,gBAAgB;IAAC,aAAa;IAAC;EAAyC;;EAAC;IAAoB;EAAgB;;EAAC;IAAqB;EAAmB;;EAAC;IAAqB;EAAkB;;EAAC;IAAqB;EAAmB;;EAAC;IAAsB;EAAgB;;EAAC;IAAiC;EAAgB;;EAAC;IAAkC;EAAmB;;EAAC;IAAkC;EAAkB;;EAAC;IAAkC;EAAmB;;EAAC;IAAmC;EAAgB;;EAAC;IAAiC;EAAgB;;EAAC;IAAkC;EAAmB;;EAAC;IAAkC;EAAkB;;EAAC;IAAkC;EAAmB;;EAAC;IAAmC;EAAgB;;EAAC;IAAY;EAAiB;;EAAC;IAAgB;EAAiB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiD;EAAyB;;EAAC;IAAuD;EAA4B;;EAAC;IAA+C;EAAoB;;EAAC;IAA8D;EAAyB;;EAAC;IAAoE;EAA4B;;EAAC;IAA4D;EAAoB;;EAAC;IAA8D;EAAyB;;EAAC;IAAoE;EAA4B;;EAAC;IAA4D;EAAoB;;EAAC;IAAiB,kCAAkC;IAAC;EAAiC;;EAAC;IAA0B,2BAA2B;IAAC;EAA4B;;EAAC;IAAsB;EAAqB;;EAAC;IAAoB;EAAsB;;EAAC;IAAqB;EAAgB;;EAAC;IAAmB;EAAqB;;EAAC;IAAoB;EAAoB;;EAAC;IAAqB;EAAmB;;EAAC;IAAiB,wBAAwB;IAAC;EAAgB;;EAAC;IAAiB,wBAAwB;IAAC;EAAgB;;EAAC;IAAgB,uBAAuB;IAAC;EAAe;;EAAC;IAAiB,wBAAwB;IAAC;EAAgB;;EAAC;IAAoB;EAAsB;;EAAC;IAAe;EAAkB;;EAAC;IAAkB;EAAqB;;EAAC;IAAkB;EAAqB;;EAAC;IAAoB;EAAuB;;EAAC;IAAuB;EAA0B;;EAAC;IAAa;EAAkB;;EAAC;IAAe;EAAiB;;EAAC;IAAuB;EAAkB;;EAAC;IAAwB;EAAkB;;EAAC;IAAoB;EAAe;;EAAC;IAAyB;EAAoB;;EAAC;IAAyB;EAAoB;;EAAC;IAAkB,oBAAoB;IAAC;EAAiB;;EAAC;IAAiB;EAAwB;;EAAC;IAAe;EAAoB;;EAAC;IAAc,eAAe;IAAC,sBAAsB;IAAC;EAAkB;;EAAC;IAAS;EAAO;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAW;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAU;;EAAC;IAAS;EAAa;;EAAC;IAAS;EAAY;;EAAC;IAAS;EAAU;;EAAC;IAAU;EAAY;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAU;EAAW;;EAAC;IAAY;EAAU;;EAAC;IAAU;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAS;;EAAC;IAAY;EAAgB;;EAAC;IAAY;EAAgB;;EAAC;IAAa;EAAe;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAS;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAS;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAgB;;EAAC;IAAa;EAAS;;EAAC;IAAc;EAAgB;;EAAC;IAAc;EAAgB;;EAAC;IAAY;EAAU;;EAAC;IAAc;EAAW;;EAAC;IAAS;EAAS;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAU;EAAU;;EAAC;IAAY;EAAY;;EAAC;IAAW,UAAU;IAAC;EAAK;;EAAC;IAAW,eAAe;IAAC;EAAU;;EAAC;IAAW,cAAc;IAAC;EAAS;;EAAC;IAAW,eAAe;IAAC;EAAU;;EAAC;IAAW,aAAa;IAAC;EAAQ;;EAAC;IAAW,gBAAgB;IAAC;EAAW;;EAAC;IAAW,eAAe;IAAC;EAAU;;EAAC;IAAW,aAAa;IAAC;EAAQ;;EAAC;IAAY,eAAe;IAAC;EAAU;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,aAAa;IAAC;EAAQ;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,cAAc;IAAC;EAAS;;EAAC;IAAY,YAAY;IAAC;EAAO;;EAAC;IAAe,iBAAiB;IAAC;EAAY;;EAAC;IAAe,sBAAsB;IAAC;EAAiB;;EAAC;IAAe,qBAAqB;IAAC;EAAgB;;EAAC;IAAe,sBAAsB;IAAC;EAAiB;;EAAC;IAAe,oBAAoB;IAAC;EAAe;;EAAC;IAAe,uBAAuB;IAAC;EAAkB;;EAAC;IAAe,sBAAsB;IAAC;EAAiB;;EAAC;IAAe,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,sBAAsB;IAAC;EAAiB;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,oBAAoB;IAAC;EAAe;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,qBAAqB;IAAC;EAAgB;;EAAC;IAAgB,mBAAmB;IAAC;EAAc;;EAAC;IAAe,cAAc;IAAC;EAAS;;EAAC;IAAe,mBAAmB;IAAC;EAAc;;EAAC;IAAe,kBAAkB;IAAC;EAAa;;EAAC;IAAe,mBAAmB;IAAC;EAAc;;EAAC;IAAe,iBAAiB;IAAC;EAAY;;EAAC;IAAe,oBAAoB;IAAC;EAAe;;EAAC;IAAe,mBAAmB;IAAC;EAAc;;EAAC;IAAe,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,mBAAmB;IAAC;EAAc;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,iBAAiB;IAAC;EAAY;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,kBAAkB;IAAC;EAAa;;EAAC;IAAgB,gBAAgB;IAAC;EAAW;;EAAC;IAAmB;EAAkB;;EAAC;IAAmB;EAAqB;;EAAC;IAAyB;EAAwB;;EAAC;IAAyB;EAA2B;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAiB;EAA6C;;EAAC;IAAkB;EAA8C;;EAAC;IAAkB;EAA8C;;EAAC;IAAkB;EAA8C;;EAAC;IAAoB;EAA0B;;EAAC;IAAc;EAAgB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAAiB;EAA2B;;EAAC;IAAiB;EAA2B;;EAAC;IAAiB;EAA2B;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAiB;EAAmB;;EAAC;IAAkB;EAAoB;;EAAC;IAAkB;EAAoB;;EAAC;IAAkB;EAAoB;;EAAC;IAAkB;EAAoB;;EAAC;IAAoB;EAAsB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAe;EAAiB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAkB;;EAAC;IAAgB;EAAkB;;EAAC;IAAkB;EAAoB;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAiB;EAA0C;;EAAC;IAAoB;EAAuB;;EAAC;IAAc;EAAa;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAsB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAiB;EAAgB;;EAAC;IAAoB;EAAmB;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAe;EAAc;;EAAC;IAAkB;EAAiB;;EAAC;IAAe,yBAAyB;IAAC,yBAAyB;IAAC,oBAAoB;IAAC,oBAAoB;IAAC,oBAAoB;IAAC,qBAAqB;IAAC,qBAAqB;IAAC;EAA2P;;EAAC;IAAoB;EAAc;;EAAC;IAAmB;EAAuB;;EAAC;IAAgB;EAAoB;;EAAC;IAAsB;EAA0B;;EAAC;IAAkB;EAAsB;;EAAC;IAAyB;EAA6B;;EAAC;IAAmB;EAAuB;;EAAC;IAAwB;EAA4B;;EAAC;IAAiB;EAAqB;;EAAC;IAAqB;EAAyB;;EAAC;IAAa,qBAAqB;IAAC;EAAqB;;EAAC;IAAc,sBAAsB;IAAC;EAAsB;;EAAC;IAAc,uBAAuB;IAAC;EAAuB;;EAAC;IAAc,sBAAsB;IAAC;EAAsB;;EAAC;IAAc,uBAAuB;IAAC;EAAuB;;EAAC;IAAe,qBAAqB;IAAC;EAAqB;;EAAC;IAAe,wBAAwB;IAAC;EAAwB;;EAAC;IAAe,uBAAuB;IAAC;EAAuB;;EAAC;IAAe,wBAAwB;IAAC;EAAwB;;EAAC;IAAe,uBAAuB;IAAC;EAAuB;;EAAC;IAAe;EAAqB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAiB;EAAqB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAAe;EAAqB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAgB;EAAsB;;EAAC;IAAgB;EAAuB;;EAAC;IAAiB;EAAqB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAAiB;EAAwB;;EAAC;IAAiB;EAAuB;;EAAC;IAA0B,qBAAqB;IAAC;EAAqB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,qBAAqB;IAAC;EAAqB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA0B,qBAAqB;IAAC;EAAqB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA2B,sBAAsB;IAAC;EAAsB;;EAAC;IAA2B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,qBAAqB;IAAC;EAAqB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B,wBAAwB;IAAC;EAAwB;;EAAC;IAA4B,uBAAuB;IAAC;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA4B;EAAqB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA6B;EAAsB;;EAAC;IAA6B;EAAuB;;EAAC;IAA8B;EAAqB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAA8B;EAAwB;;EAAC;IAA8B;EAAuB;;EAAC;IAAc;EAAoB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAiB;EAA0B;;EAAC;IAAgB;EAAyB;;EAAC;IAAgB;EAAyB;;EAAC;IAA2B;EAAoB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA8B;EAA0B;;EAAC;IAA6B;EAAyB;;EAAC;IAA6B;EAAyB;;EAAC;IAA2B;EAAoB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA8B;EAA0B;;EAAC;IAA6B;EAAyB;;EAAC;IAA6B;EAAyB;;EAAC;IAAmB;EAAyB;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA4B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA4B;;EAAC;IAAoB;EAA8B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA2B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAA6B;;EAAC;IAAqB;EAA+B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA4B;;EAAC;IAAuB;EAA6B;;EAAC;IAAuB;EAA4B;;EAAC;IAAsB;EAA2B;;EAAC;IAAsB;EAA4B;;EAAC;IAAmB;EAAyB;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA4B;;EAAC;IAAmB;EAA+B;;EAAC;IAAmB;EAA8B;;EAAC;IAAmB;EAA4B;;EAAC;IAAoB;EAA8B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA4B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAA2B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA6B;;EAAC;IAAoB;EAAgC;;EAAC;IAAoB;EAA+B;;EAAC;IAAoB;EAA6B;;EAAC;IAAqB;EAA+B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA6B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA8B;;EAAC;IAAqB;EAA4B;;EAAC;IAAuB;EAA6B;;EAAC;IAAuB;EAA4B;;EAAC;IAAsB;EAA2B;;EAAC;IAAsB;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAgC;EAAyB;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA4B;;EAAC;IAAgC;EAA+B;;EAAC;IAAgC;EAA8B;;EAAC;IAAgC;EAA4B;;EAAC;IAAiC;EAA8B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA4B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAA2B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA6B;;EAAC;IAAiC;EAAgC;;EAAC;IAAiC;EAA+B;;EAAC;IAAiC;EAA6B;;EAAC;IAAkC;EAA+B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA6B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA8B;;EAAC;IAAkC;EAA4B;;EAAC;IAAoC;EAA6B;;EAAC;IAAoC;EAA4B;;EAAC;IAAmC;EAA2B;;EAAC;IAAmC;EAA4B;;EAAC;IAAc;EAAoB;;EAAC;IAAc;EAAuB;;EAAC;IAAc;EAAuB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAAc;EAAoB;;EAAC;IAAc;EAAuB;;EAAC;IAAc;EAAuB;;EAAC;IAAe;EAAwB;;EAAC;IAAgB;EAAyB;;EAAC;IAAe;EAAwB;;EAAC;IAAe;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAA2B;EAAoB;;EAAC;IAA2B;EAAuB;;EAAC;IAA2B;EAAuB;;EAAC;IAA4B;EAAwB;;EAAC;IAA6B;EAAyB;;EAAC;IAA4B;EAAwB;;EAAC;IAA4B;EAAwB;;EAAC;IAAqB;EAAwB;;EAAC;IAAoB;EAAuB;;EAAC;IAAgB;EAAgG;;EAAC;IAAuB;EAAmE;;EAAC;IAAwB;EAA2B;;EAAC;IAAuB;EAA8B;;EAAC;IAA0B;EAA6B;;EAAC;IAAiB;EAAiC;;EAAC;IAAa;EAAiD;;EAAC;IAAc;EAAiD;;EAAC;IAAiB;EAAkD;;EAAC;IAAiB;EAAwB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAwB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAuB;;EAAC;IAAkB;EAAuB;;EAAC;IAAmB;EAAsB;;EAAC;IAAc;EAAqB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAqB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAe;EAAoB;;EAAC;IAAgB;EAAmB;;EAAC;IAA0B;EAA8B;;EAAC;IAA0B;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAA8B;EAA8B;;EAAC;IAAwB;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAA0B;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAA2B;EAA8B;;EAAC;IAAyB;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAA2C;EAA8B;;EAAC;IAAqC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAA2C;EAA8B;;EAAC;IAAqC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAuC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAwC;EAA8B;;EAAC;IAAsC;EAA8B;;EAAC;IAAyD;EAA8B;;EAAC;IAAyD;EAA8B;;EAAC;IAAwD;EAA8B;;EAAC;IAA6D;EAA8B;;EAAC;IAAuD;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAAyD;EAA8B;;EAAC;IAAwD;EAA8B;;EAAC;IAAwD;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAA0D;EAA8B;;EAAC;IAAwD;EAA8B;AAAC","sourcesContent":["/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n\n/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:initial;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:initial}abbr[title]{border-bottom:none;-webkit-text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:initial}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:initial}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}[hidden],template{display:none}blockquote,dd,dl,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}button{background-color:initial;background-image:none;padding:0}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}fieldset,ol,ul{margin:0;padding:0}ol,ul{list-style:none}html{font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;line-height:1.5}*,:after,:before{border:0 solid #d5d6d7;box-sizing:border-box}hr{border-top-width:1px}img{border-style:solid}textarea{resize:vertical}input::placeholder,textarea::placeholder{color:#a0aec0}[role=button],button{cursor:pointer}table{border-collapse:collapse}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}button,input,optgroup,select,textarea{color:inherit;line-height:inherit;padding:0}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}img,video{height:auto;max-width:100%}.container{width:100%}@media (min-width:640px){.container{max-width:640px}}@media (min-width:768px){.container{max-width:768px}}@media (min-width:1024px){.container{max-width:1024px}}@media (min-width:1280px){.container{max-width:1280px}}.form-input{-webkit-appearance:none;appearance:none;background-color:#fff;border-color:#e2e8f0;border-radius:.25rem;border-width:1px;font-size:1rem;line-height:1.5;padding:.5rem .75rem}.form-input::placeholder{color:#9e9e9e;opacity:1}.form-input:focus{border-color:#63b3ed;box-shadow:0 0 0 3px #4299e180;outline:none}.form-textarea{-webkit-appearance:none;appearance:none;background-color:#fff;border-color:#e2e8f0;border-radius:.25rem;border-width:1px;font-size:1rem;line-height:1.5;padding:.5rem .75rem}.form-textarea::placeholder{color:#9e9e9e;opacity:1}.form-textarea:focus{border-color:#63b3ed;box-shadow:0 0 0 3px #4299e180;outline:none}.form-multiselect{-webkit-appearance:none;appearance:none;background-color:#fff;border-color:#e2e8f0;border-radius:.25rem;border-width:1px;font-size:1rem;line-height:1.5;padding:.5rem .75rem}.form-multiselect:focus{border-color:#63b3ed;box-shadow:0 0 0 3px #4299e180;outline:none}.form-select{-webkit-appearance:none;appearance:none;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23a0aec0' viewBox='0 0 24 24'%3E%3Cpath d='M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z'/%3E%3C/svg%3E\");-webkit-print-color-adjust:exact;print-color-adjust:exact;background-color:#fff;background-position:right .5rem center;background-repeat:no-repeat;background-size:1.5em 1.5em;border-color:#e2e8f0;border-radius:.25rem;border-width:1px;font-size:1rem;line-height:1.5;padding:.5rem 2.5rem .5rem .75rem}.form-select::-ms-expand{border:none;color:#a0aec0}@media not print{.form-select::-ms-expand{display:none}}@media print and (-ms-high-contrast:active),print and (-ms-high-contrast:none){.form-select{padding-right:.75rem}}.form-select:focus{border-color:#63b3ed;box-shadow:0 0 0 3px #4299e180;outline:none}.form-checkbox{-webkit-appearance:none;appearance:none;-webkit-print-color-adjust:exact;print-color-adjust:exact;background-color:#fff;background-origin:border-box;border-color:#e2e8f0;border-radius:.25rem;border-width:1px;color:#4299e1;display:inline-block;flex-shrink:0;height:1em;-webkit-user-select:none;user-select:none;vertical-align:middle;width:1em}.form-checkbox:checked{background-color:currentColor;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 16 16'%3E%3Cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586z'/%3E%3C/svg%3E\");background-position:50%;background-repeat:no-repeat;background-size:100% 100%;border-color:#0000}@media not print{.form-checkbox::-ms-check{background:inherit;border-color:inherit;border-radius:inherit;border-width:1px;color:#0000}}.form-checkbox:focus{border-color:#63b3ed;box-shadow:0 0 0 3px #4299e180;outline:none}.form-radio{-webkit-appearance:none;appearance:none;-webkit-print-color-adjust:exact;print-color-adjust:exact;background-color:#fff;background-origin:border-box;border-color:#e2e8f0;border-radius:100%;border-width:1px;color:#4299e1;display:inline-block;flex-shrink:0;height:1em;-webkit-user-select:none;user-select:none;vertical-align:middle;width:1em}.form-radio:checked{background-color:currentColor;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 16 16'%3E%3Ccircle cx='8' cy='8' r='3'/%3E%3C/svg%3E\");background-position:50%;background-repeat:no-repeat;background-size:100% 100%;border-color:#0000}@media not print{.form-radio::-ms-check{background:inherit;border-color:inherit;border-radius:inherit;border-width:1px;color:#0000}}.form-radio:focus{border-color:#63b3ed;box-shadow:0 0 0 3px #4299e180;outline:none}.space-y-0>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(0px*var(--space-y-reverse));margin-top:calc(0px*(1 - var(--space-y-reverse)))}.space-x-0>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(0px*(1 - var(--space-x-reverse)));margin-right:calc(0px*var(--space-x-reverse))}.space-y-1>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(.25rem*var(--space-y-reverse));margin-top:calc(.25rem*(1 - var(--space-y-reverse)))}.space-x-1>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(.25rem*(1 - var(--space-x-reverse)));margin-right:calc(.25rem*var(--space-x-reverse))}.space-y-2>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(.5rem*var(--space-y-reverse));margin-top:calc(.5rem*(1 - var(--space-y-reverse)))}.space-x-2>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(.5rem*(1 - var(--space-x-reverse)));margin-right:calc(.5rem*var(--space-x-reverse))}.space-y-3>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(.75rem*var(--space-y-reverse));margin-top:calc(.75rem*(1 - var(--space-y-reverse)))}.space-x-3>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(.75rem*(1 - var(--space-x-reverse)));margin-right:calc(.75rem*var(--space-x-reverse))}.space-y-4>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1rem*var(--space-y-reverse));margin-top:calc(1rem*(1 - var(--space-y-reverse)))}.space-x-4>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1rem*(1 - var(--space-x-reverse)));margin-right:calc(1rem*var(--space-x-reverse))}.space-y-5>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1.25rem*var(--space-y-reverse));margin-top:calc(1.25rem*(1 - var(--space-y-reverse)))}.space-x-5>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1.25rem*(1 - var(--space-x-reverse)));margin-right:calc(1.25rem*var(--space-x-reverse))}.space-y-6>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1.5rem*var(--space-y-reverse));margin-top:calc(1.5rem*(1 - var(--space-y-reverse)))}.space-x-6>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1.5rem*(1 - var(--space-x-reverse)));margin-right:calc(1.5rem*var(--space-x-reverse))}.space-y-8>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(2rem*var(--space-y-reverse));margin-top:calc(2rem*(1 - var(--space-y-reverse)))}.space-x-8>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(2rem*(1 - var(--space-x-reverse)));margin-right:calc(2rem*var(--space-x-reverse))}.space-y-10>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(2.5rem*var(--space-y-reverse));margin-top:calc(2.5rem*(1 - var(--space-y-reverse)))}.space-x-10>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(2.5rem*(1 - var(--space-x-reverse)));margin-right:calc(2.5rem*var(--space-x-reverse))}.space-y-12>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(3rem*var(--space-y-reverse));margin-top:calc(3rem*(1 - var(--space-y-reverse)))}.space-x-12>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(3rem*(1 - var(--space-x-reverse)));margin-right:calc(3rem*var(--space-x-reverse))}.space-y-16>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(4rem*var(--space-y-reverse));margin-top:calc(4rem*(1 - var(--space-y-reverse)))}.space-x-16>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(4rem*(1 - var(--space-x-reverse)));margin-right:calc(4rem*var(--space-x-reverse))}.space-y-20>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(5rem*var(--space-y-reverse));margin-top:calc(5rem*(1 - var(--space-y-reverse)))}.space-x-20>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(5rem*(1 - var(--space-x-reverse)));margin-right:calc(5rem*var(--space-x-reverse))}.space-y-24>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(6rem*var(--space-y-reverse));margin-top:calc(6rem*(1 - var(--space-y-reverse)))}.space-x-24>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(6rem*(1 - var(--space-x-reverse)));margin-right:calc(6rem*var(--space-x-reverse))}.space-y-32>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(8rem*var(--space-y-reverse));margin-top:calc(8rem*(1 - var(--space-y-reverse)))}.space-x-32>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(8rem*(1 - var(--space-x-reverse)));margin-right:calc(8rem*var(--space-x-reverse))}.space-y-40>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(10rem*var(--space-y-reverse));margin-top:calc(10rem*(1 - var(--space-y-reverse)))}.space-x-40>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(10rem*(1 - var(--space-x-reverse)));margin-right:calc(10rem*var(--space-x-reverse))}.space-y-48>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(12rem*var(--space-y-reverse));margin-top:calc(12rem*(1 - var(--space-y-reverse)))}.space-x-48>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(12rem*(1 - var(--space-x-reverse)));margin-right:calc(12rem*var(--space-x-reverse))}.space-y-56>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(14rem*var(--space-y-reverse));margin-top:calc(14rem*(1 - var(--space-y-reverse)))}.space-x-56>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(14rem*(1 - var(--space-x-reverse)));margin-right:calc(14rem*var(--space-x-reverse))}.space-y-64>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(16rem*var(--space-y-reverse));margin-top:calc(16rem*(1 - var(--space-y-reverse)))}.space-x-64>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(16rem*(1 - var(--space-x-reverse)));margin-right:calc(16rem*var(--space-x-reverse))}.space-y-px>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1px*var(--space-y-reverse));margin-top:calc(1px*(1 - var(--space-y-reverse)))}.space-x-px>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1px*(1 - var(--space-x-reverse)));margin-right:calc(1px*var(--space-x-reverse))}.-space-y-1>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-.25rem*var(--space-y-reverse));margin-top:calc(-.25rem*(1 - var(--space-y-reverse)))}.-space-x-1>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-.25rem*(1 - var(--space-x-reverse)));margin-right:calc(-.25rem*var(--space-x-reverse))}.-space-y-2>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-.5rem*var(--space-y-reverse));margin-top:calc(-.5rem*(1 - var(--space-y-reverse)))}.-space-x-2>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-.5rem*(1 - var(--space-x-reverse)));margin-right:calc(-.5rem*var(--space-x-reverse))}.-space-y-3>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-.75rem*var(--space-y-reverse));margin-top:calc(-.75rem*(1 - var(--space-y-reverse)))}.-space-x-3>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-.75rem*(1 - var(--space-x-reverse)));margin-right:calc(-.75rem*var(--space-x-reverse))}.-space-y-4>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1rem*var(--space-y-reverse));margin-top:calc(-1rem*(1 - var(--space-y-reverse)))}.-space-x-4>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1rem*(1 - var(--space-x-reverse)));margin-right:calc(-1rem*var(--space-x-reverse))}.-space-y-5>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1.25rem*var(--space-y-reverse));margin-top:calc(-1.25rem*(1 - var(--space-y-reverse)))}.-space-x-5>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1.25rem*(1 - var(--space-x-reverse)));margin-right:calc(-1.25rem*var(--space-x-reverse))}.-space-y-6>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1.5rem*var(--space-y-reverse));margin-top:calc(-1.5rem*(1 - var(--space-y-reverse)))}.-space-x-6>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1.5rem*(1 - var(--space-x-reverse)));margin-right:calc(-1.5rem*var(--space-x-reverse))}.-space-y-8>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-2rem*var(--space-y-reverse));margin-top:calc(-2rem*(1 - var(--space-y-reverse)))}.-space-x-8>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-2rem*(1 - var(--space-x-reverse)));margin-right:calc(-2rem*var(--space-x-reverse))}.-space-y-10>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-2.5rem*var(--space-y-reverse));margin-top:calc(-2.5rem*(1 - var(--space-y-reverse)))}.-space-x-10>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-2.5rem*(1 - var(--space-x-reverse)));margin-right:calc(-2.5rem*var(--space-x-reverse))}.-space-y-12>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-3rem*var(--space-y-reverse));margin-top:calc(-3rem*(1 - var(--space-y-reverse)))}.-space-x-12>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-3rem*(1 - var(--space-x-reverse)));margin-right:calc(-3rem*var(--space-x-reverse))}.-space-y-16>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-4rem*var(--space-y-reverse));margin-top:calc(-4rem*(1 - var(--space-y-reverse)))}.-space-x-16>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-4rem*(1 - var(--space-x-reverse)));margin-right:calc(-4rem*var(--space-x-reverse))}.-space-y-20>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-5rem*var(--space-y-reverse));margin-top:calc(-5rem*(1 - var(--space-y-reverse)))}.-space-x-20>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-5rem*(1 - var(--space-x-reverse)));margin-right:calc(-5rem*var(--space-x-reverse))}.-space-y-24>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-6rem*var(--space-y-reverse));margin-top:calc(-6rem*(1 - var(--space-y-reverse)))}.-space-x-24>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-6rem*(1 - var(--space-x-reverse)));margin-right:calc(-6rem*var(--space-x-reverse))}.-space-y-32>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-8rem*var(--space-y-reverse));margin-top:calc(-8rem*(1 - var(--space-y-reverse)))}.-space-x-32>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-8rem*(1 - var(--space-x-reverse)));margin-right:calc(-8rem*var(--space-x-reverse))}.-space-y-40>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-10rem*var(--space-y-reverse));margin-top:calc(-10rem*(1 - var(--space-y-reverse)))}.-space-x-40>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-10rem*(1 - var(--space-x-reverse)));margin-right:calc(-10rem*var(--space-x-reverse))}.-space-y-48>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-12rem*var(--space-y-reverse));margin-top:calc(-12rem*(1 - var(--space-y-reverse)))}.-space-x-48>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-12rem*(1 - var(--space-x-reverse)));margin-right:calc(-12rem*var(--space-x-reverse))}.-space-y-56>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-14rem*var(--space-y-reverse));margin-top:calc(-14rem*(1 - var(--space-y-reverse)))}.-space-x-56>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-14rem*(1 - var(--space-x-reverse)));margin-right:calc(-14rem*var(--space-x-reverse))}.-space-y-64>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-16rem*var(--space-y-reverse));margin-top:calc(-16rem*(1 - var(--space-y-reverse)))}.-space-x-64>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-16rem*(1 - var(--space-x-reverse)));margin-right:calc(-16rem*var(--space-x-reverse))}.-space-y-px>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1px*var(--space-y-reverse));margin-top:calc(-1px*(1 - var(--space-y-reverse)))}.-space-x-px>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1px*(1 - var(--space-x-reverse)));margin-right:calc(-1px*var(--space-x-reverse))}.space-y-reverse>:not(template)~:not(template){--space-y-reverse:1}.space-x-reverse>:not(template)~:not(template){--space-x-reverse:1}.divide-y-0>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(0px*var(--divide-y-reverse));border-top-width:calc(0px*(1 - var(--divide-y-reverse)))}.divide-x-0>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(0px*(1 - var(--divide-x-reverse)));border-right-width:calc(0px*var(--divide-x-reverse))}.divide-y-2>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(2px*var(--divide-y-reverse));border-top-width:calc(2px*(1 - var(--divide-y-reverse)))}.divide-x-2>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(2px*(1 - var(--divide-x-reverse)));border-right-width:calc(2px*var(--divide-x-reverse))}.divide-y-4>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(4px*var(--divide-y-reverse));border-top-width:calc(4px*(1 - var(--divide-y-reverse)))}.divide-x-4>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(4px*(1 - var(--divide-x-reverse)));border-right-width:calc(4px*var(--divide-x-reverse))}.divide-y-8>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(8px*var(--divide-y-reverse));border-top-width:calc(8px*(1 - var(--divide-y-reverse)))}.divide-x-8>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(8px*(1 - var(--divide-x-reverse)));border-right-width:calc(8px*var(--divide-x-reverse))}.divide-y>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(1px*var(--divide-y-reverse));border-top-width:calc(1px*(1 - var(--divide-y-reverse)))}.divide-x>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(1px*(1 - var(--divide-x-reverse)));border-right-width:calc(1px*var(--divide-x-reverse))}.divide-y-reverse>:not(template)~:not(template){--divide-y-reverse:1}.divide-x-reverse>:not(template)~:not(template){--divide-x-reverse:1}.divide-transparent>:not(template)~:not(template){border-color:#0000}.divide-white>:not(template)~:not(template){--divide-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--divide-opacity))}.divide-black>:not(template)~:not(template){--divide-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--divide-opacity))}.divide-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--divide-opacity))}.divide-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--divide-opacity))}.divide-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--divide-opacity))}.divide-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--divide-opacity))}.divide-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--divide-opacity))}.divide-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--divide-opacity))}.divide-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--divide-opacity))}.divide-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--divide-opacity))}.divide-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--divide-opacity))}.divide-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--divide-opacity))}.divide-cool-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--divide-opacity))}.divide-cool-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--divide-opacity))}.divide-cool-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--divide-opacity))}.divide-cool-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--divide-opacity))}.divide-cool-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--divide-opacity))}.divide-cool-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--divide-opacity))}.divide-cool-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--divide-opacity))}.divide-cool-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--divide-opacity))}.divide-cool-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--divide-opacity))}.divide-cool-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--divide-opacity))}.divide-red-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--divide-opacity))}.divide-red-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--divide-opacity))}.divide-red-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--divide-opacity))}.divide-red-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--divide-opacity))}.divide-red-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--divide-opacity))}.divide-red-500>:not(template)~:not(template){--divide-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--divide-opacity))}.divide-red-600>:not(template)~:not(template){--divide-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--divide-opacity))}.divide-red-700>:not(template)~:not(template){--divide-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--divide-opacity))}.divide-red-800>:not(template)~:not(template){--divide-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--divide-opacity))}.divide-red-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.divide-orange-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--divide-opacity))}.divide-orange-100>:not(template)~:not(template){--divide-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--divide-opacity))}.divide-orange-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--divide-opacity))}.divide-orange-300>:not(template)~:not(template){--divide-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--divide-opacity))}.divide-orange-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--divide-opacity))}.divide-orange-500>:not(template)~:not(template){--divide-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--divide-opacity))}.divide-orange-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--divide-opacity))}.divide-orange-700>:not(template)~:not(template){--divide-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--divide-opacity))}.divide-orange-800>:not(template)~:not(template){--divide-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--divide-opacity))}.divide-orange-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.divide-yellow-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--divide-opacity))}.divide-yellow-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--divide-opacity))}.divide-yellow-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--divide-opacity))}.divide-yellow-300>:not(template)~:not(template){--divide-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--divide-opacity))}.divide-yellow-400>:not(template)~:not(template){--divide-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--divide-opacity))}.divide-yellow-500>:not(template)~:not(template){--divide-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--divide-opacity))}.divide-yellow-600>:not(template)~:not(template){--divide-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--divide-opacity))}.divide-yellow-700>:not(template)~:not(template){--divide-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--divide-opacity))}.divide-yellow-800>:not(template)~:not(template){--divide-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--divide-opacity))}.divide-yellow-900>:not(template)~:not(template){--divide-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--divide-opacity))}.divide-green-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--divide-opacity))}.divide-green-100>:not(template)~:not(template){--divide-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--divide-opacity))}.divide-green-200>:not(template)~:not(template){--divide-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--divide-opacity))}.divide-green-300>:not(template)~:not(template){--divide-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--divide-opacity))}.divide-green-400>:not(template)~:not(template){--divide-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--divide-opacity))}.divide-green-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--divide-opacity))}.divide-green-600>:not(template)~:not(template){--divide-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--divide-opacity))}.divide-green-700>:not(template)~:not(template){--divide-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--divide-opacity))}.divide-green-800>:not(template)~:not(template){--divide-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--divide-opacity))}.divide-green-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--divide-opacity))}.divide-teal-50>:not(template)~:not(template){--divide-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--divide-opacity))}.divide-teal-100>:not(template)~:not(template){--divide-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--divide-opacity))}.divide-teal-200>:not(template)~:not(template){--divide-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--divide-opacity))}.divide-teal-300>:not(template)~:not(template){--divide-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--divide-opacity))}.divide-teal-400>:not(template)~:not(template){--divide-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--divide-opacity))}.divide-teal-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--divide-opacity))}.divide-teal-600>:not(template)~:not(template){--divide-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--divide-opacity))}.divide-teal-700>:not(template)~:not(template){--divide-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--divide-opacity))}.divide-teal-800>:not(template)~:not(template){--divide-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--divide-opacity))}.divide-teal-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--divide-opacity))}.divide-blue-50>:not(template)~:not(template){--divide-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--divide-opacity))}.divide-blue-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--divide-opacity))}.divide-blue-200>:not(template)~:not(template){--divide-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--divide-opacity))}.divide-blue-300>:not(template)~:not(template){--divide-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--divide-opacity))}.divide-blue-400>:not(template)~:not(template){--divide-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--divide-opacity))}.divide-blue-500>:not(template)~:not(template){--divide-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--divide-opacity))}.divide-blue-600>:not(template)~:not(template){--divide-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--divide-opacity))}.divide-blue-700>:not(template)~:not(template){--divide-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--divide-opacity))}.divide-blue-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--divide-opacity))}.divide-blue-900>:not(template)~:not(template){--divide-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--divide-opacity))}.divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--divide-opacity))}.divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--divide-opacity))}.divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--divide-opacity))}.divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--divide-opacity))}.divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--divide-opacity))}.divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--divide-opacity))}.divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--divide-opacity))}.divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--divide-opacity))}.divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--divide-opacity))}.divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--divide-opacity))}.divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--divide-opacity))}.divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--divide-opacity))}.divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--divide-opacity))}.divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--divide-opacity))}.divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--divide-opacity))}.divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--divide-opacity))}.divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--divide-opacity))}.divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--divide-opacity))}.divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--divide-opacity))}.divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--divide-opacity))}.divide-pink-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--divide-opacity))}.divide-pink-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--divide-opacity))}.divide-pink-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--divide-opacity))}.divide-pink-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--divide-opacity))}.divide-pink-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--divide-opacity))}.divide-pink-500>:not(template)~:not(template){--divide-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--divide-opacity))}.divide-pink-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--divide-opacity))}.divide-pink-700>:not(template)~:not(template){--divide-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--divide-opacity))}.divide-pink-800>:not(template)~:not(template){--divide-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--divide-opacity))}.divide-pink-900>:not(template)~:not(template){--divide-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--divide-opacity))}.theme-dark .dark\\:divide-transparent>:not(template)~:not(template){border-color:#0000}.theme-dark .dark\\:divide-white>:not(template)~:not(template){--divide-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--divide-opacity))}.theme-dark .dark\\:divide-black>:not(template)~:not(template){--divide-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--divide-opacity))}.theme-dark .dark\\:divide-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--divide-opacity))}.theme-dark .dark\\:divide-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--divide-opacity))}.theme-dark .dark\\:divide-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--divide-opacity))}.theme-dark .dark\\:divide-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--divide-opacity))}.theme-dark .dark\\:divide-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--divide-opacity))}.theme-dark .dark\\:divide-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--divide-opacity))}.theme-dark .dark\\:divide-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--divide-opacity))}.theme-dark .dark\\:divide-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--divide-opacity))}.theme-dark .dark\\:divide-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--divide-opacity))}.theme-dark .dark\\:divide-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--divide-opacity))}.theme-dark .dark\\:divide-cool-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--divide-opacity))}.theme-dark .dark\\:divide-cool-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--divide-opacity))}.theme-dark .dark\\:divide-cool-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--divide-opacity))}.theme-dark .dark\\:divide-cool-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--divide-opacity))}.theme-dark .dark\\:divide-cool-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--divide-opacity))}.theme-dark .dark\\:divide-cool-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--divide-opacity))}.theme-dark .dark\\:divide-cool-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--divide-opacity))}.theme-dark .dark\\:divide-cool-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--divide-opacity))}.theme-dark .dark\\:divide-cool-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--divide-opacity))}.theme-dark .dark\\:divide-cool-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--divide-opacity))}.theme-dark .dark\\:divide-red-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--divide-opacity))}.theme-dark .dark\\:divide-red-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--divide-opacity))}.theme-dark .dark\\:divide-red-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--divide-opacity))}.theme-dark .dark\\:divide-red-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--divide-opacity))}.theme-dark .dark\\:divide-red-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--divide-opacity))}.theme-dark .dark\\:divide-red-500>:not(template)~:not(template){--divide-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--divide-opacity))}.theme-dark .dark\\:divide-red-600>:not(template)~:not(template){--divide-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--divide-opacity))}.theme-dark .dark\\:divide-red-700>:not(template)~:not(template){--divide-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--divide-opacity))}.theme-dark .dark\\:divide-red-800>:not(template)~:not(template){--divide-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--divide-opacity))}.theme-dark .dark\\:divide-red-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.theme-dark .dark\\:divide-orange-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--divide-opacity))}.theme-dark .dark\\:divide-orange-100>:not(template)~:not(template){--divide-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--divide-opacity))}.theme-dark .dark\\:divide-orange-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--divide-opacity))}.theme-dark .dark\\:divide-orange-300>:not(template)~:not(template){--divide-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--divide-opacity))}.theme-dark .dark\\:divide-orange-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--divide-opacity))}.theme-dark .dark\\:divide-orange-500>:not(template)~:not(template){--divide-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--divide-opacity))}.theme-dark .dark\\:divide-orange-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--divide-opacity))}.theme-dark .dark\\:divide-orange-700>:not(template)~:not(template){--divide-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--divide-opacity))}.theme-dark .dark\\:divide-orange-800>:not(template)~:not(template){--divide-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--divide-opacity))}.theme-dark .dark\\:divide-orange-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.theme-dark .dark\\:divide-yellow-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--divide-opacity))}.theme-dark .dark\\:divide-yellow-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--divide-opacity))}.theme-dark .dark\\:divide-yellow-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--divide-opacity))}.theme-dark .dark\\:divide-yellow-300>:not(template)~:not(template){--divide-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--divide-opacity))}.theme-dark .dark\\:divide-yellow-400>:not(template)~:not(template){--divide-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--divide-opacity))}.theme-dark .dark\\:divide-yellow-500>:not(template)~:not(template){--divide-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--divide-opacity))}.theme-dark .dark\\:divide-yellow-600>:not(template)~:not(template){--divide-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--divide-opacity))}.theme-dark .dark\\:divide-yellow-700>:not(template)~:not(template){--divide-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--divide-opacity))}.theme-dark .dark\\:divide-yellow-800>:not(template)~:not(template){--divide-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--divide-opacity))}.theme-dark .dark\\:divide-yellow-900>:not(template)~:not(template){--divide-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--divide-opacity))}.theme-dark .dark\\:divide-green-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--divide-opacity))}.theme-dark .dark\\:divide-green-100>:not(template)~:not(template){--divide-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--divide-opacity))}.theme-dark .dark\\:divide-green-200>:not(template)~:not(template){--divide-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--divide-opacity))}.theme-dark .dark\\:divide-green-300>:not(template)~:not(template){--divide-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--divide-opacity))}.theme-dark .dark\\:divide-green-400>:not(template)~:not(template){--divide-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--divide-opacity))}.theme-dark .dark\\:divide-green-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--divide-opacity))}.theme-dark .dark\\:divide-green-600>:not(template)~:not(template){--divide-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--divide-opacity))}.theme-dark .dark\\:divide-green-700>:not(template)~:not(template){--divide-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--divide-opacity))}.theme-dark .dark\\:divide-green-800>:not(template)~:not(template){--divide-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--divide-opacity))}.theme-dark .dark\\:divide-green-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--divide-opacity))}.theme-dark .dark\\:divide-teal-50>:not(template)~:not(template){--divide-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--divide-opacity))}.theme-dark .dark\\:divide-teal-100>:not(template)~:not(template){--divide-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--divide-opacity))}.theme-dark .dark\\:divide-teal-200>:not(template)~:not(template){--divide-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--divide-opacity))}.theme-dark .dark\\:divide-teal-300>:not(template)~:not(template){--divide-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--divide-opacity))}.theme-dark .dark\\:divide-teal-400>:not(template)~:not(template){--divide-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--divide-opacity))}.theme-dark .dark\\:divide-teal-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--divide-opacity))}.theme-dark .dark\\:divide-teal-600>:not(template)~:not(template){--divide-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--divide-opacity))}.theme-dark .dark\\:divide-teal-700>:not(template)~:not(template){--divide-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--divide-opacity))}.theme-dark .dark\\:divide-teal-800>:not(template)~:not(template){--divide-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--divide-opacity))}.theme-dark .dark\\:divide-teal-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--divide-opacity))}.theme-dark .dark\\:divide-blue-50>:not(template)~:not(template){--divide-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--divide-opacity))}.theme-dark .dark\\:divide-blue-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--divide-opacity))}.theme-dark .dark\\:divide-blue-200>:not(template)~:not(template){--divide-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--divide-opacity))}.theme-dark .dark\\:divide-blue-300>:not(template)~:not(template){--divide-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--divide-opacity))}.theme-dark .dark\\:divide-blue-400>:not(template)~:not(template){--divide-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--divide-opacity))}.theme-dark .dark\\:divide-blue-500>:not(template)~:not(template){--divide-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--divide-opacity))}.theme-dark .dark\\:divide-blue-600>:not(template)~:not(template){--divide-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--divide-opacity))}.theme-dark .dark\\:divide-blue-700>:not(template)~:not(template){--divide-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--divide-opacity))}.theme-dark .dark\\:divide-blue-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--divide-opacity))}.theme-dark .dark\\:divide-blue-900>:not(template)~:not(template){--divide-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--divide-opacity))}.theme-dark .dark\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--divide-opacity))}.theme-dark .dark\\:divide-pink-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--divide-opacity))}.theme-dark .dark\\:divide-pink-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--divide-opacity))}.theme-dark .dark\\:divide-pink-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--divide-opacity))}.theme-dark .dark\\:divide-pink-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--divide-opacity))}.theme-dark .dark\\:divide-pink-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--divide-opacity))}.theme-dark .dark\\:divide-pink-500>:not(template)~:not(template){--divide-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--divide-opacity))}.theme-dark .dark\\:divide-pink-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--divide-opacity))}.theme-dark .dark\\:divide-pink-700>:not(template)~:not(template){--divide-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--divide-opacity))}.theme-dark .dark\\:divide-pink-800>:not(template)~:not(template){--divide-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--divide-opacity))}.theme-dark .dark\\:divide-pink-900>:not(template)~:not(template){--divide-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--divide-opacity))}.divide-opacity-0>:not(template)~:not(template){--divide-opacity:0}.divide-opacity-25>:not(template)~:not(template){--divide-opacity:0.25}.divide-opacity-50>:not(template)~:not(template){--divide-opacity:0.5}.divide-opacity-75>:not(template)~:not(template){--divide-opacity:0.75}.divide-opacity-100>:not(template)~:not(template){--divide-opacity:1}.sr-only{height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;clip:rect(0,0,0,0);border-width:0;white-space:nowrap}.not-sr-only{height:auto;margin:0;overflow:visible;padding:0;position:static;width:auto;clip:auto;white-space:normal}.focus\\:sr-only:focus{height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;clip:rect(0,0,0,0);border-width:0;white-space:nowrap}.focus\\:not-sr-only:focus{height:auto;margin:0;overflow:visible;padding:0;position:static;width:auto;clip:auto;white-space:normal}.appearance-none{-webkit-appearance:none;appearance:none}.bg-fixed{background-attachment:fixed}.bg-local{background-attachment:local}.bg-scroll{background-attachment:scroll}.bg-transparent{background-color:initial}.bg-white{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.bg-black{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.bg-gray-50{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.bg-gray-100{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.bg-gray-200{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.bg-gray-300{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.bg-gray-400{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.bg-gray-500{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.bg-gray-600{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.bg-gray-700{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.bg-gray-800{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.bg-gray-900{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.bg-cool-gray-50{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.bg-cool-gray-100{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.bg-cool-gray-200{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.bg-cool-gray-300{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.bg-cool-gray-400{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.bg-cool-gray-500{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.bg-cool-gray-600{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.bg-cool-gray-700{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.bg-cool-gray-800{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.bg-cool-gray-900{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.bg-red-50{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.bg-red-100{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.bg-red-200{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.bg-red-300{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.bg-red-400{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.bg-red-500{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.bg-red-600{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.bg-red-700{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.bg-red-800{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.bg-red-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.bg-orange-50{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.bg-orange-100{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.bg-orange-200{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.bg-orange-300{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.bg-orange-400{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.bg-orange-500{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.bg-orange-600{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.bg-orange-700{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.bg-orange-800{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.bg-orange-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.bg-yellow-50{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.bg-yellow-100{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.bg-yellow-200{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.bg-yellow-300{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.bg-yellow-400{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.bg-yellow-500{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.bg-yellow-600{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.bg-yellow-700{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.bg-yellow-800{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.bg-yellow-900{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.bg-green-50{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.bg-green-100{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.bg-green-200{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.bg-green-300{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.bg-green-400{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.bg-green-500{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.bg-green-600{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.bg-green-700{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.bg-green-800{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.bg-green-900{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.bg-teal-50{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.bg-teal-100{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.bg-teal-200{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.bg-teal-300{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.bg-teal-400{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.bg-teal-500{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.bg-teal-600{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.bg-teal-700{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.bg-teal-800{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.bg-teal-900{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.bg-blue-50{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.bg-blue-100{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.bg-blue-200{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.bg-blue-300{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.bg-blue-400{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.bg-blue-500{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.bg-blue-600{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.bg-blue-700{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.bg-blue-800{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.bg-blue-900{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.bg-indigo-50{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.bg-indigo-100{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.bg-indigo-200{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.bg-indigo-300{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.bg-indigo-400{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.bg-indigo-500{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.bg-indigo-600{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.bg-indigo-700{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.bg-indigo-800{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.bg-indigo-900{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.bg-indigo-50{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.bg-indigo-100{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.bg-indigo-200{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.bg-indigo-300{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.bg-indigo-400{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.bg-indigo-500{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.bg-indigo-600{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.bg-indigo-700{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.bg-indigo-800{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.bg-indigo-900{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.bg-pink-50{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.bg-pink-100{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.bg-pink-200{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.bg-pink-300{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.bg-pink-400{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.bg-pink-500{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.bg-pink-600{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.bg-pink-700{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.bg-pink-800{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.bg-pink-900{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.hover\\:bg-transparent:hover{background-color:initial}.hover\\:bg-white:hover{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.hover\\:bg-black:hover{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.hover\\:bg-gray-50:hover{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.hover\\:bg-gray-100:hover{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.hover\\:bg-gray-200:hover{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.hover\\:bg-gray-300:hover{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.hover\\:bg-gray-400:hover{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.hover\\:bg-gray-500:hover{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.hover\\:bg-gray-600:hover{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.hover\\:bg-gray-700:hover{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.hover\\:bg-gray-800:hover{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.hover\\:bg-gray-900:hover{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.hover\\:bg-cool-gray-50:hover{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.hover\\:bg-cool-gray-100:hover{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.hover\\:bg-cool-gray-200:hover{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.hover\\:bg-cool-gray-300:hover{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.hover\\:bg-cool-gray-400:hover{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.hover\\:bg-cool-gray-500:hover{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.hover\\:bg-cool-gray-600:hover{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.hover\\:bg-cool-gray-700:hover{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.hover\\:bg-cool-gray-800:hover{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.hover\\:bg-cool-gray-900:hover{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.hover\\:bg-red-50:hover{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.hover\\:bg-red-100:hover{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.hover\\:bg-red-200:hover{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.hover\\:bg-red-300:hover{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.hover\\:bg-red-400:hover{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.hover\\:bg-red-500:hover{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.hover\\:bg-red-600:hover{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.hover\\:bg-red-700:hover{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.hover\\:bg-red-800:hover{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.hover\\:bg-red-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.hover\\:bg-orange-50:hover{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.hover\\:bg-orange-100:hover{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.hover\\:bg-orange-200:hover{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.hover\\:bg-orange-300:hover{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.hover\\:bg-orange-400:hover{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.hover\\:bg-orange-500:hover{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.hover\\:bg-orange-600:hover{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.hover\\:bg-orange-700:hover{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.hover\\:bg-orange-800:hover{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.hover\\:bg-orange-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.hover\\:bg-yellow-50:hover{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.hover\\:bg-yellow-100:hover{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.hover\\:bg-yellow-200:hover{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.hover\\:bg-yellow-300:hover{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.hover\\:bg-yellow-400:hover{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.hover\\:bg-yellow-500:hover{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.hover\\:bg-yellow-600:hover{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.hover\\:bg-yellow-700:hover{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.hover\\:bg-yellow-800:hover{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.hover\\:bg-yellow-900:hover{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.hover\\:bg-green-50:hover{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.hover\\:bg-green-100:hover{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.hover\\:bg-green-200:hover{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.hover\\:bg-green-300:hover{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.hover\\:bg-green-400:hover{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.hover\\:bg-green-500:hover{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.hover\\:bg-green-600:hover{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.hover\\:bg-green-700:hover{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.hover\\:bg-green-800:hover{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.hover\\:bg-green-900:hover{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.hover\\:bg-teal-50:hover{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.hover\\:bg-teal-100:hover{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.hover\\:bg-teal-200:hover{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.hover\\:bg-teal-300:hover{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.hover\\:bg-teal-400:hover{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.hover\\:bg-teal-500:hover{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.hover\\:bg-teal-600:hover{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.hover\\:bg-teal-700:hover{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.hover\\:bg-teal-800:hover{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.hover\\:bg-teal-900:hover{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.hover\\:bg-blue-50:hover{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.hover\\:bg-blue-100:hover{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.hover\\:bg-blue-200:hover{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.hover\\:bg-blue-300:hover{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.hover\\:bg-blue-400:hover{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.hover\\:bg-blue-500:hover{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.hover\\:bg-blue-600:hover{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.hover\\:bg-blue-700:hover{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.hover\\:bg-blue-800:hover{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.hover\\:bg-blue-900:hover{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.hover\\:bg-pink-50:hover{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.hover\\:bg-pink-100:hover{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.hover\\:bg-pink-200:hover{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.hover\\:bg-pink-300:hover{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.hover\\:bg-pink-400:hover{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.hover\\:bg-pink-500:hover{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.hover\\:bg-pink-600:hover{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.hover\\:bg-pink-700:hover{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.hover\\:bg-pink-800:hover{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.hover\\:bg-pink-900:hover{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.focus\\:bg-transparent:focus{background-color:initial}.focus\\:bg-white:focus{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.focus\\:bg-black:focus{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.focus\\:bg-gray-50:focus{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.focus\\:bg-gray-100:focus{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.focus\\:bg-gray-200:focus{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.focus\\:bg-gray-300:focus{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.focus\\:bg-gray-400:focus{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.focus\\:bg-gray-500:focus{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.focus\\:bg-gray-600:focus{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.focus\\:bg-gray-700:focus{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.focus\\:bg-gray-800:focus{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.focus\\:bg-gray-900:focus{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.focus\\:bg-cool-gray-50:focus{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.focus\\:bg-cool-gray-100:focus{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.focus\\:bg-cool-gray-200:focus{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.focus\\:bg-cool-gray-300:focus{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.focus\\:bg-cool-gray-400:focus{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.focus\\:bg-cool-gray-500:focus{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.focus\\:bg-cool-gray-600:focus{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.focus\\:bg-cool-gray-700:focus{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.focus\\:bg-cool-gray-800:focus{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.focus\\:bg-cool-gray-900:focus{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.focus\\:bg-red-50:focus{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.focus\\:bg-red-100:focus{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.focus\\:bg-red-200:focus{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.focus\\:bg-red-300:focus{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.focus\\:bg-red-400:focus{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.focus\\:bg-red-500:focus{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.focus\\:bg-red-600:focus{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.focus\\:bg-red-700:focus{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.focus\\:bg-red-800:focus{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.focus\\:bg-red-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.focus\\:bg-orange-50:focus{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.focus\\:bg-orange-100:focus{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.focus\\:bg-orange-200:focus{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.focus\\:bg-orange-300:focus{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.focus\\:bg-orange-400:focus{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.focus\\:bg-orange-500:focus{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.focus\\:bg-orange-600:focus{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.focus\\:bg-orange-700:focus{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.focus\\:bg-orange-800:focus{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.focus\\:bg-orange-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.focus\\:bg-yellow-50:focus{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.focus\\:bg-yellow-100:focus{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.focus\\:bg-yellow-200:focus{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.focus\\:bg-yellow-300:focus{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.focus\\:bg-yellow-400:focus{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.focus\\:bg-yellow-500:focus{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.focus\\:bg-yellow-600:focus{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.focus\\:bg-yellow-700:focus{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.focus\\:bg-yellow-800:focus{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.focus\\:bg-yellow-900:focus{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.focus\\:bg-green-50:focus{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.focus\\:bg-green-100:focus{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.focus\\:bg-green-200:focus{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.focus\\:bg-green-300:focus{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.focus\\:bg-green-400:focus{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.focus\\:bg-green-500:focus{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.focus\\:bg-green-600:focus{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.focus\\:bg-green-700:focus{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.focus\\:bg-green-800:focus{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.focus\\:bg-green-900:focus{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.focus\\:bg-teal-50:focus{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.focus\\:bg-teal-100:focus{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.focus\\:bg-teal-200:focus{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.focus\\:bg-teal-300:focus{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.focus\\:bg-teal-400:focus{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.focus\\:bg-teal-500:focus{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.focus\\:bg-teal-600:focus{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.focus\\:bg-teal-700:focus{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.focus\\:bg-teal-800:focus{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.focus\\:bg-teal-900:focus{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.focus\\:bg-blue-50:focus{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.focus\\:bg-blue-100:focus{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.focus\\:bg-blue-200:focus{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.focus\\:bg-blue-300:focus{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.focus\\:bg-blue-400:focus{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.focus\\:bg-blue-500:focus{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.focus\\:bg-blue-600:focus{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.focus\\:bg-blue-700:focus{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.focus\\:bg-blue-800:focus{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.focus\\:bg-blue-900:focus{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.focus\\:bg-pink-50:focus{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.focus\\:bg-pink-100:focus{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.focus\\:bg-pink-200:focus{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.focus\\:bg-pink-300:focus{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.focus\\:bg-pink-400:focus{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.focus\\:bg-pink-500:focus{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.focus\\:bg-pink-600:focus{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.focus\\:bg-pink-700:focus{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.focus\\:bg-pink-800:focus{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.focus\\:bg-pink-900:focus{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.active\\:bg-transparent:active{background-color:initial}.active\\:bg-white:active{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.active\\:bg-black:active{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.active\\:bg-gray-50:active{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.active\\:bg-gray-100:active{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.active\\:bg-gray-200:active{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.active\\:bg-gray-300:active{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.active\\:bg-gray-400:active{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.active\\:bg-gray-500:active{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.active\\:bg-gray-600:active{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.active\\:bg-gray-700:active{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.active\\:bg-gray-800:active{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.active\\:bg-gray-900:active{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.active\\:bg-cool-gray-50:active{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.active\\:bg-cool-gray-100:active{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.active\\:bg-cool-gray-200:active{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.active\\:bg-cool-gray-300:active{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.active\\:bg-cool-gray-400:active{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.active\\:bg-cool-gray-500:active{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.active\\:bg-cool-gray-600:active{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.active\\:bg-cool-gray-700:active{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.active\\:bg-cool-gray-800:active{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.active\\:bg-cool-gray-900:active{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.active\\:bg-red-50:active{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.active\\:bg-red-100:active{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.active\\:bg-red-200:active{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.active\\:bg-red-300:active{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.active\\:bg-red-400:active{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.active\\:bg-red-500:active{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.active\\:bg-red-600:active{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.active\\:bg-red-700:active{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.active\\:bg-red-800:active{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.active\\:bg-red-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.active\\:bg-orange-50:active{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.active\\:bg-orange-100:active{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.active\\:bg-orange-200:active{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.active\\:bg-orange-300:active{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.active\\:bg-orange-400:active{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.active\\:bg-orange-500:active{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.active\\:bg-orange-600:active{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.active\\:bg-orange-700:active{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.active\\:bg-orange-800:active{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.active\\:bg-orange-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.active\\:bg-yellow-50:active{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.active\\:bg-yellow-100:active{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.active\\:bg-yellow-200:active{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.active\\:bg-yellow-300:active{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.active\\:bg-yellow-400:active{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.active\\:bg-yellow-500:active{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.active\\:bg-yellow-600:active{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.active\\:bg-yellow-700:active{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.active\\:bg-yellow-800:active{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.active\\:bg-yellow-900:active{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.active\\:bg-green-50:active{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.active\\:bg-green-100:active{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.active\\:bg-green-200:active{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.active\\:bg-green-300:active{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.active\\:bg-green-400:active{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.active\\:bg-green-500:active{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.active\\:bg-green-600:active{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.active\\:bg-green-700:active{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.active\\:bg-green-800:active{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.active\\:bg-green-900:active{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.active\\:bg-teal-50:active{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.active\\:bg-teal-100:active{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.active\\:bg-teal-200:active{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.active\\:bg-teal-300:active{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.active\\:bg-teal-400:active{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.active\\:bg-teal-500:active{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.active\\:bg-teal-600:active{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.active\\:bg-teal-700:active{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.active\\:bg-teal-800:active{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.active\\:bg-teal-900:active{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.active\\:bg-blue-50:active{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.active\\:bg-blue-100:active{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.active\\:bg-blue-200:active{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.active\\:bg-blue-300:active{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.active\\:bg-blue-400:active{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.active\\:bg-blue-500:active{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.active\\:bg-blue-600:active{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.active\\:bg-blue-700:active{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.active\\:bg-blue-800:active{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.active\\:bg-blue-900:active{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.active\\:bg-pink-50:active{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.active\\:bg-pink-100:active{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.active\\:bg-pink-200:active{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.active\\:bg-pink-300:active{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.active\\:bg-pink-400:active{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.active\\:bg-pink-500:active{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.active\\:bg-pink-600:active{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.active\\:bg-pink-700:active{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.active\\:bg-pink-800:active{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.active\\:bg-pink-900:active{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.odd\\:bg-transparent:nth-child(odd){background-color:initial}.odd\\:bg-white:nth-child(odd){--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.odd\\:bg-black:nth-child(odd){--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.odd\\:bg-gray-50:nth-child(odd){--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.odd\\:bg-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.odd\\:bg-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.odd\\:bg-gray-300:nth-child(odd){--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.odd\\:bg-gray-400:nth-child(odd){--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.odd\\:bg-gray-500:nth-child(odd){--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.odd\\:bg-gray-600:nth-child(odd){--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.odd\\:bg-gray-700:nth-child(odd){--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.odd\\:bg-gray-800:nth-child(odd){--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.odd\\:bg-gray-900:nth-child(odd){--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.odd\\:bg-cool-gray-50:nth-child(odd){--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.odd\\:bg-cool-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.odd\\:bg-cool-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.odd\\:bg-cool-gray-300:nth-child(odd){--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.odd\\:bg-cool-gray-400:nth-child(odd){--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.odd\\:bg-cool-gray-500:nth-child(odd){--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.odd\\:bg-cool-gray-600:nth-child(odd){--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.odd\\:bg-cool-gray-700:nth-child(odd){--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.odd\\:bg-cool-gray-800:nth-child(odd){--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.odd\\:bg-cool-gray-900:nth-child(odd){--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.odd\\:bg-red-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.odd\\:bg-red-100:nth-child(odd){--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.odd\\:bg-red-200:nth-child(odd){--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.odd\\:bg-red-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.odd\\:bg-red-400:nth-child(odd){--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.odd\\:bg-red-500:nth-child(odd){--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.odd\\:bg-red-600:nth-child(odd){--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.odd\\:bg-red-700:nth-child(odd){--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.odd\\:bg-red-800:nth-child(odd){--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.odd\\:bg-red-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.odd\\:bg-orange-50:nth-child(odd){--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.odd\\:bg-orange-100:nth-child(odd){--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.odd\\:bg-orange-200:nth-child(odd){--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.odd\\:bg-orange-300:nth-child(odd){--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.odd\\:bg-orange-400:nth-child(odd){--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.odd\\:bg-orange-500:nth-child(odd){--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.odd\\:bg-orange-600:nth-child(odd){--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.odd\\:bg-orange-700:nth-child(odd){--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.odd\\:bg-orange-800:nth-child(odd){--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.odd\\:bg-orange-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.odd\\:bg-yellow-50:nth-child(odd){--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.odd\\:bg-yellow-100:nth-child(odd){--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.odd\\:bg-yellow-200:nth-child(odd){--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.odd\\:bg-yellow-300:nth-child(odd){--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.odd\\:bg-yellow-400:nth-child(odd){--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.odd\\:bg-yellow-500:nth-child(odd){--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.odd\\:bg-yellow-600:nth-child(odd){--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.odd\\:bg-yellow-700:nth-child(odd){--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.odd\\:bg-yellow-800:nth-child(odd){--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.odd\\:bg-yellow-900:nth-child(odd){--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.odd\\:bg-green-50:nth-child(odd){--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.odd\\:bg-green-100:nth-child(odd){--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.odd\\:bg-green-200:nth-child(odd){--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.odd\\:bg-green-300:nth-child(odd){--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.odd\\:bg-green-400:nth-child(odd){--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.odd\\:bg-green-500:nth-child(odd){--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.odd\\:bg-green-600:nth-child(odd){--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.odd\\:bg-green-700:nth-child(odd){--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.odd\\:bg-green-800:nth-child(odd){--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.odd\\:bg-green-900:nth-child(odd){--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.odd\\:bg-teal-50:nth-child(odd){--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.odd\\:bg-teal-100:nth-child(odd){--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.odd\\:bg-teal-200:nth-child(odd){--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.odd\\:bg-teal-300:nth-child(odd){--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.odd\\:bg-teal-400:nth-child(odd){--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.odd\\:bg-teal-500:nth-child(odd){--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.odd\\:bg-teal-600:nth-child(odd){--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.odd\\:bg-teal-700:nth-child(odd){--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.odd\\:bg-teal-800:nth-child(odd){--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.odd\\:bg-teal-900:nth-child(odd){--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.odd\\:bg-blue-50:nth-child(odd){--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.odd\\:bg-blue-100:nth-child(odd){--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.odd\\:bg-blue-200:nth-child(odd){--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.odd\\:bg-blue-300:nth-child(odd){--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.odd\\:bg-blue-400:nth-child(odd){--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.odd\\:bg-blue-500:nth-child(odd){--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.odd\\:bg-blue-600:nth-child(odd){--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.odd\\:bg-blue-700:nth-child(odd){--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.odd\\:bg-blue-800:nth-child(odd){--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.odd\\:bg-blue-900:nth-child(odd){--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.odd\\:bg-pink-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.odd\\:bg-pink-100:nth-child(odd){--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.odd\\:bg-pink-200:nth-child(odd){--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.odd\\:bg-pink-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.odd\\:bg-pink-400:nth-child(odd){--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.odd\\:bg-pink-500:nth-child(odd){--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.odd\\:bg-pink-600:nth-child(odd){--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.odd\\:bg-pink-700:nth-child(odd){--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.odd\\:bg-pink-800:nth-child(odd){--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.odd\\:bg-pink-900:nth-child(odd){--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .dark\\:bg-transparent{background-color:initial}.theme-dark .dark\\:bg-white{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .dark\\:bg-black{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .dark\\:bg-gray-50{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .dark\\:bg-gray-100{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .dark\\:bg-gray-200{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .dark\\:bg-gray-300{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .dark\\:bg-gray-400{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .dark\\:bg-gray-500{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .dark\\:bg-gray-600{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .dark\\:bg-gray-700{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .dark\\:bg-gray-800{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .dark\\:bg-gray-900{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .dark\\:bg-cool-gray-50{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .dark\\:bg-cool-gray-100{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .dark\\:bg-cool-gray-200{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .dark\\:bg-cool-gray-300{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .dark\\:bg-cool-gray-400{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .dark\\:bg-cool-gray-500{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .dark\\:bg-cool-gray-600{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .dark\\:bg-cool-gray-700{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .dark\\:bg-cool-gray-800{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .dark\\:bg-cool-gray-900{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .dark\\:bg-red-50{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .dark\\:bg-red-100{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .dark\\:bg-red-200{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .dark\\:bg-red-300{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .dark\\:bg-red-400{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .dark\\:bg-red-500{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .dark\\:bg-red-600{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .dark\\:bg-red-700{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .dark\\:bg-red-800{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .dark\\:bg-red-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .dark\\:bg-orange-50{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .dark\\:bg-orange-100{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .dark\\:bg-orange-200{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .dark\\:bg-orange-300{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .dark\\:bg-orange-400{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .dark\\:bg-orange-500{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .dark\\:bg-orange-600{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .dark\\:bg-orange-700{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .dark\\:bg-orange-800{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .dark\\:bg-orange-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .dark\\:bg-yellow-50{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .dark\\:bg-yellow-100{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .dark\\:bg-yellow-200{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .dark\\:bg-yellow-300{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .dark\\:bg-yellow-400{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .dark\\:bg-yellow-500{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .dark\\:bg-yellow-600{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .dark\\:bg-yellow-700{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .dark\\:bg-yellow-800{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .dark\\:bg-yellow-900{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .dark\\:bg-green-50{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .dark\\:bg-green-100{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .dark\\:bg-green-200{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .dark\\:bg-green-300{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .dark\\:bg-green-400{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .dark\\:bg-green-500{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .dark\\:bg-green-600{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .dark\\:bg-green-700{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .dark\\:bg-green-800{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .dark\\:bg-green-900{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .dark\\:bg-teal-50{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .dark\\:bg-teal-100{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .dark\\:bg-teal-200{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .dark\\:bg-teal-300{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .dark\\:bg-teal-400{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .dark\\:bg-teal-500{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .dark\\:bg-teal-600{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .dark\\:bg-teal-700{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .dark\\:bg-teal-800{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .dark\\:bg-teal-900{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .dark\\:bg-blue-50{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .dark\\:bg-blue-100{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .dark\\:bg-blue-200{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .dark\\:bg-blue-300{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .dark\\:bg-blue-400{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .dark\\:bg-blue-500{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .dark\\:bg-blue-600{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .dark\\:bg-blue-700{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .dark\\:bg-blue-800{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .dark\\:bg-blue-900{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-50{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-100{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-200{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-300{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-400{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-500{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-600{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-700{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-800{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-900{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-50{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-100{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-200{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-300{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-400{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-500{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-600{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-700{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-800{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .dark\\:bg-indigo-900{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .dark\\:bg-pink-50{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .dark\\:bg-pink-100{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .dark\\:bg-pink-200{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .dark\\:bg-pink-300{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .dark\\:bg-pink-400{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .dark\\:bg-pink-500{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .dark\\:bg-pink-600{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .dark\\:bg-pink-700{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .dark\\:bg-pink-800{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .dark\\:bg-pink-900{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-transparent:hover{background-color:initial}.theme-dark .dark\\:hover\\:bg-white:hover{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-black:hover{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-gray-50:hover{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-gray-100:hover{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-gray-200:hover{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-gray-300:hover{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-gray-400:hover{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-gray-500:hover{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-gray-600:hover{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-gray-700:hover{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-gray-800:hover{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-gray-900:hover{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-cool-gray-50:hover{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-cool-gray-100:hover{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-cool-gray-200:hover{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-cool-gray-300:hover{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-cool-gray-400:hover{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-cool-gray-500:hover{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-cool-gray-600:hover{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-cool-gray-700:hover{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-cool-gray-800:hover{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-cool-gray-900:hover{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-red-50:hover{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-red-100:hover{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-red-200:hover{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-red-300:hover{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-red-400:hover{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-red-500:hover{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-red-600:hover{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-red-700:hover{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-red-800:hover{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-red-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-orange-50:hover{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-orange-100:hover{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-orange-200:hover{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-orange-300:hover{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-orange-400:hover{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-orange-500:hover{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-orange-600:hover{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-orange-700:hover{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-orange-800:hover{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-orange-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-yellow-50:hover{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-yellow-100:hover{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-yellow-200:hover{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-yellow-300:hover{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-yellow-400:hover{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-yellow-500:hover{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-yellow-600:hover{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-yellow-700:hover{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-yellow-800:hover{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-yellow-900:hover{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-green-50:hover{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-green-100:hover{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-green-200:hover{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-green-300:hover{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-green-400:hover{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-green-500:hover{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-green-600:hover{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-green-700:hover{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-green-800:hover{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-green-900:hover{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-teal-50:hover{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-teal-100:hover{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-teal-200:hover{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-teal-300:hover{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-teal-400:hover{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-teal-500:hover{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-teal-600:hover{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-teal-700:hover{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-teal-800:hover{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-teal-900:hover{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-blue-50:hover{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-blue-100:hover{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-blue-200:hover{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-blue-300:hover{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-blue-400:hover{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-blue-500:hover{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-blue-600:hover{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-blue-700:hover{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-blue-800:hover{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-blue-900:hover{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-pink-50:hover{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-pink-100:hover{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-pink-200:hover{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-pink-300:hover{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-pink-400:hover{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-pink-500:hover{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-pink-600:hover{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-pink-700:hover{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-pink-800:hover{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .dark\\:hover\\:bg-pink-900:hover{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-transparent:focus{background-color:initial}.theme-dark .dark\\:focus\\:bg-white:focus{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-black:focus{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-gray-50:focus{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-gray-100:focus{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-gray-200:focus{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-gray-300:focus{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-gray-400:focus{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-gray-500:focus{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-gray-600:focus{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-gray-700:focus{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-gray-800:focus{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-gray-900:focus{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-cool-gray-50:focus{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-cool-gray-100:focus{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-cool-gray-200:focus{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-cool-gray-300:focus{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-cool-gray-400:focus{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-cool-gray-500:focus{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-cool-gray-600:focus{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-cool-gray-700:focus{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-cool-gray-800:focus{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-cool-gray-900:focus{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-red-50:focus{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-red-100:focus{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-red-200:focus{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-red-300:focus{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-red-400:focus{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-red-500:focus{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-red-600:focus{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-red-700:focus{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-red-800:focus{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-red-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-orange-50:focus{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-orange-100:focus{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-orange-200:focus{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-orange-300:focus{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-orange-400:focus{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-orange-500:focus{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-orange-600:focus{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-orange-700:focus{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-orange-800:focus{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-orange-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-yellow-50:focus{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-yellow-100:focus{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-yellow-200:focus{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-yellow-300:focus{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-yellow-400:focus{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-yellow-500:focus{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-yellow-600:focus{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-yellow-700:focus{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-yellow-800:focus{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-yellow-900:focus{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-green-50:focus{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-green-100:focus{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-green-200:focus{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-green-300:focus{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-green-400:focus{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-green-500:focus{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-green-600:focus{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-green-700:focus{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-green-800:focus{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-green-900:focus{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-teal-50:focus{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-teal-100:focus{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-teal-200:focus{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-teal-300:focus{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-teal-400:focus{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-teal-500:focus{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-teal-600:focus{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-teal-700:focus{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-teal-800:focus{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-teal-900:focus{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-blue-50:focus{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-blue-100:focus{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-blue-200:focus{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-blue-300:focus{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-blue-400:focus{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-blue-500:focus{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-blue-600:focus{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-blue-700:focus{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-blue-800:focus{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-blue-900:focus{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-pink-50:focus{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-pink-100:focus{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-pink-200:focus{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-pink-300:focus{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-pink-400:focus{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-pink-500:focus{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-pink-600:focus{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-pink-700:focus{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-pink-800:focus{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .dark\\:focus\\:bg-pink-900:focus{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-transparent:active{background-color:initial}.theme-dark .dark\\:active\\:bg-white:active{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-black:active{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-gray-50:active{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-gray-100:active{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-gray-200:active{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-gray-300:active{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-gray-400:active{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-gray-500:active{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-gray-600:active{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-gray-700:active{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-gray-800:active{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-gray-900:active{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-cool-gray-50:active{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-cool-gray-100:active{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-cool-gray-200:active{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-cool-gray-300:active{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-cool-gray-400:active{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-cool-gray-500:active{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-cool-gray-600:active{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-cool-gray-700:active{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-cool-gray-800:active{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-cool-gray-900:active{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-red-50:active{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-red-100:active{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-red-200:active{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-red-300:active{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-red-400:active{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-red-500:active{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-red-600:active{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-red-700:active{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-red-800:active{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-red-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-orange-50:active{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-orange-100:active{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-orange-200:active{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-orange-300:active{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-orange-400:active{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-orange-500:active{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-orange-600:active{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-orange-700:active{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-orange-800:active{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-orange-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-yellow-50:active{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-yellow-100:active{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-yellow-200:active{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-yellow-300:active{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-yellow-400:active{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-yellow-500:active{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-yellow-600:active{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-yellow-700:active{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-yellow-800:active{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-yellow-900:active{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-green-50:active{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-green-100:active{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-green-200:active{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-green-300:active{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-green-400:active{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-green-500:active{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-green-600:active{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-green-700:active{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-green-800:active{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-green-900:active{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-teal-50:active{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-teal-100:active{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-teal-200:active{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-teal-300:active{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-teal-400:active{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-teal-500:active{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-teal-600:active{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-teal-700:active{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-teal-800:active{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-teal-900:active{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-blue-50:active{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-blue-100:active{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-blue-200:active{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-blue-300:active{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-blue-400:active{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-blue-500:active{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-blue-600:active{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-blue-700:active{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-blue-800:active{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-blue-900:active{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-pink-50:active{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-pink-100:active{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-pink-200:active{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-pink-300:active{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-pink-400:active{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-pink-500:active{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-pink-600:active{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-pink-700:active{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-pink-800:active{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .dark\\:active\\:bg-pink-900:active{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-transparent:nth-child(odd){background-color:initial}.theme-dark .dark\\:odd\\:bg-white:nth-child(odd){--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-black:nth-child(odd){--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-gray-50:nth-child(odd){--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-gray-300:nth-child(odd){--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-gray-400:nth-child(odd){--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-gray-500:nth-child(odd){--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-gray-600:nth-child(odd){--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-gray-700:nth-child(odd){--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-gray-800:nth-child(odd){--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-gray-900:nth-child(odd){--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-cool-gray-50:nth-child(odd){--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-cool-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-cool-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-cool-gray-300:nth-child(odd){--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-cool-gray-400:nth-child(odd){--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-cool-gray-500:nth-child(odd){--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-cool-gray-600:nth-child(odd){--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-cool-gray-700:nth-child(odd){--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-cool-gray-800:nth-child(odd){--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-cool-gray-900:nth-child(odd){--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-red-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-red-100:nth-child(odd){--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-red-200:nth-child(odd){--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-red-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-red-400:nth-child(odd){--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-red-500:nth-child(odd){--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-red-600:nth-child(odd){--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-red-700:nth-child(odd){--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-red-800:nth-child(odd){--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-red-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-orange-50:nth-child(odd){--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-orange-100:nth-child(odd){--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-orange-200:nth-child(odd){--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-orange-300:nth-child(odd){--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-orange-400:nth-child(odd){--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-orange-500:nth-child(odd){--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-orange-600:nth-child(odd){--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-orange-700:nth-child(odd){--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-orange-800:nth-child(odd){--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-orange-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-yellow-50:nth-child(odd){--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-yellow-100:nth-child(odd){--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-yellow-200:nth-child(odd){--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-yellow-300:nth-child(odd){--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-yellow-400:nth-child(odd){--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-yellow-500:nth-child(odd){--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-yellow-600:nth-child(odd){--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-yellow-700:nth-child(odd){--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-yellow-800:nth-child(odd){--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-yellow-900:nth-child(odd){--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-green-50:nth-child(odd){--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-green-100:nth-child(odd){--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-green-200:nth-child(odd){--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-green-300:nth-child(odd){--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-green-400:nth-child(odd){--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-green-500:nth-child(odd){--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-green-600:nth-child(odd){--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-green-700:nth-child(odd){--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-green-800:nth-child(odd){--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-green-900:nth-child(odd){--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-teal-50:nth-child(odd){--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-teal-100:nth-child(odd){--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-teal-200:nth-child(odd){--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-teal-300:nth-child(odd){--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-teal-400:nth-child(odd){--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-teal-500:nth-child(odd){--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-teal-600:nth-child(odd){--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-teal-700:nth-child(odd){--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-teal-800:nth-child(odd){--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-teal-900:nth-child(odd){--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-blue-50:nth-child(odd){--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-blue-100:nth-child(odd){--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-blue-200:nth-child(odd){--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-blue-300:nth-child(odd){--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-blue-400:nth-child(odd){--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-blue-500:nth-child(odd){--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-blue-600:nth-child(odd){--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-blue-700:nth-child(odd){--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-blue-800:nth-child(odd){--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-blue-900:nth-child(odd){--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-pink-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-pink-100:nth-child(odd){--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-pink-200:nth-child(odd){--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-pink-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-pink-400:nth-child(odd){--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-pink-500:nth-child(odd){--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-pink-600:nth-child(odd){--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-pink-700:nth-child(odd){--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-pink-800:nth-child(odd){--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .dark\\:odd\\:bg-pink-900:nth-child(odd){--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.bg-opacity-0{--bg-opacity:0}.bg-opacity-10{--bg-opacity:0.1}.bg-opacity-25{--bg-opacity:0.25}.bg-opacity-50{--bg-opacity:0.5}.bg-opacity-75{--bg-opacity:0.75}.bg-opacity-100{--bg-opacity:1}.hover\\:bg-opacity-0:hover{--bg-opacity:0}.hover\\:bg-opacity-10:hover{--bg-opacity:0.1}.hover\\:bg-opacity-25:hover{--bg-opacity:0.25}.hover\\:bg-opacity-50:hover{--bg-opacity:0.5}.hover\\:bg-opacity-75:hover{--bg-opacity:0.75}.hover\\:bg-opacity-100:hover{--bg-opacity:1}.focus\\:bg-opacity-0:focus{--bg-opacity:0}.focus\\:bg-opacity-10:focus{--bg-opacity:0.1}.focus\\:bg-opacity-25:focus{--bg-opacity:0.25}.focus\\:bg-opacity-50:focus{--bg-opacity:0.5}.focus\\:bg-opacity-75:focus{--bg-opacity:0.75}.focus\\:bg-opacity-100:focus{--bg-opacity:1}.theme-dark .dark\\:hover\\:bg-opacity-0:hover{--bg-opacity:0}.theme-dark .dark\\:hover\\:bg-opacity-10:hover{--bg-opacity:0.1}.theme-dark .dark\\:hover\\:bg-opacity-25:hover{--bg-opacity:0.25}.theme-dark .dark\\:hover\\:bg-opacity-50:hover{--bg-opacity:0.5}.theme-dark .dark\\:hover\\:bg-opacity-75:hover{--bg-opacity:0.75}.theme-dark .dark\\:hover\\:bg-opacity-100:hover{--bg-opacity:1}.bg-bottom{background-position:bottom}.bg-center{background-position:50%}.bg-left{background-position:0}.bg-left-bottom{background-position:0 100%}.bg-left-top{background-position:0 0}.bg-right{background-position:100%}.bg-right-bottom{background-position:100% 100%}.bg-right-top{background-position:100% 0}.bg-top{background-position:top}.bg-repeat{background-repeat:repeat}.bg-no-repeat{background-repeat:no-repeat}.bg-repeat-x{background-repeat:repeat-x}.bg-repeat-y{background-repeat:repeat-y}.bg-repeat-round{background-repeat:round}.bg-repeat-space{background-repeat:space}.bg-auto{background-size:auto}.bg-cover{background-size:cover}.bg-contain{background-size:contain}.border-collapse{border-collapse:collapse}.border-separate{border-collapse:initial}.border-transparent{border-color:#0000}.border-white{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.border-black{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.border-gray-50{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.border-gray-100{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.border-gray-200{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.border-gray-300{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.border-gray-400{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.border-gray-500{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.border-gray-600{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.border-gray-700{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.border-gray-800{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.border-gray-900{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.border-cool-gray-50{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.border-cool-gray-100{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.border-cool-gray-200{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.border-cool-gray-300{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.border-cool-gray-400{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.border-cool-gray-500{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.border-cool-gray-600{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.border-cool-gray-700{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.border-cool-gray-800{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.border-cool-gray-900{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.border-red-50{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.border-red-100{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.border-red-200{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.border-red-300{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.border-red-400{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.border-red-500{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.border-red-600{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.border-red-700{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.border-red-800{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.border-red-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.border-orange-50{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.border-orange-100{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.border-orange-200{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.border-orange-300{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.border-orange-400{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.border-orange-500{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.border-orange-600{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.border-orange-700{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.border-orange-800{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.border-orange-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.border-yellow-50{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.border-yellow-100{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.border-yellow-200{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.border-yellow-300{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.border-yellow-400{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.border-yellow-500{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.border-yellow-600{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.border-yellow-700{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.border-yellow-800{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.border-yellow-900{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.border-green-50{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.border-green-100{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.border-green-200{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.border-green-300{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.border-green-400{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.border-green-500{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.border-green-600{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.border-green-700{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.border-green-800{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.border-green-900{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.border-teal-50{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.border-teal-100{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.border-teal-200{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.border-teal-300{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.border-teal-400{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.border-teal-500{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.border-teal-600{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.border-teal-700{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.border-teal-800{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.border-teal-900{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.border-blue-50{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.border-blue-100{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.border-blue-200{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.border-blue-300{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.border-blue-400{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.border-blue-500{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.border-blue-600{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.border-blue-700{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.border-blue-800{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.border-blue-900{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.border-indigo-50{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.border-indigo-100{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.border-indigo-200{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.border-indigo-300{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.border-indigo-400{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.border-indigo-500{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.border-indigo-600{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.border-indigo-700{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.border-indigo-800{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.border-indigo-900{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.border-indigo-50{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.border-indigo-100{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.border-indigo-200{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.border-indigo-300{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.border-indigo-400{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.border-indigo-500{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.border-indigo-600{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.border-indigo-700{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.border-indigo-800{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.border-indigo-900{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.border-pink-50{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.border-pink-100{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.border-pink-200{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.border-pink-300{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.border-pink-400{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.border-pink-500{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.border-pink-600{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.border-pink-700{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.border-pink-800{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.border-pink-900{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.hover\\:border-transparent:hover{border-color:#0000}.hover\\:border-white:hover{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.hover\\:border-black:hover{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.hover\\:border-gray-50:hover{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.hover\\:border-gray-100:hover{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.hover\\:border-gray-200:hover{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.hover\\:border-gray-300:hover{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.hover\\:border-gray-400:hover{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.hover\\:border-gray-500:hover{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.hover\\:border-gray-600:hover{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.hover\\:border-gray-700:hover{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.hover\\:border-gray-800:hover{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.hover\\:border-gray-900:hover{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.hover\\:border-cool-gray-50:hover{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.hover\\:border-cool-gray-100:hover{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.hover\\:border-cool-gray-200:hover{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.hover\\:border-cool-gray-300:hover{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.hover\\:border-cool-gray-400:hover{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.hover\\:border-cool-gray-500:hover{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.hover\\:border-cool-gray-600:hover{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.hover\\:border-cool-gray-700:hover{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.hover\\:border-cool-gray-800:hover{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.hover\\:border-cool-gray-900:hover{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.hover\\:border-red-50:hover{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.hover\\:border-red-100:hover{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.hover\\:border-red-200:hover{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.hover\\:border-red-300:hover{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.hover\\:border-red-400:hover{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.hover\\:border-red-500:hover{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.hover\\:border-red-600:hover{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.hover\\:border-red-700:hover{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.hover\\:border-red-800:hover{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.hover\\:border-red-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.hover\\:border-orange-50:hover{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.hover\\:border-orange-100:hover{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.hover\\:border-orange-200:hover{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.hover\\:border-orange-300:hover{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.hover\\:border-orange-400:hover{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.hover\\:border-orange-500:hover{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.hover\\:border-orange-600:hover{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.hover\\:border-orange-700:hover{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.hover\\:border-orange-800:hover{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.hover\\:border-orange-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.hover\\:border-yellow-50:hover{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.hover\\:border-yellow-100:hover{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.hover\\:border-yellow-200:hover{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.hover\\:border-yellow-300:hover{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.hover\\:border-yellow-400:hover{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.hover\\:border-yellow-500:hover{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.hover\\:border-yellow-600:hover{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.hover\\:border-yellow-700:hover{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.hover\\:border-yellow-800:hover{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.hover\\:border-yellow-900:hover{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.hover\\:border-green-50:hover{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.hover\\:border-green-100:hover{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.hover\\:border-green-200:hover{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.hover\\:border-green-300:hover{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.hover\\:border-green-400:hover{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.hover\\:border-green-500:hover{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.hover\\:border-green-600:hover{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.hover\\:border-green-700:hover{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.hover\\:border-green-800:hover{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.hover\\:border-green-900:hover{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.hover\\:border-teal-50:hover{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.hover\\:border-teal-100:hover{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.hover\\:border-teal-200:hover{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.hover\\:border-teal-300:hover{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.hover\\:border-teal-400:hover{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.hover\\:border-teal-500:hover{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.hover\\:border-teal-600:hover{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.hover\\:border-teal-700:hover{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.hover\\:border-teal-800:hover{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.hover\\:border-teal-900:hover{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.hover\\:border-blue-50:hover{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.hover\\:border-blue-100:hover{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.hover\\:border-blue-200:hover{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.hover\\:border-blue-300:hover{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.hover\\:border-blue-400:hover{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.hover\\:border-blue-500:hover{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.hover\\:border-blue-600:hover{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.hover\\:border-blue-700:hover{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.hover\\:border-blue-800:hover{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.hover\\:border-blue-900:hover{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.hover\\:border-pink-50:hover{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.hover\\:border-pink-100:hover{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.hover\\:border-pink-200:hover{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.hover\\:border-pink-300:hover{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.hover\\:border-pink-400:hover{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.hover\\:border-pink-500:hover{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.hover\\:border-pink-600:hover{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.hover\\:border-pink-700:hover{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.hover\\:border-pink-800:hover{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.hover\\:border-pink-900:hover{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.focus\\:border-transparent:focus{border-color:#0000}.focus\\:border-white:focus{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.focus\\:border-black:focus{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.focus\\:border-gray-50:focus{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.focus\\:border-gray-100:focus{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.focus\\:border-gray-200:focus{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.focus\\:border-gray-300:focus{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.focus\\:border-gray-400:focus{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.focus\\:border-gray-500:focus{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.focus\\:border-gray-600:focus{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.focus\\:border-gray-700:focus{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.focus\\:border-gray-800:focus{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.focus\\:border-gray-900:focus{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.focus\\:border-cool-gray-50:focus{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.focus\\:border-cool-gray-100:focus{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.focus\\:border-cool-gray-200:focus{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.focus\\:border-cool-gray-300:focus{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.focus\\:border-cool-gray-400:focus{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.focus\\:border-cool-gray-500:focus{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.focus\\:border-cool-gray-600:focus{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.focus\\:border-cool-gray-700:focus{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.focus\\:border-cool-gray-800:focus{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.focus\\:border-cool-gray-900:focus{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.focus\\:border-red-50:focus{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.focus\\:border-red-100:focus{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.focus\\:border-red-200:focus{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.focus\\:border-red-300:focus{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.focus\\:border-red-400:focus{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.focus\\:border-red-500:focus{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.focus\\:border-red-600:focus{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.focus\\:border-red-700:focus{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.focus\\:border-red-800:focus{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.focus\\:border-red-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.focus\\:border-orange-50:focus{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.focus\\:border-orange-100:focus{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.focus\\:border-orange-200:focus{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.focus\\:border-orange-300:focus{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.focus\\:border-orange-400:focus{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.focus\\:border-orange-500:focus{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.focus\\:border-orange-600:focus{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.focus\\:border-orange-700:focus{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.focus\\:border-orange-800:focus{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.focus\\:border-orange-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.focus\\:border-yellow-50:focus{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.focus\\:border-yellow-100:focus{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.focus\\:border-yellow-200:focus{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.focus\\:border-yellow-300:focus{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.focus\\:border-yellow-400:focus{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.focus\\:border-yellow-500:focus{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.focus\\:border-yellow-600:focus{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.focus\\:border-yellow-700:focus{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.focus\\:border-yellow-800:focus{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.focus\\:border-yellow-900:focus{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.focus\\:border-green-50:focus{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.focus\\:border-green-100:focus{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.focus\\:border-green-200:focus{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.focus\\:border-green-300:focus{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.focus\\:border-green-400:focus{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.focus\\:border-green-500:focus{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.focus\\:border-green-600:focus{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.focus\\:border-green-700:focus{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.focus\\:border-green-800:focus{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.focus\\:border-green-900:focus{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.focus\\:border-teal-50:focus{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.focus\\:border-teal-100:focus{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.focus\\:border-teal-200:focus{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.focus\\:border-teal-300:focus{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.focus\\:border-teal-400:focus{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.focus\\:border-teal-500:focus{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.focus\\:border-teal-600:focus{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.focus\\:border-teal-700:focus{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.focus\\:border-teal-800:focus{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.focus\\:border-teal-900:focus{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.focus\\:border-blue-50:focus{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.focus\\:border-blue-100:focus{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.focus\\:border-blue-200:focus{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.focus\\:border-blue-300:focus{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.focus\\:border-blue-400:focus{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.focus\\:border-blue-500:focus{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.focus\\:border-blue-600:focus{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.focus\\:border-blue-700:focus{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.focus\\:border-blue-800:focus{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.focus\\:border-blue-900:focus{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.focus\\:border-pink-50:focus{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.focus\\:border-pink-100:focus{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.focus\\:border-pink-200:focus{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.focus\\:border-pink-300:focus{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.focus\\:border-pink-400:focus{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.focus\\:border-pink-500:focus{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.focus\\:border-pink-600:focus{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.focus\\:border-pink-700:focus{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.focus\\:border-pink-800:focus{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.focus\\:border-pink-900:focus{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.theme-dark .dark\\:border-transparent{border-color:#0000}.theme-dark .dark\\:border-white{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.theme-dark .dark\\:border-black{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.theme-dark .dark\\:border-gray-50{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.theme-dark .dark\\:border-gray-100{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.theme-dark .dark\\:border-gray-200{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.theme-dark .dark\\:border-gray-300{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.theme-dark .dark\\:border-gray-400{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.theme-dark .dark\\:border-gray-500{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.theme-dark .dark\\:border-gray-600{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.theme-dark .dark\\:border-gray-700{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.theme-dark .dark\\:border-gray-800{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.theme-dark .dark\\:border-gray-900{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.theme-dark .dark\\:border-cool-gray-50{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.theme-dark .dark\\:border-cool-gray-100{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.theme-dark .dark\\:border-cool-gray-200{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.theme-dark .dark\\:border-cool-gray-300{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.theme-dark .dark\\:border-cool-gray-400{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.theme-dark .dark\\:border-cool-gray-500{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.theme-dark .dark\\:border-cool-gray-600{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.theme-dark .dark\\:border-cool-gray-700{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.theme-dark .dark\\:border-cool-gray-800{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.theme-dark .dark\\:border-cool-gray-900{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.theme-dark .dark\\:border-red-50{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.theme-dark .dark\\:border-red-100{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.theme-dark .dark\\:border-red-200{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.theme-dark .dark\\:border-red-300{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.theme-dark .dark\\:border-red-400{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.theme-dark .dark\\:border-red-500{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.theme-dark .dark\\:border-red-600{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.theme-dark .dark\\:border-red-700{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.theme-dark .dark\\:border-red-800{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.theme-dark .dark\\:border-red-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .dark\\:border-orange-50{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.theme-dark .dark\\:border-orange-100{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.theme-dark .dark\\:border-orange-200{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.theme-dark .dark\\:border-orange-300{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.theme-dark .dark\\:border-orange-400{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.theme-dark .dark\\:border-orange-500{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.theme-dark .dark\\:border-orange-600{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.theme-dark .dark\\:border-orange-700{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.theme-dark .dark\\:border-orange-800{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.theme-dark .dark\\:border-orange-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .dark\\:border-yellow-50{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.theme-dark .dark\\:border-yellow-100{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.theme-dark .dark\\:border-yellow-200{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.theme-dark .dark\\:border-yellow-300{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.theme-dark .dark\\:border-yellow-400{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.theme-dark .dark\\:border-yellow-500{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.theme-dark .dark\\:border-yellow-600{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.theme-dark .dark\\:border-yellow-700{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.theme-dark .dark\\:border-yellow-800{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.theme-dark .dark\\:border-yellow-900{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.theme-dark .dark\\:border-green-50{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.theme-dark .dark\\:border-green-100{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.theme-dark .dark\\:border-green-200{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.theme-dark .dark\\:border-green-300{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.theme-dark .dark\\:border-green-400{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.theme-dark .dark\\:border-green-500{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.theme-dark .dark\\:border-green-600{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.theme-dark .dark\\:border-green-700{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.theme-dark .dark\\:border-green-800{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.theme-dark .dark\\:border-green-900{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.theme-dark .dark\\:border-teal-50{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.theme-dark .dark\\:border-teal-100{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.theme-dark .dark\\:border-teal-200{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.theme-dark .dark\\:border-teal-300{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.theme-dark .dark\\:border-teal-400{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.theme-dark .dark\\:border-teal-500{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.theme-dark .dark\\:border-teal-600{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.theme-dark .dark\\:border-teal-700{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.theme-dark .dark\\:border-teal-800{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.theme-dark .dark\\:border-teal-900{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.theme-dark .dark\\:border-blue-50{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.theme-dark .dark\\:border-blue-100{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.theme-dark .dark\\:border-blue-200{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.theme-dark .dark\\:border-blue-300{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.theme-dark .dark\\:border-blue-400{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.theme-dark .dark\\:border-blue-500{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.theme-dark .dark\\:border-blue-600{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.theme-dark .dark\\:border-blue-700{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.theme-dark .dark\\:border-blue-800{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.theme-dark .dark\\:border-blue-900{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.theme-dark .dark\\:border-indigo-50{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.theme-dark .dark\\:border-indigo-100{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.theme-dark .dark\\:border-indigo-200{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.theme-dark .dark\\:border-indigo-300{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.theme-dark .dark\\:border-indigo-400{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.theme-dark .dark\\:border-indigo-500{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.theme-dark .dark\\:border-indigo-600{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.theme-dark .dark\\:border-indigo-700{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.theme-dark .dark\\:border-indigo-800{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.theme-dark .dark\\:border-indigo-900{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.theme-dark .dark\\:border-indigo-50{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.theme-dark .dark\\:border-indigo-100{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.theme-dark .dark\\:border-indigo-200{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.theme-dark .dark\\:border-indigo-300{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.theme-dark .dark\\:border-indigo-400{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.theme-dark .dark\\:border-indigo-500{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.theme-dark .dark\\:border-indigo-600{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.theme-dark .dark\\:border-indigo-700{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.theme-dark .dark\\:border-indigo-800{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.theme-dark .dark\\:border-indigo-900{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.theme-dark .dark\\:border-pink-50{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.theme-dark .dark\\:border-pink-100{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.theme-dark .dark\\:border-pink-200{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.theme-dark .dark\\:border-pink-300{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.theme-dark .dark\\:border-pink-400{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.theme-dark .dark\\:border-pink-500{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.theme-dark .dark\\:border-pink-600{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.theme-dark .dark\\:border-pink-700{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.theme-dark .dark\\:border-pink-800{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.theme-dark .dark\\:border-pink-900{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-transparent:focus{border-color:#0000}.theme-dark .dark\\:focus\\:border-white:focus{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-black:focus{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-gray-50:focus{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-gray-100:focus{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-gray-200:focus{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-gray-300:focus{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-gray-400:focus{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-gray-500:focus{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-gray-600:focus{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-gray-700:focus{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-gray-800:focus{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-gray-900:focus{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-cool-gray-50:focus{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-cool-gray-100:focus{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-cool-gray-200:focus{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-cool-gray-300:focus{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-cool-gray-400:focus{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-cool-gray-500:focus{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-cool-gray-600:focus{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-cool-gray-700:focus{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-cool-gray-800:focus{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-cool-gray-900:focus{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-red-50:focus{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-red-100:focus{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-red-200:focus{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-red-300:focus{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-red-400:focus{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-red-500:focus{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-red-600:focus{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-red-700:focus{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-red-800:focus{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-red-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-orange-50:focus{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-orange-100:focus{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-orange-200:focus{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-orange-300:focus{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-orange-400:focus{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-orange-500:focus{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-orange-600:focus{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-orange-700:focus{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-orange-800:focus{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-orange-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-yellow-50:focus{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-yellow-100:focus{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-yellow-200:focus{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-yellow-300:focus{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-yellow-400:focus{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-yellow-500:focus{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-yellow-600:focus{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-yellow-700:focus{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-yellow-800:focus{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-yellow-900:focus{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-green-50:focus{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-green-100:focus{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-green-200:focus{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-green-300:focus{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-green-400:focus{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-green-500:focus{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-green-600:focus{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-green-700:focus{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-green-800:focus{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-green-900:focus{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-teal-50:focus{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-teal-100:focus{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-teal-200:focus{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-teal-300:focus{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-teal-400:focus{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-teal-500:focus{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-teal-600:focus{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-teal-700:focus{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-teal-800:focus{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-teal-900:focus{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-blue-50:focus{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-blue-100:focus{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-blue-200:focus{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-blue-300:focus{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-blue-400:focus{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-blue-500:focus{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-blue-600:focus{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-blue-700:focus{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-blue-800:focus{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-blue-900:focus{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-pink-50:focus{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-pink-100:focus{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-pink-200:focus{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-pink-300:focus{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-pink-400:focus{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-pink-500:focus{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-pink-600:focus{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-pink-700:focus{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-pink-800:focus{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.theme-dark .dark\\:focus\\:border-pink-900:focus{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-transparent:hover{border-color:#0000}.theme-dark .dark\\:hover\\:border-white:hover{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-black:hover{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-gray-50:hover{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-gray-100:hover{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-gray-200:hover{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-gray-300:hover{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-gray-400:hover{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-gray-500:hover{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-gray-600:hover{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-gray-700:hover{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-gray-800:hover{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-gray-900:hover{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-cool-gray-50:hover{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-cool-gray-100:hover{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-cool-gray-200:hover{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-cool-gray-300:hover{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-cool-gray-400:hover{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-cool-gray-500:hover{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-cool-gray-600:hover{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-cool-gray-700:hover{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-cool-gray-800:hover{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-cool-gray-900:hover{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-red-50:hover{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-red-100:hover{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-red-200:hover{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-red-300:hover{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-red-400:hover{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-red-500:hover{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-red-600:hover{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-red-700:hover{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-red-800:hover{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-red-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-orange-50:hover{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-orange-100:hover{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-orange-200:hover{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-orange-300:hover{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-orange-400:hover{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-orange-500:hover{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-orange-600:hover{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-orange-700:hover{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-orange-800:hover{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-orange-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-yellow-50:hover{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-yellow-100:hover{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-yellow-200:hover{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-yellow-300:hover{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-yellow-400:hover{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-yellow-500:hover{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-yellow-600:hover{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-yellow-700:hover{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-yellow-800:hover{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-yellow-900:hover{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-green-50:hover{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-green-100:hover{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-green-200:hover{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-green-300:hover{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-green-400:hover{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-green-500:hover{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-green-600:hover{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-green-700:hover{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-green-800:hover{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-green-900:hover{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-teal-50:hover{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-teal-100:hover{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-teal-200:hover{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-teal-300:hover{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-teal-400:hover{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-teal-500:hover{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-teal-600:hover{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-teal-700:hover{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-teal-800:hover{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-teal-900:hover{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-blue-50:hover{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-blue-100:hover{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-blue-200:hover{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-blue-300:hover{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-blue-400:hover{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-blue-500:hover{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-blue-600:hover{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-blue-700:hover{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-blue-800:hover{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-blue-900:hover{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-pink-50:hover{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-pink-100:hover{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-pink-200:hover{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-pink-300:hover{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-pink-400:hover{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-pink-500:hover{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-pink-600:hover{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-pink-700:hover{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-pink-800:hover{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.theme-dark .dark\\:hover\\:border-pink-900:hover{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.border-opacity-0{--border-opacity:0}.border-opacity-25{--border-opacity:0.25}.border-opacity-50{--border-opacity:0.5}.border-opacity-75{--border-opacity:0.75}.border-opacity-100{--border-opacity:1}.hover\\:border-opacity-0:hover{--border-opacity:0}.hover\\:border-opacity-25:hover{--border-opacity:0.25}.hover\\:border-opacity-50:hover{--border-opacity:0.5}.hover\\:border-opacity-75:hover{--border-opacity:0.75}.hover\\:border-opacity-100:hover{--border-opacity:1}.focus\\:border-opacity-0:focus{--border-opacity:0}.focus\\:border-opacity-25:focus{--border-opacity:0.25}.focus\\:border-opacity-50:focus{--border-opacity:0.5}.focus\\:border-opacity-75:focus{--border-opacity:0.75}.focus\\:border-opacity-100:focus{--border-opacity:1}.rounded-none{border-radius:0}.rounded-sm{border-radius:.125rem}.rounded{border-radius:.25rem}.rounded-md{border-radius:.375rem}.rounded-lg{border-radius:.5rem}.rounded-full{border-radius:9999px}.rounded-t-none{border-top-left-radius:0;border-top-right-radius:0}.rounded-r-none{border-bottom-right-radius:0;border-top-right-radius:0}.rounded-b-none{border-bottom-left-radius:0;border-bottom-right-radius:0}.rounded-l-none{border-bottom-left-radius:0;border-top-left-radius:0}.rounded-t-sm{border-top-left-radius:.125rem}.rounded-r-sm,.rounded-t-sm{border-top-right-radius:.125rem}.rounded-b-sm,.rounded-r-sm{border-bottom-right-radius:.125rem}.rounded-b-sm,.rounded-l-sm{border-bottom-left-radius:.125rem}.rounded-l-sm{border-top-left-radius:.125rem}.rounded-t{border-top-left-radius:.25rem}.rounded-r,.rounded-t{border-top-right-radius:.25rem}.rounded-b,.rounded-r{border-bottom-right-radius:.25rem}.rounded-b,.rounded-l{border-bottom-left-radius:.25rem}.rounded-l{border-top-left-radius:.25rem}.rounded-t-md{border-top-left-radius:.375rem}.rounded-r-md,.rounded-t-md{border-top-right-radius:.375rem}.rounded-b-md,.rounded-r-md{border-bottom-right-radius:.375rem}.rounded-b-md,.rounded-l-md{border-bottom-left-radius:.375rem}.rounded-l-md{border-top-left-radius:.375rem}.rounded-t-lg{border-top-left-radius:.5rem}.rounded-r-lg,.rounded-t-lg{border-top-right-radius:.5rem}.rounded-b-lg,.rounded-r-lg{border-bottom-right-radius:.5rem}.rounded-b-lg,.rounded-l-lg{border-bottom-left-radius:.5rem}.rounded-l-lg{border-top-left-radius:.5rem}.rounded-t-full{border-top-left-radius:9999px}.rounded-r-full,.rounded-t-full{border-top-right-radius:9999px}.rounded-b-full,.rounded-r-full{border-bottom-right-radius:9999px}.rounded-b-full,.rounded-l-full{border-bottom-left-radius:9999px}.rounded-l-full{border-top-left-radius:9999px}.rounded-tl-none{border-top-left-radius:0}.rounded-tr-none{border-top-right-radius:0}.rounded-br-none{border-bottom-right-radius:0}.rounded-bl-none{border-bottom-left-radius:0}.rounded-tl-sm{border-top-left-radius:.125rem}.rounded-tr-sm{border-top-right-radius:.125rem}.rounded-br-sm{border-bottom-right-radius:.125rem}.rounded-bl-sm{border-bottom-left-radius:.125rem}.rounded-tl{border-top-left-radius:.25rem}.rounded-tr{border-top-right-radius:.25rem}.rounded-br{border-bottom-right-radius:.25rem}.rounded-bl{border-bottom-left-radius:.25rem}.rounded-tl-md{border-top-left-radius:.375rem}.rounded-tr-md{border-top-right-radius:.375rem}.rounded-br-md{border-bottom-right-radius:.375rem}.rounded-bl-md{border-bottom-left-radius:.375rem}.rounded-tl-lg{border-top-left-radius:.5rem}.rounded-tr-lg{border-top-right-radius:.5rem}.rounded-br-lg{border-bottom-right-radius:.5rem}.rounded-bl-lg{border-bottom-left-radius:.5rem}.rounded-tl-full{border-top-left-radius:9999px}.rounded-tr-full{border-top-right-radius:9999px}.rounded-br-full{border-bottom-right-radius:9999px}.rounded-bl-full{border-bottom-left-radius:9999px}.border-solid{border-style:solid}.border-dashed{border-style:dashed}.border-dotted{border-style:dotted}.border-double{border-style:double}.border-none{border-style:none}.border-0{border-width:0}.border-2{border-width:2px}.border-4{border-width:4px}.border-8{border-width:8px}.border{border-width:1px}.border-t-0{border-top-width:0}.border-r-0{border-right-width:0}.border-b-0{border-bottom-width:0}.border-l-0{border-left-width:0}.border-t-2{border-top-width:2px}.border-r-2{border-right-width:2px}.border-b-2{border-bottom-width:2px}.border-l-2{border-left-width:2px}.border-t-4{border-top-width:4px}.border-r-4{border-right-width:4px}.border-b-4{border-bottom-width:4px}.border-l-4{border-left-width:4px}.border-t-8{border-top-width:8px}.border-r-8{border-right-width:8px}.border-b-8{border-bottom-width:8px}.border-l-8{border-left-width:8px}.border-t{border-top-width:1px}.border-r{border-right-width:1px}.border-b{border-bottom-width:1px}.border-l{border-left-width:1px}.box-border{box-sizing:border-box}.box-content{box-sizing:initial}.cursor-auto{cursor:auto}.cursor-default{cursor:default}.cursor-pointer{cursor:pointer}.cursor-wait{cursor:wait}.cursor-text{cursor:text}.cursor-move{cursor:move}.cursor-not-allowed{cursor:not-allowed}.block{display:block}.inline-block{display:inline-block}.inline{display:inline}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.table-caption{display:table-caption}.table-cell{display:table-cell}.table-column{display:table-column}.table-column-group{display:table-column-group}.table-footer-group{display:table-footer-group}.table-header-group{display:table-header-group}.table-row-group{display:table-row-group}.table-row{display:table-row}.flow-root{display:flow-root}.grid{display:grid}.inline-grid{display:inline-grid}.hidden{display:none}.theme-dark .dark\\:block{display:block}.theme-dark .dark\\:inline-block{display:inline-block}.theme-dark .dark\\:inline{display:inline}.theme-dark .dark\\:flex{display:flex}.theme-dark .dark\\:inline-flex{display:inline-flex}.theme-dark .dark\\:table{display:table}.theme-dark .dark\\:table-caption{display:table-caption}.theme-dark .dark\\:table-cell{display:table-cell}.theme-dark .dark\\:table-column{display:table-column}.theme-dark .dark\\:table-column-group{display:table-column-group}.theme-dark .dark\\:table-footer-group{display:table-footer-group}.theme-dark .dark\\:table-header-group{display:table-header-group}.theme-dark .dark\\:table-row-group{display:table-row-group}.theme-dark .dark\\:table-row{display:table-row}.theme-dark .dark\\:flow-root{display:flow-root}.theme-dark .dark\\:grid{display:grid}.theme-dark .dark\\:inline-grid{display:inline-grid}.theme-dark .dark\\:hidden{display:none}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-col{flex-direction:column}.flex-col-reverse{flex-direction:column-reverse}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.flex-no-wrap{flex-wrap:nowrap}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.items-baseline{align-items:baseline}.items-stretch{align-items:stretch}.self-auto{align-self:auto}.self-start{align-self:flex-start}.self-end{align-self:flex-end}.self-center{align-self:center}.self-stretch{align-self:stretch}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}.content-center{align-content:center}.content-start{align-content:flex-start}.content-end{align-content:flex-end}.content-between{align-content:space-between}.content-around{align-content:space-around}.flex-1{flex:1 1 0%}.flex-auto{flex:1 1 auto}.flex-initial{flex:0 1 auto}.flex-none{flex:none}.flex-grow-0{flex-grow:0}.flex-grow{flex-grow:1}.flex-shrink-0{flex-shrink:0}.flex-shrink{flex-shrink:1}.order-1{order:1}.order-2{order:2}.order-3{order:3}.order-4{order:4}.order-5{order:5}.order-6{order:6}.order-7{order:7}.order-8{order:8}.order-9{order:9}.order-10{order:10}.order-11{order:11}.order-12{order:12}.order-first{order:-9999}.order-last{order:9999}.order-none{order:0}.float-right{float:right}.float-left{float:left}.float-none{float:none}.clearfix:after{clear:both;content:\"\";display:table}.clear-left{clear:left}.clear-right{clear:right}.clear-both{clear:both}.clear-none{clear:none}.font-sans{font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji}.font-serif{font-family:Georgia,Cambria,Times New Roman,Times,serif}.font-mono{font-family:Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}.font-hairline{font-weight:100}.font-thin{font-weight:200}.font-light{font-weight:300}.font-normal{font-weight:400}.font-medium{font-weight:500}.font-semibold{font-weight:600}.font-bold{font-weight:700}.font-extrabold{font-weight:800}.font-black{font-weight:900}.hover\\:font-hairline:hover{font-weight:100}.hover\\:font-thin:hover{font-weight:200}.hover\\:font-light:hover{font-weight:300}.hover\\:font-normal:hover{font-weight:400}.hover\\:font-medium:hover{font-weight:500}.hover\\:font-semibold:hover{font-weight:600}.hover\\:font-bold:hover{font-weight:700}.hover\\:font-extrabold:hover{font-weight:800}.hover\\:font-black:hover{font-weight:900}.focus\\:font-hairline:focus{font-weight:100}.focus\\:font-thin:focus{font-weight:200}.focus\\:font-light:focus{font-weight:300}.focus\\:font-normal:focus{font-weight:400}.focus\\:font-medium:focus{font-weight:500}.focus\\:font-semibold:focus{font-weight:600}.focus\\:font-bold:focus{font-weight:700}.focus\\:font-extrabold:focus{font-weight:800}.focus\\:font-black:focus{font-weight:900}.h-0{height:0}.h-1{height:.25rem}.h-2{height:.5rem}.h-3{height:.75rem}.h-4{height:1rem}.h-5{height:1.25rem}.h-6{height:1.5rem}.h-8{height:2rem}.h-10{height:2.5rem}.h-12{height:3rem}.h-16{height:4rem}.h-20{height:5rem}.h-24{height:6rem}.h-32{height:8rem}.h-40{height:10rem}.h-48{height:12rem}.h-56{height:14rem}.h-64{height:16rem}.h-auto{height:auto}.h-px{height:1px}.h-full{height:100%}.h-screen{height:100vh}.text-xs{font-size:.75rem}.text-sm{font-size:.875rem}.text-base{font-size:1rem}.text-lg{font-size:1.125rem}.text-xl{font-size:1.25rem}.text-2xl{font-size:1.5rem}.text-3xl{font-size:1.875rem}.text-4xl{font-size:2.25rem}.text-5xl{font-size:3rem}.text-6xl{font-size:4rem}.leading-3{line-height:.75rem}.leading-4{line-height:1rem}.leading-5{line-height:1.25rem}.leading-6{line-height:1.5rem}.leading-7{line-height:1.75rem}.leading-8{line-height:2rem}.leading-9{line-height:2.25rem}.leading-10{line-height:2.5rem}.leading-none{line-height:1}.leading-tight{line-height:1.25}.leading-snug{line-height:1.375}.leading-normal{line-height:1.5}.leading-relaxed{line-height:1.625}.leading-loose{line-height:2}.list-inside{list-style-position:inside}.list-outside{list-style-position:outside}.list-none{list-style-type:none}.list-disc{list-style-type:disc}.list-decimal{list-style-type:decimal}.m-0{margin:0}.m-1{margin:.25rem}.m-2{margin:.5rem}.m-3{margin:.75rem}.m-4{margin:1rem}.m-5{margin:1.25rem}.m-6{margin:1.5rem}.m-8{margin:2rem}.m-10{margin:2.5rem}.m-12{margin:3rem}.m-16{margin:4rem}.m-20{margin:5rem}.m-24{margin:6rem}.m-32{margin:8rem}.m-40{margin:10rem}.m-48{margin:12rem}.m-56{margin:14rem}.m-64{margin:16rem}.m-auto{margin:auto}.m-px{margin:1px}.-m-1{margin:-.25rem}.-m-2{margin:-.5rem}.-m-3{margin:-.75rem}.-m-4{margin:-1rem}.-m-5{margin:-1.25rem}.-m-6{margin:-1.5rem}.-m-8{margin:-2rem}.-m-10{margin:-2.5rem}.-m-12{margin:-3rem}.-m-16{margin:-4rem}.-m-20{margin:-5rem}.-m-24{margin:-6rem}.-m-32{margin:-8rem}.-m-40{margin:-10rem}.-m-48{margin:-12rem}.-m-56{margin:-14rem}.-m-64{margin:-16rem}.-m-px{margin:-1px}.my-0{margin-bottom:0;margin-top:0}.mx-0{margin-left:0;margin-right:0}.my-1{margin-bottom:.25rem;margin-top:.25rem}.mx-1{margin-left:.25rem;margin-right:.25rem}.my-2{margin-bottom:.5rem;margin-top:.5rem}.mx-2{margin-left:.5rem;margin-right:.5rem}.my-3{margin-bottom:.75rem;margin-top:.75rem}.mx-3{margin-left:.75rem;margin-right:.75rem}.my-4{margin-bottom:1rem;margin-top:1rem}.mx-4{margin-left:1rem;margin-right:1rem}.my-5{margin-bottom:1.25rem;margin-top:1.25rem}.mx-5{margin-left:1.25rem;margin-right:1.25rem}.my-6{margin-bottom:1.5rem;margin-top:1.5rem}.mx-6{margin-left:1.5rem;margin-right:1.5rem}.my-8{margin-bottom:2rem;margin-top:2rem}.mx-8{margin-left:2rem;margin-right:2rem}.my-10{margin-bottom:2.5rem;margin-top:2.5rem}.mx-10{margin-left:2.5rem;margin-right:2.5rem}.my-12{margin-bottom:3rem;margin-top:3rem}.mx-12{margin-left:3rem;margin-right:3rem}.my-16{margin-bottom:4rem;margin-top:4rem}.mx-16{margin-left:4rem;margin-right:4rem}.my-20{margin-bottom:5rem;margin-top:5rem}.mx-20{margin-left:5rem;margin-right:5rem}.my-24{margin-bottom:6rem;margin-top:6rem}.mx-24{margin-left:6rem;margin-right:6rem}.my-32{margin-bottom:8rem;margin-top:8rem}.mx-32{margin-left:8rem;margin-right:8rem}.my-40{margin-bottom:10rem;margin-top:10rem}.mx-40{margin-left:10rem;margin-right:10rem}.my-48{margin-bottom:12rem;margin-top:12rem}.mx-48{margin-left:12rem;margin-right:12rem}.my-56{margin-bottom:14rem;margin-top:14rem}.mx-56{margin-left:14rem;margin-right:14rem}.my-64{margin-bottom:16rem;margin-top:16rem}.mx-64{margin-left:16rem;margin-right:16rem}.my-auto{margin-bottom:auto;margin-top:auto}.mx-auto{margin-left:auto;margin-right:auto}.my-px{margin-bottom:1px;margin-top:1px}.mx-px{margin-left:1px;margin-right:1px}.-my-1{margin-bottom:-.25rem;margin-top:-.25rem}.-mx-1{margin-left:-.25rem;margin-right:-.25rem}.-my-2{margin-bottom:-.5rem;margin-top:-.5rem}.-mx-2{margin-left:-.5rem;margin-right:-.5rem}.-my-3{margin-bottom:-.75rem;margin-top:-.75rem}.-mx-3{margin-left:-.75rem;margin-right:-.75rem}.-my-4{margin-bottom:-1rem;margin-top:-1rem}.-mx-4{margin-left:-1rem;margin-right:-1rem}.-my-5{margin-bottom:-1.25rem;margin-top:-1.25rem}.-mx-5{margin-left:-1.25rem;margin-right:-1.25rem}.-my-6{margin-bottom:-1.5rem;margin-top:-1.5rem}.-mx-6{margin-left:-1.5rem;margin-right:-1.5rem}.-my-8{margin-bottom:-2rem;margin-top:-2rem}.-mx-8{margin-left:-2rem;margin-right:-2rem}.-my-10{margin-bottom:-2.5rem;margin-top:-2.5rem}.-mx-10{margin-left:-2.5rem;margin-right:-2.5rem}.-my-12{margin-bottom:-3rem;margin-top:-3rem}.-mx-12{margin-left:-3rem;margin-right:-3rem}.-my-16{margin-bottom:-4rem;margin-top:-4rem}.-mx-16{margin-left:-4rem;margin-right:-4rem}.-my-20{margin-bottom:-5rem;margin-top:-5rem}.-mx-20{margin-left:-5rem;margin-right:-5rem}.-my-24{margin-bottom:-6rem;margin-top:-6rem}.-mx-24{margin-left:-6rem;margin-right:-6rem}.-my-32{margin-bottom:-8rem;margin-top:-8rem}.-mx-32{margin-left:-8rem;margin-right:-8rem}.-my-40{margin-bottom:-10rem;margin-top:-10rem}.-mx-40{margin-left:-10rem;margin-right:-10rem}.-my-48{margin-bottom:-12rem;margin-top:-12rem}.-mx-48{margin-left:-12rem;margin-right:-12rem}.-my-56{margin-bottom:-14rem;margin-top:-14rem}.-mx-56{margin-left:-14rem;margin-right:-14rem}.-my-64{margin-bottom:-16rem;margin-top:-16rem}.-mx-64{margin-left:-16rem;margin-right:-16rem}.-my-px{margin-bottom:-1px;margin-top:-1px}.-mx-px{margin-left:-1px;margin-right:-1px}.mt-0{margin-top:0}.mr-0{margin-right:0}.mb-0{margin-bottom:0}.ml-0{margin-left:0}.mt-1{margin-top:.25rem}.mr-1{margin-right:.25rem}.mb-1{margin-bottom:.25rem}.ml-1{margin-left:.25rem}.mt-2{margin-top:.5rem}.mr-2{margin-right:.5rem}.mb-2{margin-bottom:.5rem}.ml-2{margin-left:.5rem}.mt-3{margin-top:.75rem}.mr-3{margin-right:.75rem}.mb-3{margin-bottom:.75rem}.ml-3{margin-left:.75rem}.mt-4{margin-top:1rem}.mr-4{margin-right:1rem}.mb-4{margin-bottom:1rem}.ml-4{margin-left:1rem}.mt-5{margin-top:1.25rem}.mr-5{margin-right:1.25rem}.mb-5{margin-bottom:1.25rem}.ml-5{margin-left:1.25rem}.mt-6{margin-top:1.5rem}.mr-6{margin-right:1.5rem}.mb-6{margin-bottom:1.5rem}.ml-6{margin-left:1.5rem}.mt-8{margin-top:2rem}.mr-8{margin-right:2rem}.mb-8{margin-bottom:2rem}.ml-8{margin-left:2rem}.mt-10{margin-top:2.5rem}.mr-10{margin-right:2.5rem}.mb-10{margin-bottom:2.5rem}.ml-10{margin-left:2.5rem}.mt-12{margin-top:3rem}.mr-12{margin-right:3rem}.mb-12{margin-bottom:3rem}.ml-12{margin-left:3rem}.mt-16{margin-top:4rem}.mr-16{margin-right:4rem}.mb-16{margin-bottom:4rem}.ml-16{margin-left:4rem}.mt-20{margin-top:5rem}.mr-20{margin-right:5rem}.mb-20{margin-bottom:5rem}.ml-20{margin-left:5rem}.mt-24{margin-top:6rem}.mr-24{margin-right:6rem}.mb-24{margin-bottom:6rem}.ml-24{margin-left:6rem}.mt-32{margin-top:8rem}.mr-32{margin-right:8rem}.mb-32{margin-bottom:8rem}.ml-32{margin-left:8rem}.mt-40{margin-top:10rem}.mr-40{margin-right:10rem}.mb-40{margin-bottom:10rem}.ml-40{margin-left:10rem}.mt-48{margin-top:12rem}.mr-48{margin-right:12rem}.mb-48{margin-bottom:12rem}.ml-48{margin-left:12rem}.mt-56{margin-top:14rem}.mr-56{margin-right:14rem}.mb-56{margin-bottom:14rem}.ml-56{margin-left:14rem}.mt-64{margin-top:16rem}.mr-64{margin-right:16rem}.mb-64{margin-bottom:16rem}.ml-64{margin-left:16rem}.mt-auto{margin-top:auto}.mr-auto{margin-right:auto}.mb-auto{margin-bottom:auto}.ml-auto{margin-left:auto}.mt-px{margin-top:1px}.mr-px{margin-right:1px}.mb-px{margin-bottom:1px}.ml-px{margin-left:1px}.-mt-1{margin-top:-.25rem}.-mr-1{margin-right:-.25rem}.-mb-1{margin-bottom:-.25rem}.-ml-1{margin-left:-.25rem}.-mt-2{margin-top:-.5rem}.-mr-2{margin-right:-.5rem}.-mb-2{margin-bottom:-.5rem}.-ml-2{margin-left:-.5rem}.-mt-3{margin-top:-.75rem}.-mr-3{margin-right:-.75rem}.-mb-3{margin-bottom:-.75rem}.-ml-3{margin-left:-.75rem}.-mt-4{margin-top:-1rem}.-mr-4{margin-right:-1rem}.-mb-4{margin-bottom:-1rem}.-ml-4{margin-left:-1rem}.-mt-5{margin-top:-1.25rem}.-mr-5{margin-right:-1.25rem}.-mb-5{margin-bottom:-1.25rem}.-ml-5{margin-left:-1.25rem}.-mt-6{margin-top:-1.5rem}.-mr-6{margin-right:-1.5rem}.-mb-6{margin-bottom:-1.5rem}.-ml-6{margin-left:-1.5rem}.-mt-8{margin-top:-2rem}.-mr-8{margin-right:-2rem}.-mb-8{margin-bottom:-2rem}.-ml-8{margin-left:-2rem}.-mt-10{margin-top:-2.5rem}.-mr-10{margin-right:-2.5rem}.-mb-10{margin-bottom:-2.5rem}.-ml-10{margin-left:-2.5rem}.-mt-12{margin-top:-3rem}.-mr-12{margin-right:-3rem}.-mb-12{margin-bottom:-3rem}.-ml-12{margin-left:-3rem}.-mt-16{margin-top:-4rem}.-mr-16{margin-right:-4rem}.-mb-16{margin-bottom:-4rem}.-ml-16{margin-left:-4rem}.-mt-20{margin-top:-5rem}.-mr-20{margin-right:-5rem}.-mb-20{margin-bottom:-5rem}.-ml-20{margin-left:-5rem}.-mt-24{margin-top:-6rem}.-mr-24{margin-right:-6rem}.-mb-24{margin-bottom:-6rem}.-ml-24{margin-left:-6rem}.-mt-32{margin-top:-8rem}.-mr-32{margin-right:-8rem}.-mb-32{margin-bottom:-8rem}.-ml-32{margin-left:-8rem}.-mt-40{margin-top:-10rem}.-mr-40{margin-right:-10rem}.-mb-40{margin-bottom:-10rem}.-ml-40{margin-left:-10rem}.-mt-48{margin-top:-12rem}.-mr-48{margin-right:-12rem}.-mb-48{margin-bottom:-12rem}.-ml-48{margin-left:-12rem}.-mt-56{margin-top:-14rem}.-mr-56{margin-right:-14rem}.-mb-56{margin-bottom:-14rem}.-ml-56{margin-left:-14rem}.-mt-64{margin-top:-16rem}.-mr-64{margin-right:-16rem}.-mb-64{margin-bottom:-16rem}.-ml-64{margin-left:-16rem}.-mt-px{margin-top:-1px}.-mr-px{margin-right:-1px}.-mb-px{margin-bottom:-1px}.-ml-px{margin-left:-1px}.last\\:m-0:last-child{margin:0}.last\\:m-1:last-child{margin:.25rem}.last\\:m-2:last-child{margin:.5rem}.last\\:m-3:last-child{margin:.75rem}.last\\:m-4:last-child{margin:1rem}.last\\:m-5:last-child{margin:1.25rem}.last\\:m-6:last-child{margin:1.5rem}.last\\:m-8:last-child{margin:2rem}.last\\:m-10:last-child{margin:2.5rem}.last\\:m-12:last-child{margin:3rem}.last\\:m-16:last-child{margin:4rem}.last\\:m-20:last-child{margin:5rem}.last\\:m-24:last-child{margin:6rem}.last\\:m-32:last-child{margin:8rem}.last\\:m-40:last-child{margin:10rem}.last\\:m-48:last-child{margin:12rem}.last\\:m-56:last-child{margin:14rem}.last\\:m-64:last-child{margin:16rem}.last\\:m-auto:last-child{margin:auto}.last\\:m-px:last-child{margin:1px}.last\\:-m-1:last-child{margin:-.25rem}.last\\:-m-2:last-child{margin:-.5rem}.last\\:-m-3:last-child{margin:-.75rem}.last\\:-m-4:last-child{margin:-1rem}.last\\:-m-5:last-child{margin:-1.25rem}.last\\:-m-6:last-child{margin:-1.5rem}.last\\:-m-8:last-child{margin:-2rem}.last\\:-m-10:last-child{margin:-2.5rem}.last\\:-m-12:last-child{margin:-3rem}.last\\:-m-16:last-child{margin:-4rem}.last\\:-m-20:last-child{margin:-5rem}.last\\:-m-24:last-child{margin:-6rem}.last\\:-m-32:last-child{margin:-8rem}.last\\:-m-40:last-child{margin:-10rem}.last\\:-m-48:last-child{margin:-12rem}.last\\:-m-56:last-child{margin:-14rem}.last\\:-m-64:last-child{margin:-16rem}.last\\:-m-px:last-child{margin:-1px}.last\\:my-0:last-child{margin-bottom:0;margin-top:0}.last\\:mx-0:last-child{margin-left:0;margin-right:0}.last\\:my-1:last-child{margin-bottom:.25rem;margin-top:.25rem}.last\\:mx-1:last-child{margin-left:.25rem;margin-right:.25rem}.last\\:my-2:last-child{margin-bottom:.5rem;margin-top:.5rem}.last\\:mx-2:last-child{margin-left:.5rem;margin-right:.5rem}.last\\:my-3:last-child{margin-bottom:.75rem;margin-top:.75rem}.last\\:mx-3:last-child{margin-left:.75rem;margin-right:.75rem}.last\\:my-4:last-child{margin-bottom:1rem;margin-top:1rem}.last\\:mx-4:last-child{margin-left:1rem;margin-right:1rem}.last\\:my-5:last-child{margin-bottom:1.25rem;margin-top:1.25rem}.last\\:mx-5:last-child{margin-left:1.25rem;margin-right:1.25rem}.last\\:my-6:last-child{margin-bottom:1.5rem;margin-top:1.5rem}.last\\:mx-6:last-child{margin-left:1.5rem;margin-right:1.5rem}.last\\:my-8:last-child{margin-bottom:2rem;margin-top:2rem}.last\\:mx-8:last-child{margin-left:2rem;margin-right:2rem}.last\\:my-10:last-child{margin-bottom:2.5rem;margin-top:2.5rem}.last\\:mx-10:last-child{margin-left:2.5rem;margin-right:2.5rem}.last\\:my-12:last-child{margin-bottom:3rem;margin-top:3rem}.last\\:mx-12:last-child{margin-left:3rem;margin-right:3rem}.last\\:my-16:last-child{margin-bottom:4rem;margin-top:4rem}.last\\:mx-16:last-child{margin-left:4rem;margin-right:4rem}.last\\:my-20:last-child{margin-bottom:5rem;margin-top:5rem}.last\\:mx-20:last-child{margin-left:5rem;margin-right:5rem}.last\\:my-24:last-child{margin-bottom:6rem;margin-top:6rem}.last\\:mx-24:last-child{margin-left:6rem;margin-right:6rem}.last\\:my-32:last-child{margin-bottom:8rem;margin-top:8rem}.last\\:mx-32:last-child{margin-left:8rem;margin-right:8rem}.last\\:my-40:last-child{margin-bottom:10rem;margin-top:10rem}.last\\:mx-40:last-child{margin-left:10rem;margin-right:10rem}.last\\:my-48:last-child{margin-bottom:12rem;margin-top:12rem}.last\\:mx-48:last-child{margin-left:12rem;margin-right:12rem}.last\\:my-56:last-child{margin-bottom:14rem;margin-top:14rem}.last\\:mx-56:last-child{margin-left:14rem;margin-right:14rem}.last\\:my-64:last-child{margin-bottom:16rem;margin-top:16rem}.last\\:mx-64:last-child{margin-left:16rem;margin-right:16rem}.last\\:my-auto:last-child{margin-bottom:auto;margin-top:auto}.last\\:mx-auto:last-child{margin-left:auto;margin-right:auto}.last\\:my-px:last-child{margin-bottom:1px;margin-top:1px}.last\\:mx-px:last-child{margin-left:1px;margin-right:1px}.last\\:-my-1:last-child{margin-bottom:-.25rem;margin-top:-.25rem}.last\\:-mx-1:last-child{margin-left:-.25rem;margin-right:-.25rem}.last\\:-my-2:last-child{margin-bottom:-.5rem;margin-top:-.5rem}.last\\:-mx-2:last-child{margin-left:-.5rem;margin-right:-.5rem}.last\\:-my-3:last-child{margin-bottom:-.75rem;margin-top:-.75rem}.last\\:-mx-3:last-child{margin-left:-.75rem;margin-right:-.75rem}.last\\:-my-4:last-child{margin-bottom:-1rem;margin-top:-1rem}.last\\:-mx-4:last-child{margin-left:-1rem;margin-right:-1rem}.last\\:-my-5:last-child{margin-bottom:-1.25rem;margin-top:-1.25rem}.last\\:-mx-5:last-child{margin-left:-1.25rem;margin-right:-1.25rem}.last\\:-my-6:last-child{margin-bottom:-1.5rem;margin-top:-1.5rem}.last\\:-mx-6:last-child{margin-left:-1.5rem;margin-right:-1.5rem}.last\\:-my-8:last-child{margin-bottom:-2rem;margin-top:-2rem}.last\\:-mx-8:last-child{margin-left:-2rem;margin-right:-2rem}.last\\:-my-10:last-child{margin-bottom:-2.5rem;margin-top:-2.5rem}.last\\:-mx-10:last-child{margin-left:-2.5rem;margin-right:-2.5rem}.last\\:-my-12:last-child{margin-bottom:-3rem;margin-top:-3rem}.last\\:-mx-12:last-child{margin-left:-3rem;margin-right:-3rem}.last\\:-my-16:last-child{margin-bottom:-4rem;margin-top:-4rem}.last\\:-mx-16:last-child{margin-left:-4rem;margin-right:-4rem}.last\\:-my-20:last-child{margin-bottom:-5rem;margin-top:-5rem}.last\\:-mx-20:last-child{margin-left:-5rem;margin-right:-5rem}.last\\:-my-24:last-child{margin-bottom:-6rem;margin-top:-6rem}.last\\:-mx-24:last-child{margin-left:-6rem;margin-right:-6rem}.last\\:-my-32:last-child{margin-bottom:-8rem;margin-top:-8rem}.last\\:-mx-32:last-child{margin-left:-8rem;margin-right:-8rem}.last\\:-my-40:last-child{margin-bottom:-10rem;margin-top:-10rem}.last\\:-mx-40:last-child{margin-left:-10rem;margin-right:-10rem}.last\\:-my-48:last-child{margin-bottom:-12rem;margin-top:-12rem}.last\\:-mx-48:last-child{margin-left:-12rem;margin-right:-12rem}.last\\:-my-56:last-child{margin-bottom:-14rem;margin-top:-14rem}.last\\:-mx-56:last-child{margin-left:-14rem;margin-right:-14rem}.last\\:-my-64:last-child{margin-bottom:-16rem;margin-top:-16rem}.last\\:-mx-64:last-child{margin-left:-16rem;margin-right:-16rem}.last\\:-my-px:last-child{margin-bottom:-1px;margin-top:-1px}.last\\:-mx-px:last-child{margin-left:-1px;margin-right:-1px}.last\\:mt-0:last-child{margin-top:0}.last\\:mr-0:last-child{margin-right:0}.last\\:mb-0:last-child{margin-bottom:0}.last\\:ml-0:last-child{margin-left:0}.last\\:mt-1:last-child{margin-top:.25rem}.last\\:mr-1:last-child{margin-right:.25rem}.last\\:mb-1:last-child{margin-bottom:.25rem}.last\\:ml-1:last-child{margin-left:.25rem}.last\\:mt-2:last-child{margin-top:.5rem}.last\\:mr-2:last-child{margin-right:.5rem}.last\\:mb-2:last-child{margin-bottom:.5rem}.last\\:ml-2:last-child{margin-left:.5rem}.last\\:mt-3:last-child{margin-top:.75rem}.last\\:mr-3:last-child{margin-right:.75rem}.last\\:mb-3:last-child{margin-bottom:.75rem}.last\\:ml-3:last-child{margin-left:.75rem}.last\\:mt-4:last-child{margin-top:1rem}.last\\:mr-4:last-child{margin-right:1rem}.last\\:mb-4:last-child{margin-bottom:1rem}.last\\:ml-4:last-child{margin-left:1rem}.last\\:mt-5:last-child{margin-top:1.25rem}.last\\:mr-5:last-child{margin-right:1.25rem}.last\\:mb-5:last-child{margin-bottom:1.25rem}.last\\:ml-5:last-child{margin-left:1.25rem}.last\\:mt-6:last-child{margin-top:1.5rem}.last\\:mr-6:last-child{margin-right:1.5rem}.last\\:mb-6:last-child{margin-bottom:1.5rem}.last\\:ml-6:last-child{margin-left:1.5rem}.last\\:mt-8:last-child{margin-top:2rem}.last\\:mr-8:last-child{margin-right:2rem}.last\\:mb-8:last-child{margin-bottom:2rem}.last\\:ml-8:last-child{margin-left:2rem}.last\\:mt-10:last-child{margin-top:2.5rem}.last\\:mr-10:last-child{margin-right:2.5rem}.last\\:mb-10:last-child{margin-bottom:2.5rem}.last\\:ml-10:last-child{margin-left:2.5rem}.last\\:mt-12:last-child{margin-top:3rem}.last\\:mr-12:last-child{margin-right:3rem}.last\\:mb-12:last-child{margin-bottom:3rem}.last\\:ml-12:last-child{margin-left:3rem}.last\\:mt-16:last-child{margin-top:4rem}.last\\:mr-16:last-child{margin-right:4rem}.last\\:mb-16:last-child{margin-bottom:4rem}.last\\:ml-16:last-child{margin-left:4rem}.last\\:mt-20:last-child{margin-top:5rem}.last\\:mr-20:last-child{margin-right:5rem}.last\\:mb-20:last-child{margin-bottom:5rem}.last\\:ml-20:last-child{margin-left:5rem}.last\\:mt-24:last-child{margin-top:6rem}.last\\:mr-24:last-child{margin-right:6rem}.last\\:mb-24:last-child{margin-bottom:6rem}.last\\:ml-24:last-child{margin-left:6rem}.last\\:mt-32:last-child{margin-top:8rem}.last\\:mr-32:last-child{margin-right:8rem}.last\\:mb-32:last-child{margin-bottom:8rem}.last\\:ml-32:last-child{margin-left:8rem}.last\\:mt-40:last-child{margin-top:10rem}.last\\:mr-40:last-child{margin-right:10rem}.last\\:mb-40:last-child{margin-bottom:10rem}.last\\:ml-40:last-child{margin-left:10rem}.last\\:mt-48:last-child{margin-top:12rem}.last\\:mr-48:last-child{margin-right:12rem}.last\\:mb-48:last-child{margin-bottom:12rem}.last\\:ml-48:last-child{margin-left:12rem}.last\\:mt-56:last-child{margin-top:14rem}.last\\:mr-56:last-child{margin-right:14rem}.last\\:mb-56:last-child{margin-bottom:14rem}.last\\:ml-56:last-child{margin-left:14rem}.last\\:mt-64:last-child{margin-top:16rem}.last\\:mr-64:last-child{margin-right:16rem}.last\\:mb-64:last-child{margin-bottom:16rem}.last\\:ml-64:last-child{margin-left:16rem}.last\\:mt-auto:last-child{margin-top:auto}.last\\:mr-auto:last-child{margin-right:auto}.last\\:mb-auto:last-child{margin-bottom:auto}.last\\:ml-auto:last-child{margin-left:auto}.last\\:mt-px:last-child{margin-top:1px}.last\\:mr-px:last-child{margin-right:1px}.last\\:mb-px:last-child{margin-bottom:1px}.last\\:ml-px:last-child{margin-left:1px}.last\\:-mt-1:last-child{margin-top:-.25rem}.last\\:-mr-1:last-child{margin-right:-.25rem}.last\\:-mb-1:last-child{margin-bottom:-.25rem}.last\\:-ml-1:last-child{margin-left:-.25rem}.last\\:-mt-2:last-child{margin-top:-.5rem}.last\\:-mr-2:last-child{margin-right:-.5rem}.last\\:-mb-2:last-child{margin-bottom:-.5rem}.last\\:-ml-2:last-child{margin-left:-.5rem}.last\\:-mt-3:last-child{margin-top:-.75rem}.last\\:-mr-3:last-child{margin-right:-.75rem}.last\\:-mb-3:last-child{margin-bottom:-.75rem}.last\\:-ml-3:last-child{margin-left:-.75rem}.last\\:-mt-4:last-child{margin-top:-1rem}.last\\:-mr-4:last-child{margin-right:-1rem}.last\\:-mb-4:last-child{margin-bottom:-1rem}.last\\:-ml-4:last-child{margin-left:-1rem}.last\\:-mt-5:last-child{margin-top:-1.25rem}.last\\:-mr-5:last-child{margin-right:-1.25rem}.last\\:-mb-5:last-child{margin-bottom:-1.25rem}.last\\:-ml-5:last-child{margin-left:-1.25rem}.last\\:-mt-6:last-child{margin-top:-1.5rem}.last\\:-mr-6:last-child{margin-right:-1.5rem}.last\\:-mb-6:last-child{margin-bottom:-1.5rem}.last\\:-ml-6:last-child{margin-left:-1.5rem}.last\\:-mt-8:last-child{margin-top:-2rem}.last\\:-mr-8:last-child{margin-right:-2rem}.last\\:-mb-8:last-child{margin-bottom:-2rem}.last\\:-ml-8:last-child{margin-left:-2rem}.last\\:-mt-10:last-child{margin-top:-2.5rem}.last\\:-mr-10:last-child{margin-right:-2.5rem}.last\\:-mb-10:last-child{margin-bottom:-2.5rem}.last\\:-ml-10:last-child{margin-left:-2.5rem}.last\\:-mt-12:last-child{margin-top:-3rem}.last\\:-mr-12:last-child{margin-right:-3rem}.last\\:-mb-12:last-child{margin-bottom:-3rem}.last\\:-ml-12:last-child{margin-left:-3rem}.last\\:-mt-16:last-child{margin-top:-4rem}.last\\:-mr-16:last-child{margin-right:-4rem}.last\\:-mb-16:last-child{margin-bottom:-4rem}.last\\:-ml-16:last-child{margin-left:-4rem}.last\\:-mt-20:last-child{margin-top:-5rem}.last\\:-mr-20:last-child{margin-right:-5rem}.last\\:-mb-20:last-child{margin-bottom:-5rem}.last\\:-ml-20:last-child{margin-left:-5rem}.last\\:-mt-24:last-child{margin-top:-6rem}.last\\:-mr-24:last-child{margin-right:-6rem}.last\\:-mb-24:last-child{margin-bottom:-6rem}.last\\:-ml-24:last-child{margin-left:-6rem}.last\\:-mt-32:last-child{margin-top:-8rem}.last\\:-mr-32:last-child{margin-right:-8rem}.last\\:-mb-32:last-child{margin-bottom:-8rem}.last\\:-ml-32:last-child{margin-left:-8rem}.last\\:-mt-40:last-child{margin-top:-10rem}.last\\:-mr-40:last-child{margin-right:-10rem}.last\\:-mb-40:last-child{margin-bottom:-10rem}.last\\:-ml-40:last-child{margin-left:-10rem}.last\\:-mt-48:last-child{margin-top:-12rem}.last\\:-mr-48:last-child{margin-right:-12rem}.last\\:-mb-48:last-child{margin-bottom:-12rem}.last\\:-ml-48:last-child{margin-left:-12rem}.last\\:-mt-56:last-child{margin-top:-14rem}.last\\:-mr-56:last-child{margin-right:-14rem}.last\\:-mb-56:last-child{margin-bottom:-14rem}.last\\:-ml-56:last-child{margin-left:-14rem}.last\\:-mt-64:last-child{margin-top:-16rem}.last\\:-mr-64:last-child{margin-right:-16rem}.last\\:-mb-64:last-child{margin-bottom:-16rem}.last\\:-ml-64:last-child{margin-left:-16rem}.last\\:-mt-px:last-child{margin-top:-1px}.last\\:-mr-px:last-child{margin-right:-1px}.last\\:-mb-px:last-child{margin-bottom:-1px}.last\\:-ml-px:last-child{margin-left:-1px}.max-h-0{max-height:0}.max-h-1{max-height:.25rem}.max-h-2{max-height:.5rem}.max-h-3{max-height:.75rem}.max-h-4{max-height:1rem}.max-h-5{max-height:1.25rem}.max-h-6{max-height:1.5rem}.max-h-8{max-height:2rem}.max-h-10{max-height:2.5rem}.max-h-12{max-height:3rem}.max-h-16{max-height:4rem}.max-h-20{max-height:5rem}.max-h-24{max-height:6rem}.max-h-32{max-height:8rem}.max-h-40{max-height:10rem}.max-h-48{max-height:12rem}.max-h-56{max-height:14rem}.max-h-64{max-height:16rem}.max-h-xl{max-height:36rem}.max-h-px{max-height:1px}.max-w-none{max-width:none}.max-w-xs{max-width:20rem}.max-w-sm{max-width:24rem}.max-w-md{max-width:28rem}.max-w-lg{max-width:32rem}.max-w-xl{max-width:36rem}.max-w-2xl{max-width:42rem}.max-w-3xl{max-width:48rem}.max-w-4xl{max-width:56rem}.max-w-5xl{max-width:64rem}.max-w-6xl{max-width:72rem}.max-w-full{max-width:100%}.max-w-screen-sm{max-width:640px}.max-w-screen-md{max-width:768px}.max-w-screen-lg{max-width:1024px}.max-w-screen-xl{max-width:1280px}.min-h-0{min-height:0}.min-h-full{min-height:100%}.min-h-screen{min-height:100vh}.min-w-0{min-width:0}.min-w-1{min-width:.25rem}.min-w-2{min-width:.5rem}.min-w-3{min-width:.75rem}.min-w-4{min-width:1rem}.min-w-5{min-width:1.25rem}.min-w-6{min-width:1.5rem}.min-w-8{min-width:2rem}.min-w-10{min-width:2.5rem}.min-w-12{min-width:3rem}.min-w-16{min-width:4rem}.min-w-20{min-width:5rem}.min-w-24{min-width:6rem}.min-w-32{min-width:8rem}.min-w-40{min-width:10rem}.min-w-48{min-width:12rem}.min-w-56{min-width:14rem}.min-w-64{min-width:16rem}.min-w-max-content{min-width:-webkit-max-content;min-width:max-content}.min-w-px{min-width:1px}.object-contain{object-fit:contain}.object-cover{object-fit:cover}.object-fill{object-fit:fill}.object-none{object-fit:none}.object-scale-down{object-fit:scale-down}.object-bottom{object-position:bottom}.object-center{object-position:center}.object-left{object-position:left}.object-left-bottom{object-position:left bottom}.object-left-top{object-position:left top}.object-right{object-position:right}.object-right-bottom{object-position:right bottom}.object-right-top{object-position:right top}.object-top{object-position:top}.opacity-0{opacity:0}.opacity-25{opacity:.25}.opacity-50{opacity:.5}.opacity-75{opacity:.75}.opacity-100{opacity:1}.hover\\:opacity-0:hover{opacity:0}.hover\\:opacity-25:hover{opacity:.25}.hover\\:opacity-50:hover{opacity:.5}.hover\\:opacity-75:hover{opacity:.75}.hover\\:opacity-100:hover{opacity:1}.focus\\:opacity-0:focus{opacity:0}.focus\\:opacity-25:focus{opacity:.25}.focus\\:opacity-50:focus{opacity:.5}.focus\\:opacity-75:focus{opacity:.75}.focus\\:opacity-100:focus{opacity:1}.focus\\:outline-none:focus,.outline-none{outline:0}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-visible{overflow:visible}.overflow-scroll{overflow:scroll}.overflow-x-auto{overflow-x:auto}.overflow-y-auto{overflow-y:auto}.overflow-x-hidden{overflow-x:hidden}.overflow-y-hidden{overflow-y:hidden}.overflow-x-visible{overflow-x:visible}.overflow-y-visible{overflow-y:visible}.overflow-x-scroll{overflow-x:scroll}.overflow-y-scroll{overflow-y:scroll}.scrolling-touch{-webkit-overflow-scrolling:touch}.scrolling-auto{-webkit-overflow-scrolling:auto}.p-0{padding:0}.p-1{padding:.25rem}.p-2{padding:.5rem}.p-3{padding:.75rem}.p-4{padding:1rem}.p-5{padding:1.25rem}.p-6{padding:1.5rem}.p-8{padding:2rem}.p-10{padding:2.5rem}.p-12{padding:3rem}.p-16{padding:4rem}.p-20{padding:5rem}.p-24{padding:6rem}.p-32{padding:8rem}.p-40{padding:10rem}.p-48{padding:12rem}.p-56{padding:14rem}.p-64{padding:16rem}.p-px{padding:1px}.py-0{padding-bottom:0;padding-top:0}.px-0{padding-left:0;padding-right:0}.py-1{padding-bottom:.25rem;padding-top:.25rem}.px-1{padding-left:.25rem;padding-right:.25rem}.py-2{padding-bottom:.5rem;padding-top:.5rem}.px-2{padding-left:.5rem;padding-right:.5rem}.py-3{padding-bottom:.75rem;padding-top:.75rem}.px-3{padding-left:.75rem;padding-right:.75rem}.py-4{padding-bottom:1rem;padding-top:1rem}.px-4{padding-left:1rem;padding-right:1rem}.py-5{padding-bottom:1.25rem;padding-top:1.25rem}.px-5{padding-left:1.25rem;padding-right:1.25rem}.py-6{padding-bottom:1.5rem;padding-top:1.5rem}.px-6{padding-left:1.5rem;padding-right:1.5rem}.py-8{padding-bottom:2rem;padding-top:2rem}.px-8{padding-left:2rem;padding-right:2rem}.py-10{padding-bottom:2.5rem;padding-top:2.5rem}.px-10{padding-left:2.5rem;padding-right:2.5rem}.py-12{padding-bottom:3rem;padding-top:3rem}.px-12{padding-left:3rem;padding-right:3rem}.py-16{padding-bottom:4rem;padding-top:4rem}.px-16{padding-left:4rem;padding-right:4rem}.py-20{padding-bottom:5rem;padding-top:5rem}.px-20{padding-left:5rem;padding-right:5rem}.py-24{padding-bottom:6rem;padding-top:6rem}.px-24{padding-left:6rem;padding-right:6rem}.py-32{padding-bottom:8rem;padding-top:8rem}.px-32{padding-left:8rem;padding-right:8rem}.py-40{padding-bottom:10rem;padding-top:10rem}.px-40{padding-left:10rem;padding-right:10rem}.py-48{padding-bottom:12rem;padding-top:12rem}.px-48{padding-left:12rem;padding-right:12rem}.py-56{padding-bottom:14rem;padding-top:14rem}.px-56{padding-left:14rem;padding-right:14rem}.py-64{padding-bottom:16rem;padding-top:16rem}.px-64{padding-left:16rem;padding-right:16rem}.py-px{padding-bottom:1px;padding-top:1px}.px-px{padding-left:1px;padding-right:1px}.pt-0{padding-top:0}.pr-0{padding-right:0}.pb-0{padding-bottom:0}.pl-0{padding-left:0}.pt-1{padding-top:.25rem}.pr-1{padding-right:.25rem}.pb-1{padding-bottom:.25rem}.pl-1{padding-left:.25rem}.pt-2{padding-top:.5rem}.pr-2{padding-right:.5rem}.pb-2{padding-bottom:.5rem}.pl-2{padding-left:.5rem}.pt-3{padding-top:.75rem}.pr-3{padding-right:.75rem}.pb-3{padding-bottom:.75rem}.pl-3{padding-left:.75rem}.pt-4{padding-top:1rem}.pr-4{padding-right:1rem}.pb-4{padding-bottom:1rem}.pl-4{padding-left:1rem}.pt-5{padding-top:1.25rem}.pr-5{padding-right:1.25rem}.pb-5{padding-bottom:1.25rem}.pl-5{padding-left:1.25rem}.pt-6{padding-top:1.5rem}.pr-6{padding-right:1.5rem}.pb-6{padding-bottom:1.5rem}.pl-6{padding-left:1.5rem}.pt-8{padding-top:2rem}.pr-8{padding-right:2rem}.pb-8{padding-bottom:2rem}.pl-8{padding-left:2rem}.pt-10{padding-top:2.5rem}.pr-10{padding-right:2.5rem}.pb-10{padding-bottom:2.5rem}.pl-10{padding-left:2.5rem}.pt-12{padding-top:3rem}.pr-12{padding-right:3rem}.pb-12{padding-bottom:3rem}.pl-12{padding-left:3rem}.pt-16{padding-top:4rem}.pr-16{padding-right:4rem}.pb-16{padding-bottom:4rem}.pl-16{padding-left:4rem}.pt-20{padding-top:5rem}.pr-20{padding-right:5rem}.pb-20{padding-bottom:5rem}.pl-20{padding-left:5rem}.pt-24{padding-top:6rem}.pr-24{padding-right:6rem}.pb-24{padding-bottom:6rem}.pl-24{padding-left:6rem}.pt-32{padding-top:8rem}.pr-32{padding-right:8rem}.pb-32{padding-bottom:8rem}.pl-32{padding-left:8rem}.pt-40{padding-top:10rem}.pr-40{padding-right:10rem}.pb-40{padding-bottom:10rem}.pl-40{padding-left:10rem}.pt-48{padding-top:12rem}.pr-48{padding-right:12rem}.pb-48{padding-bottom:12rem}.pl-48{padding-left:12rem}.pt-56{padding-top:14rem}.pr-56{padding-right:14rem}.pb-56{padding-bottom:14rem}.pl-56{padding-left:14rem}.pt-64{padding-top:16rem}.pr-64{padding-right:16rem}.pb-64{padding-bottom:16rem}.pl-64{padding-left:16rem}.pt-px{padding-top:1px}.pr-px{padding-right:1px}.pb-px{padding-bottom:1px}.pl-px{padding-left:1px}.placeholder-transparent::placeholder{color:#0000}.placeholder-white::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.placeholder-black::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.placeholder-gray-50::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.placeholder-gray-100::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.placeholder-gray-200::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.placeholder-gray-300::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.placeholder-gray-400::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.placeholder-gray-500::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.placeholder-gray-600::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.placeholder-gray-700::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.placeholder-gray-800::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.placeholder-gray-900::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.placeholder-cool-gray-50::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.placeholder-cool-gray-100::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.placeholder-cool-gray-200::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.placeholder-cool-gray-300::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.placeholder-cool-gray-400::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.placeholder-cool-gray-500::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.placeholder-cool-gray-600::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.placeholder-cool-gray-700::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.placeholder-cool-gray-800::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.placeholder-cool-gray-900::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.placeholder-red-50::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.placeholder-red-100::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.placeholder-red-200::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.placeholder-red-300::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.placeholder-red-400::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.placeholder-red-500::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.placeholder-red-600::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.placeholder-red-700::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.placeholder-red-800::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.placeholder-red-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.placeholder-orange-50::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.placeholder-orange-100::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.placeholder-orange-200::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.placeholder-orange-300::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.placeholder-orange-400::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.placeholder-orange-500::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.placeholder-orange-600::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.placeholder-orange-700::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.placeholder-orange-800::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.placeholder-orange-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.placeholder-yellow-50::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.placeholder-yellow-100::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.placeholder-yellow-200::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.placeholder-yellow-300::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.placeholder-yellow-400::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.placeholder-yellow-500::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.placeholder-yellow-600::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.placeholder-yellow-700::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.placeholder-yellow-800::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.placeholder-yellow-900::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.placeholder-green-50::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.placeholder-green-100::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.placeholder-green-200::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.placeholder-green-300::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.placeholder-green-400::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.placeholder-green-500::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.placeholder-green-600::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.placeholder-green-700::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.placeholder-green-800::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.placeholder-green-900::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.placeholder-teal-50::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.placeholder-teal-100::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.placeholder-teal-200::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.placeholder-teal-300::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.placeholder-teal-400::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.placeholder-teal-500::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.placeholder-teal-600::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.placeholder-teal-700::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.placeholder-teal-800::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.placeholder-teal-900::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.placeholder-blue-50::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.placeholder-blue-100::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.placeholder-blue-200::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.placeholder-blue-300::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.placeholder-blue-400::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.placeholder-blue-500::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.placeholder-blue-600::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.placeholder-blue-700::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.placeholder-blue-800::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.placeholder-blue-900::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.placeholder-pink-50::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.placeholder-pink-100::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.placeholder-pink-200::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.placeholder-pink-300::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.placeholder-pink-400::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.placeholder-pink-500::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.placeholder-pink-600::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.placeholder-pink-700::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.placeholder-pink-800::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.placeholder-pink-900::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.focus\\:placeholder-transparent:focus::placeholder{color:#0000}.focus\\:placeholder-white:focus::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.focus\\:placeholder-black:focus::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.focus\\:placeholder-gray-50:focus::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.focus\\:placeholder-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.focus\\:placeholder-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.focus\\:placeholder-gray-300:focus::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.focus\\:placeholder-gray-400:focus::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.focus\\:placeholder-gray-500:focus::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.focus\\:placeholder-gray-600:focus::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.focus\\:placeholder-gray-700:focus::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.focus\\:placeholder-gray-800:focus::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.focus\\:placeholder-gray-900:focus::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.focus\\:placeholder-cool-gray-50:focus::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.focus\\:placeholder-cool-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.focus\\:placeholder-cool-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.focus\\:placeholder-cool-gray-300:focus::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.focus\\:placeholder-cool-gray-400:focus::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.focus\\:placeholder-cool-gray-500:focus::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.focus\\:placeholder-cool-gray-600:focus::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.focus\\:placeholder-cool-gray-700:focus::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.focus\\:placeholder-cool-gray-800:focus::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.focus\\:placeholder-cool-gray-900:focus::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.focus\\:placeholder-red-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.focus\\:placeholder-red-100:focus::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.focus\\:placeholder-red-200:focus::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.focus\\:placeholder-red-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.focus\\:placeholder-red-400:focus::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.focus\\:placeholder-red-500:focus::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.focus\\:placeholder-red-600:focus::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.focus\\:placeholder-red-700:focus::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.focus\\:placeholder-red-800:focus::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.focus\\:placeholder-red-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.focus\\:placeholder-orange-50:focus::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.focus\\:placeholder-orange-100:focus::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.focus\\:placeholder-orange-200:focus::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.focus\\:placeholder-orange-300:focus::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.focus\\:placeholder-orange-400:focus::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.focus\\:placeholder-orange-500:focus::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.focus\\:placeholder-orange-600:focus::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.focus\\:placeholder-orange-700:focus::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.focus\\:placeholder-orange-800:focus::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.focus\\:placeholder-orange-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.focus\\:placeholder-yellow-50:focus::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.focus\\:placeholder-yellow-100:focus::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.focus\\:placeholder-yellow-200:focus::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.focus\\:placeholder-yellow-300:focus::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.focus\\:placeholder-yellow-400:focus::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.focus\\:placeholder-yellow-500:focus::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.focus\\:placeholder-yellow-600:focus::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.focus\\:placeholder-yellow-700:focus::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.focus\\:placeholder-yellow-800:focus::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.focus\\:placeholder-yellow-900:focus::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.focus\\:placeholder-green-50:focus::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.focus\\:placeholder-green-100:focus::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.focus\\:placeholder-green-200:focus::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.focus\\:placeholder-green-300:focus::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.focus\\:placeholder-green-400:focus::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.focus\\:placeholder-green-500:focus::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.focus\\:placeholder-green-600:focus::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.focus\\:placeholder-green-700:focus::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.focus\\:placeholder-green-800:focus::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.focus\\:placeholder-green-900:focus::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.focus\\:placeholder-teal-50:focus::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.focus\\:placeholder-teal-100:focus::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.focus\\:placeholder-teal-200:focus::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.focus\\:placeholder-teal-300:focus::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.focus\\:placeholder-teal-400:focus::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.focus\\:placeholder-teal-500:focus::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.focus\\:placeholder-teal-600:focus::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.focus\\:placeholder-teal-700:focus::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.focus\\:placeholder-teal-800:focus::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.focus\\:placeholder-teal-900:focus::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.focus\\:placeholder-blue-50:focus::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.focus\\:placeholder-blue-100:focus::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.focus\\:placeholder-blue-200:focus::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.focus\\:placeholder-blue-300:focus::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.focus\\:placeholder-blue-400:focus::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.focus\\:placeholder-blue-500:focus::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.focus\\:placeholder-blue-600:focus::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.focus\\:placeholder-blue-700:focus::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.focus\\:placeholder-blue-800:focus::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.focus\\:placeholder-blue-900:focus::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.focus\\:placeholder-pink-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.focus\\:placeholder-pink-100:focus::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.focus\\:placeholder-pink-200:focus::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.focus\\:placeholder-pink-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.focus\\:placeholder-pink-400:focus::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.focus\\:placeholder-pink-500:focus::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.focus\\:placeholder-pink-600:focus::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.focus\\:placeholder-pink-700:focus::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.focus\\:placeholder-pink-800:focus::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.focus\\:placeholder-pink-900:focus::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-transparent::placeholder{color:#0000}.theme-dark .dark\\:placeholder-white::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-black::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-gray-50::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-gray-100::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-gray-200::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-gray-300::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-gray-400::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-gray-500::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-gray-600::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-gray-700::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-gray-800::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-gray-900::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-cool-gray-50::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-cool-gray-100::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-cool-gray-200::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-cool-gray-300::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-cool-gray-400::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-cool-gray-500::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-cool-gray-600::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-cool-gray-700::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-cool-gray-800::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-cool-gray-900::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-red-50::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-red-100::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-red-200::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-red-300::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-red-400::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-red-500::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-red-600::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-red-700::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-red-800::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-red-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-orange-50::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-orange-100::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-orange-200::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-orange-300::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-orange-400::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-orange-500::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-orange-600::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-orange-700::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-orange-800::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-orange-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-yellow-50::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-yellow-100::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-yellow-200::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-yellow-300::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-yellow-400::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-yellow-500::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-yellow-600::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-yellow-700::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-yellow-800::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-yellow-900::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-green-50::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-green-100::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-green-200::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-green-300::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-green-400::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-green-500::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-green-600::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-green-700::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-green-800::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-green-900::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-teal-50::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-teal-100::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-teal-200::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-teal-300::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-teal-400::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-teal-500::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-teal-600::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-teal-700::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-teal-800::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-teal-900::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-blue-50::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-blue-100::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-blue-200::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-blue-300::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-blue-400::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-blue-500::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-blue-600::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-blue-700::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-blue-800::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-blue-900::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-pink-50::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-pink-100::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-pink-200::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-pink-300::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-pink-400::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-pink-500::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-pink-600::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-pink-700::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-pink-800::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.theme-dark .dark\\:placeholder-pink-900::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-transparent:focus::placeholder{color:#0000}.theme-dark .dark\\:focus\\:placeholder-white:focus::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-black:focus::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-gray-50:focus::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-gray-300:focus::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-gray-400:focus::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-gray-500:focus::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-gray-600:focus::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-gray-700:focus::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-gray-800:focus::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-gray-900:focus::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-cool-gray-50:focus::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-cool-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-cool-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-cool-gray-300:focus::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-cool-gray-400:focus::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-cool-gray-500:focus::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-cool-gray-600:focus::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-cool-gray-700:focus::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-cool-gray-800:focus::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-cool-gray-900:focus::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-red-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-red-100:focus::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-red-200:focus::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-red-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-red-400:focus::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-red-500:focus::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-red-600:focus::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-red-700:focus::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-red-800:focus::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-red-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-orange-50:focus::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-orange-100:focus::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-orange-200:focus::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-orange-300:focus::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-orange-400:focus::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-orange-500:focus::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-orange-600:focus::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-orange-700:focus::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-orange-800:focus::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-orange-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-yellow-50:focus::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-yellow-100:focus::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-yellow-200:focus::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-yellow-300:focus::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-yellow-400:focus::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-yellow-500:focus::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-yellow-600:focus::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-yellow-700:focus::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-yellow-800:focus::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-yellow-900:focus::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-green-50:focus::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-green-100:focus::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-green-200:focus::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-green-300:focus::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-green-400:focus::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-green-500:focus::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-green-600:focus::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-green-700:focus::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-green-800:focus::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-green-900:focus::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-teal-50:focus::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-teal-100:focus::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-teal-200:focus::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-teal-300:focus::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-teal-400:focus::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-teal-500:focus::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-teal-600:focus::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-teal-700:focus::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-teal-800:focus::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-teal-900:focus::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-blue-50:focus::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-blue-100:focus::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-blue-200:focus::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-blue-300:focus::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-blue-400:focus::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-blue-500:focus::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-blue-600:focus::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-blue-700:focus::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-blue-800:focus::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-blue-900:focus::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-pink-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-pink-100:focus::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-pink-200:focus::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-pink-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-pink-400:focus::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-pink-500:focus::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-pink-600:focus::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-pink-700:focus::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-pink-800:focus::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.theme-dark .dark\\:focus\\:placeholder-pink-900:focus::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.placeholder-opacity-0::placeholder{--placeholder-opacity:0}.placeholder-opacity-25::placeholder{--placeholder-opacity:0.25}.placeholder-opacity-50::placeholder{--placeholder-opacity:0.5}.placeholder-opacity-75::placeholder{--placeholder-opacity:0.75}.placeholder-opacity-100::placeholder{--placeholder-opacity:1}.focus\\:placeholder-opacity-0:focus::placeholder{--placeholder-opacity:0}.focus\\:placeholder-opacity-25:focus::placeholder{--placeholder-opacity:0.25}.focus\\:placeholder-opacity-50:focus::placeholder{--placeholder-opacity:0.5}.focus\\:placeholder-opacity-75:focus::placeholder{--placeholder-opacity:0.75}.focus\\:placeholder-opacity-100:focus::placeholder{--placeholder-opacity:1}.pointer-events-none{pointer-events:none}.pointer-events-auto{pointer-events:auto}.static{position:static}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.sticky{position:-webkit-sticky;position:sticky}.inset-0{bottom:0;left:0;right:0;top:0}.inset-auto{bottom:auto;left:auto;right:auto;top:auto}.inset-y-0{bottom:0;top:0}.inset-x-0{left:0;right:0}.inset-y-auto{bottom:auto;top:auto}.inset-x-auto{left:auto;right:auto}.top-0{top:0}.right-0{right:0}.bottom-0{bottom:0}.left-0{left:0}.top-auto{top:auto}.right-auto{right:auto}.bottom-auto{bottom:auto}.left-auto{left:auto}.resize-none{resize:none}.resize-y{resize:vertical}.resize-x{resize:horizontal}.resize{resize:both}.shadow-xs{box-shadow:0 0 0 1px #0000000d}.shadow-sm{box-shadow:0 1px 2px 0 #0000000d}.shadow{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.shadow-md{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.shadow-lg{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.shadow-xl{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.shadow-2xl{box-shadow:0 25px 50px -12px #00000040}.shadow-inner{box-shadow:inset 0 2px 4px 0 #0000000f}.shadow-outline{box-shadow:0 0 0 3px #4299e180}.shadow-none{box-shadow:none}.shadow-bottom{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.hover\\:shadow-xs:hover{box-shadow:0 0 0 1px #0000000d}.hover\\:shadow-sm:hover{box-shadow:0 1px 2px 0 #0000000d}.hover\\:shadow:hover{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.hover\\:shadow-md:hover{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.hover\\:shadow-lg:hover{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.hover\\:shadow-xl:hover{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.hover\\:shadow-2xl:hover{box-shadow:0 25px 50px -12px #00000040}.hover\\:shadow-inner:hover{box-shadow:inset 0 2px 4px 0 #0000000f}.hover\\:shadow-outline:hover{box-shadow:0 0 0 3px #4299e180}.hover\\:shadow-none:hover{box-shadow:none}.hover\\:shadow-bottom:hover{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.focus\\:shadow-xs:focus{box-shadow:0 0 0 1px #0000000d}.focus\\:shadow-sm:focus{box-shadow:0 1px 2px 0 #0000000d}.focus\\:shadow:focus{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.focus\\:shadow-md:focus{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.focus\\:shadow-lg:focus{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.focus\\:shadow-xl:focus{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.focus\\:shadow-2xl:focus{box-shadow:0 25px 50px -12px #00000040}.focus\\:shadow-inner:focus{box-shadow:inset 0 2px 4px 0 #0000000f}.focus\\:shadow-outline:focus{box-shadow:0 0 0 3px #4299e180}.focus\\:shadow-none:focus{box-shadow:none}.focus\\:shadow-bottom:focus{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.theme-dark .dark\\:focus\\:shadow-xs:focus{box-shadow:0 0 0 1px #0000000d}.theme-dark .dark\\:focus\\:shadow-sm:focus{box-shadow:0 1px 2px 0 #0000000d}.theme-dark .dark\\:focus\\:shadow:focus{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.theme-dark .dark\\:focus\\:shadow-md:focus{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.theme-dark .dark\\:focus\\:shadow-lg:focus{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.theme-dark .dark\\:focus\\:shadow-xl:focus{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.theme-dark .dark\\:focus\\:shadow-2xl:focus{box-shadow:0 25px 50px -12px #00000040}.theme-dark .dark\\:focus\\:shadow-inner:focus{box-shadow:inset 0 2px 4px 0 #0000000f}.theme-dark .dark\\:focus\\:shadow-outline:focus{box-shadow:0 0 0 3px #4299e180}.theme-dark .dark\\:focus\\:shadow-none:focus{box-shadow:none}.theme-dark .dark\\:focus\\:shadow-bottom:focus{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.fill-current{fill:currentColor}.stroke-current{stroke:currentColor}.stroke-0{stroke-width:0}.stroke-1{stroke-width:1}.stroke-2{stroke-width:2}.table-auto{table-layout:auto}.table-fixed{table-layout:fixed}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.text-justify{text-align:justify}.text-transparent{color:#0000}.text-white{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.text-black{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.text-gray-50{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.text-gray-100{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.text-gray-200{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.text-gray-300{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.text-gray-400{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.text-gray-500{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.text-gray-600{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.text-gray-700{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.text-gray-800{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.text-gray-900{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.text-cool-gray-50{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.text-cool-gray-100{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.text-cool-gray-200{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.text-cool-gray-300{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.text-cool-gray-400{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.text-cool-gray-500{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.text-cool-gray-600{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.text-cool-gray-700{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.text-cool-gray-800{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.text-cool-gray-900{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.text-red-50{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.text-red-100{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.text-red-200{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.text-red-300{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.text-red-400{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.text-red-500{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.text-red-600{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.text-red-700{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.text-red-800{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.text-red-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.text-orange-50{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.text-orange-100{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.text-orange-200{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.text-orange-300{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.text-orange-400{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.text-orange-500{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.text-orange-600{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.text-orange-700{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.text-orange-800{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.text-orange-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.text-yellow-50{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.text-yellow-100{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.text-yellow-200{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.text-yellow-300{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.text-yellow-400{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.text-yellow-500{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.text-yellow-600{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.text-yellow-700{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.text-yellow-800{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.text-yellow-900{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.text-green-50{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.text-green-100{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.text-green-200{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.text-green-300{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.text-green-400{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.text-green-500{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.text-green-600{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.text-green-700{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.text-green-800{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.text-green-900{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.text-teal-50{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.text-teal-100{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.text-teal-200{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.text-teal-300{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.text-teal-400{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.text-teal-500{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.text-teal-600{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.text-teal-700{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.text-teal-800{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.text-teal-900{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.text-blue-50{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.text-blue-100{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.text-blue-200{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.text-blue-300{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.text-blue-400{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.text-blue-500{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.text-blue-600{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.text-blue-700{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.text-blue-800{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.text-blue-900{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.text-indigo-50{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.text-indigo-100{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.text-indigo-200{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.text-indigo-300{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.text-indigo-400{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.text-indigo-500{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.text-indigo-600{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.text-indigo-700{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.text-indigo-800{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.text-indigo-900{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.text-indigo-50{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.text-indigo-100{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.text-indigo-200{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.text-indigo-300{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.text-indigo-400{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.text-indigo-500{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.text-indigo-600{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.text-indigo-700{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.text-indigo-800{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.text-indigo-900{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.text-pink-50{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.text-pink-100{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.text-pink-200{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.text-pink-300{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.text-pink-400{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.text-pink-500{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.text-pink-600{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.text-pink-700{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.text-pink-800{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.text-pink-900{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.focus\\:text-transparent:focus{color:#0000}.focus\\:text-white:focus{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.focus\\:text-black:focus{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.focus\\:text-gray-50:focus{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.focus\\:text-gray-100:focus{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.focus\\:text-gray-200:focus{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.focus\\:text-gray-300:focus{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.focus\\:text-gray-400:focus{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.focus\\:text-gray-500:focus{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.focus\\:text-gray-600:focus{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.focus\\:text-gray-700:focus{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.focus\\:text-gray-800:focus{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.focus\\:text-gray-900:focus{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.focus\\:text-cool-gray-50:focus{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.focus\\:text-cool-gray-100:focus{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.focus\\:text-cool-gray-200:focus{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.focus\\:text-cool-gray-300:focus{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.focus\\:text-cool-gray-400:focus{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.focus\\:text-cool-gray-500:focus{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.focus\\:text-cool-gray-600:focus{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.focus\\:text-cool-gray-700:focus{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.focus\\:text-cool-gray-800:focus{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.focus\\:text-cool-gray-900:focus{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.focus\\:text-red-50:focus{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.focus\\:text-red-100:focus{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.focus\\:text-red-200:focus{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.focus\\:text-red-300:focus{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.focus\\:text-red-400:focus{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.focus\\:text-red-500:focus{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.focus\\:text-red-600:focus{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.focus\\:text-red-700:focus{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.focus\\:text-red-800:focus{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.focus\\:text-red-900:focus{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.focus\\:text-orange-50:focus{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.focus\\:text-orange-100:focus{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.focus\\:text-orange-200:focus{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.focus\\:text-orange-300:focus{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.focus\\:text-orange-400:focus{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.focus\\:text-orange-500:focus{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.focus\\:text-orange-600:focus{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.focus\\:text-orange-700:focus{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.focus\\:text-orange-800:focus{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.focus\\:text-orange-900:focus{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.focus\\:text-yellow-50:focus{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.focus\\:text-yellow-100:focus{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.focus\\:text-yellow-200:focus{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.focus\\:text-yellow-300:focus{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.focus\\:text-yellow-400:focus{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.focus\\:text-yellow-500:focus{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.focus\\:text-yellow-600:focus{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.focus\\:text-yellow-700:focus{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.focus\\:text-yellow-800:focus{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.focus\\:text-yellow-900:focus{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.focus\\:text-green-50:focus{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.focus\\:text-green-100:focus{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.focus\\:text-green-200:focus{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.focus\\:text-green-300:focus{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.focus\\:text-green-400:focus{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.focus\\:text-green-500:focus{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.focus\\:text-green-600:focus{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.focus\\:text-green-700:focus{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.focus\\:text-green-800:focus{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.focus\\:text-green-900:focus{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.focus\\:text-teal-50:focus{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.focus\\:text-teal-100:focus{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.focus\\:text-teal-200:focus{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.focus\\:text-teal-300:focus{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.focus\\:text-teal-400:focus{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.focus\\:text-teal-500:focus{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.focus\\:text-teal-600:focus{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.focus\\:text-teal-700:focus{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.focus\\:text-teal-800:focus{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.focus\\:text-teal-900:focus{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.focus\\:text-blue-50:focus{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.focus\\:text-blue-100:focus{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.focus\\:text-blue-200:focus{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.focus\\:text-blue-300:focus{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.focus\\:text-blue-400:focus{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.focus\\:text-blue-500:focus{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.focus\\:text-blue-600:focus{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.focus\\:text-blue-700:focus{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.focus\\:text-blue-800:focus{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.focus\\:text-blue-900:focus{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.focus\\:text-indigo-50:focus{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.focus\\:text-indigo-100:focus{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.focus\\:text-indigo-200:focus{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.focus\\:text-indigo-300:focus{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.focus\\:text-indigo-400:focus{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.focus\\:text-indigo-500:focus{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.focus\\:text-indigo-600:focus{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.focus\\:text-indigo-700:focus{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.focus\\:text-indigo-800:focus{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.focus\\:text-indigo-900:focus{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.focus\\:text-indigo-50:focus{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.focus\\:text-indigo-100:focus{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.focus\\:text-indigo-200:focus{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.focus\\:text-indigo-300:focus{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.focus\\:text-indigo-400:focus{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.focus\\:text-indigo-500:focus{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.focus\\:text-indigo-600:focus{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.focus\\:text-indigo-700:focus{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.focus\\:text-indigo-800:focus{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.focus\\:text-indigo-900:focus{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.focus\\:text-pink-50:focus{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.focus\\:text-pink-100:focus{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.focus\\:text-pink-200:focus{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.focus\\:text-pink-300:focus{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.focus\\:text-pink-400:focus{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.focus\\:text-pink-500:focus{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.focus\\:text-pink-600:focus{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.focus\\:text-pink-700:focus{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.focus\\:text-pink-800:focus{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.focus\\:text-pink-900:focus{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.focus-within\\:text-transparent:focus-within{color:#0000}.focus-within\\:text-white:focus-within{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.focus-within\\:text-black:focus-within{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.focus-within\\:text-gray-50:focus-within{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.focus-within\\:text-gray-100:focus-within{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.focus-within\\:text-gray-200:focus-within{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.focus-within\\:text-gray-300:focus-within{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.focus-within\\:text-gray-400:focus-within{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.focus-within\\:text-gray-500:focus-within{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.focus-within\\:text-gray-600:focus-within{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.focus-within\\:text-gray-700:focus-within{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.focus-within\\:text-gray-800:focus-within{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.focus-within\\:text-gray-900:focus-within{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.focus-within\\:text-cool-gray-50:focus-within{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.focus-within\\:text-cool-gray-100:focus-within{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.focus-within\\:text-cool-gray-200:focus-within{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.focus-within\\:text-cool-gray-300:focus-within{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.focus-within\\:text-cool-gray-400:focus-within{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.focus-within\\:text-cool-gray-500:focus-within{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.focus-within\\:text-cool-gray-600:focus-within{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.focus-within\\:text-cool-gray-700:focus-within{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.focus-within\\:text-cool-gray-800:focus-within{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.focus-within\\:text-cool-gray-900:focus-within{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.focus-within\\:text-red-50:focus-within{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.focus-within\\:text-red-100:focus-within{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.focus-within\\:text-red-200:focus-within{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.focus-within\\:text-red-300:focus-within{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.focus-within\\:text-red-400:focus-within{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.focus-within\\:text-red-500:focus-within{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.focus-within\\:text-red-600:focus-within{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.focus-within\\:text-red-700:focus-within{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.focus-within\\:text-red-800:focus-within{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.focus-within\\:text-red-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.focus-within\\:text-orange-50:focus-within{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.focus-within\\:text-orange-100:focus-within{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.focus-within\\:text-orange-200:focus-within{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.focus-within\\:text-orange-300:focus-within{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.focus-within\\:text-orange-400:focus-within{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.focus-within\\:text-orange-500:focus-within{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.focus-within\\:text-orange-600:focus-within{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.focus-within\\:text-orange-700:focus-within{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.focus-within\\:text-orange-800:focus-within{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.focus-within\\:text-orange-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.focus-within\\:text-yellow-50:focus-within{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.focus-within\\:text-yellow-100:focus-within{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.focus-within\\:text-yellow-200:focus-within{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.focus-within\\:text-yellow-300:focus-within{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.focus-within\\:text-yellow-400:focus-within{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.focus-within\\:text-yellow-500:focus-within{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.focus-within\\:text-yellow-600:focus-within{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.focus-within\\:text-yellow-700:focus-within{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.focus-within\\:text-yellow-800:focus-within{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.focus-within\\:text-yellow-900:focus-within{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.focus-within\\:text-green-50:focus-within{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.focus-within\\:text-green-100:focus-within{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.focus-within\\:text-green-200:focus-within{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.focus-within\\:text-green-300:focus-within{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.focus-within\\:text-green-400:focus-within{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.focus-within\\:text-green-500:focus-within{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.focus-within\\:text-green-600:focus-within{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.focus-within\\:text-green-700:focus-within{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.focus-within\\:text-green-800:focus-within{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.focus-within\\:text-green-900:focus-within{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.focus-within\\:text-teal-50:focus-within{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.focus-within\\:text-teal-100:focus-within{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.focus-within\\:text-teal-200:focus-within{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.focus-within\\:text-teal-300:focus-within{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.focus-within\\:text-teal-400:focus-within{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.focus-within\\:text-teal-500:focus-within{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.focus-within\\:text-teal-600:focus-within{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.focus-within\\:text-teal-700:focus-within{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.focus-within\\:text-teal-800:focus-within{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.focus-within\\:text-teal-900:focus-within{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.focus-within\\:text-blue-50:focus-within{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.focus-within\\:text-blue-100:focus-within{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.focus-within\\:text-blue-200:focus-within{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.focus-within\\:text-blue-300:focus-within{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.focus-within\\:text-blue-400:focus-within{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.focus-within\\:text-blue-500:focus-within{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.focus-within\\:text-blue-600:focus-within{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.focus-within\\:text-blue-700:focus-within{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.focus-within\\:text-blue-800:focus-within{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.focus-within\\:text-blue-900:focus-within{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.focus-within\\:text-pink-50:focus-within{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.focus-within\\:text-pink-100:focus-within{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.focus-within\\:text-pink-200:focus-within{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.focus-within\\:text-pink-300:focus-within{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.focus-within\\:text-pink-400:focus-within{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.focus-within\\:text-pink-500:focus-within{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.focus-within\\:text-pink-600:focus-within{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.focus-within\\:text-pink-700:focus-within{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.focus-within\\:text-pink-800:focus-within{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.focus-within\\:text-pink-900:focus-within{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.hover\\:text-transparent:hover{color:#0000}.hover\\:text-white:hover{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.hover\\:text-black:hover{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.hover\\:text-gray-50:hover{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.hover\\:text-gray-100:hover{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.hover\\:text-gray-200:hover{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.hover\\:text-gray-300:hover{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.hover\\:text-gray-400:hover{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.hover\\:text-gray-500:hover{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.hover\\:text-gray-600:hover{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.hover\\:text-gray-700:hover{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.hover\\:text-gray-800:hover{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.hover\\:text-gray-900:hover{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.hover\\:text-cool-gray-50:hover{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.hover\\:text-cool-gray-100:hover{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.hover\\:text-cool-gray-200:hover{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.hover\\:text-cool-gray-300:hover{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.hover\\:text-cool-gray-400:hover{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.hover\\:text-cool-gray-500:hover{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.hover\\:text-cool-gray-600:hover{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.hover\\:text-cool-gray-700:hover{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.hover\\:text-cool-gray-800:hover{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.hover\\:text-cool-gray-900:hover{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.hover\\:text-red-50:hover{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.hover\\:text-red-100:hover{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.hover\\:text-red-200:hover{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.hover\\:text-red-300:hover{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.hover\\:text-red-400:hover{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.hover\\:text-red-500:hover{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.hover\\:text-red-600:hover{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.hover\\:text-red-700:hover{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.hover\\:text-red-800:hover{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.hover\\:text-red-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.hover\\:text-orange-50:hover{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.hover\\:text-orange-100:hover{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.hover\\:text-orange-200:hover{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.hover\\:text-orange-300:hover{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.hover\\:text-orange-400:hover{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.hover\\:text-orange-500:hover{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.hover\\:text-orange-600:hover{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.hover\\:text-orange-700:hover{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.hover\\:text-orange-800:hover{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.hover\\:text-orange-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.hover\\:text-yellow-50:hover{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.hover\\:text-yellow-100:hover{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.hover\\:text-yellow-200:hover{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.hover\\:text-yellow-300:hover{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.hover\\:text-yellow-400:hover{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.hover\\:text-yellow-500:hover{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.hover\\:text-yellow-600:hover{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.hover\\:text-yellow-700:hover{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.hover\\:text-yellow-800:hover{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.hover\\:text-yellow-900:hover{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.hover\\:text-green-50:hover{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.hover\\:text-green-100:hover{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.hover\\:text-green-200:hover{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.hover\\:text-green-300:hover{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.hover\\:text-green-400:hover{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.hover\\:text-green-500:hover{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.hover\\:text-green-600:hover{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.hover\\:text-green-700:hover{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.hover\\:text-green-800:hover{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.hover\\:text-green-900:hover{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.hover\\:text-teal-50:hover{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.hover\\:text-teal-100:hover{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.hover\\:text-teal-200:hover{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.hover\\:text-teal-300:hover{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.hover\\:text-teal-400:hover{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.hover\\:text-teal-500:hover{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.hover\\:text-teal-600:hover{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.hover\\:text-teal-700:hover{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.hover\\:text-teal-800:hover{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.hover\\:text-teal-900:hover{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.hover\\:text-blue-50:hover{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.hover\\:text-blue-100:hover{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.hover\\:text-blue-200:hover{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.hover\\:text-blue-300:hover{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.hover\\:text-blue-400:hover{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.hover\\:text-blue-500:hover{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.hover\\:text-blue-600:hover{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.hover\\:text-blue-700:hover{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.hover\\:text-blue-800:hover{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.hover\\:text-blue-900:hover{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.hover\\:text-indigo-50:hover{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.hover\\:text-indigo-100:hover{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.hover\\:text-indigo-200:hover{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.hover\\:text-indigo-300:hover{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.hover\\:text-indigo-400:hover{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.hover\\:text-indigo-500:hover{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.hover\\:text-indigo-600:hover{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.hover\\:text-indigo-700:hover{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.hover\\:text-indigo-800:hover{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.hover\\:text-indigo-900:hover{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.hover\\:text-indigo-50:hover{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.hover\\:text-indigo-100:hover{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.hover\\:text-indigo-200:hover{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.hover\\:text-indigo-300:hover{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.hover\\:text-indigo-400:hover{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.hover\\:text-indigo-500:hover{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.hover\\:text-indigo-600:hover{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.hover\\:text-indigo-700:hover{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.hover\\:text-indigo-800:hover{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.hover\\:text-indigo-900:hover{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.hover\\:text-pink-50:hover{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.hover\\:text-pink-100:hover{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.hover\\:text-pink-200:hover{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.hover\\:text-pink-300:hover{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.hover\\:text-pink-400:hover{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.hover\\:text-pink-500:hover{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.hover\\:text-pink-600:hover{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.hover\\:text-pink-700:hover{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.hover\\:text-pink-800:hover{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.hover\\:text-pink-900:hover{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.active\\:text-transparent:active{color:#0000}.active\\:text-white:active{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.active\\:text-black:active{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.active\\:text-gray-50:active{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.active\\:text-gray-100:active{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.active\\:text-gray-200:active{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.active\\:text-gray-300:active{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.active\\:text-gray-400:active{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.active\\:text-gray-500:active{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.active\\:text-gray-600:active{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.active\\:text-gray-700:active{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.active\\:text-gray-800:active{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.active\\:text-gray-900:active{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.active\\:text-cool-gray-50:active{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.active\\:text-cool-gray-100:active{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.active\\:text-cool-gray-200:active{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.active\\:text-cool-gray-300:active{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.active\\:text-cool-gray-400:active{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.active\\:text-cool-gray-500:active{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.active\\:text-cool-gray-600:active{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.active\\:text-cool-gray-700:active{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.active\\:text-cool-gray-800:active{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.active\\:text-cool-gray-900:active{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.active\\:text-red-50:active{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.active\\:text-red-100:active{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.active\\:text-red-200:active{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.active\\:text-red-300:active{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.active\\:text-red-400:active{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.active\\:text-red-500:active{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.active\\:text-red-600:active{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.active\\:text-red-700:active{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.active\\:text-red-800:active{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.active\\:text-red-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.active\\:text-orange-50:active{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.active\\:text-orange-100:active{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.active\\:text-orange-200:active{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.active\\:text-orange-300:active{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.active\\:text-orange-400:active{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.active\\:text-orange-500:active{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.active\\:text-orange-600:active{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.active\\:text-orange-700:active{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.active\\:text-orange-800:active{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.active\\:text-orange-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.active\\:text-yellow-50:active{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.active\\:text-yellow-100:active{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.active\\:text-yellow-200:active{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.active\\:text-yellow-300:active{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.active\\:text-yellow-400:active{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.active\\:text-yellow-500:active{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.active\\:text-yellow-600:active{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.active\\:text-yellow-700:active{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.active\\:text-yellow-800:active{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.active\\:text-yellow-900:active{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.active\\:text-green-50:active{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.active\\:text-green-100:active{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.active\\:text-green-200:active{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.active\\:text-green-300:active{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.active\\:text-green-400:active{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.active\\:text-green-500:active{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.active\\:text-green-600:active{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.active\\:text-green-700:active{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.active\\:text-green-800:active{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.active\\:text-green-900:active{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.active\\:text-teal-50:active{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.active\\:text-teal-100:active{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.active\\:text-teal-200:active{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.active\\:text-teal-300:active{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.active\\:text-teal-400:active{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.active\\:text-teal-500:active{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.active\\:text-teal-600:active{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.active\\:text-teal-700:active{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.active\\:text-teal-800:active{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.active\\:text-teal-900:active{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.active\\:text-blue-50:active{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.active\\:text-blue-100:active{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.active\\:text-blue-200:active{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.active\\:text-blue-300:active{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.active\\:text-blue-400:active{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.active\\:text-blue-500:active{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.active\\:text-blue-600:active{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.active\\:text-blue-700:active{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.active\\:text-blue-800:active{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.active\\:text-blue-900:active{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.active\\:text-indigo-50:active{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.active\\:text-indigo-100:active{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.active\\:text-indigo-200:active{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.active\\:text-indigo-300:active{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.active\\:text-indigo-400:active{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.active\\:text-indigo-500:active{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.active\\:text-indigo-600:active{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.active\\:text-indigo-700:active{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.active\\:text-indigo-800:active{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.active\\:text-indigo-900:active{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.active\\:text-indigo-50:active{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.active\\:text-indigo-100:active{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.active\\:text-indigo-200:active{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.active\\:text-indigo-300:active{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.active\\:text-indigo-400:active{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.active\\:text-indigo-500:active{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.active\\:text-indigo-600:active{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.active\\:text-indigo-700:active{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.active\\:text-indigo-800:active{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.active\\:text-indigo-900:active{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.active\\:text-pink-50:active{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.active\\:text-pink-100:active{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.active\\:text-pink-200:active{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.active\\:text-pink-300:active{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.active\\:text-pink-400:active{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.active\\:text-pink-500:active{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.active\\:text-pink-600:active{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.active\\:text-pink-700:active{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.active\\:text-pink-800:active{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.active\\:text-pink-900:active{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .dark\\:text-transparent{color:#0000}.theme-dark .dark\\:text-white{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .dark\\:text-black{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .dark\\:text-gray-50{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .dark\\:text-gray-100{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .dark\\:text-gray-200{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .dark\\:text-gray-300{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .dark\\:text-gray-400{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .dark\\:text-gray-500{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .dark\\:text-gray-600{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .dark\\:text-gray-700{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .dark\\:text-gray-800{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .dark\\:text-gray-900{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .dark\\:text-cool-gray-50{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .dark\\:text-cool-gray-100{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .dark\\:text-cool-gray-200{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .dark\\:text-cool-gray-300{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .dark\\:text-cool-gray-400{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .dark\\:text-cool-gray-500{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .dark\\:text-cool-gray-600{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .dark\\:text-cool-gray-700{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .dark\\:text-cool-gray-800{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .dark\\:text-cool-gray-900{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .dark\\:text-red-50{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .dark\\:text-red-100{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .dark\\:text-red-200{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .dark\\:text-red-300{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .dark\\:text-red-400{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .dark\\:text-red-500{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .dark\\:text-red-600{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .dark\\:text-red-700{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .dark\\:text-red-800{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .dark\\:text-red-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .dark\\:text-orange-50{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .dark\\:text-orange-100{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .dark\\:text-orange-200{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .dark\\:text-orange-300{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .dark\\:text-orange-400{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .dark\\:text-orange-500{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .dark\\:text-orange-600{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .dark\\:text-orange-700{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .dark\\:text-orange-800{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .dark\\:text-orange-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .dark\\:text-yellow-50{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .dark\\:text-yellow-100{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .dark\\:text-yellow-200{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .dark\\:text-yellow-300{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .dark\\:text-yellow-400{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .dark\\:text-yellow-500{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .dark\\:text-yellow-600{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .dark\\:text-yellow-700{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .dark\\:text-yellow-800{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .dark\\:text-yellow-900{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .dark\\:text-green-50{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .dark\\:text-green-100{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .dark\\:text-green-200{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .dark\\:text-green-300{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .dark\\:text-green-400{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .dark\\:text-green-500{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .dark\\:text-green-600{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .dark\\:text-green-700{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .dark\\:text-green-800{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .dark\\:text-green-900{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .dark\\:text-teal-50{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .dark\\:text-teal-100{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .dark\\:text-teal-200{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .dark\\:text-teal-300{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .dark\\:text-teal-400{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .dark\\:text-teal-500{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .dark\\:text-teal-600{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .dark\\:text-teal-700{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .dark\\:text-teal-800{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .dark\\:text-teal-900{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .dark\\:text-blue-50{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .dark\\:text-blue-100{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .dark\\:text-blue-200{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .dark\\:text-blue-300{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .dark\\:text-blue-400{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .dark\\:text-blue-500{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .dark\\:text-blue-600{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .dark\\:text-blue-700{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .dark\\:text-blue-800{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .dark\\:text-blue-900{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .dark\\:text-indigo-50{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .dark\\:text-indigo-100{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .dark\\:text-indigo-200{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .dark\\:text-indigo-300{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .dark\\:text-indigo-400{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .dark\\:text-indigo-500{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .dark\\:text-indigo-600{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .dark\\:text-indigo-700{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .dark\\:text-indigo-800{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .dark\\:text-indigo-900{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .dark\\:text-indigo-50{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .dark\\:text-indigo-100{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .dark\\:text-indigo-200{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .dark\\:text-indigo-300{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .dark\\:text-indigo-400{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .dark\\:text-indigo-500{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .dark\\:text-indigo-600{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .dark\\:text-indigo-700{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .dark\\:text-indigo-800{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .dark\\:text-indigo-900{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .dark\\:text-pink-50{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .dark\\:text-pink-100{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .dark\\:text-pink-200{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .dark\\:text-pink-300{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .dark\\:text-pink-400{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .dark\\:text-pink-500{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .dark\\:text-pink-600{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .dark\\:text-pink-700{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .dark\\:text-pink-800{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .dark\\:text-pink-900{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-transparent:focus-within{color:#0000}.theme-dark .dark\\:focus-within\\:text-white:focus-within{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-black:focus-within{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-gray-50:focus-within{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-gray-100:focus-within{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-gray-200:focus-within{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-gray-300:focus-within{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-gray-400:focus-within{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-gray-500:focus-within{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-gray-600:focus-within{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-gray-700:focus-within{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-gray-800:focus-within{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-gray-900:focus-within{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-cool-gray-50:focus-within{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-cool-gray-100:focus-within{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-cool-gray-200:focus-within{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-cool-gray-300:focus-within{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-cool-gray-400:focus-within{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-cool-gray-500:focus-within{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-cool-gray-600:focus-within{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-cool-gray-700:focus-within{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-cool-gray-800:focus-within{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-cool-gray-900:focus-within{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-red-50:focus-within{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-red-100:focus-within{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-red-200:focus-within{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-red-300:focus-within{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-red-400:focus-within{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-red-500:focus-within{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-red-600:focus-within{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-red-700:focus-within{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-red-800:focus-within{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-red-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-orange-50:focus-within{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-orange-100:focus-within{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-orange-200:focus-within{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-orange-300:focus-within{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-orange-400:focus-within{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-orange-500:focus-within{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-orange-600:focus-within{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-orange-700:focus-within{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-orange-800:focus-within{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-orange-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-yellow-50:focus-within{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-yellow-100:focus-within{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-yellow-200:focus-within{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-yellow-300:focus-within{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-yellow-400:focus-within{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-yellow-500:focus-within{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-yellow-600:focus-within{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-yellow-700:focus-within{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-yellow-800:focus-within{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-yellow-900:focus-within{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-green-50:focus-within{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-green-100:focus-within{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-green-200:focus-within{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-green-300:focus-within{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-green-400:focus-within{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-green-500:focus-within{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-green-600:focus-within{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-green-700:focus-within{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-green-800:focus-within{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-green-900:focus-within{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-teal-50:focus-within{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-teal-100:focus-within{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-teal-200:focus-within{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-teal-300:focus-within{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-teal-400:focus-within{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-teal-500:focus-within{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-teal-600:focus-within{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-teal-700:focus-within{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-teal-800:focus-within{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-teal-900:focus-within{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-blue-50:focus-within{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-blue-100:focus-within{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-blue-200:focus-within{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-blue-300:focus-within{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-blue-400:focus-within{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-blue-500:focus-within{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-blue-600:focus-within{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-blue-700:focus-within{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-blue-800:focus-within{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-blue-900:focus-within{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-pink-50:focus-within{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-pink-100:focus-within{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-pink-200:focus-within{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-pink-300:focus-within{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-pink-400:focus-within{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-pink-500:focus-within{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-pink-600:focus-within{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-pink-700:focus-within{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-pink-800:focus-within{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .dark\\:focus-within\\:text-pink-900:focus-within{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-transparent:hover{color:#0000}.theme-dark .dark\\:hover\\:text-white:hover{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-black:hover{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-gray-50:hover{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-gray-100:hover{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-gray-200:hover{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-gray-300:hover{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-gray-400:hover{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-gray-500:hover{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-gray-600:hover{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-gray-700:hover{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-gray-800:hover{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-gray-900:hover{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-cool-gray-50:hover{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-cool-gray-100:hover{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-cool-gray-200:hover{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-cool-gray-300:hover{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-cool-gray-400:hover{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-cool-gray-500:hover{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-cool-gray-600:hover{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-cool-gray-700:hover{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-cool-gray-800:hover{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-cool-gray-900:hover{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-red-50:hover{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-red-100:hover{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-red-200:hover{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-red-300:hover{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-red-400:hover{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-red-500:hover{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-red-600:hover{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-red-700:hover{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-red-800:hover{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-red-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-orange-50:hover{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-orange-100:hover{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-orange-200:hover{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-orange-300:hover{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-orange-400:hover{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-orange-500:hover{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-orange-600:hover{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-orange-700:hover{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-orange-800:hover{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-orange-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-yellow-50:hover{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-yellow-100:hover{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-yellow-200:hover{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-yellow-300:hover{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-yellow-400:hover{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-yellow-500:hover{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-yellow-600:hover{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-yellow-700:hover{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-yellow-800:hover{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-yellow-900:hover{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-green-50:hover{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-green-100:hover{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-green-200:hover{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-green-300:hover{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-green-400:hover{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-green-500:hover{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-green-600:hover{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-green-700:hover{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-green-800:hover{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-green-900:hover{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-teal-50:hover{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-teal-100:hover{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-teal-200:hover{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-teal-300:hover{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-teal-400:hover{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-teal-500:hover{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-teal-600:hover{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-teal-700:hover{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-teal-800:hover{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-teal-900:hover{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-blue-50:hover{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-blue-100:hover{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-blue-200:hover{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-blue-300:hover{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-blue-400:hover{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-blue-500:hover{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-blue-600:hover{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-blue-700:hover{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-blue-800:hover{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-blue-900:hover{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-pink-50:hover{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-pink-100:hover{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-pink-200:hover{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-pink-300:hover{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-pink-400:hover{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-pink-500:hover{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-pink-600:hover{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-pink-700:hover{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-pink-800:hover{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .dark\\:hover\\:text-pink-900:hover{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .dark\\:active\\:text-transparent:active{color:#0000}.theme-dark .dark\\:active\\:text-white:active{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .dark\\:active\\:text-black:active{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .dark\\:active\\:text-gray-50:active{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .dark\\:active\\:text-gray-100:active{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .dark\\:active\\:text-gray-200:active{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .dark\\:active\\:text-gray-300:active{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .dark\\:active\\:text-gray-400:active{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .dark\\:active\\:text-gray-500:active{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .dark\\:active\\:text-gray-600:active{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .dark\\:active\\:text-gray-700:active{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .dark\\:active\\:text-gray-800:active{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .dark\\:active\\:text-gray-900:active{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .dark\\:active\\:text-cool-gray-50:active{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .dark\\:active\\:text-cool-gray-100:active{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .dark\\:active\\:text-cool-gray-200:active{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .dark\\:active\\:text-cool-gray-300:active{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .dark\\:active\\:text-cool-gray-400:active{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .dark\\:active\\:text-cool-gray-500:active{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .dark\\:active\\:text-cool-gray-600:active{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .dark\\:active\\:text-cool-gray-700:active{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .dark\\:active\\:text-cool-gray-800:active{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .dark\\:active\\:text-cool-gray-900:active{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .dark\\:active\\:text-red-50:active{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .dark\\:active\\:text-red-100:active{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .dark\\:active\\:text-red-200:active{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .dark\\:active\\:text-red-300:active{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .dark\\:active\\:text-red-400:active{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .dark\\:active\\:text-red-500:active{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .dark\\:active\\:text-red-600:active{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .dark\\:active\\:text-red-700:active{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .dark\\:active\\:text-red-800:active{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .dark\\:active\\:text-red-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .dark\\:active\\:text-orange-50:active{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .dark\\:active\\:text-orange-100:active{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .dark\\:active\\:text-orange-200:active{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .dark\\:active\\:text-orange-300:active{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .dark\\:active\\:text-orange-400:active{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .dark\\:active\\:text-orange-500:active{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .dark\\:active\\:text-orange-600:active{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .dark\\:active\\:text-orange-700:active{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .dark\\:active\\:text-orange-800:active{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .dark\\:active\\:text-orange-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .dark\\:active\\:text-yellow-50:active{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .dark\\:active\\:text-yellow-100:active{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .dark\\:active\\:text-yellow-200:active{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .dark\\:active\\:text-yellow-300:active{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .dark\\:active\\:text-yellow-400:active{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .dark\\:active\\:text-yellow-500:active{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .dark\\:active\\:text-yellow-600:active{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .dark\\:active\\:text-yellow-700:active{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .dark\\:active\\:text-yellow-800:active{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .dark\\:active\\:text-yellow-900:active{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .dark\\:active\\:text-green-50:active{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .dark\\:active\\:text-green-100:active{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .dark\\:active\\:text-green-200:active{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .dark\\:active\\:text-green-300:active{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .dark\\:active\\:text-green-400:active{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .dark\\:active\\:text-green-500:active{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .dark\\:active\\:text-green-600:active{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .dark\\:active\\:text-green-700:active{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .dark\\:active\\:text-green-800:active{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .dark\\:active\\:text-green-900:active{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .dark\\:active\\:text-teal-50:active{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .dark\\:active\\:text-teal-100:active{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .dark\\:active\\:text-teal-200:active{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .dark\\:active\\:text-teal-300:active{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .dark\\:active\\:text-teal-400:active{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .dark\\:active\\:text-teal-500:active{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .dark\\:active\\:text-teal-600:active{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .dark\\:active\\:text-teal-700:active{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .dark\\:active\\:text-teal-800:active{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .dark\\:active\\:text-teal-900:active{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .dark\\:active\\:text-blue-50:active{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .dark\\:active\\:text-blue-100:active{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .dark\\:active\\:text-blue-200:active{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .dark\\:active\\:text-blue-300:active{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .dark\\:active\\:text-blue-400:active{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .dark\\:active\\:text-blue-500:active{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .dark\\:active\\:text-blue-600:active{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .dark\\:active\\:text-blue-700:active{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .dark\\:active\\:text-blue-800:active{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .dark\\:active\\:text-blue-900:active{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-100:active{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-200:active{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-300:active{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-400:active{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-500:active{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-600:active{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-700:active{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-800:active{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-900:active{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-100:active{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-200:active{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-300:active{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-400:active{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-500:active{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-600:active{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-700:active{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-800:active{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .dark\\:active\\:text-indigo-900:active{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .dark\\:active\\:text-pink-50:active{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .dark\\:active\\:text-pink-100:active{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .dark\\:active\\:text-pink-200:active{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .dark\\:active\\:text-pink-300:active{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .dark\\:active\\:text-pink-400:active{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .dark\\:active\\:text-pink-500:active{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .dark\\:active\\:text-pink-600:active{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .dark\\:active\\:text-pink-700:active{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .dark\\:active\\:text-pink-800:active{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .dark\\:active\\:text-pink-900:active{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.text-opacity-0{--text-opacity:0}.text-opacity-25{--text-opacity:0.25}.text-opacity-50{--text-opacity:0.5}.text-opacity-75{--text-opacity:0.75}.text-opacity-100{--text-opacity:1}.hover\\:text-opacity-0:hover{--text-opacity:0}.hover\\:text-opacity-25:hover{--text-opacity:0.25}.hover\\:text-opacity-50:hover{--text-opacity:0.5}.hover\\:text-opacity-75:hover{--text-opacity:0.75}.hover\\:text-opacity-100:hover{--text-opacity:1}.focus\\:text-opacity-0:focus{--text-opacity:0}.focus\\:text-opacity-25:focus{--text-opacity:0.25}.focus\\:text-opacity-50:focus{--text-opacity:0.5}.focus\\:text-opacity-75:focus{--text-opacity:0.75}.focus\\:text-opacity-100:focus{--text-opacity:1}.italic{font-style:italic}.not-italic{font-style:normal}.uppercase{text-transform:uppercase}.lowercase{text-transform:lowercase}.capitalize{text-transform:capitalize}.normal-case{text-transform:none}.underline{-webkit-text-decoration:underline;text-decoration:underline}.line-through{-webkit-text-decoration:line-through;text-decoration:line-through}.no-underline{-webkit-text-decoration:none;text-decoration:none}.hover\\:underline:hover{-webkit-text-decoration:underline;text-decoration:underline}.hover\\:line-through:hover{-webkit-text-decoration:line-through;text-decoration:line-through}.hover\\:no-underline:hover{-webkit-text-decoration:none;text-decoration:none}.focus\\:underline:focus{-webkit-text-decoration:underline;text-decoration:underline}.focus\\:line-through:focus{-webkit-text-decoration:line-through;text-decoration:line-through}.focus\\:no-underline:focus{-webkit-text-decoration:none;text-decoration:none}.antialiased{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.subpixel-antialiased{-webkit-font-smoothing:auto;-moz-osx-font-smoothing:auto}.tracking-tighter{letter-spacing:-.05em}.tracking-tight{letter-spacing:-.025em}.tracking-normal{letter-spacing:0}.tracking-wide{letter-spacing:.025em}.tracking-wider{letter-spacing:.05em}.tracking-widest{letter-spacing:.1em}.select-none{-webkit-user-select:none;user-select:none}.select-text{-webkit-user-select:text;user-select:text}.select-all{-webkit-user-select:all;user-select:all}.select-auto{-webkit-user-select:auto;user-select:auto}.align-baseline{vertical-align:initial}.align-top{vertical-align:top}.align-middle{vertical-align:middle}.align-bottom{vertical-align:bottom}.align-text-top{vertical-align:text-top}.align-text-bottom{vertical-align:text-bottom}.visible{visibility:visible}.invisible{visibility:hidden}.whitespace-normal{white-space:normal}.whitespace-no-wrap{white-space:nowrap}.whitespace-pre{white-space:pre}.whitespace-pre-line{white-space:pre-line}.whitespace-pre-wrap{white-space:pre-wrap}.break-normal{overflow-wrap:normal;word-break:normal}.break-words{overflow-wrap:break-word}.break-all{word-break:break-all}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.w-0{width:0}.w-1{width:.25rem}.w-2{width:.5rem}.w-3{width:.75rem}.w-4{width:1rem}.w-5{width:1.25rem}.w-6{width:1.5rem}.w-8{width:2rem}.w-10{width:2.5rem}.w-12{width:3rem}.w-16{width:4rem}.w-20{width:5rem}.w-24{width:6rem}.w-32{width:8rem}.w-40{width:10rem}.w-48{width:12rem}.w-56{width:14rem}.w-64{width:16rem}.w-auto{width:auto}.w-px{width:1px}.w-1\\/2{width:50%}.w-1\\/3{width:33.333333%}.w-2\\/3{width:66.666667%}.w-1\\/4{width:25%}.w-2\\/4{width:50%}.w-3\\/4{width:75%}.w-1\\/5{width:20%}.w-2\\/5{width:40%}.w-3\\/5{width:60%}.w-4\\/5{width:80%}.w-1\\/6{width:16.666667%}.w-2\\/6{width:33.333333%}.w-3\\/6{width:50%}.w-4\\/6{width:66.666667%}.w-5\\/6{width:83.333333%}.w-1\\/12{width:8.333333%}.w-2\\/12{width:16.666667%}.w-3\\/12{width:25%}.w-4\\/12{width:33.333333%}.w-5\\/12{width:41.666667%}.w-6\\/12{width:50%}.w-7\\/12{width:58.333333%}.w-8\\/12{width:66.666667%}.w-9\\/12{width:75%}.w-10\\/12{width:83.333333%}.w-11\\/12{width:91.666667%}.w-full{width:100%}.w-screen{width:100vw}.z-0{z-index:0}.z-10{z-index:10}.z-20{z-index:20}.z-30{z-index:30}.z-40{z-index:40}.z-50{z-index:50}.z-auto{z-index:auto}.gap-0{grid-gap:0;gap:0}.gap-1{grid-gap:.25rem;gap:.25rem}.gap-2{grid-gap:.5rem;gap:.5rem}.gap-3{grid-gap:.75rem;gap:.75rem}.gap-4{grid-gap:1rem;gap:1rem}.gap-5{grid-gap:1.25rem;gap:1.25rem}.gap-6{grid-gap:1.5rem;gap:1.5rem}.gap-8{grid-gap:2rem;gap:2rem}.gap-10{grid-gap:2.5rem;gap:2.5rem}.gap-12{grid-gap:3rem;gap:3rem}.gap-16{grid-gap:4rem;gap:4rem}.gap-20{grid-gap:5rem;gap:5rem}.gap-24{grid-gap:6rem;gap:6rem}.gap-32{grid-gap:8rem;gap:8rem}.gap-40{grid-gap:10rem;gap:10rem}.gap-48{grid-gap:12rem;gap:12rem}.gap-56{grid-gap:14rem;gap:14rem}.gap-64{grid-gap:16rem;gap:16rem}.gap-px{grid-gap:1px;gap:1px}.col-gap-0{grid-column-gap:0;column-gap:0}.col-gap-1{grid-column-gap:.25rem;column-gap:.25rem}.col-gap-2{grid-column-gap:.5rem;column-gap:.5rem}.col-gap-3{grid-column-gap:.75rem;column-gap:.75rem}.col-gap-4{grid-column-gap:1rem;column-gap:1rem}.col-gap-5{grid-column-gap:1.25rem;column-gap:1.25rem}.col-gap-6{grid-column-gap:1.5rem;column-gap:1.5rem}.col-gap-8{grid-column-gap:2rem;column-gap:2rem}.col-gap-10{grid-column-gap:2.5rem;column-gap:2.5rem}.col-gap-12{grid-column-gap:3rem;column-gap:3rem}.col-gap-16{grid-column-gap:4rem;column-gap:4rem}.col-gap-20{grid-column-gap:5rem;column-gap:5rem}.col-gap-24{grid-column-gap:6rem;column-gap:6rem}.col-gap-32{grid-column-gap:8rem;column-gap:8rem}.col-gap-40{grid-column-gap:10rem;column-gap:10rem}.col-gap-48{grid-column-gap:12rem;column-gap:12rem}.col-gap-56{grid-column-gap:14rem;column-gap:14rem}.col-gap-64{grid-column-gap:16rem;column-gap:16rem}.col-gap-px{grid-column-gap:1px;column-gap:1px}.row-gap-0{grid-row-gap:0;row-gap:0}.row-gap-1{grid-row-gap:.25rem;row-gap:.25rem}.row-gap-2{grid-row-gap:.5rem;row-gap:.5rem}.row-gap-3{grid-row-gap:.75rem;row-gap:.75rem}.row-gap-4{grid-row-gap:1rem;row-gap:1rem}.row-gap-5{grid-row-gap:1.25rem;row-gap:1.25rem}.row-gap-6{grid-row-gap:1.5rem;row-gap:1.5rem}.row-gap-8{grid-row-gap:2rem;row-gap:2rem}.row-gap-10{grid-row-gap:2.5rem;row-gap:2.5rem}.row-gap-12{grid-row-gap:3rem;row-gap:3rem}.row-gap-16{grid-row-gap:4rem;row-gap:4rem}.row-gap-20{grid-row-gap:5rem;row-gap:5rem}.row-gap-24{grid-row-gap:6rem;row-gap:6rem}.row-gap-32{grid-row-gap:8rem;row-gap:8rem}.row-gap-40{grid-row-gap:10rem;row-gap:10rem}.row-gap-48{grid-row-gap:12rem;row-gap:12rem}.row-gap-56{grid-row-gap:14rem;row-gap:14rem}.row-gap-64{grid-row-gap:16rem;row-gap:16rem}.row-gap-px{grid-row-gap:1px;row-gap:1px}.grid-flow-row{grid-auto-flow:row}.grid-flow-col{grid-auto-flow:column}.grid-flow-row-dense{grid-auto-flow:row dense}.grid-flow-col-dense{grid-auto-flow:column dense}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.grid-cols-5{grid-template-columns:repeat(5,minmax(0,1fr))}.grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.grid-cols-7{grid-template-columns:repeat(7,minmax(0,1fr))}.grid-cols-8{grid-template-columns:repeat(8,minmax(0,1fr))}.grid-cols-9{grid-template-columns:repeat(9,minmax(0,1fr))}.grid-cols-10{grid-template-columns:repeat(10,minmax(0,1fr))}.grid-cols-11{grid-template-columns:repeat(11,minmax(0,1fr))}.grid-cols-12{grid-template-columns:repeat(12,minmax(0,1fr))}.grid-cols-none{grid-template-columns:none}.col-auto{grid-column:auto}.col-span-1{grid-column:span 1/span 1}.col-span-2{grid-column:span 2/span 2}.col-span-3{grid-column:span 3/span 3}.col-span-4{grid-column:span 4/span 4}.col-span-5{grid-column:span 5/span 5}.col-span-6{grid-column:span 6/span 6}.col-span-7{grid-column:span 7/span 7}.col-span-8{grid-column:span 8/span 8}.col-span-9{grid-column:span 9/span 9}.col-span-10{grid-column:span 10/span 10}.col-span-11{grid-column:span 11/span 11}.col-span-12{grid-column:span 12/span 12}.col-start-1{grid-column-start:1}.col-start-2{grid-column-start:2}.col-start-3{grid-column-start:3}.col-start-4{grid-column-start:4}.col-start-5{grid-column-start:5}.col-start-6{grid-column-start:6}.col-start-7{grid-column-start:7}.col-start-8{grid-column-start:8}.col-start-9{grid-column-start:9}.col-start-10{grid-column-start:10}.col-start-11{grid-column-start:11}.col-start-12{grid-column-start:12}.col-start-13{grid-column-start:13}.col-start-auto{grid-column-start:auto}.col-end-1{grid-column-end:1}.col-end-2{grid-column-end:2}.col-end-3{grid-column-end:3}.col-end-4{grid-column-end:4}.col-end-5{grid-column-end:5}.col-end-6{grid-column-end:6}.col-end-7{grid-column-end:7}.col-end-8{grid-column-end:8}.col-end-9{grid-column-end:9}.col-end-10{grid-column-end:10}.col-end-11{grid-column-end:11}.col-end-12{grid-column-end:12}.col-end-13{grid-column-end:13}.col-end-auto{grid-column-end:auto}.grid-rows-1{grid-template-rows:repeat(1,minmax(0,1fr))}.grid-rows-2{grid-template-rows:repeat(2,minmax(0,1fr))}.grid-rows-3{grid-template-rows:repeat(3,minmax(0,1fr))}.grid-rows-4{grid-template-rows:repeat(4,minmax(0,1fr))}.grid-rows-5{grid-template-rows:repeat(5,minmax(0,1fr))}.grid-rows-6{grid-template-rows:repeat(6,minmax(0,1fr))}.grid-rows-none{grid-template-rows:none}.row-auto{grid-row:auto}.row-span-1{grid-row:span 1/span 1}.row-span-2{grid-row:span 2/span 2}.row-span-3{grid-row:span 3/span 3}.row-span-4{grid-row:span 4/span 4}.row-span-5{grid-row:span 5/span 5}.row-span-6{grid-row:span 6/span 6}.row-start-1{grid-row-start:1}.row-start-2{grid-row-start:2}.row-start-3{grid-row-start:3}.row-start-4{grid-row-start:4}.row-start-5{grid-row-start:5}.row-start-6{grid-row-start:6}.row-start-7{grid-row-start:7}.row-start-auto{grid-row-start:auto}.row-end-1{grid-row-end:1}.row-end-2{grid-row-end:2}.row-end-3{grid-row-end:3}.row-end-4{grid-row-end:4}.row-end-5{grid-row-end:5}.row-end-6{grid-row-end:6}.row-end-7{grid-row-end:7}.row-end-auto{grid-row-end:auto}.transform{--transform-translate-x:0;--transform-translate-y:0;--transform-rotate:0;--transform-skew-x:0;--transform-skew-y:0;--transform-scale-x:1;--transform-scale-y:1;transform:translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y))}.transform-none{transform:none}.origin-center{transform-origin:center}.origin-top{transform-origin:top}.origin-top-right{transform-origin:top right}.origin-right{transform-origin:right}.origin-bottom-right{transform-origin:bottom right}.origin-bottom{transform-origin:bottom}.origin-bottom-left{transform-origin:bottom left}.origin-left{transform-origin:left}.origin-top-left{transform-origin:top left}.scale-0{--transform-scale-x:0;--transform-scale-y:0}.scale-50{--transform-scale-x:.5;--transform-scale-y:.5}.scale-75{--transform-scale-x:.75;--transform-scale-y:.75}.scale-90{--transform-scale-x:.9;--transform-scale-y:.9}.scale-95{--transform-scale-x:.95;--transform-scale-y:.95}.scale-100{--transform-scale-x:1;--transform-scale-y:1}.scale-105{--transform-scale-x:1.05;--transform-scale-y:1.05}.scale-110{--transform-scale-x:1.1;--transform-scale-y:1.1}.scale-125{--transform-scale-x:1.25;--transform-scale-y:1.25}.scale-150{--transform-scale-x:1.5;--transform-scale-y:1.5}.scale-x-0{--transform-scale-x:0}.scale-x-50{--transform-scale-x:.5}.scale-x-75{--transform-scale-x:.75}.scale-x-90{--transform-scale-x:.9}.scale-x-95{--transform-scale-x:.95}.scale-x-100{--transform-scale-x:1}.scale-x-105{--transform-scale-x:1.05}.scale-x-110{--transform-scale-x:1.1}.scale-x-125{--transform-scale-x:1.25}.scale-x-150{--transform-scale-x:1.5}.scale-y-0{--transform-scale-y:0}.scale-y-50{--transform-scale-y:.5}.scale-y-75{--transform-scale-y:.75}.scale-y-90{--transform-scale-y:.9}.scale-y-95{--transform-scale-y:.95}.scale-y-100{--transform-scale-y:1}.scale-y-105{--transform-scale-y:1.05}.scale-y-110{--transform-scale-y:1.1}.scale-y-125{--transform-scale-y:1.25}.scale-y-150{--transform-scale-y:1.5}.hover\\:scale-0:hover{--transform-scale-x:0;--transform-scale-y:0}.hover\\:scale-50:hover{--transform-scale-x:.5;--transform-scale-y:.5}.hover\\:scale-75:hover{--transform-scale-x:.75;--transform-scale-y:.75}.hover\\:scale-90:hover{--transform-scale-x:.9;--transform-scale-y:.9}.hover\\:scale-95:hover{--transform-scale-x:.95;--transform-scale-y:.95}.hover\\:scale-100:hover{--transform-scale-x:1;--transform-scale-y:1}.hover\\:scale-105:hover{--transform-scale-x:1.05;--transform-scale-y:1.05}.hover\\:scale-110:hover{--transform-scale-x:1.1;--transform-scale-y:1.1}.hover\\:scale-125:hover{--transform-scale-x:1.25;--transform-scale-y:1.25}.hover\\:scale-150:hover{--transform-scale-x:1.5;--transform-scale-y:1.5}.hover\\:scale-x-0:hover{--transform-scale-x:0}.hover\\:scale-x-50:hover{--transform-scale-x:.5}.hover\\:scale-x-75:hover{--transform-scale-x:.75}.hover\\:scale-x-90:hover{--transform-scale-x:.9}.hover\\:scale-x-95:hover{--transform-scale-x:.95}.hover\\:scale-x-100:hover{--transform-scale-x:1}.hover\\:scale-x-105:hover{--transform-scale-x:1.05}.hover\\:scale-x-110:hover{--transform-scale-x:1.1}.hover\\:scale-x-125:hover{--transform-scale-x:1.25}.hover\\:scale-x-150:hover{--transform-scale-x:1.5}.hover\\:scale-y-0:hover{--transform-scale-y:0}.hover\\:scale-y-50:hover{--transform-scale-y:.5}.hover\\:scale-y-75:hover{--transform-scale-y:.75}.hover\\:scale-y-90:hover{--transform-scale-y:.9}.hover\\:scale-y-95:hover{--transform-scale-y:.95}.hover\\:scale-y-100:hover{--transform-scale-y:1}.hover\\:scale-y-105:hover{--transform-scale-y:1.05}.hover\\:scale-y-110:hover{--transform-scale-y:1.1}.hover\\:scale-y-125:hover{--transform-scale-y:1.25}.hover\\:scale-y-150:hover{--transform-scale-y:1.5}.focus\\:scale-0:focus{--transform-scale-x:0;--transform-scale-y:0}.focus\\:scale-50:focus{--transform-scale-x:.5;--transform-scale-y:.5}.focus\\:scale-75:focus{--transform-scale-x:.75;--transform-scale-y:.75}.focus\\:scale-90:focus{--transform-scale-x:.9;--transform-scale-y:.9}.focus\\:scale-95:focus{--transform-scale-x:.95;--transform-scale-y:.95}.focus\\:scale-100:focus{--transform-scale-x:1;--transform-scale-y:1}.focus\\:scale-105:focus{--transform-scale-x:1.05;--transform-scale-y:1.05}.focus\\:scale-110:focus{--transform-scale-x:1.1;--transform-scale-y:1.1}.focus\\:scale-125:focus{--transform-scale-x:1.25;--transform-scale-y:1.25}.focus\\:scale-150:focus{--transform-scale-x:1.5;--transform-scale-y:1.5}.focus\\:scale-x-0:focus{--transform-scale-x:0}.focus\\:scale-x-50:focus{--transform-scale-x:.5}.focus\\:scale-x-75:focus{--transform-scale-x:.75}.focus\\:scale-x-90:focus{--transform-scale-x:.9}.focus\\:scale-x-95:focus{--transform-scale-x:.95}.focus\\:scale-x-100:focus{--transform-scale-x:1}.focus\\:scale-x-105:focus{--transform-scale-x:1.05}.focus\\:scale-x-110:focus{--transform-scale-x:1.1}.focus\\:scale-x-125:focus{--transform-scale-x:1.25}.focus\\:scale-x-150:focus{--transform-scale-x:1.5}.focus\\:scale-y-0:focus{--transform-scale-y:0}.focus\\:scale-y-50:focus{--transform-scale-y:.5}.focus\\:scale-y-75:focus{--transform-scale-y:.75}.focus\\:scale-y-90:focus{--transform-scale-y:.9}.focus\\:scale-y-95:focus{--transform-scale-y:.95}.focus\\:scale-y-100:focus{--transform-scale-y:1}.focus\\:scale-y-105:focus{--transform-scale-y:1.05}.focus\\:scale-y-110:focus{--transform-scale-y:1.1}.focus\\:scale-y-125:focus{--transform-scale-y:1.25}.focus\\:scale-y-150:focus{--transform-scale-y:1.5}.rotate-0{--transform-rotate:0}.rotate-45{--transform-rotate:45deg}.rotate-90{--transform-rotate:90deg}.rotate-180{--transform-rotate:180deg}.-rotate-180{--transform-rotate:-180deg}.-rotate-90{--transform-rotate:-90deg}.-rotate-45{--transform-rotate:-45deg}.hover\\:rotate-0:hover{--transform-rotate:0}.hover\\:rotate-45:hover{--transform-rotate:45deg}.hover\\:rotate-90:hover{--transform-rotate:90deg}.hover\\:rotate-180:hover{--transform-rotate:180deg}.hover\\:-rotate-180:hover{--transform-rotate:-180deg}.hover\\:-rotate-90:hover{--transform-rotate:-90deg}.hover\\:-rotate-45:hover{--transform-rotate:-45deg}.focus\\:rotate-0:focus{--transform-rotate:0}.focus\\:rotate-45:focus{--transform-rotate:45deg}.focus\\:rotate-90:focus{--transform-rotate:90deg}.focus\\:rotate-180:focus{--transform-rotate:180deg}.focus\\:-rotate-180:focus{--transform-rotate:-180deg}.focus\\:-rotate-90:focus{--transform-rotate:-90deg}.focus\\:-rotate-45:focus{--transform-rotate:-45deg}.translate-x-0{--transform-translate-x:0}.translate-x-1{--transform-translate-x:0.25rem}.translate-x-2{--transform-translate-x:0.5rem}.translate-x-3{--transform-translate-x:0.75rem}.translate-x-4{--transform-translate-x:1rem}.translate-x-5{--transform-translate-x:1.25rem}.translate-x-6{--transform-translate-x:1.5rem}.translate-x-8{--transform-translate-x:2rem}.translate-x-10{--transform-translate-x:2.5rem}.translate-x-12{--transform-translate-x:3rem}.translate-x-16{--transform-translate-x:4rem}.translate-x-20{--transform-translate-x:5rem}.translate-x-24{--transform-translate-x:6rem}.translate-x-32{--transform-translate-x:8rem}.translate-x-40{--transform-translate-x:10rem}.translate-x-48{--transform-translate-x:12rem}.translate-x-56{--transform-translate-x:14rem}.translate-x-64{--transform-translate-x:16rem}.translate-x-px{--transform-translate-x:1px}.-translate-x-1{--transform-translate-x:-0.25rem}.-translate-x-2{--transform-translate-x:-0.5rem}.-translate-x-3{--transform-translate-x:-0.75rem}.-translate-x-4{--transform-translate-x:-1rem}.-translate-x-5{--transform-translate-x:-1.25rem}.-translate-x-6{--transform-translate-x:-1.5rem}.-translate-x-8{--transform-translate-x:-2rem}.-translate-x-10{--transform-translate-x:-2.5rem}.-translate-x-12{--transform-translate-x:-3rem}.-translate-x-16{--transform-translate-x:-4rem}.-translate-x-20{--transform-translate-x:-5rem}.-translate-x-24{--transform-translate-x:-6rem}.-translate-x-32{--transform-translate-x:-8rem}.-translate-x-40{--transform-translate-x:-10rem}.-translate-x-48{--transform-translate-x:-12rem}.-translate-x-56{--transform-translate-x:-14rem}.-translate-x-64{--transform-translate-x:-16rem}.-translate-x-px{--transform-translate-x:-1px}.-translate-x-full{--transform-translate-x:-100%}.-translate-x-1\\/2{--transform-translate-x:-50%}.translate-x-1\\/2{--transform-translate-x:50%}.translate-x-full{--transform-translate-x:100%}.translate-y-0{--transform-translate-y:0}.translate-y-1{--transform-translate-y:0.25rem}.translate-y-2{--transform-translate-y:0.5rem}.translate-y-3{--transform-translate-y:0.75rem}.translate-y-4{--transform-translate-y:1rem}.translate-y-5{--transform-translate-y:1.25rem}.translate-y-6{--transform-translate-y:1.5rem}.translate-y-8{--transform-translate-y:2rem}.translate-y-10{--transform-translate-y:2.5rem}.translate-y-12{--transform-translate-y:3rem}.translate-y-16{--transform-translate-y:4rem}.translate-y-20{--transform-translate-y:5rem}.translate-y-24{--transform-translate-y:6rem}.translate-y-32{--transform-translate-y:8rem}.translate-y-40{--transform-translate-y:10rem}.translate-y-48{--transform-translate-y:12rem}.translate-y-56{--transform-translate-y:14rem}.translate-y-64{--transform-translate-y:16rem}.translate-y-px{--transform-translate-y:1px}.-translate-y-1{--transform-translate-y:-0.25rem}.-translate-y-2{--transform-translate-y:-0.5rem}.-translate-y-3{--transform-translate-y:-0.75rem}.-translate-y-4{--transform-translate-y:-1rem}.-translate-y-5{--transform-translate-y:-1.25rem}.-translate-y-6{--transform-translate-y:-1.5rem}.-translate-y-8{--transform-translate-y:-2rem}.-translate-y-10{--transform-translate-y:-2.5rem}.-translate-y-12{--transform-translate-y:-3rem}.-translate-y-16{--transform-translate-y:-4rem}.-translate-y-20{--transform-translate-y:-5rem}.-translate-y-24{--transform-translate-y:-6rem}.-translate-y-32{--transform-translate-y:-8rem}.-translate-y-40{--transform-translate-y:-10rem}.-translate-y-48{--transform-translate-y:-12rem}.-translate-y-56{--transform-translate-y:-14rem}.-translate-y-64{--transform-translate-y:-16rem}.-translate-y-px{--transform-translate-y:-1px}.-translate-y-full{--transform-translate-y:-100%}.-translate-y-1\\/2{--transform-translate-y:-50%}.translate-y-1\\/2{--transform-translate-y:50%}.translate-y-full{--transform-translate-y:100%}.hover\\:translate-x-0:hover{--transform-translate-x:0}.hover\\:translate-x-1:hover{--transform-translate-x:0.25rem}.hover\\:translate-x-2:hover{--transform-translate-x:0.5rem}.hover\\:translate-x-3:hover{--transform-translate-x:0.75rem}.hover\\:translate-x-4:hover{--transform-translate-x:1rem}.hover\\:translate-x-5:hover{--transform-translate-x:1.25rem}.hover\\:translate-x-6:hover{--transform-translate-x:1.5rem}.hover\\:translate-x-8:hover{--transform-translate-x:2rem}.hover\\:translate-x-10:hover{--transform-translate-x:2.5rem}.hover\\:translate-x-12:hover{--transform-translate-x:3rem}.hover\\:translate-x-16:hover{--transform-translate-x:4rem}.hover\\:translate-x-20:hover{--transform-translate-x:5rem}.hover\\:translate-x-24:hover{--transform-translate-x:6rem}.hover\\:translate-x-32:hover{--transform-translate-x:8rem}.hover\\:translate-x-40:hover{--transform-translate-x:10rem}.hover\\:translate-x-48:hover{--transform-translate-x:12rem}.hover\\:translate-x-56:hover{--transform-translate-x:14rem}.hover\\:translate-x-64:hover{--transform-translate-x:16rem}.hover\\:translate-x-px:hover{--transform-translate-x:1px}.hover\\:-translate-x-1:hover{--transform-translate-x:-0.25rem}.hover\\:-translate-x-2:hover{--transform-translate-x:-0.5rem}.hover\\:-translate-x-3:hover{--transform-translate-x:-0.75rem}.hover\\:-translate-x-4:hover{--transform-translate-x:-1rem}.hover\\:-translate-x-5:hover{--transform-translate-x:-1.25rem}.hover\\:-translate-x-6:hover{--transform-translate-x:-1.5rem}.hover\\:-translate-x-8:hover{--transform-translate-x:-2rem}.hover\\:-translate-x-10:hover{--transform-translate-x:-2.5rem}.hover\\:-translate-x-12:hover{--transform-translate-x:-3rem}.hover\\:-translate-x-16:hover{--transform-translate-x:-4rem}.hover\\:-translate-x-20:hover{--transform-translate-x:-5rem}.hover\\:-translate-x-24:hover{--transform-translate-x:-6rem}.hover\\:-translate-x-32:hover{--transform-translate-x:-8rem}.hover\\:-translate-x-40:hover{--transform-translate-x:-10rem}.hover\\:-translate-x-48:hover{--transform-translate-x:-12rem}.hover\\:-translate-x-56:hover{--transform-translate-x:-14rem}.hover\\:-translate-x-64:hover{--transform-translate-x:-16rem}.hover\\:-translate-x-px:hover{--transform-translate-x:-1px}.hover\\:-translate-x-full:hover{--transform-translate-x:-100%}.hover\\:-translate-x-1\\/2:hover{--transform-translate-x:-50%}.hover\\:translate-x-1\\/2:hover{--transform-translate-x:50%}.hover\\:translate-x-full:hover{--transform-translate-x:100%}.hover\\:translate-y-0:hover{--transform-translate-y:0}.hover\\:translate-y-1:hover{--transform-translate-y:0.25rem}.hover\\:translate-y-2:hover{--transform-translate-y:0.5rem}.hover\\:translate-y-3:hover{--transform-translate-y:0.75rem}.hover\\:translate-y-4:hover{--transform-translate-y:1rem}.hover\\:translate-y-5:hover{--transform-translate-y:1.25rem}.hover\\:translate-y-6:hover{--transform-translate-y:1.5rem}.hover\\:translate-y-8:hover{--transform-translate-y:2rem}.hover\\:translate-y-10:hover{--transform-translate-y:2.5rem}.hover\\:translate-y-12:hover{--transform-translate-y:3rem}.hover\\:translate-y-16:hover{--transform-translate-y:4rem}.hover\\:translate-y-20:hover{--transform-translate-y:5rem}.hover\\:translate-y-24:hover{--transform-translate-y:6rem}.hover\\:translate-y-32:hover{--transform-translate-y:8rem}.hover\\:translate-y-40:hover{--transform-translate-y:10rem}.hover\\:translate-y-48:hover{--transform-translate-y:12rem}.hover\\:translate-y-56:hover{--transform-translate-y:14rem}.hover\\:translate-y-64:hover{--transform-translate-y:16rem}.hover\\:translate-y-px:hover{--transform-translate-y:1px}.hover\\:-translate-y-1:hover{--transform-translate-y:-0.25rem}.hover\\:-translate-y-2:hover{--transform-translate-y:-0.5rem}.hover\\:-translate-y-3:hover{--transform-translate-y:-0.75rem}.hover\\:-translate-y-4:hover{--transform-translate-y:-1rem}.hover\\:-translate-y-5:hover{--transform-translate-y:-1.25rem}.hover\\:-translate-y-6:hover{--transform-translate-y:-1.5rem}.hover\\:-translate-y-8:hover{--transform-translate-y:-2rem}.hover\\:-translate-y-10:hover{--transform-translate-y:-2.5rem}.hover\\:-translate-y-12:hover{--transform-translate-y:-3rem}.hover\\:-translate-y-16:hover{--transform-translate-y:-4rem}.hover\\:-translate-y-20:hover{--transform-translate-y:-5rem}.hover\\:-translate-y-24:hover{--transform-translate-y:-6rem}.hover\\:-translate-y-32:hover{--transform-translate-y:-8rem}.hover\\:-translate-y-40:hover{--transform-translate-y:-10rem}.hover\\:-translate-y-48:hover{--transform-translate-y:-12rem}.hover\\:-translate-y-56:hover{--transform-translate-y:-14rem}.hover\\:-translate-y-64:hover{--transform-translate-y:-16rem}.hover\\:-translate-y-px:hover{--transform-translate-y:-1px}.hover\\:-translate-y-full:hover{--transform-translate-y:-100%}.hover\\:-translate-y-1\\/2:hover{--transform-translate-y:-50%}.hover\\:translate-y-1\\/2:hover{--transform-translate-y:50%}.hover\\:translate-y-full:hover{--transform-translate-y:100%}.focus\\:translate-x-0:focus{--transform-translate-x:0}.focus\\:translate-x-1:focus{--transform-translate-x:0.25rem}.focus\\:translate-x-2:focus{--transform-translate-x:0.5rem}.focus\\:translate-x-3:focus{--transform-translate-x:0.75rem}.focus\\:translate-x-4:focus{--transform-translate-x:1rem}.focus\\:translate-x-5:focus{--transform-translate-x:1.25rem}.focus\\:translate-x-6:focus{--transform-translate-x:1.5rem}.focus\\:translate-x-8:focus{--transform-translate-x:2rem}.focus\\:translate-x-10:focus{--transform-translate-x:2.5rem}.focus\\:translate-x-12:focus{--transform-translate-x:3rem}.focus\\:translate-x-16:focus{--transform-translate-x:4rem}.focus\\:translate-x-20:focus{--transform-translate-x:5rem}.focus\\:translate-x-24:focus{--transform-translate-x:6rem}.focus\\:translate-x-32:focus{--transform-translate-x:8rem}.focus\\:translate-x-40:focus{--transform-translate-x:10rem}.focus\\:translate-x-48:focus{--transform-translate-x:12rem}.focus\\:translate-x-56:focus{--transform-translate-x:14rem}.focus\\:translate-x-64:focus{--transform-translate-x:16rem}.focus\\:translate-x-px:focus{--transform-translate-x:1px}.focus\\:-translate-x-1:focus{--transform-translate-x:-0.25rem}.focus\\:-translate-x-2:focus{--transform-translate-x:-0.5rem}.focus\\:-translate-x-3:focus{--transform-translate-x:-0.75rem}.focus\\:-translate-x-4:focus{--transform-translate-x:-1rem}.focus\\:-translate-x-5:focus{--transform-translate-x:-1.25rem}.focus\\:-translate-x-6:focus{--transform-translate-x:-1.5rem}.focus\\:-translate-x-8:focus{--transform-translate-x:-2rem}.focus\\:-translate-x-10:focus{--transform-translate-x:-2.5rem}.focus\\:-translate-x-12:focus{--transform-translate-x:-3rem}.focus\\:-translate-x-16:focus{--transform-translate-x:-4rem}.focus\\:-translate-x-20:focus{--transform-translate-x:-5rem}.focus\\:-translate-x-24:focus{--transform-translate-x:-6rem}.focus\\:-translate-x-32:focus{--transform-translate-x:-8rem}.focus\\:-translate-x-40:focus{--transform-translate-x:-10rem}.focus\\:-translate-x-48:focus{--transform-translate-x:-12rem}.focus\\:-translate-x-56:focus{--transform-translate-x:-14rem}.focus\\:-translate-x-64:focus{--transform-translate-x:-16rem}.focus\\:-translate-x-px:focus{--transform-translate-x:-1px}.focus\\:-translate-x-full:focus{--transform-translate-x:-100%}.focus\\:-translate-x-1\\/2:focus{--transform-translate-x:-50%}.focus\\:translate-x-1\\/2:focus{--transform-translate-x:50%}.focus\\:translate-x-full:focus{--transform-translate-x:100%}.focus\\:translate-y-0:focus{--transform-translate-y:0}.focus\\:translate-y-1:focus{--transform-translate-y:0.25rem}.focus\\:translate-y-2:focus{--transform-translate-y:0.5rem}.focus\\:translate-y-3:focus{--transform-translate-y:0.75rem}.focus\\:translate-y-4:focus{--transform-translate-y:1rem}.focus\\:translate-y-5:focus{--transform-translate-y:1.25rem}.focus\\:translate-y-6:focus{--transform-translate-y:1.5rem}.focus\\:translate-y-8:focus{--transform-translate-y:2rem}.focus\\:translate-y-10:focus{--transform-translate-y:2.5rem}.focus\\:translate-y-12:focus{--transform-translate-y:3rem}.focus\\:translate-y-16:focus{--transform-translate-y:4rem}.focus\\:translate-y-20:focus{--transform-translate-y:5rem}.focus\\:translate-y-24:focus{--transform-translate-y:6rem}.focus\\:translate-y-32:focus{--transform-translate-y:8rem}.focus\\:translate-y-40:focus{--transform-translate-y:10rem}.focus\\:translate-y-48:focus{--transform-translate-y:12rem}.focus\\:translate-y-56:focus{--transform-translate-y:14rem}.focus\\:translate-y-64:focus{--transform-translate-y:16rem}.focus\\:translate-y-px:focus{--transform-translate-y:1px}.focus\\:-translate-y-1:focus{--transform-translate-y:-0.25rem}.focus\\:-translate-y-2:focus{--transform-translate-y:-0.5rem}.focus\\:-translate-y-3:focus{--transform-translate-y:-0.75rem}.focus\\:-translate-y-4:focus{--transform-translate-y:-1rem}.focus\\:-translate-y-5:focus{--transform-translate-y:-1.25rem}.focus\\:-translate-y-6:focus{--transform-translate-y:-1.5rem}.focus\\:-translate-y-8:focus{--transform-translate-y:-2rem}.focus\\:-translate-y-10:focus{--transform-translate-y:-2.5rem}.focus\\:-translate-y-12:focus{--transform-translate-y:-3rem}.focus\\:-translate-y-16:focus{--transform-translate-y:-4rem}.focus\\:-translate-y-20:focus{--transform-translate-y:-5rem}.focus\\:-translate-y-24:focus{--transform-translate-y:-6rem}.focus\\:-translate-y-32:focus{--transform-translate-y:-8rem}.focus\\:-translate-y-40:focus{--transform-translate-y:-10rem}.focus\\:-translate-y-48:focus{--transform-translate-y:-12rem}.focus\\:-translate-y-56:focus{--transform-translate-y:-14rem}.focus\\:-translate-y-64:focus{--transform-translate-y:-16rem}.focus\\:-translate-y-px:focus{--transform-translate-y:-1px}.focus\\:-translate-y-full:focus{--transform-translate-y:-100%}.focus\\:-translate-y-1\\/2:focus{--transform-translate-y:-50%}.focus\\:translate-y-1\\/2:focus{--transform-translate-y:50%}.focus\\:translate-y-full:focus{--transform-translate-y:100%}.skew-x-0{--transform-skew-x:0}.skew-x-3{--transform-skew-x:3deg}.skew-x-6{--transform-skew-x:6deg}.skew-x-12{--transform-skew-x:12deg}.-skew-x-12{--transform-skew-x:-12deg}.-skew-x-6{--transform-skew-x:-6deg}.-skew-x-3{--transform-skew-x:-3deg}.skew-y-0{--transform-skew-y:0}.skew-y-3{--transform-skew-y:3deg}.skew-y-6{--transform-skew-y:6deg}.skew-y-12{--transform-skew-y:12deg}.-skew-y-12{--transform-skew-y:-12deg}.-skew-y-6{--transform-skew-y:-6deg}.-skew-y-3{--transform-skew-y:-3deg}.hover\\:skew-x-0:hover{--transform-skew-x:0}.hover\\:skew-x-3:hover{--transform-skew-x:3deg}.hover\\:skew-x-6:hover{--transform-skew-x:6deg}.hover\\:skew-x-12:hover{--transform-skew-x:12deg}.hover\\:-skew-x-12:hover{--transform-skew-x:-12deg}.hover\\:-skew-x-6:hover{--transform-skew-x:-6deg}.hover\\:-skew-x-3:hover{--transform-skew-x:-3deg}.hover\\:skew-y-0:hover{--transform-skew-y:0}.hover\\:skew-y-3:hover{--transform-skew-y:3deg}.hover\\:skew-y-6:hover{--transform-skew-y:6deg}.hover\\:skew-y-12:hover{--transform-skew-y:12deg}.hover\\:-skew-y-12:hover{--transform-skew-y:-12deg}.hover\\:-skew-y-6:hover{--transform-skew-y:-6deg}.hover\\:-skew-y-3:hover{--transform-skew-y:-3deg}.focus\\:skew-x-0:focus{--transform-skew-x:0}.focus\\:skew-x-3:focus{--transform-skew-x:3deg}.focus\\:skew-x-6:focus{--transform-skew-x:6deg}.focus\\:skew-x-12:focus{--transform-skew-x:12deg}.focus\\:-skew-x-12:focus{--transform-skew-x:-12deg}.focus\\:-skew-x-6:focus{--transform-skew-x:-6deg}.focus\\:-skew-x-3:focus{--transform-skew-x:-3deg}.focus\\:skew-y-0:focus{--transform-skew-y:0}.focus\\:skew-y-3:focus{--transform-skew-y:3deg}.focus\\:skew-y-6:focus{--transform-skew-y:6deg}.focus\\:skew-y-12:focus{--transform-skew-y:12deg}.focus\\:-skew-y-12:focus{--transform-skew-y:-12deg}.focus\\:-skew-y-6:focus{--transform-skew-y:-6deg}.focus\\:-skew-y-3:focus{--transform-skew-y:-3deg}.transition-none{transition-property:none}.transition-all{transition-property:all}.transition{transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform}.transition-colors{transition-property:background-color,border-color,color,fill,stroke}.transition-opacity{transition-property:opacity}.transition-shadow{transition-property:box-shadow}.transition-transform{transition-property:transform}.ease-linear{transition-timing-function:linear}.ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.duration-75{transition-duration:75ms}.duration-100{transition-duration:.1s}.duration-150{transition-duration:.15s}.duration-200{transition-duration:.2s}.duration-300{transition-duration:.3s}.duration-500{transition-duration:.5s}.duration-700{transition-duration:.7s}.duration-1000{transition-duration:1s}.delay-75{transition-delay:75ms}.delay-100{transition-delay:.1s}.delay-150{transition-delay:.15s}.delay-200{transition-delay:.2s}.delay-300{transition-delay:.3s}.delay-500{transition-delay:.5s}.delay-700{transition-delay:.7s}.delay-1000{transition-delay:1s}.shadow-outline-white{box-shadow:0 0 0 3px #ffffff73}.shadow-outline-black{box-shadow:0 0 0 3px #00000073}.shadow-outline-gray{box-shadow:0 0 0 3px #d5d6d773}.shadow-outline-cool-gray{box-shadow:0 0 0 3px #cfd8e373}.shadow-outline-red{box-shadow:0 0 0 3px #f8b4b473}.shadow-outline-orange{box-shadow:0 0 0 3px #fdba8c73}.shadow-outline-yellow{box-shadow:0 0 0 3px #faca1573}.shadow-outline-green{box-shadow:0 0 0 3px #84e1bc73}.shadow-outline-teal{box-shadow:0 0 0 3px #7edce273}.shadow-outline-blue{box-shadow:0 0 0 3px #a4cafe73}.shadow-outline-indigo{box-shadow:0 0 0 3px #b4c6fc73}.shadow-outline-indigo{box-shadow:0 0 0 3px #cabffd73}.shadow-outline-pink{box-shadow:0 0 0 3px #f8b4d973}.hover\\:shadow-outline-white:hover{box-shadow:0 0 0 3px #ffffff73}.hover\\:shadow-outline-black:hover{box-shadow:0 0 0 3px #00000073}.hover\\:shadow-outline-gray:hover{box-shadow:0 0 0 3px #d5d6d773}.hover\\:shadow-outline-cool-gray:hover{box-shadow:0 0 0 3px #cfd8e373}.hover\\:shadow-outline-red:hover{box-shadow:0 0 0 3px #f8b4b473}.hover\\:shadow-outline-orange:hover{box-shadow:0 0 0 3px #fdba8c73}.hover\\:shadow-outline-yellow:hover{box-shadow:0 0 0 3px #faca1573}.hover\\:shadow-outline-green:hover{box-shadow:0 0 0 3px #84e1bc73}.hover\\:shadow-outline-teal:hover{box-shadow:0 0 0 3px #7edce273}.hover\\:shadow-outline-blue:hover{box-shadow:0 0 0 3px #a4cafe73}.hover\\:shadow-outline-indigo:hover{box-shadow:0 0 0 3px #b4c6fc73}.hover\\:shadow-outline-indigo:hover{box-shadow:0 0 0 3px #cabffd73}.hover\\:shadow-outline-pink:hover{box-shadow:0 0 0 3px #f8b4d973}.focus\\:shadow-outline-white:focus{box-shadow:0 0 0 3px #ffffff73}.focus\\:shadow-outline-black:focus{box-shadow:0 0 0 3px #00000073}.focus\\:shadow-outline-gray:focus{box-shadow:0 0 0 3px #d5d6d773}.focus\\:shadow-outline-cool-gray:focus{box-shadow:0 0 0 3px #cfd8e373}.focus\\:shadow-outline-red:focus{box-shadow:0 0 0 3px #f8b4b473}.focus\\:shadow-outline-orange:focus{box-shadow:0 0 0 3px #fdba8c73}.focus\\:shadow-outline-yellow:focus{box-shadow:0 0 0 3px #faca1573}.focus\\:shadow-outline-green:focus{box-shadow:0 0 0 3px #84e1bc73}.focus\\:shadow-outline-teal:focus{box-shadow:0 0 0 3px #7edce273}.focus\\:shadow-outline-blue:focus{box-shadow:0 0 0 3px #a4cafe73}.focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #b4c6fc73}.focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #cabffd73}.focus\\:shadow-outline-pink:focus{box-shadow:0 0 0 3px #f8b4d973}.theme-dark .dark\\:focus\\:shadow-outline-white:focus{box-shadow:0 0 0 3px #ffffff73}.theme-dark .dark\\:focus\\:shadow-outline-black:focus{box-shadow:0 0 0 3px #00000073}.theme-dark .dark\\:focus\\:shadow-outline-gray:focus{box-shadow:0 0 0 3px #d5d6d773}.theme-dark .dark\\:focus\\:shadow-outline-cool-gray:focus{box-shadow:0 0 0 3px #cfd8e373}.theme-dark .dark\\:focus\\:shadow-outline-red:focus{box-shadow:0 0 0 3px #f8b4b473}.theme-dark .dark\\:focus\\:shadow-outline-orange:focus{box-shadow:0 0 0 3px #fdba8c73}.theme-dark .dark\\:focus\\:shadow-outline-yellow:focus{box-shadow:0 0 0 3px #faca1573}.theme-dark .dark\\:focus\\:shadow-outline-green:focus{box-shadow:0 0 0 3px #84e1bc73}.theme-dark .dark\\:focus\\:shadow-outline-teal:focus{box-shadow:0 0 0 3px #7edce273}.theme-dark .dark\\:focus\\:shadow-outline-blue:focus{box-shadow:0 0 0 3px #a4cafe73}.theme-dark .dark\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #b4c6fc73}.theme-dark .dark\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #cabffd73}.theme-dark .dark\\:focus\\:shadow-outline-pink:focus{box-shadow:0 0 0 3px #f8b4d973}@media (min-width:640px){.sm\\:space-y-0>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(0px*var(--space-y-reverse));margin-top:calc(0px*(1 - var(--space-y-reverse)))}.sm\\:space-x-0>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(0px*(1 - var(--space-x-reverse)));margin-right:calc(0px*var(--space-x-reverse))}.sm\\:space-y-1>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(.25rem*var(--space-y-reverse));margin-top:calc(.25rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-1>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(.25rem*(1 - var(--space-x-reverse)));margin-right:calc(.25rem*var(--space-x-reverse))}.sm\\:space-y-2>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(.5rem*var(--space-y-reverse));margin-top:calc(.5rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-2>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(.5rem*(1 - var(--space-x-reverse)));margin-right:calc(.5rem*var(--space-x-reverse))}.sm\\:space-y-3>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(.75rem*var(--space-y-reverse));margin-top:calc(.75rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-3>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(.75rem*(1 - var(--space-x-reverse)));margin-right:calc(.75rem*var(--space-x-reverse))}.sm\\:space-y-4>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1rem*var(--space-y-reverse));margin-top:calc(1rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-4>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1rem*(1 - var(--space-x-reverse)));margin-right:calc(1rem*var(--space-x-reverse))}.sm\\:space-y-5>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1.25rem*var(--space-y-reverse));margin-top:calc(1.25rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-5>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1.25rem*(1 - var(--space-x-reverse)));margin-right:calc(1.25rem*var(--space-x-reverse))}.sm\\:space-y-6>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1.5rem*var(--space-y-reverse));margin-top:calc(1.5rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-6>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1.5rem*(1 - var(--space-x-reverse)));margin-right:calc(1.5rem*var(--space-x-reverse))}.sm\\:space-y-8>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(2rem*var(--space-y-reverse));margin-top:calc(2rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-8>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(2rem*(1 - var(--space-x-reverse)));margin-right:calc(2rem*var(--space-x-reverse))}.sm\\:space-y-10>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(2.5rem*var(--space-y-reverse));margin-top:calc(2.5rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-10>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(2.5rem*(1 - var(--space-x-reverse)));margin-right:calc(2.5rem*var(--space-x-reverse))}.sm\\:space-y-12>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(3rem*var(--space-y-reverse));margin-top:calc(3rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-12>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(3rem*(1 - var(--space-x-reverse)));margin-right:calc(3rem*var(--space-x-reverse))}.sm\\:space-y-16>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(4rem*var(--space-y-reverse));margin-top:calc(4rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-16>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(4rem*(1 - var(--space-x-reverse)));margin-right:calc(4rem*var(--space-x-reverse))}.sm\\:space-y-20>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(5rem*var(--space-y-reverse));margin-top:calc(5rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-20>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(5rem*(1 - var(--space-x-reverse)));margin-right:calc(5rem*var(--space-x-reverse))}.sm\\:space-y-24>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(6rem*var(--space-y-reverse));margin-top:calc(6rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-24>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(6rem*(1 - var(--space-x-reverse)));margin-right:calc(6rem*var(--space-x-reverse))}.sm\\:space-y-32>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(8rem*var(--space-y-reverse));margin-top:calc(8rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-32>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(8rem*(1 - var(--space-x-reverse)));margin-right:calc(8rem*var(--space-x-reverse))}.sm\\:space-y-40>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(10rem*var(--space-y-reverse));margin-top:calc(10rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-40>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(10rem*(1 - var(--space-x-reverse)));margin-right:calc(10rem*var(--space-x-reverse))}.sm\\:space-y-48>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(12rem*var(--space-y-reverse));margin-top:calc(12rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-48>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(12rem*(1 - var(--space-x-reverse)));margin-right:calc(12rem*var(--space-x-reverse))}.sm\\:space-y-56>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(14rem*var(--space-y-reverse));margin-top:calc(14rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-56>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(14rem*(1 - var(--space-x-reverse)));margin-right:calc(14rem*var(--space-x-reverse))}.sm\\:space-y-64>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(16rem*var(--space-y-reverse));margin-top:calc(16rem*(1 - var(--space-y-reverse)))}.sm\\:space-x-64>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(16rem*(1 - var(--space-x-reverse)));margin-right:calc(16rem*var(--space-x-reverse))}.sm\\:space-y-px>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1px*var(--space-y-reverse));margin-top:calc(1px*(1 - var(--space-y-reverse)))}.sm\\:space-x-px>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1px*(1 - var(--space-x-reverse)));margin-right:calc(1px*var(--space-x-reverse))}.sm\\:-space-y-1>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-.25rem*var(--space-y-reverse));margin-top:calc(-.25rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-1>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-.25rem*(1 - var(--space-x-reverse)));margin-right:calc(-.25rem*var(--space-x-reverse))}.sm\\:-space-y-2>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-.5rem*var(--space-y-reverse));margin-top:calc(-.5rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-2>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-.5rem*(1 - var(--space-x-reverse)));margin-right:calc(-.5rem*var(--space-x-reverse))}.sm\\:-space-y-3>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-.75rem*var(--space-y-reverse));margin-top:calc(-.75rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-3>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-.75rem*(1 - var(--space-x-reverse)));margin-right:calc(-.75rem*var(--space-x-reverse))}.sm\\:-space-y-4>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1rem*var(--space-y-reverse));margin-top:calc(-1rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-4>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1rem*(1 - var(--space-x-reverse)));margin-right:calc(-1rem*var(--space-x-reverse))}.sm\\:-space-y-5>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1.25rem*var(--space-y-reverse));margin-top:calc(-1.25rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-5>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1.25rem*(1 - var(--space-x-reverse)));margin-right:calc(-1.25rem*var(--space-x-reverse))}.sm\\:-space-y-6>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1.5rem*var(--space-y-reverse));margin-top:calc(-1.5rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-6>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1.5rem*(1 - var(--space-x-reverse)));margin-right:calc(-1.5rem*var(--space-x-reverse))}.sm\\:-space-y-8>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-2rem*var(--space-y-reverse));margin-top:calc(-2rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-8>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-2rem*(1 - var(--space-x-reverse)));margin-right:calc(-2rem*var(--space-x-reverse))}.sm\\:-space-y-10>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-2.5rem*var(--space-y-reverse));margin-top:calc(-2.5rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-10>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-2.5rem*(1 - var(--space-x-reverse)));margin-right:calc(-2.5rem*var(--space-x-reverse))}.sm\\:-space-y-12>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-3rem*var(--space-y-reverse));margin-top:calc(-3rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-12>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-3rem*(1 - var(--space-x-reverse)));margin-right:calc(-3rem*var(--space-x-reverse))}.sm\\:-space-y-16>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-4rem*var(--space-y-reverse));margin-top:calc(-4rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-16>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-4rem*(1 - var(--space-x-reverse)));margin-right:calc(-4rem*var(--space-x-reverse))}.sm\\:-space-y-20>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-5rem*var(--space-y-reverse));margin-top:calc(-5rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-20>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-5rem*(1 - var(--space-x-reverse)));margin-right:calc(-5rem*var(--space-x-reverse))}.sm\\:-space-y-24>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-6rem*var(--space-y-reverse));margin-top:calc(-6rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-24>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-6rem*(1 - var(--space-x-reverse)));margin-right:calc(-6rem*var(--space-x-reverse))}.sm\\:-space-y-32>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-8rem*var(--space-y-reverse));margin-top:calc(-8rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-32>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-8rem*(1 - var(--space-x-reverse)));margin-right:calc(-8rem*var(--space-x-reverse))}.sm\\:-space-y-40>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-10rem*var(--space-y-reverse));margin-top:calc(-10rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-40>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-10rem*(1 - var(--space-x-reverse)));margin-right:calc(-10rem*var(--space-x-reverse))}.sm\\:-space-y-48>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-12rem*var(--space-y-reverse));margin-top:calc(-12rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-48>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-12rem*(1 - var(--space-x-reverse)));margin-right:calc(-12rem*var(--space-x-reverse))}.sm\\:-space-y-56>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-14rem*var(--space-y-reverse));margin-top:calc(-14rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-56>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-14rem*(1 - var(--space-x-reverse)));margin-right:calc(-14rem*var(--space-x-reverse))}.sm\\:-space-y-64>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-16rem*var(--space-y-reverse));margin-top:calc(-16rem*(1 - var(--space-y-reverse)))}.sm\\:-space-x-64>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-16rem*(1 - var(--space-x-reverse)));margin-right:calc(-16rem*var(--space-x-reverse))}.sm\\:-space-y-px>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1px*var(--space-y-reverse));margin-top:calc(-1px*(1 - var(--space-y-reverse)))}.sm\\:-space-x-px>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1px*(1 - var(--space-x-reverse)));margin-right:calc(-1px*var(--space-x-reverse))}.sm\\:space-y-reverse>:not(template)~:not(template){--space-y-reverse:1}.sm\\:space-x-reverse>:not(template)~:not(template){--space-x-reverse:1}.sm\\:divide-y-0>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(0px*var(--divide-y-reverse));border-top-width:calc(0px*(1 - var(--divide-y-reverse)))}.sm\\:divide-x-0>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(0px*(1 - var(--divide-x-reverse)));border-right-width:calc(0px*var(--divide-x-reverse))}.sm\\:divide-y-2>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(2px*var(--divide-y-reverse));border-top-width:calc(2px*(1 - var(--divide-y-reverse)))}.sm\\:divide-x-2>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(2px*(1 - var(--divide-x-reverse)));border-right-width:calc(2px*var(--divide-x-reverse))}.sm\\:divide-y-4>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(4px*var(--divide-y-reverse));border-top-width:calc(4px*(1 - var(--divide-y-reverse)))}.sm\\:divide-x-4>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(4px*(1 - var(--divide-x-reverse)));border-right-width:calc(4px*var(--divide-x-reverse))}.sm\\:divide-y-8>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(8px*var(--divide-y-reverse));border-top-width:calc(8px*(1 - var(--divide-y-reverse)))}.sm\\:divide-x-8>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(8px*(1 - var(--divide-x-reverse)));border-right-width:calc(8px*var(--divide-x-reverse))}.sm\\:divide-y>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(1px*var(--divide-y-reverse));border-top-width:calc(1px*(1 - var(--divide-y-reverse)))}.sm\\:divide-x>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(1px*(1 - var(--divide-x-reverse)));border-right-width:calc(1px*var(--divide-x-reverse))}.sm\\:divide-y-reverse>:not(template)~:not(template){--divide-y-reverse:1}.sm\\:divide-x-reverse>:not(template)~:not(template){--divide-x-reverse:1}.sm\\:divide-transparent>:not(template)~:not(template){border-color:#0000}.sm\\:divide-white>:not(template)~:not(template){--divide-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--divide-opacity))}.sm\\:divide-black>:not(template)~:not(template){--divide-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--divide-opacity))}.sm\\:divide-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--divide-opacity))}.sm\\:divide-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--divide-opacity))}.sm\\:divide-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--divide-opacity))}.sm\\:divide-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--divide-opacity))}.sm\\:divide-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--divide-opacity))}.sm\\:divide-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--divide-opacity))}.sm\\:divide-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--divide-opacity))}.sm\\:divide-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--divide-opacity))}.sm\\:divide-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--divide-opacity))}.sm\\:divide-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--divide-opacity))}.sm\\:divide-cool-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--divide-opacity))}.sm\\:divide-cool-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--divide-opacity))}.sm\\:divide-cool-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--divide-opacity))}.sm\\:divide-cool-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--divide-opacity))}.sm\\:divide-cool-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--divide-opacity))}.sm\\:divide-cool-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--divide-opacity))}.sm\\:divide-cool-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--divide-opacity))}.sm\\:divide-cool-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--divide-opacity))}.sm\\:divide-cool-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--divide-opacity))}.sm\\:divide-cool-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--divide-opacity))}.sm\\:divide-red-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--divide-opacity))}.sm\\:divide-red-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--divide-opacity))}.sm\\:divide-red-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--divide-opacity))}.sm\\:divide-red-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--divide-opacity))}.sm\\:divide-red-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--divide-opacity))}.sm\\:divide-red-500>:not(template)~:not(template){--divide-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--divide-opacity))}.sm\\:divide-red-600>:not(template)~:not(template){--divide-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--divide-opacity))}.sm\\:divide-red-700>:not(template)~:not(template){--divide-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--divide-opacity))}.sm\\:divide-red-800>:not(template)~:not(template){--divide-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--divide-opacity))}.sm\\:divide-red-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.sm\\:divide-orange-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--divide-opacity))}.sm\\:divide-orange-100>:not(template)~:not(template){--divide-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--divide-opacity))}.sm\\:divide-orange-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--divide-opacity))}.sm\\:divide-orange-300>:not(template)~:not(template){--divide-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--divide-opacity))}.sm\\:divide-orange-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--divide-opacity))}.sm\\:divide-orange-500>:not(template)~:not(template){--divide-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--divide-opacity))}.sm\\:divide-orange-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--divide-opacity))}.sm\\:divide-orange-700>:not(template)~:not(template){--divide-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--divide-opacity))}.sm\\:divide-orange-800>:not(template)~:not(template){--divide-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--divide-opacity))}.sm\\:divide-orange-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.sm\\:divide-yellow-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--divide-opacity))}.sm\\:divide-yellow-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--divide-opacity))}.sm\\:divide-yellow-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--divide-opacity))}.sm\\:divide-yellow-300>:not(template)~:not(template){--divide-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--divide-opacity))}.sm\\:divide-yellow-400>:not(template)~:not(template){--divide-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--divide-opacity))}.sm\\:divide-yellow-500>:not(template)~:not(template){--divide-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--divide-opacity))}.sm\\:divide-yellow-600>:not(template)~:not(template){--divide-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--divide-opacity))}.sm\\:divide-yellow-700>:not(template)~:not(template){--divide-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--divide-opacity))}.sm\\:divide-yellow-800>:not(template)~:not(template){--divide-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--divide-opacity))}.sm\\:divide-yellow-900>:not(template)~:not(template){--divide-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--divide-opacity))}.sm\\:divide-green-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--divide-opacity))}.sm\\:divide-green-100>:not(template)~:not(template){--divide-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--divide-opacity))}.sm\\:divide-green-200>:not(template)~:not(template){--divide-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--divide-opacity))}.sm\\:divide-green-300>:not(template)~:not(template){--divide-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--divide-opacity))}.sm\\:divide-green-400>:not(template)~:not(template){--divide-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--divide-opacity))}.sm\\:divide-green-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--divide-opacity))}.sm\\:divide-green-600>:not(template)~:not(template){--divide-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--divide-opacity))}.sm\\:divide-green-700>:not(template)~:not(template){--divide-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--divide-opacity))}.sm\\:divide-green-800>:not(template)~:not(template){--divide-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--divide-opacity))}.sm\\:divide-green-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--divide-opacity))}.sm\\:divide-teal-50>:not(template)~:not(template){--divide-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--divide-opacity))}.sm\\:divide-teal-100>:not(template)~:not(template){--divide-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--divide-opacity))}.sm\\:divide-teal-200>:not(template)~:not(template){--divide-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--divide-opacity))}.sm\\:divide-teal-300>:not(template)~:not(template){--divide-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--divide-opacity))}.sm\\:divide-teal-400>:not(template)~:not(template){--divide-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--divide-opacity))}.sm\\:divide-teal-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--divide-opacity))}.sm\\:divide-teal-600>:not(template)~:not(template){--divide-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--divide-opacity))}.sm\\:divide-teal-700>:not(template)~:not(template){--divide-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--divide-opacity))}.sm\\:divide-teal-800>:not(template)~:not(template){--divide-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--divide-opacity))}.sm\\:divide-teal-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--divide-opacity))}.sm\\:divide-blue-50>:not(template)~:not(template){--divide-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--divide-opacity))}.sm\\:divide-blue-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--divide-opacity))}.sm\\:divide-blue-200>:not(template)~:not(template){--divide-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--divide-opacity))}.sm\\:divide-blue-300>:not(template)~:not(template){--divide-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--divide-opacity))}.sm\\:divide-blue-400>:not(template)~:not(template){--divide-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--divide-opacity))}.sm\\:divide-blue-500>:not(template)~:not(template){--divide-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--divide-opacity))}.sm\\:divide-blue-600>:not(template)~:not(template){--divide-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--divide-opacity))}.sm\\:divide-blue-700>:not(template)~:not(template){--divide-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--divide-opacity))}.sm\\:divide-blue-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--divide-opacity))}.sm\\:divide-blue-900>:not(template)~:not(template){--divide-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--divide-opacity))}.sm\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--divide-opacity))}.sm\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--divide-opacity))}.sm\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--divide-opacity))}.sm\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--divide-opacity))}.sm\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--divide-opacity))}.sm\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--divide-opacity))}.sm\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--divide-opacity))}.sm\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--divide-opacity))}.sm\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--divide-opacity))}.sm\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--divide-opacity))}.sm\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--divide-opacity))}.sm\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--divide-opacity))}.sm\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--divide-opacity))}.sm\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--divide-opacity))}.sm\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--divide-opacity))}.sm\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--divide-opacity))}.sm\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--divide-opacity))}.sm\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--divide-opacity))}.sm\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--divide-opacity))}.sm\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--divide-opacity))}.sm\\:divide-pink-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--divide-opacity))}.sm\\:divide-pink-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--divide-opacity))}.sm\\:divide-pink-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--divide-opacity))}.sm\\:divide-pink-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--divide-opacity))}.sm\\:divide-pink-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--divide-opacity))}.sm\\:divide-pink-500>:not(template)~:not(template){--divide-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--divide-opacity))}.sm\\:divide-pink-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--divide-opacity))}.sm\\:divide-pink-700>:not(template)~:not(template){--divide-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--divide-opacity))}.sm\\:divide-pink-800>:not(template)~:not(template){--divide-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--divide-opacity))}.sm\\:divide-pink-900>:not(template)~:not(template){--divide-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-transparent>:not(template)~:not(template){border-color:#0000}.theme-dark .sm\\:dark\\:divide-white>:not(template)~:not(template){--divide-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-black>:not(template)~:not(template){--divide-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-cool-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-cool-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-cool-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-cool-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-cool-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-cool-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-cool-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-cool-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-cool-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-cool-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-red-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-red-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-red-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-red-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-red-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-red-500>:not(template)~:not(template){--divide-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-red-600>:not(template)~:not(template){--divide-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-red-700>:not(template)~:not(template){--divide-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-red-800>:not(template)~:not(template){--divide-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-red-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-orange-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-orange-100>:not(template)~:not(template){--divide-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-orange-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-orange-300>:not(template)~:not(template){--divide-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-orange-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-orange-500>:not(template)~:not(template){--divide-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-orange-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-orange-700>:not(template)~:not(template){--divide-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-orange-800>:not(template)~:not(template){--divide-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-orange-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-yellow-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-yellow-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-yellow-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-yellow-300>:not(template)~:not(template){--divide-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-yellow-400>:not(template)~:not(template){--divide-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-yellow-500>:not(template)~:not(template){--divide-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-yellow-600>:not(template)~:not(template){--divide-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-yellow-700>:not(template)~:not(template){--divide-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-yellow-800>:not(template)~:not(template){--divide-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-yellow-900>:not(template)~:not(template){--divide-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-green-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-green-100>:not(template)~:not(template){--divide-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-green-200>:not(template)~:not(template){--divide-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-green-300>:not(template)~:not(template){--divide-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-green-400>:not(template)~:not(template){--divide-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-green-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-green-600>:not(template)~:not(template){--divide-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-green-700>:not(template)~:not(template){--divide-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-green-800>:not(template)~:not(template){--divide-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-green-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-teal-50>:not(template)~:not(template){--divide-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-teal-100>:not(template)~:not(template){--divide-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-teal-200>:not(template)~:not(template){--divide-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-teal-300>:not(template)~:not(template){--divide-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-teal-400>:not(template)~:not(template){--divide-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-teal-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-teal-600>:not(template)~:not(template){--divide-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-teal-700>:not(template)~:not(template){--divide-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-teal-800>:not(template)~:not(template){--divide-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-teal-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-blue-50>:not(template)~:not(template){--divide-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-blue-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-blue-200>:not(template)~:not(template){--divide-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-blue-300>:not(template)~:not(template){--divide-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-blue-400>:not(template)~:not(template){--divide-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-blue-500>:not(template)~:not(template){--divide-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-blue-600>:not(template)~:not(template){--divide-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-blue-700>:not(template)~:not(template){--divide-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-blue-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-blue-900>:not(template)~:not(template){--divide-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-pink-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-pink-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-pink-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-pink-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-pink-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-pink-500>:not(template)~:not(template){--divide-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-pink-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-pink-700>:not(template)~:not(template){--divide-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-pink-800>:not(template)~:not(template){--divide-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--divide-opacity))}.theme-dark .sm\\:dark\\:divide-pink-900>:not(template)~:not(template){--divide-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--divide-opacity))}.sm\\:divide-opacity-0>:not(template)~:not(template){--divide-opacity:0}.sm\\:divide-opacity-25>:not(template)~:not(template){--divide-opacity:0.25}.sm\\:divide-opacity-50>:not(template)~:not(template){--divide-opacity:0.5}.sm\\:divide-opacity-75>:not(template)~:not(template){--divide-opacity:0.75}.sm\\:divide-opacity-100>:not(template)~:not(template){--divide-opacity:1}.sm\\:sr-only{height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;clip:rect(0,0,0,0);border-width:0;white-space:nowrap}.sm\\:not-sr-only{height:auto;margin:0;overflow:visible;padding:0;position:static;width:auto;clip:auto;white-space:normal}.sm\\:focus\\:sr-only:focus{height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;clip:rect(0,0,0,0);border-width:0;white-space:nowrap}.sm\\:focus\\:not-sr-only:focus{height:auto;margin:0;overflow:visible;padding:0;position:static;width:auto;clip:auto;white-space:normal}.sm\\:appearance-none{-webkit-appearance:none;appearance:none}.sm\\:bg-fixed{background-attachment:fixed}.sm\\:bg-local{background-attachment:local}.sm\\:bg-scroll{background-attachment:scroll}.sm\\:bg-transparent{background-color:initial}.sm\\:bg-white{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.sm\\:bg-black{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.sm\\:bg-gray-50{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.sm\\:bg-gray-100{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.sm\\:bg-gray-200{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.sm\\:bg-gray-300{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.sm\\:bg-gray-400{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.sm\\:bg-gray-500{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.sm\\:bg-gray-600{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.sm\\:bg-gray-700{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.sm\\:bg-gray-800{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.sm\\:bg-gray-900{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.sm\\:bg-cool-gray-50{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.sm\\:bg-cool-gray-100{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.sm\\:bg-cool-gray-200{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.sm\\:bg-cool-gray-300{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.sm\\:bg-cool-gray-400{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.sm\\:bg-cool-gray-500{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.sm\\:bg-cool-gray-600{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.sm\\:bg-cool-gray-700{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.sm\\:bg-cool-gray-800{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.sm\\:bg-cool-gray-900{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.sm\\:bg-red-50{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.sm\\:bg-red-100{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.sm\\:bg-red-200{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.sm\\:bg-red-300{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.sm\\:bg-red-400{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.sm\\:bg-red-500{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.sm\\:bg-red-600{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.sm\\:bg-red-700{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.sm\\:bg-red-800{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.sm\\:bg-red-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.sm\\:bg-orange-50{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.sm\\:bg-orange-100{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.sm\\:bg-orange-200{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.sm\\:bg-orange-300{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.sm\\:bg-orange-400{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.sm\\:bg-orange-500{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.sm\\:bg-orange-600{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.sm\\:bg-orange-700{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.sm\\:bg-orange-800{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.sm\\:bg-orange-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.sm\\:bg-yellow-50{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.sm\\:bg-yellow-100{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.sm\\:bg-yellow-200{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.sm\\:bg-yellow-300{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.sm\\:bg-yellow-400{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.sm\\:bg-yellow-500{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.sm\\:bg-yellow-600{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.sm\\:bg-yellow-700{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.sm\\:bg-yellow-800{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.sm\\:bg-yellow-900{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.sm\\:bg-green-50{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.sm\\:bg-green-100{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.sm\\:bg-green-200{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.sm\\:bg-green-300{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.sm\\:bg-green-400{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.sm\\:bg-green-500{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.sm\\:bg-green-600{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.sm\\:bg-green-700{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.sm\\:bg-green-800{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.sm\\:bg-green-900{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.sm\\:bg-teal-50{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.sm\\:bg-teal-100{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.sm\\:bg-teal-200{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.sm\\:bg-teal-300{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.sm\\:bg-teal-400{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.sm\\:bg-teal-500{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.sm\\:bg-teal-600{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.sm\\:bg-teal-700{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.sm\\:bg-teal-800{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.sm\\:bg-teal-900{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.sm\\:bg-blue-50{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.sm\\:bg-blue-100{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.sm\\:bg-blue-200{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.sm\\:bg-blue-300{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.sm\\:bg-blue-400{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.sm\\:bg-blue-500{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.sm\\:bg-blue-600{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.sm\\:bg-blue-700{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.sm\\:bg-blue-800{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.sm\\:bg-blue-900{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.sm\\:bg-indigo-50{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.sm\\:bg-indigo-100{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.sm\\:bg-indigo-200{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.sm\\:bg-indigo-300{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.sm\\:bg-indigo-400{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.sm\\:bg-indigo-500{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.sm\\:bg-indigo-600{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.sm\\:bg-indigo-700{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.sm\\:bg-indigo-800{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.sm\\:bg-indigo-900{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.sm\\:bg-indigo-50{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.sm\\:bg-indigo-100{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.sm\\:bg-indigo-200{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.sm\\:bg-indigo-300{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.sm\\:bg-indigo-400{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.sm\\:bg-indigo-500{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.sm\\:bg-indigo-600{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.sm\\:bg-indigo-700{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.sm\\:bg-indigo-800{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.sm\\:bg-indigo-900{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.sm\\:bg-pink-50{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.sm\\:bg-pink-100{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.sm\\:bg-pink-200{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.sm\\:bg-pink-300{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.sm\\:bg-pink-400{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.sm\\:bg-pink-500{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.sm\\:bg-pink-600{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.sm\\:bg-pink-700{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.sm\\:bg-pink-800{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.sm\\:bg-pink-900{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.sm\\:hover\\:bg-transparent:hover{background-color:initial}.sm\\:hover\\:bg-white:hover{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.sm\\:hover\\:bg-black:hover{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.sm\\:hover\\:bg-gray-50:hover{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.sm\\:hover\\:bg-gray-100:hover{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.sm\\:hover\\:bg-gray-200:hover{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.sm\\:hover\\:bg-gray-300:hover{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.sm\\:hover\\:bg-gray-400:hover{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.sm\\:hover\\:bg-gray-500:hover{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.sm\\:hover\\:bg-gray-600:hover{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.sm\\:hover\\:bg-gray-700:hover{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.sm\\:hover\\:bg-gray-800:hover{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.sm\\:hover\\:bg-gray-900:hover{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.sm\\:hover\\:bg-cool-gray-50:hover{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.sm\\:hover\\:bg-cool-gray-100:hover{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.sm\\:hover\\:bg-cool-gray-200:hover{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.sm\\:hover\\:bg-cool-gray-300:hover{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.sm\\:hover\\:bg-cool-gray-400:hover{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.sm\\:hover\\:bg-cool-gray-500:hover{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.sm\\:hover\\:bg-cool-gray-600:hover{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.sm\\:hover\\:bg-cool-gray-700:hover{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.sm\\:hover\\:bg-cool-gray-800:hover{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.sm\\:hover\\:bg-cool-gray-900:hover{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.sm\\:hover\\:bg-red-50:hover{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.sm\\:hover\\:bg-red-100:hover{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.sm\\:hover\\:bg-red-200:hover{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.sm\\:hover\\:bg-red-300:hover{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.sm\\:hover\\:bg-red-400:hover{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.sm\\:hover\\:bg-red-500:hover{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.sm\\:hover\\:bg-red-600:hover{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.sm\\:hover\\:bg-red-700:hover{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.sm\\:hover\\:bg-red-800:hover{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.sm\\:hover\\:bg-red-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.sm\\:hover\\:bg-orange-50:hover{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.sm\\:hover\\:bg-orange-100:hover{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.sm\\:hover\\:bg-orange-200:hover{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.sm\\:hover\\:bg-orange-300:hover{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.sm\\:hover\\:bg-orange-400:hover{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.sm\\:hover\\:bg-orange-500:hover{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.sm\\:hover\\:bg-orange-600:hover{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.sm\\:hover\\:bg-orange-700:hover{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.sm\\:hover\\:bg-orange-800:hover{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.sm\\:hover\\:bg-orange-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.sm\\:hover\\:bg-yellow-50:hover{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.sm\\:hover\\:bg-yellow-100:hover{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.sm\\:hover\\:bg-yellow-200:hover{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.sm\\:hover\\:bg-yellow-300:hover{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.sm\\:hover\\:bg-yellow-400:hover{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.sm\\:hover\\:bg-yellow-500:hover{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.sm\\:hover\\:bg-yellow-600:hover{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.sm\\:hover\\:bg-yellow-700:hover{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.sm\\:hover\\:bg-yellow-800:hover{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.sm\\:hover\\:bg-yellow-900:hover{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.sm\\:hover\\:bg-green-50:hover{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.sm\\:hover\\:bg-green-100:hover{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.sm\\:hover\\:bg-green-200:hover{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.sm\\:hover\\:bg-green-300:hover{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.sm\\:hover\\:bg-green-400:hover{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.sm\\:hover\\:bg-green-500:hover{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.sm\\:hover\\:bg-green-600:hover{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.sm\\:hover\\:bg-green-700:hover{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.sm\\:hover\\:bg-green-800:hover{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.sm\\:hover\\:bg-green-900:hover{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.sm\\:hover\\:bg-teal-50:hover{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.sm\\:hover\\:bg-teal-100:hover{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.sm\\:hover\\:bg-teal-200:hover{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.sm\\:hover\\:bg-teal-300:hover{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.sm\\:hover\\:bg-teal-400:hover{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.sm\\:hover\\:bg-teal-500:hover{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.sm\\:hover\\:bg-teal-600:hover{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.sm\\:hover\\:bg-teal-700:hover{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.sm\\:hover\\:bg-teal-800:hover{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.sm\\:hover\\:bg-teal-900:hover{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.sm\\:hover\\:bg-blue-50:hover{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.sm\\:hover\\:bg-blue-100:hover{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.sm\\:hover\\:bg-blue-200:hover{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.sm\\:hover\\:bg-blue-300:hover{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.sm\\:hover\\:bg-blue-400:hover{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.sm\\:hover\\:bg-blue-500:hover{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.sm\\:hover\\:bg-blue-600:hover{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.sm\\:hover\\:bg-blue-700:hover{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.sm\\:hover\\:bg-blue-800:hover{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.sm\\:hover\\:bg-blue-900:hover{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.sm\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.sm\\:hover\\:bg-pink-50:hover{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.sm\\:hover\\:bg-pink-100:hover{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.sm\\:hover\\:bg-pink-200:hover{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.sm\\:hover\\:bg-pink-300:hover{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.sm\\:hover\\:bg-pink-400:hover{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.sm\\:hover\\:bg-pink-500:hover{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.sm\\:hover\\:bg-pink-600:hover{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.sm\\:hover\\:bg-pink-700:hover{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.sm\\:hover\\:bg-pink-800:hover{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.sm\\:hover\\:bg-pink-900:hover{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.sm\\:focus\\:bg-transparent:focus{background-color:initial}.sm\\:focus\\:bg-white:focus{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.sm\\:focus\\:bg-black:focus{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.sm\\:focus\\:bg-gray-50:focus{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.sm\\:focus\\:bg-gray-100:focus{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.sm\\:focus\\:bg-gray-200:focus{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.sm\\:focus\\:bg-gray-300:focus{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.sm\\:focus\\:bg-gray-400:focus{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.sm\\:focus\\:bg-gray-500:focus{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.sm\\:focus\\:bg-gray-600:focus{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.sm\\:focus\\:bg-gray-700:focus{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.sm\\:focus\\:bg-gray-800:focus{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.sm\\:focus\\:bg-gray-900:focus{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.sm\\:focus\\:bg-cool-gray-50:focus{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.sm\\:focus\\:bg-cool-gray-100:focus{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.sm\\:focus\\:bg-cool-gray-200:focus{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.sm\\:focus\\:bg-cool-gray-300:focus{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.sm\\:focus\\:bg-cool-gray-400:focus{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.sm\\:focus\\:bg-cool-gray-500:focus{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.sm\\:focus\\:bg-cool-gray-600:focus{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.sm\\:focus\\:bg-cool-gray-700:focus{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.sm\\:focus\\:bg-cool-gray-800:focus{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.sm\\:focus\\:bg-cool-gray-900:focus{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.sm\\:focus\\:bg-red-50:focus{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.sm\\:focus\\:bg-red-100:focus{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.sm\\:focus\\:bg-red-200:focus{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.sm\\:focus\\:bg-red-300:focus{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.sm\\:focus\\:bg-red-400:focus{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.sm\\:focus\\:bg-red-500:focus{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.sm\\:focus\\:bg-red-600:focus{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.sm\\:focus\\:bg-red-700:focus{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.sm\\:focus\\:bg-red-800:focus{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.sm\\:focus\\:bg-red-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.sm\\:focus\\:bg-orange-50:focus{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.sm\\:focus\\:bg-orange-100:focus{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.sm\\:focus\\:bg-orange-200:focus{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.sm\\:focus\\:bg-orange-300:focus{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.sm\\:focus\\:bg-orange-400:focus{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.sm\\:focus\\:bg-orange-500:focus{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.sm\\:focus\\:bg-orange-600:focus{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.sm\\:focus\\:bg-orange-700:focus{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.sm\\:focus\\:bg-orange-800:focus{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.sm\\:focus\\:bg-orange-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.sm\\:focus\\:bg-yellow-50:focus{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.sm\\:focus\\:bg-yellow-100:focus{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.sm\\:focus\\:bg-yellow-200:focus{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.sm\\:focus\\:bg-yellow-300:focus{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.sm\\:focus\\:bg-yellow-400:focus{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.sm\\:focus\\:bg-yellow-500:focus{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.sm\\:focus\\:bg-yellow-600:focus{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.sm\\:focus\\:bg-yellow-700:focus{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.sm\\:focus\\:bg-yellow-800:focus{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.sm\\:focus\\:bg-yellow-900:focus{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.sm\\:focus\\:bg-green-50:focus{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.sm\\:focus\\:bg-green-100:focus{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.sm\\:focus\\:bg-green-200:focus{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.sm\\:focus\\:bg-green-300:focus{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.sm\\:focus\\:bg-green-400:focus{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.sm\\:focus\\:bg-green-500:focus{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.sm\\:focus\\:bg-green-600:focus{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.sm\\:focus\\:bg-green-700:focus{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.sm\\:focus\\:bg-green-800:focus{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.sm\\:focus\\:bg-green-900:focus{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.sm\\:focus\\:bg-teal-50:focus{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.sm\\:focus\\:bg-teal-100:focus{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.sm\\:focus\\:bg-teal-200:focus{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.sm\\:focus\\:bg-teal-300:focus{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.sm\\:focus\\:bg-teal-400:focus{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.sm\\:focus\\:bg-teal-500:focus{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.sm\\:focus\\:bg-teal-600:focus{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.sm\\:focus\\:bg-teal-700:focus{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.sm\\:focus\\:bg-teal-800:focus{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.sm\\:focus\\:bg-teal-900:focus{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.sm\\:focus\\:bg-blue-50:focus{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.sm\\:focus\\:bg-blue-100:focus{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.sm\\:focus\\:bg-blue-200:focus{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.sm\\:focus\\:bg-blue-300:focus{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.sm\\:focus\\:bg-blue-400:focus{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.sm\\:focus\\:bg-blue-500:focus{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.sm\\:focus\\:bg-blue-600:focus{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.sm\\:focus\\:bg-blue-700:focus{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.sm\\:focus\\:bg-blue-800:focus{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.sm\\:focus\\:bg-blue-900:focus{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.sm\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.sm\\:focus\\:bg-pink-50:focus{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.sm\\:focus\\:bg-pink-100:focus{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.sm\\:focus\\:bg-pink-200:focus{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.sm\\:focus\\:bg-pink-300:focus{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.sm\\:focus\\:bg-pink-400:focus{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.sm\\:focus\\:bg-pink-500:focus{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.sm\\:focus\\:bg-pink-600:focus{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.sm\\:focus\\:bg-pink-700:focus{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.sm\\:focus\\:bg-pink-800:focus{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.sm\\:focus\\:bg-pink-900:focus{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.sm\\:active\\:bg-transparent:active{background-color:initial}.sm\\:active\\:bg-white:active{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.sm\\:active\\:bg-black:active{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.sm\\:active\\:bg-gray-50:active{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.sm\\:active\\:bg-gray-100:active{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.sm\\:active\\:bg-gray-200:active{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.sm\\:active\\:bg-gray-300:active{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.sm\\:active\\:bg-gray-400:active{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.sm\\:active\\:bg-gray-500:active{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.sm\\:active\\:bg-gray-600:active{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.sm\\:active\\:bg-gray-700:active{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.sm\\:active\\:bg-gray-800:active{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.sm\\:active\\:bg-gray-900:active{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.sm\\:active\\:bg-cool-gray-50:active{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.sm\\:active\\:bg-cool-gray-100:active{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.sm\\:active\\:bg-cool-gray-200:active{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.sm\\:active\\:bg-cool-gray-300:active{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.sm\\:active\\:bg-cool-gray-400:active{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.sm\\:active\\:bg-cool-gray-500:active{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.sm\\:active\\:bg-cool-gray-600:active{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.sm\\:active\\:bg-cool-gray-700:active{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.sm\\:active\\:bg-cool-gray-800:active{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.sm\\:active\\:bg-cool-gray-900:active{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.sm\\:active\\:bg-red-50:active{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.sm\\:active\\:bg-red-100:active{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.sm\\:active\\:bg-red-200:active{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.sm\\:active\\:bg-red-300:active{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.sm\\:active\\:bg-red-400:active{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.sm\\:active\\:bg-red-500:active{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.sm\\:active\\:bg-red-600:active{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.sm\\:active\\:bg-red-700:active{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.sm\\:active\\:bg-red-800:active{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.sm\\:active\\:bg-red-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.sm\\:active\\:bg-orange-50:active{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.sm\\:active\\:bg-orange-100:active{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.sm\\:active\\:bg-orange-200:active{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.sm\\:active\\:bg-orange-300:active{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.sm\\:active\\:bg-orange-400:active{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.sm\\:active\\:bg-orange-500:active{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.sm\\:active\\:bg-orange-600:active{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.sm\\:active\\:bg-orange-700:active{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.sm\\:active\\:bg-orange-800:active{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.sm\\:active\\:bg-orange-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.sm\\:active\\:bg-yellow-50:active{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.sm\\:active\\:bg-yellow-100:active{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.sm\\:active\\:bg-yellow-200:active{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.sm\\:active\\:bg-yellow-300:active{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.sm\\:active\\:bg-yellow-400:active{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.sm\\:active\\:bg-yellow-500:active{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.sm\\:active\\:bg-yellow-600:active{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.sm\\:active\\:bg-yellow-700:active{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.sm\\:active\\:bg-yellow-800:active{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.sm\\:active\\:bg-yellow-900:active{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.sm\\:active\\:bg-green-50:active{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.sm\\:active\\:bg-green-100:active{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.sm\\:active\\:bg-green-200:active{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.sm\\:active\\:bg-green-300:active{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.sm\\:active\\:bg-green-400:active{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.sm\\:active\\:bg-green-500:active{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.sm\\:active\\:bg-green-600:active{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.sm\\:active\\:bg-green-700:active{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.sm\\:active\\:bg-green-800:active{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.sm\\:active\\:bg-green-900:active{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.sm\\:active\\:bg-teal-50:active{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.sm\\:active\\:bg-teal-100:active{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.sm\\:active\\:bg-teal-200:active{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.sm\\:active\\:bg-teal-300:active{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.sm\\:active\\:bg-teal-400:active{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.sm\\:active\\:bg-teal-500:active{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.sm\\:active\\:bg-teal-600:active{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.sm\\:active\\:bg-teal-700:active{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.sm\\:active\\:bg-teal-800:active{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.sm\\:active\\:bg-teal-900:active{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.sm\\:active\\:bg-blue-50:active{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.sm\\:active\\:bg-blue-100:active{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.sm\\:active\\:bg-blue-200:active{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.sm\\:active\\:bg-blue-300:active{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.sm\\:active\\:bg-blue-400:active{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.sm\\:active\\:bg-blue-500:active{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.sm\\:active\\:bg-blue-600:active{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.sm\\:active\\:bg-blue-700:active{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.sm\\:active\\:bg-blue-800:active{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.sm\\:active\\:bg-blue-900:active{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.sm\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.sm\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.sm\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.sm\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.sm\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.sm\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.sm\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.sm\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.sm\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.sm\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.sm\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.sm\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.sm\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.sm\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.sm\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.sm\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.sm\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.sm\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.sm\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.sm\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.sm\\:active\\:bg-pink-50:active{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.sm\\:active\\:bg-pink-100:active{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.sm\\:active\\:bg-pink-200:active{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.sm\\:active\\:bg-pink-300:active{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.sm\\:active\\:bg-pink-400:active{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.sm\\:active\\:bg-pink-500:active{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.sm\\:active\\:bg-pink-600:active{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.sm\\:active\\:bg-pink-700:active{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.sm\\:active\\:bg-pink-800:active{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.sm\\:active\\:bg-pink-900:active{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.sm\\:odd\\:bg-transparent:nth-child(odd){background-color:initial}.sm\\:odd\\:bg-white:nth-child(odd){--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.sm\\:odd\\:bg-black:nth-child(odd){--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.sm\\:odd\\:bg-gray-50:nth-child(odd){--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.sm\\:odd\\:bg-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.sm\\:odd\\:bg-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.sm\\:odd\\:bg-gray-300:nth-child(odd){--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.sm\\:odd\\:bg-gray-400:nth-child(odd){--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.sm\\:odd\\:bg-gray-500:nth-child(odd){--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.sm\\:odd\\:bg-gray-600:nth-child(odd){--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.sm\\:odd\\:bg-gray-700:nth-child(odd){--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.sm\\:odd\\:bg-gray-800:nth-child(odd){--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.sm\\:odd\\:bg-gray-900:nth-child(odd){--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.sm\\:odd\\:bg-cool-gray-50:nth-child(odd){--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.sm\\:odd\\:bg-cool-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.sm\\:odd\\:bg-cool-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.sm\\:odd\\:bg-cool-gray-300:nth-child(odd){--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.sm\\:odd\\:bg-cool-gray-400:nth-child(odd){--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.sm\\:odd\\:bg-cool-gray-500:nth-child(odd){--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.sm\\:odd\\:bg-cool-gray-600:nth-child(odd){--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.sm\\:odd\\:bg-cool-gray-700:nth-child(odd){--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.sm\\:odd\\:bg-cool-gray-800:nth-child(odd){--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.sm\\:odd\\:bg-cool-gray-900:nth-child(odd){--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.sm\\:odd\\:bg-red-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.sm\\:odd\\:bg-red-100:nth-child(odd){--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.sm\\:odd\\:bg-red-200:nth-child(odd){--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.sm\\:odd\\:bg-red-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.sm\\:odd\\:bg-red-400:nth-child(odd){--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.sm\\:odd\\:bg-red-500:nth-child(odd){--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.sm\\:odd\\:bg-red-600:nth-child(odd){--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.sm\\:odd\\:bg-red-700:nth-child(odd){--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.sm\\:odd\\:bg-red-800:nth-child(odd){--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.sm\\:odd\\:bg-red-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.sm\\:odd\\:bg-orange-50:nth-child(odd){--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.sm\\:odd\\:bg-orange-100:nth-child(odd){--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.sm\\:odd\\:bg-orange-200:nth-child(odd){--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.sm\\:odd\\:bg-orange-300:nth-child(odd){--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.sm\\:odd\\:bg-orange-400:nth-child(odd){--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.sm\\:odd\\:bg-orange-500:nth-child(odd){--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.sm\\:odd\\:bg-orange-600:nth-child(odd){--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.sm\\:odd\\:bg-orange-700:nth-child(odd){--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.sm\\:odd\\:bg-orange-800:nth-child(odd){--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.sm\\:odd\\:bg-orange-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.sm\\:odd\\:bg-yellow-50:nth-child(odd){--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.sm\\:odd\\:bg-yellow-100:nth-child(odd){--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.sm\\:odd\\:bg-yellow-200:nth-child(odd){--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.sm\\:odd\\:bg-yellow-300:nth-child(odd){--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.sm\\:odd\\:bg-yellow-400:nth-child(odd){--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.sm\\:odd\\:bg-yellow-500:nth-child(odd){--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.sm\\:odd\\:bg-yellow-600:nth-child(odd){--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.sm\\:odd\\:bg-yellow-700:nth-child(odd){--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.sm\\:odd\\:bg-yellow-800:nth-child(odd){--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.sm\\:odd\\:bg-yellow-900:nth-child(odd){--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.sm\\:odd\\:bg-green-50:nth-child(odd){--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.sm\\:odd\\:bg-green-100:nth-child(odd){--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.sm\\:odd\\:bg-green-200:nth-child(odd){--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.sm\\:odd\\:bg-green-300:nth-child(odd){--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.sm\\:odd\\:bg-green-400:nth-child(odd){--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.sm\\:odd\\:bg-green-500:nth-child(odd){--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.sm\\:odd\\:bg-green-600:nth-child(odd){--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.sm\\:odd\\:bg-green-700:nth-child(odd){--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.sm\\:odd\\:bg-green-800:nth-child(odd){--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.sm\\:odd\\:bg-green-900:nth-child(odd){--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.sm\\:odd\\:bg-teal-50:nth-child(odd){--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.sm\\:odd\\:bg-teal-100:nth-child(odd){--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.sm\\:odd\\:bg-teal-200:nth-child(odd){--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.sm\\:odd\\:bg-teal-300:nth-child(odd){--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.sm\\:odd\\:bg-teal-400:nth-child(odd){--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.sm\\:odd\\:bg-teal-500:nth-child(odd){--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.sm\\:odd\\:bg-teal-600:nth-child(odd){--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.sm\\:odd\\:bg-teal-700:nth-child(odd){--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.sm\\:odd\\:bg-teal-800:nth-child(odd){--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.sm\\:odd\\:bg-teal-900:nth-child(odd){--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.sm\\:odd\\:bg-blue-50:nth-child(odd){--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.sm\\:odd\\:bg-blue-100:nth-child(odd){--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.sm\\:odd\\:bg-blue-200:nth-child(odd){--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.sm\\:odd\\:bg-blue-300:nth-child(odd){--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.sm\\:odd\\:bg-blue-400:nth-child(odd){--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.sm\\:odd\\:bg-blue-500:nth-child(odd){--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.sm\\:odd\\:bg-blue-600:nth-child(odd){--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.sm\\:odd\\:bg-blue-700:nth-child(odd){--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.sm\\:odd\\:bg-blue-800:nth-child(odd){--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.sm\\:odd\\:bg-blue-900:nth-child(odd){--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.sm\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.sm\\:odd\\:bg-pink-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.sm\\:odd\\:bg-pink-100:nth-child(odd){--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.sm\\:odd\\:bg-pink-200:nth-child(odd){--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.sm\\:odd\\:bg-pink-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.sm\\:odd\\:bg-pink-400:nth-child(odd){--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.sm\\:odd\\:bg-pink-500:nth-child(odd){--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.sm\\:odd\\:bg-pink-600:nth-child(odd){--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.sm\\:odd\\:bg-pink-700:nth-child(odd){--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.sm\\:odd\\:bg-pink-800:nth-child(odd){--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.sm\\:odd\\:bg-pink-900:nth-child(odd){--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-transparent{background-color:initial}.theme-dark .sm\\:dark\\:bg-white{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-black{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-gray-50{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-gray-100{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-gray-200{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-gray-300{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-gray-400{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-gray-500{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-gray-600{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-gray-700{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-gray-800{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-gray-900{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-cool-gray-50{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-cool-gray-100{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-cool-gray-200{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-cool-gray-300{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-cool-gray-400{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-cool-gray-500{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-cool-gray-600{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-cool-gray-700{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-cool-gray-800{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-cool-gray-900{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-red-50{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-red-100{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-red-200{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-red-300{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-red-400{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-red-500{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-red-600{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-red-700{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-red-800{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-red-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-orange-50{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-orange-100{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-orange-200{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-orange-300{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-orange-400{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-orange-500{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-orange-600{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-orange-700{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-orange-800{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-orange-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-yellow-50{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-yellow-100{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-yellow-200{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-yellow-300{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-yellow-400{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-yellow-500{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-yellow-600{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-yellow-700{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-yellow-800{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-yellow-900{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-green-50{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-green-100{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-green-200{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-green-300{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-green-400{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-green-500{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-green-600{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-green-700{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-green-800{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-green-900{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-teal-50{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-teal-100{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-teal-200{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-teal-300{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-teal-400{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-teal-500{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-teal-600{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-teal-700{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-teal-800{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-teal-900{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-blue-50{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-blue-100{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-blue-200{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-blue-300{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-blue-400{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-blue-500{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-blue-600{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-blue-700{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-blue-800{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-blue-900{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-50{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-100{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-200{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-300{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-400{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-500{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-600{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-700{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-800{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-900{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-50{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-100{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-200{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-300{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-400{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-500{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-600{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-700{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-800{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-indigo-900{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-pink-50{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-pink-100{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-pink-200{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-pink-300{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-pink-400{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-pink-500{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-pink-600{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-pink-700{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-pink-800{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .sm\\:dark\\:bg-pink-900{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-transparent:hover{background-color:initial}.theme-dark .sm\\:dark\\:hover\\:bg-white:hover{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-black:hover{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-gray-50:hover{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-gray-100:hover{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-gray-200:hover{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-gray-300:hover{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-gray-400:hover{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-gray-500:hover{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-gray-600:hover{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-gray-700:hover{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-gray-800:hover{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-gray-900:hover{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-50:hover{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-100:hover{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-200:hover{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-300:hover{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-400:hover{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-500:hover{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-600:hover{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-700:hover{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-800:hover{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-cool-gray-900:hover{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-red-50:hover{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-red-100:hover{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-red-200:hover{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-red-300:hover{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-red-400:hover{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-red-500:hover{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-red-600:hover{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-red-700:hover{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-red-800:hover{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-red-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-orange-50:hover{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-orange-100:hover{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-orange-200:hover{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-orange-300:hover{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-orange-400:hover{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-orange-500:hover{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-orange-600:hover{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-orange-700:hover{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-orange-800:hover{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-orange-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-yellow-50:hover{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-yellow-100:hover{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-yellow-200:hover{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-yellow-300:hover{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-yellow-400:hover{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-yellow-500:hover{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-yellow-600:hover{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-yellow-700:hover{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-yellow-800:hover{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-yellow-900:hover{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-green-50:hover{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-green-100:hover{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-green-200:hover{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-green-300:hover{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-green-400:hover{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-green-500:hover{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-green-600:hover{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-green-700:hover{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-green-800:hover{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-green-900:hover{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-teal-50:hover{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-teal-100:hover{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-teal-200:hover{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-teal-300:hover{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-teal-400:hover{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-teal-500:hover{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-teal-600:hover{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-teal-700:hover{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-teal-800:hover{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-teal-900:hover{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-blue-50:hover{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-blue-100:hover{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-blue-200:hover{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-blue-300:hover{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-blue-400:hover{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-blue-500:hover{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-blue-600:hover{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-blue-700:hover{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-blue-800:hover{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-blue-900:hover{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-pink-50:hover{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-pink-100:hover{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-pink-200:hover{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-pink-300:hover{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-pink-400:hover{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-pink-500:hover{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-pink-600:hover{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-pink-700:hover{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-pink-800:hover{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .sm\\:dark\\:hover\\:bg-pink-900:hover{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-transparent:focus{background-color:initial}.theme-dark .sm\\:dark\\:focus\\:bg-white:focus{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-black:focus{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-gray-50:focus{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-gray-100:focus{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-gray-200:focus{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-gray-300:focus{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-gray-400:focus{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-gray-500:focus{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-gray-600:focus{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-gray-700:focus{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-gray-800:focus{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-gray-900:focus{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-50:focus{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-100:focus{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-200:focus{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-300:focus{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-400:focus{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-500:focus{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-600:focus{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-700:focus{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-800:focus{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-cool-gray-900:focus{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-red-50:focus{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-red-100:focus{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-red-200:focus{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-red-300:focus{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-red-400:focus{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-red-500:focus{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-red-600:focus{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-red-700:focus{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-red-800:focus{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-red-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-orange-50:focus{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-orange-100:focus{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-orange-200:focus{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-orange-300:focus{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-orange-400:focus{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-orange-500:focus{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-orange-600:focus{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-orange-700:focus{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-orange-800:focus{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-orange-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-yellow-50:focus{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-yellow-100:focus{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-yellow-200:focus{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-yellow-300:focus{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-yellow-400:focus{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-yellow-500:focus{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-yellow-600:focus{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-yellow-700:focus{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-yellow-800:focus{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-yellow-900:focus{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-green-50:focus{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-green-100:focus{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-green-200:focus{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-green-300:focus{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-green-400:focus{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-green-500:focus{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-green-600:focus{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-green-700:focus{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-green-800:focus{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-green-900:focus{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-teal-50:focus{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-teal-100:focus{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-teal-200:focus{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-teal-300:focus{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-teal-400:focus{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-teal-500:focus{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-teal-600:focus{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-teal-700:focus{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-teal-800:focus{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-teal-900:focus{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-blue-50:focus{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-blue-100:focus{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-blue-200:focus{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-blue-300:focus{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-blue-400:focus{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-blue-500:focus{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-blue-600:focus{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-blue-700:focus{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-blue-800:focus{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-blue-900:focus{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-pink-50:focus{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-pink-100:focus{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-pink-200:focus{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-pink-300:focus{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-pink-400:focus{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-pink-500:focus{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-pink-600:focus{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-pink-700:focus{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-pink-800:focus{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .sm\\:dark\\:focus\\:bg-pink-900:focus{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-transparent:active{background-color:initial}.theme-dark .sm\\:dark\\:active\\:bg-white:active{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-black:active{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-gray-50:active{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-gray-100:active{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-gray-200:active{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-gray-300:active{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-gray-400:active{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-gray-500:active{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-gray-600:active{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-gray-700:active{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-gray-800:active{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-gray-900:active{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-cool-gray-50:active{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-cool-gray-100:active{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-cool-gray-200:active{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-cool-gray-300:active{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-cool-gray-400:active{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-cool-gray-500:active{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-cool-gray-600:active{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-cool-gray-700:active{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-cool-gray-800:active{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-cool-gray-900:active{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-red-50:active{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-red-100:active{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-red-200:active{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-red-300:active{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-red-400:active{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-red-500:active{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-red-600:active{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-red-700:active{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-red-800:active{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-red-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-orange-50:active{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-orange-100:active{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-orange-200:active{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-orange-300:active{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-orange-400:active{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-orange-500:active{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-orange-600:active{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-orange-700:active{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-orange-800:active{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-orange-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-yellow-50:active{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-yellow-100:active{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-yellow-200:active{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-yellow-300:active{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-yellow-400:active{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-yellow-500:active{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-yellow-600:active{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-yellow-700:active{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-yellow-800:active{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-yellow-900:active{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-green-50:active{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-green-100:active{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-green-200:active{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-green-300:active{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-green-400:active{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-green-500:active{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-green-600:active{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-green-700:active{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-green-800:active{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-green-900:active{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-teal-50:active{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-teal-100:active{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-teal-200:active{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-teal-300:active{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-teal-400:active{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-teal-500:active{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-teal-600:active{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-teal-700:active{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-teal-800:active{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-teal-900:active{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-blue-50:active{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-blue-100:active{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-blue-200:active{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-blue-300:active{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-blue-400:active{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-blue-500:active{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-blue-600:active{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-blue-700:active{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-blue-800:active{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-blue-900:active{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-pink-50:active{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-pink-100:active{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-pink-200:active{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-pink-300:active{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-pink-400:active{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-pink-500:active{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-pink-600:active{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-pink-700:active{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-pink-800:active{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .sm\\:dark\\:active\\:bg-pink-900:active{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-transparent:nth-child(odd){background-color:initial}.theme-dark .sm\\:dark\\:odd\\:bg-white:nth-child(odd){--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-black:nth-child(odd){--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-gray-50:nth-child(odd){--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-gray-300:nth-child(odd){--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-gray-400:nth-child(odd){--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-gray-500:nth-child(odd){--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-gray-600:nth-child(odd){--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-gray-700:nth-child(odd){--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-gray-800:nth-child(odd){--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-gray-900:nth-child(odd){--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-50:nth-child(odd){--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-300:nth-child(odd){--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-400:nth-child(odd){--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-500:nth-child(odd){--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-600:nth-child(odd){--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-700:nth-child(odd){--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-800:nth-child(odd){--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-cool-gray-900:nth-child(odd){--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-red-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-red-100:nth-child(odd){--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-red-200:nth-child(odd){--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-red-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-red-400:nth-child(odd){--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-red-500:nth-child(odd){--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-red-600:nth-child(odd){--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-red-700:nth-child(odd){--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-red-800:nth-child(odd){--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-red-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-orange-50:nth-child(odd){--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-orange-100:nth-child(odd){--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-orange-200:nth-child(odd){--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-orange-300:nth-child(odd){--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-orange-400:nth-child(odd){--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-orange-500:nth-child(odd){--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-orange-600:nth-child(odd){--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-orange-700:nth-child(odd){--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-orange-800:nth-child(odd){--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-orange-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-yellow-50:nth-child(odd){--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-yellow-100:nth-child(odd){--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-yellow-200:nth-child(odd){--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-yellow-300:nth-child(odd){--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-yellow-400:nth-child(odd){--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-yellow-500:nth-child(odd){--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-yellow-600:nth-child(odd){--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-yellow-700:nth-child(odd){--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-yellow-800:nth-child(odd){--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-yellow-900:nth-child(odd){--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-green-50:nth-child(odd){--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-green-100:nth-child(odd){--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-green-200:nth-child(odd){--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-green-300:nth-child(odd){--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-green-400:nth-child(odd){--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-green-500:nth-child(odd){--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-green-600:nth-child(odd){--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-green-700:nth-child(odd){--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-green-800:nth-child(odd){--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-green-900:nth-child(odd){--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-teal-50:nth-child(odd){--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-teal-100:nth-child(odd){--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-teal-200:nth-child(odd){--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-teal-300:nth-child(odd){--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-teal-400:nth-child(odd){--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-teal-500:nth-child(odd){--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-teal-600:nth-child(odd){--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-teal-700:nth-child(odd){--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-teal-800:nth-child(odd){--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-teal-900:nth-child(odd){--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-blue-50:nth-child(odd){--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-blue-100:nth-child(odd){--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-blue-200:nth-child(odd){--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-blue-300:nth-child(odd){--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-blue-400:nth-child(odd){--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-blue-500:nth-child(odd){--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-blue-600:nth-child(odd){--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-blue-700:nth-child(odd){--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-blue-800:nth-child(odd){--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-blue-900:nth-child(odd){--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-pink-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-pink-100:nth-child(odd){--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-pink-200:nth-child(odd){--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-pink-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-pink-400:nth-child(odd){--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-pink-500:nth-child(odd){--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-pink-600:nth-child(odd){--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-pink-700:nth-child(odd){--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-pink-800:nth-child(odd){--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .sm\\:dark\\:odd\\:bg-pink-900:nth-child(odd){--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.sm\\:bg-opacity-0{--bg-opacity:0}.sm\\:bg-opacity-10{--bg-opacity:0.1}.sm\\:bg-opacity-25{--bg-opacity:0.25}.sm\\:bg-opacity-50{--bg-opacity:0.5}.sm\\:bg-opacity-75{--bg-opacity:0.75}.sm\\:bg-opacity-100{--bg-opacity:1}.sm\\:hover\\:bg-opacity-0:hover{--bg-opacity:0}.sm\\:hover\\:bg-opacity-10:hover{--bg-opacity:0.1}.sm\\:hover\\:bg-opacity-25:hover{--bg-opacity:0.25}.sm\\:hover\\:bg-opacity-50:hover{--bg-opacity:0.5}.sm\\:hover\\:bg-opacity-75:hover{--bg-opacity:0.75}.sm\\:hover\\:bg-opacity-100:hover{--bg-opacity:1}.sm\\:focus\\:bg-opacity-0:focus{--bg-opacity:0}.sm\\:focus\\:bg-opacity-10:focus{--bg-opacity:0.1}.sm\\:focus\\:bg-opacity-25:focus{--bg-opacity:0.25}.sm\\:focus\\:bg-opacity-50:focus{--bg-opacity:0.5}.sm\\:focus\\:bg-opacity-75:focus{--bg-opacity:0.75}.sm\\:focus\\:bg-opacity-100:focus{--bg-opacity:1}.theme-dark .sm\\:dark\\:hover\\:bg-opacity-0:hover{--bg-opacity:0}.theme-dark .sm\\:dark\\:hover\\:bg-opacity-10:hover{--bg-opacity:0.1}.theme-dark .sm\\:dark\\:hover\\:bg-opacity-25:hover{--bg-opacity:0.25}.theme-dark .sm\\:dark\\:hover\\:bg-opacity-50:hover{--bg-opacity:0.5}.theme-dark .sm\\:dark\\:hover\\:bg-opacity-75:hover{--bg-opacity:0.75}.theme-dark .sm\\:dark\\:hover\\:bg-opacity-100:hover{--bg-opacity:1}.sm\\:bg-bottom{background-position:bottom}.sm\\:bg-center{background-position:50%}.sm\\:bg-left{background-position:0}.sm\\:bg-left-bottom{background-position:0 100%}.sm\\:bg-left-top{background-position:0 0}.sm\\:bg-right{background-position:100%}.sm\\:bg-right-bottom{background-position:100% 100%}.sm\\:bg-right-top{background-position:100% 0}.sm\\:bg-top{background-position:top}.sm\\:bg-repeat{background-repeat:repeat}.sm\\:bg-no-repeat{background-repeat:no-repeat}.sm\\:bg-repeat-x{background-repeat:repeat-x}.sm\\:bg-repeat-y{background-repeat:repeat-y}.sm\\:bg-repeat-round{background-repeat:round}.sm\\:bg-repeat-space{background-repeat:space}.sm\\:bg-auto{background-size:auto}.sm\\:bg-cover{background-size:cover}.sm\\:bg-contain{background-size:contain}.sm\\:border-collapse{border-collapse:collapse}.sm\\:border-separate{border-collapse:initial}.sm\\:border-transparent{border-color:#0000}.sm\\:border-white{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.sm\\:border-black{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.sm\\:border-gray-50{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.sm\\:border-gray-100{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.sm\\:border-gray-200{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.sm\\:border-gray-300{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.sm\\:border-gray-400{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.sm\\:border-gray-500{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.sm\\:border-gray-600{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.sm\\:border-gray-700{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.sm\\:border-gray-800{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.sm\\:border-gray-900{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.sm\\:border-cool-gray-50{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.sm\\:border-cool-gray-100{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.sm\\:border-cool-gray-200{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.sm\\:border-cool-gray-300{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.sm\\:border-cool-gray-400{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.sm\\:border-cool-gray-500{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.sm\\:border-cool-gray-600{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.sm\\:border-cool-gray-700{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.sm\\:border-cool-gray-800{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.sm\\:border-cool-gray-900{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.sm\\:border-red-50{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.sm\\:border-red-100{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.sm\\:border-red-200{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.sm\\:border-red-300{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.sm\\:border-red-400{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.sm\\:border-red-500{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.sm\\:border-red-600{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.sm\\:border-red-700{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.sm\\:border-red-800{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.sm\\:border-red-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.sm\\:border-orange-50{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.sm\\:border-orange-100{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.sm\\:border-orange-200{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.sm\\:border-orange-300{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.sm\\:border-orange-400{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.sm\\:border-orange-500{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.sm\\:border-orange-600{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.sm\\:border-orange-700{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.sm\\:border-orange-800{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.sm\\:border-orange-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.sm\\:border-yellow-50{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.sm\\:border-yellow-100{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.sm\\:border-yellow-200{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.sm\\:border-yellow-300{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.sm\\:border-yellow-400{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.sm\\:border-yellow-500{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.sm\\:border-yellow-600{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.sm\\:border-yellow-700{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.sm\\:border-yellow-800{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.sm\\:border-yellow-900{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.sm\\:border-green-50{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.sm\\:border-green-100{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.sm\\:border-green-200{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.sm\\:border-green-300{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.sm\\:border-green-400{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.sm\\:border-green-500{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.sm\\:border-green-600{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.sm\\:border-green-700{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.sm\\:border-green-800{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.sm\\:border-green-900{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.sm\\:border-teal-50{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.sm\\:border-teal-100{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.sm\\:border-teal-200{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.sm\\:border-teal-300{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.sm\\:border-teal-400{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.sm\\:border-teal-500{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.sm\\:border-teal-600{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.sm\\:border-teal-700{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.sm\\:border-teal-800{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.sm\\:border-teal-900{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.sm\\:border-blue-50{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.sm\\:border-blue-100{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.sm\\:border-blue-200{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.sm\\:border-blue-300{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.sm\\:border-blue-400{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.sm\\:border-blue-500{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.sm\\:border-blue-600{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.sm\\:border-blue-700{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.sm\\:border-blue-800{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.sm\\:border-blue-900{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.sm\\:border-indigo-50{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.sm\\:border-indigo-100{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.sm\\:border-indigo-200{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.sm\\:border-indigo-300{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.sm\\:border-indigo-400{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.sm\\:border-indigo-500{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.sm\\:border-indigo-600{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.sm\\:border-indigo-700{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.sm\\:border-indigo-800{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.sm\\:border-indigo-900{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.sm\\:border-indigo-50{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.sm\\:border-indigo-100{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.sm\\:border-indigo-200{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.sm\\:border-indigo-300{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.sm\\:border-indigo-400{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.sm\\:border-indigo-500{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.sm\\:border-indigo-600{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.sm\\:border-indigo-700{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.sm\\:border-indigo-800{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.sm\\:border-indigo-900{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.sm\\:border-pink-50{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.sm\\:border-pink-100{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.sm\\:border-pink-200{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.sm\\:border-pink-300{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.sm\\:border-pink-400{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.sm\\:border-pink-500{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.sm\\:border-pink-600{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.sm\\:border-pink-700{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.sm\\:border-pink-800{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.sm\\:border-pink-900{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.sm\\:hover\\:border-transparent:hover{border-color:#0000}.sm\\:hover\\:border-white:hover{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.sm\\:hover\\:border-black:hover{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.sm\\:hover\\:border-gray-50:hover{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.sm\\:hover\\:border-gray-100:hover{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.sm\\:hover\\:border-gray-200:hover{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.sm\\:hover\\:border-gray-300:hover{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.sm\\:hover\\:border-gray-400:hover{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.sm\\:hover\\:border-gray-500:hover{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.sm\\:hover\\:border-gray-600:hover{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.sm\\:hover\\:border-gray-700:hover{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.sm\\:hover\\:border-gray-800:hover{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.sm\\:hover\\:border-gray-900:hover{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.sm\\:hover\\:border-cool-gray-50:hover{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.sm\\:hover\\:border-cool-gray-100:hover{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.sm\\:hover\\:border-cool-gray-200:hover{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.sm\\:hover\\:border-cool-gray-300:hover{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.sm\\:hover\\:border-cool-gray-400:hover{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.sm\\:hover\\:border-cool-gray-500:hover{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.sm\\:hover\\:border-cool-gray-600:hover{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.sm\\:hover\\:border-cool-gray-700:hover{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.sm\\:hover\\:border-cool-gray-800:hover{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.sm\\:hover\\:border-cool-gray-900:hover{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.sm\\:hover\\:border-red-50:hover{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.sm\\:hover\\:border-red-100:hover{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.sm\\:hover\\:border-red-200:hover{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.sm\\:hover\\:border-red-300:hover{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.sm\\:hover\\:border-red-400:hover{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.sm\\:hover\\:border-red-500:hover{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.sm\\:hover\\:border-red-600:hover{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.sm\\:hover\\:border-red-700:hover{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.sm\\:hover\\:border-red-800:hover{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.sm\\:hover\\:border-red-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.sm\\:hover\\:border-orange-50:hover{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.sm\\:hover\\:border-orange-100:hover{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.sm\\:hover\\:border-orange-200:hover{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.sm\\:hover\\:border-orange-300:hover{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.sm\\:hover\\:border-orange-400:hover{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.sm\\:hover\\:border-orange-500:hover{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.sm\\:hover\\:border-orange-600:hover{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.sm\\:hover\\:border-orange-700:hover{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.sm\\:hover\\:border-orange-800:hover{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.sm\\:hover\\:border-orange-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.sm\\:hover\\:border-yellow-50:hover{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.sm\\:hover\\:border-yellow-100:hover{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.sm\\:hover\\:border-yellow-200:hover{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.sm\\:hover\\:border-yellow-300:hover{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.sm\\:hover\\:border-yellow-400:hover{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.sm\\:hover\\:border-yellow-500:hover{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.sm\\:hover\\:border-yellow-600:hover{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.sm\\:hover\\:border-yellow-700:hover{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.sm\\:hover\\:border-yellow-800:hover{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.sm\\:hover\\:border-yellow-900:hover{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.sm\\:hover\\:border-green-50:hover{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.sm\\:hover\\:border-green-100:hover{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.sm\\:hover\\:border-green-200:hover{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.sm\\:hover\\:border-green-300:hover{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.sm\\:hover\\:border-green-400:hover{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.sm\\:hover\\:border-green-500:hover{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.sm\\:hover\\:border-green-600:hover{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.sm\\:hover\\:border-green-700:hover{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.sm\\:hover\\:border-green-800:hover{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.sm\\:hover\\:border-green-900:hover{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.sm\\:hover\\:border-teal-50:hover{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.sm\\:hover\\:border-teal-100:hover{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.sm\\:hover\\:border-teal-200:hover{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.sm\\:hover\\:border-teal-300:hover{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.sm\\:hover\\:border-teal-400:hover{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.sm\\:hover\\:border-teal-500:hover{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.sm\\:hover\\:border-teal-600:hover{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.sm\\:hover\\:border-teal-700:hover{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.sm\\:hover\\:border-teal-800:hover{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.sm\\:hover\\:border-teal-900:hover{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.sm\\:hover\\:border-blue-50:hover{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.sm\\:hover\\:border-blue-100:hover{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.sm\\:hover\\:border-blue-200:hover{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.sm\\:hover\\:border-blue-300:hover{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.sm\\:hover\\:border-blue-400:hover{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.sm\\:hover\\:border-blue-500:hover{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.sm\\:hover\\:border-blue-600:hover{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.sm\\:hover\\:border-blue-700:hover{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.sm\\:hover\\:border-blue-800:hover{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.sm\\:hover\\:border-blue-900:hover{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.sm\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.sm\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.sm\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.sm\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.sm\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.sm\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.sm\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.sm\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.sm\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.sm\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.sm\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.sm\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.sm\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.sm\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.sm\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.sm\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.sm\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.sm\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.sm\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.sm\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.sm\\:hover\\:border-pink-50:hover{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.sm\\:hover\\:border-pink-100:hover{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.sm\\:hover\\:border-pink-200:hover{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.sm\\:hover\\:border-pink-300:hover{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.sm\\:hover\\:border-pink-400:hover{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.sm\\:hover\\:border-pink-500:hover{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.sm\\:hover\\:border-pink-600:hover{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.sm\\:hover\\:border-pink-700:hover{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.sm\\:hover\\:border-pink-800:hover{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.sm\\:hover\\:border-pink-900:hover{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.sm\\:focus\\:border-transparent:focus{border-color:#0000}.sm\\:focus\\:border-white:focus{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.sm\\:focus\\:border-black:focus{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.sm\\:focus\\:border-gray-50:focus{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.sm\\:focus\\:border-gray-100:focus{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.sm\\:focus\\:border-gray-200:focus{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.sm\\:focus\\:border-gray-300:focus{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.sm\\:focus\\:border-gray-400:focus{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.sm\\:focus\\:border-gray-500:focus{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.sm\\:focus\\:border-gray-600:focus{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.sm\\:focus\\:border-gray-700:focus{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.sm\\:focus\\:border-gray-800:focus{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.sm\\:focus\\:border-gray-900:focus{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.sm\\:focus\\:border-cool-gray-50:focus{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.sm\\:focus\\:border-cool-gray-100:focus{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.sm\\:focus\\:border-cool-gray-200:focus{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.sm\\:focus\\:border-cool-gray-300:focus{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.sm\\:focus\\:border-cool-gray-400:focus{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.sm\\:focus\\:border-cool-gray-500:focus{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.sm\\:focus\\:border-cool-gray-600:focus{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.sm\\:focus\\:border-cool-gray-700:focus{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.sm\\:focus\\:border-cool-gray-800:focus{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.sm\\:focus\\:border-cool-gray-900:focus{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.sm\\:focus\\:border-red-50:focus{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.sm\\:focus\\:border-red-100:focus{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.sm\\:focus\\:border-red-200:focus{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.sm\\:focus\\:border-red-300:focus{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.sm\\:focus\\:border-red-400:focus{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.sm\\:focus\\:border-red-500:focus{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.sm\\:focus\\:border-red-600:focus{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.sm\\:focus\\:border-red-700:focus{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.sm\\:focus\\:border-red-800:focus{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.sm\\:focus\\:border-red-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.sm\\:focus\\:border-orange-50:focus{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.sm\\:focus\\:border-orange-100:focus{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.sm\\:focus\\:border-orange-200:focus{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.sm\\:focus\\:border-orange-300:focus{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.sm\\:focus\\:border-orange-400:focus{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.sm\\:focus\\:border-orange-500:focus{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.sm\\:focus\\:border-orange-600:focus{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.sm\\:focus\\:border-orange-700:focus{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.sm\\:focus\\:border-orange-800:focus{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.sm\\:focus\\:border-orange-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.sm\\:focus\\:border-yellow-50:focus{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.sm\\:focus\\:border-yellow-100:focus{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.sm\\:focus\\:border-yellow-200:focus{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.sm\\:focus\\:border-yellow-300:focus{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.sm\\:focus\\:border-yellow-400:focus{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.sm\\:focus\\:border-yellow-500:focus{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.sm\\:focus\\:border-yellow-600:focus{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.sm\\:focus\\:border-yellow-700:focus{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.sm\\:focus\\:border-yellow-800:focus{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.sm\\:focus\\:border-yellow-900:focus{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.sm\\:focus\\:border-green-50:focus{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.sm\\:focus\\:border-green-100:focus{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.sm\\:focus\\:border-green-200:focus{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.sm\\:focus\\:border-green-300:focus{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.sm\\:focus\\:border-green-400:focus{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.sm\\:focus\\:border-green-500:focus{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.sm\\:focus\\:border-green-600:focus{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.sm\\:focus\\:border-green-700:focus{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.sm\\:focus\\:border-green-800:focus{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.sm\\:focus\\:border-green-900:focus{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.sm\\:focus\\:border-teal-50:focus{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.sm\\:focus\\:border-teal-100:focus{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.sm\\:focus\\:border-teal-200:focus{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.sm\\:focus\\:border-teal-300:focus{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.sm\\:focus\\:border-teal-400:focus{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.sm\\:focus\\:border-teal-500:focus{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.sm\\:focus\\:border-teal-600:focus{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.sm\\:focus\\:border-teal-700:focus{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.sm\\:focus\\:border-teal-800:focus{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.sm\\:focus\\:border-teal-900:focus{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.sm\\:focus\\:border-blue-50:focus{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.sm\\:focus\\:border-blue-100:focus{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.sm\\:focus\\:border-blue-200:focus{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.sm\\:focus\\:border-blue-300:focus{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.sm\\:focus\\:border-blue-400:focus{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.sm\\:focus\\:border-blue-500:focus{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.sm\\:focus\\:border-blue-600:focus{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.sm\\:focus\\:border-blue-700:focus{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.sm\\:focus\\:border-blue-800:focus{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.sm\\:focus\\:border-blue-900:focus{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.sm\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.sm\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.sm\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.sm\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.sm\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.sm\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.sm\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.sm\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.sm\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.sm\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.sm\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.sm\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.sm\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.sm\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.sm\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.sm\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.sm\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.sm\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.sm\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.sm\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.sm\\:focus\\:border-pink-50:focus{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.sm\\:focus\\:border-pink-100:focus{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.sm\\:focus\\:border-pink-200:focus{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.sm\\:focus\\:border-pink-300:focus{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.sm\\:focus\\:border-pink-400:focus{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.sm\\:focus\\:border-pink-500:focus{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.sm\\:focus\\:border-pink-600:focus{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.sm\\:focus\\:border-pink-700:focus{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.sm\\:focus\\:border-pink-800:focus{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.sm\\:focus\\:border-pink-900:focus{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-transparent{border-color:#0000}.theme-dark .sm\\:dark\\:border-white{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-black{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-gray-50{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-gray-100{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-gray-200{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-gray-300{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-gray-400{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-gray-500{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-gray-600{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-gray-700{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-gray-800{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-gray-900{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-cool-gray-50{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-cool-gray-100{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-cool-gray-200{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-cool-gray-300{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-cool-gray-400{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-cool-gray-500{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-cool-gray-600{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-cool-gray-700{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-cool-gray-800{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-cool-gray-900{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-red-50{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-red-100{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-red-200{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-red-300{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-red-400{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-red-500{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-red-600{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-red-700{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-red-800{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-red-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-orange-50{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-orange-100{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-orange-200{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-orange-300{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-orange-400{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-orange-500{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-orange-600{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-orange-700{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-orange-800{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-orange-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-yellow-50{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-yellow-100{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-yellow-200{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-yellow-300{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-yellow-400{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-yellow-500{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-yellow-600{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-yellow-700{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-yellow-800{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-yellow-900{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-green-50{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-green-100{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-green-200{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-green-300{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-green-400{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-green-500{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-green-600{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-green-700{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-green-800{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-green-900{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-teal-50{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-teal-100{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-teal-200{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-teal-300{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-teal-400{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-teal-500{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-teal-600{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-teal-700{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-teal-800{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-teal-900{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-blue-50{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-blue-100{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-blue-200{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-blue-300{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-blue-400{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-blue-500{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-blue-600{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-blue-700{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-blue-800{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-blue-900{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-50{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-100{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-200{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-300{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-400{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-500{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-600{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-700{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-800{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-900{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-50{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-100{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-200{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-300{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-400{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-500{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-600{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-700{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-800{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-indigo-900{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-pink-50{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-pink-100{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-pink-200{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-pink-300{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-pink-400{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-pink-500{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-pink-600{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-pink-700{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-pink-800{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.theme-dark .sm\\:dark\\:border-pink-900{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-transparent:focus{border-color:#0000}.theme-dark .sm\\:dark\\:focus\\:border-white:focus{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-black:focus{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-gray-50:focus{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-gray-100:focus{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-gray-200:focus{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-gray-300:focus{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-gray-400:focus{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-gray-500:focus{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-gray-600:focus{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-gray-700:focus{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-gray-800:focus{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-gray-900:focus{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-cool-gray-50:focus{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-cool-gray-100:focus{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-cool-gray-200:focus{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-cool-gray-300:focus{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-cool-gray-400:focus{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-cool-gray-500:focus{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-cool-gray-600:focus{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-cool-gray-700:focus{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-cool-gray-800:focus{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-cool-gray-900:focus{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-red-50:focus{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-red-100:focus{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-red-200:focus{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-red-300:focus{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-red-400:focus{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-red-500:focus{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-red-600:focus{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-red-700:focus{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-red-800:focus{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-red-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-orange-50:focus{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-orange-100:focus{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-orange-200:focus{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-orange-300:focus{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-orange-400:focus{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-orange-500:focus{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-orange-600:focus{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-orange-700:focus{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-orange-800:focus{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-orange-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-yellow-50:focus{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-yellow-100:focus{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-yellow-200:focus{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-yellow-300:focus{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-yellow-400:focus{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-yellow-500:focus{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-yellow-600:focus{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-yellow-700:focus{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-yellow-800:focus{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-yellow-900:focus{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-green-50:focus{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-green-100:focus{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-green-200:focus{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-green-300:focus{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-green-400:focus{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-green-500:focus{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-green-600:focus{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-green-700:focus{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-green-800:focus{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-green-900:focus{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-teal-50:focus{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-teal-100:focus{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-teal-200:focus{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-teal-300:focus{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-teal-400:focus{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-teal-500:focus{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-teal-600:focus{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-teal-700:focus{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-teal-800:focus{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-teal-900:focus{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-blue-50:focus{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-blue-100:focus{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-blue-200:focus{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-blue-300:focus{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-blue-400:focus{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-blue-500:focus{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-blue-600:focus{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-blue-700:focus{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-blue-800:focus{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-blue-900:focus{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-pink-50:focus{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-pink-100:focus{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-pink-200:focus{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-pink-300:focus{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-pink-400:focus{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-pink-500:focus{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-pink-600:focus{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-pink-700:focus{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-pink-800:focus{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.theme-dark .sm\\:dark\\:focus\\:border-pink-900:focus{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-transparent:hover{border-color:#0000}.theme-dark .sm\\:dark\\:hover\\:border-white:hover{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-black:hover{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-gray-50:hover{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-gray-100:hover{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-gray-200:hover{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-gray-300:hover{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-gray-400:hover{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-gray-500:hover{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-gray-600:hover{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-gray-700:hover{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-gray-800:hover{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-gray-900:hover{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-cool-gray-50:hover{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-cool-gray-100:hover{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-cool-gray-200:hover{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-cool-gray-300:hover{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-cool-gray-400:hover{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-cool-gray-500:hover{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-cool-gray-600:hover{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-cool-gray-700:hover{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-cool-gray-800:hover{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-cool-gray-900:hover{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-red-50:hover{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-red-100:hover{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-red-200:hover{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-red-300:hover{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-red-400:hover{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-red-500:hover{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-red-600:hover{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-red-700:hover{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-red-800:hover{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-red-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-orange-50:hover{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-orange-100:hover{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-orange-200:hover{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-orange-300:hover{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-orange-400:hover{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-orange-500:hover{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-orange-600:hover{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-orange-700:hover{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-orange-800:hover{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-orange-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-yellow-50:hover{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-yellow-100:hover{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-yellow-200:hover{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-yellow-300:hover{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-yellow-400:hover{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-yellow-500:hover{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-yellow-600:hover{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-yellow-700:hover{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-yellow-800:hover{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-yellow-900:hover{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-green-50:hover{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-green-100:hover{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-green-200:hover{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-green-300:hover{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-green-400:hover{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-green-500:hover{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-green-600:hover{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-green-700:hover{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-green-800:hover{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-green-900:hover{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-teal-50:hover{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-teal-100:hover{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-teal-200:hover{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-teal-300:hover{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-teal-400:hover{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-teal-500:hover{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-teal-600:hover{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-teal-700:hover{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-teal-800:hover{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-teal-900:hover{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-blue-50:hover{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-blue-100:hover{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-blue-200:hover{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-blue-300:hover{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-blue-400:hover{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-blue-500:hover{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-blue-600:hover{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-blue-700:hover{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-blue-800:hover{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-blue-900:hover{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-pink-50:hover{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-pink-100:hover{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-pink-200:hover{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-pink-300:hover{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-pink-400:hover{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-pink-500:hover{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-pink-600:hover{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-pink-700:hover{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-pink-800:hover{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.theme-dark .sm\\:dark\\:hover\\:border-pink-900:hover{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.sm\\:border-opacity-0{--border-opacity:0}.sm\\:border-opacity-25{--border-opacity:0.25}.sm\\:border-opacity-50{--border-opacity:0.5}.sm\\:border-opacity-75{--border-opacity:0.75}.sm\\:border-opacity-100{--border-opacity:1}.sm\\:hover\\:border-opacity-0:hover{--border-opacity:0}.sm\\:hover\\:border-opacity-25:hover{--border-opacity:0.25}.sm\\:hover\\:border-opacity-50:hover{--border-opacity:0.5}.sm\\:hover\\:border-opacity-75:hover{--border-opacity:0.75}.sm\\:hover\\:border-opacity-100:hover{--border-opacity:1}.sm\\:focus\\:border-opacity-0:focus{--border-opacity:0}.sm\\:focus\\:border-opacity-25:focus{--border-opacity:0.25}.sm\\:focus\\:border-opacity-50:focus{--border-opacity:0.5}.sm\\:focus\\:border-opacity-75:focus{--border-opacity:0.75}.sm\\:focus\\:border-opacity-100:focus{--border-opacity:1}.sm\\:rounded-none{border-radius:0}.sm\\:rounded-sm{border-radius:.125rem}.sm\\:rounded{border-radius:.25rem}.sm\\:rounded-md{border-radius:.375rem}.sm\\:rounded-lg{border-radius:.5rem}.sm\\:rounded-full{border-radius:9999px}.sm\\:rounded-t-none{border-top-left-radius:0;border-top-right-radius:0}.sm\\:rounded-r-none{border-bottom-right-radius:0;border-top-right-radius:0}.sm\\:rounded-b-none{border-bottom-left-radius:0;border-bottom-right-radius:0}.sm\\:rounded-l-none{border-bottom-left-radius:0;border-top-left-radius:0}.sm\\:rounded-t-sm{border-top-left-radius:.125rem;border-top-right-radius:.125rem}.sm\\:rounded-r-sm{border-bottom-right-radius:.125rem;border-top-right-radius:.125rem}.sm\\:rounded-b-sm{border-bottom-left-radius:.125rem;border-bottom-right-radius:.125rem}.sm\\:rounded-l-sm{border-bottom-left-radius:.125rem;border-top-left-radius:.125rem}.sm\\:rounded-t{border-top-left-radius:.25rem}.sm\\:rounded-r,.sm\\:rounded-t{border-top-right-radius:.25rem}.sm\\:rounded-b,.sm\\:rounded-r{border-bottom-right-radius:.25rem}.sm\\:rounded-b,.sm\\:rounded-l{border-bottom-left-radius:.25rem}.sm\\:rounded-l{border-top-left-radius:.25rem}.sm\\:rounded-t-md{border-top-left-radius:.375rem;border-top-right-radius:.375rem}.sm\\:rounded-r-md{border-bottom-right-radius:.375rem;border-top-right-radius:.375rem}.sm\\:rounded-b-md{border-bottom-left-radius:.375rem;border-bottom-right-radius:.375rem}.sm\\:rounded-l-md{border-bottom-left-radius:.375rem;border-top-left-radius:.375rem}.sm\\:rounded-t-lg{border-top-left-radius:.5rem;border-top-right-radius:.5rem}.sm\\:rounded-r-lg{border-bottom-right-radius:.5rem;border-top-right-radius:.5rem}.sm\\:rounded-b-lg{border-bottom-left-radius:.5rem;border-bottom-right-radius:.5rem}.sm\\:rounded-l-lg{border-bottom-left-radius:.5rem;border-top-left-radius:.5rem}.sm\\:rounded-t-full{border-top-left-radius:9999px;border-top-right-radius:9999px}.sm\\:rounded-r-full{border-bottom-right-radius:9999px;border-top-right-radius:9999px}.sm\\:rounded-b-full{border-bottom-left-radius:9999px;border-bottom-right-radius:9999px}.sm\\:rounded-l-full{border-bottom-left-radius:9999px;border-top-left-radius:9999px}.sm\\:rounded-tl-none{border-top-left-radius:0}.sm\\:rounded-tr-none{border-top-right-radius:0}.sm\\:rounded-br-none{border-bottom-right-radius:0}.sm\\:rounded-bl-none{border-bottom-left-radius:0}.sm\\:rounded-tl-sm{border-top-left-radius:.125rem}.sm\\:rounded-tr-sm{border-top-right-radius:.125rem}.sm\\:rounded-br-sm{border-bottom-right-radius:.125rem}.sm\\:rounded-bl-sm{border-bottom-left-radius:.125rem}.sm\\:rounded-tl{border-top-left-radius:.25rem}.sm\\:rounded-tr{border-top-right-radius:.25rem}.sm\\:rounded-br{border-bottom-right-radius:.25rem}.sm\\:rounded-bl{border-bottom-left-radius:.25rem}.sm\\:rounded-tl-md{border-top-left-radius:.375rem}.sm\\:rounded-tr-md{border-top-right-radius:.375rem}.sm\\:rounded-br-md{border-bottom-right-radius:.375rem}.sm\\:rounded-bl-md{border-bottom-left-radius:.375rem}.sm\\:rounded-tl-lg{border-top-left-radius:.5rem}.sm\\:rounded-tr-lg{border-top-right-radius:.5rem}.sm\\:rounded-br-lg{border-bottom-right-radius:.5rem}.sm\\:rounded-bl-lg{border-bottom-left-radius:.5rem}.sm\\:rounded-tl-full{border-top-left-radius:9999px}.sm\\:rounded-tr-full{border-top-right-radius:9999px}.sm\\:rounded-br-full{border-bottom-right-radius:9999px}.sm\\:rounded-bl-full{border-bottom-left-radius:9999px}.sm\\:border-solid{border-style:solid}.sm\\:border-dashed{border-style:dashed}.sm\\:border-dotted{border-style:dotted}.sm\\:border-double{border-style:double}.sm\\:border-none{border-style:none}.sm\\:border-0{border-width:0}.sm\\:border-2{border-width:2px}.sm\\:border-4{border-width:4px}.sm\\:border-8{border-width:8px}.sm\\:border{border-width:1px}.sm\\:border-t-0{border-top-width:0}.sm\\:border-r-0{border-right-width:0}.sm\\:border-b-0{border-bottom-width:0}.sm\\:border-l-0{border-left-width:0}.sm\\:border-t-2{border-top-width:2px}.sm\\:border-r-2{border-right-width:2px}.sm\\:border-b-2{border-bottom-width:2px}.sm\\:border-l-2{border-left-width:2px}.sm\\:border-t-4{border-top-width:4px}.sm\\:border-r-4{border-right-width:4px}.sm\\:border-b-4{border-bottom-width:4px}.sm\\:border-l-4{border-left-width:4px}.sm\\:border-t-8{border-top-width:8px}.sm\\:border-r-8{border-right-width:8px}.sm\\:border-b-8{border-bottom-width:8px}.sm\\:border-l-8{border-left-width:8px}.sm\\:border-t{border-top-width:1px}.sm\\:border-r{border-right-width:1px}.sm\\:border-b{border-bottom-width:1px}.sm\\:border-l{border-left-width:1px}.sm\\:box-border{box-sizing:border-box}.sm\\:box-content{box-sizing:initial}.sm\\:cursor-auto{cursor:auto}.sm\\:cursor-default{cursor:default}.sm\\:cursor-pointer{cursor:pointer}.sm\\:cursor-wait{cursor:wait}.sm\\:cursor-text{cursor:text}.sm\\:cursor-move{cursor:move}.sm\\:cursor-not-allowed{cursor:not-allowed}.sm\\:block{display:block}.sm\\:inline-block{display:inline-block}.sm\\:inline{display:inline}.sm\\:flex{display:flex}.sm\\:inline-flex{display:inline-flex}.sm\\:table{display:table}.sm\\:table-caption{display:table-caption}.sm\\:table-cell{display:table-cell}.sm\\:table-column{display:table-column}.sm\\:table-column-group{display:table-column-group}.sm\\:table-footer-group{display:table-footer-group}.sm\\:table-header-group{display:table-header-group}.sm\\:table-row-group{display:table-row-group}.sm\\:table-row{display:table-row}.sm\\:flow-root{display:flow-root}.sm\\:grid{display:grid}.sm\\:inline-grid{display:inline-grid}.sm\\:hidden{display:none}.theme-dark .sm\\:dark\\:block{display:block}.theme-dark .sm\\:dark\\:inline-block{display:inline-block}.theme-dark .sm\\:dark\\:inline{display:inline}.theme-dark .sm\\:dark\\:flex{display:flex}.theme-dark .sm\\:dark\\:inline-flex{display:inline-flex}.theme-dark .sm\\:dark\\:table{display:table}.theme-dark .sm\\:dark\\:table-caption{display:table-caption}.theme-dark .sm\\:dark\\:table-cell{display:table-cell}.theme-dark .sm\\:dark\\:table-column{display:table-column}.theme-dark .sm\\:dark\\:table-column-group{display:table-column-group}.theme-dark .sm\\:dark\\:table-footer-group{display:table-footer-group}.theme-dark .sm\\:dark\\:table-header-group{display:table-header-group}.theme-dark .sm\\:dark\\:table-row-group{display:table-row-group}.theme-dark .sm\\:dark\\:table-row{display:table-row}.theme-dark .sm\\:dark\\:flow-root{display:flow-root}.theme-dark .sm\\:dark\\:grid{display:grid}.theme-dark .sm\\:dark\\:inline-grid{display:inline-grid}.theme-dark .sm\\:dark\\:hidden{display:none}.sm\\:flex-row{flex-direction:row}.sm\\:flex-row-reverse{flex-direction:row-reverse}.sm\\:flex-col{flex-direction:column}.sm\\:flex-col-reverse{flex-direction:column-reverse}.sm\\:flex-wrap{flex-wrap:wrap}.sm\\:flex-wrap-reverse{flex-wrap:wrap-reverse}.sm\\:flex-no-wrap{flex-wrap:nowrap}.sm\\:items-start{align-items:flex-start}.sm\\:items-end{align-items:flex-end}.sm\\:items-center{align-items:center}.sm\\:items-baseline{align-items:baseline}.sm\\:items-stretch{align-items:stretch}.sm\\:self-auto{align-self:auto}.sm\\:self-start{align-self:flex-start}.sm\\:self-end{align-self:flex-end}.sm\\:self-center{align-self:center}.sm\\:self-stretch{align-self:stretch}.sm\\:justify-start{justify-content:flex-start}.sm\\:justify-end{justify-content:flex-end}.sm\\:justify-center{justify-content:center}.sm\\:justify-between{justify-content:space-between}.sm\\:justify-around{justify-content:space-around}.sm\\:justify-evenly{justify-content:space-evenly}.sm\\:content-center{align-content:center}.sm\\:content-start{align-content:flex-start}.sm\\:content-end{align-content:flex-end}.sm\\:content-between{align-content:space-between}.sm\\:content-around{align-content:space-around}.sm\\:flex-1{flex:1 1 0%}.sm\\:flex-auto{flex:1 1 auto}.sm\\:flex-initial{flex:0 1 auto}.sm\\:flex-none{flex:none}.sm\\:flex-grow-0{flex-grow:0}.sm\\:flex-grow{flex-grow:1}.sm\\:flex-shrink-0{flex-shrink:0}.sm\\:flex-shrink{flex-shrink:1}.sm\\:order-1{order:1}.sm\\:order-2{order:2}.sm\\:order-3{order:3}.sm\\:order-4{order:4}.sm\\:order-5{order:5}.sm\\:order-6{order:6}.sm\\:order-7{order:7}.sm\\:order-8{order:8}.sm\\:order-9{order:9}.sm\\:order-10{order:10}.sm\\:order-11{order:11}.sm\\:order-12{order:12}.sm\\:order-first{order:-9999}.sm\\:order-last{order:9999}.sm\\:order-none{order:0}.sm\\:float-right{float:right}.sm\\:float-left{float:left}.sm\\:float-none{float:none}.sm\\:clearfix:after{clear:both;content:\"\";display:table}.sm\\:clear-left{clear:left}.sm\\:clear-right{clear:right}.sm\\:clear-both{clear:both}.sm\\:clear-none{clear:none}.sm\\:font-sans{font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji}.sm\\:font-serif{font-family:Georgia,Cambria,Times New Roman,Times,serif}.sm\\:font-mono{font-family:Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}.sm\\:font-hairline{font-weight:100}.sm\\:font-thin{font-weight:200}.sm\\:font-light{font-weight:300}.sm\\:font-normal{font-weight:400}.sm\\:font-medium{font-weight:500}.sm\\:font-semibold{font-weight:600}.sm\\:font-bold{font-weight:700}.sm\\:font-extrabold{font-weight:800}.sm\\:font-black{font-weight:900}.sm\\:hover\\:font-hairline:hover{font-weight:100}.sm\\:hover\\:font-thin:hover{font-weight:200}.sm\\:hover\\:font-light:hover{font-weight:300}.sm\\:hover\\:font-normal:hover{font-weight:400}.sm\\:hover\\:font-medium:hover{font-weight:500}.sm\\:hover\\:font-semibold:hover{font-weight:600}.sm\\:hover\\:font-bold:hover{font-weight:700}.sm\\:hover\\:font-extrabold:hover{font-weight:800}.sm\\:hover\\:font-black:hover{font-weight:900}.sm\\:focus\\:font-hairline:focus{font-weight:100}.sm\\:focus\\:font-thin:focus{font-weight:200}.sm\\:focus\\:font-light:focus{font-weight:300}.sm\\:focus\\:font-normal:focus{font-weight:400}.sm\\:focus\\:font-medium:focus{font-weight:500}.sm\\:focus\\:font-semibold:focus{font-weight:600}.sm\\:focus\\:font-bold:focus{font-weight:700}.sm\\:focus\\:font-extrabold:focus{font-weight:800}.sm\\:focus\\:font-black:focus{font-weight:900}.sm\\:h-0{height:0}.sm\\:h-1{height:.25rem}.sm\\:h-2{height:.5rem}.sm\\:h-3{height:.75rem}.sm\\:h-4{height:1rem}.sm\\:h-5{height:1.25rem}.sm\\:h-6{height:1.5rem}.sm\\:h-8{height:2rem}.sm\\:h-10{height:2.5rem}.sm\\:h-12{height:3rem}.sm\\:h-16{height:4rem}.sm\\:h-20{height:5rem}.sm\\:h-24{height:6rem}.sm\\:h-32{height:8rem}.sm\\:h-40{height:10rem}.sm\\:h-48{height:12rem}.sm\\:h-56{height:14rem}.sm\\:h-64{height:16rem}.sm\\:h-auto{height:auto}.sm\\:h-px{height:1px}.sm\\:h-full{height:100%}.sm\\:h-screen{height:100vh}.sm\\:text-xs{font-size:.75rem}.sm\\:text-sm{font-size:.875rem}.sm\\:text-base{font-size:1rem}.sm\\:text-lg{font-size:1.125rem}.sm\\:text-xl{font-size:1.25rem}.sm\\:text-2xl{font-size:1.5rem}.sm\\:text-3xl{font-size:1.875rem}.sm\\:text-4xl{font-size:2.25rem}.sm\\:text-5xl{font-size:3rem}.sm\\:text-6xl{font-size:4rem}.sm\\:leading-3{line-height:.75rem}.sm\\:leading-4{line-height:1rem}.sm\\:leading-5{line-height:1.25rem}.sm\\:leading-6{line-height:1.5rem}.sm\\:leading-7{line-height:1.75rem}.sm\\:leading-8{line-height:2rem}.sm\\:leading-9{line-height:2.25rem}.sm\\:leading-10{line-height:2.5rem}.sm\\:leading-none{line-height:1}.sm\\:leading-tight{line-height:1.25}.sm\\:leading-snug{line-height:1.375}.sm\\:leading-normal{line-height:1.5}.sm\\:leading-relaxed{line-height:1.625}.sm\\:leading-loose{line-height:2}.sm\\:list-inside{list-style-position:inside}.sm\\:list-outside{list-style-position:outside}.sm\\:list-none{list-style-type:none}.sm\\:list-disc{list-style-type:disc}.sm\\:list-decimal{list-style-type:decimal}.sm\\:m-0{margin:0}.sm\\:m-1{margin:.25rem}.sm\\:m-2{margin:.5rem}.sm\\:m-3{margin:.75rem}.sm\\:m-4{margin:1rem}.sm\\:m-5{margin:1.25rem}.sm\\:m-6{margin:1.5rem}.sm\\:m-8{margin:2rem}.sm\\:m-10{margin:2.5rem}.sm\\:m-12{margin:3rem}.sm\\:m-16{margin:4rem}.sm\\:m-20{margin:5rem}.sm\\:m-24{margin:6rem}.sm\\:m-32{margin:8rem}.sm\\:m-40{margin:10rem}.sm\\:m-48{margin:12rem}.sm\\:m-56{margin:14rem}.sm\\:m-64{margin:16rem}.sm\\:m-auto{margin:auto}.sm\\:m-px{margin:1px}.sm\\:-m-1{margin:-.25rem}.sm\\:-m-2{margin:-.5rem}.sm\\:-m-3{margin:-.75rem}.sm\\:-m-4{margin:-1rem}.sm\\:-m-5{margin:-1.25rem}.sm\\:-m-6{margin:-1.5rem}.sm\\:-m-8{margin:-2rem}.sm\\:-m-10{margin:-2.5rem}.sm\\:-m-12{margin:-3rem}.sm\\:-m-16{margin:-4rem}.sm\\:-m-20{margin:-5rem}.sm\\:-m-24{margin:-6rem}.sm\\:-m-32{margin:-8rem}.sm\\:-m-40{margin:-10rem}.sm\\:-m-48{margin:-12rem}.sm\\:-m-56{margin:-14rem}.sm\\:-m-64{margin:-16rem}.sm\\:-m-px{margin:-1px}.sm\\:my-0{margin-bottom:0;margin-top:0}.sm\\:mx-0{margin-left:0;margin-right:0}.sm\\:my-1{margin-bottom:.25rem;margin-top:.25rem}.sm\\:mx-1{margin-left:.25rem;margin-right:.25rem}.sm\\:my-2{margin-bottom:.5rem;margin-top:.5rem}.sm\\:mx-2{margin-left:.5rem;margin-right:.5rem}.sm\\:my-3{margin-bottom:.75rem;margin-top:.75rem}.sm\\:mx-3{margin-left:.75rem;margin-right:.75rem}.sm\\:my-4{margin-bottom:1rem;margin-top:1rem}.sm\\:mx-4{margin-left:1rem;margin-right:1rem}.sm\\:my-5{margin-bottom:1.25rem;margin-top:1.25rem}.sm\\:mx-5{margin-left:1.25rem;margin-right:1.25rem}.sm\\:my-6{margin-bottom:1.5rem;margin-top:1.5rem}.sm\\:mx-6{margin-left:1.5rem;margin-right:1.5rem}.sm\\:my-8{margin-bottom:2rem;margin-top:2rem}.sm\\:mx-8{margin-left:2rem;margin-right:2rem}.sm\\:my-10{margin-bottom:2.5rem;margin-top:2.5rem}.sm\\:mx-10{margin-left:2.5rem;margin-right:2.5rem}.sm\\:my-12{margin-bottom:3rem;margin-top:3rem}.sm\\:mx-12{margin-left:3rem;margin-right:3rem}.sm\\:my-16{margin-bottom:4rem;margin-top:4rem}.sm\\:mx-16{margin-left:4rem;margin-right:4rem}.sm\\:my-20{margin-bottom:5rem;margin-top:5rem}.sm\\:mx-20{margin-left:5rem;margin-right:5rem}.sm\\:my-24{margin-bottom:6rem;margin-top:6rem}.sm\\:mx-24{margin-left:6rem;margin-right:6rem}.sm\\:my-32{margin-bottom:8rem;margin-top:8rem}.sm\\:mx-32{margin-left:8rem;margin-right:8rem}.sm\\:my-40{margin-bottom:10rem;margin-top:10rem}.sm\\:mx-40{margin-left:10rem;margin-right:10rem}.sm\\:my-48{margin-bottom:12rem;margin-top:12rem}.sm\\:mx-48{margin-left:12rem;margin-right:12rem}.sm\\:my-56{margin-bottom:14rem;margin-top:14rem}.sm\\:mx-56{margin-left:14rem;margin-right:14rem}.sm\\:my-64{margin-bottom:16rem;margin-top:16rem}.sm\\:mx-64{margin-left:16rem;margin-right:16rem}.sm\\:my-auto{margin-bottom:auto;margin-top:auto}.sm\\:mx-auto{margin-left:auto;margin-right:auto}.sm\\:my-px{margin-bottom:1px;margin-top:1px}.sm\\:mx-px{margin-left:1px;margin-right:1px}.sm\\:-my-1{margin-bottom:-.25rem;margin-top:-.25rem}.sm\\:-mx-1{margin-left:-.25rem;margin-right:-.25rem}.sm\\:-my-2{margin-bottom:-.5rem;margin-top:-.5rem}.sm\\:-mx-2{margin-left:-.5rem;margin-right:-.5rem}.sm\\:-my-3{margin-bottom:-.75rem;margin-top:-.75rem}.sm\\:-mx-3{margin-left:-.75rem;margin-right:-.75rem}.sm\\:-my-4{margin-bottom:-1rem;margin-top:-1rem}.sm\\:-mx-4{margin-left:-1rem;margin-right:-1rem}.sm\\:-my-5{margin-bottom:-1.25rem;margin-top:-1.25rem}.sm\\:-mx-5{margin-left:-1.25rem;margin-right:-1.25rem}.sm\\:-my-6{margin-bottom:-1.5rem;margin-top:-1.5rem}.sm\\:-mx-6{margin-left:-1.5rem;margin-right:-1.5rem}.sm\\:-my-8{margin-bottom:-2rem;margin-top:-2rem}.sm\\:-mx-8{margin-left:-2rem;margin-right:-2rem}.sm\\:-my-10{margin-bottom:-2.5rem;margin-top:-2.5rem}.sm\\:-mx-10{margin-left:-2.5rem;margin-right:-2.5rem}.sm\\:-my-12{margin-bottom:-3rem;margin-top:-3rem}.sm\\:-mx-12{margin-left:-3rem;margin-right:-3rem}.sm\\:-my-16{margin-bottom:-4rem;margin-top:-4rem}.sm\\:-mx-16{margin-left:-4rem;margin-right:-4rem}.sm\\:-my-20{margin-bottom:-5rem;margin-top:-5rem}.sm\\:-mx-20{margin-left:-5rem;margin-right:-5rem}.sm\\:-my-24{margin-bottom:-6rem;margin-top:-6rem}.sm\\:-mx-24{margin-left:-6rem;margin-right:-6rem}.sm\\:-my-32{margin-bottom:-8rem;margin-top:-8rem}.sm\\:-mx-32{margin-left:-8rem;margin-right:-8rem}.sm\\:-my-40{margin-bottom:-10rem;margin-top:-10rem}.sm\\:-mx-40{margin-left:-10rem;margin-right:-10rem}.sm\\:-my-48{margin-bottom:-12rem;margin-top:-12rem}.sm\\:-mx-48{margin-left:-12rem;margin-right:-12rem}.sm\\:-my-56{margin-bottom:-14rem;margin-top:-14rem}.sm\\:-mx-56{margin-left:-14rem;margin-right:-14rem}.sm\\:-my-64{margin-bottom:-16rem;margin-top:-16rem}.sm\\:-mx-64{margin-left:-16rem;margin-right:-16rem}.sm\\:-my-px{margin-bottom:-1px;margin-top:-1px}.sm\\:-mx-px{margin-left:-1px;margin-right:-1px}.sm\\:mt-0{margin-top:0}.sm\\:mr-0{margin-right:0}.sm\\:mb-0{margin-bottom:0}.sm\\:ml-0{margin-left:0}.sm\\:mt-1{margin-top:.25rem}.sm\\:mr-1{margin-right:.25rem}.sm\\:mb-1{margin-bottom:.25rem}.sm\\:ml-1{margin-left:.25rem}.sm\\:mt-2{margin-top:.5rem}.sm\\:mr-2{margin-right:.5rem}.sm\\:mb-2{margin-bottom:.5rem}.sm\\:ml-2{margin-left:.5rem}.sm\\:mt-3{margin-top:.75rem}.sm\\:mr-3{margin-right:.75rem}.sm\\:mb-3{margin-bottom:.75rem}.sm\\:ml-3{margin-left:.75rem}.sm\\:mt-4{margin-top:1rem}.sm\\:mr-4{margin-right:1rem}.sm\\:mb-4{margin-bottom:1rem}.sm\\:ml-4{margin-left:1rem}.sm\\:mt-5{margin-top:1.25rem}.sm\\:mr-5{margin-right:1.25rem}.sm\\:mb-5{margin-bottom:1.25rem}.sm\\:ml-5{margin-left:1.25rem}.sm\\:mt-6{margin-top:1.5rem}.sm\\:mr-6{margin-right:1.5rem}.sm\\:mb-6{margin-bottom:1.5rem}.sm\\:ml-6{margin-left:1.5rem}.sm\\:mt-8{margin-top:2rem}.sm\\:mr-8{margin-right:2rem}.sm\\:mb-8{margin-bottom:2rem}.sm\\:ml-8{margin-left:2rem}.sm\\:mt-10{margin-top:2.5rem}.sm\\:mr-10{margin-right:2.5rem}.sm\\:mb-10{margin-bottom:2.5rem}.sm\\:ml-10{margin-left:2.5rem}.sm\\:mt-12{margin-top:3rem}.sm\\:mr-12{margin-right:3rem}.sm\\:mb-12{margin-bottom:3rem}.sm\\:ml-12{margin-left:3rem}.sm\\:mt-16{margin-top:4rem}.sm\\:mr-16{margin-right:4rem}.sm\\:mb-16{margin-bottom:4rem}.sm\\:ml-16{margin-left:4rem}.sm\\:mt-20{margin-top:5rem}.sm\\:mr-20{margin-right:5rem}.sm\\:mb-20{margin-bottom:5rem}.sm\\:ml-20{margin-left:5rem}.sm\\:mt-24{margin-top:6rem}.sm\\:mr-24{margin-right:6rem}.sm\\:mb-24{margin-bottom:6rem}.sm\\:ml-24{margin-left:6rem}.sm\\:mt-32{margin-top:8rem}.sm\\:mr-32{margin-right:8rem}.sm\\:mb-32{margin-bottom:8rem}.sm\\:ml-32{margin-left:8rem}.sm\\:mt-40{margin-top:10rem}.sm\\:mr-40{margin-right:10rem}.sm\\:mb-40{margin-bottom:10rem}.sm\\:ml-40{margin-left:10rem}.sm\\:mt-48{margin-top:12rem}.sm\\:mr-48{margin-right:12rem}.sm\\:mb-48{margin-bottom:12rem}.sm\\:ml-48{margin-left:12rem}.sm\\:mt-56{margin-top:14rem}.sm\\:mr-56{margin-right:14rem}.sm\\:mb-56{margin-bottom:14rem}.sm\\:ml-56{margin-left:14rem}.sm\\:mt-64{margin-top:16rem}.sm\\:mr-64{margin-right:16rem}.sm\\:mb-64{margin-bottom:16rem}.sm\\:ml-64{margin-left:16rem}.sm\\:mt-auto{margin-top:auto}.sm\\:mr-auto{margin-right:auto}.sm\\:mb-auto{margin-bottom:auto}.sm\\:ml-auto{margin-left:auto}.sm\\:mt-px{margin-top:1px}.sm\\:mr-px{margin-right:1px}.sm\\:mb-px{margin-bottom:1px}.sm\\:ml-px{margin-left:1px}.sm\\:-mt-1{margin-top:-.25rem}.sm\\:-mr-1{margin-right:-.25rem}.sm\\:-mb-1{margin-bottom:-.25rem}.sm\\:-ml-1{margin-left:-.25rem}.sm\\:-mt-2{margin-top:-.5rem}.sm\\:-mr-2{margin-right:-.5rem}.sm\\:-mb-2{margin-bottom:-.5rem}.sm\\:-ml-2{margin-left:-.5rem}.sm\\:-mt-3{margin-top:-.75rem}.sm\\:-mr-3{margin-right:-.75rem}.sm\\:-mb-3{margin-bottom:-.75rem}.sm\\:-ml-3{margin-left:-.75rem}.sm\\:-mt-4{margin-top:-1rem}.sm\\:-mr-4{margin-right:-1rem}.sm\\:-mb-4{margin-bottom:-1rem}.sm\\:-ml-4{margin-left:-1rem}.sm\\:-mt-5{margin-top:-1.25rem}.sm\\:-mr-5{margin-right:-1.25rem}.sm\\:-mb-5{margin-bottom:-1.25rem}.sm\\:-ml-5{margin-left:-1.25rem}.sm\\:-mt-6{margin-top:-1.5rem}.sm\\:-mr-6{margin-right:-1.5rem}.sm\\:-mb-6{margin-bottom:-1.5rem}.sm\\:-ml-6{margin-left:-1.5rem}.sm\\:-mt-8{margin-top:-2rem}.sm\\:-mr-8{margin-right:-2rem}.sm\\:-mb-8{margin-bottom:-2rem}.sm\\:-ml-8{margin-left:-2rem}.sm\\:-mt-10{margin-top:-2.5rem}.sm\\:-mr-10{margin-right:-2.5rem}.sm\\:-mb-10{margin-bottom:-2.5rem}.sm\\:-ml-10{margin-left:-2.5rem}.sm\\:-mt-12{margin-top:-3rem}.sm\\:-mr-12{margin-right:-3rem}.sm\\:-mb-12{margin-bottom:-3rem}.sm\\:-ml-12{margin-left:-3rem}.sm\\:-mt-16{margin-top:-4rem}.sm\\:-mr-16{margin-right:-4rem}.sm\\:-mb-16{margin-bottom:-4rem}.sm\\:-ml-16{margin-left:-4rem}.sm\\:-mt-20{margin-top:-5rem}.sm\\:-mr-20{margin-right:-5rem}.sm\\:-mb-20{margin-bottom:-5rem}.sm\\:-ml-20{margin-left:-5rem}.sm\\:-mt-24{margin-top:-6rem}.sm\\:-mr-24{margin-right:-6rem}.sm\\:-mb-24{margin-bottom:-6rem}.sm\\:-ml-24{margin-left:-6rem}.sm\\:-mt-32{margin-top:-8rem}.sm\\:-mr-32{margin-right:-8rem}.sm\\:-mb-32{margin-bottom:-8rem}.sm\\:-ml-32{margin-left:-8rem}.sm\\:-mt-40{margin-top:-10rem}.sm\\:-mr-40{margin-right:-10rem}.sm\\:-mb-40{margin-bottom:-10rem}.sm\\:-ml-40{margin-left:-10rem}.sm\\:-mt-48{margin-top:-12rem}.sm\\:-mr-48{margin-right:-12rem}.sm\\:-mb-48{margin-bottom:-12rem}.sm\\:-ml-48{margin-left:-12rem}.sm\\:-mt-56{margin-top:-14rem}.sm\\:-mr-56{margin-right:-14rem}.sm\\:-mb-56{margin-bottom:-14rem}.sm\\:-ml-56{margin-left:-14rem}.sm\\:-mt-64{margin-top:-16rem}.sm\\:-mr-64{margin-right:-16rem}.sm\\:-mb-64{margin-bottom:-16rem}.sm\\:-ml-64{margin-left:-16rem}.sm\\:-mt-px{margin-top:-1px}.sm\\:-mr-px{margin-right:-1px}.sm\\:-mb-px{margin-bottom:-1px}.sm\\:-ml-px{margin-left:-1px}.sm\\:last\\:m-0:last-child{margin:0}.sm\\:last\\:m-1:last-child{margin:.25rem}.sm\\:last\\:m-2:last-child{margin:.5rem}.sm\\:last\\:m-3:last-child{margin:.75rem}.sm\\:last\\:m-4:last-child{margin:1rem}.sm\\:last\\:m-5:last-child{margin:1.25rem}.sm\\:last\\:m-6:last-child{margin:1.5rem}.sm\\:last\\:m-8:last-child{margin:2rem}.sm\\:last\\:m-10:last-child{margin:2.5rem}.sm\\:last\\:m-12:last-child{margin:3rem}.sm\\:last\\:m-16:last-child{margin:4rem}.sm\\:last\\:m-20:last-child{margin:5rem}.sm\\:last\\:m-24:last-child{margin:6rem}.sm\\:last\\:m-32:last-child{margin:8rem}.sm\\:last\\:m-40:last-child{margin:10rem}.sm\\:last\\:m-48:last-child{margin:12rem}.sm\\:last\\:m-56:last-child{margin:14rem}.sm\\:last\\:m-64:last-child{margin:16rem}.sm\\:last\\:m-auto:last-child{margin:auto}.sm\\:last\\:m-px:last-child{margin:1px}.sm\\:last\\:-m-1:last-child{margin:-.25rem}.sm\\:last\\:-m-2:last-child{margin:-.5rem}.sm\\:last\\:-m-3:last-child{margin:-.75rem}.sm\\:last\\:-m-4:last-child{margin:-1rem}.sm\\:last\\:-m-5:last-child{margin:-1.25rem}.sm\\:last\\:-m-6:last-child{margin:-1.5rem}.sm\\:last\\:-m-8:last-child{margin:-2rem}.sm\\:last\\:-m-10:last-child{margin:-2.5rem}.sm\\:last\\:-m-12:last-child{margin:-3rem}.sm\\:last\\:-m-16:last-child{margin:-4rem}.sm\\:last\\:-m-20:last-child{margin:-5rem}.sm\\:last\\:-m-24:last-child{margin:-6rem}.sm\\:last\\:-m-32:last-child{margin:-8rem}.sm\\:last\\:-m-40:last-child{margin:-10rem}.sm\\:last\\:-m-48:last-child{margin:-12rem}.sm\\:last\\:-m-56:last-child{margin:-14rem}.sm\\:last\\:-m-64:last-child{margin:-16rem}.sm\\:last\\:-m-px:last-child{margin:-1px}.sm\\:last\\:my-0:last-child{margin-bottom:0;margin-top:0}.sm\\:last\\:mx-0:last-child{margin-left:0;margin-right:0}.sm\\:last\\:my-1:last-child{margin-bottom:.25rem;margin-top:.25rem}.sm\\:last\\:mx-1:last-child{margin-left:.25rem;margin-right:.25rem}.sm\\:last\\:my-2:last-child{margin-bottom:.5rem;margin-top:.5rem}.sm\\:last\\:mx-2:last-child{margin-left:.5rem;margin-right:.5rem}.sm\\:last\\:my-3:last-child{margin-bottom:.75rem;margin-top:.75rem}.sm\\:last\\:mx-3:last-child{margin-left:.75rem;margin-right:.75rem}.sm\\:last\\:my-4:last-child{margin-bottom:1rem;margin-top:1rem}.sm\\:last\\:mx-4:last-child{margin-left:1rem;margin-right:1rem}.sm\\:last\\:my-5:last-child{margin-bottom:1.25rem;margin-top:1.25rem}.sm\\:last\\:mx-5:last-child{margin-left:1.25rem;margin-right:1.25rem}.sm\\:last\\:my-6:last-child{margin-bottom:1.5rem;margin-top:1.5rem}.sm\\:last\\:mx-6:last-child{margin-left:1.5rem;margin-right:1.5rem}.sm\\:last\\:my-8:last-child{margin-bottom:2rem;margin-top:2rem}.sm\\:last\\:mx-8:last-child{margin-left:2rem;margin-right:2rem}.sm\\:last\\:my-10:last-child{margin-bottom:2.5rem;margin-top:2.5rem}.sm\\:last\\:mx-10:last-child{margin-left:2.5rem;margin-right:2.5rem}.sm\\:last\\:my-12:last-child{margin-bottom:3rem;margin-top:3rem}.sm\\:last\\:mx-12:last-child{margin-left:3rem;margin-right:3rem}.sm\\:last\\:my-16:last-child{margin-bottom:4rem;margin-top:4rem}.sm\\:last\\:mx-16:last-child{margin-left:4rem;margin-right:4rem}.sm\\:last\\:my-20:last-child{margin-bottom:5rem;margin-top:5rem}.sm\\:last\\:mx-20:last-child{margin-left:5rem;margin-right:5rem}.sm\\:last\\:my-24:last-child{margin-bottom:6rem;margin-top:6rem}.sm\\:last\\:mx-24:last-child{margin-left:6rem;margin-right:6rem}.sm\\:last\\:my-32:last-child{margin-bottom:8rem;margin-top:8rem}.sm\\:last\\:mx-32:last-child{margin-left:8rem;margin-right:8rem}.sm\\:last\\:my-40:last-child{margin-bottom:10rem;margin-top:10rem}.sm\\:last\\:mx-40:last-child{margin-left:10rem;margin-right:10rem}.sm\\:last\\:my-48:last-child{margin-bottom:12rem;margin-top:12rem}.sm\\:last\\:mx-48:last-child{margin-left:12rem;margin-right:12rem}.sm\\:last\\:my-56:last-child{margin-bottom:14rem;margin-top:14rem}.sm\\:last\\:mx-56:last-child{margin-left:14rem;margin-right:14rem}.sm\\:last\\:my-64:last-child{margin-bottom:16rem;margin-top:16rem}.sm\\:last\\:mx-64:last-child{margin-left:16rem;margin-right:16rem}.sm\\:last\\:my-auto:last-child{margin-bottom:auto;margin-top:auto}.sm\\:last\\:mx-auto:last-child{margin-left:auto;margin-right:auto}.sm\\:last\\:my-px:last-child{margin-bottom:1px;margin-top:1px}.sm\\:last\\:mx-px:last-child{margin-left:1px;margin-right:1px}.sm\\:last\\:-my-1:last-child{margin-bottom:-.25rem;margin-top:-.25rem}.sm\\:last\\:-mx-1:last-child{margin-left:-.25rem;margin-right:-.25rem}.sm\\:last\\:-my-2:last-child{margin-bottom:-.5rem;margin-top:-.5rem}.sm\\:last\\:-mx-2:last-child{margin-left:-.5rem;margin-right:-.5rem}.sm\\:last\\:-my-3:last-child{margin-bottom:-.75rem;margin-top:-.75rem}.sm\\:last\\:-mx-3:last-child{margin-left:-.75rem;margin-right:-.75rem}.sm\\:last\\:-my-4:last-child{margin-bottom:-1rem;margin-top:-1rem}.sm\\:last\\:-mx-4:last-child{margin-left:-1rem;margin-right:-1rem}.sm\\:last\\:-my-5:last-child{margin-bottom:-1.25rem;margin-top:-1.25rem}.sm\\:last\\:-mx-5:last-child{margin-left:-1.25rem;margin-right:-1.25rem}.sm\\:last\\:-my-6:last-child{margin-bottom:-1.5rem;margin-top:-1.5rem}.sm\\:last\\:-mx-6:last-child{margin-left:-1.5rem;margin-right:-1.5rem}.sm\\:last\\:-my-8:last-child{margin-bottom:-2rem;margin-top:-2rem}.sm\\:last\\:-mx-8:last-child{margin-left:-2rem;margin-right:-2rem}.sm\\:last\\:-my-10:last-child{margin-bottom:-2.5rem;margin-top:-2.5rem}.sm\\:last\\:-mx-10:last-child{margin-left:-2.5rem;margin-right:-2.5rem}.sm\\:last\\:-my-12:last-child{margin-bottom:-3rem;margin-top:-3rem}.sm\\:last\\:-mx-12:last-child{margin-left:-3rem;margin-right:-3rem}.sm\\:last\\:-my-16:last-child{margin-bottom:-4rem;margin-top:-4rem}.sm\\:last\\:-mx-16:last-child{margin-left:-4rem;margin-right:-4rem}.sm\\:last\\:-my-20:last-child{margin-bottom:-5rem;margin-top:-5rem}.sm\\:last\\:-mx-20:last-child{margin-left:-5rem;margin-right:-5rem}.sm\\:last\\:-my-24:last-child{margin-bottom:-6rem;margin-top:-6rem}.sm\\:last\\:-mx-24:last-child{margin-left:-6rem;margin-right:-6rem}.sm\\:last\\:-my-32:last-child{margin-bottom:-8rem;margin-top:-8rem}.sm\\:last\\:-mx-32:last-child{margin-left:-8rem;margin-right:-8rem}.sm\\:last\\:-my-40:last-child{margin-bottom:-10rem;margin-top:-10rem}.sm\\:last\\:-mx-40:last-child{margin-left:-10rem;margin-right:-10rem}.sm\\:last\\:-my-48:last-child{margin-bottom:-12rem;margin-top:-12rem}.sm\\:last\\:-mx-48:last-child{margin-left:-12rem;margin-right:-12rem}.sm\\:last\\:-my-56:last-child{margin-bottom:-14rem;margin-top:-14rem}.sm\\:last\\:-mx-56:last-child{margin-left:-14rem;margin-right:-14rem}.sm\\:last\\:-my-64:last-child{margin-bottom:-16rem;margin-top:-16rem}.sm\\:last\\:-mx-64:last-child{margin-left:-16rem;margin-right:-16rem}.sm\\:last\\:-my-px:last-child{margin-bottom:-1px;margin-top:-1px}.sm\\:last\\:-mx-px:last-child{margin-left:-1px;margin-right:-1px}.sm\\:last\\:mt-0:last-child{margin-top:0}.sm\\:last\\:mr-0:last-child{margin-right:0}.sm\\:last\\:mb-0:last-child{margin-bottom:0}.sm\\:last\\:ml-0:last-child{margin-left:0}.sm\\:last\\:mt-1:last-child{margin-top:.25rem}.sm\\:last\\:mr-1:last-child{margin-right:.25rem}.sm\\:last\\:mb-1:last-child{margin-bottom:.25rem}.sm\\:last\\:ml-1:last-child{margin-left:.25rem}.sm\\:last\\:mt-2:last-child{margin-top:.5rem}.sm\\:last\\:mr-2:last-child{margin-right:.5rem}.sm\\:last\\:mb-2:last-child{margin-bottom:.5rem}.sm\\:last\\:ml-2:last-child{margin-left:.5rem}.sm\\:last\\:mt-3:last-child{margin-top:.75rem}.sm\\:last\\:mr-3:last-child{margin-right:.75rem}.sm\\:last\\:mb-3:last-child{margin-bottom:.75rem}.sm\\:last\\:ml-3:last-child{margin-left:.75rem}.sm\\:last\\:mt-4:last-child{margin-top:1rem}.sm\\:last\\:mr-4:last-child{margin-right:1rem}.sm\\:last\\:mb-4:last-child{margin-bottom:1rem}.sm\\:last\\:ml-4:last-child{margin-left:1rem}.sm\\:last\\:mt-5:last-child{margin-top:1.25rem}.sm\\:last\\:mr-5:last-child{margin-right:1.25rem}.sm\\:last\\:mb-5:last-child{margin-bottom:1.25rem}.sm\\:last\\:ml-5:last-child{margin-left:1.25rem}.sm\\:last\\:mt-6:last-child{margin-top:1.5rem}.sm\\:last\\:mr-6:last-child{margin-right:1.5rem}.sm\\:last\\:mb-6:last-child{margin-bottom:1.5rem}.sm\\:last\\:ml-6:last-child{margin-left:1.5rem}.sm\\:last\\:mt-8:last-child{margin-top:2rem}.sm\\:last\\:mr-8:last-child{margin-right:2rem}.sm\\:last\\:mb-8:last-child{margin-bottom:2rem}.sm\\:last\\:ml-8:last-child{margin-left:2rem}.sm\\:last\\:mt-10:last-child{margin-top:2.5rem}.sm\\:last\\:mr-10:last-child{margin-right:2.5rem}.sm\\:last\\:mb-10:last-child{margin-bottom:2.5rem}.sm\\:last\\:ml-10:last-child{margin-left:2.5rem}.sm\\:last\\:mt-12:last-child{margin-top:3rem}.sm\\:last\\:mr-12:last-child{margin-right:3rem}.sm\\:last\\:mb-12:last-child{margin-bottom:3rem}.sm\\:last\\:ml-12:last-child{margin-left:3rem}.sm\\:last\\:mt-16:last-child{margin-top:4rem}.sm\\:last\\:mr-16:last-child{margin-right:4rem}.sm\\:last\\:mb-16:last-child{margin-bottom:4rem}.sm\\:last\\:ml-16:last-child{margin-left:4rem}.sm\\:last\\:mt-20:last-child{margin-top:5rem}.sm\\:last\\:mr-20:last-child{margin-right:5rem}.sm\\:last\\:mb-20:last-child{margin-bottom:5rem}.sm\\:last\\:ml-20:last-child{margin-left:5rem}.sm\\:last\\:mt-24:last-child{margin-top:6rem}.sm\\:last\\:mr-24:last-child{margin-right:6rem}.sm\\:last\\:mb-24:last-child{margin-bottom:6rem}.sm\\:last\\:ml-24:last-child{margin-left:6rem}.sm\\:last\\:mt-32:last-child{margin-top:8rem}.sm\\:last\\:mr-32:last-child{margin-right:8rem}.sm\\:last\\:mb-32:last-child{margin-bottom:8rem}.sm\\:last\\:ml-32:last-child{margin-left:8rem}.sm\\:last\\:mt-40:last-child{margin-top:10rem}.sm\\:last\\:mr-40:last-child{margin-right:10rem}.sm\\:last\\:mb-40:last-child{margin-bottom:10rem}.sm\\:last\\:ml-40:last-child{margin-left:10rem}.sm\\:last\\:mt-48:last-child{margin-top:12rem}.sm\\:last\\:mr-48:last-child{margin-right:12rem}.sm\\:last\\:mb-48:last-child{margin-bottom:12rem}.sm\\:last\\:ml-48:last-child{margin-left:12rem}.sm\\:last\\:mt-56:last-child{margin-top:14rem}.sm\\:last\\:mr-56:last-child{margin-right:14rem}.sm\\:last\\:mb-56:last-child{margin-bottom:14rem}.sm\\:last\\:ml-56:last-child{margin-left:14rem}.sm\\:last\\:mt-64:last-child{margin-top:16rem}.sm\\:last\\:mr-64:last-child{margin-right:16rem}.sm\\:last\\:mb-64:last-child{margin-bottom:16rem}.sm\\:last\\:ml-64:last-child{margin-left:16rem}.sm\\:last\\:mt-auto:last-child{margin-top:auto}.sm\\:last\\:mr-auto:last-child{margin-right:auto}.sm\\:last\\:mb-auto:last-child{margin-bottom:auto}.sm\\:last\\:ml-auto:last-child{margin-left:auto}.sm\\:last\\:mt-px:last-child{margin-top:1px}.sm\\:last\\:mr-px:last-child{margin-right:1px}.sm\\:last\\:mb-px:last-child{margin-bottom:1px}.sm\\:last\\:ml-px:last-child{margin-left:1px}.sm\\:last\\:-mt-1:last-child{margin-top:-.25rem}.sm\\:last\\:-mr-1:last-child{margin-right:-.25rem}.sm\\:last\\:-mb-1:last-child{margin-bottom:-.25rem}.sm\\:last\\:-ml-1:last-child{margin-left:-.25rem}.sm\\:last\\:-mt-2:last-child{margin-top:-.5rem}.sm\\:last\\:-mr-2:last-child{margin-right:-.5rem}.sm\\:last\\:-mb-2:last-child{margin-bottom:-.5rem}.sm\\:last\\:-ml-2:last-child{margin-left:-.5rem}.sm\\:last\\:-mt-3:last-child{margin-top:-.75rem}.sm\\:last\\:-mr-3:last-child{margin-right:-.75rem}.sm\\:last\\:-mb-3:last-child{margin-bottom:-.75rem}.sm\\:last\\:-ml-3:last-child{margin-left:-.75rem}.sm\\:last\\:-mt-4:last-child{margin-top:-1rem}.sm\\:last\\:-mr-4:last-child{margin-right:-1rem}.sm\\:last\\:-mb-4:last-child{margin-bottom:-1rem}.sm\\:last\\:-ml-4:last-child{margin-left:-1rem}.sm\\:last\\:-mt-5:last-child{margin-top:-1.25rem}.sm\\:last\\:-mr-5:last-child{margin-right:-1.25rem}.sm\\:last\\:-mb-5:last-child{margin-bottom:-1.25rem}.sm\\:last\\:-ml-5:last-child{margin-left:-1.25rem}.sm\\:last\\:-mt-6:last-child{margin-top:-1.5rem}.sm\\:last\\:-mr-6:last-child{margin-right:-1.5rem}.sm\\:last\\:-mb-6:last-child{margin-bottom:-1.5rem}.sm\\:last\\:-ml-6:last-child{margin-left:-1.5rem}.sm\\:last\\:-mt-8:last-child{margin-top:-2rem}.sm\\:last\\:-mr-8:last-child{margin-right:-2rem}.sm\\:last\\:-mb-8:last-child{margin-bottom:-2rem}.sm\\:last\\:-ml-8:last-child{margin-left:-2rem}.sm\\:last\\:-mt-10:last-child{margin-top:-2.5rem}.sm\\:last\\:-mr-10:last-child{margin-right:-2.5rem}.sm\\:last\\:-mb-10:last-child{margin-bottom:-2.5rem}.sm\\:last\\:-ml-10:last-child{margin-left:-2.5rem}.sm\\:last\\:-mt-12:last-child{margin-top:-3rem}.sm\\:last\\:-mr-12:last-child{margin-right:-3rem}.sm\\:last\\:-mb-12:last-child{margin-bottom:-3rem}.sm\\:last\\:-ml-12:last-child{margin-left:-3rem}.sm\\:last\\:-mt-16:last-child{margin-top:-4rem}.sm\\:last\\:-mr-16:last-child{margin-right:-4rem}.sm\\:last\\:-mb-16:last-child{margin-bottom:-4rem}.sm\\:last\\:-ml-16:last-child{margin-left:-4rem}.sm\\:last\\:-mt-20:last-child{margin-top:-5rem}.sm\\:last\\:-mr-20:last-child{margin-right:-5rem}.sm\\:last\\:-mb-20:last-child{margin-bottom:-5rem}.sm\\:last\\:-ml-20:last-child{margin-left:-5rem}.sm\\:last\\:-mt-24:last-child{margin-top:-6rem}.sm\\:last\\:-mr-24:last-child{margin-right:-6rem}.sm\\:last\\:-mb-24:last-child{margin-bottom:-6rem}.sm\\:last\\:-ml-24:last-child{margin-left:-6rem}.sm\\:last\\:-mt-32:last-child{margin-top:-8rem}.sm\\:last\\:-mr-32:last-child{margin-right:-8rem}.sm\\:last\\:-mb-32:last-child{margin-bottom:-8rem}.sm\\:last\\:-ml-32:last-child{margin-left:-8rem}.sm\\:last\\:-mt-40:last-child{margin-top:-10rem}.sm\\:last\\:-mr-40:last-child{margin-right:-10rem}.sm\\:last\\:-mb-40:last-child{margin-bottom:-10rem}.sm\\:last\\:-ml-40:last-child{margin-left:-10rem}.sm\\:last\\:-mt-48:last-child{margin-top:-12rem}.sm\\:last\\:-mr-48:last-child{margin-right:-12rem}.sm\\:last\\:-mb-48:last-child{margin-bottom:-12rem}.sm\\:last\\:-ml-48:last-child{margin-left:-12rem}.sm\\:last\\:-mt-56:last-child{margin-top:-14rem}.sm\\:last\\:-mr-56:last-child{margin-right:-14rem}.sm\\:last\\:-mb-56:last-child{margin-bottom:-14rem}.sm\\:last\\:-ml-56:last-child{margin-left:-14rem}.sm\\:last\\:-mt-64:last-child{margin-top:-16rem}.sm\\:last\\:-mr-64:last-child{margin-right:-16rem}.sm\\:last\\:-mb-64:last-child{margin-bottom:-16rem}.sm\\:last\\:-ml-64:last-child{margin-left:-16rem}.sm\\:last\\:-mt-px:last-child{margin-top:-1px}.sm\\:last\\:-mr-px:last-child{margin-right:-1px}.sm\\:last\\:-mb-px:last-child{margin-bottom:-1px}.sm\\:last\\:-ml-px:last-child{margin-left:-1px}.sm\\:max-h-0{max-height:0}.sm\\:max-h-1{max-height:.25rem}.sm\\:max-h-2{max-height:.5rem}.sm\\:max-h-3{max-height:.75rem}.sm\\:max-h-4{max-height:1rem}.sm\\:max-h-5{max-height:1.25rem}.sm\\:max-h-6{max-height:1.5rem}.sm\\:max-h-8{max-height:2rem}.sm\\:max-h-10{max-height:2.5rem}.sm\\:max-h-12{max-height:3rem}.sm\\:max-h-16{max-height:4rem}.sm\\:max-h-20{max-height:5rem}.sm\\:max-h-24{max-height:6rem}.sm\\:max-h-32{max-height:8rem}.sm\\:max-h-40{max-height:10rem}.sm\\:max-h-48{max-height:12rem}.sm\\:max-h-56{max-height:14rem}.sm\\:max-h-64{max-height:16rem}.sm\\:max-h-xl{max-height:36rem}.sm\\:max-h-px{max-height:1px}.sm\\:max-w-none{max-width:none}.sm\\:max-w-xs{max-width:20rem}.sm\\:max-w-sm{max-width:24rem}.sm\\:max-w-md{max-width:28rem}.sm\\:max-w-lg{max-width:32rem}.sm\\:max-w-xl{max-width:36rem}.sm\\:max-w-2xl{max-width:42rem}.sm\\:max-w-3xl{max-width:48rem}.sm\\:max-w-4xl{max-width:56rem}.sm\\:max-w-5xl{max-width:64rem}.sm\\:max-w-6xl{max-width:72rem}.sm\\:max-w-full{max-width:100%}.sm\\:max-w-screen-sm{max-width:640px}.sm\\:max-w-screen-md{max-width:768px}.sm\\:max-w-screen-lg{max-width:1024px}.sm\\:max-w-screen-xl{max-width:1280px}.sm\\:min-h-0{min-height:0}.sm\\:min-h-full{min-height:100%}.sm\\:min-h-screen{min-height:100vh}.sm\\:min-w-0{min-width:0}.sm\\:min-w-1{min-width:.25rem}.sm\\:min-w-2{min-width:.5rem}.sm\\:min-w-3{min-width:.75rem}.sm\\:min-w-4{min-width:1rem}.sm\\:min-w-5{min-width:1.25rem}.sm\\:min-w-6{min-width:1.5rem}.sm\\:min-w-8{min-width:2rem}.sm\\:min-w-10{min-width:2.5rem}.sm\\:min-w-12{min-width:3rem}.sm\\:min-w-16{min-width:4rem}.sm\\:min-w-20{min-width:5rem}.sm\\:min-w-24{min-width:6rem}.sm\\:min-w-32{min-width:8rem}.sm\\:min-w-40{min-width:10rem}.sm\\:min-w-48{min-width:12rem}.sm\\:min-w-56{min-width:14rem}.sm\\:min-w-64{min-width:16rem}.sm\\:min-w-max-content{min-width:-webkit-max-content;min-width:max-content}.sm\\:min-w-px{min-width:1px}.sm\\:object-contain{object-fit:contain}.sm\\:object-cover{object-fit:cover}.sm\\:object-fill{object-fit:fill}.sm\\:object-none{object-fit:none}.sm\\:object-scale-down{object-fit:scale-down}.sm\\:object-bottom{object-position:bottom}.sm\\:object-center{object-position:center}.sm\\:object-left{object-position:left}.sm\\:object-left-bottom{object-position:left bottom}.sm\\:object-left-top{object-position:left top}.sm\\:object-right{object-position:right}.sm\\:object-right-bottom{object-position:right bottom}.sm\\:object-right-top{object-position:right top}.sm\\:object-top{object-position:top}.sm\\:opacity-0{opacity:0}.sm\\:opacity-25{opacity:.25}.sm\\:opacity-50{opacity:.5}.sm\\:opacity-75{opacity:.75}.sm\\:opacity-100{opacity:1}.sm\\:hover\\:opacity-0:hover{opacity:0}.sm\\:hover\\:opacity-25:hover{opacity:.25}.sm\\:hover\\:opacity-50:hover{opacity:.5}.sm\\:hover\\:opacity-75:hover{opacity:.75}.sm\\:hover\\:opacity-100:hover{opacity:1}.sm\\:focus\\:opacity-0:focus{opacity:0}.sm\\:focus\\:opacity-25:focus{opacity:.25}.sm\\:focus\\:opacity-50:focus{opacity:.5}.sm\\:focus\\:opacity-75:focus{opacity:.75}.sm\\:focus\\:opacity-100:focus{opacity:1}.sm\\:focus\\:outline-none:focus,.sm\\:outline-none{outline:0}.sm\\:overflow-auto{overflow:auto}.sm\\:overflow-hidden{overflow:hidden}.sm\\:overflow-visible{overflow:visible}.sm\\:overflow-scroll{overflow:scroll}.sm\\:overflow-x-auto{overflow-x:auto}.sm\\:overflow-y-auto{overflow-y:auto}.sm\\:overflow-x-hidden{overflow-x:hidden}.sm\\:overflow-y-hidden{overflow-y:hidden}.sm\\:overflow-x-visible{overflow-x:visible}.sm\\:overflow-y-visible{overflow-y:visible}.sm\\:overflow-x-scroll{overflow-x:scroll}.sm\\:overflow-y-scroll{overflow-y:scroll}.sm\\:scrolling-touch{-webkit-overflow-scrolling:touch}.sm\\:scrolling-auto{-webkit-overflow-scrolling:auto}.sm\\:p-0{padding:0}.sm\\:p-1{padding:.25rem}.sm\\:p-2{padding:.5rem}.sm\\:p-3{padding:.75rem}.sm\\:p-4{padding:1rem}.sm\\:p-5{padding:1.25rem}.sm\\:p-6{padding:1.5rem}.sm\\:p-8{padding:2rem}.sm\\:p-10{padding:2.5rem}.sm\\:p-12{padding:3rem}.sm\\:p-16{padding:4rem}.sm\\:p-20{padding:5rem}.sm\\:p-24{padding:6rem}.sm\\:p-32{padding:8rem}.sm\\:p-40{padding:10rem}.sm\\:p-48{padding:12rem}.sm\\:p-56{padding:14rem}.sm\\:p-64{padding:16rem}.sm\\:p-px{padding:1px}.sm\\:py-0{padding-bottom:0;padding-top:0}.sm\\:px-0{padding-left:0;padding-right:0}.sm\\:py-1{padding-bottom:.25rem;padding-top:.25rem}.sm\\:px-1{padding-left:.25rem;padding-right:.25rem}.sm\\:py-2{padding-bottom:.5rem;padding-top:.5rem}.sm\\:px-2{padding-left:.5rem;padding-right:.5rem}.sm\\:py-3{padding-bottom:.75rem;padding-top:.75rem}.sm\\:px-3{padding-left:.75rem;padding-right:.75rem}.sm\\:py-4{padding-bottom:1rem;padding-top:1rem}.sm\\:px-4{padding-left:1rem;padding-right:1rem}.sm\\:py-5{padding-bottom:1.25rem;padding-top:1.25rem}.sm\\:px-5{padding-left:1.25rem;padding-right:1.25rem}.sm\\:py-6{padding-bottom:1.5rem;padding-top:1.5rem}.sm\\:px-6{padding-left:1.5rem;padding-right:1.5rem}.sm\\:py-8{padding-bottom:2rem;padding-top:2rem}.sm\\:px-8{padding-left:2rem;padding-right:2rem}.sm\\:py-10{padding-bottom:2.5rem;padding-top:2.5rem}.sm\\:px-10{padding-left:2.5rem;padding-right:2.5rem}.sm\\:py-12{padding-bottom:3rem;padding-top:3rem}.sm\\:px-12{padding-left:3rem;padding-right:3rem}.sm\\:py-16{padding-bottom:4rem;padding-top:4rem}.sm\\:px-16{padding-left:4rem;padding-right:4rem}.sm\\:py-20{padding-bottom:5rem;padding-top:5rem}.sm\\:px-20{padding-left:5rem;padding-right:5rem}.sm\\:py-24{padding-bottom:6rem;padding-top:6rem}.sm\\:px-24{padding-left:6rem;padding-right:6rem}.sm\\:py-32{padding-bottom:8rem;padding-top:8rem}.sm\\:px-32{padding-left:8rem;padding-right:8rem}.sm\\:py-40{padding-bottom:10rem;padding-top:10rem}.sm\\:px-40{padding-left:10rem;padding-right:10rem}.sm\\:py-48{padding-bottom:12rem;padding-top:12rem}.sm\\:px-48{padding-left:12rem;padding-right:12rem}.sm\\:py-56{padding-bottom:14rem;padding-top:14rem}.sm\\:px-56{padding-left:14rem;padding-right:14rem}.sm\\:py-64{padding-bottom:16rem;padding-top:16rem}.sm\\:px-64{padding-left:16rem;padding-right:16rem}.sm\\:py-px{padding-bottom:1px;padding-top:1px}.sm\\:px-px{padding-left:1px;padding-right:1px}.sm\\:pt-0{padding-top:0}.sm\\:pr-0{padding-right:0}.sm\\:pb-0{padding-bottom:0}.sm\\:pl-0{padding-left:0}.sm\\:pt-1{padding-top:.25rem}.sm\\:pr-1{padding-right:.25rem}.sm\\:pb-1{padding-bottom:.25rem}.sm\\:pl-1{padding-left:.25rem}.sm\\:pt-2{padding-top:.5rem}.sm\\:pr-2{padding-right:.5rem}.sm\\:pb-2{padding-bottom:.5rem}.sm\\:pl-2{padding-left:.5rem}.sm\\:pt-3{padding-top:.75rem}.sm\\:pr-3{padding-right:.75rem}.sm\\:pb-3{padding-bottom:.75rem}.sm\\:pl-3{padding-left:.75rem}.sm\\:pt-4{padding-top:1rem}.sm\\:pr-4{padding-right:1rem}.sm\\:pb-4{padding-bottom:1rem}.sm\\:pl-4{padding-left:1rem}.sm\\:pt-5{padding-top:1.25rem}.sm\\:pr-5{padding-right:1.25rem}.sm\\:pb-5{padding-bottom:1.25rem}.sm\\:pl-5{padding-left:1.25rem}.sm\\:pt-6{padding-top:1.5rem}.sm\\:pr-6{padding-right:1.5rem}.sm\\:pb-6{padding-bottom:1.5rem}.sm\\:pl-6{padding-left:1.5rem}.sm\\:pt-8{padding-top:2rem}.sm\\:pr-8{padding-right:2rem}.sm\\:pb-8{padding-bottom:2rem}.sm\\:pl-8{padding-left:2rem}.sm\\:pt-10{padding-top:2.5rem}.sm\\:pr-10{padding-right:2.5rem}.sm\\:pb-10{padding-bottom:2.5rem}.sm\\:pl-10{padding-left:2.5rem}.sm\\:pt-12{padding-top:3rem}.sm\\:pr-12{padding-right:3rem}.sm\\:pb-12{padding-bottom:3rem}.sm\\:pl-12{padding-left:3rem}.sm\\:pt-16{padding-top:4rem}.sm\\:pr-16{padding-right:4rem}.sm\\:pb-16{padding-bottom:4rem}.sm\\:pl-16{padding-left:4rem}.sm\\:pt-20{padding-top:5rem}.sm\\:pr-20{padding-right:5rem}.sm\\:pb-20{padding-bottom:5rem}.sm\\:pl-20{padding-left:5rem}.sm\\:pt-24{padding-top:6rem}.sm\\:pr-24{padding-right:6rem}.sm\\:pb-24{padding-bottom:6rem}.sm\\:pl-24{padding-left:6rem}.sm\\:pt-32{padding-top:8rem}.sm\\:pr-32{padding-right:8rem}.sm\\:pb-32{padding-bottom:8rem}.sm\\:pl-32{padding-left:8rem}.sm\\:pt-40{padding-top:10rem}.sm\\:pr-40{padding-right:10rem}.sm\\:pb-40{padding-bottom:10rem}.sm\\:pl-40{padding-left:10rem}.sm\\:pt-48{padding-top:12rem}.sm\\:pr-48{padding-right:12rem}.sm\\:pb-48{padding-bottom:12rem}.sm\\:pl-48{padding-left:12rem}.sm\\:pt-56{padding-top:14rem}.sm\\:pr-56{padding-right:14rem}.sm\\:pb-56{padding-bottom:14rem}.sm\\:pl-56{padding-left:14rem}.sm\\:pt-64{padding-top:16rem}.sm\\:pr-64{padding-right:16rem}.sm\\:pb-64{padding-bottom:16rem}.sm\\:pl-64{padding-left:16rem}.sm\\:pt-px{padding-top:1px}.sm\\:pr-px{padding-right:1px}.sm\\:pb-px{padding-bottom:1px}.sm\\:pl-px{padding-left:1px}.sm\\:placeholder-transparent::placeholder{color:#0000}.sm\\:placeholder-white::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.sm\\:placeholder-black::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.sm\\:placeholder-gray-50::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.sm\\:placeholder-gray-100::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.sm\\:placeholder-gray-200::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.sm\\:placeholder-gray-300::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.sm\\:placeholder-gray-400::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.sm\\:placeholder-gray-500::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.sm\\:placeholder-gray-600::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.sm\\:placeholder-gray-700::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.sm\\:placeholder-gray-800::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.sm\\:placeholder-gray-900::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.sm\\:placeholder-cool-gray-50::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.sm\\:placeholder-cool-gray-100::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.sm\\:placeholder-cool-gray-200::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.sm\\:placeholder-cool-gray-300::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.sm\\:placeholder-cool-gray-400::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.sm\\:placeholder-cool-gray-500::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.sm\\:placeholder-cool-gray-600::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.sm\\:placeholder-cool-gray-700::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.sm\\:placeholder-cool-gray-800::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.sm\\:placeholder-cool-gray-900::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.sm\\:placeholder-red-50::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.sm\\:placeholder-red-100::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.sm\\:placeholder-red-200::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.sm\\:placeholder-red-300::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.sm\\:placeholder-red-400::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.sm\\:placeholder-red-500::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.sm\\:placeholder-red-600::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.sm\\:placeholder-red-700::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.sm\\:placeholder-red-800::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.sm\\:placeholder-red-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.sm\\:placeholder-orange-50::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.sm\\:placeholder-orange-100::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.sm\\:placeholder-orange-200::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.sm\\:placeholder-orange-300::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.sm\\:placeholder-orange-400::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.sm\\:placeholder-orange-500::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.sm\\:placeholder-orange-600::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.sm\\:placeholder-orange-700::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.sm\\:placeholder-orange-800::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.sm\\:placeholder-orange-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.sm\\:placeholder-yellow-50::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.sm\\:placeholder-yellow-100::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.sm\\:placeholder-yellow-200::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.sm\\:placeholder-yellow-300::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.sm\\:placeholder-yellow-400::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.sm\\:placeholder-yellow-500::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.sm\\:placeholder-yellow-600::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.sm\\:placeholder-yellow-700::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.sm\\:placeholder-yellow-800::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.sm\\:placeholder-yellow-900::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.sm\\:placeholder-green-50::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.sm\\:placeholder-green-100::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.sm\\:placeholder-green-200::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.sm\\:placeholder-green-300::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.sm\\:placeholder-green-400::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.sm\\:placeholder-green-500::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.sm\\:placeholder-green-600::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.sm\\:placeholder-green-700::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.sm\\:placeholder-green-800::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.sm\\:placeholder-green-900::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.sm\\:placeholder-teal-50::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.sm\\:placeholder-teal-100::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.sm\\:placeholder-teal-200::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.sm\\:placeholder-teal-300::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.sm\\:placeholder-teal-400::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.sm\\:placeholder-teal-500::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.sm\\:placeholder-teal-600::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.sm\\:placeholder-teal-700::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.sm\\:placeholder-teal-800::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.sm\\:placeholder-teal-900::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.sm\\:placeholder-blue-50::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.sm\\:placeholder-blue-100::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.sm\\:placeholder-blue-200::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.sm\\:placeholder-blue-300::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.sm\\:placeholder-blue-400::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.sm\\:placeholder-blue-500::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.sm\\:placeholder-blue-600::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.sm\\:placeholder-blue-700::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.sm\\:placeholder-blue-800::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.sm\\:placeholder-blue-900::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.sm\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.sm\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.sm\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.sm\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.sm\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.sm\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.sm\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.sm\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.sm\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.sm\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.sm\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.sm\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.sm\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.sm\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.sm\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.sm\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.sm\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.sm\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.sm\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.sm\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.sm\\:placeholder-pink-50::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.sm\\:placeholder-pink-100::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.sm\\:placeholder-pink-200::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.sm\\:placeholder-pink-300::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.sm\\:placeholder-pink-400::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.sm\\:placeholder-pink-500::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.sm\\:placeholder-pink-600::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.sm\\:placeholder-pink-700::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.sm\\:placeholder-pink-800::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.sm\\:placeholder-pink-900::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-transparent:focus::placeholder{color:#0000}.sm\\:focus\\:placeholder-white:focus::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-black:focus::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-gray-50:focus::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-gray-300:focus::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-gray-400:focus::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-gray-500:focus::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-gray-600:focus::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-gray-700:focus::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-gray-800:focus::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-gray-900:focus::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-cool-gray-50:focus::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-cool-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-cool-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-cool-gray-300:focus::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-cool-gray-400:focus::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-cool-gray-500:focus::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-cool-gray-600:focus::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-cool-gray-700:focus::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-cool-gray-800:focus::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-cool-gray-900:focus::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-red-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-red-100:focus::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-red-200:focus::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-red-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-red-400:focus::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-red-500:focus::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-red-600:focus::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-red-700:focus::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-red-800:focus::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-red-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-orange-50:focus::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-orange-100:focus::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-orange-200:focus::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-orange-300:focus::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-orange-400:focus::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-orange-500:focus::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-orange-600:focus::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-orange-700:focus::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-orange-800:focus::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-orange-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-yellow-50:focus::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-yellow-100:focus::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-yellow-200:focus::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-yellow-300:focus::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-yellow-400:focus::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-yellow-500:focus::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-yellow-600:focus::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-yellow-700:focus::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-yellow-800:focus::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-yellow-900:focus::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-green-50:focus::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-green-100:focus::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-green-200:focus::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-green-300:focus::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-green-400:focus::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-green-500:focus::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-green-600:focus::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-green-700:focus::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-green-800:focus::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-green-900:focus::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-teal-50:focus::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-teal-100:focus::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-teal-200:focus::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-teal-300:focus::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-teal-400:focus::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-teal-500:focus::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-teal-600:focus::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-teal-700:focus::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-teal-800:focus::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-teal-900:focus::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-blue-50:focus::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-blue-100:focus::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-blue-200:focus::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-blue-300:focus::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-blue-400:focus::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-blue-500:focus::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-blue-600:focus::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-blue-700:focus::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-blue-800:focus::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-blue-900:focus::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-pink-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-pink-100:focus::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-pink-200:focus::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-pink-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-pink-400:focus::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-pink-500:focus::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-pink-600:focus::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-pink-700:focus::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-pink-800:focus::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.sm\\:focus\\:placeholder-pink-900:focus::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-transparent::placeholder{color:#0000}.theme-dark .sm\\:dark\\:placeholder-white::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-black::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-gray-50::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-gray-100::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-gray-200::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-gray-300::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-gray-400::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-gray-500::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-gray-600::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-gray-700::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-gray-800::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-gray-900::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-cool-gray-50::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-cool-gray-100::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-cool-gray-200::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-cool-gray-300::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-cool-gray-400::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-cool-gray-500::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-cool-gray-600::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-cool-gray-700::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-cool-gray-800::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-cool-gray-900::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-red-50::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-red-100::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-red-200::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-red-300::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-red-400::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-red-500::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-red-600::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-red-700::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-red-800::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-red-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-orange-50::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-orange-100::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-orange-200::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-orange-300::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-orange-400::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-orange-500::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-orange-600::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-orange-700::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-orange-800::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-orange-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-yellow-50::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-yellow-100::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-yellow-200::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-yellow-300::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-yellow-400::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-yellow-500::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-yellow-600::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-yellow-700::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-yellow-800::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-yellow-900::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-green-50::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-green-100::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-green-200::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-green-300::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-green-400::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-green-500::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-green-600::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-green-700::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-green-800::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-green-900::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-teal-50::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-teal-100::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-teal-200::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-teal-300::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-teal-400::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-teal-500::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-teal-600::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-teal-700::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-teal-800::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-teal-900::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-blue-50::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-blue-100::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-blue-200::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-blue-300::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-blue-400::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-blue-500::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-blue-600::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-blue-700::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-blue-800::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-blue-900::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-pink-50::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-pink-100::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-pink-200::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-pink-300::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-pink-400::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-pink-500::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-pink-600::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-pink-700::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-pink-800::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:placeholder-pink-900::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-transparent:focus::placeholder{color:#0000}.theme-dark .sm\\:dark\\:focus\\:placeholder-white:focus::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-black:focus::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-gray-50:focus::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-gray-300:focus::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-gray-400:focus::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-gray-500:focus::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-gray-600:focus::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-gray-700:focus::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-gray-800:focus::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-gray-900:focus::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-50:focus::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-300:focus::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-400:focus::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-500:focus::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-600:focus::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-700:focus::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-800:focus::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-cool-gray-900:focus::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-red-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-red-100:focus::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-red-200:focus::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-red-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-red-400:focus::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-red-500:focus::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-red-600:focus::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-red-700:focus::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-red-800:focus::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-red-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-orange-50:focus::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-orange-100:focus::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-orange-200:focus::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-orange-300:focus::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-orange-400:focus::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-orange-500:focus::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-orange-600:focus::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-orange-700:focus::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-orange-800:focus::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-orange-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-50:focus::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-100:focus::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-200:focus::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-300:focus::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-400:focus::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-500:focus::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-600:focus::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-700:focus::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-800:focus::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-yellow-900:focus::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-green-50:focus::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-green-100:focus::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-green-200:focus::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-green-300:focus::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-green-400:focus::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-green-500:focus::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-green-600:focus::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-green-700:focus::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-green-800:focus::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-green-900:focus::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-teal-50:focus::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-teal-100:focus::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-teal-200:focus::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-teal-300:focus::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-teal-400:focus::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-teal-500:focus::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-teal-600:focus::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-teal-700:focus::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-teal-800:focus::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-teal-900:focus::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-blue-50:focus::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-blue-100:focus::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-blue-200:focus::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-blue-300:focus::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-blue-400:focus::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-blue-500:focus::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-blue-600:focus::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-blue-700:focus::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-blue-800:focus::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-blue-900:focus::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-pink-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-pink-100:focus::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-pink-200:focus::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-pink-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-pink-400:focus::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-pink-500:focus::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-pink-600:focus::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-pink-700:focus::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-pink-800:focus::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.theme-dark .sm\\:dark\\:focus\\:placeholder-pink-900:focus::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.sm\\:placeholder-opacity-0::placeholder{--placeholder-opacity:0}.sm\\:placeholder-opacity-25::placeholder{--placeholder-opacity:0.25}.sm\\:placeholder-opacity-50::placeholder{--placeholder-opacity:0.5}.sm\\:placeholder-opacity-75::placeholder{--placeholder-opacity:0.75}.sm\\:placeholder-opacity-100::placeholder{--placeholder-opacity:1}.sm\\:focus\\:placeholder-opacity-0:focus::placeholder{--placeholder-opacity:0}.sm\\:focus\\:placeholder-opacity-25:focus::placeholder{--placeholder-opacity:0.25}.sm\\:focus\\:placeholder-opacity-50:focus::placeholder{--placeholder-opacity:0.5}.sm\\:focus\\:placeholder-opacity-75:focus::placeholder{--placeholder-opacity:0.75}.sm\\:focus\\:placeholder-opacity-100:focus::placeholder{--placeholder-opacity:1}.sm\\:pointer-events-none{pointer-events:none}.sm\\:pointer-events-auto{pointer-events:auto}.sm\\:static{position:static}.sm\\:fixed{position:fixed}.sm\\:absolute{position:absolute}.sm\\:relative{position:relative}.sm\\:sticky{position:-webkit-sticky;position:sticky}.sm\\:inset-0{bottom:0;left:0;right:0;top:0}.sm\\:inset-auto{bottom:auto;left:auto;right:auto;top:auto}.sm\\:inset-y-0{bottom:0;top:0}.sm\\:inset-x-0{left:0;right:0}.sm\\:inset-y-auto{bottom:auto;top:auto}.sm\\:inset-x-auto{left:auto;right:auto}.sm\\:top-0{top:0}.sm\\:right-0{right:0}.sm\\:bottom-0{bottom:0}.sm\\:left-0{left:0}.sm\\:top-auto{top:auto}.sm\\:right-auto{right:auto}.sm\\:bottom-auto{bottom:auto}.sm\\:left-auto{left:auto}.sm\\:resize-none{resize:none}.sm\\:resize-y{resize:vertical}.sm\\:resize-x{resize:horizontal}.sm\\:resize{resize:both}.sm\\:shadow-xs{box-shadow:0 0 0 1px #0000000d}.sm\\:shadow-sm{box-shadow:0 1px 2px 0 #0000000d}.sm\\:shadow{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.sm\\:shadow-md{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.sm\\:shadow-lg{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.sm\\:shadow-xl{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.sm\\:shadow-2xl{box-shadow:0 25px 50px -12px #00000040}.sm\\:shadow-inner{box-shadow:inset 0 2px 4px 0 #0000000f}.sm\\:shadow-outline{box-shadow:0 0 0 3px #4299e180}.sm\\:shadow-none{box-shadow:none}.sm\\:shadow-bottom{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.sm\\:hover\\:shadow-xs:hover{box-shadow:0 0 0 1px #0000000d}.sm\\:hover\\:shadow-sm:hover{box-shadow:0 1px 2px 0 #0000000d}.sm\\:hover\\:shadow:hover{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.sm\\:hover\\:shadow-md:hover{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.sm\\:hover\\:shadow-lg:hover{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.sm\\:hover\\:shadow-xl:hover{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.sm\\:hover\\:shadow-2xl:hover{box-shadow:0 25px 50px -12px #00000040}.sm\\:hover\\:shadow-inner:hover{box-shadow:inset 0 2px 4px 0 #0000000f}.sm\\:hover\\:shadow-outline:hover{box-shadow:0 0 0 3px #4299e180}.sm\\:hover\\:shadow-none:hover{box-shadow:none}.sm\\:hover\\:shadow-bottom:hover{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.sm\\:focus\\:shadow-xs:focus{box-shadow:0 0 0 1px #0000000d}.sm\\:focus\\:shadow-sm:focus{box-shadow:0 1px 2px 0 #0000000d}.sm\\:focus\\:shadow:focus{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.sm\\:focus\\:shadow-md:focus{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.sm\\:focus\\:shadow-lg:focus{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.sm\\:focus\\:shadow-xl:focus{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.sm\\:focus\\:shadow-2xl:focus{box-shadow:0 25px 50px -12px #00000040}.sm\\:focus\\:shadow-inner:focus{box-shadow:inset 0 2px 4px 0 #0000000f}.sm\\:focus\\:shadow-outline:focus{box-shadow:0 0 0 3px #4299e180}.sm\\:focus\\:shadow-none:focus{box-shadow:none}.sm\\:focus\\:shadow-bottom:focus{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.theme-dark .sm\\:dark\\:focus\\:shadow-xs:focus{box-shadow:0 0 0 1px #0000000d}.theme-dark .sm\\:dark\\:focus\\:shadow-sm:focus{box-shadow:0 1px 2px 0 #0000000d}.theme-dark .sm\\:dark\\:focus\\:shadow:focus{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.theme-dark .sm\\:dark\\:focus\\:shadow-md:focus{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.theme-dark .sm\\:dark\\:focus\\:shadow-lg:focus{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.theme-dark .sm\\:dark\\:focus\\:shadow-xl:focus{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.theme-dark .sm\\:dark\\:focus\\:shadow-2xl:focus{box-shadow:0 25px 50px -12px #00000040}.theme-dark .sm\\:dark\\:focus\\:shadow-inner:focus{box-shadow:inset 0 2px 4px 0 #0000000f}.theme-dark .sm\\:dark\\:focus\\:shadow-outline:focus{box-shadow:0 0 0 3px #4299e180}.theme-dark .sm\\:dark\\:focus\\:shadow-none:focus{box-shadow:none}.theme-dark .sm\\:dark\\:focus\\:shadow-bottom:focus{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.sm\\:fill-current{fill:currentColor}.sm\\:stroke-current{stroke:currentColor}.sm\\:stroke-0{stroke-width:0}.sm\\:stroke-1{stroke-width:1}.sm\\:stroke-2{stroke-width:2}.sm\\:table-auto{table-layout:auto}.sm\\:table-fixed{table-layout:fixed}.sm\\:text-left{text-align:left}.sm\\:text-center{text-align:center}.sm\\:text-right{text-align:right}.sm\\:text-justify{text-align:justify}.sm\\:text-transparent{color:#0000}.sm\\:text-white{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.sm\\:text-black{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.sm\\:text-gray-50{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.sm\\:text-gray-100{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.sm\\:text-gray-200{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.sm\\:text-gray-300{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.sm\\:text-gray-400{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.sm\\:text-gray-500{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.sm\\:text-gray-600{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.sm\\:text-gray-700{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.sm\\:text-gray-800{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.sm\\:text-gray-900{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.sm\\:text-cool-gray-50{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.sm\\:text-cool-gray-100{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.sm\\:text-cool-gray-200{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.sm\\:text-cool-gray-300{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.sm\\:text-cool-gray-400{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.sm\\:text-cool-gray-500{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.sm\\:text-cool-gray-600{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.sm\\:text-cool-gray-700{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.sm\\:text-cool-gray-800{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.sm\\:text-cool-gray-900{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.sm\\:text-red-50{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.sm\\:text-red-100{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.sm\\:text-red-200{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.sm\\:text-red-300{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.sm\\:text-red-400{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.sm\\:text-red-500{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.sm\\:text-red-600{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.sm\\:text-red-700{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.sm\\:text-red-800{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.sm\\:text-red-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.sm\\:text-orange-50{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.sm\\:text-orange-100{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.sm\\:text-orange-200{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.sm\\:text-orange-300{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.sm\\:text-orange-400{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.sm\\:text-orange-500{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.sm\\:text-orange-600{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.sm\\:text-orange-700{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.sm\\:text-orange-800{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.sm\\:text-orange-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.sm\\:text-yellow-50{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.sm\\:text-yellow-100{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.sm\\:text-yellow-200{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.sm\\:text-yellow-300{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.sm\\:text-yellow-400{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.sm\\:text-yellow-500{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.sm\\:text-yellow-600{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.sm\\:text-yellow-700{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.sm\\:text-yellow-800{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.sm\\:text-yellow-900{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.sm\\:text-green-50{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.sm\\:text-green-100{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.sm\\:text-green-200{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.sm\\:text-green-300{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.sm\\:text-green-400{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.sm\\:text-green-500{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.sm\\:text-green-600{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.sm\\:text-green-700{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.sm\\:text-green-800{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.sm\\:text-green-900{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.sm\\:text-teal-50{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.sm\\:text-teal-100{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.sm\\:text-teal-200{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.sm\\:text-teal-300{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.sm\\:text-teal-400{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.sm\\:text-teal-500{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.sm\\:text-teal-600{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.sm\\:text-teal-700{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.sm\\:text-teal-800{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.sm\\:text-teal-900{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.sm\\:text-blue-50{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.sm\\:text-blue-100{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.sm\\:text-blue-200{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.sm\\:text-blue-300{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.sm\\:text-blue-400{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.sm\\:text-blue-500{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.sm\\:text-blue-600{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.sm\\:text-blue-700{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.sm\\:text-blue-800{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.sm\\:text-blue-900{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.sm\\:text-indigo-50{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.sm\\:text-indigo-100{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.sm\\:text-indigo-200{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.sm\\:text-indigo-300{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.sm\\:text-indigo-400{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.sm\\:text-indigo-500{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.sm\\:text-indigo-600{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.sm\\:text-indigo-700{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.sm\\:text-indigo-800{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.sm\\:text-indigo-900{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.sm\\:text-indigo-50{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.sm\\:text-indigo-100{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.sm\\:text-indigo-200{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.sm\\:text-indigo-300{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.sm\\:text-indigo-400{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.sm\\:text-indigo-500{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.sm\\:text-indigo-600{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.sm\\:text-indigo-700{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.sm\\:text-indigo-800{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.sm\\:text-indigo-900{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.sm\\:text-pink-50{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.sm\\:text-pink-100{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.sm\\:text-pink-200{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.sm\\:text-pink-300{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.sm\\:text-pink-400{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.sm\\:text-pink-500{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.sm\\:text-pink-600{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.sm\\:text-pink-700{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.sm\\:text-pink-800{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.sm\\:text-pink-900{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.sm\\:focus\\:text-transparent:focus{color:#0000}.sm\\:focus\\:text-white:focus{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.sm\\:focus\\:text-black:focus{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.sm\\:focus\\:text-gray-50:focus{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.sm\\:focus\\:text-gray-100:focus{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.sm\\:focus\\:text-gray-200:focus{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.sm\\:focus\\:text-gray-300:focus{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.sm\\:focus\\:text-gray-400:focus{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.sm\\:focus\\:text-gray-500:focus{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.sm\\:focus\\:text-gray-600:focus{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.sm\\:focus\\:text-gray-700:focus{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.sm\\:focus\\:text-gray-800:focus{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.sm\\:focus\\:text-gray-900:focus{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.sm\\:focus\\:text-cool-gray-50:focus{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.sm\\:focus\\:text-cool-gray-100:focus{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.sm\\:focus\\:text-cool-gray-200:focus{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.sm\\:focus\\:text-cool-gray-300:focus{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.sm\\:focus\\:text-cool-gray-400:focus{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.sm\\:focus\\:text-cool-gray-500:focus{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.sm\\:focus\\:text-cool-gray-600:focus{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.sm\\:focus\\:text-cool-gray-700:focus{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.sm\\:focus\\:text-cool-gray-800:focus{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.sm\\:focus\\:text-cool-gray-900:focus{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.sm\\:focus\\:text-red-50:focus{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.sm\\:focus\\:text-red-100:focus{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.sm\\:focus\\:text-red-200:focus{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.sm\\:focus\\:text-red-300:focus{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.sm\\:focus\\:text-red-400:focus{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.sm\\:focus\\:text-red-500:focus{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.sm\\:focus\\:text-red-600:focus{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.sm\\:focus\\:text-red-700:focus{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.sm\\:focus\\:text-red-800:focus{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.sm\\:focus\\:text-red-900:focus{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.sm\\:focus\\:text-orange-50:focus{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.sm\\:focus\\:text-orange-100:focus{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.sm\\:focus\\:text-orange-200:focus{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.sm\\:focus\\:text-orange-300:focus{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.sm\\:focus\\:text-orange-400:focus{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.sm\\:focus\\:text-orange-500:focus{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.sm\\:focus\\:text-orange-600:focus{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.sm\\:focus\\:text-orange-700:focus{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.sm\\:focus\\:text-orange-800:focus{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.sm\\:focus\\:text-orange-900:focus{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.sm\\:focus\\:text-yellow-50:focus{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.sm\\:focus\\:text-yellow-100:focus{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.sm\\:focus\\:text-yellow-200:focus{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.sm\\:focus\\:text-yellow-300:focus{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.sm\\:focus\\:text-yellow-400:focus{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.sm\\:focus\\:text-yellow-500:focus{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.sm\\:focus\\:text-yellow-600:focus{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.sm\\:focus\\:text-yellow-700:focus{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.sm\\:focus\\:text-yellow-800:focus{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.sm\\:focus\\:text-yellow-900:focus{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.sm\\:focus\\:text-green-50:focus{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.sm\\:focus\\:text-green-100:focus{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.sm\\:focus\\:text-green-200:focus{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.sm\\:focus\\:text-green-300:focus{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.sm\\:focus\\:text-green-400:focus{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.sm\\:focus\\:text-green-500:focus{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.sm\\:focus\\:text-green-600:focus{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.sm\\:focus\\:text-green-700:focus{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.sm\\:focus\\:text-green-800:focus{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.sm\\:focus\\:text-green-900:focus{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.sm\\:focus\\:text-teal-50:focus{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.sm\\:focus\\:text-teal-100:focus{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.sm\\:focus\\:text-teal-200:focus{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.sm\\:focus\\:text-teal-300:focus{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.sm\\:focus\\:text-teal-400:focus{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.sm\\:focus\\:text-teal-500:focus{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.sm\\:focus\\:text-teal-600:focus{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.sm\\:focus\\:text-teal-700:focus{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.sm\\:focus\\:text-teal-800:focus{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.sm\\:focus\\:text-teal-900:focus{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.sm\\:focus\\:text-blue-50:focus{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.sm\\:focus\\:text-blue-100:focus{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.sm\\:focus\\:text-blue-200:focus{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.sm\\:focus\\:text-blue-300:focus{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.sm\\:focus\\:text-blue-400:focus{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.sm\\:focus\\:text-blue-500:focus{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.sm\\:focus\\:text-blue-600:focus{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.sm\\:focus\\:text-blue-700:focus{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.sm\\:focus\\:text-blue-800:focus{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.sm\\:focus\\:text-blue-900:focus{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.sm\\:focus\\:text-indigo-50:focus{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.sm\\:focus\\:text-indigo-100:focus{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.sm\\:focus\\:text-indigo-200:focus{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.sm\\:focus\\:text-indigo-300:focus{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.sm\\:focus\\:text-indigo-400:focus{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.sm\\:focus\\:text-indigo-500:focus{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.sm\\:focus\\:text-indigo-600:focus{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.sm\\:focus\\:text-indigo-700:focus{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.sm\\:focus\\:text-indigo-800:focus{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.sm\\:focus\\:text-indigo-900:focus{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.sm\\:focus\\:text-indigo-50:focus{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.sm\\:focus\\:text-indigo-100:focus{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.sm\\:focus\\:text-indigo-200:focus{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.sm\\:focus\\:text-indigo-300:focus{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.sm\\:focus\\:text-indigo-400:focus{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.sm\\:focus\\:text-indigo-500:focus{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.sm\\:focus\\:text-indigo-600:focus{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.sm\\:focus\\:text-indigo-700:focus{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.sm\\:focus\\:text-indigo-800:focus{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.sm\\:focus\\:text-indigo-900:focus{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.sm\\:focus\\:text-pink-50:focus{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.sm\\:focus\\:text-pink-100:focus{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.sm\\:focus\\:text-pink-200:focus{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.sm\\:focus\\:text-pink-300:focus{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.sm\\:focus\\:text-pink-400:focus{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.sm\\:focus\\:text-pink-500:focus{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.sm\\:focus\\:text-pink-600:focus{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.sm\\:focus\\:text-pink-700:focus{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.sm\\:focus\\:text-pink-800:focus{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.sm\\:focus\\:text-pink-900:focus{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.sm\\:focus-within\\:text-transparent:focus-within{color:#0000}.sm\\:focus-within\\:text-white:focus-within{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.sm\\:focus-within\\:text-black:focus-within{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.sm\\:focus-within\\:text-gray-50:focus-within{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.sm\\:focus-within\\:text-gray-100:focus-within{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.sm\\:focus-within\\:text-gray-200:focus-within{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.sm\\:focus-within\\:text-gray-300:focus-within{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.sm\\:focus-within\\:text-gray-400:focus-within{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.sm\\:focus-within\\:text-gray-500:focus-within{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.sm\\:focus-within\\:text-gray-600:focus-within{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.sm\\:focus-within\\:text-gray-700:focus-within{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.sm\\:focus-within\\:text-gray-800:focus-within{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.sm\\:focus-within\\:text-gray-900:focus-within{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.sm\\:focus-within\\:text-cool-gray-50:focus-within{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.sm\\:focus-within\\:text-cool-gray-100:focus-within{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.sm\\:focus-within\\:text-cool-gray-200:focus-within{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.sm\\:focus-within\\:text-cool-gray-300:focus-within{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.sm\\:focus-within\\:text-cool-gray-400:focus-within{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.sm\\:focus-within\\:text-cool-gray-500:focus-within{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.sm\\:focus-within\\:text-cool-gray-600:focus-within{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.sm\\:focus-within\\:text-cool-gray-700:focus-within{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.sm\\:focus-within\\:text-cool-gray-800:focus-within{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.sm\\:focus-within\\:text-cool-gray-900:focus-within{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.sm\\:focus-within\\:text-red-50:focus-within{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.sm\\:focus-within\\:text-red-100:focus-within{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.sm\\:focus-within\\:text-red-200:focus-within{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.sm\\:focus-within\\:text-red-300:focus-within{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.sm\\:focus-within\\:text-red-400:focus-within{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.sm\\:focus-within\\:text-red-500:focus-within{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.sm\\:focus-within\\:text-red-600:focus-within{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.sm\\:focus-within\\:text-red-700:focus-within{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.sm\\:focus-within\\:text-red-800:focus-within{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.sm\\:focus-within\\:text-red-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.sm\\:focus-within\\:text-orange-50:focus-within{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.sm\\:focus-within\\:text-orange-100:focus-within{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.sm\\:focus-within\\:text-orange-200:focus-within{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.sm\\:focus-within\\:text-orange-300:focus-within{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.sm\\:focus-within\\:text-orange-400:focus-within{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.sm\\:focus-within\\:text-orange-500:focus-within{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.sm\\:focus-within\\:text-orange-600:focus-within{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.sm\\:focus-within\\:text-orange-700:focus-within{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.sm\\:focus-within\\:text-orange-800:focus-within{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.sm\\:focus-within\\:text-orange-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.sm\\:focus-within\\:text-yellow-50:focus-within{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.sm\\:focus-within\\:text-yellow-100:focus-within{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.sm\\:focus-within\\:text-yellow-200:focus-within{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.sm\\:focus-within\\:text-yellow-300:focus-within{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.sm\\:focus-within\\:text-yellow-400:focus-within{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.sm\\:focus-within\\:text-yellow-500:focus-within{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.sm\\:focus-within\\:text-yellow-600:focus-within{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.sm\\:focus-within\\:text-yellow-700:focus-within{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.sm\\:focus-within\\:text-yellow-800:focus-within{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.sm\\:focus-within\\:text-yellow-900:focus-within{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.sm\\:focus-within\\:text-green-50:focus-within{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.sm\\:focus-within\\:text-green-100:focus-within{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.sm\\:focus-within\\:text-green-200:focus-within{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.sm\\:focus-within\\:text-green-300:focus-within{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.sm\\:focus-within\\:text-green-400:focus-within{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.sm\\:focus-within\\:text-green-500:focus-within{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.sm\\:focus-within\\:text-green-600:focus-within{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.sm\\:focus-within\\:text-green-700:focus-within{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.sm\\:focus-within\\:text-green-800:focus-within{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.sm\\:focus-within\\:text-green-900:focus-within{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.sm\\:focus-within\\:text-teal-50:focus-within{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.sm\\:focus-within\\:text-teal-100:focus-within{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.sm\\:focus-within\\:text-teal-200:focus-within{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.sm\\:focus-within\\:text-teal-300:focus-within{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.sm\\:focus-within\\:text-teal-400:focus-within{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.sm\\:focus-within\\:text-teal-500:focus-within{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.sm\\:focus-within\\:text-teal-600:focus-within{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.sm\\:focus-within\\:text-teal-700:focus-within{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.sm\\:focus-within\\:text-teal-800:focus-within{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.sm\\:focus-within\\:text-teal-900:focus-within{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.sm\\:focus-within\\:text-blue-50:focus-within{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.sm\\:focus-within\\:text-blue-100:focus-within{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.sm\\:focus-within\\:text-blue-200:focus-within{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.sm\\:focus-within\\:text-blue-300:focus-within{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.sm\\:focus-within\\:text-blue-400:focus-within{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.sm\\:focus-within\\:text-blue-500:focus-within{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.sm\\:focus-within\\:text-blue-600:focus-within{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.sm\\:focus-within\\:text-blue-700:focus-within{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.sm\\:focus-within\\:text-blue-800:focus-within{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.sm\\:focus-within\\:text-blue-900:focus-within{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.sm\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.sm\\:focus-within\\:text-pink-50:focus-within{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.sm\\:focus-within\\:text-pink-100:focus-within{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.sm\\:focus-within\\:text-pink-200:focus-within{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.sm\\:focus-within\\:text-pink-300:focus-within{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.sm\\:focus-within\\:text-pink-400:focus-within{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.sm\\:focus-within\\:text-pink-500:focus-within{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.sm\\:focus-within\\:text-pink-600:focus-within{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.sm\\:focus-within\\:text-pink-700:focus-within{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.sm\\:focus-within\\:text-pink-800:focus-within{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.sm\\:focus-within\\:text-pink-900:focus-within{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.sm\\:hover\\:text-transparent:hover{color:#0000}.sm\\:hover\\:text-white:hover{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.sm\\:hover\\:text-black:hover{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.sm\\:hover\\:text-gray-50:hover{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.sm\\:hover\\:text-gray-100:hover{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.sm\\:hover\\:text-gray-200:hover{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.sm\\:hover\\:text-gray-300:hover{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.sm\\:hover\\:text-gray-400:hover{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.sm\\:hover\\:text-gray-500:hover{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.sm\\:hover\\:text-gray-600:hover{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.sm\\:hover\\:text-gray-700:hover{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.sm\\:hover\\:text-gray-800:hover{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.sm\\:hover\\:text-gray-900:hover{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.sm\\:hover\\:text-cool-gray-50:hover{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.sm\\:hover\\:text-cool-gray-100:hover{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.sm\\:hover\\:text-cool-gray-200:hover{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.sm\\:hover\\:text-cool-gray-300:hover{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.sm\\:hover\\:text-cool-gray-400:hover{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.sm\\:hover\\:text-cool-gray-500:hover{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.sm\\:hover\\:text-cool-gray-600:hover{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.sm\\:hover\\:text-cool-gray-700:hover{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.sm\\:hover\\:text-cool-gray-800:hover{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.sm\\:hover\\:text-cool-gray-900:hover{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.sm\\:hover\\:text-red-50:hover{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.sm\\:hover\\:text-red-100:hover{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.sm\\:hover\\:text-red-200:hover{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.sm\\:hover\\:text-red-300:hover{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.sm\\:hover\\:text-red-400:hover{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.sm\\:hover\\:text-red-500:hover{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.sm\\:hover\\:text-red-600:hover{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.sm\\:hover\\:text-red-700:hover{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.sm\\:hover\\:text-red-800:hover{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.sm\\:hover\\:text-red-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.sm\\:hover\\:text-orange-50:hover{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.sm\\:hover\\:text-orange-100:hover{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.sm\\:hover\\:text-orange-200:hover{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.sm\\:hover\\:text-orange-300:hover{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.sm\\:hover\\:text-orange-400:hover{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.sm\\:hover\\:text-orange-500:hover{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.sm\\:hover\\:text-orange-600:hover{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.sm\\:hover\\:text-orange-700:hover{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.sm\\:hover\\:text-orange-800:hover{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.sm\\:hover\\:text-orange-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.sm\\:hover\\:text-yellow-50:hover{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.sm\\:hover\\:text-yellow-100:hover{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.sm\\:hover\\:text-yellow-200:hover{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.sm\\:hover\\:text-yellow-300:hover{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.sm\\:hover\\:text-yellow-400:hover{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.sm\\:hover\\:text-yellow-500:hover{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.sm\\:hover\\:text-yellow-600:hover{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.sm\\:hover\\:text-yellow-700:hover{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.sm\\:hover\\:text-yellow-800:hover{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.sm\\:hover\\:text-yellow-900:hover{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.sm\\:hover\\:text-green-50:hover{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.sm\\:hover\\:text-green-100:hover{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.sm\\:hover\\:text-green-200:hover{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.sm\\:hover\\:text-green-300:hover{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.sm\\:hover\\:text-green-400:hover{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.sm\\:hover\\:text-green-500:hover{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.sm\\:hover\\:text-green-600:hover{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.sm\\:hover\\:text-green-700:hover{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.sm\\:hover\\:text-green-800:hover{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.sm\\:hover\\:text-green-900:hover{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.sm\\:hover\\:text-teal-50:hover{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.sm\\:hover\\:text-teal-100:hover{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.sm\\:hover\\:text-teal-200:hover{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.sm\\:hover\\:text-teal-300:hover{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.sm\\:hover\\:text-teal-400:hover{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.sm\\:hover\\:text-teal-500:hover{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.sm\\:hover\\:text-teal-600:hover{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.sm\\:hover\\:text-teal-700:hover{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.sm\\:hover\\:text-teal-800:hover{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.sm\\:hover\\:text-teal-900:hover{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.sm\\:hover\\:text-blue-50:hover{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.sm\\:hover\\:text-blue-100:hover{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.sm\\:hover\\:text-blue-200:hover{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.sm\\:hover\\:text-blue-300:hover{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.sm\\:hover\\:text-blue-400:hover{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.sm\\:hover\\:text-blue-500:hover{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.sm\\:hover\\:text-blue-600:hover{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.sm\\:hover\\:text-blue-700:hover{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.sm\\:hover\\:text-blue-800:hover{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.sm\\:hover\\:text-blue-900:hover{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.sm\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.sm\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.sm\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.sm\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.sm\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.sm\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.sm\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.sm\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.sm\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.sm\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.sm\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.sm\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.sm\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.sm\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.sm\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.sm\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.sm\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.sm\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.sm\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.sm\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.sm\\:hover\\:text-pink-50:hover{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.sm\\:hover\\:text-pink-100:hover{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.sm\\:hover\\:text-pink-200:hover{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.sm\\:hover\\:text-pink-300:hover{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.sm\\:hover\\:text-pink-400:hover{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.sm\\:hover\\:text-pink-500:hover{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.sm\\:hover\\:text-pink-600:hover{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.sm\\:hover\\:text-pink-700:hover{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.sm\\:hover\\:text-pink-800:hover{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.sm\\:hover\\:text-pink-900:hover{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.sm\\:active\\:text-transparent:active{color:#0000}.sm\\:active\\:text-white:active{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.sm\\:active\\:text-black:active{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.sm\\:active\\:text-gray-50:active{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.sm\\:active\\:text-gray-100:active{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.sm\\:active\\:text-gray-200:active{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.sm\\:active\\:text-gray-300:active{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.sm\\:active\\:text-gray-400:active{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.sm\\:active\\:text-gray-500:active{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.sm\\:active\\:text-gray-600:active{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.sm\\:active\\:text-gray-700:active{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.sm\\:active\\:text-gray-800:active{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.sm\\:active\\:text-gray-900:active{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.sm\\:active\\:text-cool-gray-50:active{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.sm\\:active\\:text-cool-gray-100:active{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.sm\\:active\\:text-cool-gray-200:active{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.sm\\:active\\:text-cool-gray-300:active{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.sm\\:active\\:text-cool-gray-400:active{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.sm\\:active\\:text-cool-gray-500:active{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.sm\\:active\\:text-cool-gray-600:active{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.sm\\:active\\:text-cool-gray-700:active{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.sm\\:active\\:text-cool-gray-800:active{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.sm\\:active\\:text-cool-gray-900:active{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.sm\\:active\\:text-red-50:active{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.sm\\:active\\:text-red-100:active{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.sm\\:active\\:text-red-200:active{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.sm\\:active\\:text-red-300:active{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.sm\\:active\\:text-red-400:active{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.sm\\:active\\:text-red-500:active{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.sm\\:active\\:text-red-600:active{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.sm\\:active\\:text-red-700:active{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.sm\\:active\\:text-red-800:active{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.sm\\:active\\:text-red-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.sm\\:active\\:text-orange-50:active{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.sm\\:active\\:text-orange-100:active{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.sm\\:active\\:text-orange-200:active{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.sm\\:active\\:text-orange-300:active{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.sm\\:active\\:text-orange-400:active{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.sm\\:active\\:text-orange-500:active{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.sm\\:active\\:text-orange-600:active{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.sm\\:active\\:text-orange-700:active{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.sm\\:active\\:text-orange-800:active{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.sm\\:active\\:text-orange-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.sm\\:active\\:text-yellow-50:active{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.sm\\:active\\:text-yellow-100:active{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.sm\\:active\\:text-yellow-200:active{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.sm\\:active\\:text-yellow-300:active{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.sm\\:active\\:text-yellow-400:active{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.sm\\:active\\:text-yellow-500:active{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.sm\\:active\\:text-yellow-600:active{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.sm\\:active\\:text-yellow-700:active{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.sm\\:active\\:text-yellow-800:active{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.sm\\:active\\:text-yellow-900:active{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.sm\\:active\\:text-green-50:active{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.sm\\:active\\:text-green-100:active{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.sm\\:active\\:text-green-200:active{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.sm\\:active\\:text-green-300:active{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.sm\\:active\\:text-green-400:active{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.sm\\:active\\:text-green-500:active{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.sm\\:active\\:text-green-600:active{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.sm\\:active\\:text-green-700:active{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.sm\\:active\\:text-green-800:active{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.sm\\:active\\:text-green-900:active{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.sm\\:active\\:text-teal-50:active{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.sm\\:active\\:text-teal-100:active{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.sm\\:active\\:text-teal-200:active{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.sm\\:active\\:text-teal-300:active{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.sm\\:active\\:text-teal-400:active{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.sm\\:active\\:text-teal-500:active{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.sm\\:active\\:text-teal-600:active{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.sm\\:active\\:text-teal-700:active{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.sm\\:active\\:text-teal-800:active{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.sm\\:active\\:text-teal-900:active{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.sm\\:active\\:text-blue-50:active{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.sm\\:active\\:text-blue-100:active{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.sm\\:active\\:text-blue-200:active{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.sm\\:active\\:text-blue-300:active{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.sm\\:active\\:text-blue-400:active{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.sm\\:active\\:text-blue-500:active{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.sm\\:active\\:text-blue-600:active{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.sm\\:active\\:text-blue-700:active{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.sm\\:active\\:text-blue-800:active{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.sm\\:active\\:text-blue-900:active{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.sm\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.sm\\:active\\:text-indigo-100:active{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.sm\\:active\\:text-indigo-200:active{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.sm\\:active\\:text-indigo-300:active{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.sm\\:active\\:text-indigo-400:active{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.sm\\:active\\:text-indigo-500:active{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.sm\\:active\\:text-indigo-600:active{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.sm\\:active\\:text-indigo-700:active{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.sm\\:active\\:text-indigo-800:active{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.sm\\:active\\:text-indigo-900:active{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.sm\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.sm\\:active\\:text-indigo-100:active{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.sm\\:active\\:text-indigo-200:active{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.sm\\:active\\:text-indigo-300:active{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.sm\\:active\\:text-indigo-400:active{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.sm\\:active\\:text-indigo-500:active{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.sm\\:active\\:text-indigo-600:active{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.sm\\:active\\:text-indigo-700:active{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.sm\\:active\\:text-indigo-800:active{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.sm\\:active\\:text-indigo-900:active{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.sm\\:active\\:text-pink-50:active{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.sm\\:active\\:text-pink-100:active{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.sm\\:active\\:text-pink-200:active{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.sm\\:active\\:text-pink-300:active{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.sm\\:active\\:text-pink-400:active{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.sm\\:active\\:text-pink-500:active{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.sm\\:active\\:text-pink-600:active{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.sm\\:active\\:text-pink-700:active{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.sm\\:active\\:text-pink-800:active{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.sm\\:active\\:text-pink-900:active{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-transparent{color:#0000}.theme-dark .sm\\:dark\\:text-white{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-black{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-gray-50{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-gray-100{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-gray-200{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-gray-300{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-gray-400{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-gray-500{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-gray-600{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-gray-700{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-gray-800{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-gray-900{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-cool-gray-50{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-cool-gray-100{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-cool-gray-200{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-cool-gray-300{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-cool-gray-400{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-cool-gray-500{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-cool-gray-600{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-cool-gray-700{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-cool-gray-800{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-cool-gray-900{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-red-50{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-red-100{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-red-200{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-red-300{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-red-400{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-red-500{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-red-600{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-red-700{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-red-800{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-red-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-orange-50{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-orange-100{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-orange-200{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-orange-300{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-orange-400{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-orange-500{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-orange-600{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-orange-700{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-orange-800{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-orange-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-yellow-50{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-yellow-100{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-yellow-200{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-yellow-300{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-yellow-400{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-yellow-500{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-yellow-600{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-yellow-700{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-yellow-800{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-yellow-900{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-green-50{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-green-100{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-green-200{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-green-300{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-green-400{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-green-500{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-green-600{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-green-700{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-green-800{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-green-900{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-teal-50{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-teal-100{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-teal-200{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-teal-300{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-teal-400{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-teal-500{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-teal-600{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-teal-700{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-teal-800{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-teal-900{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-blue-50{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-blue-100{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-blue-200{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-blue-300{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-blue-400{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-blue-500{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-blue-600{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-blue-700{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-blue-800{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-blue-900{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-50{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-100{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-200{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-300{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-400{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-500{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-600{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-700{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-800{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-900{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-50{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-100{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-200{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-300{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-400{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-500{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-600{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-700{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-800{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-indigo-900{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-pink-50{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-pink-100{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-pink-200{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-pink-300{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-pink-400{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-pink-500{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-pink-600{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-pink-700{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-pink-800{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .sm\\:dark\\:text-pink-900{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-transparent:focus-within{color:#0000}.theme-dark .sm\\:dark\\:focus-within\\:text-white:focus-within{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-black:focus-within{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-gray-50:focus-within{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-gray-100:focus-within{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-gray-200:focus-within{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-gray-300:focus-within{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-gray-400:focus-within{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-gray-500:focus-within{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-gray-600:focus-within{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-gray-700:focus-within{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-gray-800:focus-within{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-gray-900:focus-within{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-50:focus-within{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-100:focus-within{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-200:focus-within{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-300:focus-within{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-400:focus-within{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-500:focus-within{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-600:focus-within{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-700:focus-within{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-800:focus-within{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-cool-gray-900:focus-within{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-red-50:focus-within{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-red-100:focus-within{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-red-200:focus-within{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-red-300:focus-within{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-red-400:focus-within{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-red-500:focus-within{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-red-600:focus-within{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-red-700:focus-within{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-red-800:focus-within{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-red-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-orange-50:focus-within{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-orange-100:focus-within{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-orange-200:focus-within{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-orange-300:focus-within{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-orange-400:focus-within{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-orange-500:focus-within{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-orange-600:focus-within{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-orange-700:focus-within{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-orange-800:focus-within{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-orange-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-yellow-50:focus-within{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-yellow-100:focus-within{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-yellow-200:focus-within{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-yellow-300:focus-within{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-yellow-400:focus-within{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-yellow-500:focus-within{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-yellow-600:focus-within{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-yellow-700:focus-within{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-yellow-800:focus-within{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-yellow-900:focus-within{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-green-50:focus-within{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-green-100:focus-within{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-green-200:focus-within{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-green-300:focus-within{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-green-400:focus-within{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-green-500:focus-within{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-green-600:focus-within{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-green-700:focus-within{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-green-800:focus-within{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-green-900:focus-within{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-teal-50:focus-within{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-teal-100:focus-within{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-teal-200:focus-within{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-teal-300:focus-within{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-teal-400:focus-within{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-teal-500:focus-within{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-teal-600:focus-within{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-teal-700:focus-within{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-teal-800:focus-within{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-teal-900:focus-within{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-blue-50:focus-within{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-blue-100:focus-within{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-blue-200:focus-within{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-blue-300:focus-within{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-blue-400:focus-within{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-blue-500:focus-within{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-blue-600:focus-within{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-blue-700:focus-within{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-blue-800:focus-within{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-blue-900:focus-within{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-pink-50:focus-within{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-pink-100:focus-within{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-pink-200:focus-within{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-pink-300:focus-within{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-pink-400:focus-within{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-pink-500:focus-within{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-pink-600:focus-within{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-pink-700:focus-within{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-pink-800:focus-within{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .sm\\:dark\\:focus-within\\:text-pink-900:focus-within{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-transparent:hover{color:#0000}.theme-dark .sm\\:dark\\:hover\\:text-white:hover{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-black:hover{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-gray-50:hover{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-gray-100:hover{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-gray-200:hover{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-gray-300:hover{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-gray-400:hover{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-gray-500:hover{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-gray-600:hover{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-gray-700:hover{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-gray-800:hover{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-gray-900:hover{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-cool-gray-50:hover{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-cool-gray-100:hover{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-cool-gray-200:hover{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-cool-gray-300:hover{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-cool-gray-400:hover{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-cool-gray-500:hover{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-cool-gray-600:hover{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-cool-gray-700:hover{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-cool-gray-800:hover{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-cool-gray-900:hover{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-red-50:hover{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-red-100:hover{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-red-200:hover{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-red-300:hover{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-red-400:hover{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-red-500:hover{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-red-600:hover{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-red-700:hover{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-red-800:hover{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-red-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-orange-50:hover{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-orange-100:hover{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-orange-200:hover{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-orange-300:hover{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-orange-400:hover{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-orange-500:hover{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-orange-600:hover{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-orange-700:hover{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-orange-800:hover{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-orange-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-yellow-50:hover{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-yellow-100:hover{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-yellow-200:hover{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-yellow-300:hover{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-yellow-400:hover{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-yellow-500:hover{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-yellow-600:hover{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-yellow-700:hover{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-yellow-800:hover{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-yellow-900:hover{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-green-50:hover{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-green-100:hover{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-green-200:hover{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-green-300:hover{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-green-400:hover{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-green-500:hover{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-green-600:hover{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-green-700:hover{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-green-800:hover{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-green-900:hover{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-teal-50:hover{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-teal-100:hover{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-teal-200:hover{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-teal-300:hover{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-teal-400:hover{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-teal-500:hover{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-teal-600:hover{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-teal-700:hover{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-teal-800:hover{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-teal-900:hover{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-blue-50:hover{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-blue-100:hover{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-blue-200:hover{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-blue-300:hover{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-blue-400:hover{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-blue-500:hover{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-blue-600:hover{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-blue-700:hover{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-blue-800:hover{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-blue-900:hover{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-pink-50:hover{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-pink-100:hover{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-pink-200:hover{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-pink-300:hover{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-pink-400:hover{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-pink-500:hover{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-pink-600:hover{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-pink-700:hover{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-pink-800:hover{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .sm\\:dark\\:hover\\:text-pink-900:hover{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-transparent:active{color:#0000}.theme-dark .sm\\:dark\\:active\\:text-white:active{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-black:active{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-gray-50:active{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-gray-100:active{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-gray-200:active{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-gray-300:active{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-gray-400:active{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-gray-500:active{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-gray-600:active{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-gray-700:active{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-gray-800:active{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-gray-900:active{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-cool-gray-50:active{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-cool-gray-100:active{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-cool-gray-200:active{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-cool-gray-300:active{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-cool-gray-400:active{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-cool-gray-500:active{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-cool-gray-600:active{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-cool-gray-700:active{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-cool-gray-800:active{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-cool-gray-900:active{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-red-50:active{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-red-100:active{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-red-200:active{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-red-300:active{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-red-400:active{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-red-500:active{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-red-600:active{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-red-700:active{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-red-800:active{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-red-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-orange-50:active{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-orange-100:active{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-orange-200:active{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-orange-300:active{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-orange-400:active{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-orange-500:active{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-orange-600:active{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-orange-700:active{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-orange-800:active{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-orange-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-yellow-50:active{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-yellow-100:active{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-yellow-200:active{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-yellow-300:active{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-yellow-400:active{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-yellow-500:active{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-yellow-600:active{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-yellow-700:active{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-yellow-800:active{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-yellow-900:active{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-green-50:active{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-green-100:active{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-green-200:active{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-green-300:active{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-green-400:active{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-green-500:active{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-green-600:active{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-green-700:active{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-green-800:active{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-green-900:active{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-teal-50:active{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-teal-100:active{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-teal-200:active{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-teal-300:active{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-teal-400:active{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-teal-500:active{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-teal-600:active{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-teal-700:active{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-teal-800:active{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-teal-900:active{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-blue-50:active{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-blue-100:active{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-blue-200:active{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-blue-300:active{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-blue-400:active{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-blue-500:active{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-blue-600:active{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-blue-700:active{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-blue-800:active{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-blue-900:active{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-100:active{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-200:active{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-300:active{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-400:active{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-500:active{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-600:active{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-700:active{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-800:active{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-900:active{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-100:active{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-200:active{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-300:active{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-400:active{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-500:active{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-600:active{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-700:active{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-800:active{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-indigo-900:active{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-pink-50:active{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-pink-100:active{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-pink-200:active{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-pink-300:active{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-pink-400:active{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-pink-500:active{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-pink-600:active{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-pink-700:active{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-pink-800:active{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .sm\\:dark\\:active\\:text-pink-900:active{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.sm\\:text-opacity-0{--text-opacity:0}.sm\\:text-opacity-25{--text-opacity:0.25}.sm\\:text-opacity-50{--text-opacity:0.5}.sm\\:text-opacity-75{--text-opacity:0.75}.sm\\:text-opacity-100{--text-opacity:1}.sm\\:hover\\:text-opacity-0:hover{--text-opacity:0}.sm\\:hover\\:text-opacity-25:hover{--text-opacity:0.25}.sm\\:hover\\:text-opacity-50:hover{--text-opacity:0.5}.sm\\:hover\\:text-opacity-75:hover{--text-opacity:0.75}.sm\\:hover\\:text-opacity-100:hover{--text-opacity:1}.sm\\:focus\\:text-opacity-0:focus{--text-opacity:0}.sm\\:focus\\:text-opacity-25:focus{--text-opacity:0.25}.sm\\:focus\\:text-opacity-50:focus{--text-opacity:0.5}.sm\\:focus\\:text-opacity-75:focus{--text-opacity:0.75}.sm\\:focus\\:text-opacity-100:focus{--text-opacity:1}.sm\\:italic{font-style:italic}.sm\\:not-italic{font-style:normal}.sm\\:uppercase{text-transform:uppercase}.sm\\:lowercase{text-transform:lowercase}.sm\\:capitalize{text-transform:capitalize}.sm\\:normal-case{text-transform:none}.sm\\:underline{-webkit-text-decoration:underline;text-decoration:underline}.sm\\:line-through{-webkit-text-decoration:line-through;text-decoration:line-through}.sm\\:no-underline{-webkit-text-decoration:none;text-decoration:none}.sm\\:hover\\:underline:hover{-webkit-text-decoration:underline;text-decoration:underline}.sm\\:hover\\:line-through:hover{-webkit-text-decoration:line-through;text-decoration:line-through}.sm\\:hover\\:no-underline:hover{-webkit-text-decoration:none;text-decoration:none}.sm\\:focus\\:underline:focus{-webkit-text-decoration:underline;text-decoration:underline}.sm\\:focus\\:line-through:focus{-webkit-text-decoration:line-through;text-decoration:line-through}.sm\\:focus\\:no-underline:focus{-webkit-text-decoration:none;text-decoration:none}.sm\\:antialiased{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.sm\\:subpixel-antialiased{-webkit-font-smoothing:auto;-moz-osx-font-smoothing:auto}.sm\\:tracking-tighter{letter-spacing:-.05em}.sm\\:tracking-tight{letter-spacing:-.025em}.sm\\:tracking-normal{letter-spacing:0}.sm\\:tracking-wide{letter-spacing:.025em}.sm\\:tracking-wider{letter-spacing:.05em}.sm\\:tracking-widest{letter-spacing:.1em}.sm\\:select-none{-webkit-user-select:none;user-select:none}.sm\\:select-text{-webkit-user-select:text;user-select:text}.sm\\:select-all{-webkit-user-select:all;user-select:all}.sm\\:select-auto{-webkit-user-select:auto;user-select:auto}.sm\\:align-baseline{vertical-align:initial}.sm\\:align-top{vertical-align:top}.sm\\:align-middle{vertical-align:middle}.sm\\:align-bottom{vertical-align:bottom}.sm\\:align-text-top{vertical-align:text-top}.sm\\:align-text-bottom{vertical-align:text-bottom}.sm\\:visible{visibility:visible}.sm\\:invisible{visibility:hidden}.sm\\:whitespace-normal{white-space:normal}.sm\\:whitespace-no-wrap{white-space:nowrap}.sm\\:whitespace-pre{white-space:pre}.sm\\:whitespace-pre-line{white-space:pre-line}.sm\\:whitespace-pre-wrap{white-space:pre-wrap}.sm\\:break-normal{overflow-wrap:normal;word-break:normal}.sm\\:break-words{overflow-wrap:break-word}.sm\\:break-all{word-break:break-all}.sm\\:truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sm\\:w-0{width:0}.sm\\:w-1{width:.25rem}.sm\\:w-2{width:.5rem}.sm\\:w-3{width:.75rem}.sm\\:w-4{width:1rem}.sm\\:w-5{width:1.25rem}.sm\\:w-6{width:1.5rem}.sm\\:w-8{width:2rem}.sm\\:w-10{width:2.5rem}.sm\\:w-12{width:3rem}.sm\\:w-16{width:4rem}.sm\\:w-20{width:5rem}.sm\\:w-24{width:6rem}.sm\\:w-32{width:8rem}.sm\\:w-40{width:10rem}.sm\\:w-48{width:12rem}.sm\\:w-56{width:14rem}.sm\\:w-64{width:16rem}.sm\\:w-auto{width:auto}.sm\\:w-px{width:1px}.sm\\:w-1\\/2{width:50%}.sm\\:w-1\\/3{width:33.333333%}.sm\\:w-2\\/3{width:66.666667%}.sm\\:w-1\\/4{width:25%}.sm\\:w-2\\/4{width:50%}.sm\\:w-3\\/4{width:75%}.sm\\:w-1\\/5{width:20%}.sm\\:w-2\\/5{width:40%}.sm\\:w-3\\/5{width:60%}.sm\\:w-4\\/5{width:80%}.sm\\:w-1\\/6{width:16.666667%}.sm\\:w-2\\/6{width:33.333333%}.sm\\:w-3\\/6{width:50%}.sm\\:w-4\\/6{width:66.666667%}.sm\\:w-5\\/6{width:83.333333%}.sm\\:w-1\\/12{width:8.333333%}.sm\\:w-2\\/12{width:16.666667%}.sm\\:w-3\\/12{width:25%}.sm\\:w-4\\/12{width:33.333333%}.sm\\:w-5\\/12{width:41.666667%}.sm\\:w-6\\/12{width:50%}.sm\\:w-7\\/12{width:58.333333%}.sm\\:w-8\\/12{width:66.666667%}.sm\\:w-9\\/12{width:75%}.sm\\:w-10\\/12{width:83.333333%}.sm\\:w-11\\/12{width:91.666667%}.sm\\:w-full{width:100%}.sm\\:w-screen{width:100vw}.sm\\:z-0{z-index:0}.sm\\:z-10{z-index:10}.sm\\:z-20{z-index:20}.sm\\:z-30{z-index:30}.sm\\:z-40{z-index:40}.sm\\:z-50{z-index:50}.sm\\:z-auto{z-index:auto}.sm\\:gap-0{grid-gap:0;gap:0}.sm\\:gap-1{grid-gap:.25rem;gap:.25rem}.sm\\:gap-2{grid-gap:.5rem;gap:.5rem}.sm\\:gap-3{grid-gap:.75rem;gap:.75rem}.sm\\:gap-4{grid-gap:1rem;gap:1rem}.sm\\:gap-5{grid-gap:1.25rem;gap:1.25rem}.sm\\:gap-6{grid-gap:1.5rem;gap:1.5rem}.sm\\:gap-8{grid-gap:2rem;gap:2rem}.sm\\:gap-10{grid-gap:2.5rem;gap:2.5rem}.sm\\:gap-12{grid-gap:3rem;gap:3rem}.sm\\:gap-16{grid-gap:4rem;gap:4rem}.sm\\:gap-20{grid-gap:5rem;gap:5rem}.sm\\:gap-24{grid-gap:6rem;gap:6rem}.sm\\:gap-32{grid-gap:8rem;gap:8rem}.sm\\:gap-40{grid-gap:10rem;gap:10rem}.sm\\:gap-48{grid-gap:12rem;gap:12rem}.sm\\:gap-56{grid-gap:14rem;gap:14rem}.sm\\:gap-64{grid-gap:16rem;gap:16rem}.sm\\:gap-px{grid-gap:1px;gap:1px}.sm\\:col-gap-0{grid-column-gap:0;column-gap:0}.sm\\:col-gap-1{grid-column-gap:.25rem;column-gap:.25rem}.sm\\:col-gap-2{grid-column-gap:.5rem;column-gap:.5rem}.sm\\:col-gap-3{grid-column-gap:.75rem;column-gap:.75rem}.sm\\:col-gap-4{grid-column-gap:1rem;column-gap:1rem}.sm\\:col-gap-5{grid-column-gap:1.25rem;column-gap:1.25rem}.sm\\:col-gap-6{grid-column-gap:1.5rem;column-gap:1.5rem}.sm\\:col-gap-8{grid-column-gap:2rem;column-gap:2rem}.sm\\:col-gap-10{grid-column-gap:2.5rem;column-gap:2.5rem}.sm\\:col-gap-12{grid-column-gap:3rem;column-gap:3rem}.sm\\:col-gap-16{grid-column-gap:4rem;column-gap:4rem}.sm\\:col-gap-20{grid-column-gap:5rem;column-gap:5rem}.sm\\:col-gap-24{grid-column-gap:6rem;column-gap:6rem}.sm\\:col-gap-32{grid-column-gap:8rem;column-gap:8rem}.sm\\:col-gap-40{grid-column-gap:10rem;column-gap:10rem}.sm\\:col-gap-48{grid-column-gap:12rem;column-gap:12rem}.sm\\:col-gap-56{grid-column-gap:14rem;column-gap:14rem}.sm\\:col-gap-64{grid-column-gap:16rem;column-gap:16rem}.sm\\:col-gap-px{grid-column-gap:1px;column-gap:1px}.sm\\:row-gap-0{grid-row-gap:0;row-gap:0}.sm\\:row-gap-1{grid-row-gap:.25rem;row-gap:.25rem}.sm\\:row-gap-2{grid-row-gap:.5rem;row-gap:.5rem}.sm\\:row-gap-3{grid-row-gap:.75rem;row-gap:.75rem}.sm\\:row-gap-4{grid-row-gap:1rem;row-gap:1rem}.sm\\:row-gap-5{grid-row-gap:1.25rem;row-gap:1.25rem}.sm\\:row-gap-6{grid-row-gap:1.5rem;row-gap:1.5rem}.sm\\:row-gap-8{grid-row-gap:2rem;row-gap:2rem}.sm\\:row-gap-10{grid-row-gap:2.5rem;row-gap:2.5rem}.sm\\:row-gap-12{grid-row-gap:3rem;row-gap:3rem}.sm\\:row-gap-16{grid-row-gap:4rem;row-gap:4rem}.sm\\:row-gap-20{grid-row-gap:5rem;row-gap:5rem}.sm\\:row-gap-24{grid-row-gap:6rem;row-gap:6rem}.sm\\:row-gap-32{grid-row-gap:8rem;row-gap:8rem}.sm\\:row-gap-40{grid-row-gap:10rem;row-gap:10rem}.sm\\:row-gap-48{grid-row-gap:12rem;row-gap:12rem}.sm\\:row-gap-56{grid-row-gap:14rem;row-gap:14rem}.sm\\:row-gap-64{grid-row-gap:16rem;row-gap:16rem}.sm\\:row-gap-px{grid-row-gap:1px;row-gap:1px}.sm\\:grid-flow-row{grid-auto-flow:row}.sm\\:grid-flow-col{grid-auto-flow:column}.sm\\:grid-flow-row-dense{grid-auto-flow:row dense}.sm\\:grid-flow-col-dense{grid-auto-flow:column dense}.sm\\:grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.sm\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.sm\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.sm\\:grid-cols-5{grid-template-columns:repeat(5,minmax(0,1fr))}.sm\\:grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.sm\\:grid-cols-7{grid-template-columns:repeat(7,minmax(0,1fr))}.sm\\:grid-cols-8{grid-template-columns:repeat(8,minmax(0,1fr))}.sm\\:grid-cols-9{grid-template-columns:repeat(9,minmax(0,1fr))}.sm\\:grid-cols-10{grid-template-columns:repeat(10,minmax(0,1fr))}.sm\\:grid-cols-11{grid-template-columns:repeat(11,minmax(0,1fr))}.sm\\:grid-cols-12{grid-template-columns:repeat(12,minmax(0,1fr))}.sm\\:grid-cols-none{grid-template-columns:none}.sm\\:col-auto{grid-column:auto}.sm\\:col-span-1{grid-column:span 1/span 1}.sm\\:col-span-2{grid-column:span 2/span 2}.sm\\:col-span-3{grid-column:span 3/span 3}.sm\\:col-span-4{grid-column:span 4/span 4}.sm\\:col-span-5{grid-column:span 5/span 5}.sm\\:col-span-6{grid-column:span 6/span 6}.sm\\:col-span-7{grid-column:span 7/span 7}.sm\\:col-span-8{grid-column:span 8/span 8}.sm\\:col-span-9{grid-column:span 9/span 9}.sm\\:col-span-10{grid-column:span 10/span 10}.sm\\:col-span-11{grid-column:span 11/span 11}.sm\\:col-span-12{grid-column:span 12/span 12}.sm\\:col-start-1{grid-column-start:1}.sm\\:col-start-2{grid-column-start:2}.sm\\:col-start-3{grid-column-start:3}.sm\\:col-start-4{grid-column-start:4}.sm\\:col-start-5{grid-column-start:5}.sm\\:col-start-6{grid-column-start:6}.sm\\:col-start-7{grid-column-start:7}.sm\\:col-start-8{grid-column-start:8}.sm\\:col-start-9{grid-column-start:9}.sm\\:col-start-10{grid-column-start:10}.sm\\:col-start-11{grid-column-start:11}.sm\\:col-start-12{grid-column-start:12}.sm\\:col-start-13{grid-column-start:13}.sm\\:col-start-auto{grid-column-start:auto}.sm\\:col-end-1{grid-column-end:1}.sm\\:col-end-2{grid-column-end:2}.sm\\:col-end-3{grid-column-end:3}.sm\\:col-end-4{grid-column-end:4}.sm\\:col-end-5{grid-column-end:5}.sm\\:col-end-6{grid-column-end:6}.sm\\:col-end-7{grid-column-end:7}.sm\\:col-end-8{grid-column-end:8}.sm\\:col-end-9{grid-column-end:9}.sm\\:col-end-10{grid-column-end:10}.sm\\:col-end-11{grid-column-end:11}.sm\\:col-end-12{grid-column-end:12}.sm\\:col-end-13{grid-column-end:13}.sm\\:col-end-auto{grid-column-end:auto}.sm\\:grid-rows-1{grid-template-rows:repeat(1,minmax(0,1fr))}.sm\\:grid-rows-2{grid-template-rows:repeat(2,minmax(0,1fr))}.sm\\:grid-rows-3{grid-template-rows:repeat(3,minmax(0,1fr))}.sm\\:grid-rows-4{grid-template-rows:repeat(4,minmax(0,1fr))}.sm\\:grid-rows-5{grid-template-rows:repeat(5,minmax(0,1fr))}.sm\\:grid-rows-6{grid-template-rows:repeat(6,minmax(0,1fr))}.sm\\:grid-rows-none{grid-template-rows:none}.sm\\:row-auto{grid-row:auto}.sm\\:row-span-1{grid-row:span 1/span 1}.sm\\:row-span-2{grid-row:span 2/span 2}.sm\\:row-span-3{grid-row:span 3/span 3}.sm\\:row-span-4{grid-row:span 4/span 4}.sm\\:row-span-5{grid-row:span 5/span 5}.sm\\:row-span-6{grid-row:span 6/span 6}.sm\\:row-start-1{grid-row-start:1}.sm\\:row-start-2{grid-row-start:2}.sm\\:row-start-3{grid-row-start:3}.sm\\:row-start-4{grid-row-start:4}.sm\\:row-start-5{grid-row-start:5}.sm\\:row-start-6{grid-row-start:6}.sm\\:row-start-7{grid-row-start:7}.sm\\:row-start-auto{grid-row-start:auto}.sm\\:row-end-1{grid-row-end:1}.sm\\:row-end-2{grid-row-end:2}.sm\\:row-end-3{grid-row-end:3}.sm\\:row-end-4{grid-row-end:4}.sm\\:row-end-5{grid-row-end:5}.sm\\:row-end-6{grid-row-end:6}.sm\\:row-end-7{grid-row-end:7}.sm\\:row-end-auto{grid-row-end:auto}.sm\\:transform{--transform-translate-x:0;--transform-translate-y:0;--transform-rotate:0;--transform-skew-x:0;--transform-skew-y:0;--transform-scale-x:1;--transform-scale-y:1;transform:translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y))}.sm\\:transform-none{transform:none}.sm\\:origin-center{transform-origin:center}.sm\\:origin-top{transform-origin:top}.sm\\:origin-top-right{transform-origin:top right}.sm\\:origin-right{transform-origin:right}.sm\\:origin-bottom-right{transform-origin:bottom right}.sm\\:origin-bottom{transform-origin:bottom}.sm\\:origin-bottom-left{transform-origin:bottom left}.sm\\:origin-left{transform-origin:left}.sm\\:origin-top-left{transform-origin:top left}.sm\\:scale-0{--transform-scale-x:0;--transform-scale-y:0}.sm\\:scale-50{--transform-scale-x:.5;--transform-scale-y:.5}.sm\\:scale-75{--transform-scale-x:.75;--transform-scale-y:.75}.sm\\:scale-90{--transform-scale-x:.9;--transform-scale-y:.9}.sm\\:scale-95{--transform-scale-x:.95;--transform-scale-y:.95}.sm\\:scale-100{--transform-scale-x:1;--transform-scale-y:1}.sm\\:scale-105{--transform-scale-x:1.05;--transform-scale-y:1.05}.sm\\:scale-110{--transform-scale-x:1.1;--transform-scale-y:1.1}.sm\\:scale-125{--transform-scale-x:1.25;--transform-scale-y:1.25}.sm\\:scale-150{--transform-scale-x:1.5;--transform-scale-y:1.5}.sm\\:scale-x-0{--transform-scale-x:0}.sm\\:scale-x-50{--transform-scale-x:.5}.sm\\:scale-x-75{--transform-scale-x:.75}.sm\\:scale-x-90{--transform-scale-x:.9}.sm\\:scale-x-95{--transform-scale-x:.95}.sm\\:scale-x-100{--transform-scale-x:1}.sm\\:scale-x-105{--transform-scale-x:1.05}.sm\\:scale-x-110{--transform-scale-x:1.1}.sm\\:scale-x-125{--transform-scale-x:1.25}.sm\\:scale-x-150{--transform-scale-x:1.5}.sm\\:scale-y-0{--transform-scale-y:0}.sm\\:scale-y-50{--transform-scale-y:.5}.sm\\:scale-y-75{--transform-scale-y:.75}.sm\\:scale-y-90{--transform-scale-y:.9}.sm\\:scale-y-95{--transform-scale-y:.95}.sm\\:scale-y-100{--transform-scale-y:1}.sm\\:scale-y-105{--transform-scale-y:1.05}.sm\\:scale-y-110{--transform-scale-y:1.1}.sm\\:scale-y-125{--transform-scale-y:1.25}.sm\\:scale-y-150{--transform-scale-y:1.5}.sm\\:hover\\:scale-0:hover{--transform-scale-x:0;--transform-scale-y:0}.sm\\:hover\\:scale-50:hover{--transform-scale-x:.5;--transform-scale-y:.5}.sm\\:hover\\:scale-75:hover{--transform-scale-x:.75;--transform-scale-y:.75}.sm\\:hover\\:scale-90:hover{--transform-scale-x:.9;--transform-scale-y:.9}.sm\\:hover\\:scale-95:hover{--transform-scale-x:.95;--transform-scale-y:.95}.sm\\:hover\\:scale-100:hover{--transform-scale-x:1;--transform-scale-y:1}.sm\\:hover\\:scale-105:hover{--transform-scale-x:1.05;--transform-scale-y:1.05}.sm\\:hover\\:scale-110:hover{--transform-scale-x:1.1;--transform-scale-y:1.1}.sm\\:hover\\:scale-125:hover{--transform-scale-x:1.25;--transform-scale-y:1.25}.sm\\:hover\\:scale-150:hover{--transform-scale-x:1.5;--transform-scale-y:1.5}.sm\\:hover\\:scale-x-0:hover{--transform-scale-x:0}.sm\\:hover\\:scale-x-50:hover{--transform-scale-x:.5}.sm\\:hover\\:scale-x-75:hover{--transform-scale-x:.75}.sm\\:hover\\:scale-x-90:hover{--transform-scale-x:.9}.sm\\:hover\\:scale-x-95:hover{--transform-scale-x:.95}.sm\\:hover\\:scale-x-100:hover{--transform-scale-x:1}.sm\\:hover\\:scale-x-105:hover{--transform-scale-x:1.05}.sm\\:hover\\:scale-x-110:hover{--transform-scale-x:1.1}.sm\\:hover\\:scale-x-125:hover{--transform-scale-x:1.25}.sm\\:hover\\:scale-x-150:hover{--transform-scale-x:1.5}.sm\\:hover\\:scale-y-0:hover{--transform-scale-y:0}.sm\\:hover\\:scale-y-50:hover{--transform-scale-y:.5}.sm\\:hover\\:scale-y-75:hover{--transform-scale-y:.75}.sm\\:hover\\:scale-y-90:hover{--transform-scale-y:.9}.sm\\:hover\\:scale-y-95:hover{--transform-scale-y:.95}.sm\\:hover\\:scale-y-100:hover{--transform-scale-y:1}.sm\\:hover\\:scale-y-105:hover{--transform-scale-y:1.05}.sm\\:hover\\:scale-y-110:hover{--transform-scale-y:1.1}.sm\\:hover\\:scale-y-125:hover{--transform-scale-y:1.25}.sm\\:hover\\:scale-y-150:hover{--transform-scale-y:1.5}.sm\\:focus\\:scale-0:focus{--transform-scale-x:0;--transform-scale-y:0}.sm\\:focus\\:scale-50:focus{--transform-scale-x:.5;--transform-scale-y:.5}.sm\\:focus\\:scale-75:focus{--transform-scale-x:.75;--transform-scale-y:.75}.sm\\:focus\\:scale-90:focus{--transform-scale-x:.9;--transform-scale-y:.9}.sm\\:focus\\:scale-95:focus{--transform-scale-x:.95;--transform-scale-y:.95}.sm\\:focus\\:scale-100:focus{--transform-scale-x:1;--transform-scale-y:1}.sm\\:focus\\:scale-105:focus{--transform-scale-x:1.05;--transform-scale-y:1.05}.sm\\:focus\\:scale-110:focus{--transform-scale-x:1.1;--transform-scale-y:1.1}.sm\\:focus\\:scale-125:focus{--transform-scale-x:1.25;--transform-scale-y:1.25}.sm\\:focus\\:scale-150:focus{--transform-scale-x:1.5;--transform-scale-y:1.5}.sm\\:focus\\:scale-x-0:focus{--transform-scale-x:0}.sm\\:focus\\:scale-x-50:focus{--transform-scale-x:.5}.sm\\:focus\\:scale-x-75:focus{--transform-scale-x:.75}.sm\\:focus\\:scale-x-90:focus{--transform-scale-x:.9}.sm\\:focus\\:scale-x-95:focus{--transform-scale-x:.95}.sm\\:focus\\:scale-x-100:focus{--transform-scale-x:1}.sm\\:focus\\:scale-x-105:focus{--transform-scale-x:1.05}.sm\\:focus\\:scale-x-110:focus{--transform-scale-x:1.1}.sm\\:focus\\:scale-x-125:focus{--transform-scale-x:1.25}.sm\\:focus\\:scale-x-150:focus{--transform-scale-x:1.5}.sm\\:focus\\:scale-y-0:focus{--transform-scale-y:0}.sm\\:focus\\:scale-y-50:focus{--transform-scale-y:.5}.sm\\:focus\\:scale-y-75:focus{--transform-scale-y:.75}.sm\\:focus\\:scale-y-90:focus{--transform-scale-y:.9}.sm\\:focus\\:scale-y-95:focus{--transform-scale-y:.95}.sm\\:focus\\:scale-y-100:focus{--transform-scale-y:1}.sm\\:focus\\:scale-y-105:focus{--transform-scale-y:1.05}.sm\\:focus\\:scale-y-110:focus{--transform-scale-y:1.1}.sm\\:focus\\:scale-y-125:focus{--transform-scale-y:1.25}.sm\\:focus\\:scale-y-150:focus{--transform-scale-y:1.5}.sm\\:rotate-0{--transform-rotate:0}.sm\\:rotate-45{--transform-rotate:45deg}.sm\\:rotate-90{--transform-rotate:90deg}.sm\\:rotate-180{--transform-rotate:180deg}.sm\\:-rotate-180{--transform-rotate:-180deg}.sm\\:-rotate-90{--transform-rotate:-90deg}.sm\\:-rotate-45{--transform-rotate:-45deg}.sm\\:hover\\:rotate-0:hover{--transform-rotate:0}.sm\\:hover\\:rotate-45:hover{--transform-rotate:45deg}.sm\\:hover\\:rotate-90:hover{--transform-rotate:90deg}.sm\\:hover\\:rotate-180:hover{--transform-rotate:180deg}.sm\\:hover\\:-rotate-180:hover{--transform-rotate:-180deg}.sm\\:hover\\:-rotate-90:hover{--transform-rotate:-90deg}.sm\\:hover\\:-rotate-45:hover{--transform-rotate:-45deg}.sm\\:focus\\:rotate-0:focus{--transform-rotate:0}.sm\\:focus\\:rotate-45:focus{--transform-rotate:45deg}.sm\\:focus\\:rotate-90:focus{--transform-rotate:90deg}.sm\\:focus\\:rotate-180:focus{--transform-rotate:180deg}.sm\\:focus\\:-rotate-180:focus{--transform-rotate:-180deg}.sm\\:focus\\:-rotate-90:focus{--transform-rotate:-90deg}.sm\\:focus\\:-rotate-45:focus{--transform-rotate:-45deg}.sm\\:translate-x-0{--transform-translate-x:0}.sm\\:translate-x-1{--transform-translate-x:0.25rem}.sm\\:translate-x-2{--transform-translate-x:0.5rem}.sm\\:translate-x-3{--transform-translate-x:0.75rem}.sm\\:translate-x-4{--transform-translate-x:1rem}.sm\\:translate-x-5{--transform-translate-x:1.25rem}.sm\\:translate-x-6{--transform-translate-x:1.5rem}.sm\\:translate-x-8{--transform-translate-x:2rem}.sm\\:translate-x-10{--transform-translate-x:2.5rem}.sm\\:translate-x-12{--transform-translate-x:3rem}.sm\\:translate-x-16{--transform-translate-x:4rem}.sm\\:translate-x-20{--transform-translate-x:5rem}.sm\\:translate-x-24{--transform-translate-x:6rem}.sm\\:translate-x-32{--transform-translate-x:8rem}.sm\\:translate-x-40{--transform-translate-x:10rem}.sm\\:translate-x-48{--transform-translate-x:12rem}.sm\\:translate-x-56{--transform-translate-x:14rem}.sm\\:translate-x-64{--transform-translate-x:16rem}.sm\\:translate-x-px{--transform-translate-x:1px}.sm\\:-translate-x-1{--transform-translate-x:-0.25rem}.sm\\:-translate-x-2{--transform-translate-x:-0.5rem}.sm\\:-translate-x-3{--transform-translate-x:-0.75rem}.sm\\:-translate-x-4{--transform-translate-x:-1rem}.sm\\:-translate-x-5{--transform-translate-x:-1.25rem}.sm\\:-translate-x-6{--transform-translate-x:-1.5rem}.sm\\:-translate-x-8{--transform-translate-x:-2rem}.sm\\:-translate-x-10{--transform-translate-x:-2.5rem}.sm\\:-translate-x-12{--transform-translate-x:-3rem}.sm\\:-translate-x-16{--transform-translate-x:-4rem}.sm\\:-translate-x-20{--transform-translate-x:-5rem}.sm\\:-translate-x-24{--transform-translate-x:-6rem}.sm\\:-translate-x-32{--transform-translate-x:-8rem}.sm\\:-translate-x-40{--transform-translate-x:-10rem}.sm\\:-translate-x-48{--transform-translate-x:-12rem}.sm\\:-translate-x-56{--transform-translate-x:-14rem}.sm\\:-translate-x-64{--transform-translate-x:-16rem}.sm\\:-translate-x-px{--transform-translate-x:-1px}.sm\\:-translate-x-full{--transform-translate-x:-100%}.sm\\:-translate-x-1\\/2{--transform-translate-x:-50%}.sm\\:translate-x-1\\/2{--transform-translate-x:50%}.sm\\:translate-x-full{--transform-translate-x:100%}.sm\\:translate-y-0{--transform-translate-y:0}.sm\\:translate-y-1{--transform-translate-y:0.25rem}.sm\\:translate-y-2{--transform-translate-y:0.5rem}.sm\\:translate-y-3{--transform-translate-y:0.75rem}.sm\\:translate-y-4{--transform-translate-y:1rem}.sm\\:translate-y-5{--transform-translate-y:1.25rem}.sm\\:translate-y-6{--transform-translate-y:1.5rem}.sm\\:translate-y-8{--transform-translate-y:2rem}.sm\\:translate-y-10{--transform-translate-y:2.5rem}.sm\\:translate-y-12{--transform-translate-y:3rem}.sm\\:translate-y-16{--transform-translate-y:4rem}.sm\\:translate-y-20{--transform-translate-y:5rem}.sm\\:translate-y-24{--transform-translate-y:6rem}.sm\\:translate-y-32{--transform-translate-y:8rem}.sm\\:translate-y-40{--transform-translate-y:10rem}.sm\\:translate-y-48{--transform-translate-y:12rem}.sm\\:translate-y-56{--transform-translate-y:14rem}.sm\\:translate-y-64{--transform-translate-y:16rem}.sm\\:translate-y-px{--transform-translate-y:1px}.sm\\:-translate-y-1{--transform-translate-y:-0.25rem}.sm\\:-translate-y-2{--transform-translate-y:-0.5rem}.sm\\:-translate-y-3{--transform-translate-y:-0.75rem}.sm\\:-translate-y-4{--transform-translate-y:-1rem}.sm\\:-translate-y-5{--transform-translate-y:-1.25rem}.sm\\:-translate-y-6{--transform-translate-y:-1.5rem}.sm\\:-translate-y-8{--transform-translate-y:-2rem}.sm\\:-translate-y-10{--transform-translate-y:-2.5rem}.sm\\:-translate-y-12{--transform-translate-y:-3rem}.sm\\:-translate-y-16{--transform-translate-y:-4rem}.sm\\:-translate-y-20{--transform-translate-y:-5rem}.sm\\:-translate-y-24{--transform-translate-y:-6rem}.sm\\:-translate-y-32{--transform-translate-y:-8rem}.sm\\:-translate-y-40{--transform-translate-y:-10rem}.sm\\:-translate-y-48{--transform-translate-y:-12rem}.sm\\:-translate-y-56{--transform-translate-y:-14rem}.sm\\:-translate-y-64{--transform-translate-y:-16rem}.sm\\:-translate-y-px{--transform-translate-y:-1px}.sm\\:-translate-y-full{--transform-translate-y:-100%}.sm\\:-translate-y-1\\/2{--transform-translate-y:-50%}.sm\\:translate-y-1\\/2{--transform-translate-y:50%}.sm\\:translate-y-full{--transform-translate-y:100%}.sm\\:hover\\:translate-x-0:hover{--transform-translate-x:0}.sm\\:hover\\:translate-x-1:hover{--transform-translate-x:0.25rem}.sm\\:hover\\:translate-x-2:hover{--transform-translate-x:0.5rem}.sm\\:hover\\:translate-x-3:hover{--transform-translate-x:0.75rem}.sm\\:hover\\:translate-x-4:hover{--transform-translate-x:1rem}.sm\\:hover\\:translate-x-5:hover{--transform-translate-x:1.25rem}.sm\\:hover\\:translate-x-6:hover{--transform-translate-x:1.5rem}.sm\\:hover\\:translate-x-8:hover{--transform-translate-x:2rem}.sm\\:hover\\:translate-x-10:hover{--transform-translate-x:2.5rem}.sm\\:hover\\:translate-x-12:hover{--transform-translate-x:3rem}.sm\\:hover\\:translate-x-16:hover{--transform-translate-x:4rem}.sm\\:hover\\:translate-x-20:hover{--transform-translate-x:5rem}.sm\\:hover\\:translate-x-24:hover{--transform-translate-x:6rem}.sm\\:hover\\:translate-x-32:hover{--transform-translate-x:8rem}.sm\\:hover\\:translate-x-40:hover{--transform-translate-x:10rem}.sm\\:hover\\:translate-x-48:hover{--transform-translate-x:12rem}.sm\\:hover\\:translate-x-56:hover{--transform-translate-x:14rem}.sm\\:hover\\:translate-x-64:hover{--transform-translate-x:16rem}.sm\\:hover\\:translate-x-px:hover{--transform-translate-x:1px}.sm\\:hover\\:-translate-x-1:hover{--transform-translate-x:-0.25rem}.sm\\:hover\\:-translate-x-2:hover{--transform-translate-x:-0.5rem}.sm\\:hover\\:-translate-x-3:hover{--transform-translate-x:-0.75rem}.sm\\:hover\\:-translate-x-4:hover{--transform-translate-x:-1rem}.sm\\:hover\\:-translate-x-5:hover{--transform-translate-x:-1.25rem}.sm\\:hover\\:-translate-x-6:hover{--transform-translate-x:-1.5rem}.sm\\:hover\\:-translate-x-8:hover{--transform-translate-x:-2rem}.sm\\:hover\\:-translate-x-10:hover{--transform-translate-x:-2.5rem}.sm\\:hover\\:-translate-x-12:hover{--transform-translate-x:-3rem}.sm\\:hover\\:-translate-x-16:hover{--transform-translate-x:-4rem}.sm\\:hover\\:-translate-x-20:hover{--transform-translate-x:-5rem}.sm\\:hover\\:-translate-x-24:hover{--transform-translate-x:-6rem}.sm\\:hover\\:-translate-x-32:hover{--transform-translate-x:-8rem}.sm\\:hover\\:-translate-x-40:hover{--transform-translate-x:-10rem}.sm\\:hover\\:-translate-x-48:hover{--transform-translate-x:-12rem}.sm\\:hover\\:-translate-x-56:hover{--transform-translate-x:-14rem}.sm\\:hover\\:-translate-x-64:hover{--transform-translate-x:-16rem}.sm\\:hover\\:-translate-x-px:hover{--transform-translate-x:-1px}.sm\\:hover\\:-translate-x-full:hover{--transform-translate-x:-100%}.sm\\:hover\\:-translate-x-1\\/2:hover{--transform-translate-x:-50%}.sm\\:hover\\:translate-x-1\\/2:hover{--transform-translate-x:50%}.sm\\:hover\\:translate-x-full:hover{--transform-translate-x:100%}.sm\\:hover\\:translate-y-0:hover{--transform-translate-y:0}.sm\\:hover\\:translate-y-1:hover{--transform-translate-y:0.25rem}.sm\\:hover\\:translate-y-2:hover{--transform-translate-y:0.5rem}.sm\\:hover\\:translate-y-3:hover{--transform-translate-y:0.75rem}.sm\\:hover\\:translate-y-4:hover{--transform-translate-y:1rem}.sm\\:hover\\:translate-y-5:hover{--transform-translate-y:1.25rem}.sm\\:hover\\:translate-y-6:hover{--transform-translate-y:1.5rem}.sm\\:hover\\:translate-y-8:hover{--transform-translate-y:2rem}.sm\\:hover\\:translate-y-10:hover{--transform-translate-y:2.5rem}.sm\\:hover\\:translate-y-12:hover{--transform-translate-y:3rem}.sm\\:hover\\:translate-y-16:hover{--transform-translate-y:4rem}.sm\\:hover\\:translate-y-20:hover{--transform-translate-y:5rem}.sm\\:hover\\:translate-y-24:hover{--transform-translate-y:6rem}.sm\\:hover\\:translate-y-32:hover{--transform-translate-y:8rem}.sm\\:hover\\:translate-y-40:hover{--transform-translate-y:10rem}.sm\\:hover\\:translate-y-48:hover{--transform-translate-y:12rem}.sm\\:hover\\:translate-y-56:hover{--transform-translate-y:14rem}.sm\\:hover\\:translate-y-64:hover{--transform-translate-y:16rem}.sm\\:hover\\:translate-y-px:hover{--transform-translate-y:1px}.sm\\:hover\\:-translate-y-1:hover{--transform-translate-y:-0.25rem}.sm\\:hover\\:-translate-y-2:hover{--transform-translate-y:-0.5rem}.sm\\:hover\\:-translate-y-3:hover{--transform-translate-y:-0.75rem}.sm\\:hover\\:-translate-y-4:hover{--transform-translate-y:-1rem}.sm\\:hover\\:-translate-y-5:hover{--transform-translate-y:-1.25rem}.sm\\:hover\\:-translate-y-6:hover{--transform-translate-y:-1.5rem}.sm\\:hover\\:-translate-y-8:hover{--transform-translate-y:-2rem}.sm\\:hover\\:-translate-y-10:hover{--transform-translate-y:-2.5rem}.sm\\:hover\\:-translate-y-12:hover{--transform-translate-y:-3rem}.sm\\:hover\\:-translate-y-16:hover{--transform-translate-y:-4rem}.sm\\:hover\\:-translate-y-20:hover{--transform-translate-y:-5rem}.sm\\:hover\\:-translate-y-24:hover{--transform-translate-y:-6rem}.sm\\:hover\\:-translate-y-32:hover{--transform-translate-y:-8rem}.sm\\:hover\\:-translate-y-40:hover{--transform-translate-y:-10rem}.sm\\:hover\\:-translate-y-48:hover{--transform-translate-y:-12rem}.sm\\:hover\\:-translate-y-56:hover{--transform-translate-y:-14rem}.sm\\:hover\\:-translate-y-64:hover{--transform-translate-y:-16rem}.sm\\:hover\\:-translate-y-px:hover{--transform-translate-y:-1px}.sm\\:hover\\:-translate-y-full:hover{--transform-translate-y:-100%}.sm\\:hover\\:-translate-y-1\\/2:hover{--transform-translate-y:-50%}.sm\\:hover\\:translate-y-1\\/2:hover{--transform-translate-y:50%}.sm\\:hover\\:translate-y-full:hover{--transform-translate-y:100%}.sm\\:focus\\:translate-x-0:focus{--transform-translate-x:0}.sm\\:focus\\:translate-x-1:focus{--transform-translate-x:0.25rem}.sm\\:focus\\:translate-x-2:focus{--transform-translate-x:0.5rem}.sm\\:focus\\:translate-x-3:focus{--transform-translate-x:0.75rem}.sm\\:focus\\:translate-x-4:focus{--transform-translate-x:1rem}.sm\\:focus\\:translate-x-5:focus{--transform-translate-x:1.25rem}.sm\\:focus\\:translate-x-6:focus{--transform-translate-x:1.5rem}.sm\\:focus\\:translate-x-8:focus{--transform-translate-x:2rem}.sm\\:focus\\:translate-x-10:focus{--transform-translate-x:2.5rem}.sm\\:focus\\:translate-x-12:focus{--transform-translate-x:3rem}.sm\\:focus\\:translate-x-16:focus{--transform-translate-x:4rem}.sm\\:focus\\:translate-x-20:focus{--transform-translate-x:5rem}.sm\\:focus\\:translate-x-24:focus{--transform-translate-x:6rem}.sm\\:focus\\:translate-x-32:focus{--transform-translate-x:8rem}.sm\\:focus\\:translate-x-40:focus{--transform-translate-x:10rem}.sm\\:focus\\:translate-x-48:focus{--transform-translate-x:12rem}.sm\\:focus\\:translate-x-56:focus{--transform-translate-x:14rem}.sm\\:focus\\:translate-x-64:focus{--transform-translate-x:16rem}.sm\\:focus\\:translate-x-px:focus{--transform-translate-x:1px}.sm\\:focus\\:-translate-x-1:focus{--transform-translate-x:-0.25rem}.sm\\:focus\\:-translate-x-2:focus{--transform-translate-x:-0.5rem}.sm\\:focus\\:-translate-x-3:focus{--transform-translate-x:-0.75rem}.sm\\:focus\\:-translate-x-4:focus{--transform-translate-x:-1rem}.sm\\:focus\\:-translate-x-5:focus{--transform-translate-x:-1.25rem}.sm\\:focus\\:-translate-x-6:focus{--transform-translate-x:-1.5rem}.sm\\:focus\\:-translate-x-8:focus{--transform-translate-x:-2rem}.sm\\:focus\\:-translate-x-10:focus{--transform-translate-x:-2.5rem}.sm\\:focus\\:-translate-x-12:focus{--transform-translate-x:-3rem}.sm\\:focus\\:-translate-x-16:focus{--transform-translate-x:-4rem}.sm\\:focus\\:-translate-x-20:focus{--transform-translate-x:-5rem}.sm\\:focus\\:-translate-x-24:focus{--transform-translate-x:-6rem}.sm\\:focus\\:-translate-x-32:focus{--transform-translate-x:-8rem}.sm\\:focus\\:-translate-x-40:focus{--transform-translate-x:-10rem}.sm\\:focus\\:-translate-x-48:focus{--transform-translate-x:-12rem}.sm\\:focus\\:-translate-x-56:focus{--transform-translate-x:-14rem}.sm\\:focus\\:-translate-x-64:focus{--transform-translate-x:-16rem}.sm\\:focus\\:-translate-x-px:focus{--transform-translate-x:-1px}.sm\\:focus\\:-translate-x-full:focus{--transform-translate-x:-100%}.sm\\:focus\\:-translate-x-1\\/2:focus{--transform-translate-x:-50%}.sm\\:focus\\:translate-x-1\\/2:focus{--transform-translate-x:50%}.sm\\:focus\\:translate-x-full:focus{--transform-translate-x:100%}.sm\\:focus\\:translate-y-0:focus{--transform-translate-y:0}.sm\\:focus\\:translate-y-1:focus{--transform-translate-y:0.25rem}.sm\\:focus\\:translate-y-2:focus{--transform-translate-y:0.5rem}.sm\\:focus\\:translate-y-3:focus{--transform-translate-y:0.75rem}.sm\\:focus\\:translate-y-4:focus{--transform-translate-y:1rem}.sm\\:focus\\:translate-y-5:focus{--transform-translate-y:1.25rem}.sm\\:focus\\:translate-y-6:focus{--transform-translate-y:1.5rem}.sm\\:focus\\:translate-y-8:focus{--transform-translate-y:2rem}.sm\\:focus\\:translate-y-10:focus{--transform-translate-y:2.5rem}.sm\\:focus\\:translate-y-12:focus{--transform-translate-y:3rem}.sm\\:focus\\:translate-y-16:focus{--transform-translate-y:4rem}.sm\\:focus\\:translate-y-20:focus{--transform-translate-y:5rem}.sm\\:focus\\:translate-y-24:focus{--transform-translate-y:6rem}.sm\\:focus\\:translate-y-32:focus{--transform-translate-y:8rem}.sm\\:focus\\:translate-y-40:focus{--transform-translate-y:10rem}.sm\\:focus\\:translate-y-48:focus{--transform-translate-y:12rem}.sm\\:focus\\:translate-y-56:focus{--transform-translate-y:14rem}.sm\\:focus\\:translate-y-64:focus{--transform-translate-y:16rem}.sm\\:focus\\:translate-y-px:focus{--transform-translate-y:1px}.sm\\:focus\\:-translate-y-1:focus{--transform-translate-y:-0.25rem}.sm\\:focus\\:-translate-y-2:focus{--transform-translate-y:-0.5rem}.sm\\:focus\\:-translate-y-3:focus{--transform-translate-y:-0.75rem}.sm\\:focus\\:-translate-y-4:focus{--transform-translate-y:-1rem}.sm\\:focus\\:-translate-y-5:focus{--transform-translate-y:-1.25rem}.sm\\:focus\\:-translate-y-6:focus{--transform-translate-y:-1.5rem}.sm\\:focus\\:-translate-y-8:focus{--transform-translate-y:-2rem}.sm\\:focus\\:-translate-y-10:focus{--transform-translate-y:-2.5rem}.sm\\:focus\\:-translate-y-12:focus{--transform-translate-y:-3rem}.sm\\:focus\\:-translate-y-16:focus{--transform-translate-y:-4rem}.sm\\:focus\\:-translate-y-20:focus{--transform-translate-y:-5rem}.sm\\:focus\\:-translate-y-24:focus{--transform-translate-y:-6rem}.sm\\:focus\\:-translate-y-32:focus{--transform-translate-y:-8rem}.sm\\:focus\\:-translate-y-40:focus{--transform-translate-y:-10rem}.sm\\:focus\\:-translate-y-48:focus{--transform-translate-y:-12rem}.sm\\:focus\\:-translate-y-56:focus{--transform-translate-y:-14rem}.sm\\:focus\\:-translate-y-64:focus{--transform-translate-y:-16rem}.sm\\:focus\\:-translate-y-px:focus{--transform-translate-y:-1px}.sm\\:focus\\:-translate-y-full:focus{--transform-translate-y:-100%}.sm\\:focus\\:-translate-y-1\\/2:focus{--transform-translate-y:-50%}.sm\\:focus\\:translate-y-1\\/2:focus{--transform-translate-y:50%}.sm\\:focus\\:translate-y-full:focus{--transform-translate-y:100%}.sm\\:skew-x-0{--transform-skew-x:0}.sm\\:skew-x-3{--transform-skew-x:3deg}.sm\\:skew-x-6{--transform-skew-x:6deg}.sm\\:skew-x-12{--transform-skew-x:12deg}.sm\\:-skew-x-12{--transform-skew-x:-12deg}.sm\\:-skew-x-6{--transform-skew-x:-6deg}.sm\\:-skew-x-3{--transform-skew-x:-3deg}.sm\\:skew-y-0{--transform-skew-y:0}.sm\\:skew-y-3{--transform-skew-y:3deg}.sm\\:skew-y-6{--transform-skew-y:6deg}.sm\\:skew-y-12{--transform-skew-y:12deg}.sm\\:-skew-y-12{--transform-skew-y:-12deg}.sm\\:-skew-y-6{--transform-skew-y:-6deg}.sm\\:-skew-y-3{--transform-skew-y:-3deg}.sm\\:hover\\:skew-x-0:hover{--transform-skew-x:0}.sm\\:hover\\:skew-x-3:hover{--transform-skew-x:3deg}.sm\\:hover\\:skew-x-6:hover{--transform-skew-x:6deg}.sm\\:hover\\:skew-x-12:hover{--transform-skew-x:12deg}.sm\\:hover\\:-skew-x-12:hover{--transform-skew-x:-12deg}.sm\\:hover\\:-skew-x-6:hover{--transform-skew-x:-6deg}.sm\\:hover\\:-skew-x-3:hover{--transform-skew-x:-3deg}.sm\\:hover\\:skew-y-0:hover{--transform-skew-y:0}.sm\\:hover\\:skew-y-3:hover{--transform-skew-y:3deg}.sm\\:hover\\:skew-y-6:hover{--transform-skew-y:6deg}.sm\\:hover\\:skew-y-12:hover{--transform-skew-y:12deg}.sm\\:hover\\:-skew-y-12:hover{--transform-skew-y:-12deg}.sm\\:hover\\:-skew-y-6:hover{--transform-skew-y:-6deg}.sm\\:hover\\:-skew-y-3:hover{--transform-skew-y:-3deg}.sm\\:focus\\:skew-x-0:focus{--transform-skew-x:0}.sm\\:focus\\:skew-x-3:focus{--transform-skew-x:3deg}.sm\\:focus\\:skew-x-6:focus{--transform-skew-x:6deg}.sm\\:focus\\:skew-x-12:focus{--transform-skew-x:12deg}.sm\\:focus\\:-skew-x-12:focus{--transform-skew-x:-12deg}.sm\\:focus\\:-skew-x-6:focus{--transform-skew-x:-6deg}.sm\\:focus\\:-skew-x-3:focus{--transform-skew-x:-3deg}.sm\\:focus\\:skew-y-0:focus{--transform-skew-y:0}.sm\\:focus\\:skew-y-3:focus{--transform-skew-y:3deg}.sm\\:focus\\:skew-y-6:focus{--transform-skew-y:6deg}.sm\\:focus\\:skew-y-12:focus{--transform-skew-y:12deg}.sm\\:focus\\:-skew-y-12:focus{--transform-skew-y:-12deg}.sm\\:focus\\:-skew-y-6:focus{--transform-skew-y:-6deg}.sm\\:focus\\:-skew-y-3:focus{--transform-skew-y:-3deg}.sm\\:transition-none{transition-property:none}.sm\\:transition-all{transition-property:all}.sm\\:transition{transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform}.sm\\:transition-colors{transition-property:background-color,border-color,color,fill,stroke}.sm\\:transition-opacity{transition-property:opacity}.sm\\:transition-shadow{transition-property:box-shadow}.sm\\:transition-transform{transition-property:transform}.sm\\:ease-linear{transition-timing-function:linear}.sm\\:ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.sm\\:ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.sm\\:ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.sm\\:duration-75{transition-duration:75ms}.sm\\:duration-100{transition-duration:.1s}.sm\\:duration-150{transition-duration:.15s}.sm\\:duration-200{transition-duration:.2s}.sm\\:duration-300{transition-duration:.3s}.sm\\:duration-500{transition-duration:.5s}.sm\\:duration-700{transition-duration:.7s}.sm\\:duration-1000{transition-duration:1s}.sm\\:delay-75{transition-delay:75ms}.sm\\:delay-100{transition-delay:.1s}.sm\\:delay-150{transition-delay:.15s}.sm\\:delay-200{transition-delay:.2s}.sm\\:delay-300{transition-delay:.3s}.sm\\:delay-500{transition-delay:.5s}.sm\\:delay-700{transition-delay:.7s}.sm\\:delay-1000{transition-delay:1s}.sm\\:shadow-outline-white{box-shadow:0 0 0 3px #ffffff73}.sm\\:shadow-outline-black{box-shadow:0 0 0 3px #00000073}.sm\\:shadow-outline-gray{box-shadow:0 0 0 3px #d5d6d773}.sm\\:shadow-outline-cool-gray{box-shadow:0 0 0 3px #cfd8e373}.sm\\:shadow-outline-red{box-shadow:0 0 0 3px #f8b4b473}.sm\\:shadow-outline-orange{box-shadow:0 0 0 3px #fdba8c73}.sm\\:shadow-outline-yellow{box-shadow:0 0 0 3px #faca1573}.sm\\:shadow-outline-green{box-shadow:0 0 0 3px #84e1bc73}.sm\\:shadow-outline-teal{box-shadow:0 0 0 3px #7edce273}.sm\\:shadow-outline-blue{box-shadow:0 0 0 3px #a4cafe73}.sm\\:shadow-outline-indigo{box-shadow:0 0 0 3px #b4c6fc73}.sm\\:shadow-outline-indigo{box-shadow:0 0 0 3px #cabffd73}.sm\\:shadow-outline-pink{box-shadow:0 0 0 3px #f8b4d973}.sm\\:hover\\:shadow-outline-white:hover{box-shadow:0 0 0 3px #ffffff73}.sm\\:hover\\:shadow-outline-black:hover{box-shadow:0 0 0 3px #00000073}.sm\\:hover\\:shadow-outline-gray:hover{box-shadow:0 0 0 3px #d5d6d773}.sm\\:hover\\:shadow-outline-cool-gray:hover{box-shadow:0 0 0 3px #cfd8e373}.sm\\:hover\\:shadow-outline-red:hover{box-shadow:0 0 0 3px #f8b4b473}.sm\\:hover\\:shadow-outline-orange:hover{box-shadow:0 0 0 3px #fdba8c73}.sm\\:hover\\:shadow-outline-yellow:hover{box-shadow:0 0 0 3px #faca1573}.sm\\:hover\\:shadow-outline-green:hover{box-shadow:0 0 0 3px #84e1bc73}.sm\\:hover\\:shadow-outline-teal:hover{box-shadow:0 0 0 3px #7edce273}.sm\\:hover\\:shadow-outline-blue:hover{box-shadow:0 0 0 3px #a4cafe73}.sm\\:hover\\:shadow-outline-indigo:hover{box-shadow:0 0 0 3px #b4c6fc73}.sm\\:hover\\:shadow-outline-indigo:hover{box-shadow:0 0 0 3px #cabffd73}.sm\\:hover\\:shadow-outline-pink:hover{box-shadow:0 0 0 3px #f8b4d973}.sm\\:focus\\:shadow-outline-white:focus{box-shadow:0 0 0 3px #ffffff73}.sm\\:focus\\:shadow-outline-black:focus{box-shadow:0 0 0 3px #00000073}.sm\\:focus\\:shadow-outline-gray:focus{box-shadow:0 0 0 3px #d5d6d773}.sm\\:focus\\:shadow-outline-cool-gray:focus{box-shadow:0 0 0 3px #cfd8e373}.sm\\:focus\\:shadow-outline-red:focus{box-shadow:0 0 0 3px #f8b4b473}.sm\\:focus\\:shadow-outline-orange:focus{box-shadow:0 0 0 3px #fdba8c73}.sm\\:focus\\:shadow-outline-yellow:focus{box-shadow:0 0 0 3px #faca1573}.sm\\:focus\\:shadow-outline-green:focus{box-shadow:0 0 0 3px #84e1bc73}.sm\\:focus\\:shadow-outline-teal:focus{box-shadow:0 0 0 3px #7edce273}.sm\\:focus\\:shadow-outline-blue:focus{box-shadow:0 0 0 3px #a4cafe73}.sm\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #b4c6fc73}.sm\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #cabffd73}.sm\\:focus\\:shadow-outline-pink:focus{box-shadow:0 0 0 3px #f8b4d973}.theme-dark .sm\\:dark\\:focus\\:shadow-outline-white:focus{box-shadow:0 0 0 3px #ffffff73}.theme-dark .sm\\:dark\\:focus\\:shadow-outline-black:focus{box-shadow:0 0 0 3px #00000073}.theme-dark .sm\\:dark\\:focus\\:shadow-outline-gray:focus{box-shadow:0 0 0 3px #d5d6d773}.theme-dark .sm\\:dark\\:focus\\:shadow-outline-cool-gray:focus{box-shadow:0 0 0 3px #cfd8e373}.theme-dark .sm\\:dark\\:focus\\:shadow-outline-red:focus{box-shadow:0 0 0 3px #f8b4b473}.theme-dark .sm\\:dark\\:focus\\:shadow-outline-orange:focus{box-shadow:0 0 0 3px #fdba8c73}.theme-dark .sm\\:dark\\:focus\\:shadow-outline-yellow:focus{box-shadow:0 0 0 3px #faca1573}.theme-dark .sm\\:dark\\:focus\\:shadow-outline-green:focus{box-shadow:0 0 0 3px #84e1bc73}.theme-dark .sm\\:dark\\:focus\\:shadow-outline-teal:focus{box-shadow:0 0 0 3px #7edce273}.theme-dark .sm\\:dark\\:focus\\:shadow-outline-blue:focus{box-shadow:0 0 0 3px #a4cafe73}.theme-dark .sm\\:dark\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #b4c6fc73}.theme-dark .sm\\:dark\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #cabffd73}.theme-dark .sm\\:dark\\:focus\\:shadow-outline-pink:focus{box-shadow:0 0 0 3px #f8b4d973}}@media (min-width:768px){.md\\:space-y-0>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(0px*var(--space-y-reverse));margin-top:calc(0px*(1 - var(--space-y-reverse)))}.md\\:space-x-0>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(0px*(1 - var(--space-x-reverse)));margin-right:calc(0px*var(--space-x-reverse))}.md\\:space-y-1>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(.25rem*var(--space-y-reverse));margin-top:calc(.25rem*(1 - var(--space-y-reverse)))}.md\\:space-x-1>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(.25rem*(1 - var(--space-x-reverse)));margin-right:calc(.25rem*var(--space-x-reverse))}.md\\:space-y-2>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(.5rem*var(--space-y-reverse));margin-top:calc(.5rem*(1 - var(--space-y-reverse)))}.md\\:space-x-2>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(.5rem*(1 - var(--space-x-reverse)));margin-right:calc(.5rem*var(--space-x-reverse))}.md\\:space-y-3>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(.75rem*var(--space-y-reverse));margin-top:calc(.75rem*(1 - var(--space-y-reverse)))}.md\\:space-x-3>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(.75rem*(1 - var(--space-x-reverse)));margin-right:calc(.75rem*var(--space-x-reverse))}.md\\:space-y-4>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1rem*var(--space-y-reverse));margin-top:calc(1rem*(1 - var(--space-y-reverse)))}.md\\:space-x-4>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1rem*(1 - var(--space-x-reverse)));margin-right:calc(1rem*var(--space-x-reverse))}.md\\:space-y-5>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1.25rem*var(--space-y-reverse));margin-top:calc(1.25rem*(1 - var(--space-y-reverse)))}.md\\:space-x-5>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1.25rem*(1 - var(--space-x-reverse)));margin-right:calc(1.25rem*var(--space-x-reverse))}.md\\:space-y-6>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1.5rem*var(--space-y-reverse));margin-top:calc(1.5rem*(1 - var(--space-y-reverse)))}.md\\:space-x-6>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1.5rem*(1 - var(--space-x-reverse)));margin-right:calc(1.5rem*var(--space-x-reverse))}.md\\:space-y-8>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(2rem*var(--space-y-reverse));margin-top:calc(2rem*(1 - var(--space-y-reverse)))}.md\\:space-x-8>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(2rem*(1 - var(--space-x-reverse)));margin-right:calc(2rem*var(--space-x-reverse))}.md\\:space-y-10>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(2.5rem*var(--space-y-reverse));margin-top:calc(2.5rem*(1 - var(--space-y-reverse)))}.md\\:space-x-10>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(2.5rem*(1 - var(--space-x-reverse)));margin-right:calc(2.5rem*var(--space-x-reverse))}.md\\:space-y-12>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(3rem*var(--space-y-reverse));margin-top:calc(3rem*(1 - var(--space-y-reverse)))}.md\\:space-x-12>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(3rem*(1 - var(--space-x-reverse)));margin-right:calc(3rem*var(--space-x-reverse))}.md\\:space-y-16>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(4rem*var(--space-y-reverse));margin-top:calc(4rem*(1 - var(--space-y-reverse)))}.md\\:space-x-16>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(4rem*(1 - var(--space-x-reverse)));margin-right:calc(4rem*var(--space-x-reverse))}.md\\:space-y-20>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(5rem*var(--space-y-reverse));margin-top:calc(5rem*(1 - var(--space-y-reverse)))}.md\\:space-x-20>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(5rem*(1 - var(--space-x-reverse)));margin-right:calc(5rem*var(--space-x-reverse))}.md\\:space-y-24>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(6rem*var(--space-y-reverse));margin-top:calc(6rem*(1 - var(--space-y-reverse)))}.md\\:space-x-24>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(6rem*(1 - var(--space-x-reverse)));margin-right:calc(6rem*var(--space-x-reverse))}.md\\:space-y-32>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(8rem*var(--space-y-reverse));margin-top:calc(8rem*(1 - var(--space-y-reverse)))}.md\\:space-x-32>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(8rem*(1 - var(--space-x-reverse)));margin-right:calc(8rem*var(--space-x-reverse))}.md\\:space-y-40>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(10rem*var(--space-y-reverse));margin-top:calc(10rem*(1 - var(--space-y-reverse)))}.md\\:space-x-40>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(10rem*(1 - var(--space-x-reverse)));margin-right:calc(10rem*var(--space-x-reverse))}.md\\:space-y-48>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(12rem*var(--space-y-reverse));margin-top:calc(12rem*(1 - var(--space-y-reverse)))}.md\\:space-x-48>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(12rem*(1 - var(--space-x-reverse)));margin-right:calc(12rem*var(--space-x-reverse))}.md\\:space-y-56>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(14rem*var(--space-y-reverse));margin-top:calc(14rem*(1 - var(--space-y-reverse)))}.md\\:space-x-56>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(14rem*(1 - var(--space-x-reverse)));margin-right:calc(14rem*var(--space-x-reverse))}.md\\:space-y-64>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(16rem*var(--space-y-reverse));margin-top:calc(16rem*(1 - var(--space-y-reverse)))}.md\\:space-x-64>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(16rem*(1 - var(--space-x-reverse)));margin-right:calc(16rem*var(--space-x-reverse))}.md\\:space-y-px>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1px*var(--space-y-reverse));margin-top:calc(1px*(1 - var(--space-y-reverse)))}.md\\:space-x-px>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1px*(1 - var(--space-x-reverse)));margin-right:calc(1px*var(--space-x-reverse))}.md\\:-space-y-1>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-.25rem*var(--space-y-reverse));margin-top:calc(-.25rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-1>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-.25rem*(1 - var(--space-x-reverse)));margin-right:calc(-.25rem*var(--space-x-reverse))}.md\\:-space-y-2>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-.5rem*var(--space-y-reverse));margin-top:calc(-.5rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-2>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-.5rem*(1 - var(--space-x-reverse)));margin-right:calc(-.5rem*var(--space-x-reverse))}.md\\:-space-y-3>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-.75rem*var(--space-y-reverse));margin-top:calc(-.75rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-3>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-.75rem*(1 - var(--space-x-reverse)));margin-right:calc(-.75rem*var(--space-x-reverse))}.md\\:-space-y-4>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1rem*var(--space-y-reverse));margin-top:calc(-1rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-4>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1rem*(1 - var(--space-x-reverse)));margin-right:calc(-1rem*var(--space-x-reverse))}.md\\:-space-y-5>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1.25rem*var(--space-y-reverse));margin-top:calc(-1.25rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-5>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1.25rem*(1 - var(--space-x-reverse)));margin-right:calc(-1.25rem*var(--space-x-reverse))}.md\\:-space-y-6>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1.5rem*var(--space-y-reverse));margin-top:calc(-1.5rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-6>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1.5rem*(1 - var(--space-x-reverse)));margin-right:calc(-1.5rem*var(--space-x-reverse))}.md\\:-space-y-8>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-2rem*var(--space-y-reverse));margin-top:calc(-2rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-8>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-2rem*(1 - var(--space-x-reverse)));margin-right:calc(-2rem*var(--space-x-reverse))}.md\\:-space-y-10>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-2.5rem*var(--space-y-reverse));margin-top:calc(-2.5rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-10>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-2.5rem*(1 - var(--space-x-reverse)));margin-right:calc(-2.5rem*var(--space-x-reverse))}.md\\:-space-y-12>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-3rem*var(--space-y-reverse));margin-top:calc(-3rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-12>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-3rem*(1 - var(--space-x-reverse)));margin-right:calc(-3rem*var(--space-x-reverse))}.md\\:-space-y-16>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-4rem*var(--space-y-reverse));margin-top:calc(-4rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-16>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-4rem*(1 - var(--space-x-reverse)));margin-right:calc(-4rem*var(--space-x-reverse))}.md\\:-space-y-20>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-5rem*var(--space-y-reverse));margin-top:calc(-5rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-20>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-5rem*(1 - var(--space-x-reverse)));margin-right:calc(-5rem*var(--space-x-reverse))}.md\\:-space-y-24>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-6rem*var(--space-y-reverse));margin-top:calc(-6rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-24>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-6rem*(1 - var(--space-x-reverse)));margin-right:calc(-6rem*var(--space-x-reverse))}.md\\:-space-y-32>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-8rem*var(--space-y-reverse));margin-top:calc(-8rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-32>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-8rem*(1 - var(--space-x-reverse)));margin-right:calc(-8rem*var(--space-x-reverse))}.md\\:-space-y-40>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-10rem*var(--space-y-reverse));margin-top:calc(-10rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-40>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-10rem*(1 - var(--space-x-reverse)));margin-right:calc(-10rem*var(--space-x-reverse))}.md\\:-space-y-48>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-12rem*var(--space-y-reverse));margin-top:calc(-12rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-48>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-12rem*(1 - var(--space-x-reverse)));margin-right:calc(-12rem*var(--space-x-reverse))}.md\\:-space-y-56>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-14rem*var(--space-y-reverse));margin-top:calc(-14rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-56>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-14rem*(1 - var(--space-x-reverse)));margin-right:calc(-14rem*var(--space-x-reverse))}.md\\:-space-y-64>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-16rem*var(--space-y-reverse));margin-top:calc(-16rem*(1 - var(--space-y-reverse)))}.md\\:-space-x-64>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-16rem*(1 - var(--space-x-reverse)));margin-right:calc(-16rem*var(--space-x-reverse))}.md\\:-space-y-px>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1px*var(--space-y-reverse));margin-top:calc(-1px*(1 - var(--space-y-reverse)))}.md\\:-space-x-px>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1px*(1 - var(--space-x-reverse)));margin-right:calc(-1px*var(--space-x-reverse))}.md\\:space-y-reverse>:not(template)~:not(template){--space-y-reverse:1}.md\\:space-x-reverse>:not(template)~:not(template){--space-x-reverse:1}.md\\:divide-y-0>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(0px*var(--divide-y-reverse));border-top-width:calc(0px*(1 - var(--divide-y-reverse)))}.md\\:divide-x-0>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(0px*(1 - var(--divide-x-reverse)));border-right-width:calc(0px*var(--divide-x-reverse))}.md\\:divide-y-2>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(2px*var(--divide-y-reverse));border-top-width:calc(2px*(1 - var(--divide-y-reverse)))}.md\\:divide-x-2>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(2px*(1 - var(--divide-x-reverse)));border-right-width:calc(2px*var(--divide-x-reverse))}.md\\:divide-y-4>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(4px*var(--divide-y-reverse));border-top-width:calc(4px*(1 - var(--divide-y-reverse)))}.md\\:divide-x-4>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(4px*(1 - var(--divide-x-reverse)));border-right-width:calc(4px*var(--divide-x-reverse))}.md\\:divide-y-8>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(8px*var(--divide-y-reverse));border-top-width:calc(8px*(1 - var(--divide-y-reverse)))}.md\\:divide-x-8>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(8px*(1 - var(--divide-x-reverse)));border-right-width:calc(8px*var(--divide-x-reverse))}.md\\:divide-y>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(1px*var(--divide-y-reverse));border-top-width:calc(1px*(1 - var(--divide-y-reverse)))}.md\\:divide-x>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(1px*(1 - var(--divide-x-reverse)));border-right-width:calc(1px*var(--divide-x-reverse))}.md\\:divide-y-reverse>:not(template)~:not(template){--divide-y-reverse:1}.md\\:divide-x-reverse>:not(template)~:not(template){--divide-x-reverse:1}.md\\:divide-transparent>:not(template)~:not(template){border-color:#0000}.md\\:divide-white>:not(template)~:not(template){--divide-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--divide-opacity))}.md\\:divide-black>:not(template)~:not(template){--divide-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--divide-opacity))}.md\\:divide-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--divide-opacity))}.md\\:divide-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--divide-opacity))}.md\\:divide-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--divide-opacity))}.md\\:divide-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--divide-opacity))}.md\\:divide-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--divide-opacity))}.md\\:divide-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--divide-opacity))}.md\\:divide-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--divide-opacity))}.md\\:divide-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--divide-opacity))}.md\\:divide-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--divide-opacity))}.md\\:divide-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--divide-opacity))}.md\\:divide-cool-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--divide-opacity))}.md\\:divide-cool-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--divide-opacity))}.md\\:divide-cool-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--divide-opacity))}.md\\:divide-cool-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--divide-opacity))}.md\\:divide-cool-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--divide-opacity))}.md\\:divide-cool-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--divide-opacity))}.md\\:divide-cool-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--divide-opacity))}.md\\:divide-cool-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--divide-opacity))}.md\\:divide-cool-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--divide-opacity))}.md\\:divide-cool-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--divide-opacity))}.md\\:divide-red-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--divide-opacity))}.md\\:divide-red-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--divide-opacity))}.md\\:divide-red-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--divide-opacity))}.md\\:divide-red-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--divide-opacity))}.md\\:divide-red-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--divide-opacity))}.md\\:divide-red-500>:not(template)~:not(template){--divide-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--divide-opacity))}.md\\:divide-red-600>:not(template)~:not(template){--divide-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--divide-opacity))}.md\\:divide-red-700>:not(template)~:not(template){--divide-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--divide-opacity))}.md\\:divide-red-800>:not(template)~:not(template){--divide-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--divide-opacity))}.md\\:divide-red-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.md\\:divide-orange-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--divide-opacity))}.md\\:divide-orange-100>:not(template)~:not(template){--divide-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--divide-opacity))}.md\\:divide-orange-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--divide-opacity))}.md\\:divide-orange-300>:not(template)~:not(template){--divide-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--divide-opacity))}.md\\:divide-orange-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--divide-opacity))}.md\\:divide-orange-500>:not(template)~:not(template){--divide-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--divide-opacity))}.md\\:divide-orange-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--divide-opacity))}.md\\:divide-orange-700>:not(template)~:not(template){--divide-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--divide-opacity))}.md\\:divide-orange-800>:not(template)~:not(template){--divide-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--divide-opacity))}.md\\:divide-orange-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.md\\:divide-yellow-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--divide-opacity))}.md\\:divide-yellow-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--divide-opacity))}.md\\:divide-yellow-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--divide-opacity))}.md\\:divide-yellow-300>:not(template)~:not(template){--divide-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--divide-opacity))}.md\\:divide-yellow-400>:not(template)~:not(template){--divide-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--divide-opacity))}.md\\:divide-yellow-500>:not(template)~:not(template){--divide-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--divide-opacity))}.md\\:divide-yellow-600>:not(template)~:not(template){--divide-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--divide-opacity))}.md\\:divide-yellow-700>:not(template)~:not(template){--divide-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--divide-opacity))}.md\\:divide-yellow-800>:not(template)~:not(template){--divide-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--divide-opacity))}.md\\:divide-yellow-900>:not(template)~:not(template){--divide-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--divide-opacity))}.md\\:divide-green-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--divide-opacity))}.md\\:divide-green-100>:not(template)~:not(template){--divide-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--divide-opacity))}.md\\:divide-green-200>:not(template)~:not(template){--divide-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--divide-opacity))}.md\\:divide-green-300>:not(template)~:not(template){--divide-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--divide-opacity))}.md\\:divide-green-400>:not(template)~:not(template){--divide-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--divide-opacity))}.md\\:divide-green-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--divide-opacity))}.md\\:divide-green-600>:not(template)~:not(template){--divide-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--divide-opacity))}.md\\:divide-green-700>:not(template)~:not(template){--divide-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--divide-opacity))}.md\\:divide-green-800>:not(template)~:not(template){--divide-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--divide-opacity))}.md\\:divide-green-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--divide-opacity))}.md\\:divide-teal-50>:not(template)~:not(template){--divide-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--divide-opacity))}.md\\:divide-teal-100>:not(template)~:not(template){--divide-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--divide-opacity))}.md\\:divide-teal-200>:not(template)~:not(template){--divide-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--divide-opacity))}.md\\:divide-teal-300>:not(template)~:not(template){--divide-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--divide-opacity))}.md\\:divide-teal-400>:not(template)~:not(template){--divide-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--divide-opacity))}.md\\:divide-teal-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--divide-opacity))}.md\\:divide-teal-600>:not(template)~:not(template){--divide-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--divide-opacity))}.md\\:divide-teal-700>:not(template)~:not(template){--divide-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--divide-opacity))}.md\\:divide-teal-800>:not(template)~:not(template){--divide-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--divide-opacity))}.md\\:divide-teal-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--divide-opacity))}.md\\:divide-blue-50>:not(template)~:not(template){--divide-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--divide-opacity))}.md\\:divide-blue-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--divide-opacity))}.md\\:divide-blue-200>:not(template)~:not(template){--divide-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--divide-opacity))}.md\\:divide-blue-300>:not(template)~:not(template){--divide-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--divide-opacity))}.md\\:divide-blue-400>:not(template)~:not(template){--divide-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--divide-opacity))}.md\\:divide-blue-500>:not(template)~:not(template){--divide-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--divide-opacity))}.md\\:divide-blue-600>:not(template)~:not(template){--divide-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--divide-opacity))}.md\\:divide-blue-700>:not(template)~:not(template){--divide-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--divide-opacity))}.md\\:divide-blue-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--divide-opacity))}.md\\:divide-blue-900>:not(template)~:not(template){--divide-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--divide-opacity))}.md\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--divide-opacity))}.md\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--divide-opacity))}.md\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--divide-opacity))}.md\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--divide-opacity))}.md\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--divide-opacity))}.md\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--divide-opacity))}.md\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--divide-opacity))}.md\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--divide-opacity))}.md\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--divide-opacity))}.md\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--divide-opacity))}.md\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--divide-opacity))}.md\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--divide-opacity))}.md\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--divide-opacity))}.md\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--divide-opacity))}.md\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--divide-opacity))}.md\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--divide-opacity))}.md\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--divide-opacity))}.md\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--divide-opacity))}.md\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--divide-opacity))}.md\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--divide-opacity))}.md\\:divide-pink-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--divide-opacity))}.md\\:divide-pink-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--divide-opacity))}.md\\:divide-pink-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--divide-opacity))}.md\\:divide-pink-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--divide-opacity))}.md\\:divide-pink-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--divide-opacity))}.md\\:divide-pink-500>:not(template)~:not(template){--divide-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--divide-opacity))}.md\\:divide-pink-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--divide-opacity))}.md\\:divide-pink-700>:not(template)~:not(template){--divide-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--divide-opacity))}.md\\:divide-pink-800>:not(template)~:not(template){--divide-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--divide-opacity))}.md\\:divide-pink-900>:not(template)~:not(template){--divide-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-transparent>:not(template)~:not(template){border-color:#0000}.theme-dark .md\\:dark\\:divide-white>:not(template)~:not(template){--divide-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-black>:not(template)~:not(template){--divide-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-cool-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-cool-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-cool-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-cool-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-cool-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-cool-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-cool-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-cool-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-cool-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-cool-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-red-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-red-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-red-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-red-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-red-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-red-500>:not(template)~:not(template){--divide-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-red-600>:not(template)~:not(template){--divide-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-red-700>:not(template)~:not(template){--divide-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-red-800>:not(template)~:not(template){--divide-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-red-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-orange-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-orange-100>:not(template)~:not(template){--divide-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-orange-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-orange-300>:not(template)~:not(template){--divide-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-orange-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-orange-500>:not(template)~:not(template){--divide-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-orange-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-orange-700>:not(template)~:not(template){--divide-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-orange-800>:not(template)~:not(template){--divide-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-orange-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-yellow-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-yellow-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-yellow-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-yellow-300>:not(template)~:not(template){--divide-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-yellow-400>:not(template)~:not(template){--divide-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-yellow-500>:not(template)~:not(template){--divide-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-yellow-600>:not(template)~:not(template){--divide-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-yellow-700>:not(template)~:not(template){--divide-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-yellow-800>:not(template)~:not(template){--divide-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-yellow-900>:not(template)~:not(template){--divide-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-green-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-green-100>:not(template)~:not(template){--divide-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-green-200>:not(template)~:not(template){--divide-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-green-300>:not(template)~:not(template){--divide-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-green-400>:not(template)~:not(template){--divide-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-green-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-green-600>:not(template)~:not(template){--divide-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-green-700>:not(template)~:not(template){--divide-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-green-800>:not(template)~:not(template){--divide-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-green-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-teal-50>:not(template)~:not(template){--divide-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-teal-100>:not(template)~:not(template){--divide-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-teal-200>:not(template)~:not(template){--divide-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-teal-300>:not(template)~:not(template){--divide-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-teal-400>:not(template)~:not(template){--divide-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-teal-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-teal-600>:not(template)~:not(template){--divide-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-teal-700>:not(template)~:not(template){--divide-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-teal-800>:not(template)~:not(template){--divide-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-teal-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-blue-50>:not(template)~:not(template){--divide-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-blue-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-blue-200>:not(template)~:not(template){--divide-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-blue-300>:not(template)~:not(template){--divide-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-blue-400>:not(template)~:not(template){--divide-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-blue-500>:not(template)~:not(template){--divide-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-blue-600>:not(template)~:not(template){--divide-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-blue-700>:not(template)~:not(template){--divide-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-blue-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-blue-900>:not(template)~:not(template){--divide-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-pink-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-pink-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-pink-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-pink-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-pink-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-pink-500>:not(template)~:not(template){--divide-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-pink-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-pink-700>:not(template)~:not(template){--divide-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-pink-800>:not(template)~:not(template){--divide-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--divide-opacity))}.theme-dark .md\\:dark\\:divide-pink-900>:not(template)~:not(template){--divide-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--divide-opacity))}.md\\:divide-opacity-0>:not(template)~:not(template){--divide-opacity:0}.md\\:divide-opacity-25>:not(template)~:not(template){--divide-opacity:0.25}.md\\:divide-opacity-50>:not(template)~:not(template){--divide-opacity:0.5}.md\\:divide-opacity-75>:not(template)~:not(template){--divide-opacity:0.75}.md\\:divide-opacity-100>:not(template)~:not(template){--divide-opacity:1}.md\\:sr-only{height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;clip:rect(0,0,0,0);border-width:0;white-space:nowrap}.md\\:not-sr-only{height:auto;margin:0;overflow:visible;padding:0;position:static;width:auto;clip:auto;white-space:normal}.md\\:focus\\:sr-only:focus{height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;clip:rect(0,0,0,0);border-width:0;white-space:nowrap}.md\\:focus\\:not-sr-only:focus{height:auto;margin:0;overflow:visible;padding:0;position:static;width:auto;clip:auto;white-space:normal}.md\\:appearance-none{-webkit-appearance:none;appearance:none}.md\\:bg-fixed{background-attachment:fixed}.md\\:bg-local{background-attachment:local}.md\\:bg-scroll{background-attachment:scroll}.md\\:bg-transparent{background-color:initial}.md\\:bg-white{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.md\\:bg-black{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.md\\:bg-gray-50{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.md\\:bg-gray-100{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.md\\:bg-gray-200{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.md\\:bg-gray-300{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.md\\:bg-gray-400{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.md\\:bg-gray-500{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.md\\:bg-gray-600{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.md\\:bg-gray-700{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.md\\:bg-gray-800{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.md\\:bg-gray-900{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.md\\:bg-cool-gray-50{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.md\\:bg-cool-gray-100{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.md\\:bg-cool-gray-200{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.md\\:bg-cool-gray-300{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.md\\:bg-cool-gray-400{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.md\\:bg-cool-gray-500{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.md\\:bg-cool-gray-600{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.md\\:bg-cool-gray-700{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.md\\:bg-cool-gray-800{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.md\\:bg-cool-gray-900{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.md\\:bg-red-50{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.md\\:bg-red-100{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.md\\:bg-red-200{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.md\\:bg-red-300{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.md\\:bg-red-400{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.md\\:bg-red-500{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.md\\:bg-red-600{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.md\\:bg-red-700{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.md\\:bg-red-800{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.md\\:bg-red-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.md\\:bg-orange-50{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.md\\:bg-orange-100{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.md\\:bg-orange-200{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.md\\:bg-orange-300{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.md\\:bg-orange-400{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.md\\:bg-orange-500{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.md\\:bg-orange-600{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.md\\:bg-orange-700{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.md\\:bg-orange-800{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.md\\:bg-orange-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.md\\:bg-yellow-50{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.md\\:bg-yellow-100{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.md\\:bg-yellow-200{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.md\\:bg-yellow-300{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.md\\:bg-yellow-400{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.md\\:bg-yellow-500{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.md\\:bg-yellow-600{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.md\\:bg-yellow-700{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.md\\:bg-yellow-800{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.md\\:bg-yellow-900{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.md\\:bg-green-50{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.md\\:bg-green-100{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.md\\:bg-green-200{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.md\\:bg-green-300{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.md\\:bg-green-400{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.md\\:bg-green-500{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.md\\:bg-green-600{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.md\\:bg-green-700{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.md\\:bg-green-800{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.md\\:bg-green-900{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.md\\:bg-teal-50{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.md\\:bg-teal-100{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.md\\:bg-teal-200{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.md\\:bg-teal-300{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.md\\:bg-teal-400{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.md\\:bg-teal-500{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.md\\:bg-teal-600{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.md\\:bg-teal-700{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.md\\:bg-teal-800{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.md\\:bg-teal-900{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.md\\:bg-blue-50{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.md\\:bg-blue-100{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.md\\:bg-blue-200{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.md\\:bg-blue-300{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.md\\:bg-blue-400{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.md\\:bg-blue-500{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.md\\:bg-blue-600{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.md\\:bg-blue-700{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.md\\:bg-blue-800{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.md\\:bg-blue-900{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.md\\:bg-indigo-50{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.md\\:bg-indigo-100{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.md\\:bg-indigo-200{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.md\\:bg-indigo-300{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.md\\:bg-indigo-400{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.md\\:bg-indigo-500{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.md\\:bg-indigo-600{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.md\\:bg-indigo-700{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.md\\:bg-indigo-800{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.md\\:bg-indigo-900{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.md\\:bg-indigo-50{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.md\\:bg-indigo-100{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.md\\:bg-indigo-200{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.md\\:bg-indigo-300{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.md\\:bg-indigo-400{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.md\\:bg-indigo-500{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.md\\:bg-indigo-600{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.md\\:bg-indigo-700{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.md\\:bg-indigo-800{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.md\\:bg-indigo-900{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.md\\:bg-pink-50{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.md\\:bg-pink-100{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.md\\:bg-pink-200{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.md\\:bg-pink-300{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.md\\:bg-pink-400{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.md\\:bg-pink-500{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.md\\:bg-pink-600{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.md\\:bg-pink-700{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.md\\:bg-pink-800{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.md\\:bg-pink-900{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.md\\:hover\\:bg-transparent:hover{background-color:initial}.md\\:hover\\:bg-white:hover{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.md\\:hover\\:bg-black:hover{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.md\\:hover\\:bg-gray-50:hover{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.md\\:hover\\:bg-gray-100:hover{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.md\\:hover\\:bg-gray-200:hover{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.md\\:hover\\:bg-gray-300:hover{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.md\\:hover\\:bg-gray-400:hover{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.md\\:hover\\:bg-gray-500:hover{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.md\\:hover\\:bg-gray-600:hover{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.md\\:hover\\:bg-gray-700:hover{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.md\\:hover\\:bg-gray-800:hover{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.md\\:hover\\:bg-gray-900:hover{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.md\\:hover\\:bg-cool-gray-50:hover{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.md\\:hover\\:bg-cool-gray-100:hover{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.md\\:hover\\:bg-cool-gray-200:hover{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.md\\:hover\\:bg-cool-gray-300:hover{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.md\\:hover\\:bg-cool-gray-400:hover{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.md\\:hover\\:bg-cool-gray-500:hover{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.md\\:hover\\:bg-cool-gray-600:hover{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.md\\:hover\\:bg-cool-gray-700:hover{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.md\\:hover\\:bg-cool-gray-800:hover{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.md\\:hover\\:bg-cool-gray-900:hover{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.md\\:hover\\:bg-red-50:hover{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.md\\:hover\\:bg-red-100:hover{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.md\\:hover\\:bg-red-200:hover{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.md\\:hover\\:bg-red-300:hover{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.md\\:hover\\:bg-red-400:hover{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.md\\:hover\\:bg-red-500:hover{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.md\\:hover\\:bg-red-600:hover{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.md\\:hover\\:bg-red-700:hover{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.md\\:hover\\:bg-red-800:hover{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.md\\:hover\\:bg-red-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.md\\:hover\\:bg-orange-50:hover{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.md\\:hover\\:bg-orange-100:hover{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.md\\:hover\\:bg-orange-200:hover{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.md\\:hover\\:bg-orange-300:hover{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.md\\:hover\\:bg-orange-400:hover{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.md\\:hover\\:bg-orange-500:hover{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.md\\:hover\\:bg-orange-600:hover{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.md\\:hover\\:bg-orange-700:hover{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.md\\:hover\\:bg-orange-800:hover{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.md\\:hover\\:bg-orange-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.md\\:hover\\:bg-yellow-50:hover{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.md\\:hover\\:bg-yellow-100:hover{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.md\\:hover\\:bg-yellow-200:hover{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.md\\:hover\\:bg-yellow-300:hover{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.md\\:hover\\:bg-yellow-400:hover{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.md\\:hover\\:bg-yellow-500:hover{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.md\\:hover\\:bg-yellow-600:hover{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.md\\:hover\\:bg-yellow-700:hover{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.md\\:hover\\:bg-yellow-800:hover{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.md\\:hover\\:bg-yellow-900:hover{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.md\\:hover\\:bg-green-50:hover{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.md\\:hover\\:bg-green-100:hover{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.md\\:hover\\:bg-green-200:hover{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.md\\:hover\\:bg-green-300:hover{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.md\\:hover\\:bg-green-400:hover{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.md\\:hover\\:bg-green-500:hover{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.md\\:hover\\:bg-green-600:hover{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.md\\:hover\\:bg-green-700:hover{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.md\\:hover\\:bg-green-800:hover{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.md\\:hover\\:bg-green-900:hover{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.md\\:hover\\:bg-teal-50:hover{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.md\\:hover\\:bg-teal-100:hover{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.md\\:hover\\:bg-teal-200:hover{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.md\\:hover\\:bg-teal-300:hover{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.md\\:hover\\:bg-teal-400:hover{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.md\\:hover\\:bg-teal-500:hover{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.md\\:hover\\:bg-teal-600:hover{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.md\\:hover\\:bg-teal-700:hover{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.md\\:hover\\:bg-teal-800:hover{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.md\\:hover\\:bg-teal-900:hover{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.md\\:hover\\:bg-blue-50:hover{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.md\\:hover\\:bg-blue-100:hover{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.md\\:hover\\:bg-blue-200:hover{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.md\\:hover\\:bg-blue-300:hover{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.md\\:hover\\:bg-blue-400:hover{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.md\\:hover\\:bg-blue-500:hover{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.md\\:hover\\:bg-blue-600:hover{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.md\\:hover\\:bg-blue-700:hover{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.md\\:hover\\:bg-blue-800:hover{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.md\\:hover\\:bg-blue-900:hover{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.md\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.md\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.md\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.md\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.md\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.md\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.md\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.md\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.md\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.md\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.md\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.md\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.md\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.md\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.md\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.md\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.md\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.md\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.md\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.md\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.md\\:hover\\:bg-pink-50:hover{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.md\\:hover\\:bg-pink-100:hover{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.md\\:hover\\:bg-pink-200:hover{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.md\\:hover\\:bg-pink-300:hover{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.md\\:hover\\:bg-pink-400:hover{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.md\\:hover\\:bg-pink-500:hover{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.md\\:hover\\:bg-pink-600:hover{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.md\\:hover\\:bg-pink-700:hover{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.md\\:hover\\:bg-pink-800:hover{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.md\\:hover\\:bg-pink-900:hover{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.md\\:focus\\:bg-transparent:focus{background-color:initial}.md\\:focus\\:bg-white:focus{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.md\\:focus\\:bg-black:focus{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.md\\:focus\\:bg-gray-50:focus{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.md\\:focus\\:bg-gray-100:focus{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.md\\:focus\\:bg-gray-200:focus{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.md\\:focus\\:bg-gray-300:focus{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.md\\:focus\\:bg-gray-400:focus{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.md\\:focus\\:bg-gray-500:focus{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.md\\:focus\\:bg-gray-600:focus{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.md\\:focus\\:bg-gray-700:focus{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.md\\:focus\\:bg-gray-800:focus{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.md\\:focus\\:bg-gray-900:focus{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.md\\:focus\\:bg-cool-gray-50:focus{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.md\\:focus\\:bg-cool-gray-100:focus{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.md\\:focus\\:bg-cool-gray-200:focus{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.md\\:focus\\:bg-cool-gray-300:focus{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.md\\:focus\\:bg-cool-gray-400:focus{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.md\\:focus\\:bg-cool-gray-500:focus{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.md\\:focus\\:bg-cool-gray-600:focus{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.md\\:focus\\:bg-cool-gray-700:focus{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.md\\:focus\\:bg-cool-gray-800:focus{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.md\\:focus\\:bg-cool-gray-900:focus{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.md\\:focus\\:bg-red-50:focus{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.md\\:focus\\:bg-red-100:focus{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.md\\:focus\\:bg-red-200:focus{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.md\\:focus\\:bg-red-300:focus{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.md\\:focus\\:bg-red-400:focus{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.md\\:focus\\:bg-red-500:focus{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.md\\:focus\\:bg-red-600:focus{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.md\\:focus\\:bg-red-700:focus{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.md\\:focus\\:bg-red-800:focus{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.md\\:focus\\:bg-red-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.md\\:focus\\:bg-orange-50:focus{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.md\\:focus\\:bg-orange-100:focus{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.md\\:focus\\:bg-orange-200:focus{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.md\\:focus\\:bg-orange-300:focus{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.md\\:focus\\:bg-orange-400:focus{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.md\\:focus\\:bg-orange-500:focus{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.md\\:focus\\:bg-orange-600:focus{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.md\\:focus\\:bg-orange-700:focus{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.md\\:focus\\:bg-orange-800:focus{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.md\\:focus\\:bg-orange-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.md\\:focus\\:bg-yellow-50:focus{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.md\\:focus\\:bg-yellow-100:focus{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.md\\:focus\\:bg-yellow-200:focus{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.md\\:focus\\:bg-yellow-300:focus{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.md\\:focus\\:bg-yellow-400:focus{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.md\\:focus\\:bg-yellow-500:focus{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.md\\:focus\\:bg-yellow-600:focus{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.md\\:focus\\:bg-yellow-700:focus{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.md\\:focus\\:bg-yellow-800:focus{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.md\\:focus\\:bg-yellow-900:focus{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.md\\:focus\\:bg-green-50:focus{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.md\\:focus\\:bg-green-100:focus{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.md\\:focus\\:bg-green-200:focus{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.md\\:focus\\:bg-green-300:focus{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.md\\:focus\\:bg-green-400:focus{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.md\\:focus\\:bg-green-500:focus{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.md\\:focus\\:bg-green-600:focus{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.md\\:focus\\:bg-green-700:focus{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.md\\:focus\\:bg-green-800:focus{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.md\\:focus\\:bg-green-900:focus{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.md\\:focus\\:bg-teal-50:focus{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.md\\:focus\\:bg-teal-100:focus{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.md\\:focus\\:bg-teal-200:focus{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.md\\:focus\\:bg-teal-300:focus{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.md\\:focus\\:bg-teal-400:focus{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.md\\:focus\\:bg-teal-500:focus{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.md\\:focus\\:bg-teal-600:focus{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.md\\:focus\\:bg-teal-700:focus{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.md\\:focus\\:bg-teal-800:focus{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.md\\:focus\\:bg-teal-900:focus{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.md\\:focus\\:bg-blue-50:focus{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.md\\:focus\\:bg-blue-100:focus{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.md\\:focus\\:bg-blue-200:focus{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.md\\:focus\\:bg-blue-300:focus{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.md\\:focus\\:bg-blue-400:focus{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.md\\:focus\\:bg-blue-500:focus{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.md\\:focus\\:bg-blue-600:focus{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.md\\:focus\\:bg-blue-700:focus{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.md\\:focus\\:bg-blue-800:focus{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.md\\:focus\\:bg-blue-900:focus{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.md\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.md\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.md\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.md\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.md\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.md\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.md\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.md\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.md\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.md\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.md\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.md\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.md\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.md\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.md\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.md\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.md\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.md\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.md\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.md\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.md\\:focus\\:bg-pink-50:focus{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.md\\:focus\\:bg-pink-100:focus{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.md\\:focus\\:bg-pink-200:focus{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.md\\:focus\\:bg-pink-300:focus{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.md\\:focus\\:bg-pink-400:focus{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.md\\:focus\\:bg-pink-500:focus{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.md\\:focus\\:bg-pink-600:focus{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.md\\:focus\\:bg-pink-700:focus{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.md\\:focus\\:bg-pink-800:focus{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.md\\:focus\\:bg-pink-900:focus{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.md\\:active\\:bg-transparent:active{background-color:initial}.md\\:active\\:bg-white:active{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.md\\:active\\:bg-black:active{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.md\\:active\\:bg-gray-50:active{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.md\\:active\\:bg-gray-100:active{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.md\\:active\\:bg-gray-200:active{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.md\\:active\\:bg-gray-300:active{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.md\\:active\\:bg-gray-400:active{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.md\\:active\\:bg-gray-500:active{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.md\\:active\\:bg-gray-600:active{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.md\\:active\\:bg-gray-700:active{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.md\\:active\\:bg-gray-800:active{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.md\\:active\\:bg-gray-900:active{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.md\\:active\\:bg-cool-gray-50:active{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.md\\:active\\:bg-cool-gray-100:active{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.md\\:active\\:bg-cool-gray-200:active{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.md\\:active\\:bg-cool-gray-300:active{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.md\\:active\\:bg-cool-gray-400:active{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.md\\:active\\:bg-cool-gray-500:active{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.md\\:active\\:bg-cool-gray-600:active{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.md\\:active\\:bg-cool-gray-700:active{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.md\\:active\\:bg-cool-gray-800:active{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.md\\:active\\:bg-cool-gray-900:active{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.md\\:active\\:bg-red-50:active{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.md\\:active\\:bg-red-100:active{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.md\\:active\\:bg-red-200:active{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.md\\:active\\:bg-red-300:active{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.md\\:active\\:bg-red-400:active{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.md\\:active\\:bg-red-500:active{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.md\\:active\\:bg-red-600:active{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.md\\:active\\:bg-red-700:active{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.md\\:active\\:bg-red-800:active{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.md\\:active\\:bg-red-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.md\\:active\\:bg-orange-50:active{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.md\\:active\\:bg-orange-100:active{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.md\\:active\\:bg-orange-200:active{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.md\\:active\\:bg-orange-300:active{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.md\\:active\\:bg-orange-400:active{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.md\\:active\\:bg-orange-500:active{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.md\\:active\\:bg-orange-600:active{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.md\\:active\\:bg-orange-700:active{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.md\\:active\\:bg-orange-800:active{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.md\\:active\\:bg-orange-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.md\\:active\\:bg-yellow-50:active{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.md\\:active\\:bg-yellow-100:active{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.md\\:active\\:bg-yellow-200:active{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.md\\:active\\:bg-yellow-300:active{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.md\\:active\\:bg-yellow-400:active{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.md\\:active\\:bg-yellow-500:active{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.md\\:active\\:bg-yellow-600:active{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.md\\:active\\:bg-yellow-700:active{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.md\\:active\\:bg-yellow-800:active{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.md\\:active\\:bg-yellow-900:active{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.md\\:active\\:bg-green-50:active{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.md\\:active\\:bg-green-100:active{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.md\\:active\\:bg-green-200:active{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.md\\:active\\:bg-green-300:active{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.md\\:active\\:bg-green-400:active{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.md\\:active\\:bg-green-500:active{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.md\\:active\\:bg-green-600:active{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.md\\:active\\:bg-green-700:active{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.md\\:active\\:bg-green-800:active{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.md\\:active\\:bg-green-900:active{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.md\\:active\\:bg-teal-50:active{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.md\\:active\\:bg-teal-100:active{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.md\\:active\\:bg-teal-200:active{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.md\\:active\\:bg-teal-300:active{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.md\\:active\\:bg-teal-400:active{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.md\\:active\\:bg-teal-500:active{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.md\\:active\\:bg-teal-600:active{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.md\\:active\\:bg-teal-700:active{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.md\\:active\\:bg-teal-800:active{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.md\\:active\\:bg-teal-900:active{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.md\\:active\\:bg-blue-50:active{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.md\\:active\\:bg-blue-100:active{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.md\\:active\\:bg-blue-200:active{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.md\\:active\\:bg-blue-300:active{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.md\\:active\\:bg-blue-400:active{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.md\\:active\\:bg-blue-500:active{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.md\\:active\\:bg-blue-600:active{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.md\\:active\\:bg-blue-700:active{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.md\\:active\\:bg-blue-800:active{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.md\\:active\\:bg-blue-900:active{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.md\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.md\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.md\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.md\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.md\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.md\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.md\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.md\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.md\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.md\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.md\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.md\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.md\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.md\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.md\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.md\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.md\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.md\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.md\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.md\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.md\\:active\\:bg-pink-50:active{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.md\\:active\\:bg-pink-100:active{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.md\\:active\\:bg-pink-200:active{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.md\\:active\\:bg-pink-300:active{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.md\\:active\\:bg-pink-400:active{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.md\\:active\\:bg-pink-500:active{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.md\\:active\\:bg-pink-600:active{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.md\\:active\\:bg-pink-700:active{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.md\\:active\\:bg-pink-800:active{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.md\\:active\\:bg-pink-900:active{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.md\\:odd\\:bg-transparent:nth-child(odd){background-color:initial}.md\\:odd\\:bg-white:nth-child(odd){--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.md\\:odd\\:bg-black:nth-child(odd){--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.md\\:odd\\:bg-gray-50:nth-child(odd){--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.md\\:odd\\:bg-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.md\\:odd\\:bg-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.md\\:odd\\:bg-gray-300:nth-child(odd){--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.md\\:odd\\:bg-gray-400:nth-child(odd){--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.md\\:odd\\:bg-gray-500:nth-child(odd){--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.md\\:odd\\:bg-gray-600:nth-child(odd){--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.md\\:odd\\:bg-gray-700:nth-child(odd){--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.md\\:odd\\:bg-gray-800:nth-child(odd){--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.md\\:odd\\:bg-gray-900:nth-child(odd){--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.md\\:odd\\:bg-cool-gray-50:nth-child(odd){--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.md\\:odd\\:bg-cool-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.md\\:odd\\:bg-cool-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.md\\:odd\\:bg-cool-gray-300:nth-child(odd){--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.md\\:odd\\:bg-cool-gray-400:nth-child(odd){--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.md\\:odd\\:bg-cool-gray-500:nth-child(odd){--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.md\\:odd\\:bg-cool-gray-600:nth-child(odd){--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.md\\:odd\\:bg-cool-gray-700:nth-child(odd){--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.md\\:odd\\:bg-cool-gray-800:nth-child(odd){--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.md\\:odd\\:bg-cool-gray-900:nth-child(odd){--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.md\\:odd\\:bg-red-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.md\\:odd\\:bg-red-100:nth-child(odd){--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.md\\:odd\\:bg-red-200:nth-child(odd){--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.md\\:odd\\:bg-red-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.md\\:odd\\:bg-red-400:nth-child(odd){--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.md\\:odd\\:bg-red-500:nth-child(odd){--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.md\\:odd\\:bg-red-600:nth-child(odd){--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.md\\:odd\\:bg-red-700:nth-child(odd){--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.md\\:odd\\:bg-red-800:nth-child(odd){--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.md\\:odd\\:bg-red-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.md\\:odd\\:bg-orange-50:nth-child(odd){--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.md\\:odd\\:bg-orange-100:nth-child(odd){--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.md\\:odd\\:bg-orange-200:nth-child(odd){--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.md\\:odd\\:bg-orange-300:nth-child(odd){--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.md\\:odd\\:bg-orange-400:nth-child(odd){--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.md\\:odd\\:bg-orange-500:nth-child(odd){--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.md\\:odd\\:bg-orange-600:nth-child(odd){--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.md\\:odd\\:bg-orange-700:nth-child(odd){--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.md\\:odd\\:bg-orange-800:nth-child(odd){--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.md\\:odd\\:bg-orange-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.md\\:odd\\:bg-yellow-50:nth-child(odd){--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.md\\:odd\\:bg-yellow-100:nth-child(odd){--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.md\\:odd\\:bg-yellow-200:nth-child(odd){--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.md\\:odd\\:bg-yellow-300:nth-child(odd){--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.md\\:odd\\:bg-yellow-400:nth-child(odd){--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.md\\:odd\\:bg-yellow-500:nth-child(odd){--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.md\\:odd\\:bg-yellow-600:nth-child(odd){--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.md\\:odd\\:bg-yellow-700:nth-child(odd){--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.md\\:odd\\:bg-yellow-800:nth-child(odd){--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.md\\:odd\\:bg-yellow-900:nth-child(odd){--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.md\\:odd\\:bg-green-50:nth-child(odd){--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.md\\:odd\\:bg-green-100:nth-child(odd){--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.md\\:odd\\:bg-green-200:nth-child(odd){--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.md\\:odd\\:bg-green-300:nth-child(odd){--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.md\\:odd\\:bg-green-400:nth-child(odd){--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.md\\:odd\\:bg-green-500:nth-child(odd){--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.md\\:odd\\:bg-green-600:nth-child(odd){--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.md\\:odd\\:bg-green-700:nth-child(odd){--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.md\\:odd\\:bg-green-800:nth-child(odd){--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.md\\:odd\\:bg-green-900:nth-child(odd){--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.md\\:odd\\:bg-teal-50:nth-child(odd){--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.md\\:odd\\:bg-teal-100:nth-child(odd){--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.md\\:odd\\:bg-teal-200:nth-child(odd){--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.md\\:odd\\:bg-teal-300:nth-child(odd){--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.md\\:odd\\:bg-teal-400:nth-child(odd){--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.md\\:odd\\:bg-teal-500:nth-child(odd){--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.md\\:odd\\:bg-teal-600:nth-child(odd){--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.md\\:odd\\:bg-teal-700:nth-child(odd){--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.md\\:odd\\:bg-teal-800:nth-child(odd){--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.md\\:odd\\:bg-teal-900:nth-child(odd){--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.md\\:odd\\:bg-blue-50:nth-child(odd){--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.md\\:odd\\:bg-blue-100:nth-child(odd){--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.md\\:odd\\:bg-blue-200:nth-child(odd){--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.md\\:odd\\:bg-blue-300:nth-child(odd){--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.md\\:odd\\:bg-blue-400:nth-child(odd){--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.md\\:odd\\:bg-blue-500:nth-child(odd){--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.md\\:odd\\:bg-blue-600:nth-child(odd){--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.md\\:odd\\:bg-blue-700:nth-child(odd){--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.md\\:odd\\:bg-blue-800:nth-child(odd){--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.md\\:odd\\:bg-blue-900:nth-child(odd){--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.md\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.md\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.md\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.md\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.md\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.md\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.md\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.md\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.md\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.md\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.md\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.md\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.md\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.md\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.md\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.md\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.md\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.md\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.md\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.md\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.md\\:odd\\:bg-pink-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.md\\:odd\\:bg-pink-100:nth-child(odd){--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.md\\:odd\\:bg-pink-200:nth-child(odd){--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.md\\:odd\\:bg-pink-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.md\\:odd\\:bg-pink-400:nth-child(odd){--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.md\\:odd\\:bg-pink-500:nth-child(odd){--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.md\\:odd\\:bg-pink-600:nth-child(odd){--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.md\\:odd\\:bg-pink-700:nth-child(odd){--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.md\\:odd\\:bg-pink-800:nth-child(odd){--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.md\\:odd\\:bg-pink-900:nth-child(odd){--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-transparent{background-color:initial}.theme-dark .md\\:dark\\:bg-white{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-black{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-gray-50{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-gray-100{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-gray-200{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-gray-300{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-gray-400{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-gray-500{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-gray-600{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-gray-700{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-gray-800{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-gray-900{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-cool-gray-50{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-cool-gray-100{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-cool-gray-200{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-cool-gray-300{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-cool-gray-400{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-cool-gray-500{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-cool-gray-600{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-cool-gray-700{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-cool-gray-800{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-cool-gray-900{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-red-50{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-red-100{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-red-200{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-red-300{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-red-400{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-red-500{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-red-600{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-red-700{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-red-800{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-red-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-orange-50{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-orange-100{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-orange-200{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-orange-300{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-orange-400{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-orange-500{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-orange-600{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-orange-700{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-orange-800{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-orange-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-yellow-50{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-yellow-100{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-yellow-200{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-yellow-300{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-yellow-400{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-yellow-500{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-yellow-600{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-yellow-700{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-yellow-800{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-yellow-900{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-green-50{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-green-100{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-green-200{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-green-300{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-green-400{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-green-500{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-green-600{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-green-700{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-green-800{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-green-900{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-teal-50{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-teal-100{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-teal-200{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-teal-300{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-teal-400{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-teal-500{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-teal-600{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-teal-700{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-teal-800{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-teal-900{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-blue-50{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-blue-100{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-blue-200{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-blue-300{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-blue-400{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-blue-500{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-blue-600{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-blue-700{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-blue-800{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-blue-900{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-50{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-100{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-200{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-300{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-400{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-500{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-600{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-700{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-800{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-900{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-50{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-100{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-200{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-300{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-400{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-500{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-600{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-700{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-800{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-indigo-900{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-pink-50{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-pink-100{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-pink-200{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-pink-300{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-pink-400{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-pink-500{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-pink-600{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-pink-700{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-pink-800{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .md\\:dark\\:bg-pink-900{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-transparent:hover{background-color:initial}.theme-dark .md\\:dark\\:hover\\:bg-white:hover{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-black:hover{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-gray-50:hover{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-gray-100:hover{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-gray-200:hover{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-gray-300:hover{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-gray-400:hover{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-gray-500:hover{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-gray-600:hover{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-gray-700:hover{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-gray-800:hover{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-gray-900:hover{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-cool-gray-50:hover{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-cool-gray-100:hover{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-cool-gray-200:hover{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-cool-gray-300:hover{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-cool-gray-400:hover{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-cool-gray-500:hover{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-cool-gray-600:hover{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-cool-gray-700:hover{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-cool-gray-800:hover{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-cool-gray-900:hover{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-red-50:hover{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-red-100:hover{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-red-200:hover{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-red-300:hover{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-red-400:hover{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-red-500:hover{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-red-600:hover{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-red-700:hover{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-red-800:hover{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-red-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-orange-50:hover{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-orange-100:hover{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-orange-200:hover{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-orange-300:hover{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-orange-400:hover{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-orange-500:hover{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-orange-600:hover{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-orange-700:hover{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-orange-800:hover{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-orange-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-yellow-50:hover{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-yellow-100:hover{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-yellow-200:hover{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-yellow-300:hover{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-yellow-400:hover{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-yellow-500:hover{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-yellow-600:hover{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-yellow-700:hover{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-yellow-800:hover{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-yellow-900:hover{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-green-50:hover{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-green-100:hover{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-green-200:hover{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-green-300:hover{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-green-400:hover{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-green-500:hover{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-green-600:hover{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-green-700:hover{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-green-800:hover{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-green-900:hover{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-teal-50:hover{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-teal-100:hover{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-teal-200:hover{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-teal-300:hover{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-teal-400:hover{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-teal-500:hover{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-teal-600:hover{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-teal-700:hover{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-teal-800:hover{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-teal-900:hover{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-blue-50:hover{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-blue-100:hover{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-blue-200:hover{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-blue-300:hover{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-blue-400:hover{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-blue-500:hover{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-blue-600:hover{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-blue-700:hover{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-blue-800:hover{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-blue-900:hover{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-pink-50:hover{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-pink-100:hover{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-pink-200:hover{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-pink-300:hover{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-pink-400:hover{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-pink-500:hover{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-pink-600:hover{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-pink-700:hover{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-pink-800:hover{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .md\\:dark\\:hover\\:bg-pink-900:hover{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-transparent:focus{background-color:initial}.theme-dark .md\\:dark\\:focus\\:bg-white:focus{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-black:focus{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-gray-50:focus{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-gray-100:focus{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-gray-200:focus{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-gray-300:focus{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-gray-400:focus{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-gray-500:focus{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-gray-600:focus{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-gray-700:focus{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-gray-800:focus{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-gray-900:focus{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-cool-gray-50:focus{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-cool-gray-100:focus{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-cool-gray-200:focus{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-cool-gray-300:focus{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-cool-gray-400:focus{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-cool-gray-500:focus{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-cool-gray-600:focus{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-cool-gray-700:focus{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-cool-gray-800:focus{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-cool-gray-900:focus{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-red-50:focus{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-red-100:focus{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-red-200:focus{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-red-300:focus{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-red-400:focus{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-red-500:focus{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-red-600:focus{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-red-700:focus{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-red-800:focus{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-red-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-orange-50:focus{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-orange-100:focus{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-orange-200:focus{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-orange-300:focus{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-orange-400:focus{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-orange-500:focus{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-orange-600:focus{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-orange-700:focus{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-orange-800:focus{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-orange-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-yellow-50:focus{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-yellow-100:focus{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-yellow-200:focus{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-yellow-300:focus{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-yellow-400:focus{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-yellow-500:focus{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-yellow-600:focus{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-yellow-700:focus{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-yellow-800:focus{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-yellow-900:focus{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-green-50:focus{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-green-100:focus{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-green-200:focus{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-green-300:focus{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-green-400:focus{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-green-500:focus{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-green-600:focus{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-green-700:focus{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-green-800:focus{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-green-900:focus{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-teal-50:focus{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-teal-100:focus{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-teal-200:focus{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-teal-300:focus{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-teal-400:focus{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-teal-500:focus{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-teal-600:focus{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-teal-700:focus{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-teal-800:focus{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-teal-900:focus{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-blue-50:focus{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-blue-100:focus{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-blue-200:focus{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-blue-300:focus{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-blue-400:focus{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-blue-500:focus{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-blue-600:focus{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-blue-700:focus{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-blue-800:focus{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-blue-900:focus{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-pink-50:focus{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-pink-100:focus{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-pink-200:focus{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-pink-300:focus{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-pink-400:focus{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-pink-500:focus{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-pink-600:focus{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-pink-700:focus{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-pink-800:focus{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .md\\:dark\\:focus\\:bg-pink-900:focus{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-transparent:active{background-color:initial}.theme-dark .md\\:dark\\:active\\:bg-white:active{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-black:active{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-gray-50:active{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-gray-100:active{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-gray-200:active{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-gray-300:active{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-gray-400:active{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-gray-500:active{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-gray-600:active{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-gray-700:active{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-gray-800:active{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-gray-900:active{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-cool-gray-50:active{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-cool-gray-100:active{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-cool-gray-200:active{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-cool-gray-300:active{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-cool-gray-400:active{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-cool-gray-500:active{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-cool-gray-600:active{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-cool-gray-700:active{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-cool-gray-800:active{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-cool-gray-900:active{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-red-50:active{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-red-100:active{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-red-200:active{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-red-300:active{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-red-400:active{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-red-500:active{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-red-600:active{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-red-700:active{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-red-800:active{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-red-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-orange-50:active{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-orange-100:active{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-orange-200:active{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-orange-300:active{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-orange-400:active{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-orange-500:active{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-orange-600:active{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-orange-700:active{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-orange-800:active{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-orange-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-yellow-50:active{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-yellow-100:active{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-yellow-200:active{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-yellow-300:active{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-yellow-400:active{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-yellow-500:active{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-yellow-600:active{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-yellow-700:active{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-yellow-800:active{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-yellow-900:active{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-green-50:active{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-green-100:active{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-green-200:active{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-green-300:active{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-green-400:active{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-green-500:active{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-green-600:active{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-green-700:active{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-green-800:active{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-green-900:active{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-teal-50:active{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-teal-100:active{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-teal-200:active{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-teal-300:active{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-teal-400:active{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-teal-500:active{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-teal-600:active{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-teal-700:active{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-teal-800:active{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-teal-900:active{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-blue-50:active{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-blue-100:active{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-blue-200:active{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-blue-300:active{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-blue-400:active{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-blue-500:active{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-blue-600:active{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-blue-700:active{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-blue-800:active{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-blue-900:active{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-pink-50:active{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-pink-100:active{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-pink-200:active{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-pink-300:active{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-pink-400:active{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-pink-500:active{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-pink-600:active{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-pink-700:active{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-pink-800:active{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .md\\:dark\\:active\\:bg-pink-900:active{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-transparent:nth-child(odd){background-color:initial}.theme-dark .md\\:dark\\:odd\\:bg-white:nth-child(odd){--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-black:nth-child(odd){--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-gray-50:nth-child(odd){--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-gray-300:nth-child(odd){--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-gray-400:nth-child(odd){--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-gray-500:nth-child(odd){--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-gray-600:nth-child(odd){--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-gray-700:nth-child(odd){--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-gray-800:nth-child(odd){--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-gray-900:nth-child(odd){--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-cool-gray-50:nth-child(odd){--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-cool-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-cool-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-cool-gray-300:nth-child(odd){--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-cool-gray-400:nth-child(odd){--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-cool-gray-500:nth-child(odd){--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-cool-gray-600:nth-child(odd){--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-cool-gray-700:nth-child(odd){--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-cool-gray-800:nth-child(odd){--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-cool-gray-900:nth-child(odd){--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-red-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-red-100:nth-child(odd){--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-red-200:nth-child(odd){--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-red-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-red-400:nth-child(odd){--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-red-500:nth-child(odd){--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-red-600:nth-child(odd){--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-red-700:nth-child(odd){--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-red-800:nth-child(odd){--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-red-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-orange-50:nth-child(odd){--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-orange-100:nth-child(odd){--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-orange-200:nth-child(odd){--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-orange-300:nth-child(odd){--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-orange-400:nth-child(odd){--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-orange-500:nth-child(odd){--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-orange-600:nth-child(odd){--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-orange-700:nth-child(odd){--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-orange-800:nth-child(odd){--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-orange-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-yellow-50:nth-child(odd){--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-yellow-100:nth-child(odd){--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-yellow-200:nth-child(odd){--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-yellow-300:nth-child(odd){--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-yellow-400:nth-child(odd){--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-yellow-500:nth-child(odd){--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-yellow-600:nth-child(odd){--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-yellow-700:nth-child(odd){--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-yellow-800:nth-child(odd){--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-yellow-900:nth-child(odd){--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-green-50:nth-child(odd){--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-green-100:nth-child(odd){--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-green-200:nth-child(odd){--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-green-300:nth-child(odd){--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-green-400:nth-child(odd){--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-green-500:nth-child(odd){--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-green-600:nth-child(odd){--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-green-700:nth-child(odd){--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-green-800:nth-child(odd){--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-green-900:nth-child(odd){--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-teal-50:nth-child(odd){--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-teal-100:nth-child(odd){--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-teal-200:nth-child(odd){--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-teal-300:nth-child(odd){--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-teal-400:nth-child(odd){--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-teal-500:nth-child(odd){--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-teal-600:nth-child(odd){--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-teal-700:nth-child(odd){--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-teal-800:nth-child(odd){--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-teal-900:nth-child(odd){--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-blue-50:nth-child(odd){--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-blue-100:nth-child(odd){--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-blue-200:nth-child(odd){--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-blue-300:nth-child(odd){--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-blue-400:nth-child(odd){--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-blue-500:nth-child(odd){--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-blue-600:nth-child(odd){--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-blue-700:nth-child(odd){--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-blue-800:nth-child(odd){--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-blue-900:nth-child(odd){--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-pink-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-pink-100:nth-child(odd){--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-pink-200:nth-child(odd){--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-pink-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-pink-400:nth-child(odd){--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-pink-500:nth-child(odd){--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-pink-600:nth-child(odd){--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-pink-700:nth-child(odd){--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-pink-800:nth-child(odd){--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .md\\:dark\\:odd\\:bg-pink-900:nth-child(odd){--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.md\\:bg-opacity-0{--bg-opacity:0}.md\\:bg-opacity-10{--bg-opacity:0.1}.md\\:bg-opacity-25{--bg-opacity:0.25}.md\\:bg-opacity-50{--bg-opacity:0.5}.md\\:bg-opacity-75{--bg-opacity:0.75}.md\\:bg-opacity-100{--bg-opacity:1}.md\\:hover\\:bg-opacity-0:hover{--bg-opacity:0}.md\\:hover\\:bg-opacity-10:hover{--bg-opacity:0.1}.md\\:hover\\:bg-opacity-25:hover{--bg-opacity:0.25}.md\\:hover\\:bg-opacity-50:hover{--bg-opacity:0.5}.md\\:hover\\:bg-opacity-75:hover{--bg-opacity:0.75}.md\\:hover\\:bg-opacity-100:hover{--bg-opacity:1}.md\\:focus\\:bg-opacity-0:focus{--bg-opacity:0}.md\\:focus\\:bg-opacity-10:focus{--bg-opacity:0.1}.md\\:focus\\:bg-opacity-25:focus{--bg-opacity:0.25}.md\\:focus\\:bg-opacity-50:focus{--bg-opacity:0.5}.md\\:focus\\:bg-opacity-75:focus{--bg-opacity:0.75}.md\\:focus\\:bg-opacity-100:focus{--bg-opacity:1}.theme-dark .md\\:dark\\:hover\\:bg-opacity-0:hover{--bg-opacity:0}.theme-dark .md\\:dark\\:hover\\:bg-opacity-10:hover{--bg-opacity:0.1}.theme-dark .md\\:dark\\:hover\\:bg-opacity-25:hover{--bg-opacity:0.25}.theme-dark .md\\:dark\\:hover\\:bg-opacity-50:hover{--bg-opacity:0.5}.theme-dark .md\\:dark\\:hover\\:bg-opacity-75:hover{--bg-opacity:0.75}.theme-dark .md\\:dark\\:hover\\:bg-opacity-100:hover{--bg-opacity:1}.md\\:bg-bottom{background-position:bottom}.md\\:bg-center{background-position:50%}.md\\:bg-left{background-position:0}.md\\:bg-left-bottom{background-position:0 100%}.md\\:bg-left-top{background-position:0 0}.md\\:bg-right{background-position:100%}.md\\:bg-right-bottom{background-position:100% 100%}.md\\:bg-right-top{background-position:100% 0}.md\\:bg-top{background-position:top}.md\\:bg-repeat{background-repeat:repeat}.md\\:bg-no-repeat{background-repeat:no-repeat}.md\\:bg-repeat-x{background-repeat:repeat-x}.md\\:bg-repeat-y{background-repeat:repeat-y}.md\\:bg-repeat-round{background-repeat:round}.md\\:bg-repeat-space{background-repeat:space}.md\\:bg-auto{background-size:auto}.md\\:bg-cover{background-size:cover}.md\\:bg-contain{background-size:contain}.md\\:border-collapse{border-collapse:collapse}.md\\:border-separate{border-collapse:initial}.md\\:border-transparent{border-color:#0000}.md\\:border-white{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.md\\:border-black{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.md\\:border-gray-50{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.md\\:border-gray-100{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.md\\:border-gray-200{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.md\\:border-gray-300{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.md\\:border-gray-400{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.md\\:border-gray-500{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.md\\:border-gray-600{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.md\\:border-gray-700{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.md\\:border-gray-800{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.md\\:border-gray-900{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.md\\:border-cool-gray-50{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.md\\:border-cool-gray-100{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.md\\:border-cool-gray-200{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.md\\:border-cool-gray-300{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.md\\:border-cool-gray-400{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.md\\:border-cool-gray-500{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.md\\:border-cool-gray-600{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.md\\:border-cool-gray-700{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.md\\:border-cool-gray-800{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.md\\:border-cool-gray-900{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.md\\:border-red-50{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.md\\:border-red-100{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.md\\:border-red-200{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.md\\:border-red-300{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.md\\:border-red-400{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.md\\:border-red-500{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.md\\:border-red-600{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.md\\:border-red-700{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.md\\:border-red-800{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.md\\:border-red-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.md\\:border-orange-50{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.md\\:border-orange-100{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.md\\:border-orange-200{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.md\\:border-orange-300{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.md\\:border-orange-400{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.md\\:border-orange-500{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.md\\:border-orange-600{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.md\\:border-orange-700{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.md\\:border-orange-800{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.md\\:border-orange-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.md\\:border-yellow-50{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.md\\:border-yellow-100{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.md\\:border-yellow-200{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.md\\:border-yellow-300{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.md\\:border-yellow-400{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.md\\:border-yellow-500{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.md\\:border-yellow-600{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.md\\:border-yellow-700{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.md\\:border-yellow-800{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.md\\:border-yellow-900{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.md\\:border-green-50{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.md\\:border-green-100{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.md\\:border-green-200{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.md\\:border-green-300{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.md\\:border-green-400{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.md\\:border-green-500{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.md\\:border-green-600{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.md\\:border-green-700{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.md\\:border-green-800{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.md\\:border-green-900{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.md\\:border-teal-50{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.md\\:border-teal-100{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.md\\:border-teal-200{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.md\\:border-teal-300{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.md\\:border-teal-400{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.md\\:border-teal-500{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.md\\:border-teal-600{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.md\\:border-teal-700{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.md\\:border-teal-800{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.md\\:border-teal-900{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.md\\:border-blue-50{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.md\\:border-blue-100{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.md\\:border-blue-200{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.md\\:border-blue-300{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.md\\:border-blue-400{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.md\\:border-blue-500{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.md\\:border-blue-600{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.md\\:border-blue-700{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.md\\:border-blue-800{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.md\\:border-blue-900{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.md\\:border-indigo-50{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.md\\:border-indigo-100{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.md\\:border-indigo-200{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.md\\:border-indigo-300{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.md\\:border-indigo-400{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.md\\:border-indigo-500{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.md\\:border-indigo-600{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.md\\:border-indigo-700{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.md\\:border-indigo-800{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.md\\:border-indigo-900{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.md\\:border-indigo-50{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.md\\:border-indigo-100{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.md\\:border-indigo-200{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.md\\:border-indigo-300{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.md\\:border-indigo-400{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.md\\:border-indigo-500{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.md\\:border-indigo-600{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.md\\:border-indigo-700{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.md\\:border-indigo-800{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.md\\:border-indigo-900{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.md\\:border-pink-50{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.md\\:border-pink-100{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.md\\:border-pink-200{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.md\\:border-pink-300{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.md\\:border-pink-400{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.md\\:border-pink-500{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.md\\:border-pink-600{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.md\\:border-pink-700{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.md\\:border-pink-800{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.md\\:border-pink-900{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.md\\:hover\\:border-transparent:hover{border-color:#0000}.md\\:hover\\:border-white:hover{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.md\\:hover\\:border-black:hover{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.md\\:hover\\:border-gray-50:hover{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.md\\:hover\\:border-gray-100:hover{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.md\\:hover\\:border-gray-200:hover{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.md\\:hover\\:border-gray-300:hover{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.md\\:hover\\:border-gray-400:hover{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.md\\:hover\\:border-gray-500:hover{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.md\\:hover\\:border-gray-600:hover{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.md\\:hover\\:border-gray-700:hover{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.md\\:hover\\:border-gray-800:hover{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.md\\:hover\\:border-gray-900:hover{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.md\\:hover\\:border-cool-gray-50:hover{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.md\\:hover\\:border-cool-gray-100:hover{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.md\\:hover\\:border-cool-gray-200:hover{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.md\\:hover\\:border-cool-gray-300:hover{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.md\\:hover\\:border-cool-gray-400:hover{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.md\\:hover\\:border-cool-gray-500:hover{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.md\\:hover\\:border-cool-gray-600:hover{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.md\\:hover\\:border-cool-gray-700:hover{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.md\\:hover\\:border-cool-gray-800:hover{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.md\\:hover\\:border-cool-gray-900:hover{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.md\\:hover\\:border-red-50:hover{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.md\\:hover\\:border-red-100:hover{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.md\\:hover\\:border-red-200:hover{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.md\\:hover\\:border-red-300:hover{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.md\\:hover\\:border-red-400:hover{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.md\\:hover\\:border-red-500:hover{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.md\\:hover\\:border-red-600:hover{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.md\\:hover\\:border-red-700:hover{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.md\\:hover\\:border-red-800:hover{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.md\\:hover\\:border-red-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.md\\:hover\\:border-orange-50:hover{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.md\\:hover\\:border-orange-100:hover{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.md\\:hover\\:border-orange-200:hover{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.md\\:hover\\:border-orange-300:hover{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.md\\:hover\\:border-orange-400:hover{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.md\\:hover\\:border-orange-500:hover{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.md\\:hover\\:border-orange-600:hover{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.md\\:hover\\:border-orange-700:hover{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.md\\:hover\\:border-orange-800:hover{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.md\\:hover\\:border-orange-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.md\\:hover\\:border-yellow-50:hover{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.md\\:hover\\:border-yellow-100:hover{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.md\\:hover\\:border-yellow-200:hover{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.md\\:hover\\:border-yellow-300:hover{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.md\\:hover\\:border-yellow-400:hover{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.md\\:hover\\:border-yellow-500:hover{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.md\\:hover\\:border-yellow-600:hover{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.md\\:hover\\:border-yellow-700:hover{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.md\\:hover\\:border-yellow-800:hover{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.md\\:hover\\:border-yellow-900:hover{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.md\\:hover\\:border-green-50:hover{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.md\\:hover\\:border-green-100:hover{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.md\\:hover\\:border-green-200:hover{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.md\\:hover\\:border-green-300:hover{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.md\\:hover\\:border-green-400:hover{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.md\\:hover\\:border-green-500:hover{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.md\\:hover\\:border-green-600:hover{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.md\\:hover\\:border-green-700:hover{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.md\\:hover\\:border-green-800:hover{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.md\\:hover\\:border-green-900:hover{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.md\\:hover\\:border-teal-50:hover{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.md\\:hover\\:border-teal-100:hover{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.md\\:hover\\:border-teal-200:hover{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.md\\:hover\\:border-teal-300:hover{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.md\\:hover\\:border-teal-400:hover{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.md\\:hover\\:border-teal-500:hover{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.md\\:hover\\:border-teal-600:hover{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.md\\:hover\\:border-teal-700:hover{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.md\\:hover\\:border-teal-800:hover{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.md\\:hover\\:border-teal-900:hover{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.md\\:hover\\:border-blue-50:hover{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.md\\:hover\\:border-blue-100:hover{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.md\\:hover\\:border-blue-200:hover{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.md\\:hover\\:border-blue-300:hover{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.md\\:hover\\:border-blue-400:hover{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.md\\:hover\\:border-blue-500:hover{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.md\\:hover\\:border-blue-600:hover{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.md\\:hover\\:border-blue-700:hover{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.md\\:hover\\:border-blue-800:hover{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.md\\:hover\\:border-blue-900:hover{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.md\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.md\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.md\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.md\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.md\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.md\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.md\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.md\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.md\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.md\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.md\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.md\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.md\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.md\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.md\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.md\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.md\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.md\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.md\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.md\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.md\\:hover\\:border-pink-50:hover{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.md\\:hover\\:border-pink-100:hover{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.md\\:hover\\:border-pink-200:hover{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.md\\:hover\\:border-pink-300:hover{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.md\\:hover\\:border-pink-400:hover{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.md\\:hover\\:border-pink-500:hover{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.md\\:hover\\:border-pink-600:hover{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.md\\:hover\\:border-pink-700:hover{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.md\\:hover\\:border-pink-800:hover{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.md\\:hover\\:border-pink-900:hover{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.md\\:focus\\:border-transparent:focus{border-color:#0000}.md\\:focus\\:border-white:focus{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.md\\:focus\\:border-black:focus{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.md\\:focus\\:border-gray-50:focus{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.md\\:focus\\:border-gray-100:focus{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.md\\:focus\\:border-gray-200:focus{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.md\\:focus\\:border-gray-300:focus{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.md\\:focus\\:border-gray-400:focus{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.md\\:focus\\:border-gray-500:focus{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.md\\:focus\\:border-gray-600:focus{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.md\\:focus\\:border-gray-700:focus{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.md\\:focus\\:border-gray-800:focus{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.md\\:focus\\:border-gray-900:focus{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.md\\:focus\\:border-cool-gray-50:focus{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.md\\:focus\\:border-cool-gray-100:focus{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.md\\:focus\\:border-cool-gray-200:focus{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.md\\:focus\\:border-cool-gray-300:focus{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.md\\:focus\\:border-cool-gray-400:focus{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.md\\:focus\\:border-cool-gray-500:focus{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.md\\:focus\\:border-cool-gray-600:focus{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.md\\:focus\\:border-cool-gray-700:focus{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.md\\:focus\\:border-cool-gray-800:focus{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.md\\:focus\\:border-cool-gray-900:focus{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.md\\:focus\\:border-red-50:focus{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.md\\:focus\\:border-red-100:focus{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.md\\:focus\\:border-red-200:focus{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.md\\:focus\\:border-red-300:focus{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.md\\:focus\\:border-red-400:focus{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.md\\:focus\\:border-red-500:focus{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.md\\:focus\\:border-red-600:focus{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.md\\:focus\\:border-red-700:focus{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.md\\:focus\\:border-red-800:focus{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.md\\:focus\\:border-red-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.md\\:focus\\:border-orange-50:focus{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.md\\:focus\\:border-orange-100:focus{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.md\\:focus\\:border-orange-200:focus{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.md\\:focus\\:border-orange-300:focus{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.md\\:focus\\:border-orange-400:focus{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.md\\:focus\\:border-orange-500:focus{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.md\\:focus\\:border-orange-600:focus{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.md\\:focus\\:border-orange-700:focus{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.md\\:focus\\:border-orange-800:focus{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.md\\:focus\\:border-orange-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.md\\:focus\\:border-yellow-50:focus{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.md\\:focus\\:border-yellow-100:focus{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.md\\:focus\\:border-yellow-200:focus{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.md\\:focus\\:border-yellow-300:focus{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.md\\:focus\\:border-yellow-400:focus{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.md\\:focus\\:border-yellow-500:focus{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.md\\:focus\\:border-yellow-600:focus{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.md\\:focus\\:border-yellow-700:focus{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.md\\:focus\\:border-yellow-800:focus{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.md\\:focus\\:border-yellow-900:focus{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.md\\:focus\\:border-green-50:focus{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.md\\:focus\\:border-green-100:focus{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.md\\:focus\\:border-green-200:focus{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.md\\:focus\\:border-green-300:focus{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.md\\:focus\\:border-green-400:focus{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.md\\:focus\\:border-green-500:focus{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.md\\:focus\\:border-green-600:focus{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.md\\:focus\\:border-green-700:focus{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.md\\:focus\\:border-green-800:focus{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.md\\:focus\\:border-green-900:focus{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.md\\:focus\\:border-teal-50:focus{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.md\\:focus\\:border-teal-100:focus{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.md\\:focus\\:border-teal-200:focus{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.md\\:focus\\:border-teal-300:focus{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.md\\:focus\\:border-teal-400:focus{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.md\\:focus\\:border-teal-500:focus{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.md\\:focus\\:border-teal-600:focus{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.md\\:focus\\:border-teal-700:focus{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.md\\:focus\\:border-teal-800:focus{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.md\\:focus\\:border-teal-900:focus{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.md\\:focus\\:border-blue-50:focus{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.md\\:focus\\:border-blue-100:focus{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.md\\:focus\\:border-blue-200:focus{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.md\\:focus\\:border-blue-300:focus{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.md\\:focus\\:border-blue-400:focus{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.md\\:focus\\:border-blue-500:focus{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.md\\:focus\\:border-blue-600:focus{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.md\\:focus\\:border-blue-700:focus{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.md\\:focus\\:border-blue-800:focus{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.md\\:focus\\:border-blue-900:focus{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.md\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.md\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.md\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.md\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.md\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.md\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.md\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.md\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.md\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.md\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.md\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.md\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.md\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.md\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.md\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.md\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.md\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.md\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.md\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.md\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.md\\:focus\\:border-pink-50:focus{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.md\\:focus\\:border-pink-100:focus{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.md\\:focus\\:border-pink-200:focus{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.md\\:focus\\:border-pink-300:focus{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.md\\:focus\\:border-pink-400:focus{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.md\\:focus\\:border-pink-500:focus{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.md\\:focus\\:border-pink-600:focus{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.md\\:focus\\:border-pink-700:focus{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.md\\:focus\\:border-pink-800:focus{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.md\\:focus\\:border-pink-900:focus{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.theme-dark .md\\:dark\\:border-transparent{border-color:#0000}.theme-dark .md\\:dark\\:border-white{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.theme-dark .md\\:dark\\:border-black{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.theme-dark .md\\:dark\\:border-gray-50{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.theme-dark .md\\:dark\\:border-gray-100{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.theme-dark .md\\:dark\\:border-gray-200{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.theme-dark .md\\:dark\\:border-gray-300{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.theme-dark .md\\:dark\\:border-gray-400{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.theme-dark .md\\:dark\\:border-gray-500{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.theme-dark .md\\:dark\\:border-gray-600{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.theme-dark .md\\:dark\\:border-gray-700{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.theme-dark .md\\:dark\\:border-gray-800{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.theme-dark .md\\:dark\\:border-gray-900{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.theme-dark .md\\:dark\\:border-cool-gray-50{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.theme-dark .md\\:dark\\:border-cool-gray-100{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.theme-dark .md\\:dark\\:border-cool-gray-200{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.theme-dark .md\\:dark\\:border-cool-gray-300{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.theme-dark .md\\:dark\\:border-cool-gray-400{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.theme-dark .md\\:dark\\:border-cool-gray-500{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.theme-dark .md\\:dark\\:border-cool-gray-600{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.theme-dark .md\\:dark\\:border-cool-gray-700{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.theme-dark .md\\:dark\\:border-cool-gray-800{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.theme-dark .md\\:dark\\:border-cool-gray-900{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.theme-dark .md\\:dark\\:border-red-50{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.theme-dark .md\\:dark\\:border-red-100{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.theme-dark .md\\:dark\\:border-red-200{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.theme-dark .md\\:dark\\:border-red-300{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.theme-dark .md\\:dark\\:border-red-400{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.theme-dark .md\\:dark\\:border-red-500{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.theme-dark .md\\:dark\\:border-red-600{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.theme-dark .md\\:dark\\:border-red-700{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.theme-dark .md\\:dark\\:border-red-800{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.theme-dark .md\\:dark\\:border-red-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .md\\:dark\\:border-orange-50{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.theme-dark .md\\:dark\\:border-orange-100{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.theme-dark .md\\:dark\\:border-orange-200{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.theme-dark .md\\:dark\\:border-orange-300{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.theme-dark .md\\:dark\\:border-orange-400{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.theme-dark .md\\:dark\\:border-orange-500{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.theme-dark .md\\:dark\\:border-orange-600{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.theme-dark .md\\:dark\\:border-orange-700{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.theme-dark .md\\:dark\\:border-orange-800{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.theme-dark .md\\:dark\\:border-orange-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .md\\:dark\\:border-yellow-50{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.theme-dark .md\\:dark\\:border-yellow-100{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.theme-dark .md\\:dark\\:border-yellow-200{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.theme-dark .md\\:dark\\:border-yellow-300{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.theme-dark .md\\:dark\\:border-yellow-400{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.theme-dark .md\\:dark\\:border-yellow-500{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.theme-dark .md\\:dark\\:border-yellow-600{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.theme-dark .md\\:dark\\:border-yellow-700{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.theme-dark .md\\:dark\\:border-yellow-800{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.theme-dark .md\\:dark\\:border-yellow-900{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.theme-dark .md\\:dark\\:border-green-50{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.theme-dark .md\\:dark\\:border-green-100{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.theme-dark .md\\:dark\\:border-green-200{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.theme-dark .md\\:dark\\:border-green-300{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.theme-dark .md\\:dark\\:border-green-400{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.theme-dark .md\\:dark\\:border-green-500{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.theme-dark .md\\:dark\\:border-green-600{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.theme-dark .md\\:dark\\:border-green-700{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.theme-dark .md\\:dark\\:border-green-800{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.theme-dark .md\\:dark\\:border-green-900{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.theme-dark .md\\:dark\\:border-teal-50{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.theme-dark .md\\:dark\\:border-teal-100{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.theme-dark .md\\:dark\\:border-teal-200{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.theme-dark .md\\:dark\\:border-teal-300{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.theme-dark .md\\:dark\\:border-teal-400{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.theme-dark .md\\:dark\\:border-teal-500{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.theme-dark .md\\:dark\\:border-teal-600{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.theme-dark .md\\:dark\\:border-teal-700{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.theme-dark .md\\:dark\\:border-teal-800{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.theme-dark .md\\:dark\\:border-teal-900{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.theme-dark .md\\:dark\\:border-blue-50{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.theme-dark .md\\:dark\\:border-blue-100{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.theme-dark .md\\:dark\\:border-blue-200{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.theme-dark .md\\:dark\\:border-blue-300{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.theme-dark .md\\:dark\\:border-blue-400{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.theme-dark .md\\:dark\\:border-blue-500{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.theme-dark .md\\:dark\\:border-blue-600{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.theme-dark .md\\:dark\\:border-blue-700{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.theme-dark .md\\:dark\\:border-blue-800{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.theme-dark .md\\:dark\\:border-blue-900{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-50{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-100{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-200{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-300{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-400{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-500{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-600{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-700{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-800{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-900{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-50{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-100{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-200{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-300{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-400{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-500{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-600{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-700{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-800{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.theme-dark .md\\:dark\\:border-indigo-900{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.theme-dark .md\\:dark\\:border-pink-50{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.theme-dark .md\\:dark\\:border-pink-100{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.theme-dark .md\\:dark\\:border-pink-200{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.theme-dark .md\\:dark\\:border-pink-300{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.theme-dark .md\\:dark\\:border-pink-400{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.theme-dark .md\\:dark\\:border-pink-500{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.theme-dark .md\\:dark\\:border-pink-600{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.theme-dark .md\\:dark\\:border-pink-700{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.theme-dark .md\\:dark\\:border-pink-800{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.theme-dark .md\\:dark\\:border-pink-900{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-transparent:focus{border-color:#0000}.theme-dark .md\\:dark\\:focus\\:border-white:focus{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-black:focus{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-gray-50:focus{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-gray-100:focus{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-gray-200:focus{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-gray-300:focus{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-gray-400:focus{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-gray-500:focus{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-gray-600:focus{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-gray-700:focus{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-gray-800:focus{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-gray-900:focus{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-cool-gray-50:focus{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-cool-gray-100:focus{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-cool-gray-200:focus{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-cool-gray-300:focus{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-cool-gray-400:focus{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-cool-gray-500:focus{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-cool-gray-600:focus{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-cool-gray-700:focus{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-cool-gray-800:focus{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-cool-gray-900:focus{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-red-50:focus{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-red-100:focus{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-red-200:focus{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-red-300:focus{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-red-400:focus{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-red-500:focus{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-red-600:focus{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-red-700:focus{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-red-800:focus{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-red-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-orange-50:focus{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-orange-100:focus{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-orange-200:focus{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-orange-300:focus{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-orange-400:focus{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-orange-500:focus{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-orange-600:focus{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-orange-700:focus{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-orange-800:focus{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-orange-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-yellow-50:focus{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-yellow-100:focus{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-yellow-200:focus{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-yellow-300:focus{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-yellow-400:focus{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-yellow-500:focus{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-yellow-600:focus{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-yellow-700:focus{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-yellow-800:focus{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-yellow-900:focus{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-green-50:focus{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-green-100:focus{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-green-200:focus{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-green-300:focus{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-green-400:focus{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-green-500:focus{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-green-600:focus{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-green-700:focus{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-green-800:focus{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-green-900:focus{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-teal-50:focus{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-teal-100:focus{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-teal-200:focus{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-teal-300:focus{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-teal-400:focus{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-teal-500:focus{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-teal-600:focus{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-teal-700:focus{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-teal-800:focus{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-teal-900:focus{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-blue-50:focus{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-blue-100:focus{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-blue-200:focus{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-blue-300:focus{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-blue-400:focus{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-blue-500:focus{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-blue-600:focus{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-blue-700:focus{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-blue-800:focus{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-blue-900:focus{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-pink-50:focus{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-pink-100:focus{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-pink-200:focus{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-pink-300:focus{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-pink-400:focus{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-pink-500:focus{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-pink-600:focus{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-pink-700:focus{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-pink-800:focus{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.theme-dark .md\\:dark\\:focus\\:border-pink-900:focus{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-transparent:hover{border-color:#0000}.theme-dark .md\\:dark\\:hover\\:border-white:hover{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-black:hover{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-gray-50:hover{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-gray-100:hover{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-gray-200:hover{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-gray-300:hover{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-gray-400:hover{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-gray-500:hover{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-gray-600:hover{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-gray-700:hover{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-gray-800:hover{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-gray-900:hover{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-cool-gray-50:hover{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-cool-gray-100:hover{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-cool-gray-200:hover{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-cool-gray-300:hover{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-cool-gray-400:hover{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-cool-gray-500:hover{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-cool-gray-600:hover{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-cool-gray-700:hover{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-cool-gray-800:hover{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-cool-gray-900:hover{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-red-50:hover{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-red-100:hover{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-red-200:hover{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-red-300:hover{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-red-400:hover{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-red-500:hover{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-red-600:hover{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-red-700:hover{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-red-800:hover{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-red-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-orange-50:hover{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-orange-100:hover{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-orange-200:hover{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-orange-300:hover{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-orange-400:hover{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-orange-500:hover{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-orange-600:hover{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-orange-700:hover{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-orange-800:hover{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-orange-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-yellow-50:hover{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-yellow-100:hover{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-yellow-200:hover{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-yellow-300:hover{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-yellow-400:hover{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-yellow-500:hover{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-yellow-600:hover{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-yellow-700:hover{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-yellow-800:hover{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-yellow-900:hover{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-green-50:hover{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-green-100:hover{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-green-200:hover{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-green-300:hover{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-green-400:hover{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-green-500:hover{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-green-600:hover{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-green-700:hover{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-green-800:hover{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-green-900:hover{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-teal-50:hover{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-teal-100:hover{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-teal-200:hover{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-teal-300:hover{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-teal-400:hover{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-teal-500:hover{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-teal-600:hover{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-teal-700:hover{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-teal-800:hover{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-teal-900:hover{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-blue-50:hover{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-blue-100:hover{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-blue-200:hover{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-blue-300:hover{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-blue-400:hover{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-blue-500:hover{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-blue-600:hover{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-blue-700:hover{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-blue-800:hover{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-blue-900:hover{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-pink-50:hover{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-pink-100:hover{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-pink-200:hover{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-pink-300:hover{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-pink-400:hover{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-pink-500:hover{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-pink-600:hover{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-pink-700:hover{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-pink-800:hover{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.theme-dark .md\\:dark\\:hover\\:border-pink-900:hover{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.md\\:border-opacity-0{--border-opacity:0}.md\\:border-opacity-25{--border-opacity:0.25}.md\\:border-opacity-50{--border-opacity:0.5}.md\\:border-opacity-75{--border-opacity:0.75}.md\\:border-opacity-100{--border-opacity:1}.md\\:hover\\:border-opacity-0:hover{--border-opacity:0}.md\\:hover\\:border-opacity-25:hover{--border-opacity:0.25}.md\\:hover\\:border-opacity-50:hover{--border-opacity:0.5}.md\\:hover\\:border-opacity-75:hover{--border-opacity:0.75}.md\\:hover\\:border-opacity-100:hover{--border-opacity:1}.md\\:focus\\:border-opacity-0:focus{--border-opacity:0}.md\\:focus\\:border-opacity-25:focus{--border-opacity:0.25}.md\\:focus\\:border-opacity-50:focus{--border-opacity:0.5}.md\\:focus\\:border-opacity-75:focus{--border-opacity:0.75}.md\\:focus\\:border-opacity-100:focus{--border-opacity:1}.md\\:rounded-none{border-radius:0}.md\\:rounded-sm{border-radius:.125rem}.md\\:rounded{border-radius:.25rem}.md\\:rounded-md{border-radius:.375rem}.md\\:rounded-lg{border-radius:.5rem}.md\\:rounded-full{border-radius:9999px}.md\\:rounded-t-none{border-top-left-radius:0;border-top-right-radius:0}.md\\:rounded-r-none{border-bottom-right-radius:0;border-top-right-radius:0}.md\\:rounded-b-none{border-bottom-left-radius:0;border-bottom-right-radius:0}.md\\:rounded-l-none{border-bottom-left-radius:0;border-top-left-radius:0}.md\\:rounded-t-sm{border-top-left-radius:.125rem;border-top-right-radius:.125rem}.md\\:rounded-r-sm{border-bottom-right-radius:.125rem;border-top-right-radius:.125rem}.md\\:rounded-b-sm{border-bottom-left-radius:.125rem;border-bottom-right-radius:.125rem}.md\\:rounded-l-sm{border-bottom-left-radius:.125rem;border-top-left-radius:.125rem}.md\\:rounded-t{border-top-left-radius:.25rem}.md\\:rounded-r,.md\\:rounded-t{border-top-right-radius:.25rem}.md\\:rounded-b,.md\\:rounded-r{border-bottom-right-radius:.25rem}.md\\:rounded-b,.md\\:rounded-l{border-bottom-left-radius:.25rem}.md\\:rounded-l{border-top-left-radius:.25rem}.md\\:rounded-t-md{border-top-left-radius:.375rem;border-top-right-radius:.375rem}.md\\:rounded-r-md{border-bottom-right-radius:.375rem;border-top-right-radius:.375rem}.md\\:rounded-b-md{border-bottom-left-radius:.375rem;border-bottom-right-radius:.375rem}.md\\:rounded-l-md{border-bottom-left-radius:.375rem;border-top-left-radius:.375rem}.md\\:rounded-t-lg{border-top-left-radius:.5rem;border-top-right-radius:.5rem}.md\\:rounded-r-lg{border-bottom-right-radius:.5rem;border-top-right-radius:.5rem}.md\\:rounded-b-lg{border-bottom-left-radius:.5rem;border-bottom-right-radius:.5rem}.md\\:rounded-l-lg{border-bottom-left-radius:.5rem;border-top-left-radius:.5rem}.md\\:rounded-t-full{border-top-left-radius:9999px;border-top-right-radius:9999px}.md\\:rounded-r-full{border-bottom-right-radius:9999px;border-top-right-radius:9999px}.md\\:rounded-b-full{border-bottom-left-radius:9999px;border-bottom-right-radius:9999px}.md\\:rounded-l-full{border-bottom-left-radius:9999px;border-top-left-radius:9999px}.md\\:rounded-tl-none{border-top-left-radius:0}.md\\:rounded-tr-none{border-top-right-radius:0}.md\\:rounded-br-none{border-bottom-right-radius:0}.md\\:rounded-bl-none{border-bottom-left-radius:0}.md\\:rounded-tl-sm{border-top-left-radius:.125rem}.md\\:rounded-tr-sm{border-top-right-radius:.125rem}.md\\:rounded-br-sm{border-bottom-right-radius:.125rem}.md\\:rounded-bl-sm{border-bottom-left-radius:.125rem}.md\\:rounded-tl{border-top-left-radius:.25rem}.md\\:rounded-tr{border-top-right-radius:.25rem}.md\\:rounded-br{border-bottom-right-radius:.25rem}.md\\:rounded-bl{border-bottom-left-radius:.25rem}.md\\:rounded-tl-md{border-top-left-radius:.375rem}.md\\:rounded-tr-md{border-top-right-radius:.375rem}.md\\:rounded-br-md{border-bottom-right-radius:.375rem}.md\\:rounded-bl-md{border-bottom-left-radius:.375rem}.md\\:rounded-tl-lg{border-top-left-radius:.5rem}.md\\:rounded-tr-lg{border-top-right-radius:.5rem}.md\\:rounded-br-lg{border-bottom-right-radius:.5rem}.md\\:rounded-bl-lg{border-bottom-left-radius:.5rem}.md\\:rounded-tl-full{border-top-left-radius:9999px}.md\\:rounded-tr-full{border-top-right-radius:9999px}.md\\:rounded-br-full{border-bottom-right-radius:9999px}.md\\:rounded-bl-full{border-bottom-left-radius:9999px}.md\\:border-solid{border-style:solid}.md\\:border-dashed{border-style:dashed}.md\\:border-dotted{border-style:dotted}.md\\:border-double{border-style:double}.md\\:border-none{border-style:none}.md\\:border-0{border-width:0}.md\\:border-2{border-width:2px}.md\\:border-4{border-width:4px}.md\\:border-8{border-width:8px}.md\\:border{border-width:1px}.md\\:border-t-0{border-top-width:0}.md\\:border-r-0{border-right-width:0}.md\\:border-b-0{border-bottom-width:0}.md\\:border-l-0{border-left-width:0}.md\\:border-t-2{border-top-width:2px}.md\\:border-r-2{border-right-width:2px}.md\\:border-b-2{border-bottom-width:2px}.md\\:border-l-2{border-left-width:2px}.md\\:border-t-4{border-top-width:4px}.md\\:border-r-4{border-right-width:4px}.md\\:border-b-4{border-bottom-width:4px}.md\\:border-l-4{border-left-width:4px}.md\\:border-t-8{border-top-width:8px}.md\\:border-r-8{border-right-width:8px}.md\\:border-b-8{border-bottom-width:8px}.md\\:border-l-8{border-left-width:8px}.md\\:border-t{border-top-width:1px}.md\\:border-r{border-right-width:1px}.md\\:border-b{border-bottom-width:1px}.md\\:border-l{border-left-width:1px}.md\\:box-border{box-sizing:border-box}.md\\:box-content{box-sizing:initial}.md\\:cursor-auto{cursor:auto}.md\\:cursor-default{cursor:default}.md\\:cursor-pointer{cursor:pointer}.md\\:cursor-wait{cursor:wait}.md\\:cursor-text{cursor:text}.md\\:cursor-move{cursor:move}.md\\:cursor-not-allowed{cursor:not-allowed}.md\\:block{display:block}.md\\:inline-block{display:inline-block}.md\\:inline{display:inline}.md\\:flex{display:flex}.md\\:inline-flex{display:inline-flex}.md\\:table{display:table}.md\\:table-caption{display:table-caption}.md\\:table-cell{display:table-cell}.md\\:table-column{display:table-column}.md\\:table-column-group{display:table-column-group}.md\\:table-footer-group{display:table-footer-group}.md\\:table-header-group{display:table-header-group}.md\\:table-row-group{display:table-row-group}.md\\:table-row{display:table-row}.md\\:flow-root{display:flow-root}.md\\:grid{display:grid}.md\\:inline-grid{display:inline-grid}.md\\:hidden{display:none}.theme-dark .md\\:dark\\:block{display:block}.theme-dark .md\\:dark\\:inline-block{display:inline-block}.theme-dark .md\\:dark\\:inline{display:inline}.theme-dark .md\\:dark\\:flex{display:flex}.theme-dark .md\\:dark\\:inline-flex{display:inline-flex}.theme-dark .md\\:dark\\:table{display:table}.theme-dark .md\\:dark\\:table-caption{display:table-caption}.theme-dark .md\\:dark\\:table-cell{display:table-cell}.theme-dark .md\\:dark\\:table-column{display:table-column}.theme-dark .md\\:dark\\:table-column-group{display:table-column-group}.theme-dark .md\\:dark\\:table-footer-group{display:table-footer-group}.theme-dark .md\\:dark\\:table-header-group{display:table-header-group}.theme-dark .md\\:dark\\:table-row-group{display:table-row-group}.theme-dark .md\\:dark\\:table-row{display:table-row}.theme-dark .md\\:dark\\:flow-root{display:flow-root}.theme-dark .md\\:dark\\:grid{display:grid}.theme-dark .md\\:dark\\:inline-grid{display:inline-grid}.theme-dark .md\\:dark\\:hidden{display:none}.md\\:flex-row{flex-direction:row}.md\\:flex-row-reverse{flex-direction:row-reverse}.md\\:flex-col{flex-direction:column}.md\\:flex-col-reverse{flex-direction:column-reverse}.md\\:flex-wrap{flex-wrap:wrap}.md\\:flex-wrap-reverse{flex-wrap:wrap-reverse}.md\\:flex-no-wrap{flex-wrap:nowrap}.md\\:items-start{align-items:flex-start}.md\\:items-end{align-items:flex-end}.md\\:items-center{align-items:center}.md\\:items-baseline{align-items:baseline}.md\\:items-stretch{align-items:stretch}.md\\:self-auto{align-self:auto}.md\\:self-start{align-self:flex-start}.md\\:self-end{align-self:flex-end}.md\\:self-center{align-self:center}.md\\:self-stretch{align-self:stretch}.md\\:justify-start{justify-content:flex-start}.md\\:justify-end{justify-content:flex-end}.md\\:justify-center{justify-content:center}.md\\:justify-between{justify-content:space-between}.md\\:justify-around{justify-content:space-around}.md\\:justify-evenly{justify-content:space-evenly}.md\\:content-center{align-content:center}.md\\:content-start{align-content:flex-start}.md\\:content-end{align-content:flex-end}.md\\:content-between{align-content:space-between}.md\\:content-around{align-content:space-around}.md\\:flex-1{flex:1 1 0%}.md\\:flex-auto{flex:1 1 auto}.md\\:flex-initial{flex:0 1 auto}.md\\:flex-none{flex:none}.md\\:flex-grow-0{flex-grow:0}.md\\:flex-grow{flex-grow:1}.md\\:flex-shrink-0{flex-shrink:0}.md\\:flex-shrink{flex-shrink:1}.md\\:order-1{order:1}.md\\:order-2{order:2}.md\\:order-3{order:3}.md\\:order-4{order:4}.md\\:order-5{order:5}.md\\:order-6{order:6}.md\\:order-7{order:7}.md\\:order-8{order:8}.md\\:order-9{order:9}.md\\:order-10{order:10}.md\\:order-11{order:11}.md\\:order-12{order:12}.md\\:order-first{order:-9999}.md\\:order-last{order:9999}.md\\:order-none{order:0}.md\\:float-right{float:right}.md\\:float-left{float:left}.md\\:float-none{float:none}.md\\:clearfix:after{clear:both;content:\"\";display:table}.md\\:clear-left{clear:left}.md\\:clear-right{clear:right}.md\\:clear-both{clear:both}.md\\:clear-none{clear:none}.md\\:font-sans{font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji}.md\\:font-serif{font-family:Georgia,Cambria,Times New Roman,Times,serif}.md\\:font-mono{font-family:Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}.md\\:font-hairline{font-weight:100}.md\\:font-thin{font-weight:200}.md\\:font-light{font-weight:300}.md\\:font-normal{font-weight:400}.md\\:font-medium{font-weight:500}.md\\:font-semibold{font-weight:600}.md\\:font-bold{font-weight:700}.md\\:font-extrabold{font-weight:800}.md\\:font-black{font-weight:900}.md\\:hover\\:font-hairline:hover{font-weight:100}.md\\:hover\\:font-thin:hover{font-weight:200}.md\\:hover\\:font-light:hover{font-weight:300}.md\\:hover\\:font-normal:hover{font-weight:400}.md\\:hover\\:font-medium:hover{font-weight:500}.md\\:hover\\:font-semibold:hover{font-weight:600}.md\\:hover\\:font-bold:hover{font-weight:700}.md\\:hover\\:font-extrabold:hover{font-weight:800}.md\\:hover\\:font-black:hover{font-weight:900}.md\\:focus\\:font-hairline:focus{font-weight:100}.md\\:focus\\:font-thin:focus{font-weight:200}.md\\:focus\\:font-light:focus{font-weight:300}.md\\:focus\\:font-normal:focus{font-weight:400}.md\\:focus\\:font-medium:focus{font-weight:500}.md\\:focus\\:font-semibold:focus{font-weight:600}.md\\:focus\\:font-bold:focus{font-weight:700}.md\\:focus\\:font-extrabold:focus{font-weight:800}.md\\:focus\\:font-black:focus{font-weight:900}.md\\:h-0{height:0}.md\\:h-1{height:.25rem}.md\\:h-2{height:.5rem}.md\\:h-3{height:.75rem}.md\\:h-4{height:1rem}.md\\:h-5{height:1.25rem}.md\\:h-6{height:1.5rem}.md\\:h-8{height:2rem}.md\\:h-10{height:2.5rem}.md\\:h-12{height:3rem}.md\\:h-16{height:4rem}.md\\:h-20{height:5rem}.md\\:h-24{height:6rem}.md\\:h-32{height:8rem}.md\\:h-40{height:10rem}.md\\:h-48{height:12rem}.md\\:h-56{height:14rem}.md\\:h-64{height:16rem}.md\\:h-auto{height:auto}.md\\:h-px{height:1px}.md\\:h-full{height:100%}.md\\:h-screen{height:100vh}.md\\:text-xs{font-size:.75rem}.md\\:text-sm{font-size:.875rem}.md\\:text-base{font-size:1rem}.md\\:text-lg{font-size:1.125rem}.md\\:text-xl{font-size:1.25rem}.md\\:text-2xl{font-size:1.5rem}.md\\:text-3xl{font-size:1.875rem}.md\\:text-4xl{font-size:2.25rem}.md\\:text-5xl{font-size:3rem}.md\\:text-6xl{font-size:4rem}.md\\:leading-3{line-height:.75rem}.md\\:leading-4{line-height:1rem}.md\\:leading-5{line-height:1.25rem}.md\\:leading-6{line-height:1.5rem}.md\\:leading-7{line-height:1.75rem}.md\\:leading-8{line-height:2rem}.md\\:leading-9{line-height:2.25rem}.md\\:leading-10{line-height:2.5rem}.md\\:leading-none{line-height:1}.md\\:leading-tight{line-height:1.25}.md\\:leading-snug{line-height:1.375}.md\\:leading-normal{line-height:1.5}.md\\:leading-relaxed{line-height:1.625}.md\\:leading-loose{line-height:2}.md\\:list-inside{list-style-position:inside}.md\\:list-outside{list-style-position:outside}.md\\:list-none{list-style-type:none}.md\\:list-disc{list-style-type:disc}.md\\:list-decimal{list-style-type:decimal}.md\\:m-0{margin:0}.md\\:m-1{margin:.25rem}.md\\:m-2{margin:.5rem}.md\\:m-3{margin:.75rem}.md\\:m-4{margin:1rem}.md\\:m-5{margin:1.25rem}.md\\:m-6{margin:1.5rem}.md\\:m-8{margin:2rem}.md\\:m-10{margin:2.5rem}.md\\:m-12{margin:3rem}.md\\:m-16{margin:4rem}.md\\:m-20{margin:5rem}.md\\:m-24{margin:6rem}.md\\:m-32{margin:8rem}.md\\:m-40{margin:10rem}.md\\:m-48{margin:12rem}.md\\:m-56{margin:14rem}.md\\:m-64{margin:16rem}.md\\:m-auto{margin:auto}.md\\:m-px{margin:1px}.md\\:-m-1{margin:-.25rem}.md\\:-m-2{margin:-.5rem}.md\\:-m-3{margin:-.75rem}.md\\:-m-4{margin:-1rem}.md\\:-m-5{margin:-1.25rem}.md\\:-m-6{margin:-1.5rem}.md\\:-m-8{margin:-2rem}.md\\:-m-10{margin:-2.5rem}.md\\:-m-12{margin:-3rem}.md\\:-m-16{margin:-4rem}.md\\:-m-20{margin:-5rem}.md\\:-m-24{margin:-6rem}.md\\:-m-32{margin:-8rem}.md\\:-m-40{margin:-10rem}.md\\:-m-48{margin:-12rem}.md\\:-m-56{margin:-14rem}.md\\:-m-64{margin:-16rem}.md\\:-m-px{margin:-1px}.md\\:my-0{margin-bottom:0;margin-top:0}.md\\:mx-0{margin-left:0;margin-right:0}.md\\:my-1{margin-bottom:.25rem;margin-top:.25rem}.md\\:mx-1{margin-left:.25rem;margin-right:.25rem}.md\\:my-2{margin-bottom:.5rem;margin-top:.5rem}.md\\:mx-2{margin-left:.5rem;margin-right:.5rem}.md\\:my-3{margin-bottom:.75rem;margin-top:.75rem}.md\\:mx-3{margin-left:.75rem;margin-right:.75rem}.md\\:my-4{margin-bottom:1rem;margin-top:1rem}.md\\:mx-4{margin-left:1rem;margin-right:1rem}.md\\:my-5{margin-bottom:1.25rem;margin-top:1.25rem}.md\\:mx-5{margin-left:1.25rem;margin-right:1.25rem}.md\\:my-6{margin-bottom:1.5rem;margin-top:1.5rem}.md\\:mx-6{margin-left:1.5rem;margin-right:1.5rem}.md\\:my-8{margin-bottom:2rem;margin-top:2rem}.md\\:mx-8{margin-left:2rem;margin-right:2rem}.md\\:my-10{margin-bottom:2.5rem;margin-top:2.5rem}.md\\:mx-10{margin-left:2.5rem;margin-right:2.5rem}.md\\:my-12{margin-bottom:3rem;margin-top:3rem}.md\\:mx-12{margin-left:3rem;margin-right:3rem}.md\\:my-16{margin-bottom:4rem;margin-top:4rem}.md\\:mx-16{margin-left:4rem;margin-right:4rem}.md\\:my-20{margin-bottom:5rem;margin-top:5rem}.md\\:mx-20{margin-left:5rem;margin-right:5rem}.md\\:my-24{margin-bottom:6rem;margin-top:6rem}.md\\:mx-24{margin-left:6rem;margin-right:6rem}.md\\:my-32{margin-bottom:8rem;margin-top:8rem}.md\\:mx-32{margin-left:8rem;margin-right:8rem}.md\\:my-40{margin-bottom:10rem;margin-top:10rem}.md\\:mx-40{margin-left:10rem;margin-right:10rem}.md\\:my-48{margin-bottom:12rem;margin-top:12rem}.md\\:mx-48{margin-left:12rem;margin-right:12rem}.md\\:my-56{margin-bottom:14rem;margin-top:14rem}.md\\:mx-56{margin-left:14rem;margin-right:14rem}.md\\:my-64{margin-bottom:16rem;margin-top:16rem}.md\\:mx-64{margin-left:16rem;margin-right:16rem}.md\\:my-auto{margin-bottom:auto;margin-top:auto}.md\\:mx-auto{margin-left:auto;margin-right:auto}.md\\:my-px{margin-bottom:1px;margin-top:1px}.md\\:mx-px{margin-left:1px;margin-right:1px}.md\\:-my-1{margin-bottom:-.25rem;margin-top:-.25rem}.md\\:-mx-1{margin-left:-.25rem;margin-right:-.25rem}.md\\:-my-2{margin-bottom:-.5rem;margin-top:-.5rem}.md\\:-mx-2{margin-left:-.5rem;margin-right:-.5rem}.md\\:-my-3{margin-bottom:-.75rem;margin-top:-.75rem}.md\\:-mx-3{margin-left:-.75rem;margin-right:-.75rem}.md\\:-my-4{margin-bottom:-1rem;margin-top:-1rem}.md\\:-mx-4{margin-left:-1rem;margin-right:-1rem}.md\\:-my-5{margin-bottom:-1.25rem;margin-top:-1.25rem}.md\\:-mx-5{margin-left:-1.25rem;margin-right:-1.25rem}.md\\:-my-6{margin-bottom:-1.5rem;margin-top:-1.5rem}.md\\:-mx-6{margin-left:-1.5rem;margin-right:-1.5rem}.md\\:-my-8{margin-bottom:-2rem;margin-top:-2rem}.md\\:-mx-8{margin-left:-2rem;margin-right:-2rem}.md\\:-my-10{margin-bottom:-2.5rem;margin-top:-2.5rem}.md\\:-mx-10{margin-left:-2.5rem;margin-right:-2.5rem}.md\\:-my-12{margin-bottom:-3rem;margin-top:-3rem}.md\\:-mx-12{margin-left:-3rem;margin-right:-3rem}.md\\:-my-16{margin-bottom:-4rem;margin-top:-4rem}.md\\:-mx-16{margin-left:-4rem;margin-right:-4rem}.md\\:-my-20{margin-bottom:-5rem;margin-top:-5rem}.md\\:-mx-20{margin-left:-5rem;margin-right:-5rem}.md\\:-my-24{margin-bottom:-6rem;margin-top:-6rem}.md\\:-mx-24{margin-left:-6rem;margin-right:-6rem}.md\\:-my-32{margin-bottom:-8rem;margin-top:-8rem}.md\\:-mx-32{margin-left:-8rem;margin-right:-8rem}.md\\:-my-40{margin-bottom:-10rem;margin-top:-10rem}.md\\:-mx-40{margin-left:-10rem;margin-right:-10rem}.md\\:-my-48{margin-bottom:-12rem;margin-top:-12rem}.md\\:-mx-48{margin-left:-12rem;margin-right:-12rem}.md\\:-my-56{margin-bottom:-14rem;margin-top:-14rem}.md\\:-mx-56{margin-left:-14rem;margin-right:-14rem}.md\\:-my-64{margin-bottom:-16rem;margin-top:-16rem}.md\\:-mx-64{margin-left:-16rem;margin-right:-16rem}.md\\:-my-px{margin-bottom:-1px;margin-top:-1px}.md\\:-mx-px{margin-left:-1px;margin-right:-1px}.md\\:mt-0{margin-top:0}.md\\:mr-0{margin-right:0}.md\\:mb-0{margin-bottom:0}.md\\:ml-0{margin-left:0}.md\\:mt-1{margin-top:.25rem}.md\\:mr-1{margin-right:.25rem}.md\\:mb-1{margin-bottom:.25rem}.md\\:ml-1{margin-left:.25rem}.md\\:mt-2{margin-top:.5rem}.md\\:mr-2{margin-right:.5rem}.md\\:mb-2{margin-bottom:.5rem}.md\\:ml-2{margin-left:.5rem}.md\\:mt-3{margin-top:.75rem}.md\\:mr-3{margin-right:.75rem}.md\\:mb-3{margin-bottom:.75rem}.md\\:ml-3{margin-left:.75rem}.md\\:mt-4{margin-top:1rem}.md\\:mr-4{margin-right:1rem}.md\\:mb-4{margin-bottom:1rem}.md\\:ml-4{margin-left:1rem}.md\\:mt-5{margin-top:1.25rem}.md\\:mr-5{margin-right:1.25rem}.md\\:mb-5{margin-bottom:1.25rem}.md\\:ml-5{margin-left:1.25rem}.md\\:mt-6{margin-top:1.5rem}.md\\:mr-6{margin-right:1.5rem}.md\\:mb-6{margin-bottom:1.5rem}.md\\:ml-6{margin-left:1.5rem}.md\\:mt-8{margin-top:2rem}.md\\:mr-8{margin-right:2rem}.md\\:mb-8{margin-bottom:2rem}.md\\:ml-8{margin-left:2rem}.md\\:mt-10{margin-top:2.5rem}.md\\:mr-10{margin-right:2.5rem}.md\\:mb-10{margin-bottom:2.5rem}.md\\:ml-10{margin-left:2.5rem}.md\\:mt-12{margin-top:3rem}.md\\:mr-12{margin-right:3rem}.md\\:mb-12{margin-bottom:3rem}.md\\:ml-12{margin-left:3rem}.md\\:mt-16{margin-top:4rem}.md\\:mr-16{margin-right:4rem}.md\\:mb-16{margin-bottom:4rem}.md\\:ml-16{margin-left:4rem}.md\\:mt-20{margin-top:5rem}.md\\:mr-20{margin-right:5rem}.md\\:mb-20{margin-bottom:5rem}.md\\:ml-20{margin-left:5rem}.md\\:mt-24{margin-top:6rem}.md\\:mr-24{margin-right:6rem}.md\\:mb-24{margin-bottom:6rem}.md\\:ml-24{margin-left:6rem}.md\\:mt-32{margin-top:8rem}.md\\:mr-32{margin-right:8rem}.md\\:mb-32{margin-bottom:8rem}.md\\:ml-32{margin-left:8rem}.md\\:mt-40{margin-top:10rem}.md\\:mr-40{margin-right:10rem}.md\\:mb-40{margin-bottom:10rem}.md\\:ml-40{margin-left:10rem}.md\\:mt-48{margin-top:12rem}.md\\:mr-48{margin-right:12rem}.md\\:mb-48{margin-bottom:12rem}.md\\:ml-48{margin-left:12rem}.md\\:mt-56{margin-top:14rem}.md\\:mr-56{margin-right:14rem}.md\\:mb-56{margin-bottom:14rem}.md\\:ml-56{margin-left:14rem}.md\\:mt-64{margin-top:16rem}.md\\:mr-64{margin-right:16rem}.md\\:mb-64{margin-bottom:16rem}.md\\:ml-64{margin-left:16rem}.md\\:mt-auto{margin-top:auto}.md\\:mr-auto{margin-right:auto}.md\\:mb-auto{margin-bottom:auto}.md\\:ml-auto{margin-left:auto}.md\\:mt-px{margin-top:1px}.md\\:mr-px{margin-right:1px}.md\\:mb-px{margin-bottom:1px}.md\\:ml-px{margin-left:1px}.md\\:-mt-1{margin-top:-.25rem}.md\\:-mr-1{margin-right:-.25rem}.md\\:-mb-1{margin-bottom:-.25rem}.md\\:-ml-1{margin-left:-.25rem}.md\\:-mt-2{margin-top:-.5rem}.md\\:-mr-2{margin-right:-.5rem}.md\\:-mb-2{margin-bottom:-.5rem}.md\\:-ml-2{margin-left:-.5rem}.md\\:-mt-3{margin-top:-.75rem}.md\\:-mr-3{margin-right:-.75rem}.md\\:-mb-3{margin-bottom:-.75rem}.md\\:-ml-3{margin-left:-.75rem}.md\\:-mt-4{margin-top:-1rem}.md\\:-mr-4{margin-right:-1rem}.md\\:-mb-4{margin-bottom:-1rem}.md\\:-ml-4{margin-left:-1rem}.md\\:-mt-5{margin-top:-1.25rem}.md\\:-mr-5{margin-right:-1.25rem}.md\\:-mb-5{margin-bottom:-1.25rem}.md\\:-ml-5{margin-left:-1.25rem}.md\\:-mt-6{margin-top:-1.5rem}.md\\:-mr-6{margin-right:-1.5rem}.md\\:-mb-6{margin-bottom:-1.5rem}.md\\:-ml-6{margin-left:-1.5rem}.md\\:-mt-8{margin-top:-2rem}.md\\:-mr-8{margin-right:-2rem}.md\\:-mb-8{margin-bottom:-2rem}.md\\:-ml-8{margin-left:-2rem}.md\\:-mt-10{margin-top:-2.5rem}.md\\:-mr-10{margin-right:-2.5rem}.md\\:-mb-10{margin-bottom:-2.5rem}.md\\:-ml-10{margin-left:-2.5rem}.md\\:-mt-12{margin-top:-3rem}.md\\:-mr-12{margin-right:-3rem}.md\\:-mb-12{margin-bottom:-3rem}.md\\:-ml-12{margin-left:-3rem}.md\\:-mt-16{margin-top:-4rem}.md\\:-mr-16{margin-right:-4rem}.md\\:-mb-16{margin-bottom:-4rem}.md\\:-ml-16{margin-left:-4rem}.md\\:-mt-20{margin-top:-5rem}.md\\:-mr-20{margin-right:-5rem}.md\\:-mb-20{margin-bottom:-5rem}.md\\:-ml-20{margin-left:-5rem}.md\\:-mt-24{margin-top:-6rem}.md\\:-mr-24{margin-right:-6rem}.md\\:-mb-24{margin-bottom:-6rem}.md\\:-ml-24{margin-left:-6rem}.md\\:-mt-32{margin-top:-8rem}.md\\:-mr-32{margin-right:-8rem}.md\\:-mb-32{margin-bottom:-8rem}.md\\:-ml-32{margin-left:-8rem}.md\\:-mt-40{margin-top:-10rem}.md\\:-mr-40{margin-right:-10rem}.md\\:-mb-40{margin-bottom:-10rem}.md\\:-ml-40{margin-left:-10rem}.md\\:-mt-48{margin-top:-12rem}.md\\:-mr-48{margin-right:-12rem}.md\\:-mb-48{margin-bottom:-12rem}.md\\:-ml-48{margin-left:-12rem}.md\\:-mt-56{margin-top:-14rem}.md\\:-mr-56{margin-right:-14rem}.md\\:-mb-56{margin-bottom:-14rem}.md\\:-ml-56{margin-left:-14rem}.md\\:-mt-64{margin-top:-16rem}.md\\:-mr-64{margin-right:-16rem}.md\\:-mb-64{margin-bottom:-16rem}.md\\:-ml-64{margin-left:-16rem}.md\\:-mt-px{margin-top:-1px}.md\\:-mr-px{margin-right:-1px}.md\\:-mb-px{margin-bottom:-1px}.md\\:-ml-px{margin-left:-1px}.md\\:last\\:m-0:last-child{margin:0}.md\\:last\\:m-1:last-child{margin:.25rem}.md\\:last\\:m-2:last-child{margin:.5rem}.md\\:last\\:m-3:last-child{margin:.75rem}.md\\:last\\:m-4:last-child{margin:1rem}.md\\:last\\:m-5:last-child{margin:1.25rem}.md\\:last\\:m-6:last-child{margin:1.5rem}.md\\:last\\:m-8:last-child{margin:2rem}.md\\:last\\:m-10:last-child{margin:2.5rem}.md\\:last\\:m-12:last-child{margin:3rem}.md\\:last\\:m-16:last-child{margin:4rem}.md\\:last\\:m-20:last-child{margin:5rem}.md\\:last\\:m-24:last-child{margin:6rem}.md\\:last\\:m-32:last-child{margin:8rem}.md\\:last\\:m-40:last-child{margin:10rem}.md\\:last\\:m-48:last-child{margin:12rem}.md\\:last\\:m-56:last-child{margin:14rem}.md\\:last\\:m-64:last-child{margin:16rem}.md\\:last\\:m-auto:last-child{margin:auto}.md\\:last\\:m-px:last-child{margin:1px}.md\\:last\\:-m-1:last-child{margin:-.25rem}.md\\:last\\:-m-2:last-child{margin:-.5rem}.md\\:last\\:-m-3:last-child{margin:-.75rem}.md\\:last\\:-m-4:last-child{margin:-1rem}.md\\:last\\:-m-5:last-child{margin:-1.25rem}.md\\:last\\:-m-6:last-child{margin:-1.5rem}.md\\:last\\:-m-8:last-child{margin:-2rem}.md\\:last\\:-m-10:last-child{margin:-2.5rem}.md\\:last\\:-m-12:last-child{margin:-3rem}.md\\:last\\:-m-16:last-child{margin:-4rem}.md\\:last\\:-m-20:last-child{margin:-5rem}.md\\:last\\:-m-24:last-child{margin:-6rem}.md\\:last\\:-m-32:last-child{margin:-8rem}.md\\:last\\:-m-40:last-child{margin:-10rem}.md\\:last\\:-m-48:last-child{margin:-12rem}.md\\:last\\:-m-56:last-child{margin:-14rem}.md\\:last\\:-m-64:last-child{margin:-16rem}.md\\:last\\:-m-px:last-child{margin:-1px}.md\\:last\\:my-0:last-child{margin-bottom:0;margin-top:0}.md\\:last\\:mx-0:last-child{margin-left:0;margin-right:0}.md\\:last\\:my-1:last-child{margin-bottom:.25rem;margin-top:.25rem}.md\\:last\\:mx-1:last-child{margin-left:.25rem;margin-right:.25rem}.md\\:last\\:my-2:last-child{margin-bottom:.5rem;margin-top:.5rem}.md\\:last\\:mx-2:last-child{margin-left:.5rem;margin-right:.5rem}.md\\:last\\:my-3:last-child{margin-bottom:.75rem;margin-top:.75rem}.md\\:last\\:mx-3:last-child{margin-left:.75rem;margin-right:.75rem}.md\\:last\\:my-4:last-child{margin-bottom:1rem;margin-top:1rem}.md\\:last\\:mx-4:last-child{margin-left:1rem;margin-right:1rem}.md\\:last\\:my-5:last-child{margin-bottom:1.25rem;margin-top:1.25rem}.md\\:last\\:mx-5:last-child{margin-left:1.25rem;margin-right:1.25rem}.md\\:last\\:my-6:last-child{margin-bottom:1.5rem;margin-top:1.5rem}.md\\:last\\:mx-6:last-child{margin-left:1.5rem;margin-right:1.5rem}.md\\:last\\:my-8:last-child{margin-bottom:2rem;margin-top:2rem}.md\\:last\\:mx-8:last-child{margin-left:2rem;margin-right:2rem}.md\\:last\\:my-10:last-child{margin-bottom:2.5rem;margin-top:2.5rem}.md\\:last\\:mx-10:last-child{margin-left:2.5rem;margin-right:2.5rem}.md\\:last\\:my-12:last-child{margin-bottom:3rem;margin-top:3rem}.md\\:last\\:mx-12:last-child{margin-left:3rem;margin-right:3rem}.md\\:last\\:my-16:last-child{margin-bottom:4rem;margin-top:4rem}.md\\:last\\:mx-16:last-child{margin-left:4rem;margin-right:4rem}.md\\:last\\:my-20:last-child{margin-bottom:5rem;margin-top:5rem}.md\\:last\\:mx-20:last-child{margin-left:5rem;margin-right:5rem}.md\\:last\\:my-24:last-child{margin-bottom:6rem;margin-top:6rem}.md\\:last\\:mx-24:last-child{margin-left:6rem;margin-right:6rem}.md\\:last\\:my-32:last-child{margin-bottom:8rem;margin-top:8rem}.md\\:last\\:mx-32:last-child{margin-left:8rem;margin-right:8rem}.md\\:last\\:my-40:last-child{margin-bottom:10rem;margin-top:10rem}.md\\:last\\:mx-40:last-child{margin-left:10rem;margin-right:10rem}.md\\:last\\:my-48:last-child{margin-bottom:12rem;margin-top:12rem}.md\\:last\\:mx-48:last-child{margin-left:12rem;margin-right:12rem}.md\\:last\\:my-56:last-child{margin-bottom:14rem;margin-top:14rem}.md\\:last\\:mx-56:last-child{margin-left:14rem;margin-right:14rem}.md\\:last\\:my-64:last-child{margin-bottom:16rem;margin-top:16rem}.md\\:last\\:mx-64:last-child{margin-left:16rem;margin-right:16rem}.md\\:last\\:my-auto:last-child{margin-bottom:auto;margin-top:auto}.md\\:last\\:mx-auto:last-child{margin-left:auto;margin-right:auto}.md\\:last\\:my-px:last-child{margin-bottom:1px;margin-top:1px}.md\\:last\\:mx-px:last-child{margin-left:1px;margin-right:1px}.md\\:last\\:-my-1:last-child{margin-bottom:-.25rem;margin-top:-.25rem}.md\\:last\\:-mx-1:last-child{margin-left:-.25rem;margin-right:-.25rem}.md\\:last\\:-my-2:last-child{margin-bottom:-.5rem;margin-top:-.5rem}.md\\:last\\:-mx-2:last-child{margin-left:-.5rem;margin-right:-.5rem}.md\\:last\\:-my-3:last-child{margin-bottom:-.75rem;margin-top:-.75rem}.md\\:last\\:-mx-3:last-child{margin-left:-.75rem;margin-right:-.75rem}.md\\:last\\:-my-4:last-child{margin-bottom:-1rem;margin-top:-1rem}.md\\:last\\:-mx-4:last-child{margin-left:-1rem;margin-right:-1rem}.md\\:last\\:-my-5:last-child{margin-bottom:-1.25rem;margin-top:-1.25rem}.md\\:last\\:-mx-5:last-child{margin-left:-1.25rem;margin-right:-1.25rem}.md\\:last\\:-my-6:last-child{margin-bottom:-1.5rem;margin-top:-1.5rem}.md\\:last\\:-mx-6:last-child{margin-left:-1.5rem;margin-right:-1.5rem}.md\\:last\\:-my-8:last-child{margin-bottom:-2rem;margin-top:-2rem}.md\\:last\\:-mx-8:last-child{margin-left:-2rem;margin-right:-2rem}.md\\:last\\:-my-10:last-child{margin-bottom:-2.5rem;margin-top:-2.5rem}.md\\:last\\:-mx-10:last-child{margin-left:-2.5rem;margin-right:-2.5rem}.md\\:last\\:-my-12:last-child{margin-bottom:-3rem;margin-top:-3rem}.md\\:last\\:-mx-12:last-child{margin-left:-3rem;margin-right:-3rem}.md\\:last\\:-my-16:last-child{margin-bottom:-4rem;margin-top:-4rem}.md\\:last\\:-mx-16:last-child{margin-left:-4rem;margin-right:-4rem}.md\\:last\\:-my-20:last-child{margin-bottom:-5rem;margin-top:-5rem}.md\\:last\\:-mx-20:last-child{margin-left:-5rem;margin-right:-5rem}.md\\:last\\:-my-24:last-child{margin-bottom:-6rem;margin-top:-6rem}.md\\:last\\:-mx-24:last-child{margin-left:-6rem;margin-right:-6rem}.md\\:last\\:-my-32:last-child{margin-bottom:-8rem;margin-top:-8rem}.md\\:last\\:-mx-32:last-child{margin-left:-8rem;margin-right:-8rem}.md\\:last\\:-my-40:last-child{margin-bottom:-10rem;margin-top:-10rem}.md\\:last\\:-mx-40:last-child{margin-left:-10rem;margin-right:-10rem}.md\\:last\\:-my-48:last-child{margin-bottom:-12rem;margin-top:-12rem}.md\\:last\\:-mx-48:last-child{margin-left:-12rem;margin-right:-12rem}.md\\:last\\:-my-56:last-child{margin-bottom:-14rem;margin-top:-14rem}.md\\:last\\:-mx-56:last-child{margin-left:-14rem;margin-right:-14rem}.md\\:last\\:-my-64:last-child{margin-bottom:-16rem;margin-top:-16rem}.md\\:last\\:-mx-64:last-child{margin-left:-16rem;margin-right:-16rem}.md\\:last\\:-my-px:last-child{margin-bottom:-1px;margin-top:-1px}.md\\:last\\:-mx-px:last-child{margin-left:-1px;margin-right:-1px}.md\\:last\\:mt-0:last-child{margin-top:0}.md\\:last\\:mr-0:last-child{margin-right:0}.md\\:last\\:mb-0:last-child{margin-bottom:0}.md\\:last\\:ml-0:last-child{margin-left:0}.md\\:last\\:mt-1:last-child{margin-top:.25rem}.md\\:last\\:mr-1:last-child{margin-right:.25rem}.md\\:last\\:mb-1:last-child{margin-bottom:.25rem}.md\\:last\\:ml-1:last-child{margin-left:.25rem}.md\\:last\\:mt-2:last-child{margin-top:.5rem}.md\\:last\\:mr-2:last-child{margin-right:.5rem}.md\\:last\\:mb-2:last-child{margin-bottom:.5rem}.md\\:last\\:ml-2:last-child{margin-left:.5rem}.md\\:last\\:mt-3:last-child{margin-top:.75rem}.md\\:last\\:mr-3:last-child{margin-right:.75rem}.md\\:last\\:mb-3:last-child{margin-bottom:.75rem}.md\\:last\\:ml-3:last-child{margin-left:.75rem}.md\\:last\\:mt-4:last-child{margin-top:1rem}.md\\:last\\:mr-4:last-child{margin-right:1rem}.md\\:last\\:mb-4:last-child{margin-bottom:1rem}.md\\:last\\:ml-4:last-child{margin-left:1rem}.md\\:last\\:mt-5:last-child{margin-top:1.25rem}.md\\:last\\:mr-5:last-child{margin-right:1.25rem}.md\\:last\\:mb-5:last-child{margin-bottom:1.25rem}.md\\:last\\:ml-5:last-child{margin-left:1.25rem}.md\\:last\\:mt-6:last-child{margin-top:1.5rem}.md\\:last\\:mr-6:last-child{margin-right:1.5rem}.md\\:last\\:mb-6:last-child{margin-bottom:1.5rem}.md\\:last\\:ml-6:last-child{margin-left:1.5rem}.md\\:last\\:mt-8:last-child{margin-top:2rem}.md\\:last\\:mr-8:last-child{margin-right:2rem}.md\\:last\\:mb-8:last-child{margin-bottom:2rem}.md\\:last\\:ml-8:last-child{margin-left:2rem}.md\\:last\\:mt-10:last-child{margin-top:2.5rem}.md\\:last\\:mr-10:last-child{margin-right:2.5rem}.md\\:last\\:mb-10:last-child{margin-bottom:2.5rem}.md\\:last\\:ml-10:last-child{margin-left:2.5rem}.md\\:last\\:mt-12:last-child{margin-top:3rem}.md\\:last\\:mr-12:last-child{margin-right:3rem}.md\\:last\\:mb-12:last-child{margin-bottom:3rem}.md\\:last\\:ml-12:last-child{margin-left:3rem}.md\\:last\\:mt-16:last-child{margin-top:4rem}.md\\:last\\:mr-16:last-child{margin-right:4rem}.md\\:last\\:mb-16:last-child{margin-bottom:4rem}.md\\:last\\:ml-16:last-child{margin-left:4rem}.md\\:last\\:mt-20:last-child{margin-top:5rem}.md\\:last\\:mr-20:last-child{margin-right:5rem}.md\\:last\\:mb-20:last-child{margin-bottom:5rem}.md\\:last\\:ml-20:last-child{margin-left:5rem}.md\\:last\\:mt-24:last-child{margin-top:6rem}.md\\:last\\:mr-24:last-child{margin-right:6rem}.md\\:last\\:mb-24:last-child{margin-bottom:6rem}.md\\:last\\:ml-24:last-child{margin-left:6rem}.md\\:last\\:mt-32:last-child{margin-top:8rem}.md\\:last\\:mr-32:last-child{margin-right:8rem}.md\\:last\\:mb-32:last-child{margin-bottom:8rem}.md\\:last\\:ml-32:last-child{margin-left:8rem}.md\\:last\\:mt-40:last-child{margin-top:10rem}.md\\:last\\:mr-40:last-child{margin-right:10rem}.md\\:last\\:mb-40:last-child{margin-bottom:10rem}.md\\:last\\:ml-40:last-child{margin-left:10rem}.md\\:last\\:mt-48:last-child{margin-top:12rem}.md\\:last\\:mr-48:last-child{margin-right:12rem}.md\\:last\\:mb-48:last-child{margin-bottom:12rem}.md\\:last\\:ml-48:last-child{margin-left:12rem}.md\\:last\\:mt-56:last-child{margin-top:14rem}.md\\:last\\:mr-56:last-child{margin-right:14rem}.md\\:last\\:mb-56:last-child{margin-bottom:14rem}.md\\:last\\:ml-56:last-child{margin-left:14rem}.md\\:last\\:mt-64:last-child{margin-top:16rem}.md\\:last\\:mr-64:last-child{margin-right:16rem}.md\\:last\\:mb-64:last-child{margin-bottom:16rem}.md\\:last\\:ml-64:last-child{margin-left:16rem}.md\\:last\\:mt-auto:last-child{margin-top:auto}.md\\:last\\:mr-auto:last-child{margin-right:auto}.md\\:last\\:mb-auto:last-child{margin-bottom:auto}.md\\:last\\:ml-auto:last-child{margin-left:auto}.md\\:last\\:mt-px:last-child{margin-top:1px}.md\\:last\\:mr-px:last-child{margin-right:1px}.md\\:last\\:mb-px:last-child{margin-bottom:1px}.md\\:last\\:ml-px:last-child{margin-left:1px}.md\\:last\\:-mt-1:last-child{margin-top:-.25rem}.md\\:last\\:-mr-1:last-child{margin-right:-.25rem}.md\\:last\\:-mb-1:last-child{margin-bottom:-.25rem}.md\\:last\\:-ml-1:last-child{margin-left:-.25rem}.md\\:last\\:-mt-2:last-child{margin-top:-.5rem}.md\\:last\\:-mr-2:last-child{margin-right:-.5rem}.md\\:last\\:-mb-2:last-child{margin-bottom:-.5rem}.md\\:last\\:-ml-2:last-child{margin-left:-.5rem}.md\\:last\\:-mt-3:last-child{margin-top:-.75rem}.md\\:last\\:-mr-3:last-child{margin-right:-.75rem}.md\\:last\\:-mb-3:last-child{margin-bottom:-.75rem}.md\\:last\\:-ml-3:last-child{margin-left:-.75rem}.md\\:last\\:-mt-4:last-child{margin-top:-1rem}.md\\:last\\:-mr-4:last-child{margin-right:-1rem}.md\\:last\\:-mb-4:last-child{margin-bottom:-1rem}.md\\:last\\:-ml-4:last-child{margin-left:-1rem}.md\\:last\\:-mt-5:last-child{margin-top:-1.25rem}.md\\:last\\:-mr-5:last-child{margin-right:-1.25rem}.md\\:last\\:-mb-5:last-child{margin-bottom:-1.25rem}.md\\:last\\:-ml-5:last-child{margin-left:-1.25rem}.md\\:last\\:-mt-6:last-child{margin-top:-1.5rem}.md\\:last\\:-mr-6:last-child{margin-right:-1.5rem}.md\\:last\\:-mb-6:last-child{margin-bottom:-1.5rem}.md\\:last\\:-ml-6:last-child{margin-left:-1.5rem}.md\\:last\\:-mt-8:last-child{margin-top:-2rem}.md\\:last\\:-mr-8:last-child{margin-right:-2rem}.md\\:last\\:-mb-8:last-child{margin-bottom:-2rem}.md\\:last\\:-ml-8:last-child{margin-left:-2rem}.md\\:last\\:-mt-10:last-child{margin-top:-2.5rem}.md\\:last\\:-mr-10:last-child{margin-right:-2.5rem}.md\\:last\\:-mb-10:last-child{margin-bottom:-2.5rem}.md\\:last\\:-ml-10:last-child{margin-left:-2.5rem}.md\\:last\\:-mt-12:last-child{margin-top:-3rem}.md\\:last\\:-mr-12:last-child{margin-right:-3rem}.md\\:last\\:-mb-12:last-child{margin-bottom:-3rem}.md\\:last\\:-ml-12:last-child{margin-left:-3rem}.md\\:last\\:-mt-16:last-child{margin-top:-4rem}.md\\:last\\:-mr-16:last-child{margin-right:-4rem}.md\\:last\\:-mb-16:last-child{margin-bottom:-4rem}.md\\:last\\:-ml-16:last-child{margin-left:-4rem}.md\\:last\\:-mt-20:last-child{margin-top:-5rem}.md\\:last\\:-mr-20:last-child{margin-right:-5rem}.md\\:last\\:-mb-20:last-child{margin-bottom:-5rem}.md\\:last\\:-ml-20:last-child{margin-left:-5rem}.md\\:last\\:-mt-24:last-child{margin-top:-6rem}.md\\:last\\:-mr-24:last-child{margin-right:-6rem}.md\\:last\\:-mb-24:last-child{margin-bottom:-6rem}.md\\:last\\:-ml-24:last-child{margin-left:-6rem}.md\\:last\\:-mt-32:last-child{margin-top:-8rem}.md\\:last\\:-mr-32:last-child{margin-right:-8rem}.md\\:last\\:-mb-32:last-child{margin-bottom:-8rem}.md\\:last\\:-ml-32:last-child{margin-left:-8rem}.md\\:last\\:-mt-40:last-child{margin-top:-10rem}.md\\:last\\:-mr-40:last-child{margin-right:-10rem}.md\\:last\\:-mb-40:last-child{margin-bottom:-10rem}.md\\:last\\:-ml-40:last-child{margin-left:-10rem}.md\\:last\\:-mt-48:last-child{margin-top:-12rem}.md\\:last\\:-mr-48:last-child{margin-right:-12rem}.md\\:last\\:-mb-48:last-child{margin-bottom:-12rem}.md\\:last\\:-ml-48:last-child{margin-left:-12rem}.md\\:last\\:-mt-56:last-child{margin-top:-14rem}.md\\:last\\:-mr-56:last-child{margin-right:-14rem}.md\\:last\\:-mb-56:last-child{margin-bottom:-14rem}.md\\:last\\:-ml-56:last-child{margin-left:-14rem}.md\\:last\\:-mt-64:last-child{margin-top:-16rem}.md\\:last\\:-mr-64:last-child{margin-right:-16rem}.md\\:last\\:-mb-64:last-child{margin-bottom:-16rem}.md\\:last\\:-ml-64:last-child{margin-left:-16rem}.md\\:last\\:-mt-px:last-child{margin-top:-1px}.md\\:last\\:-mr-px:last-child{margin-right:-1px}.md\\:last\\:-mb-px:last-child{margin-bottom:-1px}.md\\:last\\:-ml-px:last-child{margin-left:-1px}.md\\:max-h-0{max-height:0}.md\\:max-h-1{max-height:.25rem}.md\\:max-h-2{max-height:.5rem}.md\\:max-h-3{max-height:.75rem}.md\\:max-h-4{max-height:1rem}.md\\:max-h-5{max-height:1.25rem}.md\\:max-h-6{max-height:1.5rem}.md\\:max-h-8{max-height:2rem}.md\\:max-h-10{max-height:2.5rem}.md\\:max-h-12{max-height:3rem}.md\\:max-h-16{max-height:4rem}.md\\:max-h-20{max-height:5rem}.md\\:max-h-24{max-height:6rem}.md\\:max-h-32{max-height:8rem}.md\\:max-h-40{max-height:10rem}.md\\:max-h-48{max-height:12rem}.md\\:max-h-56{max-height:14rem}.md\\:max-h-64{max-height:16rem}.md\\:max-h-xl{max-height:36rem}.md\\:max-h-px{max-height:1px}.md\\:max-w-none{max-width:none}.md\\:max-w-xs{max-width:20rem}.md\\:max-w-sm{max-width:24rem}.md\\:max-w-md{max-width:28rem}.md\\:max-w-lg{max-width:32rem}.md\\:max-w-xl{max-width:36rem}.md\\:max-w-2xl{max-width:42rem}.md\\:max-w-3xl{max-width:48rem}.md\\:max-w-4xl{max-width:56rem}.md\\:max-w-5xl{max-width:64rem}.md\\:max-w-6xl{max-width:72rem}.md\\:max-w-full{max-width:100%}.md\\:max-w-screen-sm{max-width:640px}.md\\:max-w-screen-md{max-width:768px}.md\\:max-w-screen-lg{max-width:1024px}.md\\:max-w-screen-xl{max-width:1280px}.md\\:min-h-0{min-height:0}.md\\:min-h-full{min-height:100%}.md\\:min-h-screen{min-height:100vh}.md\\:min-w-0{min-width:0}.md\\:min-w-1{min-width:.25rem}.md\\:min-w-2{min-width:.5rem}.md\\:min-w-3{min-width:.75rem}.md\\:min-w-4{min-width:1rem}.md\\:min-w-5{min-width:1.25rem}.md\\:min-w-6{min-width:1.5rem}.md\\:min-w-8{min-width:2rem}.md\\:min-w-10{min-width:2.5rem}.md\\:min-w-12{min-width:3rem}.md\\:min-w-16{min-width:4rem}.md\\:min-w-20{min-width:5rem}.md\\:min-w-24{min-width:6rem}.md\\:min-w-32{min-width:8rem}.md\\:min-w-40{min-width:10rem}.md\\:min-w-48{min-width:12rem}.md\\:min-w-56{min-width:14rem}.md\\:min-w-64{min-width:16rem}.md\\:min-w-max-content{min-width:-webkit-max-content;min-width:max-content}.md\\:min-w-px{min-width:1px}.md\\:object-contain{object-fit:contain}.md\\:object-cover{object-fit:cover}.md\\:object-fill{object-fit:fill}.md\\:object-none{object-fit:none}.md\\:object-scale-down{object-fit:scale-down}.md\\:object-bottom{object-position:bottom}.md\\:object-center{object-position:center}.md\\:object-left{object-position:left}.md\\:object-left-bottom{object-position:left bottom}.md\\:object-left-top{object-position:left top}.md\\:object-right{object-position:right}.md\\:object-right-bottom{object-position:right bottom}.md\\:object-right-top{object-position:right top}.md\\:object-top{object-position:top}.md\\:opacity-0{opacity:0}.md\\:opacity-25{opacity:.25}.md\\:opacity-50{opacity:.5}.md\\:opacity-75{opacity:.75}.md\\:opacity-100{opacity:1}.md\\:hover\\:opacity-0:hover{opacity:0}.md\\:hover\\:opacity-25:hover{opacity:.25}.md\\:hover\\:opacity-50:hover{opacity:.5}.md\\:hover\\:opacity-75:hover{opacity:.75}.md\\:hover\\:opacity-100:hover{opacity:1}.md\\:focus\\:opacity-0:focus{opacity:0}.md\\:focus\\:opacity-25:focus{opacity:.25}.md\\:focus\\:opacity-50:focus{opacity:.5}.md\\:focus\\:opacity-75:focus{opacity:.75}.md\\:focus\\:opacity-100:focus{opacity:1}.md\\:focus\\:outline-none:focus,.md\\:outline-none{outline:0}.md\\:overflow-auto{overflow:auto}.md\\:overflow-hidden{overflow:hidden}.md\\:overflow-visible{overflow:visible}.md\\:overflow-scroll{overflow:scroll}.md\\:overflow-x-auto{overflow-x:auto}.md\\:overflow-y-auto{overflow-y:auto}.md\\:overflow-x-hidden{overflow-x:hidden}.md\\:overflow-y-hidden{overflow-y:hidden}.md\\:overflow-x-visible{overflow-x:visible}.md\\:overflow-y-visible{overflow-y:visible}.md\\:overflow-x-scroll{overflow-x:scroll}.md\\:overflow-y-scroll{overflow-y:scroll}.md\\:scrolling-touch{-webkit-overflow-scrolling:touch}.md\\:scrolling-auto{-webkit-overflow-scrolling:auto}.md\\:p-0{padding:0}.md\\:p-1{padding:.25rem}.md\\:p-2{padding:.5rem}.md\\:p-3{padding:.75rem}.md\\:p-4{padding:1rem}.md\\:p-5{padding:1.25rem}.md\\:p-6{padding:1.5rem}.md\\:p-8{padding:2rem}.md\\:p-10{padding:2.5rem}.md\\:p-12{padding:3rem}.md\\:p-16{padding:4rem}.md\\:p-20{padding:5rem}.md\\:p-24{padding:6rem}.md\\:p-32{padding:8rem}.md\\:p-40{padding:10rem}.md\\:p-48{padding:12rem}.md\\:p-56{padding:14rem}.md\\:p-64{padding:16rem}.md\\:p-px{padding:1px}.md\\:py-0{padding-bottom:0;padding-top:0}.md\\:px-0{padding-left:0;padding-right:0}.md\\:py-1{padding-bottom:.25rem;padding-top:.25rem}.md\\:px-1{padding-left:.25rem;padding-right:.25rem}.md\\:py-2{padding-bottom:.5rem;padding-top:.5rem}.md\\:px-2{padding-left:.5rem;padding-right:.5rem}.md\\:py-3{padding-bottom:.75rem;padding-top:.75rem}.md\\:px-3{padding-left:.75rem;padding-right:.75rem}.md\\:py-4{padding-bottom:1rem;padding-top:1rem}.md\\:px-4{padding-left:1rem;padding-right:1rem}.md\\:py-5{padding-bottom:1.25rem;padding-top:1.25rem}.md\\:px-5{padding-left:1.25rem;padding-right:1.25rem}.md\\:py-6{padding-bottom:1.5rem;padding-top:1.5rem}.md\\:px-6{padding-left:1.5rem;padding-right:1.5rem}.md\\:py-8{padding-bottom:2rem;padding-top:2rem}.md\\:px-8{padding-left:2rem;padding-right:2rem}.md\\:py-10{padding-bottom:2.5rem;padding-top:2.5rem}.md\\:px-10{padding-left:2.5rem;padding-right:2.5rem}.md\\:py-12{padding-bottom:3rem;padding-top:3rem}.md\\:px-12{padding-left:3rem;padding-right:3rem}.md\\:py-16{padding-bottom:4rem;padding-top:4rem}.md\\:px-16{padding-left:4rem;padding-right:4rem}.md\\:py-20{padding-bottom:5rem;padding-top:5rem}.md\\:px-20{padding-left:5rem;padding-right:5rem}.md\\:py-24{padding-bottom:6rem;padding-top:6rem}.md\\:px-24{padding-left:6rem;padding-right:6rem}.md\\:py-32{padding-bottom:8rem;padding-top:8rem}.md\\:px-32{padding-left:8rem;padding-right:8rem}.md\\:py-40{padding-bottom:10rem;padding-top:10rem}.md\\:px-40{padding-left:10rem;padding-right:10rem}.md\\:py-48{padding-bottom:12rem;padding-top:12rem}.md\\:px-48{padding-left:12rem;padding-right:12rem}.md\\:py-56{padding-bottom:14rem;padding-top:14rem}.md\\:px-56{padding-left:14rem;padding-right:14rem}.md\\:py-64{padding-bottom:16rem;padding-top:16rem}.md\\:px-64{padding-left:16rem;padding-right:16rem}.md\\:py-px{padding-bottom:1px;padding-top:1px}.md\\:px-px{padding-left:1px;padding-right:1px}.md\\:pt-0{padding-top:0}.md\\:pr-0{padding-right:0}.md\\:pb-0{padding-bottom:0}.md\\:pl-0{padding-left:0}.md\\:pt-1{padding-top:.25rem}.md\\:pr-1{padding-right:.25rem}.md\\:pb-1{padding-bottom:.25rem}.md\\:pl-1{padding-left:.25rem}.md\\:pt-2{padding-top:.5rem}.md\\:pr-2{padding-right:.5rem}.md\\:pb-2{padding-bottom:.5rem}.md\\:pl-2{padding-left:.5rem}.md\\:pt-3{padding-top:.75rem}.md\\:pr-3{padding-right:.75rem}.md\\:pb-3{padding-bottom:.75rem}.md\\:pl-3{padding-left:.75rem}.md\\:pt-4{padding-top:1rem}.md\\:pr-4{padding-right:1rem}.md\\:pb-4{padding-bottom:1rem}.md\\:pl-4{padding-left:1rem}.md\\:pt-5{padding-top:1.25rem}.md\\:pr-5{padding-right:1.25rem}.md\\:pb-5{padding-bottom:1.25rem}.md\\:pl-5{padding-left:1.25rem}.md\\:pt-6{padding-top:1.5rem}.md\\:pr-6{padding-right:1.5rem}.md\\:pb-6{padding-bottom:1.5rem}.md\\:pl-6{padding-left:1.5rem}.md\\:pt-8{padding-top:2rem}.md\\:pr-8{padding-right:2rem}.md\\:pb-8{padding-bottom:2rem}.md\\:pl-8{padding-left:2rem}.md\\:pt-10{padding-top:2.5rem}.md\\:pr-10{padding-right:2.5rem}.md\\:pb-10{padding-bottom:2.5rem}.md\\:pl-10{padding-left:2.5rem}.md\\:pt-12{padding-top:3rem}.md\\:pr-12{padding-right:3rem}.md\\:pb-12{padding-bottom:3rem}.md\\:pl-12{padding-left:3rem}.md\\:pt-16{padding-top:4rem}.md\\:pr-16{padding-right:4rem}.md\\:pb-16{padding-bottom:4rem}.md\\:pl-16{padding-left:4rem}.md\\:pt-20{padding-top:5rem}.md\\:pr-20{padding-right:5rem}.md\\:pb-20{padding-bottom:5rem}.md\\:pl-20{padding-left:5rem}.md\\:pt-24{padding-top:6rem}.md\\:pr-24{padding-right:6rem}.md\\:pb-24{padding-bottom:6rem}.md\\:pl-24{padding-left:6rem}.md\\:pt-32{padding-top:8rem}.md\\:pr-32{padding-right:8rem}.md\\:pb-32{padding-bottom:8rem}.md\\:pl-32{padding-left:8rem}.md\\:pt-40{padding-top:10rem}.md\\:pr-40{padding-right:10rem}.md\\:pb-40{padding-bottom:10rem}.md\\:pl-40{padding-left:10rem}.md\\:pt-48{padding-top:12rem}.md\\:pr-48{padding-right:12rem}.md\\:pb-48{padding-bottom:12rem}.md\\:pl-48{padding-left:12rem}.md\\:pt-56{padding-top:14rem}.md\\:pr-56{padding-right:14rem}.md\\:pb-56{padding-bottom:14rem}.md\\:pl-56{padding-left:14rem}.md\\:pt-64{padding-top:16rem}.md\\:pr-64{padding-right:16rem}.md\\:pb-64{padding-bottom:16rem}.md\\:pl-64{padding-left:16rem}.md\\:pt-px{padding-top:1px}.md\\:pr-px{padding-right:1px}.md\\:pb-px{padding-bottom:1px}.md\\:pl-px{padding-left:1px}.md\\:placeholder-transparent::placeholder{color:#0000}.md\\:placeholder-white::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.md\\:placeholder-black::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.md\\:placeholder-gray-50::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.md\\:placeholder-gray-100::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.md\\:placeholder-gray-200::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.md\\:placeholder-gray-300::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.md\\:placeholder-gray-400::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.md\\:placeholder-gray-500::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.md\\:placeholder-gray-600::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.md\\:placeholder-gray-700::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.md\\:placeholder-gray-800::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.md\\:placeholder-gray-900::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.md\\:placeholder-cool-gray-50::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.md\\:placeholder-cool-gray-100::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.md\\:placeholder-cool-gray-200::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.md\\:placeholder-cool-gray-300::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.md\\:placeholder-cool-gray-400::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.md\\:placeholder-cool-gray-500::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.md\\:placeholder-cool-gray-600::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.md\\:placeholder-cool-gray-700::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.md\\:placeholder-cool-gray-800::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.md\\:placeholder-cool-gray-900::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.md\\:placeholder-red-50::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.md\\:placeholder-red-100::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.md\\:placeholder-red-200::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.md\\:placeholder-red-300::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.md\\:placeholder-red-400::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.md\\:placeholder-red-500::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.md\\:placeholder-red-600::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.md\\:placeholder-red-700::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.md\\:placeholder-red-800::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.md\\:placeholder-red-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.md\\:placeholder-orange-50::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.md\\:placeholder-orange-100::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.md\\:placeholder-orange-200::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.md\\:placeholder-orange-300::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.md\\:placeholder-orange-400::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.md\\:placeholder-orange-500::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.md\\:placeholder-orange-600::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.md\\:placeholder-orange-700::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.md\\:placeholder-orange-800::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.md\\:placeholder-orange-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.md\\:placeholder-yellow-50::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.md\\:placeholder-yellow-100::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.md\\:placeholder-yellow-200::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.md\\:placeholder-yellow-300::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.md\\:placeholder-yellow-400::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.md\\:placeholder-yellow-500::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.md\\:placeholder-yellow-600::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.md\\:placeholder-yellow-700::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.md\\:placeholder-yellow-800::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.md\\:placeholder-yellow-900::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.md\\:placeholder-green-50::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.md\\:placeholder-green-100::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.md\\:placeholder-green-200::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.md\\:placeholder-green-300::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.md\\:placeholder-green-400::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.md\\:placeholder-green-500::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.md\\:placeholder-green-600::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.md\\:placeholder-green-700::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.md\\:placeholder-green-800::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.md\\:placeholder-green-900::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.md\\:placeholder-teal-50::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.md\\:placeholder-teal-100::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.md\\:placeholder-teal-200::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.md\\:placeholder-teal-300::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.md\\:placeholder-teal-400::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.md\\:placeholder-teal-500::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.md\\:placeholder-teal-600::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.md\\:placeholder-teal-700::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.md\\:placeholder-teal-800::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.md\\:placeholder-teal-900::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.md\\:placeholder-blue-50::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.md\\:placeholder-blue-100::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.md\\:placeholder-blue-200::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.md\\:placeholder-blue-300::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.md\\:placeholder-blue-400::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.md\\:placeholder-blue-500::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.md\\:placeholder-blue-600::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.md\\:placeholder-blue-700::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.md\\:placeholder-blue-800::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.md\\:placeholder-blue-900::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.md\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.md\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.md\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.md\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.md\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.md\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.md\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.md\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.md\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.md\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.md\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.md\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.md\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.md\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.md\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.md\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.md\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.md\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.md\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.md\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.md\\:placeholder-pink-50::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.md\\:placeholder-pink-100::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.md\\:placeholder-pink-200::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.md\\:placeholder-pink-300::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.md\\:placeholder-pink-400::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.md\\:placeholder-pink-500::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.md\\:placeholder-pink-600::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.md\\:placeholder-pink-700::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.md\\:placeholder-pink-800::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.md\\:placeholder-pink-900::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.md\\:focus\\:placeholder-transparent:focus::placeholder{color:#0000}.md\\:focus\\:placeholder-white:focus::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.md\\:focus\\:placeholder-black:focus::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.md\\:focus\\:placeholder-gray-50:focus::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.md\\:focus\\:placeholder-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.md\\:focus\\:placeholder-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.md\\:focus\\:placeholder-gray-300:focus::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.md\\:focus\\:placeholder-gray-400:focus::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.md\\:focus\\:placeholder-gray-500:focus::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.md\\:focus\\:placeholder-gray-600:focus::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.md\\:focus\\:placeholder-gray-700:focus::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.md\\:focus\\:placeholder-gray-800:focus::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.md\\:focus\\:placeholder-gray-900:focus::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.md\\:focus\\:placeholder-cool-gray-50:focus::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.md\\:focus\\:placeholder-cool-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.md\\:focus\\:placeholder-cool-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.md\\:focus\\:placeholder-cool-gray-300:focus::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.md\\:focus\\:placeholder-cool-gray-400:focus::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.md\\:focus\\:placeholder-cool-gray-500:focus::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.md\\:focus\\:placeholder-cool-gray-600:focus::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.md\\:focus\\:placeholder-cool-gray-700:focus::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.md\\:focus\\:placeholder-cool-gray-800:focus::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.md\\:focus\\:placeholder-cool-gray-900:focus::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.md\\:focus\\:placeholder-red-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.md\\:focus\\:placeholder-red-100:focus::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.md\\:focus\\:placeholder-red-200:focus::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.md\\:focus\\:placeholder-red-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.md\\:focus\\:placeholder-red-400:focus::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.md\\:focus\\:placeholder-red-500:focus::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.md\\:focus\\:placeholder-red-600:focus::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.md\\:focus\\:placeholder-red-700:focus::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.md\\:focus\\:placeholder-red-800:focus::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.md\\:focus\\:placeholder-red-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.md\\:focus\\:placeholder-orange-50:focus::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.md\\:focus\\:placeholder-orange-100:focus::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.md\\:focus\\:placeholder-orange-200:focus::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.md\\:focus\\:placeholder-orange-300:focus::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.md\\:focus\\:placeholder-orange-400:focus::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.md\\:focus\\:placeholder-orange-500:focus::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.md\\:focus\\:placeholder-orange-600:focus::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.md\\:focus\\:placeholder-orange-700:focus::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.md\\:focus\\:placeholder-orange-800:focus::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.md\\:focus\\:placeholder-orange-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.md\\:focus\\:placeholder-yellow-50:focus::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.md\\:focus\\:placeholder-yellow-100:focus::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.md\\:focus\\:placeholder-yellow-200:focus::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.md\\:focus\\:placeholder-yellow-300:focus::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.md\\:focus\\:placeholder-yellow-400:focus::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.md\\:focus\\:placeholder-yellow-500:focus::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.md\\:focus\\:placeholder-yellow-600:focus::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.md\\:focus\\:placeholder-yellow-700:focus::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.md\\:focus\\:placeholder-yellow-800:focus::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.md\\:focus\\:placeholder-yellow-900:focus::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.md\\:focus\\:placeholder-green-50:focus::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.md\\:focus\\:placeholder-green-100:focus::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.md\\:focus\\:placeholder-green-200:focus::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.md\\:focus\\:placeholder-green-300:focus::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.md\\:focus\\:placeholder-green-400:focus::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.md\\:focus\\:placeholder-green-500:focus::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.md\\:focus\\:placeholder-green-600:focus::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.md\\:focus\\:placeholder-green-700:focus::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.md\\:focus\\:placeholder-green-800:focus::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.md\\:focus\\:placeholder-green-900:focus::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.md\\:focus\\:placeholder-teal-50:focus::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.md\\:focus\\:placeholder-teal-100:focus::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.md\\:focus\\:placeholder-teal-200:focus::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.md\\:focus\\:placeholder-teal-300:focus::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.md\\:focus\\:placeholder-teal-400:focus::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.md\\:focus\\:placeholder-teal-500:focus::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.md\\:focus\\:placeholder-teal-600:focus::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.md\\:focus\\:placeholder-teal-700:focus::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.md\\:focus\\:placeholder-teal-800:focus::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.md\\:focus\\:placeholder-teal-900:focus::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.md\\:focus\\:placeholder-blue-50:focus::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.md\\:focus\\:placeholder-blue-100:focus::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.md\\:focus\\:placeholder-blue-200:focus::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.md\\:focus\\:placeholder-blue-300:focus::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.md\\:focus\\:placeholder-blue-400:focus::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.md\\:focus\\:placeholder-blue-500:focus::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.md\\:focus\\:placeholder-blue-600:focus::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.md\\:focus\\:placeholder-blue-700:focus::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.md\\:focus\\:placeholder-blue-800:focus::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.md\\:focus\\:placeholder-blue-900:focus::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.md\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.md\\:focus\\:placeholder-pink-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.md\\:focus\\:placeholder-pink-100:focus::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.md\\:focus\\:placeholder-pink-200:focus::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.md\\:focus\\:placeholder-pink-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.md\\:focus\\:placeholder-pink-400:focus::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.md\\:focus\\:placeholder-pink-500:focus::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.md\\:focus\\:placeholder-pink-600:focus::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.md\\:focus\\:placeholder-pink-700:focus::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.md\\:focus\\:placeholder-pink-800:focus::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.md\\:focus\\:placeholder-pink-900:focus::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-transparent::placeholder{color:#0000}.theme-dark .md\\:dark\\:placeholder-white::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-black::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-gray-50::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-gray-100::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-gray-200::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-gray-300::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-gray-400::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-gray-500::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-gray-600::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-gray-700::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-gray-800::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-gray-900::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-cool-gray-50::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-cool-gray-100::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-cool-gray-200::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-cool-gray-300::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-cool-gray-400::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-cool-gray-500::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-cool-gray-600::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-cool-gray-700::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-cool-gray-800::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-cool-gray-900::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-red-50::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-red-100::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-red-200::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-red-300::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-red-400::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-red-500::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-red-600::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-red-700::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-red-800::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-red-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-orange-50::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-orange-100::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-orange-200::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-orange-300::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-orange-400::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-orange-500::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-orange-600::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-orange-700::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-orange-800::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-orange-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-yellow-50::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-yellow-100::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-yellow-200::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-yellow-300::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-yellow-400::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-yellow-500::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-yellow-600::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-yellow-700::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-yellow-800::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-yellow-900::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-green-50::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-green-100::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-green-200::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-green-300::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-green-400::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-green-500::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-green-600::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-green-700::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-green-800::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-green-900::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-teal-50::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-teal-100::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-teal-200::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-teal-300::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-teal-400::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-teal-500::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-teal-600::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-teal-700::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-teal-800::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-teal-900::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-blue-50::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-blue-100::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-blue-200::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-blue-300::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-blue-400::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-blue-500::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-blue-600::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-blue-700::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-blue-800::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-blue-900::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-pink-50::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-pink-100::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-pink-200::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-pink-300::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-pink-400::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-pink-500::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-pink-600::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-pink-700::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-pink-800::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:placeholder-pink-900::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-transparent:focus::placeholder{color:#0000}.theme-dark .md\\:dark\\:focus\\:placeholder-white:focus::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-black:focus::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-gray-50:focus::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-gray-300:focus::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-gray-400:focus::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-gray-500:focus::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-gray-600:focus::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-gray-700:focus::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-gray-800:focus::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-gray-900:focus::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-50:focus::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-300:focus::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-400:focus::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-500:focus::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-600:focus::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-700:focus::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-800:focus::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-cool-gray-900:focus::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-red-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-red-100:focus::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-red-200:focus::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-red-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-red-400:focus::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-red-500:focus::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-red-600:focus::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-red-700:focus::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-red-800:focus::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-red-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-orange-50:focus::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-orange-100:focus::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-orange-200:focus::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-orange-300:focus::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-orange-400:focus::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-orange-500:focus::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-orange-600:focus::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-orange-700:focus::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-orange-800:focus::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-orange-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-yellow-50:focus::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-yellow-100:focus::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-yellow-200:focus::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-yellow-300:focus::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-yellow-400:focus::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-yellow-500:focus::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-yellow-600:focus::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-yellow-700:focus::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-yellow-800:focus::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-yellow-900:focus::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-green-50:focus::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-green-100:focus::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-green-200:focus::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-green-300:focus::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-green-400:focus::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-green-500:focus::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-green-600:focus::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-green-700:focus::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-green-800:focus::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-green-900:focus::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-teal-50:focus::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-teal-100:focus::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-teal-200:focus::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-teal-300:focus::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-teal-400:focus::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-teal-500:focus::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-teal-600:focus::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-teal-700:focus::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-teal-800:focus::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-teal-900:focus::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-blue-50:focus::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-blue-100:focus::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-blue-200:focus::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-blue-300:focus::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-blue-400:focus::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-blue-500:focus::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-blue-600:focus::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-blue-700:focus::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-blue-800:focus::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-blue-900:focus::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-pink-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-pink-100:focus::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-pink-200:focus::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-pink-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-pink-400:focus::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-pink-500:focus::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-pink-600:focus::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-pink-700:focus::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-pink-800:focus::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.theme-dark .md\\:dark\\:focus\\:placeholder-pink-900:focus::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.md\\:placeholder-opacity-0::placeholder{--placeholder-opacity:0}.md\\:placeholder-opacity-25::placeholder{--placeholder-opacity:0.25}.md\\:placeholder-opacity-50::placeholder{--placeholder-opacity:0.5}.md\\:placeholder-opacity-75::placeholder{--placeholder-opacity:0.75}.md\\:placeholder-opacity-100::placeholder{--placeholder-opacity:1}.md\\:focus\\:placeholder-opacity-0:focus::placeholder{--placeholder-opacity:0}.md\\:focus\\:placeholder-opacity-25:focus::placeholder{--placeholder-opacity:0.25}.md\\:focus\\:placeholder-opacity-50:focus::placeholder{--placeholder-opacity:0.5}.md\\:focus\\:placeholder-opacity-75:focus::placeholder{--placeholder-opacity:0.75}.md\\:focus\\:placeholder-opacity-100:focus::placeholder{--placeholder-opacity:1}.md\\:pointer-events-none{pointer-events:none}.md\\:pointer-events-auto{pointer-events:auto}.md\\:static{position:static}.md\\:fixed{position:fixed}.md\\:absolute{position:absolute}.md\\:relative{position:relative}.md\\:sticky{position:-webkit-sticky;position:sticky}.md\\:inset-0{bottom:0;left:0;right:0;top:0}.md\\:inset-auto{bottom:auto;left:auto;right:auto;top:auto}.md\\:inset-y-0{bottom:0;top:0}.md\\:inset-x-0{left:0;right:0}.md\\:inset-y-auto{bottom:auto;top:auto}.md\\:inset-x-auto{left:auto;right:auto}.md\\:top-0{top:0}.md\\:right-0{right:0}.md\\:bottom-0{bottom:0}.md\\:left-0{left:0}.md\\:top-auto{top:auto}.md\\:right-auto{right:auto}.md\\:bottom-auto{bottom:auto}.md\\:left-auto{left:auto}.md\\:resize-none{resize:none}.md\\:resize-y{resize:vertical}.md\\:resize-x{resize:horizontal}.md\\:resize{resize:both}.md\\:shadow-xs{box-shadow:0 0 0 1px #0000000d}.md\\:shadow-sm{box-shadow:0 1px 2px 0 #0000000d}.md\\:shadow{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.md\\:shadow-md{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.md\\:shadow-lg{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.md\\:shadow-xl{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.md\\:shadow-2xl{box-shadow:0 25px 50px -12px #00000040}.md\\:shadow-inner{box-shadow:inset 0 2px 4px 0 #0000000f}.md\\:shadow-outline{box-shadow:0 0 0 3px #4299e180}.md\\:shadow-none{box-shadow:none}.md\\:shadow-bottom{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.md\\:hover\\:shadow-xs:hover{box-shadow:0 0 0 1px #0000000d}.md\\:hover\\:shadow-sm:hover{box-shadow:0 1px 2px 0 #0000000d}.md\\:hover\\:shadow:hover{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.md\\:hover\\:shadow-md:hover{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.md\\:hover\\:shadow-lg:hover{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.md\\:hover\\:shadow-xl:hover{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.md\\:hover\\:shadow-2xl:hover{box-shadow:0 25px 50px -12px #00000040}.md\\:hover\\:shadow-inner:hover{box-shadow:inset 0 2px 4px 0 #0000000f}.md\\:hover\\:shadow-outline:hover{box-shadow:0 0 0 3px #4299e180}.md\\:hover\\:shadow-none:hover{box-shadow:none}.md\\:hover\\:shadow-bottom:hover{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.md\\:focus\\:shadow-xs:focus{box-shadow:0 0 0 1px #0000000d}.md\\:focus\\:shadow-sm:focus{box-shadow:0 1px 2px 0 #0000000d}.md\\:focus\\:shadow:focus{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.md\\:focus\\:shadow-md:focus{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.md\\:focus\\:shadow-lg:focus{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.md\\:focus\\:shadow-xl:focus{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.md\\:focus\\:shadow-2xl:focus{box-shadow:0 25px 50px -12px #00000040}.md\\:focus\\:shadow-inner:focus{box-shadow:inset 0 2px 4px 0 #0000000f}.md\\:focus\\:shadow-outline:focus{box-shadow:0 0 0 3px #4299e180}.md\\:focus\\:shadow-none:focus{box-shadow:none}.md\\:focus\\:shadow-bottom:focus{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.theme-dark .md\\:dark\\:focus\\:shadow-xs:focus{box-shadow:0 0 0 1px #0000000d}.theme-dark .md\\:dark\\:focus\\:shadow-sm:focus{box-shadow:0 1px 2px 0 #0000000d}.theme-dark .md\\:dark\\:focus\\:shadow:focus{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.theme-dark .md\\:dark\\:focus\\:shadow-md:focus{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.theme-dark .md\\:dark\\:focus\\:shadow-lg:focus{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.theme-dark .md\\:dark\\:focus\\:shadow-xl:focus{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.theme-dark .md\\:dark\\:focus\\:shadow-2xl:focus{box-shadow:0 25px 50px -12px #00000040}.theme-dark .md\\:dark\\:focus\\:shadow-inner:focus{box-shadow:inset 0 2px 4px 0 #0000000f}.theme-dark .md\\:dark\\:focus\\:shadow-outline:focus{box-shadow:0 0 0 3px #4299e180}.theme-dark .md\\:dark\\:focus\\:shadow-none:focus{box-shadow:none}.theme-dark .md\\:dark\\:focus\\:shadow-bottom:focus{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.md\\:fill-current{fill:currentColor}.md\\:stroke-current{stroke:currentColor}.md\\:stroke-0{stroke-width:0}.md\\:stroke-1{stroke-width:1}.md\\:stroke-2{stroke-width:2}.md\\:table-auto{table-layout:auto}.md\\:table-fixed{table-layout:fixed}.md\\:text-left{text-align:left}.md\\:text-center{text-align:center}.md\\:text-right{text-align:right}.md\\:text-justify{text-align:justify}.md\\:text-transparent{color:#0000}.md\\:text-white{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.md\\:text-black{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.md\\:text-gray-50{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.md\\:text-gray-100{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.md\\:text-gray-200{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.md\\:text-gray-300{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.md\\:text-gray-400{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.md\\:text-gray-500{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.md\\:text-gray-600{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.md\\:text-gray-700{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.md\\:text-gray-800{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.md\\:text-gray-900{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.md\\:text-cool-gray-50{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.md\\:text-cool-gray-100{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.md\\:text-cool-gray-200{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.md\\:text-cool-gray-300{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.md\\:text-cool-gray-400{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.md\\:text-cool-gray-500{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.md\\:text-cool-gray-600{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.md\\:text-cool-gray-700{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.md\\:text-cool-gray-800{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.md\\:text-cool-gray-900{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.md\\:text-red-50{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.md\\:text-red-100{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.md\\:text-red-200{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.md\\:text-red-300{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.md\\:text-red-400{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.md\\:text-red-500{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.md\\:text-red-600{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.md\\:text-red-700{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.md\\:text-red-800{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.md\\:text-red-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.md\\:text-orange-50{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.md\\:text-orange-100{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.md\\:text-orange-200{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.md\\:text-orange-300{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.md\\:text-orange-400{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.md\\:text-orange-500{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.md\\:text-orange-600{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.md\\:text-orange-700{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.md\\:text-orange-800{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.md\\:text-orange-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.md\\:text-yellow-50{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.md\\:text-yellow-100{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.md\\:text-yellow-200{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.md\\:text-yellow-300{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.md\\:text-yellow-400{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.md\\:text-yellow-500{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.md\\:text-yellow-600{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.md\\:text-yellow-700{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.md\\:text-yellow-800{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.md\\:text-yellow-900{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.md\\:text-green-50{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.md\\:text-green-100{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.md\\:text-green-200{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.md\\:text-green-300{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.md\\:text-green-400{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.md\\:text-green-500{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.md\\:text-green-600{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.md\\:text-green-700{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.md\\:text-green-800{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.md\\:text-green-900{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.md\\:text-teal-50{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.md\\:text-teal-100{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.md\\:text-teal-200{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.md\\:text-teal-300{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.md\\:text-teal-400{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.md\\:text-teal-500{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.md\\:text-teal-600{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.md\\:text-teal-700{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.md\\:text-teal-800{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.md\\:text-teal-900{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.md\\:text-blue-50{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.md\\:text-blue-100{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.md\\:text-blue-200{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.md\\:text-blue-300{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.md\\:text-blue-400{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.md\\:text-blue-500{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.md\\:text-blue-600{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.md\\:text-blue-700{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.md\\:text-blue-800{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.md\\:text-blue-900{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.md\\:text-indigo-50{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.md\\:text-indigo-100{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.md\\:text-indigo-200{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.md\\:text-indigo-300{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.md\\:text-indigo-400{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.md\\:text-indigo-500{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.md\\:text-indigo-600{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.md\\:text-indigo-700{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.md\\:text-indigo-800{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.md\\:text-indigo-900{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.md\\:text-indigo-50{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.md\\:text-indigo-100{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.md\\:text-indigo-200{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.md\\:text-indigo-300{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.md\\:text-indigo-400{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.md\\:text-indigo-500{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.md\\:text-indigo-600{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.md\\:text-indigo-700{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.md\\:text-indigo-800{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.md\\:text-indigo-900{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.md\\:text-pink-50{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.md\\:text-pink-100{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.md\\:text-pink-200{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.md\\:text-pink-300{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.md\\:text-pink-400{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.md\\:text-pink-500{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.md\\:text-pink-600{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.md\\:text-pink-700{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.md\\:text-pink-800{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.md\\:text-pink-900{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.md\\:focus\\:text-transparent:focus{color:#0000}.md\\:focus\\:text-white:focus{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.md\\:focus\\:text-black:focus{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.md\\:focus\\:text-gray-50:focus{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.md\\:focus\\:text-gray-100:focus{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.md\\:focus\\:text-gray-200:focus{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.md\\:focus\\:text-gray-300:focus{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.md\\:focus\\:text-gray-400:focus{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.md\\:focus\\:text-gray-500:focus{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.md\\:focus\\:text-gray-600:focus{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.md\\:focus\\:text-gray-700:focus{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.md\\:focus\\:text-gray-800:focus{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.md\\:focus\\:text-gray-900:focus{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.md\\:focus\\:text-cool-gray-50:focus{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.md\\:focus\\:text-cool-gray-100:focus{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.md\\:focus\\:text-cool-gray-200:focus{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.md\\:focus\\:text-cool-gray-300:focus{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.md\\:focus\\:text-cool-gray-400:focus{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.md\\:focus\\:text-cool-gray-500:focus{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.md\\:focus\\:text-cool-gray-600:focus{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.md\\:focus\\:text-cool-gray-700:focus{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.md\\:focus\\:text-cool-gray-800:focus{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.md\\:focus\\:text-cool-gray-900:focus{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.md\\:focus\\:text-red-50:focus{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.md\\:focus\\:text-red-100:focus{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.md\\:focus\\:text-red-200:focus{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.md\\:focus\\:text-red-300:focus{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.md\\:focus\\:text-red-400:focus{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.md\\:focus\\:text-red-500:focus{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.md\\:focus\\:text-red-600:focus{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.md\\:focus\\:text-red-700:focus{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.md\\:focus\\:text-red-800:focus{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.md\\:focus\\:text-red-900:focus{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.md\\:focus\\:text-orange-50:focus{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.md\\:focus\\:text-orange-100:focus{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.md\\:focus\\:text-orange-200:focus{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.md\\:focus\\:text-orange-300:focus{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.md\\:focus\\:text-orange-400:focus{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.md\\:focus\\:text-orange-500:focus{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.md\\:focus\\:text-orange-600:focus{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.md\\:focus\\:text-orange-700:focus{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.md\\:focus\\:text-orange-800:focus{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.md\\:focus\\:text-orange-900:focus{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.md\\:focus\\:text-yellow-50:focus{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.md\\:focus\\:text-yellow-100:focus{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.md\\:focus\\:text-yellow-200:focus{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.md\\:focus\\:text-yellow-300:focus{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.md\\:focus\\:text-yellow-400:focus{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.md\\:focus\\:text-yellow-500:focus{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.md\\:focus\\:text-yellow-600:focus{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.md\\:focus\\:text-yellow-700:focus{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.md\\:focus\\:text-yellow-800:focus{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.md\\:focus\\:text-yellow-900:focus{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.md\\:focus\\:text-green-50:focus{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.md\\:focus\\:text-green-100:focus{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.md\\:focus\\:text-green-200:focus{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.md\\:focus\\:text-green-300:focus{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.md\\:focus\\:text-green-400:focus{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.md\\:focus\\:text-green-500:focus{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.md\\:focus\\:text-green-600:focus{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.md\\:focus\\:text-green-700:focus{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.md\\:focus\\:text-green-800:focus{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.md\\:focus\\:text-green-900:focus{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.md\\:focus\\:text-teal-50:focus{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.md\\:focus\\:text-teal-100:focus{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.md\\:focus\\:text-teal-200:focus{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.md\\:focus\\:text-teal-300:focus{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.md\\:focus\\:text-teal-400:focus{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.md\\:focus\\:text-teal-500:focus{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.md\\:focus\\:text-teal-600:focus{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.md\\:focus\\:text-teal-700:focus{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.md\\:focus\\:text-teal-800:focus{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.md\\:focus\\:text-teal-900:focus{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.md\\:focus\\:text-blue-50:focus{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.md\\:focus\\:text-blue-100:focus{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.md\\:focus\\:text-blue-200:focus{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.md\\:focus\\:text-blue-300:focus{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.md\\:focus\\:text-blue-400:focus{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.md\\:focus\\:text-blue-500:focus{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.md\\:focus\\:text-blue-600:focus{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.md\\:focus\\:text-blue-700:focus{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.md\\:focus\\:text-blue-800:focus{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.md\\:focus\\:text-blue-900:focus{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.md\\:focus\\:text-indigo-50:focus{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.md\\:focus\\:text-indigo-100:focus{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.md\\:focus\\:text-indigo-200:focus{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.md\\:focus\\:text-indigo-300:focus{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.md\\:focus\\:text-indigo-400:focus{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.md\\:focus\\:text-indigo-500:focus{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.md\\:focus\\:text-indigo-600:focus{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.md\\:focus\\:text-indigo-700:focus{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.md\\:focus\\:text-indigo-800:focus{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.md\\:focus\\:text-indigo-900:focus{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.md\\:focus\\:text-indigo-50:focus{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.md\\:focus\\:text-indigo-100:focus{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.md\\:focus\\:text-indigo-200:focus{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.md\\:focus\\:text-indigo-300:focus{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.md\\:focus\\:text-indigo-400:focus{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.md\\:focus\\:text-indigo-500:focus{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.md\\:focus\\:text-indigo-600:focus{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.md\\:focus\\:text-indigo-700:focus{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.md\\:focus\\:text-indigo-800:focus{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.md\\:focus\\:text-indigo-900:focus{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.md\\:focus\\:text-pink-50:focus{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.md\\:focus\\:text-pink-100:focus{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.md\\:focus\\:text-pink-200:focus{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.md\\:focus\\:text-pink-300:focus{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.md\\:focus\\:text-pink-400:focus{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.md\\:focus\\:text-pink-500:focus{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.md\\:focus\\:text-pink-600:focus{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.md\\:focus\\:text-pink-700:focus{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.md\\:focus\\:text-pink-800:focus{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.md\\:focus\\:text-pink-900:focus{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.md\\:focus-within\\:text-transparent:focus-within{color:#0000}.md\\:focus-within\\:text-white:focus-within{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.md\\:focus-within\\:text-black:focus-within{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.md\\:focus-within\\:text-gray-50:focus-within{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.md\\:focus-within\\:text-gray-100:focus-within{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.md\\:focus-within\\:text-gray-200:focus-within{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.md\\:focus-within\\:text-gray-300:focus-within{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.md\\:focus-within\\:text-gray-400:focus-within{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.md\\:focus-within\\:text-gray-500:focus-within{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.md\\:focus-within\\:text-gray-600:focus-within{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.md\\:focus-within\\:text-gray-700:focus-within{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.md\\:focus-within\\:text-gray-800:focus-within{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.md\\:focus-within\\:text-gray-900:focus-within{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.md\\:focus-within\\:text-cool-gray-50:focus-within{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.md\\:focus-within\\:text-cool-gray-100:focus-within{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.md\\:focus-within\\:text-cool-gray-200:focus-within{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.md\\:focus-within\\:text-cool-gray-300:focus-within{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.md\\:focus-within\\:text-cool-gray-400:focus-within{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.md\\:focus-within\\:text-cool-gray-500:focus-within{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.md\\:focus-within\\:text-cool-gray-600:focus-within{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.md\\:focus-within\\:text-cool-gray-700:focus-within{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.md\\:focus-within\\:text-cool-gray-800:focus-within{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.md\\:focus-within\\:text-cool-gray-900:focus-within{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.md\\:focus-within\\:text-red-50:focus-within{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.md\\:focus-within\\:text-red-100:focus-within{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.md\\:focus-within\\:text-red-200:focus-within{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.md\\:focus-within\\:text-red-300:focus-within{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.md\\:focus-within\\:text-red-400:focus-within{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.md\\:focus-within\\:text-red-500:focus-within{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.md\\:focus-within\\:text-red-600:focus-within{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.md\\:focus-within\\:text-red-700:focus-within{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.md\\:focus-within\\:text-red-800:focus-within{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.md\\:focus-within\\:text-red-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.md\\:focus-within\\:text-orange-50:focus-within{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.md\\:focus-within\\:text-orange-100:focus-within{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.md\\:focus-within\\:text-orange-200:focus-within{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.md\\:focus-within\\:text-orange-300:focus-within{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.md\\:focus-within\\:text-orange-400:focus-within{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.md\\:focus-within\\:text-orange-500:focus-within{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.md\\:focus-within\\:text-orange-600:focus-within{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.md\\:focus-within\\:text-orange-700:focus-within{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.md\\:focus-within\\:text-orange-800:focus-within{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.md\\:focus-within\\:text-orange-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.md\\:focus-within\\:text-yellow-50:focus-within{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.md\\:focus-within\\:text-yellow-100:focus-within{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.md\\:focus-within\\:text-yellow-200:focus-within{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.md\\:focus-within\\:text-yellow-300:focus-within{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.md\\:focus-within\\:text-yellow-400:focus-within{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.md\\:focus-within\\:text-yellow-500:focus-within{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.md\\:focus-within\\:text-yellow-600:focus-within{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.md\\:focus-within\\:text-yellow-700:focus-within{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.md\\:focus-within\\:text-yellow-800:focus-within{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.md\\:focus-within\\:text-yellow-900:focus-within{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.md\\:focus-within\\:text-green-50:focus-within{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.md\\:focus-within\\:text-green-100:focus-within{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.md\\:focus-within\\:text-green-200:focus-within{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.md\\:focus-within\\:text-green-300:focus-within{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.md\\:focus-within\\:text-green-400:focus-within{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.md\\:focus-within\\:text-green-500:focus-within{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.md\\:focus-within\\:text-green-600:focus-within{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.md\\:focus-within\\:text-green-700:focus-within{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.md\\:focus-within\\:text-green-800:focus-within{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.md\\:focus-within\\:text-green-900:focus-within{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.md\\:focus-within\\:text-teal-50:focus-within{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.md\\:focus-within\\:text-teal-100:focus-within{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.md\\:focus-within\\:text-teal-200:focus-within{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.md\\:focus-within\\:text-teal-300:focus-within{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.md\\:focus-within\\:text-teal-400:focus-within{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.md\\:focus-within\\:text-teal-500:focus-within{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.md\\:focus-within\\:text-teal-600:focus-within{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.md\\:focus-within\\:text-teal-700:focus-within{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.md\\:focus-within\\:text-teal-800:focus-within{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.md\\:focus-within\\:text-teal-900:focus-within{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.md\\:focus-within\\:text-blue-50:focus-within{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.md\\:focus-within\\:text-blue-100:focus-within{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.md\\:focus-within\\:text-blue-200:focus-within{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.md\\:focus-within\\:text-blue-300:focus-within{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.md\\:focus-within\\:text-blue-400:focus-within{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.md\\:focus-within\\:text-blue-500:focus-within{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.md\\:focus-within\\:text-blue-600:focus-within{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.md\\:focus-within\\:text-blue-700:focus-within{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.md\\:focus-within\\:text-blue-800:focus-within{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.md\\:focus-within\\:text-blue-900:focus-within{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.md\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.md\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.md\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.md\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.md\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.md\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.md\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.md\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.md\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.md\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.md\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.md\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.md\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.md\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.md\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.md\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.md\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.md\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.md\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.md\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.md\\:focus-within\\:text-pink-50:focus-within{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.md\\:focus-within\\:text-pink-100:focus-within{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.md\\:focus-within\\:text-pink-200:focus-within{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.md\\:focus-within\\:text-pink-300:focus-within{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.md\\:focus-within\\:text-pink-400:focus-within{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.md\\:focus-within\\:text-pink-500:focus-within{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.md\\:focus-within\\:text-pink-600:focus-within{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.md\\:focus-within\\:text-pink-700:focus-within{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.md\\:focus-within\\:text-pink-800:focus-within{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.md\\:focus-within\\:text-pink-900:focus-within{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.md\\:hover\\:text-transparent:hover{color:#0000}.md\\:hover\\:text-white:hover{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.md\\:hover\\:text-black:hover{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.md\\:hover\\:text-gray-50:hover{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.md\\:hover\\:text-gray-100:hover{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.md\\:hover\\:text-gray-200:hover{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.md\\:hover\\:text-gray-300:hover{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.md\\:hover\\:text-gray-400:hover{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.md\\:hover\\:text-gray-500:hover{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.md\\:hover\\:text-gray-600:hover{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.md\\:hover\\:text-gray-700:hover{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.md\\:hover\\:text-gray-800:hover{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.md\\:hover\\:text-gray-900:hover{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.md\\:hover\\:text-cool-gray-50:hover{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.md\\:hover\\:text-cool-gray-100:hover{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.md\\:hover\\:text-cool-gray-200:hover{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.md\\:hover\\:text-cool-gray-300:hover{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.md\\:hover\\:text-cool-gray-400:hover{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.md\\:hover\\:text-cool-gray-500:hover{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.md\\:hover\\:text-cool-gray-600:hover{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.md\\:hover\\:text-cool-gray-700:hover{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.md\\:hover\\:text-cool-gray-800:hover{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.md\\:hover\\:text-cool-gray-900:hover{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.md\\:hover\\:text-red-50:hover{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.md\\:hover\\:text-red-100:hover{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.md\\:hover\\:text-red-200:hover{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.md\\:hover\\:text-red-300:hover{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.md\\:hover\\:text-red-400:hover{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.md\\:hover\\:text-red-500:hover{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.md\\:hover\\:text-red-600:hover{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.md\\:hover\\:text-red-700:hover{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.md\\:hover\\:text-red-800:hover{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.md\\:hover\\:text-red-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.md\\:hover\\:text-orange-50:hover{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.md\\:hover\\:text-orange-100:hover{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.md\\:hover\\:text-orange-200:hover{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.md\\:hover\\:text-orange-300:hover{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.md\\:hover\\:text-orange-400:hover{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.md\\:hover\\:text-orange-500:hover{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.md\\:hover\\:text-orange-600:hover{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.md\\:hover\\:text-orange-700:hover{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.md\\:hover\\:text-orange-800:hover{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.md\\:hover\\:text-orange-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.md\\:hover\\:text-yellow-50:hover{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.md\\:hover\\:text-yellow-100:hover{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.md\\:hover\\:text-yellow-200:hover{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.md\\:hover\\:text-yellow-300:hover{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.md\\:hover\\:text-yellow-400:hover{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.md\\:hover\\:text-yellow-500:hover{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.md\\:hover\\:text-yellow-600:hover{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.md\\:hover\\:text-yellow-700:hover{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.md\\:hover\\:text-yellow-800:hover{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.md\\:hover\\:text-yellow-900:hover{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.md\\:hover\\:text-green-50:hover{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.md\\:hover\\:text-green-100:hover{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.md\\:hover\\:text-green-200:hover{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.md\\:hover\\:text-green-300:hover{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.md\\:hover\\:text-green-400:hover{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.md\\:hover\\:text-green-500:hover{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.md\\:hover\\:text-green-600:hover{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.md\\:hover\\:text-green-700:hover{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.md\\:hover\\:text-green-800:hover{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.md\\:hover\\:text-green-900:hover{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.md\\:hover\\:text-teal-50:hover{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.md\\:hover\\:text-teal-100:hover{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.md\\:hover\\:text-teal-200:hover{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.md\\:hover\\:text-teal-300:hover{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.md\\:hover\\:text-teal-400:hover{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.md\\:hover\\:text-teal-500:hover{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.md\\:hover\\:text-teal-600:hover{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.md\\:hover\\:text-teal-700:hover{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.md\\:hover\\:text-teal-800:hover{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.md\\:hover\\:text-teal-900:hover{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.md\\:hover\\:text-blue-50:hover{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.md\\:hover\\:text-blue-100:hover{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.md\\:hover\\:text-blue-200:hover{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.md\\:hover\\:text-blue-300:hover{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.md\\:hover\\:text-blue-400:hover{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.md\\:hover\\:text-blue-500:hover{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.md\\:hover\\:text-blue-600:hover{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.md\\:hover\\:text-blue-700:hover{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.md\\:hover\\:text-blue-800:hover{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.md\\:hover\\:text-blue-900:hover{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.md\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.md\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.md\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.md\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.md\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.md\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.md\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.md\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.md\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.md\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.md\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.md\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.md\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.md\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.md\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.md\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.md\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.md\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.md\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.md\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.md\\:hover\\:text-pink-50:hover{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.md\\:hover\\:text-pink-100:hover{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.md\\:hover\\:text-pink-200:hover{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.md\\:hover\\:text-pink-300:hover{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.md\\:hover\\:text-pink-400:hover{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.md\\:hover\\:text-pink-500:hover{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.md\\:hover\\:text-pink-600:hover{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.md\\:hover\\:text-pink-700:hover{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.md\\:hover\\:text-pink-800:hover{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.md\\:hover\\:text-pink-900:hover{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.md\\:active\\:text-transparent:active{color:#0000}.md\\:active\\:text-white:active{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.md\\:active\\:text-black:active{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.md\\:active\\:text-gray-50:active{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.md\\:active\\:text-gray-100:active{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.md\\:active\\:text-gray-200:active{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.md\\:active\\:text-gray-300:active{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.md\\:active\\:text-gray-400:active{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.md\\:active\\:text-gray-500:active{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.md\\:active\\:text-gray-600:active{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.md\\:active\\:text-gray-700:active{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.md\\:active\\:text-gray-800:active{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.md\\:active\\:text-gray-900:active{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.md\\:active\\:text-cool-gray-50:active{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.md\\:active\\:text-cool-gray-100:active{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.md\\:active\\:text-cool-gray-200:active{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.md\\:active\\:text-cool-gray-300:active{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.md\\:active\\:text-cool-gray-400:active{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.md\\:active\\:text-cool-gray-500:active{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.md\\:active\\:text-cool-gray-600:active{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.md\\:active\\:text-cool-gray-700:active{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.md\\:active\\:text-cool-gray-800:active{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.md\\:active\\:text-cool-gray-900:active{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.md\\:active\\:text-red-50:active{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.md\\:active\\:text-red-100:active{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.md\\:active\\:text-red-200:active{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.md\\:active\\:text-red-300:active{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.md\\:active\\:text-red-400:active{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.md\\:active\\:text-red-500:active{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.md\\:active\\:text-red-600:active{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.md\\:active\\:text-red-700:active{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.md\\:active\\:text-red-800:active{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.md\\:active\\:text-red-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.md\\:active\\:text-orange-50:active{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.md\\:active\\:text-orange-100:active{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.md\\:active\\:text-orange-200:active{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.md\\:active\\:text-orange-300:active{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.md\\:active\\:text-orange-400:active{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.md\\:active\\:text-orange-500:active{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.md\\:active\\:text-orange-600:active{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.md\\:active\\:text-orange-700:active{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.md\\:active\\:text-orange-800:active{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.md\\:active\\:text-orange-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.md\\:active\\:text-yellow-50:active{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.md\\:active\\:text-yellow-100:active{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.md\\:active\\:text-yellow-200:active{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.md\\:active\\:text-yellow-300:active{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.md\\:active\\:text-yellow-400:active{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.md\\:active\\:text-yellow-500:active{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.md\\:active\\:text-yellow-600:active{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.md\\:active\\:text-yellow-700:active{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.md\\:active\\:text-yellow-800:active{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.md\\:active\\:text-yellow-900:active{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.md\\:active\\:text-green-50:active{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.md\\:active\\:text-green-100:active{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.md\\:active\\:text-green-200:active{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.md\\:active\\:text-green-300:active{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.md\\:active\\:text-green-400:active{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.md\\:active\\:text-green-500:active{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.md\\:active\\:text-green-600:active{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.md\\:active\\:text-green-700:active{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.md\\:active\\:text-green-800:active{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.md\\:active\\:text-green-900:active{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.md\\:active\\:text-teal-50:active{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.md\\:active\\:text-teal-100:active{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.md\\:active\\:text-teal-200:active{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.md\\:active\\:text-teal-300:active{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.md\\:active\\:text-teal-400:active{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.md\\:active\\:text-teal-500:active{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.md\\:active\\:text-teal-600:active{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.md\\:active\\:text-teal-700:active{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.md\\:active\\:text-teal-800:active{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.md\\:active\\:text-teal-900:active{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.md\\:active\\:text-blue-50:active{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.md\\:active\\:text-blue-100:active{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.md\\:active\\:text-blue-200:active{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.md\\:active\\:text-blue-300:active{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.md\\:active\\:text-blue-400:active{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.md\\:active\\:text-blue-500:active{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.md\\:active\\:text-blue-600:active{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.md\\:active\\:text-blue-700:active{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.md\\:active\\:text-blue-800:active{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.md\\:active\\:text-blue-900:active{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.md\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.md\\:active\\:text-indigo-100:active{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.md\\:active\\:text-indigo-200:active{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.md\\:active\\:text-indigo-300:active{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.md\\:active\\:text-indigo-400:active{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.md\\:active\\:text-indigo-500:active{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.md\\:active\\:text-indigo-600:active{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.md\\:active\\:text-indigo-700:active{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.md\\:active\\:text-indigo-800:active{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.md\\:active\\:text-indigo-900:active{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.md\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.md\\:active\\:text-indigo-100:active{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.md\\:active\\:text-indigo-200:active{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.md\\:active\\:text-indigo-300:active{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.md\\:active\\:text-indigo-400:active{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.md\\:active\\:text-indigo-500:active{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.md\\:active\\:text-indigo-600:active{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.md\\:active\\:text-indigo-700:active{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.md\\:active\\:text-indigo-800:active{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.md\\:active\\:text-indigo-900:active{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.md\\:active\\:text-pink-50:active{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.md\\:active\\:text-pink-100:active{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.md\\:active\\:text-pink-200:active{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.md\\:active\\:text-pink-300:active{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.md\\:active\\:text-pink-400:active{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.md\\:active\\:text-pink-500:active{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.md\\:active\\:text-pink-600:active{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.md\\:active\\:text-pink-700:active{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.md\\:active\\:text-pink-800:active{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.md\\:active\\:text-pink-900:active{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .md\\:dark\\:text-transparent{color:#0000}.theme-dark .md\\:dark\\:text-white{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .md\\:dark\\:text-black{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .md\\:dark\\:text-gray-50{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .md\\:dark\\:text-gray-100{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .md\\:dark\\:text-gray-200{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .md\\:dark\\:text-gray-300{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .md\\:dark\\:text-gray-400{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .md\\:dark\\:text-gray-500{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .md\\:dark\\:text-gray-600{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .md\\:dark\\:text-gray-700{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .md\\:dark\\:text-gray-800{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .md\\:dark\\:text-gray-900{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .md\\:dark\\:text-cool-gray-50{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .md\\:dark\\:text-cool-gray-100{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .md\\:dark\\:text-cool-gray-200{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .md\\:dark\\:text-cool-gray-300{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .md\\:dark\\:text-cool-gray-400{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .md\\:dark\\:text-cool-gray-500{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .md\\:dark\\:text-cool-gray-600{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .md\\:dark\\:text-cool-gray-700{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .md\\:dark\\:text-cool-gray-800{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .md\\:dark\\:text-cool-gray-900{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .md\\:dark\\:text-red-50{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .md\\:dark\\:text-red-100{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .md\\:dark\\:text-red-200{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .md\\:dark\\:text-red-300{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .md\\:dark\\:text-red-400{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .md\\:dark\\:text-red-500{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .md\\:dark\\:text-red-600{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .md\\:dark\\:text-red-700{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .md\\:dark\\:text-red-800{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .md\\:dark\\:text-red-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .md\\:dark\\:text-orange-50{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .md\\:dark\\:text-orange-100{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .md\\:dark\\:text-orange-200{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .md\\:dark\\:text-orange-300{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .md\\:dark\\:text-orange-400{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .md\\:dark\\:text-orange-500{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .md\\:dark\\:text-orange-600{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .md\\:dark\\:text-orange-700{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .md\\:dark\\:text-orange-800{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .md\\:dark\\:text-orange-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .md\\:dark\\:text-yellow-50{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .md\\:dark\\:text-yellow-100{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .md\\:dark\\:text-yellow-200{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .md\\:dark\\:text-yellow-300{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .md\\:dark\\:text-yellow-400{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .md\\:dark\\:text-yellow-500{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .md\\:dark\\:text-yellow-600{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .md\\:dark\\:text-yellow-700{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .md\\:dark\\:text-yellow-800{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .md\\:dark\\:text-yellow-900{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .md\\:dark\\:text-green-50{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .md\\:dark\\:text-green-100{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .md\\:dark\\:text-green-200{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .md\\:dark\\:text-green-300{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .md\\:dark\\:text-green-400{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .md\\:dark\\:text-green-500{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .md\\:dark\\:text-green-600{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .md\\:dark\\:text-green-700{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .md\\:dark\\:text-green-800{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .md\\:dark\\:text-green-900{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .md\\:dark\\:text-teal-50{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .md\\:dark\\:text-teal-100{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .md\\:dark\\:text-teal-200{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .md\\:dark\\:text-teal-300{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .md\\:dark\\:text-teal-400{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .md\\:dark\\:text-teal-500{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .md\\:dark\\:text-teal-600{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .md\\:dark\\:text-teal-700{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .md\\:dark\\:text-teal-800{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .md\\:dark\\:text-teal-900{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .md\\:dark\\:text-blue-50{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .md\\:dark\\:text-blue-100{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .md\\:dark\\:text-blue-200{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .md\\:dark\\:text-blue-300{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .md\\:dark\\:text-blue-400{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .md\\:dark\\:text-blue-500{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .md\\:dark\\:text-blue-600{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .md\\:dark\\:text-blue-700{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .md\\:dark\\:text-blue-800{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .md\\:dark\\:text-blue-900{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-50{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-100{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-200{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-300{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-400{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-500{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-600{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-700{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-800{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-900{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-50{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-100{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-200{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-300{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-400{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-500{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-600{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-700{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-800{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .md\\:dark\\:text-indigo-900{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .md\\:dark\\:text-pink-50{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .md\\:dark\\:text-pink-100{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .md\\:dark\\:text-pink-200{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .md\\:dark\\:text-pink-300{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .md\\:dark\\:text-pink-400{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .md\\:dark\\:text-pink-500{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .md\\:dark\\:text-pink-600{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .md\\:dark\\:text-pink-700{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .md\\:dark\\:text-pink-800{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .md\\:dark\\:text-pink-900{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-transparent:focus-within{color:#0000}.theme-dark .md\\:dark\\:focus-within\\:text-white:focus-within{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-black:focus-within{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-gray-50:focus-within{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-gray-100:focus-within{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-gray-200:focus-within{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-gray-300:focus-within{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-gray-400:focus-within{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-gray-500:focus-within{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-gray-600:focus-within{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-gray-700:focus-within{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-gray-800:focus-within{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-gray-900:focus-within{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-50:focus-within{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-100:focus-within{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-200:focus-within{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-300:focus-within{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-400:focus-within{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-500:focus-within{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-600:focus-within{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-700:focus-within{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-800:focus-within{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-cool-gray-900:focus-within{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-red-50:focus-within{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-red-100:focus-within{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-red-200:focus-within{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-red-300:focus-within{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-red-400:focus-within{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-red-500:focus-within{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-red-600:focus-within{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-red-700:focus-within{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-red-800:focus-within{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-red-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-orange-50:focus-within{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-orange-100:focus-within{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-orange-200:focus-within{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-orange-300:focus-within{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-orange-400:focus-within{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-orange-500:focus-within{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-orange-600:focus-within{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-orange-700:focus-within{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-orange-800:focus-within{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-orange-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-yellow-50:focus-within{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-yellow-100:focus-within{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-yellow-200:focus-within{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-yellow-300:focus-within{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-yellow-400:focus-within{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-yellow-500:focus-within{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-yellow-600:focus-within{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-yellow-700:focus-within{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-yellow-800:focus-within{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-yellow-900:focus-within{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-green-50:focus-within{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-green-100:focus-within{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-green-200:focus-within{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-green-300:focus-within{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-green-400:focus-within{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-green-500:focus-within{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-green-600:focus-within{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-green-700:focus-within{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-green-800:focus-within{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-green-900:focus-within{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-teal-50:focus-within{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-teal-100:focus-within{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-teal-200:focus-within{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-teal-300:focus-within{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-teal-400:focus-within{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-teal-500:focus-within{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-teal-600:focus-within{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-teal-700:focus-within{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-teal-800:focus-within{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-teal-900:focus-within{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-blue-50:focus-within{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-blue-100:focus-within{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-blue-200:focus-within{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-blue-300:focus-within{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-blue-400:focus-within{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-blue-500:focus-within{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-blue-600:focus-within{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-blue-700:focus-within{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-blue-800:focus-within{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-blue-900:focus-within{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-pink-50:focus-within{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-pink-100:focus-within{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-pink-200:focus-within{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-pink-300:focus-within{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-pink-400:focus-within{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-pink-500:focus-within{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-pink-600:focus-within{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-pink-700:focus-within{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-pink-800:focus-within{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .md\\:dark\\:focus-within\\:text-pink-900:focus-within{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-transparent:hover{color:#0000}.theme-dark .md\\:dark\\:hover\\:text-white:hover{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-black:hover{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-gray-50:hover{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-gray-100:hover{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-gray-200:hover{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-gray-300:hover{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-gray-400:hover{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-gray-500:hover{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-gray-600:hover{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-gray-700:hover{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-gray-800:hover{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-gray-900:hover{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-cool-gray-50:hover{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-cool-gray-100:hover{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-cool-gray-200:hover{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-cool-gray-300:hover{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-cool-gray-400:hover{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-cool-gray-500:hover{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-cool-gray-600:hover{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-cool-gray-700:hover{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-cool-gray-800:hover{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-cool-gray-900:hover{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-red-50:hover{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-red-100:hover{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-red-200:hover{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-red-300:hover{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-red-400:hover{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-red-500:hover{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-red-600:hover{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-red-700:hover{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-red-800:hover{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-red-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-orange-50:hover{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-orange-100:hover{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-orange-200:hover{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-orange-300:hover{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-orange-400:hover{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-orange-500:hover{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-orange-600:hover{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-orange-700:hover{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-orange-800:hover{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-orange-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-yellow-50:hover{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-yellow-100:hover{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-yellow-200:hover{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-yellow-300:hover{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-yellow-400:hover{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-yellow-500:hover{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-yellow-600:hover{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-yellow-700:hover{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-yellow-800:hover{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-yellow-900:hover{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-green-50:hover{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-green-100:hover{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-green-200:hover{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-green-300:hover{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-green-400:hover{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-green-500:hover{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-green-600:hover{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-green-700:hover{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-green-800:hover{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-green-900:hover{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-teal-50:hover{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-teal-100:hover{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-teal-200:hover{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-teal-300:hover{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-teal-400:hover{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-teal-500:hover{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-teal-600:hover{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-teal-700:hover{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-teal-800:hover{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-teal-900:hover{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-blue-50:hover{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-blue-100:hover{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-blue-200:hover{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-blue-300:hover{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-blue-400:hover{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-blue-500:hover{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-blue-600:hover{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-blue-700:hover{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-blue-800:hover{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-blue-900:hover{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-pink-50:hover{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-pink-100:hover{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-pink-200:hover{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-pink-300:hover{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-pink-400:hover{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-pink-500:hover{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-pink-600:hover{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-pink-700:hover{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-pink-800:hover{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .md\\:dark\\:hover\\:text-pink-900:hover{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-transparent:active{color:#0000}.theme-dark .md\\:dark\\:active\\:text-white:active{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-black:active{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-gray-50:active{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-gray-100:active{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-gray-200:active{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-gray-300:active{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-gray-400:active{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-gray-500:active{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-gray-600:active{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-gray-700:active{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-gray-800:active{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-gray-900:active{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-cool-gray-50:active{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-cool-gray-100:active{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-cool-gray-200:active{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-cool-gray-300:active{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-cool-gray-400:active{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-cool-gray-500:active{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-cool-gray-600:active{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-cool-gray-700:active{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-cool-gray-800:active{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-cool-gray-900:active{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-red-50:active{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-red-100:active{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-red-200:active{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-red-300:active{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-red-400:active{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-red-500:active{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-red-600:active{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-red-700:active{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-red-800:active{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-red-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-orange-50:active{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-orange-100:active{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-orange-200:active{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-orange-300:active{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-orange-400:active{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-orange-500:active{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-orange-600:active{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-orange-700:active{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-orange-800:active{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-orange-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-yellow-50:active{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-yellow-100:active{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-yellow-200:active{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-yellow-300:active{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-yellow-400:active{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-yellow-500:active{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-yellow-600:active{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-yellow-700:active{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-yellow-800:active{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-yellow-900:active{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-green-50:active{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-green-100:active{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-green-200:active{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-green-300:active{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-green-400:active{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-green-500:active{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-green-600:active{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-green-700:active{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-green-800:active{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-green-900:active{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-teal-50:active{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-teal-100:active{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-teal-200:active{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-teal-300:active{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-teal-400:active{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-teal-500:active{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-teal-600:active{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-teal-700:active{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-teal-800:active{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-teal-900:active{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-blue-50:active{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-blue-100:active{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-blue-200:active{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-blue-300:active{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-blue-400:active{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-blue-500:active{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-blue-600:active{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-blue-700:active{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-blue-800:active{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-blue-900:active{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-100:active{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-200:active{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-300:active{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-400:active{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-500:active{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-600:active{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-700:active{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-800:active{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-900:active{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-100:active{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-200:active{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-300:active{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-400:active{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-500:active{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-600:active{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-700:active{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-800:active{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-indigo-900:active{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-pink-50:active{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-pink-100:active{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-pink-200:active{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-pink-300:active{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-pink-400:active{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-pink-500:active{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-pink-600:active{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-pink-700:active{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-pink-800:active{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .md\\:dark\\:active\\:text-pink-900:active{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.md\\:text-opacity-0{--text-opacity:0}.md\\:text-opacity-25{--text-opacity:0.25}.md\\:text-opacity-50{--text-opacity:0.5}.md\\:text-opacity-75{--text-opacity:0.75}.md\\:text-opacity-100{--text-opacity:1}.md\\:hover\\:text-opacity-0:hover{--text-opacity:0}.md\\:hover\\:text-opacity-25:hover{--text-opacity:0.25}.md\\:hover\\:text-opacity-50:hover{--text-opacity:0.5}.md\\:hover\\:text-opacity-75:hover{--text-opacity:0.75}.md\\:hover\\:text-opacity-100:hover{--text-opacity:1}.md\\:focus\\:text-opacity-0:focus{--text-opacity:0}.md\\:focus\\:text-opacity-25:focus{--text-opacity:0.25}.md\\:focus\\:text-opacity-50:focus{--text-opacity:0.5}.md\\:focus\\:text-opacity-75:focus{--text-opacity:0.75}.md\\:focus\\:text-opacity-100:focus{--text-opacity:1}.md\\:italic{font-style:italic}.md\\:not-italic{font-style:normal}.md\\:uppercase{text-transform:uppercase}.md\\:lowercase{text-transform:lowercase}.md\\:capitalize{text-transform:capitalize}.md\\:normal-case{text-transform:none}.md\\:underline{-webkit-text-decoration:underline;text-decoration:underline}.md\\:line-through{-webkit-text-decoration:line-through;text-decoration:line-through}.md\\:no-underline{-webkit-text-decoration:none;text-decoration:none}.md\\:hover\\:underline:hover{-webkit-text-decoration:underline;text-decoration:underline}.md\\:hover\\:line-through:hover{-webkit-text-decoration:line-through;text-decoration:line-through}.md\\:hover\\:no-underline:hover{-webkit-text-decoration:none;text-decoration:none}.md\\:focus\\:underline:focus{-webkit-text-decoration:underline;text-decoration:underline}.md\\:focus\\:line-through:focus{-webkit-text-decoration:line-through;text-decoration:line-through}.md\\:focus\\:no-underline:focus{-webkit-text-decoration:none;text-decoration:none}.md\\:antialiased{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.md\\:subpixel-antialiased{-webkit-font-smoothing:auto;-moz-osx-font-smoothing:auto}.md\\:tracking-tighter{letter-spacing:-.05em}.md\\:tracking-tight{letter-spacing:-.025em}.md\\:tracking-normal{letter-spacing:0}.md\\:tracking-wide{letter-spacing:.025em}.md\\:tracking-wider{letter-spacing:.05em}.md\\:tracking-widest{letter-spacing:.1em}.md\\:select-none{-webkit-user-select:none;user-select:none}.md\\:select-text{-webkit-user-select:text;user-select:text}.md\\:select-all{-webkit-user-select:all;user-select:all}.md\\:select-auto{-webkit-user-select:auto;user-select:auto}.md\\:align-baseline{vertical-align:initial}.md\\:align-top{vertical-align:top}.md\\:align-middle{vertical-align:middle}.md\\:align-bottom{vertical-align:bottom}.md\\:align-text-top{vertical-align:text-top}.md\\:align-text-bottom{vertical-align:text-bottom}.md\\:visible{visibility:visible}.md\\:invisible{visibility:hidden}.md\\:whitespace-normal{white-space:normal}.md\\:whitespace-no-wrap{white-space:nowrap}.md\\:whitespace-pre{white-space:pre}.md\\:whitespace-pre-line{white-space:pre-line}.md\\:whitespace-pre-wrap{white-space:pre-wrap}.md\\:break-normal{overflow-wrap:normal;word-break:normal}.md\\:break-words{overflow-wrap:break-word}.md\\:break-all{word-break:break-all}.md\\:truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.md\\:w-0{width:0}.md\\:w-1{width:.25rem}.md\\:w-2{width:.5rem}.md\\:w-3{width:.75rem}.md\\:w-4{width:1rem}.md\\:w-5{width:1.25rem}.md\\:w-6{width:1.5rem}.md\\:w-8{width:2rem}.md\\:w-10{width:2.5rem}.md\\:w-12{width:3rem}.md\\:w-16{width:4rem}.md\\:w-20{width:5rem}.md\\:w-24{width:6rem}.md\\:w-32{width:8rem}.md\\:w-40{width:10rem}.md\\:w-48{width:12rem}.md\\:w-56{width:14rem}.md\\:w-64{width:16rem}.md\\:w-auto{width:auto}.md\\:w-px{width:1px}.md\\:w-1\\/2{width:50%}.md\\:w-1\\/3{width:33.333333%}.md\\:w-2\\/3{width:66.666667%}.md\\:w-1\\/4{width:25%}.md\\:w-2\\/4{width:50%}.md\\:w-3\\/4{width:75%}.md\\:w-1\\/5{width:20%}.md\\:w-2\\/5{width:40%}.md\\:w-3\\/5{width:60%}.md\\:w-4\\/5{width:80%}.md\\:w-1\\/6{width:16.666667%}.md\\:w-2\\/6{width:33.333333%}.md\\:w-3\\/6{width:50%}.md\\:w-4\\/6{width:66.666667%}.md\\:w-5\\/6{width:83.333333%}.md\\:w-1\\/12{width:8.333333%}.md\\:w-2\\/12{width:16.666667%}.md\\:w-3\\/12{width:25%}.md\\:w-4\\/12{width:33.333333%}.md\\:w-5\\/12{width:41.666667%}.md\\:w-6\\/12{width:50%}.md\\:w-7\\/12{width:58.333333%}.md\\:w-8\\/12{width:66.666667%}.md\\:w-9\\/12{width:75%}.md\\:w-10\\/12{width:83.333333%}.md\\:w-11\\/12{width:91.666667%}.md\\:w-full{width:100%}.md\\:w-screen{width:100vw}.md\\:z-0{z-index:0}.md\\:z-10{z-index:10}.md\\:z-20{z-index:20}.md\\:z-30{z-index:30}.md\\:z-40{z-index:40}.md\\:z-50{z-index:50}.md\\:z-auto{z-index:auto}.md\\:gap-0{grid-gap:0;gap:0}.md\\:gap-1{grid-gap:.25rem;gap:.25rem}.md\\:gap-2{grid-gap:.5rem;gap:.5rem}.md\\:gap-3{grid-gap:.75rem;gap:.75rem}.md\\:gap-4{grid-gap:1rem;gap:1rem}.md\\:gap-5{grid-gap:1.25rem;gap:1.25rem}.md\\:gap-6{grid-gap:1.5rem;gap:1.5rem}.md\\:gap-8{grid-gap:2rem;gap:2rem}.md\\:gap-10{grid-gap:2.5rem;gap:2.5rem}.md\\:gap-12{grid-gap:3rem;gap:3rem}.md\\:gap-16{grid-gap:4rem;gap:4rem}.md\\:gap-20{grid-gap:5rem;gap:5rem}.md\\:gap-24{grid-gap:6rem;gap:6rem}.md\\:gap-32{grid-gap:8rem;gap:8rem}.md\\:gap-40{grid-gap:10rem;gap:10rem}.md\\:gap-48{grid-gap:12rem;gap:12rem}.md\\:gap-56{grid-gap:14rem;gap:14rem}.md\\:gap-64{grid-gap:16rem;gap:16rem}.md\\:gap-px{grid-gap:1px;gap:1px}.md\\:col-gap-0{grid-column-gap:0;column-gap:0}.md\\:col-gap-1{grid-column-gap:.25rem;column-gap:.25rem}.md\\:col-gap-2{grid-column-gap:.5rem;column-gap:.5rem}.md\\:col-gap-3{grid-column-gap:.75rem;column-gap:.75rem}.md\\:col-gap-4{grid-column-gap:1rem;column-gap:1rem}.md\\:col-gap-5{grid-column-gap:1.25rem;column-gap:1.25rem}.md\\:col-gap-6{grid-column-gap:1.5rem;column-gap:1.5rem}.md\\:col-gap-8{grid-column-gap:2rem;column-gap:2rem}.md\\:col-gap-10{grid-column-gap:2.5rem;column-gap:2.5rem}.md\\:col-gap-12{grid-column-gap:3rem;column-gap:3rem}.md\\:col-gap-16{grid-column-gap:4rem;column-gap:4rem}.md\\:col-gap-20{grid-column-gap:5rem;column-gap:5rem}.md\\:col-gap-24{grid-column-gap:6rem;column-gap:6rem}.md\\:col-gap-32{grid-column-gap:8rem;column-gap:8rem}.md\\:col-gap-40{grid-column-gap:10rem;column-gap:10rem}.md\\:col-gap-48{grid-column-gap:12rem;column-gap:12rem}.md\\:col-gap-56{grid-column-gap:14rem;column-gap:14rem}.md\\:col-gap-64{grid-column-gap:16rem;column-gap:16rem}.md\\:col-gap-px{grid-column-gap:1px;column-gap:1px}.md\\:row-gap-0{grid-row-gap:0;row-gap:0}.md\\:row-gap-1{grid-row-gap:.25rem;row-gap:.25rem}.md\\:row-gap-2{grid-row-gap:.5rem;row-gap:.5rem}.md\\:row-gap-3{grid-row-gap:.75rem;row-gap:.75rem}.md\\:row-gap-4{grid-row-gap:1rem;row-gap:1rem}.md\\:row-gap-5{grid-row-gap:1.25rem;row-gap:1.25rem}.md\\:row-gap-6{grid-row-gap:1.5rem;row-gap:1.5rem}.md\\:row-gap-8{grid-row-gap:2rem;row-gap:2rem}.md\\:row-gap-10{grid-row-gap:2.5rem;row-gap:2.5rem}.md\\:row-gap-12{grid-row-gap:3rem;row-gap:3rem}.md\\:row-gap-16{grid-row-gap:4rem;row-gap:4rem}.md\\:row-gap-20{grid-row-gap:5rem;row-gap:5rem}.md\\:row-gap-24{grid-row-gap:6rem;row-gap:6rem}.md\\:row-gap-32{grid-row-gap:8rem;row-gap:8rem}.md\\:row-gap-40{grid-row-gap:10rem;row-gap:10rem}.md\\:row-gap-48{grid-row-gap:12rem;row-gap:12rem}.md\\:row-gap-56{grid-row-gap:14rem;row-gap:14rem}.md\\:row-gap-64{grid-row-gap:16rem;row-gap:16rem}.md\\:row-gap-px{grid-row-gap:1px;row-gap:1px}.md\\:grid-flow-row{grid-auto-flow:row}.md\\:grid-flow-col{grid-auto-flow:column}.md\\:grid-flow-row-dense{grid-auto-flow:row dense}.md\\:grid-flow-col-dense{grid-auto-flow:column dense}.md\\:grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.md\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.md\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.md\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.md\\:grid-cols-5{grid-template-columns:repeat(5,minmax(0,1fr))}.md\\:grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.md\\:grid-cols-7{grid-template-columns:repeat(7,minmax(0,1fr))}.md\\:grid-cols-8{grid-template-columns:repeat(8,minmax(0,1fr))}.md\\:grid-cols-9{grid-template-columns:repeat(9,minmax(0,1fr))}.md\\:grid-cols-10{grid-template-columns:repeat(10,minmax(0,1fr))}.md\\:grid-cols-11{grid-template-columns:repeat(11,minmax(0,1fr))}.md\\:grid-cols-12{grid-template-columns:repeat(12,minmax(0,1fr))}.md\\:grid-cols-none{grid-template-columns:none}.md\\:col-auto{grid-column:auto}.md\\:col-span-1{grid-column:span 1/span 1}.md\\:col-span-2{grid-column:span 2/span 2}.md\\:col-span-3{grid-column:span 3/span 3}.md\\:col-span-4{grid-column:span 4/span 4}.md\\:col-span-5{grid-column:span 5/span 5}.md\\:col-span-6{grid-column:span 6/span 6}.md\\:col-span-7{grid-column:span 7/span 7}.md\\:col-span-8{grid-column:span 8/span 8}.md\\:col-span-9{grid-column:span 9/span 9}.md\\:col-span-10{grid-column:span 10/span 10}.md\\:col-span-11{grid-column:span 11/span 11}.md\\:col-span-12{grid-column:span 12/span 12}.md\\:col-start-1{grid-column-start:1}.md\\:col-start-2{grid-column-start:2}.md\\:col-start-3{grid-column-start:3}.md\\:col-start-4{grid-column-start:4}.md\\:col-start-5{grid-column-start:5}.md\\:col-start-6{grid-column-start:6}.md\\:col-start-7{grid-column-start:7}.md\\:col-start-8{grid-column-start:8}.md\\:col-start-9{grid-column-start:9}.md\\:col-start-10{grid-column-start:10}.md\\:col-start-11{grid-column-start:11}.md\\:col-start-12{grid-column-start:12}.md\\:col-start-13{grid-column-start:13}.md\\:col-start-auto{grid-column-start:auto}.md\\:col-end-1{grid-column-end:1}.md\\:col-end-2{grid-column-end:2}.md\\:col-end-3{grid-column-end:3}.md\\:col-end-4{grid-column-end:4}.md\\:col-end-5{grid-column-end:5}.md\\:col-end-6{grid-column-end:6}.md\\:col-end-7{grid-column-end:7}.md\\:col-end-8{grid-column-end:8}.md\\:col-end-9{grid-column-end:9}.md\\:col-end-10{grid-column-end:10}.md\\:col-end-11{grid-column-end:11}.md\\:col-end-12{grid-column-end:12}.md\\:col-end-13{grid-column-end:13}.md\\:col-end-auto{grid-column-end:auto}.md\\:grid-rows-1{grid-template-rows:repeat(1,minmax(0,1fr))}.md\\:grid-rows-2{grid-template-rows:repeat(2,minmax(0,1fr))}.md\\:grid-rows-3{grid-template-rows:repeat(3,minmax(0,1fr))}.md\\:grid-rows-4{grid-template-rows:repeat(4,minmax(0,1fr))}.md\\:grid-rows-5{grid-template-rows:repeat(5,minmax(0,1fr))}.md\\:grid-rows-6{grid-template-rows:repeat(6,minmax(0,1fr))}.md\\:grid-rows-none{grid-template-rows:none}.md\\:row-auto{grid-row:auto}.md\\:row-span-1{grid-row:span 1/span 1}.md\\:row-span-2{grid-row:span 2/span 2}.md\\:row-span-3{grid-row:span 3/span 3}.md\\:row-span-4{grid-row:span 4/span 4}.md\\:row-span-5{grid-row:span 5/span 5}.md\\:row-span-6{grid-row:span 6/span 6}.md\\:row-start-1{grid-row-start:1}.md\\:row-start-2{grid-row-start:2}.md\\:row-start-3{grid-row-start:3}.md\\:row-start-4{grid-row-start:4}.md\\:row-start-5{grid-row-start:5}.md\\:row-start-6{grid-row-start:6}.md\\:row-start-7{grid-row-start:7}.md\\:row-start-auto{grid-row-start:auto}.md\\:row-end-1{grid-row-end:1}.md\\:row-end-2{grid-row-end:2}.md\\:row-end-3{grid-row-end:3}.md\\:row-end-4{grid-row-end:4}.md\\:row-end-5{grid-row-end:5}.md\\:row-end-6{grid-row-end:6}.md\\:row-end-7{grid-row-end:7}.md\\:row-end-auto{grid-row-end:auto}.md\\:transform{--transform-translate-x:0;--transform-translate-y:0;--transform-rotate:0;--transform-skew-x:0;--transform-skew-y:0;--transform-scale-x:1;--transform-scale-y:1;transform:translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y))}.md\\:transform-none{transform:none}.md\\:origin-center{transform-origin:center}.md\\:origin-top{transform-origin:top}.md\\:origin-top-right{transform-origin:top right}.md\\:origin-right{transform-origin:right}.md\\:origin-bottom-right{transform-origin:bottom right}.md\\:origin-bottom{transform-origin:bottom}.md\\:origin-bottom-left{transform-origin:bottom left}.md\\:origin-left{transform-origin:left}.md\\:origin-top-left{transform-origin:top left}.md\\:scale-0{--transform-scale-x:0;--transform-scale-y:0}.md\\:scale-50{--transform-scale-x:.5;--transform-scale-y:.5}.md\\:scale-75{--transform-scale-x:.75;--transform-scale-y:.75}.md\\:scale-90{--transform-scale-x:.9;--transform-scale-y:.9}.md\\:scale-95{--transform-scale-x:.95;--transform-scale-y:.95}.md\\:scale-100{--transform-scale-x:1;--transform-scale-y:1}.md\\:scale-105{--transform-scale-x:1.05;--transform-scale-y:1.05}.md\\:scale-110{--transform-scale-x:1.1;--transform-scale-y:1.1}.md\\:scale-125{--transform-scale-x:1.25;--transform-scale-y:1.25}.md\\:scale-150{--transform-scale-x:1.5;--transform-scale-y:1.5}.md\\:scale-x-0{--transform-scale-x:0}.md\\:scale-x-50{--transform-scale-x:.5}.md\\:scale-x-75{--transform-scale-x:.75}.md\\:scale-x-90{--transform-scale-x:.9}.md\\:scale-x-95{--transform-scale-x:.95}.md\\:scale-x-100{--transform-scale-x:1}.md\\:scale-x-105{--transform-scale-x:1.05}.md\\:scale-x-110{--transform-scale-x:1.1}.md\\:scale-x-125{--transform-scale-x:1.25}.md\\:scale-x-150{--transform-scale-x:1.5}.md\\:scale-y-0{--transform-scale-y:0}.md\\:scale-y-50{--transform-scale-y:.5}.md\\:scale-y-75{--transform-scale-y:.75}.md\\:scale-y-90{--transform-scale-y:.9}.md\\:scale-y-95{--transform-scale-y:.95}.md\\:scale-y-100{--transform-scale-y:1}.md\\:scale-y-105{--transform-scale-y:1.05}.md\\:scale-y-110{--transform-scale-y:1.1}.md\\:scale-y-125{--transform-scale-y:1.25}.md\\:scale-y-150{--transform-scale-y:1.5}.md\\:hover\\:scale-0:hover{--transform-scale-x:0;--transform-scale-y:0}.md\\:hover\\:scale-50:hover{--transform-scale-x:.5;--transform-scale-y:.5}.md\\:hover\\:scale-75:hover{--transform-scale-x:.75;--transform-scale-y:.75}.md\\:hover\\:scale-90:hover{--transform-scale-x:.9;--transform-scale-y:.9}.md\\:hover\\:scale-95:hover{--transform-scale-x:.95;--transform-scale-y:.95}.md\\:hover\\:scale-100:hover{--transform-scale-x:1;--transform-scale-y:1}.md\\:hover\\:scale-105:hover{--transform-scale-x:1.05;--transform-scale-y:1.05}.md\\:hover\\:scale-110:hover{--transform-scale-x:1.1;--transform-scale-y:1.1}.md\\:hover\\:scale-125:hover{--transform-scale-x:1.25;--transform-scale-y:1.25}.md\\:hover\\:scale-150:hover{--transform-scale-x:1.5;--transform-scale-y:1.5}.md\\:hover\\:scale-x-0:hover{--transform-scale-x:0}.md\\:hover\\:scale-x-50:hover{--transform-scale-x:.5}.md\\:hover\\:scale-x-75:hover{--transform-scale-x:.75}.md\\:hover\\:scale-x-90:hover{--transform-scale-x:.9}.md\\:hover\\:scale-x-95:hover{--transform-scale-x:.95}.md\\:hover\\:scale-x-100:hover{--transform-scale-x:1}.md\\:hover\\:scale-x-105:hover{--transform-scale-x:1.05}.md\\:hover\\:scale-x-110:hover{--transform-scale-x:1.1}.md\\:hover\\:scale-x-125:hover{--transform-scale-x:1.25}.md\\:hover\\:scale-x-150:hover{--transform-scale-x:1.5}.md\\:hover\\:scale-y-0:hover{--transform-scale-y:0}.md\\:hover\\:scale-y-50:hover{--transform-scale-y:.5}.md\\:hover\\:scale-y-75:hover{--transform-scale-y:.75}.md\\:hover\\:scale-y-90:hover{--transform-scale-y:.9}.md\\:hover\\:scale-y-95:hover{--transform-scale-y:.95}.md\\:hover\\:scale-y-100:hover{--transform-scale-y:1}.md\\:hover\\:scale-y-105:hover{--transform-scale-y:1.05}.md\\:hover\\:scale-y-110:hover{--transform-scale-y:1.1}.md\\:hover\\:scale-y-125:hover{--transform-scale-y:1.25}.md\\:hover\\:scale-y-150:hover{--transform-scale-y:1.5}.md\\:focus\\:scale-0:focus{--transform-scale-x:0;--transform-scale-y:0}.md\\:focus\\:scale-50:focus{--transform-scale-x:.5;--transform-scale-y:.5}.md\\:focus\\:scale-75:focus{--transform-scale-x:.75;--transform-scale-y:.75}.md\\:focus\\:scale-90:focus{--transform-scale-x:.9;--transform-scale-y:.9}.md\\:focus\\:scale-95:focus{--transform-scale-x:.95;--transform-scale-y:.95}.md\\:focus\\:scale-100:focus{--transform-scale-x:1;--transform-scale-y:1}.md\\:focus\\:scale-105:focus{--transform-scale-x:1.05;--transform-scale-y:1.05}.md\\:focus\\:scale-110:focus{--transform-scale-x:1.1;--transform-scale-y:1.1}.md\\:focus\\:scale-125:focus{--transform-scale-x:1.25;--transform-scale-y:1.25}.md\\:focus\\:scale-150:focus{--transform-scale-x:1.5;--transform-scale-y:1.5}.md\\:focus\\:scale-x-0:focus{--transform-scale-x:0}.md\\:focus\\:scale-x-50:focus{--transform-scale-x:.5}.md\\:focus\\:scale-x-75:focus{--transform-scale-x:.75}.md\\:focus\\:scale-x-90:focus{--transform-scale-x:.9}.md\\:focus\\:scale-x-95:focus{--transform-scale-x:.95}.md\\:focus\\:scale-x-100:focus{--transform-scale-x:1}.md\\:focus\\:scale-x-105:focus{--transform-scale-x:1.05}.md\\:focus\\:scale-x-110:focus{--transform-scale-x:1.1}.md\\:focus\\:scale-x-125:focus{--transform-scale-x:1.25}.md\\:focus\\:scale-x-150:focus{--transform-scale-x:1.5}.md\\:focus\\:scale-y-0:focus{--transform-scale-y:0}.md\\:focus\\:scale-y-50:focus{--transform-scale-y:.5}.md\\:focus\\:scale-y-75:focus{--transform-scale-y:.75}.md\\:focus\\:scale-y-90:focus{--transform-scale-y:.9}.md\\:focus\\:scale-y-95:focus{--transform-scale-y:.95}.md\\:focus\\:scale-y-100:focus{--transform-scale-y:1}.md\\:focus\\:scale-y-105:focus{--transform-scale-y:1.05}.md\\:focus\\:scale-y-110:focus{--transform-scale-y:1.1}.md\\:focus\\:scale-y-125:focus{--transform-scale-y:1.25}.md\\:focus\\:scale-y-150:focus{--transform-scale-y:1.5}.md\\:rotate-0{--transform-rotate:0}.md\\:rotate-45{--transform-rotate:45deg}.md\\:rotate-90{--transform-rotate:90deg}.md\\:rotate-180{--transform-rotate:180deg}.md\\:-rotate-180{--transform-rotate:-180deg}.md\\:-rotate-90{--transform-rotate:-90deg}.md\\:-rotate-45{--transform-rotate:-45deg}.md\\:hover\\:rotate-0:hover{--transform-rotate:0}.md\\:hover\\:rotate-45:hover{--transform-rotate:45deg}.md\\:hover\\:rotate-90:hover{--transform-rotate:90deg}.md\\:hover\\:rotate-180:hover{--transform-rotate:180deg}.md\\:hover\\:-rotate-180:hover{--transform-rotate:-180deg}.md\\:hover\\:-rotate-90:hover{--transform-rotate:-90deg}.md\\:hover\\:-rotate-45:hover{--transform-rotate:-45deg}.md\\:focus\\:rotate-0:focus{--transform-rotate:0}.md\\:focus\\:rotate-45:focus{--transform-rotate:45deg}.md\\:focus\\:rotate-90:focus{--transform-rotate:90deg}.md\\:focus\\:rotate-180:focus{--transform-rotate:180deg}.md\\:focus\\:-rotate-180:focus{--transform-rotate:-180deg}.md\\:focus\\:-rotate-90:focus{--transform-rotate:-90deg}.md\\:focus\\:-rotate-45:focus{--transform-rotate:-45deg}.md\\:translate-x-0{--transform-translate-x:0}.md\\:translate-x-1{--transform-translate-x:0.25rem}.md\\:translate-x-2{--transform-translate-x:0.5rem}.md\\:translate-x-3{--transform-translate-x:0.75rem}.md\\:translate-x-4{--transform-translate-x:1rem}.md\\:translate-x-5{--transform-translate-x:1.25rem}.md\\:translate-x-6{--transform-translate-x:1.5rem}.md\\:translate-x-8{--transform-translate-x:2rem}.md\\:translate-x-10{--transform-translate-x:2.5rem}.md\\:translate-x-12{--transform-translate-x:3rem}.md\\:translate-x-16{--transform-translate-x:4rem}.md\\:translate-x-20{--transform-translate-x:5rem}.md\\:translate-x-24{--transform-translate-x:6rem}.md\\:translate-x-32{--transform-translate-x:8rem}.md\\:translate-x-40{--transform-translate-x:10rem}.md\\:translate-x-48{--transform-translate-x:12rem}.md\\:translate-x-56{--transform-translate-x:14rem}.md\\:translate-x-64{--transform-translate-x:16rem}.md\\:translate-x-px{--transform-translate-x:1px}.md\\:-translate-x-1{--transform-translate-x:-0.25rem}.md\\:-translate-x-2{--transform-translate-x:-0.5rem}.md\\:-translate-x-3{--transform-translate-x:-0.75rem}.md\\:-translate-x-4{--transform-translate-x:-1rem}.md\\:-translate-x-5{--transform-translate-x:-1.25rem}.md\\:-translate-x-6{--transform-translate-x:-1.5rem}.md\\:-translate-x-8{--transform-translate-x:-2rem}.md\\:-translate-x-10{--transform-translate-x:-2.5rem}.md\\:-translate-x-12{--transform-translate-x:-3rem}.md\\:-translate-x-16{--transform-translate-x:-4rem}.md\\:-translate-x-20{--transform-translate-x:-5rem}.md\\:-translate-x-24{--transform-translate-x:-6rem}.md\\:-translate-x-32{--transform-translate-x:-8rem}.md\\:-translate-x-40{--transform-translate-x:-10rem}.md\\:-translate-x-48{--transform-translate-x:-12rem}.md\\:-translate-x-56{--transform-translate-x:-14rem}.md\\:-translate-x-64{--transform-translate-x:-16rem}.md\\:-translate-x-px{--transform-translate-x:-1px}.md\\:-translate-x-full{--transform-translate-x:-100%}.md\\:-translate-x-1\\/2{--transform-translate-x:-50%}.md\\:translate-x-1\\/2{--transform-translate-x:50%}.md\\:translate-x-full{--transform-translate-x:100%}.md\\:translate-y-0{--transform-translate-y:0}.md\\:translate-y-1{--transform-translate-y:0.25rem}.md\\:translate-y-2{--transform-translate-y:0.5rem}.md\\:translate-y-3{--transform-translate-y:0.75rem}.md\\:translate-y-4{--transform-translate-y:1rem}.md\\:translate-y-5{--transform-translate-y:1.25rem}.md\\:translate-y-6{--transform-translate-y:1.5rem}.md\\:translate-y-8{--transform-translate-y:2rem}.md\\:translate-y-10{--transform-translate-y:2.5rem}.md\\:translate-y-12{--transform-translate-y:3rem}.md\\:translate-y-16{--transform-translate-y:4rem}.md\\:translate-y-20{--transform-translate-y:5rem}.md\\:translate-y-24{--transform-translate-y:6rem}.md\\:translate-y-32{--transform-translate-y:8rem}.md\\:translate-y-40{--transform-translate-y:10rem}.md\\:translate-y-48{--transform-translate-y:12rem}.md\\:translate-y-56{--transform-translate-y:14rem}.md\\:translate-y-64{--transform-translate-y:16rem}.md\\:translate-y-px{--transform-translate-y:1px}.md\\:-translate-y-1{--transform-translate-y:-0.25rem}.md\\:-translate-y-2{--transform-translate-y:-0.5rem}.md\\:-translate-y-3{--transform-translate-y:-0.75rem}.md\\:-translate-y-4{--transform-translate-y:-1rem}.md\\:-translate-y-5{--transform-translate-y:-1.25rem}.md\\:-translate-y-6{--transform-translate-y:-1.5rem}.md\\:-translate-y-8{--transform-translate-y:-2rem}.md\\:-translate-y-10{--transform-translate-y:-2.5rem}.md\\:-translate-y-12{--transform-translate-y:-3rem}.md\\:-translate-y-16{--transform-translate-y:-4rem}.md\\:-translate-y-20{--transform-translate-y:-5rem}.md\\:-translate-y-24{--transform-translate-y:-6rem}.md\\:-translate-y-32{--transform-translate-y:-8rem}.md\\:-translate-y-40{--transform-translate-y:-10rem}.md\\:-translate-y-48{--transform-translate-y:-12rem}.md\\:-translate-y-56{--transform-translate-y:-14rem}.md\\:-translate-y-64{--transform-translate-y:-16rem}.md\\:-translate-y-px{--transform-translate-y:-1px}.md\\:-translate-y-full{--transform-translate-y:-100%}.md\\:-translate-y-1\\/2{--transform-translate-y:-50%}.md\\:translate-y-1\\/2{--transform-translate-y:50%}.md\\:translate-y-full{--transform-translate-y:100%}.md\\:hover\\:translate-x-0:hover{--transform-translate-x:0}.md\\:hover\\:translate-x-1:hover{--transform-translate-x:0.25rem}.md\\:hover\\:translate-x-2:hover{--transform-translate-x:0.5rem}.md\\:hover\\:translate-x-3:hover{--transform-translate-x:0.75rem}.md\\:hover\\:translate-x-4:hover{--transform-translate-x:1rem}.md\\:hover\\:translate-x-5:hover{--transform-translate-x:1.25rem}.md\\:hover\\:translate-x-6:hover{--transform-translate-x:1.5rem}.md\\:hover\\:translate-x-8:hover{--transform-translate-x:2rem}.md\\:hover\\:translate-x-10:hover{--transform-translate-x:2.5rem}.md\\:hover\\:translate-x-12:hover{--transform-translate-x:3rem}.md\\:hover\\:translate-x-16:hover{--transform-translate-x:4rem}.md\\:hover\\:translate-x-20:hover{--transform-translate-x:5rem}.md\\:hover\\:translate-x-24:hover{--transform-translate-x:6rem}.md\\:hover\\:translate-x-32:hover{--transform-translate-x:8rem}.md\\:hover\\:translate-x-40:hover{--transform-translate-x:10rem}.md\\:hover\\:translate-x-48:hover{--transform-translate-x:12rem}.md\\:hover\\:translate-x-56:hover{--transform-translate-x:14rem}.md\\:hover\\:translate-x-64:hover{--transform-translate-x:16rem}.md\\:hover\\:translate-x-px:hover{--transform-translate-x:1px}.md\\:hover\\:-translate-x-1:hover{--transform-translate-x:-0.25rem}.md\\:hover\\:-translate-x-2:hover{--transform-translate-x:-0.5rem}.md\\:hover\\:-translate-x-3:hover{--transform-translate-x:-0.75rem}.md\\:hover\\:-translate-x-4:hover{--transform-translate-x:-1rem}.md\\:hover\\:-translate-x-5:hover{--transform-translate-x:-1.25rem}.md\\:hover\\:-translate-x-6:hover{--transform-translate-x:-1.5rem}.md\\:hover\\:-translate-x-8:hover{--transform-translate-x:-2rem}.md\\:hover\\:-translate-x-10:hover{--transform-translate-x:-2.5rem}.md\\:hover\\:-translate-x-12:hover{--transform-translate-x:-3rem}.md\\:hover\\:-translate-x-16:hover{--transform-translate-x:-4rem}.md\\:hover\\:-translate-x-20:hover{--transform-translate-x:-5rem}.md\\:hover\\:-translate-x-24:hover{--transform-translate-x:-6rem}.md\\:hover\\:-translate-x-32:hover{--transform-translate-x:-8rem}.md\\:hover\\:-translate-x-40:hover{--transform-translate-x:-10rem}.md\\:hover\\:-translate-x-48:hover{--transform-translate-x:-12rem}.md\\:hover\\:-translate-x-56:hover{--transform-translate-x:-14rem}.md\\:hover\\:-translate-x-64:hover{--transform-translate-x:-16rem}.md\\:hover\\:-translate-x-px:hover{--transform-translate-x:-1px}.md\\:hover\\:-translate-x-full:hover{--transform-translate-x:-100%}.md\\:hover\\:-translate-x-1\\/2:hover{--transform-translate-x:-50%}.md\\:hover\\:translate-x-1\\/2:hover{--transform-translate-x:50%}.md\\:hover\\:translate-x-full:hover{--transform-translate-x:100%}.md\\:hover\\:translate-y-0:hover{--transform-translate-y:0}.md\\:hover\\:translate-y-1:hover{--transform-translate-y:0.25rem}.md\\:hover\\:translate-y-2:hover{--transform-translate-y:0.5rem}.md\\:hover\\:translate-y-3:hover{--transform-translate-y:0.75rem}.md\\:hover\\:translate-y-4:hover{--transform-translate-y:1rem}.md\\:hover\\:translate-y-5:hover{--transform-translate-y:1.25rem}.md\\:hover\\:translate-y-6:hover{--transform-translate-y:1.5rem}.md\\:hover\\:translate-y-8:hover{--transform-translate-y:2rem}.md\\:hover\\:translate-y-10:hover{--transform-translate-y:2.5rem}.md\\:hover\\:translate-y-12:hover{--transform-translate-y:3rem}.md\\:hover\\:translate-y-16:hover{--transform-translate-y:4rem}.md\\:hover\\:translate-y-20:hover{--transform-translate-y:5rem}.md\\:hover\\:translate-y-24:hover{--transform-translate-y:6rem}.md\\:hover\\:translate-y-32:hover{--transform-translate-y:8rem}.md\\:hover\\:translate-y-40:hover{--transform-translate-y:10rem}.md\\:hover\\:translate-y-48:hover{--transform-translate-y:12rem}.md\\:hover\\:translate-y-56:hover{--transform-translate-y:14rem}.md\\:hover\\:translate-y-64:hover{--transform-translate-y:16rem}.md\\:hover\\:translate-y-px:hover{--transform-translate-y:1px}.md\\:hover\\:-translate-y-1:hover{--transform-translate-y:-0.25rem}.md\\:hover\\:-translate-y-2:hover{--transform-translate-y:-0.5rem}.md\\:hover\\:-translate-y-3:hover{--transform-translate-y:-0.75rem}.md\\:hover\\:-translate-y-4:hover{--transform-translate-y:-1rem}.md\\:hover\\:-translate-y-5:hover{--transform-translate-y:-1.25rem}.md\\:hover\\:-translate-y-6:hover{--transform-translate-y:-1.5rem}.md\\:hover\\:-translate-y-8:hover{--transform-translate-y:-2rem}.md\\:hover\\:-translate-y-10:hover{--transform-translate-y:-2.5rem}.md\\:hover\\:-translate-y-12:hover{--transform-translate-y:-3rem}.md\\:hover\\:-translate-y-16:hover{--transform-translate-y:-4rem}.md\\:hover\\:-translate-y-20:hover{--transform-translate-y:-5rem}.md\\:hover\\:-translate-y-24:hover{--transform-translate-y:-6rem}.md\\:hover\\:-translate-y-32:hover{--transform-translate-y:-8rem}.md\\:hover\\:-translate-y-40:hover{--transform-translate-y:-10rem}.md\\:hover\\:-translate-y-48:hover{--transform-translate-y:-12rem}.md\\:hover\\:-translate-y-56:hover{--transform-translate-y:-14rem}.md\\:hover\\:-translate-y-64:hover{--transform-translate-y:-16rem}.md\\:hover\\:-translate-y-px:hover{--transform-translate-y:-1px}.md\\:hover\\:-translate-y-full:hover{--transform-translate-y:-100%}.md\\:hover\\:-translate-y-1\\/2:hover{--transform-translate-y:-50%}.md\\:hover\\:translate-y-1\\/2:hover{--transform-translate-y:50%}.md\\:hover\\:translate-y-full:hover{--transform-translate-y:100%}.md\\:focus\\:translate-x-0:focus{--transform-translate-x:0}.md\\:focus\\:translate-x-1:focus{--transform-translate-x:0.25rem}.md\\:focus\\:translate-x-2:focus{--transform-translate-x:0.5rem}.md\\:focus\\:translate-x-3:focus{--transform-translate-x:0.75rem}.md\\:focus\\:translate-x-4:focus{--transform-translate-x:1rem}.md\\:focus\\:translate-x-5:focus{--transform-translate-x:1.25rem}.md\\:focus\\:translate-x-6:focus{--transform-translate-x:1.5rem}.md\\:focus\\:translate-x-8:focus{--transform-translate-x:2rem}.md\\:focus\\:translate-x-10:focus{--transform-translate-x:2.5rem}.md\\:focus\\:translate-x-12:focus{--transform-translate-x:3rem}.md\\:focus\\:translate-x-16:focus{--transform-translate-x:4rem}.md\\:focus\\:translate-x-20:focus{--transform-translate-x:5rem}.md\\:focus\\:translate-x-24:focus{--transform-translate-x:6rem}.md\\:focus\\:translate-x-32:focus{--transform-translate-x:8rem}.md\\:focus\\:translate-x-40:focus{--transform-translate-x:10rem}.md\\:focus\\:translate-x-48:focus{--transform-translate-x:12rem}.md\\:focus\\:translate-x-56:focus{--transform-translate-x:14rem}.md\\:focus\\:translate-x-64:focus{--transform-translate-x:16rem}.md\\:focus\\:translate-x-px:focus{--transform-translate-x:1px}.md\\:focus\\:-translate-x-1:focus{--transform-translate-x:-0.25rem}.md\\:focus\\:-translate-x-2:focus{--transform-translate-x:-0.5rem}.md\\:focus\\:-translate-x-3:focus{--transform-translate-x:-0.75rem}.md\\:focus\\:-translate-x-4:focus{--transform-translate-x:-1rem}.md\\:focus\\:-translate-x-5:focus{--transform-translate-x:-1.25rem}.md\\:focus\\:-translate-x-6:focus{--transform-translate-x:-1.5rem}.md\\:focus\\:-translate-x-8:focus{--transform-translate-x:-2rem}.md\\:focus\\:-translate-x-10:focus{--transform-translate-x:-2.5rem}.md\\:focus\\:-translate-x-12:focus{--transform-translate-x:-3rem}.md\\:focus\\:-translate-x-16:focus{--transform-translate-x:-4rem}.md\\:focus\\:-translate-x-20:focus{--transform-translate-x:-5rem}.md\\:focus\\:-translate-x-24:focus{--transform-translate-x:-6rem}.md\\:focus\\:-translate-x-32:focus{--transform-translate-x:-8rem}.md\\:focus\\:-translate-x-40:focus{--transform-translate-x:-10rem}.md\\:focus\\:-translate-x-48:focus{--transform-translate-x:-12rem}.md\\:focus\\:-translate-x-56:focus{--transform-translate-x:-14rem}.md\\:focus\\:-translate-x-64:focus{--transform-translate-x:-16rem}.md\\:focus\\:-translate-x-px:focus{--transform-translate-x:-1px}.md\\:focus\\:-translate-x-full:focus{--transform-translate-x:-100%}.md\\:focus\\:-translate-x-1\\/2:focus{--transform-translate-x:-50%}.md\\:focus\\:translate-x-1\\/2:focus{--transform-translate-x:50%}.md\\:focus\\:translate-x-full:focus{--transform-translate-x:100%}.md\\:focus\\:translate-y-0:focus{--transform-translate-y:0}.md\\:focus\\:translate-y-1:focus{--transform-translate-y:0.25rem}.md\\:focus\\:translate-y-2:focus{--transform-translate-y:0.5rem}.md\\:focus\\:translate-y-3:focus{--transform-translate-y:0.75rem}.md\\:focus\\:translate-y-4:focus{--transform-translate-y:1rem}.md\\:focus\\:translate-y-5:focus{--transform-translate-y:1.25rem}.md\\:focus\\:translate-y-6:focus{--transform-translate-y:1.5rem}.md\\:focus\\:translate-y-8:focus{--transform-translate-y:2rem}.md\\:focus\\:translate-y-10:focus{--transform-translate-y:2.5rem}.md\\:focus\\:translate-y-12:focus{--transform-translate-y:3rem}.md\\:focus\\:translate-y-16:focus{--transform-translate-y:4rem}.md\\:focus\\:translate-y-20:focus{--transform-translate-y:5rem}.md\\:focus\\:translate-y-24:focus{--transform-translate-y:6rem}.md\\:focus\\:translate-y-32:focus{--transform-translate-y:8rem}.md\\:focus\\:translate-y-40:focus{--transform-translate-y:10rem}.md\\:focus\\:translate-y-48:focus{--transform-translate-y:12rem}.md\\:focus\\:translate-y-56:focus{--transform-translate-y:14rem}.md\\:focus\\:translate-y-64:focus{--transform-translate-y:16rem}.md\\:focus\\:translate-y-px:focus{--transform-translate-y:1px}.md\\:focus\\:-translate-y-1:focus{--transform-translate-y:-0.25rem}.md\\:focus\\:-translate-y-2:focus{--transform-translate-y:-0.5rem}.md\\:focus\\:-translate-y-3:focus{--transform-translate-y:-0.75rem}.md\\:focus\\:-translate-y-4:focus{--transform-translate-y:-1rem}.md\\:focus\\:-translate-y-5:focus{--transform-translate-y:-1.25rem}.md\\:focus\\:-translate-y-6:focus{--transform-translate-y:-1.5rem}.md\\:focus\\:-translate-y-8:focus{--transform-translate-y:-2rem}.md\\:focus\\:-translate-y-10:focus{--transform-translate-y:-2.5rem}.md\\:focus\\:-translate-y-12:focus{--transform-translate-y:-3rem}.md\\:focus\\:-translate-y-16:focus{--transform-translate-y:-4rem}.md\\:focus\\:-translate-y-20:focus{--transform-translate-y:-5rem}.md\\:focus\\:-translate-y-24:focus{--transform-translate-y:-6rem}.md\\:focus\\:-translate-y-32:focus{--transform-translate-y:-8rem}.md\\:focus\\:-translate-y-40:focus{--transform-translate-y:-10rem}.md\\:focus\\:-translate-y-48:focus{--transform-translate-y:-12rem}.md\\:focus\\:-translate-y-56:focus{--transform-translate-y:-14rem}.md\\:focus\\:-translate-y-64:focus{--transform-translate-y:-16rem}.md\\:focus\\:-translate-y-px:focus{--transform-translate-y:-1px}.md\\:focus\\:-translate-y-full:focus{--transform-translate-y:-100%}.md\\:focus\\:-translate-y-1\\/2:focus{--transform-translate-y:-50%}.md\\:focus\\:translate-y-1\\/2:focus{--transform-translate-y:50%}.md\\:focus\\:translate-y-full:focus{--transform-translate-y:100%}.md\\:skew-x-0{--transform-skew-x:0}.md\\:skew-x-3{--transform-skew-x:3deg}.md\\:skew-x-6{--transform-skew-x:6deg}.md\\:skew-x-12{--transform-skew-x:12deg}.md\\:-skew-x-12{--transform-skew-x:-12deg}.md\\:-skew-x-6{--transform-skew-x:-6deg}.md\\:-skew-x-3{--transform-skew-x:-3deg}.md\\:skew-y-0{--transform-skew-y:0}.md\\:skew-y-3{--transform-skew-y:3deg}.md\\:skew-y-6{--transform-skew-y:6deg}.md\\:skew-y-12{--transform-skew-y:12deg}.md\\:-skew-y-12{--transform-skew-y:-12deg}.md\\:-skew-y-6{--transform-skew-y:-6deg}.md\\:-skew-y-3{--transform-skew-y:-3deg}.md\\:hover\\:skew-x-0:hover{--transform-skew-x:0}.md\\:hover\\:skew-x-3:hover{--transform-skew-x:3deg}.md\\:hover\\:skew-x-6:hover{--transform-skew-x:6deg}.md\\:hover\\:skew-x-12:hover{--transform-skew-x:12deg}.md\\:hover\\:-skew-x-12:hover{--transform-skew-x:-12deg}.md\\:hover\\:-skew-x-6:hover{--transform-skew-x:-6deg}.md\\:hover\\:-skew-x-3:hover{--transform-skew-x:-3deg}.md\\:hover\\:skew-y-0:hover{--transform-skew-y:0}.md\\:hover\\:skew-y-3:hover{--transform-skew-y:3deg}.md\\:hover\\:skew-y-6:hover{--transform-skew-y:6deg}.md\\:hover\\:skew-y-12:hover{--transform-skew-y:12deg}.md\\:hover\\:-skew-y-12:hover{--transform-skew-y:-12deg}.md\\:hover\\:-skew-y-6:hover{--transform-skew-y:-6deg}.md\\:hover\\:-skew-y-3:hover{--transform-skew-y:-3deg}.md\\:focus\\:skew-x-0:focus{--transform-skew-x:0}.md\\:focus\\:skew-x-3:focus{--transform-skew-x:3deg}.md\\:focus\\:skew-x-6:focus{--transform-skew-x:6deg}.md\\:focus\\:skew-x-12:focus{--transform-skew-x:12deg}.md\\:focus\\:-skew-x-12:focus{--transform-skew-x:-12deg}.md\\:focus\\:-skew-x-6:focus{--transform-skew-x:-6deg}.md\\:focus\\:-skew-x-3:focus{--transform-skew-x:-3deg}.md\\:focus\\:skew-y-0:focus{--transform-skew-y:0}.md\\:focus\\:skew-y-3:focus{--transform-skew-y:3deg}.md\\:focus\\:skew-y-6:focus{--transform-skew-y:6deg}.md\\:focus\\:skew-y-12:focus{--transform-skew-y:12deg}.md\\:focus\\:-skew-y-12:focus{--transform-skew-y:-12deg}.md\\:focus\\:-skew-y-6:focus{--transform-skew-y:-6deg}.md\\:focus\\:-skew-y-3:focus{--transform-skew-y:-3deg}.md\\:transition-none{transition-property:none}.md\\:transition-all{transition-property:all}.md\\:transition{transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform}.md\\:transition-colors{transition-property:background-color,border-color,color,fill,stroke}.md\\:transition-opacity{transition-property:opacity}.md\\:transition-shadow{transition-property:box-shadow}.md\\:transition-transform{transition-property:transform}.md\\:ease-linear{transition-timing-function:linear}.md\\:ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.md\\:ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.md\\:ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.md\\:duration-75{transition-duration:75ms}.md\\:duration-100{transition-duration:.1s}.md\\:duration-150{transition-duration:.15s}.md\\:duration-200{transition-duration:.2s}.md\\:duration-300{transition-duration:.3s}.md\\:duration-500{transition-duration:.5s}.md\\:duration-700{transition-duration:.7s}.md\\:duration-1000{transition-duration:1s}.md\\:delay-75{transition-delay:75ms}.md\\:delay-100{transition-delay:.1s}.md\\:delay-150{transition-delay:.15s}.md\\:delay-200{transition-delay:.2s}.md\\:delay-300{transition-delay:.3s}.md\\:delay-500{transition-delay:.5s}.md\\:delay-700{transition-delay:.7s}.md\\:delay-1000{transition-delay:1s}.md\\:shadow-outline-white{box-shadow:0 0 0 3px #ffffff73}.md\\:shadow-outline-black{box-shadow:0 0 0 3px #00000073}.md\\:shadow-outline-gray{box-shadow:0 0 0 3px #d5d6d773}.md\\:shadow-outline-cool-gray{box-shadow:0 0 0 3px #cfd8e373}.md\\:shadow-outline-red{box-shadow:0 0 0 3px #f8b4b473}.md\\:shadow-outline-orange{box-shadow:0 0 0 3px #fdba8c73}.md\\:shadow-outline-yellow{box-shadow:0 0 0 3px #faca1573}.md\\:shadow-outline-green{box-shadow:0 0 0 3px #84e1bc73}.md\\:shadow-outline-teal{box-shadow:0 0 0 3px #7edce273}.md\\:shadow-outline-blue{box-shadow:0 0 0 3px #a4cafe73}.md\\:shadow-outline-indigo{box-shadow:0 0 0 3px #b4c6fc73}.md\\:shadow-outline-indigo{box-shadow:0 0 0 3px #cabffd73}.md\\:shadow-outline-pink{box-shadow:0 0 0 3px #f8b4d973}.md\\:hover\\:shadow-outline-white:hover{box-shadow:0 0 0 3px #ffffff73}.md\\:hover\\:shadow-outline-black:hover{box-shadow:0 0 0 3px #00000073}.md\\:hover\\:shadow-outline-gray:hover{box-shadow:0 0 0 3px #d5d6d773}.md\\:hover\\:shadow-outline-cool-gray:hover{box-shadow:0 0 0 3px #cfd8e373}.md\\:hover\\:shadow-outline-red:hover{box-shadow:0 0 0 3px #f8b4b473}.md\\:hover\\:shadow-outline-orange:hover{box-shadow:0 0 0 3px #fdba8c73}.md\\:hover\\:shadow-outline-yellow:hover{box-shadow:0 0 0 3px #faca1573}.md\\:hover\\:shadow-outline-green:hover{box-shadow:0 0 0 3px #84e1bc73}.md\\:hover\\:shadow-outline-teal:hover{box-shadow:0 0 0 3px #7edce273}.md\\:hover\\:shadow-outline-blue:hover{box-shadow:0 0 0 3px #a4cafe73}.md\\:hover\\:shadow-outline-indigo:hover{box-shadow:0 0 0 3px #b4c6fc73}.md\\:hover\\:shadow-outline-indigo:hover{box-shadow:0 0 0 3px #cabffd73}.md\\:hover\\:shadow-outline-pink:hover{box-shadow:0 0 0 3px #f8b4d973}.md\\:focus\\:shadow-outline-white:focus{box-shadow:0 0 0 3px #ffffff73}.md\\:focus\\:shadow-outline-black:focus{box-shadow:0 0 0 3px #00000073}.md\\:focus\\:shadow-outline-gray:focus{box-shadow:0 0 0 3px #d5d6d773}.md\\:focus\\:shadow-outline-cool-gray:focus{box-shadow:0 0 0 3px #cfd8e373}.md\\:focus\\:shadow-outline-red:focus{box-shadow:0 0 0 3px #f8b4b473}.md\\:focus\\:shadow-outline-orange:focus{box-shadow:0 0 0 3px #fdba8c73}.md\\:focus\\:shadow-outline-yellow:focus{box-shadow:0 0 0 3px #faca1573}.md\\:focus\\:shadow-outline-green:focus{box-shadow:0 0 0 3px #84e1bc73}.md\\:focus\\:shadow-outline-teal:focus{box-shadow:0 0 0 3px #7edce273}.md\\:focus\\:shadow-outline-blue:focus{box-shadow:0 0 0 3px #a4cafe73}.md\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #b4c6fc73}.md\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #cabffd73}.md\\:focus\\:shadow-outline-pink:focus{box-shadow:0 0 0 3px #f8b4d973}.theme-dark .md\\:dark\\:focus\\:shadow-outline-white:focus{box-shadow:0 0 0 3px #ffffff73}.theme-dark .md\\:dark\\:focus\\:shadow-outline-black:focus{box-shadow:0 0 0 3px #00000073}.theme-dark .md\\:dark\\:focus\\:shadow-outline-gray:focus{box-shadow:0 0 0 3px #d5d6d773}.theme-dark .md\\:dark\\:focus\\:shadow-outline-cool-gray:focus{box-shadow:0 0 0 3px #cfd8e373}.theme-dark .md\\:dark\\:focus\\:shadow-outline-red:focus{box-shadow:0 0 0 3px #f8b4b473}.theme-dark .md\\:dark\\:focus\\:shadow-outline-orange:focus{box-shadow:0 0 0 3px #fdba8c73}.theme-dark .md\\:dark\\:focus\\:shadow-outline-yellow:focus{box-shadow:0 0 0 3px #faca1573}.theme-dark .md\\:dark\\:focus\\:shadow-outline-green:focus{box-shadow:0 0 0 3px #84e1bc73}.theme-dark .md\\:dark\\:focus\\:shadow-outline-teal:focus{box-shadow:0 0 0 3px #7edce273}.theme-dark .md\\:dark\\:focus\\:shadow-outline-blue:focus{box-shadow:0 0 0 3px #a4cafe73}.theme-dark .md\\:dark\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #b4c6fc73}.theme-dark .md\\:dark\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #cabffd73}.theme-dark .md\\:dark\\:focus\\:shadow-outline-pink:focus{box-shadow:0 0 0 3px #f8b4d973}}@media (min-width:1024px){.lg\\:space-y-0>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(0px*var(--space-y-reverse));margin-top:calc(0px*(1 - var(--space-y-reverse)))}.lg\\:space-x-0>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(0px*(1 - var(--space-x-reverse)));margin-right:calc(0px*var(--space-x-reverse))}.lg\\:space-y-1>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(.25rem*var(--space-y-reverse));margin-top:calc(.25rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-1>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(.25rem*(1 - var(--space-x-reverse)));margin-right:calc(.25rem*var(--space-x-reverse))}.lg\\:space-y-2>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(.5rem*var(--space-y-reverse));margin-top:calc(.5rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-2>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(.5rem*(1 - var(--space-x-reverse)));margin-right:calc(.5rem*var(--space-x-reverse))}.lg\\:space-y-3>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(.75rem*var(--space-y-reverse));margin-top:calc(.75rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-3>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(.75rem*(1 - var(--space-x-reverse)));margin-right:calc(.75rem*var(--space-x-reverse))}.lg\\:space-y-4>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1rem*var(--space-y-reverse));margin-top:calc(1rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-4>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1rem*(1 - var(--space-x-reverse)));margin-right:calc(1rem*var(--space-x-reverse))}.lg\\:space-y-5>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1.25rem*var(--space-y-reverse));margin-top:calc(1.25rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-5>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1.25rem*(1 - var(--space-x-reverse)));margin-right:calc(1.25rem*var(--space-x-reverse))}.lg\\:space-y-6>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1.5rem*var(--space-y-reverse));margin-top:calc(1.5rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-6>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1.5rem*(1 - var(--space-x-reverse)));margin-right:calc(1.5rem*var(--space-x-reverse))}.lg\\:space-y-8>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(2rem*var(--space-y-reverse));margin-top:calc(2rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-8>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(2rem*(1 - var(--space-x-reverse)));margin-right:calc(2rem*var(--space-x-reverse))}.lg\\:space-y-10>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(2.5rem*var(--space-y-reverse));margin-top:calc(2.5rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-10>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(2.5rem*(1 - var(--space-x-reverse)));margin-right:calc(2.5rem*var(--space-x-reverse))}.lg\\:space-y-12>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(3rem*var(--space-y-reverse));margin-top:calc(3rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-12>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(3rem*(1 - var(--space-x-reverse)));margin-right:calc(3rem*var(--space-x-reverse))}.lg\\:space-y-16>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(4rem*var(--space-y-reverse));margin-top:calc(4rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-16>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(4rem*(1 - var(--space-x-reverse)));margin-right:calc(4rem*var(--space-x-reverse))}.lg\\:space-y-20>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(5rem*var(--space-y-reverse));margin-top:calc(5rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-20>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(5rem*(1 - var(--space-x-reverse)));margin-right:calc(5rem*var(--space-x-reverse))}.lg\\:space-y-24>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(6rem*var(--space-y-reverse));margin-top:calc(6rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-24>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(6rem*(1 - var(--space-x-reverse)));margin-right:calc(6rem*var(--space-x-reverse))}.lg\\:space-y-32>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(8rem*var(--space-y-reverse));margin-top:calc(8rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-32>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(8rem*(1 - var(--space-x-reverse)));margin-right:calc(8rem*var(--space-x-reverse))}.lg\\:space-y-40>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(10rem*var(--space-y-reverse));margin-top:calc(10rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-40>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(10rem*(1 - var(--space-x-reverse)));margin-right:calc(10rem*var(--space-x-reverse))}.lg\\:space-y-48>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(12rem*var(--space-y-reverse));margin-top:calc(12rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-48>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(12rem*(1 - var(--space-x-reverse)));margin-right:calc(12rem*var(--space-x-reverse))}.lg\\:space-y-56>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(14rem*var(--space-y-reverse));margin-top:calc(14rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-56>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(14rem*(1 - var(--space-x-reverse)));margin-right:calc(14rem*var(--space-x-reverse))}.lg\\:space-y-64>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(16rem*var(--space-y-reverse));margin-top:calc(16rem*(1 - var(--space-y-reverse)))}.lg\\:space-x-64>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(16rem*(1 - var(--space-x-reverse)));margin-right:calc(16rem*var(--space-x-reverse))}.lg\\:space-y-px>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1px*var(--space-y-reverse));margin-top:calc(1px*(1 - var(--space-y-reverse)))}.lg\\:space-x-px>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1px*(1 - var(--space-x-reverse)));margin-right:calc(1px*var(--space-x-reverse))}.lg\\:-space-y-1>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-.25rem*var(--space-y-reverse));margin-top:calc(-.25rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-1>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-.25rem*(1 - var(--space-x-reverse)));margin-right:calc(-.25rem*var(--space-x-reverse))}.lg\\:-space-y-2>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-.5rem*var(--space-y-reverse));margin-top:calc(-.5rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-2>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-.5rem*(1 - var(--space-x-reverse)));margin-right:calc(-.5rem*var(--space-x-reverse))}.lg\\:-space-y-3>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-.75rem*var(--space-y-reverse));margin-top:calc(-.75rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-3>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-.75rem*(1 - var(--space-x-reverse)));margin-right:calc(-.75rem*var(--space-x-reverse))}.lg\\:-space-y-4>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1rem*var(--space-y-reverse));margin-top:calc(-1rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-4>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1rem*(1 - var(--space-x-reverse)));margin-right:calc(-1rem*var(--space-x-reverse))}.lg\\:-space-y-5>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1.25rem*var(--space-y-reverse));margin-top:calc(-1.25rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-5>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1.25rem*(1 - var(--space-x-reverse)));margin-right:calc(-1.25rem*var(--space-x-reverse))}.lg\\:-space-y-6>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1.5rem*var(--space-y-reverse));margin-top:calc(-1.5rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-6>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1.5rem*(1 - var(--space-x-reverse)));margin-right:calc(-1.5rem*var(--space-x-reverse))}.lg\\:-space-y-8>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-2rem*var(--space-y-reverse));margin-top:calc(-2rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-8>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-2rem*(1 - var(--space-x-reverse)));margin-right:calc(-2rem*var(--space-x-reverse))}.lg\\:-space-y-10>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-2.5rem*var(--space-y-reverse));margin-top:calc(-2.5rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-10>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-2.5rem*(1 - var(--space-x-reverse)));margin-right:calc(-2.5rem*var(--space-x-reverse))}.lg\\:-space-y-12>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-3rem*var(--space-y-reverse));margin-top:calc(-3rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-12>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-3rem*(1 - var(--space-x-reverse)));margin-right:calc(-3rem*var(--space-x-reverse))}.lg\\:-space-y-16>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-4rem*var(--space-y-reverse));margin-top:calc(-4rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-16>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-4rem*(1 - var(--space-x-reverse)));margin-right:calc(-4rem*var(--space-x-reverse))}.lg\\:-space-y-20>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-5rem*var(--space-y-reverse));margin-top:calc(-5rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-20>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-5rem*(1 - var(--space-x-reverse)));margin-right:calc(-5rem*var(--space-x-reverse))}.lg\\:-space-y-24>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-6rem*var(--space-y-reverse));margin-top:calc(-6rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-24>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-6rem*(1 - var(--space-x-reverse)));margin-right:calc(-6rem*var(--space-x-reverse))}.lg\\:-space-y-32>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-8rem*var(--space-y-reverse));margin-top:calc(-8rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-32>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-8rem*(1 - var(--space-x-reverse)));margin-right:calc(-8rem*var(--space-x-reverse))}.lg\\:-space-y-40>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-10rem*var(--space-y-reverse));margin-top:calc(-10rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-40>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-10rem*(1 - var(--space-x-reverse)));margin-right:calc(-10rem*var(--space-x-reverse))}.lg\\:-space-y-48>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-12rem*var(--space-y-reverse));margin-top:calc(-12rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-48>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-12rem*(1 - var(--space-x-reverse)));margin-right:calc(-12rem*var(--space-x-reverse))}.lg\\:-space-y-56>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-14rem*var(--space-y-reverse));margin-top:calc(-14rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-56>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-14rem*(1 - var(--space-x-reverse)));margin-right:calc(-14rem*var(--space-x-reverse))}.lg\\:-space-y-64>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-16rem*var(--space-y-reverse));margin-top:calc(-16rem*(1 - var(--space-y-reverse)))}.lg\\:-space-x-64>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-16rem*(1 - var(--space-x-reverse)));margin-right:calc(-16rem*var(--space-x-reverse))}.lg\\:-space-y-px>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1px*var(--space-y-reverse));margin-top:calc(-1px*(1 - var(--space-y-reverse)))}.lg\\:-space-x-px>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1px*(1 - var(--space-x-reverse)));margin-right:calc(-1px*var(--space-x-reverse))}.lg\\:space-y-reverse>:not(template)~:not(template){--space-y-reverse:1}.lg\\:space-x-reverse>:not(template)~:not(template){--space-x-reverse:1}.lg\\:divide-y-0>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(0px*var(--divide-y-reverse));border-top-width:calc(0px*(1 - var(--divide-y-reverse)))}.lg\\:divide-x-0>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(0px*(1 - var(--divide-x-reverse)));border-right-width:calc(0px*var(--divide-x-reverse))}.lg\\:divide-y-2>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(2px*var(--divide-y-reverse));border-top-width:calc(2px*(1 - var(--divide-y-reverse)))}.lg\\:divide-x-2>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(2px*(1 - var(--divide-x-reverse)));border-right-width:calc(2px*var(--divide-x-reverse))}.lg\\:divide-y-4>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(4px*var(--divide-y-reverse));border-top-width:calc(4px*(1 - var(--divide-y-reverse)))}.lg\\:divide-x-4>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(4px*(1 - var(--divide-x-reverse)));border-right-width:calc(4px*var(--divide-x-reverse))}.lg\\:divide-y-8>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(8px*var(--divide-y-reverse));border-top-width:calc(8px*(1 - var(--divide-y-reverse)))}.lg\\:divide-x-8>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(8px*(1 - var(--divide-x-reverse)));border-right-width:calc(8px*var(--divide-x-reverse))}.lg\\:divide-y>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(1px*var(--divide-y-reverse));border-top-width:calc(1px*(1 - var(--divide-y-reverse)))}.lg\\:divide-x>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(1px*(1 - var(--divide-x-reverse)));border-right-width:calc(1px*var(--divide-x-reverse))}.lg\\:divide-y-reverse>:not(template)~:not(template){--divide-y-reverse:1}.lg\\:divide-x-reverse>:not(template)~:not(template){--divide-x-reverse:1}.lg\\:divide-transparent>:not(template)~:not(template){border-color:#0000}.lg\\:divide-white>:not(template)~:not(template){--divide-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--divide-opacity))}.lg\\:divide-black>:not(template)~:not(template){--divide-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--divide-opacity))}.lg\\:divide-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--divide-opacity))}.lg\\:divide-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--divide-opacity))}.lg\\:divide-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--divide-opacity))}.lg\\:divide-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--divide-opacity))}.lg\\:divide-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--divide-opacity))}.lg\\:divide-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--divide-opacity))}.lg\\:divide-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--divide-opacity))}.lg\\:divide-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--divide-opacity))}.lg\\:divide-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--divide-opacity))}.lg\\:divide-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--divide-opacity))}.lg\\:divide-cool-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--divide-opacity))}.lg\\:divide-cool-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--divide-opacity))}.lg\\:divide-cool-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--divide-opacity))}.lg\\:divide-cool-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--divide-opacity))}.lg\\:divide-cool-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--divide-opacity))}.lg\\:divide-cool-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--divide-opacity))}.lg\\:divide-cool-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--divide-opacity))}.lg\\:divide-cool-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--divide-opacity))}.lg\\:divide-cool-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--divide-opacity))}.lg\\:divide-cool-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--divide-opacity))}.lg\\:divide-red-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--divide-opacity))}.lg\\:divide-red-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--divide-opacity))}.lg\\:divide-red-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--divide-opacity))}.lg\\:divide-red-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--divide-opacity))}.lg\\:divide-red-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--divide-opacity))}.lg\\:divide-red-500>:not(template)~:not(template){--divide-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--divide-opacity))}.lg\\:divide-red-600>:not(template)~:not(template){--divide-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--divide-opacity))}.lg\\:divide-red-700>:not(template)~:not(template){--divide-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--divide-opacity))}.lg\\:divide-red-800>:not(template)~:not(template){--divide-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--divide-opacity))}.lg\\:divide-red-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.lg\\:divide-orange-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--divide-opacity))}.lg\\:divide-orange-100>:not(template)~:not(template){--divide-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--divide-opacity))}.lg\\:divide-orange-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--divide-opacity))}.lg\\:divide-orange-300>:not(template)~:not(template){--divide-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--divide-opacity))}.lg\\:divide-orange-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--divide-opacity))}.lg\\:divide-orange-500>:not(template)~:not(template){--divide-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--divide-opacity))}.lg\\:divide-orange-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--divide-opacity))}.lg\\:divide-orange-700>:not(template)~:not(template){--divide-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--divide-opacity))}.lg\\:divide-orange-800>:not(template)~:not(template){--divide-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--divide-opacity))}.lg\\:divide-orange-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.lg\\:divide-yellow-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--divide-opacity))}.lg\\:divide-yellow-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--divide-opacity))}.lg\\:divide-yellow-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--divide-opacity))}.lg\\:divide-yellow-300>:not(template)~:not(template){--divide-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--divide-opacity))}.lg\\:divide-yellow-400>:not(template)~:not(template){--divide-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--divide-opacity))}.lg\\:divide-yellow-500>:not(template)~:not(template){--divide-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--divide-opacity))}.lg\\:divide-yellow-600>:not(template)~:not(template){--divide-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--divide-opacity))}.lg\\:divide-yellow-700>:not(template)~:not(template){--divide-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--divide-opacity))}.lg\\:divide-yellow-800>:not(template)~:not(template){--divide-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--divide-opacity))}.lg\\:divide-yellow-900>:not(template)~:not(template){--divide-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--divide-opacity))}.lg\\:divide-green-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--divide-opacity))}.lg\\:divide-green-100>:not(template)~:not(template){--divide-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--divide-opacity))}.lg\\:divide-green-200>:not(template)~:not(template){--divide-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--divide-opacity))}.lg\\:divide-green-300>:not(template)~:not(template){--divide-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--divide-opacity))}.lg\\:divide-green-400>:not(template)~:not(template){--divide-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--divide-opacity))}.lg\\:divide-green-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--divide-opacity))}.lg\\:divide-green-600>:not(template)~:not(template){--divide-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--divide-opacity))}.lg\\:divide-green-700>:not(template)~:not(template){--divide-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--divide-opacity))}.lg\\:divide-green-800>:not(template)~:not(template){--divide-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--divide-opacity))}.lg\\:divide-green-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--divide-opacity))}.lg\\:divide-teal-50>:not(template)~:not(template){--divide-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--divide-opacity))}.lg\\:divide-teal-100>:not(template)~:not(template){--divide-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--divide-opacity))}.lg\\:divide-teal-200>:not(template)~:not(template){--divide-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--divide-opacity))}.lg\\:divide-teal-300>:not(template)~:not(template){--divide-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--divide-opacity))}.lg\\:divide-teal-400>:not(template)~:not(template){--divide-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--divide-opacity))}.lg\\:divide-teal-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--divide-opacity))}.lg\\:divide-teal-600>:not(template)~:not(template){--divide-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--divide-opacity))}.lg\\:divide-teal-700>:not(template)~:not(template){--divide-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--divide-opacity))}.lg\\:divide-teal-800>:not(template)~:not(template){--divide-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--divide-opacity))}.lg\\:divide-teal-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--divide-opacity))}.lg\\:divide-blue-50>:not(template)~:not(template){--divide-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--divide-opacity))}.lg\\:divide-blue-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--divide-opacity))}.lg\\:divide-blue-200>:not(template)~:not(template){--divide-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--divide-opacity))}.lg\\:divide-blue-300>:not(template)~:not(template){--divide-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--divide-opacity))}.lg\\:divide-blue-400>:not(template)~:not(template){--divide-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--divide-opacity))}.lg\\:divide-blue-500>:not(template)~:not(template){--divide-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--divide-opacity))}.lg\\:divide-blue-600>:not(template)~:not(template){--divide-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--divide-opacity))}.lg\\:divide-blue-700>:not(template)~:not(template){--divide-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--divide-opacity))}.lg\\:divide-blue-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--divide-opacity))}.lg\\:divide-blue-900>:not(template)~:not(template){--divide-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--divide-opacity))}.lg\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--divide-opacity))}.lg\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--divide-opacity))}.lg\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--divide-opacity))}.lg\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--divide-opacity))}.lg\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--divide-opacity))}.lg\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--divide-opacity))}.lg\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--divide-opacity))}.lg\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--divide-opacity))}.lg\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--divide-opacity))}.lg\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--divide-opacity))}.lg\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--divide-opacity))}.lg\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--divide-opacity))}.lg\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--divide-opacity))}.lg\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--divide-opacity))}.lg\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--divide-opacity))}.lg\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--divide-opacity))}.lg\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--divide-opacity))}.lg\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--divide-opacity))}.lg\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--divide-opacity))}.lg\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--divide-opacity))}.lg\\:divide-pink-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--divide-opacity))}.lg\\:divide-pink-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--divide-opacity))}.lg\\:divide-pink-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--divide-opacity))}.lg\\:divide-pink-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--divide-opacity))}.lg\\:divide-pink-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--divide-opacity))}.lg\\:divide-pink-500>:not(template)~:not(template){--divide-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--divide-opacity))}.lg\\:divide-pink-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--divide-opacity))}.lg\\:divide-pink-700>:not(template)~:not(template){--divide-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--divide-opacity))}.lg\\:divide-pink-800>:not(template)~:not(template){--divide-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--divide-opacity))}.lg\\:divide-pink-900>:not(template)~:not(template){--divide-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-transparent>:not(template)~:not(template){border-color:#0000}.theme-dark .lg\\:dark\\:divide-white>:not(template)~:not(template){--divide-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-black>:not(template)~:not(template){--divide-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-cool-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-cool-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-cool-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-cool-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-cool-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-cool-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-cool-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-cool-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-cool-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-cool-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-red-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-red-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-red-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-red-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-red-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-red-500>:not(template)~:not(template){--divide-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-red-600>:not(template)~:not(template){--divide-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-red-700>:not(template)~:not(template){--divide-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-red-800>:not(template)~:not(template){--divide-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-red-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-orange-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-orange-100>:not(template)~:not(template){--divide-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-orange-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-orange-300>:not(template)~:not(template){--divide-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-orange-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-orange-500>:not(template)~:not(template){--divide-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-orange-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-orange-700>:not(template)~:not(template){--divide-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-orange-800>:not(template)~:not(template){--divide-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-orange-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-yellow-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-yellow-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-yellow-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-yellow-300>:not(template)~:not(template){--divide-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-yellow-400>:not(template)~:not(template){--divide-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-yellow-500>:not(template)~:not(template){--divide-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-yellow-600>:not(template)~:not(template){--divide-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-yellow-700>:not(template)~:not(template){--divide-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-yellow-800>:not(template)~:not(template){--divide-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-yellow-900>:not(template)~:not(template){--divide-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-green-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-green-100>:not(template)~:not(template){--divide-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-green-200>:not(template)~:not(template){--divide-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-green-300>:not(template)~:not(template){--divide-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-green-400>:not(template)~:not(template){--divide-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-green-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-green-600>:not(template)~:not(template){--divide-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-green-700>:not(template)~:not(template){--divide-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-green-800>:not(template)~:not(template){--divide-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-green-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-teal-50>:not(template)~:not(template){--divide-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-teal-100>:not(template)~:not(template){--divide-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-teal-200>:not(template)~:not(template){--divide-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-teal-300>:not(template)~:not(template){--divide-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-teal-400>:not(template)~:not(template){--divide-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-teal-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-teal-600>:not(template)~:not(template){--divide-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-teal-700>:not(template)~:not(template){--divide-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-teal-800>:not(template)~:not(template){--divide-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-teal-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-blue-50>:not(template)~:not(template){--divide-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-blue-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-blue-200>:not(template)~:not(template){--divide-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-blue-300>:not(template)~:not(template){--divide-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-blue-400>:not(template)~:not(template){--divide-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-blue-500>:not(template)~:not(template){--divide-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-blue-600>:not(template)~:not(template){--divide-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-blue-700>:not(template)~:not(template){--divide-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-blue-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-blue-900>:not(template)~:not(template){--divide-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-pink-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-pink-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-pink-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-pink-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-pink-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-pink-500>:not(template)~:not(template){--divide-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-pink-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-pink-700>:not(template)~:not(template){--divide-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-pink-800>:not(template)~:not(template){--divide-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--divide-opacity))}.theme-dark .lg\\:dark\\:divide-pink-900>:not(template)~:not(template){--divide-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--divide-opacity))}.lg\\:divide-opacity-0>:not(template)~:not(template){--divide-opacity:0}.lg\\:divide-opacity-25>:not(template)~:not(template){--divide-opacity:0.25}.lg\\:divide-opacity-50>:not(template)~:not(template){--divide-opacity:0.5}.lg\\:divide-opacity-75>:not(template)~:not(template){--divide-opacity:0.75}.lg\\:divide-opacity-100>:not(template)~:not(template){--divide-opacity:1}.lg\\:sr-only{height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;clip:rect(0,0,0,0);border-width:0;white-space:nowrap}.lg\\:not-sr-only{height:auto;margin:0;overflow:visible;padding:0;position:static;width:auto;clip:auto;white-space:normal}.lg\\:focus\\:sr-only:focus{height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;clip:rect(0,0,0,0);border-width:0;white-space:nowrap}.lg\\:focus\\:not-sr-only:focus{height:auto;margin:0;overflow:visible;padding:0;position:static;width:auto;clip:auto;white-space:normal}.lg\\:appearance-none{-webkit-appearance:none;appearance:none}.lg\\:bg-fixed{background-attachment:fixed}.lg\\:bg-local{background-attachment:local}.lg\\:bg-scroll{background-attachment:scroll}.lg\\:bg-transparent{background-color:initial}.lg\\:bg-white{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.lg\\:bg-black{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.lg\\:bg-gray-50{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.lg\\:bg-gray-100{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.lg\\:bg-gray-200{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.lg\\:bg-gray-300{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.lg\\:bg-gray-400{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.lg\\:bg-gray-500{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.lg\\:bg-gray-600{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.lg\\:bg-gray-700{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.lg\\:bg-gray-800{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.lg\\:bg-gray-900{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.lg\\:bg-cool-gray-50{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.lg\\:bg-cool-gray-100{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.lg\\:bg-cool-gray-200{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.lg\\:bg-cool-gray-300{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.lg\\:bg-cool-gray-400{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.lg\\:bg-cool-gray-500{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.lg\\:bg-cool-gray-600{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.lg\\:bg-cool-gray-700{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.lg\\:bg-cool-gray-800{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.lg\\:bg-cool-gray-900{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.lg\\:bg-red-50{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.lg\\:bg-red-100{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.lg\\:bg-red-200{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.lg\\:bg-red-300{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.lg\\:bg-red-400{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.lg\\:bg-red-500{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.lg\\:bg-red-600{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.lg\\:bg-red-700{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.lg\\:bg-red-800{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.lg\\:bg-red-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.lg\\:bg-orange-50{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.lg\\:bg-orange-100{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.lg\\:bg-orange-200{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.lg\\:bg-orange-300{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.lg\\:bg-orange-400{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.lg\\:bg-orange-500{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.lg\\:bg-orange-600{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.lg\\:bg-orange-700{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.lg\\:bg-orange-800{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.lg\\:bg-orange-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.lg\\:bg-yellow-50{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.lg\\:bg-yellow-100{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.lg\\:bg-yellow-200{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.lg\\:bg-yellow-300{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.lg\\:bg-yellow-400{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.lg\\:bg-yellow-500{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.lg\\:bg-yellow-600{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.lg\\:bg-yellow-700{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.lg\\:bg-yellow-800{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.lg\\:bg-yellow-900{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.lg\\:bg-green-50{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.lg\\:bg-green-100{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.lg\\:bg-green-200{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.lg\\:bg-green-300{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.lg\\:bg-green-400{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.lg\\:bg-green-500{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.lg\\:bg-green-600{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.lg\\:bg-green-700{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.lg\\:bg-green-800{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.lg\\:bg-green-900{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.lg\\:bg-teal-50{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.lg\\:bg-teal-100{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.lg\\:bg-teal-200{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.lg\\:bg-teal-300{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.lg\\:bg-teal-400{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.lg\\:bg-teal-500{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.lg\\:bg-teal-600{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.lg\\:bg-teal-700{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.lg\\:bg-teal-800{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.lg\\:bg-teal-900{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.lg\\:bg-blue-50{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.lg\\:bg-blue-100{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.lg\\:bg-blue-200{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.lg\\:bg-blue-300{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.lg\\:bg-blue-400{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.lg\\:bg-blue-500{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.lg\\:bg-blue-600{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.lg\\:bg-blue-700{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.lg\\:bg-blue-800{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.lg\\:bg-blue-900{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.lg\\:bg-indigo-50{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.lg\\:bg-indigo-100{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.lg\\:bg-indigo-200{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.lg\\:bg-indigo-300{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.lg\\:bg-indigo-400{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.lg\\:bg-indigo-500{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.lg\\:bg-indigo-600{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.lg\\:bg-indigo-700{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.lg\\:bg-indigo-800{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.lg\\:bg-indigo-900{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.lg\\:bg-indigo-50{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.lg\\:bg-indigo-100{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.lg\\:bg-indigo-200{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.lg\\:bg-indigo-300{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.lg\\:bg-indigo-400{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.lg\\:bg-indigo-500{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.lg\\:bg-indigo-600{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.lg\\:bg-indigo-700{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.lg\\:bg-indigo-800{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.lg\\:bg-indigo-900{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.lg\\:bg-pink-50{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.lg\\:bg-pink-100{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.lg\\:bg-pink-200{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.lg\\:bg-pink-300{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.lg\\:bg-pink-400{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.lg\\:bg-pink-500{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.lg\\:bg-pink-600{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.lg\\:bg-pink-700{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.lg\\:bg-pink-800{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.lg\\:bg-pink-900{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.lg\\:hover\\:bg-transparent:hover{background-color:initial}.lg\\:hover\\:bg-white:hover{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.lg\\:hover\\:bg-black:hover{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.lg\\:hover\\:bg-gray-50:hover{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.lg\\:hover\\:bg-gray-100:hover{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.lg\\:hover\\:bg-gray-200:hover{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.lg\\:hover\\:bg-gray-300:hover{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.lg\\:hover\\:bg-gray-400:hover{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.lg\\:hover\\:bg-gray-500:hover{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.lg\\:hover\\:bg-gray-600:hover{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.lg\\:hover\\:bg-gray-700:hover{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.lg\\:hover\\:bg-gray-800:hover{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.lg\\:hover\\:bg-gray-900:hover{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.lg\\:hover\\:bg-cool-gray-50:hover{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.lg\\:hover\\:bg-cool-gray-100:hover{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.lg\\:hover\\:bg-cool-gray-200:hover{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.lg\\:hover\\:bg-cool-gray-300:hover{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.lg\\:hover\\:bg-cool-gray-400:hover{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.lg\\:hover\\:bg-cool-gray-500:hover{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.lg\\:hover\\:bg-cool-gray-600:hover{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.lg\\:hover\\:bg-cool-gray-700:hover{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.lg\\:hover\\:bg-cool-gray-800:hover{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.lg\\:hover\\:bg-cool-gray-900:hover{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.lg\\:hover\\:bg-red-50:hover{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.lg\\:hover\\:bg-red-100:hover{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.lg\\:hover\\:bg-red-200:hover{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.lg\\:hover\\:bg-red-300:hover{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.lg\\:hover\\:bg-red-400:hover{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.lg\\:hover\\:bg-red-500:hover{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.lg\\:hover\\:bg-red-600:hover{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.lg\\:hover\\:bg-red-700:hover{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.lg\\:hover\\:bg-red-800:hover{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.lg\\:hover\\:bg-red-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.lg\\:hover\\:bg-orange-50:hover{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.lg\\:hover\\:bg-orange-100:hover{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.lg\\:hover\\:bg-orange-200:hover{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.lg\\:hover\\:bg-orange-300:hover{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.lg\\:hover\\:bg-orange-400:hover{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.lg\\:hover\\:bg-orange-500:hover{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.lg\\:hover\\:bg-orange-600:hover{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.lg\\:hover\\:bg-orange-700:hover{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.lg\\:hover\\:bg-orange-800:hover{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.lg\\:hover\\:bg-orange-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.lg\\:hover\\:bg-yellow-50:hover{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.lg\\:hover\\:bg-yellow-100:hover{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.lg\\:hover\\:bg-yellow-200:hover{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.lg\\:hover\\:bg-yellow-300:hover{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.lg\\:hover\\:bg-yellow-400:hover{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.lg\\:hover\\:bg-yellow-500:hover{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.lg\\:hover\\:bg-yellow-600:hover{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.lg\\:hover\\:bg-yellow-700:hover{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.lg\\:hover\\:bg-yellow-800:hover{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.lg\\:hover\\:bg-yellow-900:hover{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.lg\\:hover\\:bg-green-50:hover{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.lg\\:hover\\:bg-green-100:hover{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.lg\\:hover\\:bg-green-200:hover{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.lg\\:hover\\:bg-green-300:hover{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.lg\\:hover\\:bg-green-400:hover{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.lg\\:hover\\:bg-green-500:hover{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.lg\\:hover\\:bg-green-600:hover{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.lg\\:hover\\:bg-green-700:hover{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.lg\\:hover\\:bg-green-800:hover{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.lg\\:hover\\:bg-green-900:hover{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.lg\\:hover\\:bg-teal-50:hover{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.lg\\:hover\\:bg-teal-100:hover{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.lg\\:hover\\:bg-teal-200:hover{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.lg\\:hover\\:bg-teal-300:hover{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.lg\\:hover\\:bg-teal-400:hover{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.lg\\:hover\\:bg-teal-500:hover{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.lg\\:hover\\:bg-teal-600:hover{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.lg\\:hover\\:bg-teal-700:hover{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.lg\\:hover\\:bg-teal-800:hover{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.lg\\:hover\\:bg-teal-900:hover{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.lg\\:hover\\:bg-blue-50:hover{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.lg\\:hover\\:bg-blue-100:hover{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.lg\\:hover\\:bg-blue-200:hover{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.lg\\:hover\\:bg-blue-300:hover{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.lg\\:hover\\:bg-blue-400:hover{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.lg\\:hover\\:bg-blue-500:hover{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.lg\\:hover\\:bg-blue-600:hover{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.lg\\:hover\\:bg-blue-700:hover{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.lg\\:hover\\:bg-blue-800:hover{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.lg\\:hover\\:bg-blue-900:hover{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.lg\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.lg\\:hover\\:bg-pink-50:hover{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.lg\\:hover\\:bg-pink-100:hover{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.lg\\:hover\\:bg-pink-200:hover{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.lg\\:hover\\:bg-pink-300:hover{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.lg\\:hover\\:bg-pink-400:hover{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.lg\\:hover\\:bg-pink-500:hover{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.lg\\:hover\\:bg-pink-600:hover{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.lg\\:hover\\:bg-pink-700:hover{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.lg\\:hover\\:bg-pink-800:hover{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.lg\\:hover\\:bg-pink-900:hover{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.lg\\:focus\\:bg-transparent:focus{background-color:initial}.lg\\:focus\\:bg-white:focus{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.lg\\:focus\\:bg-black:focus{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.lg\\:focus\\:bg-gray-50:focus{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.lg\\:focus\\:bg-gray-100:focus{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.lg\\:focus\\:bg-gray-200:focus{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.lg\\:focus\\:bg-gray-300:focus{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.lg\\:focus\\:bg-gray-400:focus{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.lg\\:focus\\:bg-gray-500:focus{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.lg\\:focus\\:bg-gray-600:focus{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.lg\\:focus\\:bg-gray-700:focus{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.lg\\:focus\\:bg-gray-800:focus{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.lg\\:focus\\:bg-gray-900:focus{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.lg\\:focus\\:bg-cool-gray-50:focus{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.lg\\:focus\\:bg-cool-gray-100:focus{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.lg\\:focus\\:bg-cool-gray-200:focus{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.lg\\:focus\\:bg-cool-gray-300:focus{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.lg\\:focus\\:bg-cool-gray-400:focus{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.lg\\:focus\\:bg-cool-gray-500:focus{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.lg\\:focus\\:bg-cool-gray-600:focus{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.lg\\:focus\\:bg-cool-gray-700:focus{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.lg\\:focus\\:bg-cool-gray-800:focus{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.lg\\:focus\\:bg-cool-gray-900:focus{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.lg\\:focus\\:bg-red-50:focus{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.lg\\:focus\\:bg-red-100:focus{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.lg\\:focus\\:bg-red-200:focus{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.lg\\:focus\\:bg-red-300:focus{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.lg\\:focus\\:bg-red-400:focus{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.lg\\:focus\\:bg-red-500:focus{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.lg\\:focus\\:bg-red-600:focus{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.lg\\:focus\\:bg-red-700:focus{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.lg\\:focus\\:bg-red-800:focus{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.lg\\:focus\\:bg-red-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.lg\\:focus\\:bg-orange-50:focus{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.lg\\:focus\\:bg-orange-100:focus{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.lg\\:focus\\:bg-orange-200:focus{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.lg\\:focus\\:bg-orange-300:focus{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.lg\\:focus\\:bg-orange-400:focus{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.lg\\:focus\\:bg-orange-500:focus{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.lg\\:focus\\:bg-orange-600:focus{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.lg\\:focus\\:bg-orange-700:focus{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.lg\\:focus\\:bg-orange-800:focus{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.lg\\:focus\\:bg-orange-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.lg\\:focus\\:bg-yellow-50:focus{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.lg\\:focus\\:bg-yellow-100:focus{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.lg\\:focus\\:bg-yellow-200:focus{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.lg\\:focus\\:bg-yellow-300:focus{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.lg\\:focus\\:bg-yellow-400:focus{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.lg\\:focus\\:bg-yellow-500:focus{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.lg\\:focus\\:bg-yellow-600:focus{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.lg\\:focus\\:bg-yellow-700:focus{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.lg\\:focus\\:bg-yellow-800:focus{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.lg\\:focus\\:bg-yellow-900:focus{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.lg\\:focus\\:bg-green-50:focus{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.lg\\:focus\\:bg-green-100:focus{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.lg\\:focus\\:bg-green-200:focus{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.lg\\:focus\\:bg-green-300:focus{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.lg\\:focus\\:bg-green-400:focus{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.lg\\:focus\\:bg-green-500:focus{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.lg\\:focus\\:bg-green-600:focus{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.lg\\:focus\\:bg-green-700:focus{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.lg\\:focus\\:bg-green-800:focus{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.lg\\:focus\\:bg-green-900:focus{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.lg\\:focus\\:bg-teal-50:focus{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.lg\\:focus\\:bg-teal-100:focus{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.lg\\:focus\\:bg-teal-200:focus{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.lg\\:focus\\:bg-teal-300:focus{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.lg\\:focus\\:bg-teal-400:focus{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.lg\\:focus\\:bg-teal-500:focus{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.lg\\:focus\\:bg-teal-600:focus{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.lg\\:focus\\:bg-teal-700:focus{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.lg\\:focus\\:bg-teal-800:focus{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.lg\\:focus\\:bg-teal-900:focus{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.lg\\:focus\\:bg-blue-50:focus{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.lg\\:focus\\:bg-blue-100:focus{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.lg\\:focus\\:bg-blue-200:focus{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.lg\\:focus\\:bg-blue-300:focus{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.lg\\:focus\\:bg-blue-400:focus{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.lg\\:focus\\:bg-blue-500:focus{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.lg\\:focus\\:bg-blue-600:focus{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.lg\\:focus\\:bg-blue-700:focus{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.lg\\:focus\\:bg-blue-800:focus{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.lg\\:focus\\:bg-blue-900:focus{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.lg\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.lg\\:focus\\:bg-pink-50:focus{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.lg\\:focus\\:bg-pink-100:focus{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.lg\\:focus\\:bg-pink-200:focus{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.lg\\:focus\\:bg-pink-300:focus{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.lg\\:focus\\:bg-pink-400:focus{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.lg\\:focus\\:bg-pink-500:focus{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.lg\\:focus\\:bg-pink-600:focus{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.lg\\:focus\\:bg-pink-700:focus{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.lg\\:focus\\:bg-pink-800:focus{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.lg\\:focus\\:bg-pink-900:focus{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.lg\\:active\\:bg-transparent:active{background-color:initial}.lg\\:active\\:bg-white:active{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.lg\\:active\\:bg-black:active{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.lg\\:active\\:bg-gray-50:active{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.lg\\:active\\:bg-gray-100:active{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.lg\\:active\\:bg-gray-200:active{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.lg\\:active\\:bg-gray-300:active{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.lg\\:active\\:bg-gray-400:active{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.lg\\:active\\:bg-gray-500:active{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.lg\\:active\\:bg-gray-600:active{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.lg\\:active\\:bg-gray-700:active{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.lg\\:active\\:bg-gray-800:active{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.lg\\:active\\:bg-gray-900:active{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.lg\\:active\\:bg-cool-gray-50:active{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.lg\\:active\\:bg-cool-gray-100:active{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.lg\\:active\\:bg-cool-gray-200:active{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.lg\\:active\\:bg-cool-gray-300:active{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.lg\\:active\\:bg-cool-gray-400:active{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.lg\\:active\\:bg-cool-gray-500:active{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.lg\\:active\\:bg-cool-gray-600:active{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.lg\\:active\\:bg-cool-gray-700:active{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.lg\\:active\\:bg-cool-gray-800:active{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.lg\\:active\\:bg-cool-gray-900:active{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.lg\\:active\\:bg-red-50:active{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.lg\\:active\\:bg-red-100:active{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.lg\\:active\\:bg-red-200:active{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.lg\\:active\\:bg-red-300:active{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.lg\\:active\\:bg-red-400:active{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.lg\\:active\\:bg-red-500:active{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.lg\\:active\\:bg-red-600:active{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.lg\\:active\\:bg-red-700:active{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.lg\\:active\\:bg-red-800:active{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.lg\\:active\\:bg-red-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.lg\\:active\\:bg-orange-50:active{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.lg\\:active\\:bg-orange-100:active{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.lg\\:active\\:bg-orange-200:active{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.lg\\:active\\:bg-orange-300:active{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.lg\\:active\\:bg-orange-400:active{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.lg\\:active\\:bg-orange-500:active{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.lg\\:active\\:bg-orange-600:active{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.lg\\:active\\:bg-orange-700:active{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.lg\\:active\\:bg-orange-800:active{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.lg\\:active\\:bg-orange-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.lg\\:active\\:bg-yellow-50:active{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.lg\\:active\\:bg-yellow-100:active{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.lg\\:active\\:bg-yellow-200:active{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.lg\\:active\\:bg-yellow-300:active{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.lg\\:active\\:bg-yellow-400:active{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.lg\\:active\\:bg-yellow-500:active{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.lg\\:active\\:bg-yellow-600:active{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.lg\\:active\\:bg-yellow-700:active{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.lg\\:active\\:bg-yellow-800:active{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.lg\\:active\\:bg-yellow-900:active{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.lg\\:active\\:bg-green-50:active{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.lg\\:active\\:bg-green-100:active{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.lg\\:active\\:bg-green-200:active{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.lg\\:active\\:bg-green-300:active{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.lg\\:active\\:bg-green-400:active{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.lg\\:active\\:bg-green-500:active{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.lg\\:active\\:bg-green-600:active{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.lg\\:active\\:bg-green-700:active{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.lg\\:active\\:bg-green-800:active{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.lg\\:active\\:bg-green-900:active{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.lg\\:active\\:bg-teal-50:active{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.lg\\:active\\:bg-teal-100:active{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.lg\\:active\\:bg-teal-200:active{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.lg\\:active\\:bg-teal-300:active{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.lg\\:active\\:bg-teal-400:active{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.lg\\:active\\:bg-teal-500:active{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.lg\\:active\\:bg-teal-600:active{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.lg\\:active\\:bg-teal-700:active{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.lg\\:active\\:bg-teal-800:active{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.lg\\:active\\:bg-teal-900:active{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.lg\\:active\\:bg-blue-50:active{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.lg\\:active\\:bg-blue-100:active{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.lg\\:active\\:bg-blue-200:active{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.lg\\:active\\:bg-blue-300:active{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.lg\\:active\\:bg-blue-400:active{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.lg\\:active\\:bg-blue-500:active{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.lg\\:active\\:bg-blue-600:active{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.lg\\:active\\:bg-blue-700:active{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.lg\\:active\\:bg-blue-800:active{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.lg\\:active\\:bg-blue-900:active{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.lg\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.lg\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.lg\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.lg\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.lg\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.lg\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.lg\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.lg\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.lg\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.lg\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.lg\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.lg\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.lg\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.lg\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.lg\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.lg\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.lg\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.lg\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.lg\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.lg\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.lg\\:active\\:bg-pink-50:active{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.lg\\:active\\:bg-pink-100:active{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.lg\\:active\\:bg-pink-200:active{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.lg\\:active\\:bg-pink-300:active{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.lg\\:active\\:bg-pink-400:active{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.lg\\:active\\:bg-pink-500:active{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.lg\\:active\\:bg-pink-600:active{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.lg\\:active\\:bg-pink-700:active{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.lg\\:active\\:bg-pink-800:active{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.lg\\:active\\:bg-pink-900:active{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.lg\\:odd\\:bg-transparent:nth-child(odd){background-color:initial}.lg\\:odd\\:bg-white:nth-child(odd){--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.lg\\:odd\\:bg-black:nth-child(odd){--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.lg\\:odd\\:bg-gray-50:nth-child(odd){--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.lg\\:odd\\:bg-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.lg\\:odd\\:bg-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.lg\\:odd\\:bg-gray-300:nth-child(odd){--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.lg\\:odd\\:bg-gray-400:nth-child(odd){--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.lg\\:odd\\:bg-gray-500:nth-child(odd){--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.lg\\:odd\\:bg-gray-600:nth-child(odd){--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.lg\\:odd\\:bg-gray-700:nth-child(odd){--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.lg\\:odd\\:bg-gray-800:nth-child(odd){--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.lg\\:odd\\:bg-gray-900:nth-child(odd){--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.lg\\:odd\\:bg-cool-gray-50:nth-child(odd){--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.lg\\:odd\\:bg-cool-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.lg\\:odd\\:bg-cool-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.lg\\:odd\\:bg-cool-gray-300:nth-child(odd){--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.lg\\:odd\\:bg-cool-gray-400:nth-child(odd){--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.lg\\:odd\\:bg-cool-gray-500:nth-child(odd){--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.lg\\:odd\\:bg-cool-gray-600:nth-child(odd){--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.lg\\:odd\\:bg-cool-gray-700:nth-child(odd){--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.lg\\:odd\\:bg-cool-gray-800:nth-child(odd){--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.lg\\:odd\\:bg-cool-gray-900:nth-child(odd){--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.lg\\:odd\\:bg-red-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.lg\\:odd\\:bg-red-100:nth-child(odd){--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.lg\\:odd\\:bg-red-200:nth-child(odd){--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.lg\\:odd\\:bg-red-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.lg\\:odd\\:bg-red-400:nth-child(odd){--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.lg\\:odd\\:bg-red-500:nth-child(odd){--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.lg\\:odd\\:bg-red-600:nth-child(odd){--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.lg\\:odd\\:bg-red-700:nth-child(odd){--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.lg\\:odd\\:bg-red-800:nth-child(odd){--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.lg\\:odd\\:bg-red-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.lg\\:odd\\:bg-orange-50:nth-child(odd){--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.lg\\:odd\\:bg-orange-100:nth-child(odd){--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.lg\\:odd\\:bg-orange-200:nth-child(odd){--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.lg\\:odd\\:bg-orange-300:nth-child(odd){--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.lg\\:odd\\:bg-orange-400:nth-child(odd){--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.lg\\:odd\\:bg-orange-500:nth-child(odd){--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.lg\\:odd\\:bg-orange-600:nth-child(odd){--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.lg\\:odd\\:bg-orange-700:nth-child(odd){--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.lg\\:odd\\:bg-orange-800:nth-child(odd){--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.lg\\:odd\\:bg-orange-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.lg\\:odd\\:bg-yellow-50:nth-child(odd){--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.lg\\:odd\\:bg-yellow-100:nth-child(odd){--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.lg\\:odd\\:bg-yellow-200:nth-child(odd){--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.lg\\:odd\\:bg-yellow-300:nth-child(odd){--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.lg\\:odd\\:bg-yellow-400:nth-child(odd){--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.lg\\:odd\\:bg-yellow-500:nth-child(odd){--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.lg\\:odd\\:bg-yellow-600:nth-child(odd){--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.lg\\:odd\\:bg-yellow-700:nth-child(odd){--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.lg\\:odd\\:bg-yellow-800:nth-child(odd){--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.lg\\:odd\\:bg-yellow-900:nth-child(odd){--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.lg\\:odd\\:bg-green-50:nth-child(odd){--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.lg\\:odd\\:bg-green-100:nth-child(odd){--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.lg\\:odd\\:bg-green-200:nth-child(odd){--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.lg\\:odd\\:bg-green-300:nth-child(odd){--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.lg\\:odd\\:bg-green-400:nth-child(odd){--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.lg\\:odd\\:bg-green-500:nth-child(odd){--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.lg\\:odd\\:bg-green-600:nth-child(odd){--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.lg\\:odd\\:bg-green-700:nth-child(odd){--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.lg\\:odd\\:bg-green-800:nth-child(odd){--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.lg\\:odd\\:bg-green-900:nth-child(odd){--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.lg\\:odd\\:bg-teal-50:nth-child(odd){--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.lg\\:odd\\:bg-teal-100:nth-child(odd){--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.lg\\:odd\\:bg-teal-200:nth-child(odd){--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.lg\\:odd\\:bg-teal-300:nth-child(odd){--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.lg\\:odd\\:bg-teal-400:nth-child(odd){--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.lg\\:odd\\:bg-teal-500:nth-child(odd){--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.lg\\:odd\\:bg-teal-600:nth-child(odd){--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.lg\\:odd\\:bg-teal-700:nth-child(odd){--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.lg\\:odd\\:bg-teal-800:nth-child(odd){--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.lg\\:odd\\:bg-teal-900:nth-child(odd){--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.lg\\:odd\\:bg-blue-50:nth-child(odd){--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.lg\\:odd\\:bg-blue-100:nth-child(odd){--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.lg\\:odd\\:bg-blue-200:nth-child(odd){--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.lg\\:odd\\:bg-blue-300:nth-child(odd){--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.lg\\:odd\\:bg-blue-400:nth-child(odd){--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.lg\\:odd\\:bg-blue-500:nth-child(odd){--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.lg\\:odd\\:bg-blue-600:nth-child(odd){--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.lg\\:odd\\:bg-blue-700:nth-child(odd){--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.lg\\:odd\\:bg-blue-800:nth-child(odd){--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.lg\\:odd\\:bg-blue-900:nth-child(odd){--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.lg\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.lg\\:odd\\:bg-pink-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.lg\\:odd\\:bg-pink-100:nth-child(odd){--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.lg\\:odd\\:bg-pink-200:nth-child(odd){--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.lg\\:odd\\:bg-pink-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.lg\\:odd\\:bg-pink-400:nth-child(odd){--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.lg\\:odd\\:bg-pink-500:nth-child(odd){--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.lg\\:odd\\:bg-pink-600:nth-child(odd){--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.lg\\:odd\\:bg-pink-700:nth-child(odd){--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.lg\\:odd\\:bg-pink-800:nth-child(odd){--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.lg\\:odd\\:bg-pink-900:nth-child(odd){--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-transparent{background-color:initial}.theme-dark .lg\\:dark\\:bg-white{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-black{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-gray-50{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-gray-100{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-gray-200{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-gray-300{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-gray-400{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-gray-500{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-gray-600{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-gray-700{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-gray-800{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-gray-900{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-cool-gray-50{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-cool-gray-100{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-cool-gray-200{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-cool-gray-300{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-cool-gray-400{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-cool-gray-500{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-cool-gray-600{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-cool-gray-700{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-cool-gray-800{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-cool-gray-900{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-red-50{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-red-100{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-red-200{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-red-300{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-red-400{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-red-500{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-red-600{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-red-700{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-red-800{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-red-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-orange-50{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-orange-100{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-orange-200{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-orange-300{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-orange-400{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-orange-500{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-orange-600{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-orange-700{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-orange-800{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-orange-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-yellow-50{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-yellow-100{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-yellow-200{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-yellow-300{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-yellow-400{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-yellow-500{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-yellow-600{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-yellow-700{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-yellow-800{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-yellow-900{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-green-50{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-green-100{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-green-200{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-green-300{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-green-400{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-green-500{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-green-600{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-green-700{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-green-800{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-green-900{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-teal-50{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-teal-100{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-teal-200{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-teal-300{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-teal-400{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-teal-500{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-teal-600{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-teal-700{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-teal-800{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-teal-900{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-blue-50{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-blue-100{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-blue-200{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-blue-300{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-blue-400{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-blue-500{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-blue-600{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-blue-700{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-blue-800{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-blue-900{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-50{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-100{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-200{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-300{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-400{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-500{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-600{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-700{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-800{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-900{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-50{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-100{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-200{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-300{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-400{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-500{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-600{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-700{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-800{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-indigo-900{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-pink-50{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-pink-100{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-pink-200{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-pink-300{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-pink-400{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-pink-500{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-pink-600{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-pink-700{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-pink-800{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .lg\\:dark\\:bg-pink-900{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-transparent:hover{background-color:initial}.theme-dark .lg\\:dark\\:hover\\:bg-white:hover{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-black:hover{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-gray-50:hover{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-gray-100:hover{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-gray-200:hover{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-gray-300:hover{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-gray-400:hover{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-gray-500:hover{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-gray-600:hover{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-gray-700:hover{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-gray-800:hover{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-gray-900:hover{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-50:hover{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-100:hover{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-200:hover{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-300:hover{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-400:hover{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-500:hover{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-600:hover{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-700:hover{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-800:hover{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-cool-gray-900:hover{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-red-50:hover{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-red-100:hover{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-red-200:hover{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-red-300:hover{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-red-400:hover{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-red-500:hover{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-red-600:hover{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-red-700:hover{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-red-800:hover{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-red-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-orange-50:hover{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-orange-100:hover{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-orange-200:hover{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-orange-300:hover{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-orange-400:hover{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-orange-500:hover{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-orange-600:hover{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-orange-700:hover{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-orange-800:hover{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-orange-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-yellow-50:hover{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-yellow-100:hover{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-yellow-200:hover{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-yellow-300:hover{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-yellow-400:hover{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-yellow-500:hover{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-yellow-600:hover{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-yellow-700:hover{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-yellow-800:hover{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-yellow-900:hover{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-green-50:hover{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-green-100:hover{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-green-200:hover{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-green-300:hover{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-green-400:hover{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-green-500:hover{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-green-600:hover{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-green-700:hover{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-green-800:hover{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-green-900:hover{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-teal-50:hover{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-teal-100:hover{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-teal-200:hover{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-teal-300:hover{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-teal-400:hover{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-teal-500:hover{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-teal-600:hover{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-teal-700:hover{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-teal-800:hover{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-teal-900:hover{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-blue-50:hover{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-blue-100:hover{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-blue-200:hover{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-blue-300:hover{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-blue-400:hover{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-blue-500:hover{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-blue-600:hover{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-blue-700:hover{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-blue-800:hover{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-blue-900:hover{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-pink-50:hover{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-pink-100:hover{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-pink-200:hover{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-pink-300:hover{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-pink-400:hover{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-pink-500:hover{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-pink-600:hover{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-pink-700:hover{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-pink-800:hover{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .lg\\:dark\\:hover\\:bg-pink-900:hover{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-transparent:focus{background-color:initial}.theme-dark .lg\\:dark\\:focus\\:bg-white:focus{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-black:focus{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-gray-50:focus{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-gray-100:focus{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-gray-200:focus{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-gray-300:focus{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-gray-400:focus{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-gray-500:focus{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-gray-600:focus{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-gray-700:focus{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-gray-800:focus{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-gray-900:focus{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-50:focus{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-100:focus{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-200:focus{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-300:focus{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-400:focus{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-500:focus{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-600:focus{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-700:focus{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-800:focus{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-cool-gray-900:focus{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-red-50:focus{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-red-100:focus{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-red-200:focus{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-red-300:focus{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-red-400:focus{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-red-500:focus{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-red-600:focus{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-red-700:focus{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-red-800:focus{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-red-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-orange-50:focus{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-orange-100:focus{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-orange-200:focus{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-orange-300:focus{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-orange-400:focus{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-orange-500:focus{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-orange-600:focus{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-orange-700:focus{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-orange-800:focus{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-orange-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-yellow-50:focus{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-yellow-100:focus{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-yellow-200:focus{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-yellow-300:focus{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-yellow-400:focus{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-yellow-500:focus{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-yellow-600:focus{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-yellow-700:focus{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-yellow-800:focus{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-yellow-900:focus{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-green-50:focus{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-green-100:focus{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-green-200:focus{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-green-300:focus{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-green-400:focus{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-green-500:focus{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-green-600:focus{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-green-700:focus{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-green-800:focus{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-green-900:focus{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-teal-50:focus{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-teal-100:focus{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-teal-200:focus{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-teal-300:focus{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-teal-400:focus{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-teal-500:focus{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-teal-600:focus{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-teal-700:focus{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-teal-800:focus{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-teal-900:focus{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-blue-50:focus{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-blue-100:focus{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-blue-200:focus{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-blue-300:focus{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-blue-400:focus{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-blue-500:focus{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-blue-600:focus{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-blue-700:focus{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-blue-800:focus{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-blue-900:focus{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-pink-50:focus{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-pink-100:focus{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-pink-200:focus{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-pink-300:focus{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-pink-400:focus{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-pink-500:focus{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-pink-600:focus{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-pink-700:focus{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-pink-800:focus{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .lg\\:dark\\:focus\\:bg-pink-900:focus{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-transparent:active{background-color:initial}.theme-dark .lg\\:dark\\:active\\:bg-white:active{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-black:active{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-gray-50:active{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-gray-100:active{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-gray-200:active{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-gray-300:active{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-gray-400:active{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-gray-500:active{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-gray-600:active{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-gray-700:active{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-gray-800:active{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-gray-900:active{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-cool-gray-50:active{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-cool-gray-100:active{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-cool-gray-200:active{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-cool-gray-300:active{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-cool-gray-400:active{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-cool-gray-500:active{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-cool-gray-600:active{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-cool-gray-700:active{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-cool-gray-800:active{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-cool-gray-900:active{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-red-50:active{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-red-100:active{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-red-200:active{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-red-300:active{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-red-400:active{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-red-500:active{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-red-600:active{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-red-700:active{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-red-800:active{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-red-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-orange-50:active{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-orange-100:active{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-orange-200:active{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-orange-300:active{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-orange-400:active{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-orange-500:active{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-orange-600:active{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-orange-700:active{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-orange-800:active{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-orange-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-yellow-50:active{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-yellow-100:active{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-yellow-200:active{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-yellow-300:active{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-yellow-400:active{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-yellow-500:active{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-yellow-600:active{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-yellow-700:active{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-yellow-800:active{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-yellow-900:active{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-green-50:active{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-green-100:active{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-green-200:active{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-green-300:active{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-green-400:active{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-green-500:active{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-green-600:active{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-green-700:active{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-green-800:active{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-green-900:active{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-teal-50:active{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-teal-100:active{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-teal-200:active{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-teal-300:active{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-teal-400:active{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-teal-500:active{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-teal-600:active{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-teal-700:active{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-teal-800:active{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-teal-900:active{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-blue-50:active{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-blue-100:active{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-blue-200:active{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-blue-300:active{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-blue-400:active{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-blue-500:active{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-blue-600:active{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-blue-700:active{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-blue-800:active{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-blue-900:active{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-pink-50:active{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-pink-100:active{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-pink-200:active{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-pink-300:active{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-pink-400:active{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-pink-500:active{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-pink-600:active{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-pink-700:active{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-pink-800:active{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .lg\\:dark\\:active\\:bg-pink-900:active{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-transparent:nth-child(odd){background-color:initial}.theme-dark .lg\\:dark\\:odd\\:bg-white:nth-child(odd){--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-black:nth-child(odd){--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-gray-50:nth-child(odd){--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-gray-300:nth-child(odd){--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-gray-400:nth-child(odd){--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-gray-500:nth-child(odd){--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-gray-600:nth-child(odd){--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-gray-700:nth-child(odd){--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-gray-800:nth-child(odd){--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-gray-900:nth-child(odd){--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-50:nth-child(odd){--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-300:nth-child(odd){--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-400:nth-child(odd){--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-500:nth-child(odd){--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-600:nth-child(odd){--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-700:nth-child(odd){--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-800:nth-child(odd){--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-cool-gray-900:nth-child(odd){--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-red-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-red-100:nth-child(odd){--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-red-200:nth-child(odd){--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-red-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-red-400:nth-child(odd){--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-red-500:nth-child(odd){--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-red-600:nth-child(odd){--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-red-700:nth-child(odd){--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-red-800:nth-child(odd){--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-red-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-orange-50:nth-child(odd){--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-orange-100:nth-child(odd){--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-orange-200:nth-child(odd){--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-orange-300:nth-child(odd){--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-orange-400:nth-child(odd){--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-orange-500:nth-child(odd){--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-orange-600:nth-child(odd){--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-orange-700:nth-child(odd){--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-orange-800:nth-child(odd){--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-orange-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-yellow-50:nth-child(odd){--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-yellow-100:nth-child(odd){--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-yellow-200:nth-child(odd){--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-yellow-300:nth-child(odd){--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-yellow-400:nth-child(odd){--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-yellow-500:nth-child(odd){--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-yellow-600:nth-child(odd){--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-yellow-700:nth-child(odd){--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-yellow-800:nth-child(odd){--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-yellow-900:nth-child(odd){--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-green-50:nth-child(odd){--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-green-100:nth-child(odd){--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-green-200:nth-child(odd){--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-green-300:nth-child(odd){--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-green-400:nth-child(odd){--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-green-500:nth-child(odd){--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-green-600:nth-child(odd){--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-green-700:nth-child(odd){--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-green-800:nth-child(odd){--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-green-900:nth-child(odd){--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-teal-50:nth-child(odd){--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-teal-100:nth-child(odd){--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-teal-200:nth-child(odd){--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-teal-300:nth-child(odd){--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-teal-400:nth-child(odd){--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-teal-500:nth-child(odd){--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-teal-600:nth-child(odd){--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-teal-700:nth-child(odd){--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-teal-800:nth-child(odd){--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-teal-900:nth-child(odd){--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-blue-50:nth-child(odd){--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-blue-100:nth-child(odd){--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-blue-200:nth-child(odd){--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-blue-300:nth-child(odd){--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-blue-400:nth-child(odd){--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-blue-500:nth-child(odd){--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-blue-600:nth-child(odd){--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-blue-700:nth-child(odd){--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-blue-800:nth-child(odd){--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-blue-900:nth-child(odd){--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-pink-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-pink-100:nth-child(odd){--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-pink-200:nth-child(odd){--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-pink-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-pink-400:nth-child(odd){--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-pink-500:nth-child(odd){--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-pink-600:nth-child(odd){--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-pink-700:nth-child(odd){--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-pink-800:nth-child(odd){--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .lg\\:dark\\:odd\\:bg-pink-900:nth-child(odd){--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.lg\\:bg-opacity-0{--bg-opacity:0}.lg\\:bg-opacity-10{--bg-opacity:0.1}.lg\\:bg-opacity-25{--bg-opacity:0.25}.lg\\:bg-opacity-50{--bg-opacity:0.5}.lg\\:bg-opacity-75{--bg-opacity:0.75}.lg\\:bg-opacity-100{--bg-opacity:1}.lg\\:hover\\:bg-opacity-0:hover{--bg-opacity:0}.lg\\:hover\\:bg-opacity-10:hover{--bg-opacity:0.1}.lg\\:hover\\:bg-opacity-25:hover{--bg-opacity:0.25}.lg\\:hover\\:bg-opacity-50:hover{--bg-opacity:0.5}.lg\\:hover\\:bg-opacity-75:hover{--bg-opacity:0.75}.lg\\:hover\\:bg-opacity-100:hover{--bg-opacity:1}.lg\\:focus\\:bg-opacity-0:focus{--bg-opacity:0}.lg\\:focus\\:bg-opacity-10:focus{--bg-opacity:0.1}.lg\\:focus\\:bg-opacity-25:focus{--bg-opacity:0.25}.lg\\:focus\\:bg-opacity-50:focus{--bg-opacity:0.5}.lg\\:focus\\:bg-opacity-75:focus{--bg-opacity:0.75}.lg\\:focus\\:bg-opacity-100:focus{--bg-opacity:1}.theme-dark .lg\\:dark\\:hover\\:bg-opacity-0:hover{--bg-opacity:0}.theme-dark .lg\\:dark\\:hover\\:bg-opacity-10:hover{--bg-opacity:0.1}.theme-dark .lg\\:dark\\:hover\\:bg-opacity-25:hover{--bg-opacity:0.25}.theme-dark .lg\\:dark\\:hover\\:bg-opacity-50:hover{--bg-opacity:0.5}.theme-dark .lg\\:dark\\:hover\\:bg-opacity-75:hover{--bg-opacity:0.75}.theme-dark .lg\\:dark\\:hover\\:bg-opacity-100:hover{--bg-opacity:1}.lg\\:bg-bottom{background-position:bottom}.lg\\:bg-center{background-position:50%}.lg\\:bg-left{background-position:0}.lg\\:bg-left-bottom{background-position:0 100%}.lg\\:bg-left-top{background-position:0 0}.lg\\:bg-right{background-position:100%}.lg\\:bg-right-bottom{background-position:100% 100%}.lg\\:bg-right-top{background-position:100% 0}.lg\\:bg-top{background-position:top}.lg\\:bg-repeat{background-repeat:repeat}.lg\\:bg-no-repeat{background-repeat:no-repeat}.lg\\:bg-repeat-x{background-repeat:repeat-x}.lg\\:bg-repeat-y{background-repeat:repeat-y}.lg\\:bg-repeat-round{background-repeat:round}.lg\\:bg-repeat-space{background-repeat:space}.lg\\:bg-auto{background-size:auto}.lg\\:bg-cover{background-size:cover}.lg\\:bg-contain{background-size:contain}.lg\\:border-collapse{border-collapse:collapse}.lg\\:border-separate{border-collapse:initial}.lg\\:border-transparent{border-color:#0000}.lg\\:border-white{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.lg\\:border-black{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.lg\\:border-gray-50{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.lg\\:border-gray-100{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.lg\\:border-gray-200{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.lg\\:border-gray-300{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.lg\\:border-gray-400{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.lg\\:border-gray-500{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.lg\\:border-gray-600{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.lg\\:border-gray-700{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.lg\\:border-gray-800{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.lg\\:border-gray-900{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.lg\\:border-cool-gray-50{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.lg\\:border-cool-gray-100{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.lg\\:border-cool-gray-200{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.lg\\:border-cool-gray-300{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.lg\\:border-cool-gray-400{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.lg\\:border-cool-gray-500{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.lg\\:border-cool-gray-600{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.lg\\:border-cool-gray-700{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.lg\\:border-cool-gray-800{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.lg\\:border-cool-gray-900{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.lg\\:border-red-50{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.lg\\:border-red-100{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.lg\\:border-red-200{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.lg\\:border-red-300{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.lg\\:border-red-400{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.lg\\:border-red-500{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.lg\\:border-red-600{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.lg\\:border-red-700{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.lg\\:border-red-800{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.lg\\:border-red-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.lg\\:border-orange-50{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.lg\\:border-orange-100{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.lg\\:border-orange-200{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.lg\\:border-orange-300{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.lg\\:border-orange-400{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.lg\\:border-orange-500{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.lg\\:border-orange-600{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.lg\\:border-orange-700{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.lg\\:border-orange-800{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.lg\\:border-orange-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.lg\\:border-yellow-50{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.lg\\:border-yellow-100{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.lg\\:border-yellow-200{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.lg\\:border-yellow-300{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.lg\\:border-yellow-400{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.lg\\:border-yellow-500{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.lg\\:border-yellow-600{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.lg\\:border-yellow-700{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.lg\\:border-yellow-800{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.lg\\:border-yellow-900{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.lg\\:border-green-50{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.lg\\:border-green-100{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.lg\\:border-green-200{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.lg\\:border-green-300{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.lg\\:border-green-400{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.lg\\:border-green-500{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.lg\\:border-green-600{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.lg\\:border-green-700{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.lg\\:border-green-800{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.lg\\:border-green-900{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.lg\\:border-teal-50{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.lg\\:border-teal-100{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.lg\\:border-teal-200{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.lg\\:border-teal-300{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.lg\\:border-teal-400{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.lg\\:border-teal-500{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.lg\\:border-teal-600{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.lg\\:border-teal-700{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.lg\\:border-teal-800{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.lg\\:border-teal-900{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.lg\\:border-blue-50{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.lg\\:border-blue-100{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.lg\\:border-blue-200{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.lg\\:border-blue-300{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.lg\\:border-blue-400{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.lg\\:border-blue-500{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.lg\\:border-blue-600{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.lg\\:border-blue-700{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.lg\\:border-blue-800{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.lg\\:border-blue-900{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.lg\\:border-indigo-50{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.lg\\:border-indigo-100{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.lg\\:border-indigo-200{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.lg\\:border-indigo-300{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.lg\\:border-indigo-400{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.lg\\:border-indigo-500{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.lg\\:border-indigo-600{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.lg\\:border-indigo-700{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.lg\\:border-indigo-800{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.lg\\:border-indigo-900{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.lg\\:border-indigo-50{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.lg\\:border-indigo-100{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.lg\\:border-indigo-200{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.lg\\:border-indigo-300{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.lg\\:border-indigo-400{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.lg\\:border-indigo-500{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.lg\\:border-indigo-600{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.lg\\:border-indigo-700{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.lg\\:border-indigo-800{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.lg\\:border-indigo-900{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.lg\\:border-pink-50{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.lg\\:border-pink-100{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.lg\\:border-pink-200{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.lg\\:border-pink-300{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.lg\\:border-pink-400{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.lg\\:border-pink-500{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.lg\\:border-pink-600{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.lg\\:border-pink-700{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.lg\\:border-pink-800{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.lg\\:border-pink-900{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.lg\\:hover\\:border-transparent:hover{border-color:#0000}.lg\\:hover\\:border-white:hover{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.lg\\:hover\\:border-black:hover{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.lg\\:hover\\:border-gray-50:hover{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.lg\\:hover\\:border-gray-100:hover{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.lg\\:hover\\:border-gray-200:hover{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.lg\\:hover\\:border-gray-300:hover{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.lg\\:hover\\:border-gray-400:hover{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.lg\\:hover\\:border-gray-500:hover{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.lg\\:hover\\:border-gray-600:hover{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.lg\\:hover\\:border-gray-700:hover{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.lg\\:hover\\:border-gray-800:hover{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.lg\\:hover\\:border-gray-900:hover{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.lg\\:hover\\:border-cool-gray-50:hover{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.lg\\:hover\\:border-cool-gray-100:hover{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.lg\\:hover\\:border-cool-gray-200:hover{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.lg\\:hover\\:border-cool-gray-300:hover{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.lg\\:hover\\:border-cool-gray-400:hover{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.lg\\:hover\\:border-cool-gray-500:hover{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.lg\\:hover\\:border-cool-gray-600:hover{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.lg\\:hover\\:border-cool-gray-700:hover{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.lg\\:hover\\:border-cool-gray-800:hover{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.lg\\:hover\\:border-cool-gray-900:hover{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.lg\\:hover\\:border-red-50:hover{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.lg\\:hover\\:border-red-100:hover{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.lg\\:hover\\:border-red-200:hover{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.lg\\:hover\\:border-red-300:hover{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.lg\\:hover\\:border-red-400:hover{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.lg\\:hover\\:border-red-500:hover{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.lg\\:hover\\:border-red-600:hover{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.lg\\:hover\\:border-red-700:hover{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.lg\\:hover\\:border-red-800:hover{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.lg\\:hover\\:border-red-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.lg\\:hover\\:border-orange-50:hover{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.lg\\:hover\\:border-orange-100:hover{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.lg\\:hover\\:border-orange-200:hover{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.lg\\:hover\\:border-orange-300:hover{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.lg\\:hover\\:border-orange-400:hover{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.lg\\:hover\\:border-orange-500:hover{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.lg\\:hover\\:border-orange-600:hover{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.lg\\:hover\\:border-orange-700:hover{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.lg\\:hover\\:border-orange-800:hover{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.lg\\:hover\\:border-orange-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.lg\\:hover\\:border-yellow-50:hover{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.lg\\:hover\\:border-yellow-100:hover{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.lg\\:hover\\:border-yellow-200:hover{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.lg\\:hover\\:border-yellow-300:hover{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.lg\\:hover\\:border-yellow-400:hover{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.lg\\:hover\\:border-yellow-500:hover{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.lg\\:hover\\:border-yellow-600:hover{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.lg\\:hover\\:border-yellow-700:hover{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.lg\\:hover\\:border-yellow-800:hover{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.lg\\:hover\\:border-yellow-900:hover{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.lg\\:hover\\:border-green-50:hover{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.lg\\:hover\\:border-green-100:hover{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.lg\\:hover\\:border-green-200:hover{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.lg\\:hover\\:border-green-300:hover{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.lg\\:hover\\:border-green-400:hover{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.lg\\:hover\\:border-green-500:hover{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.lg\\:hover\\:border-green-600:hover{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.lg\\:hover\\:border-green-700:hover{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.lg\\:hover\\:border-green-800:hover{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.lg\\:hover\\:border-green-900:hover{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.lg\\:hover\\:border-teal-50:hover{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.lg\\:hover\\:border-teal-100:hover{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.lg\\:hover\\:border-teal-200:hover{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.lg\\:hover\\:border-teal-300:hover{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.lg\\:hover\\:border-teal-400:hover{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.lg\\:hover\\:border-teal-500:hover{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.lg\\:hover\\:border-teal-600:hover{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.lg\\:hover\\:border-teal-700:hover{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.lg\\:hover\\:border-teal-800:hover{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.lg\\:hover\\:border-teal-900:hover{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.lg\\:hover\\:border-blue-50:hover{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.lg\\:hover\\:border-blue-100:hover{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.lg\\:hover\\:border-blue-200:hover{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.lg\\:hover\\:border-blue-300:hover{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.lg\\:hover\\:border-blue-400:hover{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.lg\\:hover\\:border-blue-500:hover{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.lg\\:hover\\:border-blue-600:hover{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.lg\\:hover\\:border-blue-700:hover{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.lg\\:hover\\:border-blue-800:hover{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.lg\\:hover\\:border-blue-900:hover{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.lg\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.lg\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.lg\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.lg\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.lg\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.lg\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.lg\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.lg\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.lg\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.lg\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.lg\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.lg\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.lg\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.lg\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.lg\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.lg\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.lg\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.lg\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.lg\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.lg\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.lg\\:hover\\:border-pink-50:hover{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.lg\\:hover\\:border-pink-100:hover{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.lg\\:hover\\:border-pink-200:hover{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.lg\\:hover\\:border-pink-300:hover{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.lg\\:hover\\:border-pink-400:hover{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.lg\\:hover\\:border-pink-500:hover{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.lg\\:hover\\:border-pink-600:hover{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.lg\\:hover\\:border-pink-700:hover{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.lg\\:hover\\:border-pink-800:hover{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.lg\\:hover\\:border-pink-900:hover{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.lg\\:focus\\:border-transparent:focus{border-color:#0000}.lg\\:focus\\:border-white:focus{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.lg\\:focus\\:border-black:focus{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.lg\\:focus\\:border-gray-50:focus{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.lg\\:focus\\:border-gray-100:focus{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.lg\\:focus\\:border-gray-200:focus{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.lg\\:focus\\:border-gray-300:focus{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.lg\\:focus\\:border-gray-400:focus{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.lg\\:focus\\:border-gray-500:focus{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.lg\\:focus\\:border-gray-600:focus{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.lg\\:focus\\:border-gray-700:focus{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.lg\\:focus\\:border-gray-800:focus{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.lg\\:focus\\:border-gray-900:focus{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.lg\\:focus\\:border-cool-gray-50:focus{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.lg\\:focus\\:border-cool-gray-100:focus{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.lg\\:focus\\:border-cool-gray-200:focus{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.lg\\:focus\\:border-cool-gray-300:focus{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.lg\\:focus\\:border-cool-gray-400:focus{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.lg\\:focus\\:border-cool-gray-500:focus{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.lg\\:focus\\:border-cool-gray-600:focus{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.lg\\:focus\\:border-cool-gray-700:focus{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.lg\\:focus\\:border-cool-gray-800:focus{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.lg\\:focus\\:border-cool-gray-900:focus{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.lg\\:focus\\:border-red-50:focus{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.lg\\:focus\\:border-red-100:focus{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.lg\\:focus\\:border-red-200:focus{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.lg\\:focus\\:border-red-300:focus{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.lg\\:focus\\:border-red-400:focus{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.lg\\:focus\\:border-red-500:focus{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.lg\\:focus\\:border-red-600:focus{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.lg\\:focus\\:border-red-700:focus{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.lg\\:focus\\:border-red-800:focus{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.lg\\:focus\\:border-red-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.lg\\:focus\\:border-orange-50:focus{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.lg\\:focus\\:border-orange-100:focus{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.lg\\:focus\\:border-orange-200:focus{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.lg\\:focus\\:border-orange-300:focus{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.lg\\:focus\\:border-orange-400:focus{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.lg\\:focus\\:border-orange-500:focus{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.lg\\:focus\\:border-orange-600:focus{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.lg\\:focus\\:border-orange-700:focus{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.lg\\:focus\\:border-orange-800:focus{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.lg\\:focus\\:border-orange-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.lg\\:focus\\:border-yellow-50:focus{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.lg\\:focus\\:border-yellow-100:focus{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.lg\\:focus\\:border-yellow-200:focus{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.lg\\:focus\\:border-yellow-300:focus{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.lg\\:focus\\:border-yellow-400:focus{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.lg\\:focus\\:border-yellow-500:focus{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.lg\\:focus\\:border-yellow-600:focus{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.lg\\:focus\\:border-yellow-700:focus{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.lg\\:focus\\:border-yellow-800:focus{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.lg\\:focus\\:border-yellow-900:focus{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.lg\\:focus\\:border-green-50:focus{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.lg\\:focus\\:border-green-100:focus{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.lg\\:focus\\:border-green-200:focus{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.lg\\:focus\\:border-green-300:focus{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.lg\\:focus\\:border-green-400:focus{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.lg\\:focus\\:border-green-500:focus{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.lg\\:focus\\:border-green-600:focus{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.lg\\:focus\\:border-green-700:focus{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.lg\\:focus\\:border-green-800:focus{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.lg\\:focus\\:border-green-900:focus{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.lg\\:focus\\:border-teal-50:focus{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.lg\\:focus\\:border-teal-100:focus{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.lg\\:focus\\:border-teal-200:focus{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.lg\\:focus\\:border-teal-300:focus{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.lg\\:focus\\:border-teal-400:focus{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.lg\\:focus\\:border-teal-500:focus{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.lg\\:focus\\:border-teal-600:focus{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.lg\\:focus\\:border-teal-700:focus{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.lg\\:focus\\:border-teal-800:focus{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.lg\\:focus\\:border-teal-900:focus{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.lg\\:focus\\:border-blue-50:focus{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.lg\\:focus\\:border-blue-100:focus{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.lg\\:focus\\:border-blue-200:focus{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.lg\\:focus\\:border-blue-300:focus{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.lg\\:focus\\:border-blue-400:focus{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.lg\\:focus\\:border-blue-500:focus{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.lg\\:focus\\:border-blue-600:focus{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.lg\\:focus\\:border-blue-700:focus{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.lg\\:focus\\:border-blue-800:focus{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.lg\\:focus\\:border-blue-900:focus{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.lg\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.lg\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.lg\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.lg\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.lg\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.lg\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.lg\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.lg\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.lg\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.lg\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.lg\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.lg\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.lg\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.lg\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.lg\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.lg\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.lg\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.lg\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.lg\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.lg\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.lg\\:focus\\:border-pink-50:focus{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.lg\\:focus\\:border-pink-100:focus{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.lg\\:focus\\:border-pink-200:focus{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.lg\\:focus\\:border-pink-300:focus{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.lg\\:focus\\:border-pink-400:focus{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.lg\\:focus\\:border-pink-500:focus{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.lg\\:focus\\:border-pink-600:focus{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.lg\\:focus\\:border-pink-700:focus{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.lg\\:focus\\:border-pink-800:focus{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.lg\\:focus\\:border-pink-900:focus{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-transparent{border-color:#0000}.theme-dark .lg\\:dark\\:border-white{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-black{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-gray-50{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-gray-100{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-gray-200{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-gray-300{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-gray-400{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-gray-500{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-gray-600{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-gray-700{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-gray-800{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-gray-900{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-cool-gray-50{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-cool-gray-100{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-cool-gray-200{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-cool-gray-300{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-cool-gray-400{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-cool-gray-500{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-cool-gray-600{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-cool-gray-700{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-cool-gray-800{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-cool-gray-900{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-red-50{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-red-100{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-red-200{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-red-300{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-red-400{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-red-500{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-red-600{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-red-700{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-red-800{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-red-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-orange-50{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-orange-100{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-orange-200{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-orange-300{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-orange-400{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-orange-500{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-orange-600{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-orange-700{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-orange-800{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-orange-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-yellow-50{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-yellow-100{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-yellow-200{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-yellow-300{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-yellow-400{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-yellow-500{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-yellow-600{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-yellow-700{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-yellow-800{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-yellow-900{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-green-50{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-green-100{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-green-200{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-green-300{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-green-400{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-green-500{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-green-600{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-green-700{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-green-800{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-green-900{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-teal-50{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-teal-100{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-teal-200{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-teal-300{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-teal-400{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-teal-500{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-teal-600{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-teal-700{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-teal-800{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-teal-900{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-blue-50{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-blue-100{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-blue-200{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-blue-300{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-blue-400{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-blue-500{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-blue-600{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-blue-700{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-blue-800{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-blue-900{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-50{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-100{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-200{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-300{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-400{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-500{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-600{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-700{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-800{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-900{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-50{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-100{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-200{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-300{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-400{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-500{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-600{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-700{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-800{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-indigo-900{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-pink-50{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-pink-100{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-pink-200{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-pink-300{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-pink-400{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-pink-500{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-pink-600{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-pink-700{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-pink-800{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.theme-dark .lg\\:dark\\:border-pink-900{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-transparent:focus{border-color:#0000}.theme-dark .lg\\:dark\\:focus\\:border-white:focus{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-black:focus{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-gray-50:focus{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-gray-100:focus{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-gray-200:focus{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-gray-300:focus{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-gray-400:focus{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-gray-500:focus{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-gray-600:focus{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-gray-700:focus{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-gray-800:focus{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-gray-900:focus{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-cool-gray-50:focus{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-cool-gray-100:focus{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-cool-gray-200:focus{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-cool-gray-300:focus{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-cool-gray-400:focus{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-cool-gray-500:focus{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-cool-gray-600:focus{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-cool-gray-700:focus{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-cool-gray-800:focus{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-cool-gray-900:focus{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-red-50:focus{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-red-100:focus{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-red-200:focus{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-red-300:focus{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-red-400:focus{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-red-500:focus{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-red-600:focus{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-red-700:focus{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-red-800:focus{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-red-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-orange-50:focus{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-orange-100:focus{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-orange-200:focus{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-orange-300:focus{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-orange-400:focus{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-orange-500:focus{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-orange-600:focus{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-orange-700:focus{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-orange-800:focus{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-orange-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-yellow-50:focus{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-yellow-100:focus{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-yellow-200:focus{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-yellow-300:focus{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-yellow-400:focus{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-yellow-500:focus{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-yellow-600:focus{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-yellow-700:focus{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-yellow-800:focus{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-yellow-900:focus{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-green-50:focus{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-green-100:focus{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-green-200:focus{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-green-300:focus{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-green-400:focus{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-green-500:focus{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-green-600:focus{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-green-700:focus{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-green-800:focus{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-green-900:focus{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-teal-50:focus{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-teal-100:focus{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-teal-200:focus{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-teal-300:focus{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-teal-400:focus{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-teal-500:focus{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-teal-600:focus{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-teal-700:focus{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-teal-800:focus{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-teal-900:focus{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-blue-50:focus{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-blue-100:focus{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-blue-200:focus{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-blue-300:focus{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-blue-400:focus{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-blue-500:focus{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-blue-600:focus{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-blue-700:focus{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-blue-800:focus{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-blue-900:focus{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-pink-50:focus{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-pink-100:focus{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-pink-200:focus{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-pink-300:focus{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-pink-400:focus{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-pink-500:focus{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-pink-600:focus{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-pink-700:focus{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-pink-800:focus{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.theme-dark .lg\\:dark\\:focus\\:border-pink-900:focus{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-transparent:hover{border-color:#0000}.theme-dark .lg\\:dark\\:hover\\:border-white:hover{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-black:hover{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-gray-50:hover{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-gray-100:hover{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-gray-200:hover{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-gray-300:hover{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-gray-400:hover{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-gray-500:hover{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-gray-600:hover{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-gray-700:hover{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-gray-800:hover{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-gray-900:hover{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-cool-gray-50:hover{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-cool-gray-100:hover{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-cool-gray-200:hover{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-cool-gray-300:hover{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-cool-gray-400:hover{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-cool-gray-500:hover{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-cool-gray-600:hover{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-cool-gray-700:hover{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-cool-gray-800:hover{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-cool-gray-900:hover{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-red-50:hover{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-red-100:hover{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-red-200:hover{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-red-300:hover{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-red-400:hover{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-red-500:hover{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-red-600:hover{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-red-700:hover{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-red-800:hover{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-red-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-orange-50:hover{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-orange-100:hover{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-orange-200:hover{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-orange-300:hover{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-orange-400:hover{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-orange-500:hover{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-orange-600:hover{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-orange-700:hover{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-orange-800:hover{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-orange-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-yellow-50:hover{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-yellow-100:hover{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-yellow-200:hover{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-yellow-300:hover{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-yellow-400:hover{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-yellow-500:hover{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-yellow-600:hover{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-yellow-700:hover{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-yellow-800:hover{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-yellow-900:hover{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-green-50:hover{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-green-100:hover{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-green-200:hover{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-green-300:hover{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-green-400:hover{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-green-500:hover{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-green-600:hover{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-green-700:hover{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-green-800:hover{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-green-900:hover{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-teal-50:hover{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-teal-100:hover{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-teal-200:hover{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-teal-300:hover{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-teal-400:hover{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-teal-500:hover{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-teal-600:hover{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-teal-700:hover{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-teal-800:hover{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-teal-900:hover{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-blue-50:hover{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-blue-100:hover{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-blue-200:hover{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-blue-300:hover{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-blue-400:hover{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-blue-500:hover{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-blue-600:hover{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-blue-700:hover{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-blue-800:hover{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-blue-900:hover{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-pink-50:hover{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-pink-100:hover{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-pink-200:hover{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-pink-300:hover{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-pink-400:hover{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-pink-500:hover{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-pink-600:hover{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-pink-700:hover{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-pink-800:hover{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.theme-dark .lg\\:dark\\:hover\\:border-pink-900:hover{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.lg\\:border-opacity-0{--border-opacity:0}.lg\\:border-opacity-25{--border-opacity:0.25}.lg\\:border-opacity-50{--border-opacity:0.5}.lg\\:border-opacity-75{--border-opacity:0.75}.lg\\:border-opacity-100{--border-opacity:1}.lg\\:hover\\:border-opacity-0:hover{--border-opacity:0}.lg\\:hover\\:border-opacity-25:hover{--border-opacity:0.25}.lg\\:hover\\:border-opacity-50:hover{--border-opacity:0.5}.lg\\:hover\\:border-opacity-75:hover{--border-opacity:0.75}.lg\\:hover\\:border-opacity-100:hover{--border-opacity:1}.lg\\:focus\\:border-opacity-0:focus{--border-opacity:0}.lg\\:focus\\:border-opacity-25:focus{--border-opacity:0.25}.lg\\:focus\\:border-opacity-50:focus{--border-opacity:0.5}.lg\\:focus\\:border-opacity-75:focus{--border-opacity:0.75}.lg\\:focus\\:border-opacity-100:focus{--border-opacity:1}.lg\\:rounded-none{border-radius:0}.lg\\:rounded-sm{border-radius:.125rem}.lg\\:rounded{border-radius:.25rem}.lg\\:rounded-md{border-radius:.375rem}.lg\\:rounded-lg{border-radius:.5rem}.lg\\:rounded-full{border-radius:9999px}.lg\\:rounded-t-none{border-top-left-radius:0;border-top-right-radius:0}.lg\\:rounded-r-none{border-bottom-right-radius:0;border-top-right-radius:0}.lg\\:rounded-b-none{border-bottom-left-radius:0;border-bottom-right-radius:0}.lg\\:rounded-l-none{border-bottom-left-radius:0;border-top-left-radius:0}.lg\\:rounded-t-sm{border-top-left-radius:.125rem;border-top-right-radius:.125rem}.lg\\:rounded-r-sm{border-bottom-right-radius:.125rem;border-top-right-radius:.125rem}.lg\\:rounded-b-sm{border-bottom-left-radius:.125rem;border-bottom-right-radius:.125rem}.lg\\:rounded-l-sm{border-bottom-left-radius:.125rem;border-top-left-radius:.125rem}.lg\\:rounded-t{border-top-left-radius:.25rem}.lg\\:rounded-r,.lg\\:rounded-t{border-top-right-radius:.25rem}.lg\\:rounded-b,.lg\\:rounded-r{border-bottom-right-radius:.25rem}.lg\\:rounded-b,.lg\\:rounded-l{border-bottom-left-radius:.25rem}.lg\\:rounded-l{border-top-left-radius:.25rem}.lg\\:rounded-t-md{border-top-left-radius:.375rem;border-top-right-radius:.375rem}.lg\\:rounded-r-md{border-bottom-right-radius:.375rem;border-top-right-radius:.375rem}.lg\\:rounded-b-md{border-bottom-left-radius:.375rem;border-bottom-right-radius:.375rem}.lg\\:rounded-l-md{border-bottom-left-radius:.375rem;border-top-left-radius:.375rem}.lg\\:rounded-t-lg{border-top-left-radius:.5rem;border-top-right-radius:.5rem}.lg\\:rounded-r-lg{border-bottom-right-radius:.5rem;border-top-right-radius:.5rem}.lg\\:rounded-b-lg{border-bottom-left-radius:.5rem;border-bottom-right-radius:.5rem}.lg\\:rounded-l-lg{border-bottom-left-radius:.5rem;border-top-left-radius:.5rem}.lg\\:rounded-t-full{border-top-left-radius:9999px;border-top-right-radius:9999px}.lg\\:rounded-r-full{border-bottom-right-radius:9999px;border-top-right-radius:9999px}.lg\\:rounded-b-full{border-bottom-left-radius:9999px;border-bottom-right-radius:9999px}.lg\\:rounded-l-full{border-bottom-left-radius:9999px;border-top-left-radius:9999px}.lg\\:rounded-tl-none{border-top-left-radius:0}.lg\\:rounded-tr-none{border-top-right-radius:0}.lg\\:rounded-br-none{border-bottom-right-radius:0}.lg\\:rounded-bl-none{border-bottom-left-radius:0}.lg\\:rounded-tl-sm{border-top-left-radius:.125rem}.lg\\:rounded-tr-sm{border-top-right-radius:.125rem}.lg\\:rounded-br-sm{border-bottom-right-radius:.125rem}.lg\\:rounded-bl-sm{border-bottom-left-radius:.125rem}.lg\\:rounded-tl{border-top-left-radius:.25rem}.lg\\:rounded-tr{border-top-right-radius:.25rem}.lg\\:rounded-br{border-bottom-right-radius:.25rem}.lg\\:rounded-bl{border-bottom-left-radius:.25rem}.lg\\:rounded-tl-md{border-top-left-radius:.375rem}.lg\\:rounded-tr-md{border-top-right-radius:.375rem}.lg\\:rounded-br-md{border-bottom-right-radius:.375rem}.lg\\:rounded-bl-md{border-bottom-left-radius:.375rem}.lg\\:rounded-tl-lg{border-top-left-radius:.5rem}.lg\\:rounded-tr-lg{border-top-right-radius:.5rem}.lg\\:rounded-br-lg{border-bottom-right-radius:.5rem}.lg\\:rounded-bl-lg{border-bottom-left-radius:.5rem}.lg\\:rounded-tl-full{border-top-left-radius:9999px}.lg\\:rounded-tr-full{border-top-right-radius:9999px}.lg\\:rounded-br-full{border-bottom-right-radius:9999px}.lg\\:rounded-bl-full{border-bottom-left-radius:9999px}.lg\\:border-solid{border-style:solid}.lg\\:border-dashed{border-style:dashed}.lg\\:border-dotted{border-style:dotted}.lg\\:border-double{border-style:double}.lg\\:border-none{border-style:none}.lg\\:border-0{border-width:0}.lg\\:border-2{border-width:2px}.lg\\:border-4{border-width:4px}.lg\\:border-8{border-width:8px}.lg\\:border{border-width:1px}.lg\\:border-t-0{border-top-width:0}.lg\\:border-r-0{border-right-width:0}.lg\\:border-b-0{border-bottom-width:0}.lg\\:border-l-0{border-left-width:0}.lg\\:border-t-2{border-top-width:2px}.lg\\:border-r-2{border-right-width:2px}.lg\\:border-b-2{border-bottom-width:2px}.lg\\:border-l-2{border-left-width:2px}.lg\\:border-t-4{border-top-width:4px}.lg\\:border-r-4{border-right-width:4px}.lg\\:border-b-4{border-bottom-width:4px}.lg\\:border-l-4{border-left-width:4px}.lg\\:border-t-8{border-top-width:8px}.lg\\:border-r-8{border-right-width:8px}.lg\\:border-b-8{border-bottom-width:8px}.lg\\:border-l-8{border-left-width:8px}.lg\\:border-t{border-top-width:1px}.lg\\:border-r{border-right-width:1px}.lg\\:border-b{border-bottom-width:1px}.lg\\:border-l{border-left-width:1px}.lg\\:box-border{box-sizing:border-box}.lg\\:box-content{box-sizing:initial}.lg\\:cursor-auto{cursor:auto}.lg\\:cursor-default{cursor:default}.lg\\:cursor-pointer{cursor:pointer}.lg\\:cursor-wait{cursor:wait}.lg\\:cursor-text{cursor:text}.lg\\:cursor-move{cursor:move}.lg\\:cursor-not-allowed{cursor:not-allowed}.lg\\:block{display:block}.lg\\:inline-block{display:inline-block}.lg\\:inline{display:inline}.lg\\:flex{display:flex}.lg\\:inline-flex{display:inline-flex}.lg\\:table{display:table}.lg\\:table-caption{display:table-caption}.lg\\:table-cell{display:table-cell}.lg\\:table-column{display:table-column}.lg\\:table-column-group{display:table-column-group}.lg\\:table-footer-group{display:table-footer-group}.lg\\:table-header-group{display:table-header-group}.lg\\:table-row-group{display:table-row-group}.lg\\:table-row{display:table-row}.lg\\:flow-root{display:flow-root}.lg\\:grid{display:grid}.lg\\:inline-grid{display:inline-grid}.lg\\:hidden{display:none}.theme-dark .lg\\:dark\\:block{display:block}.theme-dark .lg\\:dark\\:inline-block{display:inline-block}.theme-dark .lg\\:dark\\:inline{display:inline}.theme-dark .lg\\:dark\\:flex{display:flex}.theme-dark .lg\\:dark\\:inline-flex{display:inline-flex}.theme-dark .lg\\:dark\\:table{display:table}.theme-dark .lg\\:dark\\:table-caption{display:table-caption}.theme-dark .lg\\:dark\\:table-cell{display:table-cell}.theme-dark .lg\\:dark\\:table-column{display:table-column}.theme-dark .lg\\:dark\\:table-column-group{display:table-column-group}.theme-dark .lg\\:dark\\:table-footer-group{display:table-footer-group}.theme-dark .lg\\:dark\\:table-header-group{display:table-header-group}.theme-dark .lg\\:dark\\:table-row-group{display:table-row-group}.theme-dark .lg\\:dark\\:table-row{display:table-row}.theme-dark .lg\\:dark\\:flow-root{display:flow-root}.theme-dark .lg\\:dark\\:grid{display:grid}.theme-dark .lg\\:dark\\:inline-grid{display:inline-grid}.theme-dark .lg\\:dark\\:hidden{display:none}.lg\\:flex-row{flex-direction:row}.lg\\:flex-row-reverse{flex-direction:row-reverse}.lg\\:flex-col{flex-direction:column}.lg\\:flex-col-reverse{flex-direction:column-reverse}.lg\\:flex-wrap{flex-wrap:wrap}.lg\\:flex-wrap-reverse{flex-wrap:wrap-reverse}.lg\\:flex-no-wrap{flex-wrap:nowrap}.lg\\:items-start{align-items:flex-start}.lg\\:items-end{align-items:flex-end}.lg\\:items-center{align-items:center}.lg\\:items-baseline{align-items:baseline}.lg\\:items-stretch{align-items:stretch}.lg\\:self-auto{align-self:auto}.lg\\:self-start{align-self:flex-start}.lg\\:self-end{align-self:flex-end}.lg\\:self-center{align-self:center}.lg\\:self-stretch{align-self:stretch}.lg\\:justify-start{justify-content:flex-start}.lg\\:justify-end{justify-content:flex-end}.lg\\:justify-center{justify-content:center}.lg\\:justify-between{justify-content:space-between}.lg\\:justify-around{justify-content:space-around}.lg\\:justify-evenly{justify-content:space-evenly}.lg\\:content-center{align-content:center}.lg\\:content-start{align-content:flex-start}.lg\\:content-end{align-content:flex-end}.lg\\:content-between{align-content:space-between}.lg\\:content-around{align-content:space-around}.lg\\:flex-1{flex:1 1 0%}.lg\\:flex-auto{flex:1 1 auto}.lg\\:flex-initial{flex:0 1 auto}.lg\\:flex-none{flex:none}.lg\\:flex-grow-0{flex-grow:0}.lg\\:flex-grow{flex-grow:1}.lg\\:flex-shrink-0{flex-shrink:0}.lg\\:flex-shrink{flex-shrink:1}.lg\\:order-1{order:1}.lg\\:order-2{order:2}.lg\\:order-3{order:3}.lg\\:order-4{order:4}.lg\\:order-5{order:5}.lg\\:order-6{order:6}.lg\\:order-7{order:7}.lg\\:order-8{order:8}.lg\\:order-9{order:9}.lg\\:order-10{order:10}.lg\\:order-11{order:11}.lg\\:order-12{order:12}.lg\\:order-first{order:-9999}.lg\\:order-last{order:9999}.lg\\:order-none{order:0}.lg\\:float-right{float:right}.lg\\:float-left{float:left}.lg\\:float-none{float:none}.lg\\:clearfix:after{clear:both;content:\"\";display:table}.lg\\:clear-left{clear:left}.lg\\:clear-right{clear:right}.lg\\:clear-both{clear:both}.lg\\:clear-none{clear:none}.lg\\:font-sans{font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji}.lg\\:font-serif{font-family:Georgia,Cambria,Times New Roman,Times,serif}.lg\\:font-mono{font-family:Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}.lg\\:font-hairline{font-weight:100}.lg\\:font-thin{font-weight:200}.lg\\:font-light{font-weight:300}.lg\\:font-normal{font-weight:400}.lg\\:font-medium{font-weight:500}.lg\\:font-semibold{font-weight:600}.lg\\:font-bold{font-weight:700}.lg\\:font-extrabold{font-weight:800}.lg\\:font-black{font-weight:900}.lg\\:hover\\:font-hairline:hover{font-weight:100}.lg\\:hover\\:font-thin:hover{font-weight:200}.lg\\:hover\\:font-light:hover{font-weight:300}.lg\\:hover\\:font-normal:hover{font-weight:400}.lg\\:hover\\:font-medium:hover{font-weight:500}.lg\\:hover\\:font-semibold:hover{font-weight:600}.lg\\:hover\\:font-bold:hover{font-weight:700}.lg\\:hover\\:font-extrabold:hover{font-weight:800}.lg\\:hover\\:font-black:hover{font-weight:900}.lg\\:focus\\:font-hairline:focus{font-weight:100}.lg\\:focus\\:font-thin:focus{font-weight:200}.lg\\:focus\\:font-light:focus{font-weight:300}.lg\\:focus\\:font-normal:focus{font-weight:400}.lg\\:focus\\:font-medium:focus{font-weight:500}.lg\\:focus\\:font-semibold:focus{font-weight:600}.lg\\:focus\\:font-bold:focus{font-weight:700}.lg\\:focus\\:font-extrabold:focus{font-weight:800}.lg\\:focus\\:font-black:focus{font-weight:900}.lg\\:h-0{height:0}.lg\\:h-1{height:.25rem}.lg\\:h-2{height:.5rem}.lg\\:h-3{height:.75rem}.lg\\:h-4{height:1rem}.lg\\:h-5{height:1.25rem}.lg\\:h-6{height:1.5rem}.lg\\:h-8{height:2rem}.lg\\:h-10{height:2.5rem}.lg\\:h-12{height:3rem}.lg\\:h-16{height:4rem}.lg\\:h-20{height:5rem}.lg\\:h-24{height:6rem}.lg\\:h-32{height:8rem}.lg\\:h-40{height:10rem}.lg\\:h-48{height:12rem}.lg\\:h-56{height:14rem}.lg\\:h-64{height:16rem}.lg\\:h-auto{height:auto}.lg\\:h-px{height:1px}.lg\\:h-full{height:100%}.lg\\:h-screen{height:100vh}.lg\\:text-xs{font-size:.75rem}.lg\\:text-sm{font-size:.875rem}.lg\\:text-base{font-size:1rem}.lg\\:text-lg{font-size:1.125rem}.lg\\:text-xl{font-size:1.25rem}.lg\\:text-2xl{font-size:1.5rem}.lg\\:text-3xl{font-size:1.875rem}.lg\\:text-4xl{font-size:2.25rem}.lg\\:text-5xl{font-size:3rem}.lg\\:text-6xl{font-size:4rem}.lg\\:leading-3{line-height:.75rem}.lg\\:leading-4{line-height:1rem}.lg\\:leading-5{line-height:1.25rem}.lg\\:leading-6{line-height:1.5rem}.lg\\:leading-7{line-height:1.75rem}.lg\\:leading-8{line-height:2rem}.lg\\:leading-9{line-height:2.25rem}.lg\\:leading-10{line-height:2.5rem}.lg\\:leading-none{line-height:1}.lg\\:leading-tight{line-height:1.25}.lg\\:leading-snug{line-height:1.375}.lg\\:leading-normal{line-height:1.5}.lg\\:leading-relaxed{line-height:1.625}.lg\\:leading-loose{line-height:2}.lg\\:list-inside{list-style-position:inside}.lg\\:list-outside{list-style-position:outside}.lg\\:list-none{list-style-type:none}.lg\\:list-disc{list-style-type:disc}.lg\\:list-decimal{list-style-type:decimal}.lg\\:m-0{margin:0}.lg\\:m-1{margin:.25rem}.lg\\:m-2{margin:.5rem}.lg\\:m-3{margin:.75rem}.lg\\:m-4{margin:1rem}.lg\\:m-5{margin:1.25rem}.lg\\:m-6{margin:1.5rem}.lg\\:m-8{margin:2rem}.lg\\:m-10{margin:2.5rem}.lg\\:m-12{margin:3rem}.lg\\:m-16{margin:4rem}.lg\\:m-20{margin:5rem}.lg\\:m-24{margin:6rem}.lg\\:m-32{margin:8rem}.lg\\:m-40{margin:10rem}.lg\\:m-48{margin:12rem}.lg\\:m-56{margin:14rem}.lg\\:m-64{margin:16rem}.lg\\:m-auto{margin:auto}.lg\\:m-px{margin:1px}.lg\\:-m-1{margin:-.25rem}.lg\\:-m-2{margin:-.5rem}.lg\\:-m-3{margin:-.75rem}.lg\\:-m-4{margin:-1rem}.lg\\:-m-5{margin:-1.25rem}.lg\\:-m-6{margin:-1.5rem}.lg\\:-m-8{margin:-2rem}.lg\\:-m-10{margin:-2.5rem}.lg\\:-m-12{margin:-3rem}.lg\\:-m-16{margin:-4rem}.lg\\:-m-20{margin:-5rem}.lg\\:-m-24{margin:-6rem}.lg\\:-m-32{margin:-8rem}.lg\\:-m-40{margin:-10rem}.lg\\:-m-48{margin:-12rem}.lg\\:-m-56{margin:-14rem}.lg\\:-m-64{margin:-16rem}.lg\\:-m-px{margin:-1px}.lg\\:my-0{margin-bottom:0;margin-top:0}.lg\\:mx-0{margin-left:0;margin-right:0}.lg\\:my-1{margin-bottom:.25rem;margin-top:.25rem}.lg\\:mx-1{margin-left:.25rem;margin-right:.25rem}.lg\\:my-2{margin-bottom:.5rem;margin-top:.5rem}.lg\\:mx-2{margin-left:.5rem;margin-right:.5rem}.lg\\:my-3{margin-bottom:.75rem;margin-top:.75rem}.lg\\:mx-3{margin-left:.75rem;margin-right:.75rem}.lg\\:my-4{margin-bottom:1rem;margin-top:1rem}.lg\\:mx-4{margin-left:1rem;margin-right:1rem}.lg\\:my-5{margin-bottom:1.25rem;margin-top:1.25rem}.lg\\:mx-5{margin-left:1.25rem;margin-right:1.25rem}.lg\\:my-6{margin-bottom:1.5rem;margin-top:1.5rem}.lg\\:mx-6{margin-left:1.5rem;margin-right:1.5rem}.lg\\:my-8{margin-bottom:2rem;margin-top:2rem}.lg\\:mx-8{margin-left:2rem;margin-right:2rem}.lg\\:my-10{margin-bottom:2.5rem;margin-top:2.5rem}.lg\\:mx-10{margin-left:2.5rem;margin-right:2.5rem}.lg\\:my-12{margin-bottom:3rem;margin-top:3rem}.lg\\:mx-12{margin-left:3rem;margin-right:3rem}.lg\\:my-16{margin-bottom:4rem;margin-top:4rem}.lg\\:mx-16{margin-left:4rem;margin-right:4rem}.lg\\:my-20{margin-bottom:5rem;margin-top:5rem}.lg\\:mx-20{margin-left:5rem;margin-right:5rem}.lg\\:my-24{margin-bottom:6rem;margin-top:6rem}.lg\\:mx-24{margin-left:6rem;margin-right:6rem}.lg\\:my-32{margin-bottom:8rem;margin-top:8rem}.lg\\:mx-32{margin-left:8rem;margin-right:8rem}.lg\\:my-40{margin-bottom:10rem;margin-top:10rem}.lg\\:mx-40{margin-left:10rem;margin-right:10rem}.lg\\:my-48{margin-bottom:12rem;margin-top:12rem}.lg\\:mx-48{margin-left:12rem;margin-right:12rem}.lg\\:my-56{margin-bottom:14rem;margin-top:14rem}.lg\\:mx-56{margin-left:14rem;margin-right:14rem}.lg\\:my-64{margin-bottom:16rem;margin-top:16rem}.lg\\:mx-64{margin-left:16rem;margin-right:16rem}.lg\\:my-auto{margin-bottom:auto;margin-top:auto}.lg\\:mx-auto{margin-left:auto;margin-right:auto}.lg\\:my-px{margin-bottom:1px;margin-top:1px}.lg\\:mx-px{margin-left:1px;margin-right:1px}.lg\\:-my-1{margin-bottom:-.25rem;margin-top:-.25rem}.lg\\:-mx-1{margin-left:-.25rem;margin-right:-.25rem}.lg\\:-my-2{margin-bottom:-.5rem;margin-top:-.5rem}.lg\\:-mx-2{margin-left:-.5rem;margin-right:-.5rem}.lg\\:-my-3{margin-bottom:-.75rem;margin-top:-.75rem}.lg\\:-mx-3{margin-left:-.75rem;margin-right:-.75rem}.lg\\:-my-4{margin-bottom:-1rem;margin-top:-1rem}.lg\\:-mx-4{margin-left:-1rem;margin-right:-1rem}.lg\\:-my-5{margin-bottom:-1.25rem;margin-top:-1.25rem}.lg\\:-mx-5{margin-left:-1.25rem;margin-right:-1.25rem}.lg\\:-my-6{margin-bottom:-1.5rem;margin-top:-1.5rem}.lg\\:-mx-6{margin-left:-1.5rem;margin-right:-1.5rem}.lg\\:-my-8{margin-bottom:-2rem;margin-top:-2rem}.lg\\:-mx-8{margin-left:-2rem;margin-right:-2rem}.lg\\:-my-10{margin-bottom:-2.5rem;margin-top:-2.5rem}.lg\\:-mx-10{margin-left:-2.5rem;margin-right:-2.5rem}.lg\\:-my-12{margin-bottom:-3rem;margin-top:-3rem}.lg\\:-mx-12{margin-left:-3rem;margin-right:-3rem}.lg\\:-my-16{margin-bottom:-4rem;margin-top:-4rem}.lg\\:-mx-16{margin-left:-4rem;margin-right:-4rem}.lg\\:-my-20{margin-bottom:-5rem;margin-top:-5rem}.lg\\:-mx-20{margin-left:-5rem;margin-right:-5rem}.lg\\:-my-24{margin-bottom:-6rem;margin-top:-6rem}.lg\\:-mx-24{margin-left:-6rem;margin-right:-6rem}.lg\\:-my-32{margin-bottom:-8rem;margin-top:-8rem}.lg\\:-mx-32{margin-left:-8rem;margin-right:-8rem}.lg\\:-my-40{margin-bottom:-10rem;margin-top:-10rem}.lg\\:-mx-40{margin-left:-10rem;margin-right:-10rem}.lg\\:-my-48{margin-bottom:-12rem;margin-top:-12rem}.lg\\:-mx-48{margin-left:-12rem;margin-right:-12rem}.lg\\:-my-56{margin-bottom:-14rem;margin-top:-14rem}.lg\\:-mx-56{margin-left:-14rem;margin-right:-14rem}.lg\\:-my-64{margin-bottom:-16rem;margin-top:-16rem}.lg\\:-mx-64{margin-left:-16rem;margin-right:-16rem}.lg\\:-my-px{margin-bottom:-1px;margin-top:-1px}.lg\\:-mx-px{margin-left:-1px;margin-right:-1px}.lg\\:mt-0{margin-top:0}.lg\\:mr-0{margin-right:0}.lg\\:mb-0{margin-bottom:0}.lg\\:ml-0{margin-left:0}.lg\\:mt-1{margin-top:.25rem}.lg\\:mr-1{margin-right:.25rem}.lg\\:mb-1{margin-bottom:.25rem}.lg\\:ml-1{margin-left:.25rem}.lg\\:mt-2{margin-top:.5rem}.lg\\:mr-2{margin-right:.5rem}.lg\\:mb-2{margin-bottom:.5rem}.lg\\:ml-2{margin-left:.5rem}.lg\\:mt-3{margin-top:.75rem}.lg\\:mr-3{margin-right:.75rem}.lg\\:mb-3{margin-bottom:.75rem}.lg\\:ml-3{margin-left:.75rem}.lg\\:mt-4{margin-top:1rem}.lg\\:mr-4{margin-right:1rem}.lg\\:mb-4{margin-bottom:1rem}.lg\\:ml-4{margin-left:1rem}.lg\\:mt-5{margin-top:1.25rem}.lg\\:mr-5{margin-right:1.25rem}.lg\\:mb-5{margin-bottom:1.25rem}.lg\\:ml-5{margin-left:1.25rem}.lg\\:mt-6{margin-top:1.5rem}.lg\\:mr-6{margin-right:1.5rem}.lg\\:mb-6{margin-bottom:1.5rem}.lg\\:ml-6{margin-left:1.5rem}.lg\\:mt-8{margin-top:2rem}.lg\\:mr-8{margin-right:2rem}.lg\\:mb-8{margin-bottom:2rem}.lg\\:ml-8{margin-left:2rem}.lg\\:mt-10{margin-top:2.5rem}.lg\\:mr-10{margin-right:2.5rem}.lg\\:mb-10{margin-bottom:2.5rem}.lg\\:ml-10{margin-left:2.5rem}.lg\\:mt-12{margin-top:3rem}.lg\\:mr-12{margin-right:3rem}.lg\\:mb-12{margin-bottom:3rem}.lg\\:ml-12{margin-left:3rem}.lg\\:mt-16{margin-top:4rem}.lg\\:mr-16{margin-right:4rem}.lg\\:mb-16{margin-bottom:4rem}.lg\\:ml-16{margin-left:4rem}.lg\\:mt-20{margin-top:5rem}.lg\\:mr-20{margin-right:5rem}.lg\\:mb-20{margin-bottom:5rem}.lg\\:ml-20{margin-left:5rem}.lg\\:mt-24{margin-top:6rem}.lg\\:mr-24{margin-right:6rem}.lg\\:mb-24{margin-bottom:6rem}.lg\\:ml-24{margin-left:6rem}.lg\\:mt-32{margin-top:8rem}.lg\\:mr-32{margin-right:8rem}.lg\\:mb-32{margin-bottom:8rem}.lg\\:ml-32{margin-left:8rem}.lg\\:mt-40{margin-top:10rem}.lg\\:mr-40{margin-right:10rem}.lg\\:mb-40{margin-bottom:10rem}.lg\\:ml-40{margin-left:10rem}.lg\\:mt-48{margin-top:12rem}.lg\\:mr-48{margin-right:12rem}.lg\\:mb-48{margin-bottom:12rem}.lg\\:ml-48{margin-left:12rem}.lg\\:mt-56{margin-top:14rem}.lg\\:mr-56{margin-right:14rem}.lg\\:mb-56{margin-bottom:14rem}.lg\\:ml-56{margin-left:14rem}.lg\\:mt-64{margin-top:16rem}.lg\\:mr-64{margin-right:16rem}.lg\\:mb-64{margin-bottom:16rem}.lg\\:ml-64{margin-left:16rem}.lg\\:mt-auto{margin-top:auto}.lg\\:mr-auto{margin-right:auto}.lg\\:mb-auto{margin-bottom:auto}.lg\\:ml-auto{margin-left:auto}.lg\\:mt-px{margin-top:1px}.lg\\:mr-px{margin-right:1px}.lg\\:mb-px{margin-bottom:1px}.lg\\:ml-px{margin-left:1px}.lg\\:-mt-1{margin-top:-.25rem}.lg\\:-mr-1{margin-right:-.25rem}.lg\\:-mb-1{margin-bottom:-.25rem}.lg\\:-ml-1{margin-left:-.25rem}.lg\\:-mt-2{margin-top:-.5rem}.lg\\:-mr-2{margin-right:-.5rem}.lg\\:-mb-2{margin-bottom:-.5rem}.lg\\:-ml-2{margin-left:-.5rem}.lg\\:-mt-3{margin-top:-.75rem}.lg\\:-mr-3{margin-right:-.75rem}.lg\\:-mb-3{margin-bottom:-.75rem}.lg\\:-ml-3{margin-left:-.75rem}.lg\\:-mt-4{margin-top:-1rem}.lg\\:-mr-4{margin-right:-1rem}.lg\\:-mb-4{margin-bottom:-1rem}.lg\\:-ml-4{margin-left:-1rem}.lg\\:-mt-5{margin-top:-1.25rem}.lg\\:-mr-5{margin-right:-1.25rem}.lg\\:-mb-5{margin-bottom:-1.25rem}.lg\\:-ml-5{margin-left:-1.25rem}.lg\\:-mt-6{margin-top:-1.5rem}.lg\\:-mr-6{margin-right:-1.5rem}.lg\\:-mb-6{margin-bottom:-1.5rem}.lg\\:-ml-6{margin-left:-1.5rem}.lg\\:-mt-8{margin-top:-2rem}.lg\\:-mr-8{margin-right:-2rem}.lg\\:-mb-8{margin-bottom:-2rem}.lg\\:-ml-8{margin-left:-2rem}.lg\\:-mt-10{margin-top:-2.5rem}.lg\\:-mr-10{margin-right:-2.5rem}.lg\\:-mb-10{margin-bottom:-2.5rem}.lg\\:-ml-10{margin-left:-2.5rem}.lg\\:-mt-12{margin-top:-3rem}.lg\\:-mr-12{margin-right:-3rem}.lg\\:-mb-12{margin-bottom:-3rem}.lg\\:-ml-12{margin-left:-3rem}.lg\\:-mt-16{margin-top:-4rem}.lg\\:-mr-16{margin-right:-4rem}.lg\\:-mb-16{margin-bottom:-4rem}.lg\\:-ml-16{margin-left:-4rem}.lg\\:-mt-20{margin-top:-5rem}.lg\\:-mr-20{margin-right:-5rem}.lg\\:-mb-20{margin-bottom:-5rem}.lg\\:-ml-20{margin-left:-5rem}.lg\\:-mt-24{margin-top:-6rem}.lg\\:-mr-24{margin-right:-6rem}.lg\\:-mb-24{margin-bottom:-6rem}.lg\\:-ml-24{margin-left:-6rem}.lg\\:-mt-32{margin-top:-8rem}.lg\\:-mr-32{margin-right:-8rem}.lg\\:-mb-32{margin-bottom:-8rem}.lg\\:-ml-32{margin-left:-8rem}.lg\\:-mt-40{margin-top:-10rem}.lg\\:-mr-40{margin-right:-10rem}.lg\\:-mb-40{margin-bottom:-10rem}.lg\\:-ml-40{margin-left:-10rem}.lg\\:-mt-48{margin-top:-12rem}.lg\\:-mr-48{margin-right:-12rem}.lg\\:-mb-48{margin-bottom:-12rem}.lg\\:-ml-48{margin-left:-12rem}.lg\\:-mt-56{margin-top:-14rem}.lg\\:-mr-56{margin-right:-14rem}.lg\\:-mb-56{margin-bottom:-14rem}.lg\\:-ml-56{margin-left:-14rem}.lg\\:-mt-64{margin-top:-16rem}.lg\\:-mr-64{margin-right:-16rem}.lg\\:-mb-64{margin-bottom:-16rem}.lg\\:-ml-64{margin-left:-16rem}.lg\\:-mt-px{margin-top:-1px}.lg\\:-mr-px{margin-right:-1px}.lg\\:-mb-px{margin-bottom:-1px}.lg\\:-ml-px{margin-left:-1px}.lg\\:last\\:m-0:last-child{margin:0}.lg\\:last\\:m-1:last-child{margin:.25rem}.lg\\:last\\:m-2:last-child{margin:.5rem}.lg\\:last\\:m-3:last-child{margin:.75rem}.lg\\:last\\:m-4:last-child{margin:1rem}.lg\\:last\\:m-5:last-child{margin:1.25rem}.lg\\:last\\:m-6:last-child{margin:1.5rem}.lg\\:last\\:m-8:last-child{margin:2rem}.lg\\:last\\:m-10:last-child{margin:2.5rem}.lg\\:last\\:m-12:last-child{margin:3rem}.lg\\:last\\:m-16:last-child{margin:4rem}.lg\\:last\\:m-20:last-child{margin:5rem}.lg\\:last\\:m-24:last-child{margin:6rem}.lg\\:last\\:m-32:last-child{margin:8rem}.lg\\:last\\:m-40:last-child{margin:10rem}.lg\\:last\\:m-48:last-child{margin:12rem}.lg\\:last\\:m-56:last-child{margin:14rem}.lg\\:last\\:m-64:last-child{margin:16rem}.lg\\:last\\:m-auto:last-child{margin:auto}.lg\\:last\\:m-px:last-child{margin:1px}.lg\\:last\\:-m-1:last-child{margin:-.25rem}.lg\\:last\\:-m-2:last-child{margin:-.5rem}.lg\\:last\\:-m-3:last-child{margin:-.75rem}.lg\\:last\\:-m-4:last-child{margin:-1rem}.lg\\:last\\:-m-5:last-child{margin:-1.25rem}.lg\\:last\\:-m-6:last-child{margin:-1.5rem}.lg\\:last\\:-m-8:last-child{margin:-2rem}.lg\\:last\\:-m-10:last-child{margin:-2.5rem}.lg\\:last\\:-m-12:last-child{margin:-3rem}.lg\\:last\\:-m-16:last-child{margin:-4rem}.lg\\:last\\:-m-20:last-child{margin:-5rem}.lg\\:last\\:-m-24:last-child{margin:-6rem}.lg\\:last\\:-m-32:last-child{margin:-8rem}.lg\\:last\\:-m-40:last-child{margin:-10rem}.lg\\:last\\:-m-48:last-child{margin:-12rem}.lg\\:last\\:-m-56:last-child{margin:-14rem}.lg\\:last\\:-m-64:last-child{margin:-16rem}.lg\\:last\\:-m-px:last-child{margin:-1px}.lg\\:last\\:my-0:last-child{margin-bottom:0;margin-top:0}.lg\\:last\\:mx-0:last-child{margin-left:0;margin-right:0}.lg\\:last\\:my-1:last-child{margin-bottom:.25rem;margin-top:.25rem}.lg\\:last\\:mx-1:last-child{margin-left:.25rem;margin-right:.25rem}.lg\\:last\\:my-2:last-child{margin-bottom:.5rem;margin-top:.5rem}.lg\\:last\\:mx-2:last-child{margin-left:.5rem;margin-right:.5rem}.lg\\:last\\:my-3:last-child{margin-bottom:.75rem;margin-top:.75rem}.lg\\:last\\:mx-3:last-child{margin-left:.75rem;margin-right:.75rem}.lg\\:last\\:my-4:last-child{margin-bottom:1rem;margin-top:1rem}.lg\\:last\\:mx-4:last-child{margin-left:1rem;margin-right:1rem}.lg\\:last\\:my-5:last-child{margin-bottom:1.25rem;margin-top:1.25rem}.lg\\:last\\:mx-5:last-child{margin-left:1.25rem;margin-right:1.25rem}.lg\\:last\\:my-6:last-child{margin-bottom:1.5rem;margin-top:1.5rem}.lg\\:last\\:mx-6:last-child{margin-left:1.5rem;margin-right:1.5rem}.lg\\:last\\:my-8:last-child{margin-bottom:2rem;margin-top:2rem}.lg\\:last\\:mx-8:last-child{margin-left:2rem;margin-right:2rem}.lg\\:last\\:my-10:last-child{margin-bottom:2.5rem;margin-top:2.5rem}.lg\\:last\\:mx-10:last-child{margin-left:2.5rem;margin-right:2.5rem}.lg\\:last\\:my-12:last-child{margin-bottom:3rem;margin-top:3rem}.lg\\:last\\:mx-12:last-child{margin-left:3rem;margin-right:3rem}.lg\\:last\\:my-16:last-child{margin-bottom:4rem;margin-top:4rem}.lg\\:last\\:mx-16:last-child{margin-left:4rem;margin-right:4rem}.lg\\:last\\:my-20:last-child{margin-bottom:5rem;margin-top:5rem}.lg\\:last\\:mx-20:last-child{margin-left:5rem;margin-right:5rem}.lg\\:last\\:my-24:last-child{margin-bottom:6rem;margin-top:6rem}.lg\\:last\\:mx-24:last-child{margin-left:6rem;margin-right:6rem}.lg\\:last\\:my-32:last-child{margin-bottom:8rem;margin-top:8rem}.lg\\:last\\:mx-32:last-child{margin-left:8rem;margin-right:8rem}.lg\\:last\\:my-40:last-child{margin-bottom:10rem;margin-top:10rem}.lg\\:last\\:mx-40:last-child{margin-left:10rem;margin-right:10rem}.lg\\:last\\:my-48:last-child{margin-bottom:12rem;margin-top:12rem}.lg\\:last\\:mx-48:last-child{margin-left:12rem;margin-right:12rem}.lg\\:last\\:my-56:last-child{margin-bottom:14rem;margin-top:14rem}.lg\\:last\\:mx-56:last-child{margin-left:14rem;margin-right:14rem}.lg\\:last\\:my-64:last-child{margin-bottom:16rem;margin-top:16rem}.lg\\:last\\:mx-64:last-child{margin-left:16rem;margin-right:16rem}.lg\\:last\\:my-auto:last-child{margin-bottom:auto;margin-top:auto}.lg\\:last\\:mx-auto:last-child{margin-left:auto;margin-right:auto}.lg\\:last\\:my-px:last-child{margin-bottom:1px;margin-top:1px}.lg\\:last\\:mx-px:last-child{margin-left:1px;margin-right:1px}.lg\\:last\\:-my-1:last-child{margin-bottom:-.25rem;margin-top:-.25rem}.lg\\:last\\:-mx-1:last-child{margin-left:-.25rem;margin-right:-.25rem}.lg\\:last\\:-my-2:last-child{margin-bottom:-.5rem;margin-top:-.5rem}.lg\\:last\\:-mx-2:last-child{margin-left:-.5rem;margin-right:-.5rem}.lg\\:last\\:-my-3:last-child{margin-bottom:-.75rem;margin-top:-.75rem}.lg\\:last\\:-mx-3:last-child{margin-left:-.75rem;margin-right:-.75rem}.lg\\:last\\:-my-4:last-child{margin-bottom:-1rem;margin-top:-1rem}.lg\\:last\\:-mx-4:last-child{margin-left:-1rem;margin-right:-1rem}.lg\\:last\\:-my-5:last-child{margin-bottom:-1.25rem;margin-top:-1.25rem}.lg\\:last\\:-mx-5:last-child{margin-left:-1.25rem;margin-right:-1.25rem}.lg\\:last\\:-my-6:last-child{margin-bottom:-1.5rem;margin-top:-1.5rem}.lg\\:last\\:-mx-6:last-child{margin-left:-1.5rem;margin-right:-1.5rem}.lg\\:last\\:-my-8:last-child{margin-bottom:-2rem;margin-top:-2rem}.lg\\:last\\:-mx-8:last-child{margin-left:-2rem;margin-right:-2rem}.lg\\:last\\:-my-10:last-child{margin-bottom:-2.5rem;margin-top:-2.5rem}.lg\\:last\\:-mx-10:last-child{margin-left:-2.5rem;margin-right:-2.5rem}.lg\\:last\\:-my-12:last-child{margin-bottom:-3rem;margin-top:-3rem}.lg\\:last\\:-mx-12:last-child{margin-left:-3rem;margin-right:-3rem}.lg\\:last\\:-my-16:last-child{margin-bottom:-4rem;margin-top:-4rem}.lg\\:last\\:-mx-16:last-child{margin-left:-4rem;margin-right:-4rem}.lg\\:last\\:-my-20:last-child{margin-bottom:-5rem;margin-top:-5rem}.lg\\:last\\:-mx-20:last-child{margin-left:-5rem;margin-right:-5rem}.lg\\:last\\:-my-24:last-child{margin-bottom:-6rem;margin-top:-6rem}.lg\\:last\\:-mx-24:last-child{margin-left:-6rem;margin-right:-6rem}.lg\\:last\\:-my-32:last-child{margin-bottom:-8rem;margin-top:-8rem}.lg\\:last\\:-mx-32:last-child{margin-left:-8rem;margin-right:-8rem}.lg\\:last\\:-my-40:last-child{margin-bottom:-10rem;margin-top:-10rem}.lg\\:last\\:-mx-40:last-child{margin-left:-10rem;margin-right:-10rem}.lg\\:last\\:-my-48:last-child{margin-bottom:-12rem;margin-top:-12rem}.lg\\:last\\:-mx-48:last-child{margin-left:-12rem;margin-right:-12rem}.lg\\:last\\:-my-56:last-child{margin-bottom:-14rem;margin-top:-14rem}.lg\\:last\\:-mx-56:last-child{margin-left:-14rem;margin-right:-14rem}.lg\\:last\\:-my-64:last-child{margin-bottom:-16rem;margin-top:-16rem}.lg\\:last\\:-mx-64:last-child{margin-left:-16rem;margin-right:-16rem}.lg\\:last\\:-my-px:last-child{margin-bottom:-1px;margin-top:-1px}.lg\\:last\\:-mx-px:last-child{margin-left:-1px;margin-right:-1px}.lg\\:last\\:mt-0:last-child{margin-top:0}.lg\\:last\\:mr-0:last-child{margin-right:0}.lg\\:last\\:mb-0:last-child{margin-bottom:0}.lg\\:last\\:ml-0:last-child{margin-left:0}.lg\\:last\\:mt-1:last-child{margin-top:.25rem}.lg\\:last\\:mr-1:last-child{margin-right:.25rem}.lg\\:last\\:mb-1:last-child{margin-bottom:.25rem}.lg\\:last\\:ml-1:last-child{margin-left:.25rem}.lg\\:last\\:mt-2:last-child{margin-top:.5rem}.lg\\:last\\:mr-2:last-child{margin-right:.5rem}.lg\\:last\\:mb-2:last-child{margin-bottom:.5rem}.lg\\:last\\:ml-2:last-child{margin-left:.5rem}.lg\\:last\\:mt-3:last-child{margin-top:.75rem}.lg\\:last\\:mr-3:last-child{margin-right:.75rem}.lg\\:last\\:mb-3:last-child{margin-bottom:.75rem}.lg\\:last\\:ml-3:last-child{margin-left:.75rem}.lg\\:last\\:mt-4:last-child{margin-top:1rem}.lg\\:last\\:mr-4:last-child{margin-right:1rem}.lg\\:last\\:mb-4:last-child{margin-bottom:1rem}.lg\\:last\\:ml-4:last-child{margin-left:1rem}.lg\\:last\\:mt-5:last-child{margin-top:1.25rem}.lg\\:last\\:mr-5:last-child{margin-right:1.25rem}.lg\\:last\\:mb-5:last-child{margin-bottom:1.25rem}.lg\\:last\\:ml-5:last-child{margin-left:1.25rem}.lg\\:last\\:mt-6:last-child{margin-top:1.5rem}.lg\\:last\\:mr-6:last-child{margin-right:1.5rem}.lg\\:last\\:mb-6:last-child{margin-bottom:1.5rem}.lg\\:last\\:ml-6:last-child{margin-left:1.5rem}.lg\\:last\\:mt-8:last-child{margin-top:2rem}.lg\\:last\\:mr-8:last-child{margin-right:2rem}.lg\\:last\\:mb-8:last-child{margin-bottom:2rem}.lg\\:last\\:ml-8:last-child{margin-left:2rem}.lg\\:last\\:mt-10:last-child{margin-top:2.5rem}.lg\\:last\\:mr-10:last-child{margin-right:2.5rem}.lg\\:last\\:mb-10:last-child{margin-bottom:2.5rem}.lg\\:last\\:ml-10:last-child{margin-left:2.5rem}.lg\\:last\\:mt-12:last-child{margin-top:3rem}.lg\\:last\\:mr-12:last-child{margin-right:3rem}.lg\\:last\\:mb-12:last-child{margin-bottom:3rem}.lg\\:last\\:ml-12:last-child{margin-left:3rem}.lg\\:last\\:mt-16:last-child{margin-top:4rem}.lg\\:last\\:mr-16:last-child{margin-right:4rem}.lg\\:last\\:mb-16:last-child{margin-bottom:4rem}.lg\\:last\\:ml-16:last-child{margin-left:4rem}.lg\\:last\\:mt-20:last-child{margin-top:5rem}.lg\\:last\\:mr-20:last-child{margin-right:5rem}.lg\\:last\\:mb-20:last-child{margin-bottom:5rem}.lg\\:last\\:ml-20:last-child{margin-left:5rem}.lg\\:last\\:mt-24:last-child{margin-top:6rem}.lg\\:last\\:mr-24:last-child{margin-right:6rem}.lg\\:last\\:mb-24:last-child{margin-bottom:6rem}.lg\\:last\\:ml-24:last-child{margin-left:6rem}.lg\\:last\\:mt-32:last-child{margin-top:8rem}.lg\\:last\\:mr-32:last-child{margin-right:8rem}.lg\\:last\\:mb-32:last-child{margin-bottom:8rem}.lg\\:last\\:ml-32:last-child{margin-left:8rem}.lg\\:last\\:mt-40:last-child{margin-top:10rem}.lg\\:last\\:mr-40:last-child{margin-right:10rem}.lg\\:last\\:mb-40:last-child{margin-bottom:10rem}.lg\\:last\\:ml-40:last-child{margin-left:10rem}.lg\\:last\\:mt-48:last-child{margin-top:12rem}.lg\\:last\\:mr-48:last-child{margin-right:12rem}.lg\\:last\\:mb-48:last-child{margin-bottom:12rem}.lg\\:last\\:ml-48:last-child{margin-left:12rem}.lg\\:last\\:mt-56:last-child{margin-top:14rem}.lg\\:last\\:mr-56:last-child{margin-right:14rem}.lg\\:last\\:mb-56:last-child{margin-bottom:14rem}.lg\\:last\\:ml-56:last-child{margin-left:14rem}.lg\\:last\\:mt-64:last-child{margin-top:16rem}.lg\\:last\\:mr-64:last-child{margin-right:16rem}.lg\\:last\\:mb-64:last-child{margin-bottom:16rem}.lg\\:last\\:ml-64:last-child{margin-left:16rem}.lg\\:last\\:mt-auto:last-child{margin-top:auto}.lg\\:last\\:mr-auto:last-child{margin-right:auto}.lg\\:last\\:mb-auto:last-child{margin-bottom:auto}.lg\\:last\\:ml-auto:last-child{margin-left:auto}.lg\\:last\\:mt-px:last-child{margin-top:1px}.lg\\:last\\:mr-px:last-child{margin-right:1px}.lg\\:last\\:mb-px:last-child{margin-bottom:1px}.lg\\:last\\:ml-px:last-child{margin-left:1px}.lg\\:last\\:-mt-1:last-child{margin-top:-.25rem}.lg\\:last\\:-mr-1:last-child{margin-right:-.25rem}.lg\\:last\\:-mb-1:last-child{margin-bottom:-.25rem}.lg\\:last\\:-ml-1:last-child{margin-left:-.25rem}.lg\\:last\\:-mt-2:last-child{margin-top:-.5rem}.lg\\:last\\:-mr-2:last-child{margin-right:-.5rem}.lg\\:last\\:-mb-2:last-child{margin-bottom:-.5rem}.lg\\:last\\:-ml-2:last-child{margin-left:-.5rem}.lg\\:last\\:-mt-3:last-child{margin-top:-.75rem}.lg\\:last\\:-mr-3:last-child{margin-right:-.75rem}.lg\\:last\\:-mb-3:last-child{margin-bottom:-.75rem}.lg\\:last\\:-ml-3:last-child{margin-left:-.75rem}.lg\\:last\\:-mt-4:last-child{margin-top:-1rem}.lg\\:last\\:-mr-4:last-child{margin-right:-1rem}.lg\\:last\\:-mb-4:last-child{margin-bottom:-1rem}.lg\\:last\\:-ml-4:last-child{margin-left:-1rem}.lg\\:last\\:-mt-5:last-child{margin-top:-1.25rem}.lg\\:last\\:-mr-5:last-child{margin-right:-1.25rem}.lg\\:last\\:-mb-5:last-child{margin-bottom:-1.25rem}.lg\\:last\\:-ml-5:last-child{margin-left:-1.25rem}.lg\\:last\\:-mt-6:last-child{margin-top:-1.5rem}.lg\\:last\\:-mr-6:last-child{margin-right:-1.5rem}.lg\\:last\\:-mb-6:last-child{margin-bottom:-1.5rem}.lg\\:last\\:-ml-6:last-child{margin-left:-1.5rem}.lg\\:last\\:-mt-8:last-child{margin-top:-2rem}.lg\\:last\\:-mr-8:last-child{margin-right:-2rem}.lg\\:last\\:-mb-8:last-child{margin-bottom:-2rem}.lg\\:last\\:-ml-8:last-child{margin-left:-2rem}.lg\\:last\\:-mt-10:last-child{margin-top:-2.5rem}.lg\\:last\\:-mr-10:last-child{margin-right:-2.5rem}.lg\\:last\\:-mb-10:last-child{margin-bottom:-2.5rem}.lg\\:last\\:-ml-10:last-child{margin-left:-2.5rem}.lg\\:last\\:-mt-12:last-child{margin-top:-3rem}.lg\\:last\\:-mr-12:last-child{margin-right:-3rem}.lg\\:last\\:-mb-12:last-child{margin-bottom:-3rem}.lg\\:last\\:-ml-12:last-child{margin-left:-3rem}.lg\\:last\\:-mt-16:last-child{margin-top:-4rem}.lg\\:last\\:-mr-16:last-child{margin-right:-4rem}.lg\\:last\\:-mb-16:last-child{margin-bottom:-4rem}.lg\\:last\\:-ml-16:last-child{margin-left:-4rem}.lg\\:last\\:-mt-20:last-child{margin-top:-5rem}.lg\\:last\\:-mr-20:last-child{margin-right:-5rem}.lg\\:last\\:-mb-20:last-child{margin-bottom:-5rem}.lg\\:last\\:-ml-20:last-child{margin-left:-5rem}.lg\\:last\\:-mt-24:last-child{margin-top:-6rem}.lg\\:last\\:-mr-24:last-child{margin-right:-6rem}.lg\\:last\\:-mb-24:last-child{margin-bottom:-6rem}.lg\\:last\\:-ml-24:last-child{margin-left:-6rem}.lg\\:last\\:-mt-32:last-child{margin-top:-8rem}.lg\\:last\\:-mr-32:last-child{margin-right:-8rem}.lg\\:last\\:-mb-32:last-child{margin-bottom:-8rem}.lg\\:last\\:-ml-32:last-child{margin-left:-8rem}.lg\\:last\\:-mt-40:last-child{margin-top:-10rem}.lg\\:last\\:-mr-40:last-child{margin-right:-10rem}.lg\\:last\\:-mb-40:last-child{margin-bottom:-10rem}.lg\\:last\\:-ml-40:last-child{margin-left:-10rem}.lg\\:last\\:-mt-48:last-child{margin-top:-12rem}.lg\\:last\\:-mr-48:last-child{margin-right:-12rem}.lg\\:last\\:-mb-48:last-child{margin-bottom:-12rem}.lg\\:last\\:-ml-48:last-child{margin-left:-12rem}.lg\\:last\\:-mt-56:last-child{margin-top:-14rem}.lg\\:last\\:-mr-56:last-child{margin-right:-14rem}.lg\\:last\\:-mb-56:last-child{margin-bottom:-14rem}.lg\\:last\\:-ml-56:last-child{margin-left:-14rem}.lg\\:last\\:-mt-64:last-child{margin-top:-16rem}.lg\\:last\\:-mr-64:last-child{margin-right:-16rem}.lg\\:last\\:-mb-64:last-child{margin-bottom:-16rem}.lg\\:last\\:-ml-64:last-child{margin-left:-16rem}.lg\\:last\\:-mt-px:last-child{margin-top:-1px}.lg\\:last\\:-mr-px:last-child{margin-right:-1px}.lg\\:last\\:-mb-px:last-child{margin-bottom:-1px}.lg\\:last\\:-ml-px:last-child{margin-left:-1px}.lg\\:max-h-0{max-height:0}.lg\\:max-h-1{max-height:.25rem}.lg\\:max-h-2{max-height:.5rem}.lg\\:max-h-3{max-height:.75rem}.lg\\:max-h-4{max-height:1rem}.lg\\:max-h-5{max-height:1.25rem}.lg\\:max-h-6{max-height:1.5rem}.lg\\:max-h-8{max-height:2rem}.lg\\:max-h-10{max-height:2.5rem}.lg\\:max-h-12{max-height:3rem}.lg\\:max-h-16{max-height:4rem}.lg\\:max-h-20{max-height:5rem}.lg\\:max-h-24{max-height:6rem}.lg\\:max-h-32{max-height:8rem}.lg\\:max-h-40{max-height:10rem}.lg\\:max-h-48{max-height:12rem}.lg\\:max-h-56{max-height:14rem}.lg\\:max-h-64{max-height:16rem}.lg\\:max-h-xl{max-height:36rem}.lg\\:max-h-px{max-height:1px}.lg\\:max-w-none{max-width:none}.lg\\:max-w-xs{max-width:20rem}.lg\\:max-w-sm{max-width:24rem}.lg\\:max-w-md{max-width:28rem}.lg\\:max-w-lg{max-width:32rem}.lg\\:max-w-xl{max-width:36rem}.lg\\:max-w-2xl{max-width:42rem}.lg\\:max-w-3xl{max-width:48rem}.lg\\:max-w-4xl{max-width:56rem}.lg\\:max-w-5xl{max-width:64rem}.lg\\:max-w-6xl{max-width:72rem}.lg\\:max-w-full{max-width:100%}.lg\\:max-w-screen-sm{max-width:640px}.lg\\:max-w-screen-md{max-width:768px}.lg\\:max-w-screen-lg{max-width:1024px}.lg\\:max-w-screen-xl{max-width:1280px}.lg\\:min-h-0{min-height:0}.lg\\:min-h-full{min-height:100%}.lg\\:min-h-screen{min-height:100vh}.lg\\:min-w-0{min-width:0}.lg\\:min-w-1{min-width:.25rem}.lg\\:min-w-2{min-width:.5rem}.lg\\:min-w-3{min-width:.75rem}.lg\\:min-w-4{min-width:1rem}.lg\\:min-w-5{min-width:1.25rem}.lg\\:min-w-6{min-width:1.5rem}.lg\\:min-w-8{min-width:2rem}.lg\\:min-w-10{min-width:2.5rem}.lg\\:min-w-12{min-width:3rem}.lg\\:min-w-16{min-width:4rem}.lg\\:min-w-20{min-width:5rem}.lg\\:min-w-24{min-width:6rem}.lg\\:min-w-32{min-width:8rem}.lg\\:min-w-40{min-width:10rem}.lg\\:min-w-48{min-width:12rem}.lg\\:min-w-56{min-width:14rem}.lg\\:min-w-64{min-width:16rem}.lg\\:min-w-max-content{min-width:-webkit-max-content;min-width:max-content}.lg\\:min-w-px{min-width:1px}.lg\\:object-contain{object-fit:contain}.lg\\:object-cover{object-fit:cover}.lg\\:object-fill{object-fit:fill}.lg\\:object-none{object-fit:none}.lg\\:object-scale-down{object-fit:scale-down}.lg\\:object-bottom{object-position:bottom}.lg\\:object-center{object-position:center}.lg\\:object-left{object-position:left}.lg\\:object-left-bottom{object-position:left bottom}.lg\\:object-left-top{object-position:left top}.lg\\:object-right{object-position:right}.lg\\:object-right-bottom{object-position:right bottom}.lg\\:object-right-top{object-position:right top}.lg\\:object-top{object-position:top}.lg\\:opacity-0{opacity:0}.lg\\:opacity-25{opacity:.25}.lg\\:opacity-50{opacity:.5}.lg\\:opacity-75{opacity:.75}.lg\\:opacity-100{opacity:1}.lg\\:hover\\:opacity-0:hover{opacity:0}.lg\\:hover\\:opacity-25:hover{opacity:.25}.lg\\:hover\\:opacity-50:hover{opacity:.5}.lg\\:hover\\:opacity-75:hover{opacity:.75}.lg\\:hover\\:opacity-100:hover{opacity:1}.lg\\:focus\\:opacity-0:focus{opacity:0}.lg\\:focus\\:opacity-25:focus{opacity:.25}.lg\\:focus\\:opacity-50:focus{opacity:.5}.lg\\:focus\\:opacity-75:focus{opacity:.75}.lg\\:focus\\:opacity-100:focus{opacity:1}.lg\\:focus\\:outline-none:focus,.lg\\:outline-none{outline:0}.lg\\:overflow-auto{overflow:auto}.lg\\:overflow-hidden{overflow:hidden}.lg\\:overflow-visible{overflow:visible}.lg\\:overflow-scroll{overflow:scroll}.lg\\:overflow-x-auto{overflow-x:auto}.lg\\:overflow-y-auto{overflow-y:auto}.lg\\:overflow-x-hidden{overflow-x:hidden}.lg\\:overflow-y-hidden{overflow-y:hidden}.lg\\:overflow-x-visible{overflow-x:visible}.lg\\:overflow-y-visible{overflow-y:visible}.lg\\:overflow-x-scroll{overflow-x:scroll}.lg\\:overflow-y-scroll{overflow-y:scroll}.lg\\:scrolling-touch{-webkit-overflow-scrolling:touch}.lg\\:scrolling-auto{-webkit-overflow-scrolling:auto}.lg\\:p-0{padding:0}.lg\\:p-1{padding:.25rem}.lg\\:p-2{padding:.5rem}.lg\\:p-3{padding:.75rem}.lg\\:p-4{padding:1rem}.lg\\:p-5{padding:1.25rem}.lg\\:p-6{padding:1.5rem}.lg\\:p-8{padding:2rem}.lg\\:p-10{padding:2.5rem}.lg\\:p-12{padding:3rem}.lg\\:p-16{padding:4rem}.lg\\:p-20{padding:5rem}.lg\\:p-24{padding:6rem}.lg\\:p-32{padding:8rem}.lg\\:p-40{padding:10rem}.lg\\:p-48{padding:12rem}.lg\\:p-56{padding:14rem}.lg\\:p-64{padding:16rem}.lg\\:p-px{padding:1px}.lg\\:py-0{padding-bottom:0;padding-top:0}.lg\\:px-0{padding-left:0;padding-right:0}.lg\\:py-1{padding-bottom:.25rem;padding-top:.25rem}.lg\\:px-1{padding-left:.25rem;padding-right:.25rem}.lg\\:py-2{padding-bottom:.5rem;padding-top:.5rem}.lg\\:px-2{padding-left:.5rem;padding-right:.5rem}.lg\\:py-3{padding-bottom:.75rem;padding-top:.75rem}.lg\\:px-3{padding-left:.75rem;padding-right:.75rem}.lg\\:py-4{padding-bottom:1rem;padding-top:1rem}.lg\\:px-4{padding-left:1rem;padding-right:1rem}.lg\\:py-5{padding-bottom:1.25rem;padding-top:1.25rem}.lg\\:px-5{padding-left:1.25rem;padding-right:1.25rem}.lg\\:py-6{padding-bottom:1.5rem;padding-top:1.5rem}.lg\\:px-6{padding-left:1.5rem;padding-right:1.5rem}.lg\\:py-8{padding-bottom:2rem;padding-top:2rem}.lg\\:px-8{padding-left:2rem;padding-right:2rem}.lg\\:py-10{padding-bottom:2.5rem;padding-top:2.5rem}.lg\\:px-10{padding-left:2.5rem;padding-right:2.5rem}.lg\\:py-12{padding-bottom:3rem;padding-top:3rem}.lg\\:px-12{padding-left:3rem;padding-right:3rem}.lg\\:py-16{padding-bottom:4rem;padding-top:4rem}.lg\\:px-16{padding-left:4rem;padding-right:4rem}.lg\\:py-20{padding-bottom:5rem;padding-top:5rem}.lg\\:px-20{padding-left:5rem;padding-right:5rem}.lg\\:py-24{padding-bottom:6rem;padding-top:6rem}.lg\\:px-24{padding-left:6rem;padding-right:6rem}.lg\\:py-32{padding-bottom:8rem;padding-top:8rem}.lg\\:px-32{padding-left:8rem;padding-right:8rem}.lg\\:py-40{padding-bottom:10rem;padding-top:10rem}.lg\\:px-40{padding-left:10rem;padding-right:10rem}.lg\\:py-48{padding-bottom:12rem;padding-top:12rem}.lg\\:px-48{padding-left:12rem;padding-right:12rem}.lg\\:py-56{padding-bottom:14rem;padding-top:14rem}.lg\\:px-56{padding-left:14rem;padding-right:14rem}.lg\\:py-64{padding-bottom:16rem;padding-top:16rem}.lg\\:px-64{padding-left:16rem;padding-right:16rem}.lg\\:py-px{padding-bottom:1px;padding-top:1px}.lg\\:px-px{padding-left:1px;padding-right:1px}.lg\\:pt-0{padding-top:0}.lg\\:pr-0{padding-right:0}.lg\\:pb-0{padding-bottom:0}.lg\\:pl-0{padding-left:0}.lg\\:pt-1{padding-top:.25rem}.lg\\:pr-1{padding-right:.25rem}.lg\\:pb-1{padding-bottom:.25rem}.lg\\:pl-1{padding-left:.25rem}.lg\\:pt-2{padding-top:.5rem}.lg\\:pr-2{padding-right:.5rem}.lg\\:pb-2{padding-bottom:.5rem}.lg\\:pl-2{padding-left:.5rem}.lg\\:pt-3{padding-top:.75rem}.lg\\:pr-3{padding-right:.75rem}.lg\\:pb-3{padding-bottom:.75rem}.lg\\:pl-3{padding-left:.75rem}.lg\\:pt-4{padding-top:1rem}.lg\\:pr-4{padding-right:1rem}.lg\\:pb-4{padding-bottom:1rem}.lg\\:pl-4{padding-left:1rem}.lg\\:pt-5{padding-top:1.25rem}.lg\\:pr-5{padding-right:1.25rem}.lg\\:pb-5{padding-bottom:1.25rem}.lg\\:pl-5{padding-left:1.25rem}.lg\\:pt-6{padding-top:1.5rem}.lg\\:pr-6{padding-right:1.5rem}.lg\\:pb-6{padding-bottom:1.5rem}.lg\\:pl-6{padding-left:1.5rem}.lg\\:pt-8{padding-top:2rem}.lg\\:pr-8{padding-right:2rem}.lg\\:pb-8{padding-bottom:2rem}.lg\\:pl-8{padding-left:2rem}.lg\\:pt-10{padding-top:2.5rem}.lg\\:pr-10{padding-right:2.5rem}.lg\\:pb-10{padding-bottom:2.5rem}.lg\\:pl-10{padding-left:2.5rem}.lg\\:pt-12{padding-top:3rem}.lg\\:pr-12{padding-right:3rem}.lg\\:pb-12{padding-bottom:3rem}.lg\\:pl-12{padding-left:3rem}.lg\\:pt-16{padding-top:4rem}.lg\\:pr-16{padding-right:4rem}.lg\\:pb-16{padding-bottom:4rem}.lg\\:pl-16{padding-left:4rem}.lg\\:pt-20{padding-top:5rem}.lg\\:pr-20{padding-right:5rem}.lg\\:pb-20{padding-bottom:5rem}.lg\\:pl-20{padding-left:5rem}.lg\\:pt-24{padding-top:6rem}.lg\\:pr-24{padding-right:6rem}.lg\\:pb-24{padding-bottom:6rem}.lg\\:pl-24{padding-left:6rem}.lg\\:pt-32{padding-top:8rem}.lg\\:pr-32{padding-right:8rem}.lg\\:pb-32{padding-bottom:8rem}.lg\\:pl-32{padding-left:8rem}.lg\\:pt-40{padding-top:10rem}.lg\\:pr-40{padding-right:10rem}.lg\\:pb-40{padding-bottom:10rem}.lg\\:pl-40{padding-left:10rem}.lg\\:pt-48{padding-top:12rem}.lg\\:pr-48{padding-right:12rem}.lg\\:pb-48{padding-bottom:12rem}.lg\\:pl-48{padding-left:12rem}.lg\\:pt-56{padding-top:14rem}.lg\\:pr-56{padding-right:14rem}.lg\\:pb-56{padding-bottom:14rem}.lg\\:pl-56{padding-left:14rem}.lg\\:pt-64{padding-top:16rem}.lg\\:pr-64{padding-right:16rem}.lg\\:pb-64{padding-bottom:16rem}.lg\\:pl-64{padding-left:16rem}.lg\\:pt-px{padding-top:1px}.lg\\:pr-px{padding-right:1px}.lg\\:pb-px{padding-bottom:1px}.lg\\:pl-px{padding-left:1px}.lg\\:placeholder-transparent::placeholder{color:#0000}.lg\\:placeholder-white::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.lg\\:placeholder-black::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.lg\\:placeholder-gray-50::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.lg\\:placeholder-gray-100::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.lg\\:placeholder-gray-200::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.lg\\:placeholder-gray-300::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.lg\\:placeholder-gray-400::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.lg\\:placeholder-gray-500::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.lg\\:placeholder-gray-600::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.lg\\:placeholder-gray-700::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.lg\\:placeholder-gray-800::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.lg\\:placeholder-gray-900::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.lg\\:placeholder-cool-gray-50::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.lg\\:placeholder-cool-gray-100::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.lg\\:placeholder-cool-gray-200::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.lg\\:placeholder-cool-gray-300::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.lg\\:placeholder-cool-gray-400::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.lg\\:placeholder-cool-gray-500::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.lg\\:placeholder-cool-gray-600::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.lg\\:placeholder-cool-gray-700::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.lg\\:placeholder-cool-gray-800::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.lg\\:placeholder-cool-gray-900::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.lg\\:placeholder-red-50::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.lg\\:placeholder-red-100::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.lg\\:placeholder-red-200::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.lg\\:placeholder-red-300::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.lg\\:placeholder-red-400::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.lg\\:placeholder-red-500::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.lg\\:placeholder-red-600::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.lg\\:placeholder-red-700::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.lg\\:placeholder-red-800::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.lg\\:placeholder-red-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.lg\\:placeholder-orange-50::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.lg\\:placeholder-orange-100::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.lg\\:placeholder-orange-200::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.lg\\:placeholder-orange-300::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.lg\\:placeholder-orange-400::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.lg\\:placeholder-orange-500::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.lg\\:placeholder-orange-600::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.lg\\:placeholder-orange-700::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.lg\\:placeholder-orange-800::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.lg\\:placeholder-orange-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.lg\\:placeholder-yellow-50::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.lg\\:placeholder-yellow-100::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.lg\\:placeholder-yellow-200::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.lg\\:placeholder-yellow-300::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.lg\\:placeholder-yellow-400::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.lg\\:placeholder-yellow-500::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.lg\\:placeholder-yellow-600::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.lg\\:placeholder-yellow-700::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.lg\\:placeholder-yellow-800::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.lg\\:placeholder-yellow-900::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.lg\\:placeholder-green-50::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.lg\\:placeholder-green-100::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.lg\\:placeholder-green-200::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.lg\\:placeholder-green-300::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.lg\\:placeholder-green-400::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.lg\\:placeholder-green-500::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.lg\\:placeholder-green-600::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.lg\\:placeholder-green-700::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.lg\\:placeholder-green-800::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.lg\\:placeholder-green-900::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.lg\\:placeholder-teal-50::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.lg\\:placeholder-teal-100::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.lg\\:placeholder-teal-200::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.lg\\:placeholder-teal-300::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.lg\\:placeholder-teal-400::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.lg\\:placeholder-teal-500::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.lg\\:placeholder-teal-600::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.lg\\:placeholder-teal-700::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.lg\\:placeholder-teal-800::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.lg\\:placeholder-teal-900::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.lg\\:placeholder-blue-50::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.lg\\:placeholder-blue-100::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.lg\\:placeholder-blue-200::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.lg\\:placeholder-blue-300::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.lg\\:placeholder-blue-400::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.lg\\:placeholder-blue-500::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.lg\\:placeholder-blue-600::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.lg\\:placeholder-blue-700::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.lg\\:placeholder-blue-800::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.lg\\:placeholder-blue-900::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.lg\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.lg\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.lg\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.lg\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.lg\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.lg\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.lg\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.lg\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.lg\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.lg\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.lg\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.lg\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.lg\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.lg\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.lg\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.lg\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.lg\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.lg\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.lg\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.lg\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.lg\\:placeholder-pink-50::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.lg\\:placeholder-pink-100::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.lg\\:placeholder-pink-200::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.lg\\:placeholder-pink-300::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.lg\\:placeholder-pink-400::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.lg\\:placeholder-pink-500::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.lg\\:placeholder-pink-600::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.lg\\:placeholder-pink-700::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.lg\\:placeholder-pink-800::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.lg\\:placeholder-pink-900::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-transparent:focus::placeholder{color:#0000}.lg\\:focus\\:placeholder-white:focus::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-black:focus::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-gray-50:focus::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-gray-300:focus::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-gray-400:focus::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-gray-500:focus::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-gray-600:focus::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-gray-700:focus::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-gray-800:focus::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-gray-900:focus::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-cool-gray-50:focus::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-cool-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-cool-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-cool-gray-300:focus::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-cool-gray-400:focus::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-cool-gray-500:focus::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-cool-gray-600:focus::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-cool-gray-700:focus::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-cool-gray-800:focus::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-cool-gray-900:focus::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-red-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-red-100:focus::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-red-200:focus::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-red-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-red-400:focus::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-red-500:focus::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-red-600:focus::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-red-700:focus::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-red-800:focus::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-red-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-orange-50:focus::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-orange-100:focus::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-orange-200:focus::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-orange-300:focus::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-orange-400:focus::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-orange-500:focus::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-orange-600:focus::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-orange-700:focus::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-orange-800:focus::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-orange-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-yellow-50:focus::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-yellow-100:focus::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-yellow-200:focus::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-yellow-300:focus::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-yellow-400:focus::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-yellow-500:focus::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-yellow-600:focus::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-yellow-700:focus::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-yellow-800:focus::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-yellow-900:focus::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-green-50:focus::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-green-100:focus::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-green-200:focus::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-green-300:focus::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-green-400:focus::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-green-500:focus::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-green-600:focus::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-green-700:focus::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-green-800:focus::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-green-900:focus::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-teal-50:focus::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-teal-100:focus::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-teal-200:focus::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-teal-300:focus::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-teal-400:focus::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-teal-500:focus::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-teal-600:focus::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-teal-700:focus::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-teal-800:focus::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-teal-900:focus::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-blue-50:focus::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-blue-100:focus::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-blue-200:focus::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-blue-300:focus::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-blue-400:focus::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-blue-500:focus::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-blue-600:focus::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-blue-700:focus::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-blue-800:focus::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-blue-900:focus::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-pink-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-pink-100:focus::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-pink-200:focus::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-pink-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-pink-400:focus::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-pink-500:focus::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-pink-600:focus::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-pink-700:focus::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-pink-800:focus::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.lg\\:focus\\:placeholder-pink-900:focus::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-transparent::placeholder{color:#0000}.theme-dark .lg\\:dark\\:placeholder-white::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-black::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-gray-50::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-gray-100::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-gray-200::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-gray-300::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-gray-400::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-gray-500::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-gray-600::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-gray-700::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-gray-800::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-gray-900::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-cool-gray-50::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-cool-gray-100::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-cool-gray-200::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-cool-gray-300::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-cool-gray-400::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-cool-gray-500::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-cool-gray-600::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-cool-gray-700::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-cool-gray-800::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-cool-gray-900::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-red-50::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-red-100::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-red-200::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-red-300::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-red-400::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-red-500::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-red-600::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-red-700::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-red-800::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-red-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-orange-50::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-orange-100::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-orange-200::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-orange-300::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-orange-400::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-orange-500::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-orange-600::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-orange-700::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-orange-800::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-orange-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-yellow-50::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-yellow-100::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-yellow-200::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-yellow-300::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-yellow-400::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-yellow-500::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-yellow-600::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-yellow-700::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-yellow-800::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-yellow-900::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-green-50::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-green-100::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-green-200::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-green-300::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-green-400::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-green-500::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-green-600::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-green-700::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-green-800::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-green-900::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-teal-50::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-teal-100::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-teal-200::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-teal-300::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-teal-400::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-teal-500::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-teal-600::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-teal-700::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-teal-800::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-teal-900::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-blue-50::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-blue-100::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-blue-200::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-blue-300::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-blue-400::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-blue-500::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-blue-600::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-blue-700::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-blue-800::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-blue-900::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-pink-50::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-pink-100::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-pink-200::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-pink-300::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-pink-400::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-pink-500::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-pink-600::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-pink-700::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-pink-800::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:placeholder-pink-900::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-transparent:focus::placeholder{color:#0000}.theme-dark .lg\\:dark\\:focus\\:placeholder-white:focus::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-black:focus::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-gray-50:focus::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-gray-300:focus::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-gray-400:focus::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-gray-500:focus::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-gray-600:focus::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-gray-700:focus::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-gray-800:focus::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-gray-900:focus::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-50:focus::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-300:focus::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-400:focus::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-500:focus::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-600:focus::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-700:focus::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-800:focus::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-cool-gray-900:focus::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-red-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-red-100:focus::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-red-200:focus::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-red-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-red-400:focus::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-red-500:focus::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-red-600:focus::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-red-700:focus::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-red-800:focus::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-red-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-orange-50:focus::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-orange-100:focus::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-orange-200:focus::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-orange-300:focus::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-orange-400:focus::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-orange-500:focus::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-orange-600:focus::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-orange-700:focus::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-orange-800:focus::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-orange-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-50:focus::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-100:focus::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-200:focus::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-300:focus::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-400:focus::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-500:focus::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-600:focus::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-700:focus::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-800:focus::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-yellow-900:focus::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-green-50:focus::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-green-100:focus::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-green-200:focus::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-green-300:focus::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-green-400:focus::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-green-500:focus::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-green-600:focus::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-green-700:focus::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-green-800:focus::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-green-900:focus::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-teal-50:focus::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-teal-100:focus::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-teal-200:focus::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-teal-300:focus::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-teal-400:focus::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-teal-500:focus::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-teal-600:focus::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-teal-700:focus::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-teal-800:focus::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-teal-900:focus::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-blue-50:focus::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-blue-100:focus::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-blue-200:focus::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-blue-300:focus::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-blue-400:focus::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-blue-500:focus::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-blue-600:focus::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-blue-700:focus::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-blue-800:focus::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-blue-900:focus::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-pink-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-pink-100:focus::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-pink-200:focus::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-pink-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-pink-400:focus::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-pink-500:focus::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-pink-600:focus::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-pink-700:focus::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-pink-800:focus::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.theme-dark .lg\\:dark\\:focus\\:placeholder-pink-900:focus::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.lg\\:placeholder-opacity-0::placeholder{--placeholder-opacity:0}.lg\\:placeholder-opacity-25::placeholder{--placeholder-opacity:0.25}.lg\\:placeholder-opacity-50::placeholder{--placeholder-opacity:0.5}.lg\\:placeholder-opacity-75::placeholder{--placeholder-opacity:0.75}.lg\\:placeholder-opacity-100::placeholder{--placeholder-opacity:1}.lg\\:focus\\:placeholder-opacity-0:focus::placeholder{--placeholder-opacity:0}.lg\\:focus\\:placeholder-opacity-25:focus::placeholder{--placeholder-opacity:0.25}.lg\\:focus\\:placeholder-opacity-50:focus::placeholder{--placeholder-opacity:0.5}.lg\\:focus\\:placeholder-opacity-75:focus::placeholder{--placeholder-opacity:0.75}.lg\\:focus\\:placeholder-opacity-100:focus::placeholder{--placeholder-opacity:1}.lg\\:pointer-events-none{pointer-events:none}.lg\\:pointer-events-auto{pointer-events:auto}.lg\\:static{position:static}.lg\\:fixed{position:fixed}.lg\\:absolute{position:absolute}.lg\\:relative{position:relative}.lg\\:sticky{position:-webkit-sticky;position:sticky}.lg\\:inset-0{bottom:0;left:0;right:0;top:0}.lg\\:inset-auto{bottom:auto;left:auto;right:auto;top:auto}.lg\\:inset-y-0{bottom:0;top:0}.lg\\:inset-x-0{left:0;right:0}.lg\\:inset-y-auto{bottom:auto;top:auto}.lg\\:inset-x-auto{left:auto;right:auto}.lg\\:top-0{top:0}.lg\\:right-0{right:0}.lg\\:bottom-0{bottom:0}.lg\\:left-0{left:0}.lg\\:top-auto{top:auto}.lg\\:right-auto{right:auto}.lg\\:bottom-auto{bottom:auto}.lg\\:left-auto{left:auto}.lg\\:resize-none{resize:none}.lg\\:resize-y{resize:vertical}.lg\\:resize-x{resize:horizontal}.lg\\:resize{resize:both}.lg\\:shadow-xs{box-shadow:0 0 0 1px #0000000d}.lg\\:shadow-sm{box-shadow:0 1px 2px 0 #0000000d}.lg\\:shadow{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.lg\\:shadow-md{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.lg\\:shadow-lg{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.lg\\:shadow-xl{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.lg\\:shadow-2xl{box-shadow:0 25px 50px -12px #00000040}.lg\\:shadow-inner{box-shadow:inset 0 2px 4px 0 #0000000f}.lg\\:shadow-outline{box-shadow:0 0 0 3px #4299e180}.lg\\:shadow-none{box-shadow:none}.lg\\:shadow-bottom{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.lg\\:hover\\:shadow-xs:hover{box-shadow:0 0 0 1px #0000000d}.lg\\:hover\\:shadow-sm:hover{box-shadow:0 1px 2px 0 #0000000d}.lg\\:hover\\:shadow:hover{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.lg\\:hover\\:shadow-md:hover{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.lg\\:hover\\:shadow-lg:hover{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.lg\\:hover\\:shadow-xl:hover{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.lg\\:hover\\:shadow-2xl:hover{box-shadow:0 25px 50px -12px #00000040}.lg\\:hover\\:shadow-inner:hover{box-shadow:inset 0 2px 4px 0 #0000000f}.lg\\:hover\\:shadow-outline:hover{box-shadow:0 0 0 3px #4299e180}.lg\\:hover\\:shadow-none:hover{box-shadow:none}.lg\\:hover\\:shadow-bottom:hover{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.lg\\:focus\\:shadow-xs:focus{box-shadow:0 0 0 1px #0000000d}.lg\\:focus\\:shadow-sm:focus{box-shadow:0 1px 2px 0 #0000000d}.lg\\:focus\\:shadow:focus{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.lg\\:focus\\:shadow-md:focus{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.lg\\:focus\\:shadow-lg:focus{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.lg\\:focus\\:shadow-xl:focus{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.lg\\:focus\\:shadow-2xl:focus{box-shadow:0 25px 50px -12px #00000040}.lg\\:focus\\:shadow-inner:focus{box-shadow:inset 0 2px 4px 0 #0000000f}.lg\\:focus\\:shadow-outline:focus{box-shadow:0 0 0 3px #4299e180}.lg\\:focus\\:shadow-none:focus{box-shadow:none}.lg\\:focus\\:shadow-bottom:focus{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.theme-dark .lg\\:dark\\:focus\\:shadow-xs:focus{box-shadow:0 0 0 1px #0000000d}.theme-dark .lg\\:dark\\:focus\\:shadow-sm:focus{box-shadow:0 1px 2px 0 #0000000d}.theme-dark .lg\\:dark\\:focus\\:shadow:focus{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.theme-dark .lg\\:dark\\:focus\\:shadow-md:focus{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.theme-dark .lg\\:dark\\:focus\\:shadow-lg:focus{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.theme-dark .lg\\:dark\\:focus\\:shadow-xl:focus{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.theme-dark .lg\\:dark\\:focus\\:shadow-2xl:focus{box-shadow:0 25px 50px -12px #00000040}.theme-dark .lg\\:dark\\:focus\\:shadow-inner:focus{box-shadow:inset 0 2px 4px 0 #0000000f}.theme-dark .lg\\:dark\\:focus\\:shadow-outline:focus{box-shadow:0 0 0 3px #4299e180}.theme-dark .lg\\:dark\\:focus\\:shadow-none:focus{box-shadow:none}.theme-dark .lg\\:dark\\:focus\\:shadow-bottom:focus{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.lg\\:fill-current{fill:currentColor}.lg\\:stroke-current{stroke:currentColor}.lg\\:stroke-0{stroke-width:0}.lg\\:stroke-1{stroke-width:1}.lg\\:stroke-2{stroke-width:2}.lg\\:table-auto{table-layout:auto}.lg\\:table-fixed{table-layout:fixed}.lg\\:text-left{text-align:left}.lg\\:text-center{text-align:center}.lg\\:text-right{text-align:right}.lg\\:text-justify{text-align:justify}.lg\\:text-transparent{color:#0000}.lg\\:text-white{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.lg\\:text-black{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.lg\\:text-gray-50{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.lg\\:text-gray-100{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.lg\\:text-gray-200{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.lg\\:text-gray-300{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.lg\\:text-gray-400{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.lg\\:text-gray-500{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.lg\\:text-gray-600{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.lg\\:text-gray-700{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.lg\\:text-gray-800{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.lg\\:text-gray-900{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.lg\\:text-cool-gray-50{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.lg\\:text-cool-gray-100{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.lg\\:text-cool-gray-200{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.lg\\:text-cool-gray-300{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.lg\\:text-cool-gray-400{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.lg\\:text-cool-gray-500{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.lg\\:text-cool-gray-600{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.lg\\:text-cool-gray-700{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.lg\\:text-cool-gray-800{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.lg\\:text-cool-gray-900{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.lg\\:text-red-50{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.lg\\:text-red-100{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.lg\\:text-red-200{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.lg\\:text-red-300{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.lg\\:text-red-400{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.lg\\:text-red-500{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.lg\\:text-red-600{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.lg\\:text-red-700{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.lg\\:text-red-800{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.lg\\:text-red-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.lg\\:text-orange-50{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.lg\\:text-orange-100{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.lg\\:text-orange-200{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.lg\\:text-orange-300{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.lg\\:text-orange-400{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.lg\\:text-orange-500{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.lg\\:text-orange-600{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.lg\\:text-orange-700{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.lg\\:text-orange-800{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.lg\\:text-orange-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.lg\\:text-yellow-50{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.lg\\:text-yellow-100{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.lg\\:text-yellow-200{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.lg\\:text-yellow-300{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.lg\\:text-yellow-400{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.lg\\:text-yellow-500{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.lg\\:text-yellow-600{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.lg\\:text-yellow-700{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.lg\\:text-yellow-800{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.lg\\:text-yellow-900{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.lg\\:text-green-50{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.lg\\:text-green-100{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.lg\\:text-green-200{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.lg\\:text-green-300{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.lg\\:text-green-400{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.lg\\:text-green-500{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.lg\\:text-green-600{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.lg\\:text-green-700{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.lg\\:text-green-800{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.lg\\:text-green-900{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.lg\\:text-teal-50{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.lg\\:text-teal-100{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.lg\\:text-teal-200{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.lg\\:text-teal-300{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.lg\\:text-teal-400{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.lg\\:text-teal-500{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.lg\\:text-teal-600{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.lg\\:text-teal-700{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.lg\\:text-teal-800{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.lg\\:text-teal-900{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.lg\\:text-blue-50{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.lg\\:text-blue-100{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.lg\\:text-blue-200{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.lg\\:text-blue-300{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.lg\\:text-blue-400{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.lg\\:text-blue-500{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.lg\\:text-blue-600{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.lg\\:text-blue-700{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.lg\\:text-blue-800{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.lg\\:text-blue-900{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.lg\\:text-indigo-50{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.lg\\:text-indigo-100{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.lg\\:text-indigo-200{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.lg\\:text-indigo-300{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.lg\\:text-indigo-400{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.lg\\:text-indigo-500{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.lg\\:text-indigo-600{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.lg\\:text-indigo-700{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.lg\\:text-indigo-800{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.lg\\:text-indigo-900{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.lg\\:text-indigo-50{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.lg\\:text-indigo-100{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.lg\\:text-indigo-200{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.lg\\:text-indigo-300{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.lg\\:text-indigo-400{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.lg\\:text-indigo-500{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.lg\\:text-indigo-600{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.lg\\:text-indigo-700{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.lg\\:text-indigo-800{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.lg\\:text-indigo-900{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.lg\\:text-pink-50{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.lg\\:text-pink-100{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.lg\\:text-pink-200{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.lg\\:text-pink-300{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.lg\\:text-pink-400{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.lg\\:text-pink-500{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.lg\\:text-pink-600{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.lg\\:text-pink-700{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.lg\\:text-pink-800{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.lg\\:text-pink-900{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.lg\\:focus\\:text-transparent:focus{color:#0000}.lg\\:focus\\:text-white:focus{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.lg\\:focus\\:text-black:focus{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.lg\\:focus\\:text-gray-50:focus{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.lg\\:focus\\:text-gray-100:focus{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.lg\\:focus\\:text-gray-200:focus{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.lg\\:focus\\:text-gray-300:focus{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.lg\\:focus\\:text-gray-400:focus{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.lg\\:focus\\:text-gray-500:focus{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.lg\\:focus\\:text-gray-600:focus{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.lg\\:focus\\:text-gray-700:focus{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.lg\\:focus\\:text-gray-800:focus{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.lg\\:focus\\:text-gray-900:focus{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.lg\\:focus\\:text-cool-gray-50:focus{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.lg\\:focus\\:text-cool-gray-100:focus{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.lg\\:focus\\:text-cool-gray-200:focus{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.lg\\:focus\\:text-cool-gray-300:focus{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.lg\\:focus\\:text-cool-gray-400:focus{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.lg\\:focus\\:text-cool-gray-500:focus{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.lg\\:focus\\:text-cool-gray-600:focus{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.lg\\:focus\\:text-cool-gray-700:focus{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.lg\\:focus\\:text-cool-gray-800:focus{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.lg\\:focus\\:text-cool-gray-900:focus{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.lg\\:focus\\:text-red-50:focus{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.lg\\:focus\\:text-red-100:focus{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.lg\\:focus\\:text-red-200:focus{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.lg\\:focus\\:text-red-300:focus{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.lg\\:focus\\:text-red-400:focus{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.lg\\:focus\\:text-red-500:focus{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.lg\\:focus\\:text-red-600:focus{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.lg\\:focus\\:text-red-700:focus{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.lg\\:focus\\:text-red-800:focus{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.lg\\:focus\\:text-red-900:focus{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.lg\\:focus\\:text-orange-50:focus{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.lg\\:focus\\:text-orange-100:focus{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.lg\\:focus\\:text-orange-200:focus{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.lg\\:focus\\:text-orange-300:focus{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.lg\\:focus\\:text-orange-400:focus{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.lg\\:focus\\:text-orange-500:focus{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.lg\\:focus\\:text-orange-600:focus{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.lg\\:focus\\:text-orange-700:focus{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.lg\\:focus\\:text-orange-800:focus{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.lg\\:focus\\:text-orange-900:focus{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.lg\\:focus\\:text-yellow-50:focus{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.lg\\:focus\\:text-yellow-100:focus{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.lg\\:focus\\:text-yellow-200:focus{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.lg\\:focus\\:text-yellow-300:focus{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.lg\\:focus\\:text-yellow-400:focus{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.lg\\:focus\\:text-yellow-500:focus{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.lg\\:focus\\:text-yellow-600:focus{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.lg\\:focus\\:text-yellow-700:focus{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.lg\\:focus\\:text-yellow-800:focus{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.lg\\:focus\\:text-yellow-900:focus{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.lg\\:focus\\:text-green-50:focus{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.lg\\:focus\\:text-green-100:focus{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.lg\\:focus\\:text-green-200:focus{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.lg\\:focus\\:text-green-300:focus{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.lg\\:focus\\:text-green-400:focus{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.lg\\:focus\\:text-green-500:focus{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.lg\\:focus\\:text-green-600:focus{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.lg\\:focus\\:text-green-700:focus{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.lg\\:focus\\:text-green-800:focus{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.lg\\:focus\\:text-green-900:focus{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.lg\\:focus\\:text-teal-50:focus{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.lg\\:focus\\:text-teal-100:focus{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.lg\\:focus\\:text-teal-200:focus{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.lg\\:focus\\:text-teal-300:focus{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.lg\\:focus\\:text-teal-400:focus{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.lg\\:focus\\:text-teal-500:focus{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.lg\\:focus\\:text-teal-600:focus{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.lg\\:focus\\:text-teal-700:focus{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.lg\\:focus\\:text-teal-800:focus{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.lg\\:focus\\:text-teal-900:focus{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.lg\\:focus\\:text-blue-50:focus{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.lg\\:focus\\:text-blue-100:focus{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.lg\\:focus\\:text-blue-200:focus{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.lg\\:focus\\:text-blue-300:focus{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.lg\\:focus\\:text-blue-400:focus{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.lg\\:focus\\:text-blue-500:focus{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.lg\\:focus\\:text-blue-600:focus{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.lg\\:focus\\:text-blue-700:focus{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.lg\\:focus\\:text-blue-800:focus{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.lg\\:focus\\:text-blue-900:focus{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.lg\\:focus\\:text-indigo-50:focus{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.lg\\:focus\\:text-indigo-100:focus{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.lg\\:focus\\:text-indigo-200:focus{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.lg\\:focus\\:text-indigo-300:focus{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.lg\\:focus\\:text-indigo-400:focus{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.lg\\:focus\\:text-indigo-500:focus{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.lg\\:focus\\:text-indigo-600:focus{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.lg\\:focus\\:text-indigo-700:focus{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.lg\\:focus\\:text-indigo-800:focus{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.lg\\:focus\\:text-indigo-900:focus{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.lg\\:focus\\:text-indigo-50:focus{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.lg\\:focus\\:text-indigo-100:focus{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.lg\\:focus\\:text-indigo-200:focus{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.lg\\:focus\\:text-indigo-300:focus{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.lg\\:focus\\:text-indigo-400:focus{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.lg\\:focus\\:text-indigo-500:focus{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.lg\\:focus\\:text-indigo-600:focus{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.lg\\:focus\\:text-indigo-700:focus{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.lg\\:focus\\:text-indigo-800:focus{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.lg\\:focus\\:text-indigo-900:focus{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.lg\\:focus\\:text-pink-50:focus{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.lg\\:focus\\:text-pink-100:focus{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.lg\\:focus\\:text-pink-200:focus{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.lg\\:focus\\:text-pink-300:focus{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.lg\\:focus\\:text-pink-400:focus{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.lg\\:focus\\:text-pink-500:focus{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.lg\\:focus\\:text-pink-600:focus{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.lg\\:focus\\:text-pink-700:focus{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.lg\\:focus\\:text-pink-800:focus{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.lg\\:focus\\:text-pink-900:focus{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.lg\\:focus-within\\:text-transparent:focus-within{color:#0000}.lg\\:focus-within\\:text-white:focus-within{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.lg\\:focus-within\\:text-black:focus-within{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.lg\\:focus-within\\:text-gray-50:focus-within{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.lg\\:focus-within\\:text-gray-100:focus-within{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.lg\\:focus-within\\:text-gray-200:focus-within{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.lg\\:focus-within\\:text-gray-300:focus-within{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.lg\\:focus-within\\:text-gray-400:focus-within{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.lg\\:focus-within\\:text-gray-500:focus-within{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.lg\\:focus-within\\:text-gray-600:focus-within{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.lg\\:focus-within\\:text-gray-700:focus-within{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.lg\\:focus-within\\:text-gray-800:focus-within{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.lg\\:focus-within\\:text-gray-900:focus-within{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.lg\\:focus-within\\:text-cool-gray-50:focus-within{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.lg\\:focus-within\\:text-cool-gray-100:focus-within{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.lg\\:focus-within\\:text-cool-gray-200:focus-within{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.lg\\:focus-within\\:text-cool-gray-300:focus-within{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.lg\\:focus-within\\:text-cool-gray-400:focus-within{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.lg\\:focus-within\\:text-cool-gray-500:focus-within{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.lg\\:focus-within\\:text-cool-gray-600:focus-within{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.lg\\:focus-within\\:text-cool-gray-700:focus-within{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.lg\\:focus-within\\:text-cool-gray-800:focus-within{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.lg\\:focus-within\\:text-cool-gray-900:focus-within{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.lg\\:focus-within\\:text-red-50:focus-within{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.lg\\:focus-within\\:text-red-100:focus-within{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.lg\\:focus-within\\:text-red-200:focus-within{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.lg\\:focus-within\\:text-red-300:focus-within{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.lg\\:focus-within\\:text-red-400:focus-within{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.lg\\:focus-within\\:text-red-500:focus-within{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.lg\\:focus-within\\:text-red-600:focus-within{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.lg\\:focus-within\\:text-red-700:focus-within{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.lg\\:focus-within\\:text-red-800:focus-within{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.lg\\:focus-within\\:text-red-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.lg\\:focus-within\\:text-orange-50:focus-within{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.lg\\:focus-within\\:text-orange-100:focus-within{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.lg\\:focus-within\\:text-orange-200:focus-within{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.lg\\:focus-within\\:text-orange-300:focus-within{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.lg\\:focus-within\\:text-orange-400:focus-within{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.lg\\:focus-within\\:text-orange-500:focus-within{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.lg\\:focus-within\\:text-orange-600:focus-within{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.lg\\:focus-within\\:text-orange-700:focus-within{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.lg\\:focus-within\\:text-orange-800:focus-within{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.lg\\:focus-within\\:text-orange-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.lg\\:focus-within\\:text-yellow-50:focus-within{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.lg\\:focus-within\\:text-yellow-100:focus-within{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.lg\\:focus-within\\:text-yellow-200:focus-within{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.lg\\:focus-within\\:text-yellow-300:focus-within{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.lg\\:focus-within\\:text-yellow-400:focus-within{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.lg\\:focus-within\\:text-yellow-500:focus-within{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.lg\\:focus-within\\:text-yellow-600:focus-within{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.lg\\:focus-within\\:text-yellow-700:focus-within{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.lg\\:focus-within\\:text-yellow-800:focus-within{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.lg\\:focus-within\\:text-yellow-900:focus-within{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.lg\\:focus-within\\:text-green-50:focus-within{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.lg\\:focus-within\\:text-green-100:focus-within{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.lg\\:focus-within\\:text-green-200:focus-within{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.lg\\:focus-within\\:text-green-300:focus-within{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.lg\\:focus-within\\:text-green-400:focus-within{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.lg\\:focus-within\\:text-green-500:focus-within{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.lg\\:focus-within\\:text-green-600:focus-within{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.lg\\:focus-within\\:text-green-700:focus-within{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.lg\\:focus-within\\:text-green-800:focus-within{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.lg\\:focus-within\\:text-green-900:focus-within{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.lg\\:focus-within\\:text-teal-50:focus-within{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.lg\\:focus-within\\:text-teal-100:focus-within{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.lg\\:focus-within\\:text-teal-200:focus-within{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.lg\\:focus-within\\:text-teal-300:focus-within{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.lg\\:focus-within\\:text-teal-400:focus-within{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.lg\\:focus-within\\:text-teal-500:focus-within{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.lg\\:focus-within\\:text-teal-600:focus-within{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.lg\\:focus-within\\:text-teal-700:focus-within{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.lg\\:focus-within\\:text-teal-800:focus-within{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.lg\\:focus-within\\:text-teal-900:focus-within{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.lg\\:focus-within\\:text-blue-50:focus-within{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.lg\\:focus-within\\:text-blue-100:focus-within{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.lg\\:focus-within\\:text-blue-200:focus-within{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.lg\\:focus-within\\:text-blue-300:focus-within{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.lg\\:focus-within\\:text-blue-400:focus-within{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.lg\\:focus-within\\:text-blue-500:focus-within{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.lg\\:focus-within\\:text-blue-600:focus-within{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.lg\\:focus-within\\:text-blue-700:focus-within{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.lg\\:focus-within\\:text-blue-800:focus-within{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.lg\\:focus-within\\:text-blue-900:focus-within{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.lg\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.lg\\:focus-within\\:text-pink-50:focus-within{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.lg\\:focus-within\\:text-pink-100:focus-within{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.lg\\:focus-within\\:text-pink-200:focus-within{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.lg\\:focus-within\\:text-pink-300:focus-within{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.lg\\:focus-within\\:text-pink-400:focus-within{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.lg\\:focus-within\\:text-pink-500:focus-within{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.lg\\:focus-within\\:text-pink-600:focus-within{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.lg\\:focus-within\\:text-pink-700:focus-within{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.lg\\:focus-within\\:text-pink-800:focus-within{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.lg\\:focus-within\\:text-pink-900:focus-within{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.lg\\:hover\\:text-transparent:hover{color:#0000}.lg\\:hover\\:text-white:hover{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.lg\\:hover\\:text-black:hover{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.lg\\:hover\\:text-gray-50:hover{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.lg\\:hover\\:text-gray-100:hover{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.lg\\:hover\\:text-gray-200:hover{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.lg\\:hover\\:text-gray-300:hover{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.lg\\:hover\\:text-gray-400:hover{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.lg\\:hover\\:text-gray-500:hover{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.lg\\:hover\\:text-gray-600:hover{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.lg\\:hover\\:text-gray-700:hover{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.lg\\:hover\\:text-gray-800:hover{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.lg\\:hover\\:text-gray-900:hover{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.lg\\:hover\\:text-cool-gray-50:hover{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.lg\\:hover\\:text-cool-gray-100:hover{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.lg\\:hover\\:text-cool-gray-200:hover{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.lg\\:hover\\:text-cool-gray-300:hover{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.lg\\:hover\\:text-cool-gray-400:hover{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.lg\\:hover\\:text-cool-gray-500:hover{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.lg\\:hover\\:text-cool-gray-600:hover{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.lg\\:hover\\:text-cool-gray-700:hover{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.lg\\:hover\\:text-cool-gray-800:hover{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.lg\\:hover\\:text-cool-gray-900:hover{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.lg\\:hover\\:text-red-50:hover{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.lg\\:hover\\:text-red-100:hover{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.lg\\:hover\\:text-red-200:hover{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.lg\\:hover\\:text-red-300:hover{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.lg\\:hover\\:text-red-400:hover{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.lg\\:hover\\:text-red-500:hover{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.lg\\:hover\\:text-red-600:hover{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.lg\\:hover\\:text-red-700:hover{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.lg\\:hover\\:text-red-800:hover{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.lg\\:hover\\:text-red-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.lg\\:hover\\:text-orange-50:hover{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.lg\\:hover\\:text-orange-100:hover{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.lg\\:hover\\:text-orange-200:hover{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.lg\\:hover\\:text-orange-300:hover{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.lg\\:hover\\:text-orange-400:hover{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.lg\\:hover\\:text-orange-500:hover{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.lg\\:hover\\:text-orange-600:hover{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.lg\\:hover\\:text-orange-700:hover{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.lg\\:hover\\:text-orange-800:hover{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.lg\\:hover\\:text-orange-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.lg\\:hover\\:text-yellow-50:hover{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.lg\\:hover\\:text-yellow-100:hover{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.lg\\:hover\\:text-yellow-200:hover{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.lg\\:hover\\:text-yellow-300:hover{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.lg\\:hover\\:text-yellow-400:hover{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.lg\\:hover\\:text-yellow-500:hover{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.lg\\:hover\\:text-yellow-600:hover{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.lg\\:hover\\:text-yellow-700:hover{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.lg\\:hover\\:text-yellow-800:hover{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.lg\\:hover\\:text-yellow-900:hover{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.lg\\:hover\\:text-green-50:hover{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.lg\\:hover\\:text-green-100:hover{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.lg\\:hover\\:text-green-200:hover{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.lg\\:hover\\:text-green-300:hover{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.lg\\:hover\\:text-green-400:hover{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.lg\\:hover\\:text-green-500:hover{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.lg\\:hover\\:text-green-600:hover{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.lg\\:hover\\:text-green-700:hover{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.lg\\:hover\\:text-green-800:hover{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.lg\\:hover\\:text-green-900:hover{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.lg\\:hover\\:text-teal-50:hover{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.lg\\:hover\\:text-teal-100:hover{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.lg\\:hover\\:text-teal-200:hover{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.lg\\:hover\\:text-teal-300:hover{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.lg\\:hover\\:text-teal-400:hover{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.lg\\:hover\\:text-teal-500:hover{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.lg\\:hover\\:text-teal-600:hover{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.lg\\:hover\\:text-teal-700:hover{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.lg\\:hover\\:text-teal-800:hover{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.lg\\:hover\\:text-teal-900:hover{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.lg\\:hover\\:text-blue-50:hover{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.lg\\:hover\\:text-blue-100:hover{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.lg\\:hover\\:text-blue-200:hover{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.lg\\:hover\\:text-blue-300:hover{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.lg\\:hover\\:text-blue-400:hover{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.lg\\:hover\\:text-blue-500:hover{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.lg\\:hover\\:text-blue-600:hover{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.lg\\:hover\\:text-blue-700:hover{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.lg\\:hover\\:text-blue-800:hover{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.lg\\:hover\\:text-blue-900:hover{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.lg\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.lg\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.lg\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.lg\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.lg\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.lg\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.lg\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.lg\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.lg\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.lg\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.lg\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.lg\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.lg\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.lg\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.lg\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.lg\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.lg\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.lg\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.lg\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.lg\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.lg\\:hover\\:text-pink-50:hover{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.lg\\:hover\\:text-pink-100:hover{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.lg\\:hover\\:text-pink-200:hover{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.lg\\:hover\\:text-pink-300:hover{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.lg\\:hover\\:text-pink-400:hover{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.lg\\:hover\\:text-pink-500:hover{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.lg\\:hover\\:text-pink-600:hover{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.lg\\:hover\\:text-pink-700:hover{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.lg\\:hover\\:text-pink-800:hover{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.lg\\:hover\\:text-pink-900:hover{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.lg\\:active\\:text-transparent:active{color:#0000}.lg\\:active\\:text-white:active{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.lg\\:active\\:text-black:active{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.lg\\:active\\:text-gray-50:active{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.lg\\:active\\:text-gray-100:active{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.lg\\:active\\:text-gray-200:active{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.lg\\:active\\:text-gray-300:active{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.lg\\:active\\:text-gray-400:active{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.lg\\:active\\:text-gray-500:active{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.lg\\:active\\:text-gray-600:active{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.lg\\:active\\:text-gray-700:active{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.lg\\:active\\:text-gray-800:active{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.lg\\:active\\:text-gray-900:active{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.lg\\:active\\:text-cool-gray-50:active{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.lg\\:active\\:text-cool-gray-100:active{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.lg\\:active\\:text-cool-gray-200:active{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.lg\\:active\\:text-cool-gray-300:active{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.lg\\:active\\:text-cool-gray-400:active{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.lg\\:active\\:text-cool-gray-500:active{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.lg\\:active\\:text-cool-gray-600:active{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.lg\\:active\\:text-cool-gray-700:active{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.lg\\:active\\:text-cool-gray-800:active{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.lg\\:active\\:text-cool-gray-900:active{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.lg\\:active\\:text-red-50:active{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.lg\\:active\\:text-red-100:active{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.lg\\:active\\:text-red-200:active{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.lg\\:active\\:text-red-300:active{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.lg\\:active\\:text-red-400:active{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.lg\\:active\\:text-red-500:active{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.lg\\:active\\:text-red-600:active{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.lg\\:active\\:text-red-700:active{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.lg\\:active\\:text-red-800:active{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.lg\\:active\\:text-red-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.lg\\:active\\:text-orange-50:active{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.lg\\:active\\:text-orange-100:active{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.lg\\:active\\:text-orange-200:active{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.lg\\:active\\:text-orange-300:active{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.lg\\:active\\:text-orange-400:active{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.lg\\:active\\:text-orange-500:active{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.lg\\:active\\:text-orange-600:active{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.lg\\:active\\:text-orange-700:active{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.lg\\:active\\:text-orange-800:active{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.lg\\:active\\:text-orange-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.lg\\:active\\:text-yellow-50:active{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.lg\\:active\\:text-yellow-100:active{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.lg\\:active\\:text-yellow-200:active{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.lg\\:active\\:text-yellow-300:active{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.lg\\:active\\:text-yellow-400:active{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.lg\\:active\\:text-yellow-500:active{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.lg\\:active\\:text-yellow-600:active{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.lg\\:active\\:text-yellow-700:active{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.lg\\:active\\:text-yellow-800:active{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.lg\\:active\\:text-yellow-900:active{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.lg\\:active\\:text-green-50:active{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.lg\\:active\\:text-green-100:active{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.lg\\:active\\:text-green-200:active{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.lg\\:active\\:text-green-300:active{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.lg\\:active\\:text-green-400:active{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.lg\\:active\\:text-green-500:active{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.lg\\:active\\:text-green-600:active{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.lg\\:active\\:text-green-700:active{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.lg\\:active\\:text-green-800:active{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.lg\\:active\\:text-green-900:active{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.lg\\:active\\:text-teal-50:active{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.lg\\:active\\:text-teal-100:active{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.lg\\:active\\:text-teal-200:active{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.lg\\:active\\:text-teal-300:active{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.lg\\:active\\:text-teal-400:active{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.lg\\:active\\:text-teal-500:active{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.lg\\:active\\:text-teal-600:active{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.lg\\:active\\:text-teal-700:active{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.lg\\:active\\:text-teal-800:active{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.lg\\:active\\:text-teal-900:active{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.lg\\:active\\:text-blue-50:active{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.lg\\:active\\:text-blue-100:active{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.lg\\:active\\:text-blue-200:active{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.lg\\:active\\:text-blue-300:active{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.lg\\:active\\:text-blue-400:active{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.lg\\:active\\:text-blue-500:active{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.lg\\:active\\:text-blue-600:active{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.lg\\:active\\:text-blue-700:active{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.lg\\:active\\:text-blue-800:active{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.lg\\:active\\:text-blue-900:active{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.lg\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.lg\\:active\\:text-indigo-100:active{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.lg\\:active\\:text-indigo-200:active{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.lg\\:active\\:text-indigo-300:active{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.lg\\:active\\:text-indigo-400:active{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.lg\\:active\\:text-indigo-500:active{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.lg\\:active\\:text-indigo-600:active{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.lg\\:active\\:text-indigo-700:active{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.lg\\:active\\:text-indigo-800:active{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.lg\\:active\\:text-indigo-900:active{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.lg\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.lg\\:active\\:text-indigo-100:active{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.lg\\:active\\:text-indigo-200:active{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.lg\\:active\\:text-indigo-300:active{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.lg\\:active\\:text-indigo-400:active{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.lg\\:active\\:text-indigo-500:active{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.lg\\:active\\:text-indigo-600:active{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.lg\\:active\\:text-indigo-700:active{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.lg\\:active\\:text-indigo-800:active{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.lg\\:active\\:text-indigo-900:active{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.lg\\:active\\:text-pink-50:active{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.lg\\:active\\:text-pink-100:active{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.lg\\:active\\:text-pink-200:active{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.lg\\:active\\:text-pink-300:active{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.lg\\:active\\:text-pink-400:active{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.lg\\:active\\:text-pink-500:active{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.lg\\:active\\:text-pink-600:active{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.lg\\:active\\:text-pink-700:active{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.lg\\:active\\:text-pink-800:active{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.lg\\:active\\:text-pink-900:active{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-transparent{color:#0000}.theme-dark .lg\\:dark\\:text-white{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-black{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-gray-50{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-gray-100{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-gray-200{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-gray-300{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-gray-400{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-gray-500{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-gray-600{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-gray-700{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-gray-800{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-gray-900{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-cool-gray-50{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-cool-gray-100{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-cool-gray-200{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-cool-gray-300{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-cool-gray-400{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-cool-gray-500{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-cool-gray-600{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-cool-gray-700{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-cool-gray-800{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-cool-gray-900{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-red-50{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-red-100{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-red-200{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-red-300{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-red-400{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-red-500{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-red-600{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-red-700{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-red-800{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-red-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-orange-50{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-orange-100{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-orange-200{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-orange-300{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-orange-400{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-orange-500{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-orange-600{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-orange-700{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-orange-800{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-orange-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-yellow-50{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-yellow-100{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-yellow-200{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-yellow-300{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-yellow-400{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-yellow-500{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-yellow-600{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-yellow-700{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-yellow-800{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-yellow-900{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-green-50{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-green-100{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-green-200{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-green-300{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-green-400{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-green-500{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-green-600{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-green-700{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-green-800{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-green-900{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-teal-50{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-teal-100{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-teal-200{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-teal-300{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-teal-400{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-teal-500{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-teal-600{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-teal-700{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-teal-800{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-teal-900{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-blue-50{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-blue-100{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-blue-200{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-blue-300{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-blue-400{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-blue-500{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-blue-600{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-blue-700{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-blue-800{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-blue-900{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-50{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-100{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-200{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-300{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-400{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-500{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-600{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-700{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-800{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-900{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-50{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-100{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-200{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-300{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-400{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-500{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-600{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-700{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-800{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-indigo-900{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-pink-50{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-pink-100{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-pink-200{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-pink-300{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-pink-400{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-pink-500{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-pink-600{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-pink-700{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-pink-800{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .lg\\:dark\\:text-pink-900{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-transparent:focus-within{color:#0000}.theme-dark .lg\\:dark\\:focus-within\\:text-white:focus-within{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-black:focus-within{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-gray-50:focus-within{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-gray-100:focus-within{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-gray-200:focus-within{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-gray-300:focus-within{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-gray-400:focus-within{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-gray-500:focus-within{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-gray-600:focus-within{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-gray-700:focus-within{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-gray-800:focus-within{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-gray-900:focus-within{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-50:focus-within{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-100:focus-within{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-200:focus-within{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-300:focus-within{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-400:focus-within{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-500:focus-within{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-600:focus-within{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-700:focus-within{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-800:focus-within{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-cool-gray-900:focus-within{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-red-50:focus-within{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-red-100:focus-within{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-red-200:focus-within{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-red-300:focus-within{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-red-400:focus-within{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-red-500:focus-within{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-red-600:focus-within{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-red-700:focus-within{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-red-800:focus-within{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-red-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-orange-50:focus-within{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-orange-100:focus-within{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-orange-200:focus-within{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-orange-300:focus-within{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-orange-400:focus-within{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-orange-500:focus-within{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-orange-600:focus-within{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-orange-700:focus-within{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-orange-800:focus-within{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-orange-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-yellow-50:focus-within{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-yellow-100:focus-within{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-yellow-200:focus-within{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-yellow-300:focus-within{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-yellow-400:focus-within{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-yellow-500:focus-within{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-yellow-600:focus-within{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-yellow-700:focus-within{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-yellow-800:focus-within{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-yellow-900:focus-within{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-green-50:focus-within{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-green-100:focus-within{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-green-200:focus-within{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-green-300:focus-within{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-green-400:focus-within{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-green-500:focus-within{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-green-600:focus-within{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-green-700:focus-within{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-green-800:focus-within{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-green-900:focus-within{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-teal-50:focus-within{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-teal-100:focus-within{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-teal-200:focus-within{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-teal-300:focus-within{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-teal-400:focus-within{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-teal-500:focus-within{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-teal-600:focus-within{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-teal-700:focus-within{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-teal-800:focus-within{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-teal-900:focus-within{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-blue-50:focus-within{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-blue-100:focus-within{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-blue-200:focus-within{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-blue-300:focus-within{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-blue-400:focus-within{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-blue-500:focus-within{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-blue-600:focus-within{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-blue-700:focus-within{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-blue-800:focus-within{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-blue-900:focus-within{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-pink-50:focus-within{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-pink-100:focus-within{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-pink-200:focus-within{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-pink-300:focus-within{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-pink-400:focus-within{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-pink-500:focus-within{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-pink-600:focus-within{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-pink-700:focus-within{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-pink-800:focus-within{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .lg\\:dark\\:focus-within\\:text-pink-900:focus-within{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-transparent:hover{color:#0000}.theme-dark .lg\\:dark\\:hover\\:text-white:hover{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-black:hover{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-gray-50:hover{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-gray-100:hover{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-gray-200:hover{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-gray-300:hover{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-gray-400:hover{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-gray-500:hover{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-gray-600:hover{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-gray-700:hover{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-gray-800:hover{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-gray-900:hover{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-cool-gray-50:hover{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-cool-gray-100:hover{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-cool-gray-200:hover{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-cool-gray-300:hover{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-cool-gray-400:hover{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-cool-gray-500:hover{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-cool-gray-600:hover{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-cool-gray-700:hover{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-cool-gray-800:hover{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-cool-gray-900:hover{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-red-50:hover{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-red-100:hover{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-red-200:hover{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-red-300:hover{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-red-400:hover{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-red-500:hover{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-red-600:hover{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-red-700:hover{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-red-800:hover{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-red-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-orange-50:hover{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-orange-100:hover{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-orange-200:hover{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-orange-300:hover{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-orange-400:hover{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-orange-500:hover{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-orange-600:hover{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-orange-700:hover{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-orange-800:hover{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-orange-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-yellow-50:hover{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-yellow-100:hover{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-yellow-200:hover{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-yellow-300:hover{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-yellow-400:hover{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-yellow-500:hover{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-yellow-600:hover{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-yellow-700:hover{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-yellow-800:hover{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-yellow-900:hover{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-green-50:hover{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-green-100:hover{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-green-200:hover{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-green-300:hover{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-green-400:hover{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-green-500:hover{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-green-600:hover{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-green-700:hover{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-green-800:hover{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-green-900:hover{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-teal-50:hover{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-teal-100:hover{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-teal-200:hover{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-teal-300:hover{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-teal-400:hover{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-teal-500:hover{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-teal-600:hover{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-teal-700:hover{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-teal-800:hover{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-teal-900:hover{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-blue-50:hover{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-blue-100:hover{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-blue-200:hover{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-blue-300:hover{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-blue-400:hover{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-blue-500:hover{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-blue-600:hover{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-blue-700:hover{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-blue-800:hover{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-blue-900:hover{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-pink-50:hover{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-pink-100:hover{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-pink-200:hover{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-pink-300:hover{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-pink-400:hover{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-pink-500:hover{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-pink-600:hover{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-pink-700:hover{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-pink-800:hover{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .lg\\:dark\\:hover\\:text-pink-900:hover{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-transparent:active{color:#0000}.theme-dark .lg\\:dark\\:active\\:text-white:active{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-black:active{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-gray-50:active{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-gray-100:active{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-gray-200:active{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-gray-300:active{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-gray-400:active{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-gray-500:active{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-gray-600:active{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-gray-700:active{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-gray-800:active{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-gray-900:active{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-cool-gray-50:active{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-cool-gray-100:active{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-cool-gray-200:active{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-cool-gray-300:active{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-cool-gray-400:active{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-cool-gray-500:active{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-cool-gray-600:active{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-cool-gray-700:active{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-cool-gray-800:active{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-cool-gray-900:active{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-red-50:active{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-red-100:active{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-red-200:active{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-red-300:active{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-red-400:active{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-red-500:active{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-red-600:active{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-red-700:active{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-red-800:active{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-red-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-orange-50:active{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-orange-100:active{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-orange-200:active{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-orange-300:active{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-orange-400:active{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-orange-500:active{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-orange-600:active{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-orange-700:active{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-orange-800:active{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-orange-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-yellow-50:active{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-yellow-100:active{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-yellow-200:active{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-yellow-300:active{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-yellow-400:active{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-yellow-500:active{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-yellow-600:active{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-yellow-700:active{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-yellow-800:active{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-yellow-900:active{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-green-50:active{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-green-100:active{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-green-200:active{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-green-300:active{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-green-400:active{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-green-500:active{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-green-600:active{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-green-700:active{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-green-800:active{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-green-900:active{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-teal-50:active{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-teal-100:active{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-teal-200:active{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-teal-300:active{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-teal-400:active{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-teal-500:active{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-teal-600:active{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-teal-700:active{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-teal-800:active{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-teal-900:active{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-blue-50:active{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-blue-100:active{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-blue-200:active{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-blue-300:active{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-blue-400:active{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-blue-500:active{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-blue-600:active{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-blue-700:active{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-blue-800:active{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-blue-900:active{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-100:active{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-200:active{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-300:active{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-400:active{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-500:active{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-600:active{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-700:active{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-800:active{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-900:active{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-100:active{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-200:active{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-300:active{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-400:active{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-500:active{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-600:active{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-700:active{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-800:active{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-indigo-900:active{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-pink-50:active{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-pink-100:active{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-pink-200:active{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-pink-300:active{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-pink-400:active{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-pink-500:active{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-pink-600:active{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-pink-700:active{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-pink-800:active{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .lg\\:dark\\:active\\:text-pink-900:active{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.lg\\:text-opacity-0{--text-opacity:0}.lg\\:text-opacity-25{--text-opacity:0.25}.lg\\:text-opacity-50{--text-opacity:0.5}.lg\\:text-opacity-75{--text-opacity:0.75}.lg\\:text-opacity-100{--text-opacity:1}.lg\\:hover\\:text-opacity-0:hover{--text-opacity:0}.lg\\:hover\\:text-opacity-25:hover{--text-opacity:0.25}.lg\\:hover\\:text-opacity-50:hover{--text-opacity:0.5}.lg\\:hover\\:text-opacity-75:hover{--text-opacity:0.75}.lg\\:hover\\:text-opacity-100:hover{--text-opacity:1}.lg\\:focus\\:text-opacity-0:focus{--text-opacity:0}.lg\\:focus\\:text-opacity-25:focus{--text-opacity:0.25}.lg\\:focus\\:text-opacity-50:focus{--text-opacity:0.5}.lg\\:focus\\:text-opacity-75:focus{--text-opacity:0.75}.lg\\:focus\\:text-opacity-100:focus{--text-opacity:1}.lg\\:italic{font-style:italic}.lg\\:not-italic{font-style:normal}.lg\\:uppercase{text-transform:uppercase}.lg\\:lowercase{text-transform:lowercase}.lg\\:capitalize{text-transform:capitalize}.lg\\:normal-case{text-transform:none}.lg\\:underline{-webkit-text-decoration:underline;text-decoration:underline}.lg\\:line-through{-webkit-text-decoration:line-through;text-decoration:line-through}.lg\\:no-underline{-webkit-text-decoration:none;text-decoration:none}.lg\\:hover\\:underline:hover{-webkit-text-decoration:underline;text-decoration:underline}.lg\\:hover\\:line-through:hover{-webkit-text-decoration:line-through;text-decoration:line-through}.lg\\:hover\\:no-underline:hover{-webkit-text-decoration:none;text-decoration:none}.lg\\:focus\\:underline:focus{-webkit-text-decoration:underline;text-decoration:underline}.lg\\:focus\\:line-through:focus{-webkit-text-decoration:line-through;text-decoration:line-through}.lg\\:focus\\:no-underline:focus{-webkit-text-decoration:none;text-decoration:none}.lg\\:antialiased{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.lg\\:subpixel-antialiased{-webkit-font-smoothing:auto;-moz-osx-font-smoothing:auto}.lg\\:tracking-tighter{letter-spacing:-.05em}.lg\\:tracking-tight{letter-spacing:-.025em}.lg\\:tracking-normal{letter-spacing:0}.lg\\:tracking-wide{letter-spacing:.025em}.lg\\:tracking-wider{letter-spacing:.05em}.lg\\:tracking-widest{letter-spacing:.1em}.lg\\:select-none{-webkit-user-select:none;user-select:none}.lg\\:select-text{-webkit-user-select:text;user-select:text}.lg\\:select-all{-webkit-user-select:all;user-select:all}.lg\\:select-auto{-webkit-user-select:auto;user-select:auto}.lg\\:align-baseline{vertical-align:initial}.lg\\:align-top{vertical-align:top}.lg\\:align-middle{vertical-align:middle}.lg\\:align-bottom{vertical-align:bottom}.lg\\:align-text-top{vertical-align:text-top}.lg\\:align-text-bottom{vertical-align:text-bottom}.lg\\:visible{visibility:visible}.lg\\:invisible{visibility:hidden}.lg\\:whitespace-normal{white-space:normal}.lg\\:whitespace-no-wrap{white-space:nowrap}.lg\\:whitespace-pre{white-space:pre}.lg\\:whitespace-pre-line{white-space:pre-line}.lg\\:whitespace-pre-wrap{white-space:pre-wrap}.lg\\:break-normal{overflow-wrap:normal;word-break:normal}.lg\\:break-words{overflow-wrap:break-word}.lg\\:break-all{word-break:break-all}.lg\\:truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.lg\\:w-0{width:0}.lg\\:w-1{width:.25rem}.lg\\:w-2{width:.5rem}.lg\\:w-3{width:.75rem}.lg\\:w-4{width:1rem}.lg\\:w-5{width:1.25rem}.lg\\:w-6{width:1.5rem}.lg\\:w-8{width:2rem}.lg\\:w-10{width:2.5rem}.lg\\:w-12{width:3rem}.lg\\:w-16{width:4rem}.lg\\:w-20{width:5rem}.lg\\:w-24{width:6rem}.lg\\:w-32{width:8rem}.lg\\:w-40{width:10rem}.lg\\:w-48{width:12rem}.lg\\:w-56{width:14rem}.lg\\:w-64{width:16rem}.lg\\:w-auto{width:auto}.lg\\:w-px{width:1px}.lg\\:w-1\\/2{width:50%}.lg\\:w-1\\/3{width:33.333333%}.lg\\:w-2\\/3{width:66.666667%}.lg\\:w-1\\/4{width:25%}.lg\\:w-2\\/4{width:50%}.lg\\:w-3\\/4{width:75%}.lg\\:w-1\\/5{width:20%}.lg\\:w-2\\/5{width:40%}.lg\\:w-3\\/5{width:60%}.lg\\:w-4\\/5{width:80%}.lg\\:w-1\\/6{width:16.666667%}.lg\\:w-2\\/6{width:33.333333%}.lg\\:w-3\\/6{width:50%}.lg\\:w-4\\/6{width:66.666667%}.lg\\:w-5\\/6{width:83.333333%}.lg\\:w-1\\/12{width:8.333333%}.lg\\:w-2\\/12{width:16.666667%}.lg\\:w-3\\/12{width:25%}.lg\\:w-4\\/12{width:33.333333%}.lg\\:w-5\\/12{width:41.666667%}.lg\\:w-6\\/12{width:50%}.lg\\:w-7\\/12{width:58.333333%}.lg\\:w-8\\/12{width:66.666667%}.lg\\:w-9\\/12{width:75%}.lg\\:w-10\\/12{width:83.333333%}.lg\\:w-11\\/12{width:91.666667%}.lg\\:w-full{width:100%}.lg\\:w-screen{width:100vw}.lg\\:z-0{z-index:0}.lg\\:z-10{z-index:10}.lg\\:z-20{z-index:20}.lg\\:z-30{z-index:30}.lg\\:z-40{z-index:40}.lg\\:z-50{z-index:50}.lg\\:z-auto{z-index:auto}.lg\\:gap-0{grid-gap:0;gap:0}.lg\\:gap-1{grid-gap:.25rem;gap:.25rem}.lg\\:gap-2{grid-gap:.5rem;gap:.5rem}.lg\\:gap-3{grid-gap:.75rem;gap:.75rem}.lg\\:gap-4{grid-gap:1rem;gap:1rem}.lg\\:gap-5{grid-gap:1.25rem;gap:1.25rem}.lg\\:gap-6{grid-gap:1.5rem;gap:1.5rem}.lg\\:gap-8{grid-gap:2rem;gap:2rem}.lg\\:gap-10{grid-gap:2.5rem;gap:2.5rem}.lg\\:gap-12{grid-gap:3rem;gap:3rem}.lg\\:gap-16{grid-gap:4rem;gap:4rem}.lg\\:gap-20{grid-gap:5rem;gap:5rem}.lg\\:gap-24{grid-gap:6rem;gap:6rem}.lg\\:gap-32{grid-gap:8rem;gap:8rem}.lg\\:gap-40{grid-gap:10rem;gap:10rem}.lg\\:gap-48{grid-gap:12rem;gap:12rem}.lg\\:gap-56{grid-gap:14rem;gap:14rem}.lg\\:gap-64{grid-gap:16rem;gap:16rem}.lg\\:gap-px{grid-gap:1px;gap:1px}.lg\\:col-gap-0{grid-column-gap:0;column-gap:0}.lg\\:col-gap-1{grid-column-gap:.25rem;column-gap:.25rem}.lg\\:col-gap-2{grid-column-gap:.5rem;column-gap:.5rem}.lg\\:col-gap-3{grid-column-gap:.75rem;column-gap:.75rem}.lg\\:col-gap-4{grid-column-gap:1rem;column-gap:1rem}.lg\\:col-gap-5{grid-column-gap:1.25rem;column-gap:1.25rem}.lg\\:col-gap-6{grid-column-gap:1.5rem;column-gap:1.5rem}.lg\\:col-gap-8{grid-column-gap:2rem;column-gap:2rem}.lg\\:col-gap-10{grid-column-gap:2.5rem;column-gap:2.5rem}.lg\\:col-gap-12{grid-column-gap:3rem;column-gap:3rem}.lg\\:col-gap-16{grid-column-gap:4rem;column-gap:4rem}.lg\\:col-gap-20{grid-column-gap:5rem;column-gap:5rem}.lg\\:col-gap-24{grid-column-gap:6rem;column-gap:6rem}.lg\\:col-gap-32{grid-column-gap:8rem;column-gap:8rem}.lg\\:col-gap-40{grid-column-gap:10rem;column-gap:10rem}.lg\\:col-gap-48{grid-column-gap:12rem;column-gap:12rem}.lg\\:col-gap-56{grid-column-gap:14rem;column-gap:14rem}.lg\\:col-gap-64{grid-column-gap:16rem;column-gap:16rem}.lg\\:col-gap-px{grid-column-gap:1px;column-gap:1px}.lg\\:row-gap-0{grid-row-gap:0;row-gap:0}.lg\\:row-gap-1{grid-row-gap:.25rem;row-gap:.25rem}.lg\\:row-gap-2{grid-row-gap:.5rem;row-gap:.5rem}.lg\\:row-gap-3{grid-row-gap:.75rem;row-gap:.75rem}.lg\\:row-gap-4{grid-row-gap:1rem;row-gap:1rem}.lg\\:row-gap-5{grid-row-gap:1.25rem;row-gap:1.25rem}.lg\\:row-gap-6{grid-row-gap:1.5rem;row-gap:1.5rem}.lg\\:row-gap-8{grid-row-gap:2rem;row-gap:2rem}.lg\\:row-gap-10{grid-row-gap:2.5rem;row-gap:2.5rem}.lg\\:row-gap-12{grid-row-gap:3rem;row-gap:3rem}.lg\\:row-gap-16{grid-row-gap:4rem;row-gap:4rem}.lg\\:row-gap-20{grid-row-gap:5rem;row-gap:5rem}.lg\\:row-gap-24{grid-row-gap:6rem;row-gap:6rem}.lg\\:row-gap-32{grid-row-gap:8rem;row-gap:8rem}.lg\\:row-gap-40{grid-row-gap:10rem;row-gap:10rem}.lg\\:row-gap-48{grid-row-gap:12rem;row-gap:12rem}.lg\\:row-gap-56{grid-row-gap:14rem;row-gap:14rem}.lg\\:row-gap-64{grid-row-gap:16rem;row-gap:16rem}.lg\\:row-gap-px{grid-row-gap:1px;row-gap:1px}.lg\\:grid-flow-row{grid-auto-flow:row}.lg\\:grid-flow-col{grid-auto-flow:column}.lg\\:grid-flow-row-dense{grid-auto-flow:row dense}.lg\\:grid-flow-col-dense{grid-auto-flow:column dense}.lg\\:grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.lg\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.lg\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.lg\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.lg\\:grid-cols-5{grid-template-columns:repeat(5,minmax(0,1fr))}.lg\\:grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.lg\\:grid-cols-7{grid-template-columns:repeat(7,minmax(0,1fr))}.lg\\:grid-cols-8{grid-template-columns:repeat(8,minmax(0,1fr))}.lg\\:grid-cols-9{grid-template-columns:repeat(9,minmax(0,1fr))}.lg\\:grid-cols-10{grid-template-columns:repeat(10,minmax(0,1fr))}.lg\\:grid-cols-11{grid-template-columns:repeat(11,minmax(0,1fr))}.lg\\:grid-cols-12{grid-template-columns:repeat(12,minmax(0,1fr))}.lg\\:grid-cols-none{grid-template-columns:none}.lg\\:col-auto{grid-column:auto}.lg\\:col-span-1{grid-column:span 1/span 1}.lg\\:col-span-2{grid-column:span 2/span 2}.lg\\:col-span-3{grid-column:span 3/span 3}.lg\\:col-span-4{grid-column:span 4/span 4}.lg\\:col-span-5{grid-column:span 5/span 5}.lg\\:col-span-6{grid-column:span 6/span 6}.lg\\:col-span-7{grid-column:span 7/span 7}.lg\\:col-span-8{grid-column:span 8/span 8}.lg\\:col-span-9{grid-column:span 9/span 9}.lg\\:col-span-10{grid-column:span 10/span 10}.lg\\:col-span-11{grid-column:span 11/span 11}.lg\\:col-span-12{grid-column:span 12/span 12}.lg\\:col-start-1{grid-column-start:1}.lg\\:col-start-2{grid-column-start:2}.lg\\:col-start-3{grid-column-start:3}.lg\\:col-start-4{grid-column-start:4}.lg\\:col-start-5{grid-column-start:5}.lg\\:col-start-6{grid-column-start:6}.lg\\:col-start-7{grid-column-start:7}.lg\\:col-start-8{grid-column-start:8}.lg\\:col-start-9{grid-column-start:9}.lg\\:col-start-10{grid-column-start:10}.lg\\:col-start-11{grid-column-start:11}.lg\\:col-start-12{grid-column-start:12}.lg\\:col-start-13{grid-column-start:13}.lg\\:col-start-auto{grid-column-start:auto}.lg\\:col-end-1{grid-column-end:1}.lg\\:col-end-2{grid-column-end:2}.lg\\:col-end-3{grid-column-end:3}.lg\\:col-end-4{grid-column-end:4}.lg\\:col-end-5{grid-column-end:5}.lg\\:col-end-6{grid-column-end:6}.lg\\:col-end-7{grid-column-end:7}.lg\\:col-end-8{grid-column-end:8}.lg\\:col-end-9{grid-column-end:9}.lg\\:col-end-10{grid-column-end:10}.lg\\:col-end-11{grid-column-end:11}.lg\\:col-end-12{grid-column-end:12}.lg\\:col-end-13{grid-column-end:13}.lg\\:col-end-auto{grid-column-end:auto}.lg\\:grid-rows-1{grid-template-rows:repeat(1,minmax(0,1fr))}.lg\\:grid-rows-2{grid-template-rows:repeat(2,minmax(0,1fr))}.lg\\:grid-rows-3{grid-template-rows:repeat(3,minmax(0,1fr))}.lg\\:grid-rows-4{grid-template-rows:repeat(4,minmax(0,1fr))}.lg\\:grid-rows-5{grid-template-rows:repeat(5,minmax(0,1fr))}.lg\\:grid-rows-6{grid-template-rows:repeat(6,minmax(0,1fr))}.lg\\:grid-rows-none{grid-template-rows:none}.lg\\:row-auto{grid-row:auto}.lg\\:row-span-1{grid-row:span 1/span 1}.lg\\:row-span-2{grid-row:span 2/span 2}.lg\\:row-span-3{grid-row:span 3/span 3}.lg\\:row-span-4{grid-row:span 4/span 4}.lg\\:row-span-5{grid-row:span 5/span 5}.lg\\:row-span-6{grid-row:span 6/span 6}.lg\\:row-start-1{grid-row-start:1}.lg\\:row-start-2{grid-row-start:2}.lg\\:row-start-3{grid-row-start:3}.lg\\:row-start-4{grid-row-start:4}.lg\\:row-start-5{grid-row-start:5}.lg\\:row-start-6{grid-row-start:6}.lg\\:row-start-7{grid-row-start:7}.lg\\:row-start-auto{grid-row-start:auto}.lg\\:row-end-1{grid-row-end:1}.lg\\:row-end-2{grid-row-end:2}.lg\\:row-end-3{grid-row-end:3}.lg\\:row-end-4{grid-row-end:4}.lg\\:row-end-5{grid-row-end:5}.lg\\:row-end-6{grid-row-end:6}.lg\\:row-end-7{grid-row-end:7}.lg\\:row-end-auto{grid-row-end:auto}.lg\\:transform{--transform-translate-x:0;--transform-translate-y:0;--transform-rotate:0;--transform-skew-x:0;--transform-skew-y:0;--transform-scale-x:1;--transform-scale-y:1;transform:translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y))}.lg\\:transform-none{transform:none}.lg\\:origin-center{transform-origin:center}.lg\\:origin-top{transform-origin:top}.lg\\:origin-top-right{transform-origin:top right}.lg\\:origin-right{transform-origin:right}.lg\\:origin-bottom-right{transform-origin:bottom right}.lg\\:origin-bottom{transform-origin:bottom}.lg\\:origin-bottom-left{transform-origin:bottom left}.lg\\:origin-left{transform-origin:left}.lg\\:origin-top-left{transform-origin:top left}.lg\\:scale-0{--transform-scale-x:0;--transform-scale-y:0}.lg\\:scale-50{--transform-scale-x:.5;--transform-scale-y:.5}.lg\\:scale-75{--transform-scale-x:.75;--transform-scale-y:.75}.lg\\:scale-90{--transform-scale-x:.9;--transform-scale-y:.9}.lg\\:scale-95{--transform-scale-x:.95;--transform-scale-y:.95}.lg\\:scale-100{--transform-scale-x:1;--transform-scale-y:1}.lg\\:scale-105{--transform-scale-x:1.05;--transform-scale-y:1.05}.lg\\:scale-110{--transform-scale-x:1.1;--transform-scale-y:1.1}.lg\\:scale-125{--transform-scale-x:1.25;--transform-scale-y:1.25}.lg\\:scale-150{--transform-scale-x:1.5;--transform-scale-y:1.5}.lg\\:scale-x-0{--transform-scale-x:0}.lg\\:scale-x-50{--transform-scale-x:.5}.lg\\:scale-x-75{--transform-scale-x:.75}.lg\\:scale-x-90{--transform-scale-x:.9}.lg\\:scale-x-95{--transform-scale-x:.95}.lg\\:scale-x-100{--transform-scale-x:1}.lg\\:scale-x-105{--transform-scale-x:1.05}.lg\\:scale-x-110{--transform-scale-x:1.1}.lg\\:scale-x-125{--transform-scale-x:1.25}.lg\\:scale-x-150{--transform-scale-x:1.5}.lg\\:scale-y-0{--transform-scale-y:0}.lg\\:scale-y-50{--transform-scale-y:.5}.lg\\:scale-y-75{--transform-scale-y:.75}.lg\\:scale-y-90{--transform-scale-y:.9}.lg\\:scale-y-95{--transform-scale-y:.95}.lg\\:scale-y-100{--transform-scale-y:1}.lg\\:scale-y-105{--transform-scale-y:1.05}.lg\\:scale-y-110{--transform-scale-y:1.1}.lg\\:scale-y-125{--transform-scale-y:1.25}.lg\\:scale-y-150{--transform-scale-y:1.5}.lg\\:hover\\:scale-0:hover{--transform-scale-x:0;--transform-scale-y:0}.lg\\:hover\\:scale-50:hover{--transform-scale-x:.5;--transform-scale-y:.5}.lg\\:hover\\:scale-75:hover{--transform-scale-x:.75;--transform-scale-y:.75}.lg\\:hover\\:scale-90:hover{--transform-scale-x:.9;--transform-scale-y:.9}.lg\\:hover\\:scale-95:hover{--transform-scale-x:.95;--transform-scale-y:.95}.lg\\:hover\\:scale-100:hover{--transform-scale-x:1;--transform-scale-y:1}.lg\\:hover\\:scale-105:hover{--transform-scale-x:1.05;--transform-scale-y:1.05}.lg\\:hover\\:scale-110:hover{--transform-scale-x:1.1;--transform-scale-y:1.1}.lg\\:hover\\:scale-125:hover{--transform-scale-x:1.25;--transform-scale-y:1.25}.lg\\:hover\\:scale-150:hover{--transform-scale-x:1.5;--transform-scale-y:1.5}.lg\\:hover\\:scale-x-0:hover{--transform-scale-x:0}.lg\\:hover\\:scale-x-50:hover{--transform-scale-x:.5}.lg\\:hover\\:scale-x-75:hover{--transform-scale-x:.75}.lg\\:hover\\:scale-x-90:hover{--transform-scale-x:.9}.lg\\:hover\\:scale-x-95:hover{--transform-scale-x:.95}.lg\\:hover\\:scale-x-100:hover{--transform-scale-x:1}.lg\\:hover\\:scale-x-105:hover{--transform-scale-x:1.05}.lg\\:hover\\:scale-x-110:hover{--transform-scale-x:1.1}.lg\\:hover\\:scale-x-125:hover{--transform-scale-x:1.25}.lg\\:hover\\:scale-x-150:hover{--transform-scale-x:1.5}.lg\\:hover\\:scale-y-0:hover{--transform-scale-y:0}.lg\\:hover\\:scale-y-50:hover{--transform-scale-y:.5}.lg\\:hover\\:scale-y-75:hover{--transform-scale-y:.75}.lg\\:hover\\:scale-y-90:hover{--transform-scale-y:.9}.lg\\:hover\\:scale-y-95:hover{--transform-scale-y:.95}.lg\\:hover\\:scale-y-100:hover{--transform-scale-y:1}.lg\\:hover\\:scale-y-105:hover{--transform-scale-y:1.05}.lg\\:hover\\:scale-y-110:hover{--transform-scale-y:1.1}.lg\\:hover\\:scale-y-125:hover{--transform-scale-y:1.25}.lg\\:hover\\:scale-y-150:hover{--transform-scale-y:1.5}.lg\\:focus\\:scale-0:focus{--transform-scale-x:0;--transform-scale-y:0}.lg\\:focus\\:scale-50:focus{--transform-scale-x:.5;--transform-scale-y:.5}.lg\\:focus\\:scale-75:focus{--transform-scale-x:.75;--transform-scale-y:.75}.lg\\:focus\\:scale-90:focus{--transform-scale-x:.9;--transform-scale-y:.9}.lg\\:focus\\:scale-95:focus{--transform-scale-x:.95;--transform-scale-y:.95}.lg\\:focus\\:scale-100:focus{--transform-scale-x:1;--transform-scale-y:1}.lg\\:focus\\:scale-105:focus{--transform-scale-x:1.05;--transform-scale-y:1.05}.lg\\:focus\\:scale-110:focus{--transform-scale-x:1.1;--transform-scale-y:1.1}.lg\\:focus\\:scale-125:focus{--transform-scale-x:1.25;--transform-scale-y:1.25}.lg\\:focus\\:scale-150:focus{--transform-scale-x:1.5;--transform-scale-y:1.5}.lg\\:focus\\:scale-x-0:focus{--transform-scale-x:0}.lg\\:focus\\:scale-x-50:focus{--transform-scale-x:.5}.lg\\:focus\\:scale-x-75:focus{--transform-scale-x:.75}.lg\\:focus\\:scale-x-90:focus{--transform-scale-x:.9}.lg\\:focus\\:scale-x-95:focus{--transform-scale-x:.95}.lg\\:focus\\:scale-x-100:focus{--transform-scale-x:1}.lg\\:focus\\:scale-x-105:focus{--transform-scale-x:1.05}.lg\\:focus\\:scale-x-110:focus{--transform-scale-x:1.1}.lg\\:focus\\:scale-x-125:focus{--transform-scale-x:1.25}.lg\\:focus\\:scale-x-150:focus{--transform-scale-x:1.5}.lg\\:focus\\:scale-y-0:focus{--transform-scale-y:0}.lg\\:focus\\:scale-y-50:focus{--transform-scale-y:.5}.lg\\:focus\\:scale-y-75:focus{--transform-scale-y:.75}.lg\\:focus\\:scale-y-90:focus{--transform-scale-y:.9}.lg\\:focus\\:scale-y-95:focus{--transform-scale-y:.95}.lg\\:focus\\:scale-y-100:focus{--transform-scale-y:1}.lg\\:focus\\:scale-y-105:focus{--transform-scale-y:1.05}.lg\\:focus\\:scale-y-110:focus{--transform-scale-y:1.1}.lg\\:focus\\:scale-y-125:focus{--transform-scale-y:1.25}.lg\\:focus\\:scale-y-150:focus{--transform-scale-y:1.5}.lg\\:rotate-0{--transform-rotate:0}.lg\\:rotate-45{--transform-rotate:45deg}.lg\\:rotate-90{--transform-rotate:90deg}.lg\\:rotate-180{--transform-rotate:180deg}.lg\\:-rotate-180{--transform-rotate:-180deg}.lg\\:-rotate-90{--transform-rotate:-90deg}.lg\\:-rotate-45{--transform-rotate:-45deg}.lg\\:hover\\:rotate-0:hover{--transform-rotate:0}.lg\\:hover\\:rotate-45:hover{--transform-rotate:45deg}.lg\\:hover\\:rotate-90:hover{--transform-rotate:90deg}.lg\\:hover\\:rotate-180:hover{--transform-rotate:180deg}.lg\\:hover\\:-rotate-180:hover{--transform-rotate:-180deg}.lg\\:hover\\:-rotate-90:hover{--transform-rotate:-90deg}.lg\\:hover\\:-rotate-45:hover{--transform-rotate:-45deg}.lg\\:focus\\:rotate-0:focus{--transform-rotate:0}.lg\\:focus\\:rotate-45:focus{--transform-rotate:45deg}.lg\\:focus\\:rotate-90:focus{--transform-rotate:90deg}.lg\\:focus\\:rotate-180:focus{--transform-rotate:180deg}.lg\\:focus\\:-rotate-180:focus{--transform-rotate:-180deg}.lg\\:focus\\:-rotate-90:focus{--transform-rotate:-90deg}.lg\\:focus\\:-rotate-45:focus{--transform-rotate:-45deg}.lg\\:translate-x-0{--transform-translate-x:0}.lg\\:translate-x-1{--transform-translate-x:0.25rem}.lg\\:translate-x-2{--transform-translate-x:0.5rem}.lg\\:translate-x-3{--transform-translate-x:0.75rem}.lg\\:translate-x-4{--transform-translate-x:1rem}.lg\\:translate-x-5{--transform-translate-x:1.25rem}.lg\\:translate-x-6{--transform-translate-x:1.5rem}.lg\\:translate-x-8{--transform-translate-x:2rem}.lg\\:translate-x-10{--transform-translate-x:2.5rem}.lg\\:translate-x-12{--transform-translate-x:3rem}.lg\\:translate-x-16{--transform-translate-x:4rem}.lg\\:translate-x-20{--transform-translate-x:5rem}.lg\\:translate-x-24{--transform-translate-x:6rem}.lg\\:translate-x-32{--transform-translate-x:8rem}.lg\\:translate-x-40{--transform-translate-x:10rem}.lg\\:translate-x-48{--transform-translate-x:12rem}.lg\\:translate-x-56{--transform-translate-x:14rem}.lg\\:translate-x-64{--transform-translate-x:16rem}.lg\\:translate-x-px{--transform-translate-x:1px}.lg\\:-translate-x-1{--transform-translate-x:-0.25rem}.lg\\:-translate-x-2{--transform-translate-x:-0.5rem}.lg\\:-translate-x-3{--transform-translate-x:-0.75rem}.lg\\:-translate-x-4{--transform-translate-x:-1rem}.lg\\:-translate-x-5{--transform-translate-x:-1.25rem}.lg\\:-translate-x-6{--transform-translate-x:-1.5rem}.lg\\:-translate-x-8{--transform-translate-x:-2rem}.lg\\:-translate-x-10{--transform-translate-x:-2.5rem}.lg\\:-translate-x-12{--transform-translate-x:-3rem}.lg\\:-translate-x-16{--transform-translate-x:-4rem}.lg\\:-translate-x-20{--transform-translate-x:-5rem}.lg\\:-translate-x-24{--transform-translate-x:-6rem}.lg\\:-translate-x-32{--transform-translate-x:-8rem}.lg\\:-translate-x-40{--transform-translate-x:-10rem}.lg\\:-translate-x-48{--transform-translate-x:-12rem}.lg\\:-translate-x-56{--transform-translate-x:-14rem}.lg\\:-translate-x-64{--transform-translate-x:-16rem}.lg\\:-translate-x-px{--transform-translate-x:-1px}.lg\\:-translate-x-full{--transform-translate-x:-100%}.lg\\:-translate-x-1\\/2{--transform-translate-x:-50%}.lg\\:translate-x-1\\/2{--transform-translate-x:50%}.lg\\:translate-x-full{--transform-translate-x:100%}.lg\\:translate-y-0{--transform-translate-y:0}.lg\\:translate-y-1{--transform-translate-y:0.25rem}.lg\\:translate-y-2{--transform-translate-y:0.5rem}.lg\\:translate-y-3{--transform-translate-y:0.75rem}.lg\\:translate-y-4{--transform-translate-y:1rem}.lg\\:translate-y-5{--transform-translate-y:1.25rem}.lg\\:translate-y-6{--transform-translate-y:1.5rem}.lg\\:translate-y-8{--transform-translate-y:2rem}.lg\\:translate-y-10{--transform-translate-y:2.5rem}.lg\\:translate-y-12{--transform-translate-y:3rem}.lg\\:translate-y-16{--transform-translate-y:4rem}.lg\\:translate-y-20{--transform-translate-y:5rem}.lg\\:translate-y-24{--transform-translate-y:6rem}.lg\\:translate-y-32{--transform-translate-y:8rem}.lg\\:translate-y-40{--transform-translate-y:10rem}.lg\\:translate-y-48{--transform-translate-y:12rem}.lg\\:translate-y-56{--transform-translate-y:14rem}.lg\\:translate-y-64{--transform-translate-y:16rem}.lg\\:translate-y-px{--transform-translate-y:1px}.lg\\:-translate-y-1{--transform-translate-y:-0.25rem}.lg\\:-translate-y-2{--transform-translate-y:-0.5rem}.lg\\:-translate-y-3{--transform-translate-y:-0.75rem}.lg\\:-translate-y-4{--transform-translate-y:-1rem}.lg\\:-translate-y-5{--transform-translate-y:-1.25rem}.lg\\:-translate-y-6{--transform-translate-y:-1.5rem}.lg\\:-translate-y-8{--transform-translate-y:-2rem}.lg\\:-translate-y-10{--transform-translate-y:-2.5rem}.lg\\:-translate-y-12{--transform-translate-y:-3rem}.lg\\:-translate-y-16{--transform-translate-y:-4rem}.lg\\:-translate-y-20{--transform-translate-y:-5rem}.lg\\:-translate-y-24{--transform-translate-y:-6rem}.lg\\:-translate-y-32{--transform-translate-y:-8rem}.lg\\:-translate-y-40{--transform-translate-y:-10rem}.lg\\:-translate-y-48{--transform-translate-y:-12rem}.lg\\:-translate-y-56{--transform-translate-y:-14rem}.lg\\:-translate-y-64{--transform-translate-y:-16rem}.lg\\:-translate-y-px{--transform-translate-y:-1px}.lg\\:-translate-y-full{--transform-translate-y:-100%}.lg\\:-translate-y-1\\/2{--transform-translate-y:-50%}.lg\\:translate-y-1\\/2{--transform-translate-y:50%}.lg\\:translate-y-full{--transform-translate-y:100%}.lg\\:hover\\:translate-x-0:hover{--transform-translate-x:0}.lg\\:hover\\:translate-x-1:hover{--transform-translate-x:0.25rem}.lg\\:hover\\:translate-x-2:hover{--transform-translate-x:0.5rem}.lg\\:hover\\:translate-x-3:hover{--transform-translate-x:0.75rem}.lg\\:hover\\:translate-x-4:hover{--transform-translate-x:1rem}.lg\\:hover\\:translate-x-5:hover{--transform-translate-x:1.25rem}.lg\\:hover\\:translate-x-6:hover{--transform-translate-x:1.5rem}.lg\\:hover\\:translate-x-8:hover{--transform-translate-x:2rem}.lg\\:hover\\:translate-x-10:hover{--transform-translate-x:2.5rem}.lg\\:hover\\:translate-x-12:hover{--transform-translate-x:3rem}.lg\\:hover\\:translate-x-16:hover{--transform-translate-x:4rem}.lg\\:hover\\:translate-x-20:hover{--transform-translate-x:5rem}.lg\\:hover\\:translate-x-24:hover{--transform-translate-x:6rem}.lg\\:hover\\:translate-x-32:hover{--transform-translate-x:8rem}.lg\\:hover\\:translate-x-40:hover{--transform-translate-x:10rem}.lg\\:hover\\:translate-x-48:hover{--transform-translate-x:12rem}.lg\\:hover\\:translate-x-56:hover{--transform-translate-x:14rem}.lg\\:hover\\:translate-x-64:hover{--transform-translate-x:16rem}.lg\\:hover\\:translate-x-px:hover{--transform-translate-x:1px}.lg\\:hover\\:-translate-x-1:hover{--transform-translate-x:-0.25rem}.lg\\:hover\\:-translate-x-2:hover{--transform-translate-x:-0.5rem}.lg\\:hover\\:-translate-x-3:hover{--transform-translate-x:-0.75rem}.lg\\:hover\\:-translate-x-4:hover{--transform-translate-x:-1rem}.lg\\:hover\\:-translate-x-5:hover{--transform-translate-x:-1.25rem}.lg\\:hover\\:-translate-x-6:hover{--transform-translate-x:-1.5rem}.lg\\:hover\\:-translate-x-8:hover{--transform-translate-x:-2rem}.lg\\:hover\\:-translate-x-10:hover{--transform-translate-x:-2.5rem}.lg\\:hover\\:-translate-x-12:hover{--transform-translate-x:-3rem}.lg\\:hover\\:-translate-x-16:hover{--transform-translate-x:-4rem}.lg\\:hover\\:-translate-x-20:hover{--transform-translate-x:-5rem}.lg\\:hover\\:-translate-x-24:hover{--transform-translate-x:-6rem}.lg\\:hover\\:-translate-x-32:hover{--transform-translate-x:-8rem}.lg\\:hover\\:-translate-x-40:hover{--transform-translate-x:-10rem}.lg\\:hover\\:-translate-x-48:hover{--transform-translate-x:-12rem}.lg\\:hover\\:-translate-x-56:hover{--transform-translate-x:-14rem}.lg\\:hover\\:-translate-x-64:hover{--transform-translate-x:-16rem}.lg\\:hover\\:-translate-x-px:hover{--transform-translate-x:-1px}.lg\\:hover\\:-translate-x-full:hover{--transform-translate-x:-100%}.lg\\:hover\\:-translate-x-1\\/2:hover{--transform-translate-x:-50%}.lg\\:hover\\:translate-x-1\\/2:hover{--transform-translate-x:50%}.lg\\:hover\\:translate-x-full:hover{--transform-translate-x:100%}.lg\\:hover\\:translate-y-0:hover{--transform-translate-y:0}.lg\\:hover\\:translate-y-1:hover{--transform-translate-y:0.25rem}.lg\\:hover\\:translate-y-2:hover{--transform-translate-y:0.5rem}.lg\\:hover\\:translate-y-3:hover{--transform-translate-y:0.75rem}.lg\\:hover\\:translate-y-4:hover{--transform-translate-y:1rem}.lg\\:hover\\:translate-y-5:hover{--transform-translate-y:1.25rem}.lg\\:hover\\:translate-y-6:hover{--transform-translate-y:1.5rem}.lg\\:hover\\:translate-y-8:hover{--transform-translate-y:2rem}.lg\\:hover\\:translate-y-10:hover{--transform-translate-y:2.5rem}.lg\\:hover\\:translate-y-12:hover{--transform-translate-y:3rem}.lg\\:hover\\:translate-y-16:hover{--transform-translate-y:4rem}.lg\\:hover\\:translate-y-20:hover{--transform-translate-y:5rem}.lg\\:hover\\:translate-y-24:hover{--transform-translate-y:6rem}.lg\\:hover\\:translate-y-32:hover{--transform-translate-y:8rem}.lg\\:hover\\:translate-y-40:hover{--transform-translate-y:10rem}.lg\\:hover\\:translate-y-48:hover{--transform-translate-y:12rem}.lg\\:hover\\:translate-y-56:hover{--transform-translate-y:14rem}.lg\\:hover\\:translate-y-64:hover{--transform-translate-y:16rem}.lg\\:hover\\:translate-y-px:hover{--transform-translate-y:1px}.lg\\:hover\\:-translate-y-1:hover{--transform-translate-y:-0.25rem}.lg\\:hover\\:-translate-y-2:hover{--transform-translate-y:-0.5rem}.lg\\:hover\\:-translate-y-3:hover{--transform-translate-y:-0.75rem}.lg\\:hover\\:-translate-y-4:hover{--transform-translate-y:-1rem}.lg\\:hover\\:-translate-y-5:hover{--transform-translate-y:-1.25rem}.lg\\:hover\\:-translate-y-6:hover{--transform-translate-y:-1.5rem}.lg\\:hover\\:-translate-y-8:hover{--transform-translate-y:-2rem}.lg\\:hover\\:-translate-y-10:hover{--transform-translate-y:-2.5rem}.lg\\:hover\\:-translate-y-12:hover{--transform-translate-y:-3rem}.lg\\:hover\\:-translate-y-16:hover{--transform-translate-y:-4rem}.lg\\:hover\\:-translate-y-20:hover{--transform-translate-y:-5rem}.lg\\:hover\\:-translate-y-24:hover{--transform-translate-y:-6rem}.lg\\:hover\\:-translate-y-32:hover{--transform-translate-y:-8rem}.lg\\:hover\\:-translate-y-40:hover{--transform-translate-y:-10rem}.lg\\:hover\\:-translate-y-48:hover{--transform-translate-y:-12rem}.lg\\:hover\\:-translate-y-56:hover{--transform-translate-y:-14rem}.lg\\:hover\\:-translate-y-64:hover{--transform-translate-y:-16rem}.lg\\:hover\\:-translate-y-px:hover{--transform-translate-y:-1px}.lg\\:hover\\:-translate-y-full:hover{--transform-translate-y:-100%}.lg\\:hover\\:-translate-y-1\\/2:hover{--transform-translate-y:-50%}.lg\\:hover\\:translate-y-1\\/2:hover{--transform-translate-y:50%}.lg\\:hover\\:translate-y-full:hover{--transform-translate-y:100%}.lg\\:focus\\:translate-x-0:focus{--transform-translate-x:0}.lg\\:focus\\:translate-x-1:focus{--transform-translate-x:0.25rem}.lg\\:focus\\:translate-x-2:focus{--transform-translate-x:0.5rem}.lg\\:focus\\:translate-x-3:focus{--transform-translate-x:0.75rem}.lg\\:focus\\:translate-x-4:focus{--transform-translate-x:1rem}.lg\\:focus\\:translate-x-5:focus{--transform-translate-x:1.25rem}.lg\\:focus\\:translate-x-6:focus{--transform-translate-x:1.5rem}.lg\\:focus\\:translate-x-8:focus{--transform-translate-x:2rem}.lg\\:focus\\:translate-x-10:focus{--transform-translate-x:2.5rem}.lg\\:focus\\:translate-x-12:focus{--transform-translate-x:3rem}.lg\\:focus\\:translate-x-16:focus{--transform-translate-x:4rem}.lg\\:focus\\:translate-x-20:focus{--transform-translate-x:5rem}.lg\\:focus\\:translate-x-24:focus{--transform-translate-x:6rem}.lg\\:focus\\:translate-x-32:focus{--transform-translate-x:8rem}.lg\\:focus\\:translate-x-40:focus{--transform-translate-x:10rem}.lg\\:focus\\:translate-x-48:focus{--transform-translate-x:12rem}.lg\\:focus\\:translate-x-56:focus{--transform-translate-x:14rem}.lg\\:focus\\:translate-x-64:focus{--transform-translate-x:16rem}.lg\\:focus\\:translate-x-px:focus{--transform-translate-x:1px}.lg\\:focus\\:-translate-x-1:focus{--transform-translate-x:-0.25rem}.lg\\:focus\\:-translate-x-2:focus{--transform-translate-x:-0.5rem}.lg\\:focus\\:-translate-x-3:focus{--transform-translate-x:-0.75rem}.lg\\:focus\\:-translate-x-4:focus{--transform-translate-x:-1rem}.lg\\:focus\\:-translate-x-5:focus{--transform-translate-x:-1.25rem}.lg\\:focus\\:-translate-x-6:focus{--transform-translate-x:-1.5rem}.lg\\:focus\\:-translate-x-8:focus{--transform-translate-x:-2rem}.lg\\:focus\\:-translate-x-10:focus{--transform-translate-x:-2.5rem}.lg\\:focus\\:-translate-x-12:focus{--transform-translate-x:-3rem}.lg\\:focus\\:-translate-x-16:focus{--transform-translate-x:-4rem}.lg\\:focus\\:-translate-x-20:focus{--transform-translate-x:-5rem}.lg\\:focus\\:-translate-x-24:focus{--transform-translate-x:-6rem}.lg\\:focus\\:-translate-x-32:focus{--transform-translate-x:-8rem}.lg\\:focus\\:-translate-x-40:focus{--transform-translate-x:-10rem}.lg\\:focus\\:-translate-x-48:focus{--transform-translate-x:-12rem}.lg\\:focus\\:-translate-x-56:focus{--transform-translate-x:-14rem}.lg\\:focus\\:-translate-x-64:focus{--transform-translate-x:-16rem}.lg\\:focus\\:-translate-x-px:focus{--transform-translate-x:-1px}.lg\\:focus\\:-translate-x-full:focus{--transform-translate-x:-100%}.lg\\:focus\\:-translate-x-1\\/2:focus{--transform-translate-x:-50%}.lg\\:focus\\:translate-x-1\\/2:focus{--transform-translate-x:50%}.lg\\:focus\\:translate-x-full:focus{--transform-translate-x:100%}.lg\\:focus\\:translate-y-0:focus{--transform-translate-y:0}.lg\\:focus\\:translate-y-1:focus{--transform-translate-y:0.25rem}.lg\\:focus\\:translate-y-2:focus{--transform-translate-y:0.5rem}.lg\\:focus\\:translate-y-3:focus{--transform-translate-y:0.75rem}.lg\\:focus\\:translate-y-4:focus{--transform-translate-y:1rem}.lg\\:focus\\:translate-y-5:focus{--transform-translate-y:1.25rem}.lg\\:focus\\:translate-y-6:focus{--transform-translate-y:1.5rem}.lg\\:focus\\:translate-y-8:focus{--transform-translate-y:2rem}.lg\\:focus\\:translate-y-10:focus{--transform-translate-y:2.5rem}.lg\\:focus\\:translate-y-12:focus{--transform-translate-y:3rem}.lg\\:focus\\:translate-y-16:focus{--transform-translate-y:4rem}.lg\\:focus\\:translate-y-20:focus{--transform-translate-y:5rem}.lg\\:focus\\:translate-y-24:focus{--transform-translate-y:6rem}.lg\\:focus\\:translate-y-32:focus{--transform-translate-y:8rem}.lg\\:focus\\:translate-y-40:focus{--transform-translate-y:10rem}.lg\\:focus\\:translate-y-48:focus{--transform-translate-y:12rem}.lg\\:focus\\:translate-y-56:focus{--transform-translate-y:14rem}.lg\\:focus\\:translate-y-64:focus{--transform-translate-y:16rem}.lg\\:focus\\:translate-y-px:focus{--transform-translate-y:1px}.lg\\:focus\\:-translate-y-1:focus{--transform-translate-y:-0.25rem}.lg\\:focus\\:-translate-y-2:focus{--transform-translate-y:-0.5rem}.lg\\:focus\\:-translate-y-3:focus{--transform-translate-y:-0.75rem}.lg\\:focus\\:-translate-y-4:focus{--transform-translate-y:-1rem}.lg\\:focus\\:-translate-y-5:focus{--transform-translate-y:-1.25rem}.lg\\:focus\\:-translate-y-6:focus{--transform-translate-y:-1.5rem}.lg\\:focus\\:-translate-y-8:focus{--transform-translate-y:-2rem}.lg\\:focus\\:-translate-y-10:focus{--transform-translate-y:-2.5rem}.lg\\:focus\\:-translate-y-12:focus{--transform-translate-y:-3rem}.lg\\:focus\\:-translate-y-16:focus{--transform-translate-y:-4rem}.lg\\:focus\\:-translate-y-20:focus{--transform-translate-y:-5rem}.lg\\:focus\\:-translate-y-24:focus{--transform-translate-y:-6rem}.lg\\:focus\\:-translate-y-32:focus{--transform-translate-y:-8rem}.lg\\:focus\\:-translate-y-40:focus{--transform-translate-y:-10rem}.lg\\:focus\\:-translate-y-48:focus{--transform-translate-y:-12rem}.lg\\:focus\\:-translate-y-56:focus{--transform-translate-y:-14rem}.lg\\:focus\\:-translate-y-64:focus{--transform-translate-y:-16rem}.lg\\:focus\\:-translate-y-px:focus{--transform-translate-y:-1px}.lg\\:focus\\:-translate-y-full:focus{--transform-translate-y:-100%}.lg\\:focus\\:-translate-y-1\\/2:focus{--transform-translate-y:-50%}.lg\\:focus\\:translate-y-1\\/2:focus{--transform-translate-y:50%}.lg\\:focus\\:translate-y-full:focus{--transform-translate-y:100%}.lg\\:skew-x-0{--transform-skew-x:0}.lg\\:skew-x-3{--transform-skew-x:3deg}.lg\\:skew-x-6{--transform-skew-x:6deg}.lg\\:skew-x-12{--transform-skew-x:12deg}.lg\\:-skew-x-12{--transform-skew-x:-12deg}.lg\\:-skew-x-6{--transform-skew-x:-6deg}.lg\\:-skew-x-3{--transform-skew-x:-3deg}.lg\\:skew-y-0{--transform-skew-y:0}.lg\\:skew-y-3{--transform-skew-y:3deg}.lg\\:skew-y-6{--transform-skew-y:6deg}.lg\\:skew-y-12{--transform-skew-y:12deg}.lg\\:-skew-y-12{--transform-skew-y:-12deg}.lg\\:-skew-y-6{--transform-skew-y:-6deg}.lg\\:-skew-y-3{--transform-skew-y:-3deg}.lg\\:hover\\:skew-x-0:hover{--transform-skew-x:0}.lg\\:hover\\:skew-x-3:hover{--transform-skew-x:3deg}.lg\\:hover\\:skew-x-6:hover{--transform-skew-x:6deg}.lg\\:hover\\:skew-x-12:hover{--transform-skew-x:12deg}.lg\\:hover\\:-skew-x-12:hover{--transform-skew-x:-12deg}.lg\\:hover\\:-skew-x-6:hover{--transform-skew-x:-6deg}.lg\\:hover\\:-skew-x-3:hover{--transform-skew-x:-3deg}.lg\\:hover\\:skew-y-0:hover{--transform-skew-y:0}.lg\\:hover\\:skew-y-3:hover{--transform-skew-y:3deg}.lg\\:hover\\:skew-y-6:hover{--transform-skew-y:6deg}.lg\\:hover\\:skew-y-12:hover{--transform-skew-y:12deg}.lg\\:hover\\:-skew-y-12:hover{--transform-skew-y:-12deg}.lg\\:hover\\:-skew-y-6:hover{--transform-skew-y:-6deg}.lg\\:hover\\:-skew-y-3:hover{--transform-skew-y:-3deg}.lg\\:focus\\:skew-x-0:focus{--transform-skew-x:0}.lg\\:focus\\:skew-x-3:focus{--transform-skew-x:3deg}.lg\\:focus\\:skew-x-6:focus{--transform-skew-x:6deg}.lg\\:focus\\:skew-x-12:focus{--transform-skew-x:12deg}.lg\\:focus\\:-skew-x-12:focus{--transform-skew-x:-12deg}.lg\\:focus\\:-skew-x-6:focus{--transform-skew-x:-6deg}.lg\\:focus\\:-skew-x-3:focus{--transform-skew-x:-3deg}.lg\\:focus\\:skew-y-0:focus{--transform-skew-y:0}.lg\\:focus\\:skew-y-3:focus{--transform-skew-y:3deg}.lg\\:focus\\:skew-y-6:focus{--transform-skew-y:6deg}.lg\\:focus\\:skew-y-12:focus{--transform-skew-y:12deg}.lg\\:focus\\:-skew-y-12:focus{--transform-skew-y:-12deg}.lg\\:focus\\:-skew-y-6:focus{--transform-skew-y:-6deg}.lg\\:focus\\:-skew-y-3:focus{--transform-skew-y:-3deg}.lg\\:transition-none{transition-property:none}.lg\\:transition-all{transition-property:all}.lg\\:transition{transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform}.lg\\:transition-colors{transition-property:background-color,border-color,color,fill,stroke}.lg\\:transition-opacity{transition-property:opacity}.lg\\:transition-shadow{transition-property:box-shadow}.lg\\:transition-transform{transition-property:transform}.lg\\:ease-linear{transition-timing-function:linear}.lg\\:ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.lg\\:ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.lg\\:ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.lg\\:duration-75{transition-duration:75ms}.lg\\:duration-100{transition-duration:.1s}.lg\\:duration-150{transition-duration:.15s}.lg\\:duration-200{transition-duration:.2s}.lg\\:duration-300{transition-duration:.3s}.lg\\:duration-500{transition-duration:.5s}.lg\\:duration-700{transition-duration:.7s}.lg\\:duration-1000{transition-duration:1s}.lg\\:delay-75{transition-delay:75ms}.lg\\:delay-100{transition-delay:.1s}.lg\\:delay-150{transition-delay:.15s}.lg\\:delay-200{transition-delay:.2s}.lg\\:delay-300{transition-delay:.3s}.lg\\:delay-500{transition-delay:.5s}.lg\\:delay-700{transition-delay:.7s}.lg\\:delay-1000{transition-delay:1s}.lg\\:shadow-outline-white{box-shadow:0 0 0 3px #ffffff73}.lg\\:shadow-outline-black{box-shadow:0 0 0 3px #00000073}.lg\\:shadow-outline-gray{box-shadow:0 0 0 3px #d5d6d773}.lg\\:shadow-outline-cool-gray{box-shadow:0 0 0 3px #cfd8e373}.lg\\:shadow-outline-red{box-shadow:0 0 0 3px #f8b4b473}.lg\\:shadow-outline-orange{box-shadow:0 0 0 3px #fdba8c73}.lg\\:shadow-outline-yellow{box-shadow:0 0 0 3px #faca1573}.lg\\:shadow-outline-green{box-shadow:0 0 0 3px #84e1bc73}.lg\\:shadow-outline-teal{box-shadow:0 0 0 3px #7edce273}.lg\\:shadow-outline-blue{box-shadow:0 0 0 3px #a4cafe73}.lg\\:shadow-outline-indigo{box-shadow:0 0 0 3px #b4c6fc73}.lg\\:shadow-outline-indigo{box-shadow:0 0 0 3px #cabffd73}.lg\\:shadow-outline-pink{box-shadow:0 0 0 3px #f8b4d973}.lg\\:hover\\:shadow-outline-white:hover{box-shadow:0 0 0 3px #ffffff73}.lg\\:hover\\:shadow-outline-black:hover{box-shadow:0 0 0 3px #00000073}.lg\\:hover\\:shadow-outline-gray:hover{box-shadow:0 0 0 3px #d5d6d773}.lg\\:hover\\:shadow-outline-cool-gray:hover{box-shadow:0 0 0 3px #cfd8e373}.lg\\:hover\\:shadow-outline-red:hover{box-shadow:0 0 0 3px #f8b4b473}.lg\\:hover\\:shadow-outline-orange:hover{box-shadow:0 0 0 3px #fdba8c73}.lg\\:hover\\:shadow-outline-yellow:hover{box-shadow:0 0 0 3px #faca1573}.lg\\:hover\\:shadow-outline-green:hover{box-shadow:0 0 0 3px #84e1bc73}.lg\\:hover\\:shadow-outline-teal:hover{box-shadow:0 0 0 3px #7edce273}.lg\\:hover\\:shadow-outline-blue:hover{box-shadow:0 0 0 3px #a4cafe73}.lg\\:hover\\:shadow-outline-indigo:hover{box-shadow:0 0 0 3px #b4c6fc73}.lg\\:hover\\:shadow-outline-indigo:hover{box-shadow:0 0 0 3px #cabffd73}.lg\\:hover\\:shadow-outline-pink:hover{box-shadow:0 0 0 3px #f8b4d973}.lg\\:focus\\:shadow-outline-white:focus{box-shadow:0 0 0 3px #ffffff73}.lg\\:focus\\:shadow-outline-black:focus{box-shadow:0 0 0 3px #00000073}.lg\\:focus\\:shadow-outline-gray:focus{box-shadow:0 0 0 3px #d5d6d773}.lg\\:focus\\:shadow-outline-cool-gray:focus{box-shadow:0 0 0 3px #cfd8e373}.lg\\:focus\\:shadow-outline-red:focus{box-shadow:0 0 0 3px #f8b4b473}.lg\\:focus\\:shadow-outline-orange:focus{box-shadow:0 0 0 3px #fdba8c73}.lg\\:focus\\:shadow-outline-yellow:focus{box-shadow:0 0 0 3px #faca1573}.lg\\:focus\\:shadow-outline-green:focus{box-shadow:0 0 0 3px #84e1bc73}.lg\\:focus\\:shadow-outline-teal:focus{box-shadow:0 0 0 3px #7edce273}.lg\\:focus\\:shadow-outline-blue:focus{box-shadow:0 0 0 3px #a4cafe73}.lg\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #b4c6fc73}.lg\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #cabffd73}.lg\\:focus\\:shadow-outline-pink:focus{box-shadow:0 0 0 3px #f8b4d973}.theme-dark .lg\\:dark\\:focus\\:shadow-outline-white:focus{box-shadow:0 0 0 3px #ffffff73}.theme-dark .lg\\:dark\\:focus\\:shadow-outline-black:focus{box-shadow:0 0 0 3px #00000073}.theme-dark .lg\\:dark\\:focus\\:shadow-outline-gray:focus{box-shadow:0 0 0 3px #d5d6d773}.theme-dark .lg\\:dark\\:focus\\:shadow-outline-cool-gray:focus{box-shadow:0 0 0 3px #cfd8e373}.theme-dark .lg\\:dark\\:focus\\:shadow-outline-red:focus{box-shadow:0 0 0 3px #f8b4b473}.theme-dark .lg\\:dark\\:focus\\:shadow-outline-orange:focus{box-shadow:0 0 0 3px #fdba8c73}.theme-dark .lg\\:dark\\:focus\\:shadow-outline-yellow:focus{box-shadow:0 0 0 3px #faca1573}.theme-dark .lg\\:dark\\:focus\\:shadow-outline-green:focus{box-shadow:0 0 0 3px #84e1bc73}.theme-dark .lg\\:dark\\:focus\\:shadow-outline-teal:focus{box-shadow:0 0 0 3px #7edce273}.theme-dark .lg\\:dark\\:focus\\:shadow-outline-blue:focus{box-shadow:0 0 0 3px #a4cafe73}.theme-dark .lg\\:dark\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #b4c6fc73}.theme-dark .lg\\:dark\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #cabffd73}.theme-dark .lg\\:dark\\:focus\\:shadow-outline-pink:focus{box-shadow:0 0 0 3px #f8b4d973}}@media (min-width:1280px){.xl\\:space-y-0>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(0px*var(--space-y-reverse));margin-top:calc(0px*(1 - var(--space-y-reverse)))}.xl\\:space-x-0>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(0px*(1 - var(--space-x-reverse)));margin-right:calc(0px*var(--space-x-reverse))}.xl\\:space-y-1>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(.25rem*var(--space-y-reverse));margin-top:calc(.25rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-1>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(.25rem*(1 - var(--space-x-reverse)));margin-right:calc(.25rem*var(--space-x-reverse))}.xl\\:space-y-2>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(.5rem*var(--space-y-reverse));margin-top:calc(.5rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-2>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(.5rem*(1 - var(--space-x-reverse)));margin-right:calc(.5rem*var(--space-x-reverse))}.xl\\:space-y-3>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(.75rem*var(--space-y-reverse));margin-top:calc(.75rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-3>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(.75rem*(1 - var(--space-x-reverse)));margin-right:calc(.75rem*var(--space-x-reverse))}.xl\\:space-y-4>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1rem*var(--space-y-reverse));margin-top:calc(1rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-4>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1rem*(1 - var(--space-x-reverse)));margin-right:calc(1rem*var(--space-x-reverse))}.xl\\:space-y-5>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1.25rem*var(--space-y-reverse));margin-top:calc(1.25rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-5>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1.25rem*(1 - var(--space-x-reverse)));margin-right:calc(1.25rem*var(--space-x-reverse))}.xl\\:space-y-6>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1.5rem*var(--space-y-reverse));margin-top:calc(1.5rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-6>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1.5rem*(1 - var(--space-x-reverse)));margin-right:calc(1.5rem*var(--space-x-reverse))}.xl\\:space-y-8>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(2rem*var(--space-y-reverse));margin-top:calc(2rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-8>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(2rem*(1 - var(--space-x-reverse)));margin-right:calc(2rem*var(--space-x-reverse))}.xl\\:space-y-10>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(2.5rem*var(--space-y-reverse));margin-top:calc(2.5rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-10>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(2.5rem*(1 - var(--space-x-reverse)));margin-right:calc(2.5rem*var(--space-x-reverse))}.xl\\:space-y-12>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(3rem*var(--space-y-reverse));margin-top:calc(3rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-12>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(3rem*(1 - var(--space-x-reverse)));margin-right:calc(3rem*var(--space-x-reverse))}.xl\\:space-y-16>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(4rem*var(--space-y-reverse));margin-top:calc(4rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-16>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(4rem*(1 - var(--space-x-reverse)));margin-right:calc(4rem*var(--space-x-reverse))}.xl\\:space-y-20>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(5rem*var(--space-y-reverse));margin-top:calc(5rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-20>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(5rem*(1 - var(--space-x-reverse)));margin-right:calc(5rem*var(--space-x-reverse))}.xl\\:space-y-24>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(6rem*var(--space-y-reverse));margin-top:calc(6rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-24>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(6rem*(1 - var(--space-x-reverse)));margin-right:calc(6rem*var(--space-x-reverse))}.xl\\:space-y-32>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(8rem*var(--space-y-reverse));margin-top:calc(8rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-32>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(8rem*(1 - var(--space-x-reverse)));margin-right:calc(8rem*var(--space-x-reverse))}.xl\\:space-y-40>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(10rem*var(--space-y-reverse));margin-top:calc(10rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-40>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(10rem*(1 - var(--space-x-reverse)));margin-right:calc(10rem*var(--space-x-reverse))}.xl\\:space-y-48>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(12rem*var(--space-y-reverse));margin-top:calc(12rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-48>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(12rem*(1 - var(--space-x-reverse)));margin-right:calc(12rem*var(--space-x-reverse))}.xl\\:space-y-56>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(14rem*var(--space-y-reverse));margin-top:calc(14rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-56>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(14rem*(1 - var(--space-x-reverse)));margin-right:calc(14rem*var(--space-x-reverse))}.xl\\:space-y-64>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(16rem*var(--space-y-reverse));margin-top:calc(16rem*(1 - var(--space-y-reverse)))}.xl\\:space-x-64>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(16rem*(1 - var(--space-x-reverse)));margin-right:calc(16rem*var(--space-x-reverse))}.xl\\:space-y-px>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(1px*var(--space-y-reverse));margin-top:calc(1px*(1 - var(--space-y-reverse)))}.xl\\:space-x-px>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(1px*(1 - var(--space-x-reverse)));margin-right:calc(1px*var(--space-x-reverse))}.xl\\:-space-y-1>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-.25rem*var(--space-y-reverse));margin-top:calc(-.25rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-1>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-.25rem*(1 - var(--space-x-reverse)));margin-right:calc(-.25rem*var(--space-x-reverse))}.xl\\:-space-y-2>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-.5rem*var(--space-y-reverse));margin-top:calc(-.5rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-2>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-.5rem*(1 - var(--space-x-reverse)));margin-right:calc(-.5rem*var(--space-x-reverse))}.xl\\:-space-y-3>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-.75rem*var(--space-y-reverse));margin-top:calc(-.75rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-3>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-.75rem*(1 - var(--space-x-reverse)));margin-right:calc(-.75rem*var(--space-x-reverse))}.xl\\:-space-y-4>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1rem*var(--space-y-reverse));margin-top:calc(-1rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-4>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1rem*(1 - var(--space-x-reverse)));margin-right:calc(-1rem*var(--space-x-reverse))}.xl\\:-space-y-5>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1.25rem*var(--space-y-reverse));margin-top:calc(-1.25rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-5>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1.25rem*(1 - var(--space-x-reverse)));margin-right:calc(-1.25rem*var(--space-x-reverse))}.xl\\:-space-y-6>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1.5rem*var(--space-y-reverse));margin-top:calc(-1.5rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-6>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1.5rem*(1 - var(--space-x-reverse)));margin-right:calc(-1.5rem*var(--space-x-reverse))}.xl\\:-space-y-8>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-2rem*var(--space-y-reverse));margin-top:calc(-2rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-8>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-2rem*(1 - var(--space-x-reverse)));margin-right:calc(-2rem*var(--space-x-reverse))}.xl\\:-space-y-10>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-2.5rem*var(--space-y-reverse));margin-top:calc(-2.5rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-10>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-2.5rem*(1 - var(--space-x-reverse)));margin-right:calc(-2.5rem*var(--space-x-reverse))}.xl\\:-space-y-12>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-3rem*var(--space-y-reverse));margin-top:calc(-3rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-12>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-3rem*(1 - var(--space-x-reverse)));margin-right:calc(-3rem*var(--space-x-reverse))}.xl\\:-space-y-16>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-4rem*var(--space-y-reverse));margin-top:calc(-4rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-16>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-4rem*(1 - var(--space-x-reverse)));margin-right:calc(-4rem*var(--space-x-reverse))}.xl\\:-space-y-20>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-5rem*var(--space-y-reverse));margin-top:calc(-5rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-20>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-5rem*(1 - var(--space-x-reverse)));margin-right:calc(-5rem*var(--space-x-reverse))}.xl\\:-space-y-24>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-6rem*var(--space-y-reverse));margin-top:calc(-6rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-24>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-6rem*(1 - var(--space-x-reverse)));margin-right:calc(-6rem*var(--space-x-reverse))}.xl\\:-space-y-32>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-8rem*var(--space-y-reverse));margin-top:calc(-8rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-32>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-8rem*(1 - var(--space-x-reverse)));margin-right:calc(-8rem*var(--space-x-reverse))}.xl\\:-space-y-40>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-10rem*var(--space-y-reverse));margin-top:calc(-10rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-40>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-10rem*(1 - var(--space-x-reverse)));margin-right:calc(-10rem*var(--space-x-reverse))}.xl\\:-space-y-48>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-12rem*var(--space-y-reverse));margin-top:calc(-12rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-48>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-12rem*(1 - var(--space-x-reverse)));margin-right:calc(-12rem*var(--space-x-reverse))}.xl\\:-space-y-56>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-14rem*var(--space-y-reverse));margin-top:calc(-14rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-56>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-14rem*(1 - var(--space-x-reverse)));margin-right:calc(-14rem*var(--space-x-reverse))}.xl\\:-space-y-64>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-16rem*var(--space-y-reverse));margin-top:calc(-16rem*(1 - var(--space-y-reverse)))}.xl\\:-space-x-64>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-16rem*(1 - var(--space-x-reverse)));margin-right:calc(-16rem*var(--space-x-reverse))}.xl\\:-space-y-px>:not(template)~:not(template){--space-y-reverse:0;margin-bottom:calc(-1px*var(--space-y-reverse));margin-top:calc(-1px*(1 - var(--space-y-reverse)))}.xl\\:-space-x-px>:not(template)~:not(template){--space-x-reverse:0;margin-left:calc(-1px*(1 - var(--space-x-reverse)));margin-right:calc(-1px*var(--space-x-reverse))}.xl\\:space-y-reverse>:not(template)~:not(template){--space-y-reverse:1}.xl\\:space-x-reverse>:not(template)~:not(template){--space-x-reverse:1}.xl\\:divide-y-0>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(0px*var(--divide-y-reverse));border-top-width:calc(0px*(1 - var(--divide-y-reverse)))}.xl\\:divide-x-0>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(0px*(1 - var(--divide-x-reverse)));border-right-width:calc(0px*var(--divide-x-reverse))}.xl\\:divide-y-2>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(2px*var(--divide-y-reverse));border-top-width:calc(2px*(1 - var(--divide-y-reverse)))}.xl\\:divide-x-2>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(2px*(1 - var(--divide-x-reverse)));border-right-width:calc(2px*var(--divide-x-reverse))}.xl\\:divide-y-4>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(4px*var(--divide-y-reverse));border-top-width:calc(4px*(1 - var(--divide-y-reverse)))}.xl\\:divide-x-4>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(4px*(1 - var(--divide-x-reverse)));border-right-width:calc(4px*var(--divide-x-reverse))}.xl\\:divide-y-8>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(8px*var(--divide-y-reverse));border-top-width:calc(8px*(1 - var(--divide-y-reverse)))}.xl\\:divide-x-8>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(8px*(1 - var(--divide-x-reverse)));border-right-width:calc(8px*var(--divide-x-reverse))}.xl\\:divide-y>:not(template)~:not(template){--divide-y-reverse:0;border-bottom-width:calc(1px*var(--divide-y-reverse));border-top-width:calc(1px*(1 - var(--divide-y-reverse)))}.xl\\:divide-x>:not(template)~:not(template){--divide-x-reverse:0;border-left-width:calc(1px*(1 - var(--divide-x-reverse)));border-right-width:calc(1px*var(--divide-x-reverse))}.xl\\:divide-y-reverse>:not(template)~:not(template){--divide-y-reverse:1}.xl\\:divide-x-reverse>:not(template)~:not(template){--divide-x-reverse:1}.xl\\:divide-transparent>:not(template)~:not(template){border-color:#0000}.xl\\:divide-white>:not(template)~:not(template){--divide-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--divide-opacity))}.xl\\:divide-black>:not(template)~:not(template){--divide-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--divide-opacity))}.xl\\:divide-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--divide-opacity))}.xl\\:divide-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--divide-opacity))}.xl\\:divide-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--divide-opacity))}.xl\\:divide-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--divide-opacity))}.xl\\:divide-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--divide-opacity))}.xl\\:divide-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--divide-opacity))}.xl\\:divide-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--divide-opacity))}.xl\\:divide-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--divide-opacity))}.xl\\:divide-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--divide-opacity))}.xl\\:divide-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--divide-opacity))}.xl\\:divide-cool-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--divide-opacity))}.xl\\:divide-cool-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--divide-opacity))}.xl\\:divide-cool-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--divide-opacity))}.xl\\:divide-cool-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--divide-opacity))}.xl\\:divide-cool-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--divide-opacity))}.xl\\:divide-cool-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--divide-opacity))}.xl\\:divide-cool-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--divide-opacity))}.xl\\:divide-cool-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--divide-opacity))}.xl\\:divide-cool-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--divide-opacity))}.xl\\:divide-cool-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--divide-opacity))}.xl\\:divide-red-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--divide-opacity))}.xl\\:divide-red-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--divide-opacity))}.xl\\:divide-red-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--divide-opacity))}.xl\\:divide-red-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--divide-opacity))}.xl\\:divide-red-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--divide-opacity))}.xl\\:divide-red-500>:not(template)~:not(template){--divide-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--divide-opacity))}.xl\\:divide-red-600>:not(template)~:not(template){--divide-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--divide-opacity))}.xl\\:divide-red-700>:not(template)~:not(template){--divide-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--divide-opacity))}.xl\\:divide-red-800>:not(template)~:not(template){--divide-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--divide-opacity))}.xl\\:divide-red-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.xl\\:divide-orange-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--divide-opacity))}.xl\\:divide-orange-100>:not(template)~:not(template){--divide-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--divide-opacity))}.xl\\:divide-orange-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--divide-opacity))}.xl\\:divide-orange-300>:not(template)~:not(template){--divide-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--divide-opacity))}.xl\\:divide-orange-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--divide-opacity))}.xl\\:divide-orange-500>:not(template)~:not(template){--divide-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--divide-opacity))}.xl\\:divide-orange-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--divide-opacity))}.xl\\:divide-orange-700>:not(template)~:not(template){--divide-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--divide-opacity))}.xl\\:divide-orange-800>:not(template)~:not(template){--divide-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--divide-opacity))}.xl\\:divide-orange-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.xl\\:divide-yellow-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--divide-opacity))}.xl\\:divide-yellow-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--divide-opacity))}.xl\\:divide-yellow-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--divide-opacity))}.xl\\:divide-yellow-300>:not(template)~:not(template){--divide-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--divide-opacity))}.xl\\:divide-yellow-400>:not(template)~:not(template){--divide-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--divide-opacity))}.xl\\:divide-yellow-500>:not(template)~:not(template){--divide-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--divide-opacity))}.xl\\:divide-yellow-600>:not(template)~:not(template){--divide-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--divide-opacity))}.xl\\:divide-yellow-700>:not(template)~:not(template){--divide-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--divide-opacity))}.xl\\:divide-yellow-800>:not(template)~:not(template){--divide-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--divide-opacity))}.xl\\:divide-yellow-900>:not(template)~:not(template){--divide-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--divide-opacity))}.xl\\:divide-green-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--divide-opacity))}.xl\\:divide-green-100>:not(template)~:not(template){--divide-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--divide-opacity))}.xl\\:divide-green-200>:not(template)~:not(template){--divide-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--divide-opacity))}.xl\\:divide-green-300>:not(template)~:not(template){--divide-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--divide-opacity))}.xl\\:divide-green-400>:not(template)~:not(template){--divide-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--divide-opacity))}.xl\\:divide-green-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--divide-opacity))}.xl\\:divide-green-600>:not(template)~:not(template){--divide-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--divide-opacity))}.xl\\:divide-green-700>:not(template)~:not(template){--divide-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--divide-opacity))}.xl\\:divide-green-800>:not(template)~:not(template){--divide-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--divide-opacity))}.xl\\:divide-green-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--divide-opacity))}.xl\\:divide-teal-50>:not(template)~:not(template){--divide-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--divide-opacity))}.xl\\:divide-teal-100>:not(template)~:not(template){--divide-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--divide-opacity))}.xl\\:divide-teal-200>:not(template)~:not(template){--divide-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--divide-opacity))}.xl\\:divide-teal-300>:not(template)~:not(template){--divide-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--divide-opacity))}.xl\\:divide-teal-400>:not(template)~:not(template){--divide-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--divide-opacity))}.xl\\:divide-teal-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--divide-opacity))}.xl\\:divide-teal-600>:not(template)~:not(template){--divide-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--divide-opacity))}.xl\\:divide-teal-700>:not(template)~:not(template){--divide-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--divide-opacity))}.xl\\:divide-teal-800>:not(template)~:not(template){--divide-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--divide-opacity))}.xl\\:divide-teal-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--divide-opacity))}.xl\\:divide-blue-50>:not(template)~:not(template){--divide-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--divide-opacity))}.xl\\:divide-blue-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--divide-opacity))}.xl\\:divide-blue-200>:not(template)~:not(template){--divide-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--divide-opacity))}.xl\\:divide-blue-300>:not(template)~:not(template){--divide-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--divide-opacity))}.xl\\:divide-blue-400>:not(template)~:not(template){--divide-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--divide-opacity))}.xl\\:divide-blue-500>:not(template)~:not(template){--divide-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--divide-opacity))}.xl\\:divide-blue-600>:not(template)~:not(template){--divide-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--divide-opacity))}.xl\\:divide-blue-700>:not(template)~:not(template){--divide-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--divide-opacity))}.xl\\:divide-blue-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--divide-opacity))}.xl\\:divide-blue-900>:not(template)~:not(template){--divide-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--divide-opacity))}.xl\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--divide-opacity))}.xl\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--divide-opacity))}.xl\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--divide-opacity))}.xl\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--divide-opacity))}.xl\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--divide-opacity))}.xl\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--divide-opacity))}.xl\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--divide-opacity))}.xl\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--divide-opacity))}.xl\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--divide-opacity))}.xl\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--divide-opacity))}.xl\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--divide-opacity))}.xl\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--divide-opacity))}.xl\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--divide-opacity))}.xl\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--divide-opacity))}.xl\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--divide-opacity))}.xl\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--divide-opacity))}.xl\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--divide-opacity))}.xl\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--divide-opacity))}.xl\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--divide-opacity))}.xl\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--divide-opacity))}.xl\\:divide-pink-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--divide-opacity))}.xl\\:divide-pink-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--divide-opacity))}.xl\\:divide-pink-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--divide-opacity))}.xl\\:divide-pink-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--divide-opacity))}.xl\\:divide-pink-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--divide-opacity))}.xl\\:divide-pink-500>:not(template)~:not(template){--divide-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--divide-opacity))}.xl\\:divide-pink-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--divide-opacity))}.xl\\:divide-pink-700>:not(template)~:not(template){--divide-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--divide-opacity))}.xl\\:divide-pink-800>:not(template)~:not(template){--divide-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--divide-opacity))}.xl\\:divide-pink-900>:not(template)~:not(template){--divide-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-transparent>:not(template)~:not(template){border-color:#0000}.theme-dark .xl\\:dark\\:divide-white>:not(template)~:not(template){--divide-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-black>:not(template)~:not(template){--divide-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-cool-gray-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-cool-gray-100>:not(template)~:not(template){--divide-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-cool-gray-200>:not(template)~:not(template){--divide-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-cool-gray-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-cool-gray-400>:not(template)~:not(template){--divide-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-cool-gray-500>:not(template)~:not(template){--divide-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-cool-gray-600>:not(template)~:not(template){--divide-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-cool-gray-700>:not(template)~:not(template){--divide-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-cool-gray-800>:not(template)~:not(template){--divide-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-cool-gray-900>:not(template)~:not(template){--divide-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-red-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-red-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-red-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-red-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-red-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-red-500>:not(template)~:not(template){--divide-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-red-600>:not(template)~:not(template){--divide-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-red-700>:not(template)~:not(template){--divide-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-red-800>:not(template)~:not(template){--divide-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-red-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-orange-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-orange-100>:not(template)~:not(template){--divide-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-orange-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-orange-300>:not(template)~:not(template){--divide-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-orange-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-orange-500>:not(template)~:not(template){--divide-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-orange-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-orange-700>:not(template)~:not(template){--divide-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-orange-800>:not(template)~:not(template){--divide-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-orange-900>:not(template)~:not(template){--divide-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-yellow-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-yellow-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-yellow-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-yellow-300>:not(template)~:not(template){--divide-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-yellow-400>:not(template)~:not(template){--divide-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-yellow-500>:not(template)~:not(template){--divide-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-yellow-600>:not(template)~:not(template){--divide-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-yellow-700>:not(template)~:not(template){--divide-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-yellow-800>:not(template)~:not(template){--divide-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-yellow-900>:not(template)~:not(template){--divide-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-green-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-green-100>:not(template)~:not(template){--divide-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-green-200>:not(template)~:not(template){--divide-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-green-300>:not(template)~:not(template){--divide-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-green-400>:not(template)~:not(template){--divide-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-green-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-green-600>:not(template)~:not(template){--divide-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-green-700>:not(template)~:not(template){--divide-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-green-800>:not(template)~:not(template){--divide-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-green-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-teal-50>:not(template)~:not(template){--divide-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-teal-100>:not(template)~:not(template){--divide-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-teal-200>:not(template)~:not(template){--divide-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-teal-300>:not(template)~:not(template){--divide-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-teal-400>:not(template)~:not(template){--divide-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-teal-500>:not(template)~:not(template){--divide-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-teal-600>:not(template)~:not(template){--divide-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-teal-700>:not(template)~:not(template){--divide-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-teal-800>:not(template)~:not(template){--divide-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-teal-900>:not(template)~:not(template){--divide-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-blue-50>:not(template)~:not(template){--divide-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-blue-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-blue-200>:not(template)~:not(template){--divide-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-blue-300>:not(template)~:not(template){--divide-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-blue-400>:not(template)~:not(template){--divide-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-blue-500>:not(template)~:not(template){--divide-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-blue-600>:not(template)~:not(template){--divide-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-blue-700>:not(template)~:not(template){--divide-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-blue-800>:not(template)~:not(template){--divide-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-blue-900>:not(template)~:not(template){--divide-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-50>:not(template)~:not(template){--divide-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-100>:not(template)~:not(template){--divide-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-200>:not(template)~:not(template){--divide-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-300>:not(template)~:not(template){--divide-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-400>:not(template)~:not(template){--divide-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-500>:not(template)~:not(template){--divide-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-600>:not(template)~:not(template){--divide-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-700>:not(template)~:not(template){--divide-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-800>:not(template)~:not(template){--divide-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-indigo-900>:not(template)~:not(template){--divide-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-pink-50>:not(template)~:not(template){--divide-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-pink-100>:not(template)~:not(template){--divide-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-pink-200>:not(template)~:not(template){--divide-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-pink-300>:not(template)~:not(template){--divide-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-pink-400>:not(template)~:not(template){--divide-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-pink-500>:not(template)~:not(template){--divide-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-pink-600>:not(template)~:not(template){--divide-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-pink-700>:not(template)~:not(template){--divide-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-pink-800>:not(template)~:not(template){--divide-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--divide-opacity))}.theme-dark .xl\\:dark\\:divide-pink-900>:not(template)~:not(template){--divide-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--divide-opacity))}.xl\\:divide-opacity-0>:not(template)~:not(template){--divide-opacity:0}.xl\\:divide-opacity-25>:not(template)~:not(template){--divide-opacity:0.25}.xl\\:divide-opacity-50>:not(template)~:not(template){--divide-opacity:0.5}.xl\\:divide-opacity-75>:not(template)~:not(template){--divide-opacity:0.75}.xl\\:divide-opacity-100>:not(template)~:not(template){--divide-opacity:1}.xl\\:sr-only{height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;clip:rect(0,0,0,0);border-width:0;white-space:nowrap}.xl\\:not-sr-only{height:auto;margin:0;overflow:visible;padding:0;position:static;width:auto;clip:auto;white-space:normal}.xl\\:focus\\:sr-only:focus{height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;clip:rect(0,0,0,0);border-width:0;white-space:nowrap}.xl\\:focus\\:not-sr-only:focus{height:auto;margin:0;overflow:visible;padding:0;position:static;width:auto;clip:auto;white-space:normal}.xl\\:appearance-none{-webkit-appearance:none;appearance:none}.xl\\:bg-fixed{background-attachment:fixed}.xl\\:bg-local{background-attachment:local}.xl\\:bg-scroll{background-attachment:scroll}.xl\\:bg-transparent{background-color:initial}.xl\\:bg-white{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.xl\\:bg-black{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.xl\\:bg-gray-50{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.xl\\:bg-gray-100{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.xl\\:bg-gray-200{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.xl\\:bg-gray-300{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.xl\\:bg-gray-400{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.xl\\:bg-gray-500{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.xl\\:bg-gray-600{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.xl\\:bg-gray-700{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.xl\\:bg-gray-800{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.xl\\:bg-gray-900{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.xl\\:bg-cool-gray-50{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.xl\\:bg-cool-gray-100{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.xl\\:bg-cool-gray-200{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.xl\\:bg-cool-gray-300{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.xl\\:bg-cool-gray-400{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.xl\\:bg-cool-gray-500{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.xl\\:bg-cool-gray-600{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.xl\\:bg-cool-gray-700{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.xl\\:bg-cool-gray-800{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.xl\\:bg-cool-gray-900{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.xl\\:bg-red-50{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.xl\\:bg-red-100{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.xl\\:bg-red-200{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.xl\\:bg-red-300{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.xl\\:bg-red-400{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.xl\\:bg-red-500{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.xl\\:bg-red-600{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.xl\\:bg-red-700{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.xl\\:bg-red-800{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.xl\\:bg-red-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.xl\\:bg-orange-50{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.xl\\:bg-orange-100{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.xl\\:bg-orange-200{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.xl\\:bg-orange-300{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.xl\\:bg-orange-400{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.xl\\:bg-orange-500{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.xl\\:bg-orange-600{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.xl\\:bg-orange-700{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.xl\\:bg-orange-800{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.xl\\:bg-orange-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.xl\\:bg-yellow-50{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.xl\\:bg-yellow-100{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.xl\\:bg-yellow-200{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.xl\\:bg-yellow-300{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.xl\\:bg-yellow-400{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.xl\\:bg-yellow-500{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.xl\\:bg-yellow-600{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.xl\\:bg-yellow-700{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.xl\\:bg-yellow-800{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.xl\\:bg-yellow-900{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.xl\\:bg-green-50{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.xl\\:bg-green-100{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.xl\\:bg-green-200{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.xl\\:bg-green-300{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.xl\\:bg-green-400{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.xl\\:bg-green-500{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.xl\\:bg-green-600{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.xl\\:bg-green-700{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.xl\\:bg-green-800{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.xl\\:bg-green-900{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.xl\\:bg-teal-50{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.xl\\:bg-teal-100{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.xl\\:bg-teal-200{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.xl\\:bg-teal-300{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.xl\\:bg-teal-400{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.xl\\:bg-teal-500{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.xl\\:bg-teal-600{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.xl\\:bg-teal-700{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.xl\\:bg-teal-800{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.xl\\:bg-teal-900{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.xl\\:bg-blue-50{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.xl\\:bg-blue-100{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.xl\\:bg-blue-200{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.xl\\:bg-blue-300{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.xl\\:bg-blue-400{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.xl\\:bg-blue-500{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.xl\\:bg-blue-600{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.xl\\:bg-blue-700{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.xl\\:bg-blue-800{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.xl\\:bg-blue-900{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.xl\\:bg-indigo-50{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.xl\\:bg-indigo-100{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.xl\\:bg-indigo-200{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.xl\\:bg-indigo-300{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.xl\\:bg-indigo-400{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.xl\\:bg-indigo-500{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.xl\\:bg-indigo-600{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.xl\\:bg-indigo-700{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.xl\\:bg-indigo-800{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.xl\\:bg-indigo-900{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.xl\\:bg-indigo-50{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.xl\\:bg-indigo-100{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.xl\\:bg-indigo-200{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.xl\\:bg-indigo-300{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.xl\\:bg-indigo-400{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.xl\\:bg-indigo-500{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.xl\\:bg-indigo-600{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.xl\\:bg-indigo-700{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.xl\\:bg-indigo-800{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.xl\\:bg-indigo-900{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.xl\\:bg-pink-50{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.xl\\:bg-pink-100{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.xl\\:bg-pink-200{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.xl\\:bg-pink-300{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.xl\\:bg-pink-400{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.xl\\:bg-pink-500{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.xl\\:bg-pink-600{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.xl\\:bg-pink-700{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.xl\\:bg-pink-800{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.xl\\:bg-pink-900{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.xl\\:hover\\:bg-transparent:hover{background-color:initial}.xl\\:hover\\:bg-white:hover{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.xl\\:hover\\:bg-black:hover{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.xl\\:hover\\:bg-gray-50:hover{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.xl\\:hover\\:bg-gray-100:hover{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.xl\\:hover\\:bg-gray-200:hover{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.xl\\:hover\\:bg-gray-300:hover{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.xl\\:hover\\:bg-gray-400:hover{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.xl\\:hover\\:bg-gray-500:hover{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.xl\\:hover\\:bg-gray-600:hover{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.xl\\:hover\\:bg-gray-700:hover{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.xl\\:hover\\:bg-gray-800:hover{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.xl\\:hover\\:bg-gray-900:hover{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.xl\\:hover\\:bg-cool-gray-50:hover{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.xl\\:hover\\:bg-cool-gray-100:hover{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.xl\\:hover\\:bg-cool-gray-200:hover{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.xl\\:hover\\:bg-cool-gray-300:hover{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.xl\\:hover\\:bg-cool-gray-400:hover{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.xl\\:hover\\:bg-cool-gray-500:hover{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.xl\\:hover\\:bg-cool-gray-600:hover{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.xl\\:hover\\:bg-cool-gray-700:hover{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.xl\\:hover\\:bg-cool-gray-800:hover{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.xl\\:hover\\:bg-cool-gray-900:hover{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.xl\\:hover\\:bg-red-50:hover{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.xl\\:hover\\:bg-red-100:hover{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.xl\\:hover\\:bg-red-200:hover{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.xl\\:hover\\:bg-red-300:hover{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.xl\\:hover\\:bg-red-400:hover{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.xl\\:hover\\:bg-red-500:hover{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.xl\\:hover\\:bg-red-600:hover{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.xl\\:hover\\:bg-red-700:hover{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.xl\\:hover\\:bg-red-800:hover{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.xl\\:hover\\:bg-red-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.xl\\:hover\\:bg-orange-50:hover{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.xl\\:hover\\:bg-orange-100:hover{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.xl\\:hover\\:bg-orange-200:hover{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.xl\\:hover\\:bg-orange-300:hover{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.xl\\:hover\\:bg-orange-400:hover{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.xl\\:hover\\:bg-orange-500:hover{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.xl\\:hover\\:bg-orange-600:hover{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.xl\\:hover\\:bg-orange-700:hover{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.xl\\:hover\\:bg-orange-800:hover{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.xl\\:hover\\:bg-orange-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.xl\\:hover\\:bg-yellow-50:hover{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.xl\\:hover\\:bg-yellow-100:hover{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.xl\\:hover\\:bg-yellow-200:hover{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.xl\\:hover\\:bg-yellow-300:hover{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.xl\\:hover\\:bg-yellow-400:hover{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.xl\\:hover\\:bg-yellow-500:hover{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.xl\\:hover\\:bg-yellow-600:hover{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.xl\\:hover\\:bg-yellow-700:hover{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.xl\\:hover\\:bg-yellow-800:hover{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.xl\\:hover\\:bg-yellow-900:hover{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.xl\\:hover\\:bg-green-50:hover{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.xl\\:hover\\:bg-green-100:hover{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.xl\\:hover\\:bg-green-200:hover{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.xl\\:hover\\:bg-green-300:hover{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.xl\\:hover\\:bg-green-400:hover{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.xl\\:hover\\:bg-green-500:hover{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.xl\\:hover\\:bg-green-600:hover{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.xl\\:hover\\:bg-green-700:hover{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.xl\\:hover\\:bg-green-800:hover{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.xl\\:hover\\:bg-green-900:hover{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.xl\\:hover\\:bg-teal-50:hover{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.xl\\:hover\\:bg-teal-100:hover{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.xl\\:hover\\:bg-teal-200:hover{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.xl\\:hover\\:bg-teal-300:hover{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.xl\\:hover\\:bg-teal-400:hover{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.xl\\:hover\\:bg-teal-500:hover{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.xl\\:hover\\:bg-teal-600:hover{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.xl\\:hover\\:bg-teal-700:hover{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.xl\\:hover\\:bg-teal-800:hover{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.xl\\:hover\\:bg-teal-900:hover{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.xl\\:hover\\:bg-blue-50:hover{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.xl\\:hover\\:bg-blue-100:hover{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.xl\\:hover\\:bg-blue-200:hover{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.xl\\:hover\\:bg-blue-300:hover{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.xl\\:hover\\:bg-blue-400:hover{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.xl\\:hover\\:bg-blue-500:hover{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.xl\\:hover\\:bg-blue-600:hover{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.xl\\:hover\\:bg-blue-700:hover{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.xl\\:hover\\:bg-blue-800:hover{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.xl\\:hover\\:bg-blue-900:hover{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.xl\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.xl\\:hover\\:bg-pink-50:hover{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.xl\\:hover\\:bg-pink-100:hover{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.xl\\:hover\\:bg-pink-200:hover{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.xl\\:hover\\:bg-pink-300:hover{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.xl\\:hover\\:bg-pink-400:hover{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.xl\\:hover\\:bg-pink-500:hover{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.xl\\:hover\\:bg-pink-600:hover{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.xl\\:hover\\:bg-pink-700:hover{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.xl\\:hover\\:bg-pink-800:hover{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.xl\\:hover\\:bg-pink-900:hover{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.xl\\:focus\\:bg-transparent:focus{background-color:initial}.xl\\:focus\\:bg-white:focus{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.xl\\:focus\\:bg-black:focus{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.xl\\:focus\\:bg-gray-50:focus{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.xl\\:focus\\:bg-gray-100:focus{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.xl\\:focus\\:bg-gray-200:focus{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.xl\\:focus\\:bg-gray-300:focus{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.xl\\:focus\\:bg-gray-400:focus{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.xl\\:focus\\:bg-gray-500:focus{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.xl\\:focus\\:bg-gray-600:focus{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.xl\\:focus\\:bg-gray-700:focus{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.xl\\:focus\\:bg-gray-800:focus{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.xl\\:focus\\:bg-gray-900:focus{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.xl\\:focus\\:bg-cool-gray-50:focus{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.xl\\:focus\\:bg-cool-gray-100:focus{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.xl\\:focus\\:bg-cool-gray-200:focus{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.xl\\:focus\\:bg-cool-gray-300:focus{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.xl\\:focus\\:bg-cool-gray-400:focus{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.xl\\:focus\\:bg-cool-gray-500:focus{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.xl\\:focus\\:bg-cool-gray-600:focus{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.xl\\:focus\\:bg-cool-gray-700:focus{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.xl\\:focus\\:bg-cool-gray-800:focus{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.xl\\:focus\\:bg-cool-gray-900:focus{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.xl\\:focus\\:bg-red-50:focus{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.xl\\:focus\\:bg-red-100:focus{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.xl\\:focus\\:bg-red-200:focus{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.xl\\:focus\\:bg-red-300:focus{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.xl\\:focus\\:bg-red-400:focus{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.xl\\:focus\\:bg-red-500:focus{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.xl\\:focus\\:bg-red-600:focus{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.xl\\:focus\\:bg-red-700:focus{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.xl\\:focus\\:bg-red-800:focus{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.xl\\:focus\\:bg-red-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.xl\\:focus\\:bg-orange-50:focus{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.xl\\:focus\\:bg-orange-100:focus{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.xl\\:focus\\:bg-orange-200:focus{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.xl\\:focus\\:bg-orange-300:focus{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.xl\\:focus\\:bg-orange-400:focus{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.xl\\:focus\\:bg-orange-500:focus{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.xl\\:focus\\:bg-orange-600:focus{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.xl\\:focus\\:bg-orange-700:focus{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.xl\\:focus\\:bg-orange-800:focus{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.xl\\:focus\\:bg-orange-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.xl\\:focus\\:bg-yellow-50:focus{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.xl\\:focus\\:bg-yellow-100:focus{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.xl\\:focus\\:bg-yellow-200:focus{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.xl\\:focus\\:bg-yellow-300:focus{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.xl\\:focus\\:bg-yellow-400:focus{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.xl\\:focus\\:bg-yellow-500:focus{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.xl\\:focus\\:bg-yellow-600:focus{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.xl\\:focus\\:bg-yellow-700:focus{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.xl\\:focus\\:bg-yellow-800:focus{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.xl\\:focus\\:bg-yellow-900:focus{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.xl\\:focus\\:bg-green-50:focus{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.xl\\:focus\\:bg-green-100:focus{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.xl\\:focus\\:bg-green-200:focus{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.xl\\:focus\\:bg-green-300:focus{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.xl\\:focus\\:bg-green-400:focus{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.xl\\:focus\\:bg-green-500:focus{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.xl\\:focus\\:bg-green-600:focus{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.xl\\:focus\\:bg-green-700:focus{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.xl\\:focus\\:bg-green-800:focus{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.xl\\:focus\\:bg-green-900:focus{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.xl\\:focus\\:bg-teal-50:focus{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.xl\\:focus\\:bg-teal-100:focus{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.xl\\:focus\\:bg-teal-200:focus{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.xl\\:focus\\:bg-teal-300:focus{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.xl\\:focus\\:bg-teal-400:focus{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.xl\\:focus\\:bg-teal-500:focus{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.xl\\:focus\\:bg-teal-600:focus{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.xl\\:focus\\:bg-teal-700:focus{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.xl\\:focus\\:bg-teal-800:focus{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.xl\\:focus\\:bg-teal-900:focus{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.xl\\:focus\\:bg-blue-50:focus{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.xl\\:focus\\:bg-blue-100:focus{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.xl\\:focus\\:bg-blue-200:focus{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.xl\\:focus\\:bg-blue-300:focus{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.xl\\:focus\\:bg-blue-400:focus{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.xl\\:focus\\:bg-blue-500:focus{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.xl\\:focus\\:bg-blue-600:focus{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.xl\\:focus\\:bg-blue-700:focus{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.xl\\:focus\\:bg-blue-800:focus{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.xl\\:focus\\:bg-blue-900:focus{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.xl\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.xl\\:focus\\:bg-pink-50:focus{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.xl\\:focus\\:bg-pink-100:focus{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.xl\\:focus\\:bg-pink-200:focus{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.xl\\:focus\\:bg-pink-300:focus{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.xl\\:focus\\:bg-pink-400:focus{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.xl\\:focus\\:bg-pink-500:focus{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.xl\\:focus\\:bg-pink-600:focus{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.xl\\:focus\\:bg-pink-700:focus{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.xl\\:focus\\:bg-pink-800:focus{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.xl\\:focus\\:bg-pink-900:focus{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.xl\\:active\\:bg-transparent:active{background-color:initial}.xl\\:active\\:bg-white:active{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.xl\\:active\\:bg-black:active{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.xl\\:active\\:bg-gray-50:active{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.xl\\:active\\:bg-gray-100:active{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.xl\\:active\\:bg-gray-200:active{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.xl\\:active\\:bg-gray-300:active{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.xl\\:active\\:bg-gray-400:active{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.xl\\:active\\:bg-gray-500:active{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.xl\\:active\\:bg-gray-600:active{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.xl\\:active\\:bg-gray-700:active{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.xl\\:active\\:bg-gray-800:active{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.xl\\:active\\:bg-gray-900:active{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.xl\\:active\\:bg-cool-gray-50:active{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.xl\\:active\\:bg-cool-gray-100:active{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.xl\\:active\\:bg-cool-gray-200:active{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.xl\\:active\\:bg-cool-gray-300:active{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.xl\\:active\\:bg-cool-gray-400:active{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.xl\\:active\\:bg-cool-gray-500:active{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.xl\\:active\\:bg-cool-gray-600:active{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.xl\\:active\\:bg-cool-gray-700:active{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.xl\\:active\\:bg-cool-gray-800:active{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.xl\\:active\\:bg-cool-gray-900:active{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.xl\\:active\\:bg-red-50:active{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.xl\\:active\\:bg-red-100:active{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.xl\\:active\\:bg-red-200:active{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.xl\\:active\\:bg-red-300:active{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.xl\\:active\\:bg-red-400:active{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.xl\\:active\\:bg-red-500:active{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.xl\\:active\\:bg-red-600:active{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.xl\\:active\\:bg-red-700:active{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.xl\\:active\\:bg-red-800:active{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.xl\\:active\\:bg-red-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.xl\\:active\\:bg-orange-50:active{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.xl\\:active\\:bg-orange-100:active{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.xl\\:active\\:bg-orange-200:active{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.xl\\:active\\:bg-orange-300:active{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.xl\\:active\\:bg-orange-400:active{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.xl\\:active\\:bg-orange-500:active{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.xl\\:active\\:bg-orange-600:active{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.xl\\:active\\:bg-orange-700:active{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.xl\\:active\\:bg-orange-800:active{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.xl\\:active\\:bg-orange-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.xl\\:active\\:bg-yellow-50:active{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.xl\\:active\\:bg-yellow-100:active{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.xl\\:active\\:bg-yellow-200:active{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.xl\\:active\\:bg-yellow-300:active{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.xl\\:active\\:bg-yellow-400:active{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.xl\\:active\\:bg-yellow-500:active{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.xl\\:active\\:bg-yellow-600:active{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.xl\\:active\\:bg-yellow-700:active{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.xl\\:active\\:bg-yellow-800:active{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.xl\\:active\\:bg-yellow-900:active{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.xl\\:active\\:bg-green-50:active{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.xl\\:active\\:bg-green-100:active{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.xl\\:active\\:bg-green-200:active{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.xl\\:active\\:bg-green-300:active{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.xl\\:active\\:bg-green-400:active{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.xl\\:active\\:bg-green-500:active{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.xl\\:active\\:bg-green-600:active{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.xl\\:active\\:bg-green-700:active{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.xl\\:active\\:bg-green-800:active{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.xl\\:active\\:bg-green-900:active{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.xl\\:active\\:bg-teal-50:active{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.xl\\:active\\:bg-teal-100:active{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.xl\\:active\\:bg-teal-200:active{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.xl\\:active\\:bg-teal-300:active{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.xl\\:active\\:bg-teal-400:active{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.xl\\:active\\:bg-teal-500:active{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.xl\\:active\\:bg-teal-600:active{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.xl\\:active\\:bg-teal-700:active{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.xl\\:active\\:bg-teal-800:active{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.xl\\:active\\:bg-teal-900:active{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.xl\\:active\\:bg-blue-50:active{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.xl\\:active\\:bg-blue-100:active{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.xl\\:active\\:bg-blue-200:active{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.xl\\:active\\:bg-blue-300:active{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.xl\\:active\\:bg-blue-400:active{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.xl\\:active\\:bg-blue-500:active{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.xl\\:active\\:bg-blue-600:active{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.xl\\:active\\:bg-blue-700:active{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.xl\\:active\\:bg-blue-800:active{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.xl\\:active\\:bg-blue-900:active{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.xl\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.xl\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.xl\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.xl\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.xl\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.xl\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.xl\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.xl\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.xl\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.xl\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.xl\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.xl\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.xl\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.xl\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.xl\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.xl\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.xl\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.xl\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.xl\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.xl\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.xl\\:active\\:bg-pink-50:active{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.xl\\:active\\:bg-pink-100:active{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.xl\\:active\\:bg-pink-200:active{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.xl\\:active\\:bg-pink-300:active{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.xl\\:active\\:bg-pink-400:active{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.xl\\:active\\:bg-pink-500:active{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.xl\\:active\\:bg-pink-600:active{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.xl\\:active\\:bg-pink-700:active{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.xl\\:active\\:bg-pink-800:active{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.xl\\:active\\:bg-pink-900:active{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.xl\\:odd\\:bg-transparent:nth-child(odd){background-color:initial}.xl\\:odd\\:bg-white:nth-child(odd){--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.xl\\:odd\\:bg-black:nth-child(odd){--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.xl\\:odd\\:bg-gray-50:nth-child(odd){--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.xl\\:odd\\:bg-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.xl\\:odd\\:bg-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.xl\\:odd\\:bg-gray-300:nth-child(odd){--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.xl\\:odd\\:bg-gray-400:nth-child(odd){--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.xl\\:odd\\:bg-gray-500:nth-child(odd){--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.xl\\:odd\\:bg-gray-600:nth-child(odd){--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.xl\\:odd\\:bg-gray-700:nth-child(odd){--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.xl\\:odd\\:bg-gray-800:nth-child(odd){--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.xl\\:odd\\:bg-gray-900:nth-child(odd){--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.xl\\:odd\\:bg-cool-gray-50:nth-child(odd){--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.xl\\:odd\\:bg-cool-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.xl\\:odd\\:bg-cool-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.xl\\:odd\\:bg-cool-gray-300:nth-child(odd){--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.xl\\:odd\\:bg-cool-gray-400:nth-child(odd){--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.xl\\:odd\\:bg-cool-gray-500:nth-child(odd){--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.xl\\:odd\\:bg-cool-gray-600:nth-child(odd){--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.xl\\:odd\\:bg-cool-gray-700:nth-child(odd){--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.xl\\:odd\\:bg-cool-gray-800:nth-child(odd){--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.xl\\:odd\\:bg-cool-gray-900:nth-child(odd){--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.xl\\:odd\\:bg-red-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.xl\\:odd\\:bg-red-100:nth-child(odd){--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.xl\\:odd\\:bg-red-200:nth-child(odd){--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.xl\\:odd\\:bg-red-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.xl\\:odd\\:bg-red-400:nth-child(odd){--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.xl\\:odd\\:bg-red-500:nth-child(odd){--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.xl\\:odd\\:bg-red-600:nth-child(odd){--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.xl\\:odd\\:bg-red-700:nth-child(odd){--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.xl\\:odd\\:bg-red-800:nth-child(odd){--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.xl\\:odd\\:bg-red-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.xl\\:odd\\:bg-orange-50:nth-child(odd){--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.xl\\:odd\\:bg-orange-100:nth-child(odd){--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.xl\\:odd\\:bg-orange-200:nth-child(odd){--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.xl\\:odd\\:bg-orange-300:nth-child(odd){--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.xl\\:odd\\:bg-orange-400:nth-child(odd){--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.xl\\:odd\\:bg-orange-500:nth-child(odd){--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.xl\\:odd\\:bg-orange-600:nth-child(odd){--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.xl\\:odd\\:bg-orange-700:nth-child(odd){--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.xl\\:odd\\:bg-orange-800:nth-child(odd){--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.xl\\:odd\\:bg-orange-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.xl\\:odd\\:bg-yellow-50:nth-child(odd){--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.xl\\:odd\\:bg-yellow-100:nth-child(odd){--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.xl\\:odd\\:bg-yellow-200:nth-child(odd){--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.xl\\:odd\\:bg-yellow-300:nth-child(odd){--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.xl\\:odd\\:bg-yellow-400:nth-child(odd){--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.xl\\:odd\\:bg-yellow-500:nth-child(odd){--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.xl\\:odd\\:bg-yellow-600:nth-child(odd){--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.xl\\:odd\\:bg-yellow-700:nth-child(odd){--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.xl\\:odd\\:bg-yellow-800:nth-child(odd){--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.xl\\:odd\\:bg-yellow-900:nth-child(odd){--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.xl\\:odd\\:bg-green-50:nth-child(odd){--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.xl\\:odd\\:bg-green-100:nth-child(odd){--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.xl\\:odd\\:bg-green-200:nth-child(odd){--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.xl\\:odd\\:bg-green-300:nth-child(odd){--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.xl\\:odd\\:bg-green-400:nth-child(odd){--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.xl\\:odd\\:bg-green-500:nth-child(odd){--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.xl\\:odd\\:bg-green-600:nth-child(odd){--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.xl\\:odd\\:bg-green-700:nth-child(odd){--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.xl\\:odd\\:bg-green-800:nth-child(odd){--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.xl\\:odd\\:bg-green-900:nth-child(odd){--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.xl\\:odd\\:bg-teal-50:nth-child(odd){--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.xl\\:odd\\:bg-teal-100:nth-child(odd){--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.xl\\:odd\\:bg-teal-200:nth-child(odd){--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.xl\\:odd\\:bg-teal-300:nth-child(odd){--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.xl\\:odd\\:bg-teal-400:nth-child(odd){--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.xl\\:odd\\:bg-teal-500:nth-child(odd){--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.xl\\:odd\\:bg-teal-600:nth-child(odd){--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.xl\\:odd\\:bg-teal-700:nth-child(odd){--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.xl\\:odd\\:bg-teal-800:nth-child(odd){--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.xl\\:odd\\:bg-teal-900:nth-child(odd){--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.xl\\:odd\\:bg-blue-50:nth-child(odd){--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.xl\\:odd\\:bg-blue-100:nth-child(odd){--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.xl\\:odd\\:bg-blue-200:nth-child(odd){--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.xl\\:odd\\:bg-blue-300:nth-child(odd){--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.xl\\:odd\\:bg-blue-400:nth-child(odd){--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.xl\\:odd\\:bg-blue-500:nth-child(odd){--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.xl\\:odd\\:bg-blue-600:nth-child(odd){--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.xl\\:odd\\:bg-blue-700:nth-child(odd){--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.xl\\:odd\\:bg-blue-800:nth-child(odd){--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.xl\\:odd\\:bg-blue-900:nth-child(odd){--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.xl\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.xl\\:odd\\:bg-pink-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.xl\\:odd\\:bg-pink-100:nth-child(odd){--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.xl\\:odd\\:bg-pink-200:nth-child(odd){--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.xl\\:odd\\:bg-pink-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.xl\\:odd\\:bg-pink-400:nth-child(odd){--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.xl\\:odd\\:bg-pink-500:nth-child(odd){--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.xl\\:odd\\:bg-pink-600:nth-child(odd){--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.xl\\:odd\\:bg-pink-700:nth-child(odd){--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.xl\\:odd\\:bg-pink-800:nth-child(odd){--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.xl\\:odd\\:bg-pink-900:nth-child(odd){--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-transparent{background-color:initial}.theme-dark .xl\\:dark\\:bg-white{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-black{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-gray-50{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-gray-100{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-gray-200{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-gray-300{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-gray-400{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-gray-500{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-gray-600{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-gray-700{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-gray-800{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-gray-900{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-cool-gray-50{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-cool-gray-100{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-cool-gray-200{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-cool-gray-300{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-cool-gray-400{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-cool-gray-500{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-cool-gray-600{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-cool-gray-700{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-cool-gray-800{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-cool-gray-900{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-red-50{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-red-100{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-red-200{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-red-300{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-red-400{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-red-500{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-red-600{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-red-700{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-red-800{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-red-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-orange-50{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-orange-100{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-orange-200{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-orange-300{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-orange-400{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-orange-500{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-orange-600{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-orange-700{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-orange-800{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-orange-900{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-yellow-50{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-yellow-100{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-yellow-200{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-yellow-300{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-yellow-400{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-yellow-500{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-yellow-600{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-yellow-700{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-yellow-800{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-yellow-900{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-green-50{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-green-100{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-green-200{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-green-300{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-green-400{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-green-500{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-green-600{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-green-700{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-green-800{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-green-900{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-teal-50{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-teal-100{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-teal-200{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-teal-300{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-teal-400{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-teal-500{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-teal-600{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-teal-700{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-teal-800{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-teal-900{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-blue-50{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-blue-100{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-blue-200{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-blue-300{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-blue-400{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-blue-500{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-blue-600{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-blue-700{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-blue-800{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-blue-900{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-50{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-100{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-200{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-300{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-400{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-500{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-600{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-700{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-800{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-900{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-50{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-100{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-200{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-300{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-400{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-500{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-600{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-700{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-800{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-indigo-900{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-pink-50{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-pink-100{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-pink-200{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-pink-300{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-pink-400{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-pink-500{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-pink-600{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-pink-700{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-pink-800{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .xl\\:dark\\:bg-pink-900{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-transparent:hover{background-color:initial}.theme-dark .xl\\:dark\\:hover\\:bg-white:hover{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-black:hover{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-gray-50:hover{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-gray-100:hover{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-gray-200:hover{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-gray-300:hover{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-gray-400:hover{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-gray-500:hover{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-gray-600:hover{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-gray-700:hover{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-gray-800:hover{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-gray-900:hover{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-50:hover{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-100:hover{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-200:hover{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-300:hover{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-400:hover{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-500:hover{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-600:hover{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-700:hover{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-800:hover{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-cool-gray-900:hover{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-red-50:hover{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-red-100:hover{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-red-200:hover{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-red-300:hover{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-red-400:hover{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-red-500:hover{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-red-600:hover{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-red-700:hover{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-red-800:hover{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-red-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-orange-50:hover{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-orange-100:hover{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-orange-200:hover{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-orange-300:hover{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-orange-400:hover{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-orange-500:hover{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-orange-600:hover{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-orange-700:hover{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-orange-800:hover{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-orange-900:hover{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-yellow-50:hover{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-yellow-100:hover{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-yellow-200:hover{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-yellow-300:hover{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-yellow-400:hover{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-yellow-500:hover{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-yellow-600:hover{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-yellow-700:hover{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-yellow-800:hover{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-yellow-900:hover{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-green-50:hover{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-green-100:hover{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-green-200:hover{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-green-300:hover{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-green-400:hover{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-green-500:hover{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-green-600:hover{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-green-700:hover{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-green-800:hover{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-green-900:hover{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-teal-50:hover{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-teal-100:hover{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-teal-200:hover{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-teal-300:hover{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-teal-400:hover{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-teal-500:hover{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-teal-600:hover{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-teal-700:hover{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-teal-800:hover{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-teal-900:hover{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-blue-50:hover{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-blue-100:hover{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-blue-200:hover{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-blue-300:hover{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-blue-400:hover{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-blue-500:hover{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-blue-600:hover{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-blue-700:hover{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-blue-800:hover{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-blue-900:hover{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-50:hover{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-100:hover{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-200:hover{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-300:hover{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-400:hover{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-500:hover{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-600:hover{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-700:hover{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-800:hover{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-indigo-900:hover{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-pink-50:hover{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-pink-100:hover{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-pink-200:hover{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-pink-300:hover{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-pink-400:hover{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-pink-500:hover{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-pink-600:hover{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-pink-700:hover{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-pink-800:hover{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .xl\\:dark\\:hover\\:bg-pink-900:hover{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-transparent:focus{background-color:initial}.theme-dark .xl\\:dark\\:focus\\:bg-white:focus{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-black:focus{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-gray-50:focus{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-gray-100:focus{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-gray-200:focus{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-gray-300:focus{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-gray-400:focus{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-gray-500:focus{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-gray-600:focus{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-gray-700:focus{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-gray-800:focus{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-gray-900:focus{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-50:focus{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-100:focus{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-200:focus{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-300:focus{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-400:focus{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-500:focus{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-600:focus{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-700:focus{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-800:focus{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-cool-gray-900:focus{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-red-50:focus{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-red-100:focus{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-red-200:focus{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-red-300:focus{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-red-400:focus{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-red-500:focus{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-red-600:focus{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-red-700:focus{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-red-800:focus{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-red-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-orange-50:focus{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-orange-100:focus{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-orange-200:focus{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-orange-300:focus{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-orange-400:focus{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-orange-500:focus{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-orange-600:focus{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-orange-700:focus{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-orange-800:focus{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-orange-900:focus{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-yellow-50:focus{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-yellow-100:focus{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-yellow-200:focus{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-yellow-300:focus{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-yellow-400:focus{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-yellow-500:focus{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-yellow-600:focus{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-yellow-700:focus{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-yellow-800:focus{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-yellow-900:focus{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-green-50:focus{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-green-100:focus{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-green-200:focus{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-green-300:focus{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-green-400:focus{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-green-500:focus{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-green-600:focus{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-green-700:focus{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-green-800:focus{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-green-900:focus{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-teal-50:focus{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-teal-100:focus{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-teal-200:focus{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-teal-300:focus{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-teal-400:focus{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-teal-500:focus{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-teal-600:focus{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-teal-700:focus{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-teal-800:focus{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-teal-900:focus{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-blue-50:focus{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-blue-100:focus{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-blue-200:focus{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-blue-300:focus{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-blue-400:focus{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-blue-500:focus{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-blue-600:focus{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-blue-700:focus{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-blue-800:focus{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-blue-900:focus{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-50:focus{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-100:focus{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-200:focus{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-300:focus{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-400:focus{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-500:focus{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-600:focus{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-700:focus{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-800:focus{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-indigo-900:focus{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-pink-50:focus{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-pink-100:focus{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-pink-200:focus{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-pink-300:focus{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-pink-400:focus{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-pink-500:focus{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-pink-600:focus{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-pink-700:focus{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-pink-800:focus{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .xl\\:dark\\:focus\\:bg-pink-900:focus{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-transparent:active{background-color:initial}.theme-dark .xl\\:dark\\:active\\:bg-white:active{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-black:active{--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-gray-50:active{--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-gray-100:active{--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-gray-200:active{--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-gray-300:active{--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-gray-400:active{--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-gray-500:active{--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-gray-600:active{--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-gray-700:active{--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-gray-800:active{--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-gray-900:active{--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-cool-gray-50:active{--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-cool-gray-100:active{--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-cool-gray-200:active{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-cool-gray-300:active{--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-cool-gray-400:active{--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-cool-gray-500:active{--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-cool-gray-600:active{--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-cool-gray-700:active{--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-cool-gray-800:active{--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-cool-gray-900:active{--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-red-50:active{--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-red-100:active{--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-red-200:active{--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-red-300:active{--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-red-400:active{--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-red-500:active{--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-red-600:active{--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-red-700:active{--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-red-800:active{--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-red-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-orange-50:active{--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-orange-100:active{--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-orange-200:active{--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-orange-300:active{--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-orange-400:active{--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-orange-500:active{--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-orange-600:active{--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-orange-700:active{--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-orange-800:active{--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-orange-900:active{--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-yellow-50:active{--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-yellow-100:active{--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-yellow-200:active{--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-yellow-300:active{--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-yellow-400:active{--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-yellow-500:active{--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-yellow-600:active{--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-yellow-700:active{--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-yellow-800:active{--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-yellow-900:active{--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-green-50:active{--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-green-100:active{--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-green-200:active{--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-green-300:active{--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-green-400:active{--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-green-500:active{--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-green-600:active{--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-green-700:active{--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-green-800:active{--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-green-900:active{--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-teal-50:active{--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-teal-100:active{--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-teal-200:active{--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-teal-300:active{--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-teal-400:active{--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-teal-500:active{--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-teal-600:active{--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-teal-700:active{--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-teal-800:active{--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-teal-900:active{--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-blue-50:active{--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-blue-100:active{--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-blue-200:active{--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-blue-300:active{--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-blue-400:active{--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-blue-500:active{--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-blue-600:active{--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-blue-700:active{--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-blue-800:active{--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-blue-900:active{--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-50:active{--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-100:active{--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-200:active{--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-300:active{--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-400:active{--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-500:active{--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-600:active{--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-700:active{--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-800:active{--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-indigo-900:active{--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-pink-50:active{--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-pink-100:active{--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-pink-200:active{--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-pink-300:active{--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-pink-400:active{--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-pink-500:active{--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-pink-600:active{--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-pink-700:active{--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-pink-800:active{--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .xl\\:dark\\:active\\:bg-pink-900:active{--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-transparent:nth-child(odd){background-color:initial}.theme-dark .xl\\:dark\\:odd\\:bg-white:nth-child(odd){--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-black:nth-child(odd){--bg-opacity:1;background-color:#000;background-color:rgba(0,0,0,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-gray-50:nth-child(odd){--bg-opacity:1;background-color:#f9fafb;background-color:rgba(249,250,251,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f4f5f7;background-color:rgba(244,245,247,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e5e7eb;background-color:rgba(229,231,235,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-gray-300:nth-child(odd){--bg-opacity:1;background-color:#d5d6d7;background-color:rgba(213,214,215,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-gray-400:nth-child(odd){--bg-opacity:1;background-color:#9e9e9e;background-color:rgba(158,158,158,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-gray-500:nth-child(odd){--bg-opacity:1;background-color:#707275;background-color:rgba(112,114,117,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-gray-600:nth-child(odd){--bg-opacity:1;background-color:#4c4f52;background-color:rgba(76,79,82,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-gray-700:nth-child(odd){--bg-opacity:1;background-color:#24262d;background-color:rgba(36,38,45,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-gray-800:nth-child(odd){--bg-opacity:1;background-color:#1a1c23;background-color:rgba(26,28,35,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-gray-900:nth-child(odd){--bg-opacity:1;background-color:#121317;background-color:rgba(18,19,23,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-50:nth-child(odd){--bg-opacity:1;background-color:#fbfdfe;background-color:rgba(251,253,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-100:nth-child(odd){--bg-opacity:1;background-color:#f1f5f9;background-color:rgba(241,245,249,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-200:nth-child(odd){--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-300:nth-child(odd){--bg-opacity:1;background-color:#cfd8e3;background-color:rgba(207,216,227,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-400:nth-child(odd){--bg-opacity:1;background-color:#97a6ba;background-color:rgba(151,166,186,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-500:nth-child(odd){--bg-opacity:1;background-color:#64748b;background-color:rgba(100,116,139,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-600:nth-child(odd){--bg-opacity:1;background-color:#475569;background-color:rgba(71,85,105,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-700:nth-child(odd){--bg-opacity:1;background-color:#364152;background-color:rgba(54,65,82,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-800:nth-child(odd){--bg-opacity:1;background-color:#27303f;background-color:rgba(39,48,63,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-cool-gray-900:nth-child(odd){--bg-opacity:1;background-color:#1a202e;background-color:rgba(26,32,46,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-red-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f2;background-color:rgba(253,242,242,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-red-100:nth-child(odd){--bg-opacity:1;background-color:#fde8e8;background-color:rgba(253,232,232,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-red-200:nth-child(odd){--bg-opacity:1;background-color:#fbd5d5;background-color:rgba(251,213,213,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-red-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4b4;background-color:rgba(248,180,180,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-red-400:nth-child(odd){--bg-opacity:1;background-color:#f98080;background-color:rgba(249,128,128,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-red-500:nth-child(odd){--bg-opacity:1;background-color:#f05252;background-color:rgba(240,82,82,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-red-600:nth-child(odd){--bg-opacity:1;background-color:#e02424;background-color:rgba(224,36,36,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-red-700:nth-child(odd){--bg-opacity:1;background-color:#c81e1e;background-color:rgba(200,30,30,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-red-800:nth-child(odd){--bg-opacity:1;background-color:#9b1c1c;background-color:rgba(155,28,28,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-red-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-orange-50:nth-child(odd){--bg-opacity:1;background-color:#fff8f1;background-color:rgba(255,248,241,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-orange-100:nth-child(odd){--bg-opacity:1;background-color:#feecdc;background-color:rgba(254,236,220,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-orange-200:nth-child(odd){--bg-opacity:1;background-color:#fcd9bd;background-color:rgba(252,217,189,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-orange-300:nth-child(odd){--bg-opacity:1;background-color:#fdba8c;background-color:rgba(253,186,140,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-orange-400:nth-child(odd){--bg-opacity:1;background-color:#ff8a4c;background-color:rgba(255,138,76,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-orange-500:nth-child(odd){--bg-opacity:1;background-color:#ff5a1f;background-color:rgba(255,90,31,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-orange-600:nth-child(odd){--bg-opacity:1;background-color:#d03801;background-color:rgba(208,56,1,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-orange-700:nth-child(odd){--bg-opacity:1;background-color:#b43403;background-color:rgba(180,52,3,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-orange-800:nth-child(odd){--bg-opacity:1;background-color:#8a2c0d;background-color:rgba(138,44,13,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-orange-900:nth-child(odd){--bg-opacity:1;background-color:#771d1d;background-color:rgba(119,29,29,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-yellow-50:nth-child(odd){--bg-opacity:1;background-color:#fdfdea;background-color:rgba(253,253,234,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-yellow-100:nth-child(odd){--bg-opacity:1;background-color:#fdf6b2;background-color:rgba(253,246,178,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-yellow-200:nth-child(odd){--bg-opacity:1;background-color:#fce96a;background-color:rgba(252,233,106,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-yellow-300:nth-child(odd){--bg-opacity:1;background-color:#faca15;background-color:rgba(250,202,21,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-yellow-400:nth-child(odd){--bg-opacity:1;background-color:#e3a008;background-color:rgba(227,160,8,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-yellow-500:nth-child(odd){--bg-opacity:1;background-color:#c27803;background-color:rgba(194,120,3,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-yellow-600:nth-child(odd){--bg-opacity:1;background-color:#9f580a;background-color:rgba(159,88,10,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-yellow-700:nth-child(odd){--bg-opacity:1;background-color:#8e4b10;background-color:rgba(142,75,16,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-yellow-800:nth-child(odd){--bg-opacity:1;background-color:#723b13;background-color:rgba(114,59,19,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-yellow-900:nth-child(odd){--bg-opacity:1;background-color:#633112;background-color:rgba(99,49,18,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-green-50:nth-child(odd){--bg-opacity:1;background-color:#f3faf7;background-color:rgba(243,250,247,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-green-100:nth-child(odd){--bg-opacity:1;background-color:#def7ec;background-color:rgba(222,247,236,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-green-200:nth-child(odd){--bg-opacity:1;background-color:#bcf0da;background-color:rgba(188,240,218,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-green-300:nth-child(odd){--bg-opacity:1;background-color:#84e1bc;background-color:rgba(132,225,188,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-green-400:nth-child(odd){--bg-opacity:1;background-color:#31c48d;background-color:rgba(49,196,141,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-green-500:nth-child(odd){--bg-opacity:1;background-color:#0e9f6e;background-color:rgba(14,159,110,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-green-600:nth-child(odd){--bg-opacity:1;background-color:#057a55;background-color:rgba(5,122,85,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-green-700:nth-child(odd){--bg-opacity:1;background-color:#046c4e;background-color:rgba(4,108,78,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-green-800:nth-child(odd){--bg-opacity:1;background-color:#03543f;background-color:rgba(3,84,63,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-green-900:nth-child(odd){--bg-opacity:1;background-color:#014737;background-color:rgba(1,71,55,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-teal-50:nth-child(odd){--bg-opacity:1;background-color:#edfafa;background-color:rgba(237,250,250,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-teal-100:nth-child(odd){--bg-opacity:1;background-color:#d5f5f6;background-color:rgba(213,245,246,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-teal-200:nth-child(odd){--bg-opacity:1;background-color:#afecef;background-color:rgba(175,236,239,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-teal-300:nth-child(odd){--bg-opacity:1;background-color:#7edce2;background-color:rgba(126,220,226,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-teal-400:nth-child(odd){--bg-opacity:1;background-color:#16bdca;background-color:rgba(22,189,202,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-teal-500:nth-child(odd){--bg-opacity:1;background-color:#0694a2;background-color:rgba(6,148,162,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-teal-600:nth-child(odd){--bg-opacity:1;background-color:#047481;background-color:rgba(4,116,129,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-teal-700:nth-child(odd){--bg-opacity:1;background-color:#036672;background-color:rgba(3,102,114,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-teal-800:nth-child(odd){--bg-opacity:1;background-color:#05505c;background-color:rgba(5,80,92,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-teal-900:nth-child(odd){--bg-opacity:1;background-color:#014451;background-color:rgba(1,68,81,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-blue-50:nth-child(odd){--bg-opacity:1;background-color:#ebf5ff;background-color:rgba(235,245,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-blue-100:nth-child(odd){--bg-opacity:1;background-color:#e1effe;background-color:rgba(225,239,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-blue-200:nth-child(odd){--bg-opacity:1;background-color:#c3ddfd;background-color:rgba(195,221,253,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-blue-300:nth-child(odd){--bg-opacity:1;background-color:#a4cafe;background-color:rgba(164,202,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-blue-400:nth-child(odd){--bg-opacity:1;background-color:#76a9fa;background-color:rgba(118,169,250,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-blue-500:nth-child(odd){--bg-opacity:1;background-color:#3f83f8;background-color:rgba(63,131,248,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-blue-600:nth-child(odd){--bg-opacity:1;background-color:#1c64f2;background-color:rgba(28,100,242,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-blue-700:nth-child(odd){--bg-opacity:1;background-color:#1a56db;background-color:rgba(26,86,219,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-blue-800:nth-child(odd){--bg-opacity:1;background-color:#1e429f;background-color:rgba(30,66,159,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-blue-900:nth-child(odd){--bg-opacity:1;background-color:#233876;background-color:rgba(35,56,118,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f0f5ff;background-color:rgba(240,245,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#e5edff;background-color:rgba(229,237,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#cddbfe;background-color:rgba(205,219,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#b4c6fc;background-color:rgba(180,198,252,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#8da2fb;background-color:rgba(141,162,251,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#6875f5;background-color:rgba(104,117,245,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#5850ec;background-color:rgba(88,80,236,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#5145cd;background-color:rgba(81,69,205,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#42389d;background-color:rgba(66,56,157,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#362f78;background-color:rgba(54,47,120,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-50:nth-child(odd){--bg-opacity:1;background-color:#f6f5ff;background-color:rgba(246,245,255,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-100:nth-child(odd){--bg-opacity:1;background-color:#edebfe;background-color:rgba(237,235,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-200:nth-child(odd){--bg-opacity:1;background-color:#dcd7fe;background-color:rgba(220,215,254,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-300:nth-child(odd){--bg-opacity:1;background-color:#cabffd;background-color:rgba(202,191,253,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-400:nth-child(odd){--bg-opacity:1;background-color:#ac94fa;background-color:rgba(172,148,250,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-500:nth-child(odd){--bg-opacity:1;background-color:#9061f9;background-color:rgba(144,97,249,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-600:nth-child(odd){--bg-opacity:1;background-color:#7e3af2;background-color:rgba(126,58,242,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-700:nth-child(odd){--bg-opacity:1;background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-800:nth-child(odd){--bg-opacity:1;background-color:#5521b5;background-color:rgba(85,33,181,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-indigo-900:nth-child(odd){--bg-opacity:1;background-color:#4a1d96;background-color:rgba(74,29,150,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-pink-50:nth-child(odd){--bg-opacity:1;background-color:#fdf2f8;background-color:rgba(253,242,248,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-pink-100:nth-child(odd){--bg-opacity:1;background-color:#fce8f3;background-color:rgba(252,232,243,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-pink-200:nth-child(odd){--bg-opacity:1;background-color:#fad1e8;background-color:rgba(250,209,232,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-pink-300:nth-child(odd){--bg-opacity:1;background-color:#f8b4d9;background-color:rgba(248,180,217,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-pink-400:nth-child(odd){--bg-opacity:1;background-color:#f17eb8;background-color:rgba(241,126,184,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-pink-500:nth-child(odd){--bg-opacity:1;background-color:#e74694;background-color:rgba(231,70,148,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-pink-600:nth-child(odd){--bg-opacity:1;background-color:#d61f69;background-color:rgba(214,31,105,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-pink-700:nth-child(odd){--bg-opacity:1;background-color:#bf125d;background-color:rgba(191,18,93,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-pink-800:nth-child(odd){--bg-opacity:1;background-color:#99154b;background-color:rgba(153,21,75,var(--bg-opacity))}.theme-dark .xl\\:dark\\:odd\\:bg-pink-900:nth-child(odd){--bg-opacity:1;background-color:#751a3d;background-color:rgba(117,26,61,var(--bg-opacity))}.xl\\:bg-opacity-0{--bg-opacity:0}.xl\\:bg-opacity-10{--bg-opacity:0.1}.xl\\:bg-opacity-25{--bg-opacity:0.25}.xl\\:bg-opacity-50{--bg-opacity:0.5}.xl\\:bg-opacity-75{--bg-opacity:0.75}.xl\\:bg-opacity-100{--bg-opacity:1}.xl\\:hover\\:bg-opacity-0:hover{--bg-opacity:0}.xl\\:hover\\:bg-opacity-10:hover{--bg-opacity:0.1}.xl\\:hover\\:bg-opacity-25:hover{--bg-opacity:0.25}.xl\\:hover\\:bg-opacity-50:hover{--bg-opacity:0.5}.xl\\:hover\\:bg-opacity-75:hover{--bg-opacity:0.75}.xl\\:hover\\:bg-opacity-100:hover{--bg-opacity:1}.xl\\:focus\\:bg-opacity-0:focus{--bg-opacity:0}.xl\\:focus\\:bg-opacity-10:focus{--bg-opacity:0.1}.xl\\:focus\\:bg-opacity-25:focus{--bg-opacity:0.25}.xl\\:focus\\:bg-opacity-50:focus{--bg-opacity:0.5}.xl\\:focus\\:bg-opacity-75:focus{--bg-opacity:0.75}.xl\\:focus\\:bg-opacity-100:focus{--bg-opacity:1}.theme-dark .xl\\:dark\\:hover\\:bg-opacity-0:hover{--bg-opacity:0}.theme-dark .xl\\:dark\\:hover\\:bg-opacity-10:hover{--bg-opacity:0.1}.theme-dark .xl\\:dark\\:hover\\:bg-opacity-25:hover{--bg-opacity:0.25}.theme-dark .xl\\:dark\\:hover\\:bg-opacity-50:hover{--bg-opacity:0.5}.theme-dark .xl\\:dark\\:hover\\:bg-opacity-75:hover{--bg-opacity:0.75}.theme-dark .xl\\:dark\\:hover\\:bg-opacity-100:hover{--bg-opacity:1}.xl\\:bg-bottom{background-position:bottom}.xl\\:bg-center{background-position:50%}.xl\\:bg-left{background-position:0}.xl\\:bg-left-bottom{background-position:0 100%}.xl\\:bg-left-top{background-position:0 0}.xl\\:bg-right{background-position:100%}.xl\\:bg-right-bottom{background-position:100% 100%}.xl\\:bg-right-top{background-position:100% 0}.xl\\:bg-top{background-position:top}.xl\\:bg-repeat{background-repeat:repeat}.xl\\:bg-no-repeat{background-repeat:no-repeat}.xl\\:bg-repeat-x{background-repeat:repeat-x}.xl\\:bg-repeat-y{background-repeat:repeat-y}.xl\\:bg-repeat-round{background-repeat:round}.xl\\:bg-repeat-space{background-repeat:space}.xl\\:bg-auto{background-size:auto}.xl\\:bg-cover{background-size:cover}.xl\\:bg-contain{background-size:contain}.xl\\:border-collapse{border-collapse:collapse}.xl\\:border-separate{border-collapse:initial}.xl\\:border-transparent{border-color:#0000}.xl\\:border-white{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.xl\\:border-black{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.xl\\:border-gray-50{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.xl\\:border-gray-100{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.xl\\:border-gray-200{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.xl\\:border-gray-300{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.xl\\:border-gray-400{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.xl\\:border-gray-500{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.xl\\:border-gray-600{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.xl\\:border-gray-700{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.xl\\:border-gray-800{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.xl\\:border-gray-900{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.xl\\:border-cool-gray-50{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.xl\\:border-cool-gray-100{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.xl\\:border-cool-gray-200{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.xl\\:border-cool-gray-300{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.xl\\:border-cool-gray-400{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.xl\\:border-cool-gray-500{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.xl\\:border-cool-gray-600{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.xl\\:border-cool-gray-700{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.xl\\:border-cool-gray-800{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.xl\\:border-cool-gray-900{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.xl\\:border-red-50{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.xl\\:border-red-100{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.xl\\:border-red-200{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.xl\\:border-red-300{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.xl\\:border-red-400{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.xl\\:border-red-500{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.xl\\:border-red-600{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.xl\\:border-red-700{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.xl\\:border-red-800{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.xl\\:border-red-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.xl\\:border-orange-50{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.xl\\:border-orange-100{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.xl\\:border-orange-200{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.xl\\:border-orange-300{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.xl\\:border-orange-400{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.xl\\:border-orange-500{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.xl\\:border-orange-600{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.xl\\:border-orange-700{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.xl\\:border-orange-800{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.xl\\:border-orange-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.xl\\:border-yellow-50{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.xl\\:border-yellow-100{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.xl\\:border-yellow-200{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.xl\\:border-yellow-300{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.xl\\:border-yellow-400{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.xl\\:border-yellow-500{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.xl\\:border-yellow-600{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.xl\\:border-yellow-700{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.xl\\:border-yellow-800{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.xl\\:border-yellow-900{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.xl\\:border-green-50{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.xl\\:border-green-100{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.xl\\:border-green-200{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.xl\\:border-green-300{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.xl\\:border-green-400{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.xl\\:border-green-500{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.xl\\:border-green-600{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.xl\\:border-green-700{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.xl\\:border-green-800{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.xl\\:border-green-900{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.xl\\:border-teal-50{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.xl\\:border-teal-100{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.xl\\:border-teal-200{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.xl\\:border-teal-300{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.xl\\:border-teal-400{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.xl\\:border-teal-500{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.xl\\:border-teal-600{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.xl\\:border-teal-700{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.xl\\:border-teal-800{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.xl\\:border-teal-900{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.xl\\:border-blue-50{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.xl\\:border-blue-100{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.xl\\:border-blue-200{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.xl\\:border-blue-300{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.xl\\:border-blue-400{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.xl\\:border-blue-500{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.xl\\:border-blue-600{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.xl\\:border-blue-700{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.xl\\:border-blue-800{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.xl\\:border-blue-900{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.xl\\:border-indigo-50{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.xl\\:border-indigo-100{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.xl\\:border-indigo-200{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.xl\\:border-indigo-300{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.xl\\:border-indigo-400{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.xl\\:border-indigo-500{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.xl\\:border-indigo-600{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.xl\\:border-indigo-700{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.xl\\:border-indigo-800{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.xl\\:border-indigo-900{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.xl\\:border-indigo-50{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.xl\\:border-indigo-100{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.xl\\:border-indigo-200{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.xl\\:border-indigo-300{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.xl\\:border-indigo-400{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.xl\\:border-indigo-500{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.xl\\:border-indigo-600{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.xl\\:border-indigo-700{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.xl\\:border-indigo-800{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.xl\\:border-indigo-900{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.xl\\:border-pink-50{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.xl\\:border-pink-100{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.xl\\:border-pink-200{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.xl\\:border-pink-300{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.xl\\:border-pink-400{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.xl\\:border-pink-500{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.xl\\:border-pink-600{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.xl\\:border-pink-700{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.xl\\:border-pink-800{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.xl\\:border-pink-900{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.xl\\:hover\\:border-transparent:hover{border-color:#0000}.xl\\:hover\\:border-white:hover{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.xl\\:hover\\:border-black:hover{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.xl\\:hover\\:border-gray-50:hover{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.xl\\:hover\\:border-gray-100:hover{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.xl\\:hover\\:border-gray-200:hover{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.xl\\:hover\\:border-gray-300:hover{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.xl\\:hover\\:border-gray-400:hover{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.xl\\:hover\\:border-gray-500:hover{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.xl\\:hover\\:border-gray-600:hover{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.xl\\:hover\\:border-gray-700:hover{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.xl\\:hover\\:border-gray-800:hover{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.xl\\:hover\\:border-gray-900:hover{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.xl\\:hover\\:border-cool-gray-50:hover{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.xl\\:hover\\:border-cool-gray-100:hover{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.xl\\:hover\\:border-cool-gray-200:hover{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.xl\\:hover\\:border-cool-gray-300:hover{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.xl\\:hover\\:border-cool-gray-400:hover{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.xl\\:hover\\:border-cool-gray-500:hover{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.xl\\:hover\\:border-cool-gray-600:hover{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.xl\\:hover\\:border-cool-gray-700:hover{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.xl\\:hover\\:border-cool-gray-800:hover{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.xl\\:hover\\:border-cool-gray-900:hover{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.xl\\:hover\\:border-red-50:hover{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.xl\\:hover\\:border-red-100:hover{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.xl\\:hover\\:border-red-200:hover{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.xl\\:hover\\:border-red-300:hover{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.xl\\:hover\\:border-red-400:hover{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.xl\\:hover\\:border-red-500:hover{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.xl\\:hover\\:border-red-600:hover{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.xl\\:hover\\:border-red-700:hover{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.xl\\:hover\\:border-red-800:hover{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.xl\\:hover\\:border-red-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.xl\\:hover\\:border-orange-50:hover{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.xl\\:hover\\:border-orange-100:hover{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.xl\\:hover\\:border-orange-200:hover{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.xl\\:hover\\:border-orange-300:hover{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.xl\\:hover\\:border-orange-400:hover{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.xl\\:hover\\:border-orange-500:hover{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.xl\\:hover\\:border-orange-600:hover{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.xl\\:hover\\:border-orange-700:hover{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.xl\\:hover\\:border-orange-800:hover{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.xl\\:hover\\:border-orange-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.xl\\:hover\\:border-yellow-50:hover{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.xl\\:hover\\:border-yellow-100:hover{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.xl\\:hover\\:border-yellow-200:hover{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.xl\\:hover\\:border-yellow-300:hover{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.xl\\:hover\\:border-yellow-400:hover{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.xl\\:hover\\:border-yellow-500:hover{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.xl\\:hover\\:border-yellow-600:hover{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.xl\\:hover\\:border-yellow-700:hover{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.xl\\:hover\\:border-yellow-800:hover{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.xl\\:hover\\:border-yellow-900:hover{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.xl\\:hover\\:border-green-50:hover{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.xl\\:hover\\:border-green-100:hover{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.xl\\:hover\\:border-green-200:hover{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.xl\\:hover\\:border-green-300:hover{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.xl\\:hover\\:border-green-400:hover{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.xl\\:hover\\:border-green-500:hover{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.xl\\:hover\\:border-green-600:hover{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.xl\\:hover\\:border-green-700:hover{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.xl\\:hover\\:border-green-800:hover{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.xl\\:hover\\:border-green-900:hover{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.xl\\:hover\\:border-teal-50:hover{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.xl\\:hover\\:border-teal-100:hover{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.xl\\:hover\\:border-teal-200:hover{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.xl\\:hover\\:border-teal-300:hover{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.xl\\:hover\\:border-teal-400:hover{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.xl\\:hover\\:border-teal-500:hover{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.xl\\:hover\\:border-teal-600:hover{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.xl\\:hover\\:border-teal-700:hover{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.xl\\:hover\\:border-teal-800:hover{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.xl\\:hover\\:border-teal-900:hover{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.xl\\:hover\\:border-blue-50:hover{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.xl\\:hover\\:border-blue-100:hover{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.xl\\:hover\\:border-blue-200:hover{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.xl\\:hover\\:border-blue-300:hover{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.xl\\:hover\\:border-blue-400:hover{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.xl\\:hover\\:border-blue-500:hover{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.xl\\:hover\\:border-blue-600:hover{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.xl\\:hover\\:border-blue-700:hover{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.xl\\:hover\\:border-blue-800:hover{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.xl\\:hover\\:border-blue-900:hover{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.xl\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.xl\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.xl\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.xl\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.xl\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.xl\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.xl\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.xl\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.xl\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.xl\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.xl\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.xl\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.xl\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.xl\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.xl\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.xl\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.xl\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.xl\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.xl\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.xl\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.xl\\:hover\\:border-pink-50:hover{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.xl\\:hover\\:border-pink-100:hover{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.xl\\:hover\\:border-pink-200:hover{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.xl\\:hover\\:border-pink-300:hover{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.xl\\:hover\\:border-pink-400:hover{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.xl\\:hover\\:border-pink-500:hover{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.xl\\:hover\\:border-pink-600:hover{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.xl\\:hover\\:border-pink-700:hover{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.xl\\:hover\\:border-pink-800:hover{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.xl\\:hover\\:border-pink-900:hover{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.xl\\:focus\\:border-transparent:focus{border-color:#0000}.xl\\:focus\\:border-white:focus{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.xl\\:focus\\:border-black:focus{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.xl\\:focus\\:border-gray-50:focus{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.xl\\:focus\\:border-gray-100:focus{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.xl\\:focus\\:border-gray-200:focus{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.xl\\:focus\\:border-gray-300:focus{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.xl\\:focus\\:border-gray-400:focus{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.xl\\:focus\\:border-gray-500:focus{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.xl\\:focus\\:border-gray-600:focus{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.xl\\:focus\\:border-gray-700:focus{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.xl\\:focus\\:border-gray-800:focus{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.xl\\:focus\\:border-gray-900:focus{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.xl\\:focus\\:border-cool-gray-50:focus{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.xl\\:focus\\:border-cool-gray-100:focus{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.xl\\:focus\\:border-cool-gray-200:focus{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.xl\\:focus\\:border-cool-gray-300:focus{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.xl\\:focus\\:border-cool-gray-400:focus{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.xl\\:focus\\:border-cool-gray-500:focus{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.xl\\:focus\\:border-cool-gray-600:focus{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.xl\\:focus\\:border-cool-gray-700:focus{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.xl\\:focus\\:border-cool-gray-800:focus{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.xl\\:focus\\:border-cool-gray-900:focus{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.xl\\:focus\\:border-red-50:focus{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.xl\\:focus\\:border-red-100:focus{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.xl\\:focus\\:border-red-200:focus{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.xl\\:focus\\:border-red-300:focus{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.xl\\:focus\\:border-red-400:focus{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.xl\\:focus\\:border-red-500:focus{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.xl\\:focus\\:border-red-600:focus{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.xl\\:focus\\:border-red-700:focus{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.xl\\:focus\\:border-red-800:focus{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.xl\\:focus\\:border-red-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.xl\\:focus\\:border-orange-50:focus{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.xl\\:focus\\:border-orange-100:focus{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.xl\\:focus\\:border-orange-200:focus{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.xl\\:focus\\:border-orange-300:focus{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.xl\\:focus\\:border-orange-400:focus{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.xl\\:focus\\:border-orange-500:focus{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.xl\\:focus\\:border-orange-600:focus{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.xl\\:focus\\:border-orange-700:focus{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.xl\\:focus\\:border-orange-800:focus{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.xl\\:focus\\:border-orange-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.xl\\:focus\\:border-yellow-50:focus{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.xl\\:focus\\:border-yellow-100:focus{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.xl\\:focus\\:border-yellow-200:focus{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.xl\\:focus\\:border-yellow-300:focus{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.xl\\:focus\\:border-yellow-400:focus{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.xl\\:focus\\:border-yellow-500:focus{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.xl\\:focus\\:border-yellow-600:focus{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.xl\\:focus\\:border-yellow-700:focus{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.xl\\:focus\\:border-yellow-800:focus{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.xl\\:focus\\:border-yellow-900:focus{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.xl\\:focus\\:border-green-50:focus{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.xl\\:focus\\:border-green-100:focus{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.xl\\:focus\\:border-green-200:focus{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.xl\\:focus\\:border-green-300:focus{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.xl\\:focus\\:border-green-400:focus{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.xl\\:focus\\:border-green-500:focus{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.xl\\:focus\\:border-green-600:focus{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.xl\\:focus\\:border-green-700:focus{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.xl\\:focus\\:border-green-800:focus{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.xl\\:focus\\:border-green-900:focus{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.xl\\:focus\\:border-teal-50:focus{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.xl\\:focus\\:border-teal-100:focus{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.xl\\:focus\\:border-teal-200:focus{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.xl\\:focus\\:border-teal-300:focus{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.xl\\:focus\\:border-teal-400:focus{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.xl\\:focus\\:border-teal-500:focus{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.xl\\:focus\\:border-teal-600:focus{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.xl\\:focus\\:border-teal-700:focus{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.xl\\:focus\\:border-teal-800:focus{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.xl\\:focus\\:border-teal-900:focus{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.xl\\:focus\\:border-blue-50:focus{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.xl\\:focus\\:border-blue-100:focus{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.xl\\:focus\\:border-blue-200:focus{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.xl\\:focus\\:border-blue-300:focus{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.xl\\:focus\\:border-blue-400:focus{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.xl\\:focus\\:border-blue-500:focus{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.xl\\:focus\\:border-blue-600:focus{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.xl\\:focus\\:border-blue-700:focus{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.xl\\:focus\\:border-blue-800:focus{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.xl\\:focus\\:border-blue-900:focus{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.xl\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.xl\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.xl\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.xl\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.xl\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.xl\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.xl\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.xl\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.xl\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.xl\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.xl\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.xl\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.xl\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.xl\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.xl\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.xl\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.xl\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.xl\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.xl\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.xl\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.xl\\:focus\\:border-pink-50:focus{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.xl\\:focus\\:border-pink-100:focus{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.xl\\:focus\\:border-pink-200:focus{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.xl\\:focus\\:border-pink-300:focus{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.xl\\:focus\\:border-pink-400:focus{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.xl\\:focus\\:border-pink-500:focus{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.xl\\:focus\\:border-pink-600:focus{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.xl\\:focus\\:border-pink-700:focus{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.xl\\:focus\\:border-pink-800:focus{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.xl\\:focus\\:border-pink-900:focus{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-transparent{border-color:#0000}.theme-dark .xl\\:dark\\:border-white{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-black{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-gray-50{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-gray-100{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-gray-200{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-gray-300{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-gray-400{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-gray-500{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-gray-600{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-gray-700{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-gray-800{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-gray-900{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-cool-gray-50{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-cool-gray-100{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-cool-gray-200{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-cool-gray-300{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-cool-gray-400{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-cool-gray-500{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-cool-gray-600{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-cool-gray-700{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-cool-gray-800{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-cool-gray-900{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-red-50{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-red-100{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-red-200{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-red-300{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-red-400{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-red-500{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-red-600{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-red-700{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-red-800{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-red-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-orange-50{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-orange-100{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-orange-200{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-orange-300{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-orange-400{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-orange-500{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-orange-600{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-orange-700{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-orange-800{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-orange-900{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-yellow-50{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-yellow-100{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-yellow-200{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-yellow-300{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-yellow-400{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-yellow-500{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-yellow-600{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-yellow-700{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-yellow-800{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-yellow-900{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-green-50{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-green-100{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-green-200{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-green-300{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-green-400{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-green-500{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-green-600{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-green-700{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-green-800{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-green-900{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-teal-50{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-teal-100{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-teal-200{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-teal-300{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-teal-400{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-teal-500{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-teal-600{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-teal-700{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-teal-800{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-teal-900{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-blue-50{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-blue-100{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-blue-200{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-blue-300{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-blue-400{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-blue-500{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-blue-600{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-blue-700{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-blue-800{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-blue-900{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-50{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-100{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-200{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-300{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-400{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-500{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-600{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-700{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-800{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-900{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-50{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-100{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-200{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-300{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-400{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-500{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-600{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-700{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-800{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-indigo-900{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-pink-50{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-pink-100{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-pink-200{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-pink-300{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-pink-400{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-pink-500{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-pink-600{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-pink-700{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-pink-800{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.theme-dark .xl\\:dark\\:border-pink-900{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-transparent:focus{border-color:#0000}.theme-dark .xl\\:dark\\:focus\\:border-white:focus{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-black:focus{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-gray-50:focus{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-gray-100:focus{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-gray-200:focus{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-gray-300:focus{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-gray-400:focus{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-gray-500:focus{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-gray-600:focus{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-gray-700:focus{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-gray-800:focus{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-gray-900:focus{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-cool-gray-50:focus{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-cool-gray-100:focus{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-cool-gray-200:focus{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-cool-gray-300:focus{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-cool-gray-400:focus{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-cool-gray-500:focus{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-cool-gray-600:focus{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-cool-gray-700:focus{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-cool-gray-800:focus{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-cool-gray-900:focus{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-red-50:focus{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-red-100:focus{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-red-200:focus{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-red-300:focus{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-red-400:focus{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-red-500:focus{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-red-600:focus{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-red-700:focus{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-red-800:focus{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-red-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-orange-50:focus{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-orange-100:focus{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-orange-200:focus{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-orange-300:focus{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-orange-400:focus{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-orange-500:focus{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-orange-600:focus{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-orange-700:focus{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-orange-800:focus{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-orange-900:focus{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-yellow-50:focus{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-yellow-100:focus{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-yellow-200:focus{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-yellow-300:focus{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-yellow-400:focus{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-yellow-500:focus{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-yellow-600:focus{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-yellow-700:focus{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-yellow-800:focus{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-yellow-900:focus{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-green-50:focus{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-green-100:focus{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-green-200:focus{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-green-300:focus{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-green-400:focus{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-green-500:focus{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-green-600:focus{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-green-700:focus{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-green-800:focus{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-green-900:focus{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-teal-50:focus{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-teal-100:focus{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-teal-200:focus{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-teal-300:focus{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-teal-400:focus{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-teal-500:focus{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-teal-600:focus{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-teal-700:focus{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-teal-800:focus{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-teal-900:focus{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-blue-50:focus{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-blue-100:focus{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-blue-200:focus{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-blue-300:focus{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-blue-400:focus{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-blue-500:focus{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-blue-600:focus{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-blue-700:focus{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-blue-800:focus{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-blue-900:focus{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-50:focus{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-100:focus{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-200:focus{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-300:focus{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-400:focus{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-500:focus{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-600:focus{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-700:focus{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-800:focus{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-indigo-900:focus{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-pink-50:focus{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-pink-100:focus{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-pink-200:focus{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-pink-300:focus{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-pink-400:focus{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-pink-500:focus{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-pink-600:focus{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-pink-700:focus{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-pink-800:focus{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.theme-dark .xl\\:dark\\:focus\\:border-pink-900:focus{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-transparent:hover{border-color:#0000}.theme-dark .xl\\:dark\\:hover\\:border-white:hover{--border-opacity:1;border-color:#fff;border-color:rgba(255,255,255,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-black:hover{--border-opacity:1;border-color:#000;border-color:rgba(0,0,0,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-gray-50:hover{--border-opacity:1;border-color:#f9fafb;border-color:rgba(249,250,251,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-gray-100:hover{--border-opacity:1;border-color:#f4f5f7;border-color:rgba(244,245,247,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-gray-200:hover{--border-opacity:1;border-color:#e5e7eb;border-color:rgba(229,231,235,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-gray-300:hover{--border-opacity:1;border-color:#d5d6d7;border-color:rgba(213,214,215,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-gray-400:hover{--border-opacity:1;border-color:#9e9e9e;border-color:rgba(158,158,158,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-gray-500:hover{--border-opacity:1;border-color:#707275;border-color:rgba(112,114,117,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-gray-600:hover{--border-opacity:1;border-color:#4c4f52;border-color:rgba(76,79,82,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-gray-700:hover{--border-opacity:1;border-color:#24262d;border-color:rgba(36,38,45,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-gray-800:hover{--border-opacity:1;border-color:#1a1c23;border-color:rgba(26,28,35,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-gray-900:hover{--border-opacity:1;border-color:#121317;border-color:rgba(18,19,23,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-cool-gray-50:hover{--border-opacity:1;border-color:#fbfdfe;border-color:rgba(251,253,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-cool-gray-100:hover{--border-opacity:1;border-color:#f1f5f9;border-color:rgba(241,245,249,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-cool-gray-200:hover{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-cool-gray-300:hover{--border-opacity:1;border-color:#cfd8e3;border-color:rgba(207,216,227,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-cool-gray-400:hover{--border-opacity:1;border-color:#97a6ba;border-color:rgba(151,166,186,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-cool-gray-500:hover{--border-opacity:1;border-color:#64748b;border-color:rgba(100,116,139,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-cool-gray-600:hover{--border-opacity:1;border-color:#475569;border-color:rgba(71,85,105,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-cool-gray-700:hover{--border-opacity:1;border-color:#364152;border-color:rgba(54,65,82,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-cool-gray-800:hover{--border-opacity:1;border-color:#27303f;border-color:rgba(39,48,63,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-cool-gray-900:hover{--border-opacity:1;border-color:#1a202e;border-color:rgba(26,32,46,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-red-50:hover{--border-opacity:1;border-color:#fdf2f2;border-color:rgba(253,242,242,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-red-100:hover{--border-opacity:1;border-color:#fde8e8;border-color:rgba(253,232,232,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-red-200:hover{--border-opacity:1;border-color:#fbd5d5;border-color:rgba(251,213,213,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-red-300:hover{--border-opacity:1;border-color:#f8b4b4;border-color:rgba(248,180,180,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-red-400:hover{--border-opacity:1;border-color:#f98080;border-color:rgba(249,128,128,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-red-500:hover{--border-opacity:1;border-color:#f05252;border-color:rgba(240,82,82,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-red-600:hover{--border-opacity:1;border-color:#e02424;border-color:rgba(224,36,36,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-red-700:hover{--border-opacity:1;border-color:#c81e1e;border-color:rgba(200,30,30,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-red-800:hover{--border-opacity:1;border-color:#9b1c1c;border-color:rgba(155,28,28,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-red-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-orange-50:hover{--border-opacity:1;border-color:#fff8f1;border-color:rgba(255,248,241,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-orange-100:hover{--border-opacity:1;border-color:#feecdc;border-color:rgba(254,236,220,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-orange-200:hover{--border-opacity:1;border-color:#fcd9bd;border-color:rgba(252,217,189,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-orange-300:hover{--border-opacity:1;border-color:#fdba8c;border-color:rgba(253,186,140,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-orange-400:hover{--border-opacity:1;border-color:#ff8a4c;border-color:rgba(255,138,76,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-orange-500:hover{--border-opacity:1;border-color:#ff5a1f;border-color:rgba(255,90,31,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-orange-600:hover{--border-opacity:1;border-color:#d03801;border-color:rgba(208,56,1,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-orange-700:hover{--border-opacity:1;border-color:#b43403;border-color:rgba(180,52,3,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-orange-800:hover{--border-opacity:1;border-color:#8a2c0d;border-color:rgba(138,44,13,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-orange-900:hover{--border-opacity:1;border-color:#771d1d;border-color:rgba(119,29,29,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-yellow-50:hover{--border-opacity:1;border-color:#fdfdea;border-color:rgba(253,253,234,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-yellow-100:hover{--border-opacity:1;border-color:#fdf6b2;border-color:rgba(253,246,178,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-yellow-200:hover{--border-opacity:1;border-color:#fce96a;border-color:rgba(252,233,106,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-yellow-300:hover{--border-opacity:1;border-color:#faca15;border-color:rgba(250,202,21,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-yellow-400:hover{--border-opacity:1;border-color:#e3a008;border-color:rgba(227,160,8,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-yellow-500:hover{--border-opacity:1;border-color:#c27803;border-color:rgba(194,120,3,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-yellow-600:hover{--border-opacity:1;border-color:#9f580a;border-color:rgba(159,88,10,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-yellow-700:hover{--border-opacity:1;border-color:#8e4b10;border-color:rgba(142,75,16,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-yellow-800:hover{--border-opacity:1;border-color:#723b13;border-color:rgba(114,59,19,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-yellow-900:hover{--border-opacity:1;border-color:#633112;border-color:rgba(99,49,18,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-green-50:hover{--border-opacity:1;border-color:#f3faf7;border-color:rgba(243,250,247,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-green-100:hover{--border-opacity:1;border-color:#def7ec;border-color:rgba(222,247,236,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-green-200:hover{--border-opacity:1;border-color:#bcf0da;border-color:rgba(188,240,218,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-green-300:hover{--border-opacity:1;border-color:#84e1bc;border-color:rgba(132,225,188,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-green-400:hover{--border-opacity:1;border-color:#31c48d;border-color:rgba(49,196,141,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-green-500:hover{--border-opacity:1;border-color:#0e9f6e;border-color:rgba(14,159,110,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-green-600:hover{--border-opacity:1;border-color:#057a55;border-color:rgba(5,122,85,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-green-700:hover{--border-opacity:1;border-color:#046c4e;border-color:rgba(4,108,78,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-green-800:hover{--border-opacity:1;border-color:#03543f;border-color:rgba(3,84,63,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-green-900:hover{--border-opacity:1;border-color:#014737;border-color:rgba(1,71,55,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-teal-50:hover{--border-opacity:1;border-color:#edfafa;border-color:rgba(237,250,250,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-teal-100:hover{--border-opacity:1;border-color:#d5f5f6;border-color:rgba(213,245,246,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-teal-200:hover{--border-opacity:1;border-color:#afecef;border-color:rgba(175,236,239,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-teal-300:hover{--border-opacity:1;border-color:#7edce2;border-color:rgba(126,220,226,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-teal-400:hover{--border-opacity:1;border-color:#16bdca;border-color:rgba(22,189,202,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-teal-500:hover{--border-opacity:1;border-color:#0694a2;border-color:rgba(6,148,162,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-teal-600:hover{--border-opacity:1;border-color:#047481;border-color:rgba(4,116,129,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-teal-700:hover{--border-opacity:1;border-color:#036672;border-color:rgba(3,102,114,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-teal-800:hover{--border-opacity:1;border-color:#05505c;border-color:rgba(5,80,92,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-teal-900:hover{--border-opacity:1;border-color:#014451;border-color:rgba(1,68,81,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-blue-50:hover{--border-opacity:1;border-color:#ebf5ff;border-color:rgba(235,245,255,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-blue-100:hover{--border-opacity:1;border-color:#e1effe;border-color:rgba(225,239,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-blue-200:hover{--border-opacity:1;border-color:#c3ddfd;border-color:rgba(195,221,253,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-blue-300:hover{--border-opacity:1;border-color:#a4cafe;border-color:rgba(164,202,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-blue-400:hover{--border-opacity:1;border-color:#76a9fa;border-color:rgba(118,169,250,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-blue-500:hover{--border-opacity:1;border-color:#3f83f8;border-color:rgba(63,131,248,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-blue-600:hover{--border-opacity:1;border-color:#1c64f2;border-color:rgba(28,100,242,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-blue-700:hover{--border-opacity:1;border-color:#1a56db;border-color:rgba(26,86,219,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-blue-800:hover{--border-opacity:1;border-color:#1e429f;border-color:rgba(30,66,159,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-blue-900:hover{--border-opacity:1;border-color:#233876;border-color:rgba(35,56,118,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f0f5ff;border-color:rgba(240,245,255,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#e5edff;border-color:rgba(229,237,255,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#cddbfe;border-color:rgba(205,219,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#b4c6fc;border-color:rgba(180,198,252,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#8da2fb;border-color:rgba(141,162,251,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#6875f5;border-color:rgba(104,117,245,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#5850ec;border-color:rgba(88,80,236,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#5145cd;border-color:rgba(81,69,205,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#42389d;border-color:rgba(66,56,157,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#362f78;border-color:rgba(54,47,120,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-50:hover{--border-opacity:1;border-color:#f6f5ff;border-color:rgba(246,245,255,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-100:hover{--border-opacity:1;border-color:#edebfe;border-color:rgba(237,235,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-200:hover{--border-opacity:1;border-color:#dcd7fe;border-color:rgba(220,215,254,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-300:hover{--border-opacity:1;border-color:#cabffd;border-color:rgba(202,191,253,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-400:hover{--border-opacity:1;border-color:#ac94fa;border-color:rgba(172,148,250,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-500:hover{--border-opacity:1;border-color:#9061f9;border-color:rgba(144,97,249,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-600:hover{--border-opacity:1;border-color:#7e3af2;border-color:rgba(126,58,242,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-700:hover{--border-opacity:1;border-color:#6c2bd9;border-color:rgba(108,43,217,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-800:hover{--border-opacity:1;border-color:#5521b5;border-color:rgba(85,33,181,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-indigo-900:hover{--border-opacity:1;border-color:#4a1d96;border-color:rgba(74,29,150,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-pink-50:hover{--border-opacity:1;border-color:#fdf2f8;border-color:rgba(253,242,248,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-pink-100:hover{--border-opacity:1;border-color:#fce8f3;border-color:rgba(252,232,243,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-pink-200:hover{--border-opacity:1;border-color:#fad1e8;border-color:rgba(250,209,232,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-pink-300:hover{--border-opacity:1;border-color:#f8b4d9;border-color:rgba(248,180,217,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-pink-400:hover{--border-opacity:1;border-color:#f17eb8;border-color:rgba(241,126,184,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-pink-500:hover{--border-opacity:1;border-color:#e74694;border-color:rgba(231,70,148,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-pink-600:hover{--border-opacity:1;border-color:#d61f69;border-color:rgba(214,31,105,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-pink-700:hover{--border-opacity:1;border-color:#bf125d;border-color:rgba(191,18,93,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-pink-800:hover{--border-opacity:1;border-color:#99154b;border-color:rgba(153,21,75,var(--border-opacity))}.theme-dark .xl\\:dark\\:hover\\:border-pink-900:hover{--border-opacity:1;border-color:#751a3d;border-color:rgba(117,26,61,var(--border-opacity))}.xl\\:border-opacity-0{--border-opacity:0}.xl\\:border-opacity-25{--border-opacity:0.25}.xl\\:border-opacity-50{--border-opacity:0.5}.xl\\:border-opacity-75{--border-opacity:0.75}.xl\\:border-opacity-100{--border-opacity:1}.xl\\:hover\\:border-opacity-0:hover{--border-opacity:0}.xl\\:hover\\:border-opacity-25:hover{--border-opacity:0.25}.xl\\:hover\\:border-opacity-50:hover{--border-opacity:0.5}.xl\\:hover\\:border-opacity-75:hover{--border-opacity:0.75}.xl\\:hover\\:border-opacity-100:hover{--border-opacity:1}.xl\\:focus\\:border-opacity-0:focus{--border-opacity:0}.xl\\:focus\\:border-opacity-25:focus{--border-opacity:0.25}.xl\\:focus\\:border-opacity-50:focus{--border-opacity:0.5}.xl\\:focus\\:border-opacity-75:focus{--border-opacity:0.75}.xl\\:focus\\:border-opacity-100:focus{--border-opacity:1}.xl\\:rounded-none{border-radius:0}.xl\\:rounded-sm{border-radius:.125rem}.xl\\:rounded{border-radius:.25rem}.xl\\:rounded-md{border-radius:.375rem}.xl\\:rounded-lg{border-radius:.5rem}.xl\\:rounded-full{border-radius:9999px}.xl\\:rounded-t-none{border-top-left-radius:0;border-top-right-radius:0}.xl\\:rounded-r-none{border-bottom-right-radius:0;border-top-right-radius:0}.xl\\:rounded-b-none{border-bottom-left-radius:0;border-bottom-right-radius:0}.xl\\:rounded-l-none{border-bottom-left-radius:0;border-top-left-radius:0}.xl\\:rounded-t-sm{border-top-left-radius:.125rem;border-top-right-radius:.125rem}.xl\\:rounded-r-sm{border-bottom-right-radius:.125rem;border-top-right-radius:.125rem}.xl\\:rounded-b-sm{border-bottom-left-radius:.125rem;border-bottom-right-radius:.125rem}.xl\\:rounded-l-sm{border-bottom-left-radius:.125rem;border-top-left-radius:.125rem}.xl\\:rounded-t{border-top-left-radius:.25rem}.xl\\:rounded-r,.xl\\:rounded-t{border-top-right-radius:.25rem}.xl\\:rounded-b,.xl\\:rounded-r{border-bottom-right-radius:.25rem}.xl\\:rounded-b,.xl\\:rounded-l{border-bottom-left-radius:.25rem}.xl\\:rounded-l{border-top-left-radius:.25rem}.xl\\:rounded-t-md{border-top-left-radius:.375rem;border-top-right-radius:.375rem}.xl\\:rounded-r-md{border-bottom-right-radius:.375rem;border-top-right-radius:.375rem}.xl\\:rounded-b-md{border-bottom-left-radius:.375rem;border-bottom-right-radius:.375rem}.xl\\:rounded-l-md{border-bottom-left-radius:.375rem;border-top-left-radius:.375rem}.xl\\:rounded-t-lg{border-top-left-radius:.5rem;border-top-right-radius:.5rem}.xl\\:rounded-r-lg{border-bottom-right-radius:.5rem;border-top-right-radius:.5rem}.xl\\:rounded-b-lg{border-bottom-left-radius:.5rem;border-bottom-right-radius:.5rem}.xl\\:rounded-l-lg{border-bottom-left-radius:.5rem;border-top-left-radius:.5rem}.xl\\:rounded-t-full{border-top-left-radius:9999px;border-top-right-radius:9999px}.xl\\:rounded-r-full{border-bottom-right-radius:9999px;border-top-right-radius:9999px}.xl\\:rounded-b-full{border-bottom-left-radius:9999px;border-bottom-right-radius:9999px}.xl\\:rounded-l-full{border-bottom-left-radius:9999px;border-top-left-radius:9999px}.xl\\:rounded-tl-none{border-top-left-radius:0}.xl\\:rounded-tr-none{border-top-right-radius:0}.xl\\:rounded-br-none{border-bottom-right-radius:0}.xl\\:rounded-bl-none{border-bottom-left-radius:0}.xl\\:rounded-tl-sm{border-top-left-radius:.125rem}.xl\\:rounded-tr-sm{border-top-right-radius:.125rem}.xl\\:rounded-br-sm{border-bottom-right-radius:.125rem}.xl\\:rounded-bl-sm{border-bottom-left-radius:.125rem}.xl\\:rounded-tl{border-top-left-radius:.25rem}.xl\\:rounded-tr{border-top-right-radius:.25rem}.xl\\:rounded-br{border-bottom-right-radius:.25rem}.xl\\:rounded-bl{border-bottom-left-radius:.25rem}.xl\\:rounded-tl-md{border-top-left-radius:.375rem}.xl\\:rounded-tr-md{border-top-right-radius:.375rem}.xl\\:rounded-br-md{border-bottom-right-radius:.375rem}.xl\\:rounded-bl-md{border-bottom-left-radius:.375rem}.xl\\:rounded-tl-lg{border-top-left-radius:.5rem}.xl\\:rounded-tr-lg{border-top-right-radius:.5rem}.xl\\:rounded-br-lg{border-bottom-right-radius:.5rem}.xl\\:rounded-bl-lg{border-bottom-left-radius:.5rem}.xl\\:rounded-tl-full{border-top-left-radius:9999px}.xl\\:rounded-tr-full{border-top-right-radius:9999px}.xl\\:rounded-br-full{border-bottom-right-radius:9999px}.xl\\:rounded-bl-full{border-bottom-left-radius:9999px}.xl\\:border-solid{border-style:solid}.xl\\:border-dashed{border-style:dashed}.xl\\:border-dotted{border-style:dotted}.xl\\:border-double{border-style:double}.xl\\:border-none{border-style:none}.xl\\:border-0{border-width:0}.xl\\:border-2{border-width:2px}.xl\\:border-4{border-width:4px}.xl\\:border-8{border-width:8px}.xl\\:border{border-width:1px}.xl\\:border-t-0{border-top-width:0}.xl\\:border-r-0{border-right-width:0}.xl\\:border-b-0{border-bottom-width:0}.xl\\:border-l-0{border-left-width:0}.xl\\:border-t-2{border-top-width:2px}.xl\\:border-r-2{border-right-width:2px}.xl\\:border-b-2{border-bottom-width:2px}.xl\\:border-l-2{border-left-width:2px}.xl\\:border-t-4{border-top-width:4px}.xl\\:border-r-4{border-right-width:4px}.xl\\:border-b-4{border-bottom-width:4px}.xl\\:border-l-4{border-left-width:4px}.xl\\:border-t-8{border-top-width:8px}.xl\\:border-r-8{border-right-width:8px}.xl\\:border-b-8{border-bottom-width:8px}.xl\\:border-l-8{border-left-width:8px}.xl\\:border-t{border-top-width:1px}.xl\\:border-r{border-right-width:1px}.xl\\:border-b{border-bottom-width:1px}.xl\\:border-l{border-left-width:1px}.xl\\:box-border{box-sizing:border-box}.xl\\:box-content{box-sizing:initial}.xl\\:cursor-auto{cursor:auto}.xl\\:cursor-default{cursor:default}.xl\\:cursor-pointer{cursor:pointer}.xl\\:cursor-wait{cursor:wait}.xl\\:cursor-text{cursor:text}.xl\\:cursor-move{cursor:move}.xl\\:cursor-not-allowed{cursor:not-allowed}.xl\\:block{display:block}.xl\\:inline-block{display:inline-block}.xl\\:inline{display:inline}.xl\\:flex{display:flex}.xl\\:inline-flex{display:inline-flex}.xl\\:table{display:table}.xl\\:table-caption{display:table-caption}.xl\\:table-cell{display:table-cell}.xl\\:table-column{display:table-column}.xl\\:table-column-group{display:table-column-group}.xl\\:table-footer-group{display:table-footer-group}.xl\\:table-header-group{display:table-header-group}.xl\\:table-row-group{display:table-row-group}.xl\\:table-row{display:table-row}.xl\\:flow-root{display:flow-root}.xl\\:grid{display:grid}.xl\\:inline-grid{display:inline-grid}.xl\\:hidden{display:none}.theme-dark .xl\\:dark\\:block{display:block}.theme-dark .xl\\:dark\\:inline-block{display:inline-block}.theme-dark .xl\\:dark\\:inline{display:inline}.theme-dark .xl\\:dark\\:flex{display:flex}.theme-dark .xl\\:dark\\:inline-flex{display:inline-flex}.theme-dark .xl\\:dark\\:table{display:table}.theme-dark .xl\\:dark\\:table-caption{display:table-caption}.theme-dark .xl\\:dark\\:table-cell{display:table-cell}.theme-dark .xl\\:dark\\:table-column{display:table-column}.theme-dark .xl\\:dark\\:table-column-group{display:table-column-group}.theme-dark .xl\\:dark\\:table-footer-group{display:table-footer-group}.theme-dark .xl\\:dark\\:table-header-group{display:table-header-group}.theme-dark .xl\\:dark\\:table-row-group{display:table-row-group}.theme-dark .xl\\:dark\\:table-row{display:table-row}.theme-dark .xl\\:dark\\:flow-root{display:flow-root}.theme-dark .xl\\:dark\\:grid{display:grid}.theme-dark .xl\\:dark\\:inline-grid{display:inline-grid}.theme-dark .xl\\:dark\\:hidden{display:none}.xl\\:flex-row{flex-direction:row}.xl\\:flex-row-reverse{flex-direction:row-reverse}.xl\\:flex-col{flex-direction:column}.xl\\:flex-col-reverse{flex-direction:column-reverse}.xl\\:flex-wrap{flex-wrap:wrap}.xl\\:flex-wrap-reverse{flex-wrap:wrap-reverse}.xl\\:flex-no-wrap{flex-wrap:nowrap}.xl\\:items-start{align-items:flex-start}.xl\\:items-end{align-items:flex-end}.xl\\:items-center{align-items:center}.xl\\:items-baseline{align-items:baseline}.xl\\:items-stretch{align-items:stretch}.xl\\:self-auto{align-self:auto}.xl\\:self-start{align-self:flex-start}.xl\\:self-end{align-self:flex-end}.xl\\:self-center{align-self:center}.xl\\:self-stretch{align-self:stretch}.xl\\:justify-start{justify-content:flex-start}.xl\\:justify-end{justify-content:flex-end}.xl\\:justify-center{justify-content:center}.xl\\:justify-between{justify-content:space-between}.xl\\:justify-around{justify-content:space-around}.xl\\:justify-evenly{justify-content:space-evenly}.xl\\:content-center{align-content:center}.xl\\:content-start{align-content:flex-start}.xl\\:content-end{align-content:flex-end}.xl\\:content-between{align-content:space-between}.xl\\:content-around{align-content:space-around}.xl\\:flex-1{flex:1 1 0%}.xl\\:flex-auto{flex:1 1 auto}.xl\\:flex-initial{flex:0 1 auto}.xl\\:flex-none{flex:none}.xl\\:flex-grow-0{flex-grow:0}.xl\\:flex-grow{flex-grow:1}.xl\\:flex-shrink-0{flex-shrink:0}.xl\\:flex-shrink{flex-shrink:1}.xl\\:order-1{order:1}.xl\\:order-2{order:2}.xl\\:order-3{order:3}.xl\\:order-4{order:4}.xl\\:order-5{order:5}.xl\\:order-6{order:6}.xl\\:order-7{order:7}.xl\\:order-8{order:8}.xl\\:order-9{order:9}.xl\\:order-10{order:10}.xl\\:order-11{order:11}.xl\\:order-12{order:12}.xl\\:order-first{order:-9999}.xl\\:order-last{order:9999}.xl\\:order-none{order:0}.xl\\:float-right{float:right}.xl\\:float-left{float:left}.xl\\:float-none{float:none}.xl\\:clearfix:after{clear:both;content:\"\";display:table}.xl\\:clear-left{clear:left}.xl\\:clear-right{clear:right}.xl\\:clear-both{clear:both}.xl\\:clear-none{clear:none}.xl\\:font-sans{font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji}.xl\\:font-serif{font-family:Georgia,Cambria,Times New Roman,Times,serif}.xl\\:font-mono{font-family:Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}.xl\\:font-hairline{font-weight:100}.xl\\:font-thin{font-weight:200}.xl\\:font-light{font-weight:300}.xl\\:font-normal{font-weight:400}.xl\\:font-medium{font-weight:500}.xl\\:font-semibold{font-weight:600}.xl\\:font-bold{font-weight:700}.xl\\:font-extrabold{font-weight:800}.xl\\:font-black{font-weight:900}.xl\\:hover\\:font-hairline:hover{font-weight:100}.xl\\:hover\\:font-thin:hover{font-weight:200}.xl\\:hover\\:font-light:hover{font-weight:300}.xl\\:hover\\:font-normal:hover{font-weight:400}.xl\\:hover\\:font-medium:hover{font-weight:500}.xl\\:hover\\:font-semibold:hover{font-weight:600}.xl\\:hover\\:font-bold:hover{font-weight:700}.xl\\:hover\\:font-extrabold:hover{font-weight:800}.xl\\:hover\\:font-black:hover{font-weight:900}.xl\\:focus\\:font-hairline:focus{font-weight:100}.xl\\:focus\\:font-thin:focus{font-weight:200}.xl\\:focus\\:font-light:focus{font-weight:300}.xl\\:focus\\:font-normal:focus{font-weight:400}.xl\\:focus\\:font-medium:focus{font-weight:500}.xl\\:focus\\:font-semibold:focus{font-weight:600}.xl\\:focus\\:font-bold:focus{font-weight:700}.xl\\:focus\\:font-extrabold:focus{font-weight:800}.xl\\:focus\\:font-black:focus{font-weight:900}.xl\\:h-0{height:0}.xl\\:h-1{height:.25rem}.xl\\:h-2{height:.5rem}.xl\\:h-3{height:.75rem}.xl\\:h-4{height:1rem}.xl\\:h-5{height:1.25rem}.xl\\:h-6{height:1.5rem}.xl\\:h-8{height:2rem}.xl\\:h-10{height:2.5rem}.xl\\:h-12{height:3rem}.xl\\:h-16{height:4rem}.xl\\:h-20{height:5rem}.xl\\:h-24{height:6rem}.xl\\:h-32{height:8rem}.xl\\:h-40{height:10rem}.xl\\:h-48{height:12rem}.xl\\:h-56{height:14rem}.xl\\:h-64{height:16rem}.xl\\:h-auto{height:auto}.xl\\:h-px{height:1px}.xl\\:h-full{height:100%}.xl\\:h-screen{height:100vh}.xl\\:text-xs{font-size:.75rem}.xl\\:text-sm{font-size:.875rem}.xl\\:text-base{font-size:1rem}.xl\\:text-lg{font-size:1.125rem}.xl\\:text-xl{font-size:1.25rem}.xl\\:text-2xl{font-size:1.5rem}.xl\\:text-3xl{font-size:1.875rem}.xl\\:text-4xl{font-size:2.25rem}.xl\\:text-5xl{font-size:3rem}.xl\\:text-6xl{font-size:4rem}.xl\\:leading-3{line-height:.75rem}.xl\\:leading-4{line-height:1rem}.xl\\:leading-5{line-height:1.25rem}.xl\\:leading-6{line-height:1.5rem}.xl\\:leading-7{line-height:1.75rem}.xl\\:leading-8{line-height:2rem}.xl\\:leading-9{line-height:2.25rem}.xl\\:leading-10{line-height:2.5rem}.xl\\:leading-none{line-height:1}.xl\\:leading-tight{line-height:1.25}.xl\\:leading-snug{line-height:1.375}.xl\\:leading-normal{line-height:1.5}.xl\\:leading-relaxed{line-height:1.625}.xl\\:leading-loose{line-height:2}.xl\\:list-inside{list-style-position:inside}.xl\\:list-outside{list-style-position:outside}.xl\\:list-none{list-style-type:none}.xl\\:list-disc{list-style-type:disc}.xl\\:list-decimal{list-style-type:decimal}.xl\\:m-0{margin:0}.xl\\:m-1{margin:.25rem}.xl\\:m-2{margin:.5rem}.xl\\:m-3{margin:.75rem}.xl\\:m-4{margin:1rem}.xl\\:m-5{margin:1.25rem}.xl\\:m-6{margin:1.5rem}.xl\\:m-8{margin:2rem}.xl\\:m-10{margin:2.5rem}.xl\\:m-12{margin:3rem}.xl\\:m-16{margin:4rem}.xl\\:m-20{margin:5rem}.xl\\:m-24{margin:6rem}.xl\\:m-32{margin:8rem}.xl\\:m-40{margin:10rem}.xl\\:m-48{margin:12rem}.xl\\:m-56{margin:14rem}.xl\\:m-64{margin:16rem}.xl\\:m-auto{margin:auto}.xl\\:m-px{margin:1px}.xl\\:-m-1{margin:-.25rem}.xl\\:-m-2{margin:-.5rem}.xl\\:-m-3{margin:-.75rem}.xl\\:-m-4{margin:-1rem}.xl\\:-m-5{margin:-1.25rem}.xl\\:-m-6{margin:-1.5rem}.xl\\:-m-8{margin:-2rem}.xl\\:-m-10{margin:-2.5rem}.xl\\:-m-12{margin:-3rem}.xl\\:-m-16{margin:-4rem}.xl\\:-m-20{margin:-5rem}.xl\\:-m-24{margin:-6rem}.xl\\:-m-32{margin:-8rem}.xl\\:-m-40{margin:-10rem}.xl\\:-m-48{margin:-12rem}.xl\\:-m-56{margin:-14rem}.xl\\:-m-64{margin:-16rem}.xl\\:-m-px{margin:-1px}.xl\\:my-0{margin-bottom:0;margin-top:0}.xl\\:mx-0{margin-left:0;margin-right:0}.xl\\:my-1{margin-bottom:.25rem;margin-top:.25rem}.xl\\:mx-1{margin-left:.25rem;margin-right:.25rem}.xl\\:my-2{margin-bottom:.5rem;margin-top:.5rem}.xl\\:mx-2{margin-left:.5rem;margin-right:.5rem}.xl\\:my-3{margin-bottom:.75rem;margin-top:.75rem}.xl\\:mx-3{margin-left:.75rem;margin-right:.75rem}.xl\\:my-4{margin-bottom:1rem;margin-top:1rem}.xl\\:mx-4{margin-left:1rem;margin-right:1rem}.xl\\:my-5{margin-bottom:1.25rem;margin-top:1.25rem}.xl\\:mx-5{margin-left:1.25rem;margin-right:1.25rem}.xl\\:my-6{margin-bottom:1.5rem;margin-top:1.5rem}.xl\\:mx-6{margin-left:1.5rem;margin-right:1.5rem}.xl\\:my-8{margin-bottom:2rem;margin-top:2rem}.xl\\:mx-8{margin-left:2rem;margin-right:2rem}.xl\\:my-10{margin-bottom:2.5rem;margin-top:2.5rem}.xl\\:mx-10{margin-left:2.5rem;margin-right:2.5rem}.xl\\:my-12{margin-bottom:3rem;margin-top:3rem}.xl\\:mx-12{margin-left:3rem;margin-right:3rem}.xl\\:my-16{margin-bottom:4rem;margin-top:4rem}.xl\\:mx-16{margin-left:4rem;margin-right:4rem}.xl\\:my-20{margin-bottom:5rem;margin-top:5rem}.xl\\:mx-20{margin-left:5rem;margin-right:5rem}.xl\\:my-24{margin-bottom:6rem;margin-top:6rem}.xl\\:mx-24{margin-left:6rem;margin-right:6rem}.xl\\:my-32{margin-bottom:8rem;margin-top:8rem}.xl\\:mx-32{margin-left:8rem;margin-right:8rem}.xl\\:my-40{margin-bottom:10rem;margin-top:10rem}.xl\\:mx-40{margin-left:10rem;margin-right:10rem}.xl\\:my-48{margin-bottom:12rem;margin-top:12rem}.xl\\:mx-48{margin-left:12rem;margin-right:12rem}.xl\\:my-56{margin-bottom:14rem;margin-top:14rem}.xl\\:mx-56{margin-left:14rem;margin-right:14rem}.xl\\:my-64{margin-bottom:16rem;margin-top:16rem}.xl\\:mx-64{margin-left:16rem;margin-right:16rem}.xl\\:my-auto{margin-bottom:auto;margin-top:auto}.xl\\:mx-auto{margin-left:auto;margin-right:auto}.xl\\:my-px{margin-bottom:1px;margin-top:1px}.xl\\:mx-px{margin-left:1px;margin-right:1px}.xl\\:-my-1{margin-bottom:-.25rem;margin-top:-.25rem}.xl\\:-mx-1{margin-left:-.25rem;margin-right:-.25rem}.xl\\:-my-2{margin-bottom:-.5rem;margin-top:-.5rem}.xl\\:-mx-2{margin-left:-.5rem;margin-right:-.5rem}.xl\\:-my-3{margin-bottom:-.75rem;margin-top:-.75rem}.xl\\:-mx-3{margin-left:-.75rem;margin-right:-.75rem}.xl\\:-my-4{margin-bottom:-1rem;margin-top:-1rem}.xl\\:-mx-4{margin-left:-1rem;margin-right:-1rem}.xl\\:-my-5{margin-bottom:-1.25rem;margin-top:-1.25rem}.xl\\:-mx-5{margin-left:-1.25rem;margin-right:-1.25rem}.xl\\:-my-6{margin-bottom:-1.5rem;margin-top:-1.5rem}.xl\\:-mx-6{margin-left:-1.5rem;margin-right:-1.5rem}.xl\\:-my-8{margin-bottom:-2rem;margin-top:-2rem}.xl\\:-mx-8{margin-left:-2rem;margin-right:-2rem}.xl\\:-my-10{margin-bottom:-2.5rem;margin-top:-2.5rem}.xl\\:-mx-10{margin-left:-2.5rem;margin-right:-2.5rem}.xl\\:-my-12{margin-bottom:-3rem;margin-top:-3rem}.xl\\:-mx-12{margin-left:-3rem;margin-right:-3rem}.xl\\:-my-16{margin-bottom:-4rem;margin-top:-4rem}.xl\\:-mx-16{margin-left:-4rem;margin-right:-4rem}.xl\\:-my-20{margin-bottom:-5rem;margin-top:-5rem}.xl\\:-mx-20{margin-left:-5rem;margin-right:-5rem}.xl\\:-my-24{margin-bottom:-6rem;margin-top:-6rem}.xl\\:-mx-24{margin-left:-6rem;margin-right:-6rem}.xl\\:-my-32{margin-bottom:-8rem;margin-top:-8rem}.xl\\:-mx-32{margin-left:-8rem;margin-right:-8rem}.xl\\:-my-40{margin-bottom:-10rem;margin-top:-10rem}.xl\\:-mx-40{margin-left:-10rem;margin-right:-10rem}.xl\\:-my-48{margin-bottom:-12rem;margin-top:-12rem}.xl\\:-mx-48{margin-left:-12rem;margin-right:-12rem}.xl\\:-my-56{margin-bottom:-14rem;margin-top:-14rem}.xl\\:-mx-56{margin-left:-14rem;margin-right:-14rem}.xl\\:-my-64{margin-bottom:-16rem;margin-top:-16rem}.xl\\:-mx-64{margin-left:-16rem;margin-right:-16rem}.xl\\:-my-px{margin-bottom:-1px;margin-top:-1px}.xl\\:-mx-px{margin-left:-1px;margin-right:-1px}.xl\\:mt-0{margin-top:0}.xl\\:mr-0{margin-right:0}.xl\\:mb-0{margin-bottom:0}.xl\\:ml-0{margin-left:0}.xl\\:mt-1{margin-top:.25rem}.xl\\:mr-1{margin-right:.25rem}.xl\\:mb-1{margin-bottom:.25rem}.xl\\:ml-1{margin-left:.25rem}.xl\\:mt-2{margin-top:.5rem}.xl\\:mr-2{margin-right:.5rem}.xl\\:mb-2{margin-bottom:.5rem}.xl\\:ml-2{margin-left:.5rem}.xl\\:mt-3{margin-top:.75rem}.xl\\:mr-3{margin-right:.75rem}.xl\\:mb-3{margin-bottom:.75rem}.xl\\:ml-3{margin-left:.75rem}.xl\\:mt-4{margin-top:1rem}.xl\\:mr-4{margin-right:1rem}.xl\\:mb-4{margin-bottom:1rem}.xl\\:ml-4{margin-left:1rem}.xl\\:mt-5{margin-top:1.25rem}.xl\\:mr-5{margin-right:1.25rem}.xl\\:mb-5{margin-bottom:1.25rem}.xl\\:ml-5{margin-left:1.25rem}.xl\\:mt-6{margin-top:1.5rem}.xl\\:mr-6{margin-right:1.5rem}.xl\\:mb-6{margin-bottom:1.5rem}.xl\\:ml-6{margin-left:1.5rem}.xl\\:mt-8{margin-top:2rem}.xl\\:mr-8{margin-right:2rem}.xl\\:mb-8{margin-bottom:2rem}.xl\\:ml-8{margin-left:2rem}.xl\\:mt-10{margin-top:2.5rem}.xl\\:mr-10{margin-right:2.5rem}.xl\\:mb-10{margin-bottom:2.5rem}.xl\\:ml-10{margin-left:2.5rem}.xl\\:mt-12{margin-top:3rem}.xl\\:mr-12{margin-right:3rem}.xl\\:mb-12{margin-bottom:3rem}.xl\\:ml-12{margin-left:3rem}.xl\\:mt-16{margin-top:4rem}.xl\\:mr-16{margin-right:4rem}.xl\\:mb-16{margin-bottom:4rem}.xl\\:ml-16{margin-left:4rem}.xl\\:mt-20{margin-top:5rem}.xl\\:mr-20{margin-right:5rem}.xl\\:mb-20{margin-bottom:5rem}.xl\\:ml-20{margin-left:5rem}.xl\\:mt-24{margin-top:6rem}.xl\\:mr-24{margin-right:6rem}.xl\\:mb-24{margin-bottom:6rem}.xl\\:ml-24{margin-left:6rem}.xl\\:mt-32{margin-top:8rem}.xl\\:mr-32{margin-right:8rem}.xl\\:mb-32{margin-bottom:8rem}.xl\\:ml-32{margin-left:8rem}.xl\\:mt-40{margin-top:10rem}.xl\\:mr-40{margin-right:10rem}.xl\\:mb-40{margin-bottom:10rem}.xl\\:ml-40{margin-left:10rem}.xl\\:mt-48{margin-top:12rem}.xl\\:mr-48{margin-right:12rem}.xl\\:mb-48{margin-bottom:12rem}.xl\\:ml-48{margin-left:12rem}.xl\\:mt-56{margin-top:14rem}.xl\\:mr-56{margin-right:14rem}.xl\\:mb-56{margin-bottom:14rem}.xl\\:ml-56{margin-left:14rem}.xl\\:mt-64{margin-top:16rem}.xl\\:mr-64{margin-right:16rem}.xl\\:mb-64{margin-bottom:16rem}.xl\\:ml-64{margin-left:16rem}.xl\\:mt-auto{margin-top:auto}.xl\\:mr-auto{margin-right:auto}.xl\\:mb-auto{margin-bottom:auto}.xl\\:ml-auto{margin-left:auto}.xl\\:mt-px{margin-top:1px}.xl\\:mr-px{margin-right:1px}.xl\\:mb-px{margin-bottom:1px}.xl\\:ml-px{margin-left:1px}.xl\\:-mt-1{margin-top:-.25rem}.xl\\:-mr-1{margin-right:-.25rem}.xl\\:-mb-1{margin-bottom:-.25rem}.xl\\:-ml-1{margin-left:-.25rem}.xl\\:-mt-2{margin-top:-.5rem}.xl\\:-mr-2{margin-right:-.5rem}.xl\\:-mb-2{margin-bottom:-.5rem}.xl\\:-ml-2{margin-left:-.5rem}.xl\\:-mt-3{margin-top:-.75rem}.xl\\:-mr-3{margin-right:-.75rem}.xl\\:-mb-3{margin-bottom:-.75rem}.xl\\:-ml-3{margin-left:-.75rem}.xl\\:-mt-4{margin-top:-1rem}.xl\\:-mr-4{margin-right:-1rem}.xl\\:-mb-4{margin-bottom:-1rem}.xl\\:-ml-4{margin-left:-1rem}.xl\\:-mt-5{margin-top:-1.25rem}.xl\\:-mr-5{margin-right:-1.25rem}.xl\\:-mb-5{margin-bottom:-1.25rem}.xl\\:-ml-5{margin-left:-1.25rem}.xl\\:-mt-6{margin-top:-1.5rem}.xl\\:-mr-6{margin-right:-1.5rem}.xl\\:-mb-6{margin-bottom:-1.5rem}.xl\\:-ml-6{margin-left:-1.5rem}.xl\\:-mt-8{margin-top:-2rem}.xl\\:-mr-8{margin-right:-2rem}.xl\\:-mb-8{margin-bottom:-2rem}.xl\\:-ml-8{margin-left:-2rem}.xl\\:-mt-10{margin-top:-2.5rem}.xl\\:-mr-10{margin-right:-2.5rem}.xl\\:-mb-10{margin-bottom:-2.5rem}.xl\\:-ml-10{margin-left:-2.5rem}.xl\\:-mt-12{margin-top:-3rem}.xl\\:-mr-12{margin-right:-3rem}.xl\\:-mb-12{margin-bottom:-3rem}.xl\\:-ml-12{margin-left:-3rem}.xl\\:-mt-16{margin-top:-4rem}.xl\\:-mr-16{margin-right:-4rem}.xl\\:-mb-16{margin-bottom:-4rem}.xl\\:-ml-16{margin-left:-4rem}.xl\\:-mt-20{margin-top:-5rem}.xl\\:-mr-20{margin-right:-5rem}.xl\\:-mb-20{margin-bottom:-5rem}.xl\\:-ml-20{margin-left:-5rem}.xl\\:-mt-24{margin-top:-6rem}.xl\\:-mr-24{margin-right:-6rem}.xl\\:-mb-24{margin-bottom:-6rem}.xl\\:-ml-24{margin-left:-6rem}.xl\\:-mt-32{margin-top:-8rem}.xl\\:-mr-32{margin-right:-8rem}.xl\\:-mb-32{margin-bottom:-8rem}.xl\\:-ml-32{margin-left:-8rem}.xl\\:-mt-40{margin-top:-10rem}.xl\\:-mr-40{margin-right:-10rem}.xl\\:-mb-40{margin-bottom:-10rem}.xl\\:-ml-40{margin-left:-10rem}.xl\\:-mt-48{margin-top:-12rem}.xl\\:-mr-48{margin-right:-12rem}.xl\\:-mb-48{margin-bottom:-12rem}.xl\\:-ml-48{margin-left:-12rem}.xl\\:-mt-56{margin-top:-14rem}.xl\\:-mr-56{margin-right:-14rem}.xl\\:-mb-56{margin-bottom:-14rem}.xl\\:-ml-56{margin-left:-14rem}.xl\\:-mt-64{margin-top:-16rem}.xl\\:-mr-64{margin-right:-16rem}.xl\\:-mb-64{margin-bottom:-16rem}.xl\\:-ml-64{margin-left:-16rem}.xl\\:-mt-px{margin-top:-1px}.xl\\:-mr-px{margin-right:-1px}.xl\\:-mb-px{margin-bottom:-1px}.xl\\:-ml-px{margin-left:-1px}.xl\\:last\\:m-0:last-child{margin:0}.xl\\:last\\:m-1:last-child{margin:.25rem}.xl\\:last\\:m-2:last-child{margin:.5rem}.xl\\:last\\:m-3:last-child{margin:.75rem}.xl\\:last\\:m-4:last-child{margin:1rem}.xl\\:last\\:m-5:last-child{margin:1.25rem}.xl\\:last\\:m-6:last-child{margin:1.5rem}.xl\\:last\\:m-8:last-child{margin:2rem}.xl\\:last\\:m-10:last-child{margin:2.5rem}.xl\\:last\\:m-12:last-child{margin:3rem}.xl\\:last\\:m-16:last-child{margin:4rem}.xl\\:last\\:m-20:last-child{margin:5rem}.xl\\:last\\:m-24:last-child{margin:6rem}.xl\\:last\\:m-32:last-child{margin:8rem}.xl\\:last\\:m-40:last-child{margin:10rem}.xl\\:last\\:m-48:last-child{margin:12rem}.xl\\:last\\:m-56:last-child{margin:14rem}.xl\\:last\\:m-64:last-child{margin:16rem}.xl\\:last\\:m-auto:last-child{margin:auto}.xl\\:last\\:m-px:last-child{margin:1px}.xl\\:last\\:-m-1:last-child{margin:-.25rem}.xl\\:last\\:-m-2:last-child{margin:-.5rem}.xl\\:last\\:-m-3:last-child{margin:-.75rem}.xl\\:last\\:-m-4:last-child{margin:-1rem}.xl\\:last\\:-m-5:last-child{margin:-1.25rem}.xl\\:last\\:-m-6:last-child{margin:-1.5rem}.xl\\:last\\:-m-8:last-child{margin:-2rem}.xl\\:last\\:-m-10:last-child{margin:-2.5rem}.xl\\:last\\:-m-12:last-child{margin:-3rem}.xl\\:last\\:-m-16:last-child{margin:-4rem}.xl\\:last\\:-m-20:last-child{margin:-5rem}.xl\\:last\\:-m-24:last-child{margin:-6rem}.xl\\:last\\:-m-32:last-child{margin:-8rem}.xl\\:last\\:-m-40:last-child{margin:-10rem}.xl\\:last\\:-m-48:last-child{margin:-12rem}.xl\\:last\\:-m-56:last-child{margin:-14rem}.xl\\:last\\:-m-64:last-child{margin:-16rem}.xl\\:last\\:-m-px:last-child{margin:-1px}.xl\\:last\\:my-0:last-child{margin-bottom:0;margin-top:0}.xl\\:last\\:mx-0:last-child{margin-left:0;margin-right:0}.xl\\:last\\:my-1:last-child{margin-bottom:.25rem;margin-top:.25rem}.xl\\:last\\:mx-1:last-child{margin-left:.25rem;margin-right:.25rem}.xl\\:last\\:my-2:last-child{margin-bottom:.5rem;margin-top:.5rem}.xl\\:last\\:mx-2:last-child{margin-left:.5rem;margin-right:.5rem}.xl\\:last\\:my-3:last-child{margin-bottom:.75rem;margin-top:.75rem}.xl\\:last\\:mx-3:last-child{margin-left:.75rem;margin-right:.75rem}.xl\\:last\\:my-4:last-child{margin-bottom:1rem;margin-top:1rem}.xl\\:last\\:mx-4:last-child{margin-left:1rem;margin-right:1rem}.xl\\:last\\:my-5:last-child{margin-bottom:1.25rem;margin-top:1.25rem}.xl\\:last\\:mx-5:last-child{margin-left:1.25rem;margin-right:1.25rem}.xl\\:last\\:my-6:last-child{margin-bottom:1.5rem;margin-top:1.5rem}.xl\\:last\\:mx-6:last-child{margin-left:1.5rem;margin-right:1.5rem}.xl\\:last\\:my-8:last-child{margin-bottom:2rem;margin-top:2rem}.xl\\:last\\:mx-8:last-child{margin-left:2rem;margin-right:2rem}.xl\\:last\\:my-10:last-child{margin-bottom:2.5rem;margin-top:2.5rem}.xl\\:last\\:mx-10:last-child{margin-left:2.5rem;margin-right:2.5rem}.xl\\:last\\:my-12:last-child{margin-bottom:3rem;margin-top:3rem}.xl\\:last\\:mx-12:last-child{margin-left:3rem;margin-right:3rem}.xl\\:last\\:my-16:last-child{margin-bottom:4rem;margin-top:4rem}.xl\\:last\\:mx-16:last-child{margin-left:4rem;margin-right:4rem}.xl\\:last\\:my-20:last-child{margin-bottom:5rem;margin-top:5rem}.xl\\:last\\:mx-20:last-child{margin-left:5rem;margin-right:5rem}.xl\\:last\\:my-24:last-child{margin-bottom:6rem;margin-top:6rem}.xl\\:last\\:mx-24:last-child{margin-left:6rem;margin-right:6rem}.xl\\:last\\:my-32:last-child{margin-bottom:8rem;margin-top:8rem}.xl\\:last\\:mx-32:last-child{margin-left:8rem;margin-right:8rem}.xl\\:last\\:my-40:last-child{margin-bottom:10rem;margin-top:10rem}.xl\\:last\\:mx-40:last-child{margin-left:10rem;margin-right:10rem}.xl\\:last\\:my-48:last-child{margin-bottom:12rem;margin-top:12rem}.xl\\:last\\:mx-48:last-child{margin-left:12rem;margin-right:12rem}.xl\\:last\\:my-56:last-child{margin-bottom:14rem;margin-top:14rem}.xl\\:last\\:mx-56:last-child{margin-left:14rem;margin-right:14rem}.xl\\:last\\:my-64:last-child{margin-bottom:16rem;margin-top:16rem}.xl\\:last\\:mx-64:last-child{margin-left:16rem;margin-right:16rem}.xl\\:last\\:my-auto:last-child{margin-bottom:auto;margin-top:auto}.xl\\:last\\:mx-auto:last-child{margin-left:auto;margin-right:auto}.xl\\:last\\:my-px:last-child{margin-bottom:1px;margin-top:1px}.xl\\:last\\:mx-px:last-child{margin-left:1px;margin-right:1px}.xl\\:last\\:-my-1:last-child{margin-bottom:-.25rem;margin-top:-.25rem}.xl\\:last\\:-mx-1:last-child{margin-left:-.25rem;margin-right:-.25rem}.xl\\:last\\:-my-2:last-child{margin-bottom:-.5rem;margin-top:-.5rem}.xl\\:last\\:-mx-2:last-child{margin-left:-.5rem;margin-right:-.5rem}.xl\\:last\\:-my-3:last-child{margin-bottom:-.75rem;margin-top:-.75rem}.xl\\:last\\:-mx-3:last-child{margin-left:-.75rem;margin-right:-.75rem}.xl\\:last\\:-my-4:last-child{margin-bottom:-1rem;margin-top:-1rem}.xl\\:last\\:-mx-4:last-child{margin-left:-1rem;margin-right:-1rem}.xl\\:last\\:-my-5:last-child{margin-bottom:-1.25rem;margin-top:-1.25rem}.xl\\:last\\:-mx-5:last-child{margin-left:-1.25rem;margin-right:-1.25rem}.xl\\:last\\:-my-6:last-child{margin-bottom:-1.5rem;margin-top:-1.5rem}.xl\\:last\\:-mx-6:last-child{margin-left:-1.5rem;margin-right:-1.5rem}.xl\\:last\\:-my-8:last-child{margin-bottom:-2rem;margin-top:-2rem}.xl\\:last\\:-mx-8:last-child{margin-left:-2rem;margin-right:-2rem}.xl\\:last\\:-my-10:last-child{margin-bottom:-2.5rem;margin-top:-2.5rem}.xl\\:last\\:-mx-10:last-child{margin-left:-2.5rem;margin-right:-2.5rem}.xl\\:last\\:-my-12:last-child{margin-bottom:-3rem;margin-top:-3rem}.xl\\:last\\:-mx-12:last-child{margin-left:-3rem;margin-right:-3rem}.xl\\:last\\:-my-16:last-child{margin-bottom:-4rem;margin-top:-4rem}.xl\\:last\\:-mx-16:last-child{margin-left:-4rem;margin-right:-4rem}.xl\\:last\\:-my-20:last-child{margin-bottom:-5rem;margin-top:-5rem}.xl\\:last\\:-mx-20:last-child{margin-left:-5rem;margin-right:-5rem}.xl\\:last\\:-my-24:last-child{margin-bottom:-6rem;margin-top:-6rem}.xl\\:last\\:-mx-24:last-child{margin-left:-6rem;margin-right:-6rem}.xl\\:last\\:-my-32:last-child{margin-bottom:-8rem;margin-top:-8rem}.xl\\:last\\:-mx-32:last-child{margin-left:-8rem;margin-right:-8rem}.xl\\:last\\:-my-40:last-child{margin-bottom:-10rem;margin-top:-10rem}.xl\\:last\\:-mx-40:last-child{margin-left:-10rem;margin-right:-10rem}.xl\\:last\\:-my-48:last-child{margin-bottom:-12rem;margin-top:-12rem}.xl\\:last\\:-mx-48:last-child{margin-left:-12rem;margin-right:-12rem}.xl\\:last\\:-my-56:last-child{margin-bottom:-14rem;margin-top:-14rem}.xl\\:last\\:-mx-56:last-child{margin-left:-14rem;margin-right:-14rem}.xl\\:last\\:-my-64:last-child{margin-bottom:-16rem;margin-top:-16rem}.xl\\:last\\:-mx-64:last-child{margin-left:-16rem;margin-right:-16rem}.xl\\:last\\:-my-px:last-child{margin-bottom:-1px;margin-top:-1px}.xl\\:last\\:-mx-px:last-child{margin-left:-1px;margin-right:-1px}.xl\\:last\\:mt-0:last-child{margin-top:0}.xl\\:last\\:mr-0:last-child{margin-right:0}.xl\\:last\\:mb-0:last-child{margin-bottom:0}.xl\\:last\\:ml-0:last-child{margin-left:0}.xl\\:last\\:mt-1:last-child{margin-top:.25rem}.xl\\:last\\:mr-1:last-child{margin-right:.25rem}.xl\\:last\\:mb-1:last-child{margin-bottom:.25rem}.xl\\:last\\:ml-1:last-child{margin-left:.25rem}.xl\\:last\\:mt-2:last-child{margin-top:.5rem}.xl\\:last\\:mr-2:last-child{margin-right:.5rem}.xl\\:last\\:mb-2:last-child{margin-bottom:.5rem}.xl\\:last\\:ml-2:last-child{margin-left:.5rem}.xl\\:last\\:mt-3:last-child{margin-top:.75rem}.xl\\:last\\:mr-3:last-child{margin-right:.75rem}.xl\\:last\\:mb-3:last-child{margin-bottom:.75rem}.xl\\:last\\:ml-3:last-child{margin-left:.75rem}.xl\\:last\\:mt-4:last-child{margin-top:1rem}.xl\\:last\\:mr-4:last-child{margin-right:1rem}.xl\\:last\\:mb-4:last-child{margin-bottom:1rem}.xl\\:last\\:ml-4:last-child{margin-left:1rem}.xl\\:last\\:mt-5:last-child{margin-top:1.25rem}.xl\\:last\\:mr-5:last-child{margin-right:1.25rem}.xl\\:last\\:mb-5:last-child{margin-bottom:1.25rem}.xl\\:last\\:ml-5:last-child{margin-left:1.25rem}.xl\\:last\\:mt-6:last-child{margin-top:1.5rem}.xl\\:last\\:mr-6:last-child{margin-right:1.5rem}.xl\\:last\\:mb-6:last-child{margin-bottom:1.5rem}.xl\\:last\\:ml-6:last-child{margin-left:1.5rem}.xl\\:last\\:mt-8:last-child{margin-top:2rem}.xl\\:last\\:mr-8:last-child{margin-right:2rem}.xl\\:last\\:mb-8:last-child{margin-bottom:2rem}.xl\\:last\\:ml-8:last-child{margin-left:2rem}.xl\\:last\\:mt-10:last-child{margin-top:2.5rem}.xl\\:last\\:mr-10:last-child{margin-right:2.5rem}.xl\\:last\\:mb-10:last-child{margin-bottom:2.5rem}.xl\\:last\\:ml-10:last-child{margin-left:2.5rem}.xl\\:last\\:mt-12:last-child{margin-top:3rem}.xl\\:last\\:mr-12:last-child{margin-right:3rem}.xl\\:last\\:mb-12:last-child{margin-bottom:3rem}.xl\\:last\\:ml-12:last-child{margin-left:3rem}.xl\\:last\\:mt-16:last-child{margin-top:4rem}.xl\\:last\\:mr-16:last-child{margin-right:4rem}.xl\\:last\\:mb-16:last-child{margin-bottom:4rem}.xl\\:last\\:ml-16:last-child{margin-left:4rem}.xl\\:last\\:mt-20:last-child{margin-top:5rem}.xl\\:last\\:mr-20:last-child{margin-right:5rem}.xl\\:last\\:mb-20:last-child{margin-bottom:5rem}.xl\\:last\\:ml-20:last-child{margin-left:5rem}.xl\\:last\\:mt-24:last-child{margin-top:6rem}.xl\\:last\\:mr-24:last-child{margin-right:6rem}.xl\\:last\\:mb-24:last-child{margin-bottom:6rem}.xl\\:last\\:ml-24:last-child{margin-left:6rem}.xl\\:last\\:mt-32:last-child{margin-top:8rem}.xl\\:last\\:mr-32:last-child{margin-right:8rem}.xl\\:last\\:mb-32:last-child{margin-bottom:8rem}.xl\\:last\\:ml-32:last-child{margin-left:8rem}.xl\\:last\\:mt-40:last-child{margin-top:10rem}.xl\\:last\\:mr-40:last-child{margin-right:10rem}.xl\\:last\\:mb-40:last-child{margin-bottom:10rem}.xl\\:last\\:ml-40:last-child{margin-left:10rem}.xl\\:last\\:mt-48:last-child{margin-top:12rem}.xl\\:last\\:mr-48:last-child{margin-right:12rem}.xl\\:last\\:mb-48:last-child{margin-bottom:12rem}.xl\\:last\\:ml-48:last-child{margin-left:12rem}.xl\\:last\\:mt-56:last-child{margin-top:14rem}.xl\\:last\\:mr-56:last-child{margin-right:14rem}.xl\\:last\\:mb-56:last-child{margin-bottom:14rem}.xl\\:last\\:ml-56:last-child{margin-left:14rem}.xl\\:last\\:mt-64:last-child{margin-top:16rem}.xl\\:last\\:mr-64:last-child{margin-right:16rem}.xl\\:last\\:mb-64:last-child{margin-bottom:16rem}.xl\\:last\\:ml-64:last-child{margin-left:16rem}.xl\\:last\\:mt-auto:last-child{margin-top:auto}.xl\\:last\\:mr-auto:last-child{margin-right:auto}.xl\\:last\\:mb-auto:last-child{margin-bottom:auto}.xl\\:last\\:ml-auto:last-child{margin-left:auto}.xl\\:last\\:mt-px:last-child{margin-top:1px}.xl\\:last\\:mr-px:last-child{margin-right:1px}.xl\\:last\\:mb-px:last-child{margin-bottom:1px}.xl\\:last\\:ml-px:last-child{margin-left:1px}.xl\\:last\\:-mt-1:last-child{margin-top:-.25rem}.xl\\:last\\:-mr-1:last-child{margin-right:-.25rem}.xl\\:last\\:-mb-1:last-child{margin-bottom:-.25rem}.xl\\:last\\:-ml-1:last-child{margin-left:-.25rem}.xl\\:last\\:-mt-2:last-child{margin-top:-.5rem}.xl\\:last\\:-mr-2:last-child{margin-right:-.5rem}.xl\\:last\\:-mb-2:last-child{margin-bottom:-.5rem}.xl\\:last\\:-ml-2:last-child{margin-left:-.5rem}.xl\\:last\\:-mt-3:last-child{margin-top:-.75rem}.xl\\:last\\:-mr-3:last-child{margin-right:-.75rem}.xl\\:last\\:-mb-3:last-child{margin-bottom:-.75rem}.xl\\:last\\:-ml-3:last-child{margin-left:-.75rem}.xl\\:last\\:-mt-4:last-child{margin-top:-1rem}.xl\\:last\\:-mr-4:last-child{margin-right:-1rem}.xl\\:last\\:-mb-4:last-child{margin-bottom:-1rem}.xl\\:last\\:-ml-4:last-child{margin-left:-1rem}.xl\\:last\\:-mt-5:last-child{margin-top:-1.25rem}.xl\\:last\\:-mr-5:last-child{margin-right:-1.25rem}.xl\\:last\\:-mb-5:last-child{margin-bottom:-1.25rem}.xl\\:last\\:-ml-5:last-child{margin-left:-1.25rem}.xl\\:last\\:-mt-6:last-child{margin-top:-1.5rem}.xl\\:last\\:-mr-6:last-child{margin-right:-1.5rem}.xl\\:last\\:-mb-6:last-child{margin-bottom:-1.5rem}.xl\\:last\\:-ml-6:last-child{margin-left:-1.5rem}.xl\\:last\\:-mt-8:last-child{margin-top:-2rem}.xl\\:last\\:-mr-8:last-child{margin-right:-2rem}.xl\\:last\\:-mb-8:last-child{margin-bottom:-2rem}.xl\\:last\\:-ml-8:last-child{margin-left:-2rem}.xl\\:last\\:-mt-10:last-child{margin-top:-2.5rem}.xl\\:last\\:-mr-10:last-child{margin-right:-2.5rem}.xl\\:last\\:-mb-10:last-child{margin-bottom:-2.5rem}.xl\\:last\\:-ml-10:last-child{margin-left:-2.5rem}.xl\\:last\\:-mt-12:last-child{margin-top:-3rem}.xl\\:last\\:-mr-12:last-child{margin-right:-3rem}.xl\\:last\\:-mb-12:last-child{margin-bottom:-3rem}.xl\\:last\\:-ml-12:last-child{margin-left:-3rem}.xl\\:last\\:-mt-16:last-child{margin-top:-4rem}.xl\\:last\\:-mr-16:last-child{margin-right:-4rem}.xl\\:last\\:-mb-16:last-child{margin-bottom:-4rem}.xl\\:last\\:-ml-16:last-child{margin-left:-4rem}.xl\\:last\\:-mt-20:last-child{margin-top:-5rem}.xl\\:last\\:-mr-20:last-child{margin-right:-5rem}.xl\\:last\\:-mb-20:last-child{margin-bottom:-5rem}.xl\\:last\\:-ml-20:last-child{margin-left:-5rem}.xl\\:last\\:-mt-24:last-child{margin-top:-6rem}.xl\\:last\\:-mr-24:last-child{margin-right:-6rem}.xl\\:last\\:-mb-24:last-child{margin-bottom:-6rem}.xl\\:last\\:-ml-24:last-child{margin-left:-6rem}.xl\\:last\\:-mt-32:last-child{margin-top:-8rem}.xl\\:last\\:-mr-32:last-child{margin-right:-8rem}.xl\\:last\\:-mb-32:last-child{margin-bottom:-8rem}.xl\\:last\\:-ml-32:last-child{margin-left:-8rem}.xl\\:last\\:-mt-40:last-child{margin-top:-10rem}.xl\\:last\\:-mr-40:last-child{margin-right:-10rem}.xl\\:last\\:-mb-40:last-child{margin-bottom:-10rem}.xl\\:last\\:-ml-40:last-child{margin-left:-10rem}.xl\\:last\\:-mt-48:last-child{margin-top:-12rem}.xl\\:last\\:-mr-48:last-child{margin-right:-12rem}.xl\\:last\\:-mb-48:last-child{margin-bottom:-12rem}.xl\\:last\\:-ml-48:last-child{margin-left:-12rem}.xl\\:last\\:-mt-56:last-child{margin-top:-14rem}.xl\\:last\\:-mr-56:last-child{margin-right:-14rem}.xl\\:last\\:-mb-56:last-child{margin-bottom:-14rem}.xl\\:last\\:-ml-56:last-child{margin-left:-14rem}.xl\\:last\\:-mt-64:last-child{margin-top:-16rem}.xl\\:last\\:-mr-64:last-child{margin-right:-16rem}.xl\\:last\\:-mb-64:last-child{margin-bottom:-16rem}.xl\\:last\\:-ml-64:last-child{margin-left:-16rem}.xl\\:last\\:-mt-px:last-child{margin-top:-1px}.xl\\:last\\:-mr-px:last-child{margin-right:-1px}.xl\\:last\\:-mb-px:last-child{margin-bottom:-1px}.xl\\:last\\:-ml-px:last-child{margin-left:-1px}.xl\\:max-h-0{max-height:0}.xl\\:max-h-1{max-height:.25rem}.xl\\:max-h-2{max-height:.5rem}.xl\\:max-h-3{max-height:.75rem}.xl\\:max-h-4{max-height:1rem}.xl\\:max-h-5{max-height:1.25rem}.xl\\:max-h-6{max-height:1.5rem}.xl\\:max-h-8{max-height:2rem}.xl\\:max-h-10{max-height:2.5rem}.xl\\:max-h-12{max-height:3rem}.xl\\:max-h-16{max-height:4rem}.xl\\:max-h-20{max-height:5rem}.xl\\:max-h-24{max-height:6rem}.xl\\:max-h-32{max-height:8rem}.xl\\:max-h-40{max-height:10rem}.xl\\:max-h-48{max-height:12rem}.xl\\:max-h-56{max-height:14rem}.xl\\:max-h-64{max-height:16rem}.xl\\:max-h-xl{max-height:36rem}.xl\\:max-h-px{max-height:1px}.xl\\:max-w-none{max-width:none}.xl\\:max-w-xs{max-width:20rem}.xl\\:max-w-sm{max-width:24rem}.xl\\:max-w-md{max-width:28rem}.xl\\:max-w-lg{max-width:32rem}.xl\\:max-w-xl{max-width:36rem}.xl\\:max-w-2xl{max-width:42rem}.xl\\:max-w-3xl{max-width:48rem}.xl\\:max-w-4xl{max-width:56rem}.xl\\:max-w-5xl{max-width:64rem}.xl\\:max-w-6xl{max-width:72rem}.xl\\:max-w-full{max-width:100%}.xl\\:max-w-screen-sm{max-width:640px}.xl\\:max-w-screen-md{max-width:768px}.xl\\:max-w-screen-lg{max-width:1024px}.xl\\:max-w-screen-xl{max-width:1280px}.xl\\:min-h-0{min-height:0}.xl\\:min-h-full{min-height:100%}.xl\\:min-h-screen{min-height:100vh}.xl\\:min-w-0{min-width:0}.xl\\:min-w-1{min-width:.25rem}.xl\\:min-w-2{min-width:.5rem}.xl\\:min-w-3{min-width:.75rem}.xl\\:min-w-4{min-width:1rem}.xl\\:min-w-5{min-width:1.25rem}.xl\\:min-w-6{min-width:1.5rem}.xl\\:min-w-8{min-width:2rem}.xl\\:min-w-10{min-width:2.5rem}.xl\\:min-w-12{min-width:3rem}.xl\\:min-w-16{min-width:4rem}.xl\\:min-w-20{min-width:5rem}.xl\\:min-w-24{min-width:6rem}.xl\\:min-w-32{min-width:8rem}.xl\\:min-w-40{min-width:10rem}.xl\\:min-w-48{min-width:12rem}.xl\\:min-w-56{min-width:14rem}.xl\\:min-w-64{min-width:16rem}.xl\\:min-w-max-content{min-width:-webkit-max-content;min-width:max-content}.xl\\:min-w-px{min-width:1px}.xl\\:object-contain{object-fit:contain}.xl\\:object-cover{object-fit:cover}.xl\\:object-fill{object-fit:fill}.xl\\:object-none{object-fit:none}.xl\\:object-scale-down{object-fit:scale-down}.xl\\:object-bottom{object-position:bottom}.xl\\:object-center{object-position:center}.xl\\:object-left{object-position:left}.xl\\:object-left-bottom{object-position:left bottom}.xl\\:object-left-top{object-position:left top}.xl\\:object-right{object-position:right}.xl\\:object-right-bottom{object-position:right bottom}.xl\\:object-right-top{object-position:right top}.xl\\:object-top{object-position:top}.xl\\:opacity-0{opacity:0}.xl\\:opacity-25{opacity:.25}.xl\\:opacity-50{opacity:.5}.xl\\:opacity-75{opacity:.75}.xl\\:opacity-100{opacity:1}.xl\\:hover\\:opacity-0:hover{opacity:0}.xl\\:hover\\:opacity-25:hover{opacity:.25}.xl\\:hover\\:opacity-50:hover{opacity:.5}.xl\\:hover\\:opacity-75:hover{opacity:.75}.xl\\:hover\\:opacity-100:hover{opacity:1}.xl\\:focus\\:opacity-0:focus{opacity:0}.xl\\:focus\\:opacity-25:focus{opacity:.25}.xl\\:focus\\:opacity-50:focus{opacity:.5}.xl\\:focus\\:opacity-75:focus{opacity:.75}.xl\\:focus\\:opacity-100:focus{opacity:1}.xl\\:focus\\:outline-none:focus,.xl\\:outline-none{outline:0}.xl\\:overflow-auto{overflow:auto}.xl\\:overflow-hidden{overflow:hidden}.xl\\:overflow-visible{overflow:visible}.xl\\:overflow-scroll{overflow:scroll}.xl\\:overflow-x-auto{overflow-x:auto}.xl\\:overflow-y-auto{overflow-y:auto}.xl\\:overflow-x-hidden{overflow-x:hidden}.xl\\:overflow-y-hidden{overflow-y:hidden}.xl\\:overflow-x-visible{overflow-x:visible}.xl\\:overflow-y-visible{overflow-y:visible}.xl\\:overflow-x-scroll{overflow-x:scroll}.xl\\:overflow-y-scroll{overflow-y:scroll}.xl\\:scrolling-touch{-webkit-overflow-scrolling:touch}.xl\\:scrolling-auto{-webkit-overflow-scrolling:auto}.xl\\:p-0{padding:0}.xl\\:p-1{padding:.25rem}.xl\\:p-2{padding:.5rem}.xl\\:p-3{padding:.75rem}.xl\\:p-4{padding:1rem}.xl\\:p-5{padding:1.25rem}.xl\\:p-6{padding:1.5rem}.xl\\:p-8{padding:2rem}.xl\\:p-10{padding:2.5rem}.xl\\:p-12{padding:3rem}.xl\\:p-16{padding:4rem}.xl\\:p-20{padding:5rem}.xl\\:p-24{padding:6rem}.xl\\:p-32{padding:8rem}.xl\\:p-40{padding:10rem}.xl\\:p-48{padding:12rem}.xl\\:p-56{padding:14rem}.xl\\:p-64{padding:16rem}.xl\\:p-px{padding:1px}.xl\\:py-0{padding-bottom:0;padding-top:0}.xl\\:px-0{padding-left:0;padding-right:0}.xl\\:py-1{padding-bottom:.25rem;padding-top:.25rem}.xl\\:px-1{padding-left:.25rem;padding-right:.25rem}.xl\\:py-2{padding-bottom:.5rem;padding-top:.5rem}.xl\\:px-2{padding-left:.5rem;padding-right:.5rem}.xl\\:py-3{padding-bottom:.75rem;padding-top:.75rem}.xl\\:px-3{padding-left:.75rem;padding-right:.75rem}.xl\\:py-4{padding-bottom:1rem;padding-top:1rem}.xl\\:px-4{padding-left:1rem;padding-right:1rem}.xl\\:py-5{padding-bottom:1.25rem;padding-top:1.25rem}.xl\\:px-5{padding-left:1.25rem;padding-right:1.25rem}.xl\\:py-6{padding-bottom:1.5rem;padding-top:1.5rem}.xl\\:px-6{padding-left:1.5rem;padding-right:1.5rem}.xl\\:py-8{padding-bottom:2rem;padding-top:2rem}.xl\\:px-8{padding-left:2rem;padding-right:2rem}.xl\\:py-10{padding-bottom:2.5rem;padding-top:2.5rem}.xl\\:px-10{padding-left:2.5rem;padding-right:2.5rem}.xl\\:py-12{padding-bottom:3rem;padding-top:3rem}.xl\\:px-12{padding-left:3rem;padding-right:3rem}.xl\\:py-16{padding-bottom:4rem;padding-top:4rem}.xl\\:px-16{padding-left:4rem;padding-right:4rem}.xl\\:py-20{padding-bottom:5rem;padding-top:5rem}.xl\\:px-20{padding-left:5rem;padding-right:5rem}.xl\\:py-24{padding-bottom:6rem;padding-top:6rem}.xl\\:px-24{padding-left:6rem;padding-right:6rem}.xl\\:py-32{padding-bottom:8rem;padding-top:8rem}.xl\\:px-32{padding-left:8rem;padding-right:8rem}.xl\\:py-40{padding-bottom:10rem;padding-top:10rem}.xl\\:px-40{padding-left:10rem;padding-right:10rem}.xl\\:py-48{padding-bottom:12rem;padding-top:12rem}.xl\\:px-48{padding-left:12rem;padding-right:12rem}.xl\\:py-56{padding-bottom:14rem;padding-top:14rem}.xl\\:px-56{padding-left:14rem;padding-right:14rem}.xl\\:py-64{padding-bottom:16rem;padding-top:16rem}.xl\\:px-64{padding-left:16rem;padding-right:16rem}.xl\\:py-px{padding-bottom:1px;padding-top:1px}.xl\\:px-px{padding-left:1px;padding-right:1px}.xl\\:pt-0{padding-top:0}.xl\\:pr-0{padding-right:0}.xl\\:pb-0{padding-bottom:0}.xl\\:pl-0{padding-left:0}.xl\\:pt-1{padding-top:.25rem}.xl\\:pr-1{padding-right:.25rem}.xl\\:pb-1{padding-bottom:.25rem}.xl\\:pl-1{padding-left:.25rem}.xl\\:pt-2{padding-top:.5rem}.xl\\:pr-2{padding-right:.5rem}.xl\\:pb-2{padding-bottom:.5rem}.xl\\:pl-2{padding-left:.5rem}.xl\\:pt-3{padding-top:.75rem}.xl\\:pr-3{padding-right:.75rem}.xl\\:pb-3{padding-bottom:.75rem}.xl\\:pl-3{padding-left:.75rem}.xl\\:pt-4{padding-top:1rem}.xl\\:pr-4{padding-right:1rem}.xl\\:pb-4{padding-bottom:1rem}.xl\\:pl-4{padding-left:1rem}.xl\\:pt-5{padding-top:1.25rem}.xl\\:pr-5{padding-right:1.25rem}.xl\\:pb-5{padding-bottom:1.25rem}.xl\\:pl-5{padding-left:1.25rem}.xl\\:pt-6{padding-top:1.5rem}.xl\\:pr-6{padding-right:1.5rem}.xl\\:pb-6{padding-bottom:1.5rem}.xl\\:pl-6{padding-left:1.5rem}.xl\\:pt-8{padding-top:2rem}.xl\\:pr-8{padding-right:2rem}.xl\\:pb-8{padding-bottom:2rem}.xl\\:pl-8{padding-left:2rem}.xl\\:pt-10{padding-top:2.5rem}.xl\\:pr-10{padding-right:2.5rem}.xl\\:pb-10{padding-bottom:2.5rem}.xl\\:pl-10{padding-left:2.5rem}.xl\\:pt-12{padding-top:3rem}.xl\\:pr-12{padding-right:3rem}.xl\\:pb-12{padding-bottom:3rem}.xl\\:pl-12{padding-left:3rem}.xl\\:pt-16{padding-top:4rem}.xl\\:pr-16{padding-right:4rem}.xl\\:pb-16{padding-bottom:4rem}.xl\\:pl-16{padding-left:4rem}.xl\\:pt-20{padding-top:5rem}.xl\\:pr-20{padding-right:5rem}.xl\\:pb-20{padding-bottom:5rem}.xl\\:pl-20{padding-left:5rem}.xl\\:pt-24{padding-top:6rem}.xl\\:pr-24{padding-right:6rem}.xl\\:pb-24{padding-bottom:6rem}.xl\\:pl-24{padding-left:6rem}.xl\\:pt-32{padding-top:8rem}.xl\\:pr-32{padding-right:8rem}.xl\\:pb-32{padding-bottom:8rem}.xl\\:pl-32{padding-left:8rem}.xl\\:pt-40{padding-top:10rem}.xl\\:pr-40{padding-right:10rem}.xl\\:pb-40{padding-bottom:10rem}.xl\\:pl-40{padding-left:10rem}.xl\\:pt-48{padding-top:12rem}.xl\\:pr-48{padding-right:12rem}.xl\\:pb-48{padding-bottom:12rem}.xl\\:pl-48{padding-left:12rem}.xl\\:pt-56{padding-top:14rem}.xl\\:pr-56{padding-right:14rem}.xl\\:pb-56{padding-bottom:14rem}.xl\\:pl-56{padding-left:14rem}.xl\\:pt-64{padding-top:16rem}.xl\\:pr-64{padding-right:16rem}.xl\\:pb-64{padding-bottom:16rem}.xl\\:pl-64{padding-left:16rem}.xl\\:pt-px{padding-top:1px}.xl\\:pr-px{padding-right:1px}.xl\\:pb-px{padding-bottom:1px}.xl\\:pl-px{padding-left:1px}.xl\\:placeholder-transparent::placeholder{color:#0000}.xl\\:placeholder-white::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.xl\\:placeholder-black::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.xl\\:placeholder-gray-50::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.xl\\:placeholder-gray-100::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.xl\\:placeholder-gray-200::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.xl\\:placeholder-gray-300::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.xl\\:placeholder-gray-400::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.xl\\:placeholder-gray-500::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.xl\\:placeholder-gray-600::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.xl\\:placeholder-gray-700::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.xl\\:placeholder-gray-800::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.xl\\:placeholder-gray-900::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.xl\\:placeholder-cool-gray-50::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.xl\\:placeholder-cool-gray-100::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.xl\\:placeholder-cool-gray-200::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.xl\\:placeholder-cool-gray-300::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.xl\\:placeholder-cool-gray-400::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.xl\\:placeholder-cool-gray-500::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.xl\\:placeholder-cool-gray-600::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.xl\\:placeholder-cool-gray-700::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.xl\\:placeholder-cool-gray-800::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.xl\\:placeholder-cool-gray-900::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.xl\\:placeholder-red-50::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.xl\\:placeholder-red-100::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.xl\\:placeholder-red-200::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.xl\\:placeholder-red-300::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.xl\\:placeholder-red-400::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.xl\\:placeholder-red-500::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.xl\\:placeholder-red-600::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.xl\\:placeholder-red-700::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.xl\\:placeholder-red-800::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.xl\\:placeholder-red-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.xl\\:placeholder-orange-50::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.xl\\:placeholder-orange-100::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.xl\\:placeholder-orange-200::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.xl\\:placeholder-orange-300::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.xl\\:placeholder-orange-400::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.xl\\:placeholder-orange-500::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.xl\\:placeholder-orange-600::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.xl\\:placeholder-orange-700::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.xl\\:placeholder-orange-800::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.xl\\:placeholder-orange-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.xl\\:placeholder-yellow-50::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.xl\\:placeholder-yellow-100::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.xl\\:placeholder-yellow-200::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.xl\\:placeholder-yellow-300::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.xl\\:placeholder-yellow-400::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.xl\\:placeholder-yellow-500::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.xl\\:placeholder-yellow-600::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.xl\\:placeholder-yellow-700::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.xl\\:placeholder-yellow-800::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.xl\\:placeholder-yellow-900::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.xl\\:placeholder-green-50::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.xl\\:placeholder-green-100::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.xl\\:placeholder-green-200::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.xl\\:placeholder-green-300::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.xl\\:placeholder-green-400::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.xl\\:placeholder-green-500::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.xl\\:placeholder-green-600::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.xl\\:placeholder-green-700::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.xl\\:placeholder-green-800::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.xl\\:placeholder-green-900::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.xl\\:placeholder-teal-50::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.xl\\:placeholder-teal-100::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.xl\\:placeholder-teal-200::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.xl\\:placeholder-teal-300::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.xl\\:placeholder-teal-400::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.xl\\:placeholder-teal-500::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.xl\\:placeholder-teal-600::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.xl\\:placeholder-teal-700::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.xl\\:placeholder-teal-800::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.xl\\:placeholder-teal-900::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.xl\\:placeholder-blue-50::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.xl\\:placeholder-blue-100::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.xl\\:placeholder-blue-200::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.xl\\:placeholder-blue-300::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.xl\\:placeholder-blue-400::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.xl\\:placeholder-blue-500::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.xl\\:placeholder-blue-600::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.xl\\:placeholder-blue-700::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.xl\\:placeholder-blue-800::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.xl\\:placeholder-blue-900::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.xl\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.xl\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.xl\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.xl\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.xl\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.xl\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.xl\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.xl\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.xl\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.xl\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.xl\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.xl\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.xl\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.xl\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.xl\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.xl\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.xl\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.xl\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.xl\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.xl\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.xl\\:placeholder-pink-50::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.xl\\:placeholder-pink-100::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.xl\\:placeholder-pink-200::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.xl\\:placeholder-pink-300::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.xl\\:placeholder-pink-400::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.xl\\:placeholder-pink-500::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.xl\\:placeholder-pink-600::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.xl\\:placeholder-pink-700::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.xl\\:placeholder-pink-800::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.xl\\:placeholder-pink-900::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-transparent:focus::placeholder{color:#0000}.xl\\:focus\\:placeholder-white:focus::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-black:focus::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-gray-50:focus::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-gray-300:focus::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-gray-400:focus::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-gray-500:focus::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-gray-600:focus::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-gray-700:focus::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-gray-800:focus::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-gray-900:focus::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-cool-gray-50:focus::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-cool-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-cool-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-cool-gray-300:focus::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-cool-gray-400:focus::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-cool-gray-500:focus::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-cool-gray-600:focus::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-cool-gray-700:focus::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-cool-gray-800:focus::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-cool-gray-900:focus::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-red-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-red-100:focus::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-red-200:focus::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-red-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-red-400:focus::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-red-500:focus::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-red-600:focus::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-red-700:focus::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-red-800:focus::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-red-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-orange-50:focus::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-orange-100:focus::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-orange-200:focus::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-orange-300:focus::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-orange-400:focus::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-orange-500:focus::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-orange-600:focus::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-orange-700:focus::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-orange-800:focus::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-orange-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-yellow-50:focus::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-yellow-100:focus::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-yellow-200:focus::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-yellow-300:focus::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-yellow-400:focus::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-yellow-500:focus::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-yellow-600:focus::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-yellow-700:focus::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-yellow-800:focus::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-yellow-900:focus::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-green-50:focus::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-green-100:focus::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-green-200:focus::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-green-300:focus::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-green-400:focus::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-green-500:focus::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-green-600:focus::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-green-700:focus::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-green-800:focus::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-green-900:focus::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-teal-50:focus::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-teal-100:focus::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-teal-200:focus::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-teal-300:focus::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-teal-400:focus::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-teal-500:focus::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-teal-600:focus::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-teal-700:focus::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-teal-800:focus::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-teal-900:focus::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-blue-50:focus::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-blue-100:focus::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-blue-200:focus::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-blue-300:focus::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-blue-400:focus::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-blue-500:focus::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-blue-600:focus::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-blue-700:focus::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-blue-800:focus::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-blue-900:focus::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-pink-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-pink-100:focus::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-pink-200:focus::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-pink-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-pink-400:focus::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-pink-500:focus::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-pink-600:focus::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-pink-700:focus::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-pink-800:focus::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.xl\\:focus\\:placeholder-pink-900:focus::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-transparent::placeholder{color:#0000}.theme-dark .xl\\:dark\\:placeholder-white::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-black::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-gray-50::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-gray-100::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-gray-200::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-gray-300::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-gray-400::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-gray-500::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-gray-600::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-gray-700::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-gray-800::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-gray-900::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-cool-gray-50::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-cool-gray-100::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-cool-gray-200::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-cool-gray-300::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-cool-gray-400::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-cool-gray-500::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-cool-gray-600::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-cool-gray-700::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-cool-gray-800::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-cool-gray-900::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-red-50::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-red-100::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-red-200::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-red-300::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-red-400::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-red-500::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-red-600::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-red-700::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-red-800::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-red-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-orange-50::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-orange-100::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-orange-200::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-orange-300::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-orange-400::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-orange-500::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-orange-600::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-orange-700::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-orange-800::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-orange-900::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-yellow-50::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-yellow-100::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-yellow-200::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-yellow-300::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-yellow-400::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-yellow-500::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-yellow-600::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-yellow-700::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-yellow-800::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-yellow-900::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-green-50::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-green-100::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-green-200::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-green-300::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-green-400::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-green-500::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-green-600::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-green-700::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-green-800::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-green-900::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-teal-50::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-teal-100::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-teal-200::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-teal-300::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-teal-400::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-teal-500::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-teal-600::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-teal-700::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-teal-800::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-teal-900::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-blue-50::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-blue-100::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-blue-200::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-blue-300::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-blue-400::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-blue-500::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-blue-600::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-blue-700::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-blue-800::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-blue-900::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-50::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-100::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-200::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-300::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-400::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-500::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-600::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-700::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-800::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-indigo-900::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-pink-50::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-pink-100::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-pink-200::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-pink-300::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-pink-400::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-pink-500::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-pink-600::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-pink-700::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-pink-800::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:placeholder-pink-900::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-transparent:focus::placeholder{color:#0000}.theme-dark .xl\\:dark\\:focus\\:placeholder-white:focus::placeholder{--placeholder-opacity:1;color:#fff;color:rgba(255,255,255,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-black:focus::placeholder{--placeholder-opacity:1;color:#000;color:rgba(0,0,0,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-gray-50:focus::placeholder{--placeholder-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-gray-300:focus::placeholder{--placeholder-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-gray-400:focus::placeholder{--placeholder-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-gray-500:focus::placeholder{--placeholder-opacity:1;color:#707275;color:rgba(112,114,117,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-gray-600:focus::placeholder{--placeholder-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-gray-700:focus::placeholder{--placeholder-opacity:1;color:#24262d;color:rgba(36,38,45,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-gray-800:focus::placeholder{--placeholder-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-gray-900:focus::placeholder{--placeholder-opacity:1;color:#121317;color:rgba(18,19,23,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-50:focus::placeholder{--placeholder-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-100:focus::placeholder{--placeholder-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-200:focus::placeholder{--placeholder-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-300:focus::placeholder{--placeholder-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-400:focus::placeholder{--placeholder-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-500:focus::placeholder{--placeholder-opacity:1;color:#64748b;color:rgba(100,116,139,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-600:focus::placeholder{--placeholder-opacity:1;color:#475569;color:rgba(71,85,105,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-700:focus::placeholder{--placeholder-opacity:1;color:#364152;color:rgba(54,65,82,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-800:focus::placeholder{--placeholder-opacity:1;color:#27303f;color:rgba(39,48,63,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-cool-gray-900:focus::placeholder{--placeholder-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-red-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-red-100:focus::placeholder{--placeholder-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-red-200:focus::placeholder{--placeholder-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-red-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-red-400:focus::placeholder{--placeholder-opacity:1;color:#f98080;color:rgba(249,128,128,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-red-500:focus::placeholder{--placeholder-opacity:1;color:#f05252;color:rgba(240,82,82,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-red-600:focus::placeholder{--placeholder-opacity:1;color:#e02424;color:rgba(224,36,36,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-red-700:focus::placeholder{--placeholder-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-red-800:focus::placeholder{--placeholder-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-red-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-orange-50:focus::placeholder{--placeholder-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-orange-100:focus::placeholder{--placeholder-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-orange-200:focus::placeholder{--placeholder-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-orange-300:focus::placeholder{--placeholder-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-orange-400:focus::placeholder{--placeholder-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-orange-500:focus::placeholder{--placeholder-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-orange-600:focus::placeholder{--placeholder-opacity:1;color:#d03801;color:rgba(208,56,1,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-orange-700:focus::placeholder{--placeholder-opacity:1;color:#b43403;color:rgba(180,52,3,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-orange-800:focus::placeholder{--placeholder-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-orange-900:focus::placeholder{--placeholder-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-50:focus::placeholder{--placeholder-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-100:focus::placeholder{--placeholder-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-200:focus::placeholder{--placeholder-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-300:focus::placeholder{--placeholder-opacity:1;color:#faca15;color:rgba(250,202,21,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-400:focus::placeholder{--placeholder-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-500:focus::placeholder{--placeholder-opacity:1;color:#c27803;color:rgba(194,120,3,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-600:focus::placeholder{--placeholder-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-700:focus::placeholder{--placeholder-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-800:focus::placeholder{--placeholder-opacity:1;color:#723b13;color:rgba(114,59,19,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-yellow-900:focus::placeholder{--placeholder-opacity:1;color:#633112;color:rgba(99,49,18,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-green-50:focus::placeholder{--placeholder-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-green-100:focus::placeholder{--placeholder-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-green-200:focus::placeholder{--placeholder-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-green-300:focus::placeholder{--placeholder-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-green-400:focus::placeholder{--placeholder-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-green-500:focus::placeholder{--placeholder-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-green-600:focus::placeholder{--placeholder-opacity:1;color:#057a55;color:rgba(5,122,85,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-green-700:focus::placeholder{--placeholder-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-green-800:focus::placeholder{--placeholder-opacity:1;color:#03543f;color:rgba(3,84,63,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-green-900:focus::placeholder{--placeholder-opacity:1;color:#014737;color:rgba(1,71,55,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-teal-50:focus::placeholder{--placeholder-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-teal-100:focus::placeholder{--placeholder-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-teal-200:focus::placeholder{--placeholder-opacity:1;color:#afecef;color:rgba(175,236,239,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-teal-300:focus::placeholder{--placeholder-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-teal-400:focus::placeholder{--placeholder-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-teal-500:focus::placeholder{--placeholder-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-teal-600:focus::placeholder{--placeholder-opacity:1;color:#047481;color:rgba(4,116,129,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-teal-700:focus::placeholder{--placeholder-opacity:1;color:#036672;color:rgba(3,102,114,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-teal-800:focus::placeholder{--placeholder-opacity:1;color:#05505c;color:rgba(5,80,92,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-teal-900:focus::placeholder{--placeholder-opacity:1;color:#014451;color:rgba(1,68,81,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-blue-50:focus::placeholder{--placeholder-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-blue-100:focus::placeholder{--placeholder-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-blue-200:focus::placeholder{--placeholder-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-blue-300:focus::placeholder{--placeholder-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-blue-400:focus::placeholder{--placeholder-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-blue-500:focus::placeholder{--placeholder-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-blue-600:focus::placeholder{--placeholder-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-blue-700:focus::placeholder{--placeholder-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-blue-800:focus::placeholder{--placeholder-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-blue-900:focus::placeholder{--placeholder-opacity:1;color:#233876;color:rgba(35,56,118,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#42389d;color:rgba(66,56,157,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#362f78;color:rgba(54,47,120,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-50:focus::placeholder{--placeholder-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-100:focus::placeholder{--placeholder-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-200:focus::placeholder{--placeholder-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-300:focus::placeholder{--placeholder-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-400:focus::placeholder{--placeholder-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-500:focus::placeholder{--placeholder-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-600:focus::placeholder{--placeholder-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-700:focus::placeholder{--placeholder-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-800:focus::placeholder{--placeholder-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-indigo-900:focus::placeholder{--placeholder-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-pink-50:focus::placeholder{--placeholder-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-pink-100:focus::placeholder{--placeholder-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-pink-200:focus::placeholder{--placeholder-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-pink-300:focus::placeholder{--placeholder-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-pink-400:focus::placeholder{--placeholder-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-pink-500:focus::placeholder{--placeholder-opacity:1;color:#e74694;color:rgba(231,70,148,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-pink-600:focus::placeholder{--placeholder-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-pink-700:focus::placeholder{--placeholder-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-pink-800:focus::placeholder{--placeholder-opacity:1;color:#99154b;color:rgba(153,21,75,var(--placeholder-opacity))}.theme-dark .xl\\:dark\\:focus\\:placeholder-pink-900:focus::placeholder{--placeholder-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--placeholder-opacity))}.xl\\:placeholder-opacity-0::placeholder{--placeholder-opacity:0}.xl\\:placeholder-opacity-25::placeholder{--placeholder-opacity:0.25}.xl\\:placeholder-opacity-50::placeholder{--placeholder-opacity:0.5}.xl\\:placeholder-opacity-75::placeholder{--placeholder-opacity:0.75}.xl\\:placeholder-opacity-100::placeholder{--placeholder-opacity:1}.xl\\:focus\\:placeholder-opacity-0:focus::placeholder{--placeholder-opacity:0}.xl\\:focus\\:placeholder-opacity-25:focus::placeholder{--placeholder-opacity:0.25}.xl\\:focus\\:placeholder-opacity-50:focus::placeholder{--placeholder-opacity:0.5}.xl\\:focus\\:placeholder-opacity-75:focus::placeholder{--placeholder-opacity:0.75}.xl\\:focus\\:placeholder-opacity-100:focus::placeholder{--placeholder-opacity:1}.xl\\:pointer-events-none{pointer-events:none}.xl\\:pointer-events-auto{pointer-events:auto}.xl\\:static{position:static}.xl\\:fixed{position:fixed}.xl\\:absolute{position:absolute}.xl\\:relative{position:relative}.xl\\:sticky{position:-webkit-sticky;position:sticky}.xl\\:inset-0{bottom:0;left:0;right:0;top:0}.xl\\:inset-auto{bottom:auto;left:auto;right:auto;top:auto}.xl\\:inset-y-0{bottom:0;top:0}.xl\\:inset-x-0{left:0;right:0}.xl\\:inset-y-auto{bottom:auto;top:auto}.xl\\:inset-x-auto{left:auto;right:auto}.xl\\:top-0{top:0}.xl\\:right-0{right:0}.xl\\:bottom-0{bottom:0}.xl\\:left-0{left:0}.xl\\:top-auto{top:auto}.xl\\:right-auto{right:auto}.xl\\:bottom-auto{bottom:auto}.xl\\:left-auto{left:auto}.xl\\:resize-none{resize:none}.xl\\:resize-y{resize:vertical}.xl\\:resize-x{resize:horizontal}.xl\\:resize{resize:both}.xl\\:shadow-xs{box-shadow:0 0 0 1px #0000000d}.xl\\:shadow-sm{box-shadow:0 1px 2px 0 #0000000d}.xl\\:shadow{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.xl\\:shadow-md{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.xl\\:shadow-lg{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.xl\\:shadow-xl{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.xl\\:shadow-2xl{box-shadow:0 25px 50px -12px #00000040}.xl\\:shadow-inner{box-shadow:inset 0 2px 4px 0 #0000000f}.xl\\:shadow-outline{box-shadow:0 0 0 3px #4299e180}.xl\\:shadow-none{box-shadow:none}.xl\\:shadow-bottom{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.xl\\:hover\\:shadow-xs:hover{box-shadow:0 0 0 1px #0000000d}.xl\\:hover\\:shadow-sm:hover{box-shadow:0 1px 2px 0 #0000000d}.xl\\:hover\\:shadow:hover{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.xl\\:hover\\:shadow-md:hover{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.xl\\:hover\\:shadow-lg:hover{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.xl\\:hover\\:shadow-xl:hover{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.xl\\:hover\\:shadow-2xl:hover{box-shadow:0 25px 50px -12px #00000040}.xl\\:hover\\:shadow-inner:hover{box-shadow:inset 0 2px 4px 0 #0000000f}.xl\\:hover\\:shadow-outline:hover{box-shadow:0 0 0 3px #4299e180}.xl\\:hover\\:shadow-none:hover{box-shadow:none}.xl\\:hover\\:shadow-bottom:hover{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.xl\\:focus\\:shadow-xs:focus{box-shadow:0 0 0 1px #0000000d}.xl\\:focus\\:shadow-sm:focus{box-shadow:0 1px 2px 0 #0000000d}.xl\\:focus\\:shadow:focus{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.xl\\:focus\\:shadow-md:focus{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.xl\\:focus\\:shadow-lg:focus{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.xl\\:focus\\:shadow-xl:focus{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.xl\\:focus\\:shadow-2xl:focus{box-shadow:0 25px 50px -12px #00000040}.xl\\:focus\\:shadow-inner:focus{box-shadow:inset 0 2px 4px 0 #0000000f}.xl\\:focus\\:shadow-outline:focus{box-shadow:0 0 0 3px #4299e180}.xl\\:focus\\:shadow-none:focus{box-shadow:none}.xl\\:focus\\:shadow-bottom:focus{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.theme-dark .xl\\:dark\\:focus\\:shadow-xs:focus{box-shadow:0 0 0 1px #0000000d}.theme-dark .xl\\:dark\\:focus\\:shadow-sm:focus{box-shadow:0 1px 2px 0 #0000000d}.theme-dark .xl\\:dark\\:focus\\:shadow:focus{box-shadow:0 1px 3px 0 #0000001a,0 1px 2px 0 #0000000f}.theme-dark .xl\\:dark\\:focus\\:shadow-md:focus{box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f}.theme-dark .xl\\:dark\\:focus\\:shadow-lg:focus{box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.theme-dark .xl\\:dark\\:focus\\:shadow-xl:focus{box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a}.theme-dark .xl\\:dark\\:focus\\:shadow-2xl:focus{box-shadow:0 25px 50px -12px #00000040}.theme-dark .xl\\:dark\\:focus\\:shadow-inner:focus{box-shadow:inset 0 2px 4px 0 #0000000f}.theme-dark .xl\\:dark\\:focus\\:shadow-outline:focus{box-shadow:0 0 0 3px #4299e180}.theme-dark .xl\\:dark\\:focus\\:shadow-none:focus{box-shadow:none}.theme-dark .xl\\:dark\\:focus\\:shadow-bottom:focus{box-shadow:0 5px 6px -7px #0009,0 2px 4px -5px #0000000f}.xl\\:fill-current{fill:currentColor}.xl\\:stroke-current{stroke:currentColor}.xl\\:stroke-0{stroke-width:0}.xl\\:stroke-1{stroke-width:1}.xl\\:stroke-2{stroke-width:2}.xl\\:table-auto{table-layout:auto}.xl\\:table-fixed{table-layout:fixed}.xl\\:text-left{text-align:left}.xl\\:text-center{text-align:center}.xl\\:text-right{text-align:right}.xl\\:text-justify{text-align:justify}.xl\\:text-transparent{color:#0000}.xl\\:text-white{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.xl\\:text-black{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.xl\\:text-gray-50{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.xl\\:text-gray-100{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.xl\\:text-gray-200{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.xl\\:text-gray-300{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.xl\\:text-gray-400{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.xl\\:text-gray-500{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.xl\\:text-gray-600{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.xl\\:text-gray-700{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.xl\\:text-gray-800{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.xl\\:text-gray-900{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.xl\\:text-cool-gray-50{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.xl\\:text-cool-gray-100{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.xl\\:text-cool-gray-200{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.xl\\:text-cool-gray-300{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.xl\\:text-cool-gray-400{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.xl\\:text-cool-gray-500{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.xl\\:text-cool-gray-600{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.xl\\:text-cool-gray-700{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.xl\\:text-cool-gray-800{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.xl\\:text-cool-gray-900{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.xl\\:text-red-50{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.xl\\:text-red-100{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.xl\\:text-red-200{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.xl\\:text-red-300{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.xl\\:text-red-400{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.xl\\:text-red-500{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.xl\\:text-red-600{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.xl\\:text-red-700{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.xl\\:text-red-800{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.xl\\:text-red-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.xl\\:text-orange-50{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.xl\\:text-orange-100{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.xl\\:text-orange-200{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.xl\\:text-orange-300{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.xl\\:text-orange-400{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.xl\\:text-orange-500{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.xl\\:text-orange-600{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.xl\\:text-orange-700{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.xl\\:text-orange-800{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.xl\\:text-orange-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.xl\\:text-yellow-50{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.xl\\:text-yellow-100{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.xl\\:text-yellow-200{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.xl\\:text-yellow-300{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.xl\\:text-yellow-400{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.xl\\:text-yellow-500{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.xl\\:text-yellow-600{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.xl\\:text-yellow-700{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.xl\\:text-yellow-800{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.xl\\:text-yellow-900{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.xl\\:text-green-50{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.xl\\:text-green-100{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.xl\\:text-green-200{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.xl\\:text-green-300{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.xl\\:text-green-400{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.xl\\:text-green-500{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.xl\\:text-green-600{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.xl\\:text-green-700{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.xl\\:text-green-800{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.xl\\:text-green-900{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.xl\\:text-teal-50{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.xl\\:text-teal-100{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.xl\\:text-teal-200{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.xl\\:text-teal-300{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.xl\\:text-teal-400{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.xl\\:text-teal-500{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.xl\\:text-teal-600{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.xl\\:text-teal-700{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.xl\\:text-teal-800{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.xl\\:text-teal-900{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.xl\\:text-blue-50{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.xl\\:text-blue-100{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.xl\\:text-blue-200{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.xl\\:text-blue-300{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.xl\\:text-blue-400{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.xl\\:text-blue-500{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.xl\\:text-blue-600{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.xl\\:text-blue-700{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.xl\\:text-blue-800{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.xl\\:text-blue-900{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.xl\\:text-indigo-50{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.xl\\:text-indigo-100{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.xl\\:text-indigo-200{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.xl\\:text-indigo-300{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.xl\\:text-indigo-400{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.xl\\:text-indigo-500{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.xl\\:text-indigo-600{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.xl\\:text-indigo-700{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.xl\\:text-indigo-800{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.xl\\:text-indigo-900{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.xl\\:text-indigo-50{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.xl\\:text-indigo-100{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.xl\\:text-indigo-200{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.xl\\:text-indigo-300{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.xl\\:text-indigo-400{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.xl\\:text-indigo-500{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.xl\\:text-indigo-600{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.xl\\:text-indigo-700{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.xl\\:text-indigo-800{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.xl\\:text-indigo-900{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.xl\\:text-pink-50{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.xl\\:text-pink-100{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.xl\\:text-pink-200{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.xl\\:text-pink-300{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.xl\\:text-pink-400{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.xl\\:text-pink-500{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.xl\\:text-pink-600{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.xl\\:text-pink-700{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.xl\\:text-pink-800{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.xl\\:text-pink-900{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.xl\\:focus\\:text-transparent:focus{color:#0000}.xl\\:focus\\:text-white:focus{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.xl\\:focus\\:text-black:focus{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.xl\\:focus\\:text-gray-50:focus{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.xl\\:focus\\:text-gray-100:focus{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.xl\\:focus\\:text-gray-200:focus{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.xl\\:focus\\:text-gray-300:focus{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.xl\\:focus\\:text-gray-400:focus{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.xl\\:focus\\:text-gray-500:focus{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.xl\\:focus\\:text-gray-600:focus{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.xl\\:focus\\:text-gray-700:focus{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.xl\\:focus\\:text-gray-800:focus{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.xl\\:focus\\:text-gray-900:focus{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.xl\\:focus\\:text-cool-gray-50:focus{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.xl\\:focus\\:text-cool-gray-100:focus{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.xl\\:focus\\:text-cool-gray-200:focus{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.xl\\:focus\\:text-cool-gray-300:focus{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.xl\\:focus\\:text-cool-gray-400:focus{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.xl\\:focus\\:text-cool-gray-500:focus{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.xl\\:focus\\:text-cool-gray-600:focus{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.xl\\:focus\\:text-cool-gray-700:focus{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.xl\\:focus\\:text-cool-gray-800:focus{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.xl\\:focus\\:text-cool-gray-900:focus{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.xl\\:focus\\:text-red-50:focus{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.xl\\:focus\\:text-red-100:focus{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.xl\\:focus\\:text-red-200:focus{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.xl\\:focus\\:text-red-300:focus{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.xl\\:focus\\:text-red-400:focus{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.xl\\:focus\\:text-red-500:focus{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.xl\\:focus\\:text-red-600:focus{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.xl\\:focus\\:text-red-700:focus{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.xl\\:focus\\:text-red-800:focus{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.xl\\:focus\\:text-red-900:focus{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.xl\\:focus\\:text-orange-50:focus{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.xl\\:focus\\:text-orange-100:focus{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.xl\\:focus\\:text-orange-200:focus{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.xl\\:focus\\:text-orange-300:focus{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.xl\\:focus\\:text-orange-400:focus{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.xl\\:focus\\:text-orange-500:focus{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.xl\\:focus\\:text-orange-600:focus{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.xl\\:focus\\:text-orange-700:focus{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.xl\\:focus\\:text-orange-800:focus{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.xl\\:focus\\:text-orange-900:focus{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.xl\\:focus\\:text-yellow-50:focus{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.xl\\:focus\\:text-yellow-100:focus{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.xl\\:focus\\:text-yellow-200:focus{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.xl\\:focus\\:text-yellow-300:focus{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.xl\\:focus\\:text-yellow-400:focus{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.xl\\:focus\\:text-yellow-500:focus{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.xl\\:focus\\:text-yellow-600:focus{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.xl\\:focus\\:text-yellow-700:focus{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.xl\\:focus\\:text-yellow-800:focus{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.xl\\:focus\\:text-yellow-900:focus{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.xl\\:focus\\:text-green-50:focus{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.xl\\:focus\\:text-green-100:focus{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.xl\\:focus\\:text-green-200:focus{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.xl\\:focus\\:text-green-300:focus{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.xl\\:focus\\:text-green-400:focus{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.xl\\:focus\\:text-green-500:focus{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.xl\\:focus\\:text-green-600:focus{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.xl\\:focus\\:text-green-700:focus{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.xl\\:focus\\:text-green-800:focus{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.xl\\:focus\\:text-green-900:focus{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.xl\\:focus\\:text-teal-50:focus{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.xl\\:focus\\:text-teal-100:focus{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.xl\\:focus\\:text-teal-200:focus{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.xl\\:focus\\:text-teal-300:focus{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.xl\\:focus\\:text-teal-400:focus{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.xl\\:focus\\:text-teal-500:focus{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.xl\\:focus\\:text-teal-600:focus{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.xl\\:focus\\:text-teal-700:focus{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.xl\\:focus\\:text-teal-800:focus{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.xl\\:focus\\:text-teal-900:focus{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.xl\\:focus\\:text-blue-50:focus{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.xl\\:focus\\:text-blue-100:focus{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.xl\\:focus\\:text-blue-200:focus{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.xl\\:focus\\:text-blue-300:focus{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.xl\\:focus\\:text-blue-400:focus{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.xl\\:focus\\:text-blue-500:focus{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.xl\\:focus\\:text-blue-600:focus{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.xl\\:focus\\:text-blue-700:focus{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.xl\\:focus\\:text-blue-800:focus{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.xl\\:focus\\:text-blue-900:focus{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.xl\\:focus\\:text-indigo-50:focus{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.xl\\:focus\\:text-indigo-100:focus{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.xl\\:focus\\:text-indigo-200:focus{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.xl\\:focus\\:text-indigo-300:focus{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.xl\\:focus\\:text-indigo-400:focus{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.xl\\:focus\\:text-indigo-500:focus{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.xl\\:focus\\:text-indigo-600:focus{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.xl\\:focus\\:text-indigo-700:focus{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.xl\\:focus\\:text-indigo-800:focus{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.xl\\:focus\\:text-indigo-900:focus{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.xl\\:focus\\:text-indigo-50:focus{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.xl\\:focus\\:text-indigo-100:focus{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.xl\\:focus\\:text-indigo-200:focus{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.xl\\:focus\\:text-indigo-300:focus{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.xl\\:focus\\:text-indigo-400:focus{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.xl\\:focus\\:text-indigo-500:focus{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.xl\\:focus\\:text-indigo-600:focus{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.xl\\:focus\\:text-indigo-700:focus{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.xl\\:focus\\:text-indigo-800:focus{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.xl\\:focus\\:text-indigo-900:focus{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.xl\\:focus\\:text-pink-50:focus{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.xl\\:focus\\:text-pink-100:focus{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.xl\\:focus\\:text-pink-200:focus{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.xl\\:focus\\:text-pink-300:focus{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.xl\\:focus\\:text-pink-400:focus{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.xl\\:focus\\:text-pink-500:focus{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.xl\\:focus\\:text-pink-600:focus{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.xl\\:focus\\:text-pink-700:focus{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.xl\\:focus\\:text-pink-800:focus{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.xl\\:focus\\:text-pink-900:focus{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.xl\\:focus-within\\:text-transparent:focus-within{color:#0000}.xl\\:focus-within\\:text-white:focus-within{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.xl\\:focus-within\\:text-black:focus-within{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.xl\\:focus-within\\:text-gray-50:focus-within{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.xl\\:focus-within\\:text-gray-100:focus-within{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.xl\\:focus-within\\:text-gray-200:focus-within{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.xl\\:focus-within\\:text-gray-300:focus-within{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.xl\\:focus-within\\:text-gray-400:focus-within{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.xl\\:focus-within\\:text-gray-500:focus-within{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.xl\\:focus-within\\:text-gray-600:focus-within{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.xl\\:focus-within\\:text-gray-700:focus-within{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.xl\\:focus-within\\:text-gray-800:focus-within{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.xl\\:focus-within\\:text-gray-900:focus-within{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.xl\\:focus-within\\:text-cool-gray-50:focus-within{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.xl\\:focus-within\\:text-cool-gray-100:focus-within{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.xl\\:focus-within\\:text-cool-gray-200:focus-within{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.xl\\:focus-within\\:text-cool-gray-300:focus-within{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.xl\\:focus-within\\:text-cool-gray-400:focus-within{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.xl\\:focus-within\\:text-cool-gray-500:focus-within{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.xl\\:focus-within\\:text-cool-gray-600:focus-within{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.xl\\:focus-within\\:text-cool-gray-700:focus-within{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.xl\\:focus-within\\:text-cool-gray-800:focus-within{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.xl\\:focus-within\\:text-cool-gray-900:focus-within{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.xl\\:focus-within\\:text-red-50:focus-within{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.xl\\:focus-within\\:text-red-100:focus-within{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.xl\\:focus-within\\:text-red-200:focus-within{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.xl\\:focus-within\\:text-red-300:focus-within{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.xl\\:focus-within\\:text-red-400:focus-within{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.xl\\:focus-within\\:text-red-500:focus-within{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.xl\\:focus-within\\:text-red-600:focus-within{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.xl\\:focus-within\\:text-red-700:focus-within{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.xl\\:focus-within\\:text-red-800:focus-within{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.xl\\:focus-within\\:text-red-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.xl\\:focus-within\\:text-orange-50:focus-within{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.xl\\:focus-within\\:text-orange-100:focus-within{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.xl\\:focus-within\\:text-orange-200:focus-within{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.xl\\:focus-within\\:text-orange-300:focus-within{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.xl\\:focus-within\\:text-orange-400:focus-within{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.xl\\:focus-within\\:text-orange-500:focus-within{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.xl\\:focus-within\\:text-orange-600:focus-within{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.xl\\:focus-within\\:text-orange-700:focus-within{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.xl\\:focus-within\\:text-orange-800:focus-within{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.xl\\:focus-within\\:text-orange-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.xl\\:focus-within\\:text-yellow-50:focus-within{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.xl\\:focus-within\\:text-yellow-100:focus-within{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.xl\\:focus-within\\:text-yellow-200:focus-within{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.xl\\:focus-within\\:text-yellow-300:focus-within{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.xl\\:focus-within\\:text-yellow-400:focus-within{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.xl\\:focus-within\\:text-yellow-500:focus-within{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.xl\\:focus-within\\:text-yellow-600:focus-within{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.xl\\:focus-within\\:text-yellow-700:focus-within{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.xl\\:focus-within\\:text-yellow-800:focus-within{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.xl\\:focus-within\\:text-yellow-900:focus-within{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.xl\\:focus-within\\:text-green-50:focus-within{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.xl\\:focus-within\\:text-green-100:focus-within{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.xl\\:focus-within\\:text-green-200:focus-within{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.xl\\:focus-within\\:text-green-300:focus-within{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.xl\\:focus-within\\:text-green-400:focus-within{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.xl\\:focus-within\\:text-green-500:focus-within{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.xl\\:focus-within\\:text-green-600:focus-within{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.xl\\:focus-within\\:text-green-700:focus-within{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.xl\\:focus-within\\:text-green-800:focus-within{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.xl\\:focus-within\\:text-green-900:focus-within{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.xl\\:focus-within\\:text-teal-50:focus-within{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.xl\\:focus-within\\:text-teal-100:focus-within{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.xl\\:focus-within\\:text-teal-200:focus-within{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.xl\\:focus-within\\:text-teal-300:focus-within{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.xl\\:focus-within\\:text-teal-400:focus-within{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.xl\\:focus-within\\:text-teal-500:focus-within{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.xl\\:focus-within\\:text-teal-600:focus-within{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.xl\\:focus-within\\:text-teal-700:focus-within{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.xl\\:focus-within\\:text-teal-800:focus-within{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.xl\\:focus-within\\:text-teal-900:focus-within{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.xl\\:focus-within\\:text-blue-50:focus-within{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.xl\\:focus-within\\:text-blue-100:focus-within{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.xl\\:focus-within\\:text-blue-200:focus-within{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.xl\\:focus-within\\:text-blue-300:focus-within{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.xl\\:focus-within\\:text-blue-400:focus-within{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.xl\\:focus-within\\:text-blue-500:focus-within{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.xl\\:focus-within\\:text-blue-600:focus-within{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.xl\\:focus-within\\:text-blue-700:focus-within{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.xl\\:focus-within\\:text-blue-800:focus-within{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.xl\\:focus-within\\:text-blue-900:focus-within{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.xl\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.xl\\:focus-within\\:text-pink-50:focus-within{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.xl\\:focus-within\\:text-pink-100:focus-within{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.xl\\:focus-within\\:text-pink-200:focus-within{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.xl\\:focus-within\\:text-pink-300:focus-within{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.xl\\:focus-within\\:text-pink-400:focus-within{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.xl\\:focus-within\\:text-pink-500:focus-within{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.xl\\:focus-within\\:text-pink-600:focus-within{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.xl\\:focus-within\\:text-pink-700:focus-within{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.xl\\:focus-within\\:text-pink-800:focus-within{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.xl\\:focus-within\\:text-pink-900:focus-within{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.xl\\:hover\\:text-transparent:hover{color:#0000}.xl\\:hover\\:text-white:hover{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.xl\\:hover\\:text-black:hover{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.xl\\:hover\\:text-gray-50:hover{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.xl\\:hover\\:text-gray-100:hover{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.xl\\:hover\\:text-gray-200:hover{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.xl\\:hover\\:text-gray-300:hover{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.xl\\:hover\\:text-gray-400:hover{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.xl\\:hover\\:text-gray-500:hover{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.xl\\:hover\\:text-gray-600:hover{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.xl\\:hover\\:text-gray-700:hover{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.xl\\:hover\\:text-gray-800:hover{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.xl\\:hover\\:text-gray-900:hover{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.xl\\:hover\\:text-cool-gray-50:hover{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.xl\\:hover\\:text-cool-gray-100:hover{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.xl\\:hover\\:text-cool-gray-200:hover{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.xl\\:hover\\:text-cool-gray-300:hover{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.xl\\:hover\\:text-cool-gray-400:hover{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.xl\\:hover\\:text-cool-gray-500:hover{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.xl\\:hover\\:text-cool-gray-600:hover{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.xl\\:hover\\:text-cool-gray-700:hover{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.xl\\:hover\\:text-cool-gray-800:hover{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.xl\\:hover\\:text-cool-gray-900:hover{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.xl\\:hover\\:text-red-50:hover{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.xl\\:hover\\:text-red-100:hover{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.xl\\:hover\\:text-red-200:hover{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.xl\\:hover\\:text-red-300:hover{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.xl\\:hover\\:text-red-400:hover{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.xl\\:hover\\:text-red-500:hover{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.xl\\:hover\\:text-red-600:hover{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.xl\\:hover\\:text-red-700:hover{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.xl\\:hover\\:text-red-800:hover{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.xl\\:hover\\:text-red-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.xl\\:hover\\:text-orange-50:hover{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.xl\\:hover\\:text-orange-100:hover{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.xl\\:hover\\:text-orange-200:hover{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.xl\\:hover\\:text-orange-300:hover{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.xl\\:hover\\:text-orange-400:hover{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.xl\\:hover\\:text-orange-500:hover{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.xl\\:hover\\:text-orange-600:hover{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.xl\\:hover\\:text-orange-700:hover{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.xl\\:hover\\:text-orange-800:hover{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.xl\\:hover\\:text-orange-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.xl\\:hover\\:text-yellow-50:hover{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.xl\\:hover\\:text-yellow-100:hover{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.xl\\:hover\\:text-yellow-200:hover{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.xl\\:hover\\:text-yellow-300:hover{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.xl\\:hover\\:text-yellow-400:hover{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.xl\\:hover\\:text-yellow-500:hover{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.xl\\:hover\\:text-yellow-600:hover{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.xl\\:hover\\:text-yellow-700:hover{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.xl\\:hover\\:text-yellow-800:hover{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.xl\\:hover\\:text-yellow-900:hover{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.xl\\:hover\\:text-green-50:hover{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.xl\\:hover\\:text-green-100:hover{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.xl\\:hover\\:text-green-200:hover{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.xl\\:hover\\:text-green-300:hover{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.xl\\:hover\\:text-green-400:hover{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.xl\\:hover\\:text-green-500:hover{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.xl\\:hover\\:text-green-600:hover{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.xl\\:hover\\:text-green-700:hover{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.xl\\:hover\\:text-green-800:hover{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.xl\\:hover\\:text-green-900:hover{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.xl\\:hover\\:text-teal-50:hover{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.xl\\:hover\\:text-teal-100:hover{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.xl\\:hover\\:text-teal-200:hover{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.xl\\:hover\\:text-teal-300:hover{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.xl\\:hover\\:text-teal-400:hover{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.xl\\:hover\\:text-teal-500:hover{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.xl\\:hover\\:text-teal-600:hover{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.xl\\:hover\\:text-teal-700:hover{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.xl\\:hover\\:text-teal-800:hover{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.xl\\:hover\\:text-teal-900:hover{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.xl\\:hover\\:text-blue-50:hover{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.xl\\:hover\\:text-blue-100:hover{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.xl\\:hover\\:text-blue-200:hover{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.xl\\:hover\\:text-blue-300:hover{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.xl\\:hover\\:text-blue-400:hover{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.xl\\:hover\\:text-blue-500:hover{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.xl\\:hover\\:text-blue-600:hover{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.xl\\:hover\\:text-blue-700:hover{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.xl\\:hover\\:text-blue-800:hover{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.xl\\:hover\\:text-blue-900:hover{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.xl\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.xl\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.xl\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.xl\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.xl\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.xl\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.xl\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.xl\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.xl\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.xl\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.xl\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.xl\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.xl\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.xl\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.xl\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.xl\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.xl\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.xl\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.xl\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.xl\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.xl\\:hover\\:text-pink-50:hover{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.xl\\:hover\\:text-pink-100:hover{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.xl\\:hover\\:text-pink-200:hover{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.xl\\:hover\\:text-pink-300:hover{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.xl\\:hover\\:text-pink-400:hover{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.xl\\:hover\\:text-pink-500:hover{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.xl\\:hover\\:text-pink-600:hover{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.xl\\:hover\\:text-pink-700:hover{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.xl\\:hover\\:text-pink-800:hover{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.xl\\:hover\\:text-pink-900:hover{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.xl\\:active\\:text-transparent:active{color:#0000}.xl\\:active\\:text-white:active{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.xl\\:active\\:text-black:active{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.xl\\:active\\:text-gray-50:active{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.xl\\:active\\:text-gray-100:active{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.xl\\:active\\:text-gray-200:active{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.xl\\:active\\:text-gray-300:active{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.xl\\:active\\:text-gray-400:active{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.xl\\:active\\:text-gray-500:active{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.xl\\:active\\:text-gray-600:active{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.xl\\:active\\:text-gray-700:active{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.xl\\:active\\:text-gray-800:active{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.xl\\:active\\:text-gray-900:active{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.xl\\:active\\:text-cool-gray-50:active{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.xl\\:active\\:text-cool-gray-100:active{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.xl\\:active\\:text-cool-gray-200:active{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.xl\\:active\\:text-cool-gray-300:active{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.xl\\:active\\:text-cool-gray-400:active{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.xl\\:active\\:text-cool-gray-500:active{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.xl\\:active\\:text-cool-gray-600:active{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.xl\\:active\\:text-cool-gray-700:active{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.xl\\:active\\:text-cool-gray-800:active{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.xl\\:active\\:text-cool-gray-900:active{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.xl\\:active\\:text-red-50:active{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.xl\\:active\\:text-red-100:active{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.xl\\:active\\:text-red-200:active{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.xl\\:active\\:text-red-300:active{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.xl\\:active\\:text-red-400:active{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.xl\\:active\\:text-red-500:active{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.xl\\:active\\:text-red-600:active{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.xl\\:active\\:text-red-700:active{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.xl\\:active\\:text-red-800:active{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.xl\\:active\\:text-red-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.xl\\:active\\:text-orange-50:active{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.xl\\:active\\:text-orange-100:active{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.xl\\:active\\:text-orange-200:active{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.xl\\:active\\:text-orange-300:active{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.xl\\:active\\:text-orange-400:active{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.xl\\:active\\:text-orange-500:active{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.xl\\:active\\:text-orange-600:active{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.xl\\:active\\:text-orange-700:active{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.xl\\:active\\:text-orange-800:active{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.xl\\:active\\:text-orange-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.xl\\:active\\:text-yellow-50:active{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.xl\\:active\\:text-yellow-100:active{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.xl\\:active\\:text-yellow-200:active{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.xl\\:active\\:text-yellow-300:active{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.xl\\:active\\:text-yellow-400:active{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.xl\\:active\\:text-yellow-500:active{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.xl\\:active\\:text-yellow-600:active{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.xl\\:active\\:text-yellow-700:active{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.xl\\:active\\:text-yellow-800:active{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.xl\\:active\\:text-yellow-900:active{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.xl\\:active\\:text-green-50:active{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.xl\\:active\\:text-green-100:active{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.xl\\:active\\:text-green-200:active{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.xl\\:active\\:text-green-300:active{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.xl\\:active\\:text-green-400:active{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.xl\\:active\\:text-green-500:active{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.xl\\:active\\:text-green-600:active{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.xl\\:active\\:text-green-700:active{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.xl\\:active\\:text-green-800:active{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.xl\\:active\\:text-green-900:active{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.xl\\:active\\:text-teal-50:active{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.xl\\:active\\:text-teal-100:active{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.xl\\:active\\:text-teal-200:active{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.xl\\:active\\:text-teal-300:active{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.xl\\:active\\:text-teal-400:active{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.xl\\:active\\:text-teal-500:active{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.xl\\:active\\:text-teal-600:active{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.xl\\:active\\:text-teal-700:active{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.xl\\:active\\:text-teal-800:active{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.xl\\:active\\:text-teal-900:active{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.xl\\:active\\:text-blue-50:active{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.xl\\:active\\:text-blue-100:active{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.xl\\:active\\:text-blue-200:active{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.xl\\:active\\:text-blue-300:active{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.xl\\:active\\:text-blue-400:active{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.xl\\:active\\:text-blue-500:active{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.xl\\:active\\:text-blue-600:active{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.xl\\:active\\:text-blue-700:active{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.xl\\:active\\:text-blue-800:active{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.xl\\:active\\:text-blue-900:active{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.xl\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.xl\\:active\\:text-indigo-100:active{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.xl\\:active\\:text-indigo-200:active{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.xl\\:active\\:text-indigo-300:active{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.xl\\:active\\:text-indigo-400:active{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.xl\\:active\\:text-indigo-500:active{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.xl\\:active\\:text-indigo-600:active{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.xl\\:active\\:text-indigo-700:active{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.xl\\:active\\:text-indigo-800:active{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.xl\\:active\\:text-indigo-900:active{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.xl\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.xl\\:active\\:text-indigo-100:active{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.xl\\:active\\:text-indigo-200:active{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.xl\\:active\\:text-indigo-300:active{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.xl\\:active\\:text-indigo-400:active{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.xl\\:active\\:text-indigo-500:active{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.xl\\:active\\:text-indigo-600:active{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.xl\\:active\\:text-indigo-700:active{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.xl\\:active\\:text-indigo-800:active{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.xl\\:active\\:text-indigo-900:active{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.xl\\:active\\:text-pink-50:active{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.xl\\:active\\:text-pink-100:active{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.xl\\:active\\:text-pink-200:active{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.xl\\:active\\:text-pink-300:active{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.xl\\:active\\:text-pink-400:active{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.xl\\:active\\:text-pink-500:active{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.xl\\:active\\:text-pink-600:active{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.xl\\:active\\:text-pink-700:active{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.xl\\:active\\:text-pink-800:active{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.xl\\:active\\:text-pink-900:active{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-transparent{color:#0000}.theme-dark .xl\\:dark\\:text-white{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-black{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-gray-50{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-gray-100{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-gray-200{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-gray-300{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-gray-400{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-gray-500{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-gray-600{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-gray-700{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-gray-800{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-gray-900{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-cool-gray-50{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-cool-gray-100{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-cool-gray-200{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-cool-gray-300{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-cool-gray-400{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-cool-gray-500{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-cool-gray-600{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-cool-gray-700{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-cool-gray-800{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-cool-gray-900{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-red-50{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-red-100{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-red-200{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-red-300{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-red-400{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-red-500{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-red-600{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-red-700{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-red-800{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-red-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-orange-50{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-orange-100{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-orange-200{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-orange-300{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-orange-400{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-orange-500{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-orange-600{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-orange-700{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-orange-800{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-orange-900{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-yellow-50{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-yellow-100{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-yellow-200{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-yellow-300{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-yellow-400{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-yellow-500{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-yellow-600{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-yellow-700{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-yellow-800{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-yellow-900{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-green-50{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-green-100{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-green-200{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-green-300{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-green-400{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-green-500{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-green-600{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-green-700{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-green-800{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-green-900{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-teal-50{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-teal-100{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-teal-200{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-teal-300{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-teal-400{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-teal-500{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-teal-600{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-teal-700{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-teal-800{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-teal-900{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-blue-50{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-blue-100{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-blue-200{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-blue-300{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-blue-400{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-blue-500{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-blue-600{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-blue-700{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-blue-800{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-blue-900{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-50{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-100{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-200{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-300{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-400{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-500{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-600{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-700{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-800{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-900{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-50{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-100{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-200{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-300{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-400{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-500{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-600{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-700{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-800{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-indigo-900{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-pink-50{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-pink-100{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-pink-200{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-pink-300{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-pink-400{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-pink-500{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-pink-600{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-pink-700{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-pink-800{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .xl\\:dark\\:text-pink-900{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-transparent:focus-within{color:#0000}.theme-dark .xl\\:dark\\:focus-within\\:text-white:focus-within{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-black:focus-within{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-gray-50:focus-within{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-gray-100:focus-within{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-gray-200:focus-within{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-gray-300:focus-within{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-gray-400:focus-within{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-gray-500:focus-within{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-gray-600:focus-within{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-gray-700:focus-within{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-gray-800:focus-within{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-gray-900:focus-within{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-50:focus-within{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-100:focus-within{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-200:focus-within{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-300:focus-within{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-400:focus-within{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-500:focus-within{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-600:focus-within{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-700:focus-within{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-800:focus-within{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-cool-gray-900:focus-within{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-red-50:focus-within{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-red-100:focus-within{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-red-200:focus-within{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-red-300:focus-within{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-red-400:focus-within{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-red-500:focus-within{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-red-600:focus-within{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-red-700:focus-within{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-red-800:focus-within{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-red-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-orange-50:focus-within{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-orange-100:focus-within{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-orange-200:focus-within{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-orange-300:focus-within{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-orange-400:focus-within{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-orange-500:focus-within{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-orange-600:focus-within{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-orange-700:focus-within{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-orange-800:focus-within{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-orange-900:focus-within{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-yellow-50:focus-within{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-yellow-100:focus-within{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-yellow-200:focus-within{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-yellow-300:focus-within{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-yellow-400:focus-within{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-yellow-500:focus-within{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-yellow-600:focus-within{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-yellow-700:focus-within{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-yellow-800:focus-within{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-yellow-900:focus-within{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-green-50:focus-within{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-green-100:focus-within{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-green-200:focus-within{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-green-300:focus-within{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-green-400:focus-within{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-green-500:focus-within{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-green-600:focus-within{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-green-700:focus-within{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-green-800:focus-within{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-green-900:focus-within{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-teal-50:focus-within{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-teal-100:focus-within{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-teal-200:focus-within{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-teal-300:focus-within{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-teal-400:focus-within{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-teal-500:focus-within{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-teal-600:focus-within{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-teal-700:focus-within{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-teal-800:focus-within{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-teal-900:focus-within{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-blue-50:focus-within{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-blue-100:focus-within{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-blue-200:focus-within{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-blue-300:focus-within{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-blue-400:focus-within{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-blue-500:focus-within{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-blue-600:focus-within{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-blue-700:focus-within{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-blue-800:focus-within{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-blue-900:focus-within{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-50:focus-within{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-100:focus-within{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-200:focus-within{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-300:focus-within{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-400:focus-within{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-500:focus-within{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-600:focus-within{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-700:focus-within{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-800:focus-within{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-indigo-900:focus-within{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-pink-50:focus-within{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-pink-100:focus-within{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-pink-200:focus-within{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-pink-300:focus-within{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-pink-400:focus-within{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-pink-500:focus-within{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-pink-600:focus-within{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-pink-700:focus-within{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-pink-800:focus-within{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .xl\\:dark\\:focus-within\\:text-pink-900:focus-within{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-transparent:hover{color:#0000}.theme-dark .xl\\:dark\\:hover\\:text-white:hover{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-black:hover{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-gray-50:hover{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-gray-100:hover{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-gray-200:hover{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-gray-300:hover{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-gray-400:hover{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-gray-500:hover{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-gray-600:hover{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-gray-700:hover{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-gray-800:hover{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-gray-900:hover{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-cool-gray-50:hover{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-cool-gray-100:hover{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-cool-gray-200:hover{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-cool-gray-300:hover{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-cool-gray-400:hover{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-cool-gray-500:hover{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-cool-gray-600:hover{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-cool-gray-700:hover{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-cool-gray-800:hover{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-cool-gray-900:hover{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-red-50:hover{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-red-100:hover{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-red-200:hover{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-red-300:hover{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-red-400:hover{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-red-500:hover{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-red-600:hover{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-red-700:hover{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-red-800:hover{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-red-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-orange-50:hover{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-orange-100:hover{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-orange-200:hover{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-orange-300:hover{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-orange-400:hover{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-orange-500:hover{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-orange-600:hover{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-orange-700:hover{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-orange-800:hover{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-orange-900:hover{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-yellow-50:hover{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-yellow-100:hover{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-yellow-200:hover{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-yellow-300:hover{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-yellow-400:hover{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-yellow-500:hover{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-yellow-600:hover{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-yellow-700:hover{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-yellow-800:hover{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-yellow-900:hover{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-green-50:hover{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-green-100:hover{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-green-200:hover{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-green-300:hover{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-green-400:hover{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-green-500:hover{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-green-600:hover{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-green-700:hover{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-green-800:hover{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-green-900:hover{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-teal-50:hover{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-teal-100:hover{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-teal-200:hover{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-teal-300:hover{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-teal-400:hover{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-teal-500:hover{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-teal-600:hover{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-teal-700:hover{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-teal-800:hover{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-teal-900:hover{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-blue-50:hover{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-blue-100:hover{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-blue-200:hover{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-blue-300:hover{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-blue-400:hover{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-blue-500:hover{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-blue-600:hover{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-blue-700:hover{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-blue-800:hover{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-blue-900:hover{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-50:hover{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-100:hover{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-200:hover{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-300:hover{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-400:hover{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-500:hover{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-600:hover{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-700:hover{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-800:hover{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-indigo-900:hover{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-pink-50:hover{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-pink-100:hover{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-pink-200:hover{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-pink-300:hover{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-pink-400:hover{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-pink-500:hover{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-pink-600:hover{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-pink-700:hover{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-pink-800:hover{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .xl\\:dark\\:hover\\:text-pink-900:hover{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-transparent:active{color:#0000}.theme-dark .xl\\:dark\\:active\\:text-white:active{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-black:active{--text-opacity:1;color:#000;color:rgba(0,0,0,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-gray-50:active{--text-opacity:1;color:#f9fafb;color:rgba(249,250,251,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-gray-100:active{--text-opacity:1;color:#f4f5f7;color:rgba(244,245,247,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-gray-200:active{--text-opacity:1;color:#e5e7eb;color:rgba(229,231,235,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-gray-300:active{--text-opacity:1;color:#d5d6d7;color:rgba(213,214,215,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-gray-400:active{--text-opacity:1;color:#9e9e9e;color:rgba(158,158,158,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-gray-500:active{--text-opacity:1;color:#707275;color:rgba(112,114,117,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-gray-600:active{--text-opacity:1;color:#4c4f52;color:rgba(76,79,82,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-gray-700:active{--text-opacity:1;color:#24262d;color:rgba(36,38,45,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-gray-800:active{--text-opacity:1;color:#1a1c23;color:rgba(26,28,35,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-gray-900:active{--text-opacity:1;color:#121317;color:rgba(18,19,23,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-cool-gray-50:active{--text-opacity:1;color:#fbfdfe;color:rgba(251,253,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-cool-gray-100:active{--text-opacity:1;color:#f1f5f9;color:rgba(241,245,249,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-cool-gray-200:active{--text-opacity:1;color:#e2e8f0;color:rgba(226,232,240,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-cool-gray-300:active{--text-opacity:1;color:#cfd8e3;color:rgba(207,216,227,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-cool-gray-400:active{--text-opacity:1;color:#97a6ba;color:rgba(151,166,186,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-cool-gray-500:active{--text-opacity:1;color:#64748b;color:rgba(100,116,139,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-cool-gray-600:active{--text-opacity:1;color:#475569;color:rgba(71,85,105,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-cool-gray-700:active{--text-opacity:1;color:#364152;color:rgba(54,65,82,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-cool-gray-800:active{--text-opacity:1;color:#27303f;color:rgba(39,48,63,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-cool-gray-900:active{--text-opacity:1;color:#1a202e;color:rgba(26,32,46,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-red-50:active{--text-opacity:1;color:#fdf2f2;color:rgba(253,242,242,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-red-100:active{--text-opacity:1;color:#fde8e8;color:rgba(253,232,232,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-red-200:active{--text-opacity:1;color:#fbd5d5;color:rgba(251,213,213,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-red-300:active{--text-opacity:1;color:#f8b4b4;color:rgba(248,180,180,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-red-400:active{--text-opacity:1;color:#f98080;color:rgba(249,128,128,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-red-500:active{--text-opacity:1;color:#f05252;color:rgba(240,82,82,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-red-600:active{--text-opacity:1;color:#e02424;color:rgba(224,36,36,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-red-700:active{--text-opacity:1;color:#c81e1e;color:rgba(200,30,30,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-red-800:active{--text-opacity:1;color:#9b1c1c;color:rgba(155,28,28,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-red-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-orange-50:active{--text-opacity:1;color:#fff8f1;color:rgba(255,248,241,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-orange-100:active{--text-opacity:1;color:#feecdc;color:rgba(254,236,220,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-orange-200:active{--text-opacity:1;color:#fcd9bd;color:rgba(252,217,189,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-orange-300:active{--text-opacity:1;color:#fdba8c;color:rgba(253,186,140,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-orange-400:active{--text-opacity:1;color:#ff8a4c;color:rgba(255,138,76,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-orange-500:active{--text-opacity:1;color:#ff5a1f;color:rgba(255,90,31,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-orange-600:active{--text-opacity:1;color:#d03801;color:rgba(208,56,1,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-orange-700:active{--text-opacity:1;color:#b43403;color:rgba(180,52,3,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-orange-800:active{--text-opacity:1;color:#8a2c0d;color:rgba(138,44,13,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-orange-900:active{--text-opacity:1;color:#771d1d;color:rgba(119,29,29,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-yellow-50:active{--text-opacity:1;color:#fdfdea;color:rgba(253,253,234,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-yellow-100:active{--text-opacity:1;color:#fdf6b2;color:rgba(253,246,178,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-yellow-200:active{--text-opacity:1;color:#fce96a;color:rgba(252,233,106,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-yellow-300:active{--text-opacity:1;color:#faca15;color:rgba(250,202,21,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-yellow-400:active{--text-opacity:1;color:#e3a008;color:rgba(227,160,8,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-yellow-500:active{--text-opacity:1;color:#c27803;color:rgba(194,120,3,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-yellow-600:active{--text-opacity:1;color:#9f580a;color:rgba(159,88,10,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-yellow-700:active{--text-opacity:1;color:#8e4b10;color:rgba(142,75,16,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-yellow-800:active{--text-opacity:1;color:#723b13;color:rgba(114,59,19,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-yellow-900:active{--text-opacity:1;color:#633112;color:rgba(99,49,18,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-green-50:active{--text-opacity:1;color:#f3faf7;color:rgba(243,250,247,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-green-100:active{--text-opacity:1;color:#def7ec;color:rgba(222,247,236,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-green-200:active{--text-opacity:1;color:#bcf0da;color:rgba(188,240,218,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-green-300:active{--text-opacity:1;color:#84e1bc;color:rgba(132,225,188,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-green-400:active{--text-opacity:1;color:#31c48d;color:rgba(49,196,141,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-green-500:active{--text-opacity:1;color:#0e9f6e;color:rgba(14,159,110,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-green-600:active{--text-opacity:1;color:#057a55;color:rgba(5,122,85,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-green-700:active{--text-opacity:1;color:#046c4e;color:rgba(4,108,78,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-green-800:active{--text-opacity:1;color:#03543f;color:rgba(3,84,63,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-green-900:active{--text-opacity:1;color:#014737;color:rgba(1,71,55,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-teal-50:active{--text-opacity:1;color:#edfafa;color:rgba(237,250,250,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-teal-100:active{--text-opacity:1;color:#d5f5f6;color:rgba(213,245,246,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-teal-200:active{--text-opacity:1;color:#afecef;color:rgba(175,236,239,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-teal-300:active{--text-opacity:1;color:#7edce2;color:rgba(126,220,226,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-teal-400:active{--text-opacity:1;color:#16bdca;color:rgba(22,189,202,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-teal-500:active{--text-opacity:1;color:#0694a2;color:rgba(6,148,162,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-teal-600:active{--text-opacity:1;color:#047481;color:rgba(4,116,129,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-teal-700:active{--text-opacity:1;color:#036672;color:rgba(3,102,114,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-teal-800:active{--text-opacity:1;color:#05505c;color:rgba(5,80,92,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-teal-900:active{--text-opacity:1;color:#014451;color:rgba(1,68,81,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-blue-50:active{--text-opacity:1;color:#ebf5ff;color:rgba(235,245,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-blue-100:active{--text-opacity:1;color:#e1effe;color:rgba(225,239,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-blue-200:active{--text-opacity:1;color:#c3ddfd;color:rgba(195,221,253,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-blue-300:active{--text-opacity:1;color:#a4cafe;color:rgba(164,202,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-blue-400:active{--text-opacity:1;color:#76a9fa;color:rgba(118,169,250,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-blue-500:active{--text-opacity:1;color:#3f83f8;color:rgba(63,131,248,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-blue-600:active{--text-opacity:1;color:#1c64f2;color:rgba(28,100,242,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-blue-700:active{--text-opacity:1;color:#1a56db;color:rgba(26,86,219,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-blue-800:active{--text-opacity:1;color:#1e429f;color:rgba(30,66,159,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-blue-900:active{--text-opacity:1;color:#233876;color:rgba(35,56,118,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f0f5ff;color:rgba(240,245,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-100:active{--text-opacity:1;color:#e5edff;color:rgba(229,237,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-200:active{--text-opacity:1;color:#cddbfe;color:rgba(205,219,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-300:active{--text-opacity:1;color:#b4c6fc;color:rgba(180,198,252,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-400:active{--text-opacity:1;color:#8da2fb;color:rgba(141,162,251,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-500:active{--text-opacity:1;color:#6875f5;color:rgba(104,117,245,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-600:active{--text-opacity:1;color:#5850ec;color:rgba(88,80,236,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-700:active{--text-opacity:1;color:#5145cd;color:rgba(81,69,205,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-800:active{--text-opacity:1;color:#42389d;color:rgba(66,56,157,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-900:active{--text-opacity:1;color:#362f78;color:rgba(54,47,120,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-50:active{--text-opacity:1;color:#f6f5ff;color:rgba(246,245,255,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-100:active{--text-opacity:1;color:#edebfe;color:rgba(237,235,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-200:active{--text-opacity:1;color:#dcd7fe;color:rgba(220,215,254,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-300:active{--text-opacity:1;color:#cabffd;color:rgba(202,191,253,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-400:active{--text-opacity:1;color:#ac94fa;color:rgba(172,148,250,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-500:active{--text-opacity:1;color:#9061f9;color:rgba(144,97,249,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-600:active{--text-opacity:1;color:#7e3af2;color:rgba(126,58,242,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-700:active{--text-opacity:1;color:#6c2bd9;color:rgba(108,43,217,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-800:active{--text-opacity:1;color:#5521b5;color:rgba(85,33,181,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-indigo-900:active{--text-opacity:1;color:#4a1d96;color:rgba(74,29,150,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-pink-50:active{--text-opacity:1;color:#fdf2f8;color:rgba(253,242,248,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-pink-100:active{--text-opacity:1;color:#fce8f3;color:rgba(252,232,243,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-pink-200:active{--text-opacity:1;color:#fad1e8;color:rgba(250,209,232,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-pink-300:active{--text-opacity:1;color:#f8b4d9;color:rgba(248,180,217,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-pink-400:active{--text-opacity:1;color:#f17eb8;color:rgba(241,126,184,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-pink-500:active{--text-opacity:1;color:#e74694;color:rgba(231,70,148,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-pink-600:active{--text-opacity:1;color:#d61f69;color:rgba(214,31,105,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-pink-700:active{--text-opacity:1;color:#bf125d;color:rgba(191,18,93,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-pink-800:active{--text-opacity:1;color:#99154b;color:rgba(153,21,75,var(--text-opacity))}.theme-dark .xl\\:dark\\:active\\:text-pink-900:active{--text-opacity:1;color:#751a3d;color:rgba(117,26,61,var(--text-opacity))}.xl\\:text-opacity-0{--text-opacity:0}.xl\\:text-opacity-25{--text-opacity:0.25}.xl\\:text-opacity-50{--text-opacity:0.5}.xl\\:text-opacity-75{--text-opacity:0.75}.xl\\:text-opacity-100{--text-opacity:1}.xl\\:hover\\:text-opacity-0:hover{--text-opacity:0}.xl\\:hover\\:text-opacity-25:hover{--text-opacity:0.25}.xl\\:hover\\:text-opacity-50:hover{--text-opacity:0.5}.xl\\:hover\\:text-opacity-75:hover{--text-opacity:0.75}.xl\\:hover\\:text-opacity-100:hover{--text-opacity:1}.xl\\:focus\\:text-opacity-0:focus{--text-opacity:0}.xl\\:focus\\:text-opacity-25:focus{--text-opacity:0.25}.xl\\:focus\\:text-opacity-50:focus{--text-opacity:0.5}.xl\\:focus\\:text-opacity-75:focus{--text-opacity:0.75}.xl\\:focus\\:text-opacity-100:focus{--text-opacity:1}.xl\\:italic{font-style:italic}.xl\\:not-italic{font-style:normal}.xl\\:uppercase{text-transform:uppercase}.xl\\:lowercase{text-transform:lowercase}.xl\\:capitalize{text-transform:capitalize}.xl\\:normal-case{text-transform:none}.xl\\:underline{-webkit-text-decoration:underline;text-decoration:underline}.xl\\:line-through{-webkit-text-decoration:line-through;text-decoration:line-through}.xl\\:no-underline{-webkit-text-decoration:none;text-decoration:none}.xl\\:hover\\:underline:hover{-webkit-text-decoration:underline;text-decoration:underline}.xl\\:hover\\:line-through:hover{-webkit-text-decoration:line-through;text-decoration:line-through}.xl\\:hover\\:no-underline:hover{-webkit-text-decoration:none;text-decoration:none}.xl\\:focus\\:underline:focus{-webkit-text-decoration:underline;text-decoration:underline}.xl\\:focus\\:line-through:focus{-webkit-text-decoration:line-through;text-decoration:line-through}.xl\\:focus\\:no-underline:focus{-webkit-text-decoration:none;text-decoration:none}.xl\\:antialiased{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.xl\\:subpixel-antialiased{-webkit-font-smoothing:auto;-moz-osx-font-smoothing:auto}.xl\\:tracking-tighter{letter-spacing:-.05em}.xl\\:tracking-tight{letter-spacing:-.025em}.xl\\:tracking-normal{letter-spacing:0}.xl\\:tracking-wide{letter-spacing:.025em}.xl\\:tracking-wider{letter-spacing:.05em}.xl\\:tracking-widest{letter-spacing:.1em}.xl\\:select-none{-webkit-user-select:none;user-select:none}.xl\\:select-text{-webkit-user-select:text;user-select:text}.xl\\:select-all{-webkit-user-select:all;user-select:all}.xl\\:select-auto{-webkit-user-select:auto;user-select:auto}.xl\\:align-baseline{vertical-align:initial}.xl\\:align-top{vertical-align:top}.xl\\:align-middle{vertical-align:middle}.xl\\:align-bottom{vertical-align:bottom}.xl\\:align-text-top{vertical-align:text-top}.xl\\:align-text-bottom{vertical-align:text-bottom}.xl\\:visible{visibility:visible}.xl\\:invisible{visibility:hidden}.xl\\:whitespace-normal{white-space:normal}.xl\\:whitespace-no-wrap{white-space:nowrap}.xl\\:whitespace-pre{white-space:pre}.xl\\:whitespace-pre-line{white-space:pre-line}.xl\\:whitespace-pre-wrap{white-space:pre-wrap}.xl\\:break-normal{overflow-wrap:normal;word-break:normal}.xl\\:break-words{overflow-wrap:break-word}.xl\\:break-all{word-break:break-all}.xl\\:truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.xl\\:w-0{width:0}.xl\\:w-1{width:.25rem}.xl\\:w-2{width:.5rem}.xl\\:w-3{width:.75rem}.xl\\:w-4{width:1rem}.xl\\:w-5{width:1.25rem}.xl\\:w-6{width:1.5rem}.xl\\:w-8{width:2rem}.xl\\:w-10{width:2.5rem}.xl\\:w-12{width:3rem}.xl\\:w-16{width:4rem}.xl\\:w-20{width:5rem}.xl\\:w-24{width:6rem}.xl\\:w-32{width:8rem}.xl\\:w-40{width:10rem}.xl\\:w-48{width:12rem}.xl\\:w-56{width:14rem}.xl\\:w-64{width:16rem}.xl\\:w-auto{width:auto}.xl\\:w-px{width:1px}.xl\\:w-1\\/2{width:50%}.xl\\:w-1\\/3{width:33.333333%}.xl\\:w-2\\/3{width:66.666667%}.xl\\:w-1\\/4{width:25%}.xl\\:w-2\\/4{width:50%}.xl\\:w-3\\/4{width:75%}.xl\\:w-1\\/5{width:20%}.xl\\:w-2\\/5{width:40%}.xl\\:w-3\\/5{width:60%}.xl\\:w-4\\/5{width:80%}.xl\\:w-1\\/6{width:16.666667%}.xl\\:w-2\\/6{width:33.333333%}.xl\\:w-3\\/6{width:50%}.xl\\:w-4\\/6{width:66.666667%}.xl\\:w-5\\/6{width:83.333333%}.xl\\:w-1\\/12{width:8.333333%}.xl\\:w-2\\/12{width:16.666667%}.xl\\:w-3\\/12{width:25%}.xl\\:w-4\\/12{width:33.333333%}.xl\\:w-5\\/12{width:41.666667%}.xl\\:w-6\\/12{width:50%}.xl\\:w-7\\/12{width:58.333333%}.xl\\:w-8\\/12{width:66.666667%}.xl\\:w-9\\/12{width:75%}.xl\\:w-10\\/12{width:83.333333%}.xl\\:w-11\\/12{width:91.666667%}.xl\\:w-full{width:100%}.xl\\:w-screen{width:100vw}.xl\\:z-0{z-index:0}.xl\\:z-10{z-index:10}.xl\\:z-20{z-index:20}.xl\\:z-30{z-index:30}.xl\\:z-40{z-index:40}.xl\\:z-50{z-index:50}.xl\\:z-auto{z-index:auto}.xl\\:gap-0{grid-gap:0;gap:0}.xl\\:gap-1{grid-gap:.25rem;gap:.25rem}.xl\\:gap-2{grid-gap:.5rem;gap:.5rem}.xl\\:gap-3{grid-gap:.75rem;gap:.75rem}.xl\\:gap-4{grid-gap:1rem;gap:1rem}.xl\\:gap-5{grid-gap:1.25rem;gap:1.25rem}.xl\\:gap-6{grid-gap:1.5rem;gap:1.5rem}.xl\\:gap-8{grid-gap:2rem;gap:2rem}.xl\\:gap-10{grid-gap:2.5rem;gap:2.5rem}.xl\\:gap-12{grid-gap:3rem;gap:3rem}.xl\\:gap-16{grid-gap:4rem;gap:4rem}.xl\\:gap-20{grid-gap:5rem;gap:5rem}.xl\\:gap-24{grid-gap:6rem;gap:6rem}.xl\\:gap-32{grid-gap:8rem;gap:8rem}.xl\\:gap-40{grid-gap:10rem;gap:10rem}.xl\\:gap-48{grid-gap:12rem;gap:12rem}.xl\\:gap-56{grid-gap:14rem;gap:14rem}.xl\\:gap-64{grid-gap:16rem;gap:16rem}.xl\\:gap-px{grid-gap:1px;gap:1px}.xl\\:col-gap-0{grid-column-gap:0;column-gap:0}.xl\\:col-gap-1{grid-column-gap:.25rem;column-gap:.25rem}.xl\\:col-gap-2{grid-column-gap:.5rem;column-gap:.5rem}.xl\\:col-gap-3{grid-column-gap:.75rem;column-gap:.75rem}.xl\\:col-gap-4{grid-column-gap:1rem;column-gap:1rem}.xl\\:col-gap-5{grid-column-gap:1.25rem;column-gap:1.25rem}.xl\\:col-gap-6{grid-column-gap:1.5rem;column-gap:1.5rem}.xl\\:col-gap-8{grid-column-gap:2rem;column-gap:2rem}.xl\\:col-gap-10{grid-column-gap:2.5rem;column-gap:2.5rem}.xl\\:col-gap-12{grid-column-gap:3rem;column-gap:3rem}.xl\\:col-gap-16{grid-column-gap:4rem;column-gap:4rem}.xl\\:col-gap-20{grid-column-gap:5rem;column-gap:5rem}.xl\\:col-gap-24{grid-column-gap:6rem;column-gap:6rem}.xl\\:col-gap-32{grid-column-gap:8rem;column-gap:8rem}.xl\\:col-gap-40{grid-column-gap:10rem;column-gap:10rem}.xl\\:col-gap-48{grid-column-gap:12rem;column-gap:12rem}.xl\\:col-gap-56{grid-column-gap:14rem;column-gap:14rem}.xl\\:col-gap-64{grid-column-gap:16rem;column-gap:16rem}.xl\\:col-gap-px{grid-column-gap:1px;column-gap:1px}.xl\\:row-gap-0{grid-row-gap:0;row-gap:0}.xl\\:row-gap-1{grid-row-gap:.25rem;row-gap:.25rem}.xl\\:row-gap-2{grid-row-gap:.5rem;row-gap:.5rem}.xl\\:row-gap-3{grid-row-gap:.75rem;row-gap:.75rem}.xl\\:row-gap-4{grid-row-gap:1rem;row-gap:1rem}.xl\\:row-gap-5{grid-row-gap:1.25rem;row-gap:1.25rem}.xl\\:row-gap-6{grid-row-gap:1.5rem;row-gap:1.5rem}.xl\\:row-gap-8{grid-row-gap:2rem;row-gap:2rem}.xl\\:row-gap-10{grid-row-gap:2.5rem;row-gap:2.5rem}.xl\\:row-gap-12{grid-row-gap:3rem;row-gap:3rem}.xl\\:row-gap-16{grid-row-gap:4rem;row-gap:4rem}.xl\\:row-gap-20{grid-row-gap:5rem;row-gap:5rem}.xl\\:row-gap-24{grid-row-gap:6rem;row-gap:6rem}.xl\\:row-gap-32{grid-row-gap:8rem;row-gap:8rem}.xl\\:row-gap-40{grid-row-gap:10rem;row-gap:10rem}.xl\\:row-gap-48{grid-row-gap:12rem;row-gap:12rem}.xl\\:row-gap-56{grid-row-gap:14rem;row-gap:14rem}.xl\\:row-gap-64{grid-row-gap:16rem;row-gap:16rem}.xl\\:row-gap-px{grid-row-gap:1px;row-gap:1px}.xl\\:grid-flow-row{grid-auto-flow:row}.xl\\:grid-flow-col{grid-auto-flow:column}.xl\\:grid-flow-row-dense{grid-auto-flow:row dense}.xl\\:grid-flow-col-dense{grid-auto-flow:column dense}.xl\\:grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.xl\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.xl\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.xl\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.xl\\:grid-cols-5{grid-template-columns:repeat(5,minmax(0,1fr))}.xl\\:grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.xl\\:grid-cols-7{grid-template-columns:repeat(7,minmax(0,1fr))}.xl\\:grid-cols-8{grid-template-columns:repeat(8,minmax(0,1fr))}.xl\\:grid-cols-9{grid-template-columns:repeat(9,minmax(0,1fr))}.xl\\:grid-cols-10{grid-template-columns:repeat(10,minmax(0,1fr))}.xl\\:grid-cols-11{grid-template-columns:repeat(11,minmax(0,1fr))}.xl\\:grid-cols-12{grid-template-columns:repeat(12,minmax(0,1fr))}.xl\\:grid-cols-none{grid-template-columns:none}.xl\\:col-auto{grid-column:auto}.xl\\:col-span-1{grid-column:span 1/span 1}.xl\\:col-span-2{grid-column:span 2/span 2}.xl\\:col-span-3{grid-column:span 3/span 3}.xl\\:col-span-4{grid-column:span 4/span 4}.xl\\:col-span-5{grid-column:span 5/span 5}.xl\\:col-span-6{grid-column:span 6/span 6}.xl\\:col-span-7{grid-column:span 7/span 7}.xl\\:col-span-8{grid-column:span 8/span 8}.xl\\:col-span-9{grid-column:span 9/span 9}.xl\\:col-span-10{grid-column:span 10/span 10}.xl\\:col-span-11{grid-column:span 11/span 11}.xl\\:col-span-12{grid-column:span 12/span 12}.xl\\:col-start-1{grid-column-start:1}.xl\\:col-start-2{grid-column-start:2}.xl\\:col-start-3{grid-column-start:3}.xl\\:col-start-4{grid-column-start:4}.xl\\:col-start-5{grid-column-start:5}.xl\\:col-start-6{grid-column-start:6}.xl\\:col-start-7{grid-column-start:7}.xl\\:col-start-8{grid-column-start:8}.xl\\:col-start-9{grid-column-start:9}.xl\\:col-start-10{grid-column-start:10}.xl\\:col-start-11{grid-column-start:11}.xl\\:col-start-12{grid-column-start:12}.xl\\:col-start-13{grid-column-start:13}.xl\\:col-start-auto{grid-column-start:auto}.xl\\:col-end-1{grid-column-end:1}.xl\\:col-end-2{grid-column-end:2}.xl\\:col-end-3{grid-column-end:3}.xl\\:col-end-4{grid-column-end:4}.xl\\:col-end-5{grid-column-end:5}.xl\\:col-end-6{grid-column-end:6}.xl\\:col-end-7{grid-column-end:7}.xl\\:col-end-8{grid-column-end:8}.xl\\:col-end-9{grid-column-end:9}.xl\\:col-end-10{grid-column-end:10}.xl\\:col-end-11{grid-column-end:11}.xl\\:col-end-12{grid-column-end:12}.xl\\:col-end-13{grid-column-end:13}.xl\\:col-end-auto{grid-column-end:auto}.xl\\:grid-rows-1{grid-template-rows:repeat(1,minmax(0,1fr))}.xl\\:grid-rows-2{grid-template-rows:repeat(2,minmax(0,1fr))}.xl\\:grid-rows-3{grid-template-rows:repeat(3,minmax(0,1fr))}.xl\\:grid-rows-4{grid-template-rows:repeat(4,minmax(0,1fr))}.xl\\:grid-rows-5{grid-template-rows:repeat(5,minmax(0,1fr))}.xl\\:grid-rows-6{grid-template-rows:repeat(6,minmax(0,1fr))}.xl\\:grid-rows-none{grid-template-rows:none}.xl\\:row-auto{grid-row:auto}.xl\\:row-span-1{grid-row:span 1/span 1}.xl\\:row-span-2{grid-row:span 2/span 2}.xl\\:row-span-3{grid-row:span 3/span 3}.xl\\:row-span-4{grid-row:span 4/span 4}.xl\\:row-span-5{grid-row:span 5/span 5}.xl\\:row-span-6{grid-row:span 6/span 6}.xl\\:row-start-1{grid-row-start:1}.xl\\:row-start-2{grid-row-start:2}.xl\\:row-start-3{grid-row-start:3}.xl\\:row-start-4{grid-row-start:4}.xl\\:row-start-5{grid-row-start:5}.xl\\:row-start-6{grid-row-start:6}.xl\\:row-start-7{grid-row-start:7}.xl\\:row-start-auto{grid-row-start:auto}.xl\\:row-end-1{grid-row-end:1}.xl\\:row-end-2{grid-row-end:2}.xl\\:row-end-3{grid-row-end:3}.xl\\:row-end-4{grid-row-end:4}.xl\\:row-end-5{grid-row-end:5}.xl\\:row-end-6{grid-row-end:6}.xl\\:row-end-7{grid-row-end:7}.xl\\:row-end-auto{grid-row-end:auto}.xl\\:transform{--transform-translate-x:0;--transform-translate-y:0;--transform-rotate:0;--transform-skew-x:0;--transform-skew-y:0;--transform-scale-x:1;--transform-scale-y:1;transform:translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y))}.xl\\:transform-none{transform:none}.xl\\:origin-center{transform-origin:center}.xl\\:origin-top{transform-origin:top}.xl\\:origin-top-right{transform-origin:top right}.xl\\:origin-right{transform-origin:right}.xl\\:origin-bottom-right{transform-origin:bottom right}.xl\\:origin-bottom{transform-origin:bottom}.xl\\:origin-bottom-left{transform-origin:bottom left}.xl\\:origin-left{transform-origin:left}.xl\\:origin-top-left{transform-origin:top left}.xl\\:scale-0{--transform-scale-x:0;--transform-scale-y:0}.xl\\:scale-50{--transform-scale-x:.5;--transform-scale-y:.5}.xl\\:scale-75{--transform-scale-x:.75;--transform-scale-y:.75}.xl\\:scale-90{--transform-scale-x:.9;--transform-scale-y:.9}.xl\\:scale-95{--transform-scale-x:.95;--transform-scale-y:.95}.xl\\:scale-100{--transform-scale-x:1;--transform-scale-y:1}.xl\\:scale-105{--transform-scale-x:1.05;--transform-scale-y:1.05}.xl\\:scale-110{--transform-scale-x:1.1;--transform-scale-y:1.1}.xl\\:scale-125{--transform-scale-x:1.25;--transform-scale-y:1.25}.xl\\:scale-150{--transform-scale-x:1.5;--transform-scale-y:1.5}.xl\\:scale-x-0{--transform-scale-x:0}.xl\\:scale-x-50{--transform-scale-x:.5}.xl\\:scale-x-75{--transform-scale-x:.75}.xl\\:scale-x-90{--transform-scale-x:.9}.xl\\:scale-x-95{--transform-scale-x:.95}.xl\\:scale-x-100{--transform-scale-x:1}.xl\\:scale-x-105{--transform-scale-x:1.05}.xl\\:scale-x-110{--transform-scale-x:1.1}.xl\\:scale-x-125{--transform-scale-x:1.25}.xl\\:scale-x-150{--transform-scale-x:1.5}.xl\\:scale-y-0{--transform-scale-y:0}.xl\\:scale-y-50{--transform-scale-y:.5}.xl\\:scale-y-75{--transform-scale-y:.75}.xl\\:scale-y-90{--transform-scale-y:.9}.xl\\:scale-y-95{--transform-scale-y:.95}.xl\\:scale-y-100{--transform-scale-y:1}.xl\\:scale-y-105{--transform-scale-y:1.05}.xl\\:scale-y-110{--transform-scale-y:1.1}.xl\\:scale-y-125{--transform-scale-y:1.25}.xl\\:scale-y-150{--transform-scale-y:1.5}.xl\\:hover\\:scale-0:hover{--transform-scale-x:0;--transform-scale-y:0}.xl\\:hover\\:scale-50:hover{--transform-scale-x:.5;--transform-scale-y:.5}.xl\\:hover\\:scale-75:hover{--transform-scale-x:.75;--transform-scale-y:.75}.xl\\:hover\\:scale-90:hover{--transform-scale-x:.9;--transform-scale-y:.9}.xl\\:hover\\:scale-95:hover{--transform-scale-x:.95;--transform-scale-y:.95}.xl\\:hover\\:scale-100:hover{--transform-scale-x:1;--transform-scale-y:1}.xl\\:hover\\:scale-105:hover{--transform-scale-x:1.05;--transform-scale-y:1.05}.xl\\:hover\\:scale-110:hover{--transform-scale-x:1.1;--transform-scale-y:1.1}.xl\\:hover\\:scale-125:hover{--transform-scale-x:1.25;--transform-scale-y:1.25}.xl\\:hover\\:scale-150:hover{--transform-scale-x:1.5;--transform-scale-y:1.5}.xl\\:hover\\:scale-x-0:hover{--transform-scale-x:0}.xl\\:hover\\:scale-x-50:hover{--transform-scale-x:.5}.xl\\:hover\\:scale-x-75:hover{--transform-scale-x:.75}.xl\\:hover\\:scale-x-90:hover{--transform-scale-x:.9}.xl\\:hover\\:scale-x-95:hover{--transform-scale-x:.95}.xl\\:hover\\:scale-x-100:hover{--transform-scale-x:1}.xl\\:hover\\:scale-x-105:hover{--transform-scale-x:1.05}.xl\\:hover\\:scale-x-110:hover{--transform-scale-x:1.1}.xl\\:hover\\:scale-x-125:hover{--transform-scale-x:1.25}.xl\\:hover\\:scale-x-150:hover{--transform-scale-x:1.5}.xl\\:hover\\:scale-y-0:hover{--transform-scale-y:0}.xl\\:hover\\:scale-y-50:hover{--transform-scale-y:.5}.xl\\:hover\\:scale-y-75:hover{--transform-scale-y:.75}.xl\\:hover\\:scale-y-90:hover{--transform-scale-y:.9}.xl\\:hover\\:scale-y-95:hover{--transform-scale-y:.95}.xl\\:hover\\:scale-y-100:hover{--transform-scale-y:1}.xl\\:hover\\:scale-y-105:hover{--transform-scale-y:1.05}.xl\\:hover\\:scale-y-110:hover{--transform-scale-y:1.1}.xl\\:hover\\:scale-y-125:hover{--transform-scale-y:1.25}.xl\\:hover\\:scale-y-150:hover{--transform-scale-y:1.5}.xl\\:focus\\:scale-0:focus{--transform-scale-x:0;--transform-scale-y:0}.xl\\:focus\\:scale-50:focus{--transform-scale-x:.5;--transform-scale-y:.5}.xl\\:focus\\:scale-75:focus{--transform-scale-x:.75;--transform-scale-y:.75}.xl\\:focus\\:scale-90:focus{--transform-scale-x:.9;--transform-scale-y:.9}.xl\\:focus\\:scale-95:focus{--transform-scale-x:.95;--transform-scale-y:.95}.xl\\:focus\\:scale-100:focus{--transform-scale-x:1;--transform-scale-y:1}.xl\\:focus\\:scale-105:focus{--transform-scale-x:1.05;--transform-scale-y:1.05}.xl\\:focus\\:scale-110:focus{--transform-scale-x:1.1;--transform-scale-y:1.1}.xl\\:focus\\:scale-125:focus{--transform-scale-x:1.25;--transform-scale-y:1.25}.xl\\:focus\\:scale-150:focus{--transform-scale-x:1.5;--transform-scale-y:1.5}.xl\\:focus\\:scale-x-0:focus{--transform-scale-x:0}.xl\\:focus\\:scale-x-50:focus{--transform-scale-x:.5}.xl\\:focus\\:scale-x-75:focus{--transform-scale-x:.75}.xl\\:focus\\:scale-x-90:focus{--transform-scale-x:.9}.xl\\:focus\\:scale-x-95:focus{--transform-scale-x:.95}.xl\\:focus\\:scale-x-100:focus{--transform-scale-x:1}.xl\\:focus\\:scale-x-105:focus{--transform-scale-x:1.05}.xl\\:focus\\:scale-x-110:focus{--transform-scale-x:1.1}.xl\\:focus\\:scale-x-125:focus{--transform-scale-x:1.25}.xl\\:focus\\:scale-x-150:focus{--transform-scale-x:1.5}.xl\\:focus\\:scale-y-0:focus{--transform-scale-y:0}.xl\\:focus\\:scale-y-50:focus{--transform-scale-y:.5}.xl\\:focus\\:scale-y-75:focus{--transform-scale-y:.75}.xl\\:focus\\:scale-y-90:focus{--transform-scale-y:.9}.xl\\:focus\\:scale-y-95:focus{--transform-scale-y:.95}.xl\\:focus\\:scale-y-100:focus{--transform-scale-y:1}.xl\\:focus\\:scale-y-105:focus{--transform-scale-y:1.05}.xl\\:focus\\:scale-y-110:focus{--transform-scale-y:1.1}.xl\\:focus\\:scale-y-125:focus{--transform-scale-y:1.25}.xl\\:focus\\:scale-y-150:focus{--transform-scale-y:1.5}.xl\\:rotate-0{--transform-rotate:0}.xl\\:rotate-45{--transform-rotate:45deg}.xl\\:rotate-90{--transform-rotate:90deg}.xl\\:rotate-180{--transform-rotate:180deg}.xl\\:-rotate-180{--transform-rotate:-180deg}.xl\\:-rotate-90{--transform-rotate:-90deg}.xl\\:-rotate-45{--transform-rotate:-45deg}.xl\\:hover\\:rotate-0:hover{--transform-rotate:0}.xl\\:hover\\:rotate-45:hover{--transform-rotate:45deg}.xl\\:hover\\:rotate-90:hover{--transform-rotate:90deg}.xl\\:hover\\:rotate-180:hover{--transform-rotate:180deg}.xl\\:hover\\:-rotate-180:hover{--transform-rotate:-180deg}.xl\\:hover\\:-rotate-90:hover{--transform-rotate:-90deg}.xl\\:hover\\:-rotate-45:hover{--transform-rotate:-45deg}.xl\\:focus\\:rotate-0:focus{--transform-rotate:0}.xl\\:focus\\:rotate-45:focus{--transform-rotate:45deg}.xl\\:focus\\:rotate-90:focus{--transform-rotate:90deg}.xl\\:focus\\:rotate-180:focus{--transform-rotate:180deg}.xl\\:focus\\:-rotate-180:focus{--transform-rotate:-180deg}.xl\\:focus\\:-rotate-90:focus{--transform-rotate:-90deg}.xl\\:focus\\:-rotate-45:focus{--transform-rotate:-45deg}.xl\\:translate-x-0{--transform-translate-x:0}.xl\\:translate-x-1{--transform-translate-x:0.25rem}.xl\\:translate-x-2{--transform-translate-x:0.5rem}.xl\\:translate-x-3{--transform-translate-x:0.75rem}.xl\\:translate-x-4{--transform-translate-x:1rem}.xl\\:translate-x-5{--transform-translate-x:1.25rem}.xl\\:translate-x-6{--transform-translate-x:1.5rem}.xl\\:translate-x-8{--transform-translate-x:2rem}.xl\\:translate-x-10{--transform-translate-x:2.5rem}.xl\\:translate-x-12{--transform-translate-x:3rem}.xl\\:translate-x-16{--transform-translate-x:4rem}.xl\\:translate-x-20{--transform-translate-x:5rem}.xl\\:translate-x-24{--transform-translate-x:6rem}.xl\\:translate-x-32{--transform-translate-x:8rem}.xl\\:translate-x-40{--transform-translate-x:10rem}.xl\\:translate-x-48{--transform-translate-x:12rem}.xl\\:translate-x-56{--transform-translate-x:14rem}.xl\\:translate-x-64{--transform-translate-x:16rem}.xl\\:translate-x-px{--transform-translate-x:1px}.xl\\:-translate-x-1{--transform-translate-x:-0.25rem}.xl\\:-translate-x-2{--transform-translate-x:-0.5rem}.xl\\:-translate-x-3{--transform-translate-x:-0.75rem}.xl\\:-translate-x-4{--transform-translate-x:-1rem}.xl\\:-translate-x-5{--transform-translate-x:-1.25rem}.xl\\:-translate-x-6{--transform-translate-x:-1.5rem}.xl\\:-translate-x-8{--transform-translate-x:-2rem}.xl\\:-translate-x-10{--transform-translate-x:-2.5rem}.xl\\:-translate-x-12{--transform-translate-x:-3rem}.xl\\:-translate-x-16{--transform-translate-x:-4rem}.xl\\:-translate-x-20{--transform-translate-x:-5rem}.xl\\:-translate-x-24{--transform-translate-x:-6rem}.xl\\:-translate-x-32{--transform-translate-x:-8rem}.xl\\:-translate-x-40{--transform-translate-x:-10rem}.xl\\:-translate-x-48{--transform-translate-x:-12rem}.xl\\:-translate-x-56{--transform-translate-x:-14rem}.xl\\:-translate-x-64{--transform-translate-x:-16rem}.xl\\:-translate-x-px{--transform-translate-x:-1px}.xl\\:-translate-x-full{--transform-translate-x:-100%}.xl\\:-translate-x-1\\/2{--transform-translate-x:-50%}.xl\\:translate-x-1\\/2{--transform-translate-x:50%}.xl\\:translate-x-full{--transform-translate-x:100%}.xl\\:translate-y-0{--transform-translate-y:0}.xl\\:translate-y-1{--transform-translate-y:0.25rem}.xl\\:translate-y-2{--transform-translate-y:0.5rem}.xl\\:translate-y-3{--transform-translate-y:0.75rem}.xl\\:translate-y-4{--transform-translate-y:1rem}.xl\\:translate-y-5{--transform-translate-y:1.25rem}.xl\\:translate-y-6{--transform-translate-y:1.5rem}.xl\\:translate-y-8{--transform-translate-y:2rem}.xl\\:translate-y-10{--transform-translate-y:2.5rem}.xl\\:translate-y-12{--transform-translate-y:3rem}.xl\\:translate-y-16{--transform-translate-y:4rem}.xl\\:translate-y-20{--transform-translate-y:5rem}.xl\\:translate-y-24{--transform-translate-y:6rem}.xl\\:translate-y-32{--transform-translate-y:8rem}.xl\\:translate-y-40{--transform-translate-y:10rem}.xl\\:translate-y-48{--transform-translate-y:12rem}.xl\\:translate-y-56{--transform-translate-y:14rem}.xl\\:translate-y-64{--transform-translate-y:16rem}.xl\\:translate-y-px{--transform-translate-y:1px}.xl\\:-translate-y-1{--transform-translate-y:-0.25rem}.xl\\:-translate-y-2{--transform-translate-y:-0.5rem}.xl\\:-translate-y-3{--transform-translate-y:-0.75rem}.xl\\:-translate-y-4{--transform-translate-y:-1rem}.xl\\:-translate-y-5{--transform-translate-y:-1.25rem}.xl\\:-translate-y-6{--transform-translate-y:-1.5rem}.xl\\:-translate-y-8{--transform-translate-y:-2rem}.xl\\:-translate-y-10{--transform-translate-y:-2.5rem}.xl\\:-translate-y-12{--transform-translate-y:-3rem}.xl\\:-translate-y-16{--transform-translate-y:-4rem}.xl\\:-translate-y-20{--transform-translate-y:-5rem}.xl\\:-translate-y-24{--transform-translate-y:-6rem}.xl\\:-translate-y-32{--transform-translate-y:-8rem}.xl\\:-translate-y-40{--transform-translate-y:-10rem}.xl\\:-translate-y-48{--transform-translate-y:-12rem}.xl\\:-translate-y-56{--transform-translate-y:-14rem}.xl\\:-translate-y-64{--transform-translate-y:-16rem}.xl\\:-translate-y-px{--transform-translate-y:-1px}.xl\\:-translate-y-full{--transform-translate-y:-100%}.xl\\:-translate-y-1\\/2{--transform-translate-y:-50%}.xl\\:translate-y-1\\/2{--transform-translate-y:50%}.xl\\:translate-y-full{--transform-translate-y:100%}.xl\\:hover\\:translate-x-0:hover{--transform-translate-x:0}.xl\\:hover\\:translate-x-1:hover{--transform-translate-x:0.25rem}.xl\\:hover\\:translate-x-2:hover{--transform-translate-x:0.5rem}.xl\\:hover\\:translate-x-3:hover{--transform-translate-x:0.75rem}.xl\\:hover\\:translate-x-4:hover{--transform-translate-x:1rem}.xl\\:hover\\:translate-x-5:hover{--transform-translate-x:1.25rem}.xl\\:hover\\:translate-x-6:hover{--transform-translate-x:1.5rem}.xl\\:hover\\:translate-x-8:hover{--transform-translate-x:2rem}.xl\\:hover\\:translate-x-10:hover{--transform-translate-x:2.5rem}.xl\\:hover\\:translate-x-12:hover{--transform-translate-x:3rem}.xl\\:hover\\:translate-x-16:hover{--transform-translate-x:4rem}.xl\\:hover\\:translate-x-20:hover{--transform-translate-x:5rem}.xl\\:hover\\:translate-x-24:hover{--transform-translate-x:6rem}.xl\\:hover\\:translate-x-32:hover{--transform-translate-x:8rem}.xl\\:hover\\:translate-x-40:hover{--transform-translate-x:10rem}.xl\\:hover\\:translate-x-48:hover{--transform-translate-x:12rem}.xl\\:hover\\:translate-x-56:hover{--transform-translate-x:14rem}.xl\\:hover\\:translate-x-64:hover{--transform-translate-x:16rem}.xl\\:hover\\:translate-x-px:hover{--transform-translate-x:1px}.xl\\:hover\\:-translate-x-1:hover{--transform-translate-x:-0.25rem}.xl\\:hover\\:-translate-x-2:hover{--transform-translate-x:-0.5rem}.xl\\:hover\\:-translate-x-3:hover{--transform-translate-x:-0.75rem}.xl\\:hover\\:-translate-x-4:hover{--transform-translate-x:-1rem}.xl\\:hover\\:-translate-x-5:hover{--transform-translate-x:-1.25rem}.xl\\:hover\\:-translate-x-6:hover{--transform-translate-x:-1.5rem}.xl\\:hover\\:-translate-x-8:hover{--transform-translate-x:-2rem}.xl\\:hover\\:-translate-x-10:hover{--transform-translate-x:-2.5rem}.xl\\:hover\\:-translate-x-12:hover{--transform-translate-x:-3rem}.xl\\:hover\\:-translate-x-16:hover{--transform-translate-x:-4rem}.xl\\:hover\\:-translate-x-20:hover{--transform-translate-x:-5rem}.xl\\:hover\\:-translate-x-24:hover{--transform-translate-x:-6rem}.xl\\:hover\\:-translate-x-32:hover{--transform-translate-x:-8rem}.xl\\:hover\\:-translate-x-40:hover{--transform-translate-x:-10rem}.xl\\:hover\\:-translate-x-48:hover{--transform-translate-x:-12rem}.xl\\:hover\\:-translate-x-56:hover{--transform-translate-x:-14rem}.xl\\:hover\\:-translate-x-64:hover{--transform-translate-x:-16rem}.xl\\:hover\\:-translate-x-px:hover{--transform-translate-x:-1px}.xl\\:hover\\:-translate-x-full:hover{--transform-translate-x:-100%}.xl\\:hover\\:-translate-x-1\\/2:hover{--transform-translate-x:-50%}.xl\\:hover\\:translate-x-1\\/2:hover{--transform-translate-x:50%}.xl\\:hover\\:translate-x-full:hover{--transform-translate-x:100%}.xl\\:hover\\:translate-y-0:hover{--transform-translate-y:0}.xl\\:hover\\:translate-y-1:hover{--transform-translate-y:0.25rem}.xl\\:hover\\:translate-y-2:hover{--transform-translate-y:0.5rem}.xl\\:hover\\:translate-y-3:hover{--transform-translate-y:0.75rem}.xl\\:hover\\:translate-y-4:hover{--transform-translate-y:1rem}.xl\\:hover\\:translate-y-5:hover{--transform-translate-y:1.25rem}.xl\\:hover\\:translate-y-6:hover{--transform-translate-y:1.5rem}.xl\\:hover\\:translate-y-8:hover{--transform-translate-y:2rem}.xl\\:hover\\:translate-y-10:hover{--transform-translate-y:2.5rem}.xl\\:hover\\:translate-y-12:hover{--transform-translate-y:3rem}.xl\\:hover\\:translate-y-16:hover{--transform-translate-y:4rem}.xl\\:hover\\:translate-y-20:hover{--transform-translate-y:5rem}.xl\\:hover\\:translate-y-24:hover{--transform-translate-y:6rem}.xl\\:hover\\:translate-y-32:hover{--transform-translate-y:8rem}.xl\\:hover\\:translate-y-40:hover{--transform-translate-y:10rem}.xl\\:hover\\:translate-y-48:hover{--transform-translate-y:12rem}.xl\\:hover\\:translate-y-56:hover{--transform-translate-y:14rem}.xl\\:hover\\:translate-y-64:hover{--transform-translate-y:16rem}.xl\\:hover\\:translate-y-px:hover{--transform-translate-y:1px}.xl\\:hover\\:-translate-y-1:hover{--transform-translate-y:-0.25rem}.xl\\:hover\\:-translate-y-2:hover{--transform-translate-y:-0.5rem}.xl\\:hover\\:-translate-y-3:hover{--transform-translate-y:-0.75rem}.xl\\:hover\\:-translate-y-4:hover{--transform-translate-y:-1rem}.xl\\:hover\\:-translate-y-5:hover{--transform-translate-y:-1.25rem}.xl\\:hover\\:-translate-y-6:hover{--transform-translate-y:-1.5rem}.xl\\:hover\\:-translate-y-8:hover{--transform-translate-y:-2rem}.xl\\:hover\\:-translate-y-10:hover{--transform-translate-y:-2.5rem}.xl\\:hover\\:-translate-y-12:hover{--transform-translate-y:-3rem}.xl\\:hover\\:-translate-y-16:hover{--transform-translate-y:-4rem}.xl\\:hover\\:-translate-y-20:hover{--transform-translate-y:-5rem}.xl\\:hover\\:-translate-y-24:hover{--transform-translate-y:-6rem}.xl\\:hover\\:-translate-y-32:hover{--transform-translate-y:-8rem}.xl\\:hover\\:-translate-y-40:hover{--transform-translate-y:-10rem}.xl\\:hover\\:-translate-y-48:hover{--transform-translate-y:-12rem}.xl\\:hover\\:-translate-y-56:hover{--transform-translate-y:-14rem}.xl\\:hover\\:-translate-y-64:hover{--transform-translate-y:-16rem}.xl\\:hover\\:-translate-y-px:hover{--transform-translate-y:-1px}.xl\\:hover\\:-translate-y-full:hover{--transform-translate-y:-100%}.xl\\:hover\\:-translate-y-1\\/2:hover{--transform-translate-y:-50%}.xl\\:hover\\:translate-y-1\\/2:hover{--transform-translate-y:50%}.xl\\:hover\\:translate-y-full:hover{--transform-translate-y:100%}.xl\\:focus\\:translate-x-0:focus{--transform-translate-x:0}.xl\\:focus\\:translate-x-1:focus{--transform-translate-x:0.25rem}.xl\\:focus\\:translate-x-2:focus{--transform-translate-x:0.5rem}.xl\\:focus\\:translate-x-3:focus{--transform-translate-x:0.75rem}.xl\\:focus\\:translate-x-4:focus{--transform-translate-x:1rem}.xl\\:focus\\:translate-x-5:focus{--transform-translate-x:1.25rem}.xl\\:focus\\:translate-x-6:focus{--transform-translate-x:1.5rem}.xl\\:focus\\:translate-x-8:focus{--transform-translate-x:2rem}.xl\\:focus\\:translate-x-10:focus{--transform-translate-x:2.5rem}.xl\\:focus\\:translate-x-12:focus{--transform-translate-x:3rem}.xl\\:focus\\:translate-x-16:focus{--transform-translate-x:4rem}.xl\\:focus\\:translate-x-20:focus{--transform-translate-x:5rem}.xl\\:focus\\:translate-x-24:focus{--transform-translate-x:6rem}.xl\\:focus\\:translate-x-32:focus{--transform-translate-x:8rem}.xl\\:focus\\:translate-x-40:focus{--transform-translate-x:10rem}.xl\\:focus\\:translate-x-48:focus{--transform-translate-x:12rem}.xl\\:focus\\:translate-x-56:focus{--transform-translate-x:14rem}.xl\\:focus\\:translate-x-64:focus{--transform-translate-x:16rem}.xl\\:focus\\:translate-x-px:focus{--transform-translate-x:1px}.xl\\:focus\\:-translate-x-1:focus{--transform-translate-x:-0.25rem}.xl\\:focus\\:-translate-x-2:focus{--transform-translate-x:-0.5rem}.xl\\:focus\\:-translate-x-3:focus{--transform-translate-x:-0.75rem}.xl\\:focus\\:-translate-x-4:focus{--transform-translate-x:-1rem}.xl\\:focus\\:-translate-x-5:focus{--transform-translate-x:-1.25rem}.xl\\:focus\\:-translate-x-6:focus{--transform-translate-x:-1.5rem}.xl\\:focus\\:-translate-x-8:focus{--transform-translate-x:-2rem}.xl\\:focus\\:-translate-x-10:focus{--transform-translate-x:-2.5rem}.xl\\:focus\\:-translate-x-12:focus{--transform-translate-x:-3rem}.xl\\:focus\\:-translate-x-16:focus{--transform-translate-x:-4rem}.xl\\:focus\\:-translate-x-20:focus{--transform-translate-x:-5rem}.xl\\:focus\\:-translate-x-24:focus{--transform-translate-x:-6rem}.xl\\:focus\\:-translate-x-32:focus{--transform-translate-x:-8rem}.xl\\:focus\\:-translate-x-40:focus{--transform-translate-x:-10rem}.xl\\:focus\\:-translate-x-48:focus{--transform-translate-x:-12rem}.xl\\:focus\\:-translate-x-56:focus{--transform-translate-x:-14rem}.xl\\:focus\\:-translate-x-64:focus{--transform-translate-x:-16rem}.xl\\:focus\\:-translate-x-px:focus{--transform-translate-x:-1px}.xl\\:focus\\:-translate-x-full:focus{--transform-translate-x:-100%}.xl\\:focus\\:-translate-x-1\\/2:focus{--transform-translate-x:-50%}.xl\\:focus\\:translate-x-1\\/2:focus{--transform-translate-x:50%}.xl\\:focus\\:translate-x-full:focus{--transform-translate-x:100%}.xl\\:focus\\:translate-y-0:focus{--transform-translate-y:0}.xl\\:focus\\:translate-y-1:focus{--transform-translate-y:0.25rem}.xl\\:focus\\:translate-y-2:focus{--transform-translate-y:0.5rem}.xl\\:focus\\:translate-y-3:focus{--transform-translate-y:0.75rem}.xl\\:focus\\:translate-y-4:focus{--transform-translate-y:1rem}.xl\\:focus\\:translate-y-5:focus{--transform-translate-y:1.25rem}.xl\\:focus\\:translate-y-6:focus{--transform-translate-y:1.5rem}.xl\\:focus\\:translate-y-8:focus{--transform-translate-y:2rem}.xl\\:focus\\:translate-y-10:focus{--transform-translate-y:2.5rem}.xl\\:focus\\:translate-y-12:focus{--transform-translate-y:3rem}.xl\\:focus\\:translate-y-16:focus{--transform-translate-y:4rem}.xl\\:focus\\:translate-y-20:focus{--transform-translate-y:5rem}.xl\\:focus\\:translate-y-24:focus{--transform-translate-y:6rem}.xl\\:focus\\:translate-y-32:focus{--transform-translate-y:8rem}.xl\\:focus\\:translate-y-40:focus{--transform-translate-y:10rem}.xl\\:focus\\:translate-y-48:focus{--transform-translate-y:12rem}.xl\\:focus\\:translate-y-56:focus{--transform-translate-y:14rem}.xl\\:focus\\:translate-y-64:focus{--transform-translate-y:16rem}.xl\\:focus\\:translate-y-px:focus{--transform-translate-y:1px}.xl\\:focus\\:-translate-y-1:focus{--transform-translate-y:-0.25rem}.xl\\:focus\\:-translate-y-2:focus{--transform-translate-y:-0.5rem}.xl\\:focus\\:-translate-y-3:focus{--transform-translate-y:-0.75rem}.xl\\:focus\\:-translate-y-4:focus{--transform-translate-y:-1rem}.xl\\:focus\\:-translate-y-5:focus{--transform-translate-y:-1.25rem}.xl\\:focus\\:-translate-y-6:focus{--transform-translate-y:-1.5rem}.xl\\:focus\\:-translate-y-8:focus{--transform-translate-y:-2rem}.xl\\:focus\\:-translate-y-10:focus{--transform-translate-y:-2.5rem}.xl\\:focus\\:-translate-y-12:focus{--transform-translate-y:-3rem}.xl\\:focus\\:-translate-y-16:focus{--transform-translate-y:-4rem}.xl\\:focus\\:-translate-y-20:focus{--transform-translate-y:-5rem}.xl\\:focus\\:-translate-y-24:focus{--transform-translate-y:-6rem}.xl\\:focus\\:-translate-y-32:focus{--transform-translate-y:-8rem}.xl\\:focus\\:-translate-y-40:focus{--transform-translate-y:-10rem}.xl\\:focus\\:-translate-y-48:focus{--transform-translate-y:-12rem}.xl\\:focus\\:-translate-y-56:focus{--transform-translate-y:-14rem}.xl\\:focus\\:-translate-y-64:focus{--transform-translate-y:-16rem}.xl\\:focus\\:-translate-y-px:focus{--transform-translate-y:-1px}.xl\\:focus\\:-translate-y-full:focus{--transform-translate-y:-100%}.xl\\:focus\\:-translate-y-1\\/2:focus{--transform-translate-y:-50%}.xl\\:focus\\:translate-y-1\\/2:focus{--transform-translate-y:50%}.xl\\:focus\\:translate-y-full:focus{--transform-translate-y:100%}.xl\\:skew-x-0{--transform-skew-x:0}.xl\\:skew-x-3{--transform-skew-x:3deg}.xl\\:skew-x-6{--transform-skew-x:6deg}.xl\\:skew-x-12{--transform-skew-x:12deg}.xl\\:-skew-x-12{--transform-skew-x:-12deg}.xl\\:-skew-x-6{--transform-skew-x:-6deg}.xl\\:-skew-x-3{--transform-skew-x:-3deg}.xl\\:skew-y-0{--transform-skew-y:0}.xl\\:skew-y-3{--transform-skew-y:3deg}.xl\\:skew-y-6{--transform-skew-y:6deg}.xl\\:skew-y-12{--transform-skew-y:12deg}.xl\\:-skew-y-12{--transform-skew-y:-12deg}.xl\\:-skew-y-6{--transform-skew-y:-6deg}.xl\\:-skew-y-3{--transform-skew-y:-3deg}.xl\\:hover\\:skew-x-0:hover{--transform-skew-x:0}.xl\\:hover\\:skew-x-3:hover{--transform-skew-x:3deg}.xl\\:hover\\:skew-x-6:hover{--transform-skew-x:6deg}.xl\\:hover\\:skew-x-12:hover{--transform-skew-x:12deg}.xl\\:hover\\:-skew-x-12:hover{--transform-skew-x:-12deg}.xl\\:hover\\:-skew-x-6:hover{--transform-skew-x:-6deg}.xl\\:hover\\:-skew-x-3:hover{--transform-skew-x:-3deg}.xl\\:hover\\:skew-y-0:hover{--transform-skew-y:0}.xl\\:hover\\:skew-y-3:hover{--transform-skew-y:3deg}.xl\\:hover\\:skew-y-6:hover{--transform-skew-y:6deg}.xl\\:hover\\:skew-y-12:hover{--transform-skew-y:12deg}.xl\\:hover\\:-skew-y-12:hover{--transform-skew-y:-12deg}.xl\\:hover\\:-skew-y-6:hover{--transform-skew-y:-6deg}.xl\\:hover\\:-skew-y-3:hover{--transform-skew-y:-3deg}.xl\\:focus\\:skew-x-0:focus{--transform-skew-x:0}.xl\\:focus\\:skew-x-3:focus{--transform-skew-x:3deg}.xl\\:focus\\:skew-x-6:focus{--transform-skew-x:6deg}.xl\\:focus\\:skew-x-12:focus{--transform-skew-x:12deg}.xl\\:focus\\:-skew-x-12:focus{--transform-skew-x:-12deg}.xl\\:focus\\:-skew-x-6:focus{--transform-skew-x:-6deg}.xl\\:focus\\:-skew-x-3:focus{--transform-skew-x:-3deg}.xl\\:focus\\:skew-y-0:focus{--transform-skew-y:0}.xl\\:focus\\:skew-y-3:focus{--transform-skew-y:3deg}.xl\\:focus\\:skew-y-6:focus{--transform-skew-y:6deg}.xl\\:focus\\:skew-y-12:focus{--transform-skew-y:12deg}.xl\\:focus\\:-skew-y-12:focus{--transform-skew-y:-12deg}.xl\\:focus\\:-skew-y-6:focus{--transform-skew-y:-6deg}.xl\\:focus\\:-skew-y-3:focus{--transform-skew-y:-3deg}.xl\\:transition-none{transition-property:none}.xl\\:transition-all{transition-property:all}.xl\\:transition{transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform}.xl\\:transition-colors{transition-property:background-color,border-color,color,fill,stroke}.xl\\:transition-opacity{transition-property:opacity}.xl\\:transition-shadow{transition-property:box-shadow}.xl\\:transition-transform{transition-property:transform}.xl\\:ease-linear{transition-timing-function:linear}.xl\\:ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.xl\\:ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.xl\\:ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.xl\\:duration-75{transition-duration:75ms}.xl\\:duration-100{transition-duration:.1s}.xl\\:duration-150{transition-duration:.15s}.xl\\:duration-200{transition-duration:.2s}.xl\\:duration-300{transition-duration:.3s}.xl\\:duration-500{transition-duration:.5s}.xl\\:duration-700{transition-duration:.7s}.xl\\:duration-1000{transition-duration:1s}.xl\\:delay-75{transition-delay:75ms}.xl\\:delay-100{transition-delay:.1s}.xl\\:delay-150{transition-delay:.15s}.xl\\:delay-200{transition-delay:.2s}.xl\\:delay-300{transition-delay:.3s}.xl\\:delay-500{transition-delay:.5s}.xl\\:delay-700{transition-delay:.7s}.xl\\:delay-1000{transition-delay:1s}.xl\\:shadow-outline-white{box-shadow:0 0 0 3px #ffffff73}.xl\\:shadow-outline-black{box-shadow:0 0 0 3px #00000073}.xl\\:shadow-outline-gray{box-shadow:0 0 0 3px #d5d6d773}.xl\\:shadow-outline-cool-gray{box-shadow:0 0 0 3px #cfd8e373}.xl\\:shadow-outline-red{box-shadow:0 0 0 3px #f8b4b473}.xl\\:shadow-outline-orange{box-shadow:0 0 0 3px #fdba8c73}.xl\\:shadow-outline-yellow{box-shadow:0 0 0 3px #faca1573}.xl\\:shadow-outline-green{box-shadow:0 0 0 3px #84e1bc73}.xl\\:shadow-outline-teal{box-shadow:0 0 0 3px #7edce273}.xl\\:shadow-outline-blue{box-shadow:0 0 0 3px #a4cafe73}.xl\\:shadow-outline-indigo{box-shadow:0 0 0 3px #b4c6fc73}.xl\\:shadow-outline-indigo{box-shadow:0 0 0 3px #cabffd73}.xl\\:shadow-outline-pink{box-shadow:0 0 0 3px #f8b4d973}.xl\\:hover\\:shadow-outline-white:hover{box-shadow:0 0 0 3px #ffffff73}.xl\\:hover\\:shadow-outline-black:hover{box-shadow:0 0 0 3px #00000073}.xl\\:hover\\:shadow-outline-gray:hover{box-shadow:0 0 0 3px #d5d6d773}.xl\\:hover\\:shadow-outline-cool-gray:hover{box-shadow:0 0 0 3px #cfd8e373}.xl\\:hover\\:shadow-outline-red:hover{box-shadow:0 0 0 3px #f8b4b473}.xl\\:hover\\:shadow-outline-orange:hover{box-shadow:0 0 0 3px #fdba8c73}.xl\\:hover\\:shadow-outline-yellow:hover{box-shadow:0 0 0 3px #faca1573}.xl\\:hover\\:shadow-outline-green:hover{box-shadow:0 0 0 3px #84e1bc73}.xl\\:hover\\:shadow-outline-teal:hover{box-shadow:0 0 0 3px #7edce273}.xl\\:hover\\:shadow-outline-blue:hover{box-shadow:0 0 0 3px #a4cafe73}.xl\\:hover\\:shadow-outline-indigo:hover{box-shadow:0 0 0 3px #b4c6fc73}.xl\\:hover\\:shadow-outline-indigo:hover{box-shadow:0 0 0 3px #cabffd73}.xl\\:hover\\:shadow-outline-pink:hover{box-shadow:0 0 0 3px #f8b4d973}.xl\\:focus\\:shadow-outline-white:focus{box-shadow:0 0 0 3px #ffffff73}.xl\\:focus\\:shadow-outline-black:focus{box-shadow:0 0 0 3px #00000073}.xl\\:focus\\:shadow-outline-gray:focus{box-shadow:0 0 0 3px #d5d6d773}.xl\\:focus\\:shadow-outline-cool-gray:focus{box-shadow:0 0 0 3px #cfd8e373}.xl\\:focus\\:shadow-outline-red:focus{box-shadow:0 0 0 3px #f8b4b473}.xl\\:focus\\:shadow-outline-orange:focus{box-shadow:0 0 0 3px #fdba8c73}.xl\\:focus\\:shadow-outline-yellow:focus{box-shadow:0 0 0 3px #faca1573}.xl\\:focus\\:shadow-outline-green:focus{box-shadow:0 0 0 3px #84e1bc73}.xl\\:focus\\:shadow-outline-teal:focus{box-shadow:0 0 0 3px #7edce273}.xl\\:focus\\:shadow-outline-blue:focus{box-shadow:0 0 0 3px #a4cafe73}.xl\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #b4c6fc73}.xl\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #cabffd73}.xl\\:focus\\:shadow-outline-pink:focus{box-shadow:0 0 0 3px #f8b4d973}.theme-dark .xl\\:dark\\:focus\\:shadow-outline-white:focus{box-shadow:0 0 0 3px #ffffff73}.theme-dark .xl\\:dark\\:focus\\:shadow-outline-black:focus{box-shadow:0 0 0 3px #00000073}.theme-dark .xl\\:dark\\:focus\\:shadow-outline-gray:focus{box-shadow:0 0 0 3px #d5d6d773}.theme-dark .xl\\:dark\\:focus\\:shadow-outline-cool-gray:focus{box-shadow:0 0 0 3px #cfd8e373}.theme-dark .xl\\:dark\\:focus\\:shadow-outline-red:focus{box-shadow:0 0 0 3px #f8b4b473}.theme-dark .xl\\:dark\\:focus\\:shadow-outline-orange:focus{box-shadow:0 0 0 3px #fdba8c73}.theme-dark .xl\\:dark\\:focus\\:shadow-outline-yellow:focus{box-shadow:0 0 0 3px #faca1573}.theme-dark .xl\\:dark\\:focus\\:shadow-outline-green:focus{box-shadow:0 0 0 3px #84e1bc73}.theme-dark .xl\\:dark\\:focus\\:shadow-outline-teal:focus{box-shadow:0 0 0 3px #7edce273}.theme-dark .xl\\:dark\\:focus\\:shadow-outline-blue:focus{box-shadow:0 0 0 3px #a4cafe73}.theme-dark .xl\\:dark\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #b4c6fc73}.theme-dark .xl\\:dark\\:focus\\:shadow-outline-indigo:focus{box-shadow:0 0 0 3px #cabffd73}.theme-dark .xl\\:dark\\:focus\\:shadow-outline-pink:focus{box-shadow:0 0 0 3px #f8b4d973}}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
